
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8abc"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8abc"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cF2Ke", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "isObservableObject", function () { return isObservableObject; });
$parcel$export(module.exports, "isObservableArray", function () { return isObservableArray; });
$parcel$export(module.exports, "isObservableMap", function () { return isObservableMap; });
$parcel$export(module.exports, "computed", function () { return computed; });
$parcel$export(module.exports, "_allowStateChanges", function () { return allowStateChanges; });
$parcel$export(module.exports, "untracked", function () { return untracked; });
$parcel$export(module.exports, "_getGlobalState", function () { return getGlobalState; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "action", function () { return action; });
$parcel$export(module.exports, "reaction", function () { return reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "toJS", function () { return toJS; });
$parcel$export(module.exports, "when", function () { return when; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    var computedValues;
    // Defer ComputedValue creation until first access — avoids allocating
    // ComputedValues for getters that are never read on a given instance.
    // The factory is materialised by ObservableObjectAdministration on demand.
    function createComputedValue(target, adm) {
        var options = _extends({}, ann.options_, {
            get: get,
            context: target
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        return new ComputedValue(options);
    }
    addInitializer(function() {
        var _adm$lazyComputedKeys;
        var adm = asObservableObject(this)[$mobx];
        var target = this;
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) adm.values_["delete"](key);
        ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null ? _adm$lazyComputedKeys : adm.lazyComputedKeys_ = new Map()).set(key, function() {
            return createComputedValue(target, adm);
        });
    });
    return function() {
        var adm = this[$mobx];
        var observable = adm.values_.get(key);
        if (observable instanceof ComputedValue && observable.derivation !== get) {
            var _computedValues;
            var computed = (_computedValues = computedValues) == null ? void 0 : _computedValues.get(this);
            if (!computed) {
                var _computedValues2;
                computed = createComputedValue(this, adm);
                ((_computedValues2 = computedValues) != null ? _computedValues2 : computedValues = new WeakMap()).set(this, computed);
            }
            return computed.get();
        }
        return adm.getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    if (kind !== "accessor") return;
    // Defer ObservableValue construction until first access. The factory is
    // materialised by ObservableObjectAdministration on demand, so unused
    // fields on wide classes never pay the per-instance allocation cost.
    function registerLazy(target, value) {
        var _adm$lazyObservableKe;
        var adm = asObservableObject(target)[$mobx];
        ((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null ? _adm$lazyObservableKe : adm.lazyObservableKeys_ = new Map()).set(name, function() {
            var _ann$options_$enhance, _ann$options_;
            return new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        });
        return adm;
    }
    return {
        get: function get() {
            var _this$$mobx;
            var adm = (_this$$mobx = this[$mobx]) != null ? _this$$mobx : registerLazy(this, desc.get.call(this));
            return adm.getObservablePropValue_(name);
        },
        set: function set(value) {
            var _this$$mobx2;
            var adm = (_this$$mobx2 = this[$mobx]) != null ? _this$$mobx2 : registerLazy(this, value);
            return adm.setObservablePropValue_(name, value);
        },
        init: function init(value) {
            registerLazy(this, value);
            return value;
        }
    };
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
var FlowCancellationError = /*#__PURE__*/ function(_Error) {
    function FlowCancellationError() {
        var _this;
        _this = _Error.call(this, "FLOW_CANCELLED") || this;
        Object.setPrototypeOf(_this, (this instanceof FlowCancellationError ? this.constructor : void 0).prototype);
        _this.name = "FlowCancellationError";
        return _this;
    }
    _inheritsLoose(FlowCancellationError, _Error);
    var _proto = FlowCancellationError.prototype;
    _proto.toString = function toString() {
        return "Error: " + this.message;
    };
    return FlowCancellationError;
}(/*#__PURE__*/ _wrapNativeSuper(Error));
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    var _adm$lazyComputedKeys;
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    var adm = value[$mobx];
    if ((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) return true;
    if (!adm.values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) {
            var _adm$lazyComputedKeys, _adm$lazyObservableKe;
            var adm = value[$mobx];
            return adm.values_.has(property) || !!((_adm$lazyComputedKeys = adm.lazyComputedKeys_) != null && _adm$lazyComputedKeys.has(property)) || !!((_adm$lazyObservableKe = adm.lazyObservableKeys_) != null && _adm$lazyObservableKe.has(property));
        }
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.getOrInsert = function getOrInsert(key, value) {
        if (!this.has(key)) this.set(key, value);
        return this.get(key);
    };
    _proto.getOrInsertComputed = function getOrInsertComputed(key, callback) {
        if (!this.has(key)) this.set(key, callback(key));
        return this.get(key);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.lazyComputedKeys_ = void 0;
        this.lazyObservableKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        var _ref, _this$values_$get;
        // Hot path: single map lookup. Lazy entries (rare) take the materialise branch.
        var observable = (_ref = (_this$values_$get = this.values_.get(key)) != null ? _this$values_$get : this.materializeLazyComputed_(key)) != null ? _ref : this.materializeLazyObservable_(key);
        return observable.get();
    };
    _proto.materializeLazyComputed_ = function materializeLazyComputed_(key) {
        var _this$lazyComputedKey;
        var factory = (_this$lazyComputedKey = this.lazyComputedKeys_) == null ? void 0 : _this$lazyComputedKey.get(key);
        if (!factory) return undefined;
        this.lazyComputedKeys_["delete"](key);
        if (this.lazyComputedKeys_.size === 0) this.lazyComputedKeys_ = undefined;
        var computed = factory();
        this.values_.set(key, computed);
        return computed;
    };
    _proto.materializeLazyObservable_ = function materializeLazyObservable_(key) {
        var _this$lazyObservableK;
        var factory = (_this$lazyObservableK = this.lazyObservableKeys_) == null ? void 0 : _this$lazyObservableK.get(key);
        if (!factory) return undefined;
        this.lazyObservableKeys_["delete"](key);
        if (this.lazyObservableKeys_.size === 0) this.lazyObservableKeys_ = undefined;
        var observable = factory();
        this.values_.set(key, observable);
        return observable;
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var _ref2, _this$values_$get2;
        var observable = (_ref2 = (_this$values_$get2 = this.values_.get(key)) != null ? _this$values_$get2 : this.materializeLazyComputed_(key)) != null ? _ref2 : this.materializeLazyObservable_(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            var _ref, _adm$values_$get;
            if (!property) return die(26);
            var adm = thing[$mobx];
            var _observable = (_ref = (_adm$values_$get = adm.values_.get(property)) != null ? _adm$values_$get : adm.materializeLazyComputed_(property)) != null ? _ref : adm.materializeLazyObservable_(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _global$Iterator;
// safely get iterator prototype if available
var global$1 = /*#__PURE__*/ getGlobal();
var maybeIteratorPrototype = ((_global$Iterator = global$1.Iterator) == null ? void 0 : _global$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("36bfA", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $241aa8c06e4e7e71$export$2b8d127b894957b9; }, function (v) { return $241aa8c06e4e7e71$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $241aa8c06e4e7e71$export$cea3a54a6425200c; }, function (v) { return $241aa8c06e4e7e71$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $241aa8c06e4e7e71$export$a7c73072b1a182ae; }, function (v) { return $241aa8c06e4e7e71$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $241aa8c06e4e7e71$export$9f27bc3417b4524d; }, function (v) { return $241aa8c06e4e7e71$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $241aa8c06e4e7e71$export$db77ccec0bb4ccac; }, function (v) { return $241aa8c06e4e7e71$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $241aa8c06e4e7e71$export$8392c0c9d3dcbd35; }, function (v) { return $241aa8c06e4e7e71$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $241aa8c06e4e7e71$export$ffb0004e005737fa; }, function (v) { return $241aa8c06e4e7e71$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $241aa8c06e4e7e71$export$b624eff549462981; }, function (v) { return $241aa8c06e4e7e71$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $241aa8c06e4e7e71$export$7897aa7841a5380c; }, function (v) { return $241aa8c06e4e7e71$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $241aa8c06e4e7e71$export$602eac185826482c; }, function (v) { return $241aa8c06e4e7e71$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $241aa8c06e4e7e71$export$e2c29f18771995cb; }, function (v) { return $241aa8c06e4e7e71$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $241aa8c06e4e7e71$export$5f8d39834fd61797; }, function (v) { return $241aa8c06e4e7e71$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $241aa8c06e4e7e71$export$74bf444e3cd11ea5; }, function (v) { return $241aa8c06e4e7e71$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $241aa8c06e4e7e71$export$92387174baf9b227; }, function (v) { return $241aa8c06e4e7e71$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $241aa8c06e4e7e71$export$ec112efeb987d9c6; }, function (v) { return $241aa8c06e4e7e71$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $241aa8c06e4e7e71$export$b706b080d889d2c9; }, function (v) { return $241aa8c06e4e7e71$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $241aa8c06e4e7e71$export$5be5a87408f70ddc; }, function (v) { return $241aa8c06e4e7e71$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $241aa8c06e4e7e71$export$45a5e7f76e0caa8d; }, function (v) { return $241aa8c06e4e7e71$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $241aa8c06e4e7e71$export$455c2e768291efa6; }, function (v) { return $241aa8c06e4e7e71$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $241aa8c06e4e7e71$export$9522e17588c12572; }, function (v) { return $241aa8c06e4e7e71$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $241aa8c06e4e7e71$export$2110ac352bb060b9; }, function (v) { return $241aa8c06e4e7e71$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $241aa8c06e4e7e71$export$56885ab8b9c456ab; }, function (v) { return $241aa8c06e4e7e71$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $241aa8c06e4e7e71$export$d927fcb6adf8f9de; }, function (v) { return $241aa8c06e4e7e71$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $241aa8c06e4e7e71$export$b82d16f27459e05a; }, function (v) { return $241aa8c06e4e7e71$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $241aa8c06e4e7e71$export$522c17b4f5e123e8; }, function (v) { return $241aa8c06e4e7e71$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $241aa8c06e4e7e71$export$1aabd8a0274ecfd6; }, function (v) { return $241aa8c06e4e7e71$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $241aa8c06e4e7e71$export$9b621391a187a31a; }, function (v) { return $241aa8c06e4e7e71$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $241aa8c06e4e7e71$export$f5bbd400c2f4426f; }, function (v) { return $241aa8c06e4e7e71$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $241aa8c06e4e7e71$export$2b8d127b894957b9;
var $241aa8c06e4e7e71$export$cea3a54a6425200c;
var $241aa8c06e4e7e71$export$a7c73072b1a182ae;
var $241aa8c06e4e7e71$export$9f27bc3417b4524d;
var $241aa8c06e4e7e71$export$db77ccec0bb4ccac;
var $241aa8c06e4e7e71$export$8392c0c9d3dcbd35;
var $241aa8c06e4e7e71$export$ffb0004e005737fa;
var $241aa8c06e4e7e71$export$b624eff549462981;
var $241aa8c06e4e7e71$export$7897aa7841a5380c;
var $241aa8c06e4e7e71$export$602eac185826482c;
var $241aa8c06e4e7e71$export$e2c29f18771995cb;
var $241aa8c06e4e7e71$export$5f8d39834fd61797;
var $241aa8c06e4e7e71$export$74bf444e3cd11ea5;
var $241aa8c06e4e7e71$export$92387174baf9b227;
var $241aa8c06e4e7e71$export$ec112efeb987d9c6;
var $241aa8c06e4e7e71$export$b706b080d889d2c9;
var $241aa8c06e4e7e71$export$5be5a87408f70ddc;
var $241aa8c06e4e7e71$export$45a5e7f76e0caa8d;
var $241aa8c06e4e7e71$export$455c2e768291efa6;
var $241aa8c06e4e7e71$export$9522e17588c12572;
var $241aa8c06e4e7e71$export$2110ac352bb060b9;
var $241aa8c06e4e7e71$export$56885ab8b9c456ab;
var $241aa8c06e4e7e71$export$d927fcb6adf8f9de;
var $241aa8c06e4e7e71$export$b82d16f27459e05a;
var $241aa8c06e4e7e71$export$522c17b4f5e123e8;
var $241aa8c06e4e7e71$export$1aabd8a0274ecfd6;
var $241aa8c06e4e7e71$export$9b621391a187a31a;
var $241aa8c06e4e7e71$export$f5bbd400c2f4426f;
'use strict';
var $241aa8c06e4e7e71$var$b = "function" === typeof Symbol && Symbol.for, $241aa8c06e4e7e71$var$c = $241aa8c06e4e7e71$var$b ? Symbol.for("react.element") : 60103, $241aa8c06e4e7e71$var$d = $241aa8c06e4e7e71$var$b ? Symbol.for("react.portal") : 60106, $241aa8c06e4e7e71$var$e = $241aa8c06e4e7e71$var$b ? Symbol.for("react.fragment") : 60107, $241aa8c06e4e7e71$var$f = $241aa8c06e4e7e71$var$b ? Symbol.for("react.strict_mode") : 60108, $241aa8c06e4e7e71$var$g = $241aa8c06e4e7e71$var$b ? Symbol.for("react.profiler") : 60114, $241aa8c06e4e7e71$var$h = $241aa8c06e4e7e71$var$b ? Symbol.for("react.provider") : 60109, $241aa8c06e4e7e71$var$k = $241aa8c06e4e7e71$var$b ? Symbol.for("react.context") : 60110, $241aa8c06e4e7e71$var$l = $241aa8c06e4e7e71$var$b ? Symbol.for("react.async_mode") : 60111, $241aa8c06e4e7e71$var$m = $241aa8c06e4e7e71$var$b ? Symbol.for("react.concurrent_mode") : 60111, $241aa8c06e4e7e71$var$n = $241aa8c06e4e7e71$var$b ? Symbol.for("react.forward_ref") : 60112, $241aa8c06e4e7e71$var$p = $241aa8c06e4e7e71$var$b ? Symbol.for("react.suspense") : 60113, $241aa8c06e4e7e71$var$q = $241aa8c06e4e7e71$var$b ? Symbol.for("react.suspense_list") : 60120, $241aa8c06e4e7e71$var$r = $241aa8c06e4e7e71$var$b ? Symbol.for("react.memo") : 60115, $241aa8c06e4e7e71$var$t = $241aa8c06e4e7e71$var$b ? Symbol.for("react.lazy") : 60116, $241aa8c06e4e7e71$var$v = $241aa8c06e4e7e71$var$b ? Symbol.for("react.block") : 60121, $241aa8c06e4e7e71$var$w = $241aa8c06e4e7e71$var$b ? Symbol.for("react.fundamental") : 60117, $241aa8c06e4e7e71$var$x = $241aa8c06e4e7e71$var$b ? Symbol.for("react.responder") : 60118, $241aa8c06e4e7e71$var$y = $241aa8c06e4e7e71$var$b ? Symbol.for("react.scope") : 60119;
function $241aa8c06e4e7e71$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $241aa8c06e4e7e71$var$c:
                switch(a = a.type, a){
                    case $241aa8c06e4e7e71$var$l:
                    case $241aa8c06e4e7e71$var$m:
                    case $241aa8c06e4e7e71$var$e:
                    case $241aa8c06e4e7e71$var$g:
                    case $241aa8c06e4e7e71$var$f:
                    case $241aa8c06e4e7e71$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $241aa8c06e4e7e71$var$k:
                            case $241aa8c06e4e7e71$var$n:
                            case $241aa8c06e4e7e71$var$t:
                            case $241aa8c06e4e7e71$var$r:
                            case $241aa8c06e4e7e71$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $241aa8c06e4e7e71$var$d:
                return u;
        }
    }
}
function $241aa8c06e4e7e71$var$A(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$m;
}
$241aa8c06e4e7e71$export$2b8d127b894957b9 = $241aa8c06e4e7e71$var$l;
$241aa8c06e4e7e71$export$cea3a54a6425200c = $241aa8c06e4e7e71$var$m;
$241aa8c06e4e7e71$export$a7c73072b1a182ae = $241aa8c06e4e7e71$var$k;
$241aa8c06e4e7e71$export$9f27bc3417b4524d = $241aa8c06e4e7e71$var$h;
$241aa8c06e4e7e71$export$db77ccec0bb4ccac = $241aa8c06e4e7e71$var$c;
$241aa8c06e4e7e71$export$8392c0c9d3dcbd35 = $241aa8c06e4e7e71$var$n;
$241aa8c06e4e7e71$export$ffb0004e005737fa = $241aa8c06e4e7e71$var$e;
$241aa8c06e4e7e71$export$b624eff549462981 = $241aa8c06e4e7e71$var$t;
$241aa8c06e4e7e71$export$7897aa7841a5380c = $241aa8c06e4e7e71$var$r;
$241aa8c06e4e7e71$export$602eac185826482c = $241aa8c06e4e7e71$var$d;
$241aa8c06e4e7e71$export$e2c29f18771995cb = $241aa8c06e4e7e71$var$g;
$241aa8c06e4e7e71$export$5f8d39834fd61797 = $241aa8c06e4e7e71$var$f;
$241aa8c06e4e7e71$export$74bf444e3cd11ea5 = $241aa8c06e4e7e71$var$p;
$241aa8c06e4e7e71$export$92387174baf9b227 = function(a) {
    return $241aa8c06e4e7e71$var$A(a) || $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$l;
};
$241aa8c06e4e7e71$export$ec112efeb987d9c6 = $241aa8c06e4e7e71$var$A;
$241aa8c06e4e7e71$export$b706b080d889d2c9 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$k;
};
$241aa8c06e4e7e71$export$5be5a87408f70ddc = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$h;
};
$241aa8c06e4e7e71$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $241aa8c06e4e7e71$var$c;
};
$241aa8c06e4e7e71$export$455c2e768291efa6 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$n;
};
$241aa8c06e4e7e71$export$9522e17588c12572 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$e;
};
$241aa8c06e4e7e71$export$2110ac352bb060b9 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$t;
};
$241aa8c06e4e7e71$export$56885ab8b9c456ab = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$r;
};
$241aa8c06e4e7e71$export$d927fcb6adf8f9de = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$d;
};
$241aa8c06e4e7e71$export$b82d16f27459e05a = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$g;
};
$241aa8c06e4e7e71$export$522c17b4f5e123e8 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$f;
};
$241aa8c06e4e7e71$export$1aabd8a0274ecfd6 = function(a) {
    return $241aa8c06e4e7e71$var$z(a) === $241aa8c06e4e7e71$var$p;
};
$241aa8c06e4e7e71$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $241aa8c06e4e7e71$var$e || a === $241aa8c06e4e7e71$var$m || a === $241aa8c06e4e7e71$var$g || a === $241aa8c06e4e7e71$var$f || a === $241aa8c06e4e7e71$var$p || a === $241aa8c06e4e7e71$var$q || "object" === typeof a && null !== a && (a.$$typeof === $241aa8c06e4e7e71$var$t || a.$$typeof === $241aa8c06e4e7e71$var$r || a.$$typeof === $241aa8c06e4e7e71$var$h || a.$$typeof === $241aa8c06e4e7e71$var$k || a.$$typeof === $241aa8c06e4e7e71$var$n || a.$$typeof === $241aa8c06e4e7e71$var$w || a.$$typeof === $241aa8c06e4e7e71$var$x || a.$$typeof === $241aa8c06e4e7e71$var$y || a.$$typeof === $241aa8c06e4e7e71$var$v);
};
$241aa8c06e4e7e71$export$f5bbd400c2f4426f = $241aa8c06e4e7e71$var$z;

});

parcelRegister("bTKq6", function(module, exports) {
Prism.languages.javascript = Prism.languages.extend('clike', {
    'class-name': [
        Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
Prism.languages.js = Prism.languages.javascript;

});

parcelRegister("84txe", function(module, exports) {
(function(Prism1) {
    var javascript = Prism1.util.clone(Prism1.languages.javascript);
    var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
    var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
    var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    /**
	 * @param {string} source
	 * @param {string} [flags]
	 */ function re(source, flags) {
        source = source.replace(/<S>/g, function() {
            return space;
        }).replace(/<BRACES>/g, function() {
            return braces;
        }).replace(/<SPREAD>/g, function() {
            return spread;
        });
        return RegExp(source, flags);
    }
    spread = re(spread).source;
    Prism1.languages.jsx = Prism1.languages.extend('markup', javascript);
    Prism1.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
    Prism1.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
    Prism1.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
    Prism1.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
    Prism1.languages.jsx.tag.inside['comment'] = javascript['comment'];
    Prism1.languages.insertBefore('inside', 'attr-name', {
        'spread': {
            pattern: re(/<SPREAD>/.source),
            inside: Prism1.languages.jsx
        }
    }, Prism1.languages.jsx.tag);
    Prism1.languages.insertBefore('inside', 'special-attr', {
        'script': {
            // Allow for two levels of nesting
            pattern: re(/=<BRACES>/.source),
            alias: 'language-javascript',
            inside: {
                'script-punctuation': {
                    pattern: /^=(?=\{)/,
                    alias: 'punctuation'
                },
                rest: Prism1.languages.jsx
            }
        }
    }, Prism1.languages.jsx.tag);
    // The following will handle plain text inside tags
    var stringifyToken = function(token) {
        if (!token) return '';
        if (typeof token === 'string') return token;
        if (typeof token.content === 'string') return token.content;
        return token.content.map(stringifyToken).join('');
    };
    var walkTokens = function(tokens) {
        var openedTags = [];
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            var notTagNorBrace = false;
            if (typeof token !== 'string') {
                if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                    // We found a tag, now find its kind
                    if (token.content[0].content[0].content === '</') // Closing tag
                    {
                        if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                        openedTags.pop();
                    } else {
                        if (token.content[token.content.length - 1].content === '/>') ;
                        else // Opening tag
                        openedTags.push({
                            tagName: stringifyToken(token.content[0].content[1]),
                            openedBraces: 0
                        });
                    }
                } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces++;
                else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces--;
                else notTagNorBrace = true;
            }
            if (notTagNorBrace || typeof token === 'string') {
                if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                    // Here we are inside a tag, and not inside a JSX context.
                    // That's plain text: drop any tokens matched.
                    var plainText = stringifyToken(token);
                    // And merge text with adjacent text
                    if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                        plainText += stringifyToken(tokens[i + 1]);
                        tokens.splice(i + 1, 1);
                    }
                    if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                        plainText = stringifyToken(tokens[i - 1]) + plainText;
                        tokens.splice(i - 1, 1);
                        i--;
                    }
                    tokens[i] = new Prism1.Token('plain-text', plainText, null, plainText);
                }
            }
            if (token.content && typeof token.content !== 'string') walkTokens(token.content);
        }
    };
    Prism1.hooks.add('after-tokenize', function(env) {
        if (env.language !== 'jsx' && env.language !== 'tsx') return;
        walkTokens(env.tokens);
    });
})(Prism);

});

parcelRegister("8GElt", function(module, exports) {
(function(Prism1) {
    var typescript = Prism1.util.clone(Prism1.languages.typescript);
    Prism1.languages.tsx = Prism1.languages.extend('jsx', typescript);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.tsx['parameter'];
    delete Prism1.languages.tsx['literal-property'];
    // This will prevent collisions between TSX tags and TS generic types.
    // Idea by https://github.com/karlhorky
    // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
    var tag = Prism1.languages.tsx.tag;
    tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
    tag.lookbehind = true;
})(Prism);

});

parcelRegister("8KfTK", function(module, exports) {
(function(Prism1) {
    Prism1.languages.typescript = Prism1.languages.extend('javascript', {
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        'builtin': /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    });
    // The keywords TypeScript adds to JavaScript
    Prism1.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.typescript['parameter'];
    delete Prism1.languages.typescript['literal-property'];
    // a version of typescript specifically for highlighting types
    var typeInside = Prism1.languages.extend('typescript', {});
    delete typeInside['class-name'];
    Prism1.languages.typescript['class-name'].inside = typeInside;
    Prism1.languages.insertBefore('typescript', 'function', {
        'decorator': {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                'at': {
                    pattern: /^@/,
                    alias: 'operator'
                },
                'function': /^[\s\S]+/
            }
        },
        'generic-function': {
            // e.g. foo<T extends "bar" | "baz">( ...
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                'generic': {
                    pattern: /<[\s\S]+/,
                    alias: 'class-name',
                    inside: typeInside
                }
            }
        }
    });
    Prism1.languages.ts = Prism1.languages.typescript;
})(Prism);

});

parcelRegister("h7SvJ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $c77d5fd5036c6492$export$306c0aa65ff9ec16; }, function (v) { return $c77d5fd5036c6492$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c77d5fd5036c6492$export$306c0aa65ff9ec16;
"use strict";
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
var $kzd8a = parcelRequire("kzd8a");
function $c77d5fd5036c6492$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c77d5fd5036c6492$var$objectIs = "function" === typeof Object.is ? Object.is : $c77d5fd5036c6492$var$is, $c77d5fd5036c6492$var$useState = $jmWak.useState, $c77d5fd5036c6492$var$useEffect = $jmWak.useEffect, $c77d5fd5036c6492$var$useLayoutEffect = $jmWak.useLayoutEffect, $c77d5fd5036c6492$var$useDebugValue = $jmWak.useDebugValue;
function $c77d5fd5036c6492$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c77d5fd5036c6492$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c77d5fd5036c6492$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c77d5fd5036c6492$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c77d5fd5036c6492$var$useEffect(function() {
        $c77d5fd5036c6492$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c77d5fd5036c6492$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c77d5fd5036c6492$var$useDebugValue(value);
    return value;
}
function $c77d5fd5036c6492$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c77d5fd5036c6492$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c77d5fd5036c6492$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c77d5fd5036c6492$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c77d5fd5036c6492$var$useSyncExternalStore$1 : $c77d5fd5036c6492$var$useSyncExternalStore$2;
$c77d5fd5036c6492$export$306c0aa65ff9ec16 = void 0 !== $kzd8a.useSyncExternalStore ? $kzd8a.useSyncExternalStore : $c77d5fd5036c6492$var$shim;

});
parcelRegister("kzd8a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "useSyncExternalStore", function () { return $ef91430802c393f9$export$306c0aa65ff9ec16; });
$parcel$export(module.exports, "startTransition", function () { return $ef91430802c393f9$export$7568632d0d33d16d; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ef91430802c393f9$export$6a7bc4e911dc01cf; });
$parcel$export(module.exports, "useTransition", function () { return $ef91430802c393f9$export$7b286972b8d8ccbf; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ef91430802c393f9$export$aaabe4eda9ed9969; });
$parcel$export(module.exports, "PureComponent", function () { return $ef91430802c393f9$export$221d75b3f55bb0bd; });
$parcel$export(module.exports, "memo", function () { return $ef91430802c393f9$export$7c73462e0d25e514; });
$parcel$export(module.exports, "forwardRef", function () { return $ef91430802c393f9$export$257a8862b851cb5b; });
$parcel$export(module.exports, "Children", function () { return $ef91430802c393f9$export$dca3b0875bd9a954; });
$parcel$export(module.exports, "Suspense", function () { return $ef91430802c393f9$export$74bf444e3cd11ea5; });
$parcel$export(module.exports, "lazy", function () { return $ef91430802c393f9$export$488013bae63b21da; });
$parcel$export(module.exports, "SuspenseList", function () { return $ef91430802c393f9$export$998bcd577473dd93; });
$parcel$export(module.exports, "createPortal", function () { return $ef91430802c393f9$export$d39a5bbd09211389; });
$parcel$export(module.exports, "render", function () { return $ef91430802c393f9$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $ef91430802c393f9$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ef91430802c393f9$export$ae55be85d98224ed; });
$parcel$export(module.exports, "version", function () { return $ef91430802c393f9$export$83d89fbfd8236492; });
$parcel$export(module.exports, "createFactory", function () { return $ef91430802c393f9$export$d38cd72104c1f0e9; });
$parcel$export(module.exports, "isValidElement", function () { return $ef91430802c393f9$export$a8257692ac88316c; });
$parcel$export(module.exports, "isFragment", function () { return $ef91430802c393f9$export$9522e17588c12572; });
$parcel$export(module.exports, "isMemo", function () { return $ef91430802c393f9$export$56885ab8b9c456ab; });
$parcel$export(module.exports, "cloneElement", function () { return $ef91430802c393f9$export$e530037191fcd5d7; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $ef91430802c393f9$export$502457920280e6be; });
$parcel$export(module.exports, "findDOMNode", function () { return $ef91430802c393f9$export$466bfc07425424d5; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $ef91430802c393f9$export$c78a37762a8d58e1; });
$parcel$export(module.exports, "flushSync", function () { return $ef91430802c393f9$export$cd75ccfd720a3cd4; });
$parcel$export(module.exports, "isElement", function () { return $ef91430802c393f9$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "default", function () { return $ef91430802c393f9$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "Component", function () { return (parcelRequire("3lE4N")).Component; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("3lE4N")).Fragment; });
$parcel$export(module.exports, "StrictMode", function () { return (parcelRequire("3lE4N")).Fragment; });
$parcel$export(module.exports, "createContext", function () { return (parcelRequire("3lE4N")).createContext; });
$parcel$export(module.exports, "createElement", function () { return (parcelRequire("3lE4N")).createElement; });
$parcel$export(module.exports, "createRef", function () { return (parcelRequire("3lE4N")).createRef; });

var $3lE4N = parcelRequire("3lE4N");

var $jmWak = parcelRequire("jmWak");
function $ef91430802c393f9$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $ef91430802c393f9$var$E(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $ef91430802c393f9$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $jmWak.useState)({
        t: {
            __: e,
            u: t
        }
    }), u = r[0].t, o = r[1];
    return (0, $jmWak.useLayoutEffect)(function() {
        u.__ = e, u.u = t, $ef91430802c393f9$var$R(u) && o({
            t: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $jmWak.useEffect)(function() {
        return $ef91430802c393f9$var$R(u) && o({
            t: u
        }), n(function() {
            $ef91430802c393f9$var$R(u) && o({
                t: u
            });
        });
    }, [
        n
    ]), e;
}
function $ef91430802c393f9$var$R(n) {
    try {
        return !((t = n.__) === (e = n.u()) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
    var t, e;
}
function $ef91430802c393f9$export$7568632d0d33d16d(n) {
    n();
}
function $ef91430802c393f9$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $ef91430802c393f9$export$7b286972b8d8ccbf() {
    return [
        !1,
        $ef91430802c393f9$export$7568632d0d33d16d
    ];
}
var $ef91430802c393f9$export$aaabe4eda9ed9969 = (0, $jmWak.useLayoutEffect);
function $ef91430802c393f9$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $ef91430802c393f9$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref;
        return t != n.ref && t && ("function" == typeof t ? t(null) : t.current = null), e ? !e(this.props, n) || t != n.ref : $ef91430802c393f9$var$E(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $3lE4N.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.__f = u.prototype.isReactComponent = !0, u.type = n, u;
}
($ef91430802c393f9$export$221d75b3f55bb0bd.prototype = new (0, $3lE4N.Component)).isPureReactComponent = !0, $ef91430802c393f9$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $ef91430802c393f9$var$E(this.props, n) || $ef91430802c393f9$var$E(this.state, t);
};
var $ef91430802c393f9$var$T = (0, $3lE4N.options).__b;
(0, $3lE4N.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $ef91430802c393f9$var$T && $ef91430802c393f9$var$T(n);
};
var $ef91430802c393f9$var$A = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $ef91430802c393f9$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $ef91430802c393f9$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $ef91430802c393f9$var$A, t.render = n, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $ef91430802c393f9$var$F = function(n, t) {
    return null == n ? null : (0, $3lE4N.toChildArray)((0, $3lE4N.toChildArray)(n).map(t));
}, $ef91430802c393f9$export$dca3b0875bd9a954 = {
    map: $ef91430802c393f9$var$F,
    forEach: $ef91430802c393f9$var$F,
    count: function(n) {
        return n ? (0, $3lE4N.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $3lE4N.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $3lE4N.toChildArray)
}, $ef91430802c393f9$var$O = (0, $3lE4N.options).__e;
(0, $3lE4N.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $ef91430802c393f9$var$O(n, t, e, r);
};
var $ef91430802c393f9$var$U = (0, $3lE4N.options).unmount;
function $ef91430802c393f9$var$V(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $ef91430802c393f9$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = !0, n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $ef91430802c393f9$var$V(n, t, e);
    })), n;
}
function $ef91430802c393f9$var$W(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $ef91430802c393f9$var$W(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $ef91430802c393f9$export$74bf444e3cd11ea5() {
    this.__u = 0, this.o = null, this.__b = null;
}
function $ef91430802c393f9$var$j(n) {
    var t = n.__ && n.__.__c;
    return t && t.__a && t.__a(n);
}
function $ef91430802c393f9$export$488013bae63b21da(n) {
    var e, r, u, o = null;
    function i(i) {
        if (e || (e = n()).then(function(n) {
            n && (o = n.default || n), u = !0;
        }, function(n) {
            r = n, u = !0;
        }), r) throw r;
        if (!u) throw e;
        return o ? (0, $3lE4N.createElement)(o, i) : null;
    }
    return i.displayName = "Lazy", i.__f = !0, i;
}
function $ef91430802c393f9$export$998bcd577473dd93() {
    this.i = null, this.l = null;
}
(0, $3lE4N.options).unmount = function(n) {
    var t = n.__c;
    t && (t.__z = !0), t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $ef91430802c393f9$var$U && $ef91430802c393f9$var$U(n);
}, ($ef91430802c393f9$export$74bf444e3cd11ea5.prototype = new (0, $3lE4N.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.o && (r.o = []), r.o.push(e);
    var u = $ef91430802c393f9$var$j(r.__v), o = !1, i = function() {
        o || r.__z || (o = !0, e.__R = null, u ? u(c) : c());
    };
    e.__R = i;
    var l = e.__P;
    e.__P = null;
    var c = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $ef91430802c393f9$var$W(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.o.pop();)t.__P = l, t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $ef91430802c393f9$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.o = [];
}, $ef91430802c393f9$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $ef91430802c393f9$var$V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $3lE4N.createElement)((0, $3lE4N.Fragment), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $3lE4N.createElement)((0, $3lE4N.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $ef91430802c393f9$var$H = function(n, t, e) {
    if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for(e = n.i; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
    }
};
function $ef91430802c393f9$var$Z(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $ef91430802c393f9$var$Y(n) {
    var e = this, r = n.h;
    if (e.componentWillUnmount = function() {
        (0, $3lE4N.render)(null, e.v), e.v = null, e.h = null;
    }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for(var u = e.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        e.h = r, e.v = {
            nodeType: 1,
            parentNode: r,
            childNodes: [],
            __k: {
                __m: u.__m
            },
            contains: function() {
                return !0;
            },
            namespaceURI: r.namespaceURI,
            insertBefore: function(n, t) {
                this.childNodes.push(n), e.h.insertBefore(n, t);
            },
            removeChild: function(n) {
                this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.h.removeChild(n);
            }
        };
    }
    (0, $3lE4N.render)((0, $3lE4N.createElement)($ef91430802c393f9$var$Z, {
        context: e.context
    }, n.__v), e.v);
}
function $ef91430802c393f9$export$d39a5bbd09211389(n, e) {
    var r = (0, $3lE4N.createElement)($ef91430802c393f9$var$Y, {
        __v: n,
        h: e
    });
    return r.containerInfo = e, r;
}
($ef91430802c393f9$export$998bcd577473dd93.prototype = new (0, $3lE4N.Component)).__a = function(n) {
    var t = this, e = $ef91430802c393f9$var$j(t.__v), r = t.l.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $ef91430802c393f9$var$H(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $ef91430802c393f9$export$998bcd577473dd93.prototype.render = function(n) {
    this.i = null, this.l = new Map;
    var t = (0, $3lE4N.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.l.set(t[e], this.i = [
        1,
        0,
        this.i
    ]);
    return n.children;
}, $ef91430802c393f9$export$998bcd577473dd93.prototype.componentDidUpdate = $ef91430802c393f9$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.l.forEach(function(t, e) {
        $ef91430802c393f9$var$H(n, e, t);
    });
};
var $ef91430802c393f9$var$q = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $ef91430802c393f9$var$G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $ef91430802c393f9$var$J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $ef91430802c393f9$var$K = /[A-Z0-9]/g, $ef91430802c393f9$var$Q = "undefined" != typeof document, $ef91430802c393f9$var$X = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $ef91430802c393f9$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $3lE4N.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $ef91430802c393f9$export$fa8d919ba61d84db(n, t, e) {
    return (0, $3lE4N.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $3lE4N.Component).prototype.isReactComponent = !0, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $3lE4N.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $ef91430802c393f9$var$en = (0, $3lE4N.options).event;
(0, $3lE4N.options).event = function(n) {
    return $ef91430802c393f9$var$en && (n = $ef91430802c393f9$var$en(n)), n.persist = function() {}, n.isPropagationStopped = function() {
        return this.cancelBubble;
    }, n.isDefaultPrevented = function() {
        return this.defaultPrevented;
    }, n.nativeEvent = n;
};
var $ef91430802c393f9$var$rn, $ef91430802c393f9$var$un = {
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $ef91430802c393f9$var$on = (0, $3lE4N.options).vnode;
(0, $3lE4N.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {}, o = -1 == e.indexOf("-");
        for(var i in t){
            var l = t[i];
            if (!("value" === i && "defaultValue" in t && null == l || $ef91430802c393f9$var$Q && "children" === i && "noscript" === e || "class" === i || "className" === i)) {
                var c = i.toLowerCase();
                "defaultValue" === i && "value" in t && null == t.value ? i = "value" : "download" === i && !0 === l ? l = "" : "translate" === c && "no" === l ? l = !1 : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || $ef91430802c393f9$var$X(t.type) ? "onfocus" === c ? i = "onfocusin" : "onblur" === c ? i = "onfocusout" : $ef91430802c393f9$var$J.test(i) && (i = c) : c = i = "oninput" : o && $ef91430802c393f9$var$G.test(i) ? i = i.replace($ef91430802c393f9$var$K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i = c] && (i = "oninputCapture"), u[i] = l;
            }
        }
        "select" == e && (u.multiple && Array.isArray(u.value) && (u.value = (0, $3lE4N.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), null != u.defaultValue && (u.value = (0, $3lE4N.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        }))), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $ef91430802c393f9$var$un)) : t.className && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $ef91430802c393f9$var$q, $ef91430802c393f9$var$on && $ef91430802c393f9$var$on(n);
};
var $ef91430802c393f9$var$ln = (0, $3lE4N.options).__r;
(0, $3lE4N.options).__r = function(n) {
    $ef91430802c393f9$var$ln && $ef91430802c393f9$var$ln(n), $ef91430802c393f9$var$rn = n.__c;
};
var $ef91430802c393f9$var$cn = (0, $3lE4N.options).diffed;
(0, $3lE4N.options).diffed = function(n) {
    $ef91430802c393f9$var$cn && $ef91430802c393f9$var$cn(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $ef91430802c393f9$var$rn = null;
};
var $ef91430802c393f9$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $ef91430802c393f9$var$rn.__n[n.__c].props.value;
            },
            useCallback: (0, $jmWak.useCallback),
            useContext: (0, $jmWak.useContext),
            useDebugValue: (0, $jmWak.useDebugValue),
            useDeferredValue: $ef91430802c393f9$export$6a7bc4e911dc01cf,
            useEffect: (0, $jmWak.useEffect),
            useId: (0, $jmWak.useId),
            useImperativeHandle: (0, $jmWak.useImperativeHandle),
            useInsertionEffect: $ef91430802c393f9$export$aaabe4eda9ed9969,
            useLayoutEffect: (0, $jmWak.useLayoutEffect),
            useMemo: (0, $jmWak.useMemo),
            useReducer: (0, $jmWak.useReducer),
            useRef: (0, $jmWak.useRef),
            useState: (0, $jmWak.useState),
            useSyncExternalStore: $ef91430802c393f9$export$306c0aa65ff9ec16,
            useTransition: $ef91430802c393f9$export$7b286972b8d8ccbf
        }
    }
}, $ef91430802c393f9$export$83d89fbfd8236492 = "18.3.1";
function $ef91430802c393f9$export$d38cd72104c1f0e9(n) {
    return (0, $3lE4N.createElement).bind(null, n);
}
function $ef91430802c393f9$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $ef91430802c393f9$var$q;
}
function $ef91430802c393f9$export$9522e17588c12572(n) {
    return $ef91430802c393f9$export$a8257692ac88316c(n) && n.type === (0, $3lE4N.Fragment);
}
function $ef91430802c393f9$export$56885ab8b9c456ab(n) {
    return !!n && "string" == typeof n.displayName && 0 == n.displayName.indexOf("Memo(");
}
function $ef91430802c393f9$export$e530037191fcd5d7(n) {
    return $ef91430802c393f9$export$a8257692ac88316c(n) ? (0, $3lE4N.cloneElement).apply(null, arguments) : n;
}
function $ef91430802c393f9$export$502457920280e6be(n) {
    return !!n.__k && ((0, $3lE4N.render)(null, n), !0);
}
function $ef91430802c393f9$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $ef91430802c393f9$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $ef91430802c393f9$export$cd75ccfd720a3cd4 = function(n, t) {
    var r = (0, $3lE4N.options).debounceRendering;
    (0, $3lE4N.options).debounceRendering = function(n) {
        return n();
    };
    var u = n(t);
    return (0, $3lE4N.options).debounceRendering = r, u;
}, $ef91430802c393f9$export$45a5e7f76e0caa8d = $ef91430802c393f9$export$a8257692ac88316c, $ef91430802c393f9$export$2e2bcd8739ae039 = {
    useState: (0, $jmWak.useState),
    useId: (0, $jmWak.useId),
    useReducer: (0, $jmWak.useReducer),
    useEffect: (0, $jmWak.useEffect),
    useLayoutEffect: (0, $jmWak.useLayoutEffect),
    useInsertionEffect: $ef91430802c393f9$export$aaabe4eda9ed9969,
    useTransition: $ef91430802c393f9$export$7b286972b8d8ccbf,
    useDeferredValue: $ef91430802c393f9$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $ef91430802c393f9$export$306c0aa65ff9ec16,
    startTransition: $ef91430802c393f9$export$7568632d0d33d16d,
    useRef: (0, $jmWak.useRef),
    useImperativeHandle: (0, $jmWak.useImperativeHandle),
    useMemo: (0, $jmWak.useMemo),
    useCallback: (0, $jmWak.useCallback),
    useContext: (0, $jmWak.useContext),
    useDebugValue: (0, $jmWak.useDebugValue),
    version: "18.3.1",
    Children: $ef91430802c393f9$export$dca3b0875bd9a954,
    render: $ef91430802c393f9$export$b3890eb0ae9dca99,
    hydrate: $ef91430802c393f9$export$fa8d919ba61d84db,
    unmountComponentAtNode: $ef91430802c393f9$export$502457920280e6be,
    createPortal: $ef91430802c393f9$export$d39a5bbd09211389,
    createElement: (0, $3lE4N.createElement),
    createContext: (0, $3lE4N.createContext),
    createFactory: $ef91430802c393f9$export$d38cd72104c1f0e9,
    cloneElement: $ef91430802c393f9$export$e530037191fcd5d7,
    createRef: (0, $3lE4N.createRef),
    Fragment: (0, $3lE4N.Fragment),
    isValidElement: $ef91430802c393f9$export$a8257692ac88316c,
    isElement: $ef91430802c393f9$export$45a5e7f76e0caa8d,
    isFragment: $ef91430802c393f9$export$9522e17588c12572,
    isMemo: $ef91430802c393f9$export$56885ab8b9c456ab,
    findDOMNode: $ef91430802c393f9$export$466bfc07425424d5,
    Component: (0, $3lE4N.Component),
    PureComponent: $ef91430802c393f9$export$221d75b3f55bb0bd,
    memo: $ef91430802c393f9$export$7c73462e0d25e514,
    forwardRef: $ef91430802c393f9$export$257a8862b851cb5b,
    flushSync: $ef91430802c393f9$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $ef91430802c393f9$export$c78a37762a8d58e1,
    StrictMode: (0, $3lE4N.Fragment),
    Suspense: $ef91430802c393f9$export$74bf444e3cd11ea5,
    SuspenseList: $ef91430802c393f9$export$998bcd577473dd93,
    lazy: $ef91430802c393f9$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $ef91430802c393f9$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $jmWak);

});
parcelRegister("3lE4N", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $27026b9852a6016a$export$41c562ebe57d11e2; });
$parcel$export(module.exports, "createElement", function () { return $27026b9852a6016a$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "createRef", function () { return $27026b9852a6016a$export$7d1e3a5e95ceca43; });
$parcel$export(module.exports, "Fragment", function () { return $27026b9852a6016a$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Component", function () { return $27026b9852a6016a$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "toChildArray", function () { return $27026b9852a6016a$export$47e4c5b300681277; });
$parcel$export(module.exports, "render", function () { return $27026b9852a6016a$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "hydrate", function () { return $27026b9852a6016a$export$fa8d919ba61d84db; });
$parcel$export(module.exports, "cloneElement", function () { return $27026b9852a6016a$export$e530037191fcd5d7; });
$parcel$export(module.exports, "createContext", function () { return $27026b9852a6016a$export$fd42f52fd3ae1109; });
var $27026b9852a6016a$var$n, $27026b9852a6016a$export$41c562ebe57d11e2, $27026b9852a6016a$var$u, $27026b9852a6016a$export$a8257692ac88316c, $27026b9852a6016a$var$i, $27026b9852a6016a$var$r, $27026b9852a6016a$var$o, $27026b9852a6016a$var$e, $27026b9852a6016a$var$f, $27026b9852a6016a$var$c, $27026b9852a6016a$var$a, $27026b9852a6016a$var$s, $27026b9852a6016a$var$h, $27026b9852a6016a$var$p, $27026b9852a6016a$var$v, $27026b9852a6016a$var$y, $27026b9852a6016a$var$d = {}, $27026b9852a6016a$var$w = [], $27026b9852a6016a$var$_ = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $27026b9852a6016a$var$g = Array.isArray;
function $27026b9852a6016a$var$m(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $27026b9852a6016a$var$b(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $27026b9852a6016a$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $27026b9852a6016a$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $27026b9852a6016a$var$x(l, e, i, r, null);
}
function $27026b9852a6016a$var$x(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$27026b9852a6016a$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $27026b9852a6016a$export$41c562ebe57d11e2.vnode && $27026b9852a6016a$export$41c562ebe57d11e2.vnode(e), e;
}
function $27026b9852a6016a$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $27026b9852a6016a$export$ffb0004e005737fa(n) {
    return n.children;
}
function $27026b9852a6016a$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $27026b9852a6016a$var$$(n, l) {
    if (null == l) return n.__ ? $27026b9852a6016a$var$$(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $27026b9852a6016a$var$$(n) : null;
}
function $27026b9852a6016a$var$I(n) {
    if (n.__P && n.__d) {
        var u = n.__v, t = u.__e, i = [], r = [], o = $27026b9852a6016a$var$m({}, u);
        o.__v = u.__v + 1, $27026b9852a6016a$export$41c562ebe57d11e2.vnode && $27026b9852a6016a$export$41c562ebe57d11e2.vnode(o), $27026b9852a6016a$var$q(n.__P, o, u, n.__n, n.__P.namespaceURI, 32 & u.__u ? [
            t
        ] : null, i, null == t ? $27026b9852a6016a$var$$(u) : t, !!(32 & u.__u), r), o.__v = u.__v, o.__.__k[o.__i] = o, $27026b9852a6016a$var$D(i, o, r), u.__e = u.__ = null, o.__e != t && $27026b9852a6016a$var$P(o);
    }
}
function $27026b9852a6016a$var$P(n) {
    if (null != (n = n.__) && null != n.__c) return n.__e = n.__c.base = null, n.__k.some(function(l) {
        if (null != l && null != l.__e) return n.__e = n.__c.base = l.__e;
    }), $27026b9852a6016a$var$P(n);
}
function $27026b9852a6016a$var$A(n) {
    (!n.__d && (n.__d = !0) && $27026b9852a6016a$var$i.push(n) && !$27026b9852a6016a$var$H.__r++ || $27026b9852a6016a$var$r != $27026b9852a6016a$export$41c562ebe57d11e2.debounceRendering) && (($27026b9852a6016a$var$r = $27026b9852a6016a$export$41c562ebe57d11e2.debounceRendering) || $27026b9852a6016a$var$o)($27026b9852a6016a$var$H);
}
function $27026b9852a6016a$var$H() {
    try {
        for(var n, l = 1; $27026b9852a6016a$var$i.length;)$27026b9852a6016a$var$i.length > l && $27026b9852a6016a$var$i.sort($27026b9852a6016a$var$e), n = $27026b9852a6016a$var$i.shift(), l = $27026b9852a6016a$var$i.length, $27026b9852a6016a$var$I(n);
    } finally{
        $27026b9852a6016a$var$i.length = $27026b9852a6016a$var$H.__r = 0;
    }
}
function $27026b9852a6016a$var$L(n, l, u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, _, g, m = t && t.__k || $27026b9852a6016a$var$w, b = l.length;
    for(f = $27026b9852a6016a$var$T(u, l, m, f, b), s = 0; s < b; s++)null != (p = u.__k[s]) && (h = -1 != p.__i && m[p.__i] || $27026b9852a6016a$var$d, p.__i = s, _ = $27026b9852a6016a$var$q(n, p, h, i, r, o, e, f, c, a), v = p.__e, p.ref && h.ref != p.ref && (h.ref && $27026b9852a6016a$var$J(h.ref, null, p), a.push(p.ref, p.__c || v, p)), null == y && null != v && (y = v), (g = !!(4 & p.__u)) || h.__k === p.__k ? (f = $27026b9852a6016a$var$j(p, f, n, g), g && h.__e && (h.__e = null)) : "function" == typeof p.type && void 0 !== _ ? f = _ : v && (f = v.nextSibling), p.__u &= -7);
    return u.__e = y, f;
}
function $27026b9852a6016a$var$T(n, l, u, t, i) {
    var r, o, e, f, c, a = u.length, s = a, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? ("string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? o = n.__k[r] = $27026b9852a6016a$var$x(null, o, null, null, null) : $27026b9852a6016a$var$g(o) ? o = n.__k[r] = $27026b9852a6016a$var$x($27026b9852a6016a$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : void 0 === o.constructor && o.__b > 0 ? o = n.__k[r] = $27026b9852a6016a$var$x(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : n.__k[r] = o, f = r + h, o.__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $27026b9852a6016a$var$O(o, u, f, s)) && (s--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > a ? h-- : i < a && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (s) for(r = 0; r < a; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $27026b9852a6016a$var$$(e)), $27026b9852a6016a$var$K(e, e));
    return t;
}
function $27026b9852a6016a$var$j(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $27026b9852a6016a$var$j(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $27026b9852a6016a$var$$(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $27026b9852a6016a$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($27026b9852a6016a$var$g(n) ? n.some(function(n) {
        $27026b9852a6016a$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $27026b9852a6016a$var$O(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], a = null != c && 0 == (2 & c.__u);
    if (null === c && null == e || a && e == c.key && f == c.type) return u;
    if (t > (a ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $27026b9852a6016a$var$z(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $27026b9852a6016a$var$_.test(l) ? u : u + "px";
}
function $27026b9852a6016a$var$N(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $27026b9852a6016a$var$z(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $27026b9852a6016a$var$z(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($27026b9852a6016a$var$s, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u[$27026b9852a6016a$var$a] = t[$27026b9852a6016a$var$a] : (u[$27026b9852a6016a$var$a] = $27026b9852a6016a$var$h, n.addEventListener(l, r ? $27026b9852a6016a$var$v : $27026b9852a6016a$var$p, r)) : n.removeEventListener(l, r ? $27026b9852a6016a$var$v : $27026b9852a6016a$var$p, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $27026b9852a6016a$var$V(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u[$27026b9852a6016a$var$c]) u[$27026b9852a6016a$var$c] = $27026b9852a6016a$var$h++;
            else if (u[$27026b9852a6016a$var$c] < t[$27026b9852a6016a$var$a]) return;
            return t($27026b9852a6016a$export$41c562ebe57d11e2.event ? $27026b9852a6016a$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $27026b9852a6016a$var$q(n, u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, d, _, k, x, M, $, I, P, A, H, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (s = $27026b9852a6016a$export$41c562ebe57d11e2.__b) && s(u);
    n: if ("function" == typeof T) try {
        if (k = u.props, x = T.prototype && T.prototype.render, M = (s = T.contextType) && i[s.__c], $ = s ? M ? M.props.value : s.__ : i, t.__c ? _ = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(k, $) : (u.__c = h = new $27026b9852a6016a$export$16fa2f45be04daa8(k, $), h.constructor = T, h.render = $27026b9852a6016a$var$Q), M && M.sub(h), h.state || (h.state = {}), h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $27026b9852a6016a$var$m({}, h.__s)), $27026b9852a6016a$var$m(h.__s, T.getDerivedStateFromProps(k, h.__s))), v = h.props, y = h.state, h.__v = u, p) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && k !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(k, $), u.__v == t.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(k, h.__s, $)) {
                u.__v != t.__v && (h.props = k, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $27026b9852a6016a$var$w.push.apply(h.__h, h._sb), h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(k, h.__s, $), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, d);
            });
        }
        if (h.context = $, h.props = k, h.__P = n, h.__e = !1, I = $27026b9852a6016a$export$41c562ebe57d11e2.__r, P = 0, x) h.state = h.__s, h.__d = !1, I && I(u), s = h.render(h.props, h.state, h.context), $27026b9852a6016a$var$w.push.apply(h.__h, h._sb), h._sb = [];
        else do h.__d = !1, I && I(u), s = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++P < 25);
        h.state = h.__s, null != h.getChildContext && (i = $27026b9852a6016a$var$m($27026b9852a6016a$var$m({}, i), h.getChildContext())), x && !p && null != h.getSnapshotBeforeUpdate && (d = h.getSnapshotBeforeUpdate(v, y)), A = null != s && s.type === $27026b9852a6016a$export$ffb0004e005737fa && null == s.key ? $27026b9852a6016a$var$E(s.props.children) : s, f = $27026b9852a6016a$var$L(n, $27026b9852a6016a$var$g(A) ? A : [
            A
        ], u, t, i, r, o, e, f, c, a), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), _ && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(H = o.length; H--;)$27026b9852a6016a$var$b(o[H]);
                $27026b9852a6016a$var$B(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $27026b9852a6016a$var$B(u);
        $27026b9852a6016a$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $27026b9852a6016a$var$G(t.__e, u, t, i, r, o, e, c, a);
    return (s = $27026b9852a6016a$export$41c562ebe57d11e2.diffed) && s(u), 128 & u.__u ? void 0 : f;
}
function $27026b9852a6016a$var$B(n) {
    n && (n.__c && (n.__c.__e = !0), n.__k && n.__k.some($27026b9852a6016a$var$B));
}
function $27026b9852a6016a$var$D(n, u, t) {
    for(var i = 0; i < t.length; i++)$27026b9852a6016a$var$J(t[i], t[++i], t[++i]);
    $27026b9852a6016a$export$41c562ebe57d11e2.__c && $27026b9852a6016a$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $27026b9852a6016a$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $27026b9852a6016a$var$E(n) {
    return "object" != typeof n || null == n || n.__b > 0 ? n : $27026b9852a6016a$var$g(n) ? n.map($27026b9852a6016a$var$E) : void 0 !== n.constructor ? null : $27026b9852a6016a$var$m({}, n);
}
function $27026b9852a6016a$var$G(u, t, i, r, o, e, f, c, a) {
    var s, h, p, v, y, w, _, m = i.props || $27026b9852a6016a$var$d, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(s = 0; s < e.length; s++)if ((y = e[s]) && "setAttribute" in y == !!x && (x ? y.localName == x : 3 == y.nodeType)) {
            u = y, e[s] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($27026b9852a6016a$export$41c562ebe57d11e2.__m && $27026b9852a6016a$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) m === k || c && u.data == k || (u.data = k);
    else {
        if (e = "textarea" == x && null != k.defaultValue ? null : e && $27026b9852a6016a$var$n.call(u.childNodes), !c && null != e) for(m = {}, s = 0; s < u.attributes.length; s++)m[(y = u.attributes[s]).name] = y.value;
        for(s in m)y = m[s], "dangerouslySetInnerHTML" == s ? p = y : "children" == s || s in k || "value" == s && "defaultValue" in k || "checked" == s && "defaultChecked" in k || $27026b9852a6016a$var$N(u, s, null, y, o);
        for(s in k)y = k[s], "children" == s ? v = y : "dangerouslySetInnerHTML" == s ? h = y : "value" == s ? w = y : "checked" == s ? _ = y : c && "function" != typeof y || m[s] === y || $27026b9852a6016a$var$N(u, s, y, m[s], o);
        if (h) c || p && (h.__html == p.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $27026b9852a6016a$var$L("template" == t.type ? u.content : u, $27026b9852a6016a$var$g(v) ? v : [
            v
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $27026b9852a6016a$var$$(i, 0), c, a), null != e) for(s = e.length; s--;)$27026b9852a6016a$var$b(e[s]);
        c && "textarea" != x || (s = "value", "progress" == x && null == w ? u.removeAttribute("value") : null != w && (w !== u[s] || "progress" == x && !w || "option" == x && w != m[s]) && $27026b9852a6016a$var$N(u, s, w, m[s], o), s = "checked", null != _ && _ != u[s] && $27026b9852a6016a$var$N(u, s, _, m[s], o));
    }
    return u;
}
function $27026b9852a6016a$var$J(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $27026b9852a6016a$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $27026b9852a6016a$var$K(n, u, t) {
    var i, r;
    if ($27026b9852a6016a$export$41c562ebe57d11e2.unmount && $27026b9852a6016a$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $27026b9852a6016a$var$J(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $27026b9852a6016a$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $27026b9852a6016a$var$K(i[r], u, t || "function" != typeof n.type);
    t || $27026b9852a6016a$var$b(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $27026b9852a6016a$var$Q(n, l, u) {
    return this.constructor(n, u);
}
function $27026b9852a6016a$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $27026b9852a6016a$export$41c562ebe57d11e2.__ && $27026b9852a6016a$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $27026b9852a6016a$var$q(t, u = (!r && i || t).__k = $27026b9852a6016a$export$c8a8987d4410bf2d($27026b9852a6016a$export$ffb0004e005737fa, null, [
        u
    ]), o || $27026b9852a6016a$var$d, $27026b9852a6016a$var$d, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $27026b9852a6016a$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $27026b9852a6016a$var$D(e, u, f);
}
function $27026b9852a6016a$export$fa8d919ba61d84db(n, l) {
    $27026b9852a6016a$export$b3890eb0ae9dca99(n, l, $27026b9852a6016a$export$fa8d919ba61d84db);
}
function $27026b9852a6016a$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $27026b9852a6016a$var$m({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $27026b9852a6016a$var$n.call(arguments, 2) : t), $27026b9852a6016a$var$x(l.type, f, i || l.key, r || l.ref, null);
}
function $27026b9852a6016a$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $27026b9852a6016a$var$A(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $27026b9852a6016a$var$y++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$27026b9852a6016a$var$n = $27026b9852a6016a$var$w.slice, $27026b9852a6016a$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $27026b9852a6016a$var$u = 0, $27026b9852a6016a$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $27026b9852a6016a$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $27026b9852a6016a$var$m({}, this.state), "function" == typeof n && (n = n($27026b9852a6016a$var$m({}, u), this.props)), n && $27026b9852a6016a$var$m(u, n), null != n && this.__v && (l && this._sb.push(l), $27026b9852a6016a$var$A(this));
}, $27026b9852a6016a$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $27026b9852a6016a$var$A(this));
}, $27026b9852a6016a$export$16fa2f45be04daa8.prototype.render = $27026b9852a6016a$export$ffb0004e005737fa, $27026b9852a6016a$var$i = [], $27026b9852a6016a$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $27026b9852a6016a$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $27026b9852a6016a$var$H.__r = 0, $27026b9852a6016a$var$f = Math.random().toString(8), $27026b9852a6016a$var$c = "__d" + $27026b9852a6016a$var$f, $27026b9852a6016a$var$a = "__a" + $27026b9852a6016a$var$f, $27026b9852a6016a$var$s = /(PointerCapture)$|Capture$/i, $27026b9852a6016a$var$h = 0, $27026b9852a6016a$var$p = $27026b9852a6016a$var$V(!1), $27026b9852a6016a$var$v = $27026b9852a6016a$var$V(!0), $27026b9852a6016a$var$y = 0;

});

parcelRegister("jmWak", function(module, exports) {

$parcel$export(module.exports, "useState", function () { return $e19d30db60d12d4b$export$60241385465d0a34; });
$parcel$export(module.exports, "useReducer", function () { return $e19d30db60d12d4b$export$13e3392192263954; });
$parcel$export(module.exports, "useEffect", function () { return $e19d30db60d12d4b$export$6d9c69b0de29b591; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e19d30db60d12d4b$export$e5c5a5f917a5871c; });
$parcel$export(module.exports, "useRef", function () { return $e19d30db60d12d4b$export$b8f5890fc79d6aca; });
$parcel$export(module.exports, "useMemo", function () { return $e19d30db60d12d4b$export$1538c33de8887b59; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e19d30db60d12d4b$export$d5a552a76deda3c2; });
$parcel$export(module.exports, "useCallback", function () { return $e19d30db60d12d4b$export$35808ee640e87ca7; });
$parcel$export(module.exports, "useContext", function () { return $e19d30db60d12d4b$export$fae74005e78b1a27; });
$parcel$export(module.exports, "useDebugValue", function () { return $e19d30db60d12d4b$export$dc8fbce3eb94dc1e; });
$parcel$export(module.exports, "useErrorBoundary", function () { return $e19d30db60d12d4b$export$c052f6604b7d51fe; });
$parcel$export(module.exports, "useId", function () { return $e19d30db60d12d4b$export$f680877a34711e37; });

var $3lE4N = parcelRequire("3lE4N");
var $e19d30db60d12d4b$var$t, $e19d30db60d12d4b$var$r, $e19d30db60d12d4b$var$u, $e19d30db60d12d4b$var$i, $e19d30db60d12d4b$var$o = 0, $e19d30db60d12d4b$var$f = [], $e19d30db60d12d4b$var$c = (0, $3lE4N.options), $e19d30db60d12d4b$var$e = $e19d30db60d12d4b$var$c.__b, $e19d30db60d12d4b$var$a = $e19d30db60d12d4b$var$c.__r, $e19d30db60d12d4b$var$v = $e19d30db60d12d4b$var$c.diffed, $e19d30db60d12d4b$var$l = $e19d30db60d12d4b$var$c.__c, $e19d30db60d12d4b$var$m = $e19d30db60d12d4b$var$c.unmount, $e19d30db60d12d4b$var$s = $e19d30db60d12d4b$var$c.__;
function $e19d30db60d12d4b$var$p(n, t) {
    $e19d30db60d12d4b$var$c.__h && $e19d30db60d12d4b$var$c.__h($e19d30db60d12d4b$var$r, n, $e19d30db60d12d4b$var$o || t), $e19d30db60d12d4b$var$o = 0;
    var u = $e19d30db60d12d4b$var$r.__H || ($e19d30db60d12d4b$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({}), u.__[n];
}
function $e19d30db60d12d4b$export$60241385465d0a34(n) {
    return $e19d30db60d12d4b$var$o = 1, $e19d30db60d12d4b$export$13e3392192263954($e19d30db60d12d4b$var$D, n);
}
function $e19d30db60d12d4b$export$13e3392192263954(n, u, i) {
    var o = $e19d30db60d12d4b$var$p($e19d30db60d12d4b$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $e19d30db60d12d4b$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $e19d30db60d12d4b$var$r, !$e19d30db60d12d4b$var$r.__f)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = o.__c.props !== n;
            return u.some(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), c && c.call(this, n, t, r) || i;
        };
        $e19d30db60d12d4b$var$r.__f = !0;
        var c = $e19d30db60d12d4b$var$r.shouldComponentUpdate, e = $e19d30db60d12d4b$var$r.componentWillUpdate;
        $e19d30db60d12d4b$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $e19d30db60d12d4b$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $e19d30db60d12d4b$export$6d9c69b0de29b591(n, u) {
    var i = $e19d30db60d12d4b$var$p($e19d30db60d12d4b$var$t++, 3);
    !$e19d30db60d12d4b$var$c.__s && $e19d30db60d12d4b$var$C(i.__H, u) && (i.__ = n, i.u = u, $e19d30db60d12d4b$var$r.__H.__h.push(i));
}
function $e19d30db60d12d4b$export$e5c5a5f917a5871c(n, u) {
    var i = $e19d30db60d12d4b$var$p($e19d30db60d12d4b$var$t++, 4);
    !$e19d30db60d12d4b$var$c.__s && $e19d30db60d12d4b$var$C(i.__H, u) && (i.__ = n, i.u = u, $e19d30db60d12d4b$var$r.__h.push(i));
}
function $e19d30db60d12d4b$export$b8f5890fc79d6aca(n) {
    return $e19d30db60d12d4b$var$o = 5, $e19d30db60d12d4b$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $e19d30db60d12d4b$export$d5a552a76deda3c2(n, t, r) {
    $e19d30db60d12d4b$var$o = 6, $e19d30db60d12d4b$export$e5c5a5f917a5871c(function() {
        if ("function" == typeof n) {
            var r = n(t());
            return function() {
                n(null), r && "function" == typeof r && r();
            };
        }
        if (n) return n.current = t(), function() {
            return n.current = null;
        };
    }, null == r ? r : r.concat(n));
}
function $e19d30db60d12d4b$export$1538c33de8887b59(n, r) {
    var u = $e19d30db60d12d4b$var$p($e19d30db60d12d4b$var$t++, 7);
    return $e19d30db60d12d4b$var$C(u.__H, r) && (u.__ = n(), u.__H = r, u.__h = n), u.__;
}
function $e19d30db60d12d4b$export$35808ee640e87ca7(n, t) {
    return $e19d30db60d12d4b$var$o = 8, $e19d30db60d12d4b$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $e19d30db60d12d4b$export$fae74005e78b1a27(n) {
    var u = $e19d30db60d12d4b$var$r.context[n.__c], i = $e19d30db60d12d4b$var$p($e19d30db60d12d4b$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($e19d30db60d12d4b$var$r)), u.props.value) : n.__;
}
function $e19d30db60d12d4b$export$dc8fbce3eb94dc1e(n, t) {
    $e19d30db60d12d4b$var$c.useDebugValue && $e19d30db60d12d4b$var$c.useDebugValue(t ? t(n) : n);
}
function $e19d30db60d12d4b$export$c052f6604b7d51fe(n) {
    var u = $e19d30db60d12d4b$var$p($e19d30db60d12d4b$var$t++, 10), i = $e19d30db60d12d4b$export$60241385465d0a34();
    return u.__ = n, $e19d30db60d12d4b$var$r.componentDidCatch || ($e19d30db60d12d4b$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $e19d30db60d12d4b$export$f680877a34711e37() {
    var n = $e19d30db60d12d4b$var$p($e19d30db60d12d4b$var$t++, 11);
    if (!n.__) {
        for(var u = $e19d30db60d12d4b$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $e19d30db60d12d4b$var$j() {
    for(var n; n = $e19d30db60d12d4b$var$f.shift();){
        var t = n.__H;
        if (n.__P && t) try {
            t.__h.some($e19d30db60d12d4b$var$z), t.__h.some($e19d30db60d12d4b$var$B), t.__h = [];
        } catch (r) {
            t.__h = [], $e19d30db60d12d4b$var$c.__e(r, n.__v);
        }
    }
}
$e19d30db60d12d4b$var$c.__b = function(n) {
    $e19d30db60d12d4b$var$r = null, $e19d30db60d12d4b$var$e && $e19d30db60d12d4b$var$e(n);
}, $e19d30db60d12d4b$var$c.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $e19d30db60d12d4b$var$s && $e19d30db60d12d4b$var$s(n, t);
}, $e19d30db60d12d4b$var$c.__r = function(n) {
    $e19d30db60d12d4b$var$a && $e19d30db60d12d4b$var$a(n), $e19d30db60d12d4b$var$t = 0;
    var i = ($e19d30db60d12d4b$var$r = n.__c).__H;
    i && ($e19d30db60d12d4b$var$u === $e19d30db60d12d4b$var$r ? (i.__h = [], $e19d30db60d12d4b$var$r.__h = [], i.__.some(function(n) {
        n.__N && (n.__ = n.__N), n.u = n.__N = void 0;
    })) : (i.__h.some($e19d30db60d12d4b$var$z), i.__h.some($e19d30db60d12d4b$var$B), i.__h = [], $e19d30db60d12d4b$var$t = 0)), $e19d30db60d12d4b$var$u = $e19d30db60d12d4b$var$r;
}, $e19d30db60d12d4b$var$c.diffed = function(n) {
    $e19d30db60d12d4b$var$v && $e19d30db60d12d4b$var$v(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $e19d30db60d12d4b$var$f.push(t) && $e19d30db60d12d4b$var$i === $e19d30db60d12d4b$var$c.requestAnimationFrame || (($e19d30db60d12d4b$var$i = $e19d30db60d12d4b$var$c.requestAnimationFrame) || $e19d30db60d12d4b$var$w)($e19d30db60d12d4b$var$j)), t.__H.__.some(function(n) {
        n.u && (n.__H = n.u), n.u = void 0;
    })), $e19d30db60d12d4b$var$u = $e19d30db60d12d4b$var$r = null;
}, $e19d30db60d12d4b$var$c.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.some($e19d30db60d12d4b$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $e19d30db60d12d4b$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $e19d30db60d12d4b$var$c.__e(r, n.__v);
        }
    }), $e19d30db60d12d4b$var$l && $e19d30db60d12d4b$var$l(n, t);
}, $e19d30db60d12d4b$var$c.unmount = function(n) {
    $e19d30db60d12d4b$var$m && $e19d30db60d12d4b$var$m(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.some(function(n) {
        try {
            $e19d30db60d12d4b$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $e19d30db60d12d4b$var$c.__e(t, r.__v));
};
var $e19d30db60d12d4b$var$k = "function" == typeof requestAnimationFrame;
function $e19d30db60d12d4b$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $e19d30db60d12d4b$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 35);
    $e19d30db60d12d4b$var$k && (t = requestAnimationFrame(r));
}
function $e19d30db60d12d4b$var$z(n) {
    var t = $e19d30db60d12d4b$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $e19d30db60d12d4b$var$r = t;
}
function $e19d30db60d12d4b$var$B(n) {
    var t = $e19d30db60d12d4b$var$r;
    n.__c = n.__(), $e19d30db60d12d4b$var$r = t;
}
function $e19d30db60d12d4b$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $e19d30db60d12d4b$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});



parcelRegister("ddVow", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("bD1fn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $87744dd67f15048f$export$2e2bcd8739ae039; });

var $kzd8a = parcelRequire("kzd8a");

var $9XiEx = parcelRequire("9XiEx");

var $ih6Ev = parcelRequire("ih6Ev");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $87744dd67f15048f$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $87744dd67f15048f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $87744dd67f15048f$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $87744dd67f15048f$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, $kzd8a.default).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, $kzd8a.default).useRef(null);
    (0, $kzd8a.default).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, $kzd8a.default).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, $kzd8a.default).createElement("div", {
        id: memoizedHolder.current
    });
}
class $87744dd67f15048f$var$ClientEditorCore {
    constructor(_a){
        var { tools: tools } = _a, config = $87744dd67f15048f$var$__rest(_a, [
            "tools"
        ]);
        const extendTools = Object.assign({
            // default tools
            paragraph: {
                class: (0, $ih6Ev.default),
                inlineToolbar: true
            }
        }, tools);
        this._editorJS = new (0, $9XiEx.default)(Object.assign({
            tools: extendTools
        }, config));
    }
    get dangerouslyLowLevelInstance() {
        return this._editorJS;
    }
    clear() {
        return $87744dd67f15048f$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.clear();
        });
    }
    save() {
        return $87744dd67f15048f$var$__awaiter(this, void 0, void 0, function*() {
            return this._editorJS.save();
        });
    }
    destroy() {
        return $87744dd67f15048f$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.isReady;
            yield this._editorJS.destroy();
        });
    }
    render(data) {
        return $87744dd67f15048f$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.render(data);
        });
    }
}
function $87744dd67f15048f$export$2e2bcd8739ae039(props) {
    const factory = (0, $kzd8a.default).useCallback((config)=>new $87744dd67f15048f$var$ClientEditorCore(config), []);
    return (0, $kzd8a.default).createElement($87744dd67f15048f$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});
parcelRegister("9XiEx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf1b19b2f7a01d6$export$2e2bcd8739ae039; });
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
        }
    } catch (t1) {
        console.error("vite-plugin-css-injected-by-js", t1);
    }
})();
var $0cf1b19b2f7a01d6$var$Ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $0cf1b19b2f7a01d6$var$Ke(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $0cf1b19b2f7a01d6$var$Xn(n) {
    if (n.__esModule) return n;
    var e = n.default;
    if (typeof e == "function") {
        var t1 = function o() {
            return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t1.prototype = e.prototype;
    } else t1 = {};
    return Object.defineProperty(t1, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(o) {
        var i = Object.getOwnPropertyDescriptor(n, o);
        Object.defineProperty(t1, o, i.get ? i : {
            enumerable: !0,
            get: function() {
                return n[o];
            }
        });
    }), t1;
}
function $0cf1b19b2f7a01d6$var$ot() {}
Object.assign($0cf1b19b2f7a01d6$var$ot, {
    default: $0cf1b19b2f7a01d6$var$ot,
    register: $0cf1b19b2f7a01d6$var$ot,
    revert: function() {},
    __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(n) {
    const e = (this.document || this.ownerDocument).querySelectorAll(n);
    let t1 = e.length;
    for(; --t1 >= 0 && e.item(t1) !== this;);
    return t1 > -1;
});
Element.prototype.closest || (Element.prototype.closest = function(n) {
    let e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
        if (e.matches(n)) return e;
        e = e.parentElement || e.parentNode;
    }while (e !== null);
    return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function(e) {
    const t1 = document.createDocumentFragment();
    Array.isArray(e) || (e = [
        e
    ]), e.forEach((o)=>{
        const i = o instanceof Node;
        t1.appendChild(i ? o : document.createTextNode(o));
    }), this.insertBefore(t1, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function(n) {
    n = arguments.length === 0 ? !0 : !!n;
    const e = this.parentNode, t1 = window.getComputedStyle(e, null), o = parseInt(t1.getPropertyValue("border-top-width")), i = parseInt(t1.getPropertyValue("border-left-width")), s = this.offsetTop - e.offsetTop < e.scrollTop, r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight, a = this.offsetLeft - e.offsetLeft < e.scrollLeft, l = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth, c = s && !r;
    (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (a || l) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || a || l) && !n && this.scrollIntoView(c);
});
window.requestIdleCallback = window.requestIdleCallback || function(n) {
    const e = Date.now();
    return setTimeout(function() {
        n({
            didTimeout: !1,
            timeRemaining: function() {
                return Math.max(0, 50 - (Date.now() - e));
            }
        });
    }, 1);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
    clearTimeout(n);
};
let $0cf1b19b2f7a01d6$var$Vn = (n = 21)=>crypto.getRandomValues(new Uint8Array(n)).reduce((e, t1)=>(t1 &= 63, t1 < 36 ? e += t1.toString(36) : t1 < 62 ? e += (t1 - 26).toString(36).toUpperCase() : t1 > 62 ? e += "-" : e += "_", e), "");
var $0cf1b19b2f7a01d6$var$Lo = /* @__PURE__ */ ((n)=>(n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n))($0cf1b19b2f7a01d6$var$Lo || {});
const $0cf1b19b2f7a01d6$var$y = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $0cf1b19b2f7a01d6$var$qn = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
function $0cf1b19b2f7a01d6$var$Ie(n, e, t1 = "log", o, i = "color: inherit") {
    if (!("console" in window) || !window.console[t1]) return;
    const s = [
        "info",
        "log",
        "warn",
        "error"
    ].includes(t1), r = [];
    switch($0cf1b19b2f7a01d6$var$Ie.logLevel){
        case "ERROR":
            if (t1 !== "error") return;
            break;
        case "WARN":
            if (![
                "error",
                "warn"
            ].includes(t1)) return;
            break;
        case "INFO":
            if (!s || n) return;
            break;
    }
    o && r.push(o);
    const a = "Editor.js 2.31.6", l = `line-height: 1em;
            color: #006FEA;
            display: inline-block;
            font-size: 11px;
            line-height: 1em;
            background-color: #fff;
            padding: 4px 9px;
            border-radius: 30px;
            border: 1px solid rgba(56, 138, 229, 0.16);
            margin: 4px 5px 4px 0;`;
    n && (s ? (r.unshift(l, i), e = `%c${a}%c ${e}`) : e = `( ${a} )${e}`);
    try {
        s ? o ? console[t1](`${e} %o`, ...r) : console[t1](e, ...r) : console[t1](e);
    } catch  {}
}
$0cf1b19b2f7a01d6$var$Ie.logLevel = "VERBOSE";
function $0cf1b19b2f7a01d6$var$Zn(n) {
    $0cf1b19b2f7a01d6$var$Ie.logLevel = n;
}
const $0cf1b19b2f7a01d6$var$S = $0cf1b19b2f7a01d6$var$Ie.bind(window, !1), $0cf1b19b2f7a01d6$var$X = $0cf1b19b2f7a01d6$var$Ie.bind(window, !0);
function $0cf1b19b2f7a01d6$var$le(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $0cf1b19b2f7a01d6$var$A(n) {
    return $0cf1b19b2f7a01d6$var$le(n) === "function" || $0cf1b19b2f7a01d6$var$le(n) === "asyncfunction";
}
function $0cf1b19b2f7a01d6$var$D(n) {
    return $0cf1b19b2f7a01d6$var$le(n) === "object";
}
function $0cf1b19b2f7a01d6$var$te(n) {
    return $0cf1b19b2f7a01d6$var$le(n) === "string";
}
function $0cf1b19b2f7a01d6$var$Gn(n) {
    return $0cf1b19b2f7a01d6$var$le(n) === "boolean";
}
function $0cf1b19b2f7a01d6$var$yo(n) {
    return $0cf1b19b2f7a01d6$var$le(n) === "number";
}
function $0cf1b19b2f7a01d6$var$wo(n) {
    return $0cf1b19b2f7a01d6$var$le(n) === "undefined";
}
function $0cf1b19b2f7a01d6$var$V(n) {
    return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}
function $0cf1b19b2f7a01d6$var$Po(n) {
    return n > 47 && n < 58 || // number keys
    n === 32 || n === 13 || // Space bar & return key(s)
    n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    n > 64 && n < 91 || // letter keys
    n > 95 && n < 112 || // Numpad keys
    n > 185 && n < 193 || // ;=,-./` (in order)
    n > 218 && n < 223;
}
async function $0cf1b19b2f7a01d6$var$Qn(n, e = ()=>{}, t1 = ()=>{}) {
    async function o(i, s, r) {
        try {
            await i.function(i.data), await s($0cf1b19b2f7a01d6$var$wo(i.data) ? {} : i.data);
        } catch  {
            r($0cf1b19b2f7a01d6$var$wo(i.data) ? {} : i.data);
        }
    }
    return n.reduce(async (i, s)=>(await i, o(s, e, t1)), Promise.resolve());
}
function $0cf1b19b2f7a01d6$var$No(n) {
    return Array.prototype.slice.call(n);
}
function $0cf1b19b2f7a01d6$var$Fe(n, e) {
    return function() {
        const t1 = this, o = arguments;
        window.setTimeout(()=>n.apply(t1, o), e);
    };
}
function $0cf1b19b2f7a01d6$var$Jn(n) {
    return n.name.split(".").pop();
}
function $0cf1b19b2f7a01d6$var$ei(n) {
    return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}
function $0cf1b19b2f7a01d6$var$Eo(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = null, t1 || n.apply(s, i);
        }, a = t1 && !o;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $0cf1b19b2f7a01d6$var$dt(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r || (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
function $0cf1b19b2f7a01d6$var$ti() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e && (n[e] = !0), n;
}
function $0cf1b19b2f7a01d6$var$je(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $0cf1b19b2f7a01d6$var$ut(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($0cf1b19b2f7a01d6$var$D(n) && $0cf1b19b2f7a01d6$var$D(t1)) for(const o in t1)$0cf1b19b2f7a01d6$var$D(t1[o]) ? (n[o] || Object.assign(n, {
        [o]: {}
    }), $0cf1b19b2f7a01d6$var$ut(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $0cf1b19b2f7a01d6$var$ut(n, ...e);
}
function $0cf1b19b2f7a01d6$var$vt(n) {
    const e = $0cf1b19b2f7a01d6$var$ti();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $0cf1b19b2f7a01d6$var$oi(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $0cf1b19b2f7a01d6$var$ni() {
    return $0cf1b19b2f7a01d6$var$Vn(10);
}
function $0cf1b19b2f7a01d6$var$ii(n) {
    window.open(n, "_blank");
}
function $0cf1b19b2f7a01d6$var$si(n = "") {
    return `${n}${Math.floor(Math.random() * 1e8).toString(16)}`;
}
function $0cf1b19b2f7a01d6$var$ht(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && $0cf1b19b2f7a01d6$var$X(o, "warn");
}
function $0cf1b19b2f7a01d6$var$me(n, e, t1) {
    const o = t1.value ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, ...r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
const $0cf1b19b2f7a01d6$var$Ro = 650;
function $0cf1b19b2f7a01d6$var$be() {
    return window.matchMedia(`(max-width: ${$0cf1b19b2f7a01d6$var$Ro}px)`).matches;
}
const $0cf1b19b2f7a01d6$var$pt = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $0cf1b19b2f7a01d6$var$ri(n, e) {
    const t1 = Array.isArray(n) || $0cf1b19b2f7a01d6$var$D(n), o = Array.isArray(e) || $0cf1b19b2f7a01d6$var$D(e);
    return t1 || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}
class $0cf1b19b2f7a01d6$var$u {
    /**
   * Check if passed tag has no closed tag
   *
   * @param {HTMLElement} tag - element to check
   * @returns {boolean}
   */ static isSingleTag(e) {
        return e.tagName && [
            "AREA",
            "BASE",
            "BR",
            "COL",
            "COMMAND",
            "EMBED",
            "HR",
            "IMG",
            "INPUT",
            "KEYGEN",
            "LINK",
            "META",
            "PARAM",
            "SOURCE",
            "TRACK",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Check if element is BR or WBR
   *
   * @param {HTMLElement} element - element to check
   * @returns {boolean}
   */ static isLineBreakTag(e) {
        return e && e.tagName && [
            "BR",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Helper for making Elements with class name and attributes
   *
   * @param  {string} tagName - new Element tag name
   * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
   * @param  {object} [attributes] - any attributes
   * @returns {HTMLElement}
   */ static make(e, t1 = null, o = {}) {
        const i = document.createElement(e);
        if (Array.isArray(t1)) {
            const s = t1.filter((r)=>r !== void 0);
            i.classList.add(...s);
        } else t1 && i.classList.add(t1);
        for(const s in o)Object.prototype.hasOwnProperty.call(o, s) && (i[s] = o[s]);
        return i;
    }
    /**
   * Creates Text Node with the passed content
   *
   * @param {string} content - text content
   * @returns {Text}
   */ static text(e) {
        return document.createTextNode(e);
    }
    /**
   * Append one or several elements to the parent
   *
   * @param  {Element|DocumentFragment} parent - where to append
   * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
   */ static append(e, t1) {
        Array.isArray(t1) ? t1.forEach((o)=>e.appendChild(o)) : e.appendChild(t1);
    }
    /**
   * Append element or a couple to the beginning of the parent elements
   *
   * @param {Element} parent - where to append
   * @param {Element|Element[]} elements - element or elements list
   */ static prepend(e, t1) {
        Array.isArray(t1) ? (t1 = t1.reverse(), t1.forEach((o)=>e.prepend(o))) : e.prepend(t1);
    }
    /**
   * Swap two elements in parent
   *
   * @param {HTMLElement} el1 - from
   * @param {HTMLElement} el2 - to
   * @deprecated
   */ static swap(e, t1) {
        const o = document.createElement("div"), i = e.parentNode;
        i.insertBefore(o, e), i.insertBefore(e, t1), i.insertBefore(t1, o), i.removeChild(o);
    }
    /**
   * Selector Decorator
   *
   * Returns first match
   *
   * @param {Element} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {Element}
   */ static find(e = document, t1) {
        return e.querySelector(t1);
    }
    /**
   * Get Element by Id
   *
   * @param {string} id - id to find
   * @returns {HTMLElement | null}
   */ static get(e) {
        return document.getElementById(e);
    }
    /**
   * Selector Decorator.
   *
   * Returns all matches
   *
   * @param {Element|Document} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {NodeList}
   */ static findAll(e = document, t1) {
        return e.querySelectorAll(t1);
    }
    /**
   * Returns CSS selector for all text inputs
   */ static get allInputsSelector() {
        return "[contenteditable=true], textarea, input:not([type]), " + [
            "text",
            "password",
            "email",
            "number",
            "search",
            "tel",
            "url"
        ].map((t1)=>`input[type="${t1}"]`).join(", ");
    }
    /**
   * Find all contenteditable, textarea and editable input elements passed holder contains
   *
   * @param holder - element where to find inputs
   */ static findAllInputs(e) {
        return $0cf1b19b2f7a01d6$var$No(e.querySelectorAll($0cf1b19b2f7a01d6$var$u.allInputsSelector)).reduce((t1, o)=>$0cf1b19b2f7a01d6$var$u.isNativeInput(o) || $0cf1b19b2f7a01d6$var$u.containsOnlyInlineElements(o) ? [
                ...t1,
                o
            ] : [
                ...t1,
                ...$0cf1b19b2f7a01d6$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Search for deepest node which is Leaf.
   * Leaf is the vertex that doesn't have any child nodes
   *
   * @description Method recursively goes throw the all Node until it finds the Leaf
   * @param {Node} node - root Node. From this vertex we start Deep-first search
   *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
   * @param {boolean} [atLast] - find last text node
   * @returns - it can be text Node or Element Node, so that caret will able to work with it
   *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
   */ static getDeepestNode(e, t1 = !1) {
        const o = t1 ? "lastChild" : "firstChild", i = t1 ? "previousSibling" : "nextSibling";
        if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
            let s = e[o];
            if ($0cf1b19b2f7a01d6$var$u.isSingleTag(s) && !$0cf1b19b2f7a01d6$var$u.isNativeInput(s) && !$0cf1b19b2f7a01d6$var$u.isLineBreakTag(s)) {
                if (s[i]) s = s[i];
                else if (s.parentNode[i]) s = s.parentNode[i];
                else return s.parentNode;
            }
            return this.getDeepestNode(s, t1);
        }
        return e;
    }
    /**
   * Check if object is DOM node
   *
   * @param {*} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isElement(e) {
        return $0cf1b19b2f7a01d6$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
    }
    /**
   * Check if object is DocumentFragment node
   *
   * @param {object} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isFragment(e) {
        return $0cf1b19b2f7a01d6$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
   * Check if passed element is contenteditable
   *
   * @param {HTMLElement} element - html element to check
   * @returns {boolean}
   */ static isContentEditable(e) {
        return e.contentEditable === "true";
    }
    /**
   * Checks target if it is native input
   *
   * @param {*} target - HTML element or string
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isNativeInput(e) {
        const t1 = [
            "INPUT",
            "TEXTAREA"
        ];
        return e && e.tagName ? t1.includes(e.tagName) : !1;
    }
    /**
   * Checks if we can set caret
   *
   * @param {HTMLElement} target - target to check
   * @returns {boolean}
   */ static canSetCaret(e) {
        let t1 = !0;
        if ($0cf1b19b2f7a01d6$var$u.isNativeInput(e)) switch(e.type){
            case "file":
            case "checkbox":
            case "radio":
            case "hidden":
            case "submit":
            case "button":
            case "image":
            case "reset":
                t1 = !1;
                break;
        }
        else t1 = $0cf1b19b2f7a01d6$var$u.isContentEditable(e);
        return t1;
    }
    /**
   * Checks node if it is empty
   *
   * @description Method checks simple Node without any childs for emptiness
   * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean} true if it is empty
   */ static isNodeEmpty(e, t1) {
        let o;
        return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("\u200B", ""), t1 && (o = o.replace(new RegExp(t1, "g"), "")), o.length === 0);
    }
    /**
   * checks node if it is doesn't have any child nodes
   *
   * @param {Node} node - node to check
   * @returns {boolean}
   */ static isLeaf(e) {
        return e ? e.childNodes.length === 0 : !1;
    }
    /**
   * breadth-first search (BFS)
   * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
   *
   * @description Pushes to stack all DOM leafs and checks for emptiness
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean}
   */ static isEmpty(e, t1) {
        const o = [
            e
        ];
        for(; o.length > 0;)if (e = o.shift(), !!e) {
            if (this.isLeaf(e) && !this.isNodeEmpty(e, t1)) return !1;
            e.childNodes && o.push(...Array.from(e.childNodes));
        }
        return !0;
    }
    /**
   * Check if string contains html elements
   *
   * @param {string} str - string to check
   * @returns {boolean}
   */ static isHTMLString(e) {
        const t1 = $0cf1b19b2f7a01d6$var$u.make("div");
        return t1.innerHTML = e, t1.childElementCount > 0;
    }
    /**
   * Return length of node`s text content
   *
   * @param {Node} node - node with content
   * @returns {number}
   */ static getContentLength(e) {
        return $0cf1b19b2f7a01d6$var$u.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
    }
    /**
   * Return array of names of block html elements
   *
   * @returns {string[]}
   */ static get blockElements() {
        return [
            "address",
            "article",
            "aside",
            "blockquote",
            "canvas",
            "div",
            "dl",
            "dt",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "hr",
            "li",
            "main",
            "nav",
            "noscript",
            "ol",
            "output",
            "p",
            "pre",
            "ruby",
            "section",
            "table",
            "tbody",
            "thead",
            "tr",
            "tfoot",
            "ul",
            "video"
        ];
    }
    /**
   * Check if passed content includes only inline elements
   *
   * @param {string|HTMLElement} data - element or html string
   * @returns {boolean}
   */ static containsOnlyInlineElements(e) {
        let t1;
        $0cf1b19b2f7a01d6$var$te(e) ? (t1 = document.createElement("div"), t1.innerHTML = e) : t1 = e;
        const o = (i)=>!$0cf1b19b2f7a01d6$var$u.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
        return Array.from(t1.children).every(o);
    }
    /**
   * Find and return all block elements in the passed parent (including subtree)
   *
   * @param {HTMLElement} parent - root element
   * @returns {HTMLElement[]}
   */ static getDeepestBlockElements(e) {
        return $0cf1b19b2f7a01d6$var$u.containsOnlyInlineElements(e) ? [
            e
        ] : Array.from(e.children).reduce((t1, o)=>[
                ...t1,
                ...$0cf1b19b2f7a01d6$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Helper for get holder from {string} or return HTMLElement
   *
   * @param {string | HTMLElement} element - holder's id or holder's HTML Element
   * @returns {HTMLElement}
   */ static getHolder(e) {
        return $0cf1b19b2f7a01d6$var$te(e) ? document.getElementById(e) : e;
    }
    /**
   * Returns true if element is anchor (is A tag)
   *
   * @param {Element} element - element to check
   * @returns {boolean}
   */ static isAnchor(e) {
        return e.tagName.toLowerCase() === "a";
    }
    /**
   * Returns the closest ancestor anchor (A tag) of the given element (including itself)
   * 
   * @param element - element to check
   * @returns {HTMLAnchorElement | null}
   */ static getClosestAnchor(e) {
        return e.closest("a");
    }
    /**
   * Return element's offset related to the document
   *
   * @todo handle case when editor initialized in scrollable popup
   * @param el - element to compute offset
   */ static offset(e) {
        const t1 = e.getBoundingClientRect(), o = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop, s = t1.top + i, r = t1.left + o;
        return {
            top: s,
            left: r,
            bottom: s + t1.height,
            right: r + t1.width
        };
    }
    /**
   * Find text node and offset by total content offset
   *
   * @param {Node} root - root node to start search from
   * @param {number} totalOffset - offset relative to the root node content
   * @returns {{node: Node | null, offset: number}} - node and offset inside node
   */ static getNodeByOffset(e, t1) {
        let o = 0, i = null;
        const s = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
        let r = s.nextNode();
        for(; r;){
            const c = r.textContent, d = c === null ? 0 : c.length;
            if (i = r, o + d >= t1) break;
            o += d, r = s.nextNode();
        }
        if (!i) return {
            node: null,
            offset: 0
        };
        const a = i.textContent;
        if (a === null || a.length === 0) return {
            node: null,
            offset: 0
        };
        const l = Math.min(t1 - o, a.length);
        return {
            node: i,
            offset: l
        };
    }
}
function $0cf1b19b2f7a01d6$var$ai(n) {
    return !/[^\t\n\r ]/.test(n);
}
function $0cf1b19b2f7a01d6$var$li(n) {
    const e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2;
    return r + s + i + l + a;
}
function $0cf1b19b2f7a01d6$var$Do(n) {
    n.dataset.empty = $0cf1b19b2f7a01d6$var$u.isEmpty(n) ? "true" : "false";
}
const $0cf1b19b2f7a01d6$var$ci = {
    blockTunes: {
        toggler: {
            "Click to tune": "",
            "or drag to move": ""
        }
    },
    inlineToolbar: {
        converter: {
            "Convert to": ""
        }
    },
    toolbar: {
        toolbox: {
            Add: ""
        }
    },
    popover: {
        Filter: "",
        "Nothing found": "",
        "Convert to": ""
    }
}, $0cf1b19b2f7a01d6$var$di = {
    Text: "",
    Link: "",
    Bold: "",
    Italic: ""
}, $0cf1b19b2f7a01d6$var$ui = {
    link: {
        "Add a link": ""
    },
    stub: {
        "The block can not be displayed correctly.": ""
    }
}, $0cf1b19b2f7a01d6$var$hi = {
    delete: {
        Delete: "",
        "Click to delete": ""
    },
    moveUp: {
        "Move up": ""
    },
    moveDown: {
        "Move down": ""
    }
}, $0cf1b19b2f7a01d6$var$Fo = {
    ui: $0cf1b19b2f7a01d6$var$ci,
    toolNames: $0cf1b19b2f7a01d6$var$di,
    tools: $0cf1b19b2f7a01d6$var$ui,
    blockTunes: $0cf1b19b2f7a01d6$var$hi
}, $0cf1b19b2f7a01d6$var$jo = class he {
    /**
   * Type-safe translation for internal UI texts:
   * Perform translation of the string by namespace and a key
   *
   * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
   * @param internalNamespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static ui(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Translate for external strings that is not presented in default dictionary.
   * For example, for user-specified tool names
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static t(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Adjust module for using external dictionary
   *
   * @param dictionary - new messages list to override default
   */ static setDictionary(e) {
        he.currentDictionary = e;
    }
    /**
   * Perform translation both for internal and external namespaces
   * If there is no translation found, returns passed key as a translated message
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static _t(e, t1) {
        const o = he.getNamespace(e);
        return !o || !o[t1] ? t1 : o[t1];
    }
    /**
   * Find messages section by namespace path
   *
   * @param namespace - path to section
   */ static getNamespace(e) {
        return e.split(".").reduce((o, i)=>!o || !Object.keys(o).length ? {} : o[i], he.currentDictionary);
    }
};
$0cf1b19b2f7a01d6$var$jo.currentDictionary = $0cf1b19b2f7a01d6$var$Fo;
let $0cf1b19b2f7a01d6$var$z = $0cf1b19b2f7a01d6$var$jo;
class $0cf1b19b2f7a01d6$var$Ho extends Error {
}
class $0cf1b19b2f7a01d6$var$Oe {
    constructor(){
        this.subscribers = {};
    }
    /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ on(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t1);
    }
    /**
   * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ once(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []);
        const o = (i)=>{
            const s = t1(i), r = this.subscribers[e].indexOf(o);
            return r !== -1 && this.subscribers[e].splice(r, 1), s;
        };
        this.subscribers[e].push(o);
    }
    /**
   * Emit callbacks with passed data
   *
   * @param eventName - event name
   * @param data - subscribers get this data when they were fired
   */ emit(e, t1) {
        $0cf1b19b2f7a01d6$var$V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce((o, i)=>{
            const s = i(o);
            return s !== void 0 ? s : o;
        }, t1);
    }
    /**
   * Unsubscribe callback from event
   *
   * @param eventName - event name
   * @param callback - event handler
   */ off(e, t1) {
        if (this.subscribers[e] === void 0) {
            console.warn(`EventDispatcher .off(): there is no subscribers for event "${e.toString()}". Probably, .off() called before .on()`);
            return;
        }
        for(let o = 0; o < this.subscribers[e].length; o++)if (this.subscribers[e][o] === t1) {
            delete this.subscribers[e][o];
            break;
        }
    }
    /**
   * Destroyer
   * clears subscribers list
   */ destroy() {
        this.subscribers = {};
    }
}
function $0cf1b19b2f7a01d6$var$J(n) {
    Object.setPrototypeOf(this, {
        /**
     * Block id
     *
     * @returns {string}
     */ get id () {
            return n.id;
        },
        /**
     * Tool name
     *
     * @returns {string}
     */ get name () {
            return n.name;
        },
        /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */ get config () {
            return n.config;
        },
        /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */ get holder () {
            return n.holder;
        },
        /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */ get isEmpty () {
            return n.isEmpty;
        },
        /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */ get selected () {
            return n.selected;
        },
        /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */ set stretched (t){
            n.stretched = t;
        },
        /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */ get stretched () {
            return n.stretched;
        },
        /**
     * True if Block has inputs to be focused
     */ get focusable () {
            return n.focusable;
        },
        /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */ call (t1, o) {
            return n.call(t1, o);
        },
        /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */ save () {
            return n.save();
        },
        /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */ validate (t1) {
            return n.validate(t1);
        },
        /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */ dispatchChange () {
            n.dispatchChange();
        },
        /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */ getActiveToolboxEntry () {
            return n.getActiveToolboxEntry();
        }
    });
}
class $0cf1b19b2f7a01d6$var$_e {
    constructor(){
        this.allListeners = [];
    }
    /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ on(e, t1, o, i = !1) {
        const s = $0cf1b19b2f7a01d6$var$si("l"), r = {
            id: s,
            element: e,
            eventType: t1,
            handler: o,
            options: i
        };
        if (!this.findOne(e, t1, o)) return this.allListeners.push(r), e.addEventListener(t1, o, i), s;
    }
    /**
   * Removes event listener from element
   *
   * @param {EventTarget} element - DOM element that we removing listener
   * @param {string} eventType - event type
   * @param {Function} handler - remove handler, if element listens several handlers on the same event type
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ off(e, t1, o, i) {
        const s = this.findAll(e, t1, o);
        s.forEach((r, a)=>{
            const l = this.allListeners.indexOf(s[a]);
            l > -1 && (this.allListeners.splice(l, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
        });
    }
    /**
   * Removes listener by id
   *
   * @param {string} id - listener identifier
   */ offById(e) {
        const t1 = this.findById(e);
        t1 && t1.element.removeEventListener(t1.eventType, t1.handler, t1.options);
    }
    /**
   * Finds and returns first listener by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} [eventType] - event type
   * @param {Function} [handler] - event handler
   * @returns {ListenerData|null}
   */ findOne(e, t1, o) {
        const i = this.findAll(e, t1, o);
        return i.length > 0 ? i[0] : null;
    }
    /**
   * Return all stored listeners by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} eventType - event type
   * @param {Function} handler - event handler
   * @returns {ListenerData[]}
   */ findAll(e, t1, o) {
        let i;
        const s = e ? this.findByEventTarget(e) : [];
        return e && t1 && o ? i = s.filter((r)=>r.eventType === t1 && r.handler === o) : e && t1 ? i = s.filter((r)=>r.eventType === t1) : i = s, i;
    }
    /**
   * Removes all listeners
   */ removeAll() {
        this.allListeners.map((e)=>{
            e.element.removeEventListener(e.eventType, e.handler, e.options);
        }), this.allListeners = [];
    }
    /**
   * Module cleanup on destruction
   */ destroy() {
        this.removeAll();
    }
    /**
   * Search method: looks for listener by passed element
   *
   * @param {EventTarget} element - searching element
   * @returns {Array} listeners that found on element
   */ findByEventTarget(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.element === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed event type
   *
   * @param {string} eventType - event type
   * @returns {ListenerData[]} listeners that found on element
   */ findByType(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.eventType === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed handler
   *
   * @param {Function} handler - event handler
   * @returns {ListenerData[]} listeners that found on element
   */ findByHandler(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.handler === e) return t1;
        });
    }
    /**
   * Returns listener data found by id
   *
   * @param {string} id - listener identifier
   * @returns {ListenerData}
   */ findById(e) {
        return this.allListeners.find((t1)=>t1.id === e);
    }
}
class $0cf1b19b2f7a01d6$var$E {
    /**
   * @class
   * @param options - Module options
   * @param options.config - Module config
   * @param options.eventsDispatcher - Common event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        if (this.nodes = {}, this.listeners = new $0cf1b19b2f7a01d6$var$_e(), this.readOnlyMutableListeners = {
            /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */ on: (o, i, s, r = !1)=>{
                this.mutableListenerIds.push(this.listeners.on(o, i, s, r));
            },
            /**
       * Clears all mutable listeners
       */ clearAll: ()=>{
                for (const o of this.mutableListenerIds)this.listeners.offById(o);
                this.mutableListenerIds = [];
            }
        }, this.mutableListenerIds = [], new.target === $0cf1b19b2f7a01d6$var$E) throw new TypeError("Constructors for abstract class Module are not allowed.");
        this.config = e, this.eventsDispatcher = t1;
    }
    /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */ set state(e) {
        this.Editor = e;
    }
    /**
   * Remove memorized nodes
   */ removeAllNodes() {
        for(const e in this.nodes){
            const t1 = this.nodes[e];
            t1 instanceof HTMLElement && t1.remove();
        }
    }
    /**
   * Returns true if current direction is RTL (Right-To-Left)
   */ get isRtl() {
        return this.config.i18n.direction === "rtl";
    }
}
class $0cf1b19b2f7a01d6$var$b {
    constructor(){
        this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor";
    }
    /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ static get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorZone: "codex-editor__redactor"
        };
    }
    /**
   * Returns selected anchor
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
   *
   * @returns {Node|null}
   */ static get anchorNode() {
        const e = window.getSelection();
        return e ? e.anchorNode : null;
    }
    /**
   * Returns selected anchor element
   *
   * @returns {Element|null}
   */ static get anchorElement() {
        const e = window.getSelection();
        if (!e) return null;
        const t1 = e.anchorNode;
        return t1 ? $0cf1b19b2f7a01d6$var$u.isElement(t1) ? t1 : t1.parentElement : null;
    }
    /**
   * Returns selection offset according to the anchor node
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
   *
   * @returns {number|null}
   */ static get anchorOffset() {
        const e = window.getSelection();
        return e ? e.anchorOffset : null;
    }
    /**
   * Is current selection range collapsed
   *
   * @returns {boolean|null}
   */ static get isCollapsed() {
        const e = window.getSelection();
        return e ? e.isCollapsed : null;
    }
    /**
   * Check current selection if it is at Editor's zone
   *
   * @returns {boolean}
   */ static get isAtEditor() {
        return this.isSelectionAtEditor($0cf1b19b2f7a01d6$var$b.get());
    }
    /**
   * Check if passed selection is at Editor's zone
   *
   * @param selection - Selection object to check
   */ static isSelectionAtEditor(e) {
        if (!e) return !1;
        let t1 = e.anchorNode || e.focusNode;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$0cf1b19b2f7a01d6$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Check if passed range at Editor zone
   *
   * @param range - range to check
   */ static isRangeAtEditor(e) {
        if (!e) return;
        let t1 = e.startContainer;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$0cf1b19b2f7a01d6$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Methods return boolean that true if selection exists on the page
   */ static get isSelectionExists() {
        return !!$0cf1b19b2f7a01d6$var$b.get().anchorNode;
    }
    /**
   * Return first range
   *
   * @returns {Range|null}
   */ static get range() {
        return this.getRangeFromSelection(this.get());
    }
    /**
   * Returns range from passed Selection object
   *
   * @param selection - Selection object to get Range from
   */ static getRangeFromSelection(e) {
        return e && e.rangeCount ? e.getRangeAt(0) : null;
    }
    /**
   * Calculates position and size of selected text
   *
   * @returns {DOMRect | ClientRect}
   */ static get rect() {
        let e = document.selection, t1, o = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (e && e.type !== "Control") return e, t1 = e.createRange(), o.x = t1.boundingLeft, o.y = t1.boundingTop, o.width = t1.boundingWidth, o.height = t1.boundingHeight, o;
        if (!window.getSelection) return $0cf1b19b2f7a01d6$var$S("Method window.getSelection is not supported", "warn"), o;
        if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return $0cf1b19b2f7a01d6$var$S("Method SelectionUtils.rangeCount is not supported", "warn"), o;
        if (e.rangeCount === 0) return o;
        if (t1 = e.getRangeAt(0).cloneRange(), t1.getBoundingClientRect && (o = t1.getBoundingClientRect()), o.x === 0 && o.y === 0) {
            const i = document.createElement("span");
            if (i.getBoundingClientRect) {
                i.appendChild(document.createTextNode("\u200B")), t1.insertNode(i), o = i.getBoundingClientRect();
                const s = i.parentNode;
                s.removeChild(i), s.normalize();
            }
        }
        return o;
    }
    /**
   * Returns selected text as String
   *
   * @returns {string}
   */ static get text() {
        return window.getSelection ? window.getSelection().toString() : "";
    }
    /**
   * Returns window SelectionUtils
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
   *
   * @returns {Selection}
   */ static get() {
        return window.getSelection();
    }
    /**
   * Set focus to contenteditable or native input element
   *
   * @param element - element where to set focus
   * @param offset - offset of cursor
   */ static setCursor(e, t1 = 0) {
        const o = document.createRange(), i = window.getSelection();
        return $0cf1b19b2f7a01d6$var$u.isNativeInput(e) ? $0cf1b19b2f7a01d6$var$u.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t1, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t1), o.setEnd(e, t1), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
    }
    /**
   * Check if current range exists and belongs to container
   *
   * @param container - where range should be
   */ static isRangeInsideContainer(e) {
        const t1 = $0cf1b19b2f7a01d6$var$b.range;
        return t1 === null ? !1 : e.contains(t1.startContainer);
    }
    /**
   * Adds fake cursor to the current range
   */ static addFakeCursor() {
        const e = $0cf1b19b2f7a01d6$var$b.range;
        if (e === null) return;
        const t1 = $0cf1b19b2f7a01d6$var$u.make("span", "codex-editor__fake-cursor");
        t1.dataset.mutationFree = "true", e.collapse(), e.insertNode(t1);
    }
    /**
   * Check if passed element contains a fake cursor
   *
   * @param el - where to check
   */ static isFakeCursorInsideContainer(e) {
        return $0cf1b19b2f7a01d6$var$u.find(e, ".codex-editor__fake-cursor") !== null;
    }
    /**
   * Removes fake cursor from a container
   *
   * @param container - container to look for
   */ static removeFakeCursor(e = document.body) {
        const t1 = $0cf1b19b2f7a01d6$var$u.find(e, ".codex-editor__fake-cursor");
        t1 && t1.remove();
    }
    /**
   * Removes fake background
   */ removeFakeBackground() {
        this.isFakeBackgroundEnabled && (document.execCommand(this.commandBackground, !1, "transparent"), this.isFakeBackgroundEnabled = !1);
    }
    /**
   * Sets fake background
   */ setFakeBackground() {
        document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
    }
    /**
   * Save SelectionUtils's range
   */ save() {
        this.savedSelectionRange = $0cf1b19b2f7a01d6$var$b.range;
    }
    /**
   * Restore saved SelectionUtils's range
   */ restore() {
        if (!this.savedSelectionRange) return;
        const e = window.getSelection();
        e.removeAllRanges(), e.addRange(this.savedSelectionRange);
    }
    /**
   * Clears saved selection
   */ clearSaved() {
        this.savedSelectionRange = null;
    }
    /**
   * Collapse current selection
   */ collapseToEnd() {
        const e = window.getSelection(), t1 = document.createRange();
        t1.selectNodeContents(e.focusNode), t1.collapse(!1), e.removeAllRanges(), e.addRange(t1);
    }
    /**
   * Looks ahead to find passed tag from current selection
   *
   * @param  {string} tagName       - tag to found
   * @param  {string} [className]   - tag's class name
   * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1, o = 10) {
        const i = window.getSelection();
        let s = null;
        return !i || !i.anchorNode || !i.focusNode ? null : ([
            /** the Node in which the selection begins */ i.anchorNode,
            /** the Node in which the selection ends */ i.focusNode
        ].forEach((a)=>{
            let l = o;
            for(; l > 0 && a.parentNode && !(a.tagName === e && (s = a, t1 && a.classList && !a.classList.contains(t1) && (s = null), s));)a = a.parentNode, l--;
        }), s);
    }
    /**
   * Expands selection range to the passed parent node
   *
   * @param {HTMLElement} element - element which contents should be selected
   */ expandToTag(e) {
        const t1 = window.getSelection();
        t1.removeAllRanges();
        const o = document.createRange();
        o.selectNodeContents(e), t1.addRange(o);
    }
}
function $0cf1b19b2f7a01d6$var$pi(n, e) {
    const { type: t1, target: o, addedNodes: i, removedNodes: s } = n;
    return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t1 === "childList" && (Array.from(i).some((l)=>l === e) || Array.from(s).some((l)=>l === e)));
}
const $0cf1b19b2f7a01d6$var$ft = "redactor dom changed", $0cf1b19b2f7a01d6$var$$o = "block changed", $0cf1b19b2f7a01d6$var$zo = "fake cursor is about to be toggled", $0cf1b19b2f7a01d6$var$Uo = "fake cursor have been set", $0cf1b19b2f7a01d6$var$Te = "editor mobile layout toggled";
function $0cf1b19b2f7a01d6$var$gt(n, e) {
    if (!n.conversionConfig) return !1;
    const t1 = n.conversionConfig[e];
    return $0cf1b19b2f7a01d6$var$A(t1) || $0cf1b19b2f7a01d6$var$te(t1);
}
function $0cf1b19b2f7a01d6$var$He(n, e) {
    return $0cf1b19b2f7a01d6$var$gt(n.tool, e);
}
function $0cf1b19b2f7a01d6$var$Wo(n, e) {
    return Object.entries(n).some(([t1, o])=>e[t1] && $0cf1b19b2f7a01d6$var$ri(e[t1], o));
}
async function $0cf1b19b2f7a01d6$var$Yo(n, e) {
    const o = (await n.save()).data, i = e.find((s)=>s.name === n.name);
    return i !== void 0 && !$0cf1b19b2f7a01d6$var$gt(i, "export") ? [] : e.reduce((s, r)=>{
        if (!$0cf1b19b2f7a01d6$var$gt(r, "import") || r.toolbox === void 0) return s;
        const a = r.toolbox.filter((l)=>{
            if ($0cf1b19b2f7a01d6$var$V(l) || l.icon === void 0) return !1;
            if (l.data !== void 0) {
                if ($0cf1b19b2f7a01d6$var$Wo(l.data, o)) return !1;
            } else if (r.name === n.name) return !1;
            return !0;
        });
        return s.push({
            ...r,
            toolbox: a
        }), s;
    }, []);
}
function $0cf1b19b2f7a01d6$var$xo(n, e) {
    return n.mergeable ? n.name === e.name ? !0 : $0cf1b19b2f7a01d6$var$He(e, "export") && $0cf1b19b2f7a01d6$var$He(n, "import") : !1;
}
function $0cf1b19b2f7a01d6$var$fi(n, e) {
    const t1 = e == null ? void 0 : e.export;
    return $0cf1b19b2f7a01d6$var$A(t1) ? t1(n) : $0cf1b19b2f7a01d6$var$te(t1) ? n[t1] : (t1 !== void 0 && $0cf1b19b2f7a01d6$var$S("Conversion \xabexport\xbb property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}
function $0cf1b19b2f7a01d6$var$Bo(n, e, t1) {
    const o = e == null ? void 0 : e.import;
    return $0cf1b19b2f7a01d6$var$A(o) ? o(n, t1) : $0cf1b19b2f7a01d6$var$te(o) ? {
        [o]: n
    } : (o !== void 0 && $0cf1b19b2f7a01d6$var$S("Conversion \xabimport\xbb property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}
var $0cf1b19b2f7a01d6$var$_ = /* @__PURE__ */ ((n)=>(n.Default = "default", n.Separator = "separator", n.Html = "html", n))($0cf1b19b2f7a01d6$var$_ || {}), $0cf1b19b2f7a01d6$var$ee = /* @__PURE__ */ ((n)=>(n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n))($0cf1b19b2f7a01d6$var$ee || {});
class $0cf1b19b2f7a01d6$var$R extends $0cf1b19b2f7a01d6$var$Oe {
    /**
   * @param options - block constructor options
   * @param [options.id] - block's id. Will be generated if omitted.
   * @param options.data - Tool's initial data
   * @param options.tool — block's tool
   * @param options.api - Editor API module for pass it to the Block Tunes
   * @param options.readOnly - Read-Only flag
   * @param [eventBus] - Editor common event bus. Allows to subscribe on some Editor events. Could be omitted when "virtual" Block is created. See BlocksAPI@composeBlockData.
   */ constructor({ id: e = $0cf1b19b2f7a01d6$var$ni(), data: t1, tool: o, readOnly: i, tunesData: s }, r){
        super(), this.cachedInputs = [], this.toolRenderedElement = null, this.tunesInstances = /* @__PURE__ */ new Map(), this.defaultTunesInstances = /* @__PURE__ */ new Map(), this.unavailableTunesData = {}, this.inputIndex = 0, this.editorEventBus = null, this.handleFocus = ()=>{
            this.dropInputsCache(), this.updateCurrentInput();
        }, this.didMutated = (a)=>{
            const l = a === void 0, c = a instanceof InputEvent;
            !l && !c && this.detectToolRootChange(a);
            let d;
            l || c ? d = !0 : d = !(a.length > 0 && a.every((p)=>{
                const { addedNodes: g, removedNodes: f, target: v } = p;
                return [
                    ...Array.from(g),
                    ...Array.from(f),
                    v
                ].some((T)=>($0cf1b19b2f7a01d6$var$u.isElement(T) || (T = T.parentElement), T && T.closest('[data-mutation-free="true"]') !== null));
            })), d && (this.dropInputsCache(), this.updateCurrentInput(), this.toggleInputsEmptyMark(), this.call("updated"), this.emit("didMutated", this));
        }, this.name = o.name, this.id = e, this.settings = o.settings, this.config = o.settings.config || {}, this.editorEventBus = r || null, this.blockAPI = new $0cf1b19b2f7a01d6$var$J(this), this.tool = o, this.toolInstance = o.create(t1, this.blockAPI, i), this.tunes = o.tunes, this.composeTunes(s), this.holder = this.compose(), window.requestIdleCallback(()=>{
            this.watchBlockMutations(), this.addInputEvents(), this.toggleInputsEmptyMark();
        });
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            wrapper: "ce-block",
            wrapperStretched: "ce-block--stretched",
            content: "ce-block__content",
            selected: "ce-block--selected",
            dropTarget: "ce-block--drop-target"
        };
    }
    /**
   * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
   */ get inputs() {
        if (this.cachedInputs.length !== 0) return this.cachedInputs;
        const e = $0cf1b19b2f7a01d6$var$u.findAllInputs(this.holder);
        return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
    }
    /**
   * Return current Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get currentInput() {
        return this.inputs[this.inputIndex];
    }
    /**
   * Set input index to the passed element
   *
   * @param element - HTML Element to set as current input
   */ set currentInput(e) {
        const t1 = this.inputs.findIndex((o)=>o === e || o.contains(e));
        t1 !== -1 && (this.inputIndex = t1);
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get firstInput() {
        return this.inputs[0];
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get lastInput() {
        const e = this.inputs;
        return e[e.length - 1];
    }
    /**
   * Return next Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get nextInput() {
        return this.inputs[this.inputIndex + 1];
    }
    /**
   * Return previous Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get previousInput() {
        return this.inputs[this.inputIndex - 1];
    }
    /**
   * Get Block's JSON data
   *
   * @returns {object}
   */ get data() {
        return this.save().then((e)=>e && !$0cf1b19b2f7a01d6$var$V(e.data) ? e.data : {});
    }
    /**
   * Returns tool's sanitizer config
   *
   * @returns {object}
   */ get sanitize() {
        return this.tool.sanitizeConfig;
    }
    /**
   * is block mergeable
   * We plugin have merge function then we call it mergeable
   *
   * @returns {boolean}
   */ get mergeable() {
        return $0cf1b19b2f7a01d6$var$A(this.toolInstance.merge);
    }
    /**
   * If Block contains inputs, it is focusable
   */ get focusable() {
        return this.inputs.length !== 0;
    }
    /**
   * Check block for emptiness
   *
   * @returns {boolean}
   */ get isEmpty() {
        const e = $0cf1b19b2f7a01d6$var$u.isEmpty(this.pluginsContent, "/"), t1 = !this.hasMedia;
        return e && t1;
    }
    /**
   * Check if block has a media content such as images, iframe and other
   *
   * @returns {boolean}
   */ get hasMedia() {
        const e = [
            "img",
            "iframe",
            "video",
            "audio",
            "source",
            "input",
            "textarea",
            "twitterwidget"
        ];
        return !!this.holder.querySelector(e.join(","));
    }
    /**
   * Set selected state
   * We don't need to mark Block as Selected when it is empty
   *
   * @param {boolean} state - 'true' to select, 'false' to remove selection
   */ set selected(e) {
        var i, s;
        this.holder.classList.toggle($0cf1b19b2f7a01d6$var$R.CSS.selected, e);
        const t1 = e === !0 && $0cf1b19b2f7a01d6$var$b.isRangeInsideContainer(this.holder), o = e === !1 && $0cf1b19b2f7a01d6$var$b.isFakeCursorInsideContainer(this.holder);
        (t1 || o) && ((i = this.editorEventBus) == null || i.emit($0cf1b19b2f7a01d6$var$zo, {
            state: e
        }), t1 ? $0cf1b19b2f7a01d6$var$b.addFakeCursor() : $0cf1b19b2f7a01d6$var$b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit($0cf1b19b2f7a01d6$var$Uo, {
            state: e
        }));
    }
    /**
   * Returns True if it is Selected
   *
   * @returns {boolean}
   */ get selected() {
        return this.holder.classList.contains($0cf1b19b2f7a01d6$var$R.CSS.selected);
    }
    /**
   * Set stretched state
   *
   * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
   */ set stretched(e) {
        this.holder.classList.toggle($0cf1b19b2f7a01d6$var$R.CSS.wrapperStretched, e);
    }
    /**
   * Return Block's stretched state
   *
   * @returns {boolean}
   */ get stretched() {
        return this.holder.classList.contains($0cf1b19b2f7a01d6$var$R.CSS.wrapperStretched);
    }
    /**
   * Toggle drop target state
   *
   * @param {boolean} state - 'true' if block is drop target, false otherwise
   */ set dropTarget(e) {
        this.holder.classList.toggle($0cf1b19b2f7a01d6$var$R.CSS.dropTarget, e);
    }
    /**
   * Returns Plugins content
   *
   * @returns {HTMLElement}
   */ get pluginsContent() {
        return this.toolRenderedElement;
    }
    /**
   * Calls Tool's method
   *
   * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
   *
   * @param {string} methodName - method to call
   * @param {object} params - method argument
   */ call(e, t1) {
        if ($0cf1b19b2f7a01d6$var$A(this.toolInstance[e])) {
            e === "appendCallback" && $0cf1b19b2f7a01d6$var$S("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");
            try {
                this.toolInstance[e].call(this.toolInstance, t1);
            } catch (o) {
                $0cf1b19b2f7a01d6$var$S(`Error during '${e}' call: ${o.message}`, "error");
            }
        }
    }
    /**
   * Call plugins merge method
   *
   * @param {BlockToolData} data - data to merge
   */ async mergeWith(e) {
        await this.toolInstance.merge(e);
    }
    /**
   * Extracts data from Block
   * Groups Tool's save processing time
   *
   * @returns {object}
   */ async save() {
        const e = await this.toolInstance.save(this.pluginsContent), t1 = this.unavailableTunesData;
        [
            ...this.tunesInstances.entries(),
            ...this.defaultTunesInstances.entries()
        ].forEach(([s, r])=>{
            if ($0cf1b19b2f7a01d6$var$A(r.save)) try {
                t1[s] = r.save();
            } catch (a) {
                $0cf1b19b2f7a01d6$var$S(`Tune ${r.constructor.name} save method throws an Error %o`, "warn", a);
            }
        });
        const o = window.performance.now();
        let i;
        return Promise.resolve(e).then((s)=>(i = window.performance.now(), {
                id: this.id,
                tool: this.name,
                data: s,
                tunes: t1,
                time: i - o
            })).catch((s)=>{
            $0cf1b19b2f7a01d6$var$S(`Saving process for ${this.name} tool failed due to the ${s}`, "log", "red");
        });
    }
    /**
   * Uses Tool's validation method to check the correctness of output data
   * Tool's validation method is optional
   *
   * @description Method returns true|false whether data passed the validation or not
   * @param {BlockToolData} data - data to validate
   * @returns {Promise<boolean>} valid
   */ async validate(e) {
        let t1 = !0;
        return this.toolInstance.validate instanceof Function && (t1 = await this.toolInstance.validate(e)), t1;
    }
    /**
   * Returns data to render in Block Tunes menu.
   * Splits block tunes into 2 groups: block specific tunes and common tunes
   */ getTunes() {
        const e = [], t1 = [], o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
        return $0cf1b19b2f7a01d6$var$u.isElement(o) ? e.push({
            type: $0cf1b19b2f7a01d6$var$_.Html,
            element: o
        }) : Array.isArray(o) ? e.push(...o) : e.push(o), [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].map((s)=>s.render()).forEach((s)=>{
            $0cf1b19b2f7a01d6$var$u.isElement(s) ? t1.push({
                type: $0cf1b19b2f7a01d6$var$_.Html,
                element: s
            }) : Array.isArray(s) ? t1.push(...s) : t1.push(s);
        }), {
            toolTunes: e,
            commonTunes: t1
        };
    }
    /**
   * Update current input index with selection anchor node
   */ updateCurrentInput() {
        this.currentInput = $0cf1b19b2f7a01d6$var$u.isNativeInput(document.activeElement) || !$0cf1b19b2f7a01d6$var$b.anchorNode ? document.activeElement : $0cf1b19b2f7a01d6$var$b.anchorNode;
    }
    /**
   * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
   * Can be useful for block changes invisible for editor core.
   */ dispatchChange() {
        this.didMutated();
    }
    /**
   * Call Tool instance destroy method
   */ destroy() {
        this.unwatchBlockMutations(), this.removeInputEvents(), super.destroy(), $0cf1b19b2f7a01d6$var$A(this.toolInstance.destroy) && this.toolInstance.destroy();
    }
    /**
   * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
   * This method returns the entry that is related to the Block (depended on the Block data)
   */ async getActiveToolboxEntry() {
        const e = this.tool.toolbox;
        if (e.length === 1) return Promise.resolve(this.tool.toolbox[0]);
        const t1 = await this.data, o = e;
        return o == null ? void 0 : o.find((i)=>$0cf1b19b2f7a01d6$var$Wo(i.data, t1));
    }
    /**
   * Exports Block data as string using conversion config
   */ async exportDataAsString() {
        const e = await this.data;
        return $0cf1b19b2f7a01d6$var$fi(e, this.tool.conversionConfig);
    }
    /**
   * Make default Block wrappers and put Tool`s content there
   *
   * @returns {HTMLDivElement}
   */ compose() {
        const e = $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$R.CSS.wrapper), t1 = $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$R.CSS.content), o = this.toolInstance.render();
        e.dataset.id = this.id, this.toolRenderedElement = o, t1.appendChild(this.toolRenderedElement);
        let i = t1;
        return [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].forEach((s)=>{
            if ($0cf1b19b2f7a01d6$var$A(s.wrap)) try {
                i = s.wrap(i);
            } catch (r) {
                $0cf1b19b2f7a01d6$var$S(`Tune ${s.constructor.name} wrap method throws an Error %o`, "warn", r);
            }
        }), e.appendChild(i), e;
    }
    /**
   * Instantiate Block Tunes
   *
   * @param tunesData - current Block tunes data
   * @private
   */ composeTunes(e) {
        Array.from(this.tunes.values()).forEach((t1)=>{
            (t1.isInternal ? this.defaultTunesInstances : this.tunesInstances).set(t1.name, t1.create(e[t1.name], this.blockAPI));
        }), Object.entries(e).forEach(([t1, o])=>{
            this.tunesInstances.has(t1) || (this.unavailableTunesData[t1] = o);
        });
    }
    /**
   * Adds focus event listeners to all inputs and contenteditable
   */ addInputEvents() {
        this.inputs.forEach((e)=>{
            e.addEventListener("focus", this.handleFocus), $0cf1b19b2f7a01d6$var$u.isNativeInput(e) && e.addEventListener("input", this.didMutated);
        });
    }
    /**
   * removes focus event listeners from all inputs and contenteditable
   */ removeInputEvents() {
        this.inputs.forEach((e)=>{
            e.removeEventListener("focus", this.handleFocus), $0cf1b19b2f7a01d6$var$u.isNativeInput(e) && e.removeEventListener("input", this.didMutated);
        });
    }
    /**
   * Listen common editor Dom Changed event and detect mutations related to the  Block
   */ watchBlockMutations() {
        var e;
        this.redactorDomChangedCallback = (t1)=>{
            const { mutations: o } = t1;
            o.some((s)=>$0cf1b19b2f7a01d6$var$pi(s, this.toolRenderedElement)) && this.didMutated(o);
        }, (e = this.editorEventBus) == null || e.on($0cf1b19b2f7a01d6$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Remove redactor dom change event listener
   */ unwatchBlockMutations() {
        var e;
        (e = this.editorEventBus) == null || e.off($0cf1b19b2f7a01d6$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
   * We need to detect such changes and update a link to tools main element with the new one
   *
   * @param mutations - records of block content mutations
   */ detectToolRootChange(e) {
        e.forEach((t1)=>{
            if (Array.from(t1.removedNodes).includes(this.toolRenderedElement)) {
                const i = t1.addedNodes[t1.addedNodes.length - 1];
                this.toolRenderedElement = i;
            }
        });
    }
    /**
   * Clears inputs cached value
   */ dropInputsCache() {
        this.cachedInputs = [];
    }
    /**
   * Mark inputs with 'data-empty' attribute with the empty state
   */ toggleInputsEmptyMark() {
        this.inputs.forEach($0cf1b19b2f7a01d6$var$Do);
    }
}
class $0cf1b19b2f7a01d6$var$gi extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.insert = (e = this.config.defaultBlock, t1 = {}, o = {}, i, s, r, a)=>{
            const l = this.Editor.BlockManager.insert({
                id: a,
                tool: e,
                data: t1,
                index: i,
                needToFocus: s,
                replace: r
            });
            return new $0cf1b19b2f7a01d6$var$J(l);
        }, this.composeBlockData = async (e)=>{
            const t1 = this.Editor.Tools.blockTools.get(e);
            return new $0cf1b19b2f7a01d6$var$R({
                tool: t1,
                api: this.Editor.API,
                readOnly: !0,
                data: {},
                tunesData: {}
            }).data;
        }, this.update = async (e, t1, o)=>{
            const { BlockManager: i } = this.Editor, s = i.getBlockById(e);
            if (s === void 0) throw new Error(`Block with id "${e}" not found`);
            const r = await i.update(s, t1, o);
            return new $0cf1b19b2f7a01d6$var$J(r);
        }, this.convert = async (e, t1, o)=>{
            var h, p;
            const { BlockManager: i, Tools: s } = this.Editor, r = i.getBlockById(e);
            if (!r) throw new Error(`Block with id "${e}" not found`);
            const a = s.blockTools.get(r.name), l = s.blockTools.get(t1);
            if (!l) throw new Error(`Block Tool with type "${t1}" not found`);
            const c = ((h = a == null ? void 0 : a.conversionConfig) == null ? void 0 : h.export) !== void 0, d = ((p = l.conversionConfig) == null ? void 0 : p.import) !== void 0;
            if (c && d) {
                const g = await i.convert(r, t1, o);
                return new $0cf1b19b2f7a01d6$var$J(g);
            } else {
                const g = [
                    c ? !1 : $0cf1b19b2f7a01d6$var$je(r.name),
                    d ? !1 : $0cf1b19b2f7a01d6$var$je(t1)
                ].filter(Boolean).join(" and ");
                throw new Error(`Conversion from "${r.name}" to "${t1}" is not possible. ${g} tool(s) should provide a "conversionConfig"`);
            }
        }, this.insertMany = (e, t1 = this.Editor.BlockManager.blocks.length - 1)=>{
            this.validateIndex(t1);
            const o = e.map(({ id: i, type: s, data: r })=>this.Editor.BlockManager.composeBlock({
                    id: i,
                    tool: s || this.config.defaultBlock,
                    data: r
                }));
            return this.Editor.BlockManager.insertMany(o, t1), o.map((i)=>new $0cf1b19b2f7a01d6$var$J(i));
        };
    }
    /**
   * Available methods
   *
   * @returns {Blocks}
   */ get methods() {
        return {
            clear: ()=>this.clear(),
            render: (e)=>this.render(e),
            renderFromHTML: (e)=>this.renderFromHTML(e),
            delete: (e)=>this.delete(e),
            swap: (e, t1)=>this.swap(e, t1),
            move: (e, t1)=>this.move(e, t1),
            getBlockByIndex: (e)=>this.getBlockByIndex(e),
            getById: (e)=>this.getById(e),
            getCurrentBlockIndex: ()=>this.getCurrentBlockIndex(),
            getBlockIndex: (e)=>this.getBlockIndex(e),
            getBlocksCount: ()=>this.getBlocksCount(),
            getBlockByElement: (e)=>this.getBlockByElement(e),
            stretchBlock: (e, t1 = !0)=>this.stretchBlock(e, t1),
            insertNewBlock: ()=>this.insertNewBlock(),
            insert: this.insert,
            insertMany: this.insertMany,
            update: this.update,
            composeBlockData: this.composeBlockData,
            convert: this.convert
        };
    }
    /**
   * Returns Blocks count
   *
   * @returns {number}
   */ getBlocksCount() {
        return this.Editor.BlockManager.blocks.length;
    }
    /**
   * Returns current block index
   *
   * @returns {number}
   */ getCurrentBlockIndex() {
        return this.Editor.BlockManager.currentBlockIndex;
    }
    /**
   * Returns the index of Block by id;
   *
   * @param id - block id
   */ getBlockIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        if (!t1) {
            $0cf1b19b2f7a01d6$var$X("There is no block with id `" + e + "`", "warn");
            return;
        }
        return this.Editor.BlockManager.getBlockIndex(t1);
    }
    /**
   * Returns BlockAPI object by Block index
   *
   * @param {number} index - index to get
   */ getBlockByIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(e);
        if (t1 === void 0) {
            $0cf1b19b2f7a01d6$var$X("There is no block at index `" + e + "`", "warn");
            return;
        }
        return new $0cf1b19b2f7a01d6$var$J(t1);
    }
    /**
   * Returns BlockAPI object by Block id
   *
   * @param id - id of block to get
   */ getById(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        return t1 === void 0 ? ($0cf1b19b2f7a01d6$var$X("There is no block with id `" + e + "`", "warn"), null) : new $0cf1b19b2f7a01d6$var$J(t1);
    }
    /**
   * Get Block API object by any child html element
   *
   * @param element - html element to get Block by
   */ getBlockByElement(e) {
        const t1 = this.Editor.BlockManager.getBlock(e);
        if (t1 === void 0) {
            $0cf1b19b2f7a01d6$var$X("There is no block corresponding to element `" + e + "`", "warn");
            return;
        }
        return new $0cf1b19b2f7a01d6$var$J(t1);
    }
    /**
   * Call Block Manager method that swap Blocks
   *
   * @param {number} fromIndex - position of first Block
   * @param {number} toIndex - position of second Block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        $0cf1b19b2f7a01d6$var$S("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t1);
    }
    /**
   * Move block from one index to another
   *
   * @param {number} toIndex - index to move to
   * @param {number} fromIndex - index to move from
   */ move(e, t1) {
        this.Editor.BlockManager.move(e, t1);
    }
    /**
   * Deletes Block
   *
   * @param {number} blockIndex - index of Block to delete
   */ delete(e = this.Editor.BlockManager.currentBlockIndex) {
        try {
            const t1 = this.Editor.BlockManager.getBlockByIndex(e);
            this.Editor.BlockManager.removeBlock(t1);
        } catch (t1) {
            $0cf1b19b2f7a01d6$var$X(t1, "warn");
            return;
        }
        this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
    }
    /**
   * Clear Editor's area
   */ async clear() {
        await this.Editor.BlockManager.clear(!0), this.Editor.InlineToolbar.close();
    }
    /**
   * Fills Editor with Blocks data
   *
   * @param {OutputData} data — Saved Editor data
   */ async render(e) {
        if (e === void 0 || e.blocks === void 0) throw new Error("Incorrect data passed to the render() method");
        this.Editor.ModificationsObserver.disable(), await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(e.blocks), this.Editor.ModificationsObserver.enable();
    }
    /**
   * Render passed HTML string
   *
   * @param {string} data - HTML string to render
   * @returns {Promise<void>}
   */ async renderFromHTML(e) {
        return await this.Editor.BlockManager.clear(), this.Editor.Paste.processText(e, !0);
    }
    /**
   * Stretch Block's content
   *
   * @param {number} index - index of Block to stretch
   * @param {boolean} status - true to enable, false to disable
   * @deprecated Use BlockAPI interface to stretch Blocks
   */ stretchBlock(e, t1 = !0) {
        $0cf1b19b2f7a01d6$var$ht(!0, "blocks.stretchBlock()", "BlockAPI");
        const o = this.Editor.BlockManager.getBlockByIndex(e);
        o && (o.stretched = t1);
    }
    /**
   * Insert new Block
   * After set caret to this Block
   *
   * @todo remove in 3.0.0
   * @deprecated with insert() method
   */ insertNewBlock() {
        $0cf1b19b2f7a01d6$var$S("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
    }
    /**
   * Validated block index and throws an error if it's invalid
   *
   * @param index - index to validate
   */ validateIndex(e) {
        if (typeof e != "number") throw new Error("Index should be a number");
        if (e < 0) throw new Error("Index should be greater than or equal to 0");
        if (e === null) throw new Error("Index should be greater than or equal to 0");
    }
}
function $0cf1b19b2f7a01d6$var$mi(n, e) {
    return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}
class $0cf1b19b2f7a01d6$var$bi extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.setToFirstBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.firstBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.firstBlock, e, t1), !0) : !1, this.setToLastBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.lastBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.lastBlock, e, t1), !0) : !1, this.setToPreviousBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.previousBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.previousBlock, e, t1), !0) : !1, this.setToNextBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.nextBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.nextBlock, e, t1), !0) : !1, this.setToBlock = (e, t1 = this.Editor.Caret.positions.DEFAULT, o = 0)=>{
            const i = $0cf1b19b2f7a01d6$var$mi(e, this.Editor);
            return i === void 0 ? !1 : (this.Editor.Caret.setToBlock(i, t1, o), !0);
        }, this.focus = (e = !1)=>e ? this.setToLastBlock(this.Editor.Caret.positions.END) : this.setToFirstBlock(this.Editor.Caret.positions.START);
    }
    /**
   * Available methods
   *
   * @returns {Caret}
   */ get methods() {
        return {
            setToFirstBlock: this.setToFirstBlock,
            setToLastBlock: this.setToLastBlock,
            setToPreviousBlock: this.setToPreviousBlock,
            setToNextBlock: this.setToNextBlock,
            setToBlock: this.setToBlock,
            focus: this.focus
        };
    }
}
class $0cf1b19b2f7a01d6$var$vi extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods
   *
   * @returns {Events}
   */ get methods() {
        return {
            emit: (e, t1)=>this.emit(e, t1),
            off: (e, t1)=>this.off(e, t1),
            on: (e, t1)=>this.on(e, t1)
        };
    }
    /**
   * Subscribe on Events
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   */ on(e, t1) {
        this.eventsDispatcher.on(e, t1);
    }
    /**
   * Emit event with data
   *
   * @param {string} eventName - event to emit
   * @param {object} data - event's data
   */ emit(e, t1) {
        this.eventsDispatcher.emit(e, t1);
    }
    /**
   * Unsubscribe from Event
   *
   * @param {string} eventName - event to unsubscribe
   * @param {Function} callback - event handler
   */ off(e, t1) {
        this.eventsDispatcher.off(e, t1);
    }
}
class $0cf1b19b2f7a01d6$var$kt extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Return namespace section for tool or block tune
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ static getNamespace(e, t1) {
        return t1 ? `blockTunes.${e}` : `tools.${e}`;
    }
    /**
   * Return I18n API methods with global dictionary access
   */ get methods() {
        return {
            t: ()=>{
                $0cf1b19b2f7a01d6$var$X("I18n.t() method can be accessed only from Tools", "warn");
            }
        };
    }
    /**
   * Return I18n API methods with tool namespaced dictionary
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            t: (o)=>$0cf1b19b2f7a01d6$var$z.t($0cf1b19b2f7a01d6$var$kt.getNamespace(e, t1), o)
        });
    }
}
class $0cf1b19b2f7a01d6$var$ki extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Editor.js Core API modules
   */ get methods() {
        return {
            blocks: this.Editor.BlocksAPI.methods,
            caret: this.Editor.CaretAPI.methods,
            tools: this.Editor.ToolsAPI.methods,
            events: this.Editor.EventsAPI.methods,
            listeners: this.Editor.ListenersAPI.methods,
            notifier: this.Editor.NotifierAPI.methods,
            sanitizer: this.Editor.SanitizerAPI.methods,
            saver: this.Editor.SaverAPI.methods,
            selection: this.Editor.SelectionAPI.methods,
            styles: this.Editor.StylesAPI.classes,
            toolbar: this.Editor.ToolbarAPI.methods,
            inlineToolbar: this.Editor.InlineToolbarAPI.methods,
            tooltip: this.Editor.TooltipAPI.methods,
            i18n: this.Editor.I18nAPI.methods,
            readOnly: this.Editor.ReadOnlyAPI.methods,
            ui: this.Editor.UiAPI.methods
        };
    }
    /**
   * Returns Editor.js Core API methods for passed tool
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            i18n: this.Editor.I18nAPI.getMethodsForTool(e, t1)
        });
    }
}
class $0cf1b19b2f7a01d6$var$yi extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods
   *
   * @returns {InlineToolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open()
        };
    }
    /**
   * Open Inline Toolbar
   */ open() {
        this.Editor.InlineToolbar.tryToShow();
    }
    /**
   * Close Inline Toolbar
   */ close() {
        this.Editor.InlineToolbar.close();
    }
}
class $0cf1b19b2f7a01d6$var$wi extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods
   *
   * @returns {Listeners}
   */ get methods() {
        return {
            on: (e, t1, o, i)=>this.on(e, t1, o, i),
            off: (e, t1, o, i)=>this.off(e, t1, o, i),
            offById: (e)=>this.offById(e)
        };
    }
    /**
   * Ads a DOM event listener. Return it's id.
   *
   * @param {HTMLElement} element - Element to set handler to
   * @param {string} eventType - event type
   * @param {() => void} handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ on(e, t1, o, i) {
        return this.listeners.on(e, t1, o, i);
    }
    /**
   * Removes DOM listener from element
   *
   * @param {Element} element - Element to remove handler from
   * @param eventType - event type
   * @param handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ off(e, t1, o, i) {
        this.listeners.off(e, t1, o, i);
    }
    /**
   * Removes DOM listener by the listener id
   *
   * @param id - id of the listener to remove
   */ offById(e) {
        this.listeners.offById(e);
    }
}
var $0cf1b19b2f7a01d6$var$Ko = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "/", i(i.s = 0);
        }([
            function(t1, o, i) {
                i(1), /*!
       * Codex JavaScript Notification module
       * https://github.com/codex-team/js-notifier
       */ t1.exports = function() {
                    var s = i(6), r = "cdx-notify--bounce-in", a = null;
                    return {
                        show: function(l) {
                            if (l.message) {
                                (function() {
                                    if (a) return !0;
                                    a = s.getWrapper(), document.body.appendChild(a);
                                })();
                                var c = null, d = l.time || 8e3;
                                switch(l.type){
                                    case "confirm":
                                        c = s.confirm(l);
                                        break;
                                    case "prompt":
                                        c = s.prompt(l);
                                        break;
                                    default:
                                        c = s.alert(l), window.setTimeout(function() {
                                            c.remove();
                                        }, d);
                                }
                                a.appendChild(c), c.classList.add(r);
                            }
                        }
                    };
                }();
            },
            function(t1, o, i) {
                var s = i(2);
                typeof s == "string" && (s = [
                    [
                        t1.i,
                        s,
                        ""
                    ]
                ]);
                var r = {
                    hmr: !0,
                    transform: void 0,
                    insertInto: void 0
                };
                i(4)(s, r), s.locals && (t1.exports = s.locals);
            },
            function(t1, o, i) {
                (t1.exports = i(3)(!1)).push([
                    t1.i,
                    `.cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:'';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:'';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}`,
                    ""
                ]);
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = [];
                    return s.toString = function() {
                        return this.map(function(r) {
                            var a = function(l, c) {
                                var d = l[1] || "", h = l[3];
                                if (!h) return d;
                                if (c && typeof btoa == "function") {
                                    var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"), g = h.sources.map(function(v) {
                                        return "/*# sourceURL=" + h.sourceRoot + v + " */";
                                    });
                                    return [
                                        d
                                    ].concat(g).concat([
                                        p
                                    ]).join(`
`);
                                }
                                var f;
                                return [
                                    d
                                ].join(`
`);
                            }(r, i);
                            return r[2] ? "@media " + r[2] + "{" + a + "}" : a;
                        }).join("");
                    }, s.i = function(r, a) {
                        typeof r == "string" && (r = [
                            [
                                null,
                                r,
                                ""
                            ]
                        ]);
                        for(var l = {}, c = 0; c < this.length; c++){
                            var d = this[c][0];
                            typeof d == "number" && (l[d] = !0);
                        }
                        for(c = 0; c < r.length; c++){
                            var h = r[c];
                            typeof h[0] == "number" && l[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), s.push(h));
                        }
                    }, s;
                };
            },
            function(t1, o, i) {
                var s, r, a = {}, l = (s = function() {
                    return window && document && document.all && !window.atob;
                }, function() {
                    return r === void 0 && (r = s.apply(this, arguments)), r;
                }), c = function(k) {
                    var m = {};
                    return function(w) {
                        if (typeof w == "function") return w();
                        if (m[w] === void 0) {
                            var x = (function(I) {
                                return document.querySelector(I);
                            }).call(this, w);
                            if (window.HTMLIFrameElement && x instanceof window.HTMLIFrameElement) try {
                                x = x.contentDocument.head;
                            } catch  {
                                x = null;
                            }
                            m[w] = x;
                        }
                        return m[w];
                    };
                }(), d = null, h = 0, p = [], g = i(5);
                function f(k, m) {
                    for(var w = 0; w < k.length; w++){
                        var x = k[w], I = a[x.id];
                        if (I) {
                            I.refs++;
                            for(var C = 0; C < I.parts.length; C++)I.parts[C](x.parts[C]);
                            for(; C < x.parts.length; C++)I.parts.push(F(x.parts[C], m));
                        } else {
                            var N = [];
                            for(C = 0; C < x.parts.length; C++)N.push(F(x.parts[C], m));
                            a[x.id] = {
                                id: x.id,
                                refs: 1,
                                parts: N
                            };
                        }
                    }
                }
                function v(k, m) {
                    for(var w = [], x = {}, I = 0; I < k.length; I++){
                        var C = k[I], N = m.base ? C[0] + m.base : C[0], B = {
                            css: C[1],
                            media: C[2],
                            sourceMap: C[3]
                        };
                        x[N] ? x[N].parts.push(B) : w.push(x[N] = {
                            id: N,
                            parts: [
                                B
                            ]
                        });
                    }
                    return w;
                }
                function O(k, m) {
                    var w = c(k.insertInto);
                    if (!w) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                    var x = p[p.length - 1];
                    if (k.insertAt === "top") x ? x.nextSibling ? w.insertBefore(m, x.nextSibling) : w.appendChild(m) : w.insertBefore(m, w.firstChild), p.push(m);
                    else if (k.insertAt === "bottom") w.appendChild(m);
                    else {
                        if (typeof k.insertAt != "object" || !k.insertAt.before) throw new Error(`[Style Loader]

 Invalid value for parameter 'insertAt' ('options.insertAt') found.
 Must be 'top', 'bottom', or Object.
 (https://github.com/webpack-contrib/style-loader#insertat)
`);
                        var I = c(k.insertInto + " " + k.insertAt.before);
                        w.insertBefore(m, I);
                    }
                }
                function T(k) {
                    if (k.parentNode === null) return !1;
                    k.parentNode.removeChild(k);
                    var m = p.indexOf(k);
                    m >= 0 && p.splice(m, 1);
                }
                function M(k) {
                    var m = document.createElement("style");
                    return k.attrs.type === void 0 && (k.attrs.type = "text/css"), q(m, k.attrs), O(k, m), m;
                }
                function q(k, m) {
                    Object.keys(m).forEach(function(w) {
                        k.setAttribute(w, m[w]);
                    });
                }
                function F(k, m) {
                    var w, x, I, C;
                    if (m.transform && k.css) {
                        if (!(C = m.transform(k.css))) return function() {};
                        k.css = C;
                    }
                    if (m.singleton) {
                        var N = h++;
                        w = d || (d = M(m)), x = ie.bind(null, w, N, !1), I = ie.bind(null, w, N, !0);
                    } else k.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (w = function(B) {
                        var W = document.createElement("link");
                        return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", q(W, B.attrs), O(B, W), W;
                    }(m), x = (function(B, W, ve) {
                        var se = ve.css, tt = ve.sourceMap, Yn = W.convertToAbsoluteUrls === void 0 && tt;
                        (W.convertToAbsoluteUrls || Yn) && (se = g(se)), tt && (se += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(tt)))) + " */");
                        var Kn = new Blob([
                            se
                        ], {
                            type: "text/css"
                        }), ko = B.href;
                        B.href = URL.createObjectURL(Kn), ko && URL.revokeObjectURL(ko);
                    }).bind(null, w, m), I = function() {
                        T(w), w.href && URL.revokeObjectURL(w.href);
                    }) : (w = M(m), x = (function(B, W) {
                        var ve = W.css, se = W.media;
                        if (se && B.setAttribute("media", se), B.styleSheet) B.styleSheet.cssText = ve;
                        else {
                            for(; B.firstChild;)B.removeChild(B.firstChild);
                            B.appendChild(document.createTextNode(ve));
                        }
                    }).bind(null, w), I = function() {
                        T(w);
                    });
                    return x(k), function(B) {
                        if (B) {
                            if (B.css === k.css && B.media === k.media && B.sourceMap === k.sourceMap) return;
                            x(k = B);
                        } else I();
                    };
                }
                t1.exports = function(k, m) {
                    if (typeof DEBUG < "u" && DEBUG && typeof document != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                    (m = m || {}).attrs = typeof m.attrs == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = l()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
                    var w = v(k, m);
                    return f(w, m), function(x) {
                        for(var I = [], C = 0; C < w.length; C++){
                            var N = w[C];
                            (B = a[N.id]).refs--, I.push(B);
                        }
                        for(x && f(v(x, m), m), C = 0; C < I.length; C++){
                            var B;
                            if ((B = I[C]).refs === 0) {
                                for(var W = 0; W < B.parts.length; W++)B.parts[W]();
                                delete a[B.id];
                            }
                        }
                    };
                };
                var H, Q = (H = [], function(k, m) {
                    return H[k] = m, H.filter(Boolean).join(`
`);
                });
                function ie(k, m, w, x) {
                    var I = w ? "" : x.css;
                    if (k.styleSheet) k.styleSheet.cssText = Q(m, I);
                    else {
                        var C = document.createTextNode(I), N = k.childNodes;
                        N[m] && k.removeChild(N[m]), N.length ? k.insertBefore(C, N[m]) : k.appendChild(C);
                    }
                }
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = typeof window < "u" && window.location;
                    if (!s) throw new Error("fixUrls requires window.location");
                    if (!i || typeof i != "string") return i;
                    var r = s.protocol + "//" + s.host, a = r + s.pathname.replace(/\/[^\/]*$/, "/");
                    return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(l, c) {
                        var d, h = c.trim().replace(/^"(.*)"$/, function(p, g) {
                            return g;
                        }).replace(/^'(.*)'$/, function(p, g) {
                            return g;
                        });
                        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? l : (d = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : a + h.replace(/^\.\//, ""), "url(" + JSON.stringify(d) + ")");
                    });
                };
            },
            function(t1, o, i) {
                var s, r, a, l, c, d, h, p, g;
                t1.exports = (s = "cdx-notifies", r = "cdx-notify", a = "cdx-notify__cross", l = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", d = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
                    alert: g = function(f) {
                        var v = document.createElement("DIV"), O = document.createElement("DIV"), T = f.message, M = f.style;
                        return v.classList.add(r), M && v.classList.add(r + "--" + M), v.innerHTML = T, O.classList.add(a), O.addEventListener("click", v.remove.bind(v)), v.appendChild(O), v;
                    },
                    confirm: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("button"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Confirm", M.innerHTML = f.cancelText || "Cancel", T.classList.add(h), M.classList.add(h), T.classList.add(l), M.classList.add(c), F && typeof F == "function" && (M.addEventListener("click", F), q.addEventListener("click", F)), H && typeof H == "function" && T.addEventListener("click", H), T.addEventListener("click", v.remove.bind(v)), M.addEventListener("click", v.remove.bind(v)), O.appendChild(T), O.appendChild(M), v.appendChild(O), v;
                    },
                    prompt: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("input"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Ok", T.classList.add(h), T.classList.add(l), M.classList.add(d), f.placeholder && M.setAttribute("placeholder", f.placeholder), f.default && (M.value = f.default), f.inputType && (M.type = f.inputType), F && typeof F == "function" && q.addEventListener("click", F), H && typeof H == "function" && T.addEventListener("click", function() {
                            H(M.value);
                        }), T.addEventListener("click", v.remove.bind(v)), O.appendChild(M), O.appendChild(T), v.appendChild(O), v;
                    },
                    getWrapper: function() {
                        var f = document.createElement("DIV");
                        return f.classList.add(s), f;
                    }
                });
            }
        ]);
    });
})($0cf1b19b2f7a01d6$var$Ko);
var $0cf1b19b2f7a01d6$var$Ei = $0cf1b19b2f7a01d6$var$Ko.exports;
const $0cf1b19b2f7a01d6$var$xi = /* @__PURE__ */ $0cf1b19b2f7a01d6$var$Ke($0cf1b19b2f7a01d6$var$Ei);
class $0cf1b19b2f7a01d6$var$Bi {
    /**
   * Show web notification
   *
   * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
   */ show(e) {
        $0cf1b19b2f7a01d6$var$xi.show(e);
    }
}
class $0cf1b19b2f7a01d6$var$Ci extends $0cf1b19b2f7a01d6$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.notifier = new $0cf1b19b2f7a01d6$var$Bi();
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e)=>this.show(e)
        };
    }
    /**
   * Show notification
   *
   * @param {NotifierOptions} options - message option
   */ show(e) {
        return this.notifier.show(e);
    }
}
class $0cf1b19b2f7a01d6$var$Ti extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods
   */ get methods() {
        const e = ()=>this.isEnabled;
        return {
            toggle: (t1)=>this.toggle(t1),
            get isEnabled () {
                return e();
            }
        };
    }
    /**
   * Set or toggle read-only state
   *
   * @param {boolean|undefined} state - set or toggle state
   * @returns {boolean} current value
   */ toggle(e) {
        return this.Editor.ReadOnly.toggle(e);
    }
    /**
   * Returns current read-only state
   */ get isEnabled() {
        return this.Editor.ReadOnly.isEnabled;
    }
}
var $0cf1b19b2f7a01d6$var$Xo = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })($0cf1b19b2f7a01d6$var$Ce, function() {
        function t1(h) {
            var p = h.tags, g = Object.keys(p), f = g.map(function(v) {
                return typeof p[v];
            }).every(function(v) {
                return v === "object" || v === "boolean" || v === "function";
            });
            if (!f) throw new Error("The configuration was invalid");
            this.config = h;
        }
        var o = [
            "P",
            "LI",
            "TD",
            "TH",
            "DIV",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "PRE"
        ];
        function i(h) {
            return o.indexOf(h.nodeName) !== -1;
        }
        var s = [
            "A",
            "B",
            "STRONG",
            "I",
            "EM",
            "SUB",
            "SUP",
            "U",
            "STRIKE"
        ];
        function r(h) {
            return s.indexOf(h.nodeName) !== -1;
        }
        t1.prototype.clean = function(h) {
            const p = document.implementation.createHTMLDocument(), g = p.createElement("div");
            return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
        }, t1.prototype._sanitize = function(h, p) {
            var g = a(h, p), f = g.firstChild();
            if (f) do {
                if (f.nodeType === Node.TEXT_NODE) {
                    if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
                        p.removeChild(f), this._sanitize(h, p);
                        break;
                    } else continue;
                }
                if (f.nodeType === Node.COMMENT_NODE) {
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                var v = r(f), O;
                v && (O = Array.prototype.some.call(f.childNodes, i));
                var T = !!p.parentNode, M = i(p) && i(f) && T, q = f.nodeName.toLowerCase(), F = l(this.config, q, f), H = v && O;
                if (H || c(f, F) || !this.config.keepNestedBlockElements && M) {
                    if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for(; f.childNodes.length > 0;)p.insertBefore(f.childNodes[0], f);
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                for(var Q = 0; Q < f.attributes.length; Q += 1){
                    var ie = f.attributes[Q];
                    d(ie, F, f) && (f.removeAttribute(ie.name), Q = Q - 1);
                }
                this._sanitize(h, f);
            }while (f = g.nextSibling());
        };
        function a(h, p) {
            return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
        }
        function l(h, p, g) {
            return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
        }
        function c(h, p) {
            return typeof p > "u" ? !0 : typeof p == "boolean" ? !p : !1;
        }
        function d(h, p, g) {
            var f = h.name.toLowerCase();
            return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : typeof p[f] > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
        }
        return t1;
    });
})($0cf1b19b2f7a01d6$var$Xo);
var $0cf1b19b2f7a01d6$var$Si = $0cf1b19b2f7a01d6$var$Xo.exports;
const $0cf1b19b2f7a01d6$var$Ii = /* @__PURE__ */ $0cf1b19b2f7a01d6$var$Ke($0cf1b19b2f7a01d6$var$Si);
function $0cf1b19b2f7a01d6$var$yt(n, e) {
    return n.map((t1)=>{
        const o = $0cf1b19b2f7a01d6$var$A(e) ? e(t1.tool) : e;
        return $0cf1b19b2f7a01d6$var$V(o) || (t1.data = $0cf1b19b2f7a01d6$var$wt(t1.data, o)), t1;
    });
}
function $0cf1b19b2f7a01d6$var$Z(n, e = {}) {
    const t1 = {
        tags: e
    };
    return new $0cf1b19b2f7a01d6$var$Ii(t1).clean(n);
}
function $0cf1b19b2f7a01d6$var$wt(n, e) {
    return Array.isArray(n) ? $0cf1b19b2f7a01d6$var$Oi(n, e) : $0cf1b19b2f7a01d6$var$D(n) ? $0cf1b19b2f7a01d6$var$_i(n, e) : $0cf1b19b2f7a01d6$var$te(n) ? $0cf1b19b2f7a01d6$var$Mi(n, e) : n;
}
function $0cf1b19b2f7a01d6$var$Oi(n, e) {
    return n.map((t1)=>$0cf1b19b2f7a01d6$var$wt(t1, e));
}
function $0cf1b19b2f7a01d6$var$_i(n, e) {
    const t1 = {};
    for(const o in n){
        if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
        const i = n[o], s = $0cf1b19b2f7a01d6$var$Ai(e[o]) ? e[o] : e;
        t1[o] = $0cf1b19b2f7a01d6$var$wt(i, s);
    }
    return t1;
}
function $0cf1b19b2f7a01d6$var$Mi(n, e) {
    return $0cf1b19b2f7a01d6$var$D(e) ? $0cf1b19b2f7a01d6$var$Z(n, e) : e === !1 ? $0cf1b19b2f7a01d6$var$Z(n, {}) : n;
}
function $0cf1b19b2f7a01d6$var$Ai(n) {
    return $0cf1b19b2f7a01d6$var$D(n) || $0cf1b19b2f7a01d6$var$Gn(n) || $0cf1b19b2f7a01d6$var$A(n);
}
class $0cf1b19b2f7a01d6$var$Li extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods
   *
   * @returns {SanitizerConfig}
   */ get methods() {
        return {
            clean: (e, t1)=>this.clean(e, t1)
        };
    }
    /**
   * Perform sanitizing of a string
   *
   * @param {string} taintString - what to sanitize
   * @param {SanitizerConfig} config - sanitizer config
   * @returns {string}
   */ clean(e, t1) {
        return $0cf1b19b2f7a01d6$var$Z(e, t1);
    }
}
class $0cf1b19b2f7a01d6$var$Pi extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods
   *
   * @returns {Saver}
   */ get methods() {
        return {
            save: ()=>this.save()
        };
    }
    /**
   * Return Editor's data
   *
   * @returns {OutputData}
   */ save() {
        const e = "Editor's content can not be saved in read-only mode";
        return this.Editor.ReadOnly.isEnabled ? ($0cf1b19b2f7a01d6$var$X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
    }
}
class $0cf1b19b2f7a01d6$var$Ni extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.selectionUtils = new $0cf1b19b2f7a01d6$var$b();
    }
    /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */ get methods() {
        return {
            findParentTag: (e, t1)=>this.findParentTag(e, t1),
            expandToTag: (e)=>this.expandToTag(e),
            save: ()=>this.selectionUtils.save(),
            restore: ()=>this.selectionUtils.restore(),
            setFakeBackground: ()=>this.selectionUtils.setFakeBackground(),
            removeFakeBackground: ()=>this.selectionUtils.removeFakeBackground()
        };
    }
    /**
   * Looks ahead from selection and find passed tag with class name
   *
   * @param {string} tagName - tag to find
   * @param {string} className - tag's class name
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1) {
        return this.selectionUtils.findParentTag(e, t1);
    }
    /**
   * Expand selection to passed tag
   *
   * @param {HTMLElement} node - tag that should contain selection
   */ expandToTag(e) {
        this.selectionUtils.expandToTag(e);
    }
}
class $0cf1b19b2f7a01d6$var$Ri extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods
   */ get methods() {
        return {
            getBlockTools: ()=>Array.from(this.Editor.Tools.blockTools.values())
        };
    }
}
class $0cf1b19b2f7a01d6$var$Di extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Exported classes
   */ get classes() {
        return {
            /**
       * Base Block styles
       */ block: "cdx-block",
            /**
       * Inline Tools styles
       */ inlineToolButton: "ce-inline-tool",
            inlineToolButtonActive: "ce-inline-tool--active",
            /**
       * UI elements
       */ input: "cdx-input",
            loader: "cdx-loader",
            button: "cdx-button",
            /**
       * Settings styles
       */ settingsButton: "cdx-settings-button",
            settingsButtonActive: "cdx-settings-button--active"
        };
    }
}
class $0cf1b19b2f7a01d6$var$Fi extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods
   *
   * @returns {Toolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open(),
            toggleBlockSettings: (e)=>this.toggleBlockSettings(e),
            toggleToolbox: (e)=>this.toggleToolbox(e)
        };
    }
    /**
   * Open toolbar
   */ open() {
        this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * Close toolbar and all included elements
   */ close() {
        this.Editor.Toolbar.close();
    }
    /**
   * Toggles Block Setting of the current block
   *
   * @param {boolean} openingState —  opening state of Block Setting
   */ toggleBlockSettings(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $0cf1b19b2f7a01d6$var$X("Could't toggle the Toolbar because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.BlockSettings.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
    }
    /**
   * Open toolbox
   *
   * @param {boolean} openingState - Opening state of toolbox
   */ toggleToolbox(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $0cf1b19b2f7a01d6$var$X("Could't toggle the Toolbox because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
    }
}
var $0cf1b19b2f7a01d6$var$Vo = {
    exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                t1.exports = i(1);
            },
            function(t1, o, i) {
                i.r(o), i.d(o, "default", function() {
                    return s;
                });
                class s {
                    constructor(){
                        this.nodes = {
                            wrapper: null,
                            content: null
                        }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = ()=>{
                            this.showed && this.hide(!0);
                        }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
                            passive: !0
                        });
                    }
                    get CSS() {
                        return {
                            tooltip: "ct",
                            tooltipContent: "ct__content",
                            tooltipShown: "ct--shown",
                            placement: {
                                left: "ct--left",
                                bottom: "ct--bottom",
                                right: "ct--right",
                                top: "ct--top"
                            }
                        };
                    }
                    show(a, l, c) {
                        this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
                        const d = Object.assign({
                            placement: "bottom",
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            delay: 70,
                            hidingDelay: 0
                        }, c);
                        if (d.hidingDelay && (this.hidingDelay = d.hidingDelay), this.nodes.content.innerHTML = "", typeof l == "string") this.nodes.content.appendChild(document.createTextNode(l));
                        else {
                            if (!(l instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of \xabcontent\xbb passed. It should be an instance of Node or String. But " + typeof l + " given.");
                            this.nodes.content.appendChild(l);
                        }
                        switch(this.nodes.wrapper.classList.remove(...Object.values(this.CSS.placement)), d.placement){
                            case "top":
                                this.placeTop(a, d);
                                break;
                            case "left":
                                this.placeLeft(a, d);
                                break;
                            case "right":
                                this.placeRight(a, d);
                                break;
                            case "bottom":
                            default:
                                this.placeBottom(a, d);
                        }
                        d && d.delay ? this.showingTimeout = setTimeout(()=>{
                            this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0;
                        }, d.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
                    }
                    hide(a = !1) {
                        if (this.hidingDelay && !a) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(()=>{
                            this.hide(!0);
                        }, this.hidingDelay));
                        this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
                    }
                    onHover(a, l, c) {
                        a.addEventListener("mouseenter", ()=>{
                            this.show(a, l, c);
                        }), a.addEventListener("mouseleave", ()=>{
                            this.hide();
                        });
                    }
                    destroy() {
                        this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
                    }
                    prepare() {
                        this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
                    }
                    loadStyles() {
                        const a = "codex-tooltips-style";
                        if (document.getElementById(a)) return;
                        const l = i(2), c = this.make("style", null, {
                            textContent: l.toString(),
                            id: a
                        });
                        this.prepend(document.head, c);
                    }
                    placeBottom(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.bottom + window.pageYOffset + this.offsetTop + l.marginTop;
                        this.applyPlacement("bottom", d, h);
                    }
                    placeTop(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
                        this.applyPlacement("top", d, h);
                    }
                    placeLeft(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - l.marginLeft, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("left", d, h);
                    }
                    placeRight(a, l) {
                        const c = a.getBoundingClientRect(), d = c.right + this.offsetRight + l.marginRight, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("right", d, h);
                    }
                    applyPlacement(a, l, c) {
                        this.nodes.wrapper.classList.add(this.CSS.placement[a]), this.nodes.wrapper.style.left = l + "px", this.nodes.wrapper.style.top = c + "px";
                    }
                    make(a, l = null, c = {}) {
                        const d = document.createElement(a);
                        Array.isArray(l) ? d.classList.add(...l) : l && d.classList.add(l);
                        for(const h in c)c.hasOwnProperty(h) && (d[h] = c[h]);
                        return d;
                    }
                    append(a, l) {
                        Array.isArray(l) ? l.forEach((c)=>a.appendChild(c)) : a.appendChild(l);
                    }
                    prepend(a, l) {
                        Array.isArray(l) ? (l = l.reverse()).forEach((c)=>a.prepend(c)) : a.prepend(l);
                    }
                }
            },
            function(t1, o) {
                t1.exports = `.ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:"";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url("")){.ct:before{border-radius:0;-webkit-mask-box-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z"/></svg>') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:"";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}`;
            }
        ]).default;
    });
})($0cf1b19b2f7a01d6$var$Vo);
var $0cf1b19b2f7a01d6$var$ji = $0cf1b19b2f7a01d6$var$Vo.exports;
const $0cf1b19b2f7a01d6$var$Hi = /* @__PURE__ */ $0cf1b19b2f7a01d6$var$Ke($0cf1b19b2f7a01d6$var$ji);
let $0cf1b19b2f7a01d6$var$U = null;
function $0cf1b19b2f7a01d6$var$Et() {
    $0cf1b19b2f7a01d6$var$U || ($0cf1b19b2f7a01d6$var$U = new $0cf1b19b2f7a01d6$var$Hi());
}
function $0cf1b19b2f7a01d6$var$$i(n, e, t1) {
    $0cf1b19b2f7a01d6$var$Et(), $0cf1b19b2f7a01d6$var$U == null || $0cf1b19b2f7a01d6$var$U.show(n, e, t1);
}
function $0cf1b19b2f7a01d6$var$$e(n = !1) {
    $0cf1b19b2f7a01d6$var$Et(), $0cf1b19b2f7a01d6$var$U == null || $0cf1b19b2f7a01d6$var$U.hide(n);
}
function $0cf1b19b2f7a01d6$var$ze(n, e, t1) {
    $0cf1b19b2f7a01d6$var$Et(), $0cf1b19b2f7a01d6$var$U == null || $0cf1b19b2f7a01d6$var$U.onHover(n, e, t1);
}
function $0cf1b19b2f7a01d6$var$zi() {
    $0cf1b19b2f7a01d6$var$U == null || $0cf1b19b2f7a01d6$var$U.destroy(), $0cf1b19b2f7a01d6$var$U = null;
}
class $0cf1b19b2f7a01d6$var$Ui extends $0cf1b19b2f7a01d6$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        });
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e, t1, o)=>this.show(e, t1, o),
            hide: ()=>this.hide(),
            onHover: (e, t1, o)=>this.onHover(e, t1, o)
        };
    }
    /**
   * Method show tooltip on element with passed HTML content
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ show(e, t1, o) {
        $0cf1b19b2f7a01d6$var$$i(e, t1, o);
    }
    /**
   * Method hides tooltip on HTML page
   */ hide() {
        $0cf1b19b2f7a01d6$var$$e();
    }
    /**
   * Decorator for showing Tooltip by mouseenter/mouseleave
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ onHover(e, t1, o) {
        $0cf1b19b2f7a01d6$var$ze(e, t1, o);
    }
}
class $0cf1b19b2f7a01d6$var$Wi extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Available methods / getters
   */ get methods() {
        return {
            nodes: this.editorNodes
        };
    }
    /**
   * Exported classes
   */ get editorNodes() {
        return {
            /**
       * Top-level editor instance wrapper
       */ wrapper: this.Editor.UI.nodes.wrapper,
            /**
       * Element that holds all the Blocks
       */ redactor: this.Editor.UI.nodes.redactor
        };
    }
}
function $0cf1b19b2f7a01d6$var$qo(n, e) {
    const t1 = {};
    return Object.entries(n).forEach(([o, i])=>{
        if ($0cf1b19b2f7a01d6$var$D(i)) {
            const s = e ? `${e}.${o}` : o;
            Object.values(i).every((a)=>$0cf1b19b2f7a01d6$var$te(a)) ? t1[o] = s : t1[o] = $0cf1b19b2f7a01d6$var$qo(i, s);
            return;
        }
        t1[o] = i;
    }), t1;
}
const $0cf1b19b2f7a01d6$var$K = $0cf1b19b2f7a01d6$var$qo($0cf1b19b2f7a01d6$var$Fo);
function $0cf1b19b2f7a01d6$var$Yi(n, e) {
    const t1 = {};
    return Object.keys(n).forEach((o)=>{
        const i = e[o];
        i !== void 0 ? t1[i] = n[o] : t1[o] = n[o];
    }), t1;
}
const $0cf1b19b2f7a01d6$var$Zo = class Ee {
    /**
   * @param {HTMLElement[]} nodeList — the list of iterable HTML-items
   * @param {string} focusedCssClass - user-provided CSS-class that will be set in flipping process
   */ constructor(e, t1){
        this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t1;
    }
    /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */ get currentItem() {
        return this.cursor === -1 ? null : this.items[this.cursor];
    }
    /**
   * Sets cursor to specified position
   *
   * @param cursorPosition - new cursor position
   */ setCursor(e) {
        e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
    }
    /**
   * Sets items. Can be used when iterable items changed dynamically
   *
   * @param {HTMLElement[]} nodeList - nodes to iterate
   */ setItems(e) {
        this.items = e;
    }
    /**
   * Sets cursor next to the current
   */ next() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.RIGHT);
    }
    /**
   * Sets cursor before current
   */ previous() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.LEFT);
    }
    /**
   * Sets cursor to the default position and removes CSS-class from previously focused item
   */ dropCursor() {
        this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
    }
    /**
   * Leafs nodes inside the target list from active element
   *
   * @param {string} direction - leaf direction. Can be 'left' or 'right'
   * @returns {number} index of focused node
   */ leafNodesAndReturnIndex(e) {
        if (this.items.length === 0) return this.cursor;
        let t1 = this.cursor;
        return t1 === -1 ? t1 = e === Ee.directions.RIGHT ? -1 : 0 : this.items[t1].classList.remove(this.focusedCssClass), e === Ee.directions.RIGHT ? t1 = (t1 + 1) % this.items.length : t1 = (this.items.length + t1 - 1) % this.items.length, $0cf1b19b2f7a01d6$var$u.canSetCaret(this.items[t1]) && $0cf1b19b2f7a01d6$var$Fe(()=>$0cf1b19b2f7a01d6$var$b.setCursor(this.items[t1]), 50)(), this.items[t1].classList.add(this.focusedCssClass), t1;
    }
};
$0cf1b19b2f7a01d6$var$Zo.directions = {
    RIGHT: "right",
    LEFT: "left"
};
let $0cf1b19b2f7a01d6$var$ke = $0cf1b19b2f7a01d6$var$Zo;
class $0cf1b19b2f7a01d6$var$ce {
    /**
   * @param options - different constructing settings
   */ constructor(e){
        this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = (t1)=>{
            if (!(!this.isEventReadyForHandling(t1) || t1.shiftKey === !0)) switch($0cf1b19b2f7a01d6$var$ce.usedKeys.includes(t1.keyCode) && t1.preventDefault(), t1.keyCode){
                case $0cf1b19b2f7a01d6$var$y.TAB:
                    this.handleTabPress(t1);
                    break;
                case $0cf1b19b2f7a01d6$var$y.LEFT:
                case $0cf1b19b2f7a01d6$var$y.UP:
                    this.flipLeft();
                    break;
                case $0cf1b19b2f7a01d6$var$y.RIGHT:
                case $0cf1b19b2f7a01d6$var$y.DOWN:
                    this.flipRight();
                    break;
                case $0cf1b19b2f7a01d6$var$y.ENTER:
                    this.handleEnterPress(t1);
                    break;
            }
        }, this.iterator = new $0cf1b19b2f7a01d6$var$ke(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || $0cf1b19b2f7a01d6$var$ce.usedKeys;
    }
    /**
   * True if flipper is currently activated
   */ get isActivated() {
        return this.activated;
    }
    /**
   * Array of keys (codes) that is handled by Flipper
   * Used to:
   *  - preventDefault only for this keys, not all keydowns (@see constructor)
   *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
   */ static get usedKeys() {
        return [
            $0cf1b19b2f7a01d6$var$y.TAB,
            $0cf1b19b2f7a01d6$var$y.LEFT,
            $0cf1b19b2f7a01d6$var$y.RIGHT,
            $0cf1b19b2f7a01d6$var$y.ENTER,
            $0cf1b19b2f7a01d6$var$y.UP,
            $0cf1b19b2f7a01d6$var$y.DOWN
        ];
    }
    /**
   * Active tab/arrows handling by flipper
   *
   * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
   * @param cursorPosition - index of the item that should be focused once flipper is activated
   */ activate(e, t1) {
        this.activated = !0, e && this.iterator.setItems(e), t1 !== void 0 && this.iterator.setCursor(t1), document.addEventListener("keydown", this.onKeyDown, !0);
    }
    /**
   * Disable tab/arrows handling by flipper
   */ deactivate() {
        this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
    }
    /**
   * Focus first item
   */ focusFirst() {
        this.dropCursor(), this.flipRight();
    }
    /**
   * Focuses previous flipper iterator item
   */ flipLeft() {
        this.iterator.previous(), this.flipCallback();
    }
    /**
   * Focuses next flipper iterator item
   */ flipRight() {
        this.iterator.next(), this.flipCallback();
    }
    /**
   * Return true if some button is focused
   */ hasFocus() {
        return !!this.iterator.currentItem;
    }
    /**
   * Registeres function that should be executed on each navigation action
   *
   * @param cb - function to execute
   */ onFlip(e) {
        this.flipCallbacks.push(e);
    }
    /**
   * Unregisteres function that is executed on each navigation action
   *
   * @param cb - function to stop executing
   */ removeOnFlip(e) {
        this.flipCallbacks = this.flipCallbacks.filter((t1)=>t1 !== e);
    }
    /**
   * Drops flipper's iterator cursor
   *
   * @see DomIterator#dropCursor
   */ dropCursor() {
        this.iterator.dropCursor();
    }
    /**
   * This function is fired before handling flipper keycodes
   * The result of this function defines if it is need to be handled or not
   *
   * @param {KeyboardEvent} event - keydown keyboard event
   * @returns {boolean}
   */ isEventReadyForHandling(e) {
        return this.activated && this.allowedKeys.includes(e.keyCode);
    }
    /**
   * When flipper is activated tab press will leaf the items
   *
   * @param {KeyboardEvent} event - tab keydown event
   */ handleTabPress(e) {
        switch(e.shiftKey ? $0cf1b19b2f7a01d6$var$ke.directions.LEFT : $0cf1b19b2f7a01d6$var$ke.directions.RIGHT){
            case $0cf1b19b2f7a01d6$var$ke.directions.RIGHT:
                this.flipRight();
                break;
            case $0cf1b19b2f7a01d6$var$ke.directions.LEFT:
                this.flipLeft();
                break;
        }
    }
    /**
   * Enter press will click current item if flipper is activated
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ handleEnterPress(e) {
        this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), $0cf1b19b2f7a01d6$var$A(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
    }
    /**
   * Fired after flipping in any direction
   */ flipCallback() {
        this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach((e)=>e());
    }
}
const $0cf1b19b2f7a01d6$var$Ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $0cf1b19b2f7a01d6$var$Xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>', $0cf1b19b2f7a01d6$var$Vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>', $0cf1b19b2f7a01d6$var$qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>', $0cf1b19b2f7a01d6$var$Zi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>', $0cf1b19b2f7a01d6$var$Gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $0cf1b19b2f7a01d6$var$Qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>', $0cf1b19b2f7a01d6$var$Ji = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>', $0cf1b19b2f7a01d6$var$Co = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>', $0cf1b19b2f7a01d6$var$es = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>', $0cf1b19b2f7a01d6$var$ts = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $0cf1b19b2f7a01d6$var$Go = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>', $0cf1b19b2f7a01d6$var$os = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $0cf1b19b2f7a01d6$var$ns = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $0cf1b19b2f7a01d6$var$is = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>', $0cf1b19b2f7a01d6$var$ss = "__", $0cf1b19b2f7a01d6$var$rs = "--";
function $0cf1b19b2f7a01d6$var$ne(n) {
    return (e, t1)=>[
            [
                n,
                e
            ].filter((i)=>!!i).join($0cf1b19b2f7a01d6$var$ss),
            t1
        ].filter((i)=>!!i).join($0cf1b19b2f7a01d6$var$rs);
}
const $0cf1b19b2f7a01d6$var$ye = $0cf1b19b2f7a01d6$var$ne("ce-hint"), $0cf1b19b2f7a01d6$var$we = {
    root: $0cf1b19b2f7a01d6$var$ye(),
    alignedStart: $0cf1b19b2f7a01d6$var$ye(null, "align-left"),
    alignedCenter: $0cf1b19b2f7a01d6$var$ye(null, "align-center"),
    title: $0cf1b19b2f7a01d6$var$ye("title"),
    description: $0cf1b19b2f7a01d6$var$ye("description")
};
class $0cf1b19b2f7a01d6$var$as {
    /**
   * Constructs the hint content instance
   *
   * @param params - hint content parameters
   */ constructor(e){
        this.nodes = {
            root: $0cf1b19b2f7a01d6$var$u.make("div", [
                $0cf1b19b2f7a01d6$var$we.root,
                e.alignment === "center" ? $0cf1b19b2f7a01d6$var$we.alignedCenter : $0cf1b19b2f7a01d6$var$we.alignedStart
            ]),
            title: $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$we.title, {
                textContent: e.title
            })
        }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$we.description, {
            textContent: e.description
        }), this.nodes.root.appendChild(this.nodes.description));
    }
    /**
   * Returns the root element of the hint content
   */ getElement() {
        return this.nodes.root;
    }
}
class $0cf1b19b2f7a01d6$var$xt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        this.params = e;
    }
    /**
   * Item name if exists
   */ get name() {
        if (this.params !== void 0 && "name" in this.params) return this.params.name;
    }
    /**
   * Destroys the instance
   */ destroy() {
        $0cf1b19b2f7a01d6$var$$e();
    }
    /**
   * Called when children popover is opened (if exists)
   */ onChildrenOpen() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
    }
    /**
   * Called when children popover is closed (if exists)
   */ onChildrenClose() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
    }
    /**
   * Called on popover item click
   */ handleClick() {
        var e, t1;
        this.params !== void 0 && "onActivate" in this.params && ((t1 = (e = this.params).onActivate) == null || t1.call(e, this.params));
    }
    /**
   * Adds hint to the item element if hint data is provided
   *
   * @param itemElement - popover item root element to add hint to
   * @param hintData - hint data
   */ addHint(e, t1) {
        const o = new $0cf1b19b2f7a01d6$var$as(t1);
        $0cf1b19b2f7a01d6$var$ze(e, o.getElement(), {
            placement: t1.position,
            hidingDelay: 100
        });
    }
    /**
   * Returns item children that are represented as popover items
   */ get children() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
    }
    /**
   * Returns true if item has any type of children
   */ get hasChildren() {
        return this.children.length > 0;
    }
    /**
   * Returns true if item children should be open instantly after popover is opened and not on item click/hover
   */ get isChildrenOpen() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
    }
    /**
   * True if item children items should be navigatable via keyboard
   */ get isChildrenFlippable() {
        var e;
        return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
    }
    /**
   * Returns true if item has children that should be searchable
   */ get isChildrenSearchable() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
    }
    /**
   * True if popover should close once item is activated
   */ get closeOnActivate() {
        return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
    }
    /**
   * True if item is active
   */ get isActive() {
        return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
    }
}
const $0cf1b19b2f7a01d6$var$Y = $0cf1b19b2f7a01d6$var$ne("ce-popover-item"), $0cf1b19b2f7a01d6$var$L = {
    container: $0cf1b19b2f7a01d6$var$Y(),
    active: $0cf1b19b2f7a01d6$var$Y(null, "active"),
    disabled: $0cf1b19b2f7a01d6$var$Y(null, "disabled"),
    focused: $0cf1b19b2f7a01d6$var$Y(null, "focused"),
    hidden: $0cf1b19b2f7a01d6$var$Y(null, "hidden"),
    confirmationState: $0cf1b19b2f7a01d6$var$Y(null, "confirmation"),
    noHover: $0cf1b19b2f7a01d6$var$Y(null, "no-hover"),
    noFocus: $0cf1b19b2f7a01d6$var$Y(null, "no-focus"),
    title: $0cf1b19b2f7a01d6$var$Y("title"),
    secondaryTitle: $0cf1b19b2f7a01d6$var$Y("secondary-title"),
    icon: $0cf1b19b2f7a01d6$var$Y("icon"),
    iconTool: $0cf1b19b2f7a01d6$var$Y("icon", "tool"),
    iconChevronRight: $0cf1b19b2f7a01d6$var$Y("icon", "chevron-right"),
    wobbleAnimation: $0cf1b19b2f7a01d6$var$ne("wobble")()
};
class $0cf1b19b2f7a01d6$var$re extends $0cf1b19b2f7a01d6$var$xt {
    /**
   * Constructs popover item instance
   *
   * @param params - popover item construction params
   * @param renderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e), this.params = e, this.nodes = {
            root: null,
            icon: null
        }, this.confirmationState = null, this.removeSpecialFocusBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($0cf1b19b2f7a01d6$var$L.noFocus);
        }, this.removeSpecialHoverBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($0cf1b19b2f7a01d6$var$L.noHover);
        }, this.onErrorAnimationEnd = ()=>{
            var o, i;
            (o = this.nodes.icon) == null || o.classList.remove($0cf1b19b2f7a01d6$var$L.wobbleAnimation), (i = this.nodes.icon) == null || i.removeEventListener("animationend", this.onErrorAnimationEnd);
        }, this.nodes.root = this.make(e, t1);
    }
    /**
   * True if item is disabled and hence not clickable
   */ get isDisabled() {
        return this.params.isDisabled === !0;
    }
    /**
   * Exposes popover item toggle parameter
   */ get toggle() {
        return this.params.toggle;
    }
    /**
   * Item title
   */ get title() {
        return this.params.title;
    }
    /**
   * True if confirmation state is enabled for popover item
   */ get isConfirmationStateEnabled() {
        return this.confirmationState !== null;
    }
    /**
   * True if item is focused in keyboard navigation process
   */ get isFocused() {
        return this.nodes.root === null ? !1 : this.nodes.root.classList.contains($0cf1b19b2f7a01d6$var$L.focused);
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Called on popover item click
   */ handleClick() {
        if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
            this.activateOrEnableConfirmationMode(this.confirmationState);
            return;
        }
        this.activateOrEnableConfirmationMode(this.params);
    }
    /**
   * Toggles item active state
   *
   * @param isActive - true if item should strictly should become active
   */ toggleActive(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($0cf1b19b2f7a01d6$var$L.active, e);
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($0cf1b19b2f7a01d6$var$L.hidden, e);
    }
    /**
   * Resets popover item to its original state
   */ reset() {
        this.isConfirmationStateEnabled && this.disableConfirmationMode();
    }
    /**
   * Method called once item becomes focused during keyboard navigation
   */ onFocus() {
        this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Constructs HTML element corresponding to popover item params
   *
   * @param params - item construction params
   * @param renderParams - popover item render params
   */ make(e, t1) {
        var s, r;
        const o = (t1 == null ? void 0 : t1.wrapperTag) || "div", i = $0cf1b19b2f7a01d6$var$u.make(o, $0cf1b19b2f7a01d6$var$L.container, {
            type: o === "button" ? "button" : void 0
        });
        return e.name && (i.dataset.itemName = e.name), this.nodes.icon = $0cf1b19b2f7a01d6$var$u.make("div", [
            $0cf1b19b2f7a01d6$var$L.icon,
            $0cf1b19b2f7a01d6$var$L.iconTool
        ], {
            innerHTML: e.icon || $0cf1b19b2f7a01d6$var$Qi
        }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild($0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$L.title, {
            innerHTML: e.title || ""
        })), e.secondaryLabel && i.appendChild($0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$L.secondaryTitle, {
            textContent: e.secondaryLabel
        })), this.hasChildren && i.appendChild($0cf1b19b2f7a01d6$var$u.make("div", [
            $0cf1b19b2f7a01d6$var$L.icon,
            $0cf1b19b2f7a01d6$var$L.iconChevronRight
        ], {
            innerHTML: $0cf1b19b2f7a01d6$var$qi
        })), this.isActive && i.classList.add($0cf1b19b2f7a01d6$var$L.active), e.isDisabled && i.classList.add($0cf1b19b2f7a01d6$var$L.disabled), e.hint !== void 0 && ((s = t1 == null ? void 0 : t1.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, {
            ...e.hint,
            position: ((r = t1 == null ? void 0 : t1.hint) == null ? void 0 : r.position) || "right"
        }), i;
    }
    /**
   * Activates confirmation mode for the item.
   *
   * @param newState - new popover item params that should be applied
   */ enableConfirmationMode(e) {
        if (this.nodes.root === null) return;
        const t1 = {
            ...this.params,
            ...e,
            confirmation: "confirmation" in e ? e.confirmation : void 0
        }, o = this.make(t1);
        this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add($0cf1b19b2f7a01d6$var$L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
    }
    /**
   * Returns item to its original state
   */ disableConfirmationMode() {
        if (this.nodes.root === null) return;
        const e = this.make(this.params);
        this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove($0cf1b19b2f7a01d6$var$L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Enables special focus and hover behavior for item in confirmation state.
   * This is needed to prevent item from being highlighted as hovered/focused just after click.
   */ enableSpecialHoverAndFocusBehavior() {
        var e, t1, o;
        (e = this.nodes.root) == null || e.classList.add($0cf1b19b2f7a01d6$var$L.noHover), (t1 = this.nodes.root) == null || t1.classList.add($0cf1b19b2f7a01d6$var$L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
            once: !0
        });
    }
    /**
   * Disables special focus and hover behavior
   */ disableSpecialHoverAndFocusBehavior() {
        var e;
        this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
    }
    /**
   * Executes item's onActivate callback if the item has no confirmation configured
   *
   * @param item - item to activate or bring to confirmation mode
   */ activateOrEnableConfirmationMode(e) {
        var t1;
        if (!("confirmation" in e) || e.confirmation === void 0) try {
            (t1 = e.onActivate) == null || t1.call(e, e), this.disableConfirmationMode();
        } catch  {
            this.animateError();
        }
        else this.enableConfirmationMode(e.confirmation);
    }
    /**
   * Animates item which symbolizes that error occured while executing 'onActivate()' callback
   */ animateError() {
        var e, t1, o;
        (e = this.nodes.icon) != null && e.classList.contains($0cf1b19b2f7a01d6$var$L.wobbleAnimation) || ((t1 = this.nodes.icon) == null || t1.classList.add($0cf1b19b2f7a01d6$var$L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
    }
}
const $0cf1b19b2f7a01d6$var$nt = $0cf1b19b2f7a01d6$var$ne("ce-popover-item-separator"), $0cf1b19b2f7a01d6$var$it = {
    container: $0cf1b19b2f7a01d6$var$nt(),
    line: $0cf1b19b2f7a01d6$var$nt("line"),
    hidden: $0cf1b19b2f7a01d6$var$nt(null, "hidden")
};
class $0cf1b19b2f7a01d6$var$Qo extends $0cf1b19b2f7a01d6$var$xt {
    /**
   * Constructs the instance
   */ constructor(){
        super(), this.nodes = {
            root: $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$it.container),
            line: $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$it.line)
        }, this.nodes.root.appendChild(this.nodes.line);
    }
    /**
   * Returns popover separator root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($0cf1b19b2f7a01d6$var$it.hidden, e);
    }
}
var $0cf1b19b2f7a01d6$var$G = /* @__PURE__ */ ((n)=>(n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n))($0cf1b19b2f7a01d6$var$G || {});
const $0cf1b19b2f7a01d6$var$$ = $0cf1b19b2f7a01d6$var$ne("ce-popover"), $0cf1b19b2f7a01d6$var$P = {
    popover: $0cf1b19b2f7a01d6$var$$(),
    popoverContainer: $0cf1b19b2f7a01d6$var$$("container"),
    popoverOpenTop: $0cf1b19b2f7a01d6$var$$(null, "open-top"),
    popoverOpenLeft: $0cf1b19b2f7a01d6$var$$(null, "open-left"),
    popoverOpened: $0cf1b19b2f7a01d6$var$$(null, "opened"),
    search: $0cf1b19b2f7a01d6$var$$("search"),
    nothingFoundMessage: $0cf1b19b2f7a01d6$var$$("nothing-found-message"),
    nothingFoundMessageDisplayed: $0cf1b19b2f7a01d6$var$$("nothing-found-message", "displayed"),
    items: $0cf1b19b2f7a01d6$var$$("items"),
    overlay: $0cf1b19b2f7a01d6$var$$("overlay"),
    overlayHidden: $0cf1b19b2f7a01d6$var$$("overlay", "hidden"),
    popoverNested: $0cf1b19b2f7a01d6$var$$(null, "nested"),
    getPopoverNestedClass: (n)=>$0cf1b19b2f7a01d6$var$$(null, `nested-level-${n.toString()}`),
    popoverInline: $0cf1b19b2f7a01d6$var$$(null, "inline"),
    popoverHeader: $0cf1b19b2f7a01d6$var$$("header")
};
var $0cf1b19b2f7a01d6$var$fe = /* @__PURE__ */ ((n)=>(n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n))($0cf1b19b2f7a01d6$var$fe || {});
const $0cf1b19b2f7a01d6$var$To = $0cf1b19b2f7a01d6$var$ne("ce-popover-item-html"), $0cf1b19b2f7a01d6$var$So = {
    root: $0cf1b19b2f7a01d6$var$To(),
    hidden: $0cf1b19b2f7a01d6$var$To(null, "hidden")
};
class $0cf1b19b2f7a01d6$var$Se extends $0cf1b19b2f7a01d6$var$xt {
    /**
   * Constructs the instance
   *
   * @param params – instance parameters
   * @param renderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        var o, i;
        super(e), this.nodes = {
            root: $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$So.root)
        }, this.nodes.root.appendChild(e.element), e.name && (this.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t1 == null ? void 0 : t1.hint) == null ? void 0 : o.enabled) !== !1 && this.addHint(this.nodes.root, {
            ...e.hint,
            position: ((i = t1 == null ? void 0 : t1.hint) == null ? void 0 : i.position) || "right"
        });
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($0cf1b19b2f7a01d6$var$So.hidden, e);
    }
    /**
   * Returns list of buttons and inputs inside custom content
   */ getControls() {
        const e = this.nodes.root.querySelectorAll(`button, ${$0cf1b19b2f7a01d6$var$u.allInputsSelector}`);
        return Array.from(e);
    }
}
class $0cf1b19b2f7a01d6$var$Jo extends $0cf1b19b2f7a01d6$var$Oe {
    /**
   * Constructs the instance
   *
   * @param params - popover construction params
   * @param itemsRenderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1 = {}){
        super(), this.params = e, this.itemsRenderParams = t1, this.listeners = new $0cf1b19b2f7a01d6$var$_e(), this.messages = {
            nothingFound: "Nothing found",
            search: "Search"
        }, this.items = this.buildItems(e.items), e.messages && (this.messages = {
            ...this.messages,
            ...e.messages
        }), this.nodes = {}, this.nodes.popoverContainer = $0cf1b19b2f7a01d6$var$u.make("div", [
            $0cf1b19b2f7a01d6$var$P.popoverContainer
        ]), this.nodes.nothingFoundMessage = $0cf1b19b2f7a01d6$var$u.make("div", [
            $0cf1b19b2f7a01d6$var$P.nothingFoundMessage
        ], {
            textContent: this.messages.nothingFound
        }), this.nodes.popoverContainer.appendChild(this.nodes.nothingFoundMessage), this.nodes.items = $0cf1b19b2f7a01d6$var$u.make("div", [
            $0cf1b19b2f7a01d6$var$P.items
        ]), this.items.forEach((o)=>{
            const i = o.getElement();
            i !== null && this.nodes.items.appendChild(i);
        }), this.nodes.popoverContainer.appendChild(this.nodes.items), this.listeners.on(this.nodes.popoverContainer, "click", (o)=>this.handleClick(o)), this.nodes.popover = $0cf1b19b2f7a01d6$var$u.make("div", [
            $0cf1b19b2f7a01d6$var$P.popover,
            this.params.class
        ]), this.nodes.popover.appendChild(this.nodes.popoverContainer);
    }
    /**
   * List of default popover items that are searchable and may have confirmation state
   */ get itemsDefault() {
        return this.items.filter((e)=>e instanceof $0cf1b19b2f7a01d6$var$re);
    }
    /**
   * Returns HTML element corresponding to the popover
   */ getElement() {
        return this.nodes.popover;
    }
    /**
   * Open popover
   */ show() {
        this.nodes.popover.classList.add($0cf1b19b2f7a01d6$var$P.popoverOpened), this.search !== void 0 && this.search.focus();
    }
    /**
   * Closes popover
   */ hide() {
        this.nodes.popover.classList.remove($0cf1b19b2f7a01d6$var$P.popoverOpened), this.nodes.popover.classList.remove($0cf1b19b2f7a01d6$var$P.popoverOpenTop), this.itemsDefault.forEach((e)=>e.reset()), this.search !== void 0 && this.search.clear(), this.emit($0cf1b19b2f7a01d6$var$G.Closed);
    }
    /**
   * Clears memory
   */ destroy() {
        var e;
        this.items.forEach((t1)=>t1.destroy()), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
    }
    /**
   * Looks for the item by name and imitates click on it
   *
   * @param name - name of the item to activate
   */ activateItemByName(e) {
        const t1 = this.items.find((o)=>o.name === e);
        this.handleItemClick(t1);
    }
    /**
   * Factory method for creating popover items
   *
   * @param items - list of items params
   */ buildItems(e) {
        return e.map((t1)=>{
            switch(t1.type){
                case $0cf1b19b2f7a01d6$var$_.Separator:
                    return new $0cf1b19b2f7a01d6$var$Qo();
                case $0cf1b19b2f7a01d6$var$_.Html:
                    return new $0cf1b19b2f7a01d6$var$Se(t1, this.itemsRenderParams[$0cf1b19b2f7a01d6$var$_.Html]);
                default:
                    return new $0cf1b19b2f7a01d6$var$re(t1, this.itemsRenderParams[$0cf1b19b2f7a01d6$var$_.Default]);
            }
        });
    }
    /**
   * Retrieves popover item that is the target of the specified event
   *
   * @param event - event to retrieve popover item from
   */ getTargetItem(e) {
        return this.items.filter((t1)=>t1 instanceof $0cf1b19b2f7a01d6$var$re || t1 instanceof $0cf1b19b2f7a01d6$var$Se).find((t1)=>{
            const o = t1.getElement();
            return o === null ? !1 : e.composedPath().includes(o);
        });
    }
    /**
   * Handles popover item click
   *
   * @param item - item to handle click of
   */ handleItemClick(e) {
        if (!("isDisabled" in e && e.isDisabled)) {
            if (e.hasChildren) {
                this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
                return;
            }
            this.itemsDefault.filter((t1)=>t1 !== e).forEach((t1)=>t1.reset()), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit($0cf1b19b2f7a01d6$var$G.ClosedOnActivate));
        }
    }
    /**
   * Handles clicks inside popover
   *
   * @param event - item to handle click of
   */ handleClick(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.handleItemClick(t1);
    }
    /**
   * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
   *
   * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
   * (All the other items with the same key get inactive, and the item gets active)
   *
   * @param clickedItem - popover item that was clicked
   */ toggleItemActivenessIfNeeded(e) {
        if (e instanceof $0cf1b19b2f7a01d6$var$re && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
            const t1 = this.itemsDefault.filter((o)=>o.toggle === e.toggle);
            if (t1.length === 1) {
                e.toggleActive();
                return;
            }
            t1.forEach((o)=>{
                o.toggleActive(o === e);
            });
        }
    }
}
var $0cf1b19b2f7a01d6$var$Ue = /* @__PURE__ */ ((n)=>(n.Search = "search", n))($0cf1b19b2f7a01d6$var$Ue || {});
const $0cf1b19b2f7a01d6$var$st = $0cf1b19b2f7a01d6$var$ne("cdx-search-field"), $0cf1b19b2f7a01d6$var$rt = {
    wrapper: $0cf1b19b2f7a01d6$var$st(),
    icon: $0cf1b19b2f7a01d6$var$st("icon"),
    input: $0cf1b19b2f7a01d6$var$st("input")
};
class $0cf1b19b2f7a01d6$var$ls extends $0cf1b19b2f7a01d6$var$Oe {
    /**
   * @param options - available config
   * @param options.items - searchable items list
   * @param options.placeholder - input placeholder
   */ constructor({ items: e, placeholder: t1 }){
        super(), this.listeners = new $0cf1b19b2f7a01d6$var$_e(), this.items = e, this.wrapper = $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$rt.wrapper);
        const o = $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$rt.icon, {
            innerHTML: $0cf1b19b2f7a01d6$var$os
        });
        this.input = $0cf1b19b2f7a01d6$var$u.make("input", $0cf1b19b2f7a01d6$var$rt.input, {
            placeholder: t1,
            /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */ tabIndex: -1
        }), this.wrapper.appendChild(o), this.wrapper.appendChild(this.input), this.listeners.on(this.input, "input", ()=>{
            this.searchQuery = this.input.value, this.emit($0cf1b19b2f7a01d6$var$Ue.Search, {
                query: this.searchQuery,
                items: this.foundItems
            });
        });
    }
    /**
   * Returns search field element
   */ getElement() {
        return this.wrapper;
    }
    /**
   * Sets focus to the input
   */ focus() {
        this.input.focus();
    }
    /**
   * Clears search query and results
   */ clear() {
        this.input.value = "", this.searchQuery = "", this.emit($0cf1b19b2f7a01d6$var$Ue.Search, {
            query: "",
            items: this.foundItems
        });
    }
    /**
   * Clears memory
   */ destroy() {
        this.listeners.removeAll();
    }
    /**
   * Returns list of found items for the current search query
   */ get foundItems() {
        return this.items.filter((e)=>this.checkItem(e));
    }
    /**
   * Contains logic for checking whether passed item conforms the search query
   *
   * @param item - item to be checked
   */ checkItem(e) {
        var i, s;
        const t1 = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "", o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
        return o !== void 0 ? t1.includes(o) : !1;
    }
}
var $0cf1b19b2f7a01d6$var$cs = Object.defineProperty, $0cf1b19b2f7a01d6$var$ds = Object.getOwnPropertyDescriptor, $0cf1b19b2f7a01d6$var$us = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $0cf1b19b2f7a01d6$var$ds(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $0cf1b19b2f7a01d6$var$cs(e, t1, i), i;
};
const $0cf1b19b2f7a01d6$var$en = class tn extends $0cf1b19b2f7a01d6$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   * @param itemsRenderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e, t1), this.nestingLevel = 0, this.nestedPopoverTriggerItem = null, this.previouslyHoveredItem = null, this.scopeElement = document.body, this.hide = ()=>{
            var o;
            super.hide(), this.destroyNestedPopoverIfExists(), (o = this.flipper) == null || o.deactivate(), this.previouslyHoveredItem = null;
        }, this.onFlip = ()=>{
            const o = this.itemsDefault.find((i)=>i.isFocused);
            o == null || o.onFocus();
        }, this.onSearch = (o)=>{
            var a;
            const i = o.query === "", s = o.items.length === 0;
            this.items.forEach((l)=>{
                let c = !1;
                l instanceof $0cf1b19b2f7a01d6$var$re ? c = !o.items.includes(l) : (l instanceof $0cf1b19b2f7a01d6$var$Qo || l instanceof $0cf1b19b2f7a01d6$var$Se) && (c = s || !i), l.toggleHidden(c);
            }), this.toggleNothingFoundMessage(s);
            const r = o.query === "" ? this.flippableElements : o.items.map((l)=>l.getElement());
            (a = this.flipper) != null && a.isActivated && (this.flipper.deactivate(), this.flipper.activate(r));
        }, e.nestingLevel !== void 0 && (this.nestingLevel = e.nestingLevel), this.nestingLevel > 0 && this.nodes.popover.classList.add($0cf1b19b2f7a01d6$var$P.popoverNested), e.scopeElement !== void 0 && (this.scopeElement = e.scopeElement), this.nodes.popoverContainer !== null && this.listeners.on(this.nodes.popoverContainer, "mouseover", (o)=>this.handleHover(o)), e.searchable && this.addSearch(), e.flippable !== !1 && (this.flipper = new $0cf1b19b2f7a01d6$var$ce({
            items: this.flippableElements,
            focusedItemClass: $0cf1b19b2f7a01d6$var$L.focused,
            allowedKeys: [
                $0cf1b19b2f7a01d6$var$y.TAB,
                $0cf1b19b2f7a01d6$var$y.UP,
                $0cf1b19b2f7a01d6$var$y.DOWN,
                $0cf1b19b2f7a01d6$var$y.ENTER
            ]
        }), this.flipper.onFlip(this.onFlip));
    }
    /**
   * Returns true if some item inside popover is focused
   */ hasFocus() {
        return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
    }
    /**
   * Scroll position inside items container of the popover
   */ get scrollTop() {
        return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
    }
    /**
   * Returns visible element offset top
   */ get offsetTop() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
    }
    /**
   * Open popover
   */ show() {
        var e;
        this.nodes.popover.style.setProperty($0cf1b19b2f7a01d6$var$fe.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add($0cf1b19b2f7a01d6$var$P.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add($0cf1b19b2f7a01d6$var$P.popoverOpenLeft), super.show(), (e = this.flipper) == null || e.activate(this.flippableElements);
    }
    /**
   * Clears memory
   */ destroy() {
        this.hide(), super.destroy();
    }
    /**
   * Handles displaying nested items for the item.
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
    }
    /**
   * Handles hover events inside popover items container
   *
   * @param event - hover event data
   */ handleHover(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.previouslyHoveredItem !== t1 && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t1, t1.hasChildren && this.showNestedPopoverForItem(t1));
    }
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used for correct positioning of the nested popover
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = (o ? o.offsetTop : 0) - this.scrollTop, s = this.offsetTop + i;
        e.style.setProperty($0cf1b19b2f7a01d6$var$fe.TriggerItemTop, s + "px");
    }
    /**
   * Destroys existing nested popover
   */ destroyNestedPopoverIfExists() {
        var e, t1;
        this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off($0cf1b19b2f7a01d6$var$G.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t1 = this.nestedPopoverTriggerItem) == null || t1.onChildrenClose());
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        var o;
        this.nestedPopover = new tn({
            searchable: e.isChildrenSearchable,
            items: e.children,
            nestingLevel: this.nestingLevel + 1,
            flippable: e.isChildrenFlippable,
            messages: this.messages
        }), e.onChildrenOpen(), this.nestedPopover.on($0cf1b19b2f7a01d6$var$G.ClosedOnActivate, this.hide);
        const t1 = this.nestedPopover.getElement();
        return this.nodes.popover.appendChild(t1), this.setTriggerItemPosition(t1, e), t1.style.setProperty($0cf1b19b2f7a01d6$var$fe.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
    }
    /**
   * Checks if popover should be opened bottom.
   * It should happen when there is enough space below or not enough space above
   */ get shouldOpenBottom() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popoverContainer.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.height, i = e.top + o, s = e.top - o, r = Math.min(window.innerHeight, t1.bottom);
        return s < t1.top || i <= r;
    }
    /**
   * Checks if popover should be opened left.
   * It should happen when there is enough space in the right or not enough space in the left
   */ get shouldOpenRight() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popover.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.width, i = e.right + o, s = e.left - o, r = Math.min(window.innerWidth, t1.right);
        return s < t1.left || i <= r;
    }
    get size() {
        var i;
        const e = {
            height: 0,
            width: 0
        };
        if (this.nodes.popover === null) return e;
        const t1 = this.nodes.popover.cloneNode(!0);
        t1.style.visibility = "hidden", t1.style.position = "absolute", t1.style.top = "-1000px", t1.classList.add($0cf1b19b2f7a01d6$var$P.popoverOpened), (i = t1.querySelector("." + $0cf1b19b2f7a01d6$var$P.popoverNested)) == null || i.remove(), document.body.appendChild(t1);
        const o = t1.querySelector("." + $0cf1b19b2f7a01d6$var$P.popoverContainer);
        return e.height = o.offsetHeight, e.width = o.offsetWidth, t1.remove(), e;
    }
    /**
   * Returns list of elements available for keyboard navigation.
   */ get flippableElements() {
        return this.items.map((t1)=>{
            if (t1 instanceof $0cf1b19b2f7a01d6$var$re) return t1.getElement();
            if (t1 instanceof $0cf1b19b2f7a01d6$var$Se) return t1.getControls();
        }).flat().filter((t1)=>t1 != null);
    }
    /**
   * Adds search to the popover
   */ addSearch() {
        this.search = new $0cf1b19b2f7a01d6$var$ls({
            items: this.itemsDefault,
            placeholder: this.messages.search
        }), this.search.on($0cf1b19b2f7a01d6$var$Ue.Search, this.onSearch);
        const e = this.search.getElement();
        e.classList.add($0cf1b19b2f7a01d6$var$P.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
    }
    /**
   * Toggles nothing found message visibility
   *
   * @param isDisplayed - true if the message should be displayed
   */ toggleNothingFoundMessage(e) {
        this.nodes.nothingFoundMessage.classList.toggle($0cf1b19b2f7a01d6$var$P.nothingFoundMessageDisplayed, e);
    }
};
$0cf1b19b2f7a01d6$var$us([
    $0cf1b19b2f7a01d6$var$me
], $0cf1b19b2f7a01d6$var$en.prototype, "size", 1);
let $0cf1b19b2f7a01d6$var$Bt = $0cf1b19b2f7a01d6$var$en;
class $0cf1b19b2f7a01d6$var$hs extends $0cf1b19b2f7a01d6$var$Bt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        const t1 = !$0cf1b19b2f7a01d6$var$be();
        super({
            ...e,
            class: $0cf1b19b2f7a01d6$var$P.popoverInline
        }, {
            [$0cf1b19b2f7a01d6$var$_.Default]: {
                /**
           * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
           *
           * @todo figure out better way to solve the issue
           */ wrapperTag: "button",
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            },
            [$0cf1b19b2f7a01d6$var$_.Html]: {
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }
        }), this.items.forEach((o)=>{
            !(o instanceof $0cf1b19b2f7a01d6$var$re) && !(o instanceof $0cf1b19b2f7a01d6$var$Se) || o.hasChildren && o.isChildrenOpen && this.showNestedItems(o);
        });
    }
    /**
   * Returns visible element offset top
   */ get offsetLeft() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
    }
    /**
   * Open popover
   */ show() {
        this.nestingLevel === 0 && this.nodes.popover.style.setProperty($0cf1b19b2f7a01d6$var$fe.InlinePopoverWidth, this.size.width + "px"), super.show();
    }
    /**
   * Disable hover event handling.
   * Overrides parent's class behavior
   */ handleHover() {}
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used to position nested popover right below clicked item
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = o ? o.offsetLeft : 0, s = this.offsetLeft + i;
        e.style.setProperty($0cf1b19b2f7a01d6$var$fe.TriggerItemLeft, s + "px");
    }
    /**
   * Handles displaying nested items for the item.
   * Overriding in order to add toggling behaviour
   *
   * @param item – item to toggle nested popover for
   */ showNestedItems(e) {
        if (this.nestedPopoverTriggerItem === e) {
            this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
            return;
        }
        super.showNestedItems(e);
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        const t1 = super.showNestedPopoverForItem(e);
        return t1.getElement().classList.add($0cf1b19b2f7a01d6$var$P.getPopoverNestedClass(t1.nestingLevel)), t1;
    }
    /**
   * Overrides default item click handling.
   * Helps to close nested popover once other item is clicked.
   *
   * @param item - clicked item
   */ handleItemClick(e) {
        var t1;
        e !== this.nestedPopoverTriggerItem && ((t1 = this.nestedPopoverTriggerItem) == null || t1.handleClick(), super.destroyNestedPopoverIfExists()), super.handleItemClick(e);
    }
}
const $0cf1b19b2f7a01d6$var$on = class xe {
    constructor(){
        this.scrollPosition = null;
    }
    /**
   * Locks body element scroll
   */ lock() {
        $0cf1b19b2f7a01d6$var$pt ? this.lockHard() : document.body.classList.add(xe.CSS.scrollLocked);
    }
    /**
   * Unlocks body element scroll
   */ unlock() {
        $0cf1b19b2f7a01d6$var$pt ? this.unlockHard() : document.body.classList.remove(xe.CSS.scrollLocked);
    }
    /**
   * Locks scroll in a hard way (via setting fixed position to body element)
   */ lockHard() {
        this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", `${this.scrollPosition}px`), document.body.classList.add(xe.CSS.scrollLockedHard);
    }
    /**
   * Unlocks hard scroll lock
   */ unlockHard() {
        document.body.classList.remove(xe.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
    }
};
$0cf1b19b2f7a01d6$var$on.CSS = {
    scrollLocked: "ce-scroll-locked",
    scrollLockedHard: "ce-scroll-locked--hard"
};
let $0cf1b19b2f7a01d6$var$ps = $0cf1b19b2f7a01d6$var$on;
const $0cf1b19b2f7a01d6$var$at = $0cf1b19b2f7a01d6$var$ne("ce-popover-header"), $0cf1b19b2f7a01d6$var$lt = {
    root: $0cf1b19b2f7a01d6$var$at(),
    text: $0cf1b19b2f7a01d6$var$at("text"),
    backButton: $0cf1b19b2f7a01d6$var$at("back-button")
};
class $0cf1b19b2f7a01d6$var$fs {
    /**
   * Constructs the instance
   *
   * @param params - popover header params
   */ constructor({ text: e, onBackButtonClick: t1 }){
        this.listeners = new $0cf1b19b2f7a01d6$var$_e(), this.text = e, this.onBackButtonClick = t1, this.nodes = {
            root: $0cf1b19b2f7a01d6$var$u.make("div", [
                $0cf1b19b2f7a01d6$var$lt.root
            ]),
            backButton: $0cf1b19b2f7a01d6$var$u.make("button", [
                $0cf1b19b2f7a01d6$var$lt.backButton
            ]),
            text: $0cf1b19b2f7a01d6$var$u.make("div", [
                $0cf1b19b2f7a01d6$var$lt.text
            ])
        }, this.nodes.backButton.innerHTML = $0cf1b19b2f7a01d6$var$Vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
    }
    /**
   * Returns popover header root html element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Destroys the instance
   */ destroy() {
        this.nodes.root.remove(), this.listeners.destroy();
    }
}
class $0cf1b19b2f7a01d6$var$gs {
    constructor(){
        this.history = [];
    }
    /**
   * Push new popover state
   *
   * @param state - new state
   */ push(e) {
        this.history.push(e);
    }
    /**
   * Pop last popover state
   */ pop() {
        return this.history.pop();
    }
    /**
   * Title retrieved from the current state
   */ get currentTitle() {
        return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
    }
    /**
   * Items list retrieved from the current state
   */ get currentItems() {
        return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
    }
    /**
   * Returns history to initial popover state
   */ reset() {
        for(; this.history.length > 1;)this.pop();
    }
}
class $0cf1b19b2f7a01d6$var$nn extends $0cf1b19b2f7a01d6$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   */ constructor(e){
        super(e, {
            [$0cf1b19b2f7a01d6$var$_.Default]: {
                hint: {
                    enabled: !1
                }
            },
            [$0cf1b19b2f7a01d6$var$_.Html]: {
                hint: {
                    enabled: !1
                }
            }
        }), this.scrollLocker = new $0cf1b19b2f7a01d6$var$ps(), this.history = new $0cf1b19b2f7a01d6$var$gs(), this.isHidden = !0, this.nodes.overlay = $0cf1b19b2f7a01d6$var$u.make("div", [
            $0cf1b19b2f7a01d6$var$P.overlay,
            $0cf1b19b2f7a01d6$var$P.overlayHidden
        ]), this.nodes.popover.insertBefore(this.nodes.overlay, this.nodes.popover.firstChild), this.listeners.on(this.nodes.overlay, "click", ()=>{
            this.hide();
        }), this.history.push({
            items: e.items
        });
    }
    /**
   * Open popover
   */ show() {
        this.nodes.overlay.classList.remove($0cf1b19b2f7a01d6$var$P.overlayHidden), super.show(), this.scrollLocker.lock(), this.isHidden = !1;
    }
    /**
   * Closes popover
   */ hide() {
        this.isHidden || (super.hide(), this.nodes.overlay.classList.add($0cf1b19b2f7a01d6$var$P.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
    }
    /**
   * Clears memory
   */ destroy() {
        super.destroy(), this.scrollLocker.unlock();
    }
    /**
   * Handles displaying nested items for the item
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.updateItemsAndHeader(e.children, e.title), this.history.push({
            title: e.title,
            items: e.children
        });
    }
    /**
   * Removes rendered popover items and header and displays new ones
   *
   * @param items - new popover items
   * @param title - new popover header text
   */ updateItemsAndHeader(e, t1) {
        if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t1 !== void 0) {
            this.header = new $0cf1b19b2f7a01d6$var$fs({
                text: t1,
                onBackButtonClick: ()=>{
                    this.history.pop(), this.updateItemsAndHeader(this.history.currentItems, this.history.currentTitle);
                }
            });
            const o = this.header.getElement();
            o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
        }
        this.items.forEach((o)=>{
            var i;
            return (i = o.getElement()) == null ? void 0 : i.remove();
        }), this.items = this.buildItems(e), this.items.forEach((o)=>{
            var s;
            const i = o.getElement();
            i !== null && ((s = this.nodes.items) == null || s.appendChild(i));
        });
    }
}
class $0cf1b19b2f7a01d6$var$ms extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.opened = !1, this.hasMobileLayoutToggleListener = !1, this.selection = new $0cf1b19b2f7a01d6$var$b(), this.popover = null, this.close = ()=>{
            this.opened && (this.opened = !1, $0cf1b19b2f7a01d6$var$b.isAtEditor || this.selection.restore(), this.selection.clearSaved(), !this.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && this.Editor.BlockManager.currentBlock && this.Editor.BlockSelection.unselectBlock(this.Editor.BlockManager.currentBlock), this.eventsDispatcher.emit(this.events.closed), this.popover && (this.popover.off($0cf1b19b2f7a01d6$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover.getElement().remove(), this.popover = null));
        }, this.onPopoverClose = ()=>{
            this.close();
        };
    }
    /**
   * Module Events
   */ get events() {
        return {
            opened: "block-settings-opened",
            closed: "block-settings-closed"
        };
    }
    /**
   * Block Settings CSS
   */ get CSS() {
        return {
            settings: "ce-settings"
        };
    }
    /**
   * Getter for inner popover's flipper instance
   *
   * @todo remove once BlockSettings becomes standalone non-module class
   */ get flipper() {
        var e;
        if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
    }
    /**
   * Panel with block settings with 2 sections:
   *  - Tool's Settings
   *  - Default Settings [Move, Remove, etc]
   */ make() {
        this.nodes.wrapper = $0cf1b19b2f7a01d6$var$u.make("div", [
            this.CSS.settings
        ]), this.eventsDispatcher.on($0cf1b19b2f7a01d6$var$Te, this.close), this.hasMobileLayoutToggleListener = !0;
    }
    /**
   * Destroys module
   */ destroy() {
        this.removeAllNodes(), this.listeners.destroy(), this.hasMobileLayoutToggleListener && (this.eventsDispatcher.off($0cf1b19b2f7a01d6$var$Te, this.close), this.hasMobileLayoutToggleListener = !1);
    }
    /**
   * Open Block Settings pane
   *
   * @param targetBlock - near which Block we should open BlockSettings
   */ async open(e = this.Editor.BlockManager.currentBlock) {
        var s;
        this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
        const { toolTunes: t1, commonTunes: o } = e.getTunes();
        this.eventsDispatcher.emit(this.events.opened);
        const i = $0cf1b19b2f7a01d6$var$be() ? $0cf1b19b2f7a01d6$var$nn : $0cf1b19b2f7a01d6$var$Bt;
        this.popover = new i({
            searchable: !0,
            items: await this.getTunesItems(e, o, t1),
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.popover, "Nothing found"),
                search: $0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.popover, "Filter")
            }
        }), this.popover.on($0cf1b19b2f7a01d6$var$G.Closed, this.onPopoverClose), (s = this.nodes.wrapper) == null || s.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.wrapper;
    }
    /**
   * Returns list of items to be displayed in block tunes menu.
   * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
   *
   * @param currentBlock –  block we are about to open block tunes for
   * @param commonTunes – common tunes
   * @param toolTunes - tool specific tunes
   */ async getTunesItems(e, t1, o) {
        const i = [];
        o !== void 0 && o.length > 0 && (i.push(...o), i.push({
            type: $0cf1b19b2f7a01d6$var$_.Separator
        }));
        const s = Array.from(this.Editor.Tools.blockTools.values()), a = (await $0cf1b19b2f7a01d6$var$Yo(e, s)).reduce((l, c)=>(c.toolbox.forEach((d)=>{
                l.push({
                    icon: d.icon,
                    title: $0cf1b19b2f7a01d6$var$z.t($0cf1b19b2f7a01d6$var$K.toolNames, d.title),
                    name: c.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const { BlockManager: h, Caret: p, Toolbar: g } = this.Editor, f = await h.convert(e, c.name, d.data);
                        g.close(), p.setToBlock(f, p.positions.END);
                    }
                });
            }), l), []);
        return a.length > 0 && (i.push({
            icon: $0cf1b19b2f7a01d6$var$Go,
            name: "convert-to",
            title: $0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.popover, "Convert to"),
            children: {
                searchable: !0,
                items: a
            }
        }), i.push({
            type: $0cf1b19b2f7a01d6$var$_.Separator
        })), i.push(...t1), i.map((l)=>this.resolveTuneAliases(l));
    }
    /**
   * Resolves aliases in tunes menu items
   *
   * @param item - item with resolved aliases
   */ resolveTuneAliases(e) {
        if (e.type === $0cf1b19b2f7a01d6$var$_.Separator || e.type === $0cf1b19b2f7a01d6$var$_.Html) return e;
        const t1 = $0cf1b19b2f7a01d6$var$Yi(e, {
            label: "title"
        });
        return e.confirmation && (t1.confirmation = this.resolveTuneAliases(e.confirmation)), t1;
    }
}
var $0cf1b19b2f7a01d6$var$sn = {
    exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                function s(l, c) {
                    for(var d = 0; d < c.length; d++){
                        var h = c[d];
                        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
                    }
                }
                function r(l, c, d) {
                    return c && s(l.prototype, c), d && s(l, d), l;
                }
                i.r(o);
                var a = function() {
                    function l(c) {
                        var d = this;
                        (function(h, p) {
                            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
                        })(this, l), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function(h) {
                            d.execute(h);
                        }, this.element.addEventListener("keydown", this.executeShortcut, !1);
                    }
                    return r(l, null, [
                        {
                            key: "supportedCommands",
                            get: function() {
                                return {
                                    SHIFT: [
                                        "SHIFT"
                                    ],
                                    CMD: [
                                        "CMD",
                                        "CONTROL",
                                        "COMMAND",
                                        "WINDOWS",
                                        "CTRL"
                                    ],
                                    ALT: [
                                        "ALT",
                                        "OPTION"
                                    ]
                                };
                            }
                        },
                        {
                            key: "keyCodes",
                            get: function() {
                                return {
                                    0: 48,
                                    1: 49,
                                    2: 50,
                                    3: 51,
                                    4: 52,
                                    5: 53,
                                    6: 54,
                                    7: 55,
                                    8: 56,
                                    9: 57,
                                    A: 65,
                                    B: 66,
                                    C: 67,
                                    D: 68,
                                    E: 69,
                                    F: 70,
                                    G: 71,
                                    H: 72,
                                    I: 73,
                                    J: 74,
                                    K: 75,
                                    L: 76,
                                    M: 77,
                                    N: 78,
                                    O: 79,
                                    P: 80,
                                    Q: 81,
                                    R: 82,
                                    S: 83,
                                    T: 84,
                                    U: 85,
                                    V: 86,
                                    W: 87,
                                    X: 88,
                                    Y: 89,
                                    Z: 90,
                                    BACKSPACE: 8,
                                    ENTER: 13,
                                    ESCAPE: 27,
                                    LEFT: 37,
                                    UP: 38,
                                    RIGHT: 39,
                                    DOWN: 40,
                                    INSERT: 45,
                                    DELETE: 46,
                                    ".": 190
                                };
                            }
                        }
                    ]), r(l, [
                        {
                            key: "parseShortcutName",
                            value: function(c) {
                                c = c.split("+");
                                for(var d = 0; d < c.length; d++){
                                    c[d] = c[d].toUpperCase();
                                    var h = !1;
                                    for(var p in l.supportedCommands)if (l.supportedCommands[p].includes(c[d])) {
                                        h = this.commands[p] = !0;
                                        break;
                                    }
                                    h || (this.keys[c[d]] = !0);
                                }
                                for(var g in l.supportedCommands)this.commands[g] || (this.commands[g] = !1);
                            }
                        },
                        {
                            key: "execute",
                            value: function(c) {
                                var d, h = {
                                    CMD: c.ctrlKey || c.metaKey,
                                    SHIFT: c.shiftKey,
                                    ALT: c.altKey
                                }, p = !0;
                                for(d in this.commands)this.commands[d] !== h[d] && (p = !1);
                                var g, f = !0;
                                for(g in this.keys)f = f && c.keyCode === l.keyCodes[g];
                                p && f && this.callback(c);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.element.removeEventListener("keydown", this.executeShortcut);
                            }
                        }
                    ]), l;
                }();
                o.default = a;
            }
        ]).default;
    });
})($0cf1b19b2f7a01d6$var$sn);
var $0cf1b19b2f7a01d6$var$bs = $0cf1b19b2f7a01d6$var$sn.exports;
const $0cf1b19b2f7a01d6$var$vs = /* @__PURE__ */ $0cf1b19b2f7a01d6$var$Ke($0cf1b19b2f7a01d6$var$bs);
class $0cf1b19b2f7a01d6$var$ks {
    constructor(){
        this.registeredShortcuts = /* @__PURE__ */ new Map();
    }
    /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */ add(e) {
        if (this.findShortcut(e.on, e.name)) throw Error(`Shortcut ${e.name} is already registered for ${e.on}. Please remove it before add a new handler.`);
        const o = new $0cf1b19b2f7a01d6$var$vs({
            name: e.name,
            on: e.on,
            callback: e.handler
        }), i = this.registeredShortcuts.get(e.on) || [];
        this.registeredShortcuts.set(e.on, [
            ...i,
            o
        ]);
    }
    /**
   * Remove shortcut
   *
   * @param element - Element shortcut is set for
   * @param name - shortcut name
   */ remove(e, t1) {
        const o = this.findShortcut(e, t1);
        if (!o) return;
        o.remove();
        const s = this.registeredShortcuts.get(e).filter((r)=>r !== o);
        if (s.length === 0) {
            this.registeredShortcuts.delete(e);
            return;
        }
        this.registeredShortcuts.set(e, s);
    }
    /**
   * Get Shortcut instance if exist
   *
   * @param element - Element shorcut is set for
   * @param shortcut - shortcut name
   * @returns {number} index - shortcut index if exist
   */ findShortcut(e, t1) {
        return (this.registeredShortcuts.get(e) || []).find(({ name: i })=>i === t1);
    }
}
const $0cf1b19b2f7a01d6$var$ge = new $0cf1b19b2f7a01d6$var$ks();
var $0cf1b19b2f7a01d6$var$ys = Object.defineProperty, $0cf1b19b2f7a01d6$var$ws = Object.getOwnPropertyDescriptor, $0cf1b19b2f7a01d6$var$rn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $0cf1b19b2f7a01d6$var$ws(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $0cf1b19b2f7a01d6$var$ys(e, t1, i), i;
}, $0cf1b19b2f7a01d6$var$Le = /* @__PURE__ */ ((n)=>(n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n))($0cf1b19b2f7a01d6$var$Le || {});
const $0cf1b19b2f7a01d6$var$Ct = class an extends $0cf1b19b2f7a01d6$var$Oe {
    /**
   * Toolbox constructor
   *
   * @param options - available parameters
   * @param options.api - Editor API methods
   * @param options.tools - Tools available to check whether some of them should be displayed at the Toolbox or not
   */ constructor({ api: e, tools: t1, i18nLabels: o }){
        super(), this.opened = !1, this.listeners = new $0cf1b19b2f7a01d6$var$_e(), this.popover = null, this.handleMobileLayoutToggle = ()=>{
            this.destroyPopover(), this.initPopover();
        }, this.onPopoverClose = ()=>{
            this.opened = !1, this.emit("toolbox-closed");
        }, this.api = e, this.tools = t1, this.i18nLabels = o, this.enableShortcuts(), this.nodes = {
            toolbox: $0cf1b19b2f7a01d6$var$u.make("div", an.CSS.toolbox)
        }, this.initPopover(), this.api.events.on($0cf1b19b2f7a01d6$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */ get isEmpty() {
        return this.toolsToBeDisplayed.length === 0;
    }
    /**
   * CSS styles
   */ static get CSS() {
        return {
            toolbox: "ce-toolbox"
        };
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.toolbox;
    }
    /**
   * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
   */ hasFocus() {
        if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
    }
    /**
   * Destroy Module
   */ destroy() {
        var e;
        super.destroy(), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off($0cf1b19b2f7a01d6$var$G.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off($0cf1b19b2f7a01d6$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Toolbox Tool's button click handler
   *
   * @param toolName - tool type to be activated
   * @param blockDataOverrides - Block data predefined by the activated Toolbox item
   */ toolButtonActivated(e, t1) {
        this.insertNewBlock(e, t1);
    }
    /**
   * Open Toolbox with Tools
   */ open() {
        var e;
        this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"));
    }
    /**
   * Close Toolbox
   */ close() {
        var e;
        (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed");
    }
    /**
   * Close Toolbox
   */ toggle() {
        this.opened ? this.close() : this.open();
    }
    /**
   * Creates toolbox popover and appends it inside wrapper element
   */ initPopover() {
        var t1;
        const e = $0cf1b19b2f7a01d6$var$be() ? $0cf1b19b2f7a01d6$var$nn : $0cf1b19b2f7a01d6$var$Bt;
        this.popover = new e({
            scopeElement: this.api.ui.nodes.redactor,
            searchable: !0,
            messages: {
                nothingFound: this.i18nLabels.nothingFound,
                search: this.i18nLabels.filter
            },
            items: this.toolboxItemsToBeDisplayed
        }), this.popover.on($0cf1b19b2f7a01d6$var$G.Closed, this.onPopoverClose), (t1 = this.nodes.toolbox) == null || t1.append(this.popover.getElement());
    }
    /**
   * Destroys popover instance and removes it from DOM
   */ destroyPopover() {
        this.popover !== null && (this.popover.hide(), this.popover.off($0cf1b19b2f7a01d6$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
    }
    get toolsToBeDisplayed() {
        const e = [];
        return this.tools.forEach((t1)=>{
            t1.toolbox && e.push(t1);
        }), e;
    }
    get toolboxItemsToBeDisplayed() {
        const e = (t1, o, i = !0)=>({
                icon: t1.icon,
                title: $0cf1b19b2f7a01d6$var$z.t($0cf1b19b2f7a01d6$var$K.toolNames, t1.title || $0cf1b19b2f7a01d6$var$je(o.name)),
                name: o.name,
                onActivate: ()=>{
                    this.toolButtonActivated(o.name, t1.data);
                },
                secondaryLabel: o.shortcut && i ? $0cf1b19b2f7a01d6$var$vt(o.shortcut) : ""
            });
        return this.toolsToBeDisplayed.reduce((t1, o)=>(Array.isArray(o.toolbox) ? o.toolbox.forEach((i, s)=>{
                t1.push(e(i, o, s === 0));
            }) : o.toolbox !== void 0 && t1.push(e(o.toolbox, o)), t1), []);
    }
    /**
   * Iterate all tools and enable theirs shortcuts if specified
   */ enableShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && this.enableShortcutForTool(e.name, t1);
        });
    }
    /**
   * Enable shortcut Block Tool implemented shortcut
   *
   * @param {string} toolName - Tool name
   * @param {string} shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcutForTool(e, t1) {
        $0cf1b19b2f7a01d6$var$ge.add({
            name: t1,
            on: this.api.ui.nodes.redactor,
            handler: async (o)=>{
                o.preventDefault();
                const i = this.api.blocks.getCurrentBlockIndex(), s = this.api.blocks.getBlockByIndex(i);
                if (s) try {
                    const r = await this.api.blocks.convert(s.id, e);
                    this.api.caret.setToBlock(r, "end");
                    return;
                } catch  {}
                this.insertNewBlock(e);
            }
        });
    }
    /**
   * Removes all added shortcuts
   * Fired when the Read-Only mode is activated
   */ removeAllShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && $0cf1b19b2f7a01d6$var$ge.remove(this.api.ui.nodes.redactor, t1);
        });
    }
    /**
   * Inserts new block
   * Can be called when button clicked on Toolbox or by ShortcutData
   *
   * @param {string} toolName - Tool name
   * @param blockDataOverrides - predefined Block data
   */ async insertNewBlock(e, t1) {
        const o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);
        if (!i) return;
        const s = i.isEmpty ? o : o + 1;
        let r;
        if (t1) {
            const l = await this.api.blocks.composeBlockData(e);
            r = Object.assign(l, t1);
        }
        const a = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
        a.call($0cf1b19b2f7a01d6$var$ee.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
            block: a
        }), this.api.toolbar.close();
    }
};
$0cf1b19b2f7a01d6$var$rn([
    $0cf1b19b2f7a01d6$var$me
], $0cf1b19b2f7a01d6$var$Ct.prototype, "toolsToBeDisplayed", 1);
$0cf1b19b2f7a01d6$var$rn([
    $0cf1b19b2f7a01d6$var$me
], $0cf1b19b2f7a01d6$var$Ct.prototype, "toolboxItemsToBeDisplayed", 1);
let $0cf1b19b2f7a01d6$var$Es = $0cf1b19b2f7a01d6$var$Ct;
const $0cf1b19b2f7a01d6$var$ln = "block hovered";
async function $0cf1b19b2f7a01d6$var$xs(n, e) {
    const t1 = navigator.keyboard;
    if (!t1) return e;
    try {
        return (await t1.getLayoutMap()).get(n) || e;
    } catch (o) {
        return console.error(o), e;
    }
}
class $0cf1b19b2f7a01d6$var$Bs extends $0cf1b19b2f7a01d6$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.toolboxInstance = null;
    }
    /**
   * CSS styles
   *
   * @returns {object}
   */ get CSS() {
        return {
            toolbar: "ce-toolbar",
            content: "ce-toolbar__content",
            actions: "ce-toolbar__actions",
            actionsOpened: "ce-toolbar__actions--opened",
            toolbarOpened: "ce-toolbar--opened",
            openedToolboxHolderModifier: "codex-editor--toolbox-opened",
            plusButton: "ce-toolbar__plus",
            plusButtonShortcut: "ce-toolbar__plus-shortcut",
            settingsToggler: "ce-toolbar__settings-btn",
            settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
        };
    }
    /**
   * Returns the Toolbar opening state
   *
   * @returns {boolean}
   */ get opened() {
        return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
    }
    /**
   * Public interface for accessing the Toolbox
   */ get toolbox() {
        var e;
        return {
            opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
            close: ()=>{
                var t1;
                (t1 = this.toolboxInstance) == null || t1.close();
            },
            open: ()=>{
                if (this.toolboxInstance === null) {
                    $0cf1b19b2f7a01d6$var$S("toolbox.open() called before initialization is finished", "warn");
                    return;
                }
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.toolboxInstance.open();
            },
            toggle: ()=>{
                if (this.toolboxInstance === null) {
                    $0cf1b19b2f7a01d6$var$S("toolbox.toggle() called before initialization is finished", "warn");
                    return;
                }
                this.toolboxInstance.toggle();
            },
            hasFocus: ()=>{
                var t1;
                return (t1 = this.toolboxInstance) == null ? void 0 : t1.hasFocus();
            }
        };
    }
    /**
   * Block actions appearance manipulations
   */ get blockActions() {
        return {
            hide: ()=>{
                this.nodes.actions.classList.remove(this.CSS.actionsOpened);
            },
            show: ()=>{
                this.nodes.actions.classList.add(this.CSS.actionsOpened);
            }
        };
    }
    /**
   * Methods for working with Block Tunes toggler
   */ get blockTunesToggler() {
        return {
            hide: ()=>this.nodes.settingsToggler.classList.add(this.CSS.settingsTogglerHidden),
            show: ()=>this.nodes.settingsToggler.classList.remove(this.CSS.settingsTogglerHidden)
        };
    }
    /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ toggleReadOnly(e) {
        e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(()=>{
            this.drawUI(), this.enableModuleBindings();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Move Toolbar to the passed (or current) Block
   *
   * @param block - block to move Toolbar near it
   */ moveAndOpen(e = this.Editor.BlockManager.currentBlock) {
        if (this.toolboxInstance === null) {
            $0cf1b19b2f7a01d6$var$S("Can't open Toolbar since Editor initialization is not finished yet", "warn");
            return;
        }
        if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
        this.hoveredBlock = e;
        const t1 = e.holder, { isMobile: o } = this.Editor.UI;
        let i;
        const s = 20, r = e.firstInput, a = t1.getBoundingClientRect(), l = r !== void 0 ? r.getBoundingClientRect() : null, c = l !== null ? l.top - a.top : null, d = c !== null ? c > s : void 0;
        if (o) i = t1.offsetTop + t1.offsetHeight;
        else if (r === void 0 || d) {
            const h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
            i = t1.offsetTop + h;
        } else {
            const h = $0cf1b19b2f7a01d6$var$li(r), p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10), g = 8;
            i = t1.offsetTop + h - p + g + c;
        }
        this.nodes.wrapper.style.top = `${Math.floor(i)}px`, this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
    }
    /**
   * Close the Toolbar
   */ close() {
        var e, t1;
        this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t1 = this.toolboxInstance) == null || t1.close(), this.Editor.BlockSettings.close(), this.reset());
    }
    /**
   * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
   */ reset() {
        this.nodes.wrapper.style.top = "unset";
    }
    /**
   * Open Toolbar with Plus Button and Actions
   *
   * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
   *                                     This flag allows to open Toolbar without Actions.
   */ open(e = !0) {
        this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
    }
    /**
   * Draws Toolbar elements
   */ async make() {
        this.nodes.wrapper = $0cf1b19b2f7a01d6$var$u.make("div", this.CSS.toolbar), [
            "content",
            "actions"
        ].forEach((s)=>{
            this.nodes[s] = $0cf1b19b2f7a01d6$var$u.make("div", this.CSS[s]);
        }), $0cf1b19b2f7a01d6$var$u.append(this.nodes.wrapper, this.nodes.content), $0cf1b19b2f7a01d6$var$u.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = $0cf1b19b2f7a01d6$var$u.make("div", this.CSS.plusButton, {
            innerHTML: $0cf1b19b2f7a01d6$var$ts
        }), $0cf1b19b2f7a01d6$var$u.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", ()=>{
            $0cf1b19b2f7a01d6$var$$e(!0), this.plusButtonClicked();
        }, !1);
        const e = $0cf1b19b2f7a01d6$var$u.make("div");
        e.appendChild(document.createTextNode($0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.toolbar.toolbox, "Add"))), e.appendChild($0cf1b19b2f7a01d6$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: "/"
        })), $0cf1b19b2f7a01d6$var$ze(this.nodes.plusButton, e, {
            hidingDelay: 400
        }), this.nodes.settingsToggler = $0cf1b19b2f7a01d6$var$u.make("span", this.CSS.settingsToggler, {
            innerHTML: $0cf1b19b2f7a01d6$var$es
        }), $0cf1b19b2f7a01d6$var$u.append(this.nodes.actions, this.nodes.settingsToggler);
        const t1 = $0cf1b19b2f7a01d6$var$u.make("div"), o = $0cf1b19b2f7a01d6$var$u.text($0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.blockTunes.toggler, "Click to tune")), i = await $0cf1b19b2f7a01d6$var$xs("Slash", "/");
        t1.appendChild(o), t1.appendChild($0cf1b19b2f7a01d6$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: $0cf1b19b2f7a01d6$var$vt(`CMD + ${i}`)
        })), $0cf1b19b2f7a01d6$var$ze(this.nodes.settingsToggler, t1, {
            hidingDelay: 400
        }), $0cf1b19b2f7a01d6$var$u.append(this.nodes.actions, this.makeToolbox()), $0cf1b19b2f7a01d6$var$u.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), $0cf1b19b2f7a01d6$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Creates the Toolbox instance and return it's rendered element
   */ makeToolbox() {
        return this.toolboxInstance = new $0cf1b19b2f7a01d6$var$Es({
            api: this.Editor.API.methods,
            tools: this.Editor.Tools.blockTools,
            i18nLabels: {
                filter: $0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.popover, "Filter"),
                nothingFound: $0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.popover, "Nothing found")
            }
        }), this.toolboxInstance.on($0cf1b19b2f7a01d6$var$Le.Opened, ()=>{
            this.Editor.UI.nodes.wrapper.classList.add(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($0cf1b19b2f7a01d6$var$Le.Closed, ()=>{
            this.Editor.UI.nodes.wrapper.classList.remove(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($0cf1b19b2f7a01d6$var$Le.BlockAdded, ({ block: e })=>{
            const { BlockManager: t1, Caret: o } = this.Editor, i = t1.getBlockById(e.id);
            i.inputs.length === 0 && (i === t1.lastBlock ? (t1.insertAtEnd(), o.setToBlock(t1.lastBlock)) : o.setToBlock(t1.nextBlock));
        }), this.toolboxInstance.getElement();
    }
    /**
   * Handler for Plus Button
   */ plusButtonClicked() {
        var e;
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
    }
    /**
   * Enable bindings
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", (e)=>{
            var t1;
            e.stopPropagation(), this.settingsTogglerClicked(), (t1 = this.toolboxInstance) != null && t1.opened && this.toolboxInstance.close(), $0cf1b19b2f7a01d6$var$$e(!0);
        }, !0), $0cf1b19b2f7a01d6$var$be() || this.eventsDispatcher.on($0cf1b19b2f7a01d6$var$ln, (e)=>{
            var t1;
            this.Editor.BlockSettings.opened || (t1 = this.toolboxInstance) != null && t1.opened || this.moveAndOpen(e.block);
        });
    }
    /**
   * Disable bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Clicks on the Block Settings toggler
   */ settingsTogglerClicked() {
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
    }
    /**
   * Draws Toolbar UI
   *
   * Toolbar contains BlockSettings and Toolbox.
   * That's why at first we draw its components and then Toolbar itself
   *
   * Steps:
   *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
   *  - Make itself and append dependent nodes to itself
   *
   */ drawUI() {
        this.Editor.BlockSettings.make(), this.make();
    }
    /**
   * Removes all created and saved HTMLElements
   * It is used in Read-Only mode
   */ destroy() {
        this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
    }
}
var $0cf1b19b2f7a01d6$var$ae = /* @__PURE__ */ ((n)=>(n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n))($0cf1b19b2f7a01d6$var$ae || {}), $0cf1b19b2f7a01d6$var$Pe = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n))($0cf1b19b2f7a01d6$var$Pe || {}), $0cf1b19b2f7a01d6$var$cn = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n))($0cf1b19b2f7a01d6$var$cn || {}), $0cf1b19b2f7a01d6$var$pe = /* @__PURE__ */ ((n)=>(n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n))($0cf1b19b2f7a01d6$var$pe || {}), $0cf1b19b2f7a01d6$var$We = /* @__PURE__ */ ((n)=>(n.IsInline = "isInline", n.Title = "title", n.IsReadOnlySupported = "isReadOnlySupported", n))($0cf1b19b2f7a01d6$var$We || {}), $0cf1b19b2f7a01d6$var$mt = /* @__PURE__ */ ((n)=>(n.IsTune = "isTune", n))($0cf1b19b2f7a01d6$var$mt || {});
class $0cf1b19b2f7a01d6$var$Tt {
    /**
   * @class
   * @param {ConstructorOptions} options - Constructor options
   */ constructor({ name: e, constructable: t1, config: o, api: i, isDefault: s, isInternal: r = !1, defaultPlaceholder: a }){
        this.api = i, this.name = e, this.constructable = t1, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = a;
    }
    /**
   * Returns Tool user configuration
   */ get settings() {
        const e = this.config.config || {};
        return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
    }
    /**
   * Calls Tool's reset method
   */ reset() {
        if ($0cf1b19b2f7a01d6$var$A(this.constructable.reset)) return this.constructable.reset();
    }
    /**
   * Calls Tool's prepare method
   */ prepare() {
        if ($0cf1b19b2f7a01d6$var$A(this.constructable.prepare)) return this.constructable.prepare({
            toolName: this.name,
            config: this.settings
        });
    }
    /**
   * Returns shortcut for Tool (internal or specified by user)
   */ get shortcut() {
        const e = this.constructable.shortcut;
        return this.config.shortcut || e;
    }
    /**
   * Returns Tool's sanitizer configuration
   */ get sanitizeConfig() {
        return this.constructable.sanitize || {};
    }
    /**
   * Returns true if Tools is inline
   */ isInline() {
        return this.type === $0cf1b19b2f7a01d6$var$ae.Inline;
    }
    /**
   * Returns true if Tools is block
   */ isBlock() {
        return this.type === $0cf1b19b2f7a01d6$var$ae.Block;
    }
    /**
   * Returns true if Tools is tune
   */ isTune() {
        return this.type === $0cf1b19b2f7a01d6$var$ae.Tune;
    }
}
class $0cf1b19b2f7a01d6$var$Cs extends $0cf1b19b2f7a01d6$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.CSS = {
            inlineToolbar: "ce-inline-toolbar"
        }, this.opened = !1, this.popover = null, this.toolbarVerticalMargin = $0cf1b19b2f7a01d6$var$be() ? 20 : 6, this.tools = /* @__PURE__ */ new Map(), window.requestIdleCallback(()=>{
            this.make();
        }, {
            timeout: 2e3
        });
    }
    /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */ async tryToShow(e = !1) {
        e && this.close(), this.allowedToShow() && (await this.open(), this.Editor.Toolbar.close());
    }
    /**
   * Hides Inline Toolbar
   */ close() {
        var e, t1;
        if (this.opened) {
            for (const [o, i] of this.tools){
                const s = this.getToolShortcut(o.name);
                s !== void 0 && $0cf1b19b2f7a01d6$var$ge.remove(this.Editor.UI.nodes.redactor, s), $0cf1b19b2f7a01d6$var$A(i.clear) && i.clear();
            }
            this.tools = /* @__PURE__ */ new Map(), this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t1 = this.popover) == null || t1.destroy(), this.popover = null;
        }
    }
    /**
   * Check if node is contained by Inline Toolbar
   *
   * @param {Node} node — node to check
   */ containsNode(e) {
        return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
    }
    /**
   * Removes UI and its components
   */ destroy() {
        var e;
        this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
    }
    /**
   * Making DOM
   */ make() {
        this.nodes.wrapper = $0cf1b19b2f7a01d6$var$u.make("div", [
            this.CSS.inlineToolbar,
            ...this.isRtl ? [
                this.Editor.UI.CSS.editorRtlFix
            ] : []
        ]), $0cf1b19b2f7a01d6$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Shows Inline Toolbar
   */ async open() {
        var t1;
        if (this.opened) return;
        this.opened = !0, this.popover !== null && this.popover.destroy(), this.createToolsInstances();
        const e = await this.getPopoverItems();
        this.popover = new $0cf1b19b2f7a01d6$var$hs({
            items: e,
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.popover, "Nothing found"),
                search: $0cf1b19b2f7a01d6$var$z.ui($0cf1b19b2f7a01d6$var$K.ui.popover, "Filter")
            }
        }), this.move(this.popover.size.width), (t1 = this.nodes.wrapper) == null || t1.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Move Toolbar to the selected text
   *
   * @param popoverWidth - width of the toolbar popover
   */ move(e) {
        const t1 = $0cf1b19b2f7a01d6$var$b.rect, o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(), i = {
            x: t1.x - o.x,
            y: t1.y + t1.height - // + window.scrollY
            o.top + this.toolbarVerticalMargin
        };
        i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
    }
    /**
   * Clear orientation classes and reset position
   */ reset() {
        this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
    }
    /**
   * Need to show Inline Toolbar or not
   */ allowedToShow() {
        const e = [
            "IMG",
            "INPUT"
        ], t1 = $0cf1b19b2f7a01d6$var$b.get(), o = $0cf1b19b2f7a01d6$var$b.text;
        if (!t1 || !t1.anchorNode || t1.isCollapsed || o.length < 1) return !1;
        const i = $0cf1b19b2f7a01d6$var$u.isElement(t1.anchorNode) ? t1.anchorNode : t1.anchorNode.parentElement;
        if (i === null || t1 !== null && e.includes(i.tagName)) return !1;
        const s = this.Editor.BlockManager.getBlock(t1.anchorNode);
        return !s || this.getTools().some((c)=>s.tool.inlineTools.has(c.name)) === !1 ? !1 : i.closest("[contenteditable]") !== null;
    }
    /**
   *  Working with Tools
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Returns tools that are available for current block
   *
   * Used to check if Inline Toolbar could be shown
   * and to render tools in the Inline Toolbar
   */ getTools() {
        const e = this.Editor.BlockManager.currentBlock;
        return e ? Array.from(e.tool.inlineTools.values()).filter((o)=>!(this.Editor.ReadOnly.isEnabled && o.isReadOnlySupported !== !0)) : [];
    }
    /**
   * Constructs tools instances and saves them to this.tools
   */ createToolsInstances() {
        this.tools = /* @__PURE__ */ new Map(), this.getTools().forEach((t1)=>{
            const o = t1.create();
            this.tools.set(t1, o);
        });
    }
    /**
   * Returns Popover Items for tools segregated by their appearance type: regular items and custom html elements.
   */ async getPopoverItems() {
        const e = [];
        let t1 = 0;
        for (const [o, i] of this.tools){
            const s = await i.render(), r = this.getToolShortcut(o.name);
            if (r !== void 0) try {
                this.enableShortcuts(o.name, r);
            } catch  {}
            const a = r !== void 0 ? $0cf1b19b2f7a01d6$var$vt(r) : void 0, l = $0cf1b19b2f7a01d6$var$z.t($0cf1b19b2f7a01d6$var$K.toolNames, o.title || $0cf1b19b2f7a01d6$var$je(o.name));
            [
                s
            ].flat().forEach((c)=>{
                var h, p;
                const d = {
                    name: o.name,
                    onActivate: ()=>{
                        this.toolClicked(i);
                    },
                    hint: {
                        title: l,
                        description: a
                    }
                };
                if ($0cf1b19b2f7a01d6$var$u.isElement(c)) {
                    const g = {
                        ...d,
                        element: c,
                        type: $0cf1b19b2f7a01d6$var$_.Html
                    };
                    if ($0cf1b19b2f7a01d6$var$A(i.renderActions)) {
                        const f = i.renderActions();
                        g.children = {
                            isOpen: (h = i.checkState) == null ? void 0 : h.call(i, $0cf1b19b2f7a01d6$var$b.get()),
                            /** Disable keyboard navigation in actions, as it might conflict with enter press handling */ isFlippable: !1,
                            items: [
                                {
                                    type: $0cf1b19b2f7a01d6$var$_.Html,
                                    element: f
                                }
                            ]
                        };
                    } else (p = i.checkState) == null || p.call(i, $0cf1b19b2f7a01d6$var$b.get());
                    e.push(g);
                } else if (c.type === $0cf1b19b2f7a01d6$var$_.Html) e.push({
                    ...d,
                    ...c,
                    type: $0cf1b19b2f7a01d6$var$_.Html
                });
                else if (c.type === $0cf1b19b2f7a01d6$var$_.Separator) e.push({
                    type: $0cf1b19b2f7a01d6$var$_.Separator
                });
                else {
                    const g = {
                        ...d,
                        ...c,
                        type: $0cf1b19b2f7a01d6$var$_.Default
                    };
                    "children" in g && t1 !== 0 && e.push({
                        type: $0cf1b19b2f7a01d6$var$_.Separator
                    }), e.push(g), "children" in g && t1 < this.tools.size - 1 && e.push({
                        type: $0cf1b19b2f7a01d6$var$_.Separator
                    });
                }
            }), t1++;
        }
        return e;
    }
    /**
   * Get shortcut name for tool
   *
   * @param toolName — Tool name
   */ getToolShortcut(e) {
        const { Tools: t1 } = this.Editor, o = t1.inlineTools.get(e), i = t1.internal.inlineTools;
        return Array.from(i.keys()).includes(e) ? this.inlineTools[e][$0cf1b19b2f7a01d6$var$cn.Shortcut] : o == null ? void 0 : o.shortcut;
    }
    /**
   * Enable Tool shortcut with Editor Shortcuts Module
   *
   * @param toolName - tool name
   * @param shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcuts(e, t1) {
        $0cf1b19b2f7a01d6$var$ge.add({
            name: t1,
            handler: (o)=>{
                var s;
                const { currentBlock: i } = this.Editor.BlockManager;
                i && i.tool.enabledInlineTools && (o.preventDefault(), (s = this.popover) == null || s.activateItemByName(e));
            },
            /**
       * We need to bind shortcut to the document to make it work in read-only mode
       */ on: document
        });
    }
    /**
   * Inline Tool button clicks
   *
   * @param tool - Tool's instance
   */ toolClicked(e) {
        var o;
        const t1 = $0cf1b19b2f7a01d6$var$b.range;
        (o = e.surround) == null || o.call(e, t1), this.checkToolsState();
    }
    /**
   * Check Tools` state by selection
   */ checkToolsState() {
        var e;
        (e = this.tools) == null || e.forEach((t1)=>{
            var o;
            (o = t1.checkState) == null || o.call(t1, $0cf1b19b2f7a01d6$var$b.get());
        });
    }
    /**
   * Get inline tools tools
   * Tools that has isInline is true
   */ get inlineTools() {
        const e = {};
        return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(([t1, o])=>{
            e[t1] = o.create();
        }), e;
    }
}
function $0cf1b19b2f7a01d6$var$dn() {
    const n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    let e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], t1 = e.textContent.length)), [
        e,
        t1
    ]);
}
function $0cf1b19b2f7a01d6$var$un(n, e, t1, o) {
    const i = document.createRange();
    o === "left" ? (i.setStart(n, 0), i.setEnd(e, t1)) : (i.setStart(e, t1), i.setEnd(n, n.childNodes.length));
    const s = i.cloneContents(), r = document.createElement("div");
    r.appendChild(s);
    const a = r.textContent || "";
    return $0cf1b19b2f7a01d6$var$ai(a);
}
function $0cf1b19b2f7a01d6$var$Ne(n) {
    const e = $0cf1b19b2f7a01d6$var$u.getDeepestNode(n);
    if (e === null || $0cf1b19b2f7a01d6$var$u.isEmpty(n)) return !0;
    if ($0cf1b19b2f7a01d6$var$u.isNativeInput(e)) return e.selectionEnd === 0;
    if ($0cf1b19b2f7a01d6$var$u.isEmpty(n)) return !0;
    const [t1, o] = $0cf1b19b2f7a01d6$var$dn();
    return t1 === null ? !1 : $0cf1b19b2f7a01d6$var$un(n, t1, o, "left");
}
function $0cf1b19b2f7a01d6$var$Re(n) {
    const e = $0cf1b19b2f7a01d6$var$u.getDeepestNode(n, !0);
    if (e === null) return !0;
    if ($0cf1b19b2f7a01d6$var$u.isNativeInput(e)) return e.selectionEnd === e.value.length;
    const [t1, o] = $0cf1b19b2f7a01d6$var$dn();
    return t1 === null ? !1 : $0cf1b19b2f7a01d6$var$un(n, t1, o, "right");
}
var $0cf1b19b2f7a01d6$var$hn = {}, $0cf1b19b2f7a01d6$var$St = {}, $0cf1b19b2f7a01d6$var$Xe = {}, $0cf1b19b2f7a01d6$var$de = {}, $0cf1b19b2f7a01d6$var$It = {}, $0cf1b19b2f7a01d6$var$Ot = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Ot, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Ot.allInputsSelector = $0cf1b19b2f7a01d6$var$Ts;
function $0cf1b19b2f7a01d6$var$Ts() {
    var n = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + n.map(function(e) {
        return 'input[type="'.concat(e, '"]');
    }).join(", ");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.allInputsSelector = void 0;
    var e = $0cf1b19b2f7a01d6$var$Ot;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
})($0cf1b19b2f7a01d6$var$It);
var $0cf1b19b2f7a01d6$var$ue = {}, $0cf1b19b2f7a01d6$var$_t = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$_t, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$_t.isNativeInput = $0cf1b19b2f7a01d6$var$Ss;
function $0cf1b19b2f7a01d6$var$Ss(n) {
    var e = [
        "INPUT",
        "TEXTAREA"
    ];
    return n && n.tagName ? e.includes(n.tagName) : !1;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNativeInput = void 0;
    var e = $0cf1b19b2f7a01d6$var$_t;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return e.isNativeInput;
        }
    });
})($0cf1b19b2f7a01d6$var$ue);
var $0cf1b19b2f7a01d6$var$pn = {}, $0cf1b19b2f7a01d6$var$Mt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Mt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Mt.append = $0cf1b19b2f7a01d6$var$Is;
function $0cf1b19b2f7a01d6$var$Is(n, e) {
    Array.isArray(e) ? e.forEach(function(t1) {
        n.appendChild(t1);
    }) : n.appendChild(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.append = void 0;
    var e = $0cf1b19b2f7a01d6$var$Mt;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return e.append;
        }
    });
})($0cf1b19b2f7a01d6$var$pn);
var $0cf1b19b2f7a01d6$var$At = {}, $0cf1b19b2f7a01d6$var$Lt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Lt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Lt.blockElements = $0cf1b19b2f7a01d6$var$Os;
function $0cf1b19b2f7a01d6$var$Os() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.blockElements = void 0;
    var e = $0cf1b19b2f7a01d6$var$Lt;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return e.blockElements;
        }
    });
})($0cf1b19b2f7a01d6$var$At);
var $0cf1b19b2f7a01d6$var$fn = {}, $0cf1b19b2f7a01d6$var$Pt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Pt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Pt.calculateBaseline = $0cf1b19b2f7a01d6$var$_s;
function $0cf1b19b2f7a01d6$var$_s(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2, c = r + s + i + l + a;
    return c;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.calculateBaseline = void 0;
    var e = $0cf1b19b2f7a01d6$var$Pt;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return e.calculateBaseline;
        }
    });
})($0cf1b19b2f7a01d6$var$fn);
var $0cf1b19b2f7a01d6$var$gn = {}, $0cf1b19b2f7a01d6$var$Nt = {}, $0cf1b19b2f7a01d6$var$Rt = {}, $0cf1b19b2f7a01d6$var$Dt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Dt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Dt.isContentEditable = $0cf1b19b2f7a01d6$var$Ms;
function $0cf1b19b2f7a01d6$var$Ms(n) {
    return n.contentEditable === "true";
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isContentEditable = void 0;
    var e = $0cf1b19b2f7a01d6$var$Dt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return e.isContentEditable;
        }
    });
})($0cf1b19b2f7a01d6$var$Rt);
Object.defineProperty($0cf1b19b2f7a01d6$var$Nt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Nt.canSetCaret = $0cf1b19b2f7a01d6$var$Ps;
var $0cf1b19b2f7a01d6$var$As = $0cf1b19b2f7a01d6$var$ue, $0cf1b19b2f7a01d6$var$Ls = $0cf1b19b2f7a01d6$var$Rt;
function $0cf1b19b2f7a01d6$var$Ps(n) {
    var e = !0;
    if ((0, $0cf1b19b2f7a01d6$var$As.isNativeInput)(n)) switch(n.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            e = !1;
            break;
    }
    else e = (0, $0cf1b19b2f7a01d6$var$Ls.isContentEditable)(n);
    return e;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.canSetCaret = void 0;
    var e = $0cf1b19b2f7a01d6$var$Nt;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return e.canSetCaret;
        }
    });
})($0cf1b19b2f7a01d6$var$gn);
var $0cf1b19b2f7a01d6$var$Ve = {}, $0cf1b19b2f7a01d6$var$Ft = {};
function $0cf1b19b2f7a01d6$var$Ns(n, e, t1) {
    const o = t1.value !== void 0 ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
function $0cf1b19b2f7a01d6$var$mn() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e !== void 0 && (n[e] = !0), n;
}
function $0cf1b19b2f7a01d6$var$jt(n) {
    return n != null && n !== "" && (typeof n != "object" || Object.keys(n).length > 0);
}
function $0cf1b19b2f7a01d6$var$Rs(n) {
    return !$0cf1b19b2f7a01d6$var$jt(n);
}
const $0cf1b19b2f7a01d6$var$Ds = ()=>typeof window < "u" && window.navigator !== null && $0cf1b19b2f7a01d6$var$jt(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $0cf1b19b2f7a01d6$var$Fs(n) {
    const e = $0cf1b19b2f7a01d6$var$mn();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $0cf1b19b2f7a01d6$var$js(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $0cf1b19b2f7a01d6$var$Hs(n) {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.left = "-999px", e.style.bottom = "-999px", e.innerHTML = n, document.body.appendChild(e);
    const t1 = window.getSelection(), o = document.createRange();
    if (o.selectNode(e), t1 === null) throw new Error("Cannot copy text to clipboard");
    t1.removeAllRanges(), t1.addRange(o), document.execCommand("copy"), document.body.removeChild(e);
}
function $0cf1b19b2f7a01d6$var$$s(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = void 0, t1 !== !0 && n.apply(s, i);
        }, a = t1 === !0 && o !== void 0;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $0cf1b19b2f7a01d6$var$oe(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $0cf1b19b2f7a01d6$var$zs(n) {
    return $0cf1b19b2f7a01d6$var$oe(n) === "boolean";
}
function $0cf1b19b2f7a01d6$var$bn(n) {
    return $0cf1b19b2f7a01d6$var$oe(n) === "function" || $0cf1b19b2f7a01d6$var$oe(n) === "asyncfunction";
}
function $0cf1b19b2f7a01d6$var$Us(n) {
    return $0cf1b19b2f7a01d6$var$bn(n) && /^\s*class\s+/.test(n.toString());
}
function $0cf1b19b2f7a01d6$var$Ws(n) {
    return $0cf1b19b2f7a01d6$var$oe(n) === "number";
}
function $0cf1b19b2f7a01d6$var$De(n) {
    return $0cf1b19b2f7a01d6$var$oe(n) === "object";
}
function $0cf1b19b2f7a01d6$var$Ys(n) {
    return Promise.resolve(n) === n;
}
function $0cf1b19b2f7a01d6$var$Ks(n) {
    return $0cf1b19b2f7a01d6$var$oe(n) === "string";
}
function $0cf1b19b2f7a01d6$var$Xs(n) {
    return $0cf1b19b2f7a01d6$var$oe(n) === "undefined";
}
function $0cf1b19b2f7a01d6$var$bt(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($0cf1b19b2f7a01d6$var$De(n) && $0cf1b19b2f7a01d6$var$De(t1)) for(const o in t1)$0cf1b19b2f7a01d6$var$De(t1[o]) ? (n[o] === void 0 && Object.assign(n, {
        [o]: {}
    }), $0cf1b19b2f7a01d6$var$bt(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $0cf1b19b2f7a01d6$var$bt(n, ...e);
}
function $0cf1b19b2f7a01d6$var$Vs(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && console.warn(o);
}
function $0cf1b19b2f7a01d6$var$qs(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $0cf1b19b2f7a01d6$var$Zs(n) {
    return n > 47 && n < 58 || n === 32 || n === 13 || n === 229 || n > 64 && n < 91 || n > 95 && n < 112 || n > 185 && n < 193 || n > 218 && n < 223;
}
const $0cf1b19b2f7a01d6$var$Gs = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $0cf1b19b2f7a01d6$var$Qs = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
let $0cf1b19b2f7a01d6$var$Js = class {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
};
function $0cf1b19b2f7a01d6$var$er(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r === null && (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r === null && (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
const $0cf1b19b2f7a01d6$var$tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $0cf1b19b2f7a01d6$var$Js,
    beautifyShortcut: $0cf1b19b2f7a01d6$var$Fs,
    cacheable: $0cf1b19b2f7a01d6$var$Ns,
    capitalize: $0cf1b19b2f7a01d6$var$js,
    copyTextToClipboard: $0cf1b19b2f7a01d6$var$Hs,
    debounce: $0cf1b19b2f7a01d6$var$$s,
    deepMerge: $0cf1b19b2f7a01d6$var$bt,
    deprecationAssert: $0cf1b19b2f7a01d6$var$Vs,
    getUserOS: $0cf1b19b2f7a01d6$var$mn,
    getValidUrl: $0cf1b19b2f7a01d6$var$qs,
    isBoolean: $0cf1b19b2f7a01d6$var$zs,
    isClass: $0cf1b19b2f7a01d6$var$Us,
    isEmpty: $0cf1b19b2f7a01d6$var$Rs,
    isFunction: $0cf1b19b2f7a01d6$var$bn,
    isIosDevice: $0cf1b19b2f7a01d6$var$Ds,
    isNumber: $0cf1b19b2f7a01d6$var$Ws,
    isObject: $0cf1b19b2f7a01d6$var$De,
    isPrintableKey: $0cf1b19b2f7a01d6$var$Zs,
    isPromise: $0cf1b19b2f7a01d6$var$Ys,
    isString: $0cf1b19b2f7a01d6$var$Ks,
    isUndefined: $0cf1b19b2f7a01d6$var$Xs,
    keyCodes: $0cf1b19b2f7a01d6$var$Gs,
    mouseButtons: $0cf1b19b2f7a01d6$var$Qs,
    notEmpty: $0cf1b19b2f7a01d6$var$jt,
    throttle: $0cf1b19b2f7a01d6$var$er,
    typeOf: $0cf1b19b2f7a01d6$var$oe
}, Symbol.toStringTag, {
    value: "Module"
})), $0cf1b19b2f7a01d6$var$Ht = /* @__PURE__ */ $0cf1b19b2f7a01d6$var$Xn($0cf1b19b2f7a01d6$var$tr);
Object.defineProperty($0cf1b19b2f7a01d6$var$Ft, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Ft.containsOnlyInlineElements = $0cf1b19b2f7a01d6$var$ir;
var $0cf1b19b2f7a01d6$var$or = $0cf1b19b2f7a01d6$var$Ht, $0cf1b19b2f7a01d6$var$nr = $0cf1b19b2f7a01d6$var$At;
function $0cf1b19b2f7a01d6$var$ir(n) {
    var e;
    (0, $0cf1b19b2f7a01d6$var$or.isString)(n) ? (e = document.createElement("div"), e.innerHTML = n) : e = n;
    var t1 = function(o) {
        return !(0, $0cf1b19b2f7a01d6$var$nr.blockElements)().includes(o.tagName.toLowerCase()) && Array.from(o.children).every(t1);
    };
    return Array.from(e.children).every(t1);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.containsOnlyInlineElements = void 0;
    var e = $0cf1b19b2f7a01d6$var$Ft;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return e.containsOnlyInlineElements;
        }
    });
})($0cf1b19b2f7a01d6$var$Ve);
var $0cf1b19b2f7a01d6$var$vn = {}, $0cf1b19b2f7a01d6$var$$t = {}, $0cf1b19b2f7a01d6$var$qe = {}, $0cf1b19b2f7a01d6$var$zt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$zt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$zt.make = $0cf1b19b2f7a01d6$var$sr;
function $0cf1b19b2f7a01d6$var$sr(n, e, t1) {
    var o;
    e === void 0 && (e = null), t1 === void 0 && (t1 = {});
    var i = document.createElement(n);
    if (Array.isArray(e)) {
        var s = e.filter(function(a) {
            return a !== void 0;
        });
        (o = i.classList).add.apply(o, s);
    } else e !== null && i.classList.add(e);
    for(var r in t1)Object.prototype.hasOwnProperty.call(t1, r) && (i[r] = t1[r]);
    return i;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.make = void 0;
    var e = $0cf1b19b2f7a01d6$var$zt;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return e.make;
        }
    });
})($0cf1b19b2f7a01d6$var$qe);
Object.defineProperty($0cf1b19b2f7a01d6$var$$t, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$$t.fragmentToString = $0cf1b19b2f7a01d6$var$ar;
var $0cf1b19b2f7a01d6$var$rr = $0cf1b19b2f7a01d6$var$qe;
function $0cf1b19b2f7a01d6$var$ar(n) {
    var e = (0, $0cf1b19b2f7a01d6$var$rr.make)("div");
    return e.appendChild(n), e.innerHTML;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.fragmentToString = void 0;
    var e = $0cf1b19b2f7a01d6$var$$t;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return e.fragmentToString;
        }
    });
})($0cf1b19b2f7a01d6$var$vn);
var $0cf1b19b2f7a01d6$var$kn = {}, $0cf1b19b2f7a01d6$var$Ut = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Ut, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Ut.getContentLength = $0cf1b19b2f7a01d6$var$cr;
var $0cf1b19b2f7a01d6$var$lr = $0cf1b19b2f7a01d6$var$ue;
function $0cf1b19b2f7a01d6$var$cr(n) {
    var e, t1;
    return (0, $0cf1b19b2f7a01d6$var$lr.isNativeInput)(n) ? n.value.length : n.nodeType === Node.TEXT_NODE ? n.length : (t1 = (e = n.textContent) === null || e === void 0 ? void 0 : e.length) !== null && t1 !== void 0 ? t1 : 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContentLength = void 0;
    var e = $0cf1b19b2f7a01d6$var$Ut;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return e.getContentLength;
        }
    });
})($0cf1b19b2f7a01d6$var$kn);
var $0cf1b19b2f7a01d6$var$Wt = {}, $0cf1b19b2f7a01d6$var$Yt = {}, $0cf1b19b2f7a01d6$var$Io = $0cf1b19b2f7a01d6$var$Ce && $0cf1b19b2f7a01d6$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($0cf1b19b2f7a01d6$var$Yt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Yt.getDeepestBlockElements = $0cf1b19b2f7a01d6$var$yn;
var $0cf1b19b2f7a01d6$var$dr = $0cf1b19b2f7a01d6$var$Ve;
function $0cf1b19b2f7a01d6$var$yn(n) {
    return (0, $0cf1b19b2f7a01d6$var$dr.containsOnlyInlineElements)(n) ? [
        n
    ] : Array.from(n.children).reduce(function(e, t1) {
        return $0cf1b19b2f7a01d6$var$Io($0cf1b19b2f7a01d6$var$Io([], e, !0), $0cf1b19b2f7a01d6$var$yn(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestBlockElements = void 0;
    var e = $0cf1b19b2f7a01d6$var$Yt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return e.getDeepestBlockElements;
        }
    });
})($0cf1b19b2f7a01d6$var$Wt);
var $0cf1b19b2f7a01d6$var$wn = {}, $0cf1b19b2f7a01d6$var$Kt = {}, $0cf1b19b2f7a01d6$var$Ze = {}, $0cf1b19b2f7a01d6$var$Xt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Xt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Xt.isLineBreakTag = $0cf1b19b2f7a01d6$var$ur;
function $0cf1b19b2f7a01d6$var$ur(n) {
    return [
        "BR",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLineBreakTag = void 0;
    var e = $0cf1b19b2f7a01d6$var$Xt;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return e.isLineBreakTag;
        }
    });
})($0cf1b19b2f7a01d6$var$Ze);
var $0cf1b19b2f7a01d6$var$Ge = {}, $0cf1b19b2f7a01d6$var$Vt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Vt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Vt.isSingleTag = $0cf1b19b2f7a01d6$var$hr;
function $0cf1b19b2f7a01d6$var$hr(n) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isSingleTag = void 0;
    var e = $0cf1b19b2f7a01d6$var$Vt;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return e.isSingleTag;
        }
    });
})($0cf1b19b2f7a01d6$var$Ge);
Object.defineProperty($0cf1b19b2f7a01d6$var$Kt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Kt.getDeepestNode = $0cf1b19b2f7a01d6$var$En;
var $0cf1b19b2f7a01d6$var$pr = $0cf1b19b2f7a01d6$var$ue, $0cf1b19b2f7a01d6$var$fr = $0cf1b19b2f7a01d6$var$Ze, $0cf1b19b2f7a01d6$var$gr = $0cf1b19b2f7a01d6$var$Ge;
function $0cf1b19b2f7a01d6$var$En(n, e) {
    e === void 0 && (e = !1);
    var t1 = e ? "lastChild" : "firstChild", o = e ? "previousSibling" : "nextSibling";
    if (n.nodeType === Node.ELEMENT_NODE && n[t1]) {
        var i = n[t1];
        if ((0, $0cf1b19b2f7a01d6$var$gr.isSingleTag)(i) && !(0, $0cf1b19b2f7a01d6$var$pr.isNativeInput)(i) && !(0, $0cf1b19b2f7a01d6$var$fr.isLineBreakTag)(i)) {
            if (i[o]) i = i[o];
            else if (i.parentNode !== null && i.parentNode[o]) i = i.parentNode[o];
            else return i.parentNode;
        }
        return $0cf1b19b2f7a01d6$var$En(i, e);
    }
    return n;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestNode = void 0;
    var e = $0cf1b19b2f7a01d6$var$Kt;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return e.getDeepestNode;
        }
    });
})($0cf1b19b2f7a01d6$var$wn);
var $0cf1b19b2f7a01d6$var$xn = {}, $0cf1b19b2f7a01d6$var$qt = {}, $0cf1b19b2f7a01d6$var$Me = $0cf1b19b2f7a01d6$var$Ce && $0cf1b19b2f7a01d6$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($0cf1b19b2f7a01d6$var$qt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$qt.findAllInputs = $0cf1b19b2f7a01d6$var$yr;
var $0cf1b19b2f7a01d6$var$mr = $0cf1b19b2f7a01d6$var$Ve, $0cf1b19b2f7a01d6$var$br = $0cf1b19b2f7a01d6$var$Wt, $0cf1b19b2f7a01d6$var$vr = $0cf1b19b2f7a01d6$var$It, $0cf1b19b2f7a01d6$var$kr = $0cf1b19b2f7a01d6$var$ue;
function $0cf1b19b2f7a01d6$var$yr(n) {
    return Array.from(n.querySelectorAll((0, $0cf1b19b2f7a01d6$var$vr.allInputsSelector)())).reduce(function(e, t1) {
        return (0, $0cf1b19b2f7a01d6$var$kr.isNativeInput)(t1) || (0, $0cf1b19b2f7a01d6$var$mr.containsOnlyInlineElements)(t1) ? $0cf1b19b2f7a01d6$var$Me($0cf1b19b2f7a01d6$var$Me([], e, !0), [
            t1
        ], !1) : $0cf1b19b2f7a01d6$var$Me($0cf1b19b2f7a01d6$var$Me([], e, !0), (0, $0cf1b19b2f7a01d6$var$br.getDeepestBlockElements)(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.findAllInputs = void 0;
    var e = $0cf1b19b2f7a01d6$var$qt;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return e.findAllInputs;
        }
    });
})($0cf1b19b2f7a01d6$var$xn);
var $0cf1b19b2f7a01d6$var$Bn = {}, $0cf1b19b2f7a01d6$var$Zt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Zt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Zt.isCollapsedWhitespaces = $0cf1b19b2f7a01d6$var$wr;
function $0cf1b19b2f7a01d6$var$wr(n) {
    return !/[^\t\n\r ]/.test(n);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCollapsedWhitespaces = void 0;
    var e = $0cf1b19b2f7a01d6$var$Zt;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return e.isCollapsedWhitespaces;
        }
    });
})($0cf1b19b2f7a01d6$var$Bn);
var $0cf1b19b2f7a01d6$var$Gt = {}, $0cf1b19b2f7a01d6$var$Qt = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Qt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Qt.isElement = $0cf1b19b2f7a01d6$var$xr;
var $0cf1b19b2f7a01d6$var$Er = $0cf1b19b2f7a01d6$var$Ht;
function $0cf1b19b2f7a01d6$var$xr(n) {
    return (0, $0cf1b19b2f7a01d6$var$Er.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.ELEMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isElement = void 0;
    var e = $0cf1b19b2f7a01d6$var$Qt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return e.isElement;
        }
    });
})($0cf1b19b2f7a01d6$var$Gt);
var $0cf1b19b2f7a01d6$var$Cn = {}, $0cf1b19b2f7a01d6$var$Jt = {}, $0cf1b19b2f7a01d6$var$eo = {}, $0cf1b19b2f7a01d6$var$to = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$to, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$to.isLeaf = $0cf1b19b2f7a01d6$var$Br;
function $0cf1b19b2f7a01d6$var$Br(n) {
    return n === null ? !1 : n.childNodes.length === 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLeaf = void 0;
    var e = $0cf1b19b2f7a01d6$var$to;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return e.isLeaf;
        }
    });
})($0cf1b19b2f7a01d6$var$eo);
var $0cf1b19b2f7a01d6$var$oo = {}, $0cf1b19b2f7a01d6$var$no = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$no, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$no.isNodeEmpty = $0cf1b19b2f7a01d6$var$Or;
var $0cf1b19b2f7a01d6$var$Cr = $0cf1b19b2f7a01d6$var$Ze, $0cf1b19b2f7a01d6$var$Tr = $0cf1b19b2f7a01d6$var$Gt, $0cf1b19b2f7a01d6$var$Sr = $0cf1b19b2f7a01d6$var$ue, $0cf1b19b2f7a01d6$var$Ir = $0cf1b19b2f7a01d6$var$Ge;
function $0cf1b19b2f7a01d6$var$Or(n, e) {
    var t1 = "";
    return (0, $0cf1b19b2f7a01d6$var$Ir.isSingleTag)(n) && !(0, $0cf1b19b2f7a01d6$var$Cr.isLineBreakTag)(n) ? !1 : ((0, $0cf1b19b2f7a01d6$var$Tr.isElement)(n) && (0, $0cf1b19b2f7a01d6$var$Sr.isNativeInput)(n) ? t1 = n.value : n.textContent !== null && (t1 = n.textContent.replace("\u200B", "")), e !== void 0 && (t1 = t1.replace(new RegExp(e, "g"), "")), t1.trim().length === 0);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNodeEmpty = void 0;
    var e = $0cf1b19b2f7a01d6$var$no;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return e.isNodeEmpty;
        }
    });
})($0cf1b19b2f7a01d6$var$oo);
Object.defineProperty($0cf1b19b2f7a01d6$var$Jt, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Jt.isEmpty = $0cf1b19b2f7a01d6$var$Ar;
var $0cf1b19b2f7a01d6$var$_r = $0cf1b19b2f7a01d6$var$eo, $0cf1b19b2f7a01d6$var$Mr = $0cf1b19b2f7a01d6$var$oo;
function $0cf1b19b2f7a01d6$var$Ar(n, e) {
    n.normalize();
    for(var t1 = [
        n
    ]; t1.length > 0;){
        var o = t1.shift();
        if (o) {
            if (n = o, (0, $0cf1b19b2f7a01d6$var$_r.isLeaf)(n) && !(0, $0cf1b19b2f7a01d6$var$Mr.isNodeEmpty)(n, e)) return !1;
            t1.push.apply(t1, Array.from(n.childNodes));
        }
    }
    return !0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isEmpty = void 0;
    var e = $0cf1b19b2f7a01d6$var$Jt;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return e.isEmpty;
        }
    });
})($0cf1b19b2f7a01d6$var$Cn);
var $0cf1b19b2f7a01d6$var$Tn = {}, $0cf1b19b2f7a01d6$var$io = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$io, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$io.isFragment = $0cf1b19b2f7a01d6$var$Pr;
var $0cf1b19b2f7a01d6$var$Lr = $0cf1b19b2f7a01d6$var$Ht;
function $0cf1b19b2f7a01d6$var$Pr(n) {
    return (0, $0cf1b19b2f7a01d6$var$Lr.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isFragment = void 0;
    var e = $0cf1b19b2f7a01d6$var$io;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return e.isFragment;
        }
    });
})($0cf1b19b2f7a01d6$var$Tn);
var $0cf1b19b2f7a01d6$var$Sn = {}, $0cf1b19b2f7a01d6$var$so = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$so, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$so.isHTMLString = $0cf1b19b2f7a01d6$var$Rr;
var $0cf1b19b2f7a01d6$var$Nr = $0cf1b19b2f7a01d6$var$qe;
function $0cf1b19b2f7a01d6$var$Rr(n) {
    var e = (0, $0cf1b19b2f7a01d6$var$Nr.make)("div");
    return e.innerHTML = n, e.childElementCount > 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isHTMLString = void 0;
    var e = $0cf1b19b2f7a01d6$var$so;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return e.isHTMLString;
        }
    });
})($0cf1b19b2f7a01d6$var$Sn);
var $0cf1b19b2f7a01d6$var$In = {}, $0cf1b19b2f7a01d6$var$ro = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$ro, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$ro.offset = $0cf1b19b2f7a01d6$var$Dr;
function $0cf1b19b2f7a01d6$var$Dr(n) {
    var e = n.getBoundingClientRect(), t1 = window.pageXOffset || document.documentElement.scrollLeft, o = window.pageYOffset || document.documentElement.scrollTop, i = e.top + o, s = e.left + t1;
    return {
        top: i,
        left: s,
        bottom: i + e.height,
        right: s + e.width
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.offset = void 0;
    var e = $0cf1b19b2f7a01d6$var$ro;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return e.offset;
        }
    });
})($0cf1b19b2f7a01d6$var$In);
var $0cf1b19b2f7a01d6$var$On = {}, $0cf1b19b2f7a01d6$var$ao = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$ao, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$ao.prepend = $0cf1b19b2f7a01d6$var$Fr;
function $0cf1b19b2f7a01d6$var$Fr(n, e) {
    Array.isArray(e) ? (e = e.reverse(), e.forEach(function(t1) {
        return n.prepend(t1);
    })) : n.prepend(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = void 0;
    var e = $0cf1b19b2f7a01d6$var$ao;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return e.prepend;
        }
    });
})($0cf1b19b2f7a01d6$var$On);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = n.offset = n.make = n.isLineBreakTag = n.isSingleTag = n.isNodeEmpty = n.isLeaf = n.isHTMLString = n.isFragment = n.isEmpty = n.isElement = n.isContentEditable = n.isCollapsedWhitespaces = n.findAllInputs = n.isNativeInput = n.allInputsSelector = n.getDeepestNode = n.getDeepestBlockElements = n.getContentLength = n.fragmentToString = n.containsOnlyInlineElements = n.canSetCaret = n.calculateBaseline = n.blockElements = n.append = void 0;
    var e = $0cf1b19b2f7a01d6$var$It;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
    var t1 = $0cf1b19b2f7a01d6$var$ue;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return t1.isNativeInput;
        }
    });
    var o = $0cf1b19b2f7a01d6$var$pn;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return o.append;
        }
    });
    var i = $0cf1b19b2f7a01d6$var$At;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return i.blockElements;
        }
    });
    var s = $0cf1b19b2f7a01d6$var$fn;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return s.calculateBaseline;
        }
    });
    var r = $0cf1b19b2f7a01d6$var$gn;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return r.canSetCaret;
        }
    });
    var a = $0cf1b19b2f7a01d6$var$Ve;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return a.containsOnlyInlineElements;
        }
    });
    var l = $0cf1b19b2f7a01d6$var$vn;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return l.fragmentToString;
        }
    });
    var c = $0cf1b19b2f7a01d6$var$kn;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return c.getContentLength;
        }
    });
    var d = $0cf1b19b2f7a01d6$var$Wt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return d.getDeepestBlockElements;
        }
    });
    var h = $0cf1b19b2f7a01d6$var$wn;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return h.getDeepestNode;
        }
    });
    var p = $0cf1b19b2f7a01d6$var$xn;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return p.findAllInputs;
        }
    });
    var g = $0cf1b19b2f7a01d6$var$Bn;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return g.isCollapsedWhitespaces;
        }
    });
    var f = $0cf1b19b2f7a01d6$var$Rt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return f.isContentEditable;
        }
    });
    var v = $0cf1b19b2f7a01d6$var$Gt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return v.isElement;
        }
    });
    var O = $0cf1b19b2f7a01d6$var$Cn;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return O.isEmpty;
        }
    });
    var T = $0cf1b19b2f7a01d6$var$Tn;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return T.isFragment;
        }
    });
    var M = $0cf1b19b2f7a01d6$var$Sn;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return M.isHTMLString;
        }
    });
    var q = $0cf1b19b2f7a01d6$var$eo;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return q.isLeaf;
        }
    });
    var F = $0cf1b19b2f7a01d6$var$oo;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return F.isNodeEmpty;
        }
    });
    var H = $0cf1b19b2f7a01d6$var$Ze;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return H.isLineBreakTag;
        }
    });
    var Q = $0cf1b19b2f7a01d6$var$Ge;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return Q.isSingleTag;
        }
    });
    var ie = $0cf1b19b2f7a01d6$var$qe;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return ie.make;
        }
    });
    var k = $0cf1b19b2f7a01d6$var$In;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return k.offset;
        }
    });
    var m = $0cf1b19b2f7a01d6$var$On;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return m.prepend;
        }
    });
})($0cf1b19b2f7a01d6$var$de);
var $0cf1b19b2f7a01d6$var$Qe = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Qe, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Qe.getContenteditableSlice = $0cf1b19b2f7a01d6$var$Hr;
var $0cf1b19b2f7a01d6$var$jr = $0cf1b19b2f7a01d6$var$de;
function $0cf1b19b2f7a01d6$var$Hr(n, e, t1, o, i) {
    var s;
    i === void 0 && (i = !1);
    var r = document.createRange();
    if (o === "left" ? (r.setStart(n, 0), r.setEnd(e, t1)) : (r.setStart(e, t1), r.setEnd(n, n.childNodes.length)), i === !0) {
        var a = r.extractContents();
        return (0, $0cf1b19b2f7a01d6$var$jr.fragmentToString)(a);
    }
    var l = r.cloneContents(), c = document.createElement("div");
    c.appendChild(l);
    var d = (s = c.textContent) !== null && s !== void 0 ? s : "";
    return d;
}
Object.defineProperty($0cf1b19b2f7a01d6$var$Xe, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Xe.checkContenteditableSliceForEmptiness = $0cf1b19b2f7a01d6$var$Ur;
var $0cf1b19b2f7a01d6$var$$r = $0cf1b19b2f7a01d6$var$de, $0cf1b19b2f7a01d6$var$zr = $0cf1b19b2f7a01d6$var$Qe;
function $0cf1b19b2f7a01d6$var$Ur(n, e, t1, o) {
    var i = (0, $0cf1b19b2f7a01d6$var$zr.getContenteditableSlice)(n, e, t1, o);
    return (0, $0cf1b19b2f7a01d6$var$$r.isCollapsedWhitespaces)(i);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.checkContenteditableSliceForEmptiness = void 0;
    var e = $0cf1b19b2f7a01d6$var$Xe;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
})($0cf1b19b2f7a01d6$var$St);
var $0cf1b19b2f7a01d6$var$_n = {};
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContenteditableSlice = void 0;
    var e = $0cf1b19b2f7a01d6$var$Qe;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return e.getContenteditableSlice;
        }
    });
})($0cf1b19b2f7a01d6$var$_n);
var $0cf1b19b2f7a01d6$var$Mn = {}, $0cf1b19b2f7a01d6$var$lo = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$lo, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$lo.focus = $0cf1b19b2f7a01d6$var$Yr;
var $0cf1b19b2f7a01d6$var$Wr = $0cf1b19b2f7a01d6$var$de;
function $0cf1b19b2f7a01d6$var$Yr(n, e) {
    var t1, o;
    if (e === void 0 && (e = !0), (0, $0cf1b19b2f7a01d6$var$Wr.isNativeInput)(n)) {
        n.focus();
        var i = e ? 0 : n.value.length;
        n.setSelectionRange(i, i);
    } else {
        var s = document.createRange(), r = window.getSelection();
        if (!r) return;
        var a = function(p) {
            var g = document.createTextNode("");
            p.appendChild(g), s.setStart(g, 0), s.setEnd(g, 0);
        }, l = function(p) {
            return p != null;
        }, c = n.childNodes, d = e ? c[0] : c[c.length - 1];
        if (l(d)) {
            for(; l(d) && d.nodeType !== Node.TEXT_NODE;)d = e ? d.firstChild : d.lastChild;
            if (l(d) && d.nodeType === Node.TEXT_NODE) {
                var h = (o = (t1 = d.textContent) === null || t1 === void 0 ? void 0 : t1.length) !== null && o !== void 0 ? o : 0, i = e ? 0 : h;
                s.setStart(d, i), s.setEnd(d, i);
            } else a(n);
        } else a(n);
        r.removeAllRanges(), r.addRange(s);
    }
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.focus = void 0;
    var e = $0cf1b19b2f7a01d6$var$lo;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return e.focus;
        }
    });
})($0cf1b19b2f7a01d6$var$Mn);
var $0cf1b19b2f7a01d6$var$co = {}, $0cf1b19b2f7a01d6$var$Je = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$Je, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$Je.getCaretNodeAndOffset = $0cf1b19b2f7a01d6$var$Kr;
function $0cf1b19b2f7a01d6$var$Kr() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] !== void 0 ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], e.textContent !== null && (t1 = e.textContent.length))), [
        e,
        t1
    ]);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getCaretNodeAndOffset = void 0;
    var e = $0cf1b19b2f7a01d6$var$Je;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return e.getCaretNodeAndOffset;
        }
    });
})($0cf1b19b2f7a01d6$var$co);
var $0cf1b19b2f7a01d6$var$An = {}, $0cf1b19b2f7a01d6$var$et = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$et, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$et.getRange = $0cf1b19b2f7a01d6$var$Xr;
function $0cf1b19b2f7a01d6$var$Xr() {
    var n = window.getSelection();
    return n && n.rangeCount ? n.getRangeAt(0) : null;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getRange = void 0;
    var e = $0cf1b19b2f7a01d6$var$et;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return e.getRange;
        }
    });
})($0cf1b19b2f7a01d6$var$An);
var $0cf1b19b2f7a01d6$var$Ln = {}, $0cf1b19b2f7a01d6$var$uo = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$uo, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$uo.isCaretAtEndOfInput = $0cf1b19b2f7a01d6$var$Zr;
var $0cf1b19b2f7a01d6$var$Oo = $0cf1b19b2f7a01d6$var$de, $0cf1b19b2f7a01d6$var$Vr = $0cf1b19b2f7a01d6$var$co, $0cf1b19b2f7a01d6$var$qr = $0cf1b19b2f7a01d6$var$St;
function $0cf1b19b2f7a01d6$var$Zr(n) {
    var e = (0, $0cf1b19b2f7a01d6$var$Oo.getDeepestNode)(n, !0);
    if (e === null) return !0;
    if ((0, $0cf1b19b2f7a01d6$var$Oo.isNativeInput)(e)) return e.selectionEnd === e.value.length;
    var t1 = (0, $0cf1b19b2f7a01d6$var$Vr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $0cf1b19b2f7a01d6$var$qr.checkContenteditableSliceForEmptiness)(n, o, i, "right");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtEndOfInput = void 0;
    var e = $0cf1b19b2f7a01d6$var$uo;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtEndOfInput;
        }
    });
})($0cf1b19b2f7a01d6$var$Ln);
var $0cf1b19b2f7a01d6$var$Pn = {}, $0cf1b19b2f7a01d6$var$ho = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$ho, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$ho.isCaretAtStartOfInput = $0cf1b19b2f7a01d6$var$Jr;
var $0cf1b19b2f7a01d6$var$Ae = $0cf1b19b2f7a01d6$var$de, $0cf1b19b2f7a01d6$var$Gr = $0cf1b19b2f7a01d6$var$Je, $0cf1b19b2f7a01d6$var$Qr = $0cf1b19b2f7a01d6$var$Xe;
function $0cf1b19b2f7a01d6$var$Jr(n) {
    var e = (0, $0cf1b19b2f7a01d6$var$Ae.getDeepestNode)(n);
    if (e === null || (0, $0cf1b19b2f7a01d6$var$Ae.isEmpty)(n)) return !0;
    if ((0, $0cf1b19b2f7a01d6$var$Ae.isNativeInput)(e)) return e.selectionEnd === 0;
    if ((0, $0cf1b19b2f7a01d6$var$Ae.isEmpty)(n)) return !0;
    var t1 = (0, $0cf1b19b2f7a01d6$var$Gr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $0cf1b19b2f7a01d6$var$Qr.checkContenteditableSliceForEmptiness)(n, o, i, "left");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtStartOfInput = void 0;
    var e = $0cf1b19b2f7a01d6$var$ho;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtStartOfInput;
        }
    });
})($0cf1b19b2f7a01d6$var$Pn);
var $0cf1b19b2f7a01d6$var$Nn = {}, $0cf1b19b2f7a01d6$var$po = {};
Object.defineProperty($0cf1b19b2f7a01d6$var$po, "__esModule", {
    value: !0
});
$0cf1b19b2f7a01d6$var$po.save = $0cf1b19b2f7a01d6$var$oa;
var $0cf1b19b2f7a01d6$var$ea = $0cf1b19b2f7a01d6$var$de, $0cf1b19b2f7a01d6$var$ta = $0cf1b19b2f7a01d6$var$et;
function $0cf1b19b2f7a01d6$var$oa() {
    var n = (0, $0cf1b19b2f7a01d6$var$ta.getRange)(), e = (0, $0cf1b19b2f7a01d6$var$ea.make)("span");
    if (e.id = "cursor", e.hidden = !0, !!n) return n.insertNode(e), function() {
        var o = window.getSelection();
        o && (n.setStartAfter(e), n.setEndAfter(e), o.removeAllRanges(), o.addRange(n), setTimeout(function() {
            e.remove();
        }, 150));
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = void 0;
    var e = $0cf1b19b2f7a01d6$var$po;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return e.save;
        }
    });
})($0cf1b19b2f7a01d6$var$Nn);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = n.isCaretAtStartOfInput = n.isCaretAtEndOfInput = n.getRange = n.getCaretNodeAndOffset = n.focus = n.getContenteditableSlice = n.checkContenteditableSliceForEmptiness = void 0;
    var e = $0cf1b19b2f7a01d6$var$St;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
    var t1 = $0cf1b19b2f7a01d6$var$_n;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return t1.getContenteditableSlice;
        }
    });
    var o = $0cf1b19b2f7a01d6$var$Mn;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return o.focus;
        }
    });
    var i = $0cf1b19b2f7a01d6$var$co;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return i.getCaretNodeAndOffset;
        }
    });
    var s = $0cf1b19b2f7a01d6$var$An;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return s.getRange;
        }
    });
    var r = $0cf1b19b2f7a01d6$var$Ln;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return r.isCaretAtEndOfInput;
        }
    });
    var a = $0cf1b19b2f7a01d6$var$Pn;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return a.isCaretAtStartOfInput;
        }
    });
    var l = $0cf1b19b2f7a01d6$var$Nn;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return l.save;
        }
    });
})($0cf1b19b2f7a01d6$var$hn);
class $0cf1b19b2f7a01d6$var$na extends $0cf1b19b2f7a01d6$var$E {
    /**
   * All keydowns on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ keydown(e) {
        switch(this.beforeKeydownProcessing(e), e.keyCode){
            case $0cf1b19b2f7a01d6$var$y.BACKSPACE:
                this.backspace(e);
                break;
            case $0cf1b19b2f7a01d6$var$y.DELETE:
                this.delete(e);
                break;
            case $0cf1b19b2f7a01d6$var$y.ENTER:
                this.enter(e);
                break;
            case $0cf1b19b2f7a01d6$var$y.DOWN:
            case $0cf1b19b2f7a01d6$var$y.RIGHT:
                this.arrowRightAndDown(e);
                break;
            case $0cf1b19b2f7a01d6$var$y.UP:
            case $0cf1b19b2f7a01d6$var$y.LEFT:
                this.arrowLeftAndUp(e);
                break;
            case $0cf1b19b2f7a01d6$var$y.TAB:
                this.tabPressed(e);
                break;
        }
        e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
    }
    /**
   * Fires on keydown before event processing
   *
   * @param {KeyboardEvent} event - keydown
   */ beforeKeydownProcessing(e) {
        this.needToolbarClosing(e) && $0cf1b19b2f7a01d6$var$Po(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
    }
    /**
   * Key up on Block:
   * - shows Inline Toolbar if something selected
   * - shows conversion toolbar with 85% of block selection
   *
   * @param {KeyboardEvent} event - keyup event
   */ keyup(e) {
        e.shiftKey || this.Editor.UI.checkEmptiness();
    }
    /**
   * Add drop target styles
   *
   * @param {DragEvent} event - drag over event
   */ dragOver(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !0;
    }
    /**
   * Remove drop target style
   *
   * @param {DragEvent} event - drag leave event
   */ dragLeave(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !1;
    }
    /**
   * Copying selected blocks
   * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandC(e) {
        const { BlockSelection: t1 } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e);
    }
    /**
   * Copy and Delete selected Blocks
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandX(e) {
        const { BlockSelection: t1, BlockManager: o, Caret: i } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e).then(()=>{
            const s = o.removeSelectedBlocks(), r = o.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), t1.clearSelection(e);
        });
    }
    /**
   * Tab pressed inside a Block.
   *
   * @param {KeyboardEvent} event - keydown
   */ tabPressed(e) {
        const { InlineToolbar: t1, Caret: o } = this.Editor;
        if (t1.opened) return;
        (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
    }
    /**
   * '/' + 'command' keydown inside a Block
   */ commandSlashPressed() {
        this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
    }
    /**
   * '/' keydown inside a Block
   *
   * @param event - keydown
   */ slashPressed(e) {
        !this.Editor.UI.nodes.wrapper.contains(e.target) || !this.Editor.BlockManager.currentBlock.isEmpty || (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
    }
    /**
   * ENTER pressed on block
   *
   * @param {KeyboardEvent} event - keydown
   */ enter(e) {
        const { BlockManager: t1, UI: o } = this.Editor, i = t1.currentBlock;
        if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !$0cf1b19b2f7a01d6$var$pt) return;
        let s = i;
        i.currentInput !== void 0 && $0cf1b19b2f7a01d6$var$Ne(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && $0cf1b19b2f7a01d6$var$Re(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
    }
    /**
   * Handle backspace keydown on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ backspace(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, previousBlock: s } = t1;
        if (i === void 0 || !$0cf1b19b2f7a01d6$var$b.isCollapsed || !i.currentInput || !$0cf1b19b2f7a01d6$var$Ne(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
            o.navigatePrevious();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i);
            const l = t1.currentBlock;
            o.setToBlock(l, o.positions.END);
            return;
        }
        $0cf1b19b2f7a01d6$var$xo(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
    }
    /**
   * Handles delete keydown on Block
   * Removes char after the caret.
   * If caret is at the end of the block, merge next block with current
   *
   * @param {KeyboardEvent} event - keydown
   */ delete(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, nextBlock: s } = t1;
        if (!$0cf1b19b2f7a01d6$var$b.isCollapsed || !$0cf1b19b2f7a01d6$var$Re(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
            o.navigateNext();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i), o.setToBlock(s, o.positions.START);
            return;
        }
        $0cf1b19b2f7a01d6$var$xo(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
    }
    /**
   * Merge passed Blocks
   *
   * @param targetBlock - to which Block we want to merge
   * @param blockToMerge - what Block we want to merge
   */ mergeBlocks(e, t1) {
        const { BlockManager: o, Toolbar: i } = this.Editor;
        e.lastInput !== void 0 && ($0cf1b19b2f7a01d6$var$hn.focus(e.lastInput, !1), o.mergeBlocks(e, t1).then(()=>{
            i.close();
        }));
    }
    /**
   * Handle right and down keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowRightAndDown(e) {
        const t1 = $0cf1b19b2f7a01d6$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $0cf1b19b2f7a01d6$var$y.TAB);
        if (this.Editor.UI.someToolbarOpened && t1) return;
        this.Editor.Toolbar.close();
        const { currentBlock: o } = this.Editor.BlockManager, s = ((o == null ? void 0 : o.currentInput) !== void 0 ? $0cf1b19b2f7a01d6$var$Re(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $0cf1b19b2f7a01d6$var$y.DOWN && s) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState();
            return;
        }
        if (e.keyCode === $0cf1b19b2f7a01d6$var$y.DOWN || e.keyCode === $0cf1b19b2f7a01d6$var$y.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
            e.preventDefault();
            return;
        }
        $0cf1b19b2f7a01d6$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Handle left and up keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowLeftAndUp(e) {
        if (this.Editor.UI.someToolbarOpened) {
            if ($0cf1b19b2f7a01d6$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $0cf1b19b2f7a01d6$var$y.TAB)) return;
            this.Editor.UI.closeAllToolbars();
        }
        this.Editor.Toolbar.close();
        const { currentBlock: t1 } = this.Editor.BlockManager, i = ((t1 == null ? void 0 : t1.currentInput) !== void 0 ? $0cf1b19b2f7a01d6$var$Ne(t1.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $0cf1b19b2f7a01d6$var$y.UP && i) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
            return;
        }
        if (e.keyCode === $0cf1b19b2f7a01d6$var$y.UP || e.keyCode === $0cf1b19b2f7a01d6$var$y.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
            e.preventDefault();
            return;
        }
        $0cf1b19b2f7a01d6$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Cases when we need to close Toolbar
   *
   * @param {KeyboardEvent} event - keyboard event
   */ needToolbarClosing(e) {
        const t1 = e.keyCode === $0cf1b19b2f7a01d6$var$y.ENTER && this.Editor.Toolbar.toolbox.opened, o = e.keyCode === $0cf1b19b2f7a01d6$var$y.ENTER && this.Editor.BlockSettings.opened, i = e.keyCode === $0cf1b19b2f7a01d6$var$y.ENTER && this.Editor.InlineToolbar.opened, s = e.keyCode === $0cf1b19b2f7a01d6$var$y.TAB;
        return !(e.shiftKey || s || t1 || o || i);
    }
    /**
   * If Toolbox is not open, then just open it and show plus button
   */ activateToolbox() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
    }
    /**
   * Open Toolbar and show BlockSettings before flipping Tools
   */ activateBlockSettings() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
    }
}
class $0cf1b19b2f7a01d6$var$ct {
    /**
   * @class
   * @param {HTMLElement} workingArea — editor`s working node
   */ constructor(e){
        this.blocks = [], this.workingArea = e;
    }
    /**
   * Get length of Block instances array
   *
   * @returns {number}
   */ get length() {
        return this.blocks.length;
    }
    /**
   * Get Block instances array
   *
   * @returns {Block[]}
   */ get array() {
        return this.blocks;
    }
    /**
   * Get blocks html elements array
   *
   * @returns {HTMLElement[]}
   */ get nodes() {
        return $0cf1b19b2f7a01d6$var$No(this.workingArea.children);
    }
    /**
   * Proxy trap to implement array-like setter
   *
   * @example
   * blocks[0] = new Block(...)
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — block index or any Blocks class property key to set
   * @param {Block} value — value to set
   * @returns {boolean}
   */ static set(e, t1, o) {
        return isNaN(Number(t1)) ? (Reflect.set(e, t1, o), !0) : (e.insert(+t1, o), !0);
    }
    /**
   * Proxy trap to implement array-like getter
   *
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — Blocks class property key
   * @returns {Block|*}
   */ static get(e, t1) {
        return isNaN(Number(t1)) ? Reflect.get(e, t1) : e.get(+t1);
    }
    /**
   * Push new Block to the blocks array and append it to working area
   *
   * @param {Block} block - Block to add
   */ push(e) {
        this.blocks.push(e), this.insertToDOM(e);
    }
    /**
   * Swaps blocks with indexes first and second
   *
   * @param {number} first - first block index
   * @param {number} second - second block index
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        const o = this.blocks[t1];
        $0cf1b19b2f7a01d6$var$u.swap(this.blocks[e].holder, o.holder), this.blocks[t1] = this.blocks[e], this.blocks[e] = o;
    }
    /**
   * Move a block from one to another index
   *
   * @param {number} toIndex - new index of the block
   * @param {number} fromIndex - block to move
   */ move(e, t1) {
        const o = this.blocks.splice(t1, 1)[0], i = e - 1, s = Math.max(0, i), r = this.blocks[s];
        e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
        const a = this.composeBlockEvent("move", {
            fromIndex: t1,
            toIndex: e
        });
        o.call($0cf1b19b2f7a01d6$var$ee.MOVED, a);
    }
    /**
   * Insert new Block at passed index
   *
   * @param {number} index — index to insert Block
   * @param {Block} block — Block to insert
   * @param {boolean} replace — it true, replace block on given index
   */ insert(e, t1, o = !1) {
        if (!this.length) {
            this.push(t1);
            return;
        }
        e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call($0cf1b19b2f7a01d6$var$ee.REMOVED));
        const i = o ? 1 : 0;
        if (this.blocks.splice(e, i, t1), e > 0) {
            const s = this.blocks[e - 1];
            this.insertToDOM(t1, "afterend", s);
        } else {
            const s = this.blocks[e + 1];
            s ? this.insertToDOM(t1, "beforebegin", s) : this.insertToDOM(t1);
        }
    }
    /**
   * Replaces block under passed index with passed block
   *
   * @param index - index of existed block
   * @param block - new block
   */ replace(e, t1) {
        if (this.blocks[e] === void 0) throw Error("Incorrect index");
        this.blocks[e].holder.replaceWith(t1.holder), this.blocks[e] = t1;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index to insert blocks at
   */ insertMany(e, t1) {
        const o = new DocumentFragment();
        for (const i of e)o.appendChild(i.holder);
        if (this.length > 0) {
            if (t1 > 0) {
                const i = Math.min(t1 - 1, this.length - 1);
                this.blocks[i].holder.after(o);
            } else t1 === 0 && this.workingArea.prepend(o);
            this.blocks.splice(t1, 0, ...e);
        } else this.blocks.push(...e), this.workingArea.appendChild(o);
        e.forEach((i)=>i.call($0cf1b19b2f7a01d6$var$ee.RENDERED));
    }
    /**
   * Remove block
   *
   * @param {number} index - index of Block to remove
   */ remove(e) {
        isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call($0cf1b19b2f7a01d6$var$ee.REMOVED), this.blocks.splice(e, 1);
    }
    /**
   * Remove all blocks
   */ removeAll() {
        this.workingArea.innerHTML = "", this.blocks.forEach((e)=>e.call($0cf1b19b2f7a01d6$var$ee.REMOVED)), this.blocks.length = 0;
    }
    /**
   * Insert Block after passed target
   *
   * @todo decide if this method is necessary
   * @param {Block} targetBlock — target after which Block should be inserted
   * @param {Block} newBlock — Block to insert
   */ insertAfter(e, t1) {
        const o = this.blocks.indexOf(e);
        this.insert(o + 1, t1);
    }
    /**
   * Get Block by index
   *
   * @param {number} index — Block index
   * @returns {Block}
   */ get(e) {
        return this.blocks[e];
    }
    /**
   * Return index of passed Block
   *
   * @param {Block} block - Block to find
   * @returns {number}
   */ indexOf(e) {
        return this.blocks.indexOf(e);
    }
    /**
   * Insert new Block into DOM
   *
   * @param {Block} block - Block to insert
   * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
   * @param {Block} target — Block related to position
   */ insertToDOM(e, t1, o) {
        t1 ? o.holder.insertAdjacentElement(t1, e.holder) : this.workingArea.appendChild(e.holder), e.call($0cf1b19b2f7a01d6$var$ee.RENDERED);
    }
    /**
   * Composes Block event with passed type and details
   *
   * @param {string} type - event type
   * @param {object} detail - event detail
   */ composeBlockEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
}
const $0cf1b19b2f7a01d6$var$_o = "block-removed", $0cf1b19b2f7a01d6$var$Mo = "block-added", $0cf1b19b2f7a01d6$var$ia = "block-moved", $0cf1b19b2f7a01d6$var$Ao = "block-changed";
class $0cf1b19b2f7a01d6$var$sa {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
}
class $0cf1b19b2f7a01d6$var$ra extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this._currentBlockIndex = -1, this._blocks = null;
    }
    /**
   * Returns current Block index
   *
   * @returns {number}
   */ get currentBlockIndex() {
        return this._currentBlockIndex;
    }
    /**
   * Set current Block index and fire Block lifecycle callbacks
   *
   * @param {number} newIndex - index of Block to set as current
   */ set currentBlockIndex(e) {
        this._currentBlockIndex = e;
    }
    /**
   * returns first Block
   *
   * @returns {Block}
   */ get firstBlock() {
        return this._blocks[0];
    }
    /**
   * returns last Block
   *
   * @returns {Block}
   */ get lastBlock() {
        return this._blocks[this._blocks.length - 1];
    }
    /**
   * Get current Block instance
   *
   * @returns {Block}
   */ get currentBlock() {
        return this._blocks[this.currentBlockIndex];
    }
    /**
   * Set passed Block as a current
   *
   * @param block - block to set as a current
   */ set currentBlock(e) {
        this.currentBlockIndex = this.getBlockIndex(e);
    }
    /**
   * Returns next Block instance
   *
   * @returns {Block|null}
   */ get nextBlock() {
        return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
    }
    /**
   * Return first Block with inputs after current Block
   *
   * @returns {Block | undefined}
   */ get nextContentfulBlock() {
        return this.blocks.slice(this.currentBlockIndex + 1).find((t1)=>!!t1.inputs.length);
    }
    /**
   * Return first Block with inputs before current Block
   *
   * @returns {Block | undefined}
   */ get previousContentfulBlock() {
        return this.blocks.slice(0, this.currentBlockIndex).reverse().find((t1)=>!!t1.inputs.length);
    }
    /**
   * Returns previous Block instance
   *
   * @returns {Block|null}
   */ get previousBlock() {
        return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
    }
    /**
   * Get array of Block instances
   *
   * @returns {Block[]} {@link Blocks#array}
   */ get blocks() {
        return this._blocks.array;
    }
    /**
   * Check if each Block is empty
   *
   * @returns {boolean}
   */ get isEditorEmpty() {
        return this.blocks.every((e)=>e.isEmpty);
    }
    /**
   * Should be called after Editor.UI preparation
   * Define this._blocks property
   */ prepare() {
        const e = new $0cf1b19b2f7a01d6$var$ct(this.Editor.UI.nodes.redactor);
        this._blocks = new Proxy(e, {
            set: $0cf1b19b2f7a01d6$var$ct.set,
            get: $0cf1b19b2f7a01d6$var$ct.get
        }), this.listeners.on(document, "copy", (t1)=>this.Editor.BlockEvents.handleCommandC(t1));
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - Unbind event handlers from created Blocks
   *
   * if readOnly is false:
   *  - Bind event handlers to all existing Blocks
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Creates Block instance by tool name
   *
   * @param {object} options - block creation options
   * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
   * @param {string} [options.id] - unique id for this block
   * @param {BlockToolData} [options.data] - constructor params
   * @returns {Block}
   */ composeBlock({ tool: e, data: t1 = {}, id: o, tunes: i = {} }) {
        const s = this.Editor.ReadOnly.isEnabled, r = this.Editor.Tools.blockTools.get(e), a = new $0cf1b19b2f7a01d6$var$R({
            id: o,
            data: t1,
            tool: r,
            api: this.Editor.API,
            readOnly: s,
            tunesData: i
        }, this.eventsDispatcher);
        return s || window.requestIdleCallback(()=>{
            this.bindBlockEvents(a);
        }, {
            timeout: 2e3
        }), a;
    }
    /**
   * Insert new block into _blocks
   *
   * @param {object} options - insert options
   * @param {string} [options.id] - block's unique id
   * @param {string} [options.tool] - plugin name, by default method inserts the default block type
   * @param {object} [options.data] - plugin data
   * @param {number} [options.index] - index where to insert new Block
   * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
   * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
   * @returns {Block}
   */ insert({ id: e, tool: t1 = this.config.defaultBlock, data: o = {}, index: i, needToFocus: s = !0, replace: r = !1, tunes: a = {} } = {}) {
        let l = i;
        l === void 0 && (l = this.currentBlockIndex + (r ? 0 : 1));
        const c = this.composeBlock({
            id: e,
            tool: t1,
            data: o,
            tunes: a
        });
        return r && this.blockDidMutated($0cf1b19b2f7a01d6$var$_o, this.getBlockByIndex(l), {
            index: l
        }), this._blocks.insert(l, c, r), this.blockDidMutated($0cf1b19b2f7a01d6$var$Mo, c, {
            index: l
        }), s ? this.currentBlockIndex = l : l <= this.currentBlockIndex && this.currentBlockIndex++, c;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index where to insert
   */ insertMany(e, t1 = 0) {
        this._blocks.insertMany(e, t1);
    }
    /**
   * Update Block data.
   *
   * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
   * Should not trigger 'block-removed' or 'block-added' events.
   *
   * If neither data nor tunes is provided, return the provided block instead.
   *
   * @param block - block to update
   * @param data - (optional) new data
   * @param tunes - (optional) tune data
   */ async update(e, t1, o) {
        if (!t1 && !o) return e;
        const i = await e.data, s = this.composeBlock({
            id: e.id,
            tool: e.name,
            data: Object.assign({}, i, t1 ?? {}),
            tunes: o ?? e.tunes
        }), r = this.getBlockIndex(e);
        return this._blocks.replace(r, s), this.blockDidMutated($0cf1b19b2f7a01d6$var$Ao, s, {
            index: r
        }), s;
    }
    /**
   * Replace passed Block with the new one with specified Tool and data
   *
   * @param block - block to replace
   * @param newTool - new Tool name
   * @param data - new Tool data
   */ replace(e, t1, o) {
        const i = this.getBlockIndex(e);
        return this.insert({
            tool: t1,
            data: o,
            index: i,
            replace: !0
        });
    }
    /**
   * Insert pasted content. Call onPaste callback after insert.
   *
   * @param {string} toolName - name of Tool to insert
   * @param {PasteEvent} pasteEvent - pasted data
   * @param {boolean} replace - should replace current block
   */ paste(e, t1, o = !1) {
        const i = this.insert({
            tool: e,
            replace: o
        });
        try {
            window.requestIdleCallback(()=>{
                i.call($0cf1b19b2f7a01d6$var$ee.ON_PASTE, t1);
            });
        } catch (s) {
            $0cf1b19b2f7a01d6$var$S(`${e}: onPaste callback call is failed`, "error", s);
        }
        return i;
    }
    /**
   * Insert new default block at passed index
   *
   * @param {number} index - index where Block should be inserted
   * @param {boolean} needToFocus - if true, updates current Block index
   *
   * TODO: Remove method and use insert() with index instead (?)
   * @returns {Block} inserted Block
   */ insertDefaultBlockAtIndex(e, t1 = !1) {
        const o = this.composeBlock({
            tool: this.config.defaultBlock
        });
        return this._blocks[e] = o, this.blockDidMutated($0cf1b19b2f7a01d6$var$Mo, o, {
            index: e
        }), t1 ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
    }
    /**
   * Always inserts at the end
   *
   * @returns {Block}
   */ insertAtEnd() {
        return this.currentBlockIndex = this.blocks.length - 1, this.insert();
    }
    /**
   * Merge two blocks
   *
   * @param {Block} targetBlock - previous block will be append to this block
   * @param {Block} blockToMerge - block that will be merged with target block
   * @returns {Promise} - the sequence that can be continued
   */ async mergeBlocks(e, t1) {
        let o;
        if (e.name === t1.name && e.mergeable) {
            const i = await t1.data;
            if ($0cf1b19b2f7a01d6$var$V(i)) {
                console.error("Could not merge Block. Failed to extract original Block data.");
                return;
            }
            const [s] = $0cf1b19b2f7a01d6$var$yt([
                i
            ], e.tool.sanitizeConfig);
            o = s;
        } else if (e.mergeable && $0cf1b19b2f7a01d6$var$He(t1, "export") && $0cf1b19b2f7a01d6$var$He(e, "import")) {
            const i = await t1.exportDataAsString(), s = $0cf1b19b2f7a01d6$var$Z(i, e.tool.sanitizeConfig);
            o = $0cf1b19b2f7a01d6$var$Bo(s, e.tool.conversionConfig);
        }
        o !== void 0 && (await e.mergeWith(o), this.removeBlock(t1), this.currentBlockIndex = this._blocks.indexOf(e));
    }
    /**
   * Remove passed Block
   *
   * @param block - Block to remove
   * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
   */ removeBlock(e, t1 = !0) {
        return new Promise((o)=>{
            const i = this._blocks.indexOf(e);
            if (!this.validateIndex(i)) throw new Error("Can't find a Block to remove");
            this._blocks.remove(i), e.destroy(), this.blockDidMutated($0cf1b19b2f7a01d6$var$_o, e, {
                index: i
            }), this.currentBlockIndex >= i && this.currentBlockIndex--, this.blocks.length ? i === 0 && (this.currentBlockIndex = 0) : (this.unsetCurrentBlock(), t1 && this.insert()), o();
        });
    }
    /**
   * Remove only selected Blocks
   * and returns first Block index where started removing...
   *
   * @returns {number|undefined}
   */ removeSelectedBlocks() {
        let e;
        for(let t1 = this.blocks.length - 1; t1 >= 0; t1--)this.blocks[t1].selected && (this.removeBlock(this.blocks[t1]), e = t1);
        return e;
    }
    /**
   * Attention!
   * After removing insert the new default typed Block and focus on it
   * Removes all blocks
   */ removeAllBlocks() {
        for(let e = this.blocks.length - 1; e >= 0; e--)this._blocks.remove(e);
        this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
    }
    /**
   * Split current Block
   * 1. Extract content from Caret position to the Block`s end
   * 2. Insert a new Block below current one with extracted content
   *
   * @returns {Block}
   */ split() {
        const e = this.Editor.Caret.extractFragmentFromCaretPosition(), t1 = $0cf1b19b2f7a01d6$var$u.make("div");
        t1.appendChild(e);
        const o = {
            text: $0cf1b19b2f7a01d6$var$u.isEmpty(t1) ? "" : t1.innerHTML
        };
        return this.insert({
            data: o
        });
    }
    /**
   * Returns Block by passed index
   *
   * @param {number} index - index to get. -1 to get last
   * @returns {Block}
   */ getBlockByIndex(e) {
        return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
    }
    /**
   * Returns an index for passed Block
   *
   * @param block - block to find index
   */ getBlockIndex(e) {
        return this._blocks.indexOf(e);
    }
    /**
   * Returns the Block by passed id
   *
   * @param id - id of block to get
   * @returns {Block}
   */ getBlockById(e) {
        return this._blocks.array.find((t1)=>t1.id === e);
    }
    /**
   * Get Block instance by html element
   *
   * @param {Node} element - html element to get Block by
   */ getBlock(e) {
        $0cf1b19b2f7a01d6$var$u.isElement(e) || (e = e.parentNode);
        const t1 = this._blocks.nodes, o = e.closest(`.${$0cf1b19b2f7a01d6$var$R.CSS.wrapper}`), i = t1.indexOf(o);
        if (i >= 0) return this._blocks[i];
    }
    /**
   * 1) Find first-level Block from passed child Node
   * 2) Mark it as current
   *
   * @param {Node} childNode - look ahead from this node.
   * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
   */ setCurrentBlockByChildNode(e) {
        $0cf1b19b2f7a01d6$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$0cf1b19b2f7a01d6$var$R.CSS.wrapper}`);
        if (!t1) return;
        const o = t1.closest(`.${this.Editor.UI.CSS.editorWrapper}`);
        if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t1), this.currentBlock.updateCurrentInput(), this.currentBlock;
    }
    /**
   * Return block which contents passed node
   *
   * @param {Node} childNode - node to get Block by
   * @returns {Block}
   */ getBlockByChildNode(e) {
        if (!e || !(e instanceof Node)) return;
        $0cf1b19b2f7a01d6$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$0cf1b19b2f7a01d6$var$R.CSS.wrapper}`);
        return this.blocks.find((o)=>o.holder === t1);
    }
    /**
   * Swap Blocks Position
   *
   * @param {number} fromIndex - index of first block
   * @param {number} toIndex - index of second block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        this._blocks.swap(e, t1), this.currentBlockIndex = t1;
    }
    /**
   * Move a block to a new index
   *
   * @param {number} toIndex - index where to move Block
   * @param {number} fromIndex - index of Block to move
   */ move(e, t1 = this.currentBlockIndex) {
        if (isNaN(e) || isNaN(t1)) {
            $0cf1b19b2f7a01d6$var$S("Warning during 'move' call: incorrect indices provided.", "warn");
            return;
        }
        if (!this.validateIndex(e) || !this.validateIndex(t1)) {
            $0cf1b19b2f7a01d6$var$S("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
            return;
        }
        this._blocks.move(e, t1), this.currentBlockIndex = e, this.blockDidMutated($0cf1b19b2f7a01d6$var$ia, this.currentBlock, {
            fromIndex: t1,
            toIndex: e
        });
    }
    /**
   * Converts passed Block to the new Tool
   * Uses Conversion Config
   *
   * @param blockToConvert - Block that should be converted
   * @param targetToolName - name of the Tool to convert to
   * @param blockDataOverrides - optional new Block data overrides
   */ async convert(e, t1, o) {
        if (!await e.save()) throw new Error("Could not convert Block. Failed to extract original Block data.");
        const s = this.Editor.Tools.blockTools.get(t1);
        if (!s) throw new Error(`Could not convert Block. Tool \xab${t1}\xbb not found.`);
        const r = await e.exportDataAsString(), a = $0cf1b19b2f7a01d6$var$Z(r, s.sanitizeConfig);
        let l = $0cf1b19b2f7a01d6$var$Bo(a, s.conversionConfig, s.settings);
        return o && (l = Object.assign(l, o)), this.replace(e, s.name, l);
    }
    /**
   * Sets current Block Index -1 which means unknown
   * and clear highlights
   */ unsetCurrentBlock() {
        this.currentBlockIndex = -1;
    }
    /**
   * Clears Editor
   *
   * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
   *                                             we don't need to add an empty default block
   *                                        2) in api.blocks.clear we should add empty block
   */ async clear(e = !1) {
        const t1 = new $0cf1b19b2f7a01d6$var$sa();
        [
            ...this.blocks
        ].forEach((i)=>{
            t1.add(async ()=>{
                await this.removeBlock(i, !1);
            });
        }), await t1.completed, this.unsetCurrentBlock(), e && this.insert(), this.Editor.UI.checkEmptiness();
    }
    /**
   * Cleans up all the block tools' resources
   * This is called when editor is destroyed
   */ async destroy() {
        await Promise.all(this.blocks.map((e)=>e.destroy()));
    }
    /**
   * Bind Block events
   *
   * @param {Block} block - Block to which event should be bound
   */ bindBlockEvents(e) {
        const { BlockEvents: t1 } = this.Editor;
        this.readOnlyMutableListeners.on(e.holder, "keydown", (o)=>{
            t1.keydown(o);
        }), this.readOnlyMutableListeners.on(e.holder, "keyup", (o)=>{
            t1.keyup(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragover", (o)=>{
            t1.dragOver(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragleave", (o)=>{
            t1.dragLeave(o);
        }), e.on("didMutated", (o)=>this.blockDidMutated($0cf1b19b2f7a01d6$var$Ao, o, {
                index: this.getBlockIndex(o)
            }));
    }
    /**
   * Disable mutable handlers and bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Enables all module handlers and bindings for all Blocks
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(document, "cut", (e)=>this.Editor.BlockEvents.handleCommandX(e)), this.blocks.forEach((e)=>{
            this.bindBlockEvents(e);
        });
    }
    /**
   * Validates that the given index is not lower than 0 or higher than the amount of blocks
   *
   * @param {number} index - index of blocks array to validate
   * @returns {boolean}
   */ validateIndex(e) {
        return !(e < 0 || e >= this._blocks.length);
    }
    /**
   * Block mutation callback
   *
   * @param mutationType - what happened with block
   * @param block - mutated block
   * @param detailData - additional data to pass with change event
   */ blockDidMutated(e, t1, o) {
        const i = new CustomEvent(e, {
            detail: {
                target: new $0cf1b19b2f7a01d6$var$J(t1),
                ...o
            }
        });
        return this.eventsDispatcher.emit($0cf1b19b2f7a01d6$var$$o, {
            event: i
        }), t1;
    }
}
class $0cf1b19b2f7a01d6$var$aa extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.anyBlockSelectedCache = null, this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
    }
    /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */ get sanitizerConfig() {
        return {
            p: {},
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            h5: {},
            h6: {},
            ol: {},
            ul: {},
            li: {},
            br: !0,
            img: {
                src: !0,
                width: !0,
                height: !0
            },
            a: {
                href: !0
            },
            b: {},
            i: {},
            u: {}
        };
    }
    /**
   * Flag that identifies all Blocks selection
   *
   * @returns {boolean}
   */ get allBlocksSelected() {
        const { BlockManager: e } = this.Editor;
        return e.blocks.every((t1)=>t1.selected === !0);
    }
    /**
   * Set selected all blocks
   *
   * @param {boolean} state - state to set
   */ set allBlocksSelected(e) {
        const { BlockManager: t1 } = this.Editor;
        t1.blocks.forEach((o)=>{
            o.selected = e;
        }), this.clearCache();
    }
    /**
   * Flag that identifies any Block selection
   *
   * @returns {boolean}
   */ get anyBlockSelected() {
        const { BlockManager: e } = this.Editor;
        return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some((t1)=>t1.selected === !0)), this.anyBlockSelectedCache;
    }
    /**
   * Return selected Blocks array
   *
   * @returns {Block[]}
   */ get selectedBlocks() {
        return this.Editor.BlockManager.blocks.filter((e)=>e.selected);
    }
    /**
   * Module Preparation
   * Registers Shortcuts CMD+A and CMD+C
   * to select all and copy them
   */ prepare() {
        this.selection = new $0cf1b19b2f7a01d6$var$b(), $0cf1b19b2f7a01d6$var$ge.add({
            name: "CMD+A",
            handler: (e)=>{
                const { BlockManager: t1, ReadOnly: o } = this.Editor;
                if (o.isEnabled) {
                    e.preventDefault(), this.selectAllBlocks();
                    return;
                }
                t1.currentBlock && this.handleCommandA(e);
            },
            on: this.Editor.UI.nodes.redactor
        });
    }
    /**
   * Toggle read-only state
   *
   *  - Remove all ranges
   *  - Unselect all Blocks
   */ toggleReadOnly() {
        $0cf1b19b2f7a01d6$var$b.get().removeAllRanges(), this.allBlocksSelected = !1;
    }
    /**
   * Remove selection of Block
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ unSelectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        isNaN(e) ? o = t1.currentBlock : o = t1.getBlockByIndex(e), o.selected = !1, this.clearCache();
    }
    /**
   * Clear selection from Blocks
   *
   * @param {Event} reason - event caused clear of selection
   * @param {boolean} restoreSelection - if true, restore saved selection
   */ clearSelection(e, t1 = !1) {
        const { BlockManager: o, Caret: i, RectangleSelection: s } = this.Editor;
        this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
        const r = e && e instanceof KeyboardEvent, a = r && $0cf1b19b2f7a01d6$var$Po(e.keyCode);
        if (this.anyBlockSelected && r && a && !$0cf1b19b2f7a01d6$var$b.isSelectionExists) {
            const l = o.removeSelectedBlocks();
            o.insertDefaultBlockAtIndex(l, !0), i.setToBlock(o.currentBlock), $0cf1b19b2f7a01d6$var$Fe(()=>{
                const c = e.key;
                i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
            }, 20)();
        }
        if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
            this.Editor.RectangleSelection.clearSelection();
            return;
        }
        t1 && this.selection.restore(), this.allBlocksSelected = !1;
    }
    /**
   * Reduce each Block and copy its content
   *
   * @param {ClipboardEvent} e - copy/cut event
   * @returns {Promise<void>}
   */ copySelectedBlocks(e) {
        e.preventDefault();
        const t1 = $0cf1b19b2f7a01d6$var$u.make("div");
        this.selectedBlocks.forEach((s)=>{
            const r = $0cf1b19b2f7a01d6$var$Z(s.holder.innerHTML, this.sanitizerConfig), a = $0cf1b19b2f7a01d6$var$u.make("p");
            a.innerHTML = r, t1.appendChild(a);
        });
        const o = Array.from(t1.childNodes).map((s)=>s.textContent).join(`

`), i = t1.innerHTML;
        return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map((s)=>s.save())).then((s)=>{
            try {
                e.clipboardData.setData(this.Editor.Paste.MIME_TYPE, JSON.stringify(s));
            } catch  {}
        });
    }
    /**
   * Select Block by its index
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ selectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor, o = t1.getBlockByIndex(e);
        o !== void 0 && this.selectBlock(o);
    }
    /**
   * Select passed Block
   *
   * @param {Block} block - Block to select
   */ selectBlock(e) {
        this.selection.save(), $0cf1b19b2f7a01d6$var$b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
    }
    /**
   * Remove selection from passed Block
   *
   * @param {Block} block - Block to unselect
   */ unselectBlock(e) {
        e.selected = !1, this.clearCache();
    }
    /**
   * Clear anyBlockSelected cache
   */ clearCache() {
        this.anyBlockSelectedCache = null;
    }
    /**
   * Module destruction
   * De-registers Shortcut CMD+A
   */ destroy() {
        $0cf1b19b2f7a01d6$var$ge.remove(this.Editor.UI.nodes.redactor, "CMD+A");
    }
    /**
   * First CMD+A selects all input content by native behaviour,
   * next CMD+A keypress selects all blocks
   *
   * @param {KeyboardEvent} event - keyboard event
   */ handleCommandA(e) {
        if (this.Editor.RectangleSelection.clearSelection(), $0cf1b19b2f7a01d6$var$u.isNativeInput(e.target) && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        const t1 = this.Editor.BlockManager.getBlock(e.target), o = t1.inputs;
        if (o.length > 1 && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        if (o.length === 1 && !this.needToSelectAll) {
            this.needToSelectAll = !0;
            return;
        }
        this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t1), this.needToSelectAll = !0);
    }
    /**
   * Select All Blocks
   * Each Block has selected setter that makes Block copyable
   */ selectAllBlocks() {
        this.selection.save(), $0cf1b19b2f7a01d6$var$b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
    }
}
class $0cf1b19b2f7a01d6$var$Ye extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Allowed caret positions in input
   *
   * @static
   * @returns {{START: string, END: string, DEFAULT: string}}
   */ get positions() {
        return {
            START: "start",
            END: "end",
            DEFAULT: "default"
        };
    }
    /**
   * Elements styles that can be useful for Caret Module
   */ static get CSS() {
        return {
            shadowCaret: "cdx-shadow-caret"
        };
    }
    /**
   * Method gets Block instance and puts caret to the text node with offset
   * There two ways that method applies caret position:
   *   - first found text node: sets at the beginning, but you can pass an offset
   *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
   *
   * @param {Block} block - Block class
   * @param {string} position - position where to set caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the block content
   */ setToBlock(e, t1 = this.positions.DEFAULT, o = 0) {
        var c;
        const { BlockManager: i, BlockSelection: s } = this.Editor;
        if (s.clearSelection(), !e.focusable) {
            (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
            return;
        }
        let r;
        switch(t1){
            case this.positions.START:
                r = e.firstInput;
                break;
            case this.positions.END:
                r = e.lastInput;
                break;
            default:
                r = e.currentInput;
        }
        if (!r) return;
        let a, l = o;
        if (t1 === this.positions.START) a = $0cf1b19b2f7a01d6$var$u.getDeepestNode(r, !1), l = 0;
        else if (t1 === this.positions.END) a = $0cf1b19b2f7a01d6$var$u.getDeepestNode(r, !0), l = $0cf1b19b2f7a01d6$var$u.getContentLength(a);
        else {
            const { node: d, offset: h } = $0cf1b19b2f7a01d6$var$u.getNodeByOffset(r, o);
            d ? (a = d, l = h) : (a = $0cf1b19b2f7a01d6$var$u.getDeepestNode(r, !1), l = 0);
        }
        this.set(a, l), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
    }
    /**
   * Set caret to the current input of current Block.
   *
   * @param {HTMLElement} input - input where caret should be set
   * @param {string} position - position of the caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ setToInput(e, t1 = this.positions.DEFAULT, o = 0) {
        const { currentBlock: i } = this.Editor.BlockManager, s = $0cf1b19b2f7a01d6$var$u.getDeepestNode(e);
        switch(t1){
            case this.positions.START:
                this.set(s, 0);
                break;
            case this.positions.END:
                this.set(s, $0cf1b19b2f7a01d6$var$u.getContentLength(s));
                break;
            default:
                o && this.set(s, o);
        }
        i.currentInput = e;
    }
    /**
   * Creates Document Range and sets caret to the element with offset
   *
   * @param {HTMLElement} element - target node.
   * @param {number} offset - offset
   */ set(e, t1 = 0) {
        const { top: i, bottom: s } = $0cf1b19b2f7a01d6$var$b.setCursor(e, t1), { innerHeight: r } = window;
        i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
    }
    /**
   * Set Caret to the last Block
   * If last block is not empty, append another empty block
   */ setToTheLastBlock() {
        const e = this.Editor.BlockManager.lastBlock;
        if (e) {
            if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);
            else {
                const t1 = this.Editor.BlockManager.insertAtEnd();
                this.setToBlock(t1);
            }
        }
    }
    /**
   * Extract content fragment of current Block from Caret position to the end of the Block
   */ extractFragmentFromCaretPosition() {
        const e = $0cf1b19b2f7a01d6$var$b.get();
        if (e.rangeCount) {
            const t1 = e.getRangeAt(0), o = this.Editor.BlockManager.currentBlock.currentInput;
            if (t1.deleteContents(), o) {
                if ($0cf1b19b2f7a01d6$var$u.isNativeInput(o)) {
                    const i = o, s = document.createDocumentFragment(), r = i.value.substring(0, i.selectionStart), a = i.value.substring(i.selectionStart);
                    return s.textContent = a, i.value = r, s;
                } else {
                    const i = t1.cloneRange();
                    return i.selectNodeContents(o), i.setStart(t1.endContainer, t1.endOffset), i.extractContents();
                }
            }
        }
    }
    /**
   * Set's caret to the next Block or Tool`s input
   * Before moving caret, we should check if caret position is at the end of Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigateNext(e = !1) {
        const { BlockManager: t1 } = this.Editor, { currentBlock: o, nextBlock: i } = t1;
        if (o === void 0) return !1;
        const { nextInput: s, currentInput: r } = o, a = r !== void 0 ? $0cf1b19b2f7a01d6$var$Re(r) : void 0;
        let l = i;
        const c = e || a || !o.focusable;
        if (s && c) return this.setToInput(s, this.positions.START), !0;
        if (l === null) {
            if (o.tool.isDefault || !c) return !1;
            l = t1.insertAtEnd();
        }
        return c ? (this.setToBlock(l, this.positions.START), !0) : !1;
    }
    /**
   * Set's caret to the previous Tool`s input or Block
   * Before moving caret, we should check if caret position is start of the Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigatePrevious(e = !1) {
        const { currentBlock: t1, previousBlock: o } = this.Editor.BlockManager;
        if (!t1) return !1;
        const { previousInput: i, currentInput: s } = t1, r = s !== void 0 ? $0cf1b19b2f7a01d6$var$Ne(s) : void 0, a = e || r || !t1.focusable;
        return i && a ? (this.setToInput(i, this.positions.END), !0) : o !== null && a ? (this.setToBlock(o, this.positions.END), !0) : !1;
    }
    /**
   * Inserts shadow element after passed element where caret can be placed
   *
   * @param {Element} element - element after which shadow caret should be inserted
   */ createShadow(e) {
        const t1 = document.createElement("span");
        t1.classList.add($0cf1b19b2f7a01d6$var$Ye.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t1);
    }
    /**
   * Restores caret position
   *
   * @param {HTMLElement} element - element where caret should be restored
   */ restoreCaret(e) {
        const t1 = e.querySelector(`.${$0cf1b19b2f7a01d6$var$Ye.CSS.shadowCaret}`);
        if (!t1) return;
        new $0cf1b19b2f7a01d6$var$b().expandToTag(t1);
        const i = document.createRange();
        i.selectNode(t1), i.extractContents();
    }
    /**
   * Inserts passed content at caret position
   *
   * @param {string} content - content to insert
   */ insertContentAtCaretPosition(e) {
        const t1 = document.createDocumentFragment(), o = document.createElement("div"), i = $0cf1b19b2f7a01d6$var$b.get(), s = $0cf1b19b2f7a01d6$var$b.range;
        o.innerHTML = e, Array.from(o.childNodes).forEach((c)=>t1.appendChild(c)), t1.childNodes.length === 0 && t1.appendChild(new Text());
        const r = t1.lastChild;
        s.deleteContents(), s.insertNode(t1);
        const a = document.createRange(), l = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
        l !== null && l.textContent !== null && a.setStart(l, l.textContent.length), i.removeAllRanges(), i.addRange(a);
    }
}
class $0cf1b19b2f7a01d6$var$la extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.onMouseUp = ()=>{
            this.listeners.off(document, "mouseover", this.onMouseOver), this.listeners.off(document, "mouseup", this.onMouseUp);
        }, this.onMouseOver = (e)=>{
            const { BlockManager: t1, BlockSelection: o } = this.Editor;
            if (e.relatedTarget === null && e.target === null) return;
            const i = t1.getBlockByChildNode(e.relatedTarget) || this.lastSelectedBlock, s = t1.getBlockByChildNode(e.target);
            if (!(!i || !s) && s !== i) {
                if (i === this.firstSelectedBlock) {
                    $0cf1b19b2f7a01d6$var$b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
                    return;
                }
                if (s === this.firstSelectedBlock) {
                    i.selected = !1, s.selected = !1, o.clearCache();
                    return;
                }
                this.Editor.InlineToolbar.close(), this.toggleBlocksSelectedState(i, s), this.lastSelectedBlock = s;
            }
        };
    }
    /**
   * Module preparation
   *
   * @returns {Promise}
   */ async prepare() {
        this.listeners.on(document, "mousedown", (e)=>{
            this.enableCrossBlockSelection(e);
        });
    }
    /**
   * Sets up listeners
   *
   * @param {MouseEvent} event - mouse down event
   */ watchSelection(e) {
        if (e.button !== $0cf1b19b2f7a01d6$var$qn.LEFT) return;
        const { BlockManager: t1 } = this.Editor;
        this.firstSelectedBlock = t1.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
    }
    /**
   * Return boolean is cross block selection started:
   * there should be at least 2 selected blocks
   */ get isCrossBlockSelectionStarted() {
        return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
    }
    /**
   * Change selection state of the next Block
   * Used for CBS via Shift + arrow keys
   *
   * @param {boolean} next - if true, toggle next block. Previous otherwise
   */ toggleBlockSelectedState(e = !0) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t1.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), $0cf1b19b2f7a01d6$var$b.get().removeAllRanges());
        const i = t1.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1), s = t1.blocks[i];
        s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
            block: "nearest"
        }));
    }
    /**
   * Clear saved state
   *
   * @param {Event} reason - event caused clear of selection
   */ clear(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor, s = t1.blocks.indexOf(this.firstSelectedBlock), r = t1.blocks.indexOf(this.lastSelectedBlock);
        if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch(e.keyCode){
            case $0cf1b19b2f7a01d6$var$y.DOWN:
            case $0cf1b19b2f7a01d6$var$y.RIGHT:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                break;
            case $0cf1b19b2f7a01d6$var$y.UP:
            case $0cf1b19b2f7a01d6$var$y.LEFT:
                i.setToBlock(t1.blocks[Math.min(s, r)], i.positions.START);
                break;
            default:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
        }
        this.firstSelectedBlock = this.lastSelectedBlock = null;
    }
    /**
   * Enables Cross Block Selection
   *
   * @param {MouseEvent} event - mouse down event
   */ enableCrossBlockSelection(e) {
        const { UI: t1 } = this.Editor;
        $0cf1b19b2f7a01d6$var$b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t1.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Change blocks selection state between passed two blocks.
   *
   * @param {Block} firstBlock - first block in range
   * @param {Block} lastBlock - last block in range
   */ toggleBlocksSelectedState(e, t1) {
        const { BlockManager: o, BlockSelection: i } = this.Editor, s = o.blocks.indexOf(e), r = o.blocks.indexOf(t1), a = e.selected !== t1.selected;
        for(let l = Math.min(s, r); l <= Math.max(s, r); l++){
            const c = o.blocks[l];
            c !== this.firstSelectedBlock && c !== (a ? e : t1) && (o.blocks[l].selected = !o.blocks[l].selected, i.clearCache());
        }
    }
}
class $0cf1b19b2f7a01d6$var$ca extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.isStartedAtEditor = !1;
    }
    /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Add drag events listeners to editor zone
   */ enableModuleBindings() {
        const { UI: e } = this.Editor;
        this.readOnlyMutableListeners.on(e.nodes.holder, "drop", async (t1)=>{
            await this.processDrop(t1);
        }, !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", ()=>{
            this.processDragStart();
        }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", (t1)=>{
            this.processDragOver(t1);
        }, !0);
    }
    /**
   * Unbind drag-n-drop event handlers
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Handle drop event
   *
   * @param {DragEvent} dropEvent - drop event
   */ async processDrop(e) {
        const { BlockManager: t1, Paste: o, Caret: i } = this.Editor;
        e.preventDefault(), t1.blocks.forEach((r)=>{
            r.dropTarget = !1;
        }), $0cf1b19b2f7a01d6$var$b.isAtEditor && !$0cf1b19b2f7a01d6$var$b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
        const s = t1.setCurrentBlockByChildNode(e.target);
        if (s) this.Editor.Caret.setToBlock(s, i.positions.END);
        else {
            const r = t1.setCurrentBlockByChildNode(t1.lastBlock.holder);
            this.Editor.Caret.setToBlock(r, i.positions.END);
        }
        await o.processDataTransfer(e.dataTransfer, !0);
    }
    /**
   * Handle drag start event
   */ processDragStart() {
        $0cf1b19b2f7a01d6$var$b.isAtEditor && !$0cf1b19b2f7a01d6$var$b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
    }
    /**
   * @param {DragEvent} dragEvent - drag event
   */ processDragOver(e) {
        e.preventDefault();
    }
}
const $0cf1b19b2f7a01d6$var$da = 180, $0cf1b19b2f7a01d6$var$ua = 400;
class $0cf1b19b2f7a01d6$var$ha extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Prepare the module
   *
   * @param options - options used by the modification observer module
   * @param options.config - Editor configuration object
   * @param options.eventsDispatcher - common Editor event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.disabled = !1, this.batchingTimeout = null, this.batchingOnChangeQueue = /* @__PURE__ */ new Map(), this.batchTime = $0cf1b19b2f7a01d6$var$ua, this.mutationObserver = new MutationObserver((o)=>{
            this.redactorChanged(o);
        }), this.eventsDispatcher.on($0cf1b19b2f7a01d6$var$$o, (o)=>{
            this.particularBlockChanged(o.event);
        }), this.eventsDispatcher.on($0cf1b19b2f7a01d6$var$zo, ()=>{
            this.disable();
        }), this.eventsDispatcher.on($0cf1b19b2f7a01d6$var$Uo, ()=>{
            this.enable();
        });
    }
    /**
   * Enables onChange event
   */ enable() {
        this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
            childList: !0,
            subtree: !0,
            characterData: !0,
            attributes: !0
        }), this.disabled = !1;
    }
    /**
   * Disables onChange event
   */ disable() {
        this.mutationObserver.disconnect(), this.disabled = !0;
    }
    /**
   * Call onChange event passed to Editor.js configuration
   *
   * @param event - some of our custom change events
   */ particularBlockChanged(e) {
        this.disabled || !$0cf1b19b2f7a01d6$var$A(this.config.onChange) || (this.batchingOnChangeQueue.set(`block:${e.detail.target.id}:event:${e.type}`, e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(()=>{
            let t1;
            this.batchingOnChangeQueue.size === 1 ? t1 = this.batchingOnChangeQueue.values().next().value : t1 = Array.from(this.batchingOnChangeQueue.values()), this.config.onChange && this.config.onChange(this.Editor.API.methods, t1), this.batchingOnChangeQueue.clear();
        }, this.batchTime));
    }
    /**
   * Fired on every blocks wrapper dom change
   *
   * @param mutations - mutations happened
   */ redactorChanged(e) {
        this.eventsDispatcher.emit($0cf1b19b2f7a01d6$var$ft, {
            mutations: e
        });
    }
}
const $0cf1b19b2f7a01d6$var$Rn = class Dn extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.MIME_TYPE = "application/x-editor-js", this.toolsTags = {}, this.tagsByTool = {}, this.toolsPatterns = [], this.toolsFiles = {}, this.exceptionList = [], this.processTool = (e)=>{
            try {
                const t1 = e.create({}, {}, !1);
                if (e.pasteConfig === !1) {
                    this.exceptionList.push(e.name);
                    return;
                }
                if (!$0cf1b19b2f7a01d6$var$A(t1.onPaste)) return;
                this.getTagsConfig(e), this.getFilesConfig(e), this.getPatternsConfig(e);
            } catch (t1) {
                $0cf1b19b2f7a01d6$var$S(`Paste handling for \xab${e.name}\xbb Tool hasn't been set up because of the error`, "warn", t1);
            }
        }, this.handlePasteEvent = async (e)=>{
            const { BlockManager: t1, Toolbar: o } = this.Editor, i = t1.setCurrentBlockByChildNode(e.target);
            !i || this.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && this.exceptionList.includes(i.name) || (e.preventDefault(), this.processDataTransfer(e.clipboardData), o.close());
        };
    }
    /**
   * Set onPaste callback and collect tools` paste configurations
   */ async prepare() {
        this.processTools();
    }
    /**
   * Set read-only state
   *
   * @param {boolean} readOnlyEnabled - read only flag value
   */ toggleReadOnly(e) {
        e ? this.unsetCallback() : this.setCallback();
    }
    /**
   * Handle pasted or dropped data transfer object
   *
   * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
   * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
   */ async processDataTransfer(e, t1 = !1) {
        const { Tools: o } = this.Editor, i = e.types;
        if ((i.includes ? i.includes("Files") : i.contains("Files")) && !$0cf1b19b2f7a01d6$var$V(this.toolsFiles)) {
            await this.processFiles(e.files);
            return;
        }
        const r = e.getData(this.MIME_TYPE), a = e.getData("text/plain");
        let l = e.getData("text/html");
        if (r) try {
            this.insertEditorJSData(JSON.parse(r));
            return;
        } catch  {}
        t1 && a.trim() && l.trim() && (l = "<p>" + (l.trim() ? l : a) + "</p>");
        const c = Object.keys(this.toolsTags).reduce((p, g)=>(p[g.toLowerCase()] = this.toolsTags[g].sanitizationConfig ?? {}, p), {}), d = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
            br: {}
        }), h = $0cf1b19b2f7a01d6$var$Z(l, d);
        !h.trim() || h.trim() === a || !$0cf1b19b2f7a01d6$var$u.isHTMLString(h) ? await this.processText(a) : await this.processText(h, !0);
    }
    /**
   * Process pasted text and divide them into Blocks
   *
   * @param {string} data - text to process. Can be HTML or plain.
   * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
   */ async processText(e, t1 = !1) {
        const { Caret: o, BlockManager: i } = this.Editor, s = t1 ? this.processHTML(e) : this.processPlain(e);
        if (!s.length) return;
        if (s.length === 1) {
            s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
            return;
        }
        const a = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
        s.map(async (l, c)=>this.insertBlock(l, c === 0 && a)), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);
    }
    /**
   * Set onPaste callback handler
   */ setCallback() {
        this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Unset onPaste callback handler
   */ unsetCallback() {
        this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Get and process tool`s paste configs
   */ processTools() {
        const e = this.Editor.Tools.blockTools;
        Array.from(e.values()).forEach(this.processTool);
    }
    /**
   * Get tags name list from either tag name or sanitization config.
   *
   * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
   * @returns {string[]} array of tags.
   */ collectTagNames(e) {
        return $0cf1b19b2f7a01d6$var$te(e) ? [
            e
        ] : $0cf1b19b2f7a01d6$var$D(e) ? Object.keys(e) : [];
    }
    /**
   * Get tags to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getTagsConfig(e) {
        if (e.pasteConfig === !1) return;
        const t1 = e.pasteConfig.tags || [], o = [];
        t1.forEach((i)=>{
            const s = this.collectTagNames(i);
            o.push(...s), s.forEach((r)=>{
                if (Object.prototype.hasOwnProperty.call(this.toolsTags, r)) {
                    $0cf1b19b2f7a01d6$var$S(`Paste handler for \xab${e.name}\xbb Tool on \xab${r}\xbb tag is skipped because it is already used by \xab${this.toolsTags[r].tool.name}\xbb Tool.`, "warn");
                    return;
                }
                const a = $0cf1b19b2f7a01d6$var$D(i) ? i[r] : null;
                this.toolsTags[r.toUpperCase()] = {
                    tool: e,
                    sanitizationConfig: a
                };
            });
        }), this.tagsByTool[e.name] = o.map((i)=>i.toUpperCase());
    }
    /**
   * Get files` types and extensions to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getFilesConfig(e) {
        if (e.pasteConfig === !1) return;
        const { files: t1 = {} } = e.pasteConfig;
        let { extensions: o, mimeTypes: i } = t1;
        !o && !i || (o && !Array.isArray(o) && ($0cf1b19b2f7a01d6$var$S(`\xabextensions\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), o = []), i && !Array.isArray(i) && ($0cf1b19b2f7a01d6$var$S(`\xabmimeTypes\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), i = []), i && (i = i.filter((s)=>$0cf1b19b2f7a01d6$var$ei(s) ? !0 : ($0cf1b19b2f7a01d6$var$S(`MIME type value \xab${s}\xbb for the \xab${e.name}\xbb Tool is not a valid MIME type`, "warn"), !1))), this.toolsFiles[e.name] = {
            extensions: o || [],
            mimeTypes: i || []
        });
    }
    /**
   * Get RegExp patterns to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getPatternsConfig(e) {
        e.pasteConfig === !1 || !e.pasteConfig.patterns || $0cf1b19b2f7a01d6$var$V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(([t1, o])=>{
            o instanceof RegExp || $0cf1b19b2f7a01d6$var$S(`Pattern ${o} for \xab${e.name}\xbb Tool is skipped because it should be a Regexp instance.`, "warn"), this.toolsPatterns.push({
                key: t1,
                pattern: o,
                tool: e
            });
        });
    }
    /**
   * Check if browser behavior suits better
   *
   * @param {EventTarget} element - element where content has been pasted
   * @returns {boolean}
   */ isNativeBehaviour(e) {
        return $0cf1b19b2f7a01d6$var$u.isNativeInput(e);
    }
    /**
   * Get files from data transfer object and insert related Tools
   *
   * @param {FileList} items - pasted or dropped items
   */ async processFiles(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        o = await Promise.all(Array.from(e).map((r)=>this.processFile(r))), o = o.filter((r)=>!!r);
        const s = t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty;
        o.forEach((r, a)=>{
            t1.paste(r.type, r.event, a === 0 && s);
        });
    }
    /**
   * Get information about file and find Tool to handle it
   *
   * @param {File} file - file to process
   */ async processFile(e) {
        const t1 = $0cf1b19b2f7a01d6$var$Jn(e), o = Object.entries(this.toolsFiles).find(([r, { mimeTypes: a, extensions: l }])=>{
            const [c, d] = e.type.split("/"), h = l.find((g)=>g.toLowerCase() === t1.toLowerCase()), p = a.find((g)=>{
                const [f, v] = g.split("/");
                return f === c && (v === d || v === "*");
            });
            return !!h || !!p;
        });
        if (!o) return;
        const [i] = o;
        return {
            event: this.composePasteEvent("file", {
                file: e
            }),
            type: i
        };
    }
    /**
   * Split HTML string to blocks and return it as array of Block data
   *
   * @param {string} innerHTML - html string to process
   * @returns {PasteData[]}
   */ processHTML(e) {
        const { Tools: t1 } = this.Editor, o = $0cf1b19b2f7a01d6$var$u.make("DIV");
        return o.innerHTML = e, this.getNodes(o).map((s)=>{
            let r, a = t1.defaultTool, l = !1;
            switch(s.nodeType){
                case Node.DOCUMENT_FRAGMENT_NODE:
                    r = $0cf1b19b2f7a01d6$var$u.make("div"), r.appendChild(s);
                    break;
                case Node.ELEMENT_NODE:
                    r = s, l = !0, this.toolsTags[r.tagName] && (a = this.toolsTags[r.tagName].tool);
                    break;
            }
            const { tags: c } = a.pasteConfig || {
                tags: []
            }, d = c.reduce((g, f)=>(this.collectTagNames(f).forEach((O)=>{
                    const T = $0cf1b19b2f7a01d6$var$D(f) ? f[O] : null;
                    g[O.toLowerCase()] = T || {};
                }), g), {}), h = Object.assign({}, d, a.baseSanitizeConfig);
            if (r.tagName.toLowerCase() === "table") {
                const g = $0cf1b19b2f7a01d6$var$Z(r.outerHTML, h);
                r = $0cf1b19b2f7a01d6$var$u.make("div", void 0, {
                    innerHTML: g
                }).firstChild;
            } else r.innerHTML = $0cf1b19b2f7a01d6$var$Z(r.innerHTML, h);
            const p = this.composePasteEvent("tag", {
                data: r
            });
            return {
                content: r,
                isBlock: l,
                tool: a.name,
                event: p
            };
        }).filter((s)=>{
            const r = $0cf1b19b2f7a01d6$var$u.isEmpty(s.content), a = $0cf1b19b2f7a01d6$var$u.isSingleTag(s.content);
            return !r || a;
        });
    }
    /**
   * Split plain text by new line symbols and return it as array of Block data
   *
   * @param {string} plain - string to process
   * @returns {PasteData[]}
   */ processPlain(e) {
        const { defaultBlock: t1 } = this.config;
        if (!e) return [];
        const o = t1;
        return e.split(/\r?\n/).filter((i)=>i.trim()).map((i)=>{
            const s = $0cf1b19b2f7a01d6$var$u.make("div");
            s.textContent = i;
            const r = this.composePasteEvent("tag", {
                data: s
            });
            return {
                content: s,
                tool: o,
                isBlock: !1,
                event: r
            };
        });
    }
    /**
   * Process paste of single Block tool content
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processSingleBlock(e) {
        const { Caret: t1, BlockManager: o } = this.Editor, { currentBlock: i } = o;
        if (!i || e.tool !== i.name || !$0cf1b19b2f7a01d6$var$u.containsOnlyInlineElements(e.content.innerHTML)) {
            this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
            return;
        }
        t1.insertContentAtCaretPosition(e.content.innerHTML);
    }
    /**
   * Process paste to single Block:
   * 1. Find patterns` matches
   * 2. Insert new block if it is not the same type as current one
   * 3. Just insert text if there is no substitutions
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processInlinePaste(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { content: i } = e;
        if (t1.currentBlock && t1.currentBlock.tool.isDefault && i.textContent.length < Dn.PATTERN_PROCESSING_MAX_LENGTH) {
            const r = await this.processPattern(i.textContent);
            if (r) {
                const a = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty, l = t1.paste(r.tool, r.event, a);
                o.setToBlock(l, o.positions.END);
                return;
            }
        }
        if (t1.currentBlock && t1.currentBlock.currentInput) {
            const r = t1.currentBlock.tool.baseSanitizeConfig;
            document.execCommand("insertHTML", !1, $0cf1b19b2f7a01d6$var$Z(i.innerHTML, r));
        } else this.insertBlock(e);
    }
    /**
   * Get patterns` matches
   *
   * @param {string} text - text to process
   * @returns {Promise<{event: PasteEvent, tool: string}>}
   */ async processPattern(e) {
        const t1 = this.toolsPatterns.find((i)=>{
            const s = i.pattern.exec(e);
            return s ? e === s.shift() : !1;
        });
        return t1 ? {
            event: this.composePasteEvent("pattern", {
                key: t1.key,
                data: e
            }),
            tool: t1.tool.name
        } : void 0;
    }
    /**
   * Insert pasted Block content to Editor
   *
   * @param {PasteData} data - data to insert
   * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
   * @returns {void}
   */ insertBlock(e, t1 = !1) {
        const { BlockManager: o, Caret: i } = this.Editor, { currentBlock: s } = o;
        let r;
        if (t1 && s && s.isEmpty) {
            r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
            return;
        }
        r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
    }
    /**
   * Insert data passed as application/x-editor-js JSON
   *
   * @param {Array} blocks — Blocks' data to insert
   * @returns {void}
   */ insertEditorJSData(e) {
        const { BlockManager: t1, Caret: o, Tools: i } = this.Editor;
        $0cf1b19b2f7a01d6$var$yt(e, (r)=>i.blockTools.get(r).sanitizeConfig).forEach(({ tool: r, data: a }, l)=>{
            let c = !1;
            l === 0 && (c = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty);
            const d = t1.insert({
                tool: r,
                data: a,
                replace: c
            });
            o.setToBlock(d, o.positions.END);
        });
    }
    /**
   * Fetch nodes from Element node
   *
   * @param {Node} node - current node
   * @param {Node[]} nodes - processed nodes
   * @param {Node} destNode - destination node
   */ processElementNode(e, t1, o) {
        const i = Object.keys(this.toolsTags), s = e, { tool: r } = this.toolsTags[s.tagName] || {}, a = this.tagsByTool[r == null ? void 0 : r.name] || [], l = i.includes(s.tagName), c = $0cf1b19b2f7a01d6$var$u.blockElements.includes(s.tagName.toLowerCase()), d = Array.from(s.children).some(({ tagName: p })=>i.includes(p) && !a.includes(p)), h = Array.from(s.children).some(({ tagName: p })=>$0cf1b19b2f7a01d6$var$u.blockElements.includes(p.toLowerCase()));
        if (!c && !l && !d) return o.appendChild(s), [
            ...t1,
            o
        ];
        if (l && !d || c && !h && !d) return [
            ...t1,
            o,
            s
        ];
    }
    /**
   * Recursively divide HTML string to two types of nodes:
   * 1. Block element
   * 2. Document Fragments contained text and markup tags like a, b, i etc.
   *
   * @param {Node} wrapper - wrapper of paster HTML content
   * @returns {Node[]}
   */ getNodes(e) {
        const t1 = Array.from(e.childNodes);
        let o;
        const i = (s, r)=>{
            if ($0cf1b19b2f7a01d6$var$u.isEmpty(r) && !$0cf1b19b2f7a01d6$var$u.isSingleTag(r)) return s;
            const a = s[s.length - 1];
            let l = new DocumentFragment();
            switch(a && $0cf1b19b2f7a01d6$var$u.isFragment(a) && (l = s.pop()), r.nodeType){
                case Node.ELEMENT_NODE:
                    if (o = this.processElementNode(r, s, l), o) return o;
                    break;
                case Node.TEXT_NODE:
                    return l.appendChild(r), [
                        ...s,
                        l
                    ];
                default:
                    return [
                        ...s,
                        l
                    ];
            }
            return [
                ...s,
                ...Array.from(r.childNodes).reduce(i, [])
            ];
        };
        return t1.reduce(i, []);
    }
    /**
   * Compose paste event with passed type and detail
   *
   * @param {string} type - event type
   * @param {PasteEventDetail} detail - event detail
   */ composePasteEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
};
$0cf1b19b2f7a01d6$var$Rn.PATTERN_PROCESSING_MAX_LENGTH = 450;
let $0cf1b19b2f7a01d6$var$pa = $0cf1b19b2f7a01d6$var$Rn;
class $0cf1b19b2f7a01d6$var$fa extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.toolsDontSupportReadOnly = [], this.readOnlyEnabled = !1;
    }
    /**
   * Returns state of read only mode
   */ get isEnabled() {
        return this.readOnlyEnabled;
    }
    /**
   * Set initial state
   */ async prepare() {
        const { Tools: e } = this.Editor, { blockTools: t1 } = e, o = [];
        Array.from(t1.entries()).forEach(([i, s])=>{
            s.isReadOnlySupported || o.push(i);
        }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);
    }
    /**
   * Set read-only mode or toggle current state
   * Call all Modules `toggleReadOnly` method and re-render Editor
   *
   * @param state - (optional) read-only state or toggle
   * @param isInitial - (optional) true when editor is initializing
   */ async toggle(e = !this.readOnlyEnabled, t1 = !1) {
        e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
        const o = this.readOnlyEnabled;
        this.readOnlyEnabled = e;
        for(const s in this.Editor)this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
        if (o === e) return this.readOnlyEnabled;
        if (t1) return this.readOnlyEnabled;
        this.Editor.ModificationsObserver.disable();
        const i = await this.Editor.Saver.save();
        return await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(i.blocks), this.Editor.ModificationsObserver.enable(), this.readOnlyEnabled;
    }
    /**
   * Throws an error about tools which don't support read-only mode
   */ throwCriticalError() {
        throw new $0cf1b19b2f7a01d6$var$Ho(`To enable read-only mode all connected tools should support it. Tools ${this.toolsDontSupportReadOnly.join(", ")} don't support read-only mode.`);
    }
}
class $0cf1b19b2f7a01d6$var$Be extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.isRectSelectionActivated = !1, this.SCROLL_SPEED = 3, this.HEIGHT_OF_SCROLL_ZONE = 40, this.BOTTOM_SCROLL_ZONE = 1, this.TOP_SCROLL_ZONE = 2, this.MAIN_MOUSE_BUTTON = 0, this.mousedown = !1, this.isScrolling = !1, this.inScrollZone = null, this.startX = 0, this.startY = 0, this.mouseX = 0, this.mouseY = 0, this.stackOfSelected = [], this.listenerIds = [];
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            overlay: "codex-editor-overlay",
            overlayContainer: "codex-editor-overlay__container",
            rect: "codex-editor-overlay__rectangle",
            topScrollZone: "codex-editor-overlay__scroll-zone--top",
            bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
        };
    }
    /**
   * Module Preparation
   * Creating rect and hang handlers
   */ prepare() {
        this.enableModuleBindings();
    }
    /**
   * Init rect params
   *
   * @param {number} pageX - X coord of mouse
   * @param {number} pageY - Y coord of mouse
   */ startSelection(e, t1) {
        const o = document.elementFromPoint(e - window.pageXOffset, t1 - window.pageYOffset);
        o.closest(`.${this.Editor.Toolbar.CSS.toolbar}`) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
        const s = [
            `.${$0cf1b19b2f7a01d6$var$R.CSS.content}`,
            `.${this.Editor.Toolbar.CSS.toolbar}`,
            `.${this.Editor.InlineToolbar.CSS.inlineToolbar}`
        ], r = o.closest("." + this.Editor.UI.CSS.editorWrapper), a = s.some((l)=>!!o.closest(l));
        !r || a || (this.mousedown = !0, this.startX = e, this.startY = t1);
    }
    /**
   * Clear all params to end selection
   */ endSelection() {
        this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
    }
    /**
   * is RectSelection Activated
   */ isRectActivated() {
        return this.isRectSelectionActivated;
    }
    /**
   * Mark that selection is end
   */ clearSelection() {
        this.isRectSelectionActivated = !1;
    }
    /**
   * Sets Module necessary event handlers
   */ enableModuleBindings() {
        const { container: e } = this.genHTML();
        this.listeners.on(e, "mousedown", (t1)=>{
            this.processMouseDown(t1);
        }, !1), this.listeners.on(document.body, "mousemove", $0cf1b19b2f7a01d6$var$dt((t1)=>{
            this.processMouseMove(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseleave", ()=>{
            this.processMouseLeave();
        }), this.listeners.on(window, "scroll", $0cf1b19b2f7a01d6$var$dt((t1)=>{
            this.processScroll(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseup", ()=>{
            this.processMouseUp();
        }, !1);
    }
    /**
   * Handle mouse down events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseDown(e) {
        if (e.button !== this.MAIN_MOUSE_BUTTON) return;
        e.target.closest($0cf1b19b2f7a01d6$var$u.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
    }
    /**
   * Handle mouse move events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseMove(e) {
        this.changingRectangle(e), this.scrollByZones(e.clientY);
    }
    /**
   * Handle mouse leave
   */ processMouseLeave() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processScroll(e) {
        this.changingRectangle(e);
    }
    /**
   * Handle mouse up
   */ processMouseUp() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * Scroll If mouse in scroll zone
   *
   * @param {number} clientY - Y coord of mouse
   */ scrollByZones(e) {
        if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
            this.isScrolling = !1;
            return;
        }
        this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
    }
    /**
   * Generates required HTML elements
   *
   * @returns {Object<string, Element>}
   */ genHTML() {
        const { UI: e } = this.Editor, t1 = e.nodes.holder.querySelector("." + e.CSS.editorWrapper), o = $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$Be.CSS.overlay, {}), i = $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$Be.CSS.overlayContainer, {}), s = $0cf1b19b2f7a01d6$var$u.make("div", $0cf1b19b2f7a01d6$var$Be.CSS.rect, {});
        return i.appendChild(s), o.appendChild(i), t1.appendChild(o), this.overlayRectangle = s, {
            container: t1,
            overlay: o
        };
    }
    /**
   * Activates scrolling if blockSelection is active and mouse is in scroll zone
   *
   * @param {number} speed - speed of scrolling
   */ scrollVertical(e) {
        if (!(this.inScrollZone && this.mousedown)) return;
        const t1 = window.pageYOffset;
        window.scrollBy(0, e), this.mouseY += window.pageYOffset - t1, setTimeout(()=>{
            this.scrollVertical(e);
        }, 0);
    }
    /**
   * Handles the change in the rectangle and its effect
   *
   * @param {MouseEvent} event - mouse event
   */ changingRectangle(e) {
        if (!this.mousedown) return;
        e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);
        const { rightPos: t1, leftPos: o, index: i } = this.genInfoForMouseSelection(), s = this.startX > t1 && this.mouseX > t1, r = this.startX < o && this.mouseX < o;
        this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), $0cf1b19b2f7a01d6$var$b.get().removeAllRanges());
    }
    /**
   * Shrink rect to singular point
   */ shrinkRectangleToPoint() {
        this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`;
    }
    /**
   * Select or unselect all of blocks in array if rect is out or in selectable area
   */ inverseSelection() {
        const t1 = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;
        if (this.rectCrossesBlocks && !t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.selectBlockByIndex(o);
        if (!this.rectCrossesBlocks && t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.unSelectBlockByIndex(o);
    }
    /**
   * Updates size of rectangle
   */ updateRectangleSize() {
        this.mouseY >= this.startY ? (this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.mouseY - window.pageYOffset}px`) : (this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.top = `${this.mouseY - window.pageYOffset}px`), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.mouseX - window.pageXOffset}px`) : (this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.left = `${this.mouseX - window.pageXOffset}px`);
    }
    /**
   * Collects information needed to determine the behavior of the rectangle
   *
   * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
   */ genInfoForMouseSelection() {
        const t1 = document.body.offsetWidth / 2, o = this.mouseY - window.pageYOffset, i = document.elementFromPoint(t1, o), s = this.Editor.BlockManager.getBlockByChildNode(i);
        let r;
        s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex((h)=>h.holder === s.holder));
        const a = this.Editor.BlockManager.lastBlock.holder.querySelector("." + $0cf1b19b2f7a01d6$var$R.CSS.content), l = Number.parseInt(window.getComputedStyle(a).width, 10) / 2, c = t1 - l, d = t1 + l;
        return {
            index: r,
            leftPos: c,
            rightPos: d
        };
    }
    /**
   * Select block with index index
   *
   * @param index - index of block in redactor
   */ addBlockInSelection(e) {
        this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
    }
    /**
   * Adds a block to the selection and determines which blocks should be selected
   *
   * @param {object} index - index of new block in the reactor
   */ trySelectNextBlock(e) {
        const t1 = this.stackOfSelected[this.stackOfSelected.length - 1] === e, o = this.stackOfSelected.length, i = 1, s = -1, r = 0;
        if (t1) return;
        const a = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
        let l = r;
        o > 1 && (l = a ? i : s);
        const c = e > this.stackOfSelected[o - 1] && l === i, d = e < this.stackOfSelected[o - 1] && l === s, p = !(c || d || l === r);
        if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
            let v = this.stackOfSelected[o - 1] + 1 || e;
            for(v; v <= e; v++)this.addBlockInSelection(v);
            return;
        }
        if (!p && e < this.stackOfSelected[o - 1]) {
            for(let v = this.stackOfSelected[o - 1] - 1; v >= e; v--)this.addBlockInSelection(v);
            return;
        }
        if (!p) return;
        let g = o - 1, f;
        for(e > this.stackOfSelected[o - 1] ? f = ()=>e > this.stackOfSelected[g] : f = ()=>e < this.stackOfSelected[g]; f();)this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
    }
}
class $0cf1b19b2f7a01d6$var$ga extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Renders passed blocks as one batch
   *
   * @param blocksData - blocks to render
   */ async render(e) {
        return new Promise((t1)=>{
            const { Tools: o, BlockManager: i } = this.Editor;
            if (e.length === 0) i.insert();
            else {
                const s = e.map(({ type: r, data: a, tunes: l, id: c })=>{
                    o.available.has(r) === !1 && ($0cf1b19b2f7a01d6$var$X(`Tool \xab${r}\xbb is not found. Check 'tools' property at the Editor.js config.`, "warn"), a = this.composeStubDataForTool(r, a, c), r = o.stubTool);
                    let d;
                    try {
                        d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    } catch (h) {
                        $0cf1b19b2f7a01d6$var$S(`Block \xab${r}\xbb skipped because of plugins error`, "error", {
                            data: a,
                            error: h
                        }), a = this.composeStubDataForTool(r, a, c), r = o.stubTool, d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    }
                    return d;
                });
                i.insertMany(s);
            }
            window.requestIdleCallback(()=>{
                t1();
            }, {
                timeout: 2e3
            });
        });
    }
    /**
   * Create data for the Stub Tool that will be used instead of unavailable tool
   *
   * @param tool - unavailable tool name to stub
   * @param data - data of unavailable block
   * @param [id] - id of unavailable block
   */ composeStubDataForTool(e, t1, o) {
        const { Tools: i } = this.Editor;
        let s = e;
        if (i.unavailable.has(e)) {
            const r = i.unavailable.get(e).toolbox;
            r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
        }
        return {
            savedData: {
                id: o,
                type: e,
                data: t1
            },
            title: s
        };
    }
}
class $0cf1b19b2f7a01d6$var$ma extends $0cf1b19b2f7a01d6$var$E {
    /**
   * Composes new chain of Promises to fire them alternatelly
   *
   * @returns {OutputData}
   */ async save() {
        const { BlockManager: e, Tools: t1 } = this.Editor, o = e.blocks, i = [];
        try {
            o.forEach((a)=>{
                i.push(this.getSavedData(a));
            });
            const s = await Promise.all(i), r = await $0cf1b19b2f7a01d6$var$yt(s, (a)=>t1.blockTools.get(a).sanitizeConfig);
            return this.makeOutput(r);
        } catch (s) {
            $0cf1b19b2f7a01d6$var$X("Saving failed due to the Error %o", "error", s);
        }
    }
    /**
   * Saves and validates
   *
   * @param {Block} block - Editor's Tool
   * @returns {ValidatedData} - Tool's validated data
   */ async getSavedData(e) {
        const t1 = await e.save(), o = t1 && await e.validate(t1.data);
        return {
            ...t1,
            isValid: o
        };
    }
    /**
   * Creates output object with saved data, time and version of editor
   *
   * @param {ValidatedData} allExtractedData - data extracted from Blocks
   * @returns {OutputData}
   */ makeOutput(e) {
        const t1 = [];
        return e.forEach(({ id: o, tool: i, data: s, tunes: r, isValid: a })=>{
            if (!a) {
                $0cf1b19b2f7a01d6$var$S(`Block \xab${i}\xbb skipped because saved data is invalid`);
                return;
            }
            if (i === this.Editor.Tools.stubTool) {
                t1.push(s);
                return;
            }
            const l = {
                id: o,
                type: i,
                data: s,
                ...!$0cf1b19b2f7a01d6$var$V(r) && {
                    tunes: r
                }
            };
            t1.push(l);
        }), {
            time: +/* @__PURE__ */ new Date(),
            blocks: t1,
            version: "2.31.6"
        };
    }
}
(function() {
    try {
        if (typeof document < "u") {
            var n = document.createElement("style");
            n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $0cf1b19b2f7a01d6$var$ba = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $0cf1b19b2f7a01d6$var$va(n) {
    const e = document.createElement("div");
    e.innerHTML = n.trim();
    const t1 = document.createDocumentFragment();
    return t1.append(...Array.from(e.childNodes)), t1;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $0cf1b19b2f7a01d6$var$fo {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: e, config: t1, api: o, readOnly: i }){
        this.api = o, this.readOnly = i, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t1.placeholder ? t1.placeholder : $0cf1b19b2f7a01d6$var$fo.DEFAULT_PLACEHOLDER, this._data = e ?? {}, this._element = null, this._preserveBlank = t1.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(e) {
        if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
        const { textContent: t1 } = this._element;
        t1 === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const e = document.createElement("DIV");
        return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(e) {
        if (!this._element) return;
        this._data.text += e.text;
        const t1 = $0cf1b19b2f7a01d6$var$va(e.text);
        this._element.appendChild(t1), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(e) {
        return !(e.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(e) {
        return {
            text: e.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(e) {
        const t1 = {
            text: e.detail.data.innerHTML
        };
        this._data = t1, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $0cf1b19b2f7a01d6$var$ba,
            title: "Text"
        };
    }
}
class $0cf1b19b2f7a01d6$var$go {
    constructor(){
        this.commandName = "bold";
    }
    /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            b: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return {
            icon: $0cf1b19b2f7a01d6$var$Ki,
            name: "bold",
            onActivate: ()=>{
                document.execCommand(this.commandName);
            },
            isActive: ()=>document.queryCommandState(this.commandName)
        };
    }
    /**
   * Set a shortcut
   *
   * @returns {boolean}
   */ get shortcut() {
        return "CMD+B";
    }
}
$0cf1b19b2f7a01d6$var$go.isInline = !0;
$0cf1b19b2f7a01d6$var$go.title = "Bold";
class $0cf1b19b2f7a01d6$var$mo {
    constructor(){
        this.commandName = "italic", this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--italic"
        }, this.nodes = {
            button: null
        };
    }
    /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            i: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $0cf1b19b2f7a01d6$var$Ji, this.nodes.button;
    }
    /**
   * Wrap range with <i> tag
   */ surround() {
        document.execCommand(this.commandName);
    }
    /**
   * Check selection and set activated state to button if there are <i> tag
   */ checkState() {
        const e = document.queryCommandState(this.commandName);
        return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+I";
    }
}
$0cf1b19b2f7a01d6$var$mo.isInline = !0;
$0cf1b19b2f7a01d6$var$mo.title = "Italic";
class $0cf1b19b2f7a01d6$var$bo {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--link",
            buttonUnlink: "ce-inline-tool--unlink",
            input: "ce-inline-tool-input",
            inputShowed: "ce-inline-tool-input--showed"
        }, this.nodes = {
            button: null,
            input: null
        }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new $0cf1b19b2f7a01d6$var$b();
    }
    /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            a: {
                href: !0,
                target: "_blank",
                rel: "nofollow"
            }
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $0cf1b19b2f7a01d6$var$Co, this.nodes.button;
    }
    /**
   * Input for the link
   */ renderActions() {
        return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", (e)=>{
            e.keyCode === this.ENTER_KEY && this.enterPressed(e);
        }), this.nodes.input;
    }
    /**
   * Handle clicks on the Inline Toolbar icon
   *
   * @param {Range} range - range to wrap with link
   */ surround(e) {
        if (e) {
            this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
            const t1 = this.selection.findParentTag("A");
            if (t1) {
                this.inputOpened ? (this.closeActions(!1), this.checkState()) : (this.selection.expandToTag(t1), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close());
                return;
            }
        }
        this.toggleActions();
    }
    /**
   * Check selection and set activated state to button if there are <a> tag
   */ checkState() {
        const e = this.selection.findParentTag("A");
        if (e) {
            this.nodes.button.innerHTML = $0cf1b19b2f7a01d6$var$ns, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
            const t1 = e.getAttribute("href");
            this.nodes.input.defaultValue = t1 !== "null" ? t1 : "", this.selection.save();
        } else this.nodes.button.innerHTML = $0cf1b19b2f7a01d6$var$Co, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);
        return !!e;
    }
    /**
   * Function called with Inline Toolbar closing
   */ clear() {
        this.closeActions();
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+K";
    }
    /**
   * Show/close link input
   */ toggleActions() {
        this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
    }
    /**
   * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
   */ openActions(e = !1) {
        this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
    }
    /**
   * Close input
   *
   * @param {boolean} clearSavedSelection — we don't need to clear saved selection
   *                                        on toggle-clicks on the icon of opened Toolbar
   */ closeActions(e = !0) {
        if (this.selection.isFakeBackgroundEnabled) {
            const t1 = new $0cf1b19b2f7a01d6$var$b();
            t1.save(), this.selection.restore(), this.selection.removeFakeBackground(), t1.restore();
        }
        this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
    }
    /**
   * Enter pressed on input
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ enterPressed(e) {
        let t1 = this.nodes.input.value || "";
        if (!t1.trim()) {
            this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
            return;
        }
        if (!this.validateURL(t1)) {
            this.notifier.show({
                message: "Pasted link is not valid.",
                style: "error"
            }), $0cf1b19b2f7a01d6$var$S("Incorrect Link pasted", "warn", t1);
            return;
        }
        t1 = this.prepareLink(t1), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t1), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
    }
    /**
   * Detects if passed string is URL
   *
   * @param {string} str - string to validate
   * @returns {boolean}
   */ validateURL(e) {
        return !/\s/.test(e);
    }
    /**
   * Process link before injection
   * - sanitize
   * - add protocol for links like 'google.com'
   *
   * @param {string} link - raw user input
   */ prepareLink(e) {
        return e = e.trim(), e = this.addProtocol(e), e;
    }
    /**
   * Add 'http' protocol to the links like 'vc.ru', 'google.com'
   *
   * @param {string} link - string to process
   */ addProtocol(e) {
        if (/^(\w+):(\/\/)?/.test(e)) return e;
        const t1 = /^\/[^/\s]/.test(e), o = e.substring(0, 1) === "#", i = /^\/\/[^/\s]/.test(e);
        return !t1 && !o && !i && (e = "http://" + e), e;
    }
    /**
   * Inserts <a> tag with "href"
   *
   * @param {string} link - "href" value
   */ insertLink(e) {
        const t1 = this.selection.findParentTag("A");
        t1 && this.selection.expandToTag(t1), document.execCommand(this.commandLink, !1, e);
    }
    /**
   * Removes <a> tag
   */ unlink() {
        document.execCommand(this.commandUnlink);
    }
}
$0cf1b19b2f7a01d6$var$bo.isInline = !0;
$0cf1b19b2f7a01d6$var$bo.title = "Link";
class $0cf1b19b2f7a01d6$var$Fn {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
    }
    /**
   * Returns tool's UI config
   */ async render() {
        const e = $0cf1b19b2f7a01d6$var$b.get(), t1 = this.blocksAPI.getBlockByElement(e.anchorNode);
        if (t1 === void 0) return [];
        const o = this.toolsAPI.getBlockTools(), i = await $0cf1b19b2f7a01d6$var$Yo(t1, o);
        if (i.length === 0) return [];
        const s = i.reduce((c, d)=>{
            var h;
            return (h = d.toolbox) == null || h.forEach((p)=>{
                c.push({
                    icon: p.icon,
                    title: $0cf1b19b2f7a01d6$var$z.t($0cf1b19b2f7a01d6$var$K.toolNames, p.title),
                    name: d.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const g = await this.blocksAPI.convert(t1.id, d.name, p.data);
                        this.caretAPI.setToBlock(g, "end");
                    }
                });
            }), c;
        }, []), r = await t1.getActiveToolboxEntry(), a = r !== void 0 ? r.icon : $0cf1b19b2f7a01d6$var$Go, l = !$0cf1b19b2f7a01d6$var$be();
        return {
            icon: a,
            name: "convert-to",
            hint: {
                title: this.i18nAPI.t("Convert to")
            },
            children: {
                searchable: l,
                items: s,
                onOpen: ()=>{
                    l && (this.selectionAPI.setFakeBackground(), this.selectionAPI.save());
                },
                onClose: ()=>{
                    l && (this.selectionAPI.restore(), this.selectionAPI.removeFakeBackground());
                }
            }
        };
    }
}
$0cf1b19b2f7a01d6$var$Fn.isInline = !0;
class $0cf1b19b2f7a01d6$var$jn {
    /**
   * @param options - constructor options
   * @param options.data - stub tool data
   * @param options.api - Editor.js API
   */ constructor({ data: e, api: t1 }){
        this.CSS = {
            wrapper: "ce-stub",
            info: "ce-stub__info",
            title: "ce-stub__title",
            subtitle: "ce-stub__subtitle"
        }, this.api = t1, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
    }
    /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */ render() {
        return this.wrapper;
    }
    /**
   * Return original Tool data
   *
   * @returns {BlockToolData}
   */ save() {
        return this.savedData;
    }
    /**
   * Create Tool html markup
   *
   * @returns {HTMLElement}
   */ make() {
        const e = $0cf1b19b2f7a01d6$var$u.make("div", this.CSS.wrapper), t1 = $0cf1b19b2f7a01d6$var$is, o = $0cf1b19b2f7a01d6$var$u.make("div", this.CSS.info), i = $0cf1b19b2f7a01d6$var$u.make("div", this.CSS.title, {
            textContent: this.title
        }), s = $0cf1b19b2f7a01d6$var$u.make("div", this.CSS.subtitle, {
            textContent: this.subtitle
        });
        return e.innerHTML = t1, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
    }
}
$0cf1b19b2f7a01d6$var$jn.isReadOnlySupported = !0;
class $0cf1b19b2f7a01d6$var$ka extends $0cf1b19b2f7a01d6$var$Tt {
    constructor(){
        super(...arguments), this.type = $0cf1b19b2f7a01d6$var$ae.Inline;
    }
    /**
   * Returns title for Inline Tool if specified by user
   */ get title() {
        return this.constructable[$0cf1b19b2f7a01d6$var$We.Title];
    }
    /**
   * Constructs new InlineTool instance from constructable
   */ create() {
        return new this.constructable({
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Allows inline tool to be available in read-only mode
   * Can be used, for example, by comments tool
   */ get isReadOnlySupported() {
        return this.constructable[$0cf1b19b2f7a01d6$var$We.IsReadOnlySupported] ?? !1;
    }
}
class $0cf1b19b2f7a01d6$var$ya extends $0cf1b19b2f7a01d6$var$Tt {
    constructor(){
        super(...arguments), this.type = $0cf1b19b2f7a01d6$var$ae.Tune;
    }
    /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */ create(e, t1) {
        return new this.constructable({
            api: this.api,
            config: this.settings,
            block: t1,
            data: e
        });
    }
}
class $0cf1b19b2f7a01d6$var$j extends Map {
    /**
   * Returns Block Tools collection
   */ get blockTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isBlock());
        return new $0cf1b19b2f7a01d6$var$j(e);
    }
    /**
   * Returns Inline Tools collection
   */ get inlineTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInline());
        return new $0cf1b19b2f7a01d6$var$j(e);
    }
    /**
   * Returns Block Tunes collection
   */ get blockTunes() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isTune());
        return new $0cf1b19b2f7a01d6$var$j(e);
    }
    /**
   * Returns internal Tools collection
   */ get internalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInternal);
        return new $0cf1b19b2f7a01d6$var$j(e);
    }
    /**
   * Returns Tools collection provided by user
   */ get externalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>!t1.isInternal);
        return new $0cf1b19b2f7a01d6$var$j(e);
    }
}
var $0cf1b19b2f7a01d6$var$wa = Object.defineProperty, $0cf1b19b2f7a01d6$var$Ea = Object.getOwnPropertyDescriptor, $0cf1b19b2f7a01d6$var$Hn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $0cf1b19b2f7a01d6$var$Ea(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $0cf1b19b2f7a01d6$var$wa(e, t1, i), i;
};
class $0cf1b19b2f7a01d6$var$vo extends $0cf1b19b2f7a01d6$var$Tt {
    constructor(){
        super(...arguments), this.type = $0cf1b19b2f7a01d6$var$ae.Block, this.inlineTools = new $0cf1b19b2f7a01d6$var$j(), this.tunes = new $0cf1b19b2f7a01d6$var$j();
    }
    /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */ create(e, t1, o) {
        return new this.constructable({
            data: e,
            block: t1,
            readOnly: o,
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Returns true if read-only mode is supported by Tool
   */ get isReadOnlySupported() {
        return this.constructable[$0cf1b19b2f7a01d6$var$pe.IsReadOnlySupported] === !0;
    }
    /**
   * Returns true if Tool supports linebreaks
   */ get isLineBreaksEnabled() {
        return this.constructable[$0cf1b19b2f7a01d6$var$pe.IsEnabledLineBreaks];
    }
    /**
   * Returns Tool toolbox configuration (internal or user-specified).
   *
   * Merges internal and user-defined toolbox configs based on the following rules:
   *
   * - If both internal and user-defined toolbox configs are arrays their items are merged.
   * Length of the second one is kept.
   *
   * - If both are objects their properties are merged.
   *
   * - If one is an object and another is an array than internal config is replaced with user-defined
   * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
   */ get toolbox() {
        const e = this.constructable[$0cf1b19b2f7a01d6$var$pe.Toolbox], t1 = this.config[$0cf1b19b2f7a01d6$var$Pe.Toolbox];
        if (!$0cf1b19b2f7a01d6$var$V(e) && t1 !== !1) return t1 ? Array.isArray(e) ? Array.isArray(t1) ? t1.map((o, i)=>{
            const s = e[i];
            return s ? {
                ...s,
                ...o
            } : o;
        }) : [
            t1
        ] : Array.isArray(t1) ? t1 : [
            {
                ...e,
                ...t1
            }
        ] : Array.isArray(e) ? e : [
            e
        ];
    }
    /**
   * Returns Tool conversion configuration
   */ get conversionConfig() {
        return this.constructable[$0cf1b19b2f7a01d6$var$pe.ConversionConfig];
    }
    /**
   * Returns enabled inline tools for Tool
   */ get enabledInlineTools() {
        return this.config[$0cf1b19b2f7a01d6$var$Pe.EnabledInlineTools] || !1;
    }
    /**
   * Returns enabled tunes for Tool
   */ get enabledBlockTunes() {
        return this.config[$0cf1b19b2f7a01d6$var$Pe.EnabledBlockTunes];
    }
    /**
   * Returns Tool paste configuration
   */ get pasteConfig() {
        return this.constructable[$0cf1b19b2f7a01d6$var$pe.PasteConfig] ?? {};
    }
    get sanitizeConfig() {
        const e = super.sanitizeConfig, t1 = this.baseSanitizeConfig;
        if ($0cf1b19b2f7a01d6$var$V(e)) return t1;
        const o = {};
        for(const i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
            const s = e[i];
            $0cf1b19b2f7a01d6$var$D(s) ? o[i] = Object.assign({}, t1, s) : o[i] = s;
        }
        return o;
    }
    get baseSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), Array.from(this.tunes.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), e;
    }
}
$0cf1b19b2f7a01d6$var$Hn([
    $0cf1b19b2f7a01d6$var$me
], $0cf1b19b2f7a01d6$var$vo.prototype, "sanitizeConfig", 1);
$0cf1b19b2f7a01d6$var$Hn([
    $0cf1b19b2f7a01d6$var$me
], $0cf1b19b2f7a01d6$var$vo.prototype, "baseSanitizeConfig", 1);
class $0cf1b19b2f7a01d6$var$xa {
    /**
   * @class
   * @param config - tools config
   * @param editorConfig - EditorJS config
   * @param api - EditorJS API module
   */ constructor(e, t1, o){
        this.api = o, this.config = e, this.editorConfig = t1;
    }
    /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */ get(e) {
        const { class: t1, isInternal: o = !1, ...i } = this.config[e], s = this.getConstructor(t1), r = t1[$0cf1b19b2f7a01d6$var$mt.IsTune];
        return new s({
            name: e,
            constructable: t1,
            config: i,
            api: this.api.getMethodsForTool(e, r),
            isDefault: e === this.editorConfig.defaultBlock,
            defaultPlaceholder: this.editorConfig.placeholder,
            isInternal: o
        });
    }
    /**
   * Find appropriate Tool object constructor for Tool constructable
   *
   * @param constructable - Tools constructable
   */ getConstructor(e) {
        switch(!0){
            case e[$0cf1b19b2f7a01d6$var$We.IsInline]:
                return $0cf1b19b2f7a01d6$var$ka;
            case e[$0cf1b19b2f7a01d6$var$mt.IsTune]:
                return $0cf1b19b2f7a01d6$var$ya;
            default:
                return $0cf1b19b2f7a01d6$var$vo;
        }
    }
}
class $0cf1b19b2f7a01d6$var$$n {
    /**
   * MoveDownTune constructor
   *
   * @param {API} api — Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $0cf1b19b2f7a01d6$var$Xi,
            title: this.api.i18n.t("Move down"),
            onActivate: ()=>this.handleClick(),
            name: "move-down"
        };
    }
    /**
   * Handle clicks on 'move down' button
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e + 1);
        if (!t1) throw new Error("Unable to move Block down since it is already the last");
        const o = t1.holder, i = o.getBoundingClientRect();
        let s = Math.abs(window.innerHeight - o.offsetHeight);
        i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$0cf1b19b2f7a01d6$var$$n.isTune = !0;
class $0cf1b19b2f7a01d6$var$zn {
    /**
   * DeleteTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $0cf1b19b2f7a01d6$var$Gi,
            title: this.api.i18n.t("Delete"),
            name: "delete",
            confirmation: {
                title: this.api.i18n.t("Click to delete"),
                onActivate: ()=>this.handleClick()
            }
        };
    }
    /**
   * Delete block conditions passed
   */ handleClick() {
        this.api.blocks.delete();
    }
}
$0cf1b19b2f7a01d6$var$zn.isTune = !0;
class $0cf1b19b2f7a01d6$var$Un {
    /**
   * MoveUpTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $0cf1b19b2f7a01d6$var$Zi,
            title: this.api.i18n.t("Move up"),
            onActivate: ()=>this.handleClick(),
            name: "move-up"
        };
    }
    /**
   * Move current block up
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e), o = this.api.blocks.getBlockByIndex(e - 1);
        if (e === 0 || !t1 || !o) throw new Error("Unable to move Block up since it is already the first");
        const i = t1.holder, s = o.holder, r = i.getBoundingClientRect(), a = s.getBoundingClientRect();
        let l;
        a.top > 0 ? l = Math.abs(r.top) - Math.abs(a.top) : l = Math.abs(r.top) + a.height, window.scrollBy(0, -1 * l), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$0cf1b19b2f7a01d6$var$Un.isTune = !0;
var $0cf1b19b2f7a01d6$var$Ba = Object.defineProperty, $0cf1b19b2f7a01d6$var$Ca = Object.getOwnPropertyDescriptor, $0cf1b19b2f7a01d6$var$Ta = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $0cf1b19b2f7a01d6$var$Ca(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $0cf1b19b2f7a01d6$var$Ba(e, t1, i), i;
};
class $0cf1b19b2f7a01d6$var$Wn extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.stubTool = "stub", this.toolsAvailable = new $0cf1b19b2f7a01d6$var$j(), this.toolsUnavailable = new $0cf1b19b2f7a01d6$var$j();
    }
    /**
   * Returns available Tools
   */ get available() {
        return this.toolsAvailable;
    }
    /**
   * Returns unavailable Tools
   */ get unavailable() {
        return this.toolsUnavailable;
    }
    /**
   * Return Tools for the Inline Toolbar
   */ get inlineTools() {
        return this.available.inlineTools;
    }
    /**
   * Return editor block tools
   */ get blockTools() {
        return this.available.blockTools;
    }
    /**
   * Return available Block Tunes
   *
   * @returns {object} - object of Inline Tool's classes
   */ get blockTunes() {
        return this.available.blockTunes;
    }
    /**
   * Returns default Tool object
   */ get defaultTool() {
        return this.blockTools.get(this.config.defaultBlock);
    }
    /**
   * Returns internal tools
   */ get internal() {
        return this.available.internalTools;
    }
    /**
   * Creates instances via passed or default configuration
   *
   * @returns {Promise<void>}
   */ async prepare() {
        if (this.validateTools(), this.config.tools = $0cf1b19b2f7a01d6$var$ut({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0) throw Error("Can't start without tools");
        const e = this.prepareConfig();
        this.factory = new $0cf1b19b2f7a01d6$var$xa(e, this.config, this.Editor.API);
        const t1 = this.getListOfPrepareFunctions(e);
        if (t1.length === 0) return Promise.resolve();
        await $0cf1b19b2f7a01d6$var$Qn(t1, (o)=>{
            this.toolPrepareMethodSuccess(o);
        }, (o)=>{
            this.toolPrepareMethodFallback(o);
        }), this.prepareBlockTools();
    }
    getAllInlineToolsSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>{
            Object.assign(e, t1.sanitizeConfig);
        }), e;
    }
    /**
   * Calls each Tool reset method to clean up anything set by Tool
   */ destroy() {
        Object.values(this.available).forEach(async (e)=>{
            $0cf1b19b2f7a01d6$var$A(e.reset) && await e.reset();
        });
    }
    /**
   * Returns internal tools
   * Includes Bold, Italic, Link and Paragraph
   */ get internalTools() {
        return {
            convertTo: {
                class: $0cf1b19b2f7a01d6$var$Fn,
                isInternal: !0
            },
            link: {
                class: $0cf1b19b2f7a01d6$var$bo,
                isInternal: !0
            },
            bold: {
                class: $0cf1b19b2f7a01d6$var$go,
                isInternal: !0
            },
            italic: {
                class: $0cf1b19b2f7a01d6$var$mo,
                isInternal: !0
            },
            paragraph: {
                class: $0cf1b19b2f7a01d6$var$fo,
                inlineToolbar: !0,
                isInternal: !0
            },
            stub: {
                class: $0cf1b19b2f7a01d6$var$jn,
                isInternal: !0
            },
            moveUp: {
                class: $0cf1b19b2f7a01d6$var$Un,
                isInternal: !0
            },
            delete: {
                class: $0cf1b19b2f7a01d6$var$zn,
                isInternal: !0
            },
            moveDown: {
                class: $0cf1b19b2f7a01d6$var$$n,
                isInternal: !0
            }
        };
    }
    /**
   * Tool prepare method success callback
   *
   * @param {object} data - append tool to available list
   */ toolPrepareMethodSuccess(e) {
        const t1 = this.factory.get(e.toolName);
        if (t1.isInline()) {
            const i = [
                "render"
            ].filter((s)=>!t1.create()[s]);
            if (i.length) {
                $0cf1b19b2f7a01d6$var$S(`Incorrect Inline Tool: ${t1.name}. Some of required methods is not implemented %o`, "warn", i), this.toolsUnavailable.set(t1.name, t1);
                return;
            }
        }
        this.toolsAvailable.set(t1.name, t1);
    }
    /**
   * Tool prepare method fail callback
   *
   * @param {object} data - append tool to unavailable list
   */ toolPrepareMethodFallback(e) {
        this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
    }
    /**
   * Binds prepare function of plugins with user or default config
   *
   * @returns {Array} list of functions that needs to be fired sequentially
   * @param config - tools config
   */ getListOfPrepareFunctions(e) {
        const t1 = [];
        return Object.entries(e).forEach(([o, i])=>{
            t1.push({
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                function: $0cf1b19b2f7a01d6$var$A(i.class.prepare) ? i.class.prepare : ()=>{},
                data: {
                    toolName: o,
                    config: i.config
                }
            });
        }), t1;
    }
    /**
   * Assign enabled Inline Tools and Block Tunes for Block Tool
   */ prepareBlockTools() {
        Array.from(this.blockTools.values()).forEach((e)=>{
            this.assignInlineToolsToBlockTool(e), this.assignBlockTunesToBlockTool(e);
        });
    }
    /**
   * Assign enabled Inline Tools for Block Tool
   *
   * @param tool - Block Tool
   */ assignInlineToolsToBlockTool(e) {
        if (this.config.inlineToolbar !== !1) {
            if (e.enabledInlineTools === !0) {
                e.inlineTools = new $0cf1b19b2f7a01d6$var$j(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map((t1)=>[
                        t1,
                        this.inlineTools.get(t1)
                    ]) : Array.from(this.inlineTools.entries()));
                return;
            }
            Array.isArray(e.enabledInlineTools) && (e.inlineTools = new $0cf1b19b2f7a01d6$var$j(/** Prepend ConvertTo Inline Tool */ [
                "convertTo",
                ...e.enabledInlineTools
            ].map((t1)=>[
                    t1,
                    this.inlineTools.get(t1)
                ])));
        }
    }
    /**
   * Assign enabled Block Tunes for Block Tool
   *
   * @param tool — Block Tool
   */ assignBlockTunesToBlockTool(e) {
        if (e.enabledBlockTunes !== !1) {
            if (Array.isArray(e.enabledBlockTunes)) {
                const t1 = new $0cf1b19b2f7a01d6$var$j(e.enabledBlockTunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $0cf1b19b2f7a01d6$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            if (Array.isArray(this.config.tunes)) {
                const t1 = new $0cf1b19b2f7a01d6$var$j(this.config.tunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $0cf1b19b2f7a01d6$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            e.tunes = this.blockTunes.internalTools;
        }
    }
    /**
   * Validate Tools configuration objects and throw Error for user if it is invalid
   */ validateTools() {
        for(const e in this.config.tools)if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
            if (e in this.internalTools) return;
            const t1 = this.config.tools[e];
            if (!$0cf1b19b2f7a01d6$var$A(t1) && !$0cf1b19b2f7a01d6$var$A(t1.class)) throw Error(`Tool \xab${e}\xbb must be a constructor function or an object with function in the \xabclass\xbb property`);
        }
    }
    /**
   * Unify tools config
   */ prepareConfig() {
        const e = {};
        for(const t1 in this.config.tools)$0cf1b19b2f7a01d6$var$D(this.config.tools[t1]) ? e[t1] = this.config.tools[t1] : e[t1] = {
            class: this.config.tools[t1]
        };
        return e;
    }
}
$0cf1b19b2f7a01d6$var$Ta([
    $0cf1b19b2f7a01d6$var$me
], $0cf1b19b2f7a01d6$var$Wn.prototype, "getAllInlineToolsSanitizeConfig", 1);
const $0cf1b19b2f7a01d6$var$Sa = `:root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:"\\feff"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:"";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:"";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}
`;
class $0cf1b19b2f7a01d6$var$Ia extends $0cf1b19b2f7a01d6$var$E {
    constructor(){
        super(...arguments), this.isMobile = !1, this.contentRectCache = null, this.resizeDebouncer = $0cf1b19b2f7a01d6$var$Eo(()=>{
            this.windowResize();
        }, 200), this.selectionChangeDebounced = $0cf1b19b2f7a01d6$var$Eo(()=>{
            this.selectionChanged();
        }, $0cf1b19b2f7a01d6$var$da), this.documentTouchedListener = (e)=>{
            this.documentTouched(e);
        };
    }
    /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorWrapperNarrow: "codex-editor--narrow",
            editorZone: "codex-editor__redactor",
            editorZoneHidden: "codex-editor__redactor--hidden",
            editorEmpty: "codex-editor--empty",
            editorRtlFix: "codex-editor--rtl"
        };
    }
    /**
   * Return Width of center column of Editor
   *
   * @returns {DOMRect}
   */ get contentRect() {
        if (this.contentRectCache !== null) return this.contentRectCache;
        const e = this.nodes.wrapper.querySelector(`.${$0cf1b19b2f7a01d6$var$R.CSS.content}`);
        return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
            width: 650,
            left: 0,
            right: 0
        };
    }
    /**
   * Making main interface
   */ async prepare() {
        this.setIsMobile(), this.make(), this.loadStyles();
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - removes all listeners from main UI module elements
   *
   * if readOnly is false:
   *  - enables all listeners to UI module elements
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.unbindReadOnlySensitiveListeners() : window.requestIdleCallback(()=>{
            this.bindReadOnlySensitiveListeners();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Check if Editor is empty and set CSS class to wrapper
   */ checkEmptiness() {
        const { BlockManager: e } = this.Editor;
        this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
    }
    /**
   * Check if one of Toolbar is opened
   * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
   *
   * @returns {boolean}
   */ get someToolbarOpened() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        return !!(t1.opened || o.opened || e.toolbox.opened);
    }
    /**
   * Check for some Flipper-buttons is under focus
   */ get someFlipperButtonFocused() {
        return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(([e, t1])=>t1.flipper instanceof $0cf1b19b2f7a01d6$var$ce).some(([e, t1])=>t1.flipper.hasFocus());
    }
    /**
   * Clean editor`s UI
   */ destroy() {
        this.nodes.holder.innerHTML = "", this.unbindReadOnlyInsensitiveListeners();
    }
    /**
   * Close all Editor's toolbars
   */ closeAllToolbars() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        t1.close(), o.close(), e.toolbox.close();
    }
    /**
   * Check for mobile mode and save the result
   */ setIsMobile() {
        const e = window.innerWidth < $0cf1b19b2f7a01d6$var$Ro;
        e !== this.isMobile && this.eventsDispatcher.emit($0cf1b19b2f7a01d6$var$Te, {
            isEnabled: this.isMobile
        }), this.isMobile = e;
    }
    /**
   * Makes Editor.js interface
   */ make() {
        this.nodes.holder = $0cf1b19b2f7a01d6$var$u.getHolder(this.config.holder), this.nodes.wrapper = $0cf1b19b2f7a01d6$var$u.make("div", [
            this.CSS.editorWrapper,
            ...this.isRtl ? [
                this.CSS.editorRtlFix
            ] : []
        ]), this.nodes.redactor = $0cf1b19b2f7a01d6$var$u.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper), this.bindReadOnlyInsensitiveListeners();
    }
    /**
   * Appends CSS
   */ loadStyles() {
        const e = "editor-js-styles";
        if ($0cf1b19b2f7a01d6$var$u.get(e)) return;
        const t1 = $0cf1b19b2f7a01d6$var$u.make("style", null, {
            id: e,
            textContent: $0cf1b19b2f7a01d6$var$Sa.toString()
        });
        this.config.style && !$0cf1b19b2f7a01d6$var$V(this.config.style) && this.config.style.nonce && t1.setAttribute("nonce", this.config.style.nonce), $0cf1b19b2f7a01d6$var$u.prepend(document.head, t1);
    }
    /**
   * Adds listeners that should work both in read-only and read-write modes
   */ bindReadOnlyInsensitiveListeners() {
        this.listeners.on(document, "selectionchange", this.selectionChangeDebounced), this.listeners.on(window, "resize", this.resizeDebouncer, {
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "mousedown", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "touchstart", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        });
    }
    /**
   * Removes listeners that should work both in read-only and read-write modes
   */ unbindReadOnlyInsensitiveListeners() {
        this.listeners.off(document, "selectionchange", this.selectionChangeDebounced), this.listeners.off(window, "resize", this.resizeDebouncer), this.listeners.off(this.nodes.redactor, "mousedown", this.documentTouchedListener), this.listeners.off(this.nodes.redactor, "touchstart", this.documentTouchedListener);
    }
    /**
   * Adds listeners that should work only in read-only mode
   */ bindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.on(this.nodes.redactor, "click", (e)=>{
            this.redactorClicked(e);
        }, !1), this.readOnlyMutableListeners.on(document, "keydown", (e)=>{
            this.documentKeydown(e);
        }, !0), this.readOnlyMutableListeners.on(document, "mousedown", (e)=>{
            this.documentClicked(e);
        }, !0), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
    }
    /**
   * Listen redactor mousemove to emit 'block-hovered' event
   */ watchBlockHoveredEvents() {
        let e;
        this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", $0cf1b19b2f7a01d6$var$dt((t1)=>{
            const o = t1.target.closest(".ce-block");
            this.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, this.eventsDispatcher.emit($0cf1b19b2f7a01d6$var$ln, {
                block: this.Editor.BlockManager.getBlockByChildNode(o)
            }));
        }, 20), {
            passive: !0
        });
    }
    /**
   * Unbind events that should work only in read-only mode
   */ unbindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Resize window handler
   */ windowResize() {
        this.contentRectCache = null, this.setIsMobile();
    }
    /**
   * All keydowns on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ documentKeydown(e) {
        switch(e.keyCode){
            case $0cf1b19b2f7a01d6$var$y.ENTER:
                this.enterPressed(e);
                break;
            case $0cf1b19b2f7a01d6$var$y.BACKSPACE:
            case $0cf1b19b2f7a01d6$var$y.DELETE:
                this.backspacePressed(e);
                break;
            case $0cf1b19b2f7a01d6$var$y.ESC:
                this.escapePressed(e);
                break;
            default:
                this.defaultBehaviour(e);
                break;
        }
    }
    /**
   * Ignore all other document's keydown events
   *
   * @param {KeyboardEvent} event - keyboard event
   */ defaultBehaviour(e) {
        const { currentBlock: t1 } = this.Editor.BlockManager, o = e.target.closest(`.${this.CSS.editorWrapper}`), i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
        if (t1 !== void 0 && o === null) {
            this.Editor.BlockEvents.keydown(e);
            return;
        }
        o || t1 && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
    }
    /**
   * @param {KeyboardEvent} event - keyboard event
   */ backspacePressed(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor;
        if (o.anyBlockSelected && !$0cf1b19b2f7a01d6$var$b.isSelectionExists) {
            const s = t1.removeSelectedBlocks(), r = t1.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
    }
    /**
   * Escape pressed
   * If some of Toolbar components are opened, then close it otherwise close Toolbar
   *
   * @param {Event} event - escape keydown event
   */ escapePressed(e) {
        this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
    }
    /**
   * Enter pressed on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ enterPressed(e) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        if (this.someToolbarOpened) return;
        const i = t1.currentBlockIndex >= 0;
        if (o.anyBlockSelected && !$0cf1b19b2f7a01d6$var$b.isSelectionExists) {
            o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
            return;
        }
        if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
            const s = this.Editor.BlockManager.insert();
            e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * All clicks on document
   *
   * @param {MouseEvent} event - Click event
   */ documentClicked(e) {
        var a, l;
        if (!e.isTrusted) return;
        const t1 = e.target;
        this.nodes.holder.contains(t1) || $0cf1b19b2f7a01d6$var$b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
        const i = (a = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : a.contains(t1), s = (l = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : l.contains(t1), r = i || s;
        if (this.Editor.BlockSettings.opened && !r) {
            this.Editor.BlockSettings.close();
            const c = this.Editor.BlockManager.getBlockByChildNode(t1);
            this.Editor.Toolbar.moveAndOpen(c);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * First touch on editor
   * Fired before click
   *
   * Used to change current block — we need to do it before 'selectionChange' event.
   * Also:
   * - Move and show the Toolbar
   * - Set a Caret
   *
   * @param event - touch or mouse event
   */ documentTouched(e) {
        let t1 = e.target;
        if (t1 === this.nodes.redactor) {
            const o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX, i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
            t1 = document.elementFromPoint(o, i);
        }
        try {
            this.Editor.BlockManager.setCurrentBlockByChildNode(t1);
        } catch  {
            this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
        }
        this.Editor.ReadOnly.isEnabled || this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * All clicks on the redactor zone
   *
   * @param {MouseEvent} event - click event
   * @description
   * - By clicks on the Editor's bottom zone:
   *      - if last Block is empty, set a Caret to this
   *      - otherwise, add a new empty Block and set a Caret to that
   */ redactorClicked(e) {
        if (!$0cf1b19b2f7a01d6$var$b.isCollapsed) return;
        const t1 = e.target, o = e.metaKey || e.ctrlKey, i = $0cf1b19b2f7a01d6$var$u.getClosestAnchor(t1);
        if (i && o) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const s = i.getAttribute("href"), r = $0cf1b19b2f7a01d6$var$oi(s);
            $0cf1b19b2f7a01d6$var$ii(r);
            return;
        }
        this.processBottomZoneClick(e);
    }
    /**
   * Check if user clicks on the Editor's bottom zone:
   *  - set caret to the last block
   *  - or add new empty block
   *
   * @param event - click event
   */ processBottomZoneClick(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(-1), o = $0cf1b19b2f7a01d6$var$u.offset(t1.holder).bottom, i = e.pageY, { BlockSelection: s } = this.Editor;
        if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) && /**
    * If there is cross block selection started, target will be equal to redactor so we need additional check
    */ !s.anyBlockSelected && /**
    * Prevent caret jumping (to last block) when clicking between blocks
    */ o < i) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const { BlockManager: a, Caret: l, Toolbar: c } = this.Editor;
            (!a.lastBlock.tool.isDefault || !a.lastBlock.isEmpty) && a.insertAtEnd(), l.setToTheLastBlock(), c.moveAndOpen(a.lastBlock);
        }
    }
    /**
   * Handle selection changes on mobile devices
   * Uses for showing the Inline Toolbar
   */ selectionChanged() {
        const { CrossBlockSelection: e, BlockSelection: t1 } = this.Editor, o = $0cf1b19b2f7a01d6$var$b.anchorElement;
        if (e.isCrossBlockSelectionStarted && t1.anyBlockSelected && $0cf1b19b2f7a01d6$var$b.get().removeAllRanges(), !o) {
            $0cf1b19b2f7a01d6$var$b.range || this.Editor.InlineToolbar.close();
            return;
        }
        const i = o.closest(`.${$0cf1b19b2f7a01d6$var$R.CSS.content}`);
        (i === null || i.closest(`.${$0cf1b19b2f7a01d6$var$b.CSS.editorWrapper}`) !== this.nodes.wrapper) && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
    }
    /**
   * Editor.js provides and ability to show placeholders for empty contenteditable elements
   *
   * This method watches for input and focus events and toggles 'data-empty' attribute
   * to workaroud the case, when inputs contains only <br>s and has no visible content
   * Then, CSS could rely on this attribute to show placeholders
   */ enableInputsEmptyMark() {
        function e(t1) {
            const o = t1.target;
            $0cf1b19b2f7a01d6$var$Do(o);
        }
        this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
    }
}
const $0cf1b19b2f7a01d6$var$Oa = {
    // API Modules
    BlocksAPI: $0cf1b19b2f7a01d6$var$gi,
    CaretAPI: $0cf1b19b2f7a01d6$var$bi,
    EventsAPI: $0cf1b19b2f7a01d6$var$vi,
    I18nAPI: $0cf1b19b2f7a01d6$var$kt,
    API: $0cf1b19b2f7a01d6$var$ki,
    InlineToolbarAPI: $0cf1b19b2f7a01d6$var$yi,
    ListenersAPI: $0cf1b19b2f7a01d6$var$wi,
    NotifierAPI: $0cf1b19b2f7a01d6$var$Ci,
    ReadOnlyAPI: $0cf1b19b2f7a01d6$var$Ti,
    SanitizerAPI: $0cf1b19b2f7a01d6$var$Li,
    SaverAPI: $0cf1b19b2f7a01d6$var$Pi,
    SelectionAPI: $0cf1b19b2f7a01d6$var$Ni,
    ToolsAPI: $0cf1b19b2f7a01d6$var$Ri,
    StylesAPI: $0cf1b19b2f7a01d6$var$Di,
    ToolbarAPI: $0cf1b19b2f7a01d6$var$Fi,
    TooltipAPI: $0cf1b19b2f7a01d6$var$Ui,
    UiAPI: $0cf1b19b2f7a01d6$var$Wi,
    // Toolbar Modules
    BlockSettings: $0cf1b19b2f7a01d6$var$ms,
    Toolbar: $0cf1b19b2f7a01d6$var$Bs,
    InlineToolbar: $0cf1b19b2f7a01d6$var$Cs,
    // Modules
    BlockEvents: $0cf1b19b2f7a01d6$var$na,
    BlockManager: $0cf1b19b2f7a01d6$var$ra,
    BlockSelection: $0cf1b19b2f7a01d6$var$aa,
    Caret: $0cf1b19b2f7a01d6$var$Ye,
    CrossBlockSelection: $0cf1b19b2f7a01d6$var$la,
    DragNDrop: $0cf1b19b2f7a01d6$var$ca,
    ModificationsObserver: $0cf1b19b2f7a01d6$var$ha,
    Paste: $0cf1b19b2f7a01d6$var$pa,
    ReadOnly: $0cf1b19b2f7a01d6$var$fa,
    RectangleSelection: $0cf1b19b2f7a01d6$var$Be,
    Renderer: $0cf1b19b2f7a01d6$var$ga,
    Saver: $0cf1b19b2f7a01d6$var$ma,
    Tools: $0cf1b19b2f7a01d6$var$Wn,
    UI: $0cf1b19b2f7a01d6$var$Ia
};
class $0cf1b19b2f7a01d6$var$_a {
    /**
   * @param {EditorConfig} config - user configuration
   */ constructor(e){
        this.moduleInstances = {}, this.eventsDispatcher = new $0cf1b19b2f7a01d6$var$Oe();
        let t1, o;
        this.isReady = new Promise((i, s)=>{
            t1 = i, o = s;
        }), Promise.resolve().then(async ()=>{
            this.configuration = e, this.validate(), this.init(), await this.start(), await this.render();
            const { BlockManager: i, Caret: s, UI: r, ModificationsObserver: a } = this.moduleInstances;
            r.checkEmptiness(), a.enable(), this.configuration.autofocus === !0 && this.configuration.readOnly !== !0 && s.setToBlock(i.blocks[0], s.positions.START), t1();
        }).catch((i)=>{
            $0cf1b19b2f7a01d6$var$S(`Editor.js is not ready because of ${i}`, "error"), o(i);
        });
    }
    /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */ set configuration(e) {
        var o, i;
        $0cf1b19b2f7a01d6$var$D(e) ? this.config = {
            ...e
        } : this.config = {
            holder: e
        }, $0cf1b19b2f7a01d6$var$ht(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = $0cf1b19b2f7a01d6$var$Lo.VERBOSE), $0cf1b19b2f7a01d6$var$Zn(this.config.logLevel), $0cf1b19b2f7a01d6$var$ht(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
        const t1 = {
            type: this.config.defaultBlock,
            data: {}
        };
        this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
            p: !0,
            b: !0,
            a: !0
        }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
            blocks: []
        }, this.config.onReady = this.config.onReady || (()=>{}), this.config.onChange = this.config.onChange || (()=>{}), this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, ($0cf1b19b2f7a01d6$var$V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
            blocks: [
                t1
            ]
        }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && $0cf1b19b2f7a01d6$var$z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
    }
    /**
   * Returns private property
   *
   * @returns {EditorConfig}
   */ get configuration() {
        return this.config;
    }
    /**
   * Checks for required fields in Editor's config
   */ validate() {
        const { holderId: e, holder: t1 } = this.config;
        if (e && t1) throw Error("\xabholderId\xbb and \xabholder\xbb param can't assign at the same time.");
        if ($0cf1b19b2f7a01d6$var$te(t1) && !$0cf1b19b2f7a01d6$var$u.get(t1)) throw Error(`element with ID \xab${t1}\xbb is missing. Pass correct holder's ID.`);
        if (t1 && $0cf1b19b2f7a01d6$var$D(t1) && !$0cf1b19b2f7a01d6$var$u.isElement(t1)) throw Error("\xabholder\xbb value must be an Element node");
    }
    /**
   * Initializes modules:
   *  - make and save instances
   *  - configure
   */ init() {
        this.constructModules(), this.configureModules();
    }
    /**
   * Start Editor!
   *
   * Get list of modules that needs to be prepared and return a sequence (Promise)
   *
   * @returns {Promise<void>}
   */ async start() {
        await [
            "Tools",
            "UI",
            "BlockManager",
            "Paste",
            "BlockSelection",
            "RectangleSelection",
            "CrossBlockSelection",
            "ReadOnly"
        ].reduce((t1, o)=>t1.then(async ()=>{
                try {
                    await this.moduleInstances[o].prepare();
                } catch (i) {
                    if (i instanceof $0cf1b19b2f7a01d6$var$Ho) throw new Error(i.message);
                    $0cf1b19b2f7a01d6$var$S(`Module ${o} was skipped because of %o`, "warn", i);
                }
            }), Promise.resolve());
    }
    /**
   * Render initial data
   */ render() {
        return this.moduleInstances.Renderer.render(this.config.data.blocks);
    }
    /**
   * Make modules instances and save it to the @property this.moduleInstances
   */ constructModules() {
        Object.entries($0cf1b19b2f7a01d6$var$Oa).forEach(([e, t1])=>{
            try {
                this.moduleInstances[e] = new t1({
                    config: this.configuration,
                    eventsDispatcher: this.eventsDispatcher
                });
            } catch (o) {
                $0cf1b19b2f7a01d6$var$S("[constructModules]", `Module ${e} skipped because`, "error", o);
            }
        });
    }
    /**
   * Modules instances configuration:
   *  - pass other modules to the 'state' property
   *  - ...
   */ configureModules() {
        for(const e in this.moduleInstances)Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
    }
    /**
   * Return modules without passed name
   *
   * @param {string} name - module for witch modules difference should be calculated
   */ getModulesDiff(e) {
        const t1 = {};
        for(const o in this.moduleInstances)o !== e && (t1[o] = this.moduleInstances[o]);
        return t1;
    }
}
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */ class $0cf1b19b2f7a01d6$export$2e2bcd8739ae039 {
    /** Editor version */ static get version() {
        return "2.31.6";
    }
    /**
   * @param {EditorConfig|string|undefined} [configuration] - user configuration
   */ constructor(e){
        let t1 = ()=>{};
        $0cf1b19b2f7a01d6$var$D(e) && $0cf1b19b2f7a01d6$var$A(e.onReady) && (t1 = e.onReady);
        const o = new $0cf1b19b2f7a01d6$var$_a(e);
        this.isReady = o.isReady.then(()=>{
            this.exportAPI(o), t1();
        });
    }
    /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */ exportAPI(e) {
        const t1 = [
            "configuration"
        ], o = ()=>{
            Object.values(e.moduleInstances).forEach((s)=>{
                $0cf1b19b2f7a01d6$var$A(s.destroy) && s.destroy(), s.listeners.removeAll();
            }), $0cf1b19b2f7a01d6$var$zi(), e = null;
            for(const s in this)Object.prototype.hasOwnProperty.call(this, s) && delete this[s];
            Object.setPrototypeOf(this, null);
        };
        t1.forEach((s)=>{
            this[s] = e[s];
        }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
            blocks: {
                clear: "clear",
                render: "render"
            },
            caret: {
                focus: "focus"
            },
            events: {
                on: "on",
                off: "off",
                emit: "emit"
            },
            saver: {
                save: "save"
            }
        }).forEach(([s, r])=>{
            Object.entries(r).forEach(([a, l])=>{
                this[l] = e.moduleInstances.API.methods[s][a];
            });
        });
    }
}

});

parcelRegister("ih6Ev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f2fbba21b30eefea$export$2e2bcd8739ae039; });
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(e);
        }
    } catch (a) {
        console.error("vite-plugin-css-injected-by-js", a);
    }
})();
const $f2fbba21b30eefea$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $f2fbba21b30eefea$var$l(r) {
    const t = document.createElement("div");
    t.innerHTML = r.trim();
    const e = document.createDocumentFragment();
    return e.append(...Array.from(t.childNodes)), e;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $f2fbba21b30eefea$export$2e2bcd8739ae039 {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: t, config: e, api: i, readOnly: s }){
        this.api = i, this.readOnly = s, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = e.placeholder ? e.placeholder : $f2fbba21b30eefea$export$2e2bcd8739ae039.DEFAULT_PLACEHOLDER, this._data = t ?? {}, this._element = null, this._preserveBlank = e.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(t) {
        if (t.code !== "Backspace" && t.code !== "Delete" || !this._element) return;
        const { textContent: e } = this._element;
        e === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const t = document.createElement("DIV");
        return t.classList.add(this._CSS.wrapper, this._CSS.block), t.contentEditable = "false", t.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (t.innerHTML = this._data.text), this.readOnly || (t.contentEditable = "true", t.addEventListener("keyup", this.onKeyUp)), t;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(t) {
        if (!this._element) return;
        this._data.text += t.text;
        const e = $f2fbba21b30eefea$var$l(t.text);
        this._element.appendChild(e), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(t) {
        return !(t.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(t) {
        return {
            text: t.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(t) {
        const e = {
            text: t.detail.data.innerHTML
        };
        this._data = e, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $f2fbba21b30eefea$var$a,
            title: "Text"
        };
    }
}

});


parcelRegister("2K0q1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1ff033c67b15e28f$export$2e2bcd8739ae039; });

var $kzd8a = parcelRequire("kzd8a");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $1ff033c67b15e28f$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1ff033c67b15e28f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1ff033c67b15e28f$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $1ff033c67b15e28f$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, $kzd8a.default).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, $kzd8a.default).useRef(null);
    (0, $kzd8a.default).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, $kzd8a.default).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, $kzd8a.default).createElement("div", {
        id: memoizedHolder.current
    });
}
class $1ff033c67b15e28f$var$ServerEditorCore {
    constructor({ data: data }){
        if (data) this._memoizedData = data;
    }
    get dangerouslyLowLevelInstance() {
        return null;
    }
    clear() {
        return $1ff033c67b15e28f$var$__awaiter(this, void 0, void 0, function*() {});
    }
    save() {
        return $1ff033c67b15e28f$var$__awaiter(this, void 0, void 0, function*() {
            return this._memoizedData;
        });
    }
    destroy() {
        return $1ff033c67b15e28f$var$__awaiter(this, void 0, void 0, function*() {});
    }
    render() {
        return $1ff033c67b15e28f$var$__awaiter(this, void 0, void 0, function*() {});
    }
}
function $1ff033c67b15e28f$export$2e2bcd8739ae039(props) {
    const factory = (0, $kzd8a.default).useCallback((config)=>new $1ff033c67b15e28f$var$ServerEditorCore(config), []);
    return (0, $kzd8a.default).createElement($1ff033c67b15e28f$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});

parcelRegister("eNO5q", function(module, exports) {

var $76BgN = parcelRequire("76BgN");
var $ac6c7e6d7b6b2731$require$Buffer = $76BgN.Buffer;
"use strict";
/**
 * This module defines nodes used to define types and validations for objects and interfaces.
 */ // tslint:disable:no-shadowed-variable prefer-for-of
var __extends = this && this.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basicTypes = exports.BasicType = exports.TParamList = exports.TParam = exports.param = exports.TFunc = exports.func = exports.TProp = exports.TOptional = exports.opt = exports.TIface = exports.iface = exports.TEnumLiteral = exports.enumlit = exports.TEnumType = exports.enumtype = exports.TIntersection = exports.intersection = exports.TUnion = exports.union = exports.TTuple = exports.tuple = exports.TArray = exports.array = exports.TLiteral = exports.lit = exports.TName = exports.name = exports.TType = void 0;

var $ghIyI = parcelRequire("ghIyI");
/** Node that represents a type. */ var TType = /** @class */ function() {
    function TType() {}
    return TType;
}();
exports.TType = TType;
/** Parses a type spec into a TType node. */ function parseSpec(typeSpec) {
    return typeof typeSpec === "string" ? name(typeSpec) : typeSpec;
}
function getNamedType(suite, name) {
    var ttype = suite[name];
    if (!ttype) throw new Error("Unknown type " + name);
    return ttype;
}
/**
 * Defines a type name, either built-in, or defined in this suite. It can typically be included in
 * the specs as just a plain string.
 */ function name(value) {
    return new TName(value);
}
exports.name = name;
var TName = /** @class */ function(_super) {
    __extends(TName, _super);
    function TName(name) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this._failMsg = "is not a " + name;
        return _this;
    }
    TName.prototype.getChecker = function(suite, strict, allowedProps) {
        var _this = this;
        var ttype = getNamedType(suite, this.name);
        var checker = ttype.getChecker(suite, strict, allowedProps);
        if (ttype instanceof BasicType || ttype instanceof TName) return checker;
        // For complex types, add an additional "is not a <Type>" message on failure.
        return function(value, ctx) {
            return checker(value, ctx) ? true : ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TName;
}(TType);
exports.TName = TName;
/**
 * Defines a literal value, e.g. lit('hello') or lit(123).
 */ function lit(value) {
    return new TLiteral(value);
}
exports.lit = lit;
var TLiteral = /** @class */ function(_super) {
    __extends(TLiteral, _super);
    function TLiteral(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        _this.name = JSON.stringify(value);
        _this._failMsg = "is not " + _this.name;
        return _this;
    }
    TLiteral.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return value === _this.value ? true : ctx.fail(null, _this._failMsg, -1);
        };
    };
    return TLiteral;
}(TType);
exports.TLiteral = TLiteral;
/**
 * Defines an array type, e.g. array('number').
 */ function array(typeSpec) {
    return new TArray(parseSpec(typeSpec));
}
exports.array = array;
var TArray = /** @class */ function(_super) {
    __extends(TArray, _super);
    function TArray(ttype) {
        var _this = _super.call(this) || this;
        _this.ttype = ttype;
        return _this;
    }
    TArray.prototype.getChecker = function(suite, strict) {
        var itemChecker = this.ttype.getChecker(suite, strict);
        return function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < value.length; i++){
                var ok = itemChecker(value[i], ctx);
                if (!ok) return ctx.fail(i, null, 1);
            }
            return true;
        };
    };
    return TArray;
}(TType);
exports.TArray = TArray;
/**
 * Defines a tuple type, e.g. tuple('string', 'number').
 */ function tuple() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TTuple(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.tuple = tuple;
var TTuple = /** @class */ function(_super) {
    __extends(TTuple, _super);
    function TTuple(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        return _this;
    }
    TTuple.prototype.getChecker = function(suite, strict) {
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict);
        });
        var checker = function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < itemCheckers.length; i++){
                var ok = itemCheckers[i](value[i], ctx);
                if (!ok) return ctx.fail(i, null, 1);
            }
            return true;
        };
        if (!strict) return checker;
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            return value.length <= itemCheckers.length ? true : ctx.fail(itemCheckers.length, "is extraneous", 2);
        };
    };
    return TTuple;
}(TType);
exports.TTuple = TTuple;
/**
 * Defines a union type, e.g. union('number', 'null').
 */ function union() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TUnion(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.union = union;
var TUnion = /** @class */ function(_super) {
    __extends(TUnion, _super);
    function TUnion(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        var names = ttypes.map(function(t) {
            return t instanceof TName || t instanceof TLiteral ? t.name : null;
        }).filter(function(n) {
            return n;
        });
        var otherTypes = ttypes.length - names.length;
        if (names.length) {
            if (otherTypes > 0) names.push(otherTypes + " more");
            _this._failMsg = "is none of " + names.join(", ");
        } else _this._failMsg = "is none of " + otherTypes + " types";
        return _this;
    }
    TUnion.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict);
        });
        return function(value, ctx) {
            var ur = ctx.unionResolver();
            for(var i = 0; i < itemCheckers.length; i++){
                var ok = itemCheckers[i](value, ur.createContext());
                if (ok) return true;
            }
            ctx.resolveUnion(ur);
            return ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TUnion;
}(TType);
exports.TUnion = TUnion;
/**
 * Defines an intersection type, e.g. intersection('number', 'null').
 */ function intersection() {
    var typeSpec = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSpec[_i] = arguments[_i];
    return new TIntersection(typeSpec.map(function(t) {
        return parseSpec(t);
    }));
}
exports.intersection = intersection;
var TIntersection = /** @class */ function(_super) {
    __extends(TIntersection, _super);
    function TIntersection(ttypes) {
        var _this = _super.call(this) || this;
        _this.ttypes = ttypes;
        return _this;
    }
    TIntersection.prototype.getChecker = function(suite, strict) {
        var allowedProps = new Set();
        var itemCheckers = this.ttypes.map(function(t) {
            return t.getChecker(suite, strict, allowedProps);
        });
        return function(value, ctx) {
            var ok = itemCheckers.every(function(checker) {
                return checker(value, ctx);
            });
            if (ok) return true;
            return ctx.fail(null, null, 0);
        };
    };
    return TIntersection;
}(TType);
exports.TIntersection = TIntersection;
/**
 * Defines an enum type, e.g. enum({'A': 1, 'B': 2}).
 */ function enumtype(values) {
    return new TEnumType(values);
}
exports.enumtype = enumtype;
var TEnumType = /** @class */ function(_super) {
    __extends(TEnumType, _super);
    function TEnumType(members) {
        var _this = _super.call(this) || this;
        _this.members = members;
        _this.validValues = new Set();
        _this._failMsg = "is not a valid enum value";
        _this.validValues = new Set(Object.keys(members).map(function(name) {
            return members[name];
        }));
        return _this;
    }
    TEnumType.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return _this.validValues.has(value) ? true : ctx.fail(null, _this._failMsg, 0);
        };
    };
    return TEnumType;
}(TType);
exports.TEnumType = TEnumType;
/**
 * Defines a literal enum value, such as Direction.Up, specified as enumlit("Direction", "Up").
 */ function enumlit(name, prop) {
    return new TEnumLiteral(name, prop);
}
exports.enumlit = enumlit;
var TEnumLiteral = /** @class */ function(_super) {
    __extends(TEnumLiteral, _super);
    function TEnumLiteral(enumName, prop) {
        var _this = _super.call(this) || this;
        _this.enumName = enumName;
        _this.prop = prop;
        _this._failMsg = "is not " + enumName + "." + prop;
        return _this;
    }
    TEnumLiteral.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var ttype = getNamedType(suite, this.enumName);
        if (!(ttype instanceof TEnumType)) throw new Error("Type " + this.enumName + " used in enumlit is not an enum type");
        var val = ttype.members[this.prop];
        if (!ttype.members.hasOwnProperty(this.prop)) throw new Error("Unknown value " + this.enumName + "." + this.prop + " used in enumlit");
        return function(value, ctx) {
            return value === val ? true : ctx.fail(null, _this._failMsg, -1);
        };
    };
    return TEnumLiteral;
}(TType);
exports.TEnumLiteral = TEnumLiteral;
function makeIfaceProps(props) {
    return Object.keys(props).map(function(name) {
        return makeIfaceProp(name, props[name]);
    });
}
function makeIfaceProp(name, prop) {
    return prop instanceof TOptional ? new TProp(name, prop.ttype, true) : new TProp(name, parseSpec(prop), false);
}
/**
 * Defines an interface. The first argument is an array of interfaces that it extends, and the
 * second is an array of properties.
 */ function iface(bases, props) {
    return new TIface(bases, makeIfaceProps(props));
}
exports.iface = iface;
var TIface = /** @class */ function(_super) {
    __extends(TIface, _super);
    function TIface(bases, props) {
        var _this = _super.call(this) || this;
        _this.bases = bases;
        _this.props = props;
        _this.propSet = new Set(props.map(function(p) {
            return p.name;
        }));
        return _this;
    }
    TIface.prototype.getChecker = function(suite, strict, allowedProps) {
        var _this = this;
        var baseCheckers = this.bases.map(function(b) {
            return getNamedType(suite, b).getChecker(suite, strict);
        });
        var propCheckers = this.props.map(function(prop) {
            return prop.ttype.getChecker(suite, strict);
        });
        var testCtx = new $ghIyI.NoopContext();
        // Consider a prop required if it's not optional AND does not allow for undefined as a value.
        var isPropRequired = this.props.map(function(prop, i) {
            return !prop.isOpt && !propCheckers[i](undefined, testCtx);
        });
        var checker = function(value, ctx) {
            if (typeof value !== "object" || value === null) return ctx.fail(null, "is not an object", 0);
            for(var i = 0; i < baseCheckers.length; i++){
                if (!baseCheckers[i](value, ctx)) return false;
            }
            for(var i = 0; i < propCheckers.length; i++){
                var name_1 = _this.props[i].name;
                var v = value[name_1];
                if (v === undefined) {
                    if (isPropRequired[i]) return ctx.fail(name_1, "is missing", 1);
                } else {
                    var ok = propCheckers[i](v, ctx);
                    if (!ok) return ctx.fail(name_1, null, 1);
                }
            }
            return true;
        };
        if (!strict) return checker;
        var propSet = this.propSet;
        if (allowedProps) {
            this.propSet.forEach(function(prop) {
                return allowedProps.add(prop);
            });
            propSet = allowedProps;
        }
        // In strict mode, check also for unknown enumerable properties.
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            for(var prop in value){
                if (!propSet.has(prop)) return ctx.fail(prop, "is extraneous", 2);
            }
            return true;
        };
    };
    return TIface;
}(TType);
exports.TIface = TIface;
/**
 * Defines an optional property on an interface.
 */ function opt(typeSpec) {
    return new TOptional(parseSpec(typeSpec));
}
exports.opt = opt;
var TOptional = /** @class */ function(_super) {
    __extends(TOptional, _super);
    function TOptional(ttype) {
        var _this = _super.call(this) || this;
        _this.ttype = ttype;
        return _this;
    }
    TOptional.prototype.getChecker = function(suite, strict) {
        var itemChecker = this.ttype.getChecker(suite, strict);
        return function(value, ctx) {
            return value === undefined || itemChecker(value, ctx);
        };
    };
    return TOptional;
}(TType);
exports.TOptional = TOptional;
/**
 * Defines a property in an interface.
 */ var TProp = /** @class */ function() {
    function TProp(name, ttype, isOpt) {
        this.name = name;
        this.ttype = ttype;
        this.isOpt = isOpt;
    }
    return TProp;
}();
exports.TProp = TProp;
/**
 * Defines a function. The first argument declares the function's return type, the rest declare
 * its parameters.
 */ function func(resultSpec) {
    var params = [];
    for(var _i = 1; _i < arguments.length; _i++)params[_i - 1] = arguments[_i];
    return new TFunc(new TParamList(params), parseSpec(resultSpec));
}
exports.func = func;
var TFunc = /** @class */ function(_super) {
    __extends(TFunc, _super);
    function TFunc(paramList, result) {
        var _this = _super.call(this) || this;
        _this.paramList = paramList;
        _this.result = result;
        return _this;
    }
    TFunc.prototype.getChecker = function(suite, strict) {
        return function(value, ctx) {
            return typeof value === "function" ? true : ctx.fail(null, "is not a function", 0);
        };
    };
    return TFunc;
}(TType);
exports.TFunc = TFunc;
/**
 * Defines a function parameter.
 */ function param(name, typeSpec, isOpt) {
    return new TParam(name, parseSpec(typeSpec), Boolean(isOpt));
}
exports.param = param;
var TParam = /** @class */ function() {
    function TParam(name, ttype, isOpt) {
        this.name = name;
        this.ttype = ttype;
        this.isOpt = isOpt;
    }
    return TParam;
}();
exports.TParam = TParam;
/**
 * Defines a function parameter list.
 */ var TParamList = /** @class */ function(_super) {
    __extends(TParamList, _super);
    function TParamList(params) {
        var _this = _super.call(this) || this;
        _this.params = params;
        return _this;
    }
    TParamList.prototype.getChecker = function(suite, strict) {
        var _this = this;
        var itemCheckers = this.params.map(function(t) {
            return t.ttype.getChecker(suite, strict);
        });
        var testCtx = new $ghIyI.NoopContext();
        var isParamRequired = this.params.map(function(param, i) {
            return !param.isOpt && !itemCheckers[i](undefined, testCtx);
        });
        var checker = function(value, ctx) {
            if (!Array.isArray(value)) return ctx.fail(null, "is not an array", 0);
            for(var i = 0; i < itemCheckers.length; i++){
                var p = _this.params[i];
                if (value[i] === undefined) {
                    if (isParamRequired[i]) return ctx.fail(p.name, "is missing", 1);
                } else {
                    var ok = itemCheckers[i](value[i], ctx);
                    if (!ok) return ctx.fail(p.name, null, 1);
                }
            }
            return true;
        };
        if (!strict) return checker;
        return function(value, ctx) {
            if (!checker(value, ctx)) return false;
            return value.length <= itemCheckers.length ? true : ctx.fail(itemCheckers.length, "is extraneous", 2);
        };
    };
    return TParamList;
}(TType);
exports.TParamList = TParamList;
/**
 * Single TType implementation for all basic built-in types.
 */ var BasicType = /** @class */ function(_super) {
    __extends(BasicType, _super);
    function BasicType(validator, message) {
        var _this = _super.call(this) || this;
        _this.validator = validator;
        _this.message = message;
        return _this;
    }
    BasicType.prototype.getChecker = function(suite, strict) {
        var _this = this;
        return function(value, ctx) {
            return _this.validator(value) ? true : ctx.fail(null, _this.message, 0);
        };
    };
    return BasicType;
}(TType);
exports.BasicType = BasicType;
/**
 * Defines the suite of basic types.
 */ exports.basicTypes = {
    any: new BasicType(function(v) {
        return true;
    }, "is invalid"),
    number: new BasicType(function(v) {
        return typeof v === "number";
    }, "is not a number"),
    object: new BasicType(function(v) {
        return typeof v === "object" && v;
    }, "is not an object"),
    boolean: new BasicType(function(v) {
        return typeof v === "boolean";
    }, "is not a boolean"),
    string: new BasicType(function(v) {
        return typeof v === "string";
    }, "is not a string"),
    symbol: new BasicType(function(v) {
        return typeof v === "symbol";
    }, "is not a symbol"),
    void: new BasicType(function(v) {
        return v == null;
    }, "is not void"),
    undefined: new BasicType(function(v) {
        return v === undefined;
    }, "is not undefined"),
    null: new BasicType(function(v) {
        return v === null;
    }, "is not null"),
    never: new BasicType(function(v) {
        return false;
    }, "is unexpected"),
    Date: new BasicType(getIsNativeChecker("[object Date]"), "is not a Date"),
    RegExp: new BasicType(getIsNativeChecker("[object RegExp]"), "is not a RegExp")
};
// This approach for checking native object types mirrors that of lodash. Its advantage over
// `isinstance` is that it can still return true for native objects created in different JS
// execution environments.
var nativeToString = Object.prototype.toString;
function getIsNativeChecker(tag) {
    return function(v) {
        return typeof v === "object" && v && nativeToString.call(v) === tag;
    };
}
if (typeof $ac6c7e6d7b6b2731$require$Buffer !== "undefined") exports.basicTypes.Buffer = new BasicType(function(v) {
    return $ac6c7e6d7b6b2731$require$Buffer.isBuffer(v);
}, "is not a Buffer");
var _loop_1 = function(array_1) {
    exports.basicTypes[array_1.name] = new BasicType(function(v) {
        return v instanceof array_1;
    }, "is not a " + array_1.name);
};
// Support typed arrays of various flavors
for(var _i = 0, _a = [
    Int8Array,
    Uint8Array,
    Uint8ClampedArray,
    Int16Array,
    Uint16Array,
    Int32Array,
    Uint32Array,
    Float32Array,
    Float64Array,
    ArrayBuffer
]; _i < _a.length; _i++){
    var array_1 = _a[_i];
    _loop_1(array_1);
}

});
parcelRegister("76BgN", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $52c600f94124b7a5$export$a143d493d941bafc; }, function (v) { return $52c600f94124b7a5$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $52c600f94124b7a5$export$f99ded8fe4b79145; }, function (v) { return $52c600f94124b7a5$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $52c600f94124b7a5$export$a143d493d941bafc;
var $52c600f94124b7a5$export$e4cf37d7f6fb9e0a;
var $52c600f94124b7a5$export$f99ded8fe4b79145;
var $52c600f94124b7a5$export$599f31c3813fae4d;
'use strict';

var $ciAhb = parcelRequire("ciAhb");

var $jkrR6 = parcelRequire("jkrR6");
const $52c600f94124b7a5$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$52c600f94124b7a5$export$a143d493d941bafc = $52c600f94124b7a5$var$Buffer;
$52c600f94124b7a5$export$e4cf37d7f6fb9e0a = $52c600f94124b7a5$var$SlowBuffer;
$52c600f94124b7a5$export$f99ded8fe4b79145 = 50;
const $52c600f94124b7a5$var$K_MAX_LENGTH = 0x7fffffff;
$52c600f94124b7a5$export$599f31c3813fae4d = $52c600f94124b7a5$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $52c600f94124b7a5$var$Buffer.TYPED_ARRAY_SUPPORT = $52c600f94124b7a5$var$typedArraySupport();
if (!$52c600f94124b7a5$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $52c600f94124b7a5$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($52c600f94124b7a5$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$52c600f94124b7a5$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($52c600f94124b7a5$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$52c600f94124b7a5$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $52c600f94124b7a5$var$createBuffer(length) {
    if (length > $52c600f94124b7a5$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $52c600f94124b7a5$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $52c600f94124b7a5$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $52c600f94124b7a5$var$allocUnsafe(arg);
    }
    return $52c600f94124b7a5$var$from(arg, encodingOrOffset, length);
}
$52c600f94124b7a5$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $52c600f94124b7a5$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $52c600f94124b7a5$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $52c600f94124b7a5$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($52c600f94124b7a5$var$isInstance(value, ArrayBuffer) || value && $52c600f94124b7a5$var$isInstance(value.buffer, ArrayBuffer)) return $52c600f94124b7a5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($52c600f94124b7a5$var$isInstance(value, SharedArrayBuffer) || value && $52c600f94124b7a5$var$isInstance(value.buffer, SharedArrayBuffer))) return $52c600f94124b7a5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $52c600f94124b7a5$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $52c600f94124b7a5$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $52c600f94124b7a5$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $52c600f94124b7a5$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $52c600f94124b7a5$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($52c600f94124b7a5$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($52c600f94124b7a5$var$Buffer, Uint8Array);
function $52c600f94124b7a5$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $52c600f94124b7a5$var$alloc(size, fill, encoding) {
    $52c600f94124b7a5$var$assertSize(size);
    if (size <= 0) return $52c600f94124b7a5$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $52c600f94124b7a5$var$createBuffer(size).fill(fill, encoding) : $52c600f94124b7a5$var$createBuffer(size).fill(fill);
    return $52c600f94124b7a5$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $52c600f94124b7a5$var$Buffer.alloc = function(size, fill, encoding) {
    return $52c600f94124b7a5$var$alloc(size, fill, encoding);
};
function $52c600f94124b7a5$var$allocUnsafe(size) {
    $52c600f94124b7a5$var$assertSize(size);
    return $52c600f94124b7a5$var$createBuffer(size < 0 ? 0 : $52c600f94124b7a5$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $52c600f94124b7a5$var$Buffer.allocUnsafe = function(size) {
    return $52c600f94124b7a5$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $52c600f94124b7a5$var$Buffer.allocUnsafeSlow = function(size) {
    return $52c600f94124b7a5$var$allocUnsafe(size);
};
function $52c600f94124b7a5$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$52c600f94124b7a5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $52c600f94124b7a5$var$byteLength(string, encoding) | 0;
    let buf = $52c600f94124b7a5$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $52c600f94124b7a5$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $52c600f94124b7a5$var$checked(array.length) | 0;
    const buf = $52c600f94124b7a5$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $52c600f94124b7a5$var$fromArrayView(arrayView) {
    if ($52c600f94124b7a5$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $52c600f94124b7a5$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $52c600f94124b7a5$var$fromArrayLike(arrayView);
}
function $52c600f94124b7a5$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $52c600f94124b7a5$var$Buffer.prototype);
    return buf;
}
function $52c600f94124b7a5$var$fromObject(obj) {
    if ($52c600f94124b7a5$var$Buffer.isBuffer(obj)) {
        const len = $52c600f94124b7a5$var$checked(obj.length) | 0;
        const buf = $52c600f94124b7a5$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $52c600f94124b7a5$var$numberIsNaN(obj.length)) return $52c600f94124b7a5$var$createBuffer(0);
        return $52c600f94124b7a5$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $52c600f94124b7a5$var$fromArrayLike(obj.data);
}
function $52c600f94124b7a5$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $52c600f94124b7a5$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $52c600f94124b7a5$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $52c600f94124b7a5$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $52c600f94124b7a5$var$Buffer.alloc(+length);
}
$52c600f94124b7a5$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $52c600f94124b7a5$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$52c600f94124b7a5$var$Buffer.compare = function compare(a, b) {
    if ($52c600f94124b7a5$var$isInstance(a, Uint8Array)) a = $52c600f94124b7a5$var$Buffer.from(a, a.offset, a.byteLength);
    if ($52c600f94124b7a5$var$isInstance(b, Uint8Array)) b = $52c600f94124b7a5$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(a) || !$52c600f94124b7a5$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$52c600f94124b7a5$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$52c600f94124b7a5$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $52c600f94124b7a5$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $52c600f94124b7a5$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($52c600f94124b7a5$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$52c600f94124b7a5$var$Buffer.isBuffer(buf)) buf = $52c600f94124b7a5$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$52c600f94124b7a5$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $52c600f94124b7a5$var$byteLength(string, encoding) {
    if ($52c600f94124b7a5$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $52c600f94124b7a5$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $52c600f94124b7a5$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $52c600f94124b7a5$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $52c600f94124b7a5$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$52c600f94124b7a5$var$Buffer.byteLength = $52c600f94124b7a5$var$byteLength;
function $52c600f94124b7a5$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $52c600f94124b7a5$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $52c600f94124b7a5$var$utf8Slice(this, start, end);
        case 'ascii':
            return $52c600f94124b7a5$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $52c600f94124b7a5$var$latin1Slice(this, start, end);
        case 'base64':
            return $52c600f94124b7a5$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $52c600f94124b7a5$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$52c600f94124b7a5$var$Buffer.prototype._isBuffer = true;
function $52c600f94124b7a5$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$52c600f94124b7a5$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$52c600f94124b7a5$var$swap(this, i, i + 1);
    return this;
};
$52c600f94124b7a5$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $52c600f94124b7a5$var$swap(this, i, i + 3);
        $52c600f94124b7a5$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$52c600f94124b7a5$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $52c600f94124b7a5$var$swap(this, i, i + 7);
        $52c600f94124b7a5$var$swap(this, i + 1, i + 6);
        $52c600f94124b7a5$var$swap(this, i + 2, i + 5);
        $52c600f94124b7a5$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$52c600f94124b7a5$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $52c600f94124b7a5$var$utf8Slice(this, 0, length);
    return $52c600f94124b7a5$var$slowToString.apply(this, arguments);
};
$52c600f94124b7a5$var$Buffer.prototype.toLocaleString = $52c600f94124b7a5$var$Buffer.prototype.toString;
$52c600f94124b7a5$var$Buffer.prototype.equals = function equals(b) {
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $52c600f94124b7a5$var$Buffer.compare(this, b) === 0;
};
$52c600f94124b7a5$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $52c600f94124b7a5$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($52c600f94124b7a5$var$customInspectSymbol) $52c600f94124b7a5$var$Buffer.prototype[$52c600f94124b7a5$var$customInspectSymbol] = $52c600f94124b7a5$var$Buffer.prototype.inspect;
$52c600f94124b7a5$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($52c600f94124b7a5$var$isInstance(target, Uint8Array)) target = $52c600f94124b7a5$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $52c600f94124b7a5$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($52c600f94124b7a5$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $52c600f94124b7a5$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($52c600f94124b7a5$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $52c600f94124b7a5$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $52c600f94124b7a5$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $52c600f94124b7a5$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$52c600f94124b7a5$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$52c600f94124b7a5$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $52c600f94124b7a5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$52c600f94124b7a5$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $52c600f94124b7a5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $52c600f94124b7a5$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($52c600f94124b7a5$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $52c600f94124b7a5$var$utf8Write(buf, string, offset, length) {
    return $52c600f94124b7a5$var$blitBuffer($52c600f94124b7a5$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $52c600f94124b7a5$var$asciiWrite(buf, string, offset, length) {
    return $52c600f94124b7a5$var$blitBuffer($52c600f94124b7a5$var$asciiToBytes(string), buf, offset, length);
}
function $52c600f94124b7a5$var$base64Write(buf, string, offset, length) {
    return $52c600f94124b7a5$var$blitBuffer($52c600f94124b7a5$var$base64ToBytes(string), buf, offset, length);
}
function $52c600f94124b7a5$var$ucs2Write(buf, string, offset, length) {
    return $52c600f94124b7a5$var$blitBuffer($52c600f94124b7a5$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$52c600f94124b7a5$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $52c600f94124b7a5$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $52c600f94124b7a5$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $52c600f94124b7a5$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $52c600f94124b7a5$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $52c600f94124b7a5$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$52c600f94124b7a5$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $52c600f94124b7a5$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $ciAhb.fromByteArray(buf);
    else return $ciAhb.fromByteArray(buf.slice(start, end));
}
function $52c600f94124b7a5$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $52c600f94124b7a5$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $52c600f94124b7a5$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $52c600f94124b7a5$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $52c600f94124b7a5$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $52c600f94124b7a5$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $52c600f94124b7a5$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $52c600f94124b7a5$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $52c600f94124b7a5$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $52c600f94124b7a5$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $52c600f94124b7a5$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$52c600f94124b7a5$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $52c600f94124b7a5$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $52c600f94124b7a5$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$52c600f94124b7a5$var$Buffer.prototype.readUintLE = $52c600f94124b7a5$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$52c600f94124b7a5$var$Buffer.prototype.readUintBE = $52c600f94124b7a5$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$52c600f94124b7a5$var$Buffer.prototype.readUint8 = $52c600f94124b7a5$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$52c600f94124b7a5$var$Buffer.prototype.readUint16LE = $52c600f94124b7a5$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$52c600f94124b7a5$var$Buffer.prototype.readUint16BE = $52c600f94124b7a5$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$52c600f94124b7a5$var$Buffer.prototype.readUint32LE = $52c600f94124b7a5$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$52c600f94124b7a5$var$Buffer.prototype.readUint32BE = $52c600f94124b7a5$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$52c600f94124b7a5$var$Buffer.prototype.readBigUInt64LE = $52c600f94124b7a5$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $52c600f94124b7a5$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$52c600f94124b7a5$var$Buffer.prototype.readBigUInt64BE = $52c600f94124b7a5$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $52c600f94124b7a5$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$52c600f94124b7a5$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$52c600f94124b7a5$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$52c600f94124b7a5$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$52c600f94124b7a5$var$Buffer.prototype.readBigInt64LE = $52c600f94124b7a5$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $52c600f94124b7a5$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$52c600f94124b7a5$var$Buffer.prototype.readBigInt64BE = $52c600f94124b7a5$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $52c600f94124b7a5$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$52c600f94124b7a5$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return $jkrR6.read(this, offset, true, 23, 4);
};
$52c600f94124b7a5$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 4, this.length);
    return $jkrR6.read(this, offset, false, 23, 4);
};
$52c600f94124b7a5$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 8, this.length);
    return $jkrR6.read(this, offset, true, 52, 8);
};
$52c600f94124b7a5$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkOffset(offset, 8, this.length);
    return $jkrR6.read(this, offset, false, 52, 8);
};
function $52c600f94124b7a5$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$52c600f94124b7a5$var$Buffer.prototype.writeUintLE = $52c600f94124b7a5$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $52c600f94124b7a5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUintBE = $52c600f94124b7a5$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $52c600f94124b7a5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint8 = $52c600f94124b7a5$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint16LE = $52c600f94124b7a5$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint16BE = $52c600f94124b7a5$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint32LE = $52c600f94124b7a5$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$52c600f94124b7a5$var$Buffer.prototype.writeUint32BE = $52c600f94124b7a5$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $52c600f94124b7a5$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $52c600f94124b7a5$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $52c600f94124b7a5$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $52c600f94124b7a5$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$52c600f94124b7a5$var$Buffer.prototype.writeBigUInt64LE = $52c600f94124b7a5$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $52c600f94124b7a5$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$52c600f94124b7a5$var$Buffer.prototype.writeBigUInt64BE = $52c600f94124b7a5$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $52c600f94124b7a5$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$52c600f94124b7a5$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $52c600f94124b7a5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$52c600f94124b7a5$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $52c600f94124b7a5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$52c600f94124b7a5$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$52c600f94124b7a5$var$Buffer.prototype.writeBigInt64LE = $52c600f94124b7a5$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $52c600f94124b7a5$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$52c600f94124b7a5$var$Buffer.prototype.writeBigInt64BE = $52c600f94124b7a5$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $52c600f94124b7a5$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $52c600f94124b7a5$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $52c600f94124b7a5$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $jkrR6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$52c600f94124b7a5$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $52c600f94124b7a5$var$writeFloat(this, value, offset, true, noAssert);
};
$52c600f94124b7a5$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $52c600f94124b7a5$var$writeFloat(this, value, offset, false, noAssert);
};
function $52c600f94124b7a5$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $52c600f94124b7a5$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $jkrR6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$52c600f94124b7a5$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $52c600f94124b7a5$var$writeDouble(this, value, offset, true, noAssert);
};
$52c600f94124b7a5$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $52c600f94124b7a5$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$52c600f94124b7a5$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$52c600f94124b7a5$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$52c600f94124b7a5$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$52c600f94124b7a5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $52c600f94124b7a5$var$Buffer.isBuffer(val) ? val : $52c600f94124b7a5$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $52c600f94124b7a5$var$errors = {};
function $52c600f94124b7a5$var$E(sym, getMessage, Base) {
    $52c600f94124b7a5$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$52c600f94124b7a5$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$52c600f94124b7a5$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$52c600f94124b7a5$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $52c600f94124b7a5$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $52c600f94124b7a5$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $52c600f94124b7a5$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $52c600f94124b7a5$var$checkBounds(buf, offset, byteLength) {
    $52c600f94124b7a5$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $52c600f94124b7a5$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $52c600f94124b7a5$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $52c600f94124b7a5$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $52c600f94124b7a5$var$checkBounds(buf, offset, byteLength);
}
function $52c600f94124b7a5$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $52c600f94124b7a5$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $52c600f94124b7a5$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $52c600f94124b7a5$var$validateNumber(value, type);
        throw new $52c600f94124b7a5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $52c600f94124b7a5$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $52c600f94124b7a5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $52c600f94124b7a5$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $52c600f94124b7a5$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($52c600f94124b7a5$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $52c600f94124b7a5$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $52c600f94124b7a5$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $52c600f94124b7a5$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $52c600f94124b7a5$var$base64ToBytes(str) {
    return $ciAhb.toByteArray($52c600f94124b7a5$var$base64clean(str));
}
function $52c600f94124b7a5$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $52c600f94124b7a5$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $52c600f94124b7a5$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $52c600f94124b7a5$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $52c600f94124b7a5$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $52c600f94124b7a5$var$BufferBigIntNotDefined : fn;
}
function $52c600f94124b7a5$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("ciAhb", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $8f434e29c230537f$export$d622b2ad8d90c771; }, function (v) { return $8f434e29c230537f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $8f434e29c230537f$export$6100ba28696e12de; }, function (v) { return $8f434e29c230537f$export$6100ba28696e12de = v; });
var $8f434e29c230537f$export$a48f0734ac7c2329;
var $8f434e29c230537f$export$d622b2ad8d90c771;
var $8f434e29c230537f$export$6100ba28696e12de;
'use strict';
$8f434e29c230537f$export$a48f0734ac7c2329 = $8f434e29c230537f$var$byteLength;
$8f434e29c230537f$export$d622b2ad8d90c771 = $8f434e29c230537f$var$toByteArray;
$8f434e29c230537f$export$6100ba28696e12de = $8f434e29c230537f$var$fromByteArray;
var $8f434e29c230537f$var$lookup = [];
var $8f434e29c230537f$var$revLookup = [];
var $8f434e29c230537f$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8f434e29c230537f$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8f434e29c230537f$var$i = 0, $8f434e29c230537f$var$len = $8f434e29c230537f$var$code.length; $8f434e29c230537f$var$i < $8f434e29c230537f$var$len; ++$8f434e29c230537f$var$i){
    $8f434e29c230537f$var$lookup[$8f434e29c230537f$var$i] = $8f434e29c230537f$var$code[$8f434e29c230537f$var$i];
    $8f434e29c230537f$var$revLookup[$8f434e29c230537f$var$code.charCodeAt($8f434e29c230537f$var$i)] = $8f434e29c230537f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8f434e29c230537f$var$revLookup['-'.charCodeAt(0)] = 62;
$8f434e29c230537f$var$revLookup['_'.charCodeAt(0)] = 63;
function $8f434e29c230537f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8f434e29c230537f$var$byteLength(b64) {
    var lens = $8f434e29c230537f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8f434e29c230537f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8f434e29c230537f$var$toByteArray(b64) {
    var tmp;
    var lens = $8f434e29c230537f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8f434e29c230537f$var$Arr($8f434e29c230537f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8f434e29c230537f$var$revLookup[b64.charCodeAt(i)] << 18 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8f434e29c230537f$var$revLookup[b64.charCodeAt(i)] << 2 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8f434e29c230537f$var$revLookup[b64.charCodeAt(i)] << 10 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8f434e29c230537f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8f434e29c230537f$var$tripletToBase64(num) {
    return $8f434e29c230537f$var$lookup[num >> 18 & 0x3F] + $8f434e29c230537f$var$lookup[num >> 12 & 0x3F] + $8f434e29c230537f$var$lookup[num >> 6 & 0x3F] + $8f434e29c230537f$var$lookup[num & 0x3F];
}
function $8f434e29c230537f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8f434e29c230537f$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8f434e29c230537f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8f434e29c230537f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8f434e29c230537f$var$lookup[tmp >> 2] + $8f434e29c230537f$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8f434e29c230537f$var$lookup[tmp >> 10] + $8f434e29c230537f$var$lookup[tmp >> 4 & 0x3F] + $8f434e29c230537f$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("jkrR6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $e1257e1b0b7982b6$export$aafa59e2e03f2942; }, function (v) { return $e1257e1b0b7982b6$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $e1257e1b0b7982b6$export$68d8715fc104d294; }, function (v) { return $e1257e1b0b7982b6$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $e1257e1b0b7982b6$export$aafa59e2e03f2942;
var $e1257e1b0b7982b6$export$68d8715fc104d294;
$e1257e1b0b7982b6$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$e1257e1b0b7982b6$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("ghIyI", function(module, exports) {
"use strict";
var $bdb0cc53ee32d224$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DetailContext = module.exports.NoopContext = module.exports.VError = void 0;
/**
 * Error thrown by validation. Besides an informative message, it includes the path to the
 * property which triggered the failure.
 */ var $bdb0cc53ee32d224$var$VError = /** @class */ function(_super) {
    $bdb0cc53ee32d224$var$__extends(VError, _super);
    function VError(path, message) {
        var _this = _super.call(this, message) || this;
        _this.path = path;
        // See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work for info about this workaround.
        Object.setPrototypeOf(_this, VError.prototype);
        return _this;
    }
    return VError;
}(Error);
module.exports.VError = $bdb0cc53ee32d224$var$VError;
/**
 * Fast implementation of IContext used for first-pass validation. If that fails, we can validate
 * using DetailContext to collect error messages. That's faster for the common case when messages
 * normally pass validation.
 */ var $bdb0cc53ee32d224$var$NoopContext = /** @class */ function() {
    function NoopContext() {}
    NoopContext.prototype.fail = function(relPath, message, score) {
        return false;
    };
    NoopContext.prototype.unionResolver = function() {
        return this;
    };
    NoopContext.prototype.createContext = function() {
        return this;
    };
    NoopContext.prototype.resolveUnion = function(ur) {};
    return NoopContext;
}();
module.exports.NoopContext = $bdb0cc53ee32d224$var$NoopContext;
/**
 * Complete implementation of IContext that collects meaningfull errors.
 */ var $bdb0cc53ee32d224$var$DetailContext = /** @class */ function() {
    function DetailContext() {
        // Stack of property names and associated messages for reporting helpful error messages.
        this._propNames = [
            ""
        ];
        this._messages = [
            null
        ];
        // Score is used to choose the best union member whose DetailContext to use for reporting.
        // Higher score means better match (or rather less severe mismatch).
        this._score = 0;
    }
    DetailContext.prototype.fail = function(relPath, message, score) {
        this._propNames.push(relPath);
        this._messages.push(message);
        this._score += score;
        return false;
    };
    DetailContext.prototype.unionResolver = function() {
        return new $bdb0cc53ee32d224$var$DetailUnionResolver();
    };
    DetailContext.prototype.resolveUnion = function(unionResolver) {
        var _a, _b;
        var u = unionResolver;
        var best = null;
        for(var _i = 0, _c = u.contexts; _i < _c.length; _i++){
            var ctx = _c[_i];
            if (!best || ctx._score >= best._score) best = ctx;
        }
        if (best && best._score > 0) {
            (_a = this._propNames).push.apply(_a, best._propNames);
            (_b = this._messages).push.apply(_b, best._messages);
        }
    };
    DetailContext.prototype.getError = function(path) {
        var msgParts = [];
        for(var i = this._propNames.length - 1; i >= 0; i--){
            var p = this._propNames[i];
            path += typeof p === "number" ? "[" + p + "]" : p ? "." + p : "";
            var m = this._messages[i];
            if (m) msgParts.push(path + " " + m);
        }
        return new $bdb0cc53ee32d224$var$VError(path, msgParts.join("; "));
    };
    DetailContext.prototype.getErrorDetail = function(path) {
        var details = [];
        for(var i = this._propNames.length - 1; i >= 0; i--){
            var p = this._propNames[i];
            path += typeof p === "number" ? "[" + p + "]" : p ? "." + p : "";
            var message = this._messages[i];
            if (message) details.push({
                path: path,
                message: message
            });
        }
        var detail = null;
        for(var i = details.length - 1; i >= 0; i--){
            if (detail) details[i].nested = [
                detail
            ];
            detail = details[i];
        }
        return detail;
    };
    return DetailContext;
}();
module.exports.DetailContext = $bdb0cc53ee32d224$var$DetailContext;
var $bdb0cc53ee32d224$var$DetailUnionResolver = /** @class */ function() {
    function DetailUnionResolver() {
        this.contexts = [];
    }
    DetailUnionResolver.prototype.createContext = function() {
        var ctx = new $bdb0cc53ee32d224$var$DetailContext();
        this.contexts.push(ctx);
        return ctx;
    };
    return DetailUnionResolver;
}();

});


parcelRegister("3p0ZA", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $j82M4 = parcelRequire("j82M4");
function $27a479f8b1e67f1c$var$emptyFunction() {}
function $27a479f8b1e67f1c$var$emptyFunctionWithReset() {}
$27a479f8b1e67f1c$var$emptyFunctionWithReset.resetWarningCache = $27a479f8b1e67f1c$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $j82M4) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $27a479f8b1e67f1c$var$emptyFunctionWithReset,
        resetWarningCache: $27a479f8b1e67f1c$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("j82M4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $ded0ea9b72e1fb62$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $ded0ea9b72e1fb62$var$ReactPropTypesSecret;

});


parcelRegister("2jKnB", function(module, exports) {
module.exports = $parcel$import("9d8QO").then(()=>parcelRequire('ij5od'));

});

parcelRegister("pwgmx", function(module, exports) {
module.exports = $parcel$import("fIA0l").then(()=>parcelRequire('cHyQS'));

});

parcelRegister("gkgmt", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("8DUxR", function(module, exports) {

$parcel$export(module.exports, "HTTPClient", function () { return $cbd22d3323bef9ca$export$45cf759b359d3d24; });

var $bI3eA = parcelRequire("bI3eA");

var $iob0w = parcelRequire("iob0w");
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $eef213ff4197108b$exports = {};
$parcel$export($eef213ff4197108b$exports, "Stack", function() {
    return $eef213ff4197108b$export$694e0d28c7ffc90c;
});
const { push: $eef213ff4197108b$var$push } = Array.prototype;
class $eef213ff4197108b$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}
var $0fe1f1400993ba8a$exports = {};
$parcel$export($0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $0fe1f1400993ba8a$export$4125cfe7e08e2040;
});
$parcel$export($0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $0fe1f1400993ba8a$export$aa9d629c530f62a7;
});
$parcel$export($0fe1f1400993ba8a$exports, "headerParser", function() {
    return $0fe1f1400993ba8a$export$b725a69477e4d33f;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $0fe1f1400993ba8a$export$eea2c1c5e1a37e50;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseBody", function() {
    return $0fe1f1400993ba8a$export$3b629cd0ff482602;
});
$parcel$export($0fe1f1400993ba8a$exports, "FILE_TYPE_MAGIC_NUMBER_SIZE", function() {
    return $0fe1f1400993ba8a$export$153cac11fce574d;
});
$parcel$export($0fe1f1400993ba8a$exports, "defaultHTTPRuntime", function() {
    return $0fe1f1400993ba8a$export$80e06a8ed038dcf8;
});
$parcel$export($0fe1f1400993ba8a$exports, "HTTPToolkit", function() {
    return $0fe1f1400993ba8a$export$7370b3fc922cf1e6;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $0fe1f1400993ba8a$export$4f2a8c8c11a6373a;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $0fe1f1400993ba8a$export$bda27a3e49197b9;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $0fe1f1400993ba8a$export$ba14d9a5a581e827;
});
$parcel$export($0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $0fe1f1400993ba8a$export$b7b86d31099674dc;
});
$parcel$export($0fe1f1400993ba8a$exports, "rawRequest", function() {
    return $0fe1f1400993ba8a$export$3052fa16c23a17ef;
});
$parcel$export($0fe1f1400993ba8a$exports, "requestHead", function() {
    return $0fe1f1400993ba8a$export$199f266664335871;
});
$parcel$export($0fe1f1400993ba8a$exports, "request", function() {
    return $0fe1f1400993ba8a$export$b5fe3f66a567bec0;
});
var $22de11b45b0eeb97$exports = {};
$parcel$export($22de11b45b0eeb97$exports, "FileMethod", function() {
    return $22de11b45b0eeb97$export$226b21d2db5eaf9f;
});
$parcel$export($22de11b45b0eeb97$exports, "defaultDataRuntime", function() {
    return $22de11b45b0eeb97$export$f7195e83247c5fe1;
});
$parcel$export($22de11b45b0eeb97$exports, "DataToolkit", function() {
    return $22de11b45b0eeb97$export$bc241bb96b6158a8;
});
$parcel$export($22de11b45b0eeb97$exports, "polyfillProgressEvent", function() {
    return $22de11b45b0eeb97$export$5e6a03ce7b01784;
});
$parcel$export($22de11b45b0eeb97$exports, "parseDocument", function() {
    return $22de11b45b0eeb97$export$b6a9369736b19f4d;
});
$parcel$export($22de11b45b0eeb97$exports, "makeFormData", function() {
    return $22de11b45b0eeb97$export$2c28ab2e118e73f1;
});
$parcel$export($22de11b45b0eeb97$exports, "serializeNode", function() {
    return $22de11b45b0eeb97$export$a0beee2e55fb5dd1;
});
$parcel$export($22de11b45b0eeb97$exports, "serialize", function() {
    return $22de11b45b0eeb97$export$dfdc1655ccc5b9cb;
});
$parcel$export($22de11b45b0eeb97$exports, "takeBytes", function() {
    return $22de11b45b0eeb97$export$45c4469e58b7b0ca;
});
$parcel$export($22de11b45b0eeb97$exports, "readBytes", function() {
    return $22de11b45b0eeb97$export$f9f241124ee3198e;
});
$parcel$export($22de11b45b0eeb97$exports, "makeStream", function() {
    return $22de11b45b0eeb97$export$4b366c43f3cabead;
});
$parcel$export($22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $22de11b45b0eeb97$export$f8162fcba31fa547;
});
$parcel$export($22de11b45b0eeb97$exports, "emitStreamProgress", function() {
    return $22de11b45b0eeb97$export$cebfdbc318a33abe;
});
$parcel$export($22de11b45b0eeb97$exports, "readAs", function() {
    return $22de11b45b0eeb97$export$e209cbb66c5b18c;
});
$parcel$export($22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $22de11b45b0eeb97$export$8fb536984ec8b4d7;
});
var $22de11b45b0eeb97$export$226b21d2db5eaf9f = /*#__PURE__*/ function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
    return FileMethod;
}({});
const $22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
const $22de11b45b0eeb97$export$f7195e83247c5fe1 = {
    DOMParser: globalThis.DOMParser,
    Node: globalThis.Node,
    Document: globalThis.Document,
    HTMLElement: globalThis.HTMLElement,
    SVGElement: globalThis.SVGElement,
    FormData: globalThis.FormData,
    URLSearchParams: globalThis.URLSearchParams,
    Blob: globalThis.Blob,
    FileReader: globalThis.FileReader,
    Event: globalThis.Event,
    ProgressEvent: globalThis.ProgressEvent,
    ReadableStream: (0, $bI3eA.ReadableStream)
};
class $22de11b45b0eeb97$export$bc241bb96b6158a8 {
    constructor(runtime = $22de11b45b0eeb97$export$f7195e83247c5fe1){
        this.runtime = runtime;
        this.polyfillProgressEvent = ()=>globalThis.ProgressEvent ||= class ProgressEvent extends this.runtime.Event {
                constructor(type, { lengthComputable: lengthComputable, total: total, loaded: loaded, ...meta } = {}){
                    super(type, meta);
                    this.lengthComputable = lengthComputable;
                    this.total = total;
                    this.loaded = loaded;
                }
            };
        this.parseDocument = async (text, contentType = '')=>{
            const { DOMParser: DOMParser } = this.runtime;
            const [type] = contentType?.split(';') || [];
            return new DOMParser().parseFromString(text, type || 'text/html');
        };
        this.makeFormData = (data)=>{
            const { FormData: FormData } = this.runtime;
            const formData = new FormData();
            for (const [key, value] of Object.entries(data)){
                const list = typeof value !== 'string' && (0, $iob0w.likeArray)(value) ? value : [
                    value
                ];
                for (const item of Array.from(list))if (item != null) {
                    if (typeof item === 'object') formData.append(key, item, item.name);
                    else formData.append(key, item);
                }
            }
            return formData;
        };
        this.serializeNode = (root)=>{
            const { URLSearchParams: URLSearchParams, FormData: FormData, Document: Document, HTMLElement: HTMLElement, SVGElement: SVGElement } = this.runtime;
            var contentType;
            if (!(root instanceof HTMLFormElement)) return {
                contentType: root instanceof SVGElement ? 'image/svg' : root instanceof Document || root instanceof HTMLElement ? 'text/html' : 'application/xml',
                data: (0, $iob0w.stringifyDOM)(root)
            };
            if (root.querySelector('input[type="file"][name]')) return {
                contentType: 'multipart/form-data',
                data: new FormData(root)
            };
            const data = (0, $iob0w.formToJSON)(root);
            switch(contentType = root.enctype){
                case 'text/plain':
                    return {
                        contentType: contentType,
                        data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join('\n')
                    };
                case 'application/x-www-form-urlencoded':
                    return {
                        contentType: contentType,
                        data: new URLSearchParams(data)
                    };
                default:
                    return {
                        contentType: 'application/json',
                        data: JSON.stringify(data)
                    };
            }
        };
        this.serialize = (data, contentType)=>{
            const { Node: Node, URLSearchParams: URLSearchParams, FormData: FormData, Blob: Blob, ReadableStream: ReadableStream } = this.runtime;
            const [type] = contentType?.split(';') || [];
            switch(type){
                case 'application/x-www-form-urlencoded':
                    return {
                        contentType: contentType,
                        data: new URLSearchParams(data)
                    };
                case 'multipart/form-data':
                    return {
                        data: this.makeFormData(data)
                    };
                case 'application/json':
                    return {
                        contentType: contentType,
                        data: JSON.stringify(data)
                    };
                case 'text/html':
                case 'application/xml':
                case 'image/svg':
                    return {
                        contentType: contentType,
                        data: (0, $iob0w.stringifyDOM)(data)
                    };
            }
            if (type) return {
                data: data,
                contentType: contentType
            };
            try {
                if (data instanceof URLSearchParams) return {
                    contentType: 'application/x-www-form-urlencoded',
                    data: data
                };
            } catch  {}
            try {
                if (data instanceof FormData) return {
                    data: data
                };
            } catch  {}
            try {
                if (data instanceof Node) return this.serializeNode(data);
            } catch  {}
            try {
                if ((0, $iob0w.isTypedArray)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
                    contentType: 'application/octet-stream',
                    data: data
                };
            } catch  {}
            try {
                return {
                    contentType: 'application/json',
                    data: JSON.stringify(data)
                };
            } catch  {}
            throw new Error('Unserialized Object needs a specific Content-Type');
        };
        this.readBytes = async (stream, limit = Infinity)=>{
            const { Blob: Blob } = this.runtime;
            const chunks = await Array.fromAsync(this.takeBytes(stream, limit));
            return new Blob(chunks).arrayBuffer();
        };
        this.makeStream = (...chunks)=>{
            const { Blob: Blob } = this.runtime;
            return new Blob(chunks).stream();
        };
        this.streamFromProgress = (target)=>(0, $iob0w.createAsyncIterator)(({ next: next, complete: complete, error: error })=>{
                const handleProgress = ({ loaded: loaded, total: total })=>{
                    next({
                        loaded: loaded,
                        total: total
                    });
                    if (loaded >= total) complete();
                };
                target.addEventListener('progress', handleProgress);
                target.addEventListener('error', error);
                return ()=>{
                    target.removeEventListener('progress', handleProgress);
                    target.removeEventListener('error', error);
                };
            });
        this.emitStreamProgress = (stream, total, eventTarget)=>{
            const { ProgressEvent: ProgressEvent } = this.runtime;
            return async function*() {
                var loaded = 0;
                for await (const chunk of stream){
                    yield chunk;
                    loaded += chunk.byteLength;
                    const event = new ProgressEvent('progress', {
                        lengthComputable: isNaN(total),
                        loaded: loaded,
                        total: total
                    });
                    eventTarget.dispatchEvent(event);
                }
            }();
        };
        this.readAs = (file, method, encoding)=>{
            const { FileReader: FileReader } = this.runtime;
            const reader = new FileReader();
            const result = new Promise((resolve, reject)=>{
                reader.onerror = reject;
                reader.onload = ()=>resolve(reader.result);
                reader[$22de11b45b0eeb97$export$226b21d2db5eaf9f[method]](file, encoding);
            });
            return {
                progress: this.streamFromProgress(reader),
                result: result
            };
        };
        this./**
     * @param  raw - Binary data
     *
     * @return  Base64 encoded data
     */ encodeBase64 = async (raw)=>{
            const { Blob: Blob } = this.runtime;
            if (raw instanceof Blob) {
                const text = await this.readAs(raw, 'dataURL').result;
                return ($22de11b45b0eeb97$var$DataURI.exec(text) || '')[4];
            }
            const text = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+('0x' + p1)));
            return btoa(text);
        };
        if (runtime.Event) this.runtime.ProgressEvent = this.polyfillProgressEvent();
    }
    async *takeBytes(stream, limit = Infinity) {
        let total = 0;
        for await (const chunk of stream){
            const remaining = limit - total;
            if (chunk.byteLength > remaining) {
                yield chunk.slice(0, remaining);
                break;
            }
            yield new Uint8Array(chunk);
            total += chunk.byteLength;
            if (total >= limit) break;
        }
    }
}
const { polyfillProgressEvent: $22de11b45b0eeb97$export$5e6a03ce7b01784, parseDocument: $22de11b45b0eeb97$export$b6a9369736b19f4d, makeFormData: $22de11b45b0eeb97$export$2c28ab2e118e73f1, serializeNode: $22de11b45b0eeb97$export$a0beee2e55fb5dd1, serialize: $22de11b45b0eeb97$export$dfdc1655ccc5b9cb, takeBytes: $22de11b45b0eeb97$export$45c4469e58b7b0ca, readBytes: $22de11b45b0eeb97$export$f9f241124ee3198e, makeStream: $22de11b45b0eeb97$export$4b366c43f3cabead, streamFromProgress: $22de11b45b0eeb97$export$f8162fcba31fa547, emitStreamProgress: $22de11b45b0eeb97$export$cebfdbc318a33abe, readAs: $22de11b45b0eeb97$export$e209cbb66c5b18c, encodeBase64: $22de11b45b0eeb97$export$8fb536984ec8b4d7 } = new $22de11b45b0eeb97$export$bc241bb96b6158a8();
var $0fe1f1400993ba8a$export$4125cfe7e08e2040 = /*#__PURE__*/ function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
    return BodyRequestMethods;
}({});
class $0fe1f1400993ba8a$export$aa9d629c530f62a7 extends URIError {
    constructor(message, request, response){
        super(message), this.request = request, this.response = response;
    }
}
const $0fe1f1400993ba8a$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $0fe1f1400993ba8a$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $0fe1f1400993ba8a$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $0fe1f1400993ba8a$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes('json')) return (0, $iob0w.parseJSON)(raw);
    if (contentType.match(/html|xml/)) try {
        return this.parseDocument(raw, contentType);
    } catch  {}
    if (contentType.includes('text')) return raw;
    return new TextEncoder().encode(raw).buffer;
}
const $0fe1f1400993ba8a$export$153cac11fce574d = 4100;
const $0fe1f1400993ba8a$export$80e06a8ed038dcf8 = {
    ...$22de11b45b0eeb97$export$f7195e83247c5fe1,
    EventTarget: globalThis.EventTarget,
    XMLHttpRequest: globalThis.XMLHttpRequest,
    Headers: globalThis.Headers,
    fetch: globalThis.fetch
};
class $0fe1f1400993ba8a$export$7370b3fc922cf1e6 extends $22de11b45b0eeb97$export$bc241bb96b6158a8 {
    constructor(runtime = $0fe1f1400993ba8a$export$80e06a8ed038dcf8){
        super(runtime), this.runtime = runtime, this.requestXHR = ({ method: method = 'GET', path: path, headers: headers = {}, body: body, signal: signal, ...rest })=>{
            const { XMLHttpRequest: XMLHttpRequest, Headers: Headers, Blob: Blob, ReadableStream: ReadableStream } = this.runtime;
            const request = new XMLHttpRequest();
            const header = new Headers(headers);
            const bodyPromise = body instanceof ReadableStream ? Array.fromAsync(body).then((parts)=>new Blob(parts)) : Promise.resolve(body);
            const abort = ()=>request.abort();
            signal?.addEventListener('abort', abort);
            const response = new Promise((resolve, reject)=>{
                request.onreadystatechange = ()=>{
                    const { readyState: readyState, status: status, statusText: statusText, responseType: responseType } = request;
                    if (readyState !== 4 || !status && !signal?.aborted) return;
                    resolve({
                        status: status,
                        statusText: statusText,
                        headers: $0fe1f1400993ba8a$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                        body: responseType && responseType !== 'text' ? request.response : request.responseText
                    });
                };
                request.onerror = request.ontimeout = reject;
                const [MIMEType] = header.get('Accept')?.split(',') || [
                    rest.responseType === 'document' ? 'application/xhtml+xml' : rest.responseType === 'json' ? 'application/json' : ''
                ];
                if (MIMEType) request.overrideMimeType(MIMEType);
                request.open(method, path + '');
                for (const [key, value] of header)request.setRequestHeader(key, value);
                Object.assign(request, rest);
                bodyPromise.then((body)=>request.send(body));
            }).then(({ body: body, ...meta })=>{
                signal?.throwIfAborted();
                const contentType = request.getResponseHeader('Content-Type') || '';
                if (typeof body === 'string' && !contentType.includes('text')) body = $0fe1f1400993ba8a$export$3b629cd0ff482602(body, contentType);
                return {
                    ...meta,
                    body: body
                };
            });
            response.finally(()=>signal?.removeEventListener('abort', abort));
            return {
                response: response,
                upload: this.streamFromProgress(request.upload),
                download: this.streamFromProgress(request)
            };
        }, this.requestFetch = ({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType })=>{
            const { EventTarget: EventTarget, Headers: Headers, ReadableStream: ReadableStream, fetch: fetch } = this.runtime;
            const signals = [
                signal,
                timeout && AbortSignal.timeout(timeout)
            ].filter(Boolean);
            headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
            headers = responseType === 'text' ? {
                ...headers,
                Accept: 'text/plain'
            } : responseType === 'json' ? {
                ...headers,
                Accept: 'application/json'
            } : responseType === 'document' ? {
                ...headers,
                Accept: 'text/html, application/xhtml+xml, application/xml'
            } : responseType === 'arraybuffer' || responseType === 'blob' ? {
                ...headers,
                Accept: 'application/octet-stream'
            } : headers;
            const isStream = body instanceof ReadableStream;
            var upload;
            if (isStream) {
                const uploadProgress = new EventTarget();
                body = ReadableStream.from(this.emitStreamProgress(body, +headers['Content-Length'], uploadProgress));
                upload = this.streamFromProgress(uploadProgress);
            }
            const downloadProgress = new EventTarget();
            const response = fetch(path + '', {
                method: method,
                headers: headers,
                credentials: withCredentials ? 'include' : 'omit',
                body: body,
                signal: signals[0] && AbortSignal.any(signals),
                // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
                duplex: isStream ? 'half' : undefined
            }).then((response)=>this.parseResponse(response, responseType, downloadProgress));
            const download = this.streamFromProgress(downloadProgress);
            return {
                response: response,
                upload: upload,
                download: download
            };
        }, this.parseResponse = async ({ status: status, statusText: statusText, headers: headers, body: body }, responseType, downloadProgress)=>{
            const { ReadableStream: ReadableStream } = this.runtime;
            const contentType = headers.get('Content-Type') || '';
            const header = $0fe1f1400993ba8a$export$eea2c1c5e1a37e50([
                ...headers
            ].map(([key, value])=>`${key}: ${value}`).join('\n'));
            if (status === 204 || !body) return {
                status: status,
                statusText: statusText,
                headers: header,
                body: undefined
            };
            const stream = ReadableStream.from(this.emitStreamProgress(ReadableStream.from(body), +headers.get('Content-Length'), downloadProgress));
            const rBody = await this.parseFetchBody(stream, contentType, responseType);
            return {
                status: status,
                statusText: statusText,
                headers: header,
                body: rBody
            };
        }, this.parseFetchBody = async (stream, contentType, responseType)=>{
            const { Blob: Blob } = this.runtime;
            const blob = new Blob(await Array.fromAsync(stream), {
                type: contentType
            });
            if (responseType === 'blob') return blob;
            if (responseType === 'arraybuffer') return blob.arrayBuffer();
            const text = await blob.text();
            if (responseType === 'text') return text;
            return $0fe1f1400993ba8a$export$3b629cd0ff482602(text, contentType);
        }, this.rawRequest = typeof this.runtime.XMLHttpRequest === 'function' ? this.requestXHR : this.requestFetch, this./**
     * Sends a `HEAD` request, falling back to simulation when the server does
     * not support `HEAD`. Tries, in order:
     * 1. A standard `HEAD` request via `fetch()`.
     * 2. A `Range` GET to retrieve the first {@link FILE_TYPE_MAGIC_NUMBER_SIZE}
     *    bytes (magic-number file header).
     * 3. A plain `GET` that reads the first {@link FILE_TYPE_MAGIC_NUMBER_SIZE}
     *    bytes then cancels the body stream.
     */ requestHead = async ({ path: path, headers: headers, withCredentials: withCredentials, timeout: timeout, signal: signal })=>{
            const { Headers: Headers, fetch: fetch } = this.runtime;
            const normalizedHeaders = !headers ? {} : headers instanceof Headers ? Object.fromEntries(headers) : Array.isArray(headers) ? Object.fromEntries(headers) : headers;
            const signals = [
                signal,
                timeout && AbortSignal.timeout(timeout)
            ].filter(Boolean);
            const fetchOptions = {
                credentials: withCredentials ? 'include' : 'omit',
                signal: signals[1] ? AbortSignal.any(signals) : signals[0]
            };
            const toHeaders = (raw)=>$0fe1f1400993ba8a$export$eea2c1c5e1a37e50([
                    ...raw
                ].map(([k, v])=>`${k}: ${v}`).join('\n'));
            // Tier 1: fetch() HEAD
            try {
                const response = await fetch(path + '', {
                    method: 'HEAD',
                    ...fetchOptions,
                    headers: normalizedHeaders
                });
                if (response.ok) return {
                    headers: toHeaders(response.headers)
                };
            } catch  {
            // HEAD not supported; fall through to simulation tiers
            }
            // Tier 2: Range GET – read magic-number bytes only
            try {
                const response = await fetch(path + '', {
                    ...fetchOptions,
                    headers: {
                        ...normalizedHeaders,
                        Range: `bytes=0-${$0fe1f1400993ba8a$export$153cac11fce574d - 1}`
                    }
                });
                if (!response.ok) throw new Error(`${response.status} ${response.statusText}`);
                return {
                    headers: toHeaders(response.headers),
                    body: await response.arrayBuffer()
                };
            } catch  {
            // Server does not support Range requests; fall back to plain GET
            }
            // Tier 3: plain GET – read magic-number bytes then cancel the body stream
            const response = await fetch(path, {
                ...fetchOptions,
                headers: normalizedHeaders
            });
            const body = await this.readBytes((0, $bI3eA.ReadableStream).from(response.body), $0fe1f1400993ba8a$export$153cac11fce574d);
            return {
                headers: toHeaders(response.headers),
                body: body
            };
        }, this./**
     * Sends a {@link Request}, with automatic HEAD-simulation fallback for
     * servers that do not support the `HEAD` method.
     */ request = (option)=>{
            if (option.method !== 'HEAD') return this.rawRequest(option);
            const response = this.requestHead(option).then(({ headers: headers, body: body })=>({
                    status: 204,
                    statusText: 'No Content',
                    headers: headers,
                    body: body
                }));
            return {
                response: response,
                download: async function*() {}()
            };
        };
    }
}
const { requestXHR: $0fe1f1400993ba8a$export$4f2a8c8c11a6373a, requestFetch: $0fe1f1400993ba8a$export$bda27a3e49197b9, parseResponse: $0fe1f1400993ba8a$export$ba14d9a5a581e827, parseFetchBody: $0fe1f1400993ba8a$export$b7b86d31099674dc, rawRequest: $0fe1f1400993ba8a$export$3052fa16c23a17ef, requestHead: $0fe1f1400993ba8a$export$199f266664335871, request: $0fe1f1400993ba8a$export$b5fe3f66a567bec0 } = new $0fe1f1400993ba8a$export$7370b3fc922cf1e6();
var $cbd22d3323bef9ca$exports = {};
$parcel$export($cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $cbd22d3323bef9ca$export$45cf759b359d3d24;
});
const { splice: $cbd22d3323bef9ca$var$splice } = Array.prototype;
class $cbd22d3323bef9ca$export$45cf759b359d3d24 extends $eef213ff4197108b$export$694e0d28c7ffc90c {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, baseRequest: baseRequest = $0fe1f1400993ba8a$export$b5fe3f66a567bec0, ...options } = {}){
        super(), this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = 'GET', headers: headers = {}, body: body } = request;
            if (method in $0fe1f1400993ba8a$export$4125cfe7e08e2040 && body && typeof body === 'object') {
                const { contentType: contentType, data: data } = $22de11b45b0eeb97$export$dfdc1655ccc5b9cb(body, headers['Content-Type']);
                if (contentType) headers['Content-Type'] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new $0fe1f1400993ba8a$export$aa9d629c530f62a7(response.statusText, request, response);
        };
        this.baseURI = baseURI;
        this.baseRequest = baseRequest;
        this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path, this.baseURI) + '';
            Object.assign(response, await this.baseRequest({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: 'HEAD',
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: 'GET',
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: 'POST',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: 'PUT',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: 'PATCH',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: 'DELETE',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        const { 'Content-Length': length } = await this.head(path, headers, options);
        const total = +length;
        if (end === Infinity) end = total;
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}

});
parcelRegister("bI3eA", function(module, exports) {

$parcel$export(module.exports, "ReadableStreamDefaultReader", function () { return $520c3e18ee06325d$export$a890bf36e2af9168; });
$parcel$export(module.exports, "ReadableStreamBYOBRequest", function () { return $520c3e18ee06325d$export$fbcf11583158d2c; });
$parcel$export(module.exports, "ReadableByteStreamController", function () { return $520c3e18ee06325d$export$2047cf34091e94ac; });
$parcel$export(module.exports, "ReadableStreamBYOBReader", function () { return $520c3e18ee06325d$export$20068a30393fcc28; });
$parcel$export(module.exports, "WritableStream", function () { return $520c3e18ee06325d$export$826849241f7970f8; });
$parcel$export(module.exports, "WritableStreamDefaultController", function () { return $520c3e18ee06325d$export$9e6890cb9a51c7c2; });
$parcel$export(module.exports, "WritableStreamDefaultWriter", function () { return $520c3e18ee06325d$export$9295348f005d6054; });
$parcel$export(module.exports, "ReadableStreamDefaultController", function () { return $520c3e18ee06325d$export$b0bb6d0989d67700; });
$parcel$export(module.exports, "ReadableStream", function () { return $520c3e18ee06325d$export$5d3e1e5268af5f76; });
$parcel$export(module.exports, "ByteLengthQueuingStrategy", function () { return $520c3e18ee06325d$export$d386b5f37d154119; });
$parcel$export(module.exports, "CountQueuingStrategy", function () { return $520c3e18ee06325d$export$9ebfec18c2dfc625; });
$parcel$export(module.exports, "TransformStream", function () { return $520c3e18ee06325d$export$d102341634899398; });
$parcel$export(module.exports, "TransformStreamDefaultController", function () { return $520c3e18ee06325d$export$a55559184460222; });
/**
 * @license
 * web-streams-polyfill v4.3.0
 * Copyright 2026 Mattias Buelens, Diwank Singh Tomer and other contributors.
 * This code is released under the MIT license.
 * SPDX-License-Identifier: MIT
 */ function $520c3e18ee06325d$var$e() {}
function $520c3e18ee06325d$var$t(e) {
    return "object" == typeof e && null !== e || "function" == typeof e;
}
const $520c3e18ee06325d$var$r = $520c3e18ee06325d$var$e;
function $520c3e18ee06325d$var$o(e, t) {
    try {
        Object.defineProperty(e, "name", {
            value: t,
            configurable: !0
        });
    } catch (e) {}
}
const $520c3e18ee06325d$var$n = Promise, $520c3e18ee06325d$var$i = Promise.resolve.bind($520c3e18ee06325d$var$n), $520c3e18ee06325d$var$a = Promise.prototype.then, $520c3e18ee06325d$var$s = Promise.reject.bind($520c3e18ee06325d$var$n), $520c3e18ee06325d$var$l = $520c3e18ee06325d$var$i;
function $520c3e18ee06325d$var$u(e) {
    return new $520c3e18ee06325d$var$n(e);
}
function $520c3e18ee06325d$var$c(e) {
    return $520c3e18ee06325d$var$u((t)=>t(e));
}
function $520c3e18ee06325d$var$d(e) {
    return $520c3e18ee06325d$var$s(e);
}
function $520c3e18ee06325d$var$f(e, t, r) {
    return $520c3e18ee06325d$var$a.call(e, t, r);
}
function $520c3e18ee06325d$var$h(e, t, o) {
    $520c3e18ee06325d$var$f($520c3e18ee06325d$var$f(e, t, o), void 0, $520c3e18ee06325d$var$r);
}
function $520c3e18ee06325d$var$b(e, t) {
    $520c3e18ee06325d$var$h(e, t);
}
function $520c3e18ee06325d$var$_(e, t) {
    $520c3e18ee06325d$var$h(e, void 0, t);
}
function $520c3e18ee06325d$var$m(e, t, r) {
    return $520c3e18ee06325d$var$f(e, t, r);
}
function $520c3e18ee06325d$var$p(e) {
    $520c3e18ee06325d$var$f(e, void 0, $520c3e18ee06325d$var$r);
}
let $520c3e18ee06325d$var$y = (e)=>{
    if ("function" == typeof queueMicrotask) $520c3e18ee06325d$var$y = queueMicrotask;
    else {
        const e = $520c3e18ee06325d$var$c(void 0);
        $520c3e18ee06325d$var$y = (t)=>$520c3e18ee06325d$var$f(e, t);
    }
    return $520c3e18ee06325d$var$y(e);
};
function $520c3e18ee06325d$var$S(e, t, r) {
    if ("function" != typeof e) throw new TypeError("Argument is not a function");
    return Function.prototype.apply.call(e, t, r);
}
function $520c3e18ee06325d$var$g(e, t, r) {
    try {
        return $520c3e18ee06325d$var$c($520c3e18ee06325d$var$S(e, t, r));
    } catch (e) {
        return $520c3e18ee06325d$var$d(e);
    }
}
class $520c3e18ee06325d$var$v {
    constructor(){
        this._cursor = 0, this._size = 0, this._front = {
            _elements: [],
            _next: void 0
        }, this._back = this._front, this._cursor = 0, this._size = 0;
    }
    get length() {
        return this._size;
    }
    push(e) {
        const t = this._back;
        let r = t;
        16383 === t._elements.length && (r = {
            _elements: [],
            _next: void 0
        }), t._elements.push(e), r !== t && (this._back = r, t._next = r), ++this._size;
    }
    shift() {
        const e = this._front;
        let t = e;
        const r = this._cursor;
        let o = r + 1;
        const n = e._elements, i = n[r];
        return 16384 === o && (t = e._next, o = 0), --this._size, this._cursor = o, e !== t && (this._front = t), n[r] = void 0, i;
    }
    forEach(e) {
        let t = this._cursor, r = this._front, o = r._elements;
        for(; !(t === o.length && void 0 === r._next || t === o.length && (r = r._next, o = r._elements, t = 0, 0 === o.length));)e(o[t]), ++t;
    }
    peek() {
        const e = this._front, t = this._cursor;
        return e._elements[t];
    }
}
const $520c3e18ee06325d$var$w = Symbol("[[AbortSteps]]"), $520c3e18ee06325d$var$R = Symbol("[[ErrorSteps]]"), $520c3e18ee06325d$var$T = Symbol("[[CancelSteps]]"), $520c3e18ee06325d$var$P = Symbol("[[PullSteps]]"), $520c3e18ee06325d$var$C = Symbol("[[CanPullSyncSteps]]"), $520c3e18ee06325d$var$q = Symbol("[[ReleaseSteps]]");
function $520c3e18ee06325d$var$E(e, t) {
    e._ownerReadableStream = t, t._reader = e, "readable" === t._state ? $520c3e18ee06325d$var$j(e) : "closed" === t._state ? function(e) {
        $520c3e18ee06325d$var$j(e), $520c3e18ee06325d$var$z(e);
    }(e) : $520c3e18ee06325d$var$k(e, t._storedError);
}
function $520c3e18ee06325d$var$W(e, t) {
    return $520c3e18ee06325d$var$Mr(e._ownerReadableStream, t);
}
function $520c3e18ee06325d$var$O(e) {
    const t = e._ownerReadableStream;
    "readable" === t._state ? $520c3e18ee06325d$var$A(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")) : function(e, t) {
        $520c3e18ee06325d$var$k(e, t);
    }(e, new TypeError("Reader was released and can no longer be used to monitor the stream's closedness")), t._readableStreamController[$520c3e18ee06325d$var$q](), t._reader = void 0, e._ownerReadableStream = void 0;
}
function $520c3e18ee06325d$var$B(e) {
    return new TypeError("Cannot " + e + " a stream using a released reader");
}
function $520c3e18ee06325d$var$j(e) {
    e._closedPromise = $520c3e18ee06325d$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r;
    });
}
function $520c3e18ee06325d$var$k(e, t) {
    $520c3e18ee06325d$var$j(e), $520c3e18ee06325d$var$A(e, t);
}
function $520c3e18ee06325d$var$A(e, t) {
    void 0 !== e._closedPromise_reject && ($520c3e18ee06325d$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
function $520c3e18ee06325d$var$z(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0);
}
const $520c3e18ee06325d$var$D = Number.isFinite || function(e) {
    return "number" == typeof e && isFinite(e);
}, $520c3e18ee06325d$var$F = Math.trunc || function(e) {
    return e < 0 ? Math.ceil(e) : Math.floor(e);
};
function $520c3e18ee06325d$var$L(e, t) {
    if (void 0 !== e && "object" != typeof (r = e) && "function" != typeof r) throw new TypeError(`${t} is not an object.`);
    var r;
}
function $520c3e18ee06325d$var$I(e, t) {
    if ("function" != typeof e) throw new TypeError(`${t} is not a function.`);
}
function $520c3e18ee06325d$var$$(e, t) {
    if (!function(e) {
        return "object" == typeof e && null !== e || "function" == typeof e;
    }(e)) throw new TypeError(`${t} is not an object.`);
}
function $520c3e18ee06325d$var$M(e, t, r) {
    if (void 0 === e) throw new TypeError(`Parameter ${t} is required in '${r}'.`);
}
function $520c3e18ee06325d$var$Y(e, t, r) {
    if (void 0 === e) throw new TypeError(`${t} is required in '${r}'.`);
}
function $520c3e18ee06325d$var$x(e) {
    return Number(e);
}
function $520c3e18ee06325d$var$Q(e) {
    return 0 === e ? 0 : e;
}
function $520c3e18ee06325d$var$N(e, t) {
    const r = Number.MAX_SAFE_INTEGER;
    let o = Number(e);
    if (o = $520c3e18ee06325d$var$Q(o), !$520c3e18ee06325d$var$D(o)) throw new TypeError(`${t} is not a finite number`);
    if (o = function(e) {
        return $520c3e18ee06325d$var$Q($520c3e18ee06325d$var$F(e));
    }(o), o < 0 || o > r) throw new TypeError(`${t} is outside the accepted range of 0 to ${r}, inclusive`);
    return $520c3e18ee06325d$var$D(o) && 0 !== o ? o : 0;
}
function $520c3e18ee06325d$var$H(e, t) {
    if (!$520c3e18ee06325d$var$Ir(e)) throw new TypeError(`${t} is not a ReadableStream.`);
}
function $520c3e18ee06325d$var$V(e) {
    return new $520c3e18ee06325d$export$a890bf36e2af9168(e);
}
function $520c3e18ee06325d$var$U(e, t) {
    e._reader._readRequests.push(t);
}
function $520c3e18ee06325d$var$G(e, t, r) {
    const o = e._reader._readRequests.shift();
    r ? o._closeSteps() : o._chunkSteps(t);
}
function $520c3e18ee06325d$var$X(e) {
    return e._reader._readRequests.length;
}
function $520c3e18ee06325d$var$J(e) {
    const t = e._reader;
    return void 0 !== t && !!$520c3e18ee06325d$var$ee(t);
}
class $520c3e18ee06325d$export$a890bf36e2af9168 {
    constructor(e){
        if ($520c3e18ee06325d$var$M(e, 1, "ReadableStreamDefaultReader"), $520c3e18ee06325d$var$H(e, "First parameter"), $520c3e18ee06325d$var$$r(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        $520c3e18ee06325d$var$E(this, e), this._readRequests = new $520c3e18ee06325d$var$v;
    }
    get closed() {
        return $520c3e18ee06325d$var$ee(this) ? this._closedPromise : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$ne("closed"));
    }
    cancel(e) {
        return $520c3e18ee06325d$var$ee(this) ? void 0 === this._ownerReadableStream ? $520c3e18ee06325d$var$d($520c3e18ee06325d$var$B("cancel")) : $520c3e18ee06325d$var$W(this, e) : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$ne("cancel"));
    }
    read() {
        if (!$520c3e18ee06325d$var$ee(this)) return $520c3e18ee06325d$var$d($520c3e18ee06325d$var$ne("read"));
        if (void 0 === this._ownerReadableStream) return $520c3e18ee06325d$var$d($520c3e18ee06325d$var$B("read from"));
        const e = $520c3e18ee06325d$var$re(this) ? new $520c3e18ee06325d$var$Z : new $520c3e18ee06325d$var$K;
        return $520c3e18ee06325d$var$te(this, e), e._promise;
    }
    releaseLock() {
        if (!$520c3e18ee06325d$var$ee(this)) throw $520c3e18ee06325d$var$ne("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $520c3e18ee06325d$var$O(e);
            const t = new TypeError("Reader was released");
            $520c3e18ee06325d$var$oe(e, t);
        }(this);
    }
}
Object.defineProperties($520c3e18ee06325d$export$a890bf36e2af9168.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$a890bf36e2af9168.prototype.cancel, "cancel"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$a890bf36e2af9168.prototype.read, "read"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$a890bf36e2af9168.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$a890bf36e2af9168.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultReader",
    configurable: !0
});
class $520c3e18ee06325d$var$K {
    constructor(){
        this._promise = $520c3e18ee06325d$var$u((e, t)=>{
            this._resolvePromise = e, this._rejectPromise = t;
        });
    }
    _chunkSteps(e) {
        this._resolvePromise({
            value: e,
            done: !1
        });
    }
    _closeSteps() {
        this._resolvePromise({
            value: void 0,
            done: !0
        });
    }
    _errorSteps(e) {
        this._rejectPromise(e);
    }
}
class $520c3e18ee06325d$var$Z {
    constructor(){
        this._promise = void 0;
    }
    _chunkSteps(e) {
        this._promise = $520c3e18ee06325d$var$l({
            value: e,
            done: !1
        });
    }
    _closeSteps() {
        this._promise = $520c3e18ee06325d$var$l({
            value: void 0,
            done: !0
        });
    }
    _errorSteps(e) {
        this._promise = $520c3e18ee06325d$var$d(e);
    }
}
function $520c3e18ee06325d$var$ee(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readRequests") && e instanceof $520c3e18ee06325d$export$a890bf36e2af9168;
}
function $520c3e18ee06325d$var$te(e, t) {
    const r = e._ownerReadableStream;
    r._disturbed = !0, "closed" === r._state ? t._closeSteps() : "errored" === r._state ? t._errorSteps(r._storedError) : r._readableStreamController[$520c3e18ee06325d$var$P](t);
}
function $520c3e18ee06325d$var$re(e) {
    const t = e._ownerReadableStream;
    return "closed" === t._state || "errored" === t._state || t._readableStreamController[$520c3e18ee06325d$var$C]();
}
function $520c3e18ee06325d$var$oe(e, t) {
    const r = e._readRequests;
    e._readRequests = new $520c3e18ee06325d$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $520c3e18ee06325d$var$ne(e) {
    return new TypeError(`ReadableStreamDefaultReader.prototype.${e} can only be used on a ReadableStreamDefaultReader`);
}
var $520c3e18ee06325d$var$ie, $520c3e18ee06325d$var$ae, $520c3e18ee06325d$var$se;
function $520c3e18ee06325d$var$le(e) {
    return e.slice();
}
function $520c3e18ee06325d$var$ue(e, t, r, o, n) {
    new Uint8Array(e).set(new Uint8Array(r, o, n), t);
}
let $520c3e18ee06325d$var$ce = (e)=>($520c3e18ee06325d$var$ce = "function" == typeof e.transfer ? (e)=>e.transfer() : "function" == typeof structuredClone ? (e)=>structuredClone(e, {
            transfer: [
                e
            ]
        }) : (e)=>e, $520c3e18ee06325d$var$ce(e)), $520c3e18ee06325d$var$de = (e)=>($520c3e18ee06325d$var$de = "boolean" == typeof e.detached ? (e)=>e.detached : (e)=>0 === e.byteLength, $520c3e18ee06325d$var$de(e));
function $520c3e18ee06325d$var$fe(e, t, r) {
    if (e.slice) return e.slice(t, r);
    const o = r - t, n = new ArrayBuffer(o);
    return $520c3e18ee06325d$var$ue(n, 0, e, t, o), n;
}
function $520c3e18ee06325d$var$he(e, t) {
    const r = e[t];
    if (null != r) {
        if ("function" != typeof r) throw new TypeError(`${String(t)} is not a function`);
        return r;
    }
}
function $520c3e18ee06325d$var$be(e) {
    try {
        const t = e.done, r = e.value;
        return $520c3e18ee06325d$var$f($520c3e18ee06325d$var$l(r), (e)=>({
                done: t,
                value: e
            }));
    } catch (e) {
        return $520c3e18ee06325d$var$d(e);
    }
}
const $520c3e18ee06325d$var$_e = null !== ($520c3e18ee06325d$var$se = null !== ($520c3e18ee06325d$var$ie = Symbol.asyncIterator) && void 0 !== $520c3e18ee06325d$var$ie ? $520c3e18ee06325d$var$ie : null === ($520c3e18ee06325d$var$ae = Symbol.for) || void 0 === $520c3e18ee06325d$var$ae ? void 0 : $520c3e18ee06325d$var$ae.call(Symbol, "Symbol.asyncIterator")) && void 0 !== $520c3e18ee06325d$var$se ? $520c3e18ee06325d$var$se : "@@asyncIterator";
function $520c3e18ee06325d$var$me(e, r = "sync", o) {
    if (void 0 === o) {
        if ("async" === r) {
            if (void 0 === (o = $520c3e18ee06325d$var$he(e, $520c3e18ee06325d$var$_e))) return function(e) {
                const r = {
                    next () {
                        let t;
                        try {
                            t = $520c3e18ee06325d$var$pe(e);
                        } catch (e) {
                            return $520c3e18ee06325d$var$d(e);
                        }
                        return $520c3e18ee06325d$var$be(t);
                    },
                    return (r) {
                        let o;
                        try {
                            const t = $520c3e18ee06325d$var$he(e.iterator, "return");
                            if (void 0 === t) return $520c3e18ee06325d$var$c({
                                done: !0,
                                value: r
                            });
                            o = $520c3e18ee06325d$var$S(t, e.iterator, [
                                r
                            ]);
                        } catch (e) {
                            return $520c3e18ee06325d$var$d(e);
                        }
                        return $520c3e18ee06325d$var$t(o) ? $520c3e18ee06325d$var$be(o) : $520c3e18ee06325d$var$d(new TypeError("The iterator.return() method must return an object"));
                    }
                };
                return {
                    iterator: r,
                    nextMethod: r.next,
                    done: !1
                };
            }($520c3e18ee06325d$var$me(e, "sync", $520c3e18ee06325d$var$he(e, Symbol.iterator)));
        } else o = $520c3e18ee06325d$var$he(e, Symbol.iterator);
    }
    if (void 0 === o) throw new TypeError("The object is not iterable");
    const n = $520c3e18ee06325d$var$S(o, e, []);
    if (!$520c3e18ee06325d$var$t(n)) throw new TypeError("The iterator method must return an object");
    return {
        iterator: n,
        nextMethod: n.next,
        done: !1
    };
}
function $520c3e18ee06325d$var$pe(e) {
    const r = $520c3e18ee06325d$var$S(e.nextMethod, e.iterator, []);
    if (!$520c3e18ee06325d$var$t(r)) throw new TypeError("The iterator.next() method must return an object");
    return r;
}
class $520c3e18ee06325d$var$ye {
    constructor(e, t){
        this._ongoingPromise = void 0, this._isFinished = !1, this._reader = e, this._preventCancel = t;
    }
    next() {
        const e = ()=>this._nextSteps();
        return this._ongoingPromise = this._ongoingPromise ? $520c3e18ee06325d$var$m(this._ongoingPromise, e, e) : e(), this._ongoingPromise;
    }
    return(e) {
        const t = ()=>this._returnSteps(e);
        return this._ongoingPromise = this._ongoingPromise ? $520c3e18ee06325d$var$m(this._ongoingPromise, t, t) : t(), this._ongoingPromise;
    }
    _nextSteps() {
        if (this._isFinished) return Promise.resolve({
            value: void 0,
            done: !0
        });
        const e = this._reader, t = new $520c3e18ee06325d$var$Se(this);
        return $520c3e18ee06325d$var$te(e, t), t._promise;
    }
    _returnSteps(e) {
        if (this._isFinished) return Promise.resolve({
            value: e,
            done: !0
        });
        this._isFinished = !0;
        const t = this._reader;
        if (!this._preventCancel) {
            const r = $520c3e18ee06325d$var$W(t, e);
            return $520c3e18ee06325d$var$O(t), $520c3e18ee06325d$var$m(r, ()=>({
                    value: e,
                    done: !0
                }));
        }
        return $520c3e18ee06325d$var$O(t), $520c3e18ee06325d$var$c({
            value: e,
            done: !0
        });
    }
}
class $520c3e18ee06325d$var$Se {
    constructor(e){
        this._iterator = e, this._promise = $520c3e18ee06325d$var$u((e, t)=>{
            this._resolvePromise = e, this._rejectPromise = t;
        });
    }
    _chunkSteps(e) {
        this._iterator._ongoingPromise = void 0, $520c3e18ee06325d$var$y(()=>this._resolvePromise({
                value: e,
                done: !1
            }));
    }
    _closeSteps() {
        const e = this._iterator;
        e._ongoingPromise = void 0, e._isFinished = !0, $520c3e18ee06325d$var$O(e._reader), this._resolvePromise({
            value: void 0,
            done: !0
        });
    }
    _errorSteps(e) {
        const t = this._iterator;
        t._ongoingPromise = void 0, t._isFinished = !0, $520c3e18ee06325d$var$O(t._reader), this._rejectPromise(e);
    }
}
const $520c3e18ee06325d$var$ge = {
    next () {
        return $520c3e18ee06325d$var$ve(this) ? this._asyncIteratorImpl.next() : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$we("next"));
    },
    return (e) {
        return $520c3e18ee06325d$var$ve(this) ? this._asyncIteratorImpl.return(e) : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$we("return"));
    },
    [$520c3e18ee06325d$var$_e] () {
        return this;
    }
};
function $520c3e18ee06325d$var$ve(e) {
    if (!$520c3e18ee06325d$var$t(e)) return !1;
    if (!Object.prototype.hasOwnProperty.call(e, "_asyncIteratorImpl")) return !1;
    try {
        return e._asyncIteratorImpl instanceof $520c3e18ee06325d$var$ye;
    } catch (e) {
        return !1;
    }
}
function $520c3e18ee06325d$var$we(e) {
    return new TypeError(`ReadableStreamAsyncIterator.${e} can only be used on a ReadableSteamAsyncIterator`);
}
Object.defineProperty($520c3e18ee06325d$var$ge, $520c3e18ee06325d$var$_e, {
    enumerable: !1
});
const $520c3e18ee06325d$var$Re = Number.isNaN || function(e) {
    return e != e;
};
function $520c3e18ee06325d$var$Te(e) {
    const t = $520c3e18ee06325d$var$fe(e.buffer, e.byteOffset, e.byteOffset + e.byteLength);
    return new Uint8Array(t);
}
function $520c3e18ee06325d$var$Pe(e) {
    const t = e._queue.shift();
    return e._queueTotalSize -= t.size, e._queueTotalSize < 0 && (e._queueTotalSize = 0), t.value;
}
function $520c3e18ee06325d$var$Ce(e, t, r) {
    if ("number" != typeof (o = r) || $520c3e18ee06325d$var$Re(o) || o < 0 || r === 1 / 0) throw new RangeError("Size must be a finite, non-NaN, non-negative number.");
    var o;
    e._queue.push({
        value: t,
        size: r
    }), e._queueTotalSize += r;
}
function $520c3e18ee06325d$var$qe(e) {
    e._queue = new $520c3e18ee06325d$var$v, e._queueTotalSize = 0;
}
function $520c3e18ee06325d$var$Ee(e) {
    return e === DataView;
}
function $520c3e18ee06325d$var$We(e) {
    return $520c3e18ee06325d$var$Ee(e) ? 1 : e.BYTES_PER_ELEMENT;
}
class $520c3e18ee06325d$export$fbcf11583158d2c {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get view() {
        if (!$520c3e18ee06325d$var$Be(this)) throw $520c3e18ee06325d$var$ot("view");
        return this._view;
    }
    respond(e) {
        if (!$520c3e18ee06325d$var$Be(this)) throw $520c3e18ee06325d$var$ot("respond");
        if ($520c3e18ee06325d$var$M(e, 1, "respond"), e = $520c3e18ee06325d$var$N(e, "First parameter"), void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($520c3e18ee06325d$var$de(this._view.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be used as a response");
        $520c3e18ee06325d$var$et(this._associatedReadableByteStreamController, e);
    }
    respondWithNewView(e) {
        if (!$520c3e18ee06325d$var$Be(this)) throw $520c3e18ee06325d$var$ot("respondWithNewView");
        if ($520c3e18ee06325d$var$M(e, 1, "respondWithNewView"), !ArrayBuffer.isView(e)) throw new TypeError("You can only respond with array buffer views");
        if (void 0 === this._associatedReadableByteStreamController) throw new TypeError("This BYOB request has been invalidated");
        if ($520c3e18ee06325d$var$de(e.buffer)) throw new TypeError("The given view's buffer has been detached and so cannot be used as a response");
        $520c3e18ee06325d$var$tt(this._associatedReadableByteStreamController, e);
    }
}
Object.defineProperties($520c3e18ee06325d$export$fbcf11583158d2c.prototype, {
    respond: {
        enumerable: !0
    },
    respondWithNewView: {
        enumerable: !0
    },
    view: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$fbcf11583158d2c.prototype.respond, "respond"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$fbcf11583158d2c.prototype.respondWithNewView, "respondWithNewView"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$fbcf11583158d2c.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBRequest",
    configurable: !0
});
class $520c3e18ee06325d$export$2047cf34091e94ac {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get byobRequest() {
        if (!$520c3e18ee06325d$var$Oe(this)) throw $520c3e18ee06325d$var$nt("byobRequest");
        return $520c3e18ee06325d$var$Ke(this);
    }
    get desiredSize() {
        if (!$520c3e18ee06325d$var$Oe(this)) throw $520c3e18ee06325d$var$nt("desiredSize");
        return $520c3e18ee06325d$var$Ze(this);
    }
    close() {
        if (!$520c3e18ee06325d$var$Oe(this)) throw $520c3e18ee06325d$var$nt("close");
        if (this._closeRequested) throw new TypeError("The stream has already been closed; do not close it again!");
        const e = this._controlledReadableByteStream._state;
        if ("readable" !== e) throw new TypeError(`The stream (in ${e} state) is not in the readable state and cannot be closed`);
        $520c3e18ee06325d$var$Ue(this);
    }
    enqueue(e) {
        if (!$520c3e18ee06325d$var$Oe(this)) throw $520c3e18ee06325d$var$nt("enqueue");
        if ($520c3e18ee06325d$var$M(e, 1, "enqueue"), !ArrayBuffer.isView(e)) throw new TypeError("chunk must be an array buffer view");
        if (0 === e.byteLength) throw new TypeError("chunk must have non-zero byteLength");
        if (0 === e.buffer.byteLength) throw new TypeError("chunk's buffer must have non-zero byteLength");
        if (this._closeRequested) throw new TypeError("stream is closed or draining");
        const t = this._controlledReadableByteStream._state;
        if ("readable" !== t) throw new TypeError(`The stream (in ${t} state) is not in the readable state and cannot be enqueued to`);
        $520c3e18ee06325d$var$Ge(this, e);
    }
    error(e) {
        if (!$520c3e18ee06325d$var$Oe(this)) throw $520c3e18ee06325d$var$nt("error");
        $520c3e18ee06325d$var$Xe(this, e);
    }
    [$520c3e18ee06325d$var$T](e) {
        $520c3e18ee06325d$var$ke(this), $520c3e18ee06325d$var$qe(this);
        const t = this._cancelAlgorithm(e);
        return $520c3e18ee06325d$var$Ve(this), t;
    }
    [$520c3e18ee06325d$var$P](e) {
        const t = this._controlledReadableByteStream;
        if (this._queueTotalSize > 0) return void $520c3e18ee06325d$var$Je(this, e);
        const r = this._autoAllocateChunkSize;
        if (void 0 !== r) {
            let t;
            try {
                t = new ArrayBuffer(r);
            } catch (t) {
                return void e._errorSteps(t);
            }
            const o = {
                buffer: t,
                bufferByteLength: r,
                byteOffset: 0,
                byteLength: r,
                bytesFilled: 0,
                minimumFill: 1,
                elementSize: 1,
                viewConstructor: Uint8Array,
                readerType: "default"
            };
            this._pendingPullIntos.push(o);
        }
        $520c3e18ee06325d$var$U(t, e), $520c3e18ee06325d$var$je(this);
    }
    [$520c3e18ee06325d$var$C]() {
        return this._queueTotalSize > 0;
    }
    [$520c3e18ee06325d$var$q]() {
        if (this._pendingPullIntos.length > 0) {
            const e = this._pendingPullIntos.peek();
            e.readerType = "none", this._pendingPullIntos = new $520c3e18ee06325d$var$v, this._pendingPullIntos.push(e);
        }
    }
}
function $520c3e18ee06325d$var$Oe(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableByteStream") && e instanceof $520c3e18ee06325d$export$2047cf34091e94ac;
}
function $520c3e18ee06325d$var$Be(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_associatedReadableByteStreamController") && e instanceof $520c3e18ee06325d$export$fbcf11583158d2c;
}
function $520c3e18ee06325d$var$je(e) {
    const t = function(e) {
        const t = e._controlledReadableByteStream;
        if ("readable" !== t._state) return !1;
        if (e._closeRequested) return !1;
        if (!e._started) return !1;
        if ($520c3e18ee06325d$var$J(t) && $520c3e18ee06325d$var$X(t) > 0) return !0;
        if ($520c3e18ee06325d$var$ut(t) && $520c3e18ee06325d$var$lt(t) > 0) return !0;
        const r = $520c3e18ee06325d$var$Ze(e);
        if (r > 0) return !0;
        return !1;
    }(e);
    if (!t) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $520c3e18ee06325d$var$h(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $520c3e18ee06325d$var$je(e)), null), (t)=>($520c3e18ee06325d$var$Xe(e, t), null));
}
function $520c3e18ee06325d$var$ke(e) {
    $520c3e18ee06325d$var$xe(e), e._pendingPullIntos = new $520c3e18ee06325d$var$v;
}
function $520c3e18ee06325d$var$Ae(e, t) {
    let r = !1;
    "closed" === e._state && (r = !0);
    const o = $520c3e18ee06325d$var$De(t);
    "default" === t.readerType ? $520c3e18ee06325d$var$G(e, o, r) : function(e, t, r) {
        const o = e._reader, n = o._readIntoRequests.shift();
        r ? n._closeSteps(t) : n._chunkSteps(t);
    }(e, o, r);
}
function $520c3e18ee06325d$var$ze(e, t) {
    for(let r = 0; r < t.length; ++r)$520c3e18ee06325d$var$Ae(e, t[r]);
}
function $520c3e18ee06325d$var$De(e) {
    const t = e.bytesFilled, r = e.elementSize;
    return new e.viewConstructor(e.buffer, e.byteOffset, t / r);
}
function $520c3e18ee06325d$var$Fe(e, t, r, o) {
    e._queue.push({
        buffer: t,
        byteOffset: r,
        byteLength: o
    }), e._queueTotalSize += o;
}
function $520c3e18ee06325d$var$Le(e, t, r, o) {
    let n;
    try {
        n = $520c3e18ee06325d$var$fe(t, r, r + o);
    } catch (t) {
        throw $520c3e18ee06325d$var$Xe(e, t), t;
    }
    $520c3e18ee06325d$var$Fe(e, n, 0, o);
}
function $520c3e18ee06325d$var$Ie(e, t) {
    t.bytesFilled > 0 && $520c3e18ee06325d$var$Le(e, t.buffer, t.byteOffset, t.bytesFilled), $520c3e18ee06325d$var$He(e);
}
function $520c3e18ee06325d$var$$e(e, t) {
    const r = Math.min(e._queueTotalSize, t.byteLength - t.bytesFilled), o = t.bytesFilled + r;
    let n = r, i = !1;
    const a = o - o % t.elementSize;
    a >= t.minimumFill && (n = a - t.bytesFilled, i = !0);
    const s = e._queue;
    for(; n > 0;){
        const r = s.peek(), o = Math.min(n, r.byteLength), i = t.byteOffset + t.bytesFilled;
        $520c3e18ee06325d$var$ue(t.buffer, i, r.buffer, r.byteOffset, o), r.byteLength === o ? s.shift() : (r.byteOffset += o, r.byteLength -= o), e._queueTotalSize -= o, $520c3e18ee06325d$var$Me(e, o, t), n -= o;
    }
    return i;
}
function $520c3e18ee06325d$var$Me(e, t, r) {
    r.bytesFilled += t;
}
function $520c3e18ee06325d$var$Ye(e) {
    0 === e._queueTotalSize && e._closeRequested ? ($520c3e18ee06325d$var$Ve(e), $520c3e18ee06325d$var$Yr(e._controlledReadableByteStream)) : $520c3e18ee06325d$var$je(e);
}
function $520c3e18ee06325d$var$xe(e) {
    null !== e._byobRequest && (e._byobRequest._associatedReadableByteStreamController = void 0, e._byobRequest._view = null, e._byobRequest = null);
}
function $520c3e18ee06325d$var$Qe(e) {
    const t = [];
    for(; e._pendingPullIntos.length > 0 && 0 !== e._queueTotalSize;){
        const r = e._pendingPullIntos.peek();
        $520c3e18ee06325d$var$$e(e, r) && ($520c3e18ee06325d$var$He(e), t.push(r));
    }
    return t;
}
function $520c3e18ee06325d$var$Ne(e, t) {
    const r = e._pendingPullIntos.peek();
    $520c3e18ee06325d$var$xe(e);
    "closed" === e._controlledReadableByteStream._state ? function(e, t) {
        "none" === t.readerType && $520c3e18ee06325d$var$He(e);
        const r = e._controlledReadableByteStream;
        if ($520c3e18ee06325d$var$ut(r)) {
            const t = [];
            for(; t.length < $520c3e18ee06325d$var$lt(r);)t.push($520c3e18ee06325d$var$He(e));
            $520c3e18ee06325d$var$ze(r, t);
        }
    }(e, r) : function(e, t, r) {
        if ($520c3e18ee06325d$var$Me(0, t, r), "none" === r.readerType) {
            $520c3e18ee06325d$var$Ie(e, r);
            const t = $520c3e18ee06325d$var$Qe(e);
            return void $520c3e18ee06325d$var$ze(e._controlledReadableByteStream, t);
        }
        if (r.bytesFilled < r.minimumFill) return;
        $520c3e18ee06325d$var$He(e);
        const o = r.bytesFilled % r.elementSize;
        if (o > 0) {
            const t = r.byteOffset + r.bytesFilled;
            $520c3e18ee06325d$var$Le(e, r.buffer, t - o, o);
        }
        r.bytesFilled -= o;
        const n = $520c3e18ee06325d$var$Qe(e);
        $520c3e18ee06325d$var$Ae(e._controlledReadableByteStream, r), $520c3e18ee06325d$var$ze(e._controlledReadableByteStream, n);
    }(e, t, r), $520c3e18ee06325d$var$je(e);
}
function $520c3e18ee06325d$var$He(e) {
    return e._pendingPullIntos.shift();
}
function $520c3e18ee06325d$var$Ve(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $520c3e18ee06325d$var$Ue(e) {
    const t = e._controlledReadableByteStream;
    if (!e._closeRequested && "readable" === t._state) {
        if (e._queueTotalSize > 0) e._closeRequested = !0;
        else {
            if (e._pendingPullIntos.length > 0) {
                const t = e._pendingPullIntos.peek();
                if (t.bytesFilled % t.elementSize !== 0) {
                    const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                    throw $520c3e18ee06325d$var$Xe(e, t), t;
                }
            }
            $520c3e18ee06325d$var$Ve(e), $520c3e18ee06325d$var$Yr(t);
        }
    }
}
function $520c3e18ee06325d$var$Ge(e, t) {
    const r = e._controlledReadableByteStream;
    if (e._closeRequested || "readable" !== r._state) return;
    const { buffer: o, byteOffset: n, byteLength: i } = t;
    if ($520c3e18ee06325d$var$de(o)) throw new TypeError("chunk's buffer is detached and so cannot be enqueued");
    const a = $520c3e18ee06325d$var$ce(o);
    if (e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek();
        if ($520c3e18ee06325d$var$de(t.buffer)) throw new TypeError("The BYOB request's buffer has been detached and so cannot be filled with an enqueued chunk");
        $520c3e18ee06325d$var$xe(e), t.buffer = $520c3e18ee06325d$var$ce(t.buffer), "none" === t.readerType && $520c3e18ee06325d$var$Ie(e, t);
    }
    if ($520c3e18ee06325d$var$J(r)) {
        if (function(e) {
            const t = e._controlledReadableByteStream._reader;
            for(; t._readRequests.length > 0;){
                if (0 === e._queueTotalSize) return;
                $520c3e18ee06325d$var$Je(e, t._readRequests.shift());
            }
        }(e), 0 === $520c3e18ee06325d$var$X(r)) $520c3e18ee06325d$var$Fe(e, a, n, i);
        else {
            e._pendingPullIntos.length > 0 && $520c3e18ee06325d$var$He(e);
            $520c3e18ee06325d$var$G(r, new Uint8Array(a, n, i), !1);
        }
    } else if ($520c3e18ee06325d$var$ut(r)) {
        $520c3e18ee06325d$var$Fe(e, a, n, i);
        $520c3e18ee06325d$var$ze(r, $520c3e18ee06325d$var$Qe(e));
    } else $520c3e18ee06325d$var$Fe(e, a, n, i);
    $520c3e18ee06325d$var$je(e);
}
function $520c3e18ee06325d$var$Xe(e, t) {
    const r = e._controlledReadableByteStream;
    "readable" === r._state && ($520c3e18ee06325d$var$ke(e), $520c3e18ee06325d$var$qe(e), $520c3e18ee06325d$var$Ve(e), $520c3e18ee06325d$var$xr(r, t));
}
function $520c3e18ee06325d$var$Je(e, t) {
    const r = e._queue.shift();
    e._queueTotalSize -= r.byteLength, $520c3e18ee06325d$var$Ye(e);
    const o = new Uint8Array(r.buffer, r.byteOffset, r.byteLength);
    t._chunkSteps(o);
}
function $520c3e18ee06325d$var$Ke(e) {
    if (null === e._byobRequest && e._pendingPullIntos.length > 0) {
        const t = e._pendingPullIntos.peek(), r = new Uint8Array(t.buffer, t.byteOffset + t.bytesFilled, t.byteLength - t.bytesFilled), o = Object.create($520c3e18ee06325d$export$fbcf11583158d2c.prototype);
        !function(e, t, r) {
            e._associatedReadableByteStreamController = t, e._view = r;
        }(o, e, r), e._byobRequest = o;
    }
    return e._byobRequest;
}
function $520c3e18ee06325d$var$Ze(e) {
    const t = e._controlledReadableByteStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $520c3e18ee06325d$var$et(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t) throw new TypeError("bytesWritten must be 0 when calling respond() on a closed stream");
    } else {
        if (0 === t) throw new TypeError("bytesWritten must be greater than 0 when calling respond() on a readable stream");
        if (r.bytesFilled + t > r.byteLength) throw new RangeError("bytesWritten out of range");
    }
    r.buffer = $520c3e18ee06325d$var$ce(r.buffer), $520c3e18ee06325d$var$Ne(e, t);
}
function $520c3e18ee06325d$var$tt(e, t) {
    const r = e._pendingPullIntos.peek();
    if ("closed" === e._controlledReadableByteStream._state) {
        if (0 !== t.byteLength) throw new TypeError("The view's length must be 0 when calling respondWithNewView() on a closed stream");
    } else if (0 === t.byteLength) throw new TypeError("The view's length must be greater than 0 when calling respondWithNewView() on a readable stream");
    if (r.byteOffset + r.bytesFilled !== t.byteOffset) throw new RangeError("The region specified by view does not match byobRequest");
    if (r.bufferByteLength !== t.buffer.byteLength) throw new RangeError("The buffer of view has different capacity than byobRequest");
    if (r.bytesFilled + t.byteLength > r.byteLength) throw new RangeError("The region specified by view is larger than byobRequest");
    const o = t.byteLength;
    r.buffer = $520c3e18ee06325d$var$ce(t.buffer), $520c3e18ee06325d$var$Ne(e, o);
}
function $520c3e18ee06325d$var$rt(e, t, r, o, n, i, a) {
    t._controlledReadableByteStream = e, t._pullAgain = !1, t._pulling = !1, t._byobRequest = null, t._queue = t._queueTotalSize = void 0, $520c3e18ee06325d$var$qe(t), t._closeRequested = !1, t._started = !1, t._strategyHWM = i, t._pullAlgorithm = o, t._cancelAlgorithm = n, t._autoAllocateChunkSize = a, t._pendingPullIntos = new $520c3e18ee06325d$var$v, e._readableStreamController = t;
    $520c3e18ee06325d$var$h($520c3e18ee06325d$var$c(r()), ()=>(t._started = !0, $520c3e18ee06325d$var$je(t), null), (e)=>($520c3e18ee06325d$var$Xe(t, e), null));
}
function $520c3e18ee06325d$var$ot(e) {
    return new TypeError(`ReadableStreamBYOBRequest.prototype.${e} can only be used on a ReadableStreamBYOBRequest`);
}
function $520c3e18ee06325d$var$nt(e) {
    return new TypeError(`ReadableByteStreamController.prototype.${e} can only be used on a ReadableByteStreamController`);
}
function $520c3e18ee06325d$var$it(e, t) {
    if ("byob" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamReaderMode`);
    return e;
}
function $520c3e18ee06325d$var$at(e) {
    return new $520c3e18ee06325d$export$20068a30393fcc28(e);
}
function $520c3e18ee06325d$var$st(e, t) {
    e._reader._readIntoRequests.push(t);
}
function $520c3e18ee06325d$var$lt(e) {
    return e._reader._readIntoRequests.length;
}
function $520c3e18ee06325d$var$ut(e) {
    const t = e._reader;
    return void 0 !== t && !!$520c3e18ee06325d$var$ft(t);
}
Object.defineProperties($520c3e18ee06325d$export$2047cf34091e94ac.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    byobRequest: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$2047cf34091e94ac.prototype.close, "close"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$2047cf34091e94ac.prototype.enqueue, "enqueue"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$2047cf34091e94ac.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$2047cf34091e94ac.prototype, Symbol.toStringTag, {
    value: "ReadableByteStreamController",
    configurable: !0
});
class $520c3e18ee06325d$export$20068a30393fcc28 {
    constructor(e){
        if ($520c3e18ee06325d$var$M(e, 1, "ReadableStreamBYOBReader"), $520c3e18ee06325d$var$H(e, "First parameter"), $520c3e18ee06325d$var$$r(e)) throw new TypeError("This stream has already been locked for exclusive reading by another reader");
        if (!$520c3e18ee06325d$var$Oe(e._readableStreamController)) throw new TypeError("Cannot construct a ReadableStreamBYOBReader for a stream not constructed with a byte source");
        $520c3e18ee06325d$var$E(this, e), this._readIntoRequests = new $520c3e18ee06325d$var$v;
    }
    get closed() {
        return $520c3e18ee06325d$var$ft(this) ? this._closedPromise : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$_t("closed"));
    }
    cancel(e) {
        return $520c3e18ee06325d$var$ft(this) ? void 0 === this._ownerReadableStream ? $520c3e18ee06325d$var$d($520c3e18ee06325d$var$B("cancel")) : $520c3e18ee06325d$var$W(this, e) : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$_t("cancel"));
    }
    read(e, t = {}) {
        if (!$520c3e18ee06325d$var$ft(this)) return $520c3e18ee06325d$var$d($520c3e18ee06325d$var$_t("read"));
        if (!ArrayBuffer.isView(e)) return $520c3e18ee06325d$var$d(new TypeError("view must be an array buffer view"));
        if (0 === e.byteLength) return $520c3e18ee06325d$var$d(new TypeError("view must have non-zero byteLength"));
        if (0 === e.buffer.byteLength) return $520c3e18ee06325d$var$d(new TypeError("view's buffer must have non-zero byteLength"));
        if ($520c3e18ee06325d$var$de(e.buffer)) return $520c3e18ee06325d$var$d(new TypeError("view's buffer has been detached"));
        let r;
        try {
            r = function(e, t) {
                var r;
                return $520c3e18ee06325d$var$L(e, t), {
                    min: $520c3e18ee06325d$var$N(null !== (r = null == e ? void 0 : e.min) && void 0 !== r ? r : 1, `${t} has member 'min' that`)
                };
            }(t, "options");
        } catch (e) {
            return $520c3e18ee06325d$var$d(e);
        }
        const o = r.min;
        if (0 === o) return $520c3e18ee06325d$var$d(new TypeError("options.min must be greater than 0"));
        if (function(e) {
            return $520c3e18ee06325d$var$Ee(e.constructor);
        }(e)) {
            if (o > e.byteLength) return $520c3e18ee06325d$var$d(new RangeError("options.min must be less than or equal to view's byteLength"));
        } else if (o > e.length) return $520c3e18ee06325d$var$d(new RangeError("options.min must be less than or equal to view's length"));
        if (void 0 === this._ownerReadableStream) return $520c3e18ee06325d$var$d($520c3e18ee06325d$var$B("read from"));
        const n = function(e, t, r) {
            const o = e._ownerReadableStream;
            return "errored" === o._state || function(e, t, r) {
                const o = e._controlledReadableByteStream, n = $520c3e18ee06325d$var$We(t.constructor), { byteLength: i } = t, a = r * n;
                return !(e._pendingPullIntos.length > 0) && ("closed" === o._state || e._queueTotalSize >= a);
            }(o._readableStreamController, t, r);
        }(this, e, o) ? new $520c3e18ee06325d$var$dt : new $520c3e18ee06325d$var$ct;
        return $520c3e18ee06325d$var$ht(this, e, o, n), n._promise;
    }
    releaseLock() {
        if (!$520c3e18ee06325d$var$ft(this)) throw $520c3e18ee06325d$var$_t("releaseLock");
        void 0 !== this._ownerReadableStream && function(e) {
            $520c3e18ee06325d$var$O(e);
            const t = new TypeError("Reader was released");
            $520c3e18ee06325d$var$bt(e, t);
        }(this);
    }
}
Object.defineProperties($520c3e18ee06325d$export$20068a30393fcc28.prototype, {
    cancel: {
        enumerable: !0
    },
    read: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$20068a30393fcc28.prototype.cancel, "cancel"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$20068a30393fcc28.prototype.read, "read"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$20068a30393fcc28.prototype.releaseLock, "releaseLock"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$20068a30393fcc28.prototype, Symbol.toStringTag, {
    value: "ReadableStreamBYOBReader",
    configurable: !0
});
class $520c3e18ee06325d$var$ct {
    constructor(){
        this._promise = $520c3e18ee06325d$var$u((e, t)=>{
            this._resolvePromise = e, this._rejectPromise = t;
        });
    }
    _chunkSteps(e) {
        this._resolvePromise({
            value: e,
            done: !1
        });
    }
    _closeSteps(e) {
        this._resolvePromise({
            value: e,
            done: !0
        });
    }
    _errorSteps(e) {
        this._rejectPromise(e);
    }
}
class $520c3e18ee06325d$var$dt {
    constructor(){
        this._promise = void 0;
    }
    _chunkSteps(e) {
        this._promise = $520c3e18ee06325d$var$l({
            value: e,
            done: !1
        });
    }
    _closeSteps(e) {
        this._promise = $520c3e18ee06325d$var$l({
            value: e,
            done: !0
        });
    }
    _errorSteps(e) {
        this._promise = $520c3e18ee06325d$var$d(e);
    }
}
function $520c3e18ee06325d$var$ft(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readIntoRequests") && e instanceof $520c3e18ee06325d$export$20068a30393fcc28;
}
function $520c3e18ee06325d$var$ht(e, t, r, o) {
    const n = e._ownerReadableStream;
    n._disturbed = !0, "errored" === n._state ? o._errorSteps(n._storedError) : function(e, t, r, o) {
        const n = e._controlledReadableByteStream, i = t.constructor, a = $520c3e18ee06325d$var$We(i), { byteOffset: s, byteLength: l } = t, u = r * a;
        let c;
        try {
            c = $520c3e18ee06325d$var$ce(t.buffer);
        } catch (e) {
            return void o._errorSteps(e);
        }
        const d = {
            buffer: c,
            bufferByteLength: c.byteLength,
            byteOffset: s,
            byteLength: l,
            bytesFilled: 0,
            minimumFill: u,
            elementSize: a,
            viewConstructor: i,
            readerType: "byob"
        };
        if (e._pendingPullIntos.length > 0) return e._pendingPullIntos.push(d), void $520c3e18ee06325d$var$st(n, o);
        if ("closed" === n._state) {
            const e = new i(d.buffer, d.byteOffset, 0);
            return void o._closeSteps(e);
        }
        if (e._queueTotalSize > 0) {
            if ($520c3e18ee06325d$var$$e(e, d)) {
                const t = $520c3e18ee06325d$var$De(d);
                return $520c3e18ee06325d$var$Ye(e), void o._chunkSteps(t);
            }
            if (e._closeRequested) {
                const t = new TypeError("Insufficient bytes to fill elements in the given buffer");
                return $520c3e18ee06325d$var$Xe(e, t), void o._errorSteps(t);
            }
        }
        e._pendingPullIntos.push(d), $520c3e18ee06325d$var$st(n, o), $520c3e18ee06325d$var$je(e);
    }(n._readableStreamController, t, r, o);
}
function $520c3e18ee06325d$var$bt(e, t) {
    const r = e._readIntoRequests;
    e._readIntoRequests = new $520c3e18ee06325d$var$v, r.forEach((e)=>{
        e._errorSteps(t);
    });
}
function $520c3e18ee06325d$var$_t(e) {
    return new TypeError(`ReadableStreamBYOBReader.prototype.${e} can only be used on a ReadableStreamBYOBReader`);
}
function $520c3e18ee06325d$var$mt(e, t) {
    const { highWaterMark: r } = e;
    if (void 0 === r) return t;
    if ($520c3e18ee06325d$var$Re(r) || r < 0) throw new RangeError("Invalid highWaterMark");
    return r;
}
function $520c3e18ee06325d$var$pt(e) {
    const { size: t } = e;
    return t || (()=>1);
}
function $520c3e18ee06325d$var$yt(e, t) {
    $520c3e18ee06325d$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark, o = null == e ? void 0 : e.size;
    return {
        highWaterMark: void 0 === r ? void 0 : $520c3e18ee06325d$var$x(r),
        size: void 0 === o ? void 0 : $520c3e18ee06325d$var$St(o, `${t} has member 'size' that`)
    };
}
function $520c3e18ee06325d$var$St(e, t) {
    return $520c3e18ee06325d$var$I(e, t), (t)=>$520c3e18ee06325d$var$x(e(t));
}
function $520c3e18ee06325d$var$gt(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r)=>$520c3e18ee06325d$var$g(e, t, [
            r
        ]);
}
function $520c3e18ee06325d$var$vt(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), ()=>$520c3e18ee06325d$var$g(e, t, []);
}
function $520c3e18ee06325d$var$wt(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r)=>$520c3e18ee06325d$var$S(e, t, [
            r
        ]);
}
function $520c3e18ee06325d$var$Rt(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r, o)=>$520c3e18ee06325d$var$g(e, t, [
            r,
            o
        ]);
}
function $520c3e18ee06325d$var$Tt(e, t) {
    if (!$520c3e18ee06325d$var$qt(e)) throw new TypeError(`${t} is not a WritableStream.`);
}
class $520c3e18ee06325d$export$826849241f7970f8 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $520c3e18ee06325d$var$$(e, "First parameter");
        const r = $520c3e18ee06325d$var$yt(t, "Second parameter"), o = function(e, t) {
            $520c3e18ee06325d$var$L(e, t);
            const r = null == e ? void 0 : e.abort, o = null == e ? void 0 : e.close, n = null == e ? void 0 : e.start, i = null == e ? void 0 : e.type, a = null == e ? void 0 : e.write;
            return {
                abort: void 0 === r ? void 0 : $520c3e18ee06325d$var$gt(r, e, `${t} has member 'abort' that`),
                close: void 0 === o ? void 0 : $520c3e18ee06325d$var$vt(o, e, `${t} has member 'close' that`),
                start: void 0 === n ? void 0 : $520c3e18ee06325d$var$wt(n, e, `${t} has member 'start' that`),
                write: void 0 === a ? void 0 : $520c3e18ee06325d$var$Rt(a, e, `${t} has member 'write' that`),
                type: i
            };
        }(e, "First parameter");
        $520c3e18ee06325d$var$Ct(this);
        if (void 0 !== o.type) throw new RangeError("Invalid type is specified");
        const n = $520c3e18ee06325d$var$pt(r);
        !function(e, t, r, o) {
            const n = Object.create($520c3e18ee06325d$export$9e6890cb9a51c7c2.prototype);
            let i, a, s, l;
            i = void 0 !== t.start ? ()=>t.start(n) : ()=>{};
            a = void 0 !== t.write ? (e)=>t.write(e, n) : ()=>$520c3e18ee06325d$var$c(void 0);
            s = void 0 !== t.close ? ()=>t.close() : ()=>$520c3e18ee06325d$var$c(void 0);
            l = void 0 !== t.abort ? (e)=>t.abort(e) : ()=>$520c3e18ee06325d$var$c(void 0);
            $520c3e18ee06325d$var$Nt(e, n, i, a, s, l, r, o);
        }(this, o, $520c3e18ee06325d$var$mt(r, 1), n);
    }
    get locked() {
        if (!$520c3e18ee06325d$var$qt(this)) throw $520c3e18ee06325d$var$Kt("locked");
        return $520c3e18ee06325d$var$Et(this);
    }
    abort(e) {
        return $520c3e18ee06325d$var$qt(this) ? $520c3e18ee06325d$var$Et(this) ? $520c3e18ee06325d$var$d(new TypeError("Cannot abort a stream that already has a writer")) : $520c3e18ee06325d$var$Wt(this, e) : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$Kt("abort"));
    }
    close() {
        return $520c3e18ee06325d$var$qt(this) ? $520c3e18ee06325d$var$Et(this) ? $520c3e18ee06325d$var$d(new TypeError("Cannot close a stream that already has a writer")) : $520c3e18ee06325d$var$At(this) ? $520c3e18ee06325d$var$d(new TypeError("Cannot close an already-closing stream")) : $520c3e18ee06325d$var$Ot(this) : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$Kt("close"));
    }
    getWriter() {
        if (!$520c3e18ee06325d$var$qt(this)) throw $520c3e18ee06325d$var$Kt("getWriter");
        return $520c3e18ee06325d$var$Pt(this);
    }
}
function $520c3e18ee06325d$var$Pt(e) {
    return new $520c3e18ee06325d$export$9295348f005d6054(e);
}
function $520c3e18ee06325d$var$Ct(e) {
    e._state = "writable", e._storedError = void 0, e._writer = void 0, e._writableStreamController = void 0, e._writeRequests = new $520c3e18ee06325d$var$v, e._inFlightWriteRequest = void 0, e._closeRequest = void 0, e._inFlightCloseRequest = void 0, e._pendingAbortRequest = void 0, e._backpressure = !1;
}
function $520c3e18ee06325d$var$qt(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_writableStreamController") && e instanceof $520c3e18ee06325d$export$826849241f7970f8;
}
function $520c3e18ee06325d$var$Et(e) {
    return void 0 !== e._writer;
}
function $520c3e18ee06325d$var$Wt(e, t) {
    var r;
    if ("closed" === e._state || "errored" === e._state) return $520c3e18ee06325d$var$c(void 0);
    e._writableStreamController._abortReason = t, null === (r = e._writableStreamController._abortController) || void 0 === r || r.abort(t);
    const o = e._state;
    if ("closed" === o || "errored" === o) return $520c3e18ee06325d$var$c(void 0);
    if (void 0 !== e._pendingAbortRequest) return e._pendingAbortRequest._promise;
    let n = !1;
    "erroring" === o && (n = !0, t = void 0);
    const i = $520c3e18ee06325d$var$u((r, o)=>{
        e._pendingAbortRequest = {
            _promise: void 0,
            _resolve: r,
            _reject: o,
            _reason: t,
            _wasAlreadyErroring: n
        };
    });
    return e._pendingAbortRequest._promise = i, n || $520c3e18ee06325d$var$jt(e, t), i;
}
function $520c3e18ee06325d$var$Ot(e) {
    const t = e._state;
    if ("closed" === t || "errored" === t) return $520c3e18ee06325d$var$d(new TypeError(`The stream (in ${t} state) is not in the writable state and cannot be closed`));
    const r = $520c3e18ee06325d$var$u((t, r)=>{
        const o = {
            _resolve: t,
            _reject: r
        };
        e._closeRequest = o;
    }), o = e._writer;
    var n;
    return void 0 !== o && e._backpressure && "writable" === t && $520c3e18ee06325d$var$cr(o), $520c3e18ee06325d$var$Ce(n = e._writableStreamController, $520c3e18ee06325d$var$xt, 0), $520c3e18ee06325d$var$Ut(n), r;
}
function $520c3e18ee06325d$var$Bt(e, t) {
    "writable" !== e._state ? $520c3e18ee06325d$var$kt(e) : $520c3e18ee06325d$var$jt(e, t);
}
function $520c3e18ee06325d$var$jt(e, t) {
    const r = e._writableStreamController;
    e._state = "erroring", e._storedError = t;
    const o = e._writer;
    void 0 !== o && $520c3e18ee06325d$var$$t(o, t), !function(e) {
        if (void 0 === e._inFlightWriteRequest && void 0 === e._inFlightCloseRequest) return !1;
        return !0;
    }(e) && r._started && $520c3e18ee06325d$var$kt(e);
}
function $520c3e18ee06325d$var$kt(e) {
    e._state = "errored", e._writableStreamController[$520c3e18ee06325d$var$R]();
    const t = e._storedError;
    if (e._writeRequests.forEach((e)=>{
        e._reject(t);
    }), e._writeRequests = new $520c3e18ee06325d$var$v, void 0 === e._pendingAbortRequest) return void $520c3e18ee06325d$var$zt(e);
    const r = e._pendingAbortRequest;
    if (e._pendingAbortRequest = void 0, r._wasAlreadyErroring) return r._reject(t), void $520c3e18ee06325d$var$zt(e);
    $520c3e18ee06325d$var$h(e._writableStreamController[$520c3e18ee06325d$var$w](r._reason), ()=>(r._resolve(), $520c3e18ee06325d$var$zt(e), null), (t)=>(r._reject(t), $520c3e18ee06325d$var$zt(e), null));
}
function $520c3e18ee06325d$var$At(e) {
    return void 0 !== e._closeRequest || void 0 !== e._inFlightCloseRequest;
}
function $520c3e18ee06325d$var$zt(e) {
    void 0 !== e._closeRequest && (e._closeRequest._reject(e._storedError), e._closeRequest = void 0);
    const t = e._writer;
    void 0 !== t && $520c3e18ee06325d$var$nr(t, e._storedError);
}
function $520c3e18ee06325d$var$Dt(e, t) {
    const r = e._writer;
    void 0 !== r && t !== e._backpressure && (t ? function(e) {
        $520c3e18ee06325d$var$ar(e);
    }(r) : $520c3e18ee06325d$var$cr(r)), e._backpressure = t;
}
Object.defineProperties($520c3e18ee06325d$export$826849241f7970f8.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    getWriter: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$826849241f7970f8.prototype.abort, "abort"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$826849241f7970f8.prototype.close, "close"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$826849241f7970f8.prototype.getWriter, "getWriter"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$826849241f7970f8.prototype, Symbol.toStringTag, {
    value: "WritableStream",
    configurable: !0
});
class $520c3e18ee06325d$export$9295348f005d6054 {
    constructor(e){
        if ($520c3e18ee06325d$var$M(e, 1, "WritableStreamDefaultWriter"), $520c3e18ee06325d$var$Tt(e, "First parameter"), $520c3e18ee06325d$var$Et(e)) throw new TypeError("This stream has already been locked for exclusive writing by another writer");
        this._ownerWritableStream = e, e._writer = this;
        const t = e._state;
        if ("writable" === t) !$520c3e18ee06325d$var$At(e) && e._backpressure ? $520c3e18ee06325d$var$ar(this) : $520c3e18ee06325d$var$lr(this), $520c3e18ee06325d$var$rr(this);
        else if ("erroring" === t) $520c3e18ee06325d$var$sr(this, e._storedError), $520c3e18ee06325d$var$rr(this);
        else if ("closed" === t) $520c3e18ee06325d$var$lr(this), $520c3e18ee06325d$var$rr(r = this), $520c3e18ee06325d$var$ir(r);
        else {
            const t = e._storedError;
            $520c3e18ee06325d$var$sr(this, t), $520c3e18ee06325d$var$or(this, t);
        }
        var r;
    }
    get closed() {
        return $520c3e18ee06325d$var$Ft(this) ? this._closedPromise : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$er("closed"));
    }
    get desiredSize() {
        if (!$520c3e18ee06325d$var$Ft(this)) throw $520c3e18ee06325d$var$er("desiredSize");
        if (void 0 === this._ownerWritableStream) throw $520c3e18ee06325d$var$tr("desiredSize");
        return function(e) {
            const t = e._ownerWritableStream, r = t._state;
            if ("errored" === r || "erroring" === r) return null;
            if ("closed" === r) return 0;
            return $520c3e18ee06325d$var$Vt(t._writableStreamController);
        }(this);
    }
    get ready() {
        return $520c3e18ee06325d$var$Ft(this) ? this._readyPromise : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$er("ready"));
    }
    abort(e) {
        return $520c3e18ee06325d$var$Ft(this) ? void 0 === this._ownerWritableStream ? $520c3e18ee06325d$var$d($520c3e18ee06325d$var$tr("abort")) : function(e, t) {
            return $520c3e18ee06325d$var$Wt(e._ownerWritableStream, t);
        }(this, e) : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$er("abort"));
    }
    close() {
        if (!$520c3e18ee06325d$var$Ft(this)) return $520c3e18ee06325d$var$d($520c3e18ee06325d$var$er("close"));
        const e = this._ownerWritableStream;
        return void 0 === e ? $520c3e18ee06325d$var$d($520c3e18ee06325d$var$tr("close")) : $520c3e18ee06325d$var$At(e) ? $520c3e18ee06325d$var$d(new TypeError("Cannot close an already-closing stream")) : $520c3e18ee06325d$var$Lt(this);
    }
    releaseLock() {
        if (!$520c3e18ee06325d$var$Ft(this)) throw $520c3e18ee06325d$var$er("releaseLock");
        void 0 !== this._ownerWritableStream && $520c3e18ee06325d$var$Mt(this);
    }
    write(e) {
        return $520c3e18ee06325d$var$Ft(this) ? void 0 === this._ownerWritableStream ? $520c3e18ee06325d$var$d($520c3e18ee06325d$var$tr("write to")) : $520c3e18ee06325d$var$Yt(this, e) : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$er("write"));
    }
}
function $520c3e18ee06325d$var$Ft(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_ownerWritableStream") && e instanceof $520c3e18ee06325d$export$9295348f005d6054;
}
function $520c3e18ee06325d$var$Lt(e) {
    return $520c3e18ee06325d$var$Ot(e._ownerWritableStream);
}
function $520c3e18ee06325d$var$It(e, t) {
    "pending" === e._closedPromiseState ? $520c3e18ee06325d$var$nr(e, t) : function(e, t) {
        $520c3e18ee06325d$var$or(e, t);
    }(e, t);
}
function $520c3e18ee06325d$var$$t(e, t) {
    "pending" === e._readyPromiseState ? $520c3e18ee06325d$var$ur(e, t) : function(e, t) {
        $520c3e18ee06325d$var$sr(e, t);
    }(e, t);
}
function $520c3e18ee06325d$var$Mt(e) {
    const t = e._ownerWritableStream, r = new TypeError("Writer was released and can no longer be used to monitor the stream's closedness");
    $520c3e18ee06325d$var$$t(e, r), $520c3e18ee06325d$var$It(e, r), t._writer = void 0, e._ownerWritableStream = void 0;
}
function $520c3e18ee06325d$var$Yt(e, t) {
    const r = e._ownerWritableStream, o = r._writableStreamController, n = function(e, t) {
        if (void 0 === e._strategySizeAlgorithm) return 1;
        try {
            return e._strategySizeAlgorithm(t);
        } catch (t) {
            return $520c3e18ee06325d$var$Gt(e, t), 1;
        }
    }(o, t);
    if (r !== e._ownerWritableStream) return $520c3e18ee06325d$var$d($520c3e18ee06325d$var$tr("write to"));
    const i = r._state;
    if ("errored" === i) return $520c3e18ee06325d$var$d(r._storedError);
    if ($520c3e18ee06325d$var$At(r) || "closed" === i) return $520c3e18ee06325d$var$d(new TypeError("The stream is closing or closed and cannot be written to"));
    if ("erroring" === i) return $520c3e18ee06325d$var$d(r._storedError);
    const a = function(e) {
        return $520c3e18ee06325d$var$u((t, r)=>{
            const o = {
                _resolve: t,
                _reject: r
            };
            e._writeRequests.push(o);
        });
    }(r);
    return function(e, t, r) {
        try {
            $520c3e18ee06325d$var$Ce(e, t, r);
        } catch (t) {
            return void $520c3e18ee06325d$var$Gt(e, t);
        }
        const o = e._controlledWritableStream;
        if (!$520c3e18ee06325d$var$At(o) && "writable" === o._state) $520c3e18ee06325d$var$Dt(o, $520c3e18ee06325d$var$Xt(e));
        $520c3e18ee06325d$var$Ut(e);
    }(o, t, n), a;
}
Object.defineProperties($520c3e18ee06325d$export$9295348f005d6054.prototype, {
    abort: {
        enumerable: !0
    },
    close: {
        enumerable: !0
    },
    releaseLock: {
        enumerable: !0
    },
    write: {
        enumerable: !0
    },
    closed: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    },
    ready: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$9295348f005d6054.prototype.abort, "abort"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$9295348f005d6054.prototype.close, "close"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$9295348f005d6054.prototype.releaseLock, "releaseLock"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$9295348f005d6054.prototype.write, "write"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$9295348f005d6054.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultWriter",
    configurable: !0
});
const $520c3e18ee06325d$var$xt = {};
class $520c3e18ee06325d$export$9e6890cb9a51c7c2 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get abortReason() {
        if (!$520c3e18ee06325d$var$Qt(this)) throw $520c3e18ee06325d$var$Zt("abortReason");
        return this._abortReason;
    }
    get signal() {
        if (!$520c3e18ee06325d$var$Qt(this)) throw $520c3e18ee06325d$var$Zt("signal");
        if (void 0 === this._abortController) throw new TypeError("WritableStreamDefaultController.prototype.signal is not supported");
        return this._abortController.signal;
    }
    error(e) {
        if (!$520c3e18ee06325d$var$Qt(this)) throw $520c3e18ee06325d$var$Zt("error");
        "writable" === this._controlledWritableStream._state && $520c3e18ee06325d$var$Jt(this, e);
    }
    [$520c3e18ee06325d$var$w](e) {
        const t = this._abortAlgorithm(e);
        return $520c3e18ee06325d$var$Ht(this), t;
    }
    [$520c3e18ee06325d$var$R]() {
        $520c3e18ee06325d$var$qe(this);
    }
}
function $520c3e18ee06325d$var$Qt(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledWritableStream") && e instanceof $520c3e18ee06325d$export$9e6890cb9a51c7c2;
}
function $520c3e18ee06325d$var$Nt(e, t, r, o, n, i, a, s) {
    t._controlledWritableStream = e, e._writableStreamController = t, t._queue = void 0, t._queueTotalSize = void 0, $520c3e18ee06325d$var$qe(t), t._abortReason = void 0, t._abortController = function() {
        if ("function" == typeof AbortController) return new AbortController;
    }(), t._started = !1, t._strategySizeAlgorithm = s, t._strategyHWM = a, t._writeAlgorithm = o, t._closeAlgorithm = n, t._abortAlgorithm = i;
    const l = $520c3e18ee06325d$var$Xt(t);
    $520c3e18ee06325d$var$Dt(e, l);
    $520c3e18ee06325d$var$h($520c3e18ee06325d$var$c(r()), ()=>(t._started = !0, $520c3e18ee06325d$var$Ut(t), null), (r)=>(t._started = !0, $520c3e18ee06325d$var$Bt(e, r), null));
}
function $520c3e18ee06325d$var$Ht(e) {
    e._writeAlgorithm = void 0, e._closeAlgorithm = void 0, e._abortAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $520c3e18ee06325d$var$Vt(e) {
    return e._strategyHWM - e._queueTotalSize;
}
function $520c3e18ee06325d$var$Ut(e) {
    const t = e._controlledWritableStream;
    if (!e._started) return;
    if (void 0 !== t._inFlightWriteRequest) return;
    if ("erroring" === t._state) return void $520c3e18ee06325d$var$kt(t);
    if (0 === e._queue.length) return;
    const r = e._queue.peek().value;
    r === $520c3e18ee06325d$var$xt ? function(e) {
        const t = e._controlledWritableStream;
        (function(e) {
            e._inFlightCloseRequest = e._closeRequest, e._closeRequest = void 0;
        })(t), $520c3e18ee06325d$var$Pe(e);
        const r = e._closeAlgorithm();
        $520c3e18ee06325d$var$Ht(e), $520c3e18ee06325d$var$h(r, ()=>((function(e) {
                e._inFlightCloseRequest._resolve(void 0), e._inFlightCloseRequest = void 0, "erroring" === e._state && (e._storedError = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._resolve(), e._pendingAbortRequest = void 0)), e._state = "closed";
                const t = e._writer;
                void 0 !== t && $520c3e18ee06325d$var$ir(t);
            })(t), null), (e)=>((function(e, t) {
                e._inFlightCloseRequest._reject(t), e._inFlightCloseRequest = void 0, void 0 !== e._pendingAbortRequest && (e._pendingAbortRequest._reject(t), e._pendingAbortRequest = void 0), $520c3e18ee06325d$var$Bt(e, t);
            })(t, e), null));
    }(e) : function(e, t) {
        const r = e._controlledWritableStream;
        !function(e) {
            e._inFlightWriteRequest = e._writeRequests.shift();
        }(r);
        const o = e._writeAlgorithm(t);
        $520c3e18ee06325d$var$h(o, ()=>{
            !function(e) {
                e._inFlightWriteRequest._resolve(void 0), e._inFlightWriteRequest = void 0;
            }(r);
            const t = r._state;
            if ($520c3e18ee06325d$var$Pe(e), !$520c3e18ee06325d$var$At(r) && "writable" === t) {
                const t = $520c3e18ee06325d$var$Xt(e);
                $520c3e18ee06325d$var$Dt(r, t);
            }
            return $520c3e18ee06325d$var$Ut(e), null;
        }, (t)=>("writable" === r._state && $520c3e18ee06325d$var$Ht(e), function(e, t) {
                e._inFlightWriteRequest._reject(t), e._inFlightWriteRequest = void 0, $520c3e18ee06325d$var$Bt(e, t);
            }(r, t), null));
    }(e, r);
}
function $520c3e18ee06325d$var$Gt(e, t) {
    "writable" === e._controlledWritableStream._state && $520c3e18ee06325d$var$Jt(e, t);
}
function $520c3e18ee06325d$var$Xt(e) {
    return $520c3e18ee06325d$var$Vt(e) <= 0;
}
function $520c3e18ee06325d$var$Jt(e, t) {
    const r = e._controlledWritableStream;
    $520c3e18ee06325d$var$Ht(e), $520c3e18ee06325d$var$jt(r, t);
}
function $520c3e18ee06325d$var$Kt(e) {
    return new TypeError(`WritableStream.prototype.${e} can only be used on a WritableStream`);
}
function $520c3e18ee06325d$var$Zt(e) {
    return new TypeError(`WritableStreamDefaultController.prototype.${e} can only be used on a WritableStreamDefaultController`);
}
function $520c3e18ee06325d$var$er(e) {
    return new TypeError(`WritableStreamDefaultWriter.prototype.${e} can only be used on a WritableStreamDefaultWriter`);
}
function $520c3e18ee06325d$var$tr(e) {
    return new TypeError("Cannot " + e + " a stream using a released writer");
}
function $520c3e18ee06325d$var$rr(e) {
    e._closedPromise = $520c3e18ee06325d$var$u((t, r)=>{
        e._closedPromise_resolve = t, e._closedPromise_reject = r, e._closedPromiseState = "pending";
    });
}
function $520c3e18ee06325d$var$or(e, t) {
    $520c3e18ee06325d$var$rr(e), $520c3e18ee06325d$var$nr(e, t);
}
function $520c3e18ee06325d$var$nr(e, t) {
    void 0 !== e._closedPromise_reject && ($520c3e18ee06325d$var$p(e._closedPromise), e._closedPromise_reject(t), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "rejected");
}
function $520c3e18ee06325d$var$ir(e) {
    void 0 !== e._closedPromise_resolve && (e._closedPromise_resolve(void 0), e._closedPromise_resolve = void 0, e._closedPromise_reject = void 0, e._closedPromiseState = "resolved");
}
function $520c3e18ee06325d$var$ar(e) {
    e._readyPromise = $520c3e18ee06325d$var$u((t, r)=>{
        e._readyPromise_resolve = t, e._readyPromise_reject = r;
    }), e._readyPromiseState = "pending";
}
function $520c3e18ee06325d$var$sr(e, t) {
    $520c3e18ee06325d$var$ar(e), $520c3e18ee06325d$var$ur(e, t);
}
function $520c3e18ee06325d$var$lr(e) {
    $520c3e18ee06325d$var$ar(e), $520c3e18ee06325d$var$cr(e);
}
function $520c3e18ee06325d$var$ur(e, t) {
    void 0 !== e._readyPromise_reject && ($520c3e18ee06325d$var$p(e._readyPromise), e._readyPromise_reject(t), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "rejected");
}
function $520c3e18ee06325d$var$cr(e) {
    void 0 !== e._readyPromise_resolve && (e._readyPromise_resolve(void 0), e._readyPromise_resolve = void 0, e._readyPromise_reject = void 0, e._readyPromiseState = "fulfilled");
}
Object.defineProperties($520c3e18ee06325d$export$9e6890cb9a51c7c2.prototype, {
    abortReason: {
        enumerable: !0
    },
    signal: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$9e6890cb9a51c7c2.prototype, Symbol.toStringTag, {
    value: "WritableStreamDefaultController",
    configurable: !0
});
const $520c3e18ee06325d$var$dr = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof $parcel$global ? $parcel$global : void 0;
const $520c3e18ee06325d$var$fr = function() {
    const e = null == $520c3e18ee06325d$var$dr ? void 0 : $520c3e18ee06325d$var$dr.DOMException;
    return function(e) {
        if ("function" != typeof e && "object" != typeof e) return !1;
        if ("DOMException" !== e.name) return !1;
        try {
            return new e, !0;
        } catch (e) {
            return !1;
        }
    }(e) ? e : void 0;
}() || function() {
    const e = function(e, t) {
        this.message = e || "", this.name = t || "Error", Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
    };
    return $520c3e18ee06325d$var$o(e, "DOMException"), e.prototype = Object.create(Error.prototype), Object.defineProperty(e.prototype, "constructor", {
        value: e,
        writable: !0,
        configurable: !0
    }), e;
}();
function $520c3e18ee06325d$var$hr(e, t, r, o, n, i) {
    const a = $520c3e18ee06325d$var$V(e), s = $520c3e18ee06325d$var$Pt(t);
    e._disturbed = !0;
    const l = new $520c3e18ee06325d$var$br(s), _ = new $520c3e18ee06325d$var$mr(l);
    return $520c3e18ee06325d$var$u((m, y)=>{
        let S;
        if (void 0 !== i) {
            if (S = ()=>{
                const r = void 0 !== i.reason ? i.reason : new $520c3e18ee06325d$var$fr("Aborted", "AbortError"), a = [];
                o || a.push(()=>"writable" === t._state ? $520c3e18ee06325d$var$Wt(t, r) : $520c3e18ee06325d$var$c(void 0)), n || a.push(()=>"readable" === e._state ? $520c3e18ee06325d$var$Mr(e, r) : $520c3e18ee06325d$var$c(void 0)), T(()=>Promise.all(a.map((e)=>e())), !0, r);
            }, i.aborted) return void S();
            i.addEventListener("abort", S);
        }
        function g() {
            for(; !l._shuttingDown && !t._backpressure && "writable" === t._state && !$520c3e18ee06325d$var$At(t) && "readable" === e._state && $520c3e18ee06325d$var$re(a);)$520c3e18ee06325d$var$te(a, _);
            if (l._shuttingDown) return $520c3e18ee06325d$var$c(!0);
            if (t._backpressure) return $520c3e18ee06325d$var$f(s._readyPromise, g);
            const r = new $520c3e18ee06325d$var$_r(l);
            return $520c3e18ee06325d$var$te(a, r), r._promise;
        }
        var v, w, R;
        if ($520c3e18ee06325d$var$pr(e, a._closedPromise, (e)=>(o ? P(!0, e) : T(()=>$520c3e18ee06325d$var$Wt(t, e), !0, e), null)), $520c3e18ee06325d$var$pr(t, s._closedPromise, (t)=>(n ? P(!0, t) : T(()=>$520c3e18ee06325d$var$Mr(e, t), !0, t), null)), v = e, w = a._closedPromise, R = ()=>(r ? P() : T(()=>(function(e) {
                    const t = e._ownerWritableStream, r = t._state;
                    return $520c3e18ee06325d$var$At(t) || "closed" === r ? $520c3e18ee06325d$var$c(void 0) : "errored" === r ? $520c3e18ee06325d$var$d(t._storedError) : $520c3e18ee06325d$var$Lt(e);
                })(s)), null), "closed" === v._state ? R() : $520c3e18ee06325d$var$b(w, R), $520c3e18ee06325d$var$At(t) || "closed" === t._state) {
            const t = new TypeError("the destination writable stream closed before all data could be piped to it");
            n ? P(!0, t) : T(()=>$520c3e18ee06325d$var$Mr(e, t), !0, t);
        }
        function T(e, r, o) {
            function n() {
                return $520c3e18ee06325d$var$h(e(), ()=>C(r, o), (e)=>C(!0, e)), null;
            }
            l._shuttingDown || (l._shuttingDown = !0, "writable" !== t._state || $520c3e18ee06325d$var$At(t) ? n() : $520c3e18ee06325d$var$b(l._waitForWritesToFinish(), n));
        }
        function P(e, r) {
            l._shuttingDown || (l._shuttingDown = !0, "writable" !== t._state || $520c3e18ee06325d$var$At(t) ? C(e, r) : $520c3e18ee06325d$var$b(l._waitForWritesToFinish(), ()=>C(e, r)));
        }
        function C(e, t) {
            return $520c3e18ee06325d$var$Mt(s), $520c3e18ee06325d$var$O(a), void 0 !== i && i.removeEventListener("abort", S), e ? y(t) : m(void 0), null;
        }
        $520c3e18ee06325d$var$p($520c3e18ee06325d$var$u((e, t)=>{
            !function r(o) {
                o ? e() : $520c3e18ee06325d$var$f(g(), r, t);
            }(!1);
        }));
    });
}
class $520c3e18ee06325d$var$br {
    constructor(e){
        this._writer = e, this._shuttingDown = !1, this._currentWrite = $520c3e18ee06325d$var$c(void 0);
    }
    _waitForWritesToFinish() {
        const e = this._currentWrite;
        return $520c3e18ee06325d$var$f(this._currentWrite, ()=>e !== this._currentWrite ? this._waitForWritesToFinish() : void 0);
    }
}
class $520c3e18ee06325d$var$_r {
    constructor(e){
        this._state = e, this._promise = $520c3e18ee06325d$var$u((e, t)=>{
            this._resolvePromise = e, this._rejectPromise = t;
        });
    }
    _chunkSteps(t) {
        this._state._currentWrite = $520c3e18ee06325d$var$f($520c3e18ee06325d$var$Yt(this._state._writer, t), void 0, $520c3e18ee06325d$var$e), this._resolvePromise(!1);
    }
    _closeSteps() {
        this._resolvePromise(!0);
    }
    _errorSteps(e) {
        this._rejectPromise(e);
    }
}
class $520c3e18ee06325d$var$mr {
    constructor(e){
        this._state = e;
    }
    _chunkSteps(t) {
        this._state._currentWrite = $520c3e18ee06325d$var$f($520c3e18ee06325d$var$Yt(this._state._writer, t), void 0, $520c3e18ee06325d$var$e);
    }
    _closeSteps() {}
    _errorSteps(e) {}
}
function $520c3e18ee06325d$var$pr(e, t, r) {
    "errored" === e._state ? r(e._storedError) : $520c3e18ee06325d$var$_(t, r);
}
class $520c3e18ee06325d$export$b0bb6d0989d67700 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$520c3e18ee06325d$var$yr(this)) throw $520c3e18ee06325d$var$Er("desiredSize");
        return $520c3e18ee06325d$var$Pr(this);
    }
    close() {
        if (!$520c3e18ee06325d$var$yr(this)) throw $520c3e18ee06325d$var$Er("close");
        if (!$520c3e18ee06325d$var$Cr(this)) throw new TypeError("The stream is not in a state that permits close");
        $520c3e18ee06325d$var$wr(this);
    }
    enqueue(e) {
        if (!$520c3e18ee06325d$var$yr(this)) throw $520c3e18ee06325d$var$Er("enqueue");
        if (!$520c3e18ee06325d$var$Cr(this)) throw new TypeError("The stream is not in a state that permits enqueue");
        return $520c3e18ee06325d$var$Rr(this, e);
    }
    error(e) {
        if (!$520c3e18ee06325d$var$yr(this)) throw $520c3e18ee06325d$var$Er("error");
        $520c3e18ee06325d$var$Tr(this, e);
    }
    [$520c3e18ee06325d$var$T](e) {
        $520c3e18ee06325d$var$qe(this);
        const t = this._cancelAlgorithm(e);
        return $520c3e18ee06325d$var$vr(this), t;
    }
    [$520c3e18ee06325d$var$P](e) {
        const t = this._controlledReadableStream;
        if (this._queue.length > 0) {
            const r = $520c3e18ee06325d$var$Pe(this);
            this._closeRequested && 0 === this._queue.length ? ($520c3e18ee06325d$var$vr(this), $520c3e18ee06325d$var$Yr(t)) : $520c3e18ee06325d$var$Sr(this), e._chunkSteps(r);
        } else $520c3e18ee06325d$var$U(t, e), $520c3e18ee06325d$var$Sr(this);
    }
    [$520c3e18ee06325d$var$C]() {
        return this._queue.length > 0;
    }
    [$520c3e18ee06325d$var$q]() {}
}
function $520c3e18ee06325d$var$yr(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledReadableStream") && e instanceof $520c3e18ee06325d$export$b0bb6d0989d67700;
}
function $520c3e18ee06325d$var$Sr(e) {
    if (!$520c3e18ee06325d$var$gr(e)) return;
    if (e._pulling) return void (e._pullAgain = !0);
    e._pulling = !0;
    $520c3e18ee06325d$var$h(e._pullAlgorithm(), ()=>(e._pulling = !1, e._pullAgain && (e._pullAgain = !1, $520c3e18ee06325d$var$Sr(e)), null), (t)=>($520c3e18ee06325d$var$Tr(e, t), null));
}
function $520c3e18ee06325d$var$gr(e) {
    const t = e._controlledReadableStream;
    if (!$520c3e18ee06325d$var$Cr(e)) return !1;
    if (!e._started) return !1;
    if ($520c3e18ee06325d$var$$r(t) && $520c3e18ee06325d$var$X(t) > 0) return !0;
    return $520c3e18ee06325d$var$Pr(e) > 0;
}
function $520c3e18ee06325d$var$vr(e) {
    e._pullAlgorithm = void 0, e._cancelAlgorithm = void 0, e._strategySizeAlgorithm = void 0;
}
function $520c3e18ee06325d$var$wr(e) {
    if (!$520c3e18ee06325d$var$Cr(e)) return;
    const t = e._controlledReadableStream;
    e._closeRequested = !0, 0 === e._queue.length && ($520c3e18ee06325d$var$vr(e), $520c3e18ee06325d$var$Yr(t));
}
function $520c3e18ee06325d$var$Rr(e, t) {
    if (!$520c3e18ee06325d$var$Cr(e)) return;
    const r = e._controlledReadableStream;
    if ($520c3e18ee06325d$var$$r(r) && $520c3e18ee06325d$var$X(r) > 0) $520c3e18ee06325d$var$G(r, t, !1);
    else {
        let r;
        try {
            r = e._strategySizeAlgorithm(t);
        } catch (t) {
            throw $520c3e18ee06325d$var$Tr(e, t), t;
        }
        try {
            $520c3e18ee06325d$var$Ce(e, t, r);
        } catch (t) {
            throw $520c3e18ee06325d$var$Tr(e, t), t;
        }
    }
    $520c3e18ee06325d$var$Sr(e);
}
function $520c3e18ee06325d$var$Tr(e, t) {
    const r = e._controlledReadableStream;
    "readable" === r._state && ($520c3e18ee06325d$var$qe(e), $520c3e18ee06325d$var$vr(e), $520c3e18ee06325d$var$xr(r, t));
}
function $520c3e18ee06325d$var$Pr(e) {
    const t = e._controlledReadableStream._state;
    return "errored" === t ? null : "closed" === t ? 0 : e._strategyHWM - e._queueTotalSize;
}
function $520c3e18ee06325d$var$Cr(e) {
    const t = e._controlledReadableStream._state;
    return !e._closeRequested && "readable" === t;
}
function $520c3e18ee06325d$var$qr(e, t, r, o, n, i, a) {
    t._controlledReadableStream = e, t._queue = void 0, t._queueTotalSize = void 0, $520c3e18ee06325d$var$qe(t), t._started = !1, t._closeRequested = !1, t._pullAgain = !1, t._pulling = !1, t._strategySizeAlgorithm = a, t._strategyHWM = i, t._pullAlgorithm = o, t._cancelAlgorithm = n, e._readableStreamController = t;
    $520c3e18ee06325d$var$h($520c3e18ee06325d$var$c(r()), ()=>(t._started = !0, $520c3e18ee06325d$var$Sr(t), null), (e)=>($520c3e18ee06325d$var$Tr(t, e), null));
}
function $520c3e18ee06325d$var$Er(e) {
    return new TypeError(`ReadableStreamDefaultController.prototype.${e} can only be used on a ReadableStreamDefaultController`);
}
function $520c3e18ee06325d$var$Wr(e, t) {
    return $520c3e18ee06325d$var$Oe(e._readableStreamController) ? function(e) {
        let t, r, o, n, i, a = $520c3e18ee06325d$var$V(e), s = !1, l = !1, d = !1, f = !1, h = !1;
        const b = $520c3e18ee06325d$var$u((e)=>{
            i = e;
        });
        function m(e) {
            $520c3e18ee06325d$var$_(e._closedPromise, (t)=>(e !== a || ($520c3e18ee06325d$var$Xe(o._readableStreamController, t), $520c3e18ee06325d$var$Xe(n._readableStreamController, t), f && h || i(void 0)), null));
        }
        function p() {
            $520c3e18ee06325d$var$ft(a) && ($520c3e18ee06325d$var$O(a), a = $520c3e18ee06325d$var$V(e), m(a));
            $520c3e18ee06325d$var$te(a, {
                _chunkSteps: (t)=>{
                    $520c3e18ee06325d$var$y(()=>{
                        l = !1, d = !1;
                        const r = t;
                        let a = t;
                        if (!f && !h) try {
                            a = $520c3e18ee06325d$var$Te(t);
                        } catch (t) {
                            return $520c3e18ee06325d$var$Xe(o._readableStreamController, t), $520c3e18ee06325d$var$Xe(n._readableStreamController, t), void i($520c3e18ee06325d$var$Mr(e, t));
                        }
                        f || $520c3e18ee06325d$var$Ge(o._readableStreamController, r), h || $520c3e18ee06325d$var$Ge(n._readableStreamController, a), s = !1, l ? g() : d && v();
                    });
                },
                _closeSteps: ()=>{
                    s = !1, f || $520c3e18ee06325d$var$Ue(o._readableStreamController), h || $520c3e18ee06325d$var$Ue(n._readableStreamController), o._readableStreamController._pendingPullIntos.length > 0 && $520c3e18ee06325d$var$et(o._readableStreamController, 0), n._readableStreamController._pendingPullIntos.length > 0 && $520c3e18ee06325d$var$et(n._readableStreamController, 0), f && h || i(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            });
        }
        function S(t, r) {
            $520c3e18ee06325d$var$ee(a) && ($520c3e18ee06325d$var$O(a), a = $520c3e18ee06325d$var$at(e), m(a));
            const u = r ? n : o, c = r ? o : n;
            $520c3e18ee06325d$var$ht(a, t, 1, {
                _chunkSteps: (t)=>{
                    $520c3e18ee06325d$var$y(()=>{
                        l = !1, d = !1;
                        const o = r ? h : f;
                        if (r ? f : h) o || $520c3e18ee06325d$var$tt(u._readableStreamController, t);
                        else {
                            let r;
                            try {
                                r = $520c3e18ee06325d$var$Te(t);
                            } catch (t) {
                                return $520c3e18ee06325d$var$Xe(u._readableStreamController, t), $520c3e18ee06325d$var$Xe(c._readableStreamController, t), void i($520c3e18ee06325d$var$Mr(e, t));
                            }
                            o || $520c3e18ee06325d$var$tt(u._readableStreamController, t), $520c3e18ee06325d$var$Ge(c._readableStreamController, r);
                        }
                        s = !1, l ? g() : d && v();
                    });
                },
                _closeSteps: (e)=>{
                    s = !1;
                    const t = r ? h : f, o = r ? f : h;
                    t || $520c3e18ee06325d$var$Ue(u._readableStreamController), o || $520c3e18ee06325d$var$Ue(c._readableStreamController), void 0 !== e && (t || $520c3e18ee06325d$var$tt(u._readableStreamController, e), !o && c._readableStreamController._pendingPullIntos.length > 0 && $520c3e18ee06325d$var$et(c._readableStreamController, 0)), t && o || i(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            });
        }
        function g() {
            if (s) return l = !0, $520c3e18ee06325d$var$c(void 0);
            s = !0;
            const e = $520c3e18ee06325d$var$Ke(o._readableStreamController);
            return null === e ? p() : S(e._view, !1), $520c3e18ee06325d$var$c(void 0);
        }
        function v() {
            if (s) return d = !0, $520c3e18ee06325d$var$c(void 0);
            s = !0;
            const e = $520c3e18ee06325d$var$Ke(n._readableStreamController);
            return null === e ? p() : S(e._view, !0), $520c3e18ee06325d$var$c(void 0);
        }
        function w(o) {
            if (f = !0, t = o, h) {
                const o = $520c3e18ee06325d$var$le([
                    t,
                    r
                ]), n = $520c3e18ee06325d$var$Mr(e, o);
                i(n);
            }
            return b;
        }
        function R(o) {
            if (h = !0, r = o, f) {
                const o = $520c3e18ee06325d$var$le([
                    t,
                    r
                ]), n = $520c3e18ee06325d$var$Mr(e, o);
                i(n);
            }
            return b;
        }
        function T() {}
        return o = $520c3e18ee06325d$var$Fr(T, g, w), n = $520c3e18ee06325d$var$Fr(T, v, R), m(a), [
            o,
            n
        ];
    }(e) : function(e) {
        const t = $520c3e18ee06325d$var$V(e);
        let r, o, n, i, a, s = !1, l = !1, d = !1, f = !1;
        const h = $520c3e18ee06325d$var$u((e)=>{
            a = e;
        });
        function b() {
            if (s) return l = !0, $520c3e18ee06325d$var$c(void 0);
            s = !0;
            return $520c3e18ee06325d$var$te(t, {
                _chunkSteps: (e)=>{
                    $520c3e18ee06325d$var$y(()=>{
                        l = !1;
                        const t = e, r = e;
                        d || $520c3e18ee06325d$var$Rr(n._readableStreamController, t), f || $520c3e18ee06325d$var$Rr(i._readableStreamController, r), s = !1, l && b();
                    });
                },
                _closeSteps: ()=>{
                    s = !1, d || $520c3e18ee06325d$var$wr(n._readableStreamController), f || $520c3e18ee06325d$var$wr(i._readableStreamController), d && f || a(void 0);
                },
                _errorSteps: ()=>{
                    s = !1;
                }
            }), $520c3e18ee06325d$var$c(void 0);
        }
        function m(t) {
            if (d = !0, r = t, f) {
                const t = $520c3e18ee06325d$var$le([
                    r,
                    o
                ]), n = $520c3e18ee06325d$var$Mr(e, t);
                a(n);
            }
            return h;
        }
        function p(t) {
            if (f = !0, o = t, d) {
                const t = $520c3e18ee06325d$var$le([
                    r,
                    o
                ]), n = $520c3e18ee06325d$var$Mr(e, t);
                a(n);
            }
            return h;
        }
        function S() {}
        return n = $520c3e18ee06325d$var$Dr(S, b, m), i = $520c3e18ee06325d$var$Dr(S, b, p), $520c3e18ee06325d$var$_(t._closedPromise, (e)=>($520c3e18ee06325d$var$Tr(n._readableStreamController, e), $520c3e18ee06325d$var$Tr(i._readableStreamController, e), d && f || a(void 0), null)), [
            n,
            i
        ];
    }(e);
}
function $520c3e18ee06325d$var$Or(r) {
    var o;
    return $520c3e18ee06325d$var$t(o = r) && void 0 !== o.getReader ? function(r) {
        let o;
        function n() {
            let e;
            try {
                e = r.read();
            } catch (e) {
                return $520c3e18ee06325d$var$d(e);
            }
            return $520c3e18ee06325d$var$m(e, (e)=>{
                if (!$520c3e18ee06325d$var$t(e)) throw new TypeError("The promise returned by the reader.read() method must fulfill with an object");
                if (e.done) $520c3e18ee06325d$var$wr(o._readableStreamController);
                else {
                    const t = e.value;
                    $520c3e18ee06325d$var$Rr(o._readableStreamController, t);
                }
            });
        }
        function i(e) {
            try {
                return $520c3e18ee06325d$var$c(r.cancel(e));
            } catch (e) {
                return $520c3e18ee06325d$var$d(e);
            }
        }
        return o = $520c3e18ee06325d$var$Dr($520c3e18ee06325d$var$e, n, i, 0), o;
    }(r.getReader()) : function(r) {
        let o;
        const n = $520c3e18ee06325d$var$me(r, "async");
        function i() {
            let e;
            try {
                e = $520c3e18ee06325d$var$pe(n);
            } catch (e) {
                return $520c3e18ee06325d$var$d(e);
            }
            return $520c3e18ee06325d$var$m($520c3e18ee06325d$var$c(e), (e)=>{
                if (!$520c3e18ee06325d$var$t(e)) throw new TypeError("The promise returned by the iterator.next() method must fulfill with an object");
                if (e.done) $520c3e18ee06325d$var$wr(o._readableStreamController);
                else {
                    const t = e.value;
                    $520c3e18ee06325d$var$Rr(o._readableStreamController, t);
                }
            });
        }
        function a(e) {
            const r = n.iterator;
            let o;
            try {
                o = $520c3e18ee06325d$var$he(r, "return");
            } catch (e) {
                return $520c3e18ee06325d$var$d(e);
            }
            if (void 0 === o) return $520c3e18ee06325d$var$c(void 0);
            return $520c3e18ee06325d$var$m($520c3e18ee06325d$var$g(o, r, [
                e
            ]), (e)=>{
                if (!$520c3e18ee06325d$var$t(e)) throw new TypeError("The promise returned by the iterator.return() method must fulfill with an object");
            });
        }
        return o = $520c3e18ee06325d$var$Dr($520c3e18ee06325d$var$e, i, a, 0), o;
    }(r);
}
function $520c3e18ee06325d$var$Br(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r)=>$520c3e18ee06325d$var$g(e, t, [
            r
        ]);
}
function $520c3e18ee06325d$var$jr(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r)=>$520c3e18ee06325d$var$g(e, t, [
            r
        ]);
}
function $520c3e18ee06325d$var$kr(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r)=>$520c3e18ee06325d$var$S(e, t, [
            r
        ]);
}
function $520c3e18ee06325d$var$Ar(e, t) {
    if ("bytes" !== (e = `${e}`)) throw new TypeError(`${t} '${e}' is not a valid enumeration value for ReadableStreamType`);
    return e;
}
function $520c3e18ee06325d$var$zr(e, t) {
    $520c3e18ee06325d$var$L(e, t);
    const r = null == e ? void 0 : e.preventAbort, o = null == e ? void 0 : e.preventCancel, n = null == e ? void 0 : e.preventClose, i = null == e ? void 0 : e.signal;
    return void 0 !== i && function(e, t) {
        if (!function(e) {
            if ("object" != typeof e || null === e) return !1;
            try {
                return "boolean" == typeof e.aborted;
            } catch (e) {
                return !1;
            }
        }(e)) throw new TypeError(`${t} is not an AbortSignal.`);
    }(i, `${t} has member 'signal' that`), {
        preventAbort: Boolean(r),
        preventCancel: Boolean(o),
        preventClose: Boolean(n),
        signal: i
    };
}
Object.defineProperties($520c3e18ee06325d$export$b0bb6d0989d67700.prototype, {
    close: {
        enumerable: !0
    },
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$b0bb6d0989d67700.prototype.close, "close"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$b0bb6d0989d67700.prototype.enqueue, "enqueue"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$b0bb6d0989d67700.prototype.error, "error"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$b0bb6d0989d67700.prototype, Symbol.toStringTag, {
    value: "ReadableStreamDefaultController",
    configurable: !0
});
class $520c3e18ee06325d$export$5d3e1e5268af5f76 {
    constructor(e = {}, t = {}){
        void 0 === e ? e = null : $520c3e18ee06325d$var$$(e, "First parameter");
        const r = $520c3e18ee06325d$var$yt(t, "Second parameter"), o = function(e, t) {
            $520c3e18ee06325d$var$L(e, t);
            const r = e, o = null == r ? void 0 : r.autoAllocateChunkSize, n = null == r ? void 0 : r.cancel, i = null == r ? void 0 : r.pull, a = null == r ? void 0 : r.start, s = null == r ? void 0 : r.type;
            return {
                autoAllocateChunkSize: void 0 === o ? void 0 : $520c3e18ee06325d$var$N(o, `${t} has member 'autoAllocateChunkSize' that`),
                cancel: void 0 === n ? void 0 : $520c3e18ee06325d$var$Br(n, r, `${t} has member 'cancel' that`),
                pull: void 0 === i ? void 0 : $520c3e18ee06325d$var$jr(i, r, `${t} has member 'pull' that`),
                start: void 0 === a ? void 0 : $520c3e18ee06325d$var$kr(a, r, `${t} has member 'start' that`),
                type: void 0 === s ? void 0 : $520c3e18ee06325d$var$Ar(s, `${t} has member 'type' that`)
            };
        }(e, "First parameter");
        if ($520c3e18ee06325d$var$Lr(this), "bytes" === o.type) {
            if (void 0 !== r.size) throw new RangeError("The strategy for a byte stream cannot have a size function");
            !function(e, t, r) {
                const o = Object.create($520c3e18ee06325d$export$2047cf34091e94ac.prototype);
                let n, i, a;
                n = void 0 !== t.start ? ()=>t.start(o) : ()=>{}, i = void 0 !== t.pull ? ()=>t.pull(o) : ()=>$520c3e18ee06325d$var$c(void 0), a = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$520c3e18ee06325d$var$c(void 0);
                const s = t.autoAllocateChunkSize;
                if (0 === s) throw new TypeError("autoAllocateChunkSize must be greater than 0");
                $520c3e18ee06325d$var$rt(e, o, n, i, a, r, s);
            }(this, o, $520c3e18ee06325d$var$mt(r, 0));
        } else {
            const e = $520c3e18ee06325d$var$pt(r);
            !function(e, t, r, o) {
                const n = Object.create($520c3e18ee06325d$export$b0bb6d0989d67700.prototype);
                let i, a, s;
                i = void 0 !== t.start ? ()=>t.start(n) : ()=>{}, a = void 0 !== t.pull ? ()=>t.pull(n) : ()=>$520c3e18ee06325d$var$c(void 0), s = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$520c3e18ee06325d$var$c(void 0), $520c3e18ee06325d$var$qr(e, n, i, a, s, r, o);
            }(this, o, $520c3e18ee06325d$var$mt(r, 1), e);
        }
    }
    get locked() {
        if (!$520c3e18ee06325d$var$Ir(this)) throw $520c3e18ee06325d$var$Qr("locked");
        return $520c3e18ee06325d$var$$r(this);
    }
    cancel(e) {
        return $520c3e18ee06325d$var$Ir(this) ? $520c3e18ee06325d$var$$r(this) ? $520c3e18ee06325d$var$d(new TypeError("Cannot cancel a stream that already has a reader")) : $520c3e18ee06325d$var$Mr(this, e) : $520c3e18ee06325d$var$d($520c3e18ee06325d$var$Qr("cancel"));
    }
    getReader(e) {
        if (!$520c3e18ee06325d$var$Ir(this)) throw $520c3e18ee06325d$var$Qr("getReader");
        return void 0 === function(e, t) {
            $520c3e18ee06325d$var$L(e, t);
            const r = null == e ? void 0 : e.mode;
            return {
                mode: void 0 === r ? void 0 : $520c3e18ee06325d$var$it(r, `${t} has member 'mode' that`)
            };
        }(e, "First parameter").mode ? $520c3e18ee06325d$var$V(this) : $520c3e18ee06325d$var$at(this);
    }
    pipeThrough(e, t = {}) {
        if (!$520c3e18ee06325d$var$Ir(this)) throw $520c3e18ee06325d$var$Qr("pipeThrough");
        $520c3e18ee06325d$var$M(e, 1, "pipeThrough");
        const r = function(e, t) {
            $520c3e18ee06325d$var$L(e, t);
            const r = null == e ? void 0 : e.readable;
            $520c3e18ee06325d$var$Y(r, "readable", "ReadableWritablePair"), $520c3e18ee06325d$var$H(r, `${t} has member 'readable' that`);
            const o = null == e ? void 0 : e.writable;
            return $520c3e18ee06325d$var$Y(o, "writable", "ReadableWritablePair"), $520c3e18ee06325d$var$Tt(o, `${t} has member 'writable' that`), {
                readable: r,
                writable: o
            };
        }(e, "First parameter"), o = $520c3e18ee06325d$var$zr(t, "Second parameter");
        if ($520c3e18ee06325d$var$$r(this)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked ReadableStream");
        if ($520c3e18ee06325d$var$Et(r.writable)) throw new TypeError("ReadableStream.prototype.pipeThrough cannot be used on a locked WritableStream");
        return $520c3e18ee06325d$var$p($520c3e18ee06325d$var$hr(this, r.writable, o.preventClose, o.preventAbort, o.preventCancel, o.signal)), r.readable;
    }
    pipeTo(e, t = {}) {
        if (!$520c3e18ee06325d$var$Ir(this)) return $520c3e18ee06325d$var$d($520c3e18ee06325d$var$Qr("pipeTo"));
        if (void 0 === e) return $520c3e18ee06325d$var$d("Parameter 1 is required in 'pipeTo'.");
        if (!$520c3e18ee06325d$var$qt(e)) return $520c3e18ee06325d$var$d(new TypeError("ReadableStream.prototype.pipeTo's first argument must be a WritableStream"));
        let r;
        try {
            r = $520c3e18ee06325d$var$zr(t, "Second parameter");
        } catch (e) {
            return $520c3e18ee06325d$var$d(e);
        }
        return $520c3e18ee06325d$var$$r(this) ? $520c3e18ee06325d$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked ReadableStream")) : $520c3e18ee06325d$var$Et(e) ? $520c3e18ee06325d$var$d(new TypeError("ReadableStream.prototype.pipeTo cannot be used on a locked WritableStream")) : $520c3e18ee06325d$var$hr(this, e, r.preventClose, r.preventAbort, r.preventCancel, r.signal);
    }
    tee() {
        if (!$520c3e18ee06325d$var$Ir(this)) throw $520c3e18ee06325d$var$Qr("tee");
        return $520c3e18ee06325d$var$le($520c3e18ee06325d$var$Wr(this));
    }
    values(e) {
        if (!$520c3e18ee06325d$var$Ir(this)) throw $520c3e18ee06325d$var$Qr("values");
        return function(e, t) {
            const r = $520c3e18ee06325d$var$V(e), o = new $520c3e18ee06325d$var$ye(r, t), n = Object.create($520c3e18ee06325d$var$ge);
            return n._asyncIteratorImpl = o, n;
        }(this, function(e, t) {
            $520c3e18ee06325d$var$L(e, t);
            const r = null == e ? void 0 : e.preventCancel;
            return {
                preventCancel: Boolean(r)
            };
        }(e, "First parameter").preventCancel);
    }
    [$520c3e18ee06325d$var$_e](e) {
        return this.values(e);
    }
    static from(e) {
        return $520c3e18ee06325d$var$Or(e);
    }
}
function $520c3e18ee06325d$var$Dr(e, t, r, o = 1, n = ()=>1) {
    const i = Object.create($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype);
    $520c3e18ee06325d$var$Lr(i);
    return $520c3e18ee06325d$var$qr(i, Object.create($520c3e18ee06325d$export$b0bb6d0989d67700.prototype), e, t, r, o, n), i;
}
function $520c3e18ee06325d$var$Fr(e, t, r) {
    const o = Object.create($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype);
    $520c3e18ee06325d$var$Lr(o);
    return $520c3e18ee06325d$var$rt(o, Object.create($520c3e18ee06325d$export$2047cf34091e94ac.prototype), e, t, r, 0, void 0), o;
}
function $520c3e18ee06325d$var$Lr(e) {
    e._state = "readable", e._reader = void 0, e._storedError = void 0, e._disturbed = !1;
}
function $520c3e18ee06325d$var$Ir(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_readableStreamController") && e instanceof $520c3e18ee06325d$export$5d3e1e5268af5f76;
}
function $520c3e18ee06325d$var$$r(e) {
    return void 0 !== e._reader;
}
function $520c3e18ee06325d$var$Mr(t, r) {
    if (t._disturbed = !0, "closed" === t._state) return $520c3e18ee06325d$var$c(void 0);
    if ("errored" === t._state) return $520c3e18ee06325d$var$d(t._storedError);
    $520c3e18ee06325d$var$Yr(t);
    const o = t._reader;
    if (void 0 !== o && $520c3e18ee06325d$var$ft(o)) {
        const e = o._readIntoRequests;
        o._readIntoRequests = new $520c3e18ee06325d$var$v, e.forEach((e)=>{
            e._closeSteps(void 0);
        });
    }
    return $520c3e18ee06325d$var$m(t._readableStreamController[$520c3e18ee06325d$var$T](r), $520c3e18ee06325d$var$e);
}
function $520c3e18ee06325d$var$Yr(e) {
    e._state = "closed";
    const t = e._reader;
    if (void 0 !== t && ($520c3e18ee06325d$var$z(t), $520c3e18ee06325d$var$ee(t))) {
        const e = t._readRequests;
        t._readRequests = new $520c3e18ee06325d$var$v, e.forEach((e)=>{
            e._closeSteps();
        });
    }
}
function $520c3e18ee06325d$var$xr(e, t) {
    e._state = "errored", e._storedError = t;
    const r = e._reader;
    void 0 !== r && ($520c3e18ee06325d$var$A(r, t), $520c3e18ee06325d$var$ee(r) ? $520c3e18ee06325d$var$oe(r, t) : $520c3e18ee06325d$var$bt(r, t));
}
function $520c3e18ee06325d$var$Qr(e) {
    return new TypeError(`ReadableStream.prototype.${e} can only be used on a ReadableStream`);
}
function $520c3e18ee06325d$var$Nr(e, t) {
    $520c3e18ee06325d$var$L(e, t);
    const r = null == e ? void 0 : e.highWaterMark;
    return $520c3e18ee06325d$var$Y(r, "highWaterMark", "QueuingStrategyInit"), {
        highWaterMark: $520c3e18ee06325d$var$x(r)
    };
}
Object.defineProperties($520c3e18ee06325d$export$5d3e1e5268af5f76, {
    from: {
        enumerable: !0
    }
}), Object.defineProperties($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype, {
    cancel: {
        enumerable: !0
    },
    getReader: {
        enumerable: !0
    },
    pipeThrough: {
        enumerable: !0
    },
    pipeTo: {
        enumerable: !0
    },
    tee: {
        enumerable: !0
    },
    values: {
        enumerable: !0
    },
    locked: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$5d3e1e5268af5f76.from, "from"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype.cancel, "cancel"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype.getReader, "getReader"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype.pipeThrough, "pipeThrough"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype.pipeTo, "pipeTo"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype.tee, "tee"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype.values, "values"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype, Symbol.toStringTag, {
    value: "ReadableStream",
    configurable: !0
}), Object.defineProperty($520c3e18ee06325d$export$5d3e1e5268af5f76.prototype, $520c3e18ee06325d$var$_e, {
    value: $520c3e18ee06325d$export$5d3e1e5268af5f76.prototype.values,
    writable: !0,
    configurable: !0
});
const $520c3e18ee06325d$var$Hr = (e)=>e.byteLength;
$520c3e18ee06325d$var$o($520c3e18ee06325d$var$Hr, "size");
class $520c3e18ee06325d$export$d386b5f37d154119 {
    constructor(e){
        $520c3e18ee06325d$var$M(e, 1, "ByteLengthQueuingStrategy"), e = $520c3e18ee06325d$var$Nr(e, "First parameter"), this._byteLengthQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$520c3e18ee06325d$var$Ur(this)) throw $520c3e18ee06325d$var$Vr("highWaterMark");
        return this._byteLengthQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$520c3e18ee06325d$var$Ur(this)) throw $520c3e18ee06325d$var$Vr("size");
        return $520c3e18ee06325d$var$Hr;
    }
}
function $520c3e18ee06325d$var$Vr(e) {
    return new TypeError(`ByteLengthQueuingStrategy.prototype.${e} can only be used on a ByteLengthQueuingStrategy`);
}
function $520c3e18ee06325d$var$Ur(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_byteLengthQueuingStrategyHighWaterMark") && e instanceof $520c3e18ee06325d$export$d386b5f37d154119;
}
Object.defineProperties($520c3e18ee06325d$export$d386b5f37d154119.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$d386b5f37d154119.prototype, Symbol.toStringTag, {
    value: "ByteLengthQueuingStrategy",
    configurable: !0
});
const $520c3e18ee06325d$var$Gr = ()=>1;
$520c3e18ee06325d$var$o($520c3e18ee06325d$var$Gr, "size");
class $520c3e18ee06325d$export$9ebfec18c2dfc625 {
    constructor(e){
        $520c3e18ee06325d$var$M(e, 1, "CountQueuingStrategy"), e = $520c3e18ee06325d$var$Nr(e, "First parameter"), this._countQueuingStrategyHighWaterMark = e.highWaterMark;
    }
    get highWaterMark() {
        if (!$520c3e18ee06325d$var$Jr(this)) throw $520c3e18ee06325d$var$Xr("highWaterMark");
        return this._countQueuingStrategyHighWaterMark;
    }
    get size() {
        if (!$520c3e18ee06325d$var$Jr(this)) throw $520c3e18ee06325d$var$Xr("size");
        return $520c3e18ee06325d$var$Gr;
    }
}
function $520c3e18ee06325d$var$Xr(e) {
    return new TypeError(`CountQueuingStrategy.prototype.${e} can only be used on a CountQueuingStrategy`);
}
function $520c3e18ee06325d$var$Jr(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_countQueuingStrategyHighWaterMark") && e instanceof $520c3e18ee06325d$export$9ebfec18c2dfc625;
}
function $520c3e18ee06325d$var$Kr(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r)=>$520c3e18ee06325d$var$g(e, t, [
            r
        ]);
}
function $520c3e18ee06325d$var$Zr(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r)=>$520c3e18ee06325d$var$S(e, t, [
            r
        ]);
}
function $520c3e18ee06325d$var$eo(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r, o)=>$520c3e18ee06325d$var$g(e, t, [
            r,
            o
        ]);
}
function $520c3e18ee06325d$var$to(e, t, r) {
    return $520c3e18ee06325d$var$I(e, r), (r)=>$520c3e18ee06325d$var$g(e, t, [
            r
        ]);
}
Object.defineProperties($520c3e18ee06325d$export$9ebfec18c2dfc625.prototype, {
    highWaterMark: {
        enumerable: !0
    },
    size: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$9ebfec18c2dfc625.prototype, Symbol.toStringTag, {
    value: "CountQueuingStrategy",
    configurable: !0
});
class $520c3e18ee06325d$export$d102341634899398 {
    constructor(e = {}, t = {}, r = {}){
        void 0 === e && (e = null);
        const o = $520c3e18ee06325d$var$yt(t, "Second parameter"), n = $520c3e18ee06325d$var$yt(r, "Third parameter"), i = function(e, t) {
            $520c3e18ee06325d$var$L(e, t);
            const r = null == e ? void 0 : e.cancel, o = null == e ? void 0 : e.flush, n = null == e ? void 0 : e.readableType, i = null == e ? void 0 : e.start, a = null == e ? void 0 : e.transform, s = null == e ? void 0 : e.writableType;
            return {
                cancel: void 0 === r ? void 0 : $520c3e18ee06325d$var$to(r, e, `${t} has member 'cancel' that`),
                flush: void 0 === o ? void 0 : $520c3e18ee06325d$var$Kr(o, e, `${t} has member 'flush' that`),
                readableType: n,
                start: void 0 === i ? void 0 : $520c3e18ee06325d$var$Zr(i, e, `${t} has member 'start' that`),
                transform: void 0 === a ? void 0 : $520c3e18ee06325d$var$eo(a, e, `${t} has member 'transform' that`),
                writableType: s
            };
        }(e, "First parameter");
        if (void 0 !== i.readableType) throw new RangeError("Invalid readableType specified");
        if (void 0 !== i.writableType) throw new RangeError("Invalid writableType specified");
        const a = $520c3e18ee06325d$var$mt(n, 0), s = $520c3e18ee06325d$var$pt(n), l = $520c3e18ee06325d$var$mt(o, 1), f = $520c3e18ee06325d$var$pt(o);
        let b;
        !function(e, t, r, o, n, i) {
            function a() {
                return t;
            }
            function s(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (e._backpressure) return $520c3e18ee06325d$var$m(e._backpressureChangePromise, ()=>{
                        const o = e._writable;
                        if ("erroring" === o._state) throw o._storedError;
                        return $520c3e18ee06325d$var$co(r, t);
                    });
                    return $520c3e18ee06325d$var$co(r, t);
                }(e, t);
            }
            function l(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._readable;
                    r._finishPromise = $520c3e18ee06325d$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $520c3e18ee06325d$var$lo(r), $520c3e18ee06325d$var$h(n, ()=>("errored" === o._state ? $520c3e18ee06325d$var$bo(r, o._storedError) : ($520c3e18ee06325d$var$Tr(o._readableStreamController, t), $520c3e18ee06325d$var$ho(r)), null), (e)=>($520c3e18ee06325d$var$Tr(o._readableStreamController, e), $520c3e18ee06325d$var$bo(r, e), null)), r._finishPromise;
                }(e, t);
            }
            function c() {
                return function(e) {
                    const t = e._transformStreamController;
                    if (void 0 !== t._finishPromise) return t._finishPromise;
                    const r = e._readable;
                    t._finishPromise = $520c3e18ee06325d$var$u((e, r)=>{
                        t._finishPromise_resolve = e, t._finishPromise_reject = r;
                    });
                    const o = t._flushAlgorithm();
                    return $520c3e18ee06325d$var$lo(t), $520c3e18ee06325d$var$h(o, ()=>("errored" === r._state ? $520c3e18ee06325d$var$bo(t, r._storedError) : ($520c3e18ee06325d$var$wr(r._readableStreamController), $520c3e18ee06325d$var$ho(t)), null), (e)=>($520c3e18ee06325d$var$Tr(r._readableStreamController, e), $520c3e18ee06325d$var$bo(t, e), null)), t._finishPromise;
                }(e);
            }
            function d() {
                return function(e) {
                    return $520c3e18ee06325d$var$ao(e, !1), e._backpressureChangePromise;
                }(e);
            }
            function f(t) {
                return function(e, t) {
                    const r = e._transformStreamController;
                    if (void 0 !== r._finishPromise) return r._finishPromise;
                    const o = e._writable;
                    r._finishPromise = $520c3e18ee06325d$var$u((e, t)=>{
                        r._finishPromise_resolve = e, r._finishPromise_reject = t;
                    });
                    const n = r._cancelAlgorithm(t);
                    return $520c3e18ee06325d$var$lo(r), $520c3e18ee06325d$var$h(n, ()=>("errored" === o._state ? $520c3e18ee06325d$var$bo(r, o._storedError) : ($520c3e18ee06325d$var$Gt(o._writableStreamController, t), $520c3e18ee06325d$var$io(e), $520c3e18ee06325d$var$ho(r)), null), (t)=>($520c3e18ee06325d$var$Gt(o._writableStreamController, t), $520c3e18ee06325d$var$io(e), $520c3e18ee06325d$var$bo(r, t), null)), r._finishPromise;
                }(e, t);
            }
            e._writable = function(e, t, r, o, n = 1, i = ()=>1) {
                const a = Object.create($520c3e18ee06325d$export$826849241f7970f8.prototype);
                return $520c3e18ee06325d$var$Ct(a), $520c3e18ee06325d$var$Nt(a, Object.create($520c3e18ee06325d$export$9e6890cb9a51c7c2.prototype), e, t, r, o, n, i), a;
            }(a, s, c, l, r, o), e._readable = $520c3e18ee06325d$var$Dr(a, d, f, n, i), e._backpressure = void 0, e._backpressureChangePromise = void 0, e._backpressureChangePromise_resolve = void 0, $520c3e18ee06325d$var$ao(e, !0), e._transformStreamController = void 0;
        }(this, $520c3e18ee06325d$var$u((e)=>{
            b = e;
        }), l, f, a, s), function(e, t) {
            const r = Object.create($520c3e18ee06325d$export$a55559184460222.prototype);
            let o, n, i;
            o = void 0 !== t.transform ? (e)=>t.transform(e, r) : (e)=>{
                try {
                    return $520c3e18ee06325d$var$uo(r, e), $520c3e18ee06325d$var$c(void 0);
                } catch (e) {
                    return $520c3e18ee06325d$var$d(e);
                }
            };
            n = void 0 !== t.flush ? ()=>t.flush(r) : ()=>$520c3e18ee06325d$var$c(void 0);
            i = void 0 !== t.cancel ? (e)=>t.cancel(e) : ()=>$520c3e18ee06325d$var$c(void 0);
            !function(e, t, r, o, n) {
                t._controlledTransformStream = e, e._transformStreamController = t, t._transformAlgorithm = r, t._flushAlgorithm = o, t._cancelAlgorithm = n, t._finishPromise = void 0, t._finishPromise_resolve = void 0, t._finishPromise_reject = void 0;
            }(e, r, o, n, i);
        }(this, i), void 0 !== i.start ? b(i.start(this._transformStreamController)) : b(void 0);
    }
    get readable() {
        if (!$520c3e18ee06325d$var$ro(this)) throw $520c3e18ee06325d$var$_o("readable");
        return this._readable;
    }
    get writable() {
        if (!$520c3e18ee06325d$var$ro(this)) throw $520c3e18ee06325d$var$_o("writable");
        return this._writable;
    }
}
function $520c3e18ee06325d$var$ro(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_transformStreamController") && e instanceof $520c3e18ee06325d$export$d102341634899398;
}
function $520c3e18ee06325d$var$oo(e, t) {
    $520c3e18ee06325d$var$Tr(e._readable._readableStreamController, t), $520c3e18ee06325d$var$no(e, t);
}
function $520c3e18ee06325d$var$no(e, t) {
    $520c3e18ee06325d$var$lo(e._transformStreamController), $520c3e18ee06325d$var$Gt(e._writable._writableStreamController, t), $520c3e18ee06325d$var$io(e);
}
function $520c3e18ee06325d$var$io(e) {
    e._backpressure && $520c3e18ee06325d$var$ao(e, !1);
}
function $520c3e18ee06325d$var$ao(e, t) {
    void 0 !== e._backpressureChangePromise && e._backpressureChangePromise_resolve(), e._backpressureChangePromise = $520c3e18ee06325d$var$u((t)=>{
        e._backpressureChangePromise_resolve = t;
    }), e._backpressure = t;
}
Object.defineProperties($520c3e18ee06325d$export$d102341634899398.prototype, {
    readable: {
        enumerable: !0
    },
    writable: {
        enumerable: !0
    }
}), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$d102341634899398.prototype, Symbol.toStringTag, {
    value: "TransformStream",
    configurable: !0
});
class $520c3e18ee06325d$export$a55559184460222 {
    constructor(){
        throw new TypeError("Illegal constructor");
    }
    get desiredSize() {
        if (!$520c3e18ee06325d$var$so(this)) throw $520c3e18ee06325d$var$fo("desiredSize");
        return $520c3e18ee06325d$var$Pr(this._controlledTransformStream._readable._readableStreamController);
    }
    enqueue(e) {
        if (!$520c3e18ee06325d$var$so(this)) throw $520c3e18ee06325d$var$fo("enqueue");
        $520c3e18ee06325d$var$uo(this, e);
    }
    error(e) {
        if (!$520c3e18ee06325d$var$so(this)) throw $520c3e18ee06325d$var$fo("error");
        var t;
        t = e, $520c3e18ee06325d$var$oo(this._controlledTransformStream, t);
    }
    terminate() {
        if (!$520c3e18ee06325d$var$so(this)) throw $520c3e18ee06325d$var$fo("terminate");
        !function(e) {
            const t = e._controlledTransformStream;
            $520c3e18ee06325d$var$wr(t._readable._readableStreamController);
            const r = new TypeError("TransformStream terminated");
            $520c3e18ee06325d$var$no(t, r);
        }(this);
    }
}
function $520c3e18ee06325d$var$so(e) {
    return !!$520c3e18ee06325d$var$t(e) && !!Object.prototype.hasOwnProperty.call(e, "_controlledTransformStream") && e instanceof $520c3e18ee06325d$export$a55559184460222;
}
function $520c3e18ee06325d$var$lo(e) {
    e._transformAlgorithm = void 0, e._flushAlgorithm = void 0, e._cancelAlgorithm = void 0;
}
function $520c3e18ee06325d$var$uo(e, t) {
    const r = e._controlledTransformStream, o = r._readable._readableStreamController;
    if (!$520c3e18ee06325d$var$Cr(o)) throw new TypeError("Readable side is not in a state that permits enqueue");
    try {
        $520c3e18ee06325d$var$Rr(o, t);
    } catch (e) {
        throw $520c3e18ee06325d$var$no(r, e), r._readable._storedError;
    }
    const n = function(e) {
        return !$520c3e18ee06325d$var$gr(e);
    }(o);
    n !== r._backpressure && $520c3e18ee06325d$var$ao(r, !0);
}
function $520c3e18ee06325d$var$co(e, t) {
    return $520c3e18ee06325d$var$m(e._transformAlgorithm(t), void 0, (t)=>{
        throw $520c3e18ee06325d$var$oo(e._controlledTransformStream, t), t;
    });
}
function $520c3e18ee06325d$var$fo(e) {
    return new TypeError(`TransformStreamDefaultController.prototype.${e} can only be used on a TransformStreamDefaultController`);
}
function $520c3e18ee06325d$var$ho(e) {
    void 0 !== e._finishPromise_resolve && (e._finishPromise_resolve(), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $520c3e18ee06325d$var$bo(e, t) {
    void 0 !== e._finishPromise_reject && ($520c3e18ee06325d$var$p(e._finishPromise), e._finishPromise_reject(t), e._finishPromise_resolve = void 0, e._finishPromise_reject = void 0);
}
function $520c3e18ee06325d$var$_o(e) {
    return new TypeError(`TransformStream.prototype.${e} can only be used on a TransformStream`);
}
Object.defineProperties($520c3e18ee06325d$export$a55559184460222.prototype, {
    enqueue: {
        enumerable: !0
    },
    error: {
        enumerable: !0
    },
    terminate: {
        enumerable: !0
    },
    desiredSize: {
        enumerable: !0
    }
}), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$a55559184460222.prototype.enqueue, "enqueue"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$a55559184460222.prototype.error, "error"), $520c3e18ee06325d$var$o($520c3e18ee06325d$export$a55559184460222.prototype.terminate, "terminate"), "symbol" == typeof Symbol.toStringTag && Object.defineProperty($520c3e18ee06325d$export$a55559184460222.prototype, Symbol.toStringTag, {
    value: "TransformStreamDefaultController",
    configurable: !0
});

});

parcelRegister("iob0w", function(module, exports) {

$parcel$export(module.exports, "isEmpty", function () { return $d63301b8ece461ce$export$dd1bc94b04021eeb; });
$parcel$export(module.exports, "proxyPrototype", function () { return $d63301b8ece461ce$export$2a489b3f92f4996a; });
$parcel$export(module.exports, "toHyphenCase", function () { return $d63301b8ece461ce$export$3f34ca2fef821bbd; });
$parcel$export(module.exports, "toCamelCase", function () { return $d63301b8ece461ce$export$86f54f62aa7a7514; });
$parcel$export(module.exports, "uniqueID", function () { return $d63301b8ece461ce$export$89912e019eef22aa; });
$parcel$export(module.exports, "encodeBase64", function () { return $d63301b8ece461ce$export$8fb536984ec8b4d7; });
$parcel$export(module.exports, "groupBy", function () { return $d63301b8ece461ce$export$3f063810d7bf01bd; });
$parcel$export(module.exports, "likeArray", function () { return $d63301b8ece461ce$export$b5a4d6f439a5044d; });
$parcel$export(module.exports, "isTypedArray", function () { return $d63301b8ece461ce$export$b119cc7e1840e59c; });
$parcel$export(module.exports, "makeArray", function () { return $d63301b8ece461ce$export$7b85fd78dd236198; });
$parcel$export(module.exports, "splitArray", function () { return $d63301b8ece461ce$export$697c3df919c0e61a; });
$parcel$export(module.exports, "countBy", function () { return $d63301b8ece461ce$export$1d012a0dff3dab06; });
$parcel$export(module.exports, "createAsyncIterator", function () { return $d63301b8ece461ce$export$86c18c6347f4a8c4; });
$parcel$export(module.exports, "ByteSize", function () { return $d63301b8ece461ce$export$271f7c16f175f804; });
$parcel$export(module.exports, "sum", function () { return $d63301b8ece461ce$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "averageOf", function () { return $d63301b8ece461ce$export$e1f36757ecda301d; });
$parcel$export(module.exports, "Second", function () { return $d63301b8ece461ce$export$c489aa6f7fd82b1a; });
$parcel$export(module.exports, "Day", function () { return $d63301b8ece461ce$export$7a9a31a911eb9a20; });
$parcel$export(module.exports, "Timestamp", function () { return $d63301b8ece461ce$export$d9bcbd5e1ff81430; });
$parcel$export(module.exports, "diffTime", function () { return $d63301b8ece461ce$export$506c8e8f8c8edda; });
$parcel$export(module.exports, "formatDate", function () { return $d63301b8ece461ce$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "changeMonth", function () { return $d63301b8ece461ce$export$62ad822b3a5fd9a0; });
$parcel$export(module.exports, "parseJSON", function () { return $d63301b8ece461ce$export$27924e57e9afff7f; });
$parcel$export(module.exports, "parseURLData", function () { return $d63301b8ece461ce$export$eb9b2aadbe449a20; });
$parcel$export(module.exports, "buildURLData", function () { return $d63301b8ece461ce$export$13397a83aa5915d6; });
$parcel$export(module.exports, "blobOf", function () { return $d63301b8ece461ce$export$fd89523fba250fa4; });
$parcel$export(module.exports, "parseCookie", function () { return $d63301b8ece461ce$export$d0eaf3e94be578f6; });
$parcel$export(module.exports, "setCookie", function () { return $d63301b8ece461ce$export$110700823644f4a6; });
$parcel$export(module.exports, "parseDOM", function () { return $d63301b8ece461ce$export$d66b332881d9723f; });
$parcel$export(module.exports, "stringifyDOM", function () { return $d63301b8ece461ce$export$b0709844452f8b6b; });
$parcel$export(module.exports, "walkDOM", function () { return $d63301b8ece461ce$export$5118471ee5d5453b; });
$parcel$export(module.exports, "getVisibleText", function () { return $d63301b8ece461ce$export$be4650432daa84fd; });
$parcel$export(module.exports, "insertToCursor", function () { return $d63301b8ece461ce$export$28d9d24a8cd0ffc2; });
$parcel$export(module.exports, "scrollTo", function () { return $d63301b8ece461ce$export$3f99968195accfaf; });
$parcel$export(module.exports, "formToJSON", function () { return $d63301b8ece461ce$export$86d7c59254d6a2c9; });
$parcel$export(module.exports, "sleep", function () { return $d63301b8ece461ce$export$e772c8ff12451969; });
$parcel$export(module.exports, "serviceWorkerUpdate", function () { return $d63301b8ece461ce$export$d635d04af3887bbe; });
function $d63301b8ece461ce$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $d63301b8ece461ce$var$$9b05bcda60cc529c$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $d63301b8ece461ce$export$61cc6ed0f143570b;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $d63301b8ece461ce$export$dd1bc94b04021eeb;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $d63301b8ece461ce$export$a09f818797e212c4;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $d63301b8ece461ce$export$170f4e08cad8229d;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $d63301b8ece461ce$export$2a489b3f92f4996a;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $d63301b8ece461ce$export$67a6ce548ae77071;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $d63301b8ece461ce$export$a48f0734ac7c2329;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $d63301b8ece461ce$export$3f34ca2fef821bbd;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $d63301b8ece461ce$export$86f54f62aa7a7514;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $d63301b8ece461ce$export$89912e019eef22aa;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $d63301b8ece461ce$export$8fb536984ec8b4d7;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $d63301b8ece461ce$export$94fdf11bafc8de6b;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $d63301b8ece461ce$export$1c8ba402144543e5;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $d63301b8ece461ce$export$2ddabb89308e1a22;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $d63301b8ece461ce$export$14527669107aa301;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $d63301b8ece461ce$export$3f063810d7bf01bd;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $d63301b8ece461ce$export$b5a4d6f439a5044d;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $d63301b8ece461ce$export$b119cc7e1840e59c;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $d63301b8ece461ce$export$7b85fd78dd236198;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $d63301b8ece461ce$export$697c3df919c0e61a;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $d63301b8ece461ce$export$1d012a0dff3dab06;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $d63301b8ece461ce$export$e6b5ff3168b5942b;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "clone", function() {
    return $d63301b8ece461ce$export$9cd59f9826255e47;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $d63301b8ece461ce$export$fbc9cd6af26fa64f;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $d63301b8ece461ce$export$69a3209f1a06c04d;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $d63301b8ece461ce$export$86c18c6347f4a8c4;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $d63301b8ece461ce$export$dce9414bed0662c;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $d63301b8ece461ce$export$271f7c16f175f804;
});
var $d63301b8ece461ce$var$$6a9944941b4c1893$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$6a9944941b4c1893$exports, "sum", function() {
    return $d63301b8ece461ce$export$8a63f25cc62965f1;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $d63301b8ece461ce$export$e1f36757ecda301d;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $d63301b8ece461ce$export$8e694e1eafd55acb;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $d63301b8ece461ce$export$57d7c52a66287430;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $d63301b8ece461ce$export$2b4693832ca3ce16;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $d63301b8ece461ce$export$5b784e078da1ce6;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $d63301b8ece461ce$export$17ec9c9f4f23588c;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $d63301b8ece461ce$export$595dbf49c602a1f;
});
function $d63301b8ece461ce$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $d63301b8ece461ce$export$e1f36757ecda301d(...data) {
    return $d63301b8ece461ce$export$8a63f25cc62965f1(...data) / data.length;
}
function $d63301b8ece461ce$export$8e694e1eafd55acb(data, sample = false) {
    const average = $d63301b8ece461ce$export$e1f36757ecda301d(...data);
    const summary = $d63301b8ece461ce$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $d63301b8ece461ce$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($d63301b8ece461ce$export$8e694e1eafd55acb(data, sample));
}
function $d63301b8ece461ce$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($d63301b8ece461ce$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $d63301b8ece461ce$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $d63301b8ece461ce$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $d63301b8ece461ce$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $d63301b8ece461ce$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $d63301b8ece461ce$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $d63301b8ece461ce$export$dd1bc94b04021eeb = (value)=>$d63301b8ece461ce$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $d63301b8ece461ce$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $d63301b8ece461ce$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $d63301b8ece461ce$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $d63301b8ece461ce$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $d63301b8ece461ce$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $d63301b8ece461ce$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $d63301b8ece461ce$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $d63301b8ece461ce$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $d63301b8ece461ce$export$8fb536984ec8b4d7 = (input)=>btoa(String.fromCharCode(...new TextEncoder().encode(input)));
const $d63301b8ece461ce$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.from(atob(input), (char)=>char.charCodeAt(0)));
const $d63301b8ece461ce$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $d63301b8ece461ce$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $d63301b8ece461ce$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $d63301b8ece461ce$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $d63301b8ece461ce$export$b5a4d6f439a5044d(data) {
    if ($d63301b8ece461ce$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $d63301b8ece461ce$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $d63301b8ece461ce$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($d63301b8ece461ce$export$61cc6ed0f143570b(data)) return [];
    if ($d63301b8ece461ce$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $d63301b8ece461ce$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $d63301b8ece461ce$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $d63301b8ece461ce$export$1d012a0dff3dab06(list, iteratee) {
    const group = $d63301b8ece461ce$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $d63301b8ece461ce$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $d63301b8ece461ce$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $d63301b8ece461ce$export$9cd59f9826255e47(data) {
    try {
        return globalThis.structuredClone(data);
    } catch  {
        return JSON.parse(JSON.stringify(data));
    }
}
function $d63301b8ece461ce$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = $d63301b8ece461ce$export$9cd59f9826255e47(list);
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $d63301b8ece461ce$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $d63301b8ece461ce$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $d63301b8ece461ce$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $d63301b8ece461ce$export$271f7c16f175f804 extends $d63301b8ece461ce$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $d63301b8ece461ce$var$$f872d8bba1c0f79f$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $d63301b8ece461ce$export$c489aa6f7fd82b1a;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $d63301b8ece461ce$export$cbd942915f33be50;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $d63301b8ece461ce$export$9b886f8493244014;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $d63301b8ece461ce$export$e99cbb807a5bb10d;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $d63301b8ece461ce$export$7a9a31a911eb9a20;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $d63301b8ece461ce$export$fca4f8121099df57;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $d63301b8ece461ce$export$6ce2f08d515512;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $d63301b8ece461ce$export$951c8378cdfec6e6;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $d63301b8ece461ce$export$1a4097b876a13bf7;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $d63301b8ece461ce$export$d9bcbd5e1ff81430;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $d63301b8ece461ce$export$506c8e8f8c8edda;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $d63301b8ece461ce$export$3ae94a2503e890a1;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "changeYear", function() {
    return $d63301b8ece461ce$export$7e1c707225b48c34;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $d63301b8ece461ce$export$62ad822b3a5fd9a0;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "changeDate", function() {
    return $d63301b8ece461ce$export$9e85258502147ffb;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$f872d8bba1c0f79f$exports, "makeDateRange", function() {
    return $d63301b8ece461ce$export$3c1f2e5bc03748e2;
});
const $d63301b8ece461ce$export$c489aa6f7fd82b1a = 1000;
const $d63301b8ece461ce$export$cbd942915f33be50 = $d63301b8ece461ce$export$c489aa6f7fd82b1a * 60;
const $d63301b8ece461ce$export$9b886f8493244014 = $d63301b8ece461ce$export$cbd942915f33be50 * 15;
const $d63301b8ece461ce$export$e99cbb807a5bb10d = $d63301b8ece461ce$export$9b886f8493244014 * 4;
const $d63301b8ece461ce$export$7a9a31a911eb9a20 = $d63301b8ece461ce$export$e99cbb807a5bb10d * 24;
const $d63301b8ece461ce$export$fca4f8121099df57 = $d63301b8ece461ce$export$7a9a31a911eb9a20 * 7;
const $d63301b8ece461ce$export$6ce2f08d515512 = $d63301b8ece461ce$export$7a9a31a911eb9a20 * 365;
const $d63301b8ece461ce$export$951c8378cdfec6e6 = $d63301b8ece461ce$export$6ce2f08d515512 / 12;
const $d63301b8ece461ce$export$1a4097b876a13bf7 = $d63301b8ece461ce$export$951c8378cdfec6e6 * 3;
class $d63301b8ece461ce$export$d9bcbd5e1ff81430 extends $d63301b8ece461ce$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $d63301b8ece461ce$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $d63301b8ece461ce$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $d63301b8ece461ce$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $d63301b8ece461ce$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $d63301b8ece461ce$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $d63301b8ece461ce$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $d63301b8ece461ce$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $d63301b8ece461ce$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $d63301b8ece461ce$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $d63301b8ece461ce$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    const date = new Date(time);
    const localDate = new Date(+date - date.getTimezoneOffset() * $d63301b8ece461ce$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = localDate.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $d63301b8ece461ce$export$7e1c707225b48c34(date, delta) {
    date = new Date(date);
    date.setFullYear(date.getFullYear() + delta);
    return date;
}
function $d63301b8ece461ce$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date = $d63301b8ece461ce$export$7e1c707225b48c34(date, Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
const $d63301b8ece461ce$export$9e85258502147ffb = (date, unit, delta)=>unit === $d63301b8ece461ce$export$6ce2f08d515512 ? $d63301b8ece461ce$export$7e1c707225b48c34(date, delta) : unit === $d63301b8ece461ce$export$951c8378cdfec6e6 ? $d63301b8ece461ce$export$62ad822b3a5fd9a0(date, delta) : new Date(+new Date(date) + delta * unit);
const $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$DateLength2Unit = {
    4: $d63301b8ece461ce$export$6ce2f08d515512,
    7: $d63301b8ece461ce$export$951c8378cdfec6e6,
    10: $d63301b8ece461ce$export$7a9a31a911eb9a20,
    13: $d63301b8ece461ce$export$e99cbb807a5bb10d,
    16: $d63301b8ece461ce$export$cbd942915f33be50,
    19: $d63301b8ece461ce$export$c489aa6f7fd82b1a
};
function $d63301b8ece461ce$export$3c1f2e5bc03748e2(value) {
    const defaultValue = `2025-01-01T00:00:00.000Z`;
    const startedAt = new Date(value + defaultValue.slice(value.length));
    const endedAt = $d63301b8ece461ce$export$9e85258502147ffb(startedAt, $d63301b8ece461ce$var$$f872d8bba1c0f79f$var$DateLength2Unit[value.length], 1);
    return [
        startedAt,
        endedAt
    ];
}
var $d63301b8ece461ce$var$$ba0e5dc395660a7c$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $d63301b8ece461ce$export$27924e57e9afff7f;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $d63301b8ece461ce$export$7ea17d45ecdcf634;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$ba0e5dc395660a7c$exports, "stringifyTextTable", function() {
    return $d63301b8ece461ce$export$bf304e455230454a;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $d63301b8ece461ce$export$bb8626e4916f587b;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $d63301b8ece461ce$export$88182f6768071c72;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $d63301b8ece461ce$export$2427785258f88523;
});
function $d63301b8ece461ce$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $d63301b8ece461ce$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $d63301b8ece461ce$export$7ea17d45ecdcf634(raw) {
    const parsed = $d63301b8ece461ce$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
const $d63301b8ece461ce$export$bf304e455230454a = (data, separator = ',')=>[
        Object.keys(data[0]).join(separator),
        ...data.map((item)=>Object.values(item).map((value)=>JSON.stringify(value)).join(separator))
    ].join('\n');
function $d63301b8ece461ce$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $d63301b8ece461ce$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $d63301b8ece461ce$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($d63301b8ece461ce$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $d63301b8ece461ce$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$d63301b8ece461ce$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$d63301b8ece461ce$export$1c8ba402144543e5(row, data[0]));
}
const $d63301b8ece461ce$export$88182f6768071c72 = async (raw)=>Array.fromAsync($d63301b8ece461ce$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $d63301b8ece461ce$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $d63301b8ece461ce$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($d63301b8ece461ce$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $d63301b8ece461ce$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $d63301b8ece461ce$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $d63301b8ece461ce$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $d63301b8ece461ce$export$1c8ba402144543e5(row, headerRow) : row;
}
var $d63301b8ece461ce$var$$083124ac4b1a50a0$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $d63301b8ece461ce$export$71e6483fc2b024eb;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $d63301b8ece461ce$export$eb9b2aadbe449a20;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $d63301b8ece461ce$export$13397a83aa5915d6;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $d63301b8ece461ce$export$fd89523fba250fa4;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $d63301b8ece461ce$export$504fbde693c1771c;
});
const $d63301b8ece461ce$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
function $d63301b8ece461ce$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($d63301b8ece461ce$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $d63301b8ece461ce$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $d63301b8ece461ce$export$b5a4d6f439a5044d(value) ? $d63301b8ece461ce$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $d63301b8ece461ce$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$d63301b8ece461ce$export$dd1bc94b04021eeb(value) && [
            key,
            $d63301b8ece461ce$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $d63301b8ece461ce$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $d63301b8ece461ce$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $d63301b8ece461ce$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $d63301b8ece461ce$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = Uint8Array.from(data, (char)=>char.charCodeAt(0));
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $d63301b8ece461ce$var$$d677628cc2ac1e37$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $d63301b8ece461ce$export$d0eaf3e94be578f6;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $d63301b8ece461ce$export$110700823644f4a6;
});
const $d63301b8ece461ce$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $d63301b8ece461ce$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $d63301b8ece461ce$var$$50872bf213056663$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $d63301b8ece461ce$export$1b9ac4d3de3ffd2e;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$50872bf213056663$exports, "makeSHA", function() {
    return $d63301b8ece461ce$export$d51f3b55e8d1aa73;
});
const $d63301b8ece461ce$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $d63301b8ece461ce$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $d63301b8ece461ce$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $d63301b8ece461ce$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, '0')).join('');
}
var $d63301b8ece461ce$var$$93a3089d2937b23f$exports = {};
var $d63301b8ece461ce$var$$3e0a089cc13f69ad$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $d63301b8ece461ce$export$f5a4056b78c72efa;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $d63301b8ece461ce$export$2ee022bbbc550b25;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $d63301b8ece461ce$export$a549dd5cef7f8327;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $d63301b8ece461ce$export$8eece510bcb9c62c;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $d63301b8ece461ce$export$b8a1af58c024fefd;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $d63301b8ece461ce$export$a2cf0d4bb6e06de4;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $d63301b8ece461ce$export$d66b332881d9723f;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $d63301b8ece461ce$export$b0709844452f8b6b;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $d63301b8ece461ce$export$5118471ee5d5453b;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "inViewport", function() {
    return $d63301b8ece461ce$export$6e196edbcc00e5bc;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $d63301b8ece461ce$export$be4650432daa84fd;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $d63301b8ece461ce$export$578e38b4a3e0b255;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $d63301b8ece461ce$export$7cd14c57bbb84350;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $d63301b8ece461ce$export$5100419dfae0456d;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $d63301b8ece461ce$export$28d9d24a8cd0ffc2;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $d63301b8ece461ce$export$3f99968195accfaf;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $d63301b8ece461ce$export$eafdbaa868ea9975;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $d63301b8ece461ce$export$36a0c1ca2ae264fa;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $d63301b8ece461ce$export$86d7c59254d6a2c9;
});
const $d63301b8ece461ce$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $d63301b8ece461ce$var$$3e0a089cc13f69ad$var$templateMap = {};
function $d63301b8ece461ce$export$2ee022bbbc550b25(tagName) {
    if ($d63301b8ece461ce$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $d63301b8ece461ce$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $d63301b8ece461ce$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $d63301b8ece461ce$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $d63301b8ece461ce$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $d63301b8ece461ce$export$8eece510bcb9c62c = (Class)=>$d63301b8ece461ce$export$170f4e08cad8229d(Class, HTMLElement);
const $d63301b8ece461ce$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $d63301b8ece461ce$export$b8a1af58c024fefd(Class) {
    const name = $d63301b8ece461ce$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $d63301b8ece461ce$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $d63301b8ece461ce$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $d63301b8ece461ce$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $d63301b8ece461ce$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $d63301b8ece461ce$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $d63301b8ece461ce$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($d63301b8ece461ce$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $d63301b8ece461ce$export$5118471ee5d5453b(node, type);
}
function $d63301b8ece461ce$export$6e196edbcc00e5bc(element) {
    const { left: left, top: top } = element.getBoundingClientRect();
    return document.elementFromPoint(left, top) === element;
}
function $d63301b8ece461ce$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $d63301b8ece461ce$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $d63301b8ece461ce$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $d63301b8ece461ce$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $d63301b8ece461ce$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$d63301b8ece461ce$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$d63301b8ece461ce$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $d63301b8ece461ce$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $d63301b8ece461ce$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $d63301b8ece461ce$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $d63301b8ece461ce$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $d63301b8ece461ce$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $d63301b8ece461ce$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $d63301b8ece461ce$export$7ea17d45ecdcf634(defaultValue);
                else if ($d63301b8ece461ce$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$d63301b8ece461ce$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $d63301b8ece461ce$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $d63301b8ece461ce$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$d63301b8ece461ce$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $d63301b8ece461ce$var$$bb23e0c794fefbef$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $d63301b8ece461ce$export$e772c8ff12451969;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $d63301b8ece461ce$export$57207d71b8c929c8;
});
function $d63301b8ece461ce$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $d63301b8ece461ce$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $d63301b8ece461ce$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $d63301b8ece461ce$var$$19ed8aeb7905a045$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $d63301b8ece461ce$export$10b1921597150314;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $d63301b8ece461ce$export$3e2b244719956741;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $d63301b8ece461ce$export$1d1d2ed6b55cf67f;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $d63301b8ece461ce$export$2155c0b5a4b77fb8;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $d63301b8ece461ce$export$9d97473344489dfc;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $d63301b8ece461ce$export$d635d04af3887bbe;
});
function $d63301b8ece461ce$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $d63301b8ece461ce$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $d63301b8ece461ce$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $d63301b8ece461ce$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $d63301b8ece461ce$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $d63301b8ece461ce$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $d63301b8ece461ce$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $d63301b8ece461ce$var$$7a08303ce13c49c5$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $d63301b8ece461ce$export$1b88f6b6d432a52a;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $d63301b8ece461ce$export$b70f6380221b1350;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $d63301b8ece461ce$export$75d6cbe4503e149;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $d63301b8ece461ce$export$b2618d51188815c2;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $d63301b8ece461ce$export$490814474ddbb428;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $d63301b8ece461ce$export$3ea201dffb50dfef;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $d63301b8ece461ce$export$d1012c7198c6b460;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $d63301b8ece461ce$export$a35a418b7b17958e;
});
class $d63301b8ece461ce$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $d63301b8ece461ce$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $d63301b8ece461ce$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $d63301b8ece461ce$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $d63301b8ece461ce$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $d63301b8ece461ce$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $d63301b8ece461ce$export$75d6cbe4503e149(type, element)))
    ]);
}
function $d63301b8ece461ce$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $d63301b8ece461ce$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $d63301b8ece461ce$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $d63301b8ece461ce$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $d63301b8ece461ce$export$490814474ddbb428(element, className, display = 'block') {
    return $d63301b8ece461ce$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $d63301b8ece461ce$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $d63301b8ece461ce$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $d63301b8ece461ce$export$d1012c7198c6b460(element, className, remove) {
    return $d63301b8ece461ce$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $d63301b8ece461ce$export$a35a418b7b17958e(element, className, remove) {
    return $d63301b8ece461ce$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $d63301b8ece461ce$var$$69bd9f0117925302$exports = {};
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$69bd9f0117925302$exports, "describe", function() {
    return $d63301b8ece461ce$export$cd5450f3a47e3789;
});
$d63301b8ece461ce$var$$parcel$export($d63301b8ece461ce$var$$69bd9f0117925302$exports, "it", function() {
    return $d63301b8ece461ce$export$3486a10f30cf1ee4;
});
async function $d63301b8ece461ce$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $d63301b8ece461ce$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$d63301b8ece461ce$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}

});


parcelRegister("2eNzN", function(module, exports) {
module.exports = $parcel$import("cYG3x").then(()=>parcelRequire('kYRgI'));

});

parcelRegister("dYaYn", function(module, exports) {
module.exports = $parcel$import("9uSQe").then(()=>parcelRequire('ePczV'));

});

parcelRegister("a2zud", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01e2ede7bb5203b5$export$2e2bcd8739ae039; });
const $01e2ede7bb5203b5$var$config = {
    ReadableStream: globalThis.ReadableStream,
    WritableStream: globalThis.WritableStream,
    TransformStream: globalThis.TransformStream,
    DOMException: globalThis.DOMException,
    Blob: globalThis.Blob,
    File: globalThis.File
};
var $01e2ede7bb5203b5$export$2e2bcd8739ae039 = $01e2ede7bb5203b5$var$config;

});

parcelRegister("7LdLi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FileSystemDirectoryHandle", function () { return $5a679901fcc25329$export$80c69d2381792bb3; });
$parcel$export(module.exports, "default", function () { return $5a679901fcc25329$export$2e2bcd8739ae039; });

var $9QfhF = parcelRequire("9QfhF");

var $cFLn4 = parcelRequire("cFLn4");
const { GONE: $5a679901fcc25329$var$GONE, MOD_ERR: $5a679901fcc25329$var$MOD_ERR } = (0, $cFLn4.errors);
const $5a679901fcc25329$var$kAdapter = Symbol('adapter');



class $5a679901fcc25329$export$80c69d2381792bb3 extends (0, $9QfhF.default) {
    /** @type {FileSystemDirectoryHandle} */ [$5a679901fcc25329$var$kAdapter];
    constructor(adapter){
        super(adapter);
        this[$5a679901fcc25329$var$kAdapter] = adapter;
    }
    /**
   * @param {string} name Name of the directory
   * @param {object} [options]
   * @param {boolean} [options.create] create the directory if don't exist
   * @returns {Promise<FileSystemDirectoryHandle>}
   */ async getDirectoryHandle(name, options = {}) {
        if (name === '') throw new TypeError(`Name can't be an empty string.`);
        if (name === '.' || name === '..' || name.includes('/')) throw new TypeError(`Name contains invalid characters.`);
        options.create = !!options.create;
        const handle = await this[$5a679901fcc25329$var$kAdapter].getDirectoryHandle(name, options);
        return new $5a679901fcc25329$export$80c69d2381792bb3(handle);
    }
    /** @returns {AsyncGenerator<[string, FileSystemHandle | FileSystemDirectoryHandle]>} */ async *entries() {
        const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
        for await (const [_, entry] of this[$5a679901fcc25329$var$kAdapter].entries())yield [
            entry.name,
            entry.kind === 'file' ? new FileSystemFileHandle(entry) : new $5a679901fcc25329$export$80c69d2381792bb3(entry)
        ];
    }
    /** @deprecated use .entries() instead */ async *getEntries() {
        const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
        console.warn('deprecated, use .entries() instead');
        for await (let entry of this[$5a679901fcc25329$var$kAdapter].entries())yield entry.kind === 'file' ? new FileSystemFileHandle(entry) : new $5a679901fcc25329$export$80c69d2381792bb3(entry);
    }
    /**
   * @param {string} name Name of the file
   * @param {object} [options]
   * @param {boolean} [options.create] create the file if don't exist
   */ async getFileHandle(name, options = {}) {
        const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
        if (name === '') throw new TypeError(`Name can't be an empty string.`);
        if (name === '.' || name === '..' || name.includes('/')) throw new TypeError(`Name contains invalid characters.`);
        options.create = !!options.create;
        const handle = await this[$5a679901fcc25329$var$kAdapter].getFileHandle(name, options);
        return new FileSystemFileHandle(handle);
    }
    /**
   * @param {string} name
   * @param {object} [options]
   * @param {boolean} [options.recursive]
   */ async removeEntry(name, options = {}) {
        if (name === '') throw new TypeError(`Name can't be an empty string.`);
        if (name === '.' || name === '..' || name.includes('/')) throw new TypeError(`Name contains invalid characters.`);
        options.recursive = !!options.recursive // cuz node's fs.rm require boolean
        ;
        return this[$5a679901fcc25329$var$kAdapter].removeEntry(name, options);
    }
    async resolve(possibleDescendant) {
        if (await possibleDescendant.isSameEntry(this)) return [];
        const openSet = [
            {
                handle: this,
                path: []
            }
        ];
        while(openSet.length){
            let { handle: current, path: path } = openSet.pop();
            for await (const entry of current.values()){
                if (await entry.isSameEntry(possibleDescendant)) return [
                    ...path,
                    entry.name
                ];
                if (entry.kind === 'directory') openSet.push({
                    handle: entry,
                    path: [
                        ...path,
                        entry.name
                    ]
                });
            }
        }
        return null;
    }
    async *keys() {
        for await (const [name] of this[$5a679901fcc25329$var$kAdapter].entries())yield name;
    }
    async *values() {
        for await (const [_, entry] of this)yield entry;
    }
    [Symbol.asyncIterator]() {
        return this.entries();
    }
}
Object.defineProperty($5a679901fcc25329$export$80c69d2381792bb3.prototype, Symbol.toStringTag, {
    value: 'FileSystemDirectoryHandle',
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($5a679901fcc25329$export$80c69d2381792bb3.prototype, {
    getDirectoryHandle: {
        enumerable: true
    },
    entries: {
        enumerable: true
    },
    getFileHandle: {
        enumerable: true
    },
    removeEntry: {
        enumerable: true
    }
});
if (globalThis.FileSystemDirectoryHandle) {
    const proto = globalThis.FileSystemDirectoryHandle.prototype;
    proto.resolve = async function resolve(possibleDescendant) {
        if (await possibleDescendant.isSameEntry(this)) return [];
        const openSet = [
            {
                handle: this,
                path: []
            }
        ];
        while(openSet.length){
            let { handle: current, path: path } = openSet.pop();
            for await (const entry of current.values()){
                if (await entry.isSameEntry(possibleDescendant)) return [
                    ...path,
                    entry.name
                ];
                if (entry.kind === 'directory') openSet.push({
                    handle: entry,
                    path: [
                        ...path,
                        entry.name
                    ]
                });
            }
        }
        return null;
    };
    // Safari allows us operate on deleted files,
    // so we need to check if they still exist.
    // Hope to remove this one day.
    async function ensureDoActuallyStillExist(handle) {
        const root = await navigator.storage.getDirectory();
        const path = await root.resolve(handle);
        if (path === null) throw new DOMException(...$5a679901fcc25329$var$GONE);
    }
    const entries = proto.entries;
    proto.entries = async function*() {
        await ensureDoActuallyStillExist(this);
        yield* entries.call(this);
    };
    proto[Symbol.asyncIterator] = async function*() {
        yield* this.entries();
    };
    const removeEntry = proto.removeEntry;
    proto.removeEntry = async function(name, options = {}) {
        return removeEntry.call(this, name, options).catch(async (err)=>{
            const unknown = err instanceof DOMException && err.name === 'UnknownError';
            if (unknown && !options.recursive) {
                const empty = (await entries.call(this).next()).done;
                if (!empty) throw new DOMException(...$5a679901fcc25329$var$MOD_ERR);
            }
            throw err;
        });
    };
}
var $5a679901fcc25329$export$2e2bcd8739ae039 = $5a679901fcc25329$export$80c69d2381792bb3;

});
parcelRegister("9QfhF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72a4d37afd24250d$export$2e2bcd8739ae039; });
const $72a4d37afd24250d$var$kAdapter = Symbol('adapter');
/**
 * @typedef {Object} FileSystemHandlePermissionDescriptor
 * @property {('read'|'readwrite')} [mode='read']
 */ class $72a4d37afd24250d$export$90d155f9f7c2d644 {
    /** @type {FileSystemHandle} */ [$72a4d37afd24250d$var$kAdapter];
    /** @type {string} */ name;
    /** @type {('file'|'directory')} */ kind;
    /** @param {FileSystemHandle & {writable}} adapter */ constructor(adapter){
        this.kind = adapter.kind;
        this.name = adapter.name;
        this[$72a4d37afd24250d$var$kAdapter] = adapter;
    }
    /** @param {FileSystemHandlePermissionDescriptor} descriptor */ async queryPermission(descriptor = {}) {
        const { mode: mode = 'read' } = descriptor;
        const handle = this[$72a4d37afd24250d$var$kAdapter];
        if (handle.queryPermission) return handle.queryPermission({
            mode: mode
        });
        if (mode === 'read') return 'granted';
        else if (mode === 'readwrite') return handle.writable ? 'granted' : 'denied';
        else throw new TypeError(`Mode ${mode} must be 'read' or 'readwrite'`);
    }
    async requestPermission({ mode: mode = 'read' } = {}) {
        const handle = this[$72a4d37afd24250d$var$kAdapter];
        if (handle.requestPermission) return handle.requestPermission({
            mode: mode
        });
        if (mode === 'read') return 'granted';
        else if (mode === 'readwrite') return handle.writable ? 'granted' : 'denied';
        else throw new TypeError(`Mode ${mode} must be 'read' or 'readwrite'`);
    }
    /**
   * Attempts to remove the entry represented by handle from the underlying file system.
   *
   * @param {object} options
   * @param {boolean} [options.recursive=false]
   */ async remove(options = {}) {
        await this[$72a4d37afd24250d$var$kAdapter].remove(options);
    }
    /**
   * @param {FileSystemHandle} other
   */ async isSameEntry(other) {
        if (this === other) return true;
        if (!other || typeof other !== 'object' || this.kind !== other.kind || !other[$72a4d37afd24250d$var$kAdapter]) return false;
        return this[$72a4d37afd24250d$var$kAdapter].isSameEntry(other[$72a4d37afd24250d$var$kAdapter]);
    }
}
Object.defineProperty($72a4d37afd24250d$export$90d155f9f7c2d644.prototype, Symbol.toStringTag, {
    value: 'FileSystemHandle',
    writable: false,
    enumerable: false,
    configurable: true
});
// Safari safari doesn't support writable streams yet.
if (globalThis.FileSystemHandle) globalThis.FileSystemHandle.prototype.queryPermission ??= function(descriptor) {
    return 'granted';
};
var $72a4d37afd24250d$export$2e2bcd8739ae039 = $72a4d37afd24250d$export$90d155f9f7c2d644;

});

parcelRegister("cFLn4", function(module, exports) {

$parcel$export(module.exports, "errors", function () { return $939e0f49c4a3b174$export$30f3b02011db23c0; });
$parcel$export(module.exports, "config", function () { return $939e0f49c4a3b174$export$e506a1d27d1eaa20; });
$parcel$export(module.exports, "fromDataTransfer", function () { return $939e0f49c4a3b174$export$34af8373a76882c2; });
$parcel$export(module.exports, "getDirHandlesFromInput", function () { return $939e0f49c4a3b174$export$7d17e35d81e093f2; });
$parcel$export(module.exports, "getFileHandlesFromInput", function () { return $939e0f49c4a3b174$export$45ac616e835cfe89; });
const $939e0f49c4a3b174$export$30f3b02011db23c0 = {
    INVALID: [
        'seeking position failed.',
        'InvalidStateError'
    ],
    GONE: [
        'A requested file or directory could not be found at the time an operation was processed.',
        'NotFoundError'
    ],
    MISMATCH: [
        'The path supplied exists, but was not an entry of requested type.',
        'TypeMismatchError'
    ],
    MOD_ERR: [
        'The object can not be modified in this way.',
        'InvalidModificationError'
    ],
    SYNTAX: (m)=>[
            `Failed to execute 'write' on 'UnderlyingSinkBase': Invalid params passed. ${m}`,
            'SyntaxError'
        ],
    SECURITY: [
        'It was determined that certain files are unsafe for access within a Web application, or that too many calls are being made on file resources.',
        'SecurityError'
    ],
    DISALLOWED: [
        'The request is not allowed by the user agent or the platform in the current context.',
        'NotAllowedError'
    ]
};
const $939e0f49c4a3b174$export$e506a1d27d1eaa20 = {
    writable: globalThis.WritableStream
};



async function $939e0f49c4a3b174$export$34af8373a76882c2(entries) {
    console.warn('deprecated fromDataTransfer - use `dt.items[0].getAsFileSystemHandle()` instead');
    const [memory, sandbox, fs] = await Promise.all([
        (parcelRequire("khJgs")),
        (parcelRequire("dYaYn")),
        Promise.resolve((parcelRequire("7LdLi")))
    ]);
    const folder = new memory.FolderHandle('', false);
    folder._entries = entries.map((entry)=>entry.isFile ? new sandbox.FileHandle(entry, false) : new sandbox.FolderHandle(entry, false));
    return new fs.FileSystemDirectoryHandle(folder);
}


async function $939e0f49c4a3b174$export$7d17e35d81e093f2(input) {
    const { FolderHandle: FolderHandle, FileHandle: FileHandle } = await (parcelRequire("khJgs"));
    const { FileSystemDirectoryHandle: FileSystemDirectoryHandle } = await Promise.resolve((parcelRequire("7LdLi")));
    const files = Array.from(input.files);
    const rootName = files[0].webkitRelativePath.split('/', 1)[0];
    const root = new FolderHandle(rootName, false);
    files.forEach((file)=>{
        const path = file.webkitRelativePath.split('/');
        path.shift();
        const name = path.pop();
        const dir = path.reduce((dir, path)=>{
            if (!dir._entries[path]) dir._entries[path] = new FolderHandle(path, false);
            return dir._entries[path];
        }, root);
        dir._entries[name] = new FileHandle(file.name, file, false);
    });
    return new FileSystemDirectoryHandle(root);
}


async function $939e0f49c4a3b174$export$45ac616e835cfe89(input) {
    const { FileHandle: FileHandle } = await (parcelRequire("khJgs"));
    const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
    return Array.from(input.files).map((file)=>new FileSystemFileHandle(new FileHandle(file.name, file, false)));
}

});
parcelRegister("khJgs", function(module, exports) {
module.exports = $parcel$import("6uZq5").then(()=>parcelRequire('eIbxT'));

});

parcelRegister("dPisW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "FileSystemFileHandle", function () { return $a10e5cb78d2beb74$export$db2751aad7d8e0f3; });
$parcel$export(module.exports, "default", function () { return $a10e5cb78d2beb74$export$2e2bcd8739ae039; });

var $9QfhF = parcelRequire("9QfhF");

var $1A4EY = parcelRequire("1A4EY");

var $cFLn4 = parcelRequire("cFLn4");
const { INVALID: $a10e5cb78d2beb74$var$INVALID, SYNTAX: $a10e5cb78d2beb74$var$SYNTAX, GONE: $a10e5cb78d2beb74$var$GONE } = (0, $cFLn4.errors);
const $a10e5cb78d2beb74$var$kAdapter = Symbol('adapter');
class $a10e5cb78d2beb74$export$db2751aad7d8e0f3 extends (0, $9QfhF.default) {
    /** @type {FileSystemFileHandle} */ [$a10e5cb78d2beb74$var$kAdapter];
    constructor(adapter){
        super(adapter);
        this[$a10e5cb78d2beb74$var$kAdapter] = adapter;
    }
    /**
   * @param  {Object} [options={}]
   * @param  {boolean} [options.keepExistingData]
   * @returns {Promise<FileSystemWritableFileStream>}
   */ async createWritable(options = {}) {
        return new (0, $1A4EY.default)(await this[$a10e5cb78d2beb74$var$kAdapter].createWritable(options));
    }
    /**
   * @returns {Promise<File>}
   */ async getFile() {
        return this[$a10e5cb78d2beb74$var$kAdapter].getFile();
    }
}
Object.defineProperty($a10e5cb78d2beb74$export$db2751aad7d8e0f3.prototype, Symbol.toStringTag, {
    value: 'FileSystemFileHandle',
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($a10e5cb78d2beb74$export$db2751aad7d8e0f3.prototype, {
    createWritable: {
        enumerable: true
    },
    getFile: {
        enumerable: true
    }
});
// Safari doesn't support async createWritable streams yet.
if (globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable) {
    const wm = new WeakMap();
    let workerUrl;
    // Worker code that should be inlined (can't use any external functions)
    const code = ()=>{
        let fileHandle, handle;
        onmessage = async (evt)=>{
            const port = evt.ports[0];
            const cmd = evt.data;
            switch(cmd.type){
                case 'open':
                    const file = cmd.name;
                    let dir = await navigator.storage.getDirectory();
                    for (const folder of cmd.path)dir = await dir.getDirectoryHandle(folder);
                    fileHandle = await dir.getFileHandle(file);
                    handle = await fileHandle.createSyncAccessHandle();
                    break;
                case 'write':
                    handle.write(cmd.data, {
                        at: cmd.position
                    });
                    handle.flush();
                    break;
                case 'truncate':
                    handle.truncate(cmd.size);
                    break;
                case 'abort':
                case 'close':
                    handle.close();
                    break;
            }
            port.postMessage(0);
        };
    };
    globalThis.FileSystemFileHandle.prototype.createWritable = async function(options) {
        // Safari only support writing data in a worker with sync access handle.
        if (!workerUrl) {
            const stringCode = `(${code.toString()})()`;
            const blob = new Blob([
                stringCode
            ], {
                type: 'text/javascript'
            });
            workerUrl = URL.createObjectURL(blob);
        }
        const worker = new Worker(workerUrl, {
            type: 'module'
        });
        let position = 0;
        const textEncoder = new TextEncoder();
        let size = await this.getFile().then((file)=>file.size);
        const send = (message)=>new Promise((resolve, reject)=>{
                const mc = new MessageChannel();
                mc.port1.onmessage = (evt)=>{
                    if (evt.data instanceof Error) reject(evt.data);
                    else resolve(evt.data);
                    mc.port1.close();
                    mc.port2.close();
                    mc.port1.onmessage = null;
                };
                worker.postMessage(message, [
                    mc.port2
                ]);
            });
        // Safari also don't support transferable file system handles.
        // So we need to pass the path to the worker. This is a bit hacky and ugly.
        const root = await navigator.storage.getDirectory();
        const parent = await wm.get(this);
        const path = await root.resolve(parent);
        // Should likely never happen, but just in case...
        if (path === null) throw new DOMException(...$a10e5cb78d2beb74$var$GONE);
        let controller;
        await send({
            type: 'open',
            path: path,
            name: this.name
        });
        if (options?.keepExistingData === false) {
            await send({
                type: 'truncate',
                size: 0
            });
            size = 0;
        }
        const ws = new (0, $1A4EY.default)({
            start: (ctrl)=>{
                controller = ctrl;
            },
            async write (chunk) {
                const isPlainObject = chunk?.constructor === Object;
                if (isPlainObject) chunk = {
                    ...chunk
                };
                else chunk = {
                    type: 'write',
                    data: chunk,
                    position: position
                };
                if (chunk.type === 'write') {
                    if (!('data' in chunk)) {
                        await send({
                            type: 'close'
                        });
                        throw new DOMException(...$a10e5cb78d2beb74$var$SYNTAX('write requires a data argument'));
                    }
                    chunk.position ??= position;
                    if (typeof chunk.data === 'string') chunk.data = textEncoder.encode(chunk.data);
                    else if (chunk.data instanceof ArrayBuffer) chunk.data = new Uint8Array(chunk.data);
                    else if (!(chunk.data instanceof Uint8Array) && ArrayBuffer.isView(chunk.data)) chunk.data = new Uint8Array(chunk.data.buffer, chunk.data.byteOffset, chunk.data.byteLength);
                    else if (!(chunk.data instanceof Uint8Array)) {
                        const ab = await new Response(chunk.data).arrayBuffer();
                        chunk.data = new Uint8Array(ab);
                    }
                    if (Number.isInteger(chunk.position) && chunk.position >= 0) position = chunk.position;
                    position += chunk.data.byteLength;
                    size += chunk.data.byteLength;
                } else if (chunk.type === 'seek') {
                    if (Number.isInteger(chunk.position) && chunk.position >= 0) {
                        if (size < chunk.position) throw new DOMException(...$a10e5cb78d2beb74$var$INVALID);
                        console.log('seeking', chunk);
                        position = chunk.position;
                        return; // Don't need to enqueue seek...
                    } else {
                        await send({
                            type: 'close'
                        });
                        throw new DOMException(...$a10e5cb78d2beb74$var$SYNTAX('seek requires a position argument'));
                    }
                } else if (chunk.type === 'truncate') {
                    if (Number.isInteger(chunk.size) && chunk.size >= 0) {
                        size = chunk.size;
                        if (position > size) position = size;
                    } else {
                        await send({
                            type: 'close'
                        });
                        throw new DOMException(...$a10e5cb78d2beb74$var$SYNTAX('truncate requires a size argument'));
                    }
                }
                await send(chunk);
            },
            async close () {
                await send({
                    type: 'close'
                });
                worker.terminate();
            },
            async abort (reason) {
                await send({
                    type: 'abort',
                    reason: reason
                });
                worker.terminate();
            }
        });
        return ws;
    };
    const orig = FileSystemDirectoryHandle.prototype.getFileHandle;
    FileSystemDirectoryHandle.prototype.getFileHandle = async function(...args) {
        const handle = await orig.call(this, ...args);
        wm.set(handle, this);
        return handle;
    };
}
var $a10e5cb78d2beb74$export$2e2bcd8739ae039 = $a10e5cb78d2beb74$export$db2751aad7d8e0f3;

});
parcelRegister("1A4EY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $126cc49748d7ef7c$export$2e2bcd8739ae039; });

var $a2zud = parcelRequire("a2zud");
const { WritableStream: $126cc49748d7ef7c$var$WritableStream } = (0, $a2zud.default);
class $126cc49748d7ef7c$export$fea83bdfcd3f94c extends $126cc49748d7ef7c$var$WritableStream {
    #writer;
    constructor(writer){
        super(writer);
        this.#writer = writer;
        // Stupid Safari hack to extend native classes
        // https://bugs.webkit.org/show_bug.cgi?id=226201
        Object.setPrototypeOf(this, $126cc49748d7ef7c$export$fea83bdfcd3f94c.prototype);
        /** @private */ this._closed = false;
    }
    async close() {
        this._closed = true;
        const w = this.getWriter();
        const p = w.close();
        w.releaseLock();
        return p;
    // return super.close ? super.close() : this.getWriter().close()
    }
    /** @param {number} position */ seek(position) {
        return this.write({
            type: 'seek',
            position: position
        });
    }
    /** @param {number} size */ truncate(size) {
        return this.write({
            type: 'truncate',
            size: size
        });
    }
    // The write(data) method steps are:
    write(data) {
        if (this._closed) return Promise.reject(new TypeError('Cannot write to a CLOSED writable stream'));
        // 1. Let writer be the result of getting a writer for this.
        const writer = this.getWriter();
        // 2. Let result be the result of writing a chunk to writer given data.
        const result = writer.write(data);
        // 3. Release writer.
        writer.releaseLock();
        // 4. Return result.
        return result;
    }
}
Object.defineProperty($126cc49748d7ef7c$export$fea83bdfcd3f94c.prototype, Symbol.toStringTag, {
    value: 'FileSystemWritableFileStream',
    writable: false,
    enumerable: false,
    configurable: true
});
Object.defineProperties($126cc49748d7ef7c$export$fea83bdfcd3f94c.prototype, {
    close: {
        enumerable: true
    },
    seek: {
        enumerable: true
    },
    truncate: {
        enumerable: true
    },
    write: {
        enumerable: true
    }
});
// Safari safari doesn't support writable streams yet.
if (globalThis.FileSystemFileHandle && !globalThis.FileSystemFileHandle.prototype.createWritable && !globalThis.FileSystemWritableFileStream) globalThis.FileSystemWritableFileStream = $126cc49748d7ef7c$export$fea83bdfcd3f94c;
var $126cc49748d7ef7c$export$2e2bcd8739ae039 = $126cc49748d7ef7c$export$fea83bdfcd3f94c;

});




var $ddee0d70d9770d42$exports = {};
$parcel$extendImportMap({
    "9d8QO": "zh-TW.02a9f321.js",
    "fIA0l": "en-US.809a0228.js",
    "6uZq5": "memory.2b9242a5.js",
    "9uSQe": "sandbox.f5019269.js",
    "cYG3x": "downloader.e3f178be.js"
});


var $3lE4N = parcelRequire("3lE4N");
var $833f543b429117ba$var$t = /["&<]/;
function $833f543b429117ba$var$n(r) {
    if (0 === r.length || !1 === $833f543b429117ba$var$t.test(r)) return r;
    for(var e = 0, n = 0, o = "", f = ""; n < r.length; n++){
        switch(r.charCodeAt(n)){
            case 34:
                f = "&quot;";
                break;
            case 38:
                f = "&amp;";
                break;
            case 60:
                f = "&lt;";
                break;
            default:
                continue;
        }
        n !== e && (o += r.slice(e, n)), o += f, e = n + 1;
    }
    return n !== e && (o += r.slice(e, n)), o;
}
var $833f543b429117ba$var$o = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $833f543b429117ba$var$f = 0, $833f543b429117ba$var$i = Array.isArray;
function $833f543b429117ba$export$34b9dba7ce09269b(e, t, n, o, i, u) {
    t || (t = {});
    var a, c, p = t;
    if ("ref" in p) for(c in p = {}, t)"ref" == c ? a = t[c] : p[c] = t[c];
    var l = {
        type: e,
        props: p,
        key: n,
        ref: a,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: --$833f543b429117ba$var$f,
        __i: -1,
        __u: 0,
        __source: i,
        __self: u
    };
    if ("function" == typeof e && (a = e.defaultProps)) for(c in a)void 0 === p[c] && (p[c] = a[c]);
    return (0, $3lE4N.options).vnode && (0, $3lE4N.options).vnode(l), l;
}
function $833f543b429117ba$export$45700d561b2268ac(r) {
    var t = $833f543b429117ba$export$34b9dba7ce09269b((0, $3lE4N.Fragment), {
        tpl: r,
        exprs: [].slice.call(arguments, 1)
    });
    return t.key = t.__v, t;
}
var $833f543b429117ba$var$c = {}, $833f543b429117ba$var$p = /[A-Z]/g;
function $833f543b429117ba$export$991f6ffe102e5bac(e, t) {
    if ((0, $3lE4N.options).attr) {
        var f = (0, $3lE4N.options).attr(e, t);
        if ("string" == typeof f) return f;
    }
    if (t = function(r) {
        return null !== r && "object" == typeof r && "function" == typeof r.valueOf ? r.valueOf() : r;
    }(t), "ref" === e || "key" === e) return "";
    if ("style" === e && "object" == typeof t) {
        var i = "";
        for(var u in t){
            var a = t[u];
            if (null != a && "" !== a) {
                var l = "-" == u[0] ? u : $833f543b429117ba$var$c[u] || ($833f543b429117ba$var$c[u] = u.replace($833f543b429117ba$var$p, "-$&").toLowerCase()), s = ";";
                "number" != typeof a || l.startsWith("--") || $833f543b429117ba$var$o.test(l) || (s = "px;"), i = i + l + ":" + a + s;
            }
        }
        return e + '="' + $833f543b429117ba$var$n(i) + '"';
    }
    return null == t || !1 === t || "function" == typeof t || "object" == typeof t ? "" : !0 === t ? e : e + '="' + $833f543b429117ba$var$n("" + t) + '"';
}
function $833f543b429117ba$export$40e96e718441efeb(r) {
    if (null == r || "boolean" == typeof r || "function" == typeof r) return null;
    if ("object" == typeof r) {
        if (void 0 === r.constructor) return r;
        if ($833f543b429117ba$var$i(r)) {
            for(var e = 0; e < r.length; e++)r[e] = $833f543b429117ba$export$40e96e718441efeb(r[e]);
            return r;
        }
    }
    return $833f543b429117ba$var$n("" + r);
}


var $de9addb89ca41b61$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $de9addb89ca41b61$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $de9addb89ca41b61$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $de9addb89ca41b61$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $de9addb89ca41b61$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $de9addb89ca41b61$var$InstrumentedPromise$1.prototype;
    return promise;
};
$de9addb89ca41b61$var$InstrumentedPromise$1.__proto__ = $de9addb89ca41b61$var$OriginalPromise;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.__proto__ = $de9addb89ca41b61$var$OriginalPromise.prototype;
$de9addb89ca41b61$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $de9addb89ca41b61$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $de9addb89ca41b61$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $de9addb89ca41b61$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $de9addb89ca41b61$export$cea1c58a6db52bca() {
    Promise = $de9addb89ca41b61$var$InstrumentedPromise$1;
}
function $de9addb89ca41b61$export$dfb5619354ba860() {
    if ($de9addb89ca41b61$export$baf72085f5fb4df()) $de9addb89ca41b61$export$cea1c58a6db52bca();
}
var $de9addb89ca41b61$export$2e2bcd8739ae039 = $de9addb89ca41b61$var$InstrumentedPromise$1;



var $cF2Ke = parcelRequire("cF2Ke");

var $kzd8a = parcelRequire("kzd8a");
function $8c69a4426694c4f3$export$882461b6382ed46c(container) {
    return {
        // eslint-disable-next-line
        render: function(children) {
            (0, $kzd8a.render)(children, container);
        },
        // eslint-disable-next-line
        unmount: function() {
            (0, $kzd8a.unmountComponentAtNode)(container);
        }
    };
}
function $8c69a4426694c4f3$export$757ceba2d55c277e(container, children) {
    (0, $kzd8a.hydrate)(children, container);
    return $8c69a4426694c4f3$export$882461b6382ed46c(container);
}
var $8c69a4426694c4f3$export$2e2bcd8739ae039 = {
    createRoot: $8c69a4426694c4f3$export$882461b6382ed46c,
    hydrateRoot: $8c69a4426694c4f3$export$757ceba2d55c277e
};



var $iob0w = parcelRequire("iob0w");

var $3lE4N = parcelRequire("3lE4N");
var $46a03b660b5bd4f2$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($46a03b660b5bd4f2$exports) {
        classNames.default = classNames;
        $46a03b660b5bd4f2$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $kzd8a = parcelRequire("kzd8a");
parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

"use client";
const $b6315234e77a11f8$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $b6315234e77a11f8$export$ff817e17bad2e091 = 'xs';
const $b6315234e77a11f8$var$ThemeContext = /*#__PURE__*/ $3lE4N.createContext({
    prefixes: {},
    breakpoints: $b6315234e77a11f8$export$666ad80b5007f835,
    minBreakpoint: $b6315234e77a11f8$export$ff817e17bad2e091
});
const { Consumer: $b6315234e77a11f8$export$b631efc24e9d5e2f, Provider: $b6315234e77a11f8$var$Provider } = $b6315234e77a11f8$var$ThemeContext;
function $b6315234e77a11f8$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $b6315234e77a11f8$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $b6315234e77a11f8$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $jmWak.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)($b6315234e77a11f8$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $b6315234e77a11f8$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $jmWak.useContext)($b6315234e77a11f8$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $b6315234e77a11f8$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $jmWak.useContext)($b6315234e77a11f8$var$ThemeContext);
    return breakpoints;
}
function $b6315234e77a11f8$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $jmWak.useContext)($b6315234e77a11f8$var$ThemeContext);
    return minBreakpoint;
}
function $b6315234e77a11f8$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $jmWak.useContext)($b6315234e77a11f8$var$ThemeContext);
    return dir === 'rtl';
}
function $b6315234e77a11f8$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $kzd8a.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $b6315234e77a11f8$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $b6315234e77a11f8$export$2e2bcd8739ae039 = $b6315234e77a11f8$var$ThemeProvider;



"use client";
const $5f7777a6b14048f7$var$Container = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$5f7777a6b14048f7$var$Container.displayName = 'Container';
var $5f7777a6b14048f7$export$2e2bcd8739ae039 = $5f7777a6b14048f7$var$Container;


/**
 * react-router v7.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
var $jmWak = parcelRequire("jmWak");
var $kzd8a = parcelRequire("kzd8a");
var $db188477a5aad910$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.18.0_@preact+compat@18.3.2_preact@10.29.2__@preact+compat@18.3.2_preact@10.29.2_/node_modules/react-router/dist/development/chunk-4ZMWKKQ3.mjs"
});
var $db188477a5aad910$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $db188477a5aad910$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $db188477a5aad910$var$__typeError("Cannot " + msg);
var $db188477a5aad910$var$__privateGet = (obj, member, getter)=>($db188477a5aad910$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $db188477a5aad910$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $db188477a5aad910$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $db188477a5aad910$var$__privateSet = (obj, member, value, setter)=>($db188477a5aad910$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
// lib/router/url.ts
var $db188477a5aad910$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $db188477a5aad910$export$825a82322d91916e = /^[\\/]{2}/;
function $db188477a5aad910$var$normalizeProtocolRelativeUrl(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}
// lib/router/history.ts
var $db188477a5aad910$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($db188477a5aad910$export$e19cd5f9376f8cee || {});
var $db188477a5aad910$var$PopStateEventType = "popstate";
function $db188477a5aad910$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $db188477a5aad910$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $db188477a5aad910$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $db188477a5aad910$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $db188477a5aad910$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $db188477a5aad910$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $db188477a5aad910$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $db188477a5aad910$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $db188477a5aad910$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $db188477a5aad910$export$fe53371bee54353d(to);
    }
    return $db188477a5aad910$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $db188477a5aad910$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $db188477a5aad910$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $db188477a5aad910$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $db188477a5aad910$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $db188477a5aad910$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $db188477a5aad910$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $db188477a5aad910$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $db188477a5aad910$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $db188477a5aad910$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $db188477a5aad910$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $db188477a5aad910$var$createLocation(current, to, state = null, key, mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $db188477a5aad910$var$createKey(),
        mask: mask
    };
    return location;
}
function $db188477a5aad910$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $db188477a5aad910$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $db188477a5aad910$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $db188477a5aad910$var$isLocation(to) ? to : $db188477a5aad910$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $db188477a5aad910$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $db188477a5aad910$var$isLocation(to) ? to : $db188477a5aad910$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $db188477a5aad910$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $db188477a5aad910$var$createBrowserURLImpl(window2, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($db188477a5aad910$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($db188477a5aad910$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $db188477a5aad910$var$createBrowserURLImpl(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $db188477a5aad910$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $db188477a5aad910$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && $db188477a5aad910$export$825a82322d91916e.test(href)) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $db188477a5aad910$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $db188477a5aad910$var$_map;
var $db188477a5aad910$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $db188477a5aad910$var$__privateAdd(this, $db188477a5aad910$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_map).has(context)) return $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_map).set(context, value);
    }
};
$db188477a5aad910$var$_map = new WeakMap();
var $db188477a5aad910$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $db188477a5aad910$var$isUnsupportedLazyRouteObjectKey(key) {
    return $db188477a5aad910$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $db188477a5aad910$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $db188477a5aad910$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $db188477a5aad910$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $db188477a5aad910$var$isIndexRoute(route) {
    return route.index === true;
}
function $db188477a5aad910$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $db188477a5aad910$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $db188477a5aad910$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($db188477a5aad910$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $db188477a5aad910$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $db188477a5aad910$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $db188477a5aad910$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $db188477a5aad910$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $db188477a5aad910$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $db188477a5aad910$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $db188477a5aad910$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let location = typeof locationArg === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $db188477a5aad910$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $db188477a5aad910$var$flattenAndRankRoutes(routes);
    let matches = null;
    let decoded = $db188477a5aad910$var$decodePath(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $db188477a5aad910$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $db188477a5aad910$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $db188477a5aad910$var$flattenAndRankRoutes(routes) {
    let branches = $db188477a5aad910$var$flattenRoutes(routes);
    $db188477a5aad910$var$rankRouteBranches(branches);
    return branches;
}
function $db188477a5aad910$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $db188477a5aad910$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $db188477a5aad910$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $db188477a5aad910$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $db188477a5aad910$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $db188477a5aad910$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta2, i)=>{
                let [matcher, params] = $db188477a5aad910$var$compilePath(meta2.relativePath, meta2.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta2,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $db188477a5aad910$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $db188477a5aad910$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $db188477a5aad910$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $db188477a5aad910$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $db188477a5aad910$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $db188477a5aad910$var$paramRe = /^:[\w-]+$/;
var $db188477a5aad910$var$dynamicSegmentValue = 3;
var $db188477a5aad910$var$indexRouteValue = 2;
var $db188477a5aad910$var$emptySegmentValue = 1;
var $db188477a5aad910$var$staticSegmentValue = 10;
var $db188477a5aad910$var$splatPenalty = -2;
var $db188477a5aad910$var$isSplat = (s)=>s === "*";
function $db188477a5aad910$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($db188477a5aad910$var$isSplat)) initialScore += $db188477a5aad910$var$splatPenalty;
    if (index) initialScore += $db188477a5aad910$var$indexRouteValue;
    return segments.filter((s)=>!$db188477a5aad910$var$isSplat(s)).reduce((score, segment)=>score + ($db188477a5aad910$var$paramRe.test(segment) ? $db188477a5aad910$var$dynamicSegmentValue : segment === "" ? $db188477a5aad910$var$emptySegmentValue : $db188477a5aad910$var$staticSegmentValue), initialScore);
}
function $db188477a5aad910$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $db188477a5aad910$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = // Use precomputed matcher if it exists
        meta.matcher && meta.compiledParams ? $db188477a5aad910$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $db188477a5aad910$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $db188477a5aad910$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $db188477a5aad910$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $db188477a5aad910$var$normalizePathname($db188477a5aad910$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $db188477a5aad910$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $db188477a5aad910$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $db188477a5aad910$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") return stringify2(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $db188477a5aad910$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $db188477a5aad910$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $db188477a5aad910$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    return $db188477a5aad910$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $db188477a5aad910$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $db188477a5aad910$var$compilePath(path, caseSensitive = false, end = true) {
    $db188477a5aad910$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $db188477a5aad910$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $db188477a5aad910$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $db188477a5aad910$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $db188477a5aad910$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $db188477a5aad910$var$joinPaths([
        basename,
        pathname
    ]);
}
var $db188477a5aad910$var$isAbsoluteUrl = (url)=>$db188477a5aad910$var$ABSOLUTE_URL_REGEX.test(url);
function $db188477a5aad910$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $db188477a5aad910$var$removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/")) pathname = $db188477a5aad910$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $db188477a5aad910$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $db188477a5aad910$var$normalizeSearch(search),
        hash: $db188477a5aad910$var$normalizeHash(hash)
    };
}
function $db188477a5aad910$var$resolvePathname(relativePath, fromPathname) {
    let segments = $db188477a5aad910$var$removeTrailingSlash(fromPathname).split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $db188477a5aad910$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $db188477a5aad910$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $db188477a5aad910$var$getResolveToMatches(matches) {
    let pathMatches = $db188477a5aad910$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $db188477a5aad910$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $db188477a5aad910$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $db188477a5aad910$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $db188477a5aad910$var$getInvalidPathError("?", "pathname", "search", to));
        $db188477a5aad910$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $db188477a5aad910$var$getInvalidPathError("#", "pathname", "hash", to));
        $db188477a5aad910$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $db188477a5aad910$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $db188477a5aad910$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $db188477a5aad910$var$removeDoubleSlashes = (path)=>path.replace(/[\\/]{2,}/g, "/");
var $db188477a5aad910$var$joinPaths = (paths)=>$db188477a5aad910$var$removeDoubleSlashes(paths.join("/"));
var $db188477a5aad910$var$removeTrailingSlash = (path)=>path.replace(/\/+$/, "");
var $db188477a5aad910$var$normalizePathname = (pathname)=>$db188477a5aad910$var$removeTrailingSlash(pathname).replace(/^\/*/, "/");
var $db188477a5aad910$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $db188477a5aad910$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $db188477a5aad910$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $db188477a5aad910$export$4051a07651545597(data2, init) {
    return new $db188477a5aad910$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $db188477a5aad910$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $db188477a5aad910$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $db188477a5aad910$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $db188477a5aad910$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $db188477a5aad910$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $db188477a5aad910$var$SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $db188477a5aad910$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $db188477a5aad910$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $db188477a5aad910$var$getRoutePattern(matches) {
    let parts = matches.map((m)=>m.route.path).filter(Boolean);
    return $db188477a5aad910$var$joinPaths(parts) || "/";
}
var $db188477a5aad910$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $db188477a5aad910$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$db188477a5aad910$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($db188477a5aad910$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = $db188477a5aad910$export$825a82322d91916e.test(to) ? new URL($db188477a5aad910$var$normalizeProtocolRelativeUrl(to, currentUrl.protocol)) : new URL(to);
        let path = $db188477a5aad910$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $db188477a5aad910$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $db188477a5aad910$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $db188477a5aad910$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $db188477a5aad910$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $db188477a5aad910$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$db188477a5aad910$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $db188477a5aad910$var$wrapImpl(aggregated[key], original, (...args)=>$db188477a5aad910$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$db188477a5aad910$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$db188477a5aad910$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $db188477a5aad910$var$wrapImpl(aggregated.middleware, original, (...args)=>$db188477a5aad910$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$db188477a5aad910$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $db188477a5aad910$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$db188477a5aad910$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $db188477a5aad910$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $db188477a5aad910$export$fe53371bee54353d(to) : ".",
                ...$db188477a5aad910$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$db188477a5aad910$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$db188477a5aad910$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $db188477a5aad910$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$db188477a5aad910$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$db188477a5aad910$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $db188477a5aad910$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $db188477a5aad910$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $db188477a5aad910$var$getReadonlyRequest(request),
            context: context != null ? $db188477a5aad910$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $db188477a5aad910$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $db188477a5aad910$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $db188477a5aad910$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $db188477a5aad910$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $db188477a5aad910$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $db188477a5aad910$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, pattern: pattern } = args;
    return {
        request: $db188477a5aad910$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        pattern: pattern,
        context: $db188477a5aad910$var$getReadonlyContext(context)
    };
}
function $db188477a5aad910$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $db188477a5aad910$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $db188477a5aad910$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $db188477a5aad910$var$getReadonlyContext(context) {
    if ($db188477a5aad910$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $db188477a5aad910$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $db188477a5aad910$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $db188477a5aad910$var$objectProtoNames;
}
// lib/router/router.ts
var $db188477a5aad910$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $db188477a5aad910$var$validMutationMethods = new Set($db188477a5aad910$var$validMutationMethodsArr);
var $db188477a5aad910$var$validRequestMethodsArr = [
    "GET",
    ...$db188477a5aad910$var$validMutationMethodsArr
];
var $db188477a5aad910$var$validRequestMethods = new Set($db188477a5aad910$var$validRequestMethodsArr);
var $db188477a5aad910$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $db188477a5aad910$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $db188477a5aad910$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $db188477a5aad910$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $db188477a5aad910$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $db188477a5aad910$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $db188477a5aad910$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $db188477a5aad910$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
var $db188477a5aad910$var$_routes, $db188477a5aad910$var$_branches, $db188477a5aad910$var$_hmrRoutes, $db188477a5aad910$var$_hmrBranches;
var $db188477a5aad910$var$DataRoutes = class {
    constructor(routes){
        $db188477a5aad910$var$__privateAdd(this, $db188477a5aad910$var$_routes);
        $db188477a5aad910$var$__privateAdd(this, $db188477a5aad910$var$_branches);
        $db188477a5aad910$var$__privateAdd(this, $db188477a5aad910$var$_hmrRoutes);
        $db188477a5aad910$var$__privateAdd(this, $db188477a5aad910$var$_hmrBranches);
        $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_routes, routes);
        $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_branches, $db188477a5aad910$var$flattenAndRankRoutes(routes));
    }
    /** The stable route tree */ get stableRoutes() {
        return $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_hmrRoutes) ?? $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_routes);
    }
    /** Pre-computed branches */ get branches() {
        return $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_hmrBranches) ?? $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_branches);
    }
    get hasHMRRoutes() {
        return $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_routes, routes);
        $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_branches, $db188477a5aad910$var$flattenAndRankRoutes(routes));
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_hmrRoutes, routes);
        $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_hmrBranches, $db188477a5aad910$var$flattenAndRankRoutes(routes));
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ($db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_hmrRoutes)) {
            $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_routes, $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_hmrRoutes));
            $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_branches, $db188477a5aad910$var$__privateGet(this, $db188477a5aad910$var$_hmrBranches));
            $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_hmrRoutes, void 0);
            $db188477a5aad910$var$__privateSet(this, $db188477a5aad910$var$_hmrBranches, void 0);
        }
    }
};
$db188477a5aad910$var$_routes = new WeakMap();
$db188477a5aad910$var$_branches = new WeakMap();
$db188477a5aad910$var$_hmrRoutes = new WeakMap();
$db188477a5aad910$var$_hmrBranches = new WeakMap();
function $db188477a5aad910$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $db188477a5aad910$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $db188477a5aad910$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$db188477a5aad910$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = new $db188477a5aad910$var$DataRoutes($db188477a5aad910$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest));
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $db188477a5aad910$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $db188477a5aad910$export$5c7b09132f833c25(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $db188477a5aad910$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $db188477a5aad910$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$db188477a5aad910$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $db188477a5aad910$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $db188477a5aad910$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $db188477a5aad910$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $db188477a5aad910$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $db188477a5aad910$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$db188477a5aad910$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $db188477a5aad910$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $db188477a5aad910$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $db188477a5aad910$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $db188477a5aad910$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $db188477a5aad910$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $db188477a5aad910$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $db188477a5aad910$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $db188477a5aad910$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $db188477a5aad910$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $db188477a5aad910$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $db188477a5aad910$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $db188477a5aad910$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $db188477a5aad910$export$5c7b09132f833c25(routesToUse, location, basename, false, dataRoutes.branches);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $db188477a5aad910$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $db188477a5aad910$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $db188477a5aad910$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $db188477a5aad910$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $db188477a5aad910$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $db188477a5aad910$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($db188477a5aad910$var$isErrorResult(result) && $db188477a5aad910$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $db188477a5aad910$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $db188477a5aad910$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$db188477a5aad910$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $db188477a5aad910$var$getSubmittingNavigation(location, matches, historyAction, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $db188477a5aad910$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $db188477a5aad910$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $db188477a5aad910$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $db188477a5aad910$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, location, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($db188477a5aad910$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $db188477a5aad910$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($db188477a5aad910$var$isErrorResult(result)) {
            let boundaryMatch = $db188477a5aad910$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $db188477a5aad910$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $db188477a5aad910$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $db188477a5aad910$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $db188477a5aad910$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = dataRoutes.activeRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $db188477a5aad910$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers2 = new Map(state.fetchers);
            let didUpdateFetcherRedirects2 = markFetchRedirectsDone(workingFetchers2);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $db188477a5aad910$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$db188477a5aad910$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects2 ? {
                    fetchers: workingFetchers2
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $db188477a5aad910$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $db188477a5aad910$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $db188477a5aad910$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$db188477a5aad910$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $db188477a5aad910$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = dataRoutes.activeRoutes;
        let normalizedPath = $db188477a5aad910$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $db188477a5aad910$export$5c7b09132f833c25(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $db188477a5aad910$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $db188477a5aad910$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $db188477a5aad910$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $db188477a5aad910$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $db188477a5aad910$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $db188477a5aad910$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $db188477a5aad910$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $db188477a5aad910$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $db188477a5aad910$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($db188477a5aad910$var$isRedirectResult(actionResult) || $db188477a5aad910$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $db188477a5aad910$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($db188477a5aad910$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $db188477a5aad910$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $db188477a5aad910$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($db188477a5aad910$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $db188477a5aad910$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = dataRoutes.activeRoutes;
        let matches = state.navigation.state !== "idle" ? $db188477a5aad910$export$5c7b09132f833c25(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
        $db188477a5aad910$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $db188477a5aad910$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $db188477a5aad910$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = workingFetchers.get(staleKey);
            let revalidatingFetcher = $db188477a5aad910$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers2 = new Map(s.fetchers);
            workingFetchers2.set(key, $db188477a5aad910$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers2
            };
        };
        let redirect2 = $db188477a5aad910$var$findRedirect(loaderResults);
        if (redirect2) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect2 = $db188477a5aad910$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $db188477a5aad910$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $db188477a5aad910$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $db188477a5aad910$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $db188477a5aad910$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $db188477a5aad910$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $db188477a5aad910$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $db188477a5aad910$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $db188477a5aad910$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, path, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, path, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match2 of matches)if (results[match2.route.id]) {
                result = results[match2.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $db188477a5aad910$var$getDoneFetcher(void 0));
            return;
        }
        if ($db188477a5aad910$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $db188477a5aad910$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($db188477a5aad910$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $db188477a5aad910$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $db188477a5aad910$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $db188477a5aad910$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $db188477a5aad910$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($db188477a5aad910$var$isAbsoluteUrl(location)) {
                const url = $db188477a5aad910$var$createBrowserURLImpl(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $db188477a5aad910$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $db188477a5aad910$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($db188477a5aad910$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $db188477a5aad910$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $db188477a5aad910$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $db188477a5aad910$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$db188477a5aad910$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($db188477a5aad910$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $db188477a5aad910$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $db188477a5aad910$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $db188477a5aad910$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $db188477a5aad910$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $db188477a5aad910$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $db188477a5aad910$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            $db188477a5aad910$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $db188477a5aad910$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            $db188477a5aad910$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            $db188477a5aad910$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $db188477a5aad910$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $db188477a5aad910$export$386d57f03f0b2883;
        $db188477a5aad910$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $db188477a5aad910$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $db188477a5aad910$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $db188477a5aad910$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $db188477a5aad910$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$db188477a5aad910$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            let activeBranches = dataRoutes.branches;
            if (!matches) {
                let fogMatches = $db188477a5aad910$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $db188477a5aad910$export$5c7b09132f833c25(routesToUse, pathname, basename, true, activeBranches);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $db188477a5aad910$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let activeBranches = dataRoutes.branches;
            let newMatches = $db188477a5aad910$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $db188477a5aad910$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $db188477a5aad910$export$5c7b09132f833c25(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes($db188477a5aad910$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $db188477a5aad910$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = $db188477a5aad910$var$instrumentClientSideRouter(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $db188477a5aad910$export$3336b097a6fbc59a(routes, opts) {
    $db188477a5aad910$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $db188477a5aad910$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    let future = {
        ...opts?.future
    };
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$db188477a5aad910$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $db188477a5aad910$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    let routeBranches = $db188477a5aad910$var$flattenAndRankRoutes(dataRoutes);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $db188477a5aad910$var$defaultNormalizePath;
        let method = request.method;
        let location = $db188477a5aad910$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $db188477a5aad910$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $db188477a5aad910$export$b8d3e69d4b3eff04();
        if (!$db188477a5aad910$var$isValidMethod(method) && method !== "HEAD") {
            let error = $db188477a5aad910$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $db188477a5aad910$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $db188477a5aad910$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $db188477a5aad910$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $db188477a5aad910$export$f5708dca728d7177(requestContext instanceof $db188477a5aad910$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $db188477a5aad910$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $db188477a5aad910$var$runServerMiddlewarePipeline({
                    request: request,
                    url: $db188477a5aad910$var$createDataFunctionUrl(request, location),
                    pattern: $db188477a5aad910$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($db188477a5aad910$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($db188477a5aad910$export$6e80290866a84dd4(error)) return error;
                    if ($db188477a5aad910$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $db188477a5aad910$export$f2680fa305b734ca(error.status, error.statusText, await $db188477a5aad910$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($db188477a5aad910$export$e0163cfdf7bc9cfa(error)) error = $db188477a5aad910$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $db188477a5aad910$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $db188477a5aad910$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $db188477a5aad910$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $db188477a5aad910$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $db188477a5aad910$export$f5708dca728d7177($db188477a5aad910$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($db188477a5aad910$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($db188477a5aad910$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $db188477a5aad910$var$defaultNormalizePath;
        let method = request.method;
        let location = $db188477a5aad910$var$createLocation("", normalizePathImpl(request), null, "default");
        let matches = $db188477a5aad910$export$5c7b09132f833c25(dataRoutes, location, basename, false, routeBranches);
        requestContext = requestContext != null ? requestContext : new $db188477a5aad910$export$b8d3e69d4b3eff04();
        if (!$db188477a5aad910$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $db188477a5aad910$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $db188477a5aad910$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $db188477a5aad910$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $db188477a5aad910$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $db188477a5aad910$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $db188477a5aad910$export$f5708dca728d7177(requestContext instanceof $db188477a5aad910$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $db188477a5aad910$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $db188477a5aad910$var$runServerMiddlewarePipeline({
                request: request,
                url: $db188477a5aad910$var$createDataFunctionUrl(request, location),
                pattern: $db188477a5aad910$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $db188477a5aad910$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($db188477a5aad910$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($db188477a5aad910$var$dataWithResponseInitToResponse(error));
                if ($db188477a5aad910$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($db188477a5aad910$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $db188477a5aad910$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($db188477a5aad910$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, location, matches, routeMatch || $db188477a5aad910$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $db188477a5aad910$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($db188477a5aad910$var$isDataStrategyResult(e) && $db188477a5aad910$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($db188477a5aad910$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $db188477a5aad910$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $db188477a5aad910$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($db188477a5aad910$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($db188477a5aad910$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($db188477a5aad910$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $db188477a5aad910$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $db188477a5aad910$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($db188477a5aad910$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $db188477a5aad910$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $db188477a5aad910$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $db188477a5aad910$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $db188477a5aad910$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $db188477a5aad910$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $db188477a5aad910$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, false);
                return $db188477a5aad910$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $db188477a5aad910$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $db188477a5aad910$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $db188477a5aad910$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $db188477a5aad910$var$callDataStrategyImpl(dataStrategy || $db188477a5aad910$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($db188477a5aad910$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $db188477a5aad910$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($db188477a5aad910$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($db188477a5aad910$export$e0163cfdf7bc9cfa(result.result)) throw $db188477a5aad910$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $db188477a5aad910$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
function $db188477a5aad910$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $db188477a5aad910$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $db188477a5aad910$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $db188477a5aad910$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $db188477a5aad910$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $db188477a5aad910$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $db188477a5aad910$var$resolveTo(to ? to : ".", $db188477a5aad910$var$getResolveToMatches(contextualMatches), $db188477a5aad910$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $db188477a5aad910$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $db188477a5aad910$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $db188477a5aad910$export$fe53371bee54353d(path);
}
function $db188477a5aad910$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$db188477a5aad910$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$db188477a5aad910$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $db188477a5aad910$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $db188477a5aad910$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $db188477a5aad910$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$db188477a5aad910$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$db188477a5aad910$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $db188477a5aad910$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $db188477a5aad910$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $db188477a5aad910$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $db188477a5aad910$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $db188477a5aad910$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($db188477a5aad910$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $db188477a5aad910$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $db188477a5aad910$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $db188477a5aad910$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $db188477a5aad910$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $db188477a5aad910$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $db188477a5aad910$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $db188477a5aad910$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$db188477a5aad910$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $db188477a5aad910$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($db188477a5aad910$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $db188477a5aad910$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($db188477a5aad910$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $db188477a5aad910$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $db188477a5aad910$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $db188477a5aad910$export$5c7b09132f833c25(routesToUse, f.path, basename ?? "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $db188477a5aad910$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $db188477a5aad910$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($db188477a5aad910$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $db188477a5aad910$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $db188477a5aad910$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$db188477a5aad910$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $db188477a5aad910$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $db188477a5aad910$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $db188477a5aad910$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $db188477a5aad910$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $db188477a5aad910$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$db188477a5aad910$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $db188477a5aad910$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $db188477a5aad910$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $db188477a5aad910$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$db188477a5aad910$var$isSameRoute(aChild, bChild))) ?? false;
}
var $db188477a5aad910$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $db188477a5aad910$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $db188477a5aad910$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $db188477a5aad910$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $db188477a5aad910$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $db188477a5aad910$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $db188477a5aad910$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $db188477a5aad910$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $db188477a5aad910$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $db188477a5aad910$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $db188477a5aad910$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $db188477a5aad910$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $db188477a5aad910$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $db188477a5aad910$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $db188477a5aad910$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $db188477a5aad910$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $db188477a5aad910$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $db188477a5aad910$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $db188477a5aad910$var$isNonNullable(value) {
    return value !== void 0;
}
function $db188477a5aad910$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $db188477a5aad910$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($db188477a5aad910$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $db188477a5aad910$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $db188477a5aad910$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $db188477a5aad910$var$defaultDataStrategy(args);
    return $db188477a5aad910$var$runClientMiddlewarePipeline(args, ()=>$db188477a5aad910$var$defaultDataStrategy(args));
}
function $db188477a5aad910$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $db188477a5aad910$var$runMiddlewarePipeline(args, handler, processResult, $db188477a5aad910$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $db188477a5aad910$export$e0163cfdf7bc9cfa(result) ? $db188477a5aad910$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $db188477a5aad910$var$runClientMiddlewarePipeline(args, handler) {
    return $db188477a5aad910$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($db188477a5aad910$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $db188477a5aad910$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $db188477a5aad910$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $db188477a5aad910$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $db188477a5aad910$var$callRouteMiddleware(dataFnArgs, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $db188477a5aad910$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $db188477a5aad910$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $db188477a5aad910$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $db188477a5aad910$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $db188477a5aad910$var$loadLazyRoute(match.route, $db188477a5aad910$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $db188477a5aad910$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $db188477a5aad910$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $db188477a5aad910$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $db188477a5aad910$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $db188477a5aad910$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$db188477a5aad910$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($db188477a5aad910$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $db188477a5aad910$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $db188477a5aad910$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $db188477a5aad910$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $db188477a5aad910$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, path, $db188477a5aad910$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $db188477a5aad910$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: $db188477a5aad910$var$createDataFunctionUrl(request, path),
        pattern: $db188477a5aad910$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $db188477a5aad910$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $db188477a5aad910$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $db188477a5aad910$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: $db188477a5aad910$var$createDataFunctionUrl(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $db188477a5aad910$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $db188477a5aad910$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $db188477a5aad910$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $db188477a5aad910$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($db188477a5aad910$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $db188477a5aad910$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $db188477a5aad910$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($db188477a5aad910$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $db188477a5aad910$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $db188477a5aad910$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $db188477a5aad910$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($db188477a5aad910$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $db188477a5aad910$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $db188477a5aad910$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$db188477a5aad910$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $db188477a5aad910$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $db188477a5aad910$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    // eslint-disable-next-line no-script-url
    "javascript:"
];
function $db188477a5aad910$export$961a3ef7a4da3a39(location) {
    try {
        return $db188477a5aad910$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $db188477a5aad910$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ($db188477a5aad910$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = $db188477a5aad910$export$825a82322d91916e.test(normalizedLocation) ? new URL($db188477a5aad910$var$normalizeProtocolRelativeUrl(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($db188477a5aad910$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = $db188477a5aad910$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $db188477a5aad910$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if ($db188477a5aad910$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $db188477a5aad910$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($db188477a5aad910$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $db188477a5aad910$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $db188477a5aad910$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $db188477a5aad910$var$createDataFunctionUrl(request, path) {
    let url = new URL(request.url);
    let parsed = typeof path === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        url.search = searchParams.size ? `?${searchParams.toString()}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
function $db188477a5aad910$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $db188477a5aad910$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $db188477a5aad910$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $db188477a5aad910$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $db188477a5aad910$export$f5708dca728d7177(!$db188477a5aad910$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($db188477a5aad910$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $db188477a5aad910$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $db188477a5aad910$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $db188477a5aad910$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $db188477a5aad910$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $db188477a5aad910$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $db188477a5aad910$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($db188477a5aad910$var$isErrorResult(result)) {
            let boundaryMatch = $db188477a5aad910$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($db188477a5aad910$var$isRedirectResult(result)) $db188477a5aad910$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $db188477a5aad910$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $db188477a5aad910$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $db188477a5aad910$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $db188477a5aad910$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $db188477a5aad910$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $db188477a5aad910$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $db188477a5aad910$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $db188477a5aad910$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $db188477a5aad910$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $db188477a5aad910$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($db188477a5aad910$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $db188477a5aad910$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(path) : path;
    return $db188477a5aad910$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $db188477a5aad910$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $db188477a5aad910$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $db188477a5aad910$var$dataWithResponseInitToErrorResponse(data2) {
    return new $db188477a5aad910$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $db188477a5aad910$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $db188477a5aad910$var$isDataStrategyResult(value));
}
function $db188477a5aad910$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $db188477a5aad910$var$isRedirectDataStrategyResult(result) {
    return $db188477a5aad910$export$3f1eb41d9a6a6a27(result.result) && $db188477a5aad910$var$redirectStatusCodes.has(result.result.status);
}
function $db188477a5aad910$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $db188477a5aad910$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $db188477a5aad910$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $db188477a5aad910$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $db188477a5aad910$export$794b2760043cf8cd(statusCode) {
    return $db188477a5aad910$var$redirectStatusCodes.has(statusCode);
}
function $db188477a5aad910$export$6e80290866a84dd4(result) {
    return $db188477a5aad910$export$3f1eb41d9a6a6a27(result) && $db188477a5aad910$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $db188477a5aad910$var$isValidMethod(method) {
    return $db188477a5aad910$var$validRequestMethods.has(method.toUpperCase());
}
function $db188477a5aad910$export$cbae47800eb95bc3(method) {
    return $db188477a5aad910$var$validMutationMethods.has(method.toUpperCase());
}
function $db188477a5aad910$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $db188477a5aad910$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $db188477a5aad910$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $db188477a5aad910$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $db188477a5aad910$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $db188477a5aad910$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            matches: matches,
            historyAction: historyAction,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $db188477a5aad910$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $db188477a5aad910$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $db188477a5aad910$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $db188477a5aad910$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $db188477a5aad910$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($db188477a5aad910$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $db188477a5aad910$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($db188477a5aad910$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $db188477a5aad910$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $db188477a5aad910$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $db188477a5aad910$export$2eeee58951ff3c1c = $3lE4N.createContext(null);
$db188477a5aad910$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $db188477a5aad910$export$315e3ffb01f217 = $3lE4N.createContext(null);
$db188477a5aad910$export$315e3ffb01f217.displayName = "DataRouterState";
var $db188477a5aad910$export$717f757c655223f1 = $3lE4N.createContext(false);
function $db188477a5aad910$var$useIsRSCRouterContext() {
    return $jmWak.useContext($db188477a5aad910$export$717f757c655223f1);
}
var $db188477a5aad910$export$3681f408decb40d1 = $3lE4N.createContext({
    isTransitioning: false
});
$db188477a5aad910$export$3681f408decb40d1.displayName = "ViewTransition";
var $db188477a5aad910$export$cb3f1df1bef00a39 = $3lE4N.createContext(/* @__PURE__ */ new Map());
$db188477a5aad910$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $db188477a5aad910$var$AwaitContext = $3lE4N.createContext(null);
$db188477a5aad910$var$AwaitContext.displayName = "Await";
var $db188477a5aad910$export$2666c20e15407622 = (props)=>$3lE4N.createElement($db188477a5aad910$var$AwaitContext.Provider, props);
var $db188477a5aad910$export$3044ab7fdabeaee6 = $3lE4N.createContext(null);
$db188477a5aad910$export$3044ab7fdabeaee6.displayName = "Navigation";
var $db188477a5aad910$export$e6a44b110a0c44d3 = $3lE4N.createContext(null);
$db188477a5aad910$export$e6a44b110a0c44d3.displayName = "Location";
var $db188477a5aad910$export$aac280ed165a4397 = $3lE4N.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$db188477a5aad910$export$aac280ed165a4397.displayName = "Route";
var $db188477a5aad910$var$RouteErrorContext = $3lE4N.createContext(null);
$db188477a5aad910$var$RouteErrorContext.displayName = "RouteError";
var $db188477a5aad910$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $db188477a5aad910$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $db188477a5aad910$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $db188477a5aad910$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $db188477a5aad910$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$db188477a5aad910$var$ERROR_DIGEST_BASE}:${$db188477a5aad910$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $db188477a5aad910$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$db188477a5aad910$var$ERROR_DIGEST_BASE}:${$db188477a5aad910$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $db188477a5aad910$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $db188477a5aad910$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $db188477a5aad910$export$f5708dca728d7177($db188477a5aad910$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $db188477a5aad910$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $db188477a5aad910$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $db188477a5aad910$export$9c954a9d03d32f4a() {
    return $jmWak.useContext($db188477a5aad910$export$e6a44b110a0c44d3) != null;
}
function $db188477a5aad910$export$45d76561a5302f2b() {
    $db188477a5aad910$export$f5708dca728d7177($db188477a5aad910$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $jmWak.useContext($db188477a5aad910$export$e6a44b110a0c44d3).location;
}
function $db188477a5aad910$export$1b3f31771c5d07c() {
    return $jmWak.useContext($db188477a5aad910$export$e6a44b110a0c44d3).navigationType;
}
function $db188477a5aad910$export$6c330e8992e8a295(pattern) {
    $db188477a5aad910$export$f5708dca728d7177($db188477a5aad910$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $db188477a5aad910$export$45d76561a5302f2b();
    return $jmWak.useMemo(()=>$db188477a5aad910$export$81336c211d5ff295(pattern, $db188477a5aad910$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $db188477a5aad910$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $db188477a5aad910$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6).static;
    if (!isStatic) $jmWak.useLayoutEffect(cb);
}
function $db188477a5aad910$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397);
    return isDataRoute ? $db188477a5aad910$var$useNavigateStable() : $db188477a5aad910$var$useNavigateUnstable();
}
function $db188477a5aad910$var$useNavigateUnstable() {
    $db188477a5aad910$export$f5708dca728d7177($db188477a5aad910$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $jmWak.useContext($db188477a5aad910$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let { matches: matches } = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397);
    let { pathname: locationPathname } = $db188477a5aad910$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($db188477a5aad910$var$getResolveToMatches(matches));
    let activeRef = $jmWak.useRef(false);
    $db188477a5aad910$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jmWak.useCallback((to, options = {})=>{
        $db188477a5aad910$var$warning(activeRef.current, $db188477a5aad910$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $db188477a5aad910$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $db188477a5aad910$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $db188477a5aad910$var$OutletContext = $3lE4N.createContext(null);
function $db188477a5aad910$export$4138103a3ae699cc() {
    return $jmWak.useContext($db188477a5aad910$var$OutletContext);
}
function $db188477a5aad910$export$a3be3530d8e40d0b(context) {
    let outlet = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397).outlet;
    return $jmWak.useMemo(()=>outlet && /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $db188477a5aad910$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch?.params ?? {};
}
function $db188477a5aad910$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397);
    let { pathname: locationPathname } = $db188477a5aad910$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($db188477a5aad910$var$getResolveToMatches(matches));
    return $jmWak.useMemo(()=>$db188477a5aad910$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $db188477a5aad910$export$5d3fca4a98652595(routes, locationArg) {
    return $db188477a5aad910$var$useRoutesImpl(routes, locationArg);
}
function $db188477a5aad910$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $db188477a5aad910$export$f5708dca728d7177($db188477a5aad910$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($db188477a5aad910$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $db188477a5aad910$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $db188477a5aad910$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $db188477a5aad910$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $db188477a5aad910$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = dataRouterOpts && dataRouterOpts.state.matches.length ? // If we're in a data router, use the matches we've already identified but ensure
    // we have the latest route instances from the manifest in case elements have changed
    dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        })) : $db188477a5aad910$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($db188477a5aad910$export$945fecf35a8ef089) {
        $db188477a5aad910$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $db188477a5aad910$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $db188477a5aad910$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $db188477a5aad910$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $db188477a5aad910$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `%`, `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $db188477a5aad910$var$DefaultErrorComponent() {
    let error = $db188477a5aad910$export$ed527bf60f6e05f2();
    let message = $db188477a5aad910$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($db188477a5aad910$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, /* @__PURE__ */ $3lE4N.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $3lE4N.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $3lE4N.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $3lE4N.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, /* @__PURE__ */ $3lE4N.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $3lE4N.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $3lE4N.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $db188477a5aad910$var$defaultErrorElement = /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$DefaultErrorComponent, null);
var $db188477a5aad910$var$RenderErrorBoundary = class extends $3lE4N.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $db188477a5aad910$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$db188477a5aad910$var$RenderErrorBoundary.contextType = $db188477a5aad910$export$717f757c655223f1;
var $db188477a5aad910$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $db188477a5aad910$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $db188477a5aad910$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $db188477a5aad910$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $db188477a5aad910$var$parseToInfo(redirect2.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            if ($db188477a5aad910$export$961a3ef7a4da3a39(target)) throw new Error("Invalid redirect location");
            if ($db188477a5aad910$var$isBrowser && !$db188477a5aad910$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $db188477a5aad910$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $3lE4N.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $db188477a5aad910$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $jmWak.useContext($db188477a5aad910$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $db188477a5aad910$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $db188477a5aad910$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: $db188477a5aad910$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $db188477a5aad910$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $db188477a5aad910$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $3lE4N.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $db188477a5aad910$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $db188477a5aad910$var$useDataRouterContext(hookName) {
    let ctx = $jmWak.useContext($db188477a5aad910$export$2eeee58951ff3c1c);
    $db188477a5aad910$export$f5708dca728d7177(ctx, $db188477a5aad910$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $db188477a5aad910$var$useDataRouterState(hookName) {
    let state = $jmWak.useContext($db188477a5aad910$export$315e3ffb01f217);
    $db188477a5aad910$export$f5708dca728d7177(state, $db188477a5aad910$var$getDataRouterConsoleError(hookName));
    return state;
}
function $db188477a5aad910$var$useRouteContext(hookName) {
    let route = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397);
    $db188477a5aad910$export$f5708dca728d7177(route, $db188477a5aad910$var$getDataRouterConsoleError(hookName));
    return route;
}
function $db188477a5aad910$var$useCurrentRouteId(hookName) {
    let route = $db188477a5aad910$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $db188477a5aad910$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $db188477a5aad910$var$useRouteId() {
    return $db188477a5aad910$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $db188477a5aad910$export$d0fd4b7106de2769() {
    let state = $db188477a5aad910$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return $jmWak.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = state.navigation;
        return rest;
    }, [
        state.navigation
    ]);
}
function $db188477a5aad910$export$600dc272ed516c15() {
    let dataRouterContext = $db188477a5aad910$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $db188477a5aad910$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $jmWak.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $jmWak.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $db188477a5aad910$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $db188477a5aad910$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $jmWak.useMemo(()=>matches.map((m)=>$db188477a5aad910$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $db188477a5aad910$export$1448a5050d252c4d() {
    let state = $db188477a5aad910$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $db188477a5aad910$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $db188477a5aad910$export$fd5d37484eab868d(routeId) {
    let state = $db188477a5aad910$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $db188477a5aad910$export$fdc00f3f26066d5e() {
    let state = $db188477a5aad910$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $db188477a5aad910$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $db188477a5aad910$export$ed527bf60f6e05f2() {
    let error = $jmWak.useContext($db188477a5aad910$var$RouteErrorContext);
    let state = $db188477a5aad910$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $db188477a5aad910$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $db188477a5aad910$export$78a72ddb39bdd145() {
    let value = $jmWak.useContext($db188477a5aad910$var$AwaitContext);
    return value?._data;
}
function $db188477a5aad910$export$17f53340677d5831() {
    let value = $jmWak.useContext($db188477a5aad910$var$AwaitContext);
    return value?._error;
}
var $db188477a5aad910$var$blockerId = 0;
function $db188477a5aad910$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $db188477a5aad910$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $db188477a5aad910$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $jmWak.useState("");
    let blockerFunction = $jmWak.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $db188477a5aad910$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $db188477a5aad910$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $jmWak.useEffect(()=>{
        let key = String(++$db188477a5aad910$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $jmWak.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $db188477a5aad910$export$386d57f03f0b2883;
}
function $db188477a5aad910$var$useNavigateStable() {
    let { router: router } = $db188477a5aad910$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $db188477a5aad910$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $jmWak.useRef(false);
    $db188477a5aad910$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jmWak.useCallback(async (to, options = {})=>{
        $db188477a5aad910$var$warning(activeRef.current, $db188477a5aad910$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $db188477a5aad910$var$alreadyWarned = {};
function $db188477a5aad910$var$warningOnce(key, cond, message) {
    if (!cond && !$db188477a5aad910$var$alreadyWarned[key]) {
        $db188477a5aad910$var$alreadyWarned[key] = true;
        $db188477a5aad910$var$warning(false, message);
    }
}
function $db188477a5aad910$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $db188477a5aad910$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $db188477a5aad910$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
function $db188477a5aad910$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
function $db188477a5aad910$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches, navigation: navigation } = $db188477a5aad910$var$useDataRouterState("unstable_useRouterState" /* UseRouterState */ );
    let active = $jmWak.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$db188477a5aad910$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $jmWak.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$db188477a5aad910$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $jmWak.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}
// lib/server-runtime/warnings.ts
var $db188477a5aad910$var$alreadyWarned2 = {};
function $db188477a5aad910$export$5b28268982f175ba(condition, message) {
    if (!condition && !$db188477a5aad910$var$alreadyWarned2[message]) {
        $db188477a5aad910$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $db188477a5aad910$var$USE_OPTIMISTIC = "useOptimistic";
var $db188477a5aad910$var$useOptimisticImpl = $kzd8a[$db188477a5aad910$var$USE_OPTIMISTIC];
var $db188477a5aad910$var$stableUseOptimisticSetter = ()=>void 0;
function $db188477a5aad910$var$useOptimisticSafe(val) {
    if ($db188477a5aad910$var$useOptimisticImpl) return $db188477a5aad910$var$useOptimisticImpl(val);
    else return [
        val,
        $db188477a5aad910$var$stableUseOptimisticSetter
    ];
}
function $db188477a5aad910$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($db188477a5aad910$export$945fecf35a8ef089) {
            if (route.element) $db188477a5aad910$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $kzd8a.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($db188477a5aad910$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $db188477a5aad910$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $kzd8a.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($db188477a5aad910$export$945fecf35a8ef089) {
            if (route.errorElement) $db188477a5aad910$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $kzd8a.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $db188477a5aad910$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $db188477a5aad910$export$f30f7e456d254e83(routes, opts) {
    return $db188477a5aad910$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $db188477a5aad910$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $db188477a5aad910$export$e2fd2c03906469db,
        mapRouteProperties: $db188477a5aad910$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $db188477a5aad910$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $db188477a5aad910$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    let unstable_rsc = $db188477a5aad910$var$useIsRSCRouterContext();
    useTransitions = unstable_rsc || useTransitions;
    let [_state, setStateImpl] = $kzd8a.useState(router.state);
    let [state, setOptimisticState] = $db188477a5aad910$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $kzd8a.useState();
    let [vtContext, setVtContext] = $kzd8a.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $kzd8a.useState();
    let [transition, setTransition] = $kzd8a.useState();
    let [interruption, setInterruption] = $kzd8a.useState();
    let fetcherData = $kzd8a.useRef(/* @__PURE__ */ new Map());
    let setState = $kzd8a.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: $db188477a5aad910$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $db188477a5aad910$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $db188477a5aad910$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $kzd8a.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$db188477a5aad910$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $kzd8a.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $kzd8a.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $db188477a5aad910$var$Deferred());
    }, [
        vtContext
    ]);
    $kzd8a.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $kzd8a.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$db188477a5aad910$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $kzd8a.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $kzd8a.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $kzd8a.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $kzd8a.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $kzd8a.createElement($kzd8a.Fragment, null, /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $db188477a5aad910$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $db188477a5aad910$var$MemoizedDataRoutes = $kzd8a.memo($db188477a5aad910$var$DataRoutes2);
function $db188477a5aad910$var$DataRoutes2({ routes: routes, manifest: manifest, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $db188477a5aad910$var$useRoutesImpl(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $db188477a5aad910$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $kzd8a.useRef();
    if (historyRef.current == null) historyRef.current = $db188477a5aad910$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kzd8a.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kzd8a.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $kzd8a.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $kzd8a.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $db188477a5aad910$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $db188477a5aad910$export$f5708dca728d7177($db188477a5aad910$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $kzd8a.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    $db188477a5aad910$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $kzd8a.useContext($db188477a5aad910$export$aac280ed165a4397);
    let { pathname: locationPathname } = $db188477a5aad910$export$45d76561a5302f2b();
    let navigate = $db188477a5aad910$export$9770f232ac06a008();
    let path = $db188477a5aad910$var$resolveTo(to, $db188477a5aad910$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $kzd8a.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $db188477a5aad910$export$910ae8079b2c2852(props) {
    return $db188477a5aad910$export$a3be3530d8e40d0b(props.context);
}
function $db188477a5aad910$export$e7b0ac011bb776c6(props) {
    $db188477a5aad910$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $db188477a5aad910$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    $db188477a5aad910$export$f5708dca728d7177(!$db188477a5aad910$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $kzd8a.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $db188477a5aad910$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $kzd8a.useMemo(()=>{
        let trailingPathname = $db188477a5aad910$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    $db188477a5aad910$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $db188477a5aad910$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $db188477a5aad910$export$5d3fca4a98652595($db188477a5aad910$export$16da398f5434bdec(children), location);
}
function $db188477a5aad910$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $kzd8a.useContext($db188477a5aad910$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $kzd8a.useContext($db188477a5aad910$export$315e3ffb01f217);
    let onError = $kzd8a.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: $db188477a5aad910$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$var$ResolveAwait, null, children));
}
var $db188477a5aad910$var$AwaitErrorBoundary = class extends $kzd8a.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $kzd8a.createElement($db188477a5aad910$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $db188477a5aad910$var$ResolveAwait({ children: children }) {
    let data2 = $db188477a5aad910$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $kzd8a.createElement($kzd8a.Fragment, null, toRender);
}
function $db188477a5aad910$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $kzd8a.Children.forEach(children, (element, index)=>{
        if (!$kzd8a.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $kzd8a.Fragment) {
            routes.push.apply(routes, $db188477a5aad910$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $db188477a5aad910$export$f5708dca728d7177(element.type === $db188477a5aad910$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $db188477a5aad910$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $db188477a5aad910$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $db188477a5aad910$export$9b5b6d122dea0c88 = $db188477a5aad910$export$16da398f5434bdec;
function $db188477a5aad910$export$daf73786167a7f72(matches) {
    return $db188477a5aad910$var$_renderMatches(matches);
}
function $db188477a5aad910$var$useRouteComponentProps() {
    return {
        params: $db188477a5aad910$export$99eaa27ddbbb95ef(),
        loaderData: $db188477a5aad910$export$1448a5050d252c4d(),
        actionData: $db188477a5aad910$export$fdc00f3f26066d5e(),
        matches: $db188477a5aad910$export$2378eb7f5ff86053()
    };
}
function $db188477a5aad910$export$6c4f3826290c37af({ children: children }) {
    const props = $db188477a5aad910$var$useRouteComponentProps();
    return $kzd8a.cloneElement(children, props);
}
function $db188477a5aad910$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $db188477a5aad910$var$useRouteComponentProps();
        return $kzd8a.createElement(Component4, props);
    };
}
function $db188477a5aad910$var$useHydrateFallbackProps() {
    return {
        params: $db188477a5aad910$export$99eaa27ddbbb95ef(),
        loaderData: $db188477a5aad910$export$1448a5050d252c4d(),
        actionData: $db188477a5aad910$export$fdc00f3f26066d5e()
    };
}
function $db188477a5aad910$export$f8cff34f39c1932a({ children: children }) {
    const props = $db188477a5aad910$var$useHydrateFallbackProps();
    return $kzd8a.cloneElement(children, props);
}
function $db188477a5aad910$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $db188477a5aad910$var$useHydrateFallbackProps();
        return $kzd8a.createElement(HydrateFallback, props);
    };
}
function $db188477a5aad910$var$useErrorBoundaryProps() {
    return {
        params: $db188477a5aad910$export$99eaa27ddbbb95ef(),
        loaderData: $db188477a5aad910$export$1448a5050d252c4d(),
        actionData: $db188477a5aad910$export$fdc00f3f26066d5e(),
        error: $db188477a5aad910$export$ed527bf60f6e05f2()
    };
}
function $db188477a5aad910$export$e5afde5c4b6d747b({ children: children }) {
    const props = $db188477a5aad910$var$useErrorBoundaryProps();
    return $kzd8a.cloneElement(children, props);
}
function $db188477a5aad910$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $db188477a5aad910$var$useErrorBoundaryProps();
        return $kzd8a.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $db188477a5aad910$var$defaultMethod = "get";
var $db188477a5aad910$var$defaultEncType = "application/x-www-form-urlencoded";
function $db188477a5aad910$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $db188477a5aad910$var$isButtonElement(object) {
    return $db188477a5aad910$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $db188477a5aad910$var$isFormElement(object) {
    return $db188477a5aad910$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $db188477a5aad910$var$isInputElement(object) {
    return $db188477a5aad910$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $db188477a5aad910$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $db188477a5aad910$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$db188477a5aad910$var$isModifiedEvent(event);
}
function $db188477a5aad910$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $db188477a5aad910$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $db188477a5aad910$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $db188477a5aad910$var$_formDataSupportsSubmitter = null;
function $db188477a5aad910$var$isFormDataSubmitterSupported() {
    if ($db188477a5aad910$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $db188477a5aad910$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $db188477a5aad910$var$_formDataSupportsSubmitter = true;
    }
    return $db188477a5aad910$var$_formDataSupportsSubmitter;
}
var $db188477a5aad910$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $db188477a5aad910$var$getFormEncType(encType) {
    if (encType != null && !$db188477a5aad910$var$supportedFormEncTypes.has(encType)) {
        $db188477a5aad910$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$db188477a5aad910$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $db188477a5aad910$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($db188477a5aad910$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $db188477a5aad910$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $db188477a5aad910$var$defaultMethod;
        encType = $db188477a5aad910$var$getFormEncType(target.getAttribute("enctype")) || $db188477a5aad910$var$defaultEncType;
        formData = new FormData(target);
    } else if ($db188477a5aad910$var$isButtonElement(target) || $db188477a5aad910$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $db188477a5aad910$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $db188477a5aad910$var$defaultMethod;
        encType = $db188477a5aad910$var$getFormEncType(target.getAttribute("formenctype")) || $db188477a5aad910$var$getFormEncType(form.getAttribute("enctype")) || $db188477a5aad910$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$db188477a5aad910$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($db188477a5aad910$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $db188477a5aad910$var$defaultMethod;
        action = null;
        encType = $db188477a5aad910$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $db188477a5aad910$var$HOLE = -1;
var $db188477a5aad910$var$NAN = -2;
var $db188477a5aad910$var$NEGATIVE_INFINITY = -3;
var $db188477a5aad910$var$NEGATIVE_ZERO = -4;
var $db188477a5aad910$var$NULL = -5;
var $db188477a5aad910$var$POSITIVE_INFINITY = -6;
var $db188477a5aad910$var$UNDEFINED = -7;
var $db188477a5aad910$var$TYPE_BIGINT = "B";
var $db188477a5aad910$var$TYPE_DATE = "D";
var $db188477a5aad910$var$TYPE_ERROR = "E";
var $db188477a5aad910$var$TYPE_MAP = "M";
var $db188477a5aad910$var$TYPE_NULL_OBJECT = "N";
var $db188477a5aad910$var$TYPE_PROMISE = "P";
var $db188477a5aad910$var$TYPE_REGEXP = "R";
var $db188477a5aad910$var$TYPE_SET = "S";
var $db188477a5aad910$var$TYPE_SYMBOL = "Y";
var $db188477a5aad910$var$TYPE_URL = "U";
var $db188477a5aad910$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $db188477a5aad910$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $db188477a5aad910$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
var $db188477a5aad910$var$TIME_LIMIT_MS = 1;
var $db188477a5aad910$var$getNow = ()=>Date.now();
var $db188477a5aad910$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $db188477a5aad910$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $db188477a5aad910$var$UNDEFINED;
    if (input === null) return $db188477a5aad910$var$NULL;
    if (Number.isNaN(input)) return $db188477a5aad910$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $db188477a5aad910$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $db188477a5aad910$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $db188477a5aad910$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $db188477a5aad910$var$stringify.call(this, stack);
    return index;
}
async function $db188477a5aad910$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $db188477a5aad910$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return $db188477a5aad910$var$UNDEFINED;
        if (value === null) return $db188477a5aad910$var$NULL;
        if (Number.isNaN(value)) return $db188477a5aad910$var$NAN;
        if (value === Number.POSITIVE_INFINITY) return $db188477a5aad910$var$POSITIVE_INFINITY;
        if (value === Number.NEGATIVE_INFINITY) return $db188477a5aad910$var$NEGATIVE_INFINITY;
        if (value === 0 && 1 / value < 0) return $db188477a5aad910$var$NEGATIVE_ZERO;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $db188477a5aad910$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $db188477a5aad910$var$TIME_LIMIT_MS) {
            await $db188477a5aad910$var$yieldToMain();
            lastYieldTime = $db188477a5aad910$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["${$db188477a5aad910$var$TYPE_BIGINT}","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["${$db188477a5aad910$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `${$db188477a5aad910$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i2 = 0; i2 < input.length; i2++)result += (i2 ? "," : "") + (i2 in input ? flattenValue(input[i2]) : $db188477a5aad910$var$HOLE);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["${$db188477a5aad910$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["${$db188477a5aad910$var$TYPE_URL}",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["${$db188477a5aad910$var$TYPE_REGEXP}",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["${$db188477a5aad910$var$TYPE_SET}",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["${$db188477a5aad910$var$TYPE_SET}"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["${$db188477a5aad910$var$TYPE_MAP}",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["${$db188477a5aad910$var$TYPE_MAP}"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["${$db188477a5aad910$var$TYPE_PROMISE}",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["${$db188477a5aad910$var$TYPE_ERROR}",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["${$db188477a5aad910$var$TYPE_NULL_OBJECT}",{${partsForObj(input)}}]`;
                        else if ($db188477a5aad910$var$isPlainObject2(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $db188477a5aad910$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $db188477a5aad910$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $db188477a5aad910$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $db188477a5aad910$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $db188477a5aad910$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $db188477a5aad910$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $db188477a5aad910$var$hydrate.call(this, startIndex);
}
function $db188477a5aad910$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $db188477a5aad910$var$UNDEFINED:
                set(void 0);
                continue;
            case $db188477a5aad910$var$NULL:
                set(null);
                continue;
            case $db188477a5aad910$var$NAN:
                set(NaN);
                continue;
            case $db188477a5aad910$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $db188477a5aad910$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $db188477a5aad910$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $db188477a5aad910$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $db188477a5aad910$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $db188477a5aad910$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $db188477a5aad910$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $db188477a5aad910$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $db188477a5aad910$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $db188477a5aad910$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $db188477a5aad910$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $db188477a5aad910$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $db188477a5aad910$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $db188477a5aad910$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $db188477a5aad910$var$globalObj && $db188477a5aad910$var$SUPPORTED_ERROR_TYPES.includes(errorType) && errorType in $db188477a5aad910$var$globalObj && typeof $db188477a5aad910$var$globalObj[errorType] === "function" ? new $db188477a5aad910$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $db188477a5aad910$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $db188477a5aad910$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $db188477a5aad910$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $db188477a5aad910$var$Deferred2();
    const reader = readable.pipeThrough($db188477a5aad910$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $db188477a5aad910$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $db188477a5aad910$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $db188477a5aad910$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $db188477a5aad910$var$unflatten.call(this, line)
    };
}
async function $db188477a5aad910$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $db188477a5aad910$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $db188477a5aad910$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $db188477a5aad910$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $db188477a5aad910$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $db188477a5aad910$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = await $db188477a5aad910$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id2 = await $db188477a5aad910$var$flatten.call(encoder, resolved);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$db188477a5aad910$var$TYPE_PROMISE}${deferredId}:[["${$db188477a5aad910$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$db188477a5aad910$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$db188477a5aad910$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                                const id2 = await $db188477a5aad910$var$flatten.call(encoder, reason);
                                if (Array.isArray(id2)) {
                                    controller.enqueue(textEncoder.encode(`${$db188477a5aad910$var$TYPE_ERROR}${deferredId}:[["${$db188477a5aad910$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$db188477a5aad910$var$TYPE_ERROR}${deferredId}:${id2}
`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`${$db188477a5aad910$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $db188477a5aad910$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $db188477a5aad910$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $db188477a5aad910$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $db188477a5aad910$export$4cf11838cdc2a8a8(html) {
    return html.replace($db188477a5aad910$var$ESCAPE_REGEX, (match)=>$db188477a5aad910$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $db188477a5aad910$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $db188477a5aad910$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $db188477a5aad910$var$SingleFetchNoResultError = class extends Error {
};
var $db188477a5aad910$export$ae9272e641ead836 = 202;
var $db188477a5aad910$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $db188477a5aad910$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $3lE4N.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$db188477a5aad910$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, scriptTag, /* @__PURE__ */ $3lE4N.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, scriptTag, /* @__PURE__ */ $3lE4N.createElement($kzd8a.Suspense, null, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $db188477a5aad910$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $db188477a5aad910$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $db188477a5aad910$var$invariant2(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $db188477a5aad910$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $db188477a5aad910$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $db188477a5aad910$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $db188477a5aad910$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $db188477a5aad910$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $db188477a5aad910$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $db188477a5aad910$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $db188477a5aad910$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $db188477a5aad910$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($db188477a5aad910$export$3f1eb41d9a6a6a27(result.result) || $db188477a5aad910$export$972111febbeef05b(result.result) || $db188477a5aad910$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $db188477a5aad910$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $db188477a5aad910$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $db188477a5aad910$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $db188477a5aad910$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$db188477a5aad910$var$createDeferred2());
    let singleFetchDfd = $db188477a5aad910$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $db188477a5aad910$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $db188477a5aad910$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $db188477a5aad910$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $db188477a5aad910$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $db188477a5aad910$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $db188477a5aad910$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $db188477a5aad910$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $db188477a5aad910$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $db188477a5aad910$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $db188477a5aad910$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $db188477a5aad910$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${$db188477a5aad910$var$removeTrailingSlash(basename)}/_root.${extension}`;
        else url.pathname = `${$db188477a5aad910$var$removeTrailingSlash(url.pathname)}.${extension}`;
    }
    return url;
}
async function $db188477a5aad910$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $db188477a5aad910$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $db188477a5aad910$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $db188477a5aad910$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $db188477a5aad910$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $db188477a5aad910$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($db188477a5aad910$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $db188477a5aad910$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $db188477a5aad910$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($db188477a5aad910$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$db188477a5aad910$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $db188477a5aad910$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $db188477a5aad910$export$4023ad4ecd4126a2(body, global) {
    return $db188477a5aad910$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && $db188477a5aad910$var$SUPPORTED_ERROR_TYPES.includes(name) && name in global && // @ts-expect-error
                    typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $db188477a5aad910$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$db188477a5aad910$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $db188477a5aad910$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $db188477a5aad910$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $db188477a5aad910$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $db188477a5aad910$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $db188477a5aad910$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $db188477a5aad910$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $db188477a5aad910$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $db188477a5aad910$var$getModuleLinkHrefs(matches, manifest);
    return $db188477a5aad910$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $db188477a5aad910$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $db188477a5aad910$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $db188477a5aad910$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($db188477a5aad910$var$prefetchStyleLink));
}
async function $db188477a5aad910$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$db188477a5aad910$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$db188477a5aad910$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$db188477a5aad910$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($db188477a5aad910$var$prefetchStyleLink));
}
async function $db188477a5aad910$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $db188477a5aad910$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $db188477a5aad910$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $db188477a5aad910$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $db188477a5aad910$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $db188477a5aad910$var$dedupeLinkDescriptors(links.flat(1).filter($db188477a5aad910$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $db188477a5aad910$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $db188477a5aad910$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $db188477a5aad910$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $db188477a5aad910$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $db188477a5aad910$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $db188477a5aad910$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$db188477a5aad910$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($db188477a5aad910$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $db188477a5aad910$var$_isPreloadSupported;
function $db188477a5aad910$var$isPreloadSupported() {
    if ($db188477a5aad910$var$_isPreloadSupported !== void 0) return $db188477a5aad910$var$_isPreloadSupported;
    let el = document.createElement("link");
    $db188477a5aad910$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $db188477a5aad910$var$_isPreloadSupported;
}
function $db188477a5aad910$var$RemixRootDefaultHydrateFallback() {
    let { nonce: nonce } = $db188477a5aad910$var$useFrameworkContext();
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $db188477a5aad910$export$945fecf35a8ef089 ? /* @__PURE__ */ $3lE4N.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $db188477a5aad910$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $db188477a5aad910$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $db188477a5aad910$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $db188477a5aad910$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$RemixRootDefaultErrorBoundary, {
            error: $db188477a5aad910$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $3lE4N.createElement(routeModule.Layout, null, /* @__PURE__ */ $3lE4N.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $3lE4N.createElement(routeModule.Layout, null, /* @__PURE__ */ $3lE4N.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $3lE4N.createElement(routeModule.Layout, null, /* @__PURE__ */ $3lE4N.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $db188477a5aad910$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $db188477a5aad910$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $db188477a5aad910$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$db188477a5aad910$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $db188477a5aad910$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $db188477a5aad910$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $db188477a5aad910$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $db188477a5aad910$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $db188477a5aad910$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $db188477a5aad910$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $db188477a5aad910$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $db188477a5aad910$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $db188477a5aad910$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $db188477a5aad910$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $db188477a5aad910$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $db188477a5aad910$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $db188477a5aad910$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$db188477a5aad910$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $db188477a5aad910$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                let result = await prefetchStylesAndCallHandler(async ()=>{
                    $db188477a5aad910$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $db188477a5aad910$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
                return result;
            };
            dataRoute.loader.hydrate = $db188477a5aad910$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $db188477a5aad910$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $db188477a5aad910$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $db188477a5aad910$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $db188477a5aad910$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $db188477a5aad910$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $db188477a5aad910$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $db188477a5aad910$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $db188477a5aad910$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $db188477a5aad910$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $db188477a5aad910$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $db188477a5aad910$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $db188477a5aad910$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $db188477a5aad910$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $db188477a5aad910$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $db188477a5aad910$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $db188477a5aad910$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $db188477a5aad910$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $db188477a5aad910$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $db188477a5aad910$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $db188477a5aad910$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $db188477a5aad910$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $db188477a5aad910$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $db188477a5aad910$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $db188477a5aad910$var$nextPaths = /* @__PURE__ */ new Set();
var $db188477a5aad910$var$discoveredPathsMaxSize = 1e3;
var $db188477a5aad910$var$discoveredPaths = /* @__PURE__ */ new Set();
var $db188477a5aad910$export$b5915cf27fa06b9f = 7680;
function $db188477a5aad910$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $db188477a5aad910$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $db188477a5aad910$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $db188477a5aad910$export$5c7b09132f833c25(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $db188477a5aad910$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$db188477a5aad910$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($db188477a5aad910$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $db188477a5aad910$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $db188477a5aad910$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $db188477a5aad910$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $jmWak.useEffect(()=>{
        if (!$db188477a5aad910$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$db188477a5aad910$var$discoveredPaths.has(pathname)) $db188477a5aad910$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($db188477a5aad910$var$nextPaths.keys()).filter((path)=>{
                if ($db188477a5aad910$var$discoveredPaths.has(path)) {
                    $db188477a5aad910$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $db188477a5aad910$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $db188477a5aad910$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $db188477a5aad910$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : $db188477a5aad910$var$joinPaths([
        basename,
        manifestPath
    ]);
}
var $db188477a5aad910$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $db188477a5aad910$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $db188477a5aad910$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($db188477a5aad910$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $db188477a5aad910$export$b5915cf27fa06b9f) {
        $db188477a5aad910$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($db188477a5aad910$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($db188477a5aad910$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($db188477a5aad910$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$db188477a5aad910$var$addToFifoQueue(p, $db188477a5aad910$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $db188477a5aad910$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $db188477a5aad910$var$addToFifoQueue(path, queue) {
    if (queue.size >= $db188477a5aad910$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $db188477a5aad910$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $db188477a5aad910$var$useDataRouterContext2() {
    let context = $jmWak.useContext($db188477a5aad910$export$2eeee58951ff3c1c);
    $db188477a5aad910$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $db188477a5aad910$var$useDataRouterStateContext() {
    let context = $jmWak.useContext($db188477a5aad910$export$315e3ffb01f217);
    $db188477a5aad910$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $db188477a5aad910$export$208d6a3bc3aa62bd = $3lE4N.createContext(void 0);
$db188477a5aad910$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $db188477a5aad910$var$useFrameworkContext() {
    let context = $jmWak.useContext($db188477a5aad910$export$208d6a3bc3aa62bd);
    $db188477a5aad910$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $db188477a5aad910$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $jmWak.useContext($db188477a5aad910$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $jmWak.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $jmWak.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $jmWak.useRef(null);
    $jmWak.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $jmWak.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $db188477a5aad910$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $db188477a5aad910$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $db188477a5aad910$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $db188477a5aad910$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $db188477a5aad910$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $db188477a5aad910$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $db188477a5aad910$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$db188477a5aad910$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $db188477a5aad910$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $db188477a5aad910$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $db188477a5aad910$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $db188477a5aad910$var$useDataRouterStateContext();
    let matches = $db188477a5aad910$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $jmWak.useMemo(()=>$db188477a5aad910$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $3lE4N.createElement("style", {
        [$db188477a5aad910$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $3lE4N.createElement("link", {
        [$db188477a5aad910$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$db188477a5aad910$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $3lE4N.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $db188477a5aad910$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = $db188477a5aad910$var$useIsRSCRouterContext();
    let { nonce: contextNonce } = $db188477a5aad910$var$useFrameworkContext();
    let { router: router } = $db188477a5aad910$var$useDataRouterContext2();
    let matches = $jmWak.useMemo(()=>$db188477a5aad910$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $db188477a5aad910$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $db188477a5aad910$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $jmWak.useState([]);
    $jmWak.useEffect(()=>{
        let interrupted = false;
        $db188477a5aad910$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $db188477a5aad910$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let { future: future } = $db188477a5aad910$var$useFrameworkContext();
    let { basename: basename } = $db188477a5aad910$var$useDataRouterContext2();
    let dataHrefs = $jmWak.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = $db188477a5aad910$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $3lE4N.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $db188477a5aad910$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $db188477a5aad910$var$useFrameworkContext();
    let { basename: basename } = $db188477a5aad910$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $db188477a5aad910$var$useDataRouterStateContext();
    let newMatchesForData = $jmWak.useMemo(()=>$db188477a5aad910$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $jmWak.useMemo(()=>$db188477a5aad910$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $jmWak.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $db188477a5aad910$export$7b977381851b2c(page, basename, future.v8_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.v8_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $jmWak.useMemo(()=>$db188477a5aad910$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $db188477a5aad910$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $3lE4N.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $3lE4N.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $3lE4N.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $db188477a5aad910$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $db188477a5aad910$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $db188477a5aad910$var$useDataRouterStateContext();
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let _matches = $db188477a5aad910$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$db188477a5aad910$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $3lE4N.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $3lE4N.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $3lE4N.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $3lE4N.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $db188477a5aad910$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $3lE4N.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $db188477a5aad910$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $db188477a5aad910$var$isHydrated = false;
function $db188477a5aad910$export$3be068dde909e563() {
    $db188477a5aad910$var$isHydrated = true;
}
function $db188477a5aad910$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $db188477a5aad910$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $db188477a5aad910$var$useDataRouterContext2();
    let { matches: routerMatches } = $db188477a5aad910$var$useDataRouterStateContext();
    let isRSCRouterContext = $db188477a5aad910$var$useIsRSCRouterContext();
    let enableFogOfWar = $db188477a5aad910$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $db188477a5aad910$var$getActiveMatches(routerMatches, null, isSpaMode);
    $jmWak.useEffect(()=>{
        $db188477a5aad910$export$3be068dde909e563();
    }, []);
    let initialScripts = $jmWak.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $db188477a5aad910$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($db188477a5aad910$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, /* @__PURE__ */ $3lE4N.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $3lE4N.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $db188477a5aad910$var$isHydrated || isRSCRouterContext ? [] : [
        // Dedupe through a Set
        ...new Set(manifest.entry.imports.concat($db188477a5aad910$var$getModuleLinkHrefs(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $db188477a5aad910$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $db188477a5aad910$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $3lE4N.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $3lE4N.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $3lE4N.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $3lE4N.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $db188477a5aad910$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $db188477a5aad910$export$32e57f52df4b6e34 = class extends $3lE4N.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $db188477a5aad910$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = $db188477a5aad910$var$useFrameworkContext();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $3lE4N.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($db188477a5aad910$export$972111febbeef05b(error)) return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $3lE4N.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $db188477a5aad910$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $3lE4N.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $3lE4N.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $db188477a5aad910$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $db188477a5aad910$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $3lE4N.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $3lE4N.createElement("head", null, /* @__PURE__ */ $3lE4N.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $3lE4N.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $3lE4N.createElement("title", null, title)), /* @__PURE__ */ $3lE4N.createElement("body", null, /* @__PURE__ */ $3lE4N.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$ff0bf87698939488, null) : null)));
}
var $db188477a5aad910$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($db188477a5aad910$var$isBrowser2) window.__reactRouterVersion = "7.18.0";
} catch (e) {}
function $db188477a5aad910$export$1f3f55432a00e06d(routes, opts) {
    return $db188477a5aad910$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $db188477a5aad910$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $db188477a5aad910$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $db188477a5aad910$export$9269a41d8c4635e,
        hydrationRouteProperties: $db188477a5aad910$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $db188477a5aad910$export$1ba7ed8a3a7b3765(routes, opts) {
    return $db188477a5aad910$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $db188477a5aad910$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $db188477a5aad910$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $db188477a5aad910$export$9269a41d8c4635e,
        hydrationRouteProperties: $db188477a5aad910$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $db188477a5aad910$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $db188477a5aad910$var$deserializeErrors(state.errors)
    };
    return state;
}
function $db188477a5aad910$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $db188477a5aad910$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (typeof val.__subType === "string" && $db188477a5aad910$var$SUPPORTED_ERROR_TYPES.includes(val.__subType)) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $db188477a5aad910$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $jmWak.useRef();
    if (historyRef.current == null) historyRef.current = $db188477a5aad910$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jmWak.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jmWak.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $kzd8a.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jmWak.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $db188477a5aad910$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window2 }) {
    let historyRef = $jmWak.useRef();
    if (historyRef.current == null) historyRef.current = $db188477a5aad910$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jmWak.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jmWak.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $kzd8a.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jmWak.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
function $db188477a5aad910$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $jmWak.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jmWak.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $kzd8a.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $jmWak.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$db188477a5aad910$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $db188477a5aad910$export$a6c7ac8248d6e38a = $kzd8a.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $db188477a5aad910$var$ABSOLUTE_URL_REGEX.test(to);
    let parsed = $db188477a5aad910$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $db188477a5aad910$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let maskedHref = null;
    if (mask) {
        let resolved = $db188477a5aad910$var$resolveTo(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $db188477a5aad910$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $db188477a5aad910$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $db188477a5aad910$export$67621102c14d847(to, {
        replace: replace2,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $3lE4N.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $db188477a5aad910$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, link, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$db188477a5aad910$export$a6c7ac8248d6e38a.displayName = "Link";
var $db188477a5aad910$export$b0d92dbee9b5b60d = $kzd8a.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $db188477a5aad910$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let routerState = $jmWak.useContext($db188477a5aad910$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $db188477a5aad910$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $db188477a5aad910$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$db188477a5aad910$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $db188477a5aad910$export$a7fed597f4b8afd8 = $kzd8a.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $db188477a5aad910$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let submit = $db188477a5aad910$export$47c85c6e3a081d3();
    let formAction = $db188477a5aad910$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $db188477a5aad910$var$ABSOLUTE_URL_REGEX.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $kzd8a.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $3lE4N.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$db188477a5aad910$export$a7fed597f4b8afd8.displayName = "Form";
function $db188477a5aad910$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $jmWak.useContext($db188477a5aad910$export$208d6a3bc3aa62bd);
    let { basename: basename } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let matches = $db188477a5aad910$export$2378eb7f5ff86053();
    $db188477a5aad910$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $jmWak.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $db188477a5aad910$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $3lE4N.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$db188477a5aad910$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $db188477a5aad910$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$db188477a5aad910$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$db188477a5aad910$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $db188477a5aad910$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $db188477a5aad910$var$useDataRouterContext3(hookName) {
    let ctx = $jmWak.useContext($db188477a5aad910$export$2eeee58951ff3c1c);
    $db188477a5aad910$export$f5708dca728d7177(ctx, $db188477a5aad910$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $db188477a5aad910$var$useDataRouterState2(hookName) {
    let state = $jmWak.useContext($db188477a5aad910$export$315e3ffb01f217);
    $db188477a5aad910$export$f5708dca728d7177(state, $db188477a5aad910$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $db188477a5aad910$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = $db188477a5aad910$export$9770f232ac06a008();
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let path = $db188477a5aad910$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $jmWak.useCallback((event)=>{
        if ($db188477a5aad910$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $db188477a5aad910$export$fe53371bee54353d(location) === $db188477a5aad910$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $kzd8a.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
function $db188477a5aad910$export$f1a78c17382fe22a(defaultInit) {
    $db188477a5aad910$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $jmWak.useRef($db188477a5aad910$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $jmWak.useRef(false);
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let searchParams = $jmWak.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $db188477a5aad910$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $db188477a5aad910$export$9770f232ac06a008();
    let setSearchParams = $jmWak.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $db188477a5aad910$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $db188477a5aad910$var$fetcherId = 0;
var $db188477a5aad910$var$getUniqueFetcherId = ()=>`__${String(++$db188477a5aad910$var$fetcherId)}__`;
function $db188477a5aad910$export$47c85c6e3a081d3() {
    let { router: router } = $db188477a5aad910$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let currentRouteId = $db188477a5aad910$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $jmWak.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $db188477a5aad910$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $db188477a5aad910$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                defaultShouldRevalidate: options.defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $db188477a5aad910$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let routeContext = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397);
    $db188477a5aad910$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$db188477a5aad910$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $db188477a5aad910$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $db188477a5aad910$export$fe53371bee54353d(path);
}
function $db188477a5aad910$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $db188477a5aad910$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $db188477a5aad910$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $jmWak.useContext($db188477a5aad910$export$cb3f1df1bef00a39);
    let route = $jmWak.useContext($db188477a5aad910$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $db188477a5aad910$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $db188477a5aad910$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $db188477a5aad910$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $jmWak.useId();
    let [fetcherKey, setFetcherKey] = $jmWak.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $jmWak.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $jmWak.useCallback(async (href, opts)=>{
        $db188477a5aad910$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $db188477a5aad910$export$47c85c6e3a081d3();
    let submit = $jmWak.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $jmWak.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $jmWak.useMemo(()=>{
        let FetcherForm2 = $kzd8a.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $db188477a5aad910$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $jmWak.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $db188477a5aad910$export$fa996778a3a31087() {
    let state = $db188477a5aad910$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return $jmWak.useMemo(()=>Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        state.fetchers
    ]);
}
var $db188477a5aad910$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $db188477a5aad910$var$savedScrollPositions = {};
function $db188477a5aad910$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $db188477a5aad910$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $db188477a5aad910$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $db188477a5aad910$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $db188477a5aad910$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $jmWak.useContext($db188477a5aad910$export$3044ab7fdabeaee6);
    let location = $db188477a5aad910$export$45d76561a5302f2b();
    let matches = $db188477a5aad910$export$2378eb7f5ff86053();
    let navigation = $db188477a5aad910$export$d0fd4b7106de2769();
    $jmWak.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $db188477a5aad910$var$usePageHide($jmWak.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $db188477a5aad910$var$getScrollRestorationKey(location, matches, basename, getKey);
            $db188477a5aad910$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $db188477a5aad910$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($db188477a5aad910$var$savedScrollPositions));
        } catch (error) {
            $db188477a5aad910$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $jmWak.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $db188477a5aad910$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $db188477a5aad910$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $jmWak.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($db188477a5aad910$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$db188477a5aad910$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $jmWak.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $db188477a5aad910$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $db188477a5aad910$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $jmWak.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $db188477a5aad910$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $jmWak.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $db188477a5aad910$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $db188477a5aad910$export$b273b3273281a049(when);
    $jmWak.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $jmWak.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $db188477a5aad910$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $jmWak.useContext($db188477a5aad910$export$3681f408decb40d1);
    $db188477a5aad910$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $db188477a5aad910$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $db188477a5aad910$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $db188477a5aad910$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $db188477a5aad910$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $db188477a5aad910$export$81336c211d5ff295(path.pathname, nextPath) != null || $db188477a5aad910$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $db188477a5aad910$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $db188477a5aad910$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        mask: void 0
    };
    let staticNavigator = $db188477a5aad910$var$getStatelessNavigator();
    return /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        useTransitions: false
    });
}
function $db188477a5aad910$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $db188477a5aad910$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $db188477a5aad910$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $db188477a5aad910$var$serializeErrors(context.errors)
        };
        let json = $db188477a5aad910$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $3lE4N.createElement($3lE4N.Fragment, null, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        useTransitions: false
    }, /* @__PURE__ */ $3lE4N.createElement($db188477a5aad910$var$DataRoutes2, {
        manifest: router.manifest,
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $3lE4N.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $db188477a5aad910$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($db188477a5aad910$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $db188477a5aad910$var$getStatelessNavigator() {
    return {
        createHref: $db188477a5aad910$var$createHref,
        encodeLocation: $db188477a5aad910$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $db188477a5aad910$export$69163f0b72ec60d9(routes, opts) {
    return $db188477a5aad910$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $db188477a5aad910$export$9269a41d8c4635e
    });
}
function $db188477a5aad910$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $db188477a5aad910$export$87cb1a9238dc3fba(routes, $db188477a5aad910$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                v8_passThroughRequests: false,
                v8_trailingSlashAwareDataRequests: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $db188477a5aad910$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get branches () {
            return opts.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $db188477a5aad910$var$createHref,
        encodeLocation: $db188477a5aad910$var$encodeLocation,
        getFetcher () {
            return $db188477a5aad910$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $db188477a5aad910$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $db188477a5aad910$var$createHref(to) {
    return typeof to === "string" ? to : $db188477a5aad910$export$fe53371bee54353d(to);
}
function $db188477a5aad910$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $db188477a5aad910$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $db188477a5aad910$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}



var $b8df73c80b604f74$exports = {};
var $b8df73c80b604f74$var$$14c85ffeff1ab241$export$fad3c8302a7540c6, $b8df73c80b604f74$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd, $b8df73c80b604f74$var$$14c85ffeff1ab241$export$1a22ace05a045e3f, $b8df73c80b604f74$var$$14c85ffeff1ab241$export$c7aa240077ad8340, $b8df73c80b604f74$var$$14c85ffeff1ab241$export$5add10f2a1e13991, $b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$70443d1bfecdb242, $b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$a025291d1676ce41, $b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$2585081e06ef4cbf, $b8df73c80b604f74$var$$4bfbcb67a3daf664$export$79ffe56a765070d2, $b8df73c80b604f74$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461, $b8df73c80b604f74$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$5c452ff88e35e47d, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$30d389775d7a0f3c, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$896c314ae37c4db9, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$717db1a952ac2d26, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$74fdf2685172213b, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$fb184b623420d9be, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$ec176431609ba4c9, $b8df73c80b604f74$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b, $b8df73c80b604f74$var$$c628d4ba96623bb8$export$1a22ace05a045e3f, $b8df73c80b604f74$var$$c628d4ba96623bb8$export$c7aa240077ad8340;
var $a8a036b4881ec134$export$71511d61b312f219;
"use strict";
var $a834b608fd8da8fd$export$71511d61b312f219;
"use strict";
function $a834b608fd8da8fd$var$_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
$a834b608fd8da8fd$export$71511d61b312f219 = $a834b608fd8da8fd$var$_array_with_holes;


var $4b4c9ea4ac708270$export$71511d61b312f219;
"use strict";
function $4b4c9ea4ac708270$var$_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
$4b4c9ea4ac708270$export$71511d61b312f219 = $4b4c9ea4ac708270$var$_iterable_to_array_limit;


var $6b4a699b9e11976a$export$71511d61b312f219;
"use strict";
function $6b4a699b9e11976a$var$_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$6b4a699b9e11976a$export$71511d61b312f219 = $6b4a699b9e11976a$var$_non_iterable_rest;


var $5117bd7d08faa22e$export$71511d61b312f219;
"use strict";
var $2a7613545d8f3982$export$71511d61b312f219;
"use strict";
function $2a7613545d8f3982$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$2a7613545d8f3982$export$71511d61b312f219 = $2a7613545d8f3982$var$_array_like_to_array;


function $5117bd7d08faa22e$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2a7613545d8f3982$export$71511d61b312f219(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2a7613545d8f3982$export$71511d61b312f219(o, minLen);
}
$5117bd7d08faa22e$export$71511d61b312f219 = $5117bd7d08faa22e$var$_unsupported_iterable_to_array;


function $a8a036b4881ec134$var$_sliced_to_array(arr, i) {
    return $a834b608fd8da8fd$export$71511d61b312f219(arr) || $4b4c9ea4ac708270$export$71511d61b312f219(arr, i) || $5117bd7d08faa22e$export$71511d61b312f219(arr, i) || $6b4a699b9e11976a$export$71511d61b312f219();
}
$a8a036b4881ec134$export$71511d61b312f219 = $a8a036b4881ec134$var$_sliced_to_array;


var $ba6b19be90dbdadc$export$71511d61b312f219;
"use strict";
var $9c4fedc388a957f7$export$71511d61b312f219;
"use strict";

function $9c4fedc388a957f7$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $2a7613545d8f3982$export$71511d61b312f219(arr);
}
$9c4fedc388a957f7$export$71511d61b312f219 = $9c4fedc388a957f7$var$_array_without_holes;


var $28910912223efd18$export$71511d61b312f219;
"use strict";
function $28910912223efd18$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$28910912223efd18$export$71511d61b312f219 = $28910912223efd18$var$_iterable_to_array;


var $248b4d1ae6a99836$export$71511d61b312f219;
"use strict";
function $248b4d1ae6a99836$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$248b4d1ae6a99836$export$71511d61b312f219 = $248b4d1ae6a99836$var$_non_iterable_spread;



function $ba6b19be90dbdadc$var$_to_consumable_array(arr) {
    return $9c4fedc388a957f7$export$71511d61b312f219(arr) || $28910912223efd18$export$71511d61b312f219(arr) || $5117bd7d08faa22e$export$71511d61b312f219(arr) || $248b4d1ae6a99836$export$71511d61b312f219();
}
$ba6b19be90dbdadc$export$71511d61b312f219 = $ba6b19be90dbdadc$var$_to_consumable_array;



var $3lE4N = parcelRequire("3lE4N");

var $0d80fffe6b458f9f$export$71511d61b312f219;
"use strict";
var $3dfa8530dae89ae9$export$71511d61b312f219;
"use strict";
function $3dfa8530dae89ae9$var$_get_prototype_of(o) {
    $3dfa8530dae89ae9$export$71511d61b312f219 = $3dfa8530dae89ae9$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3dfa8530dae89ae9$var$_get_prototype_of(o);
}
$3dfa8530dae89ae9$export$71511d61b312f219 = $3dfa8530dae89ae9$var$_get_prototype_of;


var $cb5e7da2e5b52602$export$71511d61b312f219;
"use strict";
function $cb5e7da2e5b52602$var$_is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($cb5e7da2e5b52602$export$71511d61b312f219 = $cb5e7da2e5b52602$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
$cb5e7da2e5b52602$export$71511d61b312f219 = $cb5e7da2e5b52602$var$_is_native_reflect_construct;


var $02105c9700047b82$export$71511d61b312f219;
"use strict";
var $1b8cdfd06f1369c8$export$71511d61b312f219;
"use strict";
function $1b8cdfd06f1369c8$var$_assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$1b8cdfd06f1369c8$export$71511d61b312f219 = $1b8cdfd06f1369c8$var$_assert_this_initialized;


var $52f9d16dafc91847$export$71511d61b312f219;
"use strict";
function $52f9d16dafc91847$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
$52f9d16dafc91847$export$71511d61b312f219 = $52f9d16dafc91847$var$_type_of;


function $02105c9700047b82$var$_possible_constructor_return(self, call) {
    if (call && ($52f9d16dafc91847$export$71511d61b312f219(call) === "object" || typeof call === "function")) return call;
    return $1b8cdfd06f1369c8$export$71511d61b312f219(self);
}
$02105c9700047b82$export$71511d61b312f219 = $02105c9700047b82$var$_possible_constructor_return;


function $0d80fffe6b458f9f$var$_call_super(_this, derived, args) {
    // Super
    derived = $3dfa8530dae89ae9$export$71511d61b312f219(derived);
    return $02105c9700047b82$export$71511d61b312f219(_this, $cb5e7da2e5b52602$export$71511d61b312f219() ? Reflect.construct(derived, args || [], $3dfa8530dae89ae9$export$71511d61b312f219(_this).constructor) : derived.apply(_this, args));
}
$0d80fffe6b458f9f$export$71511d61b312f219 = $0d80fffe6b458f9f$var$_call_super;


var $d0a0f288ab521cc7$export$71511d61b312f219;
"use strict";
function $d0a0f288ab521cc7$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$d0a0f288ab521cc7$export$71511d61b312f219 = $d0a0f288ab521cc7$var$_class_call_check;


var $30088f375ab7517b$export$71511d61b312f219;
"use strict";
function $30088f375ab7517b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $30088f375ab7517b$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $30088f375ab7517b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $30088f375ab7517b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
$30088f375ab7517b$export$71511d61b312f219 = $30088f375ab7517b$var$_create_class;


var $679f156d83dccf68$export$71511d61b312f219;
"use strict";
var $abf517ec299a8bc5$export$71511d61b312f219;
"use strict";
function $abf517ec299a8bc5$var$_set_prototype_of(o, p) {
    $abf517ec299a8bc5$export$71511d61b312f219 = $abf517ec299a8bc5$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $abf517ec299a8bc5$var$_set_prototype_of(o, p);
}
$abf517ec299a8bc5$export$71511d61b312f219 = $abf517ec299a8bc5$var$_set_prototype_of;


function $679f156d83dccf68$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $abf517ec299a8bc5$export$71511d61b312f219(subClass, superClass);
}
$679f156d83dccf68$export$71511d61b312f219 = $679f156d83dccf68$var$_inherits;


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
var $kzd8a = parcelRequire("kzd8a");
var $fd3df234846bf672$exports = {};
'use strict';
Object.defineProperty($fd3df234846bf672$exports, '__esModule', {
    value: true
});
var $ac5ff8c08e82cc46$exports = {};
'use strict';
Object.defineProperty($ac5ff8c08e82cc46$exports, '__esModule', {
    value: true
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $ac5ff8c08e82cc46$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $ac5ff8c08e82cc46$var$isPlainObject(o) {
    var ctor, prot;
    if ($ac5ff8c08e82cc46$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($ac5ff8c08e82cc46$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}
$ac5ff8c08e82cc46$exports.isPlainObject = $ac5ff8c08e82cc46$var$isPlainObject;



var $kzd8a = parcelRequire("kzd8a");
var $ca1984fb79df8f18$exports = {};
"use strict";
var $ca1984fb79df8f18$var$__assign = $ca1984fb79df8f18$exports && $ca1984fb79df8f18$exports.__assign || function() {
    $ca1984fb79df8f18$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ca1984fb79df8f18$var$__assign.apply(this, arguments);
};
var $ca1984fb79df8f18$var$__spreadArray = $ca1984fb79df8f18$exports && $ca1984fb79df8f18$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($ca1984fb79df8f18$exports, "__esModule", {
    value: true
});
$ca1984fb79df8f18$exports.prettyPrint = void 0;
var $ca1984fb79df8f18$var$seen = [];
/**
 * Check if a value is an object or a function. Keep in mind that array, function, regexp, etc, are objects in JavaScript.
 *
 * @param value the value to check
 * @return true if the value is an object or a function
 */ function $ca1984fb79df8f18$var$isObj(value) {
    var type = typeof value;
    return value !== null && (type === 'object' || type === 'function');
}
/**
 * Check if a value is a regular expression.
 *
 * @param value the value to check
 * @return true if the value is a regular expression
 */ function $ca1984fb79df8f18$var$isRegexp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}
/**
 * Get an array of all of the enumerable symbols for an object.
 *
 * @param object the object to get the enumerable symbols for
 */ function $ca1984fb79df8f18$var$getOwnEnumPropSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter(function(keySymbol) {
        return Object.prototype.propertyIsEnumerable.call(object, keySymbol);
    });
}
/**
 * pretty print an object
 *
 * @param input the object to pretty print
 * @param options the formatting options, transforms, and filters
 * @param pad the padding string
 */ function $ca1984fb79df8f18$var$prettyPrint(input, options, pad) {
    if (pad === void 0) pad = '';
    // sensible option defaults
    var defaultOptions = {
        indent: '\t',
        singleQuotes: true
    };
    var combinedOptions = $ca1984fb79df8f18$var$__assign($ca1984fb79df8f18$var$__assign({}, defaultOptions), options);
    var tokens;
    if (combinedOptions.inlineCharacterLimit === undefined) tokens = {
        newLine: '\n',
        newLineOrSpace: '\n',
        pad: pad,
        indent: pad + combinedOptions.indent
    };
    else tokens = {
        newLine: '@@__PRETTY_PRINT_NEW_LINE__@@',
        newLineOrSpace: '@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@',
        pad: '@@__PRETTY_PRINT_PAD__@@',
        indent: '@@__PRETTY_PRINT_INDENT__@@'
    };
    var expandWhiteSpace = function(string) {
        if (combinedOptions.inlineCharacterLimit === undefined) return string;
        var oneLined = string.replace(new RegExp(tokens.newLine, 'g'), '').replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');
        if (oneLined.length <= combinedOptions.inlineCharacterLimit) return oneLined;
        return string.replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').replace(new RegExp(tokens.pad, 'g'), pad).replace(new RegExp(tokens.indent, 'g'), pad + combinedOptions.indent);
    };
    if ($ca1984fb79df8f18$var$seen.indexOf(input) !== -1) return '"[Circular]"';
    if (input === null || input === undefined || typeof input === 'number' || typeof input === 'boolean' || typeof input === 'function' || typeof input === 'symbol' || $ca1984fb79df8f18$var$isRegexp(input)) return String(input);
    if (input instanceof Date) return "new Date('".concat(input.toISOString(), "')");
    if (Array.isArray(input)) {
        if (input.length === 0) return '[]';
        $ca1984fb79df8f18$var$seen.push(input);
        var ret = '[' + tokens.newLine + input.map(function(el, i) {
            var eol = input.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var value = $ca1984fb79df8f18$var$prettyPrint(el, combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, i, value);
            return tokens.indent + value + eol;
        }).join('') + tokens.pad + ']';
        $ca1984fb79df8f18$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    if ($ca1984fb79df8f18$var$isObj(input)) {
        var objKeys_1 = $ca1984fb79df8f18$var$__spreadArray($ca1984fb79df8f18$var$__spreadArray([], Object.keys(input), true), $ca1984fb79df8f18$var$getOwnEnumPropSymbols(input), true);
        if (combinedOptions.filter) objKeys_1 = objKeys_1.filter(function(el) {
            return combinedOptions.filter && combinedOptions.filter(input, el);
        });
        if (objKeys_1.length === 0) return '{}';
        $ca1984fb79df8f18$var$seen.push(input);
        var ret = '{' + tokens.newLine + objKeys_1.map(function(el, i) {
            var eol = objKeys_1.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var isSymbol = typeof el === 'symbol';
            var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el.toString());
            var key = isSymbol || isClassic ? el : $ca1984fb79df8f18$var$prettyPrint(el, combinedOptions);
            var value = $ca1984fb79df8f18$var$prettyPrint(input[el], combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, el, value);
            return tokens.indent + String(key) + ': ' + value + eol;
        }).join('') + tokens.pad + '}';
        $ca1984fb79df8f18$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    input = String(input).replace(/[\r\n]/g, function(x) {
        return x === '\n' ? '\\n' : '\\r';
    });
    if (!combinedOptions.singleQuotes) {
        input = input.replace(/"/g, '\\"');
        return "\"".concat(input, "\"");
    }
    input = input.replace(/\\?'/g, '\\\'');
    return "'".concat(input, "'");
}
$ca1984fb79df8f18$exports.prettyPrint = $ca1984fb79df8f18$var$prettyPrint;


var $637b44b0ea8c50a4$exports = {};
'use strict';

$637b44b0ea8c50a4$exports = (parcelRequire("36bfA"));


function $fd3df234846bf672$var$_interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
        'default': e
    };
}
function $fd3df234846bf672$var$_interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n["default"] = e;
    return Object.freeze(n);
}
var $fd3df234846bf672$var$React__namespace = /*#__PURE__*/ $fd3df234846bf672$var$_interopNamespace($kzd8a);
var $fd3df234846bf672$var$React__default = /*#__PURE__*/ $fd3df234846bf672$var$_interopDefaultLegacy($kzd8a);
var $fd3df234846bf672$var$spacer = function(times, tabStop) {
    if (times === 0) return '';
    return new Array(times * tabStop).fill(' ').join('');
};
function $fd3df234846bf672$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $fd3df234846bf672$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $fd3df234846bf672$var$_arrayLikeToArray(r);
}
function $fd3df234846bf672$var$_defineProperty(e, r, t) {
    return (r = $fd3df234846bf672$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fd3df234846bf672$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $fd3df234846bf672$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fd3df234846bf672$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd3df234846bf672$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd3df234846bf672$var$ownKeys(Object(t), !0).forEach(function(r) {
            $fd3df234846bf672$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd3df234846bf672$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $fd3df234846bf672$var$_toConsumableArray(r) {
    return $fd3df234846bf672$var$_arrayWithoutHoles(r) || $fd3df234846bf672$var$_iterableToArray(r) || $fd3df234846bf672$var$_unsupportedIterableToArray(r) || $fd3df234846bf672$var$_nonIterableSpread();
}
function $fd3df234846bf672$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $fd3df234846bf672$var$_toPropertyKey(t) {
    var i = $fd3df234846bf672$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fd3df234846bf672$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fd3df234846bf672$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fd3df234846bf672$var$_typeof(o);
}
function $fd3df234846bf672$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fd3df234846bf672$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fd3df234846bf672$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fd3df234846bf672$var$safeSortObject(value, seen) {
    // return non-object value as is
    if (value === null || $fd3df234846bf672$var$_typeof(value) !== 'object') return value;
    // return date and regexp values as is
    if (value instanceof Date || value instanceof RegExp) return value;
    // return react element as is but remove _owner key because it can lead to recursion
    if (/*#__PURE__*/ $fd3df234846bf672$var$React__namespace.isValidElement(value)) {
        var copyObj = $fd3df234846bf672$var$_objectSpread2({}, value);
        delete copyObj._owner;
        return copyObj;
    }
    seen.add(value);
    // make a copy of array with each item passed through the sorting algorithm
    if (Array.isArray(value)) return value.map(function(v) {
        return $fd3df234846bf672$var$safeSortObject(v, seen);
    });
    // make a copy of object with key sorted
    return Object.keys(value).sort().reduce(function(result, key) {
        if (key === 'current' || seen.has(value[key])) // eslint-disable-next-line no-param-reassign
        result[key] = '[Circular]';
        else // eslint-disable-next-line no-param-reassign
        result[key] = $fd3df234846bf672$var$safeSortObject(value[key], seen);
        return result;
    }, {});
}
function $fd3df234846bf672$var$sortObject(value) {
    return $fd3df234846bf672$var$safeSortObject(value, new WeakSet());
}
/* eslint-disable no-use-before-define */ var $fd3df234846bf672$var$createStringTreeNode = function createStringTreeNode(value) {
    return {
        type: 'string',
        value: value
    };
};
var $fd3df234846bf672$var$createNumberTreeNode = function createNumberTreeNode(value) {
    return {
        type: 'number',
        value: value
    };
};
var $fd3df234846bf672$var$createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: defaultProps,
        childrens: childrens
    };
};
var $fd3df234846bf672$var$createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
    return {
        type: 'ReactFragment',
        key: key,
        childrens: childrens
    };
};
var $fd3df234846bf672$var$supportFragment = Boolean($kzd8a.Fragment);
var $fd3df234846bf672$var$getFunctionTypeName = function getFunctionTypeName(functionType) {
    if (!functionType.name || functionType.name === '_default') return 'No Display Name';
    return functionType.name;
};
var $fd3df234846bf672$var$_getWrappedComponentDisplayName = function getWrappedComponentDisplayName(Component) {
    switch(true){
        case Boolean(Component.displayName):
            return Component.displayName;
        case Component.$$typeof === $637b44b0ea8c50a4$exports.Memo:
            return $fd3df234846bf672$var$_getWrappedComponentDisplayName(Component.type);
        case Component.$$typeof === $637b44b0ea8c50a4$exports.ForwardRef:
            return $fd3df234846bf672$var$_getWrappedComponentDisplayName(Component.render);
        default:
            return $fd3df234846bf672$var$getFunctionTypeName(Component);
    }
};
// heavily inspired by:
// https://github.com/facebook/react/blob/3746eaf985dd92f8aa5f5658941d07b6b855e9d9/packages/react-devtools-shared/src/backend/renderer.js#L399-L496
var $fd3df234846bf672$var$getReactElementDisplayName = function getReactElementDisplayName(element) {
    switch(true){
        case typeof element.type === 'string':
            return element.type;
        case typeof element.type === 'function':
            if (element.type.displayName) return element.type.displayName;
            return $fd3df234846bf672$var$getFunctionTypeName(element.type);
        case $637b44b0ea8c50a4$exports.isForwardRef(element):
        case $637b44b0ea8c50a4$exports.isMemo(element):
            return $fd3df234846bf672$var$_getWrappedComponentDisplayName(element.type);
        case $637b44b0ea8c50a4$exports.isContextConsumer(element):
            return "".concat(element.type._context.displayName || 'Context', ".Consumer");
        case $637b44b0ea8c50a4$exports.isContextProvider(element):
            return "".concat(element.type.displayName || 'Context', ".Provider");
        case $637b44b0ea8c50a4$exports.isLazy(element):
            return 'Lazy';
        case $637b44b0ea8c50a4$exports.isProfiler(element):
            return 'Profiler';
        case $637b44b0ea8c50a4$exports.isStrictMode(element):
            return 'StrictMode';
        case $637b44b0ea8c50a4$exports.isSuspense(element):
            return 'Suspense';
        default:
            return 'UnknownElementType';
    }
};
var $fd3df234846bf672$var$noChildren = function noChildren(propsValue, propName) {
    return propName !== 'children';
};
var $fd3df234846bf672$var$onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
    return children !== true && children !== false && children !== null && children !== '';
};
var $fd3df234846bf672$var$filterProps = function filterProps(originalProps, cb) {
    var filteredProps = {};
    Object.keys(originalProps).filter(function(key) {
        return cb(originalProps[key], key);
    }).forEach(function(key) {
        return filteredProps[key] = originalProps[key];
    });
    return filteredProps;
};
var $fd3df234846bf672$var$_parseReactElement = function parseReactElement(element, options) {
    var _options$displayName = options.displayName, displayNameFn = _options$displayName === void 0 ? $fd3df234846bf672$var$getReactElementDisplayName : _options$displayName;
    if (typeof element === 'string') return $fd3df234846bf672$var$createStringTreeNode(element);
    else if (typeof element === 'number') return $fd3df234846bf672$var$createNumberTreeNode(element);
    else if (!/*#__PURE__*/ $fd3df234846bf672$var$React__default["default"].isValidElement(element)) throw new Error("react-element-to-jsx-string: Expected a React.Element, got `".concat($fd3df234846bf672$var$_typeof(element), "`"));
    var displayName = displayNameFn(element);
    var props = $fd3df234846bf672$var$filterProps(element.props, $fd3df234846bf672$var$noChildren);
    var key = element.key;
    if (typeof key === 'string' && key.search(/^\./)) // React automatically add key=".X" when there are some children
    props.key = key;
    var defaultProps = $fd3df234846bf672$var$filterProps(element.type.defaultProps || {}, $fd3df234846bf672$var$noChildren);
    var childrens = $fd3df234846bf672$var$React__default["default"].Children.toArray(element.props.children).filter($fd3df234846bf672$var$onlyMeaningfulChildren).map(function(child) {
        return $fd3df234846bf672$var$_parseReactElement(child, options);
    });
    if ($fd3df234846bf672$var$supportFragment && element.type === $kzd8a.Fragment) return $fd3df234846bf672$var$createReactFragmentTreeNode(key, childrens);
    return $fd3df234846bf672$var$createReactElementTreeNode(displayName, props, defaultProps, childrens);
};
function $fd3df234846bf672$var$noRefCheck() {}
var $fd3df234846bf672$var$inlineFunction = function inlineFunction(fn) {
    return fn.toString().split('\n').map(function(line) {
        return line.trim();
    }).join('');
};
var $fd3df234846bf672$var$preserveFunctionLineBreak = function preserveFunctionLineBreak(fn) {
    return fn.toString();
};
var $fd3df234846bf672$var$defaultFunctionValue = $fd3df234846bf672$var$inlineFunction;
var $fd3df234846bf672$var$formatFunction = function(fn, options) {
    var _options$functionValu = options.functionValue, functionValue = _options$functionValu === void 0 ? $fd3df234846bf672$var$defaultFunctionValue : _options$functionValu, showFunctions = options.showFunctions;
    if (!showFunctions && functionValue === $fd3df234846bf672$var$defaultFunctionValue) return functionValue($fd3df234846bf672$var$noRefCheck);
    return functionValue(fn);
};
var $fd3df234846bf672$var$formatComplexDataStructure = function(value, inline, lvl, options) {
    var normalizedValue = $fd3df234846bf672$var$sortObject(value);
    var stringifiedValue = $ca1984fb79df8f18$exports.prettyPrint(normalizedValue, {
        transform: function transform(currentObj, prop, originalResult) {
            var currentValue = currentObj[prop];
            if (currentValue && /*#__PURE__*/ $kzd8a.isValidElement(currentValue)) return $fd3df234846bf672$var$formatTreeNode($fd3df234846bf672$var$_parseReactElement(currentValue, options), true, lvl, options);
            if (typeof currentValue === 'function') return $fd3df234846bf672$var$formatFunction(currentValue, options);
            return originalResult;
        }
    });
    if (inline) return stringifiedValue.replace(/\s+/g, ' ').replace(/{ /g, '{').replace(/ }/g, '}').replace(/\[ /g, '[').replace(/ ]/g, ']');
    // Replace tabs with spaces, and add necessary indentation in front of each new line
    return stringifiedValue.replace(/\t/g, $fd3df234846bf672$var$spacer(1, options.tabStop)).replace(/\n([^$])/g, "\n".concat($fd3df234846bf672$var$spacer(lvl + 1, options.tabStop), "$1"));
};
var $fd3df234846bf672$var$escape$1 = function escape(s) {
    return s.replace(/"/g, '&quot;');
};
var $fd3df234846bf672$var$formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
    if (typeof propValue === 'number') return "{".concat(String(propValue), "}");
    if (typeof propValue === 'string') return "\"".concat($fd3df234846bf672$var$escape$1(propValue), "\"");
    // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
    // @see: https://flow.org/en/docs/types/primitives/
    // $FlowFixMe: Flow does not support Symbol
    if ($fd3df234846bf672$var$_typeof(propValue) === 'symbol') {
        var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, '$1');
        if (!symbolDescription) return "{Symbol()}";
        return "{Symbol('".concat(symbolDescription, "')}");
    }
    if (typeof propValue === 'function') return "{".concat($fd3df234846bf672$var$formatFunction(propValue, options), "}");
    if (/*#__PURE__*/ $kzd8a.isValidElement(propValue)) return "{".concat($fd3df234846bf672$var$formatTreeNode($fd3df234846bf672$var$_parseReactElement(propValue, options), true, lvl, options), "}");
    if (propValue instanceof Date) {
        if (isNaN(propValue.valueOf())) return "{new Date(NaN)}";
        return "{new Date(\"".concat(propValue.toISOString(), "\")}");
    }
    if ($ac5ff8c08e82cc46$exports.isPlainObject(propValue) || Array.isArray(propValue)) return "{".concat($fd3df234846bf672$var$formatComplexDataStructure(propValue, inline, lvl, options), "}");
    return "{".concat(String(propValue), "}");
};
var $fd3df234846bf672$var$formatProp = function(name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
    if (!hasValue && !hasDefaultValue) throw new Error("The prop \"".concat(name, "\" has no value and no default: could not be formatted"));
    var usedValue = hasValue ? value : defaultValue;
    var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax, tabStop = options.tabStop;
    var formattedPropValue = $fd3df234846bf672$var$formatPropValue(usedValue, inline, lvl, options);
    var attributeFormattedInline = ' ';
    var attributeFormattedMultiline = "\n".concat($fd3df234846bf672$var$spacer(lvl + 1, tabStop));
    var isMultilineAttribute = formattedPropValue.includes('\n');
    if (useBooleanShorthandSyntax && formattedPropValue === '{false}' && !hasDefaultValue) {
        // If a boolean is false and not different from it's default, we do not render the attribute
        attributeFormattedInline = '';
        attributeFormattedMultiline = '';
    } else if (useBooleanShorthandSyntax && formattedPropValue === '{true}') {
        attributeFormattedInline += "".concat(name);
        attributeFormattedMultiline += "".concat(name);
    } else {
        attributeFormattedInline += "".concat(name, "=").concat(formattedPropValue);
        attributeFormattedMultiline += "".concat(name, "=").concat(formattedPropValue);
    }
    return {
        attributeFormattedInline: attributeFormattedInline,
        attributeFormattedMultiline: attributeFormattedMultiline,
        isMultilineAttribute: isMultilineAttribute
    };
};
var $fd3df234846bf672$var$mergeSiblingPlainStringChildrenReducer = function(previousNodes, currentNode) {
    var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
    var previousNode = previousNodes[previousNodes.length - 1];
    if (previousNode && (currentNode.type === 'string' || currentNode.type === 'number') && (previousNode.type === 'string' || previousNode.type === 'number')) nodes.push($fd3df234846bf672$var$createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
    else {
        if (previousNode) nodes.push(previousNode);
        nodes.push(currentNode);
    }
    return nodes;
};
var $fd3df234846bf672$var$isKeyOrRefProps = function isKeyOrRefProps(propName) {
    return [
        'key',
        'ref'
    ].includes(propName);
};
var $fd3df234846bf672$var$sortPropsByNames = function(shouldSortUserProps) {
    return function(props) {
        var haveKeyProp = props.includes('key');
        var haveRefProp = props.includes('ref');
        var userPropsOnly = props.filter(function(oneProp) {
            return !$fd3df234846bf672$var$isKeyOrRefProps(oneProp);
        });
        var sortedProps = shouldSortUserProps ? $fd3df234846bf672$var$_toConsumableArray(userPropsOnly.sort()) // We use basic lexical order
         : $fd3df234846bf672$var$_toConsumableArray(userPropsOnly);
        if (haveRefProp) sortedProps.unshift('ref');
        if (haveKeyProp) sortedProps.unshift('key');
        return sortedProps;
    };
};
function $fd3df234846bf672$var$createPropFilter(props, filter) {
    if (Array.isArray(filter)) return function(key) {
        return filter.indexOf(key) === -1;
    };
    else return function(key) {
        return filter(props[key], key);
    };
}
var $fd3df234846bf672$var$compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
    var tabStop = options.tabStop;
    if (element.type === 'string') return formattedElement.split('\n').map(function(line, offset) {
        if (offset === 0) return line;
        return "".concat($fd3df234846bf672$var$spacer(lvl, tabStop)).concat(line);
    }).join('\n');
    return formattedElement;
};
var $fd3df234846bf672$var$formatOneChildren = function formatOneChildren(inline, lvl, options) {
    return function(element) {
        return $fd3df234846bf672$var$compensateMultilineStringElementIndentation(element, $fd3df234846bf672$var$formatTreeNode(element, inline, lvl, options), inline, lvl, options);
    };
};
var $fd3df234846bf672$var$onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
    return function(propName) {
        var haveDefaultValue = Object.keys(defaultProps).includes(propName);
        return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
    };
};
var $fd3df234846bf672$var$isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
    if (!maxInlineAttributesLineLength) return attributes.length > 1;
    return $fd3df234846bf672$var$spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
};
var $fd3df234846bf672$var$shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
    return ($fd3df234846bf672$var$isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
};
var $fd3df234846bf672$var$formatReactElementNode = function(node, inline, lvl, options) {
    var type = node.type, _node$displayName = node.displayName, displayName = _node$displayName === void 0 ? '' : _node$displayName, childrens = node.childrens, _node$props = node.props, props = _node$props === void 0 ? {} : _node$props, _node$defaultProps = node.defaultProps, defaultProps = _node$defaultProps === void 0 ? {} : _node$defaultProps;
    if (type !== 'ReactElement') throw new Error("The \"formatReactElementNode\" function could only format node of type \"ReactElement\". Given:  ".concat(type));
    var filterProps = options.filterProps, maxInlineAttributesLineLength = options.maxInlineAttributesLineLength, showDefaultProps = options.showDefaultProps, sortProps = options.sortProps, tabStop = options.tabStop;
    var out = "<".concat(displayName);
    var outInlineAttr = out;
    var outMultilineAttr = out;
    var containsMultilineAttr = false;
    var visibleAttributeNames = [];
    var propFilter = $fd3df234846bf672$var$createPropFilter(props, filterProps);
    Object.keys(props).filter(propFilter).filter($fd3df234846bf672$var$onlyPropsWithOriginalValue(defaultProps, props)).forEach(function(propName) {
        return visibleAttributeNames.push(propName);
    });
    Object.keys(defaultProps).filter(propFilter).filter(function() {
        return showDefaultProps;
    }).filter(function(defaultPropName) {
        return !visibleAttributeNames.includes(defaultPropName);
    }).forEach(function(defaultPropName) {
        return visibleAttributeNames.push(defaultPropName);
    });
    var attributes = $fd3df234846bf672$var$sortPropsByNames(sortProps)(visibleAttributeNames);
    attributes.forEach(function(attributeName) {
        var _formatProp = $fd3df234846bf672$var$formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options), attributeFormattedInline = _formatProp.attributeFormattedInline, attributeFormattedMultiline = _formatProp.attributeFormattedMultiline, isMultilineAttribute = _formatProp.isMultilineAttribute;
        if (isMultilineAttribute) containsMultilineAttr = true;
        outInlineAttr += attributeFormattedInline;
        outMultilineAttr += attributeFormattedMultiline;
    });
    outMultilineAttr += "\n".concat($fd3df234846bf672$var$spacer(lvl, tabStop));
    if ($fd3df234846bf672$var$shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) out = outMultilineAttr;
    else out = outInlineAttr;
    if (childrens && childrens.length > 0) {
        var newLvl = lvl + 1;
        out += '>';
        if (!inline) {
            out += '\n';
            out += $fd3df234846bf672$var$spacer(newLvl, tabStop);
        }
        out += childrens.reduce($fd3df234846bf672$var$mergeSiblingPlainStringChildrenReducer, []).map($fd3df234846bf672$var$formatOneChildren(inline, newLvl, options)).join(!inline ? "\n".concat($fd3df234846bf672$var$spacer(newLvl, tabStop)) : '');
        if (!inline) {
            out += '\n';
            out += $fd3df234846bf672$var$spacer(newLvl - 1, tabStop);
        }
        out += "</".concat(displayName, ">");
    } else {
        if (!$fd3df234846bf672$var$isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) out += ' ';
        out += '/>';
    }
    return out;
};
var $fd3df234846bf672$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = '';
var $fd3df234846bf672$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = 'React.Fragment';
var $fd3df234846bf672$var$toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
    var props = {};
    if (key) props = {
        key: key
    };
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: {},
        childrens: childrens
    };
};
var $fd3df234846bf672$var$isKeyedFragment = function isKeyedFragment(_ref) {
    var key = _ref.key;
    return Boolean(key);
};
var $fd3df234846bf672$var$hasNoChildren = function hasNoChildren(_ref2) {
    var childrens = _ref2.childrens;
    return childrens.length === 0;
};
var $fd3df234846bf672$var$formatReactFragmentNode = function(node, inline, lvl, options) {
    var type = node.type, key = node.key, childrens = node.childrens;
    if (type !== 'ReactFragment') throw new Error("The \"formatReactFragmentNode\" function could only format node of type \"ReactFragment\". Given: ".concat(type));
    var useFragmentShortSyntax = options.useFragmentShortSyntax;
    var displayName;
    if (useFragmentShortSyntax) {
        if ($fd3df234846bf672$var$hasNoChildren(node) || $fd3df234846bf672$var$isKeyedFragment(node)) displayName = $fd3df234846bf672$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
        else displayName = $fd3df234846bf672$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
    } else displayName = $fd3df234846bf672$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    return $fd3df234846bf672$var$formatReactElementNode($fd3df234846bf672$var$toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
};
var $fd3df234846bf672$var$jsxStopChars = [
    '<',
    '>',
    '{',
    '}'
];
var $fd3df234846bf672$var$shouldBeEscaped = function shouldBeEscaped(s) {
    return $fd3df234846bf672$var$jsxStopChars.some(function(jsxStopChar) {
        return s.includes(jsxStopChar);
    });
};
var $fd3df234846bf672$var$escape = function escape(s) {
    if (!$fd3df234846bf672$var$shouldBeEscaped(s)) return s;
    return "{`".concat(s, "`}");
};
var $fd3df234846bf672$var$preserveTrailingSpace = function preserveTrailingSpace(s) {
    var result = s;
    if (result.endsWith(' ')) result = result.replace(/^(.*?)(\s+)$/, "$1{'$2'}");
    if (result.startsWith(' ')) result = result.replace(/^(\s+)(.*)$/, "{'$1'}$2");
    return result;
};
var $fd3df234846bf672$var$formatTreeNode = function(node, inline, lvl, options) {
    if (node.type === 'number') return String(node.value);
    if (node.type === 'string') return node.value ? "".concat($fd3df234846bf672$var$preserveTrailingSpace($fd3df234846bf672$var$escape(String(node.value)))) : '';
    if (node.type === 'ReactElement') return $fd3df234846bf672$var$formatReactElementNode(node, inline, lvl, options);
    if (node.type === 'ReactFragment') return $fd3df234846bf672$var$formatReactFragmentNode(node, inline, lvl, options);
    throw new TypeError("Unknow format type \"".concat(node.type, "\""));
};
var $fd3df234846bf672$var$formatTree = function(node, options) {
    return $fd3df234846bf672$var$formatTreeNode(node, false, 0, options);
};
var $fd3df234846bf672$var$reactElementToJsxString = function reactElementToJsxString(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$filterProps = _ref.filterProps, filterProps = _ref$filterProps === void 0 ? [] : _ref$filterProps, _ref$showDefaultProps = _ref.showDefaultProps, showDefaultProps = _ref$showDefaultProps === void 0 ? true : _ref$showDefaultProps, _ref$showFunctions = _ref.showFunctions, showFunctions = _ref$showFunctions === void 0 ? false : _ref$showFunctions, functionValue = _ref.functionValue, _ref$tabStop = _ref.tabStop, tabStop = _ref$tabStop === void 0 ? 2 : _ref$tabStop, _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax, useBooleanShorthandSyntax = _ref$useBooleanShorth === void 0 ? true : _ref$useBooleanShorth, _ref$useFragmentShort = _ref.useFragmentShortSyntax, useFragmentShortSyntax = _ref$useFragmentShort === void 0 ? true : _ref$useFragmentShort, _ref$sortProps = _ref.sortProps, sortProps = _ref$sortProps === void 0 ? true : _ref$sortProps, maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength, displayName = _ref.displayName;
    if (!element) throw new Error('react-element-to-jsx-string: Expected a ReactElement');
    var options = {
        filterProps: filterProps,
        showDefaultProps: showDefaultProps,
        showFunctions: showFunctions,
        functionValue: functionValue,
        tabStop: tabStop,
        useBooleanShorthandSyntax: useBooleanShorthandSyntax,
        useFragmentShortSyntax: useFragmentShortSyntax,
        sortProps: sortProps,
        maxInlineAttributesLineLength: maxInlineAttributesLineLength,
        displayName: displayName
    };
    return $fd3df234846bf672$var$formatTree($fd3df234846bf672$var$_parseReactElement(element, options), options);
};
$fd3df234846bf672$exports["default"] = $fd3df234846bf672$var$reactElementToJsxString;
$fd3df234846bf672$exports.inlineFunction = $fd3df234846bf672$var$inlineFunction;
$fd3df234846bf672$exports.preserveFunctionLineBreak = $fd3df234846bf672$var$preserveFunctionLineBreak;


var $77a3cf6ce43ba174$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $77a3cf6ce43ba174$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $77a3cf6ce43ba174$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($77a3cf6ce43ba174$var$_self);
if ($77a3cf6ce43ba174$exports) $77a3cf6ce43ba174$exports = $77a3cf6ce43ba174$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== 'undefined') $parcel$global.Prism = $77a3cf6ce43ba174$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $77a3cf6ce43ba174$var$Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$77a3cf6ce43ba174$var$Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = $77a3cf6ce43ba174$var$Prism.languages.markup['entity'];
$77a3cf6ce43ba174$var$Prism.languages.markup['doctype'].inside['internal-subset'].inside = $77a3cf6ce43ba174$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$77a3cf6ce43ba174$var$Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty($77a3cf6ce43ba174$var$Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $77a3cf6ce43ba174$var$Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: $77a3cf6ce43ba174$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $77a3cf6ce43ba174$var$Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty($77a3cf6ce43ba174$var$Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $77a3cf6ce43ba174$var$Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: $77a3cf6ce43ba174$var$Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$77a3cf6ce43ba174$var$Prism.languages.html = $77a3cf6ce43ba174$var$Prism.languages.markup;
$77a3cf6ce43ba174$var$Prism.languages.mathml = $77a3cf6ce43ba174$var$Prism.languages.markup;
$77a3cf6ce43ba174$var$Prism.languages.svg = $77a3cf6ce43ba174$var$Prism.languages.markup;
$77a3cf6ce43ba174$var$Prism.languages.xml = $77a3cf6ce43ba174$var$Prism.languages.extend('markup', {});
$77a3cf6ce43ba174$var$Prism.languages.ssml = $77a3cf6ce43ba174$var$Prism.languages.xml;
$77a3cf6ce43ba174$var$Prism.languages.atom = $77a3cf6ce43ba174$var$Prism.languages.xml;
$77a3cf6ce43ba174$var$Prism.languages.rss = $77a3cf6ce43ba174$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})($77a3cf6ce43ba174$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $77a3cf6ce43ba174$var$Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $77a3cf6ce43ba174$var$Prism.languages.javascript = $77a3cf6ce43ba174$var$Prism.languages.extend('clike', {
    'class-name': [
        $77a3cf6ce43ba174$var$Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$77a3cf6ce43ba174$var$Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$77a3cf6ce43ba174$var$Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: $77a3cf6ce43ba174$var$Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $77a3cf6ce43ba174$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $77a3cf6ce43ba174$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $77a3cf6ce43ba174$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $77a3cf6ce43ba174$var$Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$77a3cf6ce43ba174$var$Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $77a3cf6ce43ba174$var$Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
$77a3cf6ce43ba174$var$Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if ($77a3cf6ce43ba174$var$Prism.languages.markup) {
    $77a3cf6ce43ba174$var$Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $77a3cf6ce43ba174$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
$77a3cf6ce43ba174$var$Prism.languages.js = $77a3cf6ce43ba174$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $77a3cf6ce43ba174$var$Prism === 'undefined' || typeof document === 'undefined') return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + ' while fetching file: ' + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        'js': 'javascript',
        'py': 'python',
        'rb': 'ruby',
        'ps1': 'powershell',
        'psm1': 'powershell',
        'sh': 'bash',
        'bat': 'batch',
        'h': 'c',
        'tex': 'latex'
    };
    var STATUS_ATTR = 'data-src-status';
    var STATUS_LOADING = 'loading';
    var STATUS_LOADED = 'loaded';
    var STATUS_FAILED = 'failed';
    var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $77a3cf6ce43ba174$var$Prism.hooks.add('before-highlightall', function(env) {
        env.selector += ', ' + SELECTOR;
    });
    $77a3cf6ce43ba174$var$Prism.hooks.add('before-sanity-check', function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ''; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement('CODE'));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute('data-src');
            var language = env.language;
            if (language === 'none') {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    'none'
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $77a3cf6ce43ba174$var$Prism.util.setLanguage(code, language);
            $77a3cf6ce43ba174$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $77a3cf6ce43ba174$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute('data-range'));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join('\n');
                    // add data-start for line numbers
                    if (!pre.hasAttribute('data-start')) pre.setAttribute('data-start', String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $77a3cf6ce43ba174$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $77a3cf6ce43ba174$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$77a3cf6ce43ba174$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $77a3cf6ce43ba174$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
            logged = true;
        }
        $77a3cf6ce43ba174$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();






!(parcelRequire("bTKq6")), !(parcelRequire("84txe")), !(parcelRequire("8GElt")), (parcelRequire("8KfTK"));
var $863bf07a5aae9b63$export$71511d61b312f219;
"use strict";
var $1a80279b10c0e4e5$export$71511d61b312f219;
"use strict";

function $1a80279b10c0e4e5$var$_super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $3dfa8530dae89ae9$export$71511d61b312f219(object);
        if (object === null) break;
    }
    return object;
}
$1a80279b10c0e4e5$export$71511d61b312f219 = $1a80279b10c0e4e5$var$_super_prop_base;


function $863bf07a5aae9b63$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $863bf07a5aae9b63$export$71511d61b312f219 = $863bf07a5aae9b63$var$_get = Reflect.get;
    else $863bf07a5aae9b63$export$71511d61b312f219 = $863bf07a5aae9b63$var$_get = function get(target, property, receiver) {
        var base = $1a80279b10c0e4e5$export$71511d61b312f219(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $863bf07a5aae9b63$var$_get(target, property, receiver || target);
}
$863bf07a5aae9b63$export$71511d61b312f219 = $863bf07a5aae9b63$var$_get;





var $cF2Ke = parcelRequire("cF2Ke");

var $cF2Ke = parcelRequire("cF2Ke");
parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
var $kzd8a = parcelRequire("kzd8a");

var $cF2Ke = parcelRequire("cF2Ke");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
if (!(0, $jmWak.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $cF2Ke.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $kzd8a = parcelRequire("kzd8a");


var $kzd8a = parcelRequire("kzd8a");

var $cF2Ke = parcelRequire("cF2Ke");
function $aeacd2a809e63611$export$fb2daceae6f5097a(callback) {
    callback();
}
function $aeacd2a809e63611$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $aeacd2a809e63611$export$fb2daceae6f5097a;
    (0, $cF2Ke.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $aeacd2a809e63611$export$13ce1459b9a04b51 = function() {
    return true;
};


var $fa3238937a1e92e6$var$deprecatedMessages = [];
function $fa3238937a1e92e6$export$be38475be17599d(msg) {
    if (!$fa3238937a1e92e6$var$deprecatedMessages.includes(msg)) {
        $fa3238937a1e92e6$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $cF2Ke = parcelRequire("cF2Ke");

var $kzd8a = parcelRequire("kzd8a");

var $cF2Ke = parcelRequire("cF2Ke");
function $39208c98bad070cc$export$ef795f1f307682c7(v) {
    return (0, $cF2Ke.getDependencyTree)(v);
}


var $2ab8bd90440a9feb$var$globalIsUsingStaticRendering = false;
function $2ab8bd90440a9feb$export$5d52eaa7c0f24c9e(enable) {
    $2ab8bd90440a9feb$var$globalIsUsingStaticRendering = enable;
}
function $2ab8bd90440a9feb$export$55979271896d643e() {
    return $2ab8bd90440a9feb$var$globalIsUsingStaticRendering;
}


var $62ec0112afd0ffcb$export$e901ba0ffe10ba41 = 10000;
var $62ec0112afd0ffcb$export$1ae22ce5a82f26b6 = 10000;
var $62ec0112afd0ffcb$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $62ec0112afd0ffcb$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $62ec0112afd0ffcb$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $62ec0112afd0ffcb$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $62ec0112afd0ffcb$export$b7a00d372cedeedd;


var $b1ec1cff75c51112$export$10e8a12fbfd8583c = new (0, $62ec0112afd0ffcb$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $46fcf9584426b9e1$exports = {};
'use strict';

$46fcf9584426b9e1$exports = (parcelRequire("h7SvJ"));


function $095f3d73ed62ffd4$var$createReaction(adm) {
    adm.reaction = new (0, $cF2Ke.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $095f3d73ed62ffd4$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $2ab8bd90440a9feb$export$55979271896d643e)()) return render();
    var admRef = (0, $kzd8a.default).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $b1ec1cff75c51112$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $095f3d73ed62ffd4$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $095f3d73ed62ffd4$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $b1ec1cff75c51112$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, $kzd8a.default).useDebugValue(adm.reaction, (0, $39208c98bad070cc$export$ef795f1f307682c7));
    (0, $46fcf9584426b9e1$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $kzd8a = parcelRequire("kzd8a");


var $d6083d4ec90fe12d$var$_a, $d6083d4ec90fe12d$var$_b;
var $d6083d4ec90fe12d$var$warnObserverOptionsDeprecated = true;
var $d6083d4ec90fe12d$var$warnLegacyContextTypes = true;
var $d6083d4ec90fe12d$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $d6083d4ec90fe12d$var$isFunctionNameConfigurable = ($d6083d4ec90fe12d$var$_b = ($d6083d4ec90fe12d$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $d6083d4ec90fe12d$var$_a === void 0 ? void 0 : $d6083d4ec90fe12d$var$_a.configurable) !== null && $d6083d4ec90fe12d$var$_b !== void 0 ? $d6083d4ec90fe12d$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $d6083d4ec90fe12d$var$ReactForwardRefSymbol = $d6083d4ec90fe12d$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $kzd8a.forwardRef) === "function" && (0, $kzd8a.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $d6083d4ec90fe12d$var$ReactMemoSymbol = $d6083d4ec90fe12d$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $kzd8a.memo) === "function" && (0, $kzd8a.memo)(function(props) {
    return null;
})["$$typeof"];
function $d6083d4ec90fe12d$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($d6083d4ec90fe12d$var$ReactMemoSymbol && baseComponent["$$typeof"] === $d6083d4ec90fe12d$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $2ab8bd90440a9feb$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($d6083d4ec90fe12d$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $d6083d4ec90fe12d$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $095f3d73ed62ffd4$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($d6083d4ec90fe12d$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $kzd8a.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $kzd8a.memo)(observerComponent);
    $d6083d4ec90fe12d$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $d6083d4ec90fe12d$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $d6083d4ec90fe12d$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$d6083d4ec90fe12d$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $01ad0ceb3c33bb00$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $095f3d73ed62ffd4$export$b9c7ecd090a87b14)(component);
}
$01ad0ceb3c33bb00$export$c1cbdee04e18ea8b.displayName = "Observer";
function $01ad0ceb3c33bb00$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $cF2Ke = parcelRequire("cF2Ke");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $0a0d1a245a6fadcb$export$aa207039f277c5f(initializer, annotations) {
    return (0, $jmWak.useState)(function() {
        return (0, $cF2Ke.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $cF2Ke = parcelRequire("cF2Ke");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



var $cF2Ke = parcelRequire("cF2Ke");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $f691b29ef02ec48f$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $jmWak.useState)(function() {
        return (0, $cF2Ke.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $cF2Ke.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $94e517b1f28218e0$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $f691b29ef02ec48f$export$e0ded3646391939c)(current);
    return (0, $jmWak.useState)(function() {
        return (0, $cF2Ke.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $e2270b61d7069fe8$var$_a;
(0, $aeacd2a809e63611$export$294943bbc3c74f4f)((0, $kzd8a.unstable_batchedUpdates));
var $e2270b61d7069fe8$export$469d51fb8d268227 = ($e2270b61d7069fe8$var$_a = (0, $b1ec1cff75c51112$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $e2270b61d7069fe8$var$_a !== void 0 ? $e2270b61d7069fe8$var$_a : function() {};
function $e2270b61d7069fe8$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $095f3d73ed62ffd4$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $e2270b61d7069fe8$export$7613124ee4202834(enable) {
    (0, $2ab8bd90440a9feb$export$5d52eaa7c0f24c9e)(enable);
}


function $5e1e6516101ba9db$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($5e1e6516101ba9db$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$5e1e6516101ba9db$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $5e1e6516101ba9db$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $5e1e6516101ba9db$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $5e1e6516101ba9db$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$5e1e6516101ba9db$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $5e1e6516101ba9db$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $5e1e6516101ba9db$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $5e1e6516101ba9db$var$getMixins(target, methodName) {
    var mixins = target[$5e1e6516101ba9db$var$mobxMixins] = target[$5e1e6516101ba9db$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $5e1e6516101ba9db$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $5e1e6516101ba9db$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $5e1e6516101ba9db$var$wrapper.call.apply($5e1e6516101ba9db$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $5e1e6516101ba9db$var$patch(target, methodName, mixinMethod) {
    var mixins = $5e1e6516101ba9db$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$5e1e6516101ba9db$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $5e1e6516101ba9db$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $5e1e6516101ba9db$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $5e1e6516101ba9db$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$5e1e6516101ba9db$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $5e1e6516101ba9db$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $5e1e6516101ba9db$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $5e1e6516101ba9db$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $5e1e6516101ba9db$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $5e1e6516101ba9db$var$observablePropDescriptors;
function $5e1e6516101ba9db$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$5e1e6516101ba9db$var$administrationSymbol]) != null ? _component$administra : component[$5e1e6516101ba9db$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $5e1e6516101ba9db$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $5e1e6516101ba9db$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$5e1e6516101ba9db$var$isMobXReactObserverSymbol]) {
        var displayName = $5e1e6516101ba9db$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$5e1e6516101ba9db$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $kzd8a.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $5e1e6516101ba9db$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $5e1e6516101ba9db$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $5e1e6516101ba9db$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $2ab8bd90440a9feb$export$55979271896d643e)() ? originalRender : $5e1e6516101ba9db$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $5e1e6516101ba9db$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $b1ec1cff75c51112$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $5e1e6516101ba9db$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $2ab8bd90440a9feb$export$55979271896d643e)()) return;
        var admin = $5e1e6516101ba9db$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $5e1e6516101ba9db$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $5e1e6516101ba9db$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $5e1e6516101ba9db$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $5e1e6516101ba9db$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $b1ec1cff75c51112$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $cF2Ke._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $5e1e6516101ba9db$var$createReaction(admin) {
    return new (0, $cF2Ke.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $5e1e6516101ba9db$var$observerSCU(nextProps, nextState) {
    if ((0, $2ab8bd90440a9feb$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$5e1e6516101ba9db$var$shallowEqual(this.props, nextProps);
}
function $5e1e6516101ba9db$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $5e1e6516101ba9db$var$getAdministration(this);
            var derivation = (0, $cF2Ke._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error("[mobx-react] Cannot read \"" + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $5e1e6516101ba9db$var$getAdministration(this)[key] = value;
        }
    };
}
function $5e1e6516101ba9db$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $3lE4N.Component), component) || Object.prototype.isPrototypeOf.call((0, $kzd8a.PureComponent), component)) // Class component
    return $5e1e6516101ba9db$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $d6083d4ec90fe12d$export$b6ae1bc530f4c149)(component);
}
function $5e1e6516101ba9db$var$_extends() {
    return $5e1e6516101ba9db$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e1e6516101ba9db$var$_extends.apply(null, arguments);
}
function $5e1e6516101ba9db$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $5e1e6516101ba9db$var$_excluded = [
    "children"
];
var $5e1e6516101ba9db$export$f07786cea590ef31 = /*#__PURE__*/ (0, $kzd8a.default).createContext({});
function $5e1e6516101ba9db$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $5e1e6516101ba9db$var$_objectWithoutPropertiesLoose(props, $5e1e6516101ba9db$var$_excluded);
    var parentValue = (0, $kzd8a.default).useContext($5e1e6516101ba9db$export$f07786cea590ef31);
    var mutableProviderRef = (0, $kzd8a.default).useRef($5e1e6516101ba9db$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, $kzd8a.default).createElement($5e1e6516101ba9db$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$5e1e6516101ba9db$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $5e1e6516101ba9db$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, $kzd8a.default).forwardRef(function(props, ref) {
        var newProps = $5e1e6516101ba9db$var$_extends({}, props);
        var context = (0, $kzd8a.default).useContext($5e1e6516101ba9db$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, $kzd8a.default).createElement(component, newProps);
    });
    if (makeReactive) Injector = $5e1e6516101ba9db$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $5e1e6516101ba9db$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $5e1e6516101ba9db$var$getInjectName(component, injectNames);
    return Injector;
}
function $5e1e6516101ba9db$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $5e1e6516101ba9db$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $5e1e6516101ba9db$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $5e1e6516101ba9db$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $5e1e6516101ba9db$var$createStoreInjector($5e1e6516101ba9db$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $5e1e6516101ba9db$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt((0, $kzd8a.default).version, 10);
var $5e1e6516101ba9db$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $5e1e6516101ba9db$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $5e1e6516101ba9db$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $5e1e6516101ba9db$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$5e1e6516101ba9db$var$protoStoreKey] || [], this[$5e1e6516101ba9db$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $5e1e6516101ba9db$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $5e1e6516101ba9db$export$4e749cb731da87a9(target, fn);
    });
    if (!$5e1e6516101ba9db$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($5e1e6516101ba9db$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $5e1e6516101ba9db$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, $kzd8a.default).Component || c === (0, $kzd8a.default).PureComponent || c2 === (0, $kzd8a.default).Component || c2 === (0, $kzd8a.default).PureComponent || c3 === (0, $kzd8a.default).Component || c3 === (0, $kzd8a.default).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$5e1e6516101ba9db$var$protoStoreKey] || !!target[$5e1e6516101ba9db$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$5e1e6516101ba9db$var$protoStoreKey] || (target[$5e1e6516101ba9db$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$5e1e6516101ba9db$var$instStoreKey] || (target[$5e1e6516101ba9db$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $5e1e6516101ba9db$var$patch(target, "componentWillUnmount", $5e1e6516101ba9db$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $5e1e6516101ba9db$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $cF2Ke.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $5e1e6516101ba9db$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $5e1e6516101ba9db$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($5e1e6516101ba9db$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $5e1e6516101ba9db$var$getPreciseType(propValue) {
    var propType = $5e1e6516101ba9db$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $5e1e6516101ba9db$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $5e1e6516101ba9db$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $cF2Ke.untracked)(function() {
            if (allowNativeType) {
                if ($5e1e6516101ba9db$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $cF2Ke.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $cF2Ke.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $cF2Ke.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $5e1e6516101ba9db$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $5e1e6516101ba9db$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $5e1e6516101ba9db$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $cF2Ke.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $5e1e6516101ba9db$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $5e1e6516101ba9db$var$observableArray = /*#__PURE__*/ $5e1e6516101ba9db$var$createObservableTypeCheckerCreator(false, "Array");
var $5e1e6516101ba9db$var$observableArrayOf = /*#__PURE__*/ $5e1e6516101ba9db$var$createObservableArrayOfTypeChecker.bind(null, false);
var $5e1e6516101ba9db$var$observableMap = /*#__PURE__*/ $5e1e6516101ba9db$var$createObservableTypeCheckerCreator(false, "Map");
var $5e1e6516101ba9db$var$observableObject = /*#__PURE__*/ $5e1e6516101ba9db$var$createObservableTypeCheckerCreator(false, "Object");
var $5e1e6516101ba9db$var$arrayOrObservableArray = /*#__PURE__*/ $5e1e6516101ba9db$var$createObservableTypeCheckerCreator(true, "Array");
var $5e1e6516101ba9db$var$arrayOrObservableArrayOf = /*#__PURE__*/ $5e1e6516101ba9db$var$createObservableArrayOfTypeChecker.bind(null, true);
var $5e1e6516101ba9db$var$objectOrObservableObject = /*#__PURE__*/ $5e1e6516101ba9db$var$createObservableTypeCheckerCreator(true, "Object");
var $5e1e6516101ba9db$export$e0c95a451cd220b7 = {
    observableArray: $5e1e6516101ba9db$var$observableArray,
    observableArrayOf: $5e1e6516101ba9db$var$observableArrayOf,
    observableMap: $5e1e6516101ba9db$var$observableMap,
    observableObject: $5e1e6516101ba9db$var$observableObject,
    arrayOrObservableArray: $5e1e6516101ba9db$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $5e1e6516101ba9db$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $5e1e6516101ba9db$var$objectOrObservableObject
};
if (!(0, $3lE4N.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $cF2Ke.observable)) throw new Error("mobx-react requires mobx to be available");


var $97ddcb8d2dacc617$exports = {};








var $ddVow = parcelRequire("ddVow");

var $cF2Ke = parcelRequire("cF2Ke");
parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");

var $iob0w = parcelRequire("iob0w");
function $97ddcb8d2dacc617$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $97ddcb8d2dacc617$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $97ddcb8d2dacc617$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $97ddcb8d2dacc617$var$$0172b398bee57f0a$exports = {};
$97ddcb8d2dacc617$var$$parcel$export($97ddcb8d2dacc617$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $97ddcb8d2dacc617$var$$parcel$export($97ddcb8d2dacc617$var$$0172b398bee57f0a$exports, "reaction", function() {
    return $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$7203b476385689ae;
}), $97ddcb8d2dacc617$var$$parcel$export($97ddcb8d2dacc617$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$7112c88e033533b8 = function(e, t) {
    return $97ddcb8d2dacc617$var$$parcel$interopDefault($ddVow)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$reactionMap = new WeakMap, $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$7203b476385689ae = function(e) {
    return function(t, r) {
        return (0, r.addInitializer)(function() {
            var r = $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$reactionMap.get(this) || [];
            r.push({
                expression: e,
                effect: t
            }), $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$reactionMap.set(this, r);
        });
    };
}, $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, $, u, f = $3lE4N.Component, d = [], b = [], p = [], v = [], _ = [], h = [];
    return r = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), s.set(e, $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__runInitializers(e, d, e.props)), n.set(e, ($97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__runInitializers(e, b), $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__runInitializers(e, p, e.state))), i.set(e, ($97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__runInitializers(e, v), $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__runInitializers(e, _, e.context))), a.set(e, $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__runInitializers(e, h)), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function() {
                    return $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedState",
                get: function() {
                    return $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function(e) {
                    $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function() {
                    return $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, i, "f");
                },
                set: function(e) {
                    $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, i, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e, t = this;
                    $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, null == (e = $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$reactionMap.get(this)) ? void 0 : e.map(function(e) {
                        var r = e.expression, a = e.effect;
                        return (0, $cF2Ke.reaction)(function(e) {
                            return r(t, e);
                        }, a.bind(t));
                    }), "f");
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    null == (e = $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f")) || e.forEach(function(e) {
                        return e();
                    });
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, r, a) {
                    var s;
                    $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }(f), a = new WeakMap, s = new WeakMap, n = new WeakMap, i = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, l = [
        (e = $cF2Ke.observable).shallow.bind(e)
    ], $ = [
        (c = $cF2Ke.observable).shallow.bind(c)
    ], u = [
        (o = $cF2Ke.observable).shallow.bind(o)
    ], $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedProps" in e;
            },
            get: function(e) {
                return e.observedProps;
            },
            set: function(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, d, b), $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__esDecorate(r, null, $, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedState" in e;
            },
            get: function(e) {
                return e.observedState;
            },
            set: function(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, p, v), $97ddcb8d2dacc617$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedContext" in e;
            },
            get: function(e) {
                return e.observedContext;
            },
            set: function(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, _, h), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $97ddcb8d2dacc617$var$$621b7277d4dc39e9$exports = {};
$97ddcb8d2dacc617$var$$parcel$export($97ddcb8d2dacc617$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $97ddcb8d2dacc617$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $97ddcb8d2dacc617$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], $ = [], u = [];
    return e = function(e) {
        "use strict";
        function n() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, n), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__runInitializers(e, l), (0, $3lE4N.createRef)())
            }), s.set(e, $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__runInitializers(e, $, e.props.defaultValue)), t.set(e, $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__runInitializers(e, u)), r.set(e, void 0), a.set(e, function(t) {
                !(0, $iob0w.isEmpty)(t) && (0, $iob0w.isEmpty)(e.innerValue) && (e.innerValue = t);
            }), Object.defineProperty(e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r, a;
                    return null == (a = (r = e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "object" ? (0, $cF2Ke.toJS)(t) : t);
                }
            }), Object.defineProperty(e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    return e.innerValue = e.props.defaultValue;
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(n, e), (0, $30088f375ab7517b$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function() {
                    return $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function() {
                    var e;
                    return null != (e = this.observedProps.value) ? e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e, s, n = this;
                    $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $cF2Ke.reaction)(function() {
                        return n.observedProps.defaultValue;
                    }, $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $cF2Ke.reaction)(function() {
                        return n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (e = this.ref.current) ? void 0 : e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e, a, s, n;
                    null == (e = $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || e.call(this), $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (n = null == (s = this.ref.current) ? void 0 : s.form) || n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($97ddcb8d2dacc617$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $97ddcb8d2dacc617$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $cF2Ke.observable
    ], i = [
        $cF2Ke.computed
    ], $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "innerValue" in e;
            },
            get: function(e) {
                return e.innerValue;
            },
            set: function(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, $, u), $97ddcb8d2dacc617$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "value" in e;
            },
            get: function(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$97ddcb8d2dacc617$var$$parcel$exportWildcard($97ddcb8d2dacc617$exports, $97ddcb8d2dacc617$var$$0172b398bee57f0a$exports), $97ddcb8d2dacc617$var$$parcel$exportWildcard($97ddcb8d2dacc617$exports, $97ddcb8d2dacc617$var$$621b7277d4dc39e9$exports);



var $iob0w = parcelRequire("iob0w");
var $24e24f69a9339c74$export$71511d61b312f219;
"use strict";
var $b9cbbdd877534a7a$export$71511d61b312f219;
"use strict";


function $b9cbbdd877534a7a$var$_construct(Parent, args, Class) {
    if ($cb5e7da2e5b52602$export$71511d61b312f219()) $b9cbbdd877534a7a$export$71511d61b312f219 = $b9cbbdd877534a7a$var$_construct = Reflect.construct;
    else $b9cbbdd877534a7a$export$71511d61b312f219 = $b9cbbdd877534a7a$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $abf517ec299a8bc5$export$71511d61b312f219(instance, Class.prototype);
        return instance;
    };
    return $b9cbbdd877534a7a$var$_construct.apply(null, arguments);
}
$b9cbbdd877534a7a$export$71511d61b312f219 = $b9cbbdd877534a7a$var$_construct;



var $3418d7c98ec4f303$export$71511d61b312f219;
"use strict";
function $3418d7c98ec4f303$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
$3418d7c98ec4f303$export$71511d61b312f219 = $3418d7c98ec4f303$var$_is_native_function;



function $24e24f69a9339c74$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $24e24f69a9339c74$export$71511d61b312f219 = $24e24f69a9339c74$var$_wrap_native_super = function(Class) {
        if (Class === null || !$3418d7c98ec4f303$export$71511d61b312f219(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $b9cbbdd877534a7a$export$71511d61b312f219(Class, arguments, $3dfa8530dae89ae9$export$71511d61b312f219(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $abf517ec299a8bc5$export$71511d61b312f219(Wrapper, Class);
    };
    return $24e24f69a9339c74$var$_wrap_native_super(Class);
}
$24e24f69a9339c74$export$71511d61b312f219 = $24e24f69a9339c74$var$_wrap_native_super;


function $630535246db4a983$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $630535246db4a983$var$$22de11b45b0eeb97$exports = {};
$630535246db4a983$var$$parcel$export($630535246db4a983$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $630535246db4a983$export$c7e91f8aec23ae14;
});
$630535246db4a983$var$$parcel$export($630535246db4a983$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $630535246db4a983$export$51ca94569b882c51;
});
class $630535246db4a983$export$c7e91f8aec23ae14 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
const $630535246db4a983$export$51ca94569b882c51 = ()=>new $630535246db4a983$export$c7e91f8aec23ae14();
var $630535246db4a983$var$$e3640f413e0c36e7$exports = {};
$630535246db4a983$var$$parcel$export($630535246db4a983$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $630535246db4a983$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
class $630535246db4a983$export$77cea355fa80b5f4 {
    constructor(subscriber){
        this.subscriber = subscriber;
    }
    [Symbol.observable]() {
        return this;
    }
    async *[Symbol.asyncIterator]() {
        var queue = [
            new $630535246db4a983$export$c7e91f8aec23ae14()
        ], canceler, done = false;
        const observer = {
            next (value) {
                if (done) return;
                queue[queue.length - 1].resolve(value);
                queue.push(new $630535246db4a983$export$c7e91f8aec23ae14());
            },
            error (reason) {
                if (!done) queue[queue.length - 1].reject(reason), done = true;
                if (canceler) canceler();
            },
            complete () {
                if (!done) queue[queue.length - 1].resolve(), done = true;
                if (canceler) canceler();
            }
        };
        canceler = this.subscriber(observer);
        do {
            yield queue[0].promise;
            queue.shift();
        }while (queue[0]);
    }
    static fromStream(list) {
        return new this(({ next: next, complete: complete, error: error })=>{
            var stopped = false;
            (async ()=>{
                try {
                    for await (const item of list)if (!stopped) next(item);
                    else break;
                    if (!stopped) complete();
                } catch (bug) {
                    if (!stopped) error(bug);
                }
            })();
            return ()=>stopped = true;
        });
    }
    static of(...items) {
        return this.fromStream(items);
    }
    async toPromise() {
        const stack = [];
        for await (const item of this){
            stack.push(item);
            if (stack.length > 2) stack.shift();
        }
        return stack[0];
    }
    subscribe(onNext, onError, onComplete) {
        var stop = false;
        (async ()=>{
            try {
                for await (const item of this)if (!stop) onNext(item);
                else break;
                if (onComplete instanceof Function) onComplete();
            } catch (error) {
                if (onError instanceof Function) onError(error);
            }
        })();
        return {
            unsubscribe: ()=>stop = true,
            get closed () {
                return stop;
            }
        };
    }
    static from(observable) {
        if (Symbol.iterator in observable) return this.of(...observable);
        if (Symbol.asyncIterator in observable) return this.fromStream(observable);
        return new this(({ next: next, error: error, complete: complete })=>observable.subscribe(next, error, complete).unsubscribe);
    }
    static fromEvent(target, name) {
        return new this(({ next: next, error: error })=>{
            if (typeof target.on === "function") target.on(name, next).on("error", error);
            else {
                target.addEventListener(name, next);
                target.addEventListener("error", error);
            }
            return ()=>{
                if (typeof target.off === "function") target.off(name, next).off("error", error);
                else {
                    target.removeEventListener(name, next);
                    target.removeEventListener("error", error);
                }
            };
        });
    }
}
var $630535246db4a983$var$$603f33a01a36ab56$exports = {};
$630535246db4a983$var$$parcel$export($630535246db4a983$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $630535246db4a983$export$d16acf4b6e75743d;
});
function $630535246db4a983$export$d16acf4b6e75743d() {
    var feedNext, stop;
    const observable = new $630535246db4a983$export$77cea355fa80b5f4(({ next: next, complete: complete })=>{
        feedNext = next, stop = complete;
    });
    return {
        process (data) {
            const defer = new $630535246db4a983$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy () {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}


var $e8e7dbc748a933f9$export$71511d61b312f219;
"use strict";
function $e8e7dbc748a933f9$var$_ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
$e8e7dbc748a933f9$export$71511d61b312f219 = $e8e7dbc748a933f9$var$_ts_generator;




function $2ba9136349711d35$export$da8ca15f4115b46e() {
    if (typeof window !== 'undefined') {
        const Component = (parcelRequire("bD1fn"));
        return Component.default || Component;
    } else {
        const Component = (parcelRequire("2K0q1"));
        return Component.default || Component;
    }
}


var $c6df664a4c0f994d$exports = {};
"use strict";
var $c6df664a4c0f994d$var$e = {
    code: ({ data: e })=>`<pre><code>${e.code}</code></pre>`,
    embed: ({ data: e })=>{
        const t = e.service;
        return "vimeo" === t ? `<iframe src="${e.embed}" height="${e.height}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>` : "youtube" === t ? `<iframe width="${e.width}" height="${e.height}" src="${e.embed}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>` : (console.error("[editorjs-html]: Only Youtube & Vimeo embeds are available by default. Write your own embed parser for other options."), "");
    },
    header: ({ data: e })=>`<h${e.level}>${e.text}</h${e.level}>`,
    image: ({ data: e })=>{
        const t = e.caption ? e.caption : "Image";
        return `<img src="${e?.file?.url || e?.url}" alt="${t}" />`;
    },
    list: ({ data: e })=>{
        const t = "unordered" === e.style ? "ul" : "ol", r = (e, t)=>{
            const o = e.map((e)=>{
                if (!e.content && !e.items) return `<li>${e}</li>`;
                let o = "";
                return e.items?.length && (o = r(e.items, t)), e.content ? `<li>${e.content}${o}</li>` : void 0;
            });
            return `<${t}>${o.join("")}</${t}>`;
        };
        return r(e.items, t);
    },
    paragraph: ({ data: e })=>{
        const t = e.alignment || e.align;
        return t ? `<p style="text-align:${t}"> ${e.text} </p>` : `<p>${e.text}</p>`;
    },
    quote: ({ data: e })=>`<blockquote>${e.text}</blockquote> - ${e.caption}`,
    delimiter: ({ data: e })=>"<br/>"
};
$c6df664a4c0f994d$exports = (t = {}, r = {
    strict: !1
})=>{
    const o = {
        ...$c6df664a4c0f994d$var$e,
        ...t
    };
    return {
        parse: (e)=>(({ blocks: e }, t, r)=>e.reduce((e, o)=>{
                    if (o.type in t) return e + t[o.type](o);
                    const i = `[editorjs-html]: Parser function for ${o.type} does not exist`;
                    if (r.strict) throw new Error(i);
                    return console.error(i), e;
                }, ""))(e, o, r),
        parseBlock: (e)=>((e, t, r)=>{
                if (e.type in t) return t[e.type](e);
                const o = `[editorjs-html]: Parser function for ${e.type} does not exist`;
                if (r.strict) throw new Error(o);
                console.error(o);
            })(e, o, r)
    };
};


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
var $jmWak = parcelRequire("jmWak");
function $3622a645c822ba87$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $3622a645c822ba87$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $3622a645c822ba87$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $3622a645c822ba87$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $3622a645c822ba87$export$2e2bcd8739ae039 = $3622a645c822ba87$export$4f5d2d50c9deca37;


var $2e16598ba480dcca$var$__create = Object.create;
var $2e16598ba480dcca$var$__defProp = Object.defineProperty;
var $2e16598ba480dcca$var$__defProps = Object.defineProperties;
var $2e16598ba480dcca$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $2e16598ba480dcca$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2e16598ba480dcca$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $2e16598ba480dcca$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2e16598ba480dcca$var$__getProtoOf = Object.getPrototypeOf;
var $2e16598ba480dcca$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2e16598ba480dcca$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2e16598ba480dcca$var$__defNormalProp = (obj, key, value)=>key in obj ? $2e16598ba480dcca$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2e16598ba480dcca$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2e16598ba480dcca$var$__hasOwnProp.call(b, prop)) $2e16598ba480dcca$var$__defNormalProp(a, prop, b[prop]);
    if ($2e16598ba480dcca$var$__getOwnPropSymbols) {
        for (var prop of $2e16598ba480dcca$var$__getOwnPropSymbols(b))if ($2e16598ba480dcca$var$__propIsEnum.call(b, prop)) $2e16598ba480dcca$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2e16598ba480dcca$var$__spreadProps = (a, b)=>$2e16598ba480dcca$var$__defProps(a, $2e16598ba480dcca$var$__getOwnPropDescs(b));
var $2e16598ba480dcca$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2e16598ba480dcca$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2e16598ba480dcca$var$__getOwnPropSymbols) {
        for (var prop of $2e16598ba480dcca$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2e16598ba480dcca$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $2e16598ba480dcca$var$__commonJS = (cb, mod)=>function __require() {
        return mod || (0, cb[$2e16598ba480dcca$var$__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var $2e16598ba480dcca$var$__export = (target, all)=>{
    for(var name in all)$2e16598ba480dcca$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $2e16598ba480dcca$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $2e16598ba480dcca$var$__getOwnPropNames(from))if (!$2e16598ba480dcca$var$__hasOwnProp.call(to, key) && key !== except) $2e16598ba480dcca$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $2e16598ba480dcca$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $2e16598ba480dcca$var$__toESM = (mod, isNodeMode, target)=>(target = mod != null ? $2e16598ba480dcca$var$__create($2e16598ba480dcca$var$__getProtoOf(mod)) : {}, $2e16598ba480dcca$var$__copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? $2e16598ba480dcca$var$__defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
// ../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js
var $2e16598ba480dcca$var$require_prism = $2e16598ba480dcca$var$__commonJS({
    "../../node_modules/.pnpm/prismjs@1.29.0_patch_hash=vrxx3pzkik6jpmgpayxfjunetu/node_modules/prismjs/prism.js" (exports, module) {
        var Prism2 = function() {
            var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
            var uniqueId = 0;
            var plainTextGrammar = {};
            var _ = {
                /**
         * A namespace for utility methods.
         *
         * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
         * change or disappear at any time.
         *
         * @namespace
         * @memberof Prism
         */ util: {
                    encode: function encode(tokens) {
                        if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                        else if (Array.isArray(tokens)) return tokens.map(encode);
                        else return tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
                    },
                    /**
           * Returns the name of the type of the given value.
           *
           * @param {any} o
           * @returns {string}
           * @example
           * type(null)      === 'Null'
           * type(undefined) === 'Undefined'
           * type(123)       === 'Number'
           * type('foo')     === 'String'
           * type(true)      === 'Boolean'
           * type([1, 2])    === 'Array'
           * type({})        === 'Object'
           * type(String)    === 'Function'
           * type(/abc+/)    === 'RegExp'
           */ type: function(o) {
                        return Object.prototype.toString.call(o).slice(8, -1);
                    },
                    /**
           * Returns a unique number for the given object. Later calls will still return the same number.
           *
           * @param {Object} obj
           * @returns {number}
           */ objId: function(obj) {
                        if (!obj["__id"]) Object.defineProperty(obj, "__id", {
                            value: ++uniqueId
                        });
                        return obj["__id"];
                    },
                    /**
           * Creates a deep clone of the given object.
           *
           * The main intended use of this function is to clone language definitions.
           *
           * @param {T} o
           * @param {Record<number, any>} [visited]
           * @returns {T}
           * @template T
           */ clone: function deepClone(o, visited) {
                        visited = visited || {};
                        var clone;
                        var id;
                        switch(_.util.type(o)){
                            case "Object":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = /** @type {Record<string, any>} */ {};
                                visited[id] = clone;
                                for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                                return /** @type {any} */ clone;
                            case "Array":
                                id = _.util.objId(o);
                                if (visited[id]) return visited[id];
                                clone = [];
                                visited[id] = clone;
                                /** @type {Array} */ /** @type {any} */ o.forEach(function(v, i) {
                                    clone[i] = deepClone(v, visited);
                                });
                                return /** @type {any} */ clone;
                            default:
                                return o;
                        }
                    },
                    /**
           * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
           *
           * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
           *
           * @param {Element} element
           * @returns {string}
           */ getLanguage: function(element) {
                        while(element){
                            var m = lang.exec(element.className);
                            if (m) return m[1].toLowerCase();
                            element = element.parentElement;
                        }
                        return "none";
                    },
                    /**
           * Sets the Prism `language-xxxx` class of the given element.
           *
           * @param {Element} element
           * @param {string} language
           * @returns {void}
           */ setLanguage: function(element, language) {
                        element.className = element.className.replace(RegExp(lang, "gi"), "");
                        element.classList.add("language-" + language);
                    },
                    /**
           * Returns whether a given class is active for `element`.
           *
           * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
           * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
           * given class is just the given class with a `no-` prefix.
           *
           * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
           * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
           * ancestors have the given class or the negated version of it, then the default activation will be returned.
           *
           * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
           * version of it, the class is considered active.
           *
           * @param {Element} element
           * @param {string} className
           * @param {boolean} [defaultActivation=false]
           * @returns {boolean}
           */ isActive: function(element, className, defaultActivation) {
                        var no = "no-" + className;
                        while(element){
                            var classList = element.classList;
                            if (classList.contains(className)) return true;
                            if (classList.contains(no)) return false;
                            element = element.parentElement;
                        }
                        return !!defaultActivation;
                    }
                },
                /**
         * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
         *
         * @namespace
         * @memberof Prism
         * @public
         */ languages: {
                    /**
           * The grammar for plain, unformatted text.
           */ plain: plainTextGrammar,
                    plaintext: plainTextGrammar,
                    text: plainTextGrammar,
                    txt: plainTextGrammar,
                    /**
           * Creates a deep copy of the language with the given id and appends the given tokens.
           *
           * If a token in `redef` also appears in the copied language, then the existing token in the copied language
           * will be overwritten at its original position.
           *
           * ## Best practices
           *
           * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
           * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
           * understand the language definition because, normally, the order of tokens matters in Prism grammars.
           *
           * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
           * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
           *
           * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
           * @param {Grammar} redef The new tokens to append.
           * @returns {Grammar} The new language created.
           * @public
           * @example
           * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
           *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
           *     // at its original position
           *     'comment': { ... },
           *     // CSS doesn't have a 'color' token, so this token will be appended
           *     'color': /\b(?:red|green|blue)\b/
           * });
           */ extend: function(id, redef) {
                        var lang2 = _.util.clone(_.languages[id]);
                        for(var key in redef)lang2[key] = redef[key];
                        return lang2;
                    },
                    /**
           * Inserts tokens _before_ another token in a language definition or any other grammar.
           *
           * ## Usage
           *
           * This helper method makes it easy to modify existing languages. For example, the CSS language definition
           * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
           * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
           * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
           * this:
           *
           * ```js
           * Prism.languages.markup.style = {
           *     // token
           * };
           * ```
           *
           * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
           * before existing tokens. For the CSS example above, you would use it like this:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'cdata', {
           *     'style': {
           *         // token
           *     }
           * });
           * ```
           *
           * ## Special cases
           *
           * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
           * will be ignored.
           *
           * This behavior can be used to insert tokens after `before`:
           *
           * ```js
           * Prism.languages.insertBefore('markup', 'comment', {
           *     'comment': Prism.languages.markup.comment,
           *     // tokens after 'comment'
           * });
           * ```
           *
           * ## Limitations
           *
           * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
           * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
           * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
           * deleting properties which is necessary to insert at arbitrary positions.
           *
           * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
           * Instead, it will create a new object and replace all references to the target object with the new one. This
           * can be done without temporarily deleting properties, so the iteration order is well-defined.
           *
           * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
           * you hold the target object in a variable, then the value of the variable will not change.
           *
           * ```js
           * var oldMarkup = Prism.languages.markup;
           * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
           *
           * assert(oldMarkup !== Prism.languages.markup);
           * assert(newMarkup === Prism.languages.markup);
           * ```
           *
           * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
           * object to be modified.
           * @param {string} before The key to insert before.
           * @param {Grammar} insert An object containing the key-value pairs to be inserted.
           * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
           * object to be modified.
           *
           * Defaults to `Prism.languages`.
           * @returns {Grammar} The new grammar object.
           * @public
           */ insertBefore: function(inside, before, insert, root) {
                        root = root || /** @type {any} */ _.languages;
                        var grammar = root[inside];
                        var ret = {};
                        for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                            if (token == before) {
                                for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                            }
                            if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                        }
                        var old = root[inside];
                        root[inside] = ret;
                        _.languages.DFS(_.languages, function(key, value) {
                            if (value === old && key != inside) this[key] = ret;
                        });
                        return ret;
                    },
                    // Traverse a language definition with Depth First Search
                    DFS: function DFS(o, callback, type, visited) {
                        visited = visited || {};
                        var objId = _.util.objId;
                        for(var i in o)if (o.hasOwnProperty(i)) {
                            callback.call(o, i, o[i], type || i);
                            var property = o[i];
                            var propertyType = _.util.type(property);
                            if (propertyType === "Object" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, null, visited);
                            } else if (propertyType === "Array" && !visited[objId(property)]) {
                                visited[objId(property)] = true;
                                DFS(property, callback, i, visited);
                            }
                        }
                    }
                },
                plugins: {},
                /**
         * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
         * and the language definitions to use, and returns a string with the HTML produced.
         *
         * The following hooks will be run:
         * 1. `before-tokenize`
         * 2. `after-tokenize`
         * 3. `wrap`: On each {@link Token}.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @param {string} language The name of the language definition passed to `grammar`.
         * @returns {string} The highlighted HTML.
         * @memberof Prism
         * @public
         * @example
         * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
         */ highlight: function(text, grammar, language) {
                    var env = {
                        code: text,
                        grammar: grammar,
                        language: language
                    };
                    _.hooks.run("before-tokenize", env);
                    if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
                    env.tokens = _.tokenize(env.code, env.grammar);
                    _.hooks.run("after-tokenize", env);
                    return Token.stringify(_.util.encode(env.tokens), env.language);
                },
                /**
         * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
         * and the language definitions to use, and returns an array with the tokenized code.
         *
         * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
         *
         * This method could be useful in other contexts as well, as a very crude parser.
         *
         * @param {string} text A string with the code to be highlighted.
         * @param {Grammar} grammar An object containing the tokens to use.
         *
         * Usually a language definition like `Prism.languages.markup`.
         * @returns {TokenStream} An array of strings and tokens, a token stream.
         * @memberof Prism
         * @public
         * @example
         * let code = `var foo = 0;`;
         * let tokens = Prism.tokenize(code, Prism.languages.javascript);
         * tokens.forEach(token => {
         *     if (token instanceof Prism.Token && token.type === 'number') {
         *         console.log(`Found numeric literal: ${token.content}`);
         *     }
         * });
         */ tokenize: function(text, grammar) {
                    var rest = grammar.rest;
                    if (rest) {
                        for(var token in rest)grammar[token] = rest[token];
                        delete grammar.rest;
                    }
                    var tokenList = new LinkedList();
                    addAfter(tokenList, tokenList.head, text);
                    matchGrammar(text, tokenList, grammar, tokenList.head, 0);
                    return toArray(tokenList);
                },
                /**
         * @namespace
         * @memberof Prism
         * @public
         */ hooks: {
                    all: {},
                    /**
           * Adds the given callback to the list of callbacks for the given hook.
           *
           * The callback will be invoked when the hook it is registered for is run.
           * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
           *
           * One callback function can be registered to multiple hooks and the same hook multiple times.
           *
           * @param {string} name The name of the hook.
           * @param {HookCallback} callback The callback function which is given environment variables.
           * @public
           */ add: function(name, callback) {
                        var hooks2 = _.hooks.all;
                        hooks2[name] = hooks2[name] || [];
                        hooks2[name].push(callback);
                    },
                    /**
           * Runs a hook invoking all registered callbacks with the given environment variables.
           *
           * Callbacks will be invoked synchronously and in the order in which they were registered.
           *
           * @param {string} name The name of the hook.
           * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
           * @public
           */ run: function(name, env) {
                        var callbacks = _.hooks.all[name];
                        if (!callbacks || !callbacks.length) return;
                        for(var i = 0, callback; callback = callbacks[i++];)callback(env);
                    }
                },
                Token: Token
            };
            function Token(type, content, alias, matchedStr) {
                this.type = type;
                this.content = content;
                this.alias = alias;
                this.length = (matchedStr || "").length | 0;
            }
            Token.stringify = function stringify(o, language) {
                if (typeof o == "string") return o;
                if (Array.isArray(o)) {
                    var s = "";
                    o.forEach(function(e) {
                        s += stringify(e, language);
                    });
                    return s;
                }
                var env = {
                    type: o.type,
                    content: stringify(o.content, language),
                    tag: "span",
                    classes: [
                        "token",
                        o.type
                    ],
                    attributes: {},
                    language: language
                };
                var aliases = o.alias;
                if (aliases) {
                    if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
                    else env.classes.push(aliases);
                }
                _.hooks.run("wrap", env);
                var attributes = "";
                for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
                return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
            };
            function matchPattern(pattern, pos, text, lookbehind) {
                pattern.lastIndex = pos;
                var match = pattern.exec(text);
                if (match && lookbehind && match[1]) {
                    var lookbehindLength = match[1].length;
                    match.index += lookbehindLength;
                    match[0] = match[0].slice(lookbehindLength);
                }
                return match;
            }
            function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
                for(var token in grammar){
                    if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
                    var patterns = grammar[token];
                    patterns = Array.isArray(patterns) ? patterns : [
                        patterns
                    ];
                    for(var j = 0; j < patterns.length; ++j){
                        if (rematch && rematch.cause == token + "," + j) return;
                        var patternObj = patterns[j];
                        var inside = patternObj.inside;
                        var lookbehind = !!patternObj.lookbehind;
                        var greedy = !!patternObj.greedy;
                        var alias = patternObj.alias;
                        if (greedy && !patternObj.pattern.global) {
                            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                        }
                        var pattern = patternObj.pattern || patternObj;
                        for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                            if (rematch && pos >= rematch.reach) break;
                            var str = currentNode.value;
                            if (tokenList.length > text.length) return;
                            if (str instanceof Token) continue;
                            var removeCount = 1;
                            var match;
                            if (greedy) {
                                match = matchPattern(pattern, pos, text, lookbehind);
                                if (!match || match.index >= text.length) break;
                                var from = match.index;
                                var to = match.index + match[0].length;
                                var p = pos;
                                p += currentNode.value.length;
                                while(from >= p){
                                    currentNode = currentNode.next;
                                    p += currentNode.value.length;
                                }
                                p -= currentNode.value.length;
                                pos = p;
                                if (currentNode.value instanceof Token) continue;
                                for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === "string"); k = k.next){
                                    removeCount++;
                                    p += k.value.length;
                                }
                                removeCount--;
                                str = text.slice(pos, p);
                                match.index -= pos;
                            } else {
                                match = matchPattern(pattern, 0, str, lookbehind);
                                if (!match) continue;
                            }
                            var from = match.index;
                            var matchStr = match[0];
                            var before = str.slice(0, from);
                            var after = str.slice(from + matchStr.length);
                            var reach = pos + str.length;
                            if (rematch && reach > rematch.reach) rematch.reach = reach;
                            var removeFrom = currentNode.prev;
                            if (before) {
                                removeFrom = addAfter(tokenList, removeFrom, before);
                                pos += before.length;
                            }
                            removeRange(tokenList, removeFrom, removeCount);
                            var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                            currentNode = addAfter(tokenList, removeFrom, wrapped);
                            if (after) addAfter(tokenList, currentNode, after);
                            if (removeCount > 1) {
                                var nestedRematch = {
                                    cause: token + "," + j,
                                    reach: reach
                                };
                                matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                                if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                            }
                        }
                    }
                }
            }
            function LinkedList() {
                var head = {
                    value: null,
                    prev: null,
                    next: null
                };
                var tail = {
                    value: null,
                    prev: head,
                    next: null
                };
                head.next = tail;
                this.head = head;
                this.tail = tail;
                this.length = 0;
            }
            function addAfter(list, node, value) {
                var next = node.next;
                var newNode = {
                    value: value,
                    prev: node,
                    next: next
                };
                node.next = newNode;
                next.prev = newNode;
                list.length++;
                return newNode;
            }
            function removeRange(list, node, count) {
                var next = node.next;
                for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
                node.next = next;
                next.prev = node;
                list.length -= i;
            }
            function toArray(list) {
                var array = [];
                var node = list.head.next;
                while(node !== list.tail){
                    array.push(node.value);
                    node = node.next;
                }
                return array;
            }
            return _;
        }();
        module.exports = Prism2;
        Prism2.default = Prism2;
    }
});
// src/prism-langs.ts
var $2e16598ba480dcca$export$dc7257ffb0972f87 = $2e16598ba480dcca$var$__toESM($2e16598ba480dcca$var$require_prism());
$2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup = {
    comment: {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    prolog: {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    doctype: {
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            "internal-subset": {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null
            },
            string: {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            punctuation: /^<!|>$|[[\]]/,
            "doctype-tag": /^DOCTYPE/i,
            name: /[^\s<>'"]+/
        }
    },
    cdata: {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    tag: {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            tag: {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    punctuation: /^<\/?/,
                    namespace: /^[^\s>\/:]+:/
                }
            },
            "special-attr": [],
            "attr-value": {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    punctuation: [
                        {
                            pattern: /^=/,
                            alias: "attr-equals"
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            punctuation: /\/?>/,
            "attr-name": {
                pattern: /[^\s>\/]+/,
                inside: {
                    namespace: /^[^\s>\/:]+:/
                }
            }
        }
    },
    entity: [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: "named-entity"
        },
        /&#x?[\da-f]{1,8};/i
    ]
}, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup.tag.inside["attr-value"].inside.entity = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup.entity, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup.doctype.inside["internal-subset"].inside = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup, $2e16598ba480dcca$export$dc7257ffb0972f87.hooks.add("wrap", function(e) {
    "entity" === e.type && (e.attributes.title = e.content.replace(/&amp;/, "&"));
}), Object.defineProperty($2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup.tag, "addInlined", {
    value: function(e, n) {
        var t = {}, t = (t["language-" + n] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages[n]
        }, t.cdata = /^<!\[CDATA\[|\]\]>$/i, {
            "included-cdata": {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: t
            }
        }), n = (t["language-" + n] = {
            pattern: /[\s\S]+/,
            inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages[n]
        }, {});
        n[e] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return e;
            }), "i"),
            lookbehind: true,
            greedy: true,
            inside: t
        }, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("markup", "cdata", n);
    }
}), Object.defineProperty($2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup.tag, "addAttribute", {
    value: function(e, n) {
        $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup.tag.inside["special-attr"].push({
            pattern: RegExp(/(^|["'\s])/.source + "(?:" + e + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
            lookbehind: true,
            inside: {
                "attr-name": /^[^\s=]+/,
                "attr-value": {
                    pattern: /=[\s\S]+/,
                    inside: {
                        value: {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                n,
                                "language-" + n
                            ],
                            inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages[n]
                        },
                        punctuation: [
                            {
                                pattern: /^=/,
                                alias: "attr-equals"
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.html = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.mathml = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.svg = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.xml = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.extend("markup", {}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.ssml = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.xml, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.atom = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.xml, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.rss = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.xml, function(e) {
    var n = {
        pattern: /\\[\\(){}[\]^$+*?|.]/,
        alias: "escape"
    }, t = /\\(?:x[\da-fA-F]{2}|u[\da-fA-F]{4}|u\{[\da-fA-F]+\}|0[0-7]{0,2}|[123][0-7]{2}|c[a-zA-Z]|.)/, a = "(?:[^\\\\-]|" + t.source + ")", a = RegExp(a + "-" + a), r = {
        pattern: /(<|')[^<>']+(?=[>']$)/,
        lookbehind: true,
        alias: "variable"
    };
    e.languages.regex = {
        "char-class": {
            pattern: /((?:^|[^\\])(?:\\\\)*)\[(?:[^\\\]]|\\[\s\S])*\]/,
            lookbehind: true,
            inside: {
                "char-class-negation": {
                    pattern: /(^\[)\^/,
                    lookbehind: true,
                    alias: "operator"
                },
                "char-class-punctuation": {
                    pattern: /^\[|\]$/,
                    alias: "punctuation"
                },
                range: {
                    pattern: a,
                    inside: {
                        escape: t,
                        "range-punctuation": {
                            pattern: /-/,
                            alias: "operator"
                        }
                    }
                },
                "special-escape": n,
                "char-set": {
                    pattern: /\\[wsd]|\\p\{[^{}]+\}/i,
                    alias: "class-name"
                },
                escape: t
            }
        },
        "special-escape": n,
        "char-set": {
            pattern: /\.|\\[wsd]|\\p\{[^{}]+\}/i,
            alias: "class-name"
        },
        backreference: [
            {
                pattern: /\\(?![123][0-7]{2})[1-9]/,
                alias: "keyword"
            },
            {
                pattern: /\\k<[^<>']+>/,
                alias: "keyword",
                inside: {
                    "group-name": r
                }
            }
        ],
        anchor: {
            pattern: /[$^]|\\[ABbGZz]/,
            alias: "function"
        },
        escape: t,
        group: [
            {
                pattern: /\((?:\?(?:<[^<>']+>|'[^<>']+'|[>:]|<?[=!]|[idmnsuxU]+(?:-[idmnsuxU]+)?:?))?/,
                alias: "punctuation",
                inside: {
                    "group-name": r
                }
            },
            {
                pattern: /\)/,
                alias: "punctuation"
            }
        ],
        quantifier: {
            pattern: /(?:[+*?]|\{\d+(?:,\d*)?\})[?+]?/,
            alias: "number"
        },
        alternation: {
            pattern: /\|/,
            alias: "keyword"
        }
    };
}($2e16598ba480dcca$export$dc7257ffb0972f87), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.clike = {
    comment: [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    string: {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            punctuation: /[.\\]/
        }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
}, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.javascript = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.extend("clike", {
    "class-name": [
        $2e16598ba480dcca$export$dc7257ffb0972f87.languages.clike["class-name"],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    keyword: [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
        pattern: RegExp(/(^|[^\w$])/.source + "(?:" + /NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source + ")" + /(?![\w$])/.source),
        lookbehind: true
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("javascript", "keyword", {
    regex: {
        pattern: RegExp(/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + /\//.source + "(?:" + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + "|" + /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ")" + /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            "regex-source": {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: "language-regex",
                inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.regex
            },
            "regex-delimiter": /^\/|\/$/,
            "regex-flags": /^[a-z]+$/
        }
    },
    "function-variable": {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: "function"
    },
    parameter: [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.javascript
        }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("javascript", "string", {
    hashbang: {
        pattern: /^#!.*/,
        greedy: true,
        alias: "comment"
    },
    "template-string": {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            "template-punctuation": {
                pattern: /^`|`$/,
                alias: "string"
            },
            interpolation: {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    "interpolation-punctuation": {
                        pattern: /^\$\{|\}$/,
                        alias: "punctuation"
                    },
                    rest: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.javascript
                }
            },
            string: /[\s\S]+/
        }
    },
    "string-property": {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: "property"
    }
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("javascript", "operator", {
    "literal-property": {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: "property"
    }
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup && ($2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup.tag.addInlined("script", "javascript"), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.js = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.javascript, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.actionscript = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:as|break|case|catch|class|const|default|delete|do|dynamic|each|else|extends|final|finally|for|function|get|if|implements|import|in|include|instanceof|interface|internal|is|namespace|native|new|null|override|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|use|var|void|while|with)\b/,
    operator: /\+\+|--|(?:[+\-*\/%^]|&&?|\|\|?|<<?|>>?>?|[!=]=?)=?|[~?@]/
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.actionscript["class-name"].alias = "function", delete $2e16598ba480dcca$export$dc7257ffb0972f87.languages.actionscript.parameter, delete $2e16598ba480dcca$export$dc7257ffb0972f87.languages.actionscript["literal-property"], $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup && $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("actionscript", "string", {
    xml: {
        pattern: /(^|[^.])<\/?\w+(?:\s+[^\s>\/=]+=("|')(?:\\[\s\S]|(?!\2)[^\\])*\2)*\s*\/?>/,
        lookbehind: true,
        inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markup
    }
}), function(e) {
    var n = /#(?!\{).+/, t = {
        pattern: /#\{[^}]+\}/,
        alias: "variable"
    };
    e.languages.coffeescript = e.languages.extend("javascript", {
        comment: n,
        string: [
            {
                pattern: /'(?:\\[\s\S]|[^\\'])*'/,
                greedy: true
            },
            {
                pattern: /"(?:\\[\s\S]|[^\\"])*"/,
                greedy: true,
                inside: {
                    interpolation: t
                }
            }
        ],
        keyword: /\b(?:and|break|by|catch|class|continue|debugger|delete|do|each|else|extend|extends|false|finally|for|if|in|instanceof|is|isnt|let|loop|namespace|new|no|not|null|of|off|on|or|own|return|super|switch|then|this|throw|true|try|typeof|undefined|unless|until|when|while|window|with|yes|yield)\b/,
        "class-member": {
            pattern: /@(?!\d)\w+/,
            alias: "variable"
        }
    }), e.languages.insertBefore("coffeescript", "comment", {
        "multiline-comment": {
            pattern: /###[\s\S]+?###/,
            alias: "comment"
        },
        "block-regex": {
            pattern: /\/{3}[\s\S]*?\/{3}/,
            alias: "regex",
            inside: {
                comment: n,
                interpolation: t
            }
        }
    }), e.languages.insertBefore("coffeescript", "string", {
        "inline-javascript": {
            pattern: /`(?:\\[\s\S]|[^\\`])*`/,
            inside: {
                delimiter: {
                    pattern: /^`|`$/,
                    alias: "punctuation"
                },
                script: {
                    pattern: /[\s\S]+/,
                    alias: "language-javascript",
                    inside: e.languages.javascript
                }
            }
        },
        "multiline-string": [
            {
                pattern: /'''[\s\S]*?'''/,
                greedy: true,
                alias: "string"
            },
            {
                pattern: /"""[\s\S]*?"""/,
                greedy: true,
                alias: "string",
                inside: {
                    interpolation: t
                }
            }
        ]
    }), e.languages.insertBefore("coffeescript", "keyword", {
        property: /(?!\d)\w+(?=\s*:(?!:))/
    }), delete e.languages.coffeescript["template-string"], e.languages.coffee = e.languages.coffeescript;
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(l) {
    var e = l.languages.javadoclike = {
        parameter: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*@(?:arg|arguments|param)\s+)\w+/m,
            lookbehind: true
        },
        keyword: {
            pattern: /(^[\t ]*(?:\/{3}|\*|\/\*\*)\s*|\{)@[a-z][a-zA-Z-]+\b/m,
            lookbehind: true
        },
        punctuation: /[{}]/
    };
    Object.defineProperty(e, "addSupport", {
        value: function(e2, o) {
            (e2 = "string" == typeof e2 ? [
                e2
            ] : e2).forEach(function(e3) {
                var n = function(e4) {
                    e4.inside || (e4.inside = {}), e4.inside.rest = o;
                }, t = "doc-comment";
                if (a = l.languages[e3]) {
                    var a, r = a[t];
                    if ((r = r ? r : (a = l.languages.insertBefore(e3, "comment", {
                        "doc-comment": {
                            pattern: /(^|[^\\])\/\*\*[^/][\s\S]*?(?:\*\/|$)/,
                            lookbehind: true,
                            alias: "comment"
                        }
                    }))[t]) instanceof RegExp && (r = a[t] = {
                        pattern: r
                    }), Array.isArray(r)) for(var s = 0, i = r.length; s < i; s++)r[s] instanceof RegExp && (r[s] = {
                        pattern: r[s]
                    }), n(r[s]);
                    else n(r);
                }
            });
        }
    }), e.addSupport([
        "java",
        "javascript",
        "php"
    ], e);
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(e) {
    var n = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/, n = (e.languages.css = {
        comment: /\/\*[\s\S]*?\*\//,
        atrule: {
            pattern: RegExp("@[\\w-](?:" + /[^;{\s"']|\s+(?!\s)/.source + "|" + n.source + ")*?" + /(?:;|(?=\s*\{))/.source),
            inside: {
                rule: /^@[\w-]+/,
                "selector-function-argument": {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: "selector"
                },
                keyword: {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        url: {
            pattern: RegExp("\\burl\\((?:" + n.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
            greedy: true,
            inside: {
                function: /^url/i,
                punctuation: /^\(|\)$/,
                string: {
                    pattern: RegExp("^" + n.source + "$"),
                    alias: "url"
                }
            }
        },
        selector: {
            pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + n.source + ")*(?=\\s*\\{)"),
            lookbehind: true
        },
        string: {
            pattern: n,
            greedy: true
        },
        property: {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        important: /!important\b/i,
        function: {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        punctuation: /[(){};:,]/
    }, e.languages.css.atrule.inside.rest = e.languages.css, e.languages.markup);
    n && (n.tag.addInlined("style", "css"), n.tag.addAttribute("style", "css"));
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(e) {
    var n = /("|')(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/, n = (e.languages.css.selector = {
        pattern: e.languages.css.selector.pattern,
        lookbehind: true,
        inside: n = {
            "pseudo-element": /:(?:after|before|first-letter|first-line|selection)|::[-\w]+/,
            "pseudo-class": /:[-\w]+/,
            class: /\.[-\w]+/,
            id: /#[-\w]+/,
            attribute: {
                pattern: RegExp(`\\[(?:[^[\\]"']|` + n.source + ")*\\]"),
                greedy: true,
                inside: {
                    punctuation: /^\[|\]$/,
                    "case-sensitivity": {
                        pattern: /(\s)[si]$/i,
                        lookbehind: true,
                        alias: "keyword"
                    },
                    namespace: {
                        pattern: /^(\s*)(?:(?!\s)[-*\w\xA0-\uFFFF])*\|(?!=)/,
                        lookbehind: true,
                        inside: {
                            punctuation: /\|$/
                        }
                    },
                    "attr-name": {
                        pattern: /^(\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+/,
                        lookbehind: true
                    },
                    "attr-value": [
                        n,
                        {
                            pattern: /(=\s*)(?:(?!\s)[-\w\xA0-\uFFFF])+(?=\s*$)/,
                            lookbehind: true
                        }
                    ],
                    operator: /[|~*^$]?=/
                }
            },
            "n-th": [
                {
                    pattern: /(\(\s*)[+-]?\d*[\dn](?:\s*[+-]\s*\d+)?(?=\s*\))/,
                    lookbehind: true,
                    inside: {
                        number: /[\dn]+/,
                        operator: /[+-]/
                    }
                },
                {
                    pattern: /(\(\s*)(?:even|odd)(?=\s*\))/i,
                    lookbehind: true
                }
            ],
            combinator: />|\+|~|\|\|/,
            punctuation: /[(),]/
        }
    }, e.languages.css.atrule.inside["selector-function-argument"].inside = n, e.languages.insertBefore("css", "property", {
        variable: {
            pattern: /(^|[^-\w\xA0-\uFFFF])--(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*/i,
            lookbehind: true
        }
    }), {
        pattern: /(\b\d+)(?:%|[a-z]+(?![\w-]))/,
        lookbehind: true
    }), t = {
        pattern: /(^|[^\w.-])-?(?:\d+(?:\.\d+)?|\.\d+)/,
        lookbehind: true
    };
    e.languages.insertBefore("css", "function", {
        operator: {
            pattern: /(\s)[+\-*\/](?=\s)/,
            lookbehind: true
        },
        hexcode: {
            pattern: /\B#[\da-f]{3,8}\b/i,
            alias: "color"
        },
        color: [
            {
                pattern: /(^|[^\w-])(?:AliceBlue|AntiqueWhite|Aqua|Aquamarine|Azure|Beige|Bisque|Black|BlanchedAlmond|Blue|BlueViolet|Brown|BurlyWood|CadetBlue|Chartreuse|Chocolate|Coral|CornflowerBlue|Cornsilk|Crimson|Cyan|DarkBlue|DarkCyan|DarkGoldenRod|DarkGr[ae]y|DarkGreen|DarkKhaki|DarkMagenta|DarkOliveGreen|DarkOrange|DarkOrchid|DarkRed|DarkSalmon|DarkSeaGreen|DarkSlateBlue|DarkSlateGr[ae]y|DarkTurquoise|DarkViolet|DeepPink|DeepSkyBlue|DimGr[ae]y|DodgerBlue|FireBrick|FloralWhite|ForestGreen|Fuchsia|Gainsboro|GhostWhite|Gold|GoldenRod|Gr[ae]y|Green|GreenYellow|HoneyDew|HotPink|IndianRed|Indigo|Ivory|Khaki|Lavender|LavenderBlush|LawnGreen|LemonChiffon|LightBlue|LightCoral|LightCyan|LightGoldenRodYellow|LightGr[ae]y|LightGreen|LightPink|LightSalmon|LightSeaGreen|LightSkyBlue|LightSlateGr[ae]y|LightSteelBlue|LightYellow|Lime|LimeGreen|Linen|Magenta|Maroon|MediumAquaMarine|MediumBlue|MediumOrchid|MediumPurple|MediumSeaGreen|MediumSlateBlue|MediumSpringGreen|MediumTurquoise|MediumVioletRed|MidnightBlue|MintCream|MistyRose|Moccasin|NavajoWhite|Navy|OldLace|Olive|OliveDrab|Orange|OrangeRed|Orchid|PaleGoldenRod|PaleGreen|PaleTurquoise|PaleVioletRed|PapayaWhip|PeachPuff|Peru|Pink|Plum|PowderBlue|Purple|RebeccaPurple|Red|RosyBrown|RoyalBlue|SaddleBrown|Salmon|SandyBrown|SeaGreen|SeaShell|Sienna|Silver|SkyBlue|SlateBlue|SlateGr[ae]y|Snow|SpringGreen|SteelBlue|Tan|Teal|Thistle|Tomato|Transparent|Turquoise|Violet|Wheat|White|WhiteSmoke|Yellow|YellowGreen)(?![\w-])/i,
                lookbehind: true
            },
            {
                pattern: /\b(?:hsl|rgb)\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*\)\B|\b(?:hsl|rgb)a\(\s*\d{1,3}\s*,\s*\d{1,3}%?\s*,\s*\d{1,3}%?\s*,\s*(?:0|0?\.\d+|1)\s*\)\B/i,
                inside: {
                    unit: n,
                    number: t,
                    function: /[\w-]+(?=\()/,
                    punctuation: /[(),]/
                }
            }
        ],
        entity: /\\[\da-f]{1,8}/i,
        unit: n,
        number: t
    });
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(e) {
    var n = /[*&][^\s[\]{},]+/, t = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, a = "(?:" + t.source + "(?:[ 	]+" + n.source + ")?|" + n.source + "(?:[ 	]+" + t.source + ")?)", r = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
        return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
    }), s = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
    function i(e2, n2) {
        n2 = (n2 || "").replace(/m/g, "") + "m";
        var t2 = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
            return a;
        }).replace(/<<value>>/g, function() {
            return e2;
        });
        return RegExp(t2, n2);
    }
    e.languages.yaml = {
        scalar: {
            pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                return a;
            })),
            lookbehind: true,
            alias: "string"
        },
        comment: /#.*/,
        key: {
            pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                return a;
            }).replace(/<<key>>/g, function() {
                return "(?:" + r + "|" + s + ")";
            })),
            lookbehind: true,
            greedy: true,
            alias: "atrule"
        },
        directive: {
            pattern: /(^[ \t]*)%.+/m,
            lookbehind: true,
            alias: "important"
        },
        datetime: {
            pattern: i(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
            lookbehind: true,
            alias: "number"
        },
        boolean: {
            pattern: i(/false|true/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        null: {
            pattern: i(/null|~/.source, "i"),
            lookbehind: true,
            alias: "important"
        },
        string: {
            pattern: i(s),
            lookbehind: true,
            greedy: true
        },
        number: {
            pattern: i(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
            lookbehind: true
        },
        tag: t,
        important: n,
        punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
    }, e.languages.yml = e.languages.yaml;
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(o) {
    var n = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
    function e(e2) {
        return e2 = e2.replace(/<inner>/g, function() {
            return n;
        }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + e2 + ")");
    }
    var t = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, a = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
        return t;
    }), r = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source, l = (o.languages.markdown = o.languages.extend("markup", {}), o.languages.insertBefore("markdown", "prolog", {
        "front-matter-block": {
            pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
            lookbehind: true,
            greedy: true,
            inside: {
                punctuation: /^---|---$/,
                "front-matter": {
                    pattern: /\S+(?:\s+\S+)*/,
                    alias: [
                        "yaml",
                        "language-yaml"
                    ],
                    inside: o.languages.yaml
                }
            }
        },
        blockquote: {
            pattern: /^>(?:[\t ]*>)*/m,
            alias: "punctuation"
        },
        table: {
            pattern: RegExp("^" + a + r + "(?:" + a + ")*", "m"),
            inside: {
                "table-data-rows": {
                    pattern: RegExp("^(" + a + r + ")(?:" + a + ")*$"),
                    lookbehind: true,
                    inside: {
                        "table-data": {
                            pattern: RegExp(t),
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                },
                "table-line": {
                    pattern: RegExp("^(" + a + ")" + r + "$"),
                    lookbehind: true,
                    inside: {
                        punctuation: /\||:?-{3,}:?/
                    }
                },
                "table-header-row": {
                    pattern: RegExp("^" + a + "$"),
                    inside: {
                        "table-header": {
                            pattern: RegExp(t),
                            alias: "important",
                            inside: o.languages.markdown
                        },
                        punctuation: /\|/
                    }
                }
            }
        },
        code: [
            {
                pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                lookbehind: true,
                alias: "keyword"
            },
            {
                pattern: /^```[\s\S]*?^```$/m,
                greedy: true,
                inside: {
                    "code-block": {
                        pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                        lookbehind: true
                    },
                    "code-language": {
                        pattern: /^(```).+/,
                        lookbehind: true
                    },
                    punctuation: /```/
                }
            }
        ],
        title: [
            {
                pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                alias: "important",
                inside: {
                    punctuation: /==+$|--+$/
                }
            },
            {
                pattern: /(^\s*)#.+/m,
                lookbehind: true,
                alias: "important",
                inside: {
                    punctuation: /^#+|#+$/
                }
            }
        ],
        hr: {
            pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        list: {
            pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
            lookbehind: true,
            alias: "punctuation"
        },
        "url-reference": {
            pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
            inside: {
                variable: {
                    pattern: /^(!?\[)[^\]]+/,
                    lookbehind: true
                },
                string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                punctuation: /^[\[\]!:]|[<>]/
            },
            alias: "url"
        },
        bold: {
            pattern: e(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^..)[\s\S]+(?=..$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /\*\*|__/
            }
        },
        italic: {
            pattern: e(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^.)[\s\S]+(?=.$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /[*_]/
            }
        },
        strike: {
            pattern: e(/(~~?)(?:(?!~)<inner>)+\2/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                content: {
                    pattern: /(^~~?)[\s\S]+(?=\1$)/,
                    lookbehind: true,
                    inside: {}
                },
                punctuation: /~~?/
            }
        },
        "code-snippet": {
            pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
            lookbehind: true,
            greedy: true,
            alias: [
                "code",
                "keyword"
            ]
        },
        url: {
            pattern: e(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                operator: /^!/,
                content: {
                    pattern: /(^\[)[^\]]+(?=\])/,
                    lookbehind: true,
                    inside: {}
                },
                variable: {
                    pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                    lookbehind: true
                },
                url: {
                    pattern: /(^\]\()[^\s)]+/,
                    lookbehind: true
                },
                string: {
                    pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                    lookbehind: true
                }
            }
        }
    }), [
        "url",
        "bold",
        "italic",
        "strike"
    ].forEach(function(n2) {
        [
            "url",
            "bold",
            "italic",
            "strike",
            "code-snippet"
        ].forEach(function(e2) {
            n2 !== e2 && (o.languages.markdown[n2].inside.content.inside[e2] = o.languages.markdown[e2]);
        });
    }), o.hooks.add("after-tokenize", function(e2) {
        "markdown" !== e2.language && "md" !== e2.language || !function e3(n2) {
            if (n2 && "string" != typeof n2) for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r2, s = n2[t2];
                "code" !== s.type ? e3(s.content) : (r2 = s.content[1], s = s.content[3], r2 && s && "code-language" === r2.type && "code-block" === s.type && "string" == typeof r2.content && (r2 = r2.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp"), r2 = "language-" + (r2 = (/[a-z][\w-]*/i.exec(r2) || [
                    ""
                ])[0].toLowerCase()), s.alias ? "string" == typeof s.alias ? s.alias = [
                    s.alias,
                    r2
                ] : s.alias.push(r2) : s.alias = [
                    r2
                ]));
            }
        }(e2.tokens);
    }), o.hooks.add("wrap", function(e2) {
        if ("code-block" === e2.type) {
            for(var n2 = "", t2 = 0, a2 = e2.classes.length; t2 < a2; t2++){
                var r2 = e2.classes[t2], r2 = /language-(.+)/.exec(r2);
                if (r2) {
                    n2 = r2[1];
                    break;
                }
            }
            var s, i = o.languages[n2];
            i ? e2.content = o.highlight(function(e3) {
                e3 = e3.replace(l, "");
                return e3 = e3.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(e4, n3) {
                    var t3;
                    return "#" === (n3 = n3.toLowerCase())[0] ? (t3 = "x" === n3[1] ? parseInt(n3.slice(2), 16) : Number(n3.slice(1)), c(t3)) : u[n3] || e4;
                });
            }(e2.content), i, n2) : n2 && "none" !== n2 && o.plugins.autoloader && (s = "md-" + /* @__PURE__ */ new Date().valueOf() + "-" + Math.floor(1e16 * Math.random()), e2.attributes.id = s, o.plugins.autoloader.loadLanguages(n2, function() {
                var e3 = document.getElementById(s);
                e3 && (e3.innerHTML = o.highlight(e3.textContent, o.languages[n2], n2));
            }));
        }
    }), RegExp(o.languages.markup.tag.pattern.source, "gi")), u = {
        amp: "&",
        lt: "<",
        gt: ">",
        quot: '"'
    }, c = String.fromCodePoint || String.fromCharCode;
    o.languages.md = o.languages.markdown;
}($2e16598ba480dcca$export$dc7257ffb0972f87), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.graphql = {
    comment: /#.*/,
    description: {
        pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
        greedy: true,
        alias: "string",
        inside: {
            "language-markdown": {
                pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                lookbehind: true,
                inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.markdown
            }
        }
    },
    string: {
        pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
        greedy: true
    },
    number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    boolean: /\b(?:false|true)\b/,
    variable: /\$[a-z_]\w*/i,
    directive: {
        pattern: /@[a-z_]\w*/i,
        alias: "function"
    },
    "attr-name": {
        pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
        greedy: true
    },
    "atom-input": {
        pattern: /\b[A-Z]\w*Input\b/,
        alias: "class-name"
    },
    scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
    constant: /\b[A-Z][A-Z_\d]*\b/,
    "class-name": {
        pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
        lookbehind: true
    },
    fragment: {
        pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-mutation": {
        pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    "definition-query": {
        pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
        lookbehind: true,
        alias: "function"
    },
    keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
    operator: /[!=|&]|\.{3}/,
    "property-query": /\w+(?=\s*\()/,
    object: /\w+(?=\s*\{)/,
    punctuation: /[!(){}\[\]:=,]/,
    property: /\w+/
}, $2e16598ba480dcca$export$dc7257ffb0972f87.hooks.add("after-tokenize", function(e) {
    if ("graphql" === e.language) for(var i = e.tokens.filter(function(e2) {
        return "string" != typeof e2 && "comment" !== e2.type && "scalar" !== e2.type;
    }), o = 0; o < i.length;){
        var n = i[o++];
        if ("keyword" === n.type && "mutation" === n.content) {
            var t = [];
            if (p([
                "definition-mutation",
                "punctuation"
            ]) && "(" === c(1).content) {
                o += 2;
                var a = d(/^\($/, /^\)$/);
                if (-1 === a) continue;
                for(; o < a; o++){
                    var r = c(0);
                    "variable" === r.type && (g(r, "variable-input"), t.push(r.content));
                }
                o = a + 1;
            }
            if (p([
                "punctuation",
                "property-query"
            ]) && "{" === c(0).content && (o++, g(c(0), "property-mutation"), 0 < t.length)) {
                var s = d(/^\{$/, /^\}$/);
                if (-1 !== s) for(var l = o; l < s; l++){
                    var u = i[l];
                    "variable" === u.type && 0 <= t.indexOf(u.content) && g(u, "variable-input");
                }
            }
        }
    }
    function c(e2) {
        return i[o + e2];
    }
    function p(e2, n2) {
        n2 = n2 || 0;
        for(var t2 = 0; t2 < e2.length; t2++){
            var a2 = c(t2 + n2);
            if (!a2 || a2.type !== e2[t2]) return;
        }
        return 1;
    }
    function d(e2, n2) {
        for(var t2 = 1, a2 = o; a2 < i.length; a2++){
            var r2 = i[a2], s2 = r2.content;
            if ("punctuation" === r2.type && "string" == typeof s2) {
                if (e2.test(s2)) t2++;
                else if (n2.test(s2) && 0 === --t2) return a2;
            }
        }
        return -1;
    }
    function g(e2, n2) {
        var t2 = e2.alias;
        t2 ? Array.isArray(t2) || (e2.alias = t2 = [
            t2
        ]) : e2.alias = t2 = [], t2.push(n2);
    }
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.sql = {
    comment: {
        pattern: /(^|[^\\])(?:\/\*[\s\S]*?\*\/|(?:--|\/\/|#).*)/,
        lookbehind: true
    },
    variable: [
        {
            pattern: /@(["'`])(?:\\[\s\S]|(?!\1)[^\\])+\1/,
            greedy: true
        },
        /@[\w.$]+/
    ],
    string: {
        pattern: /(^|[^@\\])("|')(?:\\[\s\S]|(?!\2)[^\\]|\2\2)*\2/,
        greedy: true,
        lookbehind: true
    },
    identifier: {
        pattern: /(^|[^@\\])`(?:\\[\s\S]|[^`\\]|``)*`/,
        greedy: true,
        lookbehind: true,
        inside: {
            punctuation: /^`|`$/
        }
    },
    function: /\b(?:AVG|COUNT|FIRST|FORMAT|LAST|LCASE|LEN|MAX|MID|MIN|MOD|NOW|ROUND|SUM|UCASE)(?=\s*\()/i,
    keyword: /\b(?:ACTION|ADD|AFTER|ALGORITHM|ALL|ALTER|ANALYZE|ANY|APPLY|AS|ASC|AUTHORIZATION|AUTO_INCREMENT|BACKUP|BDB|BEGIN|BERKELEYDB|BIGINT|BINARY|BIT|BLOB|BOOL|BOOLEAN|BREAK|BROWSE|BTREE|BULK|BY|CALL|CASCADED?|CASE|CHAIN|CHAR(?:ACTER|SET)?|CHECK(?:POINT)?|CLOSE|CLUSTERED|COALESCE|COLLATE|COLUMNS?|COMMENT|COMMIT(?:TED)?|COMPUTE|CONNECT|CONSISTENT|CONSTRAINT|CONTAINS(?:TABLE)?|CONTINUE|CONVERT|CREATE|CROSS|CURRENT(?:_DATE|_TIME|_TIMESTAMP|_USER)?|CURSOR|CYCLE|DATA(?:BASES?)?|DATE(?:TIME)?|DAY|DBCC|DEALLOCATE|DEC|DECIMAL|DECLARE|DEFAULT|DEFINER|DELAYED|DELETE|DELIMITERS?|DENY|DESC|DESCRIBE|DETERMINISTIC|DISABLE|DISCARD|DISK|DISTINCT|DISTINCTROW|DISTRIBUTED|DO|DOUBLE|DROP|DUMMY|DUMP(?:FILE)?|DUPLICATE|ELSE(?:IF)?|ENABLE|ENCLOSED|END|ENGINE|ENUM|ERRLVL|ERRORS|ESCAPED?|EXCEPT|EXEC(?:UTE)?|EXISTS|EXIT|EXPLAIN|EXTENDED|FETCH|FIELDS|FILE|FILLFACTOR|FIRST|FIXED|FLOAT|FOLLOWING|FOR(?: EACH ROW)?|FORCE|FOREIGN|FREETEXT(?:TABLE)?|FROM|FULL|FUNCTION|GEOMETRY(?:COLLECTION)?|GLOBAL|GOTO|GRANT|GROUP|HANDLER|HASH|HAVING|HOLDLOCK|HOUR|IDENTITY(?:COL|_INSERT)?|IF|IGNORE|IMPORT|INDEX|INFILE|INNER|INNODB|INOUT|INSERT|INT|INTEGER|INTERSECT|INTERVAL|INTO|INVOKER|ISOLATION|ITERATE|JOIN|KEYS?|KILL|LANGUAGE|LAST|LEAVE|LEFT|LEVEL|LIMIT|LINENO|LINES|LINESTRING|LOAD|LOCAL|LOCK|LONG(?:BLOB|TEXT)|LOOP|MATCH(?:ED)?|MEDIUM(?:BLOB|INT|TEXT)|MERGE|MIDDLEINT|MINUTE|MODE|MODIFIES|MODIFY|MONTH|MULTI(?:LINESTRING|POINT|POLYGON)|NATIONAL|NATURAL|NCHAR|NEXT|NO|NONCLUSTERED|NULLIF|NUMERIC|OFF?|OFFSETS?|ON|OPEN(?:DATASOURCE|QUERY|ROWSET)?|OPTIMIZE|OPTION(?:ALLY)?|ORDER|OUT(?:ER|FILE)?|OVER|PARTIAL|PARTITION|PERCENT|PIVOT|PLAN|POINT|POLYGON|PRECEDING|PRECISION|PREPARE|PREV|PRIMARY|PRINT|PRIVILEGES|PROC(?:EDURE)?|PUBLIC|PURGE|QUICK|RAISERROR|READS?|REAL|RECONFIGURE|REFERENCES|RELEASE|RENAME|REPEAT(?:ABLE)?|REPLACE|REPLICATION|REQUIRE|RESIGNAL|RESTORE|RESTRICT|RETURN(?:ING|S)?|REVOKE|RIGHT|ROLLBACK|ROUTINE|ROW(?:COUNT|GUIDCOL|S)?|RTREE|RULE|SAVE(?:POINT)?|SCHEMA|SECOND|SELECT|SERIAL(?:IZABLE)?|SESSION(?:_USER)?|SET(?:USER)?|SHARE|SHOW|SHUTDOWN|SIMPLE|SMALLINT|SNAPSHOT|SOME|SONAME|SQL|START(?:ING)?|STATISTICS|STATUS|STRIPED|SYSTEM_USER|TABLES?|TABLESPACE|TEMP(?:ORARY|TABLE)?|TERMINATED|TEXT(?:SIZE)?|THEN|TIME(?:STAMP)?|TINY(?:BLOB|INT|TEXT)|TOP?|TRAN(?:SACTIONS?)?|TRIGGER|TRUNCATE|TSEQUAL|TYPES?|UNBOUNDED|UNCOMMITTED|UNDEFINED|UNION|UNIQUE|UNLOCK|UNPIVOT|UNSIGNED|UPDATE(?:TEXT)?|USAGE|USE|USER|USING|VALUES?|VAR(?:BINARY|CHAR|CHARACTER|YING)|VIEW|WAITFOR|WARNINGS|WHEN|WHERE|WHILE|WITH(?: ROLLUP|IN)?|WORK|WRITE(?:TEXT)?|YEAR)\b/i,
    boolean: /\b(?:FALSE|NULL|TRUE)\b/i,
    number: /\b0x[\da-f]+\b|\b\d+(?:\.\d*)?|\B\.\d+\b/i,
    operator: /[-+*\/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?|\b(?:AND|BETWEEN|DIV|ILIKE|IN|IS|LIKE|NOT|OR|REGEXP|RLIKE|SOUNDS LIKE|XOR)\b/i,
    punctuation: /[;[\]()`,.]/
}, function(b) {
    var e = b.languages.javascript["template-string"], t = e.pattern.source, m = e.inside.interpolation, f = m.inside["interpolation-punctuation"], s = m.pattern.source;
    function n(e2, n2) {
        if (b.languages[e2]) return {
            pattern: RegExp("((?:" + n2 + ")\\s*)" + t),
            lookbehind: true,
            greedy: true,
            inside: {
                "template-punctuation": {
                    pattern: /^`|`$/,
                    alias: "string"
                },
                "embedded-code": {
                    pattern: /[\s\S]+/,
                    alias: e2
                }
            }
        };
    }
    function h(e2, n2, t2) {
        e2 = {
            code: e2,
            grammar: n2,
            language: t2
        };
        return b.hooks.run("before-tokenize", e2), e2.tokens = b.tokenize(e2.code, e2.grammar), b.hooks.run("after-tokenize", e2), e2.tokens;
    }
    function l(a2, e2, r) {
        var n2 = b.tokenize(a2, {
            interpolation: {
                pattern: RegExp(s),
                lookbehind: true
            }
        }), p = 0, d = {}, n2 = h(n2.map(function(e3) {
            if ("string" == typeof e3) return e3;
            for(var n3, t2, e3 = e3.content; -1 !== a2.indexOf((t2 = p++, n3 = "___" + r.toUpperCase() + "_" + t2 + "___")););
            return d[n3] = e3, n3;
        }).join(""), e2, r), g = Object.keys(d);
        return p = 0, function e3(n3) {
            for(var t2 = 0; t2 < n3.length; t2++){
                if (p >= g.length) return;
                var a3, r2, s2, i, o, l2, u2, c = n3[t2];
                "string" == typeof c || "string" == typeof c.content ? (a3 = g[p], -1 !== (u2 = (l2 = "string" == typeof c ? c : c.content).indexOf(a3)) && (++p, r2 = l2.substring(0, u2), o = d[a3], s2 = void 0, (i = {})["interpolation-punctuation"] = f, 3 === (i = b.tokenize(o, i)).length && ((s2 = [
                    1,
                    1
                ]).push.apply(s2, h(i[1], b.languages.javascript, "javascript")), i.splice.apply(i, s2)), s2 = new b.Token("interpolation", i, m.alias, o), i = l2.substring(u2 + a3.length), o = [], r2 && o.push(r2), o.push(s2), i && (e3(l2 = [
                    i
                ]), o.push.apply(o, l2)), "string" == typeof c ? (n3.splice.apply(n3, [
                    t2,
                    1
                ].concat(o)), t2 += o.length - 1) : c.content = o)) : (u2 = c.content, Array.isArray(u2) ? e3(u2) : e3([
                    u2
                ]));
            }
        }(n2), new b.Token(r, n2, "language-" + r, a2);
    }
    b.languages.javascript["template-string"] = [
        n("css", /\b(?:styled(?:\([^)]*\))?(?:\s*\.\s*\w+(?:\([^)]*\))*)*|css(?:\s*\.\s*(?:global|resolve))?|createGlobalStyle|keyframes)/.source),
        n("html", /\bhtml|\.\s*(?:inner|outer)HTML\s*\+?=/.source),
        n("svg", /\bsvg/.source),
        n("markdown", /\b(?:markdown|md)/.source),
        n("graphql", /\b(?:gql|graphql(?:\s*\.\s*experimental)?)/.source),
        n("sql", /\bsql/.source),
        e
    ].filter(Boolean);
    var a = {
        javascript: true,
        js: true,
        typescript: true,
        ts: true,
        jsx: true,
        tsx: true
    };
    function u(e2) {
        return "string" == typeof e2 ? e2 : Array.isArray(e2) ? e2.map(u).join("") : u(e2.content);
    }
    b.hooks.add("after-tokenize", function(e2) {
        e2.language in a && !function e3(n2) {
            for(var t2 = 0, a2 = n2.length; t2 < a2; t2++){
                var r, s2, i, o = n2[t2];
                "string" != typeof o && (r = o.content, Array.isArray(r) ? "template-string" === o.type ? (o = r[1], 3 === r.length && "string" != typeof o && "embedded-code" === o.type && (s2 = u(o), o = o.alias, o = Array.isArray(o) ? o[0] : o, i = b.languages[o]) && (r[1] = l(s2, i, o))) : e3(r) : "string" != typeof r && e3([
                    r
                ]));
            }
        }(e2.tokens);
    });
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(e) {
    e.languages.typescript = e.languages.extend("javascript", {
        "class-name": {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null
        },
        builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    }), e.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete e.languages.typescript.parameter, delete e.languages.typescript["literal-property"];
    var n = e.languages.extend("typescript", {});
    delete n["class-name"], e.languages.typescript["class-name"].inside = n, e.languages.insertBefore("typescript", "function", {
        decorator: {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                at: {
                    pattern: /^@/,
                    alias: "operator"
                },
                function: /^[\s\S]+/
            }
        },
        "generic-function": {
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: n
                }
            }
        }
    }), e.languages.ts = e.languages.typescript;
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(e) {
    var n = e.languages.javascript, t = /\{(?:[^{}]|\{(?:[^{}]|\{[^{}]*\})*\})+\}/.source, a = "(@(?:arg|argument|param|property)\\s+(?:" + t + "\\s+)?)";
    e.languages.jsdoc = e.languages.extend("javadoclike", {
        parameter: {
            pattern: RegExp(a + /(?:(?!\s)[$\w\xA0-\uFFFF.])+(?=\s|$)/.source),
            lookbehind: true,
            inside: {
                punctuation: /\./
            }
        }
    }), e.languages.insertBefore("jsdoc", "keyword", {
        "optional-parameter": {
            pattern: RegExp(a + /\[(?:(?!\s)[$\w\xA0-\uFFFF.])+(?:=[^[\]]+)?\](?=\s|$)/.source),
            lookbehind: true,
            inside: {
                parameter: {
                    pattern: /(^\[)[$\w\xA0-\uFFFF\.]+/,
                    lookbehind: true,
                    inside: {
                        punctuation: /\./
                    }
                },
                code: {
                    pattern: /(=)[\s\S]*(?=\]$)/,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                },
                punctuation: /[=[\]]/
            }
        },
        "class-name": [
            {
                pattern: RegExp(/(@(?:augments|class|extends|interface|memberof!?|template|this|typedef)\s+(?:<TYPE>\s+)?)[A-Z]\w*(?:\.[A-Z]\w*)*/.source.replace(/<TYPE>/g, function() {
                    return t;
                })),
                lookbehind: true,
                inside: {
                    punctuation: /\./
                }
            },
            {
                pattern: RegExp("(@[a-z]+\\s+)" + t),
                lookbehind: true,
                inside: {
                    string: n.string,
                    number: n.number,
                    boolean: n.boolean,
                    keyword: e.languages.typescript.keyword,
                    operator: /=>|\.\.\.|[&|?:*]/,
                    punctuation: /[.,;=<>{}()[\]]/
                }
            }
        ],
        example: {
            pattern: /(@example\s+(?!\s))(?:[^@\s]|\s+(?!\s))+?(?=\s*(?:\*\s*)?(?:@\w|\*\/))/,
            lookbehind: true,
            inside: {
                code: {
                    pattern: /^([\t ]*(?:\*\s*)?)\S.*$/m,
                    lookbehind: true,
                    inside: n,
                    alias: "language-javascript"
                }
            }
        }
    }), e.languages.javadoclike.addSupport("javascript", e.languages.jsdoc);
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(e) {
    e.languages.flow = e.languages.extend("javascript", {}), e.languages.insertBefore("flow", "keyword", {
        type: [
            {
                pattern: /\b(?:[Bb]oolean|Function|[Nn]umber|[Ss]tring|[Ss]ymbol|any|mixed|null|void)\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.flow["function-variable"].pattern = /(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=\s*(?:function\b|(?:\([^()]*\)(?:\s*:\s*\w+)?|(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/i, delete e.languages.flow.parameter, e.languages.insertBefore("flow", "operator", {
        "flow-punctuation": {
            pattern: /\{\||\|\}/,
            alias: "punctuation"
        }
    }), Array.isArray(e.languages.flow.keyword) || (e.languages.flow.keyword = [
        e.languages.flow.keyword
    ]), e.languages.flow.keyword.unshift({
        pattern: /(^|[^$]\b)(?:Class|declare|opaque|type)\b(?!\$)/,
        lookbehind: true
    }, {
        pattern: /(^|[^$]\B)\$(?:Diff|Enum|Exact|Keys|ObjMap|PropertyType|Record|Shape|Subtype|Supertype|await)\b(?!\$)/,
        lookbehind: true
    });
}($2e16598ba480dcca$export$dc7257ffb0972f87), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.n4js = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.extend("javascript", {
    keyword: /\b(?:Array|any|boolean|break|case|catch|class|const|constructor|continue|debugger|declare|default|delete|do|else|enum|export|extends|false|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|module|new|null|number|package|private|protected|public|return|set|static|string|super|switch|this|throw|true|try|typeof|var|void|while|with|yield)\b/
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("n4js", "constant", {
    annotation: {
        pattern: /@+\w+/,
        alias: "operator"
    }
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.n4jsd = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.n4js, function(e) {
    function n(e2, n2) {
        return RegExp(e2.replace(/<ID>/g, function() {
            return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
        }), n2);
    }
    e.languages.insertBefore("javascript", "function-variable", {
        "method-variable": {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript["function-variable"].pattern.source),
            lookbehind: true,
            alias: [
                "function-variable",
                "method",
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "function", {
        method: {
            pattern: RegExp("(\\.\\s*)" + e.languages.javascript.function.source),
            lookbehind: true,
            alias: [
                "function",
                "property-access"
            ]
        }
    }), e.languages.insertBefore("javascript", "constant", {
        "known-class-name": [
            {
                pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                alias: "class-name"
            },
            {
                pattern: /\b(?:[A-Z]\w*)Error\b/,
                alias: "class-name"
            }
        ]
    }), e.languages.insertBefore("javascript", "keyword", {
        imports: {
            pattern: n(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
            lookbehind: true,
            inside: e.languages.javascript
        },
        exports: {
            pattern: n(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
            lookbehind: true,
            inside: e.languages.javascript
        }
    }), e.languages.javascript.keyword.unshift({
        pattern: /\b(?:as|default|export|from|import)\b/,
        alias: "module"
    }, {
        pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
        alias: "control-flow"
    }, {
        pattern: /\bnull\b/,
        alias: [
            "null",
            "nil"
        ]
    }, {
        pattern: /\bundefined\b/,
        alias: "nil"
    }), e.languages.insertBefore("javascript", "operator", {
        spread: {
            pattern: /\.{3}/,
            alias: "operator"
        },
        arrow: {
            pattern: /=>/,
            alias: "operator"
        }
    }), e.languages.insertBefore("javascript", "punctuation", {
        "property-access": {
            pattern: n(/(\.\s*)#?<ID>/.source),
            lookbehind: true
        },
        "maybe-class-name": {
            pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
            lookbehind: true
        },
        dom: {
            pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
            alias: "variable"
        },
        console: {
            pattern: /\bconsole(?=\s*\.)/,
            alias: "class-name"
        }
    });
    for(var t = [
        "function",
        "function-variable",
        "method",
        "method-variable",
        "property-access"
    ], a = 0; a < t.length; a++){
        var r = t[a], s = e.languages.javascript[r], r = (s = "RegExp" === e.util.type(s) ? e.languages.javascript[r] = {
            pattern: s
        } : s).inside || {};
        (s.inside = r)["maybe-class-name"] = /^[A-Z][\s\S]*/;
    }
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(s) {
    var e = s.util.clone(s.languages.javascript), t = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, a = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, r = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    function n(e2, n2) {
        return e2 = e2.replace(/<S>/g, function() {
            return t;
        }).replace(/<BRACES>/g, function() {
            return a;
        }).replace(/<SPREAD>/g, function() {
            return r;
        }), RegExp(e2, n2);
    }
    r = n(r).source, s.languages.jsx = s.languages.extend("markup", e), s.languages.jsx.tag.pattern = n(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), s.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, s.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, s.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, s.languages.jsx.tag.inside.comment = e.comment, s.languages.insertBefore("inside", "attr-name", {
        spread: {
            pattern: n(/<SPREAD>/.source),
            inside: s.languages.jsx
        }
    }, s.languages.jsx.tag), s.languages.insertBefore("inside", "special-attr", {
        script: {
            pattern: n(/=<BRACES>/.source),
            alias: "language-javascript",
            inside: {
                "script-punctuation": {
                    pattern: /^=(?=\{)/,
                    alias: "punctuation"
                },
                rest: s.languages.jsx
            }
        }
    }, s.languages.jsx.tag);
    function i(e2) {
        for(var n2 = [], t2 = 0; t2 < e2.length; t2++){
            var a2 = e2[t2], r2 = false;
            "string" != typeof a2 && ("tag" === a2.type && a2.content[0] && "tag" === a2.content[0].type ? "</" === a2.content[0].content[0].content ? 0 < n2.length && n2[n2.length - 1].tagName === o(a2.content[0].content[1]) && n2.pop() : "/>" !== a2.content[a2.content.length - 1].content && n2.push({
                tagName: o(a2.content[0].content[1]),
                openedBraces: 0
            }) : 0 < n2.length && "punctuation" === a2.type && "{" === a2.content ? n2[n2.length - 1].openedBraces++ : 0 < n2.length && 0 < n2[n2.length - 1].openedBraces && "punctuation" === a2.type && "}" === a2.content ? n2[n2.length - 1].openedBraces-- : r2 = true), (r2 || "string" == typeof a2) && 0 < n2.length && 0 === n2[n2.length - 1].openedBraces && (r2 = o(a2), t2 < e2.length - 1 && ("string" == typeof e2[t2 + 1] || "plain-text" === e2[t2 + 1].type) && (r2 += o(e2[t2 + 1]), e2.splice(t2 + 1, 1)), 0 < t2 && ("string" == typeof e2[t2 - 1] || "plain-text" === e2[t2 - 1].type) && (r2 = o(e2[t2 - 1]) + r2, e2.splice(t2 - 1, 1), t2--), e2[t2] = new s.Token("plain-text", r2, null, r2)), a2.content && "string" != typeof a2.content && i(a2.content);
        }
    }
    var o = function(e2) {
        return e2 ? "string" == typeof e2 ? e2 : "string" == typeof e2.content ? e2.content : e2.content.map(o).join("") : "";
    };
    s.hooks.add("after-tokenize", function(e2) {
        "jsx" !== e2.language && "tsx" !== e2.language || i(e2.tokens);
    });
}($2e16598ba480dcca$export$dc7257ffb0972f87), function(e) {
    var n = e.util.clone(e.languages.typescript), n = (e.languages.tsx = e.languages.extend("jsx", n), delete e.languages.tsx.parameter, delete e.languages.tsx["literal-property"], e.languages.tsx.tag);
    n.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + n.pattern.source + ")", n.pattern.flags), n.lookbehind = true;
}($2e16598ba480dcca$export$dc7257ffb0972f87), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.swift = {
    comment: {
        pattern: /(^|[^\\:])(?:\/\/.*|\/\*(?:[^/*]|\/(?!\*)|\*(?!\/)|\/\*(?:[^*]|\*(?!\/))*\*\/)*\*\/)/,
        lookbehind: true,
        greedy: true
    },
    "string-literal": [
        {
            pattern: RegExp(/(^|[^"#])/.source + "(?:" + /"(?:\\(?:\((?:[^()]|\([^()]*\))*\)|\r\n|[^(])|[^\\\r\n"])*"/.source + "|" + /"""(?:\\(?:\((?:[^()]|\([^()]*\))*\)|[^(])|[^\\"]|"(?!""))*"""/.source + ")" + /(?!["#])/.source),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\\($/,
                    alias: "punctuation"
                },
                punctuation: /\\(?=[\r\n])/,
                string: /[\s\S]+/
            }
        },
        {
            pattern: RegExp(/(^|[^"#])(#+)/.source + "(?:" + /"(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|\r\n|[^#])|[^\\\r\n])*?"/.source + "|" + /"""(?:\\(?:#+\((?:[^()]|\([^()]*\))*\)|[^#])|[^\\])*?"""/.source + ")\\2"),
            lookbehind: true,
            greedy: true,
            inside: {
                interpolation: {
                    pattern: /(\\#+\()(?:[^()]|\([^()]*\))*(?=\))/,
                    lookbehind: true,
                    inside: null
                },
                "interpolation-punctuation": {
                    pattern: /^\)|\\#+\($/,
                    alias: "punctuation"
                },
                string: /[\s\S]+/
            }
        }
    ],
    directive: {
        pattern: RegExp(/#/.source + "(?:" + /(?:elseif|if)\b/.source + "(?:[ 	]*" + /(?:![ \t]*)?(?:\b\w+\b(?:[ \t]*\((?:[^()]|\([^()]*\))*\))?|\((?:[^()]|\([^()]*\))*\))(?:[ \t]*(?:&&|\|\|))?/.source + ")+|" + /(?:else|endif)\b/.source + ")"),
        alias: "property",
        inside: {
            "directive-name": /^#\w+/,
            boolean: /\b(?:false|true)\b/,
            number: /\b\d+(?:\.\d+)*\b/,
            operator: /!|&&|\|\||[<>]=?/,
            punctuation: /[(),]/
        }
    },
    literal: {
        pattern: /#(?:colorLiteral|column|dsohandle|file(?:ID|Literal|Path)?|function|imageLiteral|line)\b/,
        alias: "constant"
    },
    "other-directive": {
        pattern: /#\w+\b/,
        alias: "property"
    },
    attribute: {
        pattern: /@\w+/,
        alias: "atrule"
    },
    "function-definition": {
        pattern: /(\bfunc\s+)\w+/,
        lookbehind: true,
        alias: "function"
    },
    label: {
        pattern: /\b(break|continue)\s+\w+|\b[a-zA-Z_]\w*(?=\s*:\s*(?:for|repeat|while)\b)/,
        lookbehind: true,
        alias: "important"
    },
    keyword: /\b(?:Any|Protocol|Self|Type|actor|as|assignment|associatedtype|associativity|async|await|break|case|catch|class|continue|convenience|default|defer|deinit|didSet|do|dynamic|else|enum|extension|fallthrough|fileprivate|final|for|func|get|guard|higherThan|if|import|in|indirect|infix|init|inout|internal|is|isolated|lazy|left|let|lowerThan|mutating|none|nonisolated|nonmutating|open|operator|optional|override|postfix|precedencegroup|prefix|private|protocol|public|repeat|required|rethrows|return|right|safe|self|set|some|static|struct|subscript|super|switch|throw|throws|try|typealias|unowned|unsafe|var|weak|where|while|willSet)\b/,
    boolean: /\b(?:false|true)\b/,
    nil: {
        pattern: /\bnil\b/,
        alias: "constant"
    },
    "short-argument": /\$\d+\b/,
    omit: {
        pattern: /\b_\b/,
        alias: "keyword"
    },
    number: /\b(?:[\d_]+(?:\.[\de_]+)?|0x[a-f0-9_]+(?:\.[a-f0-9p_]+)?|0b[01_]+|0o[0-7_]+)\b/i,
    "class-name": /\b[A-Z](?:[A-Z_\d]*[a-z]\w*)?\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    constant: /\b(?:[A-Z_]{2,}|k[A-Z][A-Za-z_]+)\b/,
    operator: /[-+*/%=!<>&|^~?]+|\.[.\-+*/%=!<>&|^~?]+/,
    punctuation: /[{}[\]();,.:\\]/
}, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.swift["string-literal"].forEach(function(e) {
    e.inside.interpolation.inside = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.swift;
}), function(e) {
    e.languages.kotlin = e.languages.extend("clike", {
        keyword: {
            pattern: /(^|[^.])\b(?:abstract|actual|annotation|as|break|by|catch|class|companion|const|constructor|continue|crossinline|data|do|dynamic|else|enum|expect|external|final|finally|for|fun|get|if|import|in|infix|init|inline|inner|interface|internal|is|lateinit|noinline|null|object|open|operator|out|override|package|private|protected|public|reified|return|sealed|set|super|suspend|tailrec|this|throw|to|try|typealias|val|var|vararg|when|where|while)\b/,
            lookbehind: true
        },
        function: [
            {
                pattern: /(?:`[^\r\n`]+`|\b\w+)(?=\s*\()/,
                greedy: true
            },
            {
                pattern: /(\.)(?:`[^\r\n`]+`|\w+)(?=\s*\{)/,
                lookbehind: true,
                greedy: true
            }
        ],
        number: /\b(?:0[xX][\da-fA-F]+(?:_[\da-fA-F]+)*|0[bB][01]+(?:_[01]+)*|\d+(?:_\d+)*(?:\.\d+(?:_\d+)*)?(?:[eE][+-]?\d+(?:_\d+)*)?[fFL]?)\b/,
        operator: /\+[+=]?|-[-=>]?|==?=?|!(?:!|==?)?|[\/*%<>]=?|[?:]:?|\.\.|&&|\|\||\b(?:and|inv|or|shl|shr|ushr|xor)\b/
    }), delete e.languages.kotlin["class-name"];
    var n = {
        "interpolation-punctuation": {
            pattern: /^\$\{?|\}$/,
            alias: "punctuation"
        },
        expression: {
            pattern: /[\s\S]+/,
            inside: e.languages.kotlin
        }
    };
    e.languages.insertBefore("kotlin", "string", {
        "string-literal": [
            {
                pattern: /"""(?:[^$]|\$(?:(?!\{)|\{[^{}]*\}))*?"""/,
                alias: "multiline",
                inside: {
                    interpolation: {
                        pattern: /\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            },
            {
                pattern: /"(?:[^"\\\r\n$]|\\.|\$(?:(?!\{)|\{[^{}]*\}))*"/,
                alias: "singleline",
                inside: {
                    interpolation: {
                        pattern: /((?:^|[^\\])(?:\\{2})*)\$(?:[a-z_]\w*|\{[^{}]*\})/i,
                        lookbehind: true,
                        inside: n
                    },
                    string: /[\s\S]+/
                }
            }
        ],
        char: {
            pattern: /'(?:[^'\\\r\n]|\\(?:.|u[a-fA-F0-9]{0,4}))'/,
            greedy: true
        }
    }), delete e.languages.kotlin.string, e.languages.insertBefore("kotlin", "keyword", {
        annotation: {
            pattern: /\B@(?:\w+:)?(?:[A-Z]\w*|\[[^\]]+\])/,
            alias: "builtin"
        }
    }), e.languages.insertBefore("kotlin", "function", {
        label: {
            pattern: /\b\w+@|@\w+\b/,
            alias: "symbol"
        }
    }), e.languages.kt = e.languages.kotlin, e.languages.kts = e.languages.kotlin;
}($2e16598ba480dcca$export$dc7257ffb0972f87), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.c = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.extend("clike", {
    comment: {
        pattern: /\/\/(?:[^\r\n\\]|\\(?:\r\n?|\n|(?![\r\n])))*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    "class-name": {
        pattern: /(\b(?:enum|struct)\s+(?:__attribute__\s*\(\([\s\S]*?\)\)\s*)?)\w+|\b[a-z]\w*_t\b/,
        lookbehind: true
    },
    keyword: /\b(?:_Alignas|_Alignof|_Atomic|_Bool|_Complex|_Generic|_Imaginary|_Noreturn|_Static_assert|_Thread_local|__attribute__|asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|inline|int|long|register|return|short|signed|sizeof|static|struct|switch|typedef|typeof|union|unsigned|void|volatile|while)\b/,
    function: /\b[a-z_]\w*(?=\s*\()/i,
    number: /(?:\b0x(?:[\da-f]+(?:\.[\da-f]*)?|\.[\da-f]+)(?:p[+-]?\d+)?|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?)[ful]{0,4}/i,
    operator: />>=?|<<=?|->|([-+&|:])\1|[?:~]|[-+*/%&|^!=<>]=?/
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    char: {
        pattern: /'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n]){0,32}'/,
        greedy: true
    }
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("c", "string", {
    macro: {
        pattern: /(^[\t ]*)#\s*[a-z](?:[^\r\n\\/]|\/(?!\*)|\/\*(?:[^*]|\*(?!\/))*\*\/|\\(?:\r\n|[\s\S]))*/im,
        lookbehind: true,
        greedy: true,
        alias: "property",
        inside: {
            string: [
                {
                    pattern: /^(#\s*include\s*)<[^>]+>/,
                    lookbehind: true
                },
                $2e16598ba480dcca$export$dc7257ffb0972f87.languages.c.string
            ],
            char: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.c.char,
            comment: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.c.comment,
            "macro-name": [
                {
                    pattern: /(^#\s*define\s+)\w+\b(?!\()/i,
                    lookbehind: true
                },
                {
                    pattern: /(^#\s*define\s+)\w+\b(?=\()/i,
                    lookbehind: true,
                    alias: "function"
                }
            ],
            directive: {
                pattern: /^(#\s*)[a-z]+/,
                lookbehind: true,
                alias: "keyword"
            },
            "directive-hash": /^#/,
            punctuation: /##|\\(?=[\r\n])/,
            expression: {
                pattern: /\S[\s\S]*/,
                inside: $2e16598ba480dcca$export$dc7257ffb0972f87.languages.c
            }
        }
    }
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("c", "function", {
    constant: /\b(?:EOF|NULL|SEEK_CUR|SEEK_END|SEEK_SET|__DATE__|__FILE__|__LINE__|__TIMESTAMP__|__TIME__|__func__|stderr|stdin|stdout)\b/
}), delete $2e16598ba480dcca$export$dc7257ffb0972f87.languages.c.boolean, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.objectivec = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.extend("c", {
    string: {
        pattern: /@?"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"/,
        greedy: true
    },
    keyword: /\b(?:asm|auto|break|case|char|const|continue|default|do|double|else|enum|extern|float|for|goto|if|in|inline|int|long|register|return|self|short|signed|sizeof|static|struct|super|switch|typedef|typeof|union|unsigned|void|volatile|while)\b|(?:@interface|@end|@implementation|@protocol|@class|@public|@protected|@private|@property|@try|@catch|@finally|@throw|@synthesize|@dynamic|@selector)\b/,
    operator: /-[->]?|\+\+?|!=?|<<?=?|>>?=?|==?|&&?|\|\|?|[~^%?*\/@]/
}), delete $2e16598ba480dcca$export$dc7257ffb0972f87.languages.objectivec["class-name"], $2e16598ba480dcca$export$dc7257ffb0972f87.languages.objc = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.objectivec, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.reason = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /"(?:\\(?:\r\n|[\s\S])|[^\\\r\n"])*"/,
        greedy: true
    },
    "class-name": /\b[A-Z]\w*/,
    keyword: /\b(?:and|as|assert|begin|class|constraint|do|done|downto|else|end|exception|external|for|fun|function|functor|if|in|include|inherit|initializer|lazy|let|method|module|mutable|new|nonrec|object|of|open|or|private|rec|sig|struct|switch|then|to|try|type|val|virtual|when|while|with)\b/,
    operator: /\.{3}|:[:=]|\|>|->|=(?:==?|>)?|<=?|>=?|[|^?'#!~`]|[+\-*\/]\.?|\b(?:asr|land|lor|lsl|lsr|lxor|mod)\b/
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("reason", "class-name", {
    char: {
        pattern: /'(?:\\x[\da-f]{2}|\\o[0-3][0-7][0-7]|\\\d{3}|\\.|[^'\\\r\n])'/,
        greedy: true
    },
    constructor: /\b[A-Z]\w*\b(?!\s*\.)/,
    label: {
        pattern: /\b[a-z]\w*(?=::)/,
        alias: "symbol"
    }
}), delete $2e16598ba480dcca$export$dc7257ffb0972f87.languages.reason.function, function(e) {
    for(var n = /\/\*(?:[^*/]|\*(?!\/)|\/(?!\*)|<self>)*\*\//.source, t = 0; t < 2; t++)n = n.replace(/<self>/g, function() {
        return n;
    });
    n = n.replace(/<self>/g, function() {
        return /[^\s\S]/.source;
    }), e.languages.rust = {
        comment: [
            {
                pattern: RegExp(/(^|[^\\])/.source + n),
                lookbehind: true,
                greedy: true
            },
            {
                pattern: /(^|[^\\:])\/\/.*/,
                lookbehind: true,
                greedy: true
            }
        ],
        string: {
            pattern: /b?"(?:\\[\s\S]|[^\\"])*"|b?r(#*)"(?:[^"]|"(?!\1))*"\1/,
            greedy: true
        },
        char: {
            pattern: /b?'(?:\\(?:x[0-7][\da-fA-F]|u\{(?:[\da-fA-F]_*){1,6}\}|.)|[^\\\r\n\t'])'/,
            greedy: true
        },
        attribute: {
            pattern: /#!?\[(?:[^\[\]"]|"(?:\\[\s\S]|[^\\"])*")*\]/,
            greedy: true,
            alias: "attr-name",
            inside: {
                string: null
            }
        },
        "closure-params": {
            pattern: /([=(,:]\s*|\bmove\s*)\|[^|]*\||\|[^|]*\|(?=\s*(?:\{|->))/,
            lookbehind: true,
            greedy: true,
            inside: {
                "closure-punctuation": {
                    pattern: /^\||\|$/,
                    alias: "punctuation"
                },
                rest: null
            }
        },
        "lifetime-annotation": {
            pattern: /'\w+/,
            alias: "symbol"
        },
        "fragment-specifier": {
            pattern: /(\$\w+:)[a-z]+/,
            lookbehind: true,
            alias: "punctuation"
        },
        variable: /\$\w+/,
        "function-definition": {
            pattern: /(\bfn\s+)\w+/,
            lookbehind: true,
            alias: "function"
        },
        "type-definition": {
            pattern: /(\b(?:enum|struct|trait|type|union)\s+)\w+/,
            lookbehind: true,
            alias: "class-name"
        },
        "module-declaration": [
            {
                pattern: /(\b(?:crate|mod)\s+)[a-z][a-z_\d]*/,
                lookbehind: true,
                alias: "namespace"
            },
            {
                pattern: /(\b(?:crate|self|super)\s*)::\s*[a-z][a-z_\d]*\b(?:\s*::(?:\s*[a-z][a-z_\d]*\s*::)*)?/,
                lookbehind: true,
                alias: "namespace",
                inside: {
                    punctuation: /::/
                }
            }
        ],
        keyword: [
            /\b(?:Self|abstract|as|async|await|become|box|break|const|continue|crate|do|dyn|else|enum|extern|final|fn|for|if|impl|in|let|loop|macro|match|mod|move|mut|override|priv|pub|ref|return|self|static|struct|super|trait|try|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
            /\b(?:bool|char|f(?:32|64)|[ui](?:8|16|32|64|128|size)|str)\b/
        ],
        function: /\b[a-z_]\w*(?=\s*(?:::\s*<|\())/,
        macro: {
            pattern: /\b\w+!/,
            alias: "property"
        },
        constant: /\b[A-Z_][A-Z_\d]+\b/,
        "class-name": /\b[A-Z]\w*\b/,
        namespace: {
            pattern: /(?:\b[a-z][a-z_\d]*\s*::\s*)*\b[a-z][a-z_\d]*\s*::(?!\s*<)/,
            inside: {
                punctuation: /::/
            }
        },
        number: /\b(?:0x[\dA-Fa-f](?:_?[\dA-Fa-f])*|0o[0-7](?:_?[0-7])*|0b[01](?:_?[01])*|(?:(?:\d(?:_?\d)*)?\.)?\d(?:_?\d)*(?:[Ee][+-]?\d+)?)(?:_?(?:f32|f64|[iu](?:8|16|32|64|size)?))?\b/,
        boolean: /\b(?:false|true)\b/,
        punctuation: /->|\.\.=|\.{1,3}|::|[{}[\];(),:]/,
        operator: /[-+*\/%!^]=?|=[=>]?|&[&=]?|\|[|=]?|<<?=?|>>?=?|[@?]/
    }, e.languages.rust["closure-params"].inside.rest = e.languages.rust, e.languages.rust.attribute.inside.string = e.languages.rust.string;
}($2e16598ba480dcca$export$dc7257ffb0972f87), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.go = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.extend("clike", {
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^"\\\r\n])*"|`[^`]*`/,
        lookbehind: true,
        greedy: true
    },
    keyword: /\b(?:break|case|chan|const|continue|default|defer|else|fallthrough|for|func|go(?:to)?|if|import|interface|map|package|range|return|select|struct|switch|type|var)\b/,
    boolean: /\b(?:_|false|iota|nil|true)\b/,
    number: [
        /\b0(?:b[01_]+|o[0-7_]+)i?\b/i,
        /\b0x(?:[a-f\d_]+(?:\.[a-f\d_]*)?|\.[a-f\d_]+)(?:p[+-]?\d+(?:_\d+)*)?i?(?!\w)/i,
        /(?:\b\d[\d_]*(?:\.[\d_]*)?|\B\.\d[\d_]*)(?:e[+-]?[\d_]+)?i?(?!\w)/i
    ],
    operator: /[*\/%^!=]=?|\+[=+]?|-[=-]?|\|[=|]?|&(?:=|&|\^=?)?|>(?:>=?|=)?|<(?:<=?|=|-)?|:=|\.\.\./,
    builtin: /\b(?:append|bool|byte|cap|close|complex|complex(?:64|128)|copy|delete|error|float(?:32|64)|u?int(?:8|16|32|64)?|imag|len|make|new|panic|print(?:ln)?|real|recover|rune|string|uintptr)\b/
}), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.insertBefore("go", "string", {
    char: {
        pattern: /'(?:\\.|[^'\\\r\n]){0,10}'/,
        greedy: true
    }
}), delete $2e16598ba480dcca$export$dc7257ffb0972f87.languages.go["class-name"], function(e) {
    var n = /\b(?:alignas|alignof|asm|auto|bool|break|case|catch|char|char16_t|char32_t|char8_t|class|co_await|co_return|co_yield|compl|concept|const|const_cast|consteval|constexpr|constinit|continue|decltype|default|delete|do|double|dynamic_cast|else|enum|explicit|export|extern|final|float|for|friend|goto|if|import|inline|int|int16_t|int32_t|int64_t|int8_t|long|module|mutable|namespace|new|noexcept|nullptr|operator|override|private|protected|public|register|reinterpret_cast|requires|return|short|signed|sizeof|static|static_assert|static_cast|struct|switch|template|this|thread_local|throw|try|typedef|typeid|typename|uint16_t|uint32_t|uint64_t|uint8_t|union|unsigned|using|virtual|void|volatile|wchar_t|while)\b/, t = /\b(?!<keyword>)\w+(?:\s*\.\s*\w+)*\b/.source.replace(/<keyword>/g, function() {
        return n.source;
    });
    e.languages.cpp = e.languages.extend("c", {
        "class-name": [
            {
                pattern: RegExp(/(\b(?:class|concept|enum|struct|typename)\s+)(?!<keyword>)\w+/.source.replace(/<keyword>/g, function() {
                    return n.source;
                })),
                lookbehind: true
            },
            /\b[A-Z]\w*(?=\s*::\s*\w+\s*\()/,
            /\b[A-Z_]\w*(?=\s*::\s*~\w+\s*\()/i,
            /\b\w+(?=\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>\s*::\s*\w+\s*\()/
        ],
        keyword: n,
        number: {
            pattern: /(?:\b0b[01']+|\b0x(?:[\da-f']+(?:\.[\da-f']*)?|\.[\da-f']+)(?:p[+-]?[\d']+)?|(?:\b[\d']+(?:\.[\d']*)?|\B\.[\d']+)(?:e[+-]?[\d']+)?)[ful]{0,4}/i,
            greedy: true
        },
        operator: />>=?|<<=?|->|--|\+\+|&&|\|\||[?:~]|<=>|[-+*/%&|^!=<>]=?|\b(?:and|and_eq|bitand|bitor|not|not_eq|or|or_eq|xor|xor_eq)\b/,
        boolean: /\b(?:false|true)\b/
    }), e.languages.insertBefore("cpp", "string", {
        module: {
            pattern: RegExp(/(\b(?:import|module)\s+)/.source + "(?:" + /"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|<[^<>\r\n]*>/.source + "|" + /<mod-name>(?:\s*:\s*<mod-name>)?|:\s*<mod-name>/.source.replace(/<mod-name>/g, function() {
                return t;
            }) + ")"),
            lookbehind: true,
            greedy: true,
            inside: {
                string: /^[<"][\s\S]+/,
                operator: /:/,
                punctuation: /\./
            }
        },
        "raw-string": {
            pattern: /R"([^()\\ ]{0,16})\([\s\S]*?\)\1"/,
            alias: "string",
            greedy: true
        }
    }), e.languages.insertBefore("cpp", "keyword", {
        "generic-function": {
            pattern: /\b(?!operator\b)[a-z_]\w*\s*<(?:[^<>]|<[^<>]*>)*>(?=\s*\()/i,
            inside: {
                function: /^\w+/,
                generic: {
                    pattern: /<[\s\S]+/,
                    alias: "class-name",
                    inside: e.languages.cpp
                }
            }
        }
    }), e.languages.insertBefore("cpp", "operator", {
        "double-colon": {
            pattern: /::/,
            alias: "punctuation"
        }
    }), e.languages.insertBefore("cpp", "class-name", {
        "base-clause": {
            pattern: /(\b(?:class|struct)\s+\w+\s*:\s*)[^;{}"'\s]+(?:\s+[^;{}"'\s]+)*(?=\s*[;{])/,
            lookbehind: true,
            greedy: true,
            inside: e.languages.extend("cpp", {})
        }
    }), e.languages.insertBefore("inside", "double-colon", {
        "class-name": /\b[a-z_]\w*\b(?!\s*::)/i
    }, e.languages.cpp["base-clause"]);
}($2e16598ba480dcca$export$dc7257ffb0972f87), $2e16598ba480dcca$export$dc7257ffb0972f87.languages.python = {
    comment: {
        pattern: /(^|[^\\])#.*/,
        lookbehind: true,
        greedy: true
    },
    "string-interpolation": {
        pattern: /(?:f|fr|rf)(?:("""|''')[\s\S]*?\1|("|')(?:\\.|(?!\2)[^\\\r\n])*\2)/i,
        greedy: true,
        inside: {
            interpolation: {
                pattern: /((?:^|[^{])(?:\{\{)*)\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}]|\{(?!\{)(?:[^{}])+\})+\})+\}/,
                lookbehind: true,
                inside: {
                    "format-spec": {
                        pattern: /(:)[^:(){}]+(?=\}$)/,
                        lookbehind: true
                    },
                    "conversion-option": {
                        pattern: /![sra](?=[:}]$)/,
                        alias: "punctuation"
                    },
                    rest: null
                }
            },
            string: /[\s\S]+/
        }
    },
    "triple-quoted-string": {
        pattern: /(?:[rub]|br|rb)?("""|''')[\s\S]*?\1/i,
        greedy: true,
        alias: "string"
    },
    string: {
        pattern: /(?:[rub]|br|rb)?("|')(?:\\.|(?!\1)[^\\\r\n])*\1/i,
        greedy: true
    },
    function: {
        pattern: /((?:^|\s)def[ \t]+)[a-zA-Z_]\w*(?=\s*\()/g,
        lookbehind: true
    },
    "class-name": {
        pattern: /(\bclass\s+)\w+/i,
        lookbehind: true
    },
    decorator: {
        pattern: /(^[\t ]*)@\w+(?:\.\w+)*/m,
        lookbehind: true,
        alias: [
            "annotation",
            "punctuation"
        ],
        inside: {
            punctuation: /\./
        }
    },
    keyword: /\b(?:_(?=\s*:)|and|as|assert|async|await|break|case|class|continue|def|del|elif|else|except|exec|finally|for|from|global|if|import|in|is|lambda|match|nonlocal|not|or|pass|print|raise|return|try|while|with|yield)\b/,
    builtin: /\b(?:__import__|abs|all|any|apply|ascii|basestring|bin|bool|buffer|bytearray|bytes|callable|chr|classmethod|cmp|coerce|compile|complex|delattr|dict|dir|divmod|enumerate|eval|execfile|file|filter|float|format|frozenset|getattr|globals|hasattr|hash|help|hex|id|input|int|intern|isinstance|issubclass|iter|len|list|locals|long|map|max|memoryview|min|next|object|oct|open|ord|pow|property|range|raw_input|reduce|reload|repr|reversed|round|set|setattr|slice|sorted|staticmethod|str|sum|super|tuple|type|unichr|unicode|vars|xrange|zip)\b/,
    boolean: /\b(?:False|None|True)\b/,
    number: /\b0(?:b(?:_?[01])+|o(?:_?[0-7])+|x(?:_?[a-f0-9])+)\b|(?:\b\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\B\.\d+(?:_\d+)*)(?:e[+-]?\d+(?:_\d+)*)?j?(?!\w)/i,
    operator: /[-+%=]=?|!=|:=|\*\*?=?|\/\/?=?|<[<=>]?|>[=>]?|[&|^~]/,
    punctuation: /[{}[\];(),.:]/
}, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.python["string-interpolation"].inside.interpolation.inside.rest = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.python, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.py = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.python, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.json = {
    property: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
        lookbehind: true,
        greedy: true
    },
    string: {
        pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
        lookbehind: true,
        greedy: true
    },
    comment: {
        pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
        greedy: true
    },
    number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
    punctuation: /[{}[\],]/,
    operator: /:/,
    boolean: /\b(?:false|true)\b/,
    null: {
        pattern: /\bnull\b/,
        alias: "keyword"
    }
}, $2e16598ba480dcca$export$dc7257ffb0972f87.languages.webmanifest = $2e16598ba480dcca$export$dc7257ffb0972f87.languages.json;
// src/themes/index.ts
var $2e16598ba480dcca$export$d9a33280f07116d9 = {};
$2e16598ba480dcca$var$__export($2e16598ba480dcca$export$d9a33280f07116d9, {
    dracula: ()=>$2e16598ba480dcca$var$dracula_default,
    duotoneDark: ()=>$2e16598ba480dcca$var$duotoneDark_default,
    duotoneLight: ()=>$2e16598ba480dcca$var$duotoneLight_default,
    github: ()=>$2e16598ba480dcca$var$github_default,
    gruvboxMaterialDark: ()=>$2e16598ba480dcca$var$gruvboxMaterialDark_default,
    gruvboxMaterialLight: ()=>$2e16598ba480dcca$var$gruvboxMaterialLight_default,
    jettwaveDark: ()=>$2e16598ba480dcca$var$jettwaveDark_default,
    jettwaveLight: ()=>$2e16598ba480dcca$var$jettwaveLight_default,
    nightOwl: ()=>$2e16598ba480dcca$var$nightOwl_default,
    nightOwlLight: ()=>$2e16598ba480dcca$var$nightOwlLight_default,
    oceanicNext: ()=>$2e16598ba480dcca$var$oceanicNext_default,
    okaidia: ()=>$2e16598ba480dcca$var$okaidia_default,
    oneDark: ()=>$2e16598ba480dcca$var$oneDark_default,
    oneLight: ()=>$2e16598ba480dcca$var$oneLight_default,
    palenight: ()=>$2e16598ba480dcca$var$palenight_default,
    shadesOfPurple: ()=>$2e16598ba480dcca$var$shadesOfPurple_default,
    synthwave84: ()=>$2e16598ba480dcca$var$synthwave84_default,
    ultramin: ()=>$2e16598ba480dcca$var$ultramin_default,
    vsDark: ()=>$2e16598ba480dcca$var$vsDark_default,
    vsLight: ()=>$2e16598ba480dcca$var$vsLight_default
});
// src/themes/dracula.ts
var $2e16598ba480dcca$var$theme = {
    plain: {
        color: "#F8F8F2",
        backgroundColor: "#282A36"
    },
    styles: [
        {
            types: [
                "prolog",
                "constant",
                "builtin"
            ],
            style: {
                color: "rgb(189, 147, 249)"
            }
        },
        {
            types: [
                "inserted",
                "function"
            ],
            style: {
                color: "rgb(80, 250, 123)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 85)"
            }
        },
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 184, 108)"
            }
        },
        {
            types: [
                "punctuation",
                "symbol"
            ],
            style: {
                color: "rgb(248, 248, 242)"
            }
        },
        {
            types: [
                "string",
                "char",
                "tag",
                "selector"
            ],
            style: {
                color: "rgb(255, 121, 198)"
            }
        },
        {
            types: [
                "keyword",
                "variable"
            ],
            style: {
                color: "rgb(189, 147, 249)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(98, 114, 164)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(241, 250, 140)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$dracula_default = $2e16598ba480dcca$var$theme;
// src/themes/duotoneDark.ts
var $2e16598ba480dcca$var$theme2 = {
    plain: {
        backgroundColor: "#2a2734",
        color: "#9a86fd"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#6c6783"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#e09142"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#9a86fd"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#eeebff"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#c4b9fe"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule",
                "placeholder",
                "variable"
            ],
            style: {
                color: "#ffcc99"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#c4b9fe"
            }
        }
    ]
};
var $2e16598ba480dcca$var$duotoneDark_default = $2e16598ba480dcca$var$theme2;
// src/themes/duotoneLight.ts
var $2e16598ba480dcca$var$theme3 = {
    plain: {
        backgroundColor: "#faf8f5",
        color: "#728fcb"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata",
                "punctuation"
            ],
            style: {
                color: "#b6ad9a"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "operator",
                "number"
            ],
            style: {
                color: "#063289"
            }
        },
        {
            types: [
                "property",
                "function"
            ],
            style: {
                color: "#b29762"
            }
        },
        {
            types: [
                "tag-id",
                "selector",
                "atrule-id"
            ],
            style: {
                color: "#2d2006"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#896724"
            }
        },
        {
            types: [
                "boolean",
                "string",
                "entity",
                "url",
                "attr-value",
                "keyword",
                "control",
                "directive",
                "unit",
                "statement",
                "regex",
                "atrule"
            ],
            style: {
                color: "#728fcb"
            }
        },
        {
            types: [
                "placeholder",
                "variable"
            ],
            style: {
                color: "#93abdc"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "#896724"
            }
        }
    ]
};
var $2e16598ba480dcca$var$duotoneLight_default = $2e16598ba480dcca$var$theme3;
// src/themes/github.ts
var $2e16598ba480dcca$var$theme4 = {
    plain: {
        color: "#393A34",
        backgroundColor: "#f6f8fa"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#999988",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#e3116c"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#393A34"
            }
        },
        {
            types: [
                "entity",
                "url",
                "symbol",
                "number",
                "boolean",
                "variable",
                "constant",
                "property",
                "regex",
                "inserted"
            ],
            style: {
                color: "#36acaa"
            }
        },
        {
            types: [
                "atrule",
                "keyword",
                "attr-name",
                "selector"
            ],
            style: {
                color: "#00a4db"
            }
        },
        {
            types: [
                "function",
                "deleted",
                "tag"
            ],
            style: {
                color: "#d73a49"
            }
        },
        {
            types: [
                "function-variable"
            ],
            style: {
                color: "#6f42c1"
            }
        },
        {
            types: [
                "tag",
                "selector",
                "keyword"
            ],
            style: {
                color: "#00009f"
            }
        }
    ]
};
var $2e16598ba480dcca$var$github_default = $2e16598ba480dcca$var$theme4;
// src/themes/nightOwl.ts
var $2e16598ba480dcca$var$theme5 = {
    plain: {
        color: "#d6deeb",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(99, 119, 119)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(214, 222, 235)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(255, 203, 139)"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "rgb(127, 219, 202)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "property"
            ],
            style: {
                color: "rgb(128, 203, 196)"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$nightOwl_default = $2e16598ba480dcca$var$theme5;
// src/themes/nightOwlLight.ts
var $2e16598ba480dcca$var$theme6 = {
    plain: {
        color: "#403f53",
        backgroundColor: "#FBFBFB"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted",
                "attr-name"
            ],
            style: {
                color: "rgb(72, 118, 214)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(152, 159, 177)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "builtin",
                "char",
                "constant",
                "url"
            ],
            style: {
                color: "rgb(72, 118, 214)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(201, 103, 101)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(170, 9, 130)"
            }
        },
        {
            // This was manually added after the auto-generation
            // so that punctuations are not italicised
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "function",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(153, 76, 195)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(17, 17, 17)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(153, 76, 195)"
            }
        },
        {
            types: [
                "operator",
                "property",
                "keyword",
                "namespace"
            ],
            style: {
                color: "rgb(12, 150, 155)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(188, 84, 84)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$nightOwlLight_default = $2e16598ba480dcca$var$theme6;
// src/themes/oceanicNext.ts
var $2e16598ba480dcca$var$colors = {
    char: "#D8DEE9",
    comment: "#999999",
    keyword: "#c5a5c5",
    primitive: "#5a9bcf",
    string: "#8dc891",
    variable: "#d7deea",
    boolean: "#ff8b50",
    punctuation: "#5FB3B3",
    tag: "#fc929e",
    function: "#79b6f2",
    className: "#FAC863",
    method: "#6699CC",
    operator: "#fc929e"
};
var $2e16598ba480dcca$var$theme7 = {
    plain: {
        backgroundColor: "#282c34",
        color: "#ffffff"
    },
    styles: [
        {
            types: [
                "attr-name"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.keyword
            }
        },
        {
            types: [
                "attr-value"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.string
            }
        },
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata",
                "shebang"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.comment
            }
        },
        {
            types: [
                "property",
                "number",
                "function-name",
                "constant",
                "symbol",
                "deleted"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.primitive
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.boolean
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.tag
            }
        },
        {
            types: [
                "string"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.string
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.string
            }
        },
        {
            types: [
                "selector",
                "char",
                "builtin",
                "inserted"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.char
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.function
            }
        },
        {
            types: [
                "operator",
                "entity",
                "url",
                "variable"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.variable
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.keyword
            }
        },
        {
            types: [
                "atrule",
                "class-name"
            ],
            style: {
                color: $2e16598ba480dcca$var$colors.className
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                fontWeight: "400"
            }
        },
        {
            types: [
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                opacity: 0.7
            }
        }
    ]
};
var $2e16598ba480dcca$var$oceanicNext_default = $2e16598ba480dcca$var$theme7;
// src/themes/okaidia.ts
var $2e16598ba480dcca$var$theme8 = {
    plain: {
        color: "#f8f8f2",
        backgroundColor: "#272822"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(162, 191, 252)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "#f92672",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#8292a2",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "#a6e22e"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "#e6db74"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#f8f8f2"
            }
        },
        {
            types: [
                "selector",
                "doctype"
            ],
            style: {
                color: "#a6e22e",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "tag",
                "operator",
                "keyword"
            ],
            style: {
                color: "#66d9ef"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "#ae81ff"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)",
                opacity: 0.7
            }
        },
        {
            types: [
                "tag",
                "property"
            ],
            style: {
                color: "#f92672"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "#a6e22e !important"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "#8292a2"
            }
        },
        {
            types: [
                "rule"
            ],
            style: {
                color: "#e6db74"
            }
        }
    ]
};
var $2e16598ba480dcca$var$okaidia_default = $2e16598ba480dcca$var$theme8;
// src/themes/palenight.ts
var $2e16598ba480dcca$var$theme9 = {
    plain: {
        color: "#bfc7d5",
        backgroundColor: "#292d3e"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(105, 112, 152)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "string",
                "inserted"
            ],
            style: {
                color: "rgb(195, 232, 141)"
            }
        },
        {
            types: [
                "number"
            ],
            style: {
                color: "rgb(247, 140, 108)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function"
            ],
            style: {
                color: "rgb(130, 170, 255)"
            }
        },
        {
            types: [
                "punctuation",
                "selector"
            ],
            style: {
                color: "rgb(199, 146, 234)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(191, 199, 213)"
            }
        },
        {
            types: [
                "class-name",
                "attr-name"
            ],
            style: {
                color: "rgb(255, 203, 107)"
            }
        },
        {
            types: [
                "tag",
                "deleted"
            ],
            style: {
                color: "rgb(255, 85, 114)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(137, 221, 255)"
            }
        },
        {
            types: [
                "boolean"
            ],
            style: {
                color: "rgb(255, 88, 116)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "doctype"
            ],
            style: {
                color: "rgb(199, 146, 234)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "namespace"
            ],
            style: {
                color: "rgb(178, 204, 214)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "rgb(221, 221, 221)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$palenight_default = $2e16598ba480dcca$var$theme9;
// src/themes/shadesOfPurple.ts
var $2e16598ba480dcca$var$theme10 = {
    plain: {
        color: "#9EFEFF",
        backgroundColor: "#2D2A55"
    },
    styles: [
        {
            types: [
                "changed"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                color: "rgba(239, 83, 80, 0.56)"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "rgb(173, 219, 103)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(179, 98, 255)",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "rgb(255, 255, 255)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "string",
                "url"
            ],
            style: {
                color: "rgb(165, 255, 144)"
            }
        },
        {
            types: [
                "variable"
            ],
            style: {
                color: "rgb(255, 238, 128)"
            }
        },
        {
            types: [
                "number",
                "boolean"
            ],
            style: {
                color: "rgb(255, 98, 140)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 180, 84)"
            }
        },
        {
            types: [
                "keyword",
                "operator",
                "property",
                "namespace",
                "tag",
                "selector",
                "doctype"
            ],
            style: {
                color: "rgb(255, 157, 0)"
            }
        },
        {
            types: [
                "builtin",
                "char",
                "constant",
                "function",
                "class-name"
            ],
            style: {
                color: "rgb(250, 208, 0)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$shadesOfPurple_default = $2e16598ba480dcca$var$theme10;
// src/themes/synthwave84.ts
var $2e16598ba480dcca$var$theme11 = {
    plain: {
        backgroundColor: "linear-gradient(to bottom, #2a2139 75%, #34294f)",
        backgroundImage: "#34294f",
        color: "#f92aad",
        textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
    },
    styles: [
        {
            types: [
                "comment",
                "block-comment",
                "prolog",
                "doctype",
                "cdata"
            ],
            style: {
                color: "#495495",
                fontStyle: "italic"
            }
        },
        {
            types: [
                "punctuation"
            ],
            style: {
                color: "#ccc"
            }
        },
        {
            types: [
                "tag",
                "attr-name",
                "namespace",
                "number",
                "unit",
                "hexcode",
                "deleted"
            ],
            style: {
                color: "#e2777a"
            }
        },
        {
            types: [
                "property",
                "selector"
            ],
            style: {
                color: "#72f1b8",
                textShadow: "0 0 2px #100c0f, 0 0 10px #257c5575, 0 0 35px #21272475"
            }
        },
        {
            types: [
                "function-name"
            ],
            style: {
                color: "#6196cc"
            }
        },
        {
            types: [
                "boolean",
                "selector-id",
                "function"
            ],
            style: {
                color: "#fdfdfd",
                textShadow: "0 0 2px #001716, 0 0 3px #03edf975, 0 0 5px #03edf975, 0 0 8px #03edf975"
            }
        },
        {
            types: [
                "class-name",
                "maybe-class-name",
                "builtin"
            ],
            style: {
                color: "#fff5f6",
                textShadow: "0 0 2px #000, 0 0 10px #fc1f2c75, 0 0 5px #fc1f2c75, 0 0 25px #fc1f2c75"
            }
        },
        {
            types: [
                "constant",
                "symbol"
            ],
            style: {
                color: "#f92aad",
                textShadow: "0 0 2px #100c0f, 0 0 5px #dc078e33, 0 0 10px #fff3"
            }
        },
        {
            types: [
                "important",
                "atrule",
                "keyword",
                "selector-class"
            ],
            style: {
                color: "#f4eee4",
                textShadow: "0 0 2px #393a33, 0 0 8px #f39f0575, 0 0 2px #f39f0575"
            }
        },
        {
            types: [
                "string",
                "char",
                "attr-value",
                "regex",
                "variable"
            ],
            style: {
                color: "#f87c32"
            }
        },
        {
            types: [
                "parameter"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity",
                "url"
            ],
            style: {
                color: "#67cdcc"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "ffffffee"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "entity"
            ],
            style: {
                cursor: "help"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                color: "green"
            }
        }
    ]
};
var $2e16598ba480dcca$var$synthwave84_default = $2e16598ba480dcca$var$theme11;
// src/themes/ultramin.ts
var $2e16598ba480dcca$var$theme12 = {
    plain: {
        color: "#282a2e",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(197, 200, 198)"
            }
        },
        {
            types: [
                "string",
                "number",
                "builtin",
                "variable"
            ],
            style: {
                color: "rgb(150, 152, 150)"
            }
        },
        {
            types: [
                "class-name",
                "function",
                "tag",
                "attr-name"
            ],
            style: {
                color: "rgb(40, 42, 46)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$ultramin_default = $2e16598ba480dcca$var$theme12;
// src/themes/vsDark.ts
var $2e16598ba480dcca$var$theme13 = {
    plain: {
        color: "#9CDCFE",
        backgroundColor: "#1E1E1E"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "rgb(0, 0, 128)"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(106, 153, 85)"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "rgb(181, 206, 168)"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "rgb(100, 102, 149)"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "rgb(156, 220, 254)"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "rgb(206, 145, 120)"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "rgb(215, 186, 125)"
            }
        },
        {
            // Fix tag color
            types: [
                "tag"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            // Fix tag color for HTML
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "rgb(86, 156, 214)"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "rgb(212, 212, 212)"
            }
        },
        {
            // Fix punctuation color for HTML
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "rgb(220, 220, 170)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(78, 201, 176)"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "rgb(209, 105, 105)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$vsDark_default = $2e16598ba480dcca$var$theme13;
// src/themes/vsLight.ts
var $2e16598ba480dcca$var$theme14 = {
    plain: {
        color: "#000000",
        backgroundColor: "#ffffff"
    },
    styles: [
        {
            types: [
                "comment"
            ],
            style: {
                color: "rgb(0, 128, 0)"
            }
        },
        {
            types: [
                "builtin"
            ],
            style: {
                color: "rgb(0, 112, 193)"
            }
        },
        {
            types: [
                "number",
                "variable",
                "inserted"
            ],
            style: {
                color: "rgb(9, 134, 88)"
            }
        },
        {
            types: [
                "operator"
            ],
            style: {
                color: "rgb(0, 0, 0)"
            }
        },
        {
            types: [
                "constant",
                "char"
            ],
            style: {
                color: "rgb(129, 31, 63)"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "rgb(128, 0, 0)"
            }
        },
        {
            types: [
                "attr-name"
            ],
            style: {
                color: "rgb(255, 0, 0)"
            }
        },
        {
            types: [
                "deleted",
                "string"
            ],
            style: {
                color: "rgb(163, 21, 21)"
            }
        },
        {
            types: [
                "changed",
                "punctuation"
            ],
            style: {
                color: "rgb(4, 81, 165)"
            }
        },
        {
            types: [
                "function",
                "keyword"
            ],
            style: {
                color: "rgb(0, 0, 255)"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "rgb(38, 127, 153)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$vsLight_default = $2e16598ba480dcca$var$theme14;
// src/themes/jettwaveDark.ts
var $2e16598ba480dcca$var$theme15 = {
    plain: {
        color: "#f8fafc",
        backgroundColor: "#011627"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#569CD6"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#f8fafc"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#9CDCFE"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#cbd5e1"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#D4D4D4"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#7dd3fc"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $2e16598ba480dcca$var$jettwaveDark_default = $2e16598ba480dcca$var$theme15;
// src/themes/jettwaveLight.ts
var $2e16598ba480dcca$var$theme16 = {
    plain: {
        color: "#0f172a",
        backgroundColor: "#f1f5f9"
    },
    styles: [
        {
            types: [
                "prolog"
            ],
            style: {
                color: "#000080"
            }
        },
        {
            types: [
                "comment"
            ],
            style: {
                color: "#6A9955"
            }
        },
        {
            types: [
                "builtin",
                "changed",
                "keyword",
                "interpolation-punctuation"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "number",
                "inserted"
            ],
            style: {
                color: "#B5CEA8"
            }
        },
        {
            types: [
                "constant"
            ],
            style: {
                color: "#0f172a"
            }
        },
        {
            types: [
                "attr-name",
                "variable"
            ],
            style: {
                color: "#0c4a6e"
            }
        },
        {
            types: [
                "deleted",
                "string",
                "attr-value",
                "template-punctuation"
            ],
            style: {
                color: "#64748b"
            }
        },
        {
            types: [
                "selector"
            ],
            style: {
                color: "#D7BA7D"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "tag"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "punctuation",
                "operator"
            ],
            style: {
                color: "#475569"
            }
        },
        {
            types: [
                "punctuation"
            ],
            languages: [
                "markup"
            ],
            style: {
                color: "#808080"
            }
        },
        {
            types: [
                "function"
            ],
            style: {
                color: "#0e7490"
            }
        },
        {
            types: [
                "class-name"
            ],
            style: {
                color: "#0ea5e9"
            }
        },
        {
            types: [
                "char"
            ],
            style: {
                color: "#D16969"
            }
        }
    ]
};
var $2e16598ba480dcca$var$jettwaveLight_default = $2e16598ba480dcca$var$theme16;
// src/themes/oneDark.ts
var $2e16598ba480dcca$var$theme17 = {
    plain: {
        backgroundColor: "hsl(220, 13%, 18%)",
        color: "hsl(220, 14%, 71%)",
        textShadow: "0 1px rgba(0, 0, 0, 0.3)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(220, 10%, 40%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "maybe-class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(29, 54%, 61%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(286, 60%, 67%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(355, 65%, 65%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value"
            ],
            style: {
                color: "hsl(95, 38%, 62%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(207, 82%, 66%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(187, 47%, 55%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(220, 14%, 71%)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$oneDark_default = $2e16598ba480dcca$var$theme17;
// src/themes/oneLight.ts
var $2e16598ba480dcca$var$theme18 = {
    plain: {
        backgroundColor: "hsl(230, 1%, 98%)",
        color: "hsl(230, 8%, 24%)"
    },
    styles: [
        {
            types: [
                "comment",
                "prolog",
                "cdata"
            ],
            style: {
                color: "hsl(230, 4%, 64%)"
            }
        },
        {
            types: [
                "doctype",
                "punctuation",
                "entity"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        },
        {
            types: [
                "attr-name",
                "class-name",
                "boolean",
                "constant",
                "number",
                "atrule"
            ],
            style: {
                color: "hsl(35, 99%, 36%)"
            }
        },
        {
            types: [
                "keyword"
            ],
            style: {
                color: "hsl(301, 63%, 40%)"
            }
        },
        {
            types: [
                "property",
                "tag",
                "symbol",
                "deleted",
                "important"
            ],
            style: {
                color: "hsl(5, 74%, 59%)"
            }
        },
        {
            types: [
                "selector",
                "string",
                "char",
                "builtin",
                "inserted",
                "regex",
                "attr-value",
                "punctuation"
            ],
            style: {
                color: "hsl(119, 34%, 47%)"
            }
        },
        {
            types: [
                "variable",
                "operator",
                "function"
            ],
            style: {
                color: "hsl(221, 87%, 60%)"
            }
        },
        {
            types: [
                "url"
            ],
            style: {
                color: "hsl(198, 99%, 37%)"
            }
        },
        {
            types: [
                "deleted"
            ],
            style: {
                textDecorationLine: "line-through"
            }
        },
        {
            types: [
                "inserted"
            ],
            style: {
                textDecorationLine: "underline"
            }
        },
        {
            types: [
                "italic"
            ],
            style: {
                fontStyle: "italic"
            }
        },
        {
            types: [
                "important",
                "bold"
            ],
            style: {
                fontWeight: "bold"
            }
        },
        {
            types: [
                "important"
            ],
            style: {
                color: "hsl(230, 8%, 24%)"
            }
        }
    ]
};
var $2e16598ba480dcca$var$oneLight_default = $2e16598ba480dcca$var$theme18;
// src/themes/gruvboxMaterialDark.ts
var $2e16598ba480dcca$var$theme19 = {
    plain: {
        color: "#ebdbb2",
        backgroundColor: "#292828"
    },
    styles: [
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin",
                "function"
            ],
            style: {
                color: "#d8a657"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#7daea3"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#e78a4e"
            }
        },
        {
            types: [
                "attr-name",
                "char",
                "url",
                "regex"
            ],
            style: {
                color: "#a9b665"
            }
        },
        {
            types: [
                "attr-value",
                "string"
            ],
            style: {
                color: "#89b482"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#ea6962"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#d3869b"
            }
        }
    ]
};
var $2e16598ba480dcca$var$gruvboxMaterialDark_default = $2e16598ba480dcca$var$theme19;
// src/themes/gruvboxMaterialLight.ts
var $2e16598ba480dcca$var$theme20 = {
    plain: {
        color: "#654735",
        backgroundColor: "#f9f5d7"
    },
    styles: [
        {
            types: [
                "delimiter",
                "boolean",
                "keyword",
                "selector",
                "important",
                "atrule",
                "property",
                "variable",
                "deleted"
            ],
            style: {
                color: "#af2528"
            }
        },
        {
            types: [
                "imports",
                "class-name",
                "maybe-class-name",
                "constant",
                "doctype",
                "builtin"
            ],
            style: {
                color: "#b4730e"
            }
        },
        {
            types: [
                "string",
                "attr-value"
            ],
            style: {
                color: "#477a5b"
            }
        },
        {
            types: [
                "property-access"
            ],
            style: {
                color: "#266b79"
            }
        },
        {
            types: [
                "function",
                "attr-name",
                "char",
                "url"
            ],
            style: {
                color: "#72761e"
            }
        },
        {
            types: [
                "tag"
            ],
            style: {
                color: "#b94c07"
            }
        },
        {
            types: [
                "comment",
                "prolog",
                "cdata",
                "operator",
                "inserted"
            ],
            style: {
                color: "#a89984"
            }
        },
        {
            types: [
                "entity",
                "number",
                "symbol"
            ],
            style: {
                color: "#924f79"
            }
        }
    ]
};
var $2e16598ba480dcca$var$gruvboxMaterialLight_default = $2e16598ba480dcca$var$theme20;
var $2e16598ba480dcca$var$useGetLineProps = (themeDictionary)=>(0, $jmWak.useCallback)((_a)=>{
        var _b = _a, { className: className, style: style, line: line } = _b, rest = $2e16598ba480dcca$var$__objRest(_b, [
            "className",
            "style",
            "line"
        ]);
        const output = $2e16598ba480dcca$var$__spreadProps($2e16598ba480dcca$var$__spreadValues({}, rest), {
            className: (0, $3622a645c822ba87$export$2e2bcd8739ae039)("token-line", className)
        });
        if (typeof themeDictionary === "object" && "plain" in themeDictionary) output.style = themeDictionary.plain;
        if (typeof style === "object") output.style = $2e16598ba480dcca$var$__spreadValues($2e16598ba480dcca$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        themeDictionary
    ]);
var $2e16598ba480dcca$var$useGetTokenProps = (themeDictionary)=>{
    const styleForToken = (0, $jmWak.useCallback)(({ types: types, empty: empty })=>{
        if (themeDictionary == null) return void 0;
        else if (types.length === 1 && types[0] === "plain") return empty != null ? {
            display: "inline-block"
        } : void 0;
        else if (types.length === 1 && empty != null) return themeDictionary[types[0]];
        return Object.assign(empty != null ? {
            display: "inline-block"
        } : {}, ...types.map((type)=>themeDictionary[type]));
    }, [
        themeDictionary
    ]);
    return (0, $jmWak.useCallback)((_a)=>{
        var _b = _a, { token: token, className: className, style: style } = _b, rest = $2e16598ba480dcca$var$__objRest(_b, [
            "token",
            "className",
            "style"
        ]);
        const output = $2e16598ba480dcca$var$__spreadProps($2e16598ba480dcca$var$__spreadValues({}, rest), {
            className: (0, $3622a645c822ba87$export$2e2bcd8739ae039)("token", ...token.types, className),
            children: token.content,
            style: styleForToken(token)
        });
        if (style != null) output.style = $2e16598ba480dcca$var$__spreadValues($2e16598ba480dcca$var$__spreadValues({}, output.style || {}), style);
        return output;
    }, [
        styleForToken
    ]);
};
// src/utils/normalizeTokens.ts
var $2e16598ba480dcca$var$newlineRe = /\r\n|\r|\n/;
var $2e16598ba480dcca$var$normalizeEmptyLines = (line)=>{
    if (line.length === 0) line.push({
        types: [
            "plain"
        ],
        content: "\n",
        empty: true
    });
    else if (line.length === 1 && line[0].content === "") {
        line[0].content = "\n";
        line[0].empty = true;
    }
};
var $2e16598ba480dcca$var$appendTypes = (types, add)=>{
    const typesSize = types.length;
    if (typesSize > 0 && types[typesSize - 1] === add) return types;
    return types.concat(add);
};
var $2e16598ba480dcca$var$normalizeTokens = (tokens)=>{
    const typeArrStack = [
        []
    ];
    const tokenArrStack = [
        tokens
    ];
    const tokenArrIndexStack = [
        0
    ];
    const tokenArrSizeStack = [
        tokens.length
    ];
    let i = 0;
    let stackIndex = 0;
    let currentLine = [];
    const acc = [
        currentLine
    ];
    while(stackIndex > -1){
        while((i = tokenArrIndexStack[stackIndex]++) < tokenArrSizeStack[stackIndex]){
            let content;
            let types = typeArrStack[stackIndex];
            const tokenArr = tokenArrStack[stackIndex];
            const token = tokenArr[i];
            if (typeof token === "string") {
                types = stackIndex > 0 ? types : [
                    "plain"
                ];
                content = token;
            } else {
                types = $2e16598ba480dcca$var$appendTypes(types, token.type);
                if (token.alias) types = $2e16598ba480dcca$var$appendTypes(types, token.alias);
                content = token.content;
            }
            if (typeof content !== "string") {
                stackIndex++;
                typeArrStack.push(types);
                tokenArrStack.push(content);
                tokenArrIndexStack.push(0);
                tokenArrSizeStack.push(content.length);
                continue;
            }
            const splitByNewlines = content.split($2e16598ba480dcca$var$newlineRe);
            const newlineCount = splitByNewlines.length;
            currentLine.push({
                types: types,
                content: splitByNewlines[0]
            });
            for(let i2 = 1; i2 < newlineCount; i2++){
                $2e16598ba480dcca$var$normalizeEmptyLines(currentLine);
                acc.push(currentLine = []);
                currentLine.push({
                    types: types,
                    content: splitByNewlines[i2]
                });
            }
        }
        stackIndex--;
        typeArrStack.pop();
        tokenArrStack.pop();
        tokenArrIndexStack.pop();
        tokenArrSizeStack.pop();
    }
    $2e16598ba480dcca$var$normalizeEmptyLines(currentLine);
    return acc;
};
var $2e16598ba480dcca$export$2dc420fd853fdcc4 = $2e16598ba480dcca$var$normalizeTokens;
var $2e16598ba480dcca$export$7b94e077f7691ca1 = ({ prism: prism, code: code, grammar: grammar, language: language })=>{
    return (0, $jmWak.useMemo)(()=>{
        if (grammar == null) return $2e16598ba480dcca$export$2dc420fd853fdcc4([
            code
        ]);
        const prismConfig = {
            code: code,
            grammar: grammar,
            language: language,
            tokens: []
        };
        prism.hooks.run("before-tokenize", prismConfig);
        prismConfig.tokens = prism.tokenize(code, grammar);
        prism.hooks.run("after-tokenize", prismConfig);
        return $2e16598ba480dcca$export$2dc420fd853fdcc4(prismConfig.tokens);
    }, [
        code,
        grammar,
        language,
        // prism is a stable import
        prism
    ]);
};
// src/utils/themeToDict.ts
var $2e16598ba480dcca$var$themeToDict = (theme21, language)=>{
    const { plain: plain } = theme21;
    const themeDict = theme21.styles.reduce((acc, themeEntry)=>{
        const { languages: languages2, style: style } = themeEntry;
        if (languages2 && !languages2.includes(language)) return acc;
        themeEntry.types.forEach((type)=>{
            const accStyle = $2e16598ba480dcca$var$__spreadValues($2e16598ba480dcca$var$__spreadValues({}, acc[type]), style);
            acc[type] = accStyle;
        });
        return acc;
    }, {});
    themeDict.root = plain;
    themeDict.plain = $2e16598ba480dcca$var$__spreadProps($2e16598ba480dcca$var$__spreadValues({}, plain), {
        backgroundColor: void 0
    });
    return themeDict;
};
var $2e16598ba480dcca$var$themeToDict_default = $2e16598ba480dcca$var$themeToDict;
// src/components/highlight.ts
var $2e16598ba480dcca$var$Highlight = ({ children: children, language: _language, code: code, theme: theme21, prism: prism })=>{
    const language = _language.toLowerCase();
    const themeDictionary = $2e16598ba480dcca$var$themeToDict_default(theme21, language);
    const getLineProps = $2e16598ba480dcca$var$useGetLineProps(themeDictionary);
    const getTokenProps = $2e16598ba480dcca$var$useGetTokenProps(themeDictionary);
    const grammar = prism.languages[language];
    const tokens = $2e16598ba480dcca$export$7b94e077f7691ca1({
        prism: prism,
        language: language,
        code: code,
        grammar: grammar
    });
    return children({
        tokens: tokens,
        className: `prism-code language-${language}`,
        style: themeDictionary != null ? themeDictionary.root : {},
        getLineProps: getLineProps,
        getTokenProps: getTokenProps
    });
};
// src/index.ts
var $2e16598ba480dcca$export$39dbc3f558091353 = (props)=>(0, $3lE4N.createElement)($2e16598ba480dcca$var$Highlight, $2e16598ba480dcca$var$__spreadProps($2e16598ba480dcca$var$__spreadValues({}, props), {
        prism: props.prism || $2e16598ba480dcca$export$dc7257ffb0972f87,
        theme: props.theme || $2e16598ba480dcca$var$vsDark_default,
        code: props.code,
        language: props.language
    }));
 /*! Bundled license information:

prismjs/prism.js:
  (**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   *)
*/ 

parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
var $e67c660f54f67ced$var$m = {
    characterData: !0,
    characterDataOldValue: !0,
    childList: !0,
    subtree: !0
};
function $e67c660f54f67ced$var$p(c) {
    var a = window.getSelection();
    a.empty();
    a.addRange(c);
}
function $e67c660f54f67ced$var$q(c) {
    return (c.metaKey || c.ctrlKey) && !c.altKey && "KeyZ" === c.code;
}
function $e67c660f54f67ced$var$r(c) {
    c = [
        c.firstChild
    ];
    for(var b, a = ""; b = c.pop();)b.nodeType === Node.TEXT_NODE ? a += b.textContent : b.nodeType === Node.ELEMENT_NODE && "BR" === b.nodeName && (a += "\n"), b.nextSibling && c.push(b.nextSibling), b.firstChild && c.push(b.firstChild);
    "\n" !== a[a.length - 1] && (a += "\n");
    return a;
}
function $e67c660f54f67ced$var$w(c) {
    var a = window.getSelection().getRangeAt(0), b = a.collapsed ? 0 : a.toString().length, f = document.createRange();
    f.setStart(c, 0);
    f.setEnd(a.startContainer, a.startOffset);
    return {
        position: c = (f = f.toString()).length,
        extent: b,
        content: f = (f = f.split("\n"))[a = f.length - 1],
        line: a
    };
}
function $e67c660f54f67ced$var$C(c, a, b) {
    0 >= a && (a = 0);
    if (!b || 0 > b) b = a;
    var f = document.createRange();
    c = [
        c.firstChild
    ];
    for(var d, l = 0, g = a; d = c[c.length - 1];){
        if (d.nodeType === Node.TEXT_NODE) {
            if (l + d.textContent.length >= g) {
                var h = g - l;
                if (g === a) {
                    if (g = f, h < d.textContent.length ? g.setStart(d, h) : g.setStartAfter(d), b !== a) {
                        g = b;
                        continue;
                    } else break;
                } else {
                    a = f;
                    h < (b = d).textContent.length ? a.setEnd(b, h) : a.setEndAfter(b);
                    break;
                }
            }
            l += d.textContent.length;
        } else if (d.nodeType === Node.ELEMENT_NODE && "BR" === d.nodeName) {
            if (l + 1 >= g) {
                if (g === a) {
                    if (h = f, 0 < d.textContent.length ? h.setStart(d, 0) : h.setStartAfter(d), b !== a) {
                        g = b;
                        continue;
                    } else break;
                } else {
                    a = f;
                    0 < (b = d).textContent.length ? a.setEnd(b, 0) : a.setEndAfter(b);
                    break;
                }
            }
            l++;
        }
        c.pop();
        d.nextSibling && c.push(d.nextSibling);
        d.firstChild && c.push(d.firstChild);
    }
    return f;
}
function $e67c660f54f67ced$export$52a148af2bad544(c, a, b) {
    function f(k) {
        var b = c.current;
        if (b) {
            var a = $e67c660f54f67ced$var$w(b);
            b = $e67c660f54f67ced$var$r(b);
            a.position += k.length - b.length;
            e.position = a;
            e.onChange(k, a);
        }
    }
    function l(k, b) {
        var e = c.current;
        if (e) {
            var a = window.getSelection().getRangeAt(0);
            a.deleteContents();
            a.collapse();
            var d = b || 0;
            (a = $e67c660f54f67ced$var$C(e, b = (a = $e67c660f54f67ced$var$w(e)).position + (0 > d ? d : 0), a.position + (0 < d ? d : 0))).deleteContents();
            k && a.insertNode(document.createTextNode(k));
            $e67c660f54f67ced$var$p($e67c660f54f67ced$var$C(e, b + k.length));
        }
    }
    function d(b) {
        var a = c.current;
        if (a) {
            a.focus();
            var e = 0;
            if ("number" == typeof b) e = b;
            else {
                var k = $e67c660f54f67ced$var$r(a).split("\n").slice(0, b.row);
                b.row && (e += k.join("\n").length + 1);
                e += b.column;
            }
            $e67c660f54f67ced$var$p($e67c660f54f67ced$var$C(a, e));
        }
    }
    function g() {
        var b = c.current;
        return {
            text: $e67c660f54f67ced$var$r(b),
            position: b = $e67c660f54f67ced$var$w(b)
        };
    }
    function h() {
        e.observer.disconnect();
    }
    b || (b = {});
    var D = (0, $jmWak.useState)([])[1], e = (0, $jmWak.useState)(function() {
        var e = {
            observer: null,
            disconnected: !1,
            onChange: a,
            queue: [],
            history: [],
            historyAt: -1,
            position: null
        };
        "undefined" != typeof MutationObserver && (e.observer = new MutationObserver(function b(b) {
            var a;
            (a = e.queue).push.apply(a, b);
        }));
        return e;
    })[0], n = (0, $jmWak.useMemo)(function() {
        return {
            update: f,
            insert: l,
            move: d,
            getState: g
        };
    }, []);
    if ("object" != typeof navigator) return n;
    (0, $jmWak.useLayoutEffect)(function() {
        e.onChange = a;
        if (c.current && !b.disabled) {
            e.disconnected = !1;
            e.observer.observe(c.current, $e67c660f54f67ced$var$m);
            if (e.position) {
                var k = e.position, d = k.position;
                $e67c660f54f67ced$var$p($e67c660f54f67ced$var$C(c.current, d, d + k.extent));
            }
            return h;
        }
    });
    (0, $jmWak.useLayoutEffect)(function() {
        if (!c.current || b.disabled) e.history.length = 0, e.historyAt = -1;
        else {
            var a = c.current;
            if (e.position) {
                a.focus();
                var d = e.position, f = d.position;
                $e67c660f54f67ced$var$p($e67c660f54f67ced$var$C(a, f, f + d.extent));
            }
            var g = a.style.whiteSpace, h = a.contentEditable, l = !0;
            try {
                a.contentEditable = "plaintext-only";
            } catch (u) {
                a.contentEditable = "true", l = !1;
            }
            "pre" !== g && (a.style.whiteSpace = "pre-wrap");
            b.indentation && (a.style.tabSize = a.style.MozTabSize = "" + b.indentation);
            d = "" + " ".repeat(b.indentation || 0);
            var x, E = new RegExp("^(?:" + d + ")"), F = new RegExp("^(?:" + d + ")*(" + d + ")$"), t = function(b) {
                if (c.current && e.position) {
                    var u = $e67c660f54f67ced$var$r(a), d = $e67c660f54f67ced$var$w(a), f = (new Date).valueOf(), g = e.history[e.historyAt];
                    !b && 500 > f - x || g && g[1] === u ? x = f : (b = ++e.historyAt, e.history[b] = [
                        d,
                        u
                    ], e.history.splice(b + 1), 500 < b && (e.historyAt--, e.history.shift()));
                }
            }, v = function() {
                var b;
                (b = e.queue).push.apply(b, e.observer.takeRecords());
                b = $e67c660f54f67ced$var$w(a);
                if (e.queue.length) {
                    e.observer.disconnect();
                    e.disconnected = !0;
                    var d = $e67c660f54f67ced$var$r(a);
                    e.position = b;
                    for(var c, f; c = e.queue.pop();){
                        null !== c.oldValue && (c.target.textContent = c.oldValue);
                        for(f = c.removedNodes.length - 1; 0 <= f; f--)c.target.insertBefore(c.removedNodes[f], c.nextSibling);
                        for(f = c.addedNodes.length - 1; 0 <= f; f--)c.addedNodes[f].parentNode && c.target.removeChild(c.addedNodes[f]);
                    }
                    e.onChange(d, b);
                }
            }, y = function(c) {
                if (!c.defaultPrevented && c.target === a) {
                    if (e.disconnected) return c.preventDefault(), D([]);
                    if ($e67c660f54f67ced$var$q(c)) c.preventDefault(), c.shiftKey ? (c = ++e.historyAt, (c = e.history[c]) || (e.historyAt = e.history.length - 1)) : (c = --e.historyAt, (c = e.history[c]) || (e.historyAt = 0)), c && (e.observer.disconnect(), e.disconnected = !0, e.position = c[0], e.onChange(c[1], c[0]));
                    else {
                        t();
                        if ("Enter" === c.key) {
                            c.preventDefault();
                            var d = $e67c660f54f67ced$var$w(a), f = /\S/g.exec(d.content);
                            d = "\n" + d.content.slice(0, f ? f.index : d.content.length);
                            n.insert(d);
                        } else if ((!l || b.indentation) && "Backspace" === c.key) c.preventDefault(), window.getSelection().getRangeAt(0).collapsed ? (d = $e67c660f54f67ced$var$w(a), d = F.exec(d.content), n.insert("", d ? -d[1].length : -1)) : n.insert("", 0);
                        else if (b.indentation && "Tab" === c.key) {
                            c.preventDefault();
                            f = (d = $e67c660f54f67ced$var$w(a)).position - d.content.length;
                            var g = $e67c660f54f67ced$var$r(a);
                            d = c.shiftKey ? g.slice(0, f) + d.content.replace(E, "") + g.slice(f + d.content.length) : g.slice(0, f) + (b.indentation ? " ".repeat(b.indentation) : "\t") + g.slice(f);
                            n.update(d);
                        }
                        c.repeat && v();
                    }
                }
            }, z = function(b) {
                b.defaultPrevented || b.isComposing || ($e67c660f54f67ced$var$q(b) || t(), v(), a.focus());
            }, A = function(b) {
                e.position = window.getSelection().rangeCount && b.target === a ? $e67c660f54f67ced$var$w(a) : null;
            }, B = function(a) {
                a.preventDefault();
                t(!0);
                n.insert(a.clipboardData.getData("text/plain"));
                t(!0);
                v();
            };
            document.addEventListener("selectstart", A);
            window.addEventListener("keydown", y);
            a.addEventListener("paste", B);
            a.addEventListener("keyup", z);
            return function() {
                document.removeEventListener("selectstart", A);
                window.removeEventListener("keydown", y);
                a.removeEventListener("paste", B);
                a.removeEventListener("keyup", z);
                a.style.whiteSpace = g;
                a.contentEditable = h;
            };
        }
    }, [
        c.current,
        b.disabled,
        b.indentation
    ]);
    return n;
}



/* eslint max-len: 0 */ var $0e760627819a3d75$export$ee633ab6cd0138cc;
(function(ContextualKeyword) {
    const NONE = 0;
    ContextualKeyword[ContextualKeyword["NONE"] = NONE] = "NONE";
    const _abstract = NONE + 1;
    ContextualKeyword[ContextualKeyword["_abstract"] = _abstract] = "_abstract";
    const _accessor = _abstract + 1;
    ContextualKeyword[ContextualKeyword["_accessor"] = _accessor] = "_accessor";
    const _as = _accessor + 1;
    ContextualKeyword[ContextualKeyword["_as"] = _as] = "_as";
    const _assert = _as + 1;
    ContextualKeyword[ContextualKeyword["_assert"] = _assert] = "_assert";
    const _asserts = _assert + 1;
    ContextualKeyword[ContextualKeyword["_asserts"] = _asserts] = "_asserts";
    const _async = _asserts + 1;
    ContextualKeyword[ContextualKeyword["_async"] = _async] = "_async";
    const _await = _async + 1;
    ContextualKeyword[ContextualKeyword["_await"] = _await] = "_await";
    const _checks = _await + 1;
    ContextualKeyword[ContextualKeyword["_checks"] = _checks] = "_checks";
    const _constructor = _checks + 1;
    ContextualKeyword[ContextualKeyword["_constructor"] = _constructor] = "_constructor";
    const _declare = _constructor + 1;
    ContextualKeyword[ContextualKeyword["_declare"] = _declare] = "_declare";
    const _enum = _declare + 1;
    ContextualKeyword[ContextualKeyword["_enum"] = _enum] = "_enum";
    const _exports = _enum + 1;
    ContextualKeyword[ContextualKeyword["_exports"] = _exports] = "_exports";
    const _from = _exports + 1;
    ContextualKeyword[ContextualKeyword["_from"] = _from] = "_from";
    const _get = _from + 1;
    ContextualKeyword[ContextualKeyword["_get"] = _get] = "_get";
    const _global = _get + 1;
    ContextualKeyword[ContextualKeyword["_global"] = _global] = "_global";
    const _implements = _global + 1;
    ContextualKeyword[ContextualKeyword["_implements"] = _implements] = "_implements";
    const _infer = _implements + 1;
    ContextualKeyword[ContextualKeyword["_infer"] = _infer] = "_infer";
    const _interface = _infer + 1;
    ContextualKeyword[ContextualKeyword["_interface"] = _interface] = "_interface";
    const _is = _interface + 1;
    ContextualKeyword[ContextualKeyword["_is"] = _is] = "_is";
    const _keyof = _is + 1;
    ContextualKeyword[ContextualKeyword["_keyof"] = _keyof] = "_keyof";
    const _mixins = _keyof + 1;
    ContextualKeyword[ContextualKeyword["_mixins"] = _mixins] = "_mixins";
    const _module = _mixins + 1;
    ContextualKeyword[ContextualKeyword["_module"] = _module] = "_module";
    const _namespace = _module + 1;
    ContextualKeyword[ContextualKeyword["_namespace"] = _namespace] = "_namespace";
    const _of = _namespace + 1;
    ContextualKeyword[ContextualKeyword["_of"] = _of] = "_of";
    const _opaque = _of + 1;
    ContextualKeyword[ContextualKeyword["_opaque"] = _opaque] = "_opaque";
    const _out = _opaque + 1;
    ContextualKeyword[ContextualKeyword["_out"] = _out] = "_out";
    const _override = _out + 1;
    ContextualKeyword[ContextualKeyword["_override"] = _override] = "_override";
    const _private = _override + 1;
    ContextualKeyword[ContextualKeyword["_private"] = _private] = "_private";
    const _protected = _private + 1;
    ContextualKeyword[ContextualKeyword["_protected"] = _protected] = "_protected";
    const _proto = _protected + 1;
    ContextualKeyword[ContextualKeyword["_proto"] = _proto] = "_proto";
    const _public = _proto + 1;
    ContextualKeyword[ContextualKeyword["_public"] = _public] = "_public";
    const _readonly = _public + 1;
    ContextualKeyword[ContextualKeyword["_readonly"] = _readonly] = "_readonly";
    const _require = _readonly + 1;
    ContextualKeyword[ContextualKeyword["_require"] = _require] = "_require";
    const _satisfies = _require + 1;
    ContextualKeyword[ContextualKeyword["_satisfies"] = _satisfies] = "_satisfies";
    const _set = _satisfies + 1;
    ContextualKeyword[ContextualKeyword["_set"] = _set] = "_set";
    const _static = _set + 1;
    ContextualKeyword[ContextualKeyword["_static"] = _static] = "_static";
    const _symbol = _static + 1;
    ContextualKeyword[ContextualKeyword["_symbol"] = _symbol] = "_symbol";
    const _type = _symbol + 1;
    ContextualKeyword[ContextualKeyword["_type"] = _type] = "_type";
    const _unique = _type + 1;
    ContextualKeyword[ContextualKeyword["_unique"] = _unique] = "_unique";
    const _using = _unique + 1;
    ContextualKeyword[ContextualKeyword["_using"] = _using] = "_using";
})($0e760627819a3d75$export$ee633ab6cd0138cc || ($0e760627819a3d75$export$ee633ab6cd0138cc = {}));


// Generated file, do not edit! Run "yarn generate" to re-generate this file.
/* istanbul ignore file */ /**
 * Enum of all token types, with bit fields to signify meaningful properties.
 */ var $c455753917f2f29d$export$f435f793048e7a0f;
(function(TokenType) {
    // Precedence 0 means not an operator; otherwise it is a positive number up to 12.
    const PRECEDENCE_MASK = 0xf;
    TokenType[TokenType["PRECEDENCE_MASK"] = PRECEDENCE_MASK] = "PRECEDENCE_MASK";
    const IS_KEYWORD = 16;
    TokenType[TokenType["IS_KEYWORD"] = IS_KEYWORD] = "IS_KEYWORD";
    const IS_ASSIGN = 32;
    TokenType[TokenType["IS_ASSIGN"] = IS_ASSIGN] = "IS_ASSIGN";
    const IS_RIGHT_ASSOCIATIVE = 64;
    TokenType[TokenType["IS_RIGHT_ASSOCIATIVE"] = IS_RIGHT_ASSOCIATIVE] = "IS_RIGHT_ASSOCIATIVE";
    const IS_PREFIX = 128;
    TokenType[TokenType["IS_PREFIX"] = IS_PREFIX] = "IS_PREFIX";
    const IS_POSTFIX = 256;
    TokenType[TokenType["IS_POSTFIX"] = IS_POSTFIX] = "IS_POSTFIX";
    const IS_EXPRESSION_START = 512;
    TokenType[TokenType["IS_EXPRESSION_START"] = IS_EXPRESSION_START] = "IS_EXPRESSION_START";
    const num = 512;
    TokenType[TokenType["num"] = num] = "num"; // num startsExpr
    const bigint = 1536;
    TokenType[TokenType["bigint"] = bigint] = "bigint"; // bigint startsExpr
    const decimal = 2560;
    TokenType[TokenType["decimal"] = decimal] = "decimal"; // decimal startsExpr
    const regexp = 3584;
    TokenType[TokenType["regexp"] = regexp] = "regexp"; // regexp startsExpr
    const string = 4608;
    TokenType[TokenType["string"] = string] = "string"; // string startsExpr
    const name = 5632;
    TokenType[TokenType["name"] = name] = "name"; // name startsExpr
    const eof = 6144;
    TokenType[TokenType["eof"] = eof] = "eof"; // eof
    const bracketL = 7680;
    TokenType[TokenType["bracketL"] = bracketL] = "bracketL"; // [ startsExpr
    const bracketR = 8192;
    TokenType[TokenType["bracketR"] = bracketR] = "bracketR"; // ]
    const braceL = 9728;
    TokenType[TokenType["braceL"] = braceL] = "braceL"; // { startsExpr
    const braceBarL = 10752;
    TokenType[TokenType["braceBarL"] = braceBarL] = "braceBarL"; // {| startsExpr
    const braceR = 11264;
    TokenType[TokenType["braceR"] = braceR] = "braceR"; // }
    const braceBarR = 12288;
    TokenType[TokenType["braceBarR"] = braceBarR] = "braceBarR"; // |}
    const parenL = 13824;
    TokenType[TokenType["parenL"] = parenL] = "parenL"; // ( startsExpr
    const parenR = 14336;
    TokenType[TokenType["parenR"] = parenR] = "parenR"; // )
    const comma = 15360;
    TokenType[TokenType["comma"] = comma] = "comma"; // ,
    const semi = 16384;
    TokenType[TokenType["semi"] = semi] = "semi"; // ;
    const colon = 17408;
    TokenType[TokenType["colon"] = colon] = "colon"; // :
    const doubleColon = 18432;
    TokenType[TokenType["doubleColon"] = doubleColon] = "doubleColon"; // ::
    const dot = 19456;
    TokenType[TokenType["dot"] = dot] = "dot"; // .
    const question = 20480;
    TokenType[TokenType["question"] = question] = "question"; // ?
    const questionDot = 21504;
    TokenType[TokenType["questionDot"] = questionDot] = "questionDot"; // ?.
    const arrow = 22528;
    TokenType[TokenType["arrow"] = arrow] = "arrow"; // =>
    const template = 23552;
    TokenType[TokenType["template"] = template] = "template"; // template
    const ellipsis = 24576;
    TokenType[TokenType["ellipsis"] = ellipsis] = "ellipsis"; // ...
    const backQuote = 25600;
    TokenType[TokenType["backQuote"] = backQuote] = "backQuote"; // `
    const dollarBraceL = 27136;
    TokenType[TokenType["dollarBraceL"] = dollarBraceL] = "dollarBraceL"; // ${ startsExpr
    const at = 27648;
    TokenType[TokenType["at"] = at] = "at"; // @
    const hash = 29184;
    TokenType[TokenType["hash"] = hash] = "hash"; // # startsExpr
    const eq = 29728;
    TokenType[TokenType["eq"] = eq] = "eq"; // = isAssign
    const assign = 30752;
    TokenType[TokenType["assign"] = assign] = "assign"; // _= isAssign
    const preIncDec = 32640;
    TokenType[TokenType["preIncDec"] = preIncDec] = "preIncDec"; // ++/-- prefix postfix startsExpr
    const postIncDec = 33664;
    TokenType[TokenType["postIncDec"] = postIncDec] = "postIncDec"; // ++/-- prefix postfix startsExpr
    const bang = 34432;
    TokenType[TokenType["bang"] = bang] = "bang"; // ! prefix startsExpr
    const tilde = 35456;
    TokenType[TokenType["tilde"] = tilde] = "tilde"; // ~ prefix startsExpr
    const pipeline = 35841;
    TokenType[TokenType["pipeline"] = pipeline] = "pipeline"; // |> prec:1
    const nullishCoalescing = 36866;
    TokenType[TokenType["nullishCoalescing"] = nullishCoalescing] = "nullishCoalescing"; // ?? prec:2
    const logicalOR = 37890;
    TokenType[TokenType["logicalOR"] = logicalOR] = "logicalOR"; // || prec:2
    const logicalAND = 38915;
    TokenType[TokenType["logicalAND"] = logicalAND] = "logicalAND"; // && prec:3
    const bitwiseOR = 39940;
    TokenType[TokenType["bitwiseOR"] = bitwiseOR] = "bitwiseOR"; // | prec:4
    const bitwiseXOR = 40965;
    TokenType[TokenType["bitwiseXOR"] = bitwiseXOR] = "bitwiseXOR"; // ^ prec:5
    const bitwiseAND = 41990;
    TokenType[TokenType["bitwiseAND"] = bitwiseAND] = "bitwiseAND"; // & prec:6
    const equality = 43015;
    TokenType[TokenType["equality"] = equality] = "equality"; // ==/!= prec:7
    const lessThan = 44040;
    TokenType[TokenType["lessThan"] = lessThan] = "lessThan"; // < prec:8
    const greaterThan = 45064;
    TokenType[TokenType["greaterThan"] = greaterThan] = "greaterThan"; // > prec:8
    const relationalOrEqual = 46088;
    TokenType[TokenType["relationalOrEqual"] = relationalOrEqual] = "relationalOrEqual"; // <=/>= prec:8
    const bitShiftL = 47113;
    TokenType[TokenType["bitShiftL"] = bitShiftL] = "bitShiftL"; // << prec:9
    const bitShiftR = 48137;
    TokenType[TokenType["bitShiftR"] = bitShiftR] = "bitShiftR"; // >>/>>> prec:9
    const plus = 49802;
    TokenType[TokenType["plus"] = plus] = "plus"; // + prec:10 prefix startsExpr
    const minus = 50826;
    TokenType[TokenType["minus"] = minus] = "minus"; // - prec:10 prefix startsExpr
    const modulo = 51723;
    TokenType[TokenType["modulo"] = modulo] = "modulo"; // % prec:11 startsExpr
    const star = 52235;
    TokenType[TokenType["star"] = star] = "star"; // * prec:11
    const slash = 53259;
    TokenType[TokenType["slash"] = slash] = "slash"; // / prec:11
    const exponent = 54348;
    TokenType[TokenType["exponent"] = exponent] = "exponent"; // ** prec:12 rightAssociative
    const jsxName = 55296;
    TokenType[TokenType["jsxName"] = jsxName] = "jsxName"; // jsxName
    const jsxText = 56320;
    TokenType[TokenType["jsxText"] = jsxText] = "jsxText"; // jsxText
    const jsxEmptyText = 57344;
    TokenType[TokenType["jsxEmptyText"] = jsxEmptyText] = "jsxEmptyText"; // jsxEmptyText
    const jsxTagStart = 58880;
    TokenType[TokenType["jsxTagStart"] = jsxTagStart] = "jsxTagStart"; // jsxTagStart startsExpr
    const jsxTagEnd = 59392;
    TokenType[TokenType["jsxTagEnd"] = jsxTagEnd] = "jsxTagEnd"; // jsxTagEnd
    const typeParameterStart = 60928;
    TokenType[TokenType["typeParameterStart"] = typeParameterStart] = "typeParameterStart"; // typeParameterStart startsExpr
    const nonNullAssertion = 61440;
    TokenType[TokenType["nonNullAssertion"] = nonNullAssertion] = "nonNullAssertion"; // nonNullAssertion
    const _break = 62480;
    TokenType[TokenType["_break"] = _break] = "_break"; // break keyword
    const _case = 63504;
    TokenType[TokenType["_case"] = _case] = "_case"; // case keyword
    const _catch = 64528;
    TokenType[TokenType["_catch"] = _catch] = "_catch"; // catch keyword
    const _continue = 65552;
    TokenType[TokenType["_continue"] = _continue] = "_continue"; // continue keyword
    const _debugger = 66576;
    TokenType[TokenType["_debugger"] = _debugger] = "_debugger"; // debugger keyword
    const _default = 67600;
    TokenType[TokenType["_default"] = _default] = "_default"; // default keyword
    const _do = 68624;
    TokenType[TokenType["_do"] = _do] = "_do"; // do keyword
    const _else = 69648;
    TokenType[TokenType["_else"] = _else] = "_else"; // else keyword
    const _finally = 70672;
    TokenType[TokenType["_finally"] = _finally] = "_finally"; // finally keyword
    const _for = 71696;
    TokenType[TokenType["_for"] = _for] = "_for"; // for keyword
    const _function = 73232;
    TokenType[TokenType["_function"] = _function] = "_function"; // function keyword startsExpr
    const _if = 73744;
    TokenType[TokenType["_if"] = _if] = "_if"; // if keyword
    const _return = 74768;
    TokenType[TokenType["_return"] = _return] = "_return"; // return keyword
    const _switch = 75792;
    TokenType[TokenType["_switch"] = _switch] = "_switch"; // switch keyword
    const _throw = 77456;
    TokenType[TokenType["_throw"] = _throw] = "_throw"; // throw keyword prefix startsExpr
    const _try = 77840;
    TokenType[TokenType["_try"] = _try] = "_try"; // try keyword
    const _var = 78864;
    TokenType[TokenType["_var"] = _var] = "_var"; // var keyword
    const _let = 79888;
    TokenType[TokenType["_let"] = _let] = "_let"; // let keyword
    const _const = 80912;
    TokenType[TokenType["_const"] = _const] = "_const"; // const keyword
    const _while = 81936;
    TokenType[TokenType["_while"] = _while] = "_while"; // while keyword
    const _with = 82960;
    TokenType[TokenType["_with"] = _with] = "_with"; // with keyword
    const _new = 84496;
    TokenType[TokenType["_new"] = _new] = "_new"; // new keyword startsExpr
    const _this = 85520;
    TokenType[TokenType["_this"] = _this] = "_this"; // this keyword startsExpr
    const _super = 86544;
    TokenType[TokenType["_super"] = _super] = "_super"; // super keyword startsExpr
    const _class = 87568;
    TokenType[TokenType["_class"] = _class] = "_class"; // class keyword startsExpr
    const _extends = 88080;
    TokenType[TokenType["_extends"] = _extends] = "_extends"; // extends keyword
    const _export = 89104;
    TokenType[TokenType["_export"] = _export] = "_export"; // export keyword
    const _import = 90640;
    TokenType[TokenType["_import"] = _import] = "_import"; // import keyword startsExpr
    const _yield = 91664;
    TokenType[TokenType["_yield"] = _yield] = "_yield"; // yield keyword startsExpr
    const _null = 92688;
    TokenType[TokenType["_null"] = _null] = "_null"; // null keyword startsExpr
    const _true = 93712;
    TokenType[TokenType["_true"] = _true] = "_true"; // true keyword startsExpr
    const _false = 94736;
    TokenType[TokenType["_false"] = _false] = "_false"; // false keyword startsExpr
    const _in = 95256;
    TokenType[TokenType["_in"] = _in] = "_in"; // in prec:8 keyword
    const _instanceof = 96280;
    TokenType[TokenType["_instanceof"] = _instanceof] = "_instanceof"; // instanceof prec:8 keyword
    const _typeof = 97936;
    TokenType[TokenType["_typeof"] = _typeof] = "_typeof"; // typeof keyword prefix startsExpr
    const _void = 98960;
    TokenType[TokenType["_void"] = _void] = "_void"; // void keyword prefix startsExpr
    const _delete = 99984;
    TokenType[TokenType["_delete"] = _delete] = "_delete"; // delete keyword prefix startsExpr
    const _async = 100880;
    TokenType[TokenType["_async"] = _async] = "_async"; // async keyword startsExpr
    const _get = 101904;
    TokenType[TokenType["_get"] = _get] = "_get"; // get keyword startsExpr
    const _set = 102928;
    TokenType[TokenType["_set"] = _set] = "_set"; // set keyword startsExpr
    const _declare = 103952;
    TokenType[TokenType["_declare"] = _declare] = "_declare"; // declare keyword startsExpr
    const _readonly = 104976;
    TokenType[TokenType["_readonly"] = _readonly] = "_readonly"; // readonly keyword startsExpr
    const _abstract = 106000;
    TokenType[TokenType["_abstract"] = _abstract] = "_abstract"; // abstract keyword startsExpr
    const _static = 107024;
    TokenType[TokenType["_static"] = _static] = "_static"; // static keyword startsExpr
    const _public = 107536;
    TokenType[TokenType["_public"] = _public] = "_public"; // public keyword
    const _private = 108560;
    TokenType[TokenType["_private"] = _private] = "_private"; // private keyword
    const _protected = 109584;
    TokenType[TokenType["_protected"] = _protected] = "_protected"; // protected keyword
    const _override = 110608;
    TokenType[TokenType["_override"] = _override] = "_override"; // override keyword
    const _as = 112144;
    TokenType[TokenType["_as"] = _as] = "_as"; // as keyword startsExpr
    const _enum = 113168;
    TokenType[TokenType["_enum"] = _enum] = "_enum"; // enum keyword startsExpr
    const _type = 114192;
    TokenType[TokenType["_type"] = _type] = "_type"; // type keyword startsExpr
    const _implements = 115216;
    TokenType[TokenType["_implements"] = _implements] = "_implements"; // implements keyword startsExpr
})($c455753917f2f29d$export$f435f793048e7a0f || ($c455753917f2f29d$export$f435f793048e7a0f = {}));
function $c455753917f2f29d$export$b78065ce79336a93(tokenType) {
    switch(tokenType){
        case $c455753917f2f29d$export$f435f793048e7a0f.num:
            return "num";
        case $c455753917f2f29d$export$f435f793048e7a0f.bigint:
            return "bigint";
        case $c455753917f2f29d$export$f435f793048e7a0f.decimal:
            return "decimal";
        case $c455753917f2f29d$export$f435f793048e7a0f.regexp:
            return "regexp";
        case $c455753917f2f29d$export$f435f793048e7a0f.string:
            return "string";
        case $c455753917f2f29d$export$f435f793048e7a0f.name:
            return "name";
        case $c455753917f2f29d$export$f435f793048e7a0f.eof:
            return "eof";
        case $c455753917f2f29d$export$f435f793048e7a0f.bracketL:
            return "[";
        case $c455753917f2f29d$export$f435f793048e7a0f.bracketR:
            return "]";
        case $c455753917f2f29d$export$f435f793048e7a0f.braceL:
            return "{";
        case $c455753917f2f29d$export$f435f793048e7a0f.braceBarL:
            return "{|";
        case $c455753917f2f29d$export$f435f793048e7a0f.braceR:
            return "}";
        case $c455753917f2f29d$export$f435f793048e7a0f.braceBarR:
            return "|}";
        case $c455753917f2f29d$export$f435f793048e7a0f.parenL:
            return "(";
        case $c455753917f2f29d$export$f435f793048e7a0f.parenR:
            return ")";
        case $c455753917f2f29d$export$f435f793048e7a0f.comma:
            return ",";
        case $c455753917f2f29d$export$f435f793048e7a0f.semi:
            return ";";
        case $c455753917f2f29d$export$f435f793048e7a0f.colon:
            return ":";
        case $c455753917f2f29d$export$f435f793048e7a0f.doubleColon:
            return "::";
        case $c455753917f2f29d$export$f435f793048e7a0f.dot:
            return ".";
        case $c455753917f2f29d$export$f435f793048e7a0f.question:
            return "?";
        case $c455753917f2f29d$export$f435f793048e7a0f.questionDot:
            return "?.";
        case $c455753917f2f29d$export$f435f793048e7a0f.arrow:
            return "=>";
        case $c455753917f2f29d$export$f435f793048e7a0f.template:
            return "template";
        case $c455753917f2f29d$export$f435f793048e7a0f.ellipsis:
            return "...";
        case $c455753917f2f29d$export$f435f793048e7a0f.backQuote:
            return "`";
        case $c455753917f2f29d$export$f435f793048e7a0f.dollarBraceL:
            return "${";
        case $c455753917f2f29d$export$f435f793048e7a0f.at:
            return "@";
        case $c455753917f2f29d$export$f435f793048e7a0f.hash:
            return "#";
        case $c455753917f2f29d$export$f435f793048e7a0f.eq:
            return "=";
        case $c455753917f2f29d$export$f435f793048e7a0f.assign:
            return "_=";
        case $c455753917f2f29d$export$f435f793048e7a0f.preIncDec:
            return "++/--";
        case $c455753917f2f29d$export$f435f793048e7a0f.postIncDec:
            return "++/--";
        case $c455753917f2f29d$export$f435f793048e7a0f.bang:
            return "!";
        case $c455753917f2f29d$export$f435f793048e7a0f.tilde:
            return "~";
        case $c455753917f2f29d$export$f435f793048e7a0f.pipeline:
            return "|>";
        case $c455753917f2f29d$export$f435f793048e7a0f.nullishCoalescing:
            return "??";
        case $c455753917f2f29d$export$f435f793048e7a0f.logicalOR:
            return "||";
        case $c455753917f2f29d$export$f435f793048e7a0f.logicalAND:
            return "&&";
        case $c455753917f2f29d$export$f435f793048e7a0f.bitwiseOR:
            return "|";
        case $c455753917f2f29d$export$f435f793048e7a0f.bitwiseXOR:
            return "^";
        case $c455753917f2f29d$export$f435f793048e7a0f.bitwiseAND:
            return "&";
        case $c455753917f2f29d$export$f435f793048e7a0f.equality:
            return "==/!=";
        case $c455753917f2f29d$export$f435f793048e7a0f.lessThan:
            return "<";
        case $c455753917f2f29d$export$f435f793048e7a0f.greaterThan:
            return ">";
        case $c455753917f2f29d$export$f435f793048e7a0f.relationalOrEqual:
            return "<=/>=";
        case $c455753917f2f29d$export$f435f793048e7a0f.bitShiftL:
            return "<<";
        case $c455753917f2f29d$export$f435f793048e7a0f.bitShiftR:
            return ">>/>>>";
        case $c455753917f2f29d$export$f435f793048e7a0f.plus:
            return "+";
        case $c455753917f2f29d$export$f435f793048e7a0f.minus:
            return "-";
        case $c455753917f2f29d$export$f435f793048e7a0f.modulo:
            return "%";
        case $c455753917f2f29d$export$f435f793048e7a0f.star:
            return "*";
        case $c455753917f2f29d$export$f435f793048e7a0f.slash:
            return "/";
        case $c455753917f2f29d$export$f435f793048e7a0f.exponent:
            return "**";
        case $c455753917f2f29d$export$f435f793048e7a0f.jsxName:
            return "jsxName";
        case $c455753917f2f29d$export$f435f793048e7a0f.jsxText:
            return "jsxText";
        case $c455753917f2f29d$export$f435f793048e7a0f.jsxEmptyText:
            return "jsxEmptyText";
        case $c455753917f2f29d$export$f435f793048e7a0f.jsxTagStart:
            return "jsxTagStart";
        case $c455753917f2f29d$export$f435f793048e7a0f.jsxTagEnd:
            return "jsxTagEnd";
        case $c455753917f2f29d$export$f435f793048e7a0f.typeParameterStart:
            return "typeParameterStart";
        case $c455753917f2f29d$export$f435f793048e7a0f.nonNullAssertion:
            return "nonNullAssertion";
        case $c455753917f2f29d$export$f435f793048e7a0f._break:
            return "break";
        case $c455753917f2f29d$export$f435f793048e7a0f._case:
            return "case";
        case $c455753917f2f29d$export$f435f793048e7a0f._catch:
            return "catch";
        case $c455753917f2f29d$export$f435f793048e7a0f._continue:
            return "continue";
        case $c455753917f2f29d$export$f435f793048e7a0f._debugger:
            return "debugger";
        case $c455753917f2f29d$export$f435f793048e7a0f._default:
            return "default";
        case $c455753917f2f29d$export$f435f793048e7a0f._do:
            return "do";
        case $c455753917f2f29d$export$f435f793048e7a0f._else:
            return "else";
        case $c455753917f2f29d$export$f435f793048e7a0f._finally:
            return "finally";
        case $c455753917f2f29d$export$f435f793048e7a0f._for:
            return "for";
        case $c455753917f2f29d$export$f435f793048e7a0f._function:
            return "function";
        case $c455753917f2f29d$export$f435f793048e7a0f._if:
            return "if";
        case $c455753917f2f29d$export$f435f793048e7a0f._return:
            return "return";
        case $c455753917f2f29d$export$f435f793048e7a0f._switch:
            return "switch";
        case $c455753917f2f29d$export$f435f793048e7a0f._throw:
            return "throw";
        case $c455753917f2f29d$export$f435f793048e7a0f._try:
            return "try";
        case $c455753917f2f29d$export$f435f793048e7a0f._var:
            return "var";
        case $c455753917f2f29d$export$f435f793048e7a0f._let:
            return "let";
        case $c455753917f2f29d$export$f435f793048e7a0f._const:
            return "const";
        case $c455753917f2f29d$export$f435f793048e7a0f._while:
            return "while";
        case $c455753917f2f29d$export$f435f793048e7a0f._with:
            return "with";
        case $c455753917f2f29d$export$f435f793048e7a0f._new:
            return "new";
        case $c455753917f2f29d$export$f435f793048e7a0f._this:
            return "this";
        case $c455753917f2f29d$export$f435f793048e7a0f._super:
            return "super";
        case $c455753917f2f29d$export$f435f793048e7a0f._class:
            return "class";
        case $c455753917f2f29d$export$f435f793048e7a0f._extends:
            return "extends";
        case $c455753917f2f29d$export$f435f793048e7a0f._export:
            return "export";
        case $c455753917f2f29d$export$f435f793048e7a0f._import:
            return "import";
        case $c455753917f2f29d$export$f435f793048e7a0f._yield:
            return "yield";
        case $c455753917f2f29d$export$f435f793048e7a0f._null:
            return "null";
        case $c455753917f2f29d$export$f435f793048e7a0f._true:
            return "true";
        case $c455753917f2f29d$export$f435f793048e7a0f._false:
            return "false";
        case $c455753917f2f29d$export$f435f793048e7a0f._in:
            return "in";
        case $c455753917f2f29d$export$f435f793048e7a0f._instanceof:
            return "instanceof";
        case $c455753917f2f29d$export$f435f793048e7a0f._typeof:
            return "typeof";
        case $c455753917f2f29d$export$f435f793048e7a0f._void:
            return "void";
        case $c455753917f2f29d$export$f435f793048e7a0f._delete:
            return "delete";
        case $c455753917f2f29d$export$f435f793048e7a0f._async:
            return "async";
        case $c455753917f2f29d$export$f435f793048e7a0f._get:
            return "get";
        case $c455753917f2f29d$export$f435f793048e7a0f._set:
            return "set";
        case $c455753917f2f29d$export$f435f793048e7a0f._declare:
            return "declare";
        case $c455753917f2f29d$export$f435f793048e7a0f._readonly:
            return "readonly";
        case $c455753917f2f29d$export$f435f793048e7a0f._abstract:
            return "abstract";
        case $c455753917f2f29d$export$f435f793048e7a0f._static:
            return "static";
        case $c455753917f2f29d$export$f435f793048e7a0f._public:
            return "public";
        case $c455753917f2f29d$export$f435f793048e7a0f._private:
            return "private";
        case $c455753917f2f29d$export$f435f793048e7a0f._protected:
            return "protected";
        case $c455753917f2f29d$export$f435f793048e7a0f._override:
            return "override";
        case $c455753917f2f29d$export$f435f793048e7a0f._as:
            return "as";
        case $c455753917f2f29d$export$f435f793048e7a0f._enum:
            return "enum";
        case $c455753917f2f29d$export$f435f793048e7a0f._type:
            return "type";
        case $c455753917f2f29d$export$f435f793048e7a0f._implements:
            return "implements";
        default:
            return "";
    }
}


class $dfae9c1b3c46b56f$export$775b6bb06e53a214 {
    constructor(startTokenIndex, endTokenIndex, isFunctionScope){
        this.startTokenIndex = startTokenIndex;
        this.endTokenIndex = endTokenIndex;
        this.isFunctionScope = isFunctionScope;
    }
}
class $dfae9c1b3c46b56f$export$43b973415d9649ac {
    constructor(potentialArrowAt, noAnonFunctionType, inDisallowConditionalTypesContext, tokensLength, scopesLength, pos, type, contextualKeyword, start, end, isType, scopeDepth, error){
        this.potentialArrowAt = potentialArrowAt;
        this.noAnonFunctionType = noAnonFunctionType;
        this.inDisallowConditionalTypesContext = inDisallowConditionalTypesContext;
        this.tokensLength = tokensLength;
        this.scopesLength = scopesLength;
        this.pos = pos;
        this.type = type;
        this.contextualKeyword = contextualKeyword;
        this.start = start;
        this.end = end;
        this.isType = isType;
        this.scopeDepth = scopeDepth;
        this.error = error;
    }
}
class $dfae9c1b3c46b56f$export$2e2bcd8739ae039 {
    constructor(){
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init5.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init6.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init7.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init8.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init9.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init10.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init11.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init12.call(this);
        $dfae9c1b3c46b56f$export$2e2bcd8739ae039.prototype.__init13.call(this);
    }
    // Used to signify the start of a potential arrow function
    __init() {
        this.potentialArrowAt = -1;
    }
    // Used by Flow to handle an edge case involving function type parsing.
    __init2() {
        this.noAnonFunctionType = false;
    }
    // Used by TypeScript to handle ambiguities when parsing conditional types.
    __init3() {
        this.inDisallowConditionalTypesContext = false;
    }
    // Token store.
    __init4() {
        this.tokens = [];
    }
    // Array of all observed scopes, ordered by their ending position.
    __init5() {
        this.scopes = [];
    }
    // The current position of the tokenizer in the input.
    __init6() {
        this.pos = 0;
    }
    // Information about the current token.
    __init7() {
        this.type = (0, $c455753917f2f29d$export$f435f793048e7a0f).eof;
    }
    __init8() {
        this.contextualKeyword = (0, $0e760627819a3d75$export$ee633ab6cd0138cc).NONE;
    }
    __init9() {
        this.start = 0;
    }
    __init10() {
        this.end = 0;
    }
    __init11() {
        this.isType = false;
    }
    __init12() {
        this.scopeDepth = 0;
    }
    /**
   * If the parser is in an error state, then the token is always tt.eof and all functions can
   * keep executing but should be written so they don't get into an infinite loop in this situation.
   *
   * This approach, combined with the ability to snapshot and restore state, allows us to implement
   * backtracking without exceptions and without needing to explicitly propagate error states
   * everywhere.
   */ __init13() {
        this.error = null;
    }
    snapshot() {
        return new $dfae9c1b3c46b56f$export$43b973415d9649ac(this.potentialArrowAt, this.noAnonFunctionType, this.inDisallowConditionalTypesContext, this.tokens.length, this.scopes.length, this.pos, this.type, this.contextualKeyword, this.start, this.end, this.isType, this.scopeDepth, this.error);
    }
    restoreFromSnapshot(snapshot) {
        this.potentialArrowAt = snapshot.potentialArrowAt;
        this.noAnonFunctionType = snapshot.noAnonFunctionType;
        this.inDisallowConditionalTypesContext = snapshot.inDisallowConditionalTypesContext;
        this.tokens.length = snapshot.tokensLength;
        this.scopes.length = snapshot.scopesLength;
        this.pos = snapshot.pos;
        this.type = snapshot.type;
        this.contextualKeyword = snapshot.contextualKeyword;
        this.start = snapshot.start;
        this.end = snapshot.end;
        this.isType = snapshot.isType;
        this.scopeDepth = snapshot.scopeDepth;
        this.error = snapshot.error;
    }
}


var $b3c56b6031d55b89$export$dbe39bbf2ade60d5;
(function(charCodes) {
    const backSpace = 8;
    charCodes[charCodes["backSpace"] = backSpace] = "backSpace";
    const lineFeed = 10;
    charCodes[charCodes["lineFeed"] = lineFeed] = "lineFeed"; //  '\n'
    const tab = 9;
    charCodes[charCodes["tab"] = tab] = "tab"; //  '\t'
    const carriageReturn = 13;
    charCodes[charCodes["carriageReturn"] = carriageReturn] = "carriageReturn"; //  '\r'
    const shiftOut = 14;
    charCodes[charCodes["shiftOut"] = shiftOut] = "shiftOut";
    const space = 32;
    charCodes[charCodes["space"] = space] = "space";
    const exclamationMark = 33;
    charCodes[charCodes["exclamationMark"] = exclamationMark] = "exclamationMark"; //  '!'
    const quotationMark = 34;
    charCodes[charCodes["quotationMark"] = quotationMark] = "quotationMark"; //  '"'
    const numberSign = 35;
    charCodes[charCodes["numberSign"] = numberSign] = "numberSign"; //  '#'
    const dollarSign = 36;
    charCodes[charCodes["dollarSign"] = dollarSign] = "dollarSign"; //  '$'
    const percentSign = 37;
    charCodes[charCodes["percentSign"] = percentSign] = "percentSign"; //  '%'
    const ampersand = 38;
    charCodes[charCodes["ampersand"] = ampersand] = "ampersand"; //  '&'
    const apostrophe = 39;
    charCodes[charCodes["apostrophe"] = apostrophe] = "apostrophe"; //  '''
    const leftParenthesis = 40;
    charCodes[charCodes["leftParenthesis"] = leftParenthesis] = "leftParenthesis"; //  '('
    const rightParenthesis = 41;
    charCodes[charCodes["rightParenthesis"] = rightParenthesis] = "rightParenthesis"; //  ')'
    const asterisk = 42;
    charCodes[charCodes["asterisk"] = asterisk] = "asterisk"; //  '*'
    const plusSign = 43;
    charCodes[charCodes["plusSign"] = plusSign] = "plusSign"; //  '+'
    const comma = 44;
    charCodes[charCodes["comma"] = comma] = "comma"; //  ','
    const dash = 45;
    charCodes[charCodes["dash"] = dash] = "dash"; //  '-'
    const dot = 46;
    charCodes[charCodes["dot"] = dot] = "dot"; //  '.'
    const slash = 47;
    charCodes[charCodes["slash"] = slash] = "slash"; //  '/'
    const digit0 = 48;
    charCodes[charCodes["digit0"] = digit0] = "digit0"; //  '0'
    const digit1 = 49;
    charCodes[charCodes["digit1"] = digit1] = "digit1"; //  '1'
    const digit2 = 50;
    charCodes[charCodes["digit2"] = digit2] = "digit2"; //  '2'
    const digit3 = 51;
    charCodes[charCodes["digit3"] = digit3] = "digit3"; //  '3'
    const digit4 = 52;
    charCodes[charCodes["digit4"] = digit4] = "digit4"; //  '4'
    const digit5 = 53;
    charCodes[charCodes["digit5"] = digit5] = "digit5"; //  '5'
    const digit6 = 54;
    charCodes[charCodes["digit6"] = digit6] = "digit6"; //  '6'
    const digit7 = 55;
    charCodes[charCodes["digit7"] = digit7] = "digit7"; //  '7'
    const digit8 = 56;
    charCodes[charCodes["digit8"] = digit8] = "digit8"; //  '8'
    const digit9 = 57;
    charCodes[charCodes["digit9"] = digit9] = "digit9"; //  '9'
    const colon = 58;
    charCodes[charCodes["colon"] = colon] = "colon"; //  ':'
    const semicolon = 59;
    charCodes[charCodes["semicolon"] = semicolon] = "semicolon"; //  ';'
    const lessThan = 60;
    charCodes[charCodes["lessThan"] = lessThan] = "lessThan"; //  '<'
    const equalsTo = 61;
    charCodes[charCodes["equalsTo"] = equalsTo] = "equalsTo"; //  '='
    const greaterThan = 62;
    charCodes[charCodes["greaterThan"] = greaterThan] = "greaterThan"; //  '>'
    const questionMark = 63;
    charCodes[charCodes["questionMark"] = questionMark] = "questionMark"; //  '?'
    const atSign = 64;
    charCodes[charCodes["atSign"] = atSign] = "atSign"; //  '@'
    const uppercaseA = 65;
    charCodes[charCodes["uppercaseA"] = uppercaseA] = "uppercaseA"; //  'A'
    const uppercaseB = 66;
    charCodes[charCodes["uppercaseB"] = uppercaseB] = "uppercaseB"; //  'B'
    const uppercaseC = 67;
    charCodes[charCodes["uppercaseC"] = uppercaseC] = "uppercaseC"; //  'C'
    const uppercaseD = 68;
    charCodes[charCodes["uppercaseD"] = uppercaseD] = "uppercaseD"; //  'D'
    const uppercaseE = 69;
    charCodes[charCodes["uppercaseE"] = uppercaseE] = "uppercaseE"; //  'E'
    const uppercaseF = 70;
    charCodes[charCodes["uppercaseF"] = uppercaseF] = "uppercaseF"; //  'F'
    const uppercaseG = 71;
    charCodes[charCodes["uppercaseG"] = uppercaseG] = "uppercaseG"; //  'G'
    const uppercaseH = 72;
    charCodes[charCodes["uppercaseH"] = uppercaseH] = "uppercaseH"; //  'H'
    const uppercaseI = 73;
    charCodes[charCodes["uppercaseI"] = uppercaseI] = "uppercaseI"; //  'I'
    const uppercaseJ = 74;
    charCodes[charCodes["uppercaseJ"] = uppercaseJ] = "uppercaseJ"; //  'J'
    const uppercaseK = 75;
    charCodes[charCodes["uppercaseK"] = uppercaseK] = "uppercaseK"; //  'K'
    const uppercaseL = 76;
    charCodes[charCodes["uppercaseL"] = uppercaseL] = "uppercaseL"; //  'L'
    const uppercaseM = 77;
    charCodes[charCodes["uppercaseM"] = uppercaseM] = "uppercaseM"; //  'M'
    const uppercaseN = 78;
    charCodes[charCodes["uppercaseN"] = uppercaseN] = "uppercaseN"; //  'N'
    const uppercaseO = 79;
    charCodes[charCodes["uppercaseO"] = uppercaseO] = "uppercaseO"; //  'O'
    const uppercaseP = 80;
    charCodes[charCodes["uppercaseP"] = uppercaseP] = "uppercaseP"; //  'P'
    const uppercaseQ = 81;
    charCodes[charCodes["uppercaseQ"] = uppercaseQ] = "uppercaseQ"; //  'Q'
    const uppercaseR = 82;
    charCodes[charCodes["uppercaseR"] = uppercaseR] = "uppercaseR"; //  'R'
    const uppercaseS = 83;
    charCodes[charCodes["uppercaseS"] = uppercaseS] = "uppercaseS"; //  'S'
    const uppercaseT = 84;
    charCodes[charCodes["uppercaseT"] = uppercaseT] = "uppercaseT"; //  'T'
    const uppercaseU = 85;
    charCodes[charCodes["uppercaseU"] = uppercaseU] = "uppercaseU"; //  'U'
    const uppercaseV = 86;
    charCodes[charCodes["uppercaseV"] = uppercaseV] = "uppercaseV"; //  'V'
    const uppercaseW = 87;
    charCodes[charCodes["uppercaseW"] = uppercaseW] = "uppercaseW"; //  'W'
    const uppercaseX = 88;
    charCodes[charCodes["uppercaseX"] = uppercaseX] = "uppercaseX"; //  'X'
    const uppercaseY = 89;
    charCodes[charCodes["uppercaseY"] = uppercaseY] = "uppercaseY"; //  'Y'
    const uppercaseZ = 90;
    charCodes[charCodes["uppercaseZ"] = uppercaseZ] = "uppercaseZ"; //  'Z'
    const leftSquareBracket = 91;
    charCodes[charCodes["leftSquareBracket"] = leftSquareBracket] = "leftSquareBracket"; //  '['
    const backslash = 92;
    charCodes[charCodes["backslash"] = backslash] = "backslash"; //  '\    '
    const rightSquareBracket = 93;
    charCodes[charCodes["rightSquareBracket"] = rightSquareBracket] = "rightSquareBracket"; //  ']'
    const caret = 94;
    charCodes[charCodes["caret"] = caret] = "caret"; //  '^'
    const underscore = 95;
    charCodes[charCodes["underscore"] = underscore] = "underscore"; //  '_'
    const graveAccent = 96;
    charCodes[charCodes["graveAccent"] = graveAccent] = "graveAccent"; //  '`'
    const lowercaseA = 97;
    charCodes[charCodes["lowercaseA"] = lowercaseA] = "lowercaseA"; //  'a'
    const lowercaseB = 98;
    charCodes[charCodes["lowercaseB"] = lowercaseB] = "lowercaseB"; //  'b'
    const lowercaseC = 99;
    charCodes[charCodes["lowercaseC"] = lowercaseC] = "lowercaseC"; //  'c'
    const lowercaseD = 100;
    charCodes[charCodes["lowercaseD"] = lowercaseD] = "lowercaseD"; //  'd'
    const lowercaseE = 101;
    charCodes[charCodes["lowercaseE"] = lowercaseE] = "lowercaseE"; //  'e'
    const lowercaseF = 102;
    charCodes[charCodes["lowercaseF"] = lowercaseF] = "lowercaseF"; //  'f'
    const lowercaseG = 103;
    charCodes[charCodes["lowercaseG"] = lowercaseG] = "lowercaseG"; //  'g'
    const lowercaseH = 104;
    charCodes[charCodes["lowercaseH"] = lowercaseH] = "lowercaseH"; //  'h'
    const lowercaseI = 105;
    charCodes[charCodes["lowercaseI"] = lowercaseI] = "lowercaseI"; //  'i'
    const lowercaseJ = 106;
    charCodes[charCodes["lowercaseJ"] = lowercaseJ] = "lowercaseJ"; //  'j'
    const lowercaseK = 107;
    charCodes[charCodes["lowercaseK"] = lowercaseK] = "lowercaseK"; //  'k'
    const lowercaseL = 108;
    charCodes[charCodes["lowercaseL"] = lowercaseL] = "lowercaseL"; //  'l'
    const lowercaseM = 109;
    charCodes[charCodes["lowercaseM"] = lowercaseM] = "lowercaseM"; //  'm'
    const lowercaseN = 110;
    charCodes[charCodes["lowercaseN"] = lowercaseN] = "lowercaseN"; //  'n'
    const lowercaseO = 111;
    charCodes[charCodes["lowercaseO"] = lowercaseO] = "lowercaseO"; //  'o'
    const lowercaseP = 112;
    charCodes[charCodes["lowercaseP"] = lowercaseP] = "lowercaseP"; //  'p'
    const lowercaseQ = 113;
    charCodes[charCodes["lowercaseQ"] = lowercaseQ] = "lowercaseQ"; //  'q'
    const lowercaseR = 114;
    charCodes[charCodes["lowercaseR"] = lowercaseR] = "lowercaseR"; //  'r'
    const lowercaseS = 115;
    charCodes[charCodes["lowercaseS"] = lowercaseS] = "lowercaseS"; //  's'
    const lowercaseT = 116;
    charCodes[charCodes["lowercaseT"] = lowercaseT] = "lowercaseT"; //  't'
    const lowercaseU = 117;
    charCodes[charCodes["lowercaseU"] = lowercaseU] = "lowercaseU"; //  'u'
    const lowercaseV = 118;
    charCodes[charCodes["lowercaseV"] = lowercaseV] = "lowercaseV"; //  'v'
    const lowercaseW = 119;
    charCodes[charCodes["lowercaseW"] = lowercaseW] = "lowercaseW"; //  'w'
    const lowercaseX = 120;
    charCodes[charCodes["lowercaseX"] = lowercaseX] = "lowercaseX"; //  'x'
    const lowercaseY = 121;
    charCodes[charCodes["lowercaseY"] = lowercaseY] = "lowercaseY"; //  'y'
    const lowercaseZ = 122;
    charCodes[charCodes["lowercaseZ"] = lowercaseZ] = "lowercaseZ"; //  'z'
    const leftCurlyBrace = 123;
    charCodes[charCodes["leftCurlyBrace"] = leftCurlyBrace] = "leftCurlyBrace"; //  '{'
    const verticalBar = 124;
    charCodes[charCodes["verticalBar"] = verticalBar] = "verticalBar"; //  '|'
    const rightCurlyBrace = 125;
    charCodes[charCodes["rightCurlyBrace"] = rightCurlyBrace] = "rightCurlyBrace"; //  '}'
    const tilde = 126;
    charCodes[charCodes["tilde"] = tilde] = "tilde"; //  '~'
    const nonBreakingSpace = 160;
    charCodes[charCodes["nonBreakingSpace"] = nonBreakingSpace] = "nonBreakingSpace";
    // eslint-disable-next-line no-irregular-whitespace
    const oghamSpaceMark = 5760;
    charCodes[charCodes["oghamSpaceMark"] = oghamSpaceMark] = "oghamSpaceMark"; // ' '
    const lineSeparator = 8232;
    charCodes[charCodes["lineSeparator"] = lineSeparator] = "lineSeparator";
    const paragraphSeparator = 8233;
    charCodes[charCodes["paragraphSeparator"] = paragraphSeparator] = "paragraphSeparator";
})($b3c56b6031d55b89$export$dbe39bbf2ade60d5 || ($b3c56b6031d55b89$export$dbe39bbf2ade60d5 = {}));
function $b3c56b6031d55b89$export$727d9dbc4fbb948f(code) {
    return code >= $b3c56b6031d55b89$export$dbe39bbf2ade60d5.digit0 && code <= $b3c56b6031d55b89$export$dbe39bbf2ade60d5.digit9 || code >= $b3c56b6031d55b89$export$dbe39bbf2ade60d5.lowercaseA && code <= $b3c56b6031d55b89$export$dbe39bbf2ade60d5.lowercaseF || code >= $b3c56b6031d55b89$export$dbe39bbf2ade60d5.uppercaseA && code <= $b3c56b6031d55b89$export$dbe39bbf2ade60d5.uppercaseF;
}


let $d9d7db628df75264$export$43bb667a94af025a;
let $d9d7db628df75264$export$757c2735689d2de8;
let $d9d7db628df75264$export$92e334f8fe49aa94;
let $d9d7db628df75264$export$ca000e230c0caa3e;
let $d9d7db628df75264$export$b7e3ae3d7c15e42e;
let $d9d7db628df75264$export$d854af1c30ac0f3a;
function $d9d7db628df75264$export$d0c215ddd78b3d24() {
    return $d9d7db628df75264$export$d854af1c30ac0f3a++;
}
function $d9d7db628df75264$export$2ca6ff5cad32970a(error) {
    if ("pos" in error) {
        const loc = $d9d7db628df75264$export$66bfa486b735c2f7(error.pos);
        error.message += ` (${loc.line}:${loc.column})`;
        error.loc = loc;
    }
    return error;
}
class $d9d7db628df75264$export$f564f979629709cc {
    constructor(line, column){
        this.line = line;
        this.column = column;
    }
}
function $d9d7db628df75264$export$66bfa486b735c2f7(pos) {
    let line = 1;
    let column = 1;
    for(let i = 0; i < pos; i++)if ($d9d7db628df75264$export$b7e3ae3d7c15e42e.charCodeAt(i) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed) {
        line++;
        column = 1;
    } else column++;
    return new $d9d7db628df75264$export$f564f979629709cc(line, column);
}
function $d9d7db628df75264$export$84bb9899435eeb61(inputCode, isJSXEnabledArg, isTypeScriptEnabledArg, isFlowEnabledArg) {
    $d9d7db628df75264$export$b7e3ae3d7c15e42e = inputCode;
    $d9d7db628df75264$export$ca000e230c0caa3e = new (0, $dfae9c1b3c46b56f$export$2e2bcd8739ae039)();
    $d9d7db628df75264$export$d854af1c30ac0f3a = 1;
    $d9d7db628df75264$export$43bb667a94af025a = isJSXEnabledArg;
    $d9d7db628df75264$export$757c2735689d2de8 = isTypeScriptEnabledArg;
    $d9d7db628df75264$export$92e334f8fe49aa94 = isFlowEnabledArg;
}






function $85f046d5f58d0c41$export$d382681f238736f1(contextualKeyword) {
    return (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === contextualKeyword;
}
function $85f046d5f58d0c41$export$d1b5391c35999eba(contextualKeyword) {
    const l = (0, $d45b756a11a5dc19$export$ef1b94c514fc060a)();
    return l.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name && l.contextualKeyword === contextualKeyword;
}
function $85f046d5f58d0c41$export$b8f8f7fffeb6fb36(contextualKeyword) {
    return (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === contextualKeyword && (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
}
function $85f046d5f58d0c41$export$b8ead11dfed96f19(contextualKeyword) {
    if (!$85f046d5f58d0c41$export$b8f8f7fffeb6fb36(contextualKeyword)) $85f046d5f58d0c41$export$4c195bc1a97b6f7f();
}
function $85f046d5f58d0c41$export$1c0919cee6560c3() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).eof) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) || $85f046d5f58d0c41$export$942fa35f3a7c108c();
}
function $85f046d5f58d0c41$export$942fa35f3a7c108c() {
    const prevToken = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1];
    const lastTokEnd = prevToken ? prevToken.end : 0;
    for(let i = lastTokEnd; i < (0, $d9d7db628df75264$export$ca000e230c0caa3e).start; i++){
        const code = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(i);
        if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed || code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).carriageReturn || code === 0x2028 || code === 0x2029) return true;
    }
    return false;
}
function $85f046d5f58d0c41$export$a4f1ee8cbd9b31ba() {
    const nextStart = (0, $d45b756a11a5dc19$export$1678d89ce52f4a6)();
    for(let i = (0, $d9d7db628df75264$export$ca000e230c0caa3e).end; i < nextStart; i++){
        const code = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(i);
        if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed || code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).carriageReturn || code === 0x2028 || code === 0x2029) return true;
    }
    return false;
}
function $85f046d5f58d0c41$export$12d132b6e81066e4() {
    return (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi) || $85f046d5f58d0c41$export$1c0919cee6560c3();
}
function $85f046d5f58d0c41$export$62fa27d385e555f3() {
    if (!$85f046d5f58d0c41$export$12d132b6e81066e4()) $85f046d5f58d0c41$export$4c195bc1a97b6f7f('Unexpected token, expected ";"');
}
function $85f046d5f58d0c41$export$3570f33b1a1f3329(type) {
    const matched = (0, $d45b756a11a5dc19$export$3106cdec37e36f77)(type);
    if (!matched) $85f046d5f58d0c41$export$4c195bc1a97b6f7f(`Unexpected token, expected "${(0, $c455753917f2f29d$export$b78065ce79336a93)(type)}"`);
}
function $85f046d5f58d0c41$export$4c195bc1a97b6f7f(message = "Unexpected token", pos = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start) {
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const err = new SyntaxError(message);
    err.pos = pos;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).error = err;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length;
    (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).eof);
}





const $4fa6217c3efaba76$export$518c7e3eadd435e0 = [
    0x0009,
    0x000b,
    0x000c,
    (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).space,
    (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).nonBreakingSpace,
    (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).oghamSpaceMark,
    0x2000,
    0x2001,
    0x2002,
    0x2003,
    0x2004,
    0x2005,
    0x2006,
    0x2007,
    0x2008,
    0x2009,
    0x200a,
    0x202f,
    0x205f,
    0x3000,
    0xfeff
];
const $4fa6217c3efaba76$export$4856bde7911f0623 = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g;
const $4fa6217c3efaba76$export$4347b22d2e0ca480 = new Uint8Array(65536);
for (const char of $4fa6217c3efaba76$export$518c7e3eadd435e0)$4fa6217c3efaba76$export$4347b22d2e0ca480[char] = 1;


function $d6dc0379bdf024ad$var$computeIsIdentifierChar(code) {
    if (code < 48) return code === 36;
    if (code < 58) return true;
    if (code < 65) return false;
    if (code < 91) return true;
    if (code < 97) return code === 95;
    if (code < 123) return true;
    if (code < 128) return false;
    throw new Error("Should not be called with non-ASCII char code.");
}
const $d6dc0379bdf024ad$export$d19df39e3926cfef = new Uint8Array(65536);
for(let i = 0; i < 128; i++)$d6dc0379bdf024ad$export$d19df39e3926cfef[i] = $d6dc0379bdf024ad$var$computeIsIdentifierChar(i) ? 1 : 0;
for(let i = 128; i < 65536; i++)$d6dc0379bdf024ad$export$d19df39e3926cfef[i] = 1;
// Aside from whitespace and newlines, all characters outside the ASCII space are either
// identifier characters or invalid. Since we're not performing code validation, we can just
// treat all invalid characters as identifier characters.
for (const whitespaceChar of (0, $4fa6217c3efaba76$export$518c7e3eadd435e0))$d6dc0379bdf024ad$export$d19df39e3926cfef[whitespaceChar] = 0;
$d6dc0379bdf024ad$export$d19df39e3926cfef[0x2028] = 0;
$d6dc0379bdf024ad$export$d19df39e3926cfef[0x2029] = 0;
const $d6dc0379bdf024ad$export$dc1d1d7d9fdffb8 = $d6dc0379bdf024ad$export$d19df39e3926cfef.slice();
for(let numChar = (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit0; numChar <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit9; numChar++)$d6dc0379bdf024ad$export$dc1d1d7d9fdffb8[numChar] = 0;








// Generated file, do not edit! Run "yarn generate" to re-generate this file.


const $d6039ee8f3caece2$export$cb39af7c41e25635 = new Int32Array([
    // ""
    -1,
    27,
    783,
    918,
    1755,
    2376,
    2862,
    3483,
    -1,
    3699,
    -1,
    4617,
    4752,
    4833,
    5130,
    5508,
    5940,
    -1,
    6480,
    6939,
    7749,
    8181,
    8451,
    8613,
    -1,
    8829,
    -1,
    // "a"
    -1,
    -1,
    54,
    243,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    432,
    -1,
    -1,
    -1,
    675,
    -1,
    -1,
    -1,
    // "ab"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    81,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abs"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    108,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abst"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    135,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstr"
    -1,
    162,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstra"
    -1,
    -1,
    -1,
    189,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstrac"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    216,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "abstract"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._abstract << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ac"
    -1,
    -1,
    -1,
    270,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acc"
    -1,
    -1,
    -1,
    -1,
    -1,
    297,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acce"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    324,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "acces"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    351,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "access"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    378,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "accesso"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    405,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "accessor"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._accessor << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "as"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    459,
    -1,
    -1,
    -1,
    -1,
    -1,
    594,
    -1,
    // "ass"
    -1,
    -1,
    -1,
    -1,
    -1,
    486,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asse"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    513,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asser"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    540,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "assert"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._assert << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    567,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asserts"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._asserts << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asy"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    621,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "asyn"
    -1,
    -1,
    -1,
    648,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "async"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "aw"
    -1,
    702,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "awa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    729,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "awai"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    756,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "await"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._await << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "b"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    810,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "br"
    -1,
    -1,
    -1,
    -1,
    -1,
    837,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "bre"
    -1,
    864,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "brea"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    891,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "break"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._break << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "c"
    -1,
    945,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1107,
    -1,
    -1,
    -1,
    1242,
    -1,
    -1,
    1350,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ca"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    972,
    1026,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cas"
    -1,
    -1,
    -1,
    -1,
    -1,
    999,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "case"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._case << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cat"
    -1,
    -1,
    -1,
    1053,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "catc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1080,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "catch"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._catch << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ch"
    -1,
    -1,
    -1,
    -1,
    -1,
    1134,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "che"
    -1,
    -1,
    -1,
    1161,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "chec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1188,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "check"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1215,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "checks"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._checks << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cl"
    -1,
    1269,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cla"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1296,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "clas"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1323,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "class"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._class << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "co"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1377,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "con"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1404,
    1620,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cons"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1431,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "const"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._const << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1458,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1485,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constru"
    -1,
    -1,
    -1,
    1512,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "construc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1539,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "construct"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1566,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constructo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1593,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "constructor"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._constructor << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "cont"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1647,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "conti"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1674,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "contin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1701,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "continu"
    -1,
    -1,
    -1,
    -1,
    -1,
    1728,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "continue"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._continue << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "d"
    -1,
    -1,
    -1,
    -1,
    -1,
    1782,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2349,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "de"
    -1,
    -1,
    1809,
    1971,
    -1,
    -1,
    2106,
    -1,
    -1,
    -1,
    -1,
    -1,
    2241,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "deb"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1836,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1863,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debug"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1890,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugg"
    -1,
    -1,
    -1,
    -1,
    -1,
    1917,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugge"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1944,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "debugger"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._debugger << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "dec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    1998,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "decl"
    -1,
    2025,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "decla"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2052,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "declar"
    -1,
    -1,
    -1,
    -1,
    -1,
    2079,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "declare"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._declare << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "def"
    -1,
    2133,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2160,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defau"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2187,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "defaul"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2214,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "default"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._default << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "del"
    -1,
    -1,
    -1,
    -1,
    -1,
    2268,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "dele"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2295,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "delet"
    -1,
    -1,
    -1,
    -1,
    -1,
    2322,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "delete"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._delete << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "do"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._do << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "e"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2403,
    -1,
    2484,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2565,
    -1,
    -1,
    // "el"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2430,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "els"
    -1,
    -1,
    -1,
    -1,
    -1,
    2457,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "else"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._else << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "en"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2511,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "enu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2538,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "enum"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ex"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2592,
    -1,
    -1,
    -1,
    2727,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exp"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2619,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "expo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2646,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "expor"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2673,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "export"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._export << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2700,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exports"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._exports << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ext"
    -1,
    -1,
    -1,
    -1,
    -1,
    2754,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exte"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2781,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "exten"
    -1,
    -1,
    -1,
    -1,
    2808,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "extend"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2835,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "extends"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "f"
    -1,
    2889,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2997,
    -1,
    -1,
    -1,
    -1,
    -1,
    3159,
    -1,
    -1,
    3213,
    -1,
    -1,
    3294,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2916,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fal"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    2943,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fals"
    -1,
    -1,
    -1,
    -1,
    -1,
    2970,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "false"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._false << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3024,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fin"
    -1,
    3051,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fina"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3078,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "final"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3105,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "finall"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3132,
    -1,
    // "finally"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._finally << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3186,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "for"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._for << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3240,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3267,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "from"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3321,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "fun"
    -1,
    -1,
    -1,
    3348,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "func"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3375,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "funct"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3402,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "functi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3429,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "functio"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3456,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "function"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._function << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "g"
    -1,
    -1,
    -1,
    -1,
    -1,
    3510,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3564,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ge"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3537,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "get"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._get << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "gl"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3591,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "glo"
    -1,
    -1,
    3618,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "glob"
    -1,
    3645,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "globa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3672,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "global"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._global << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "i"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3726,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3753,
    4077,
    -1,
    -1,
    -1,
    -1,
    4590,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "if"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._if << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "im"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3780,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "imp"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3807,
    -1,
    -1,
    3996,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impl"
    -1,
    -1,
    -1,
    -1,
    -1,
    3834,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "imple"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3861,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implem"
    -1,
    -1,
    -1,
    -1,
    -1,
    3888,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impleme"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3915,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implemen"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3942,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implement"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    3969,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "implements"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._implements << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4023,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "impor"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4050,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "import"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._import << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "in"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._in << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4104,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4185,
    4401,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inf"
    -1,
    -1,
    -1,
    -1,
    -1,
    4131,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "infe"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4158,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "infer"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._infer << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ins"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4212,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inst"
    -1,
    4239,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "insta"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4266,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instan"
    -1,
    -1,
    -1,
    4293,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanc"
    -1,
    -1,
    -1,
    -1,
    -1,
    4320,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instance"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4347,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanceo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4374,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "instanceof"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._instanceof << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "int"
    -1,
    -1,
    -1,
    -1,
    -1,
    4428,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inte"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4455,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "inter"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4482,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interf"
    -1,
    4509,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interfa"
    -1,
    -1,
    -1,
    4536,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interfac"
    -1,
    -1,
    -1,
    -1,
    -1,
    4563,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "interface"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "is"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._is << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "k"
    -1,
    -1,
    -1,
    -1,
    -1,
    4644,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ke"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4671,
    -1,
    // "key"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4698,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "keyo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4725,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "keyof"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._keyof << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "l"
    -1,
    -1,
    -1,
    -1,
    -1,
    4779,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "le"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4806,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "let"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._let << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "m"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4860,
    -1,
    -1,
    -1,
    -1,
    -1,
    4995,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4887,
    -1,
    -1,
    // "mix"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4914,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4941,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    4968,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mixins"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._mixins << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mo"
    -1,
    -1,
    -1,
    -1,
    5022,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "mod"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5049,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "modu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5076,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "modul"
    -1,
    -1,
    -1,
    -1,
    -1,
    5103,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "module"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "n"
    -1,
    5157,
    -1,
    -1,
    -1,
    5373,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5427,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "na"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5184,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nam"
    -1,
    -1,
    -1,
    -1,
    -1,
    5211,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "name"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5238,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "names"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5265,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namesp"
    -1,
    5292,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespa"
    -1,
    -1,
    -1,
    5319,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespac"
    -1,
    -1,
    -1,
    -1,
    -1,
    5346,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "namespace"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._namespace << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ne"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5400,
    -1,
    -1,
    -1,
    // "new"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._new << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5454,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "nul"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5481,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "null"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._null << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "o"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5535,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5562,
    -1,
    -1,
    -1,
    -1,
    5697,
    5751,
    -1,
    -1,
    -1,
    -1,
    // "of"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._of << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "op"
    -1,
    5589,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5616,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaq"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5643,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaqu"
    -1,
    -1,
    -1,
    -1,
    -1,
    5670,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "opaque"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._opaque << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ou"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5724,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "out"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._out << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ov"
    -1,
    -1,
    -1,
    -1,
    -1,
    5778,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ove"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5805,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "over"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5832,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5859,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overri"
    -1,
    -1,
    -1,
    -1,
    5886,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "overrid"
    -1,
    -1,
    -1,
    -1,
    -1,
    5913,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "override"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._override << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "p"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5967,
    -1,
    -1,
    6345,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    5994,
    -1,
    -1,
    -1,
    -1,
    -1,
    6129,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pri"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6021,
    -1,
    -1,
    -1,
    -1,
    // "priv"
    -1,
    6048,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "priva"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6075,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "privat"
    -1,
    -1,
    -1,
    -1,
    -1,
    6102,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "private"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._private << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6156,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "prot"
    -1,
    -1,
    -1,
    -1,
    -1,
    6183,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6318,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "prote"
    -1,
    -1,
    -1,
    6210,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protec"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6237,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protect"
    -1,
    -1,
    -1,
    -1,
    -1,
    6264,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protecte"
    -1,
    -1,
    -1,
    -1,
    6291,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "protected"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._protected << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "proto"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._proto << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pu"
    -1,
    -1,
    6372,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "pub"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6399,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "publ"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6426,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "publi"
    -1,
    -1,
    -1,
    6453,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "public"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._public << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "r"
    -1,
    -1,
    -1,
    -1,
    -1,
    6507,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "re"
    -1,
    6534,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6696,
    -1,
    -1,
    6831,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "rea"
    -1,
    -1,
    -1,
    -1,
    6561,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "read"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6588,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "reado"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6615,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "readon"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6642,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "readonl"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6669,
    -1,
    // "readonly"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "req"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6723,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requ"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6750,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6777,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "requir"
    -1,
    -1,
    -1,
    -1,
    -1,
    6804,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "require"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._require << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ret"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6858,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "retu"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6885,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "retur"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6912,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "return"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._return << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "s"
    -1,
    6966,
    -1,
    -1,
    -1,
    7182,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7236,
    7371,
    -1,
    7479,
    -1,
    7614,
    -1,
    // "sa"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    6993,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sat"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7020,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sati"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7047,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satis"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7074,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisf"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7101,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfi"
    -1,
    -1,
    -1,
    -1,
    -1,
    7128,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfie"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7155,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "satisfies"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._satisfies << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "se"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7209,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "set"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._set << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "st"
    -1,
    7263,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sta"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7290,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "stat"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7317,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "stati"
    -1,
    -1,
    -1,
    7344,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "static"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._static << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "su"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7398,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sup"
    -1,
    -1,
    -1,
    -1,
    -1,
    7425,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "supe"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7452,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "super"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._super << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sw"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7506,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "swi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7533,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "swit"
    -1,
    -1,
    -1,
    7560,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "switc"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7587,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "switch"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._switch << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sy"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7641,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "sym"
    -1,
    -1,
    7668,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symb"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7695,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symbo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7722,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "symbol"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._symbol << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "t"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7776,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7938,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8046,
    -1,
    // "th"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7803,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7857,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7830,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "this"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._this << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7884,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "thro"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7911,
    -1,
    -1,
    -1,
    // "throw"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._throw << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "tr"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    7965,
    -1,
    -1,
    -1,
    8019,
    -1,
    // "tru"
    -1,
    -1,
    -1,
    -1,
    -1,
    7992,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "true"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._true << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "try"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._try << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "ty"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8073,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typ"
    -1,
    -1,
    -1,
    -1,
    -1,
    8100,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "type"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8127,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typeo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8154,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "typeof"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._typeof << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "u"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8208,
    -1,
    -1,
    -1,
    -1,
    8343,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "un"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8235,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uni"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8262,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uniq"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8289,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "uniqu"
    -1,
    -1,
    -1,
    -1,
    -1,
    8316,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "unique"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._unique << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "us"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8370,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "usi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8397,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "usin"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8424,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "using"
    (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._using << 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "v"
    -1,
    8478,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8532,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "va"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8505,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "var"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._var << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "vo"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8559,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "voi"
    -1,
    -1,
    -1,
    -1,
    8586,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "void"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._void << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "w"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8640,
    8748,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wh"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8667,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "whi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8694,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "whil"
    -1,
    -1,
    -1,
    -1,
    -1,
    8721,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "while"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._while << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wi"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8775,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "wit"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8802,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "with"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._with << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "y"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8856,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yi"
    -1,
    -1,
    -1,
    -1,
    -1,
    8883,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yie"
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    8910,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yiel"
    -1,
    -1,
    -1,
    -1,
    8937,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    // "yield"
    ((0, $c455753917f2f29d$export$f435f793048e7a0f)._yield << 1) + 1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1,
    -1
]);



function $282dceb445a5c57f$export$2e2bcd8739ae039() {
    let treePos = 0;
    let code = 0;
    let pos = (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    while(pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length){
        code = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(pos);
        if (code < (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseA || code > (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseZ) break;
        const next = (0, $d6039ee8f3caece2$export$cb39af7c41e25635)[treePos + (code - (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseA) + 1];
        if (next === -1) break;
        else {
            treePos = next;
            pos++;
        }
    }
    const keywordValue = (0, $d6039ee8f3caece2$export$cb39af7c41e25635)[treePos];
    if (keywordValue > -1 && !(0, $d6dc0379bdf024ad$export$d19df39e3926cfef)[code]) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos = pos;
        if (keywordValue & 1) (0, $d45b756a11a5dc19$export$58122cd1933ef607)(keywordValue >>> 1);
        else (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).name, keywordValue >>> 1);
        return;
    }
    while(pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(pos);
        if ((0, $d6dc0379bdf024ad$export$d19df39e3926cfef)[ch]) pos++;
        else if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).backslash) {
            // \u
            pos += 2;
            if ((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(pos) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftCurlyBrace) {
                while(pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(pos) !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).rightCurlyBrace)pos++;
                pos++;
            }
        } else if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).atSign && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(pos + 1) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).atSign) pos += 2;
        else break;
    }
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos = pos;
    (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
}



var $d45b756a11a5dc19$export$99f888ada3c99de3;
(function(IdentifierRole) {
    const Access = 0;
    IdentifierRole[IdentifierRole["Access"] = Access] = "Access";
    const ExportAccess = Access + 1;
    IdentifierRole[IdentifierRole["ExportAccess"] = ExportAccess] = "ExportAccess";
    const TopLevelDeclaration = ExportAccess + 1;
    IdentifierRole[IdentifierRole["TopLevelDeclaration"] = TopLevelDeclaration] = "TopLevelDeclaration";
    const FunctionScopedDeclaration = TopLevelDeclaration + 1;
    IdentifierRole[IdentifierRole["FunctionScopedDeclaration"] = FunctionScopedDeclaration] = "FunctionScopedDeclaration";
    const BlockScopedDeclaration = FunctionScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["BlockScopedDeclaration"] = BlockScopedDeclaration] = "BlockScopedDeclaration";
    const ObjectShorthandTopLevelDeclaration = BlockScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandTopLevelDeclaration"] = ObjectShorthandTopLevelDeclaration] = "ObjectShorthandTopLevelDeclaration";
    const ObjectShorthandFunctionScopedDeclaration = ObjectShorthandTopLevelDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandFunctionScopedDeclaration"] = ObjectShorthandFunctionScopedDeclaration] = "ObjectShorthandFunctionScopedDeclaration";
    const ObjectShorthandBlockScopedDeclaration = ObjectShorthandFunctionScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthandBlockScopedDeclaration"] = ObjectShorthandBlockScopedDeclaration] = "ObjectShorthandBlockScopedDeclaration";
    const ObjectShorthand = ObjectShorthandBlockScopedDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectShorthand"] = ObjectShorthand] = "ObjectShorthand";
    // Any identifier bound in an import statement, e.g. both A and b from
    // `import A, * as b from 'A';`
    const ImportDeclaration = ObjectShorthand + 1;
    IdentifierRole[IdentifierRole["ImportDeclaration"] = ImportDeclaration] = "ImportDeclaration";
    const ObjectKey = ImportDeclaration + 1;
    IdentifierRole[IdentifierRole["ObjectKey"] = ObjectKey] = "ObjectKey";
    // The `foo` in `import {foo as bar} from "./abc";`.
    const ImportAccess = ObjectKey + 1;
    IdentifierRole[IdentifierRole["ImportAccess"] = ImportAccess] = "ImportAccess";
})($d45b756a11a5dc19$export$99f888ada3c99de3 || ($d45b756a11a5dc19$export$99f888ada3c99de3 = {}));
var $d45b756a11a5dc19$export$4620c92ad8b511d9;
(function(JSXRole) {
    // The element is self-closing or has a body that resolves to empty. We
    // shouldn't emit children at all in this case.
    const NoChildren = 0;
    JSXRole[JSXRole["NoChildren"] = NoChildren] = "NoChildren";
    // The element has a single explicit child, which might still be an arbitrary
    // expression like an array. We should emit that expression as the children.
    const OneChild = NoChildren + 1;
    JSXRole[JSXRole["OneChild"] = OneChild] = "OneChild";
    // The element has at least two explicitly-specified children or has spread
    // children, so child positions are assumed to be "static". We should wrap
    // these children in an array.
    const StaticChildren = OneChild + 1;
    JSXRole[JSXRole["StaticChildren"] = StaticChildren] = "StaticChildren";
    // The element has a prop named "key" after a prop spread, so we should fall
    // back to the createElement function.
    const KeyAfterPropSpread = StaticChildren + 1;
    JSXRole[JSXRole["KeyAfterPropSpread"] = KeyAfterPropSpread] = "KeyAfterPropSpread";
})($d45b756a11a5dc19$export$4620c92ad8b511d9 || ($d45b756a11a5dc19$export$4620c92ad8b511d9 = {}));
function $d45b756a11a5dc19$export$31dc9881735f7118(token) {
    const role = token.identifierRole;
    return role === $d45b756a11a5dc19$export$99f888ada3c99de3.TopLevelDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.BlockScopedDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $d45b756a11a5dc19$export$268f8ae8b035d918(token) {
    const role = token.identifierRole;
    return role === $d45b756a11a5dc19$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.BlockScopedDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $d45b756a11a5dc19$export$c08b4dec8c3c03d(token) {
    const role = token.identifierRole;
    return role === $d45b756a11a5dc19$export$99f888ada3c99de3.TopLevelDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ImportDeclaration;
}
function $d45b756a11a5dc19$export$6aae06a56367d123(token) {
    const role = token.identifierRole;
    // Treat top-level declarations as block scope since the distinction doesn't matter here.
    return role === $d45b756a11a5dc19$export$99f888ada3c99de3.TopLevelDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.BlockScopedDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration;
}
function $d45b756a11a5dc19$export$157aa1605fc4e080(token) {
    const role = token.identifierRole;
    return role === $d45b756a11a5dc19$export$99f888ada3c99de3.FunctionScopedDeclaration || role === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration;
}
function $d45b756a11a5dc19$export$dea1d79574e9c731(token) {
    return token.identifierRole === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandTopLevelDeclaration || token.identifierRole === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandBlockScopedDeclaration || token.identifierRole === $d45b756a11a5dc19$export$99f888ada3c99de3.ObjectShorthandFunctionScopedDeclaration;
}
class $d45b756a11a5dc19$export$50792b0e93539fde {
    constructor(){
        this.type = (0, $d9d7db628df75264$export$ca000e230c0caa3e).type;
        this.contextualKeyword = (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword;
        this.start = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
        this.end = (0, $d9d7db628df75264$export$ca000e230c0caa3e).end;
        this.scopeDepth = (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth;
        this.isType = (0, $d9d7db628df75264$export$ca000e230c0caa3e).isType;
        this.identifierRole = null;
        this.jsxRole = null;
        this.shadowsGlobal = false;
        this.isAsyncOperation = false;
        this.contextId = null;
        this.rhsEndIndex = null;
        this.isExpression = false;
        this.numNullishCoalesceStarts = 0;
        this.numNullishCoalesceEnds = 0;
        this.isOptionalChainStart = false;
        this.isOptionalChainEnd = false;
        this.subscriptStartIndex = null;
        this.nullishStartIndex = null;
    }
}
function $d45b756a11a5dc19$export$48cfd1e771a65c4f() {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.push(new $d45b756a11a5dc19$export$50792b0e93539fde());
    $d45b756a11a5dc19$export$be17f8ab6696df13();
}
function $d45b756a11a5dc19$export$e4355ff2fab571ee() {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.push(new $d45b756a11a5dc19$export$50792b0e93539fde());
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).start = (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    $d45b756a11a5dc19$var$readTmplToken();
}
function $d45b756a11a5dc19$export$f6864f1ed2347988() {
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f).assign) --(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    $d45b756a11a5dc19$var$readRegexp();
}
function $d45b756a11a5dc19$export$218282073d8f0a8b(existingTokensInType) {
    for(let i = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - existingTokensInType; i < (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length; i++)(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[i].isType = true;
    const oldIsType = (0, $d9d7db628df75264$export$ca000e230c0caa3e).isType;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).isType = true;
    return oldIsType;
}
function $d45b756a11a5dc19$export$89977347ddb984a8(oldIsType) {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).isType = oldIsType;
}
function $d45b756a11a5dc19$export$3106cdec37e36f77(type) {
    if ($d45b756a11a5dc19$export$4659b591c19bdf3d(type)) {
        $d45b756a11a5dc19$export$48cfd1e771a65c4f();
        return true;
    } else return false;
}
function $d45b756a11a5dc19$export$cb3e65614411a57c(tokenType) {
    const oldIsType = (0, $d9d7db628df75264$export$ca000e230c0caa3e).isType;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).isType = true;
    $d45b756a11a5dc19$export$3106cdec37e36f77(tokenType);
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).isType = oldIsType;
}
function $d45b756a11a5dc19$export$4659b591c19bdf3d(type) {
    return (0, $d9d7db628df75264$export$ca000e230c0caa3e).type === type;
}
function $d45b756a11a5dc19$export$d2a09c60d66edd78() {
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    $d45b756a11a5dc19$export$48cfd1e771a65c4f();
    const type = (0, $d9d7db628df75264$export$ca000e230c0caa3e).type;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return type;
}
class $d45b756a11a5dc19$export$1df511c75b9e0d8b {
    constructor(type, contextualKeyword){
        this.type = type;
        this.contextualKeyword = contextualKeyword;
    }
}
function $d45b756a11a5dc19$export$ef1b94c514fc060a() {
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    $d45b756a11a5dc19$export$48cfd1e771a65c4f();
    const type = (0, $d9d7db628df75264$export$ca000e230c0caa3e).type;
    const contextualKeyword = (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return new $d45b756a11a5dc19$export$1df511c75b9e0d8b(type, contextualKeyword);
}
function $d45b756a11a5dc19$export$1678d89ce52f4a6() {
    return $d45b756a11a5dc19$export$b8d8ba48247ea123((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
}
function $d45b756a11a5dc19$export$b8d8ba48247ea123(pos) {
    (0, $4fa6217c3efaba76$export$4856bde7911f0623).lastIndex = pos;
    const skip = (0, $4fa6217c3efaba76$export$4856bde7911f0623).exec((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e));
    return pos + skip[0].length;
}
function $d45b756a11a5dc19$export$847169391b2516b8() {
    return (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt($d45b756a11a5dc19$export$1678d89ce52f4a6());
}
function $d45b756a11a5dc19$export$be17f8ab6696df13() {
    $d45b756a11a5dc19$export$b240c79c2d18160();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).start = (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos >= (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) {
        const tokens = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens;
        // We normally run past the end a bit, but if we're way past the end, avoid an infinite loop.
        // Also check the token positions rather than the types since sometimes we rewrite the token
        // type to something else.
        if (tokens.length >= 2 && tokens[tokens.length - 1].start >= (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length && tokens[tokens.length - 2].start >= (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("Unexpectedly reached the end of input.");
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).eof);
        return;
    }
    $d45b756a11a5dc19$var$readToken((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos));
}
function $d45b756a11a5dc19$var$readToken(code) {
    // Identifier or keyword. '\uXXXX' sequences are allowed in
    // identifiers, so '\' also dispatches to that.
    if ((0, $d6dc0379bdf024ad$export$dc1d1d7d9fdffb8)[code] || code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).backslash || code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).atSign && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).atSign) (0, $282dceb445a5c57f$export$2e2bcd8739ae039)();
    else $d45b756a11a5dc19$export$e0ebb9fd4c2c4701(code);
}
function $d45b756a11a5dc19$var$skipBlockComment() {
    while((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos) !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).asterisk || (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1) !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).slash){
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos > (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) {
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("Unterminated comment", (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos - 2);
            return;
        }
    }
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += 2;
}
function $d45b756a11a5dc19$export$37e131e7c1112aff(startSkip) {
    let ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += startSkip);
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) while(ch !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed && ch !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).carriageReturn && ch !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineSeparator && ch !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).paragraphSeparator && ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length)ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
}
function $d45b756a11a5dc19$export$b240c79c2d18160() {
    while((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        switch(ch){
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).carriageReturn:
                if ((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed) ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed:
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineSeparator:
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).paragraphSeparator:
                ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
                break;
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).slash:
                switch((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1)){
                    case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).asterisk:
                        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += 2;
                        $d45b756a11a5dc19$var$skipBlockComment();
                        break;
                    case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).slash:
                        $d45b756a11a5dc19$export$37e131e7c1112aff(2);
                        break;
                    default:
                        return;
                }
                break;
            default:
                if ((0, $4fa6217c3efaba76$export$4347b22d2e0ca480)[ch]) ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
                else return;
        }
    }
}
function $d45b756a11a5dc19$export$58122cd1933ef607(type, contextualKeyword = (0, $0e760627819a3d75$export$ee633ab6cd0138cc).NONE) {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).end = (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).type = type;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword = contextualKeyword;
}
// ### Token reading
// This is the function that is called to fetch the next token. It
// is somewhat obscure, because it works in character codes rather
// than characters, and because operator parsing has been inlined
// into it.
//
// All in the name of speed.
function $d45b756a11a5dc19$var$readToken_dot() {
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    if (nextChar >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit0 && nextChar <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit9) {
        $d45b756a11a5dc19$var$readNumber(true);
        return;
    }
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dot && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 2) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dot) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += 3;
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis);
    } else {
        ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).dot);
    }
}
function $d45b756a11a5dc19$var$readToken_slash() {
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).assign, 2);
    else $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).slash, 1);
}
function $d45b756a11a5dc19$var$readToken_mult_modulo(code) {
    // '%*'
    let tokenType = code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).asterisk ? (0, $c455753917f2f29d$export$f435f793048e7a0f).star : (0, $c455753917f2f29d$export$f435f793048e7a0f).modulo;
    let width = 1;
    let nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    // Exponentiation operator **
    if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).asterisk && nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).asterisk) {
        width++;
        nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 2);
        tokenType = (0, $c455753917f2f29d$export$f435f793048e7a0f).exponent;
    }
    // Match *= or %=, disallowing *=> which can be valid in flow.
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 2) !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).greaterThan) {
        width++;
        tokenType = (0, $c455753917f2f29d$export$f435f793048e7a0f).assign;
    }
    $d45b756a11a5dc19$var$finishOp(tokenType, width);
}
function $d45b756a11a5dc19$var$readToken_pipe_amp(code) {
    // '|&'
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === code) {
        if ((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 2) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) // ||= or &&=
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).assign, 3);
        else // || or &&
        $d45b756a11a5dc19$var$finishOp(code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).verticalBar ? (0, $c455753917f2f29d$export$f435f793048e7a0f).logicalOR : (0, $c455753917f2f29d$export$f435f793048e7a0f).logicalAND, 2);
        return;
    }
    if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).verticalBar) {
        // '|>'
        if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).greaterThan) {
            $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).pipeline, 2);
            return;
        } else if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).rightCurlyBrace && (0, $d9d7db628df75264$export$92e334f8fe49aa94)) {
            // '|}'
            $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).braceBarR, 2);
            return;
        }
    }
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) {
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).assign, 2);
        return;
    }
    $d45b756a11a5dc19$var$finishOp(code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).verticalBar ? (0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseOR : (0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseAND, 1);
}
function $d45b756a11a5dc19$var$readToken_caret() {
    // '^'
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).assign, 2);
    else $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseXOR, 1);
}
function $d45b756a11a5dc19$var$readToken_plus_min(code) {
    // '+-'
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === code) {
        // Tentatively call this a prefix operator, but it might be changed to postfix later.
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).preIncDec, 2);
        return;
    }
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).assign, 2);
    else if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).plusSign) $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).plus, 1);
    else $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).minus, 1);
}
function $d45b756a11a5dc19$var$readToken_lt() {
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lessThan) {
        if ((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 2) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) {
            $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).assign, 3);
            return;
        }
        // We see <<, but need to be really careful about whether to treat it as a
        // true left-shift or as two < tokens.
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).isType) // Within a type, << might come up in a snippet like `Array<<T>() => void>`,
        // so treat it as two < tokens. Importantly, this should only override <<
        // rather than other tokens like <= . If we treated <= as < in a type
        // context, then the snippet `a as T <= 1` would incorrectly start parsing
        // a type argument on T. We don't need to worry about `a as T << 1`
        // because TypeScript disallows that syntax.
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan, 1);
        else // Outside a type, this might be a true left-shift operator, or it might
        // still be two open-type-arg tokens, such as in `f<<T>() => void>()`. We
        // look at the token while considering the `f`, so we don't yet know that
        // we're in a type context. In this case, we initially tokenize as a
        // left-shift and correct after-the-fact as necessary in
        // tsParseTypeArgumentsWithPossibleBitshift .
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).bitShiftL, 2);
        return;
    }
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) // <=
    $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).relationalOrEqual, 2);
    else $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan, 1);
}
function $d45b756a11a5dc19$var$readToken_gt() {
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).isType) {
        // Avoid right-shift for things like `Array<Array<string>>` and
        // greater-than-or-equal for things like `const a: Array<number>=[];`.
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan, 1);
        return;
    }
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).greaterThan) {
        const size = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 2) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).greaterThan ? 3 : 2;
        if ((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + size) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) {
            $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).assign, size + 1);
            return;
        }
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).bitShiftR, size);
        return;
    }
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) // >=
    $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).relationalOrEqual, 2);
    else $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan, 1);
}
function $d45b756a11a5dc19$export$4d00b4f4d9d7a9b3() {
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos -= 1;
        $d45b756a11a5dc19$var$readToken_gt();
    }
}
function $d45b756a11a5dc19$var$readToken_eq_excl(code) {
    // '=!'
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) {
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).equality, (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 2) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo ? 3 : 2);
        return;
    }
    if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo && nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).greaterThan) {
        // '=>'
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += 2;
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
        return;
    }
    $d45b756a11a5dc19$var$finishOp(code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo ? (0, $c455753917f2f29d$export$f435f793048e7a0f).eq : (0, $c455753917f2f29d$export$f435f793048e7a0f).bang, 1);
}
function $d45b756a11a5dc19$var$readToken_question() {
    // '?'
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
    const nextChar2 = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 2);
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).questionMark && // In Flow (but not TypeScript), ??string is a valid type that should be
    // tokenized as two individual ? tokens.
    !((0, $d9d7db628df75264$export$92e334f8fe49aa94) && (0, $d9d7db628df75264$export$ca000e230c0caa3e).isType)) {
        if (nextChar2 === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo) // '??='
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).assign, 3);
        else // '??'
        $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).nullishCoalescing, 2);
    } else if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dot && !(nextChar2 >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit0 && nextChar2 <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit9)) {
        // '.' not followed by a number
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += 2;
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot);
    } else {
        ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    }
}
function $d45b756a11a5dc19$export$e0ebb9fd4c2c4701(code) {
    switch(code){
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).numberSign:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).hash);
            return;
        // The interpretation of a dot depends on whether it is followed
        // by a digit or another two dots.
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dot:
            $d45b756a11a5dc19$var$readToken_dot();
            return;
        // Punctuation tokens.
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftParenthesis:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).rightParenthesis:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).semicolon:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).semi);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).comma:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftSquareBracket:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).rightSquareBracket:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftCurlyBrace:
            if ((0, $d9d7db628df75264$export$92e334f8fe49aa94) && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).verticalBar) $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).braceBarL, 2);
            else {
                ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
                $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
            }
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).rightCurlyBrace:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).colon:
            if ((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).colon) $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).doubleColon, 2);
            else {
                ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
                $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
            }
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).questionMark:
            $d45b756a11a5dc19$var$readToken_question();
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).atSign:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).at);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).graveAccent:
            ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).backQuote);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit0:
            {
                const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1);
                // '0x', '0X', '0o', '0O', '0b', '0B'
                if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseX || nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).uppercaseX || nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseO || nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).uppercaseO || nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseB || nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).uppercaseB) {
                    $d45b756a11a5dc19$var$readRadixNumber();
                    return;
                }
            }
        // Anything else beginning with a digit is an integer, octal
        // number, or float.
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit1:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit2:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit3:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit4:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit5:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit6:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit7:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit8:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit9:
            $d45b756a11a5dc19$var$readNumber(false);
            return;
        // Quotes produce strings.
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).quotationMark:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).apostrophe:
            $d45b756a11a5dc19$var$readString(code);
            return;
        // Operators are parsed inline in tiny state machines. '=' (charCodes.equalsTo) is
        // often referred to. `finishOp` simply skips the amount of
        // characters it is given as second argument, and returns a token
        // of the type given by its first argument.
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).slash:
            $d45b756a11a5dc19$var$readToken_slash();
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).percentSign:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).asterisk:
            $d45b756a11a5dc19$var$readToken_mult_modulo(code);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).verticalBar:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).ampersand:
            $d45b756a11a5dc19$var$readToken_pipe_amp(code);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).caret:
            $d45b756a11a5dc19$var$readToken_caret();
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).plusSign:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dash:
            $d45b756a11a5dc19$var$readToken_plus_min(code);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lessThan:
            $d45b756a11a5dc19$var$readToken_lt();
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).greaterThan:
            $d45b756a11a5dc19$var$readToken_gt();
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo:
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).exclamationMark:
            $d45b756a11a5dc19$var$readToken_eq_excl(code);
            return;
        case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).tilde:
            $d45b756a11a5dc19$var$finishOp((0, $c455753917f2f29d$export$f435f793048e7a0f).tilde, 1);
            return;
        default:
            break;
    }
    (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)(`Unexpected character '${String.fromCharCode(code)}'`, (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
}
function $d45b756a11a5dc19$var$finishOp(type, size) {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += size;
    $d45b756a11a5dc19$export$58122cd1933ef607(type);
}
function $d45b756a11a5dc19$var$readRegexp() {
    const start = (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    let escaped = false;
    let inClass = false;
    for(;;){
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos >= (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) {
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("Unterminated regular expression", start);
            return;
        }
        const code = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if (escaped) escaped = false;
        else {
            if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftSquareBracket) inClass = true;
            else if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).rightSquareBracket && inClass) inClass = false;
            else if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).slash && !inClass) break;
            escaped = code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).backslash;
        }
        ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    }
    ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    // Need to use `skipWord` because '\uXXXX' sequences are allowed here (don't ask).
    $d45b756a11a5dc19$export$abcfffe72e6e8184();
    $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).regexp);
}
/**
 * Read a decimal integer. Note that this can't be unified with the similar code
 * in readRadixNumber (which also handles hex digits) because "e" needs to be
 * the end of the integer so that we can properly handle scientific notation.
 */ function $d45b756a11a5dc19$var$readInt() {
    while(true){
        const code = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if (code >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit0 && code <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit9 || code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).underscore) (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
        else break;
    }
}
function $d45b756a11a5dc19$var$readRadixNumber() {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += 2; // 0x
    // Walk to the end of the number, allowing hex digits.
    while(true){
        const code = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if (code >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit0 && code <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit9 || code >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseA && code <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseF || code >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).uppercaseA && code <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).uppercaseF || code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).underscore) (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
        else break;
    }
    const nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseN) {
        ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).bigint);
    } else $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).num);
}
// Read an integer, octal integer, or floating-point number.
function $d45b756a11a5dc19$var$readNumber(startsWithDot) {
    let isBigInt = false;
    let isDecimal = false;
    if (!startsWithDot) $d45b756a11a5dc19$var$readInt();
    let nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dot) {
        ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
        $d45b756a11a5dc19$var$readInt();
        nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
    }
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).uppercaseE || nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseE) {
        nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).plusSign || nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dash) ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
        $d45b756a11a5dc19$var$readInt();
        nextChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
    }
    if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseN) {
        ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
        isBigInt = true;
    } else if (nextChar === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseM) {
        ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
        isDecimal = true;
    }
    if (isBigInt) {
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).bigint);
        return;
    }
    if (isDecimal) {
        $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).decimal);
        return;
    }
    $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).num);
}
function $d45b756a11a5dc19$var$readString(quote) {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
    for(;;){
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos >= (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) {
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("Unterminated string constant");
            return;
        }
        const ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).backslash) (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
        else if (ch === quote) break;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
    }
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
    $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).string);
}
// Reads template string tokens.
function $d45b756a11a5dc19$var$readTmplToken() {
    for(;;){
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos >= (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) {
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("Unterminated template");
            return;
        }
        const ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).graveAccent || ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dollarSign && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos + 1) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftCurlyBrace) {
            if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos === (0, $d9d7db628df75264$export$ca000e230c0caa3e).start && $d45b756a11a5dc19$export$4659b591c19bdf3d((0, $c455753917f2f29d$export$f435f793048e7a0f).template)) {
                if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dollarSign) {
                    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += 2;
                    $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).dollarBraceL);
                    return;
                } else {
                    ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
                    $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).backQuote);
                    return;
                }
            }
            $d45b756a11a5dc19$export$58122cd1933ef607((0, $c455753917f2f29d$export$f435f793048e7a0f).template);
            return;
        }
        if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).backslash) (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
    }
}
function $d45b756a11a5dc19$export$abcfffe72e6e8184() {
    while((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length){
        const ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if ((0, $d6dc0379bdf024ad$export$d19df39e3926cfef)[ch]) (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
        else if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).backslash) {
            // \u
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos += 2;
            if ((0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftCurlyBrace) {
                while((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos) !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).rightCurlyBrace)(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
            }
        } else break;
    }
}





function $c66a0329e71568eb$export$2e2bcd8739ae039(tokens, index = tokens.currentIndex()) {
    let endIndex = index + 1;
    if ($c66a0329e71568eb$var$isSpecifierEnd(tokens, endIndex)) {
        // import {A}
        const name = tokens.identifierNameAtIndex(index);
        return {
            isType: false,
            leftName: name,
            rightName: name,
            endIndex: endIndex
        };
    }
    endIndex++;
    if ($c66a0329e71568eb$var$isSpecifierEnd(tokens, endIndex)) // import {type A}
    return {
        isType: true,
        leftName: null,
        rightName: null,
        endIndex: endIndex
    };
    endIndex++;
    if ($c66a0329e71568eb$var$isSpecifierEnd(tokens, endIndex)) // import {A as B}
    return {
        isType: false,
        leftName: tokens.identifierNameAtIndex(index),
        rightName: tokens.identifierNameAtIndex(index + 2),
        endIndex: endIndex
    };
    endIndex++;
    if ($c66a0329e71568eb$var$isSpecifierEnd(tokens, endIndex)) // import {type A as B}
    return {
        isType: true,
        leftName: null,
        rightName: null,
        endIndex: endIndex
    };
    throw new Error(`Unexpected import/export specifier at ${index}`);
}
function $c66a0329e71568eb$var$isSpecifierEnd(tokens, index) {
    const token = tokens.tokens[index];
    return token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR || token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).comma;
}




// Use a Map rather than object to avoid unexpected __proto__ access.
var $7d505f38ffd3b305$export$2e2bcd8739ae039 = new Map([
    [
        "quot",
        "\u0022"
    ],
    [
        "amp",
        "&"
    ],
    [
        "apos",
        "\u0027"
    ],
    [
        "lt",
        "<"
    ],
    [
        "gt",
        ">"
    ],
    [
        "nbsp",
        "\u00A0"
    ],
    [
        "iexcl",
        "\u00A1"
    ],
    [
        "cent",
        "\u00A2"
    ],
    [
        "pound",
        "\u00A3"
    ],
    [
        "curren",
        "\u00A4"
    ],
    [
        "yen",
        "\u00A5"
    ],
    [
        "brvbar",
        "\u00A6"
    ],
    [
        "sect",
        "\u00A7"
    ],
    [
        "uml",
        "\u00A8"
    ],
    [
        "copy",
        "\u00A9"
    ],
    [
        "ordf",
        "\u00AA"
    ],
    [
        "laquo",
        "\u00AB"
    ],
    [
        "not",
        "\u00AC"
    ],
    [
        "shy",
        "\u00AD"
    ],
    [
        "reg",
        "\u00AE"
    ],
    [
        "macr",
        "\u00AF"
    ],
    [
        "deg",
        "\u00B0"
    ],
    [
        "plusmn",
        "\u00B1"
    ],
    [
        "sup2",
        "\u00B2"
    ],
    [
        "sup3",
        "\u00B3"
    ],
    [
        "acute",
        "\u00B4"
    ],
    [
        "micro",
        "\u00B5"
    ],
    [
        "para",
        "\u00B6"
    ],
    [
        "middot",
        "\u00B7"
    ],
    [
        "cedil",
        "\u00B8"
    ],
    [
        "sup1",
        "\u00B9"
    ],
    [
        "ordm",
        "\u00BA"
    ],
    [
        "raquo",
        "\u00BB"
    ],
    [
        "frac14",
        "\u00BC"
    ],
    [
        "frac12",
        "\u00BD"
    ],
    [
        "frac34",
        "\u00BE"
    ],
    [
        "iquest",
        "\u00BF"
    ],
    [
        "Agrave",
        "\u00C0"
    ],
    [
        "Aacute",
        "\u00C1"
    ],
    [
        "Acirc",
        "\u00C2"
    ],
    [
        "Atilde",
        "\u00C3"
    ],
    [
        "Auml",
        "\u00C4"
    ],
    [
        "Aring",
        "\u00C5"
    ],
    [
        "AElig",
        "\u00C6"
    ],
    [
        "Ccedil",
        "\u00C7"
    ],
    [
        "Egrave",
        "\u00C8"
    ],
    [
        "Eacute",
        "\u00C9"
    ],
    [
        "Ecirc",
        "\u00CA"
    ],
    [
        "Euml",
        "\u00CB"
    ],
    [
        "Igrave",
        "\u00CC"
    ],
    [
        "Iacute",
        "\u00CD"
    ],
    [
        "Icirc",
        "\u00CE"
    ],
    [
        "Iuml",
        "\u00CF"
    ],
    [
        "ETH",
        "\u00D0"
    ],
    [
        "Ntilde",
        "\u00D1"
    ],
    [
        "Ograve",
        "\u00D2"
    ],
    [
        "Oacute",
        "\u00D3"
    ],
    [
        "Ocirc",
        "\u00D4"
    ],
    [
        "Otilde",
        "\u00D5"
    ],
    [
        "Ouml",
        "\u00D6"
    ],
    [
        "times",
        "\u00D7"
    ],
    [
        "Oslash",
        "\u00D8"
    ],
    [
        "Ugrave",
        "\u00D9"
    ],
    [
        "Uacute",
        "\u00DA"
    ],
    [
        "Ucirc",
        "\u00DB"
    ],
    [
        "Uuml",
        "\u00DC"
    ],
    [
        "Yacute",
        "\u00DD"
    ],
    [
        "THORN",
        "\u00DE"
    ],
    [
        "szlig",
        "\u00DF"
    ],
    [
        "agrave",
        "\u00E0"
    ],
    [
        "aacute",
        "\u00E1"
    ],
    [
        "acirc",
        "\u00E2"
    ],
    [
        "atilde",
        "\u00E3"
    ],
    [
        "auml",
        "\u00E4"
    ],
    [
        "aring",
        "\u00E5"
    ],
    [
        "aelig",
        "\u00E6"
    ],
    [
        "ccedil",
        "\u00E7"
    ],
    [
        "egrave",
        "\u00E8"
    ],
    [
        "eacute",
        "\u00E9"
    ],
    [
        "ecirc",
        "\u00EA"
    ],
    [
        "euml",
        "\u00EB"
    ],
    [
        "igrave",
        "\u00EC"
    ],
    [
        "iacute",
        "\u00ED"
    ],
    [
        "icirc",
        "\u00EE"
    ],
    [
        "iuml",
        "\u00EF"
    ],
    [
        "eth",
        "\u00F0"
    ],
    [
        "ntilde",
        "\u00F1"
    ],
    [
        "ograve",
        "\u00F2"
    ],
    [
        "oacute",
        "\u00F3"
    ],
    [
        "ocirc",
        "\u00F4"
    ],
    [
        "otilde",
        "\u00F5"
    ],
    [
        "ouml",
        "\u00F6"
    ],
    [
        "divide",
        "\u00F7"
    ],
    [
        "oslash",
        "\u00F8"
    ],
    [
        "ugrave",
        "\u00F9"
    ],
    [
        "uacute",
        "\u00FA"
    ],
    [
        "ucirc",
        "\u00FB"
    ],
    [
        "uuml",
        "\u00FC"
    ],
    [
        "yacute",
        "\u00FD"
    ],
    [
        "thorn",
        "\u00FE"
    ],
    [
        "yuml",
        "\u00FF"
    ],
    [
        "OElig",
        "\u0152"
    ],
    [
        "oelig",
        "\u0153"
    ],
    [
        "Scaron",
        "\u0160"
    ],
    [
        "scaron",
        "\u0161"
    ],
    [
        "Yuml",
        "\u0178"
    ],
    [
        "fnof",
        "\u0192"
    ],
    [
        "circ",
        "\u02C6"
    ],
    [
        "tilde",
        "\u02DC"
    ],
    [
        "Alpha",
        "\u0391"
    ],
    [
        "Beta",
        "\u0392"
    ],
    [
        "Gamma",
        "\u0393"
    ],
    [
        "Delta",
        "\u0394"
    ],
    [
        "Epsilon",
        "\u0395"
    ],
    [
        "Zeta",
        "\u0396"
    ],
    [
        "Eta",
        "\u0397"
    ],
    [
        "Theta",
        "\u0398"
    ],
    [
        "Iota",
        "\u0399"
    ],
    [
        "Kappa",
        "\u039A"
    ],
    [
        "Lambda",
        "\u039B"
    ],
    [
        "Mu",
        "\u039C"
    ],
    [
        "Nu",
        "\u039D"
    ],
    [
        "Xi",
        "\u039E"
    ],
    [
        "Omicron",
        "\u039F"
    ],
    [
        "Pi",
        "\u03A0"
    ],
    [
        "Rho",
        "\u03A1"
    ],
    [
        "Sigma",
        "\u03A3"
    ],
    [
        "Tau",
        "\u03A4"
    ],
    [
        "Upsilon",
        "\u03A5"
    ],
    [
        "Phi",
        "\u03A6"
    ],
    [
        "Chi",
        "\u03A7"
    ],
    [
        "Psi",
        "\u03A8"
    ],
    [
        "Omega",
        "\u03A9"
    ],
    [
        "alpha",
        "\u03B1"
    ],
    [
        "beta",
        "\u03B2"
    ],
    [
        "gamma",
        "\u03B3"
    ],
    [
        "delta",
        "\u03B4"
    ],
    [
        "epsilon",
        "\u03B5"
    ],
    [
        "zeta",
        "\u03B6"
    ],
    [
        "eta",
        "\u03B7"
    ],
    [
        "theta",
        "\u03B8"
    ],
    [
        "iota",
        "\u03B9"
    ],
    [
        "kappa",
        "\u03BA"
    ],
    [
        "lambda",
        "\u03BB"
    ],
    [
        "mu",
        "\u03BC"
    ],
    [
        "nu",
        "\u03BD"
    ],
    [
        "xi",
        "\u03BE"
    ],
    [
        "omicron",
        "\u03BF"
    ],
    [
        "pi",
        "\u03C0"
    ],
    [
        "rho",
        "\u03C1"
    ],
    [
        "sigmaf",
        "\u03C2"
    ],
    [
        "sigma",
        "\u03C3"
    ],
    [
        "tau",
        "\u03C4"
    ],
    [
        "upsilon",
        "\u03C5"
    ],
    [
        "phi",
        "\u03C6"
    ],
    [
        "chi",
        "\u03C7"
    ],
    [
        "psi",
        "\u03C8"
    ],
    [
        "omega",
        "\u03C9"
    ],
    [
        "thetasym",
        "\u03D1"
    ],
    [
        "upsih",
        "\u03D2"
    ],
    [
        "piv",
        "\u03D6"
    ],
    [
        "ensp",
        "\u2002"
    ],
    [
        "emsp",
        "\u2003"
    ],
    [
        "thinsp",
        "\u2009"
    ],
    [
        "zwnj",
        "\u200C"
    ],
    [
        "zwj",
        "\u200D"
    ],
    [
        "lrm",
        "\u200E"
    ],
    [
        "rlm",
        "\u200F"
    ],
    [
        "ndash",
        "\u2013"
    ],
    [
        "mdash",
        "\u2014"
    ],
    [
        "lsquo",
        "\u2018"
    ],
    [
        "rsquo",
        "\u2019"
    ],
    [
        "sbquo",
        "\u201A"
    ],
    [
        "ldquo",
        "\u201C"
    ],
    [
        "rdquo",
        "\u201D"
    ],
    [
        "bdquo",
        "\u201E"
    ],
    [
        "dagger",
        "\u2020"
    ],
    [
        "Dagger",
        "\u2021"
    ],
    [
        "bull",
        "\u2022"
    ],
    [
        "hellip",
        "\u2026"
    ],
    [
        "permil",
        "\u2030"
    ],
    [
        "prime",
        "\u2032"
    ],
    [
        "Prime",
        "\u2033"
    ],
    [
        "lsaquo",
        "\u2039"
    ],
    [
        "rsaquo",
        "\u203A"
    ],
    [
        "oline",
        "\u203E"
    ],
    [
        "frasl",
        "\u2044"
    ],
    [
        "euro",
        "\u20AC"
    ],
    [
        "image",
        "\u2111"
    ],
    [
        "weierp",
        "\u2118"
    ],
    [
        "real",
        "\u211C"
    ],
    [
        "trade",
        "\u2122"
    ],
    [
        "alefsym",
        "\u2135"
    ],
    [
        "larr",
        "\u2190"
    ],
    [
        "uarr",
        "\u2191"
    ],
    [
        "rarr",
        "\u2192"
    ],
    [
        "darr",
        "\u2193"
    ],
    [
        "harr",
        "\u2194"
    ],
    [
        "crarr",
        "\u21B5"
    ],
    [
        "lArr",
        "\u21D0"
    ],
    [
        "uArr",
        "\u21D1"
    ],
    [
        "rArr",
        "\u21D2"
    ],
    [
        "dArr",
        "\u21D3"
    ],
    [
        "hArr",
        "\u21D4"
    ],
    [
        "forall",
        "\u2200"
    ],
    [
        "part",
        "\u2202"
    ],
    [
        "exist",
        "\u2203"
    ],
    [
        "empty",
        "\u2205"
    ],
    [
        "nabla",
        "\u2207"
    ],
    [
        "isin",
        "\u2208"
    ],
    [
        "notin",
        "\u2209"
    ],
    [
        "ni",
        "\u220B"
    ],
    [
        "prod",
        "\u220F"
    ],
    [
        "sum",
        "\u2211"
    ],
    [
        "minus",
        "\u2212"
    ],
    [
        "lowast",
        "\u2217"
    ],
    [
        "radic",
        "\u221A"
    ],
    [
        "prop",
        "\u221D"
    ],
    [
        "infin",
        "\u221E"
    ],
    [
        "ang",
        "\u2220"
    ],
    [
        "and",
        "\u2227"
    ],
    [
        "or",
        "\u2228"
    ],
    [
        "cap",
        "\u2229"
    ],
    [
        "cup",
        "\u222A"
    ],
    [
        "int",
        "\u222B"
    ],
    [
        "there4",
        "\u2234"
    ],
    [
        "sim",
        "\u223C"
    ],
    [
        "cong",
        "\u2245"
    ],
    [
        "asymp",
        "\u2248"
    ],
    [
        "ne",
        "\u2260"
    ],
    [
        "equiv",
        "\u2261"
    ],
    [
        "le",
        "\u2264"
    ],
    [
        "ge",
        "\u2265"
    ],
    [
        "sub",
        "\u2282"
    ],
    [
        "sup",
        "\u2283"
    ],
    [
        "nsub",
        "\u2284"
    ],
    [
        "sube",
        "\u2286"
    ],
    [
        "supe",
        "\u2287"
    ],
    [
        "oplus",
        "\u2295"
    ],
    [
        "otimes",
        "\u2297"
    ],
    [
        "perp",
        "\u22A5"
    ],
    [
        "sdot",
        "\u22C5"
    ],
    [
        "lceil",
        "\u2308"
    ],
    [
        "rceil",
        "\u2309"
    ],
    [
        "lfloor",
        "\u230A"
    ],
    [
        "rfloor",
        "\u230B"
    ],
    [
        "lang",
        "\u2329"
    ],
    [
        "rang",
        "\u232A"
    ],
    [
        "loz",
        "\u25CA"
    ],
    [
        "spades",
        "\u2660"
    ],
    [
        "clubs",
        "\u2663"
    ],
    [
        "hearts",
        "\u2665"
    ],
    [
        "diams",
        "\u2666"
    ]
]);





function $428ad8752015b314$export$2e2bcd8739ae039(options) {
    const [base, suffix] = $428ad8752015b314$var$splitPragma(options.jsxPragma || "React.createElement");
    const [fragmentBase, fragmentSuffix] = $428ad8752015b314$var$splitPragma(options.jsxFragmentPragma || "React.Fragment");
    return {
        base: base,
        suffix: suffix,
        fragmentBase: fragmentBase,
        fragmentSuffix: fragmentSuffix
    };
}
function $428ad8752015b314$var$splitPragma(pragma) {
    let dotIndex = pragma.indexOf(".");
    if (dotIndex === -1) dotIndex = pragma.length;
    return [
        pragma.slice(0, dotIndex),
        pragma.slice(dotIndex)
    ];
}


class $6fa448eb02f0faca$export$2e2bcd8739ae039 {
    // Return true if anything was processed, false otherwise.
    getPrefixCode() {
        return "";
    }
    getHoistedCode() {
        return "";
    }
    getSuffixCode() {
        return "";
    }
}


class $f3732a5a55888920$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    // State for calculating the line number of each JSX tag in development.
    __init() {
        this.lastLineNumber = 1;
    }
    __init2() {
        this.lastIndex = 0;
    }
    // In development, variable name holding the name of the current file.
    __init3() {
        this.filenameVarName = null;
    }
    // Mapping of claimed names for imports in the automatic transform, e,g.
    // {jsx: "_jsx"}. This determines which imports to generate in the prefix.
    __init4() {
        this.esmAutomaticImportNameResolutions = {};
    }
    // When automatically adding imports in CJS mode, we store the variable name
    // holding the imported CJS module so we can require it in the prefix.
    __init5() {
        this.cjsAutomaticModuleNameResolutions = {};
    }
    constructor(rootTransformer, tokens, importProcessor, nameManager, options){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.nameManager = nameManager;
        this.options = options;
        $f3732a5a55888920$export$2e2bcd8739ae039.prototype.__init.call(this);
        $f3732a5a55888920$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $f3732a5a55888920$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $f3732a5a55888920$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $f3732a5a55888920$export$2e2bcd8739ae039.prototype.__init5.call(this);
        this.jsxPragmaInfo = (0, $428ad8752015b314$export$2e2bcd8739ae039)(options);
        this.isAutomaticRuntime = options.jsxRuntime === "automatic";
        this.jsxImportSource = options.jsxImportSource || "react";
    }
    process() {
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart)) {
            this.processJSXTag();
            return true;
        }
        return false;
    }
    getPrefixCode() {
        let prefix = "";
        if (this.filenameVarName) prefix += `const ${this.filenameVarName} = ${JSON.stringify(this.options.filePath || "")};`;
        if (this.isAutomaticRuntime) {
            if (this.importProcessor) // CJS mode: emit require statements for all modules that were referenced.
            for (const [path, resolvedName] of Object.entries(this.cjsAutomaticModuleNameResolutions))prefix += `var ${resolvedName} = require("${path}");`;
            else {
                // ESM mode: consolidate and emit import statements for referenced names.
                const { createElement: createElementResolution, ...otherResolutions } = this.esmAutomaticImportNameResolutions;
                if (createElementResolution) prefix += `import {createElement as ${createElementResolution}} from "${this.jsxImportSource}";`;
                const importSpecifiers = Object.entries(otherResolutions).map(([name, resolvedName])=>`${name} as ${resolvedName}`).join(", ");
                if (importSpecifiers) {
                    const importPath = this.jsxImportSource + (this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
                    prefix += `import {${importSpecifiers}} from "${importPath}";`;
                }
            }
        }
        return prefix;
    }
    processJSXTag() {
        const { jsxRole: jsxRole, start: start } = this.tokens.currentToken();
        // Calculate line number information at the very start (if in development
        // mode) so that the information is guaranteed to be queried in token order.
        const elementLocationCode = this.options.production ? null : this.getElementLocationCode(start);
        if (this.isAutomaticRuntime && jsxRole !== (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).KeyAfterPropSpread) this.transformTagToJSXFunc(elementLocationCode, jsxRole);
        else this.transformTagToCreateElement(elementLocationCode);
    }
    getElementLocationCode(firstTokenStart) {
        const lineNumber = this.getLineNumberForIndex(firstTokenStart);
        return `lineNumber: ${lineNumber}`;
    }
    /**
   * Get the line number for this source position. This is calculated lazily and
   * must be called in increasing order by index.
   */ getLineNumberForIndex(index) {
        const code = this.tokens.code;
        while(this.lastIndex < index && this.lastIndex < code.length){
            if (code[this.lastIndex] === "\n") this.lastLineNumber++;
            this.lastIndex++;
        }
        return this.lastLineNumber;
    }
    /**
   * Convert the current JSX element to a call to jsx, jsxs, or jsxDEV. This is
   * the primary transformation for the automatic transform.
   *
   * Example:
   * <div a={1} key={2}>Hello{x}</div>
   * becomes
   * jsxs('div', {a: 1, children: ["Hello", x]}, 2)
   */ transformTagToJSXFunc(elementLocationCode, jsxRole) {
        const isStatic = jsxRole === (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).StaticChildren;
        // First tag is always jsxTagStart.
        this.tokens.replaceToken(this.getJSXFuncInvocationCode(isStatic));
        let keyCode = null;
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd)) {
            // Fragment syntax.
            this.tokens.replaceToken(`${this.getFragmentCode()}, {`);
            this.processAutomaticChildrenAndEndProps(jsxRole);
        } else {
            // Normal open tag or self-closing tag.
            this.processTagIntro();
            this.tokens.appendCode(", {");
            keyCode = this.processProps(true);
            if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).slash, (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd)) // Self-closing tag, no children to add, so close the props.
            this.tokens.appendCode("}");
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd)) {
                // Tag with children.
                this.tokens.removeToken();
                this.processAutomaticChildrenAndEndProps(jsxRole);
            } else throw new Error("Expected either /> or > at the end of the tag.");
            // If a key was present, move it to its own arg. Note that moving code
            // like this will cause line numbers to get out of sync within the JSX
            // element if the key expression has a newline in it. This is unfortunate,
            // but hopefully should be rare.
            if (keyCode) this.tokens.appendCode(`, ${keyCode}`);
        }
        if (!this.options.production) {
            // If the key wasn't already added, add it now so we can correctly set
            // positional args for jsxDEV.
            if (keyCode === null) this.tokens.appendCode(", void 0");
            this.tokens.appendCode(`, ${isStatic}, ${this.getDevSource(elementLocationCode)}, this`);
        }
        // We're at the close-tag or the end of a self-closing tag, so remove
        // everything else and close the function call.
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd))this.tokens.removeToken();
        this.tokens.replaceToken(")");
    }
    /**
   * Convert the current JSX element to a createElement call. In the classic
   * runtime, this is the only case. In the automatic runtime, this is called
   * as a fallback in some situations.
   *
   * Example:
   * <div a={1} key={2}>Hello{x}</div>
   * becomes
   * React.createElement('div', {a: 1, key: 2}, "Hello", x)
   */ transformTagToCreateElement(elementLocationCode) {
        // First tag is always jsxTagStart.
        this.tokens.replaceToken(this.getCreateElementInvocationCode());
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd)) {
            // Fragment syntax.
            this.tokens.replaceToken(`${this.getFragmentCode()}, null`);
            this.processChildren(true);
        } else {
            // Normal open tag or self-closing tag.
            this.processTagIntro();
            this.processPropsObjectWithDevInfo(elementLocationCode);
            if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).slash, (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd)) ;
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd)) {
                // Tag with children and a close-tag; process the children as args.
                this.tokens.removeToken();
                this.processChildren(true);
            } else throw new Error("Expected either /> or > at the end of the tag.");
        }
        // We're at the close-tag or the end of a self-closing tag, so remove
        // everything else and close the function call.
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd))this.tokens.removeToken();
        this.tokens.replaceToken(")");
    }
    /**
   * Get the code for the relevant function for this context: jsx, jsxs,
   * or jsxDEV. The following open-paren is included as well.
   *
   * These functions are only used for the automatic runtime, so they are always
   * auto-imported, but the auto-import will be either CJS or ESM based on the
   * target module format.
   */ getJSXFuncInvocationCode(isStatic) {
        if (this.options.production) {
            if (isStatic) return this.claimAutoImportedFuncInvocation("jsxs", "/jsx-runtime");
            else return this.claimAutoImportedFuncInvocation("jsx", "/jsx-runtime");
        } else return this.claimAutoImportedFuncInvocation("jsxDEV", "/jsx-dev-runtime");
    }
    /**
   * Return the code to use for the createElement function, e.g.
   * `React.createElement`, including the following open-paren.
   *
   * This is the main function to use for the classic runtime. For the
   * automatic runtime, this function is used as a fallback function to
   * preserve behavior when there is a prop spread followed by an explicit
   * key. In that automatic runtime case, the function should be automatically
   * imported.
   */ getCreateElementInvocationCode() {
        if (this.isAutomaticRuntime) return this.claimAutoImportedFuncInvocation("createElement", "");
        else {
            const { jsxPragmaInfo: jsxPragmaInfo } = this;
            const resolvedPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.base) || jsxPragmaInfo.base : jsxPragmaInfo.base;
            return `${resolvedPragmaBaseName}${jsxPragmaInfo.suffix}(`;
        }
    }
    /**
   * Return the code to use as the component when compiling a shorthand
   * fragment, e.g. `React.Fragment`.
   *
   * This may be called from either the classic or automatic runtime, and
   * the value should be auto-imported for the automatic runtime.
   */ getFragmentCode() {
        if (this.isAutomaticRuntime) return this.claimAutoImportedName("Fragment", this.options.production ? "/jsx-runtime" : "/jsx-dev-runtime");
        else {
            const { jsxPragmaInfo: jsxPragmaInfo } = this;
            const resolvedFragmentPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.fragmentBase) || jsxPragmaInfo.fragmentBase : jsxPragmaInfo.fragmentBase;
            return resolvedFragmentPragmaBaseName + jsxPragmaInfo.fragmentSuffix;
        }
    }
    /**
   * Return code that invokes the given function.
   *
   * When the imports transform is enabled, use the CJSImportTransformer
   * strategy of using `.call(void 0, ...` to avoid passing a `this` value in a
   * situation that would otherwise look like a method call.
   */ claimAutoImportedFuncInvocation(funcName, importPathSuffix) {
        const funcCode = this.claimAutoImportedName(funcName, importPathSuffix);
        if (this.importProcessor) return `${funcCode}.call(void 0, `;
        else return `${funcCode}(`;
    }
    claimAutoImportedName(funcName, importPathSuffix) {
        if (this.importProcessor) {
            // CJS mode: claim a name for the module and mark it for import.
            const path = this.jsxImportSource + importPathSuffix;
            if (!this.cjsAutomaticModuleNameResolutions[path]) this.cjsAutomaticModuleNameResolutions[path] = this.importProcessor.getFreeIdentifierForPath(path);
            return `${this.cjsAutomaticModuleNameResolutions[path]}.${funcName}`;
        } else {
            // ESM mode: claim a name for this function and add it to the names that
            // should be auto-imported when the prefix is generated.
            if (!this.esmAutomaticImportNameResolutions[funcName]) this.esmAutomaticImportNameResolutions[funcName] = this.nameManager.claimFreeName(`_${funcName}`);
            return this.esmAutomaticImportNameResolutions[funcName];
        }
    }
    /**
   * Process the first part of a tag, before any props.
   */ processTagIntro() {
        // Walk forward until we see one of these patterns:
        // jsxName to start the first prop, preceded by another jsxName to end the tag name.
        // jsxName to start the first prop, preceded by greaterThan to end the type argument.
        // [open brace] to start the first prop.
        // [jsxTagEnd] to end the open-tag.
        // [slash, jsxTagEnd] to end the self-closing tag.
        let introEnd = this.tokens.currentIndex() + 1;
        while(this.tokens.tokens[introEnd].isType || !this.tokens.matches2AtIndex(introEnd - 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName, (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName) && !this.tokens.matches2AtIndex(introEnd - 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan, (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName) && !this.tokens.matches1AtIndex(introEnd, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) && !this.tokens.matches1AtIndex(introEnd, (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd) && !this.tokens.matches2AtIndex(introEnd, (0, $c455753917f2f29d$export$f435f793048e7a0f).slash, (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd))introEnd++;
        if (introEnd === this.tokens.currentIndex() + 1) {
            const tagName = this.tokens.identifierName();
            if ($f3732a5a55888920$export$b682d115586a1832(tagName)) this.tokens.replaceToken(`'${tagName}'`);
        }
        while(this.tokens.currentIndex() < introEnd)this.rootTransformer.processToken();
    }
    /**
   * Starting at the beginning of the props, add the props argument to
   * React.createElement, including the comma before it.
   */ processPropsObjectWithDevInfo(elementLocationCode) {
        const devProps = this.options.production ? "" : `__self: this, __source: ${this.getDevSource(elementLocationCode)}`;
        if (!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName) && !this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            if (devProps) this.tokens.appendCode(`, {${devProps}}`);
            else this.tokens.appendCode(`, null`);
            return;
        }
        this.tokens.appendCode(`, {`);
        this.processProps(false);
        if (devProps) this.tokens.appendCode(` ${devProps}}`);
        else this.tokens.appendCode("}");
    }
    /**
   * Transform the core part of the props, assuming that a { has already been
   * inserted before us and that a } will be inserted after us.
   *
   * If extractKeyCode is true (i.e. when using any jsx... function), any prop
   * named "key" has its code captured and returned rather than being emitted to
   * the output code. This shifts line numbers, and emitting the code later will
   * correct line numbers again. If no key is found or if extractKeyCode is
   * false, this function returns null.
   */ processProps(extractKeyCode) {
        let keyCode = null;
        while(true){
            if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
                // This is a regular key={value} or key="value" prop.
                const propName = this.tokens.identifierName();
                if (extractKeyCode && propName === "key") {
                    if (keyCode !== null) // The props list has multiple keys. Different implementations are
                    // inconsistent about what to do here: as of this writing, Babel and
                    // swc keep the *last* key and completely remove the rest, while
                    // TypeScript uses the *first* key and leaves the others as regular
                    // props. The React team collaborated with Babel on the
                    // implementation of this behavior, so presumably the Babel behavior
                    // is the one to use.
                    // Since we won't ever be emitting the previous key code, we need to
                    // at least emit its newlines here so that the line numbers match up
                    // in the long run.
                    this.tokens.appendCode(keyCode.replace(/[^\n]/g, ""));
                    // key
                    this.tokens.removeToken();
                    // =
                    this.tokens.removeToken();
                    const snapshot = this.tokens.snapshot();
                    this.processPropValue();
                    keyCode = this.tokens.dangerouslyGetAndRemoveCodeSinceSnapshot(snapshot);
                    continue;
                } else {
                    this.processPropName(propName);
                    this.tokens.replaceToken(": ");
                    this.processPropValue();
                }
            } else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName)) {
                // This is a shorthand prop like <input disabled />.
                const propName = this.tokens.identifierName();
                this.processPropName(propName);
                this.tokens.appendCode(": true");
            } else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
                // This is prop spread, like <div {...getProps()}>, which we can pass
                // through fairly directly as an object spread.
                this.tokens.replaceToken("");
                this.rootTransformer.processBalancedCode();
                this.tokens.replaceToken("");
            } else break;
            this.tokens.appendCode(",");
        }
        return keyCode;
    }
    processPropName(propName) {
        if (propName.includes("-")) this.tokens.replaceToken(`'${propName}'`);
        else this.tokens.copyToken();
    }
    processPropValue() {
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            this.tokens.replaceToken("");
            this.rootTransformer.processBalancedCode();
            this.tokens.replaceToken("");
        } else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart)) this.processJSXTag();
        else this.processStringPropValue();
    }
    processStringPropValue() {
        const token = this.tokens.currentToken();
        const valueCode = this.tokens.code.slice(token.start + 1, token.end - 1);
        const replacementCode = $f3732a5a55888920$var$formatJSXTextReplacement(valueCode);
        const literalCode = $f3732a5a55888920$var$formatJSXStringValueLiteral(valueCode);
        this.tokens.replaceToken(literalCode + replacementCode);
    }
    /**
   * Starting in the middle of the props object literal, produce an additional
   * prop for the children and close the object literal.
   */ processAutomaticChildrenAndEndProps(jsxRole) {
        if (jsxRole === (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).StaticChildren) {
            this.tokens.appendCode(" children: [");
            this.processChildren(false);
            this.tokens.appendCode("]}");
        } else {
            // The parser information tells us whether we will see a real child or if
            // all remaining children (if any) will resolve to empty. If there are no
            // non-empty children, don't emit a children prop at all, but still
            // process children so that we properly transform the code into nothing.
            if (jsxRole === (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).OneChild) this.tokens.appendCode(" children: ");
            this.processChildren(false);
            this.tokens.appendCode("}");
        }
    }
    /**
   * Transform children into a comma-separated list, which will be either
   * arguments to createElement or array elements of a children prop.
   */ processChildren(needsInitialComma) {
        let needsComma = needsInitialComma;
        while(true){
            if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart, (0, $c455753917f2f29d$export$f435f793048e7a0f).slash)) // Closing tag, so no more children.
            return;
            let didEmitElement = false;
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
                if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                    // Empty interpolations and comment-only interpolations are allowed
                    // and don't create an extra child arg.
                    this.tokens.replaceToken("");
                    this.tokens.replaceToken("");
                } else {
                    // Interpolated expression.
                    this.tokens.replaceToken(needsComma ? ", " : "");
                    this.rootTransformer.processBalancedCode();
                    this.tokens.replaceToken("");
                    didEmitElement = true;
                }
            } else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart)) {
                // Child JSX element
                this.tokens.appendCode(needsComma ? ", " : "");
                this.processJSXTag();
                didEmitElement = true;
            } else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxText) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxEmptyText)) didEmitElement = this.processChildTextElement(needsComma);
            else throw new Error("Unexpected token when processing JSX children.");
            if (didEmitElement) needsComma = true;
        }
    }
    /**
   * Turn a JSX text element into a string literal, or nothing at all if the JSX
   * text resolves to the empty string.
   *
   * Returns true if a string literal is emitted, false otherwise.
   */ processChildTextElement(needsComma) {
        const token = this.tokens.currentToken();
        const valueCode = this.tokens.code.slice(token.start, token.end);
        const replacementCode = $f3732a5a55888920$var$formatJSXTextReplacement(valueCode);
        const literalCode = $f3732a5a55888920$var$formatJSXTextLiteral(valueCode);
        if (literalCode === '""') {
            this.tokens.replaceToken(replacementCode);
            return false;
        } else {
            this.tokens.replaceToken(`${needsComma ? ", " : ""}${literalCode}${replacementCode}`);
            return true;
        }
    }
    getDevSource(elementLocationCode) {
        return `{fileName: ${this.getFilenameVarName()}, ${elementLocationCode}}`;
    }
    getFilenameVarName() {
        if (!this.filenameVarName) this.filenameVarName = this.nameManager.claimFreeName("_jsxFileName");
        return this.filenameVarName;
    }
}
function $f3732a5a55888920$export$b682d115586a1832(s) {
    const firstChar = s.charCodeAt(0);
    return firstChar >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseA && firstChar <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseZ;
}
/**
 * Turn the given jsxText string into a JS string literal. Leading and trailing
 * whitespace on lines is removed, except immediately after the open-tag and
 * before the close-tag. Empty lines are completely removed, and spaces are
 * added between lines after that.
 *
 * We use JSON.stringify to introduce escape characters as necessary, and trim
 * the start and end of each line and remove blank lines.
 */ function $f3732a5a55888920$var$formatJSXTextLiteral(text) {
    let result = "";
    let whitespace = "";
    let isInInitialLineWhitespace = false;
    let seenNonWhitespace = false;
    for(let i = 0; i < text.length; i++){
        const c = text[i];
        if (c === " " || c === "\t" || c === "\r") {
            if (!isInInitialLineWhitespace) whitespace += c;
        } else if (c === "\n") {
            whitespace = "";
            isInInitialLineWhitespace = true;
        } else {
            if (seenNonWhitespace && isInInitialLineWhitespace) result += " ";
            result += whitespace;
            whitespace = "";
            if (c === "&") {
                const { entity: entity, newI: newI } = $f3732a5a55888920$var$processEntity(text, i + 1);
                i = newI - 1;
                result += entity;
            } else result += c;
            seenNonWhitespace = true;
            isInInitialLineWhitespace = false;
        }
    }
    if (!isInInitialLineWhitespace) result += whitespace;
    return JSON.stringify(result);
}
/**
 * Produce the code that should be printed after the JSX text string literal,
 * with most content removed, but all newlines preserved and all spacing at the
 * end preserved.
 */ function $f3732a5a55888920$var$formatJSXTextReplacement(text) {
    let numNewlines = 0;
    let numSpaces = 0;
    for (const c of text){
        if (c === "\n") {
            numNewlines++;
            numSpaces = 0;
        } else if (c === " ") numSpaces++;
    }
    return "\n".repeat(numNewlines) + " ".repeat(numSpaces);
}
/**
 * Format a string in the value position of a JSX prop.
 *
 * Use the same implementation as convertAttribute from
 * babel-helper-builder-react-jsx.
 */ function $f3732a5a55888920$var$formatJSXStringValueLiteral(text) {
    let result = "";
    for(let i = 0; i < text.length; i++){
        const c = text[i];
        if (c === "\n") {
            if (/\s/.test(text[i + 1])) {
                result += " ";
                while(i < text.length && /\s/.test(text[i + 1]))i++;
            } else result += "\n";
        } else if (c === "&") {
            const { entity: entity, newI: newI } = $f3732a5a55888920$var$processEntity(text, i + 1);
            result += entity;
            i = newI - 1;
        } else result += c;
    }
    return JSON.stringify(result);
}
/**
 * Starting at a &, see if there's an HTML entity (specified by name, decimal
 * char code, or hex char code) and return it if so.
 *
 * Modified from jsxReadString in babel-parser.
 */ function $f3732a5a55888920$var$processEntity(text, indexAfterAmpersand) {
    let str = "";
    let count = 0;
    let entity;
    let i = indexAfterAmpersand;
    if (text[i] === "#") {
        let radix = 10;
        i++;
        let numStart;
        if (text[i] === "x") {
            radix = 16;
            i++;
            numStart = i;
            while(i < text.length && $f3732a5a55888920$var$isHexDigit(text.charCodeAt(i)))i++;
        } else {
            numStart = i;
            while(i < text.length && $f3732a5a55888920$var$isDecimalDigit(text.charCodeAt(i)))i++;
        }
        if (text[i] === ";") {
            const numStr = text.slice(numStart, i);
            if (numStr) {
                i++;
                entity = String.fromCodePoint(parseInt(numStr, radix));
            }
        }
    } else while(i < text.length && count++ < 10){
        const ch = text[i];
        i++;
        if (ch === ";") {
            entity = (0, $7d505f38ffd3b305$export$2e2bcd8739ae039).get(str);
            break;
        }
        str += ch;
    }
    if (!entity) return {
        entity: "&",
        newI: indexAfterAmpersand
    };
    return {
        entity: entity,
        newI: i
    };
}
function $f3732a5a55888920$var$isDecimalDigit(code) {
    return code >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit0 && code <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit9;
}
function $f3732a5a55888920$var$isHexDigit(code) {
    return code >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit0 && code <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).digit9 || code >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseA && code <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseF || code >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).uppercaseA && code <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).uppercaseF;
}



function $4b994eadb2c0f428$export$d0e55db0e89d76b7(tokens, options) {
    const jsxPragmaInfo = (0, $428ad8752015b314$export$2e2bcd8739ae039)(options);
    const nonTypeIdentifiers = new Set();
    for(let i = 0; i < tokens.tokens.length; i++){
        const token = tokens.tokens[i];
        if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name && !token.isType && (token.identifierRole === (0, $d45b756a11a5dc19$export$99f888ada3c99de3).Access || token.identifierRole === (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectShorthand || token.identifierRole === (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ExportAccess) && !token.shadowsGlobal) nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
        if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart) nonTypeIdentifiers.add(jsxPragmaInfo.base);
        if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart && i + 1 < tokens.tokens.length && tokens.tokens[i + 1].type === (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd) {
            nonTypeIdentifiers.add(jsxPragmaInfo.base);
            nonTypeIdentifiers.add(jsxPragmaInfo.fragmentBase);
        }
        if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName && token.identifierRole === (0, $d45b756a11a5dc19$export$99f888ada3c99de3).Access) {
            const identifierName = tokens.identifierNameForToken(token);
            // Lower-case single-component tag names like "div" don't count.
            if (!(0, $f3732a5a55888920$export$b682d115586a1832)(identifierName) || tokens.tokens[i + 1].type === (0, $c455753917f2f29d$export$f435f793048e7a0f).dot) nonTypeIdentifiers.add(tokens.identifierNameForToken(token));
        }
    }
    return nonTypeIdentifiers;
}


class $4996bcadbc7ee7a7$export$2e2bcd8739ae039 {
    __init() {
        this.nonTypeIdentifiers = new Set();
    }
    __init2() {
        this.importInfoByPath = new Map();
    }
    __init3() {
        this.importsToReplace = new Map();
    }
    __init4() {
        this.identifierReplacements = new Map();
    }
    __init5() {
        this.exportBindingsByLocalName = new Map();
    }
    constructor(nameManager, tokens, enableLegacyTypeScriptModuleInterop, options, isTypeScriptTransformEnabled, keepUnusedImports, helperManager){
        this.nameManager = nameManager;
        this.tokens = tokens;
        this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
        this.options = options;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.keepUnusedImports = keepUnusedImports;
        this.helperManager = helperManager;
        $4996bcadbc7ee7a7$export$2e2bcd8739ae039.prototype.__init.call(this);
        $4996bcadbc7ee7a7$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $4996bcadbc7ee7a7$export$2e2bcd8739ae039.prototype.__init3.call(this);
        $4996bcadbc7ee7a7$export$2e2bcd8739ae039.prototype.__init4.call(this);
        $4996bcadbc7ee7a7$export$2e2bcd8739ae039.prototype.__init5.call(this);
    }
    preprocessTokens() {
        for(let i = 0; i < this.tokens.tokens.length; i++){
            if (this.tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f)._import) && !this.tokens.matches3AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f)._import, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) this.preprocessImportAtIndex(i);
            if (this.tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export) && !this.tokens.matches2AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) this.preprocessExportAtIndex(i);
        }
        this.generateImportReplacements();
    }
    /**
   * In TypeScript, import statements that only import types should be removed.
   * This includes `import {} from 'foo';`, but not `import 'foo';`.
   */ pruneTypeOnlyImports() {
        this.nonTypeIdentifiers = (0, $4b994eadb2c0f428$export$d0e55db0e89d76b7)(this.tokens, this.options);
        for (const [path, importInfo] of this.importInfoByPath.entries()){
            if (importInfo.hasBareImport || importInfo.hasStarExport || importInfo.exportStarNames.length > 0 || importInfo.namedExports.length > 0) continue;
            const names = [
                ...importInfo.defaultNames,
                ...importInfo.wildcardNames,
                ...importInfo.namedImports.map(({ localName: localName })=>localName)
            ];
            if (names.every((name)=>this.shouldAutomaticallyElideImportedName(name))) this.importsToReplace.set(path, "");
        }
    }
    shouldAutomaticallyElideImportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(name);
    }
    generateImportReplacements() {
        for (const [path, importInfo] of this.importInfoByPath.entries()){
            const { defaultNames: defaultNames, wildcardNames: wildcardNames, namedImports: namedImports, namedExports: namedExports, exportStarNames: exportStarNames, hasStarExport: hasStarExport } = importInfo;
            if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0 && namedExports.length === 0 && exportStarNames.length === 0 && !hasStarExport) {
                // Import is never used, so don't even assign a name.
                this.importsToReplace.set(path, `require('${path}');`);
                continue;
            }
            const primaryImportName = this.getFreeIdentifierForPath(path);
            let secondaryImportName;
            if (this.enableLegacyTypeScriptModuleInterop) secondaryImportName = primaryImportName;
            else secondaryImportName = wildcardNames.length > 0 ? wildcardNames[0] : this.getFreeIdentifierForPath(path);
            let requireCode = `var ${primaryImportName} = require('${path}');`;
            if (wildcardNames.length > 0) for (const wildcardName of wildcardNames){
                const moduleExpr = this.enableLegacyTypeScriptModuleInterop ? primaryImportName : `${this.helperManager.getHelperName("interopRequireWildcard")}(${primaryImportName})`;
                requireCode += ` var ${wildcardName} = ${moduleExpr};`;
            }
            else if (exportStarNames.length > 0 && secondaryImportName !== primaryImportName) requireCode += ` var ${secondaryImportName} = ${this.helperManager.getHelperName("interopRequireWildcard")}(${primaryImportName});`;
            else if (defaultNames.length > 0 && secondaryImportName !== primaryImportName) requireCode += ` var ${secondaryImportName} = ${this.helperManager.getHelperName("interopRequireDefault")}(${primaryImportName});`;
            for (const { importedName: importedName, localName: localName } of namedExports)requireCode += ` ${this.helperManager.getHelperName("createNamedExportFrom")}(${primaryImportName}, '${localName}', '${importedName}');`;
            for (const exportStarName of exportStarNames)requireCode += ` exports.${exportStarName} = ${secondaryImportName};`;
            if (hasStarExport) requireCode += ` ${this.helperManager.getHelperName("createStarExport")}(${primaryImportName});`;
            this.importsToReplace.set(path, requireCode);
            for (const defaultName of defaultNames)this.identifierReplacements.set(defaultName, `${secondaryImportName}.default`);
            for (const { importedName: importedName, localName: localName } of namedImports)this.identifierReplacements.set(localName, `${primaryImportName}.${importedName}`);
        }
    }
    getFreeIdentifierForPath(path) {
        const components = path.split("/");
        const lastComponent = components[components.length - 1];
        const baseName = lastComponent.replace(/\W/g, "");
        return this.nameManager.claimFreeName(`_${baseName}`);
    }
    preprocessImportAtIndex(index) {
        const defaultNames = [];
        const wildcardNames = [];
        const namedImports = [];
        index++;
        if ((this.tokens.matchesContextualAtIndex(index, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type) || this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._typeof)) && !this.tokens.matches1AtIndex(index + 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(index + 1, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) // import type declaration, so no need to process anything.
        return;
        if (this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) // Dynamic import, so nothing to do
        return;
        if (this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
            defaultNames.push(this.tokens.identifierNameAtIndex(index));
            index++;
            if (this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) index++;
        }
        if (this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).star)) {
            // * as
            index += 2;
            wildcardNames.push(this.tokens.identifierNameAtIndex(index));
            index++;
        }
        if (this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            const result = this.getNamedImports(index + 1);
            index = result.newIndex;
            for (const namedImport of result.namedImports)// Treat {default as X} as a default import to ensure usage of require interop helper
            if (namedImport.importedName === "default") defaultNames.push(namedImport.localName);
            else namedImports.push(namedImport);
        }
        if (this.tokens.matchesContextualAtIndex(index, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) index++;
        if (!this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of import statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        importInfo.defaultNames.push(...defaultNames);
        importInfo.wildcardNames.push(...wildcardNames);
        importInfo.namedImports.push(...namedImports);
        if (defaultNames.length === 0 && wildcardNames.length === 0 && namedImports.length === 0) importInfo.hasBareImport = true;
    }
    preprocessExportAtIndex(index) {
        if (this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._var) || this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._let) || this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._const)) this.preprocessVarExportAtIndex(index);
        else if (this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function) || this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._class)) {
            const exportName = this.tokens.identifierNameAtIndex(index + 2);
            this.addExportBinding(exportName, exportName);
        } else if (this.tokens.matches3AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function)) {
            const exportName = this.tokens.identifierNameAtIndex(index + 3);
            this.addExportBinding(exportName, exportName);
        } else if (this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) this.preprocessNamedExportAtIndex(index);
        else if (this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).star)) this.preprocessExportStarAtIndex(index);
    }
    preprocessVarExportAtIndex(index) {
        let depth = 0;
        // Handle cases like `export let {x} = y;`, starting at the open-brace in that case.
        for(let i = index + 2;; i++){
            if (this.tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || this.tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f).dollarBraceL) || this.tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) depth++;
            else if (this.tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) || this.tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR)) depth--;
            else if (depth === 0 && !this.tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f).name)) break;
            else if (this.tokens.matches1AtIndex(1, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
                const endIndex = this.tokens.currentToken().rhsEndIndex;
                if (endIndex == null) throw new Error("Expected = token with an end index.");
                i = endIndex - 1;
            } else {
                const token = this.tokens.tokens[i];
                if ((0, $d45b756a11a5dc19$export$31dc9881735f7118)(token)) {
                    const exportName = this.tokens.identifierNameAtIndex(i);
                    this.identifierReplacements.set(exportName, `exports.${exportName}`);
                }
            }
        }
    }
    /**
   * Walk this export statement just in case it's an export...from statement.
   * If it is, combine it into the import info for that path. Otherwise, just
   * bail out; it'll be handled later.
   */ preprocessNamedExportAtIndex(index) {
        // export {
        index += 2;
        const { newIndex: newIndex, namedImports: namedImports } = this.getNamedImports(index);
        index = newIndex;
        if (this.tokens.matchesContextualAtIndex(index, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) index++;
        else {
            // Reinterpret "a as b" to be local/exported rather than imported/local.
            for (const { importedName: localName, localName: exportedName } of namedImports)this.addExportBinding(localName, exportedName);
            return;
        }
        if (!this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of import statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        importInfo.namedExports.push(...namedImports);
    }
    preprocessExportStarAtIndex(index) {
        let exportedName = null;
        if (this.tokens.matches3AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).star, (0, $c455753917f2f29d$export$f435f793048e7a0f)._as)) {
            // export * as
            index += 3;
            exportedName = this.tokens.identifierNameAtIndex(index);
            // foo from
            index += 2;
        } else // export * from
        index += 3;
        if (!this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).string)) throw new Error("Expected string token at the end of star export statement.");
        const path = this.tokens.stringValueAtIndex(index);
        const importInfo = this.getImportInfo(path);
        if (exportedName !== null) importInfo.exportStarNames.push(exportedName);
        else importInfo.hasStarExport = true;
    }
    getNamedImports(index) {
        const namedImports = [];
        while(true){
            if (this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                index++;
                break;
            }
            const specifierInfo = (0, $c66a0329e71568eb$export$2e2bcd8739ae039)(this.tokens, index);
            index = specifierInfo.endIndex;
            if (!specifierInfo.isType) namedImports.push({
                importedName: specifierInfo.leftName,
                localName: specifierInfo.rightName
            });
            if (this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                index += 2;
                break;
            } else if (this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                index++;
                break;
            } else if (this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) index++;
            else throw new Error(`Unexpected token: ${JSON.stringify(this.tokens.tokens[index])}`);
        }
        return {
            newIndex: index,
            namedImports: namedImports
        };
    }
    /**
   * Get a mutable import info object for this path, creating one if it doesn't
   * exist yet.
   */ getImportInfo(path) {
        const existingInfo = this.importInfoByPath.get(path);
        if (existingInfo) return existingInfo;
        const newInfo = {
            defaultNames: [],
            wildcardNames: [],
            namedImports: [],
            namedExports: [],
            hasBareImport: false,
            exportStarNames: [],
            hasStarExport: false
        };
        this.importInfoByPath.set(path, newInfo);
        return newInfo;
    }
    addExportBinding(localName, exportedName) {
        if (!this.exportBindingsByLocalName.has(localName)) this.exportBindingsByLocalName.set(localName, []);
        this.exportBindingsByLocalName.get(localName).push(exportedName);
    }
    /**
   * Return the code to use for the import for this path, or the empty string if
   * the code has already been "claimed" by a previous import.
   */ claimImportCode(importPath) {
        const result = this.importsToReplace.get(importPath);
        this.importsToReplace.set(importPath, "");
        return result || "";
    }
    getIdentifierReplacement(identifierName) {
        return this.identifierReplacements.get(identifierName) || null;
    }
    /**
   * Return a string like `exports.foo = exports.bar`.
   */ resolveExportBinding(assignedName) {
        const exportedNames = this.exportBindingsByLocalName.get(assignedName);
        if (!exportedNames || exportedNames.length === 0) return null;
        return exportedNames.map((exportedName)=>`exports.${exportedName}`).join(" = ");
    }
    /**
   * Return all imported/exported names where we might be interested in whether usages of those
   * names are shadowed.
   */ getGlobalNames() {
        return new Set([
            ...this.identifierReplacements.keys(),
            ...this.exportBindingsByLocalName.keys()
        ]);
    }
}


// src/set-array.ts
// src/vlq.ts

var $76BgN = parcelRequire("76BgN");
var $656945f32e31ce93$require$Buffer = $76BgN.Buffer;
var $656945f32e31ce93$var$comma = ",".charCodeAt(0);
var $656945f32e31ce93$var$semicolon = ";".charCodeAt(0);
var $656945f32e31ce93$var$chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $656945f32e31ce93$var$intToChar = new Uint8Array(64);
var $656945f32e31ce93$var$charToInt = new Uint8Array(128);
for(let i = 0; i < $656945f32e31ce93$var$chars.length; i++){
    const c = $656945f32e31ce93$var$chars.charCodeAt(i);
    $656945f32e31ce93$var$intToChar[i] = c;
    $656945f32e31ce93$var$charToInt[c] = i;
}
function $656945f32e31ce93$var$decodeInteger(reader, relative) {
    let value = 0;
    let shift = 0;
    let integer = 0;
    do {
        const c = reader.next();
        integer = $656945f32e31ce93$var$charToInt[c];
        value |= (integer & 31) << shift;
        shift += 5;
    }while (integer & 32);
    const shouldNegate = value & 1;
    value >>>= 1;
    if (shouldNegate) value = -2147483648 | -value;
    return relative + value;
}
function $656945f32e31ce93$var$encodeInteger(builder, num, relative) {
    let delta = num - relative;
    delta = delta < 0 ? -delta << 1 | 1 : delta << 1;
    do {
        let clamped = delta & 31;
        delta >>>= 5;
        if (delta > 0) clamped |= 32;
        builder.write($656945f32e31ce93$var$intToChar[clamped]);
    }while (delta > 0);
    return num;
}
function $656945f32e31ce93$var$hasMoreVlq(reader, max) {
    if (reader.pos >= max) return false;
    return reader.peek() !== $656945f32e31ce93$var$comma;
}
// src/strings.ts
var $656945f32e31ce93$var$bufLength = 16384;
var $656945f32e31ce93$var$td = typeof TextDecoder !== "undefined" ? /* @__PURE__ */ new TextDecoder() : typeof $656945f32e31ce93$require$Buffer !== "undefined" ? {
    decode (buf) {
        const out = $656945f32e31ce93$require$Buffer.from(buf.buffer, buf.byteOffset, buf.byteLength);
        return out.toString();
    }
} : {
    decode (buf) {
        let out = "";
        for(let i = 0; i < buf.length; i++)out += String.fromCharCode(buf[i]);
        return out;
    }
};
var $656945f32e31ce93$var$StringWriter = class {
    constructor(){
        this.pos = 0;
        this.out = "";
        this.buffer = new Uint8Array($656945f32e31ce93$var$bufLength);
    }
    write(v) {
        const { buffer: buffer } = this;
        buffer[this.pos++] = v;
        if (this.pos === $656945f32e31ce93$var$bufLength) {
            this.out += $656945f32e31ce93$var$td.decode(buffer);
            this.pos = 0;
        }
    }
    flush() {
        const { buffer: buffer, out: out, pos: pos } = this;
        return pos > 0 ? out + $656945f32e31ce93$var$td.decode(buffer.subarray(0, pos)) : out;
    }
};
var $656945f32e31ce93$var$StringReader = class {
    constructor(buffer){
        this.pos = 0;
        this.buffer = buffer;
    }
    next() {
        return this.buffer.charCodeAt(this.pos++);
    }
    peek() {
        return this.buffer.charCodeAt(this.pos);
    }
    indexOf(char) {
        const { buffer: buffer, pos: pos } = this;
        const idx = buffer.indexOf(char, pos);
        return idx === -1 ? buffer.length : idx;
    }
};
// src/scopes.ts
var $656945f32e31ce93$var$EMPTY = [];
function $656945f32e31ce93$export$b644ec5c290d956e(input) {
    const { length: length } = input;
    const reader = new $656945f32e31ce93$var$StringReader(input);
    const scopes = [];
    const stack = [];
    let line = 0;
    for(; reader.pos < length; reader.pos++){
        line = $656945f32e31ce93$var$decodeInteger(reader, line);
        const column = $656945f32e31ce93$var$decodeInteger(reader, 0);
        if (!$656945f32e31ce93$var$hasMoreVlq(reader, length)) {
            const last = stack.pop();
            last[2] = line;
            last[3] = column;
            continue;
        }
        const kind = $656945f32e31ce93$var$decodeInteger(reader, 0);
        const fields = $656945f32e31ce93$var$decodeInteger(reader, 0);
        const hasName = fields & 1;
        const scope = hasName ? [
            line,
            column,
            0,
            0,
            kind,
            $656945f32e31ce93$var$decodeInteger(reader, 0)
        ] : [
            line,
            column,
            0,
            0,
            kind
        ];
        let vars = $656945f32e31ce93$var$EMPTY;
        if ($656945f32e31ce93$var$hasMoreVlq(reader, length)) {
            vars = [];
            do {
                const varsIndex = $656945f32e31ce93$var$decodeInteger(reader, 0);
                vars.push(varsIndex);
            }while ($656945f32e31ce93$var$hasMoreVlq(reader, length));
        }
        scope.vars = vars;
        scopes.push(scope);
        stack.push(scope);
    }
    return scopes;
}
function $656945f32e31ce93$export$b8cf1ed92d4ce741(scopes) {
    const writer = new $656945f32e31ce93$var$StringWriter();
    for(let i = 0; i < scopes.length;)i = $656945f32e31ce93$var$_encodeOriginalScopes(scopes, i, writer, [
        0
    ]);
    return writer.flush();
}
function $656945f32e31ce93$var$_encodeOriginalScopes(scopes, index, writer, state) {
    const scope = scopes[index];
    const { 0: startLine, 1: startColumn, 2: endLine, 3: endColumn, 4: kind, vars: vars } = scope;
    if (index > 0) writer.write($656945f32e31ce93$var$comma);
    state[0] = $656945f32e31ce93$var$encodeInteger(writer, startLine, state[0]);
    $656945f32e31ce93$var$encodeInteger(writer, startColumn, 0);
    $656945f32e31ce93$var$encodeInteger(writer, kind, 0);
    const fields = scope.length === 6 ? 1 : 0;
    $656945f32e31ce93$var$encodeInteger(writer, fields, 0);
    if (scope.length === 6) $656945f32e31ce93$var$encodeInteger(writer, scope[5], 0);
    for (const v of vars)$656945f32e31ce93$var$encodeInteger(writer, v, 0);
    for(index++; index < scopes.length;){
        const next = scopes[index];
        const { 0: l, 1: c } = next;
        if (l > endLine || l === endLine && c >= endColumn) break;
        index = $656945f32e31ce93$var$_encodeOriginalScopes(scopes, index, writer, state);
    }
    writer.write($656945f32e31ce93$var$comma);
    state[0] = $656945f32e31ce93$var$encodeInteger(writer, endLine, state[0]);
    $656945f32e31ce93$var$encodeInteger(writer, endColumn, 0);
    return index;
}
function $656945f32e31ce93$export$dadc7b4b4811a4cd(input) {
    const { length: length } = input;
    const reader = new $656945f32e31ce93$var$StringReader(input);
    const ranges = [];
    const stack = [];
    let genLine = 0;
    let definitionSourcesIndex = 0;
    let definitionScopeIndex = 0;
    let callsiteSourcesIndex = 0;
    let callsiteLine = 0;
    let callsiteColumn = 0;
    let bindingLine = 0;
    let bindingColumn = 0;
    do {
        const semi = reader.indexOf(";");
        let genColumn = 0;
        for(; reader.pos < semi; reader.pos++){
            genColumn = $656945f32e31ce93$var$decodeInteger(reader, genColumn);
            if (!$656945f32e31ce93$var$hasMoreVlq(reader, semi)) {
                const last = stack.pop();
                last[2] = genLine;
                last[3] = genColumn;
                continue;
            }
            const fields = $656945f32e31ce93$var$decodeInteger(reader, 0);
            const hasDefinition = fields & 1;
            const hasCallsite = fields & 2;
            const hasScope = fields & 4;
            let callsite = null;
            let bindings = $656945f32e31ce93$var$EMPTY;
            let range;
            if (hasDefinition) {
                const defSourcesIndex = $656945f32e31ce93$var$decodeInteger(reader, definitionSourcesIndex);
                definitionScopeIndex = $656945f32e31ce93$var$decodeInteger(reader, definitionSourcesIndex === defSourcesIndex ? definitionScopeIndex : 0);
                definitionSourcesIndex = defSourcesIndex;
                range = [
                    genLine,
                    genColumn,
                    0,
                    0,
                    defSourcesIndex,
                    definitionScopeIndex
                ];
            } else range = [
                genLine,
                genColumn,
                0,
                0
            ];
            range.isScope = !!hasScope;
            if (hasCallsite) {
                const prevCsi = callsiteSourcesIndex;
                const prevLine = callsiteLine;
                callsiteSourcesIndex = $656945f32e31ce93$var$decodeInteger(reader, callsiteSourcesIndex);
                const sameSource = prevCsi === callsiteSourcesIndex;
                callsiteLine = $656945f32e31ce93$var$decodeInteger(reader, sameSource ? callsiteLine : 0);
                callsiteColumn = $656945f32e31ce93$var$decodeInteger(reader, sameSource && prevLine === callsiteLine ? callsiteColumn : 0);
                callsite = [
                    callsiteSourcesIndex,
                    callsiteLine,
                    callsiteColumn
                ];
            }
            range.callsite = callsite;
            if ($656945f32e31ce93$var$hasMoreVlq(reader, semi)) {
                bindings = [];
                do {
                    bindingLine = genLine;
                    bindingColumn = genColumn;
                    const expressionsCount = $656945f32e31ce93$var$decodeInteger(reader, 0);
                    let expressionRanges;
                    if (expressionsCount < -1) {
                        expressionRanges = [
                            [
                                $656945f32e31ce93$var$decodeInteger(reader, 0)
                            ]
                        ];
                        for(let i = -1; i > expressionsCount; i--){
                            const prevBl = bindingLine;
                            bindingLine = $656945f32e31ce93$var$decodeInteger(reader, bindingLine);
                            bindingColumn = $656945f32e31ce93$var$decodeInteger(reader, bindingLine === prevBl ? bindingColumn : 0);
                            const expression = $656945f32e31ce93$var$decodeInteger(reader, 0);
                            expressionRanges.push([
                                expression,
                                bindingLine,
                                bindingColumn
                            ]);
                        }
                    } else expressionRanges = [
                        [
                            expressionsCount
                        ]
                    ];
                    bindings.push(expressionRanges);
                }while ($656945f32e31ce93$var$hasMoreVlq(reader, semi));
            }
            range.bindings = bindings;
            ranges.push(range);
            stack.push(range);
        }
        genLine++;
        reader.pos = semi + 1;
    }while (reader.pos < length);
    return ranges;
}
function $656945f32e31ce93$export$8e469a859d564769(ranges) {
    if (ranges.length === 0) return "";
    const writer = new $656945f32e31ce93$var$StringWriter();
    for(let i = 0; i < ranges.length;)i = $656945f32e31ce93$var$_encodeGeneratedRanges(ranges, i, writer, [
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ]);
    return writer.flush();
}
function $656945f32e31ce93$var$_encodeGeneratedRanges(ranges, index, writer, state) {
    const range = ranges[index];
    const { 0: startLine, 1: startColumn, 2: endLine, 3: endColumn, isScope: isScope, callsite: callsite, bindings: bindings } = range;
    if (state[0] < startLine) {
        $656945f32e31ce93$var$catchupLine(writer, state[0], startLine);
        state[0] = startLine;
        state[1] = 0;
    } else if (index > 0) writer.write($656945f32e31ce93$var$comma);
    state[1] = $656945f32e31ce93$var$encodeInteger(writer, range[1], state[1]);
    const fields = (range.length === 6 ? 1 : 0) | (callsite ? 2 : 0) | (isScope ? 4 : 0);
    $656945f32e31ce93$var$encodeInteger(writer, fields, 0);
    if (range.length === 6) {
        const { 4: sourcesIndex, 5: scopesIndex } = range;
        if (sourcesIndex !== state[2]) state[3] = 0;
        state[2] = $656945f32e31ce93$var$encodeInteger(writer, sourcesIndex, state[2]);
        state[3] = $656945f32e31ce93$var$encodeInteger(writer, scopesIndex, state[3]);
    }
    if (callsite) {
        const { 0: sourcesIndex, 1: callLine, 2: callColumn } = range.callsite;
        if (sourcesIndex !== state[4]) {
            state[5] = 0;
            state[6] = 0;
        } else if (callLine !== state[5]) state[6] = 0;
        state[4] = $656945f32e31ce93$var$encodeInteger(writer, sourcesIndex, state[4]);
        state[5] = $656945f32e31ce93$var$encodeInteger(writer, callLine, state[5]);
        state[6] = $656945f32e31ce93$var$encodeInteger(writer, callColumn, state[6]);
    }
    if (bindings) for (const binding of bindings){
        if (binding.length > 1) $656945f32e31ce93$var$encodeInteger(writer, -binding.length, 0);
        const expression = binding[0][0];
        $656945f32e31ce93$var$encodeInteger(writer, expression, 0);
        let bindingStartLine = startLine;
        let bindingStartColumn = startColumn;
        for(let i = 1; i < binding.length; i++){
            const expRange = binding[i];
            bindingStartLine = $656945f32e31ce93$var$encodeInteger(writer, expRange[1], bindingStartLine);
            bindingStartColumn = $656945f32e31ce93$var$encodeInteger(writer, expRange[2], bindingStartColumn);
            $656945f32e31ce93$var$encodeInteger(writer, expRange[0], 0);
        }
    }
    for(index++; index < ranges.length;){
        const next = ranges[index];
        const { 0: l, 1: c } = next;
        if (l > endLine || l === endLine && c >= endColumn) break;
        index = $656945f32e31ce93$var$_encodeGeneratedRanges(ranges, index, writer, state);
    }
    if (state[0] < endLine) {
        $656945f32e31ce93$var$catchupLine(writer, state[0], endLine);
        state[0] = endLine;
        state[1] = 0;
    } else writer.write($656945f32e31ce93$var$comma);
    state[1] = $656945f32e31ce93$var$encodeInteger(writer, endColumn, state[1]);
    return index;
}
function $656945f32e31ce93$var$catchupLine(writer, lastLine, line) {
    do writer.write($656945f32e31ce93$var$semicolon);
    while (++lastLine < line);
}
// src/sourcemap-codec.ts
function $656945f32e31ce93$export$2f872c0f2117be69(mappings) {
    const { length: length } = mappings;
    const reader = new $656945f32e31ce93$var$StringReader(mappings);
    const decoded = [];
    let genColumn = 0;
    let sourcesIndex = 0;
    let sourceLine = 0;
    let sourceColumn = 0;
    let namesIndex = 0;
    do {
        const semi = reader.indexOf(";");
        const line = [];
        let sorted = true;
        let lastCol = 0;
        genColumn = 0;
        while(reader.pos < semi){
            let seg;
            genColumn = $656945f32e31ce93$var$decodeInteger(reader, genColumn);
            if (genColumn < lastCol) sorted = false;
            lastCol = genColumn;
            if ($656945f32e31ce93$var$hasMoreVlq(reader, semi)) {
                sourcesIndex = $656945f32e31ce93$var$decodeInteger(reader, sourcesIndex);
                sourceLine = $656945f32e31ce93$var$decodeInteger(reader, sourceLine);
                sourceColumn = $656945f32e31ce93$var$decodeInteger(reader, sourceColumn);
                if ($656945f32e31ce93$var$hasMoreVlq(reader, semi)) {
                    namesIndex = $656945f32e31ce93$var$decodeInteger(reader, namesIndex);
                    seg = [
                        genColumn,
                        sourcesIndex,
                        sourceLine,
                        sourceColumn,
                        namesIndex
                    ];
                } else seg = [
                    genColumn,
                    sourcesIndex,
                    sourceLine,
                    sourceColumn
                ];
            } else seg = [
                genColumn
            ];
            line.push(seg);
            reader.pos++;
        }
        if (!sorted) $656945f32e31ce93$var$sort(line);
        decoded.push(line);
        reader.pos = semi + 1;
    }while (reader.pos <= length);
    return decoded;
}
function $656945f32e31ce93$var$sort(line) {
    line.sort($656945f32e31ce93$var$sortComparator);
}
function $656945f32e31ce93$var$sortComparator(a, b) {
    return a[0] - b[0];
}
function $656945f32e31ce93$export$c564cdbbe6da493(decoded) {
    const writer = new $656945f32e31ce93$var$StringWriter();
    let sourcesIndex = 0;
    let sourceLine = 0;
    let sourceColumn = 0;
    let namesIndex = 0;
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        if (i > 0) writer.write($656945f32e31ce93$var$semicolon);
        if (line.length === 0) continue;
        let genColumn = 0;
        for(let j = 0; j < line.length; j++){
            const segment = line[j];
            if (j > 0) writer.write($656945f32e31ce93$var$comma);
            genColumn = $656945f32e31ce93$var$encodeInteger(writer, segment[0], genColumn);
            if (segment.length === 1) continue;
            sourcesIndex = $656945f32e31ce93$var$encodeInteger(writer, segment[1], sourcesIndex);
            sourceLine = $656945f32e31ce93$var$encodeInteger(writer, segment[2], sourceLine);
            sourceColumn = $656945f32e31ce93$var$encodeInteger(writer, segment[3], sourceColumn);
            if (segment.length === 4) continue;
            namesIndex = $656945f32e31ce93$var$encodeInteger(writer, segment[4], namesIndex);
        }
    }
    return writer.flush();
}


// src/trace-mapping.ts

var $82c6e9ba776be892$exports = {};
(function(global, factory) {
    $82c6e9ba776be892$exports = factory();
})($82c6e9ba776be892$exports, function() {
    'use strict';
    // Matches the scheme of a URL, eg "http://"
    const schemeRegex = /^[\w+.-]+:\/\//;
    /**
     * Matches the parts of a URL:
     * 1. Scheme, including ":", guaranteed.
     * 2. User/password, including "@", optional.
     * 3. Host, guaranteed.
     * 4. Port, including ":", optional.
     * 5. Path, including "/", optional.
     * 6. Query, including "?", optional.
     * 7. Hash, including "#", optional.
     */ const urlRegex = /^([\w+.-]+:)\/\/([^@/#?]*@)?([^:/#?]*)(:\d+)?(\/[^#?]*)?(\?[^#]*)?(#.*)?/;
    /**
     * File URLs are weird. They dont' need the regular `//` in the scheme, they may or may not start
     * with a leading `/`, they can have a domain (but only if they don't start with a Windows drive).
     *
     * 1. Host, optional.
     * 2. Path, which may include "/", guaranteed.
     * 3. Query, including "?", optional.
     * 4. Hash, including "#", optional.
     */ const fileRegex = /^file:(?:\/\/((?![a-z]:)[^/#?]*)?)?(\/?[^#?]*)(\?[^#]*)?(#.*)?/i;
    function isAbsoluteUrl(input) {
        return schemeRegex.test(input);
    }
    function isSchemeRelativeUrl(input) {
        return input.startsWith('//');
    }
    function isAbsolutePath(input) {
        return input.startsWith('/');
    }
    function isFileUrl(input) {
        return input.startsWith('file:');
    }
    function isRelative(input) {
        return /^[.?#]/.test(input);
    }
    function parseAbsoluteUrl(input) {
        const match = urlRegex.exec(input);
        return makeUrl(match[1], match[2] || '', match[3], match[4] || '', match[5] || '/', match[6] || '', match[7] || '');
    }
    function parseFileUrl(input) {
        const match = fileRegex.exec(input);
        const path = match[2];
        return makeUrl('file:', '', match[1] || '', '', isAbsolutePath(path) ? path : '/' + path, match[3] || '', match[4] || '');
    }
    function makeUrl(scheme, user, host, port, path, query, hash) {
        return {
            scheme: scheme,
            user: user,
            host: host,
            port: port,
            path: path,
            query: query,
            hash: hash,
            type: 7 /* Absolute */ 
        };
    }
    function parseUrl(input) {
        if (isSchemeRelativeUrl(input)) {
            const url = parseAbsoluteUrl('http:' + input);
            url.scheme = '';
            url.type = 6 /* SchemeRelative */ ;
            return url;
        }
        if (isAbsolutePath(input)) {
            const url = parseAbsoluteUrl('http://foo.com' + input);
            url.scheme = '';
            url.host = '';
            url.type = 5 /* AbsolutePath */ ;
            return url;
        }
        if (isFileUrl(input)) return parseFileUrl(input);
        if (isAbsoluteUrl(input)) return parseAbsoluteUrl(input);
        const url = parseAbsoluteUrl('http://foo.com/' + input);
        url.scheme = '';
        url.host = '';
        url.type = input ? input.startsWith('?') ? 3 /* Query */  : input.startsWith('#') ? 2 /* Hash */  : 4 /* RelativePath */  : 1 /* Empty */ ;
        return url;
    }
    function stripPathFilename(path) {
        // If a path ends with a parent directory "..", then it's a relative path with excess parent
        // paths. It's not a file, so we can't strip it.
        if (path.endsWith('/..')) return path;
        const index = path.lastIndexOf('/');
        return path.slice(0, index + 1);
    }
    function mergePaths(url, base) {
        normalizePath(base, base.type);
        // If the path is just a "/", then it was an empty path to begin with (remember, we're a relative
        // path).
        if (url.path === '/') url.path = base.path;
        else // Resolution happens relative to the base path's directory, not the file.
        url.path = stripPathFilename(base.path) + url.path;
    }
    /**
     * The path can have empty directories "//", unneeded parents "foo/..", or current directory
     * "foo/.". We need to normalize to a standard representation.
     */ function normalizePath(url, type) {
        const rel = type <= 4 /* RelativePath */ ;
        const pieces = url.path.split('/');
        // We need to preserve the first piece always, so that we output a leading slash. The item at
        // pieces[0] is an empty string.
        let pointer = 1;
        // Positive is the number of real directories we've output, used for popping a parent directory.
        // Eg, "foo/bar/.." will have a positive 2, and we can decrement to be left with just "foo".
        let positive = 0;
        // We need to keep a trailing slash if we encounter an empty directory (eg, splitting "foo/" will
        // generate `["foo", ""]` pieces). And, if we pop a parent directory. But once we encounter a
        // real directory, we won't need to append, unless the other conditions happen again.
        let addTrailingSlash = false;
        for(let i = 1; i < pieces.length; i++){
            const piece = pieces[i];
            // An empty directory, could be a trailing slash, or just a double "//" in the path.
            if (!piece) {
                addTrailingSlash = true;
                continue;
            }
            // If we encounter a real directory, then we don't need to append anymore.
            addTrailingSlash = false;
            // A current directory, which we can always drop.
            if (piece === '.') continue;
            // A parent directory, we need to see if there are any real directories we can pop. Else, we
            // have an excess of parents, and we'll need to keep the "..".
            if (piece === '..') {
                if (positive) {
                    addTrailingSlash = true;
                    positive--;
                    pointer--;
                } else if (rel) // If we're in a relativePath, then we need to keep the excess parents. Else, in an absolute
                // URL, protocol relative URL, or an absolute path, we don't need to keep excess.
                pieces[pointer++] = piece;
                continue;
            }
            // We've encountered a real directory. Move it to the next insertion pointer, which accounts for
            // any popped or dropped directories.
            pieces[pointer++] = piece;
            positive++;
        }
        let path = '';
        for(let i = 1; i < pointer; i++)path += '/' + pieces[i];
        if (!path || addTrailingSlash && !path.endsWith('/..')) path += '/';
        url.path = path;
    }
    /**
     * Attempts to resolve `input` URL/path relative to `base`.
     */ function resolve(input, base) {
        if (!input && !base) return '';
        const url = parseUrl(input);
        let inputType = url.type;
        if (base && inputType !== 7 /* Absolute */ ) {
            const baseUrl = parseUrl(base);
            const baseType = baseUrl.type;
            switch(inputType){
                case 1 /* Empty */ :
                    url.hash = baseUrl.hash;
                // fall through
                case 2 /* Hash */ :
                    url.query = baseUrl.query;
                // fall through
                case 3 /* Query */ :
                case 4 /* RelativePath */ :
                    mergePaths(url, baseUrl);
                // fall through
                case 5 /* AbsolutePath */ :
                    // The host, user, and port are joined, you can't copy one without the others.
                    url.user = baseUrl.user;
                    url.host = baseUrl.host;
                    url.port = baseUrl.port;
                // fall through
                case 6 /* SchemeRelative */ :
                    // The input doesn't have a schema at least, so we need to copy at least that over.
                    url.scheme = baseUrl.scheme;
            }
            if (baseType > inputType) inputType = baseType;
        }
        normalizePath(url, inputType);
        const queryHash = url.query + url.hash;
        switch(inputType){
            // This is impossible, because of the empty checks at the start of the function.
            // case UrlType.Empty:
            case 2 /* Hash */ :
            case 3 /* Query */ :
                return queryHash;
            case 4 /* RelativePath */ :
                {
                    // The first char is always a "/", and we need it to be relative.
                    const path = url.path.slice(1);
                    if (!path) return queryHash || '.';
                    if (isRelative(base || input) && !isRelative(path)) // If base started with a leading ".", or there is no base and input started with a ".",
                    // then we need to ensure that the relative path starts with a ".". We don't know if
                    // relative starts with a "..", though, so check before prepending.
                    return './' + path + queryHash;
                    return path + queryHash;
                }
            case 5 /* AbsolutePath */ :
                return url.path + queryHash;
            default:
                return url.scheme + '//' + url.user + url.host + url.port + url.path + queryHash;
        }
    }
    return resolve;
});


// src/strip-filename.ts
function $d4c5474a7187c745$var$stripFilename(path) {
    if (!path) return "";
    const index = path.lastIndexOf("/");
    return path.slice(0, index + 1);
}
// src/resolve.ts
function $d4c5474a7187c745$var$resolver(mapUrl, sourceRoot) {
    const from = $d4c5474a7187c745$var$stripFilename(mapUrl);
    const prefix = sourceRoot ? sourceRoot + "/" : "";
    return (source)=>(0, (/*@__PURE__*/$parcel$interopDefault($82c6e9ba776be892$exports)))(prefix + (source || ""), from);
}
// src/sourcemap-segment.ts
var $d4c5474a7187c745$var$COLUMN = 0;
var $d4c5474a7187c745$var$SOURCES_INDEX = 1;
var $d4c5474a7187c745$var$SOURCE_LINE = 2;
var $d4c5474a7187c745$var$SOURCE_COLUMN = 3;
var $d4c5474a7187c745$var$NAMES_INDEX = 4;
var $d4c5474a7187c745$var$REV_GENERATED_LINE = 1;
var $d4c5474a7187c745$var$REV_GENERATED_COLUMN = 2;
// src/sort.ts
function $d4c5474a7187c745$var$maybeSort(mappings, owned) {
    const unsortedIndex = $d4c5474a7187c745$var$nextUnsortedSegmentLine(mappings, 0);
    if (unsortedIndex === mappings.length) return mappings;
    if (!owned) mappings = mappings.slice();
    for(let i = unsortedIndex; i < mappings.length; i = $d4c5474a7187c745$var$nextUnsortedSegmentLine(mappings, i + 1))mappings[i] = $d4c5474a7187c745$var$sortSegments(mappings[i], owned);
    return mappings;
}
function $d4c5474a7187c745$var$nextUnsortedSegmentLine(mappings, start) {
    for(let i = start; i < mappings.length; i++){
        if (!$d4c5474a7187c745$var$isSorted(mappings[i])) return i;
    }
    return mappings.length;
}
function $d4c5474a7187c745$var$isSorted(line) {
    for(let j = 1; j < line.length; j++){
        if (line[j][$d4c5474a7187c745$var$COLUMN] < line[j - 1][$d4c5474a7187c745$var$COLUMN]) return false;
    }
    return true;
}
function $d4c5474a7187c745$var$sortSegments(line, owned) {
    if (!owned) line = line.slice();
    return line.sort($d4c5474a7187c745$var$sortComparator);
}
function $d4c5474a7187c745$var$sortComparator(a, b) {
    return a[$d4c5474a7187c745$var$COLUMN] - b[$d4c5474a7187c745$var$COLUMN];
}
// src/by-source.ts
function $d4c5474a7187c745$var$buildBySources(decoded, memos) {
    const sources = memos.map(()=>[]);
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            if (seg.length === 1) continue;
            const sourceIndex2 = seg[$d4c5474a7187c745$var$SOURCES_INDEX];
            const sourceLine = seg[$d4c5474a7187c745$var$SOURCE_LINE];
            const sourceColumn = seg[$d4c5474a7187c745$var$SOURCE_COLUMN];
            const source = sources[sourceIndex2];
            const segs = source[sourceLine] || (source[sourceLine] = []);
            segs.push([
                sourceColumn,
                i,
                seg[$d4c5474a7187c745$var$COLUMN]
            ]);
        }
    }
    for(let i = 0; i < sources.length; i++){
        const source = sources[i];
        for(let j = 0; j < source.length; j++){
            const line = source[j];
            if (line) line.sort($d4c5474a7187c745$var$sortComparator);
        }
    }
    return sources;
}
// src/binary-search.ts
var $d4c5474a7187c745$var$found = false;
function $d4c5474a7187c745$var$binarySearch(haystack, needle, low, high) {
    while(low <= high){
        const mid = low + (high - low >> 1);
        const cmp = haystack[mid][$d4c5474a7187c745$var$COLUMN] - needle;
        if (cmp === 0) {
            $d4c5474a7187c745$var$found = true;
            return mid;
        }
        if (cmp < 0) low = mid + 1;
        else high = mid - 1;
    }
    $d4c5474a7187c745$var$found = false;
    return low - 1;
}
function $d4c5474a7187c745$var$upperBound(haystack, needle, index) {
    for(let i = index + 1; i < haystack.length; index = i++){
        if (haystack[i][$d4c5474a7187c745$var$COLUMN] !== needle) break;
    }
    return index;
}
function $d4c5474a7187c745$var$lowerBound(haystack, needle, index) {
    for(let i = index - 1; i >= 0; index = i--){
        if (haystack[i][$d4c5474a7187c745$var$COLUMN] !== needle) break;
    }
    return index;
}
function $d4c5474a7187c745$var$memoizedState() {
    return {
        lastKey: -1,
        lastNeedle: -1,
        lastIndex: -1
    };
}
function $d4c5474a7187c745$var$memoizedBinarySearch(haystack, needle, state, key) {
    const { lastKey: lastKey, lastNeedle: lastNeedle, lastIndex: lastIndex } = state;
    let low = 0;
    let high = haystack.length - 1;
    if (key === lastKey) {
        if (needle === lastNeedle) {
            $d4c5474a7187c745$var$found = lastIndex !== -1 && haystack[lastIndex][$d4c5474a7187c745$var$COLUMN] === needle;
            return lastIndex;
        }
        if (needle >= lastNeedle) low = lastIndex === -1 ? 0 : lastIndex;
        else high = lastIndex;
    }
    state.lastKey = key;
    state.lastNeedle = needle;
    return state.lastIndex = $d4c5474a7187c745$var$binarySearch(haystack, needle, low, high);
}
// src/types.ts
function $d4c5474a7187c745$var$parse(map) {
    return typeof map === "string" ? JSON.parse(map) : map;
}
// src/flatten-map.ts
var $d4c5474a7187c745$export$cfb1ea40164567c5 = function(map, mapUrl) {
    const parsed = $d4c5474a7187c745$var$parse(map);
    if (!("sections" in parsed)) return new $d4c5474a7187c745$export$6fc8edf86512ec85(parsed, mapUrl);
    const mappings = [];
    const sources = [];
    const sourcesContent = [];
    const names = [];
    const ignoreList = [];
    $d4c5474a7187c745$var$recurse(parsed, mapUrl, mappings, sources, sourcesContent, names, ignoreList, 0, 0, Infinity, Infinity);
    const joined = {
        version: 3,
        file: parsed.file,
        names: names,
        sources: sources,
        sourcesContent: sourcesContent,
        mappings: mappings,
        ignoreList: ignoreList
    };
    return $d4c5474a7187c745$export$20ee0c4a5619bf3d(joined);
};
function $d4c5474a7187c745$var$recurse(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    const { sections: sections } = input;
    for(let i = 0; i < sections.length; i++){
        const { map: map, offset: offset } = sections[i];
        let sl = stopLine;
        let sc = stopColumn;
        if (i + 1 < sections.length) {
            const nextOffset = sections[i + 1].offset;
            sl = Math.min(stopLine, lineOffset + nextOffset.line);
            if (sl === stopLine) sc = Math.min(stopColumn, columnOffset + nextOffset.column);
            else if (sl < stopLine) sc = columnOffset + nextOffset.column;
        }
        $d4c5474a7187c745$var$addSection(map, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset + offset.line, columnOffset + offset.column, sl, sc);
    }
}
function $d4c5474a7187c745$var$addSection(input, mapUrl, mappings, sources, sourcesContent, names, ignoreList, lineOffset, columnOffset, stopLine, stopColumn) {
    const parsed = $d4c5474a7187c745$var$parse(input);
    if ("sections" in parsed) return $d4c5474a7187c745$var$recurse(...arguments);
    const map = new $d4c5474a7187c745$export$6fc8edf86512ec85(parsed, mapUrl);
    const sourcesOffset = sources.length;
    const namesOffset = names.length;
    const decoded = $d4c5474a7187c745$export$ecd113d4f34af700(map);
    const { resolvedSources: resolvedSources, sourcesContent: contents, ignoreList: ignores } = map;
    $d4c5474a7187c745$var$append(sources, resolvedSources);
    $d4c5474a7187c745$var$append(names, map.names);
    if (contents) $d4c5474a7187c745$var$append(sourcesContent, contents);
    else for(let i = 0; i < resolvedSources.length; i++)sourcesContent.push(null);
    if (ignores) for(let i = 0; i < ignores.length; i++)ignoreList.push(ignores[i] + sourcesOffset);
    for(let i = 0; i < decoded.length; i++){
        const lineI = lineOffset + i;
        if (lineI > stopLine) return;
        const out = $d4c5474a7187c745$var$getLine(mappings, lineI);
        const cOffset = i === 0 ? columnOffset : 0;
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const column = cOffset + seg[$d4c5474a7187c745$var$COLUMN];
            if (lineI === stopLine && column >= stopColumn) return;
            if (seg.length === 1) {
                out.push([
                    column
                ]);
                continue;
            }
            const sourcesIndex = sourcesOffset + seg[$d4c5474a7187c745$var$SOURCES_INDEX];
            const sourceLine = seg[$d4c5474a7187c745$var$SOURCE_LINE];
            const sourceColumn = seg[$d4c5474a7187c745$var$SOURCE_COLUMN];
            out.push(seg.length === 4 ? [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn
            ] : [
                column,
                sourcesIndex,
                sourceLine,
                sourceColumn,
                namesOffset + seg[$d4c5474a7187c745$var$NAMES_INDEX]
            ]);
        }
    }
}
function $d4c5474a7187c745$var$append(arr, other) {
    for(let i = 0; i < other.length; i++)arr.push(other[i]);
}
function $d4c5474a7187c745$var$getLine(arr, index) {
    for(let i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
// src/trace-mapping.ts
var $d4c5474a7187c745$var$LINE_GTR_ZERO = "`line` must be greater than 0 (lines start at line 1)";
var $d4c5474a7187c745$var$COL_GTR_EQ_ZERO = "`column` must be greater than or equal to 0 (columns start at column 0)";
var $d4c5474a7187c745$export$b99fbecff261243 = -1;
var $d4c5474a7187c745$export$4ecd616dce182dff = 1;
var $d4c5474a7187c745$export$6fc8edf86512ec85 = class {
    constructor(map, mapUrl){
        const isString = typeof map === "string";
        if (!isString && map._decodedMemo) return map;
        const parsed = $d4c5474a7187c745$var$parse(map);
        const { version: version, file: file, names: names, sourceRoot: sourceRoot, sources: sources, sourcesContent: sourcesContent } = parsed;
        this.version = version;
        this.file = file;
        this.names = names || [];
        this.sourceRoot = sourceRoot;
        this.sources = sources;
        this.sourcesContent = sourcesContent;
        this.ignoreList = parsed.ignoreList || parsed.x_google_ignoreList || void 0;
        const resolve = $d4c5474a7187c745$var$resolver(mapUrl, sourceRoot);
        this.resolvedSources = sources.map(resolve);
        const { mappings: mappings } = parsed;
        if (typeof mappings === "string") {
            this._encoded = mappings;
            this._decoded = void 0;
        } else if (Array.isArray(mappings)) {
            this._encoded = void 0;
            this._decoded = $d4c5474a7187c745$var$maybeSort(mappings, isString);
        } else if (parsed.sections) throw new Error(`TraceMap passed sectioned source map, please use FlattenMap export instead`);
        else throw new Error(`invalid source map: ${JSON.stringify(parsed)}`);
        this._decodedMemo = $d4c5474a7187c745$var$memoizedState();
        this._bySources = void 0;
        this._bySourceMemos = void 0;
    }
};
function $d4c5474a7187c745$var$cast(map) {
    return map;
}
function $d4c5474a7187c745$export$59408758bba4b625(map) {
    var _a, _b;
    return (_b = (_a = $d4c5474a7187c745$var$cast(map))._encoded) != null ? _b : _a._encoded = (0, $656945f32e31ce93$export$c564cdbbe6da493)($d4c5474a7187c745$var$cast(map)._decoded);
}
function $d4c5474a7187c745$export$ecd113d4f34af700(map) {
    var _a;
    return (_a = $d4c5474a7187c745$var$cast(map))._decoded || (_a._decoded = (0, $656945f32e31ce93$export$2f872c0f2117be69)($d4c5474a7187c745$var$cast(map)._encoded));
}
function $d4c5474a7187c745$export$6d863e58cd035563(map, line, column) {
    const decoded = $d4c5474a7187c745$export$ecd113d4f34af700(map);
    if (line >= decoded.length) return null;
    const segments = decoded[line];
    const index = $d4c5474a7187c745$var$traceSegmentInternal(segments, $d4c5474a7187c745$var$cast(map)._decodedMemo, line, column, $d4c5474a7187c745$export$4ecd616dce182dff);
    return index === -1 ? null : segments[index];
}
function $d4c5474a7187c745$export$56d62ac80d274c78(map, needle) {
    let { line: line, column: column, bias: bias } = needle;
    line--;
    if (line < 0) throw new Error($d4c5474a7187c745$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($d4c5474a7187c745$var$COL_GTR_EQ_ZERO);
    const decoded = $d4c5474a7187c745$export$ecd113d4f34af700(map);
    if (line >= decoded.length) return $d4c5474a7187c745$var$OMapping(null, null, null, null);
    const segments = decoded[line];
    const index = $d4c5474a7187c745$var$traceSegmentInternal(segments, $d4c5474a7187c745$var$cast(map)._decodedMemo, line, column, bias || $d4c5474a7187c745$export$4ecd616dce182dff);
    if (index === -1) return $d4c5474a7187c745$var$OMapping(null, null, null, null);
    const segment = segments[index];
    if (segment.length === 1) return $d4c5474a7187c745$var$OMapping(null, null, null, null);
    const { names: names, resolvedSources: resolvedSources } = map;
    return $d4c5474a7187c745$var$OMapping(resolvedSources[segment[$d4c5474a7187c745$var$SOURCES_INDEX]], segment[$d4c5474a7187c745$var$SOURCE_LINE] + 1, segment[$d4c5474a7187c745$var$SOURCE_COLUMN], segment.length === 5 ? names[segment[$d4c5474a7187c745$var$NAMES_INDEX]] : null);
}
function $d4c5474a7187c745$export$5bf80d5312a8ff17(map, needle) {
    const { source: source, line: line, column: column, bias: bias } = needle;
    return $d4c5474a7187c745$var$generatedPosition(map, source, line, column, bias || $d4c5474a7187c745$export$4ecd616dce182dff, false);
}
function $d4c5474a7187c745$export$69d37f329d319dca(map, needle) {
    const { source: source, line: line, column: column, bias: bias } = needle;
    return $d4c5474a7187c745$var$generatedPosition(map, source, line, column, bias || $d4c5474a7187c745$export$b99fbecff261243, true);
}
function $d4c5474a7187c745$export$78c99866f56beaa4(map, cb) {
    const decoded = $d4c5474a7187c745$export$ecd113d4f34af700(map);
    const { names: names, resolvedSources: resolvedSources } = map;
    for(let i = 0; i < decoded.length; i++){
        const line = decoded[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const generatedLine = i + 1;
            const generatedColumn = seg[0];
            let source = null;
            let originalLine = null;
            let originalColumn = null;
            let name = null;
            if (seg.length !== 1) {
                source = resolvedSources[seg[1]];
                originalLine = seg[2] + 1;
                originalColumn = seg[3];
            }
            if (seg.length === 5) name = names[seg[4]];
            cb({
                generatedLine: generatedLine,
                generatedColumn: generatedColumn,
                source: source,
                originalLine: originalLine,
                originalColumn: originalColumn,
                name: name
            });
        }
    }
}
function $d4c5474a7187c745$var$sourceIndex(map, source) {
    const { sources: sources, resolvedSources: resolvedSources } = map;
    let index = sources.indexOf(source);
    if (index === -1) index = resolvedSources.indexOf(source);
    return index;
}
function $d4c5474a7187c745$export$a685fd8184719fc9(map, source) {
    const { sourcesContent: sourcesContent } = map;
    if (sourcesContent == null) return null;
    const index = $d4c5474a7187c745$var$sourceIndex(map, source);
    return index === -1 ? null : sourcesContent[index];
}
function $d4c5474a7187c745$export$ac3f691269cd6d9b(map, source) {
    const { ignoreList: ignoreList } = map;
    if (ignoreList == null) return false;
    const index = $d4c5474a7187c745$var$sourceIndex(map, source);
    return index === -1 ? false : ignoreList.includes(index);
}
function $d4c5474a7187c745$export$20ee0c4a5619bf3d(map, mapUrl) {
    const tracer = new $d4c5474a7187c745$export$6fc8edf86512ec85($d4c5474a7187c745$var$clone(map, []), mapUrl);
    $d4c5474a7187c745$var$cast(tracer)._decoded = map.mappings;
    return tracer;
}
function $d4c5474a7187c745$export$f6477d963c19e792(map) {
    return $d4c5474a7187c745$var$clone(map, $d4c5474a7187c745$export$ecd113d4f34af700(map));
}
function $d4c5474a7187c745$export$f859692979919a94(map) {
    return $d4c5474a7187c745$var$clone(map, $d4c5474a7187c745$export$59408758bba4b625(map));
}
function $d4c5474a7187c745$var$clone(map, mappings) {
    return {
        version: map.version,
        file: map.file,
        names: map.names,
        sourceRoot: map.sourceRoot,
        sources: map.sources,
        sourcesContent: map.sourcesContent,
        mappings: mappings,
        ignoreList: map.ignoreList || map.x_google_ignoreList
    };
}
function $d4c5474a7187c745$var$OMapping(source, line, column, name) {
    return {
        source: source,
        line: line,
        column: column,
        name: name
    };
}
function $d4c5474a7187c745$var$GMapping(line, column) {
    return {
        line: line,
        column: column
    };
}
function $d4c5474a7187c745$var$traceSegmentInternal(segments, memo, line, column, bias) {
    let index = $d4c5474a7187c745$var$memoizedBinarySearch(segments, column, memo, line);
    if ($d4c5474a7187c745$var$found) index = (bias === $d4c5474a7187c745$export$b99fbecff261243 ? $d4c5474a7187c745$var$upperBound : $d4c5474a7187c745$var$lowerBound)(segments, column, index);
    else if (bias === $d4c5474a7187c745$export$b99fbecff261243) index++;
    if (index === -1 || index === segments.length) return -1;
    return index;
}
function $d4c5474a7187c745$var$sliceGeneratedPositions(segments, memo, line, column, bias) {
    let min = $d4c5474a7187c745$var$traceSegmentInternal(segments, memo, line, column, $d4c5474a7187c745$export$4ecd616dce182dff);
    if (!$d4c5474a7187c745$var$found && bias === $d4c5474a7187c745$export$b99fbecff261243) min++;
    if (min === -1 || min === segments.length) return [];
    const matchedColumn = $d4c5474a7187c745$var$found ? column : segments[min][$d4c5474a7187c745$var$COLUMN];
    if (!$d4c5474a7187c745$var$found) min = $d4c5474a7187c745$var$lowerBound(segments, matchedColumn, min);
    const max = $d4c5474a7187c745$var$upperBound(segments, matchedColumn, min);
    const result = [];
    for(; min <= max; min++){
        const segment = segments[min];
        result.push($d4c5474a7187c745$var$GMapping(segment[$d4c5474a7187c745$var$REV_GENERATED_LINE] + 1, segment[$d4c5474a7187c745$var$REV_GENERATED_COLUMN]));
    }
    return result;
}
function $d4c5474a7187c745$var$generatedPosition(map, source, line, column, bias, all) {
    var _a, _b;
    line--;
    if (line < 0) throw new Error($d4c5474a7187c745$var$LINE_GTR_ZERO);
    if (column < 0) throw new Error($d4c5474a7187c745$var$COL_GTR_EQ_ZERO);
    const { sources: sources, resolvedSources: resolvedSources } = map;
    let sourceIndex2 = sources.indexOf(source);
    if (sourceIndex2 === -1) sourceIndex2 = resolvedSources.indexOf(source);
    if (sourceIndex2 === -1) return all ? [] : $d4c5474a7187c745$var$GMapping(null, null);
    const bySourceMemos = (_a = $d4c5474a7187c745$var$cast(map))._bySourceMemos || (_a._bySourceMemos = sources.map($d4c5474a7187c745$var$memoizedState));
    const generated = (_b = $d4c5474a7187c745$var$cast(map))._bySources || (_b._bySources = $d4c5474a7187c745$var$buildBySources($d4c5474a7187c745$export$ecd113d4f34af700(map), bySourceMemos));
    const segments = generated[sourceIndex2][line];
    if (segments == null) return all ? [] : $d4c5474a7187c745$var$GMapping(null, null);
    const memo = bySourceMemos[sourceIndex2];
    if (all) return $d4c5474a7187c745$var$sliceGeneratedPositions(segments, memo, line, column, bias);
    const index = $d4c5474a7187c745$var$traceSegmentInternal(segments, memo, line, column, bias);
    if (index === -1) return $d4c5474a7187c745$var$GMapping(null, null);
    const segment = segments[index];
    return $d4c5474a7187c745$var$GMapping(segment[$d4c5474a7187c745$var$REV_GENERATED_LINE] + 1, segment[$d4c5474a7187c745$var$REV_GENERATED_COLUMN]);
}


var $caaf1b2b3d548c21$var$SetArray = class {
    constructor(){
        this._indexes = {
            __proto__: null
        };
        this.array = [];
    }
};
function $caaf1b2b3d548c21$var$cast(set) {
    return set;
}
function $caaf1b2b3d548c21$var$get(setarr, key) {
    return $caaf1b2b3d548c21$var$cast(setarr)._indexes[key];
}
function $caaf1b2b3d548c21$var$put(setarr, key) {
    const index = $caaf1b2b3d548c21$var$get(setarr, key);
    if (index !== void 0) return index;
    const { array: array, _indexes: indexes } = $caaf1b2b3d548c21$var$cast(setarr);
    const length = array.push(key);
    return indexes[key] = length - 1;
}
function $caaf1b2b3d548c21$var$remove(setarr, key) {
    const index = $caaf1b2b3d548c21$var$get(setarr, key);
    if (index === void 0) return;
    const { array: array, _indexes: indexes } = $caaf1b2b3d548c21$var$cast(setarr);
    for(let i = index + 1; i < array.length; i++){
        const k = array[i];
        array[i - 1] = k;
        indexes[k]--;
    }
    indexes[key] = void 0;
    array.pop();
}
// src/sourcemap-segment.ts
var $caaf1b2b3d548c21$var$COLUMN = 0;
var $caaf1b2b3d548c21$var$SOURCES_INDEX = 1;
var $caaf1b2b3d548c21$var$SOURCE_LINE = 2;
var $caaf1b2b3d548c21$var$SOURCE_COLUMN = 3;
var $caaf1b2b3d548c21$var$NAMES_INDEX = 4;
// src/gen-mapping.ts
var $caaf1b2b3d548c21$var$NO_NAME = -1;
var $caaf1b2b3d548c21$export$92fb4a3d57ca7ec = class {
    constructor({ file: file, sourceRoot: sourceRoot } = {}){
        this._names = new $caaf1b2b3d548c21$var$SetArray();
        this._sources = new $caaf1b2b3d548c21$var$SetArray();
        this._sourcesContent = [];
        this._mappings = [];
        this.file = file;
        this.sourceRoot = sourceRoot;
        this._ignoreList = new $caaf1b2b3d548c21$var$SetArray();
    }
};
function $caaf1b2b3d548c21$var$cast2(map) {
    return map;
}
function $caaf1b2b3d548c21$export$1c43f9ac826b6462(map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    return $caaf1b2b3d548c21$var$addSegmentInternal(false, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
}
function $caaf1b2b3d548c21$export$2d9a54e47969bead(map, mapping) {
    return $caaf1b2b3d548c21$var$addMappingInternal(false, map, mapping);
}
var $caaf1b2b3d548c21$export$bffbcf5bdbbd3679 = (map, genLine, genColumn, source, sourceLine, sourceColumn, name, content)=>{
    return $caaf1b2b3d548c21$var$addSegmentInternal(true, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content);
};
var $caaf1b2b3d548c21$export$6623d26b0c62901b = (map, mapping)=>{
    return $caaf1b2b3d548c21$var$addMappingInternal(true, map, mapping);
};
function $caaf1b2b3d548c21$export$c6155c9e474ba16b(map, source, content) {
    const { _sources: sources, _sourcesContent: sourcesContent } = $caaf1b2b3d548c21$var$cast2(map);
    const index = $caaf1b2b3d548c21$var$put(sources, source);
    sourcesContent[index] = content;
}
function $caaf1b2b3d548c21$export$6db5baaf5ada6795(map, source, ignore = true) {
    const { _sources: sources, _sourcesContent: sourcesContent, _ignoreList: ignoreList } = $caaf1b2b3d548c21$var$cast2(map);
    const index = $caaf1b2b3d548c21$var$put(sources, source);
    if (index === sourcesContent.length) sourcesContent[index] = null;
    if (ignore) $caaf1b2b3d548c21$var$put(ignoreList, index);
    else $caaf1b2b3d548c21$var$remove(ignoreList, index);
}
function $caaf1b2b3d548c21$export$74ae13ad22f29c85(map) {
    const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names, _ignoreList: ignoreList } = $caaf1b2b3d548c21$var$cast2(map);
    $caaf1b2b3d548c21$var$removeEmptyFinalLines(mappings);
    return {
        version: 3,
        file: map.file || void 0,
        names: names.array,
        sourceRoot: map.sourceRoot || void 0,
        sources: sources.array,
        sourcesContent: sourcesContent,
        mappings: mappings,
        // originalScopes,
        // generatedRanges,
        ignoreList: ignoreList.array
    };
}
function $caaf1b2b3d548c21$export$da8de8cfd71f671a(map) {
    const decoded = $caaf1b2b3d548c21$export$74ae13ad22f29c85(map);
    return Object.assign({}, decoded, {
        // originalScopes: decoded.originalScopes.map((os) => encodeOriginalScopes(os)),
        // generatedRanges: encodeGeneratedRanges(decoded.generatedRanges as GeneratedRange[]),
        mappings: (0, $656945f32e31ce93$export$c564cdbbe6da493)(decoded.mappings)
    });
}
function $caaf1b2b3d548c21$export$d81aa96f14f987cc(input) {
    const map = new (0, $d4c5474a7187c745$export$6fc8edf86512ec85)(input);
    const gen = new $caaf1b2b3d548c21$export$92fb4a3d57ca7ec({
        file: map.file,
        sourceRoot: map.sourceRoot
    });
    $caaf1b2b3d548c21$var$putAll($caaf1b2b3d548c21$var$cast2(gen)._names, map.names);
    $caaf1b2b3d548c21$var$putAll($caaf1b2b3d548c21$var$cast2(gen)._sources, map.sources);
    $caaf1b2b3d548c21$var$cast2(gen)._sourcesContent = map.sourcesContent || map.sources.map(()=>null);
    $caaf1b2b3d548c21$var$cast2(gen)._mappings = (0, $d4c5474a7187c745$export$ecd113d4f34af700)(map);
    if (map.ignoreList) $caaf1b2b3d548c21$var$putAll($caaf1b2b3d548c21$var$cast2(gen)._ignoreList, map.ignoreList);
    return gen;
}
function $caaf1b2b3d548c21$export$f06617c6577f8fbd(map) {
    const out = [];
    const { _mappings: mappings, _sources: sources, _names: names } = $caaf1b2b3d548c21$var$cast2(map);
    for(let i = 0; i < mappings.length; i++){
        const line = mappings[i];
        for(let j = 0; j < line.length; j++){
            const seg = line[j];
            const generated = {
                line: i + 1,
                column: seg[$caaf1b2b3d548c21$var$COLUMN]
            };
            let source = void 0;
            let original = void 0;
            let name = void 0;
            if (seg.length !== 1) {
                source = sources.array[seg[$caaf1b2b3d548c21$var$SOURCES_INDEX]];
                original = {
                    line: seg[$caaf1b2b3d548c21$var$SOURCE_LINE] + 1,
                    column: seg[$caaf1b2b3d548c21$var$SOURCE_COLUMN]
                };
                if (seg.length === 5) name = names.array[seg[$caaf1b2b3d548c21$var$NAMES_INDEX]];
            }
            out.push({
                generated: generated,
                source: source,
                original: original,
                name: name
            });
        }
    }
    return out;
}
function $caaf1b2b3d548c21$var$addSegmentInternal(skipable, map, genLine, genColumn, source, sourceLine, sourceColumn, name, content) {
    const { _mappings: mappings, _sources: sources, _sourcesContent: sourcesContent, _names: names } = $caaf1b2b3d548c21$var$cast2(map);
    const line = $caaf1b2b3d548c21$var$getIndex(mappings, genLine);
    const index = $caaf1b2b3d548c21$var$getColumnIndex(line, genColumn);
    if (!source) {
        if (skipable && $caaf1b2b3d548c21$var$skipSourceless(line, index)) return;
        return $caaf1b2b3d548c21$var$insert(line, index, [
            genColumn
        ]);
    }
    $caaf1b2b3d548c21$var$assert(sourceLine);
    $caaf1b2b3d548c21$var$assert(sourceColumn);
    const sourcesIndex = $caaf1b2b3d548c21$var$put(sources, source);
    const namesIndex = name ? $caaf1b2b3d548c21$var$put(names, name) : $caaf1b2b3d548c21$var$NO_NAME;
    if (sourcesIndex === sourcesContent.length) sourcesContent[sourcesIndex] = content != null ? content : null;
    if (skipable && $caaf1b2b3d548c21$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex)) return;
    return $caaf1b2b3d548c21$var$insert(line, index, name ? [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn,
        namesIndex
    ] : [
        genColumn,
        sourcesIndex,
        sourceLine,
        sourceColumn
    ]);
}
function $caaf1b2b3d548c21$var$assert(_val) {}
function $caaf1b2b3d548c21$var$getIndex(arr, index) {
    for(let i = arr.length; i <= index; i++)arr[i] = [];
    return arr[index];
}
function $caaf1b2b3d548c21$var$getColumnIndex(line, genColumn) {
    let index = line.length;
    for(let i = index - 1; i >= 0; index = i--){
        const current = line[i];
        if (genColumn >= current[$caaf1b2b3d548c21$var$COLUMN]) break;
    }
    return index;
}
function $caaf1b2b3d548c21$var$insert(array, index, value) {
    for(let i = array.length; i > index; i--)array[i] = array[i - 1];
    array[index] = value;
}
function $caaf1b2b3d548c21$var$removeEmptyFinalLines(mappings) {
    const { length: length } = mappings;
    let len = length;
    for(let i = len - 1; i >= 0; len = i, i--){
        if (mappings[i].length > 0) break;
    }
    if (len < length) mappings.length = len;
}
function $caaf1b2b3d548c21$var$putAll(setarr, array) {
    for(let i = 0; i < array.length; i++)$caaf1b2b3d548c21$var$put(setarr, array[i]);
}
function $caaf1b2b3d548c21$var$skipSourceless(line, index) {
    if (index === 0) return true;
    const prev = line[index - 1];
    return prev.length === 1;
}
function $caaf1b2b3d548c21$var$skipSource(line, index, sourcesIndex, sourceLine, sourceColumn, namesIndex) {
    if (index === 0) return false;
    const prev = line[index - 1];
    if (prev.length === 1) return false;
    return sourcesIndex === prev[$caaf1b2b3d548c21$var$SOURCES_INDEX] && sourceLine === prev[$caaf1b2b3d548c21$var$SOURCE_LINE] && sourceColumn === prev[$caaf1b2b3d548c21$var$SOURCE_COLUMN] && namesIndex === (prev.length === 5 ? prev[$caaf1b2b3d548c21$var$NAMES_INDEX] : $caaf1b2b3d548c21$var$NO_NAME);
}
function $caaf1b2b3d548c21$var$addMappingInternal(skipable, map, mapping) {
    const { generated: generated, source: source, original: original, name: name, content: content } = mapping;
    if (!source) return $caaf1b2b3d548c21$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, null, null, null, null, null);
    $caaf1b2b3d548c21$var$assert(original);
    return $caaf1b2b3d548c21$var$addSegmentInternal(skipable, map, generated.line - 1, generated.column, source, original.line - 1, original.column, name, content);
}



function $9cb824f031f73e03$export$2e2bcd8739ae039({ code: generatedCode, mappings: rawMappings }, filePath, options, source, tokens) {
    const sourceColumns = $9cb824f031f73e03$var$computeSourceColumns(source, tokens);
    const map = new (0, $caaf1b2b3d548c21$export$92fb4a3d57ca7ec)({
        file: options.compiledFilename
    });
    let tokenIndex = 0;
    // currentMapping is the output source index for the current input token being
    // considered.
    let currentMapping = rawMappings[0];
    while(currentMapping === undefined && tokenIndex < rawMappings.length - 1){
        tokenIndex++;
        currentMapping = rawMappings[tokenIndex];
    }
    let line = 0;
    let lineStart = 0;
    if (currentMapping !== lineStart) (0, $caaf1b2b3d548c21$export$bffbcf5bdbbd3679)(map, line, 0, filePath, line, 0);
    for(let i = 0; i < generatedCode.length; i++){
        if (i === currentMapping) {
            const genColumn = currentMapping - lineStart;
            const sourceColumn = sourceColumns[tokenIndex];
            (0, $caaf1b2b3d548c21$export$bffbcf5bdbbd3679)(map, line, genColumn, filePath, line, sourceColumn);
            while((currentMapping === i || currentMapping === undefined) && tokenIndex < rawMappings.length - 1){
                tokenIndex++;
                currentMapping = rawMappings[tokenIndex];
            }
        }
        if (generatedCode.charCodeAt(i) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed) {
            line++;
            lineStart = i + 1;
            if (currentMapping !== lineStart) (0, $caaf1b2b3d548c21$export$bffbcf5bdbbd3679)(map, line, 0, filePath, line, 0);
        }
    }
    const { sourceRoot: sourceRoot, sourcesContent: sourcesContent, ...sourceMap } = (0, $caaf1b2b3d548c21$export$da8de8cfd71f671a)(map);
    return sourceMap;
}
/**
 * Create an array mapping each token index to the 0-based column of the start
 * position of the token.
 */ function $9cb824f031f73e03$var$computeSourceColumns(code, tokens) {
    const sourceColumns = new Array(tokens.length);
    let tokenIndex = 0;
    let currentMapping = tokens[tokenIndex].start;
    let lineStart = 0;
    for(let i = 0; i < code.length; i++){
        if (i === currentMapping) {
            sourceColumns[tokenIndex] = currentMapping - lineStart;
            tokenIndex++;
            currentMapping = tokens[tokenIndex].start;
        }
        if (code.charCodeAt(i) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed) lineStart = i + 1;
    }
    return sourceColumns;
}


const $b7aa5fc22eb1b7f3$var$HELPERS = {
    require: `
    import {createRequire as CREATE_REQUIRE_NAME} from "module";
    const require = CREATE_REQUIRE_NAME(import.meta.url);
  `,
    interopRequireWildcard: `
    function interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};
        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              newObj[key] = obj[key];
            }
          }
        }
        newObj.default = obj;
        return newObj;
      }
    }
  `,
    interopRequireDefault: `
    function interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : { default: obj };
    }
  `,
    createNamedExportFrom: `
    function createNamedExportFrom(obj, localName, importedName) {
      Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]});
    }
  `,
    // Note that TypeScript and Babel do this differently; TypeScript does a simple existence
    // check in the exports object and does a plain assignment, whereas Babel uses
    // defineProperty and builds an object of explicitly-exported names so that star exports can
    // always take lower precedence. For now, we do the easier TypeScript thing.
    createStarExport: `
    function createStarExport(obj) {
      Object.keys(obj)
        .filter((key) => key !== "default" && key !== "__esModule")
        .forEach((key) => {
          if (exports.hasOwnProperty(key)) {
            return;
          }
          Object.defineProperty(exports, key, {enumerable: true, configurable: true, get: () => obj[key]});
        });
    }
  `,
    nullishCoalesce: `
    function nullishCoalesce(lhs, rhsFn) {
      if (lhs != null) {
        return lhs;
      } else {
        return rhsFn();
      }
    }
  `,
    asyncNullishCoalesce: `
    async function asyncNullishCoalesce(lhs, rhsFn) {
      if (lhs != null) {
        return lhs;
      } else {
        return await rhsFn();
      }
    }
  `,
    optionalChain: `
    function optionalChain(ops) {
      let lastAccessLHS = undefined;
      let value = ops[0];
      let i = 1;
      while (i < ops.length) {
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
          return undefined;
        }
        if (op === 'access' || op === 'optionalAccess') {
          lastAccessLHS = value;
          value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
          value = fn((...args) => value.call(lastAccessLHS, ...args));
          lastAccessLHS = undefined;
        }
      }
      return value;
    }
  `,
    asyncOptionalChain: `
    async function asyncOptionalChain(ops) {
      let lastAccessLHS = undefined;
      let value = ops[0];
      let i = 1;
      while (i < ops.length) {
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
          return undefined;
        }
        if (op === 'access' || op === 'optionalAccess') {
          lastAccessLHS = value;
          value = await fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
          value = await fn((...args) => value.call(lastAccessLHS, ...args));
          lastAccessLHS = undefined;
        }
      }
      return value;
    }
  `,
    optionalChainDelete: `
    function optionalChainDelete(ops) {
      const result = OPTIONAL_CHAIN_NAME(ops);
      return result == null ? true : result;
    }
  `,
    asyncOptionalChainDelete: `
    async function asyncOptionalChainDelete(ops) {
      const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);
      return result == null ? true : result;
    }
  `
};
class $b7aa5fc22eb1b7f3$export$b203ad16abdeb845 {
    __init() {
        this.helperNames = {};
    }
    __init2() {
        this.createRequireName = null;
    }
    constructor(nameManager){
        this.nameManager = nameManager;
        $b7aa5fc22eb1b7f3$export$b203ad16abdeb845.prototype.__init.call(this);
        $b7aa5fc22eb1b7f3$export$b203ad16abdeb845.prototype.__init2.call(this);
    }
    getHelperName(baseName) {
        let helperName = this.helperNames[baseName];
        if (helperName) return helperName;
        helperName = this.nameManager.claimFreeName(`_${baseName}`);
        this.helperNames[baseName] = helperName;
        return helperName;
    }
    emitHelpers() {
        let resultCode = "";
        if (this.helperNames.optionalChainDelete) this.getHelperName("optionalChain");
        if (this.helperNames.asyncOptionalChainDelete) this.getHelperName("asyncOptionalChain");
        for (const [baseName, helperCodeTemplate] of Object.entries($b7aa5fc22eb1b7f3$var$HELPERS)){
            const helperName = this.helperNames[baseName];
            let helperCode = helperCodeTemplate;
            if (baseName === "optionalChainDelete") helperCode = helperCode.replace("OPTIONAL_CHAIN_NAME", this.helperNames.optionalChain);
            else if (baseName === "asyncOptionalChainDelete") helperCode = helperCode.replace("ASYNC_OPTIONAL_CHAIN_NAME", this.helperNames.asyncOptionalChain);
            else if (baseName === "require") {
                if (this.createRequireName === null) this.createRequireName = this.nameManager.claimFreeName("_createRequire");
                helperCode = helperCode.replace(/CREATE_REQUIRE_NAME/g, this.createRequireName);
            }
            if (helperName) {
                resultCode += " ";
                resultCode += helperCode.replace(baseName, helperName).replace(/\s+/g, " ").trim();
            }
        }
        return resultCode;
    }
}




function $f280165de0013836$export$2e2bcd8739ae039(tokens, scopes, globalNames) {
    if (!$f280165de0013836$export$c1aa0d0852b733f5(tokens, globalNames)) return;
    $f280165de0013836$var$markShadowedGlobals(tokens, scopes, globalNames);
}
function $f280165de0013836$export$c1aa0d0852b733f5(tokens, globalNames) {
    for (const token of tokens.tokens){
        if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name && !token.isType && (0, $d45b756a11a5dc19$export$268f8ae8b035d918)(token) && globalNames.has(tokens.identifierNameForToken(token))) return true;
    }
    return false;
}
function $f280165de0013836$var$markShadowedGlobals(tokens, scopes, globalNames) {
    const scopeStack = [];
    let scopeIndex = scopes.length - 1;
    // Scopes were generated at completion time, so they're sorted by end index, so we can maintain a
    // good stack by going backwards through them.
    for(let i = tokens.tokens.length - 1;; i--){
        while(scopeStack.length > 0 && scopeStack[scopeStack.length - 1].startTokenIndex === i + 1)scopeStack.pop();
        while(scopeIndex >= 0 && scopes[scopeIndex].endTokenIndex === i + 1){
            scopeStack.push(scopes[scopeIndex]);
            scopeIndex--;
        }
        // Process scopes after the last iteration so we can make sure we pop all of them.
        if (i < 0) break;
        const token = tokens.tokens[i];
        const name = tokens.identifierNameForToken(token);
        if (scopeStack.length > 1 && !token.isType && token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name && globalNames.has(name)) {
            if ((0, $d45b756a11a5dc19$export$6aae06a56367d123)(token)) $f280165de0013836$var$markShadowedForScope(scopeStack[scopeStack.length - 1], tokens, name);
            else if ((0, $d45b756a11a5dc19$export$157aa1605fc4e080)(token)) {
                let stackIndex = scopeStack.length - 1;
                while(stackIndex > 0 && !scopeStack[stackIndex].isFunctionScope)stackIndex--;
                if (stackIndex < 0) throw new Error("Did not find parent function scope.");
                $f280165de0013836$var$markShadowedForScope(scopeStack[stackIndex], tokens, name);
            }
        }
    }
    if (scopeStack.length > 0) throw new Error("Expected empty scope stack after processing file.");
}
function $f280165de0013836$var$markShadowedForScope(scope, tokens, name) {
    for(let i = scope.startTokenIndex; i < scope.endTokenIndex; i++){
        const token = tokens.tokens[i];
        if ((token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name || token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName) && tokens.identifierNameForToken(token) === name) token.shadowsGlobal = true;
    }
}



function $909b36bc9f5287f9$export$2e2bcd8739ae039(code, tokens) {
    const names = [];
    for (const token of tokens)if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name) names.push(code.slice(token.start, token.end));
    return names;
}


class $f08dedf1f2b42140$export$2e2bcd8739ae039 {
    __init() {
        this.usedNames = new Set();
    }
    constructor(code, tokens){
        $f08dedf1f2b42140$export$2e2bcd8739ae039.prototype.__init.call(this);
        this.usedNames = new Set((0, $909b36bc9f5287f9$export$2e2bcd8739ae039)(code, tokens));
    }
    claimFreeName(name) {
        const newName = this.findFreeName(name);
        this.usedNames.add(newName);
        return newName;
    }
    findFreeName(name) {
        if (!this.usedNames.has(name)) return name;
        let suffixNum = 2;
        while(this.usedNames.has(name + String(suffixNum)))suffixNum++;
        return name + String(suffixNum);
    }
}


var $3401dcd38b59f9cc$exports = {};
"use strict";
var $3401dcd38b59f9cc$var$__spreadArrays = $3401dcd38b59f9cc$exports && $3401dcd38b59f9cc$exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty($3401dcd38b59f9cc$exports, "__esModule", {
    value: true
});
$3401dcd38b59f9cc$exports.Checker = $3401dcd38b59f9cc$exports.createCheckers = void 0;

var $eNO5q = parcelRequire("eNO5q");

var $ghIyI = parcelRequire("ghIyI");

var $eNO5q = parcelRequire("eNO5q");
Object.defineProperty($3401dcd38b59f9cc$exports, "TArray", {
    enumerable: true,
    get: function() {
        return $eNO5q.TArray;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TEnumType", {
    enumerable: true,
    get: function() {
        return $eNO5q.TEnumType;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TEnumLiteral", {
    enumerable: true,
    get: function() {
        return $eNO5q.TEnumLiteral;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TFunc", {
    enumerable: true,
    get: function() {
        return $eNO5q.TFunc;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TIface", {
    enumerable: true,
    get: function() {
        return $eNO5q.TIface;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TLiteral", {
    enumerable: true,
    get: function() {
        return $eNO5q.TLiteral;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TName", {
    enumerable: true,
    get: function() {
        return $eNO5q.TName;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TOptional", {
    enumerable: true,
    get: function() {
        return $eNO5q.TOptional;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TParam", {
    enumerable: true,
    get: function() {
        return $eNO5q.TParam;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TParamList", {
    enumerable: true,
    get: function() {
        return $eNO5q.TParamList;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TProp", {
    enumerable: true,
    get: function() {
        return $eNO5q.TProp;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TTuple", {
    enumerable: true,
    get: function() {
        return $eNO5q.TTuple;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TType", {
    enumerable: true,
    get: function() {
        return $eNO5q.TType;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TUnion", {
    enumerable: true,
    get: function() {
        return $eNO5q.TUnion;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "TIntersection", {
    enumerable: true,
    get: function() {
        return $eNO5q.TIntersection;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "array", {
    enumerable: true,
    get: function() {
        return $eNO5q.array;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "enumlit", {
    enumerable: true,
    get: function() {
        return $eNO5q.enumlit;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "enumtype", {
    enumerable: true,
    get: function() {
        return $eNO5q.enumtype;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "func", {
    enumerable: true,
    get: function() {
        return $eNO5q.func;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "iface", {
    enumerable: true,
    get: function() {
        return $eNO5q.iface;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "lit", {
    enumerable: true,
    get: function() {
        return $eNO5q.lit;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "name", {
    enumerable: true,
    get: function() {
        return $eNO5q.name;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "opt", {
    enumerable: true,
    get: function() {
        return $eNO5q.opt;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "param", {
    enumerable: true,
    get: function() {
        return $eNO5q.param;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "tuple", {
    enumerable: true,
    get: function() {
        return $eNO5q.tuple;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "union", {
    enumerable: true,
    get: function() {
        return $eNO5q.union;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "intersection", {
    enumerable: true,
    get: function() {
        return $eNO5q.intersection;
    }
});
Object.defineProperty($3401dcd38b59f9cc$exports, "BasicType", {
    enumerable: true,
    get: function() {
        return $eNO5q.BasicType;
    }
});

var $ghIyI = parcelRequire("ghIyI");
Object.defineProperty($3401dcd38b59f9cc$exports, "VError", {
    enumerable: true,
    get: function() {
        return $ghIyI.VError;
    }
});
/**
 * Takes one of more type suites (e.g. a module generated by `ts-interface-builder`), and combines
 * them into a suite of interface checkers. If a type is used by name, that name should be present
 * among the passed-in type suites.
 *
 * The returned object maps type names to Checker objects.
 */ function $3401dcd38b59f9cc$var$createCheckers() {
    var typeSuite = [];
    for(var _i = 0; _i < arguments.length; _i++)typeSuite[_i] = arguments[_i];
    var fullSuite = Object.assign.apply(Object, $3401dcd38b59f9cc$var$__spreadArrays([
        {},
        $eNO5q.basicTypes
    ], typeSuite));
    var checkers = {};
    for(var _a = 0, typeSuite_1 = typeSuite; _a < typeSuite_1.length; _a++){
        var suite_1 = typeSuite_1[_a];
        for(var _b = 0, _c = Object.keys(suite_1); _b < _c.length; _b++){
            var name = _c[_b];
            checkers[name] = new $3401dcd38b59f9cc$var$Checker(fullSuite, suite_1[name]);
        }
    }
    return checkers;
}
$3401dcd38b59f9cc$exports.createCheckers = $3401dcd38b59f9cc$var$createCheckers;
/**
 * Checker implements validation of objects, and also includes accessors to validate method calls.
 * Checkers should be created using `createCheckers()`.
 */ var $3401dcd38b59f9cc$var$Checker = /** @class */ function() {
    // Create checkers by using `createCheckers()` function.
    function Checker(suite, ttype, _path) {
        if (_path === void 0) _path = 'value';
        this.suite = suite;
        this.ttype = ttype;
        this._path = _path;
        this.props = new Map();
        if (ttype instanceof $eNO5q.TIface) for(var _i = 0, _a = ttype.props; _i < _a.length; _i++){
            var p = _a[_i];
            this.props.set(p.name, p.ttype);
        }
        this.checkerPlain = this.ttype.getChecker(suite, false);
        this.checkerStrict = this.ttype.getChecker(suite, true);
    }
    /**
     * Set the path to report in errors, instead of the default "value". (E.g. if the Checker is for
     * a "person" interface, set path to "person" to report e.g. "person.name is not a string".)
     */ Checker.prototype.setReportedPath = function(path) {
        this._path = path;
    };
    /**
     * Check that the given value satisfies this checker's type, or throw Error.
     */ Checker.prototype.check = function(value) {
        return this._doCheck(this.checkerPlain, value);
    };
    /**
     * A fast check for whether or not the given value satisfies this Checker's type. This returns
     * true or false, does not produce an error message, and is fast both on success and on failure.
     */ Checker.prototype.test = function(value) {
        return this.checkerPlain(value, new $ghIyI.NoopContext());
    };
    /**
     * Returns an error object describing the errors if the given value does not satisfy this
     * Checker's type, or null if it does.
     */ Checker.prototype.validate = function(value) {
        return this._doValidate(this.checkerPlain, value);
    };
    /**
     * Check that the given value satisfies this checker's type strictly. This checks that objects
     * and tuples have no extra members. Note that this prevents backward compatibility, so usually
     * a plain check() is more appropriate.
     */ Checker.prototype.strictCheck = function(value) {
        return this._doCheck(this.checkerStrict, value);
    };
    /**
     * A fast strict check for whether or not the given value satisfies this Checker's type. Returns
     * true or false, does not produce an error message, and is fast both on success and on failure.
     */ Checker.prototype.strictTest = function(value) {
        return this.checkerStrict(value, new $ghIyI.NoopContext());
    };
    /**
     * Returns an error object describing the errors if the given value does not satisfy this
     * Checker's type strictly, or null if it does.
     */ Checker.prototype.strictValidate = function(value) {
        return this._doValidate(this.checkerStrict, value);
    };
    /**
     * If this checker is for an interface, returns a Checker for the type required for the given
     * property of this interface.
     */ Checker.prototype.getProp = function(prop) {
        var ttype = this.props.get(prop);
        if (!ttype) throw new Error("Type has no property " + prop);
        return new Checker(this.suite, ttype, this._path + "." + prop);
    };
    /**
     * If this checker is for an interface, returns a Checker for the argument-list required to call
     * the given method of this interface. E.g. if this Checker is for the interface:
     *    interface Foo {
     *      find(s: string, pos?: number): number;
     *    }
     * Then methodArgs("find").check(...) will succeed for ["foo"] and ["foo", 3], but not for [17].
     */ Checker.prototype.methodArgs = function(methodName) {
        var tfunc = this._getMethod(methodName);
        return new Checker(this.suite, tfunc.paramList);
    };
    /**
     * If this checker is for an interface, returns a Checker for the return value of the given
     * method of this interface.
     */ Checker.prototype.methodResult = function(methodName) {
        var tfunc = this._getMethod(methodName);
        return new Checker(this.suite, tfunc.result);
    };
    /**
     * If this checker is for a function, returns a Checker for its argument-list.
     */ Checker.prototype.getArgs = function() {
        if (!(this.ttype instanceof $eNO5q.TFunc)) throw new Error("getArgs() applied to non-function");
        return new Checker(this.suite, this.ttype.paramList);
    };
    /**
     * If this checker is for a function, returns a Checker for its result.
     */ Checker.prototype.getResult = function() {
        if (!(this.ttype instanceof $eNO5q.TFunc)) throw new Error("getResult() applied to non-function");
        return new Checker(this.suite, this.ttype.result);
    };
    /**
     * Return the type for which this is a checker.
     */ Checker.prototype.getType = function() {
        return this.ttype;
    };
    /**
     * Actual implementation of check() and strictCheck().
     */ Checker.prototype._doCheck = function(checkerFunc, value) {
        var noopCtx = new $ghIyI.NoopContext();
        if (!checkerFunc(value, noopCtx)) {
            var detailCtx = new $ghIyI.DetailContext();
            checkerFunc(value, detailCtx);
            throw detailCtx.getError(this._path);
        }
    };
    Checker.prototype._doValidate = function(checkerFunc, value) {
        var noopCtx = new $ghIyI.NoopContext();
        if (checkerFunc(value, noopCtx)) return null;
        var detailCtx = new $ghIyI.DetailContext();
        checkerFunc(value, detailCtx);
        return detailCtx.getErrorDetail(this._path);
    };
    Checker.prototype._getMethod = function(methodName) {
        var ttype = this.props.get(methodName);
        if (!ttype) throw new Error("Type has no property " + methodName);
        if (!(ttype instanceof $eNO5q.TFunc)) throw new Error("Property " + methodName + " is not a method");
        return ttype;
    };
    return Checker;
}();
$3401dcd38b59f9cc$exports.Checker = $3401dcd38b59f9cc$var$Checker;


/**
 * This module was automatically generated by `ts-interface-builder`
 */ 
const $6399905efc4f2228$export$563a914cafbdc389 = $3401dcd38b59f9cc$exports.union($3401dcd38b59f9cc$exports.lit("jsx"), $3401dcd38b59f9cc$exports.lit("typescript"), $3401dcd38b59f9cc$exports.lit("flow"), $3401dcd38b59f9cc$exports.lit("imports"), $3401dcd38b59f9cc$exports.lit("react-hot-loader"), $3401dcd38b59f9cc$exports.lit("jest"));
const $6399905efc4f2228$export$6314eb8a2e5cb73e = $3401dcd38b59f9cc$exports.iface([], {
    compiledFilename: "string"
});
const $6399905efc4f2228$export$c019608e5b5bb4cb = $3401dcd38b59f9cc$exports.iface([], {
    transforms: $3401dcd38b59f9cc$exports.array("Transform"),
    disableESTransforms: $3401dcd38b59f9cc$exports.opt("boolean"),
    jsxRuntime: $3401dcd38b59f9cc$exports.opt($3401dcd38b59f9cc$exports.union($3401dcd38b59f9cc$exports.lit("classic"), $3401dcd38b59f9cc$exports.lit("automatic"), $3401dcd38b59f9cc$exports.lit("preserve"))),
    production: $3401dcd38b59f9cc$exports.opt("boolean"),
    jsxImportSource: $3401dcd38b59f9cc$exports.opt("string"),
    jsxPragma: $3401dcd38b59f9cc$exports.opt("string"),
    jsxFragmentPragma: $3401dcd38b59f9cc$exports.opt("string"),
    keepUnusedImports: $3401dcd38b59f9cc$exports.opt("boolean"),
    preserveDynamicImport: $3401dcd38b59f9cc$exports.opt("boolean"),
    injectCreateRequireForImportRequire: $3401dcd38b59f9cc$exports.opt("boolean"),
    enableLegacyTypeScriptModuleInterop: $3401dcd38b59f9cc$exports.opt("boolean"),
    enableLegacyBabel5ModuleInterop: $3401dcd38b59f9cc$exports.opt("boolean"),
    sourceMapOptions: $3401dcd38b59f9cc$exports.opt("SourceMapOptions"),
    filePath: $3401dcd38b59f9cc$exports.opt("string")
});
const $6399905efc4f2228$var$exportedTypeSuite = {
    Transform: $6399905efc4f2228$export$563a914cafbdc389,
    SourceMapOptions: $6399905efc4f2228$export$6314eb8a2e5cb73e,
    Options: $6399905efc4f2228$export$c019608e5b5bb4cb
};
var $6399905efc4f2228$export$2e2bcd8739ae039 = $6399905efc4f2228$var$exportedTypeSuite;


const { Options: $6af1ca2bc9e09530$var$OptionsChecker } = (0, $3401dcd38b59f9cc$exports.createCheckers)((0, $6399905efc4f2228$export$2e2bcd8739ae039));
function $6af1ca2bc9e09530$export$1dd09873c1bdd0fc(options) {
    $6af1ca2bc9e09530$var$OptionsChecker.strictCheck(options);
}






/* eslint max-len: 0 */ 
/* eslint max-len: 0 */ 



/* eslint max-len: 0 */ // A recursive descent parser operates by defining functions for all
// syntactic elements, and recursively calling those, each function
// advancing the input stream and returning an AST node. Precedence
// of constructs (for example, the fact that `!x[1]` means `!(x[1])`
// instead of `(!x)[1]` is handled by the fact that the parser
// function that parses unary prefix operators is called first, and
// in turn calls the function that parses `[]` subscripts — that
// way, it'll receive the node for `x[1]` already parsed, and wraps
// *that* in the unary operator node.
//
// Acorn uses an [operator precedence parser][opp] to handle binary
// operator precedence, because it is much more compact than using
// the technique outlined above, which uses different, nesting
// functions to specify precedence, for all of the ten binary
// precedence levels that JavaScript defines.
//
// [opp]: http://en.wikipedia.org/wiki/Operator-precedence_parser





















function $24b5f7a89f6adf6c$export$83bfd0877be8807a() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $33716cdef222842d$export$b97bbe8a7805284f)(false);
}
function $24b5f7a89f6adf6c$export$9504bd2748b5750c(isBlockScope) {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $24b5f7a89f6adf6c$export$e1f90e6766854abd(isBlockScope);
}
function $24b5f7a89f6adf6c$export$7538cb03fa894c83(isBlockScope) {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    $24b5f7a89f6adf6c$export$80e4117797ed03a6(isBlockScope);
}
function $24b5f7a89f6adf6c$export$cba413304e86fc0d() {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportDeclaration;
}
function $24b5f7a89f6adf6c$export$80e4117797ed03a6(isBlockScope) {
    let identifierRole;
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth === 0) identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).TopLevelDeclaration;
    else if (isBlockScope) identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).BlockScopedDeclaration;
    else identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).FunctionScopedDeclaration;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
}
function $24b5f7a89f6adf6c$export$e1f90e6766854abd(isBlockScope) {
    switch((0, $d9d7db628df75264$export$ca000e230c0caa3e).type){
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._this:
            {
                // In TypeScript, "this" may be the name of a parameter, so allow it.
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return;
            }
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._yield:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).name:
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).type = (0, $c455753917f2f29d$export$f435f793048e7a0f).name;
            $24b5f7a89f6adf6c$export$7538cb03fa894c83(isBlockScope);
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            $24b5f7a89f6adf6c$export$befa6d966a25698e((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR, isBlockScope, true);
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL:
            (0, $33716cdef222842d$export$908e61e44ae774e)(true, isBlockScope);
            return;
        default:
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    }
}
function $24b5f7a89f6adf6c$export$befa6d966a25698e(close, isBlockScope, allowEmpty = false, allowModifiers = false, contextId = 0) {
    let first = true;
    let hasRemovedComma = false;
    const firstItemTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)(close) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
            // After a "this" type in TypeScript, we need to set the following comma (if any) to also be
            // a type token so that it will be removed.
            if (!hasRemovedComma && (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[firstItemTokenIndex].isType) {
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
                hasRemovedComma = true;
            }
        }
        if (allowEmpty && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) ;
        else if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)(close)) break;
        else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) {
            $24b5f7a89f6adf6c$export$9504bd2748b5750c(isBlockScope);
            $24b5f7a89f6adf6c$var$parseAssignableListItemTypes();
            // Support rest element trailing commas allowed by TypeScript <2.9.
            (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)(close);
            break;
        } else $24b5f7a89f6adf6c$var$parseAssignableListItem(allowModifiers, isBlockScope);
    }
}
function $24b5f7a89f6adf6c$var$parseAssignableListItem(allowModifiers, isBlockScope) {
    if (allowModifiers) (0, $e018f01e7ae86c9a$export$77616e6d401f584a)([
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._public,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._protected,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._private,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._override
    ]);
    $24b5f7a89f6adf6c$export$867fe1bcec5186c9(isBlockScope);
    $24b5f7a89f6adf6c$var$parseAssignableListItemTypes();
    $24b5f7a89f6adf6c$export$867fe1bcec5186c9(isBlockScope, true);
}
function $24b5f7a89f6adf6c$var$parseAssignableListItemTypes() {
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$a9031cdcb39989e3)();
    else if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$9b46e2c9fd90d888)();
}
function $24b5f7a89f6adf6c$export$867fe1bcec5186c9(isBlockScope, leftAlreadyParsed = false) {
    if (!leftAlreadyParsed) $24b5f7a89f6adf6c$export$e1f90e6766854abd(isBlockScope);
    if (!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) return;
    const eqIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1;
    (0, $33716cdef222842d$export$b97bbe8a7805284f)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
}





function $e018f01e7ae86c9a$var$tsIsIdentifier() {
    // TODO: actually a bit more complex in TypeScript, but shouldn't matter.
    // See https://github.com/Microsoft/TypeScript/issues/15008
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
}
function $e018f01e7ae86c9a$var$isLiteralPropertyName() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || Boolean((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_KEYWORD) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).num) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bigint) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).decimal);
}
function $e018f01e7ae86c9a$var$tsNextTokenCanFollowModifier() {
    // Note: TypeScript's implementation is much more complicated because
    // more things are considered modifiers there.
    // This implementation only handles modifiers not handled by babylon itself. And "static".
    // TODO: Would be nice to avoid lookahead. Want a hasLineBreakUpNext() method...
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    const canFollowModifier = ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).hash) || $e018f01e7ae86c9a$var$isLiteralPropertyName()) && !(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)();
    if (canFollowModifier) return true;
    else {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
}
function $e018f01e7ae86c9a$export$77616e6d401f584a(allowedModifiers) {
    while(true){
        const modifier = $e018f01e7ae86c9a$export$a90a97ddca783020(allowedModifiers);
        if (modifier === null) break;
    }
}
function $e018f01e7ae86c9a$export$a90a97ddca783020(allowedModifiers) {
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) return null;
    const modifier = (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword;
    if (allowedModifiers.indexOf(modifier) !== -1 && $e018f01e7ae86c9a$var$tsNextTokenCanFollowModifier()) {
        switch(modifier){
            case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly:
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._readonly;
                break;
            case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._abstract:
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract;
                break;
            case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._static:
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._static;
                break;
            case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._public:
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._public;
                break;
            case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._private:
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._private;
                break;
            case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._protected:
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._protected;
                break;
            case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._override:
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._override;
                break;
            case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._declare:
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._declare;
                break;
            default:
                break;
        }
        return modifier;
    }
    return null;
}
function $e018f01e7ae86c9a$var$tsParseEntityName() {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    while((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot))(0, $33716cdef222842d$export$321543c11f6250ad)();
}
function $e018f01e7ae86c9a$var$tsParseTypeReference() {
    $e018f01e7ae86c9a$var$tsParseEntityName();
    if (!(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)() && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $e018f01e7ae86c9a$var$tsParseTypeArguments();
}
function $e018f01e7ae86c9a$var$tsParseThisTypePredicate() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $e018f01e7ae86c9a$export$728a3256ac690042();
}
function $e018f01e7ae86c9a$var$tsParseThisTypeNode() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
}
function $e018f01e7ae86c9a$var$tsParseTypeQuery() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._typeof);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._import)) $e018f01e7ae86c9a$var$tsParseImportType();
    else $e018f01e7ae86c9a$var$tsParseEntityName();
    if (!(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)() && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $e018f01e7ae86c9a$var$tsParseTypeArguments();
}
function $e018f01e7ae86c9a$var$tsParseImportType() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._import);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).string);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) $e018f01e7ae86c9a$var$tsParseEntityName();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $e018f01e7ae86c9a$var$tsParseTypeArguments();
}
function $e018f01e7ae86c9a$var$tsParseTypeParameter() {
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._const);
    const hadIn = (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._in);
    const hadOut = (0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._out);
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._const);
    if ((hadIn || hadOut) && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) // The "in" or "out" keyword must have actually been the type parameter
    // name, so set it as the name.
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f).name;
    else (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends)) $e018f01e7ae86c9a$export$13a289e680c077c1();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) $e018f01e7ae86c9a$export$13a289e680c077c1();
}
function $e018f01e7ae86c9a$export$827faab4e65d5897() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $e018f01e7ae86c9a$var$tsParseTypeParameters();
}
function $e018f01e7ae86c9a$var$tsParseTypeParameters() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).typeParameterStart)) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    else (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        $e018f01e7ae86c9a$var$tsParseTypeParameter();
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
// Note: In TypeScript implementation we must provide `yieldContext` and `awaitContext`,
// but here it's always false, because this is only used for types.
function $e018f01e7ae86c9a$var$tsFillSignature(returnToken) {
    // Arrow fns *must* have return token (`=>`). Normal functions can omit it.
    const returnTokenRequired = returnToken === (0, $c455753917f2f29d$export$f435f793048e7a0f).arrow;
    $e018f01e7ae86c9a$export$827faab4e65d5897();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    // Create a scope even though we're doing type parsing so we don't accidentally
    // treat params as top-level bindings.
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
    $e018f01e7ae86c9a$var$tsParseBindingListForSignature(false);
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
    if (returnTokenRequired) $e018f01e7ae86c9a$var$tsParseTypeOrTypePredicateAnnotation(returnToken);
    else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)(returnToken)) $e018f01e7ae86c9a$var$tsParseTypeOrTypePredicateAnnotation(returnToken);
}
function $e018f01e7ae86c9a$var$tsParseBindingListForSignature(isBlockScope) {
    (0, $24b5f7a89f6adf6c$export$befa6d966a25698e)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR, isBlockScope);
}
function $e018f01e7ae86c9a$var$tsParseTypeMemberSemicolon() {
    if (!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $e018f01e7ae86c9a$var$tsParseSignatureMember() {
    $e018f01e7ae86c9a$var$tsFillSignature((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    $e018f01e7ae86c9a$var$tsParseTypeMemberSemicolon();
}
function $e018f01e7ae86c9a$var$tsIsUnambiguouslyIndexSignature() {
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)(); // Skip '{'
    const isIndexSignature = (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isIndexSignature;
}
function $e018f01e7ae86c9a$var$tsTryParseIndexSignature() {
    if (!((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL) && $e018f01e7ae86c9a$var$tsIsUnambiguouslyIndexSignature())) return false;
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL);
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    $e018f01e7ae86c9a$export$728a3256ac690042();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
    $e018f01e7ae86c9a$export$e4623eb563192e0f();
    $e018f01e7ae86c9a$var$tsParseTypeMemberSemicolon();
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    return true;
}
function $e018f01e7ae86c9a$var$tsParsePropertyOrMethodSignature(isReadonly) {
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    if (!isReadonly && ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan))) {
        $e018f01e7ae86c9a$var$tsFillSignature((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
        $e018f01e7ae86c9a$var$tsParseTypeMemberSemicolon();
    } else {
        $e018f01e7ae86c9a$export$e4623eb563192e0f();
        $e018f01e7ae86c9a$var$tsParseTypeMemberSemicolon();
    }
}
function $e018f01e7ae86c9a$var$tsParseTypeMember() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
        // call signature
        $e018f01e7ae86c9a$var$tsParseSignatureMember();
        return;
    }
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._new)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) // constructor signature
        $e018f01e7ae86c9a$var$tsParseSignatureMember();
        else $e018f01e7ae86c9a$var$tsParsePropertyOrMethodSignature(false);
        return;
    }
    const readonly = !!$e018f01e7ae86c9a$export$a90a97ddca783020([
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly
    ]);
    const found = $e018f01e7ae86c9a$var$tsTryParseIndexSignature();
    if (found) return;
    ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._get) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._set)) && $e018f01e7ae86c9a$var$tsNextTokenCanFollowModifier();
    (0, $33716cdef222842d$export$ab65037f9c8fb3d3)(-1 /* Types don't need context IDs. */ );
    $e018f01e7ae86c9a$var$tsParsePropertyOrMethodSignature(readonly);
}
function $e018f01e7ae86c9a$var$tsParseTypeLiteral() {
    $e018f01e7ae86c9a$var$tsParseObjectTypeMembers();
}
function $e018f01e7ae86c9a$var$tsParseObjectTypeMembers() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error)$e018f01e7ae86c9a$var$tsParseTypeMember();
}
function $e018f01e7ae86c9a$var$tsLookaheadIsStartOfMappedType() {
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    const isStartOfMappedType = $e018f01e7ae86c9a$var$tsIsStartOfMappedType();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isStartOfMappedType;
}
function $e018f01e7ae86c9a$var$tsIsStartOfMappedType() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).plus) || (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).minus)) return (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly);
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly)) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) return false;
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if (!$e018f01e7ae86c9a$var$tsIsIdentifier()) return false;
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._in);
}
function $e018f01e7ae86c9a$var$tsParseMappedTypeParameter() {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._in);
    $e018f01e7ae86c9a$export$13a289e680c077c1();
}
function $e018f01e7ae86c9a$var$tsParseMappedType() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).plus) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).minus)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly);
    } else (0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL);
    $e018f01e7ae86c9a$var$tsParseMappedTypeParameter();
    if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as)) $e018f01e7ae86c9a$export$13a289e680c077c1();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).plus) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).minus)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    } else (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    $e018f01e7ae86c9a$var$tsTryParseType();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
}
function $e018f01e7ae86c9a$var$tsParseTupleType() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL);
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        // Do not validate presence of either none or only labeled elements
        $e018f01e7ae86c9a$var$tsParseTupleElementType();
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
}
function $e018f01e7ae86c9a$var$tsParseTupleElementType() {
    // parses `...TsType[]`
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) $e018f01e7ae86c9a$export$13a289e680c077c1();
    else {
        // parses `TsType?`
        $e018f01e7ae86c9a$export$13a289e680c077c1();
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    }
    // The type we parsed above was actually a label
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) // Labeled tuple types must affix the label with `...` or `?`, so no need to handle those here
    $e018f01e7ae86c9a$export$13a289e680c077c1();
}
function $e018f01e7ae86c9a$var$tsParseParenthesizedType() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    $e018f01e7ae86c9a$export$13a289e680c077c1();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
}
function $e018f01e7ae86c9a$var$tsParseTemplateLiteralType() {
    // Finish `, read quasi
    (0, $d45b756a11a5dc19$export$e4355ff2fab571ee)();
    // Finish quasi, read ${
    (0, $d45b756a11a5dc19$export$e4355ff2fab571ee)();
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).backQuote) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).dollarBraceL);
        $e018f01e7ae86c9a$export$13a289e680c077c1();
        // Finish }, read quasi
        (0, $d45b756a11a5dc19$export$e4355ff2fab571ee)();
        // Finish quasi, read either ${ or `
        (0, $d45b756a11a5dc19$export$e4355ff2fab571ee)();
    }
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
}
var $e018f01e7ae86c9a$var$FunctionType;
(function(FunctionType) {
    const TSFunctionType = 0;
    FunctionType[FunctionType["TSFunctionType"] = TSFunctionType] = "TSFunctionType";
    const TSConstructorType = TSFunctionType + 1;
    FunctionType[FunctionType["TSConstructorType"] = TSConstructorType] = "TSConstructorType";
    const TSAbstractConstructorType = TSConstructorType + 1;
    FunctionType[FunctionType["TSAbstractConstructorType"] = TSAbstractConstructorType] = "TSAbstractConstructorType";
})($e018f01e7ae86c9a$var$FunctionType || ($e018f01e7ae86c9a$var$FunctionType = {}));
function $e018f01e7ae86c9a$var$tsParseFunctionOrConstructorType(type) {
    if (type === $e018f01e7ae86c9a$var$FunctionType.TSAbstractConstructorType) (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._abstract);
    if (type === $e018f01e7ae86c9a$var$FunctionType.TSConstructorType || type === $e018f01e7ae86c9a$var$FunctionType.TSAbstractConstructorType) (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._new);
    const oldInDisallowConditionalTypesContext = (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = false;
    $e018f01e7ae86c9a$var$tsFillSignature((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
}
function $e018f01e7ae86c9a$var$tsParseNonArrayType() {
    switch((0, $d9d7db628df75264$export$ca000e230c0caa3e).type){
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).name:
            $e018f01e7ae86c9a$var$tsParseTypeReference();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._void:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._null:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).string:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).num:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).bigint:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).decimal:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._true:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._false:
            (0, $33716cdef222842d$export$d1b3e78ad34a47ef)();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).minus:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            (0, $33716cdef222842d$export$d1b3e78ad34a47ef)();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._this:
            $e018f01e7ae86c9a$var$tsParseThisTypeNode();
            if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._is) && !(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)()) $e018f01e7ae86c9a$var$tsParseThisTypePredicate();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._typeof:
            $e018f01e7ae86c9a$var$tsParseTypeQuery();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._import:
            $e018f01e7ae86c9a$var$tsParseImportType();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL:
            if ($e018f01e7ae86c9a$var$tsLookaheadIsStartOfMappedType()) $e018f01e7ae86c9a$var$tsParseMappedType();
            else $e018f01e7ae86c9a$var$tsParseTypeLiteral();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL:
            $e018f01e7ae86c9a$var$tsParseTupleType();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL:
            $e018f01e7ae86c9a$var$tsParseParenthesizedType();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).backQuote:
            $e018f01e7ae86c9a$var$tsParseTemplateLiteralType();
            return;
        default:
            if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_KEYWORD) {
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f).name;
                return;
            }
            break;
    }
    (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
}
function $e018f01e7ae86c9a$var$tsParseArrayTypeOrHigher() {
    $e018f01e7ae86c9a$var$tsParseNonArrayType();
    while(!(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)() && (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL))if (!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR)) {
        // If we hit ] immediately, this is an array type, otherwise it's an indexed access type.
        $e018f01e7ae86c9a$export$13a289e680c077c1();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
    }
}
function $e018f01e7ae86c9a$var$tsParseInferType() {
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._infer);
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends)) {
        // Infer type constraints introduce an ambiguity about whether the "extends"
        // is a constraint for this infer type or is another conditional type.
        const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends);
        const oldInDisallowConditionalTypesContext = (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = true;
        $e018f01e7ae86c9a$export$13a289e680c077c1();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error || !(0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).question)) (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
}
function $e018f01e7ae86c9a$var$tsParseTypeOperatorOrHigher() {
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._keyof) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._unique) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        $e018f01e7ae86c9a$var$tsParseTypeOperatorOrHigher();
    } else if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._infer)) $e018f01e7ae86c9a$var$tsParseInferType();
    else {
        const oldInDisallowConditionalTypesContext = (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = false;
        $e018f01e7ae86c9a$var$tsParseArrayTypeOrHigher();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    }
}
function $e018f01e7ae86c9a$var$tsParseIntersectionTypeOrHigher() {
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseAND);
    $e018f01e7ae86c9a$var$tsParseTypeOperatorOrHigher();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseAND)) while((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseAND))$e018f01e7ae86c9a$var$tsParseTypeOperatorOrHigher();
}
function $e018f01e7ae86c9a$var$tsParseUnionTypeOrHigher() {
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseOR);
    $e018f01e7ae86c9a$var$tsParseIntersectionTypeOrHigher();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseOR)) while((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseOR))$e018f01e7ae86c9a$var$tsParseIntersectionTypeOrHigher();
}
function $e018f01e7ae86c9a$var$tsIsStartOfFunctionType() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) return true;
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) && $e018f01e7ae86c9a$var$tsLookaheadIsUnambiguouslyStartOfFunctionType();
}
function $e018f01e7ae86c9a$var$tsSkipParameterStart() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._this)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        return true;
    }
    // If this is a possible array/object destructure, walk to the matching bracket/brace.
    // The next token after will tell us definitively whether this is a function param.
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) {
        let depth = 1;
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        while(depth > 0 && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
            if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) depth++;
            else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR)) depth--;
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        }
        return true;
    }
    return false;
}
function $e018f01e7ae86c9a$var$tsLookaheadIsUnambiguouslyStartOfFunctionType() {
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    const isUnambiguouslyStartOfFunctionType = $e018f01e7ae86c9a$var$tsIsUnambiguouslyStartOfFunctionType();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return isUnambiguouslyStartOfFunctionType;
}
function $e018f01e7ae86c9a$var$tsIsUnambiguouslyStartOfFunctionType() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) // ( )
    // ( ...
    return true;
    if ($e018f01e7ae86c9a$var$tsSkipParameterStart()) {
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).question) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) // ( xxx :
        // ( xxx ,
        // ( xxx ?
        // ( xxx =
        return true;
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR)) {
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow)) // ( xxx ) =>
            return true;
        }
    }
    return false;
}
function $e018f01e7ae86c9a$var$tsParseTypeOrTypePredicateAnnotation(returnToken) {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)(returnToken);
    const finishedReturn = $e018f01e7ae86c9a$var$tsParseTypePredicateOrAssertsPrefix();
    if (!finishedReturn) $e018f01e7ae86c9a$export$13a289e680c077c1();
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $e018f01e7ae86c9a$var$tsTryParseTypeOrTypePredicateAnnotation() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $e018f01e7ae86c9a$var$tsParseTypeOrTypePredicateAnnotation((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
}
function $e018f01e7ae86c9a$export$e4623eb563192e0f() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $e018f01e7ae86c9a$export$728a3256ac690042();
}
function $e018f01e7ae86c9a$var$tsTryParseType() {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $e018f01e7ae86c9a$export$13a289e680c077c1();
}
/**
 * Detect a few special return syntax cases: `x is T`, `asserts x`, `asserts x is T`,
 * `asserts this is T`.
 *
 * Returns true if we parsed the return type, false if there's still a type to be parsed.
 */ function $e018f01e7ae86c9a$var$tsParseTypePredicateOrAssertsPrefix() {
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._asserts)) {
        // Normally this is `asserts x is T`, but at this point, it might be `asserts is T` (a user-
        // defined type guard on the `asserts` variable) or just a type called `asserts`.
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._is)) {
            // If we see `asserts is`, then this must be of the form `asserts is T`, since
            // `asserts is is T` isn't valid.
            $e018f01e7ae86c9a$export$13a289e680c077c1();
            return true;
        } else if ($e018f01e7ae86c9a$var$tsIsIdentifier() || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._this)) {
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._is)) // If we see `is`, then this is `asserts x is T`. Otherwise, it's `asserts x`.
            $e018f01e7ae86c9a$export$13a289e680c077c1();
            return true;
        } else {
            // Regular type, so bail out and start type parsing from scratch.
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    } else if ($e018f01e7ae86c9a$var$tsIsIdentifier() || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._this)) {
        // This is a regular identifier, which may or may not have "is" after it.
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._is) && !(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)()) {
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            $e018f01e7ae86c9a$export$13a289e680c077c1();
            return true;
        } else {
            // Regular type, so bail out and start type parsing from scratch.
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    }
    return false;
}
function $e018f01e7ae86c9a$export$728a3256ac690042() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    $e018f01e7ae86c9a$export$13a289e680c077c1();
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $e018f01e7ae86c9a$export$13a289e680c077c1() {
    $e018f01e7ae86c9a$export$817427f5f29c80bc();
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext || (0, $85f046d5f58d0c41$export$942fa35f3a7c108c)() || !(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends)) return;
    // extends type
    const oldInDisallowConditionalTypesContext = (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = true;
    $e018f01e7ae86c9a$export$817427f5f29c80bc();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).inDisallowConditionalTypesContext = oldInDisallowConditionalTypesContext;
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    // true type
    $e018f01e7ae86c9a$export$13a289e680c077c1();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    // false type
    $e018f01e7ae86c9a$export$13a289e680c077c1();
}
function $e018f01e7ae86c9a$var$isAbstractConstructorSignature() {
    return (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._abstract) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f)._new;
}
function $e018f01e7ae86c9a$export$817427f5f29c80bc() {
    if ($e018f01e7ae86c9a$var$tsIsStartOfFunctionType()) {
        $e018f01e7ae86c9a$var$tsParseFunctionOrConstructorType($e018f01e7ae86c9a$var$FunctionType.TSFunctionType);
        return;
    }
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._new)) {
        // As in `new () => Date`
        $e018f01e7ae86c9a$var$tsParseFunctionOrConstructorType($e018f01e7ae86c9a$var$FunctionType.TSConstructorType);
        return;
    } else if ($e018f01e7ae86c9a$var$isAbstractConstructorSignature()) {
        // As in `abstract new () => Date`
        $e018f01e7ae86c9a$var$tsParseFunctionOrConstructorType($e018f01e7ae86c9a$var$FunctionType.TSAbstractConstructorType);
        return;
    }
    $e018f01e7ae86c9a$var$tsParseUnionTypeOrHigher();
}
function $e018f01e7ae86c9a$export$ecfac1712a900e29() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
    $e018f01e7ae86c9a$export$13a289e680c077c1();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan);
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    (0, $33716cdef222842d$export$165911d2b803e372)();
}
function $e018f01e7ae86c9a$export$382de4b7ab7e7990() {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f).typeParameterStart;
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
        while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
            $e018f01e7ae86c9a$export$13a289e680c077c1();
            (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
        }
        // Process >, but the one after needs to be parsed JSX-style.
        (0, $c87336ed1c501cb2$export$a1b2c368381052e6)();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    }
}
function $e018f01e7ae86c9a$var$tsParseHeritageClause() {
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        $e018f01e7ae86c9a$var$tsParseExpressionWithTypeArguments();
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
}
function $e018f01e7ae86c9a$var$tsParseExpressionWithTypeArguments() {
    // Note: TS uses parseLeftHandSideExpressionOrHigher,
    // then has grammar errors later if it's not an EntityName.
    $e018f01e7ae86c9a$var$tsParseEntityName();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $e018f01e7ae86c9a$var$tsParseTypeArguments();
}
function $e018f01e7ae86c9a$var$tsParseInterfaceDeclaration() {
    (0, $24b5f7a89f6adf6c$export$7538cb03fa894c83)(false);
    $e018f01e7ae86c9a$export$827faab4e65d5897();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends)) $e018f01e7ae86c9a$var$tsParseHeritageClause();
    $e018f01e7ae86c9a$var$tsParseObjectTypeMembers();
}
function $e018f01e7ae86c9a$var$tsParseTypeAliasDeclaration() {
    (0, $24b5f7a89f6adf6c$export$7538cb03fa894c83)(false);
    $e018f01e7ae86c9a$export$827faab4e65d5897();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq);
    $e018f01e7ae86c9a$export$13a289e680c077c1();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $e018f01e7ae86c9a$var$tsParseEnumMember() {
    // Computed property names are grammar errors in an enum, so accept just string literal or identifier.
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) (0, $33716cdef222842d$export$d1b3e78ad34a47ef)();
    else (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
        const eqIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1;
        (0, $33716cdef222842d$export$b97bbe8a7805284f)();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    }
}
function $e018f01e7ae86c9a$var$tsParseEnumDeclaration() {
    (0, $24b5f7a89f6adf6c$export$7538cb03fa894c83)(false);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        $e018f01e7ae86c9a$var$tsParseEnumMember();
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
}
function $e018f01e7ae86c9a$var$tsParseModuleBlock() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    (0, $1eea8ad3ef6f406b$export$e5110a9b2ab486ee)(/* end */ (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
}
function $e018f01e7ae86c9a$var$tsParseModuleOrNamespaceDeclaration() {
    (0, $24b5f7a89f6adf6c$export$7538cb03fa894c83)(false);
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) $e018f01e7ae86c9a$var$tsParseModuleOrNamespaceDeclaration();
    else $e018f01e7ae86c9a$var$tsParseModuleBlock();
}
function $e018f01e7ae86c9a$var$tsParseAmbientExternalModuleDeclaration() {
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._global)) (0, $33716cdef222842d$export$321543c11f6250ad)();
    else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) (0, $33716cdef222842d$export$fa61731cf32bc243)();
    else (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) $e018f01e7ae86c9a$var$tsParseModuleBlock();
    else (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $e018f01e7ae86c9a$export$bb14276cd4f56f44() {
    (0, $24b5f7a89f6adf6c$export$cba413304e86fc0d)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq);
    $e018f01e7ae86c9a$var$tsParseModuleReference();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $e018f01e7ae86c9a$var$tsIsExternalModuleReference() {
    return (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._require) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL;
}
function $e018f01e7ae86c9a$var$tsParseModuleReference() {
    if ($e018f01e7ae86c9a$var$tsIsExternalModuleReference()) $e018f01e7ae86c9a$var$tsParseExternalModuleReference();
    else $e018f01e7ae86c9a$var$tsParseEntityName();
}
function $e018f01e7ae86c9a$var$tsParseExternalModuleReference() {
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._require);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    (0, $33716cdef222842d$export$d1b3e78ad34a47ef)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
}
// Utilities
// Returns true if a statement matched.
function $e018f01e7ae86c9a$var$tsTryParseDeclare() {
    if ((0, $85f046d5f58d0c41$export$12d132b6e81066e4)()) return false;
    switch((0, $d9d7db628df75264$export$ca000e230c0caa3e).type){
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._function:
            {
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                // We don't need to precisely get the function start here, since it's only used to mark
                // the function as a type if it's bodiless, and it's already a type here.
                const functionStart = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
                (0, $1eea8ad3ef6f406b$export$ba3dc2bd7c065219)(functionStart, /* isStatement */ true);
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._class:
            {
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
                (0, $1eea8ad3ef6f406b$export$542081d93172af)(/* isStatement */ true, /* optionalId */ false);
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._const:
            if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._const) && (0, $85f046d5f58d0c41$export$d1b5391c35999eba)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum)) {
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
                // `const enum = 0;` not allowed because "enum" is a strict mode reserved word.
                (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._const);
                (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum);
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum;
                $e018f01e7ae86c9a$var$tsParseEnumDeclaration();
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        // falls through
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._var:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._let:
            {
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
                (0, $1eea8ad3ef6f406b$export$73f0614724a3919a)((0, $d9d7db628df75264$export$ca000e230c0caa3e).type !== (0, $c455753917f2f29d$export$f435f793048e7a0f)._var);
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return true;
            }
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).name:
            {
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
                const contextualKeyword = (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword;
                let matched = false;
                if (contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._global) {
                    $e018f01e7ae86c9a$var$tsParseAmbientExternalModuleDeclaration();
                    matched = true;
                } else matched = $e018f01e7ae86c9a$var$tsParseDeclaration(contextualKeyword, /* isBeforeToken */ true);
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return matched;
            }
        default:
            return false;
    }
}
// Note: this won't be called unless the keyword is allowed in `shouldParseExportDeclaration`.
// Returns true if it matched a declaration.
function $e018f01e7ae86c9a$var$tsTryParseExportDeclaration() {
    return $e018f01e7ae86c9a$var$tsParseDeclaration((0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword, /* isBeforeToken */ true);
}
// Returns true if it matched a statement.
function $e018f01e7ae86c9a$var$tsParseExpressionStatement(contextualKeyword) {
    switch(contextualKeyword){
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._declare:
            {
                const declareTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1;
                const matched = $e018f01e7ae86c9a$var$tsTryParseDeclare();
                if (matched) {
                    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[declareTokenIndex].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._declare;
                    return true;
                }
                break;
            }
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._global:
            // `global { }` (with no `declare`) may appear inside an ambient module declaration.
            // Would like to use tsParseAmbientExternalModuleDeclaration here, but already ran past "global".
            if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
                $e018f01e7ae86c9a$var$tsParseModuleBlock();
                return true;
            }
            break;
        default:
            return $e018f01e7ae86c9a$var$tsParseDeclaration(contextualKeyword, /* isBeforeToken */ false);
    }
    return false;
}
/**
 * Common code for parsing a declaration.
 *
 * isBeforeToken indicates that the current parser state is at the contextual
 * keyword (and that it is not yet emitted) rather than reading the token after
 * it. When isBeforeToken is true, we may be preceded by an `export` token and
 * should include that token in a type context we create, e.g. to handle
 * `export interface` or `export type`. (This is a bit of a hack and should be
 * cleaned up at some point.)
 *
 * Returns true if it matched a declaration.
 */ function $e018f01e7ae86c9a$var$tsParseDeclaration(contextualKeyword, isBeforeToken) {
    switch(contextualKeyword){
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._abstract:
            if ($e018f01e7ae86c9a$var$tsCheckLineTerminator(isBeforeToken) && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._class)) {
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract;
                (0, $1eea8ad3ef6f406b$export$542081d93172af)(/* isStatement */ true, /* optionalId */ false);
                return true;
            }
            break;
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum:
            if ($e018f01e7ae86c9a$var$tsCheckLineTerminator(isBeforeToken) && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum;
                $e018f01e7ae86c9a$var$tsParseEnumDeclaration();
                return true;
            }
            break;
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface:
            if ($e018f01e7ae86c9a$var$tsCheckLineTerminator(isBeforeToken) && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
                // `next` is true in "export" and "declare" contexts, so we want to remove that token
                // as well.
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $e018f01e7ae86c9a$var$tsParseInterfaceDeclaration();
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module:
            if ($e018f01e7ae86c9a$var$tsCheckLineTerminator(isBeforeToken)) {
                if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) {
                    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                    $e018f01e7ae86c9a$var$tsParseAmbientExternalModuleDeclaration();
                    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                    return true;
                } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
                    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                    $e018f01e7ae86c9a$var$tsParseModuleOrNamespaceDeclaration();
                    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                    return true;
                }
            }
            break;
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._namespace:
            if ($e018f01e7ae86c9a$var$tsCheckLineTerminator(isBeforeToken) && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $e018f01e7ae86c9a$var$tsParseModuleOrNamespaceDeclaration();
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type:
            if ($e018f01e7ae86c9a$var$tsCheckLineTerminator(isBeforeToken) && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
                const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(isBeforeToken ? 2 : 1);
                $e018f01e7ae86c9a$var$tsParseTypeAliasDeclaration();
                (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
                return true;
            }
            break;
        default:
            break;
    }
    return false;
}
function $e018f01e7ae86c9a$var$tsCheckLineTerminator(isBeforeToken) {
    if (isBeforeToken) {
        // Babel checks hasFollowingLineBreak here and returns false, but this
        // doesn't actually come up, e.g. `export interface` can never be on its own
        // line in valid code.
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        return true;
    } else return !(0, $85f046d5f58d0c41$export$12d132b6e81066e4)();
}
// Returns true if there was a generic async arrow function.
function $e018f01e7ae86c9a$var$tsTryParseGenericAsyncArrowFunction() {
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    $e018f01e7ae86c9a$var$tsParseTypeParameters();
    (0, $1eea8ad3ef6f406b$export$dd0fc1c64275f2c4)();
    $e018f01e7ae86c9a$var$tsTryParseTypeOrTypePredicateAnnotation();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    (0, $33716cdef222842d$export$50f85c246417e18)(true);
    return true;
}
/**
 * If necessary, hack the tokenizer state so that this bitshift was actually a
 * less-than token, then keep parsing. This should only be used in situations
 * where we restore from snapshot on error (which reverts this change) or
 * where bitshift would be illegal anyway (e.g. in a class "extends" clause).
 *
 * This hack is useful to handle situations like foo<<T>() => void>() where
 * there can legitimately be two open-angle-brackets in a row in TS.
 */ function $e018f01e7ae86c9a$var$tsParseTypeArgumentsWithPossibleBitshift() {
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f).bitShiftL) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos -= 1;
        (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan);
    }
    $e018f01e7ae86c9a$var$tsParseTypeArguments();
}
function $e018f01e7ae86c9a$var$tsParseTypeArguments() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan);
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        $e018f01e7ae86c9a$export$13a289e680c077c1();
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
    if (!oldIsType) {
        // If the type arguments are present in an expression context, e.g.
        // f<number>(), then the > sign should be tokenized as a non-type token.
        // In particular, f(a < b, c >= d) should parse the >= as a single token,
        // resulting in a syntax error and fallback to the non-type-args
        // interpretation. In the success case, even though the > is tokenized as a
        // non-type token, it still must be marked as a type token so that it is
        // erased.
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        (0, $d45b756a11a5dc19$export$4d00b4f4d9d7a9b3)();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan);
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
    } else {
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan);
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    }
}
function $e018f01e7ae86c9a$export$5df75dadb7a629b6() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) switch((0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword){
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._abstract:
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._declare:
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum:
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface:
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module:
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._namespace:
        case (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type:
            return true;
        default:
            break;
    }
    return false;
}
function $e018f01e7ae86c9a$export$3c36bc5140dd8c64(functionStart, funcContextId) {
    // For arrow functions, `parseArrow` handles the return type itself.
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $e018f01e7ae86c9a$var$tsParseTypeOrTypePredicateAnnotation((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    // The original code checked the node type to make sure this function type allows a missing
    // body, but we skip that to avoid sending around the node type. We instead just use the
    // allowExpressionBody boolean to make sure it's not an arrow function.
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) && (0, $85f046d5f58d0c41$export$12d132b6e81066e4)()) {
        // Retroactively mark the function declaration as a type.
        let i = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1;
        while(i >= 0 && ((0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[i].start >= functionStart || (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[i].type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._default || (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[i].type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._export)){
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[i].isType = true;
            i--;
        }
        return;
    }
    (0, $33716cdef222842d$export$50f85c246417e18)(false, funcContextId);
}
function $e018f01e7ae86c9a$export$f6cd10065188a17f(startTokenIndex, noCalls, stopState) {
    if (!(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)() && (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bang)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f).nonNullAssertion;
        return;
    }
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitShiftL)) {
        // There are number of things we are going to "maybe" parse, like type arguments on
        // tagged template expressions. If any of them fail, walk it back and continue.
        const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
        if (!noCalls && (0, $33716cdef222842d$export$960e7b0728d0d49e)()) {
            // Almost certainly this is a generic async function `async <T>() => ...
            // But it might be a call with a type argument `async<T>();`
            const asyncArrowFn = $e018f01e7ae86c9a$var$tsTryParseGenericAsyncArrowFunction();
            if (asyncArrowFn) return;
        }
        $e018f01e7ae86c9a$var$tsParseTypeArgumentsWithPossibleBitshift();
        if (!noCalls && (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
            // With f<T>(), the subscriptStartIndex marker is on the ( token.
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            (0, $33716cdef222842d$export$970763873d9efa73)();
        } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).backQuote)) // Tagged template with a type argument.
        (0, $33716cdef222842d$export$2e2dbd43b49fd373)();
        else if (// The remaining possible case is an instantiation expression, e.g.
        // Array<number> . Check for a few cases that would disqualify it and
        // cause us to bail out.
        // a<b>>c is not (a<b>)>c, but a<(b>>c)
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan || // a<b>c is (a<b)>c
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).type !== (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL && Boolean((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_EXPRESSION_START) && !(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)()) // Bail out. We have something like a<b>c, which is not an expression with
        // type arguments but an (a < b) > c comparison.
        (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        else return;
    } else if (!noCalls && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) {
        // If we see f?.<, then this must be an optional call with a type argument.
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart = true;
        // With f?.<T>(), the subscriptStartIndex marker is on the ?. token.
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $e018f01e7ae86c9a$var$tsParseTypeArguments();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
        (0, $33716cdef222842d$export$970763873d9efa73)();
    }
    (0, $33716cdef222842d$export$31dc8e486c1a1be6)(startTokenIndex, noCalls, stopState);
}
function $e018f01e7ae86c9a$export$6714566ca8db2f39() {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._import)) {
        // One of these cases:
        // export import A = B;
        // export import type A = require("A");
        if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() !== (0, $c455753917f2f29d$export$f435f793048e7a0f).eq) // Eat a `type` token, unless it's actually an identifier name.
        (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type);
        $e018f01e7ae86c9a$export$bb14276cd4f56f44();
        return true;
    } else if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
        // `export = x;`
        (0, $33716cdef222842d$export$ed9c825e502c46c8)();
        (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
        return true;
    } else if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as)) {
        // `export as namespace A;`
        // See `parseNamespaceExportDeclaration` in TypeScript's own parser
        (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._namespace);
        (0, $33716cdef222842d$export$321543c11f6250ad)();
        (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
        return true;
    } else {
        if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
            const nextType = (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)();
            // export type {foo} from 'a';
            // export type * from 'a';'
            // export type * as ns from 'a';'
            if (nextType === (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL || nextType === (0, $c455753917f2f29d$export$f435f793048e7a0f).star) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        }
        return false;
    }
}
function $e018f01e7ae86c9a$export$718ece2f88417ffd() {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
        // import {foo}
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportDeclaration;
        return;
    }
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
        // import {type foo}
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportDeclaration;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
        return;
    }
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
        // import {foo as bar}
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportAccess;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportDeclaration;
        return;
    }
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    // import {type foo as bar}
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportAccess;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportDeclaration;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 4].isType = true;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 3].isType = true;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
}
function $e018f01e7ae86c9a$export$7994f3b86b6c7d1e() {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
        // export {foo}
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ExportAccess;
        return;
    }
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
        // export {type foo}
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ExportAccess;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
        return;
    }
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
        // export {foo as bar}
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ExportAccess;
        return;
    }
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    // export {type foo as bar}
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 3].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ExportAccess;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 4].isType = true;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 3].isType = true;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 2].isType = true;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
}
function $e018f01e7ae86c9a$export$95d54e02ae7a0197() {
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._abstract) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f)._class) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract;
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)(); // Skip "abstract"
        (0, $1eea8ad3ef6f406b$export$542081d93172af)(true, true);
        return true;
    }
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface)) {
        // Make sure "export default" are considered type tokens so the whole thing is removed.
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(2);
        $e018f01e7ae86c9a$var$tsParseDeclaration((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface, true);
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        return true;
    }
    return false;
}
function $e018f01e7ae86c9a$export$bd8d07f8ee509b14() {
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._const) {
        const ahead = (0, $d45b756a11a5dc19$export$ef1b94c514fc060a)();
        if (ahead.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name && ahead.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum) {
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._const);
            (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum);
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum;
            $e018f01e7ae86c9a$var$tsParseEnumDeclaration();
            return true;
        }
    }
    return false;
}
function $e018f01e7ae86c9a$export$9d02a6e20851f734(isStatic) {
    const memberStartIndexAfterStatic = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    $e018f01e7ae86c9a$export$77616e6d401f584a([
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._abstract,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._readonly,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._declare,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._static,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._override
    ]);
    const modifiersEndIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    const found = $e018f01e7ae86c9a$var$tsTryParseIndexSignature();
    if (found) {
        // Index signatures are type declarations, so set the modifier tokens as
        // type tokens. Most tokens could be assumed to be type tokens, but `static`
        // is ambiguous unless we set it explicitly here.
        const memberStartIndex = isStatic ? memberStartIndexAfterStatic - 1 : memberStartIndexAfterStatic;
        for(let i = memberStartIndex; i < modifiersEndIndex; i++)(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[i].isType = true;
        return true;
    }
    return false;
}
function $e018f01e7ae86c9a$export$a642c15f5070c816(contextualKeyword) {
    const matched = $e018f01e7ae86c9a$var$tsParseExpressionStatement(contextualKeyword);
    if (!matched) (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $e018f01e7ae86c9a$export$b29e6741ccf6da0a() {
    // "export declare" is equivalent to just "export".
    const isDeclare = (0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._declare);
    if (isDeclare) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._declare;
    let matchedDeclaration = false;
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
        if (isDeclare) {
            const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(2);
            matchedDeclaration = $e018f01e7ae86c9a$var$tsTryParseExportDeclaration();
            (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        } else matchedDeclaration = $e018f01e7ae86c9a$var$tsTryParseExportDeclaration();
    }
    if (!matchedDeclaration) {
        if (isDeclare) {
            const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(2);
            (0, $1eea8ad3ef6f406b$export$68b986de0b252bc8)(true);
            (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        } else (0, $1eea8ad3ef6f406b$export$68b986de0b252bc8)(true);
    }
}
function $e018f01e7ae86c9a$export$ea9d02c53bf69095(hasSuper) {
    if (hasSuper && ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitShiftL))) $e018f01e7ae86c9a$var$tsParseTypeArgumentsWithPossibleBitshift();
    if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._implements)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._implements;
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
        $e018f01e7ae86c9a$var$tsParseHeritageClause();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    }
}
function $e018f01e7ae86c9a$export$f7c2ce498525881a() {
    $e018f01e7ae86c9a$export$827faab4e65d5897();
}
function $e018f01e7ae86c9a$export$ba34d58430377f94() {
    $e018f01e7ae86c9a$export$827faab4e65d5897();
}
function $e018f01e7ae86c9a$export$41c8703baf1bbf07() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    if (!(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)()) (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bang);
    $e018f01e7ae86c9a$export$e4623eb563192e0f();
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $e018f01e7ae86c9a$export$490a9bc22f3cab3f() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $e018f01e7ae86c9a$export$728a3256ac690042();
}
function $e018f01e7ae86c9a$export$daa24143ef798a56(noIn, isWithinParens) {
    // Note: When the JSX plugin is on, type assertions (`<T> x`) aren't valid syntax.
    if (0, $d9d7db628df75264$export$43bb667a94af025a) return $e018f01e7ae86c9a$export$fbbf4e3ed219417f(noIn, isWithinParens);
    else return $e018f01e7ae86c9a$export$9606be81aa771b16(noIn, isWithinParens);
}
function $e018f01e7ae86c9a$export$fbbf4e3ed219417f(noIn, isWithinParens) {
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) return (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    // Prefer to parse JSX if possible. But may be an arrow fn.
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    let wasArrow = (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    else return wasArrow;
    // Otherwise, try as type-parameterized arrow function.
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).type = (0, $c455753917f2f29d$export$f435f793048e7a0f).typeParameterStart;
    // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
    $e018f01e7ae86c9a$var$tsParseTypeParameters();
    wasArrow = (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if (!wasArrow) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    return wasArrow;
}
function $e018f01e7ae86c9a$export$9606be81aa771b16(noIn, isWithinParens) {
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) return (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    // This is similar to TypeScript's `tryParseParenthesizedArrowFunctionExpression`.
    $e018f01e7ae86c9a$var$tsParseTypeParameters();
    const wasArrow = (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
    if (!wasArrow) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    else return wasArrow;
    // Try parsing a type cast instead of an arrow function.
    // This will start with a type assertion (via parseMaybeUnary).
    // But don't directly call `tsParseTypeAssertion` because we want to handle any binary after it.
    return (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
}
function $e018f01e7ae86c9a$export$e20067ab7c70da1d() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) {
        // This is different from how the TS parser does it.
        // TS uses lookahead. Babylon parses it as a parenthesized expression and converts.
        const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
        $e018f01e7ae86c9a$var$tsParseTypeOrTypePredicateAnnotation((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
        if ((0, $85f046d5f58d0c41$export$1c0919cee6560c3)()) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
        if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow)) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
    return (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
}
function $e018f01e7ae86c9a$export$9b46e2c9fd90d888() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    $e018f01e7ae86c9a$export$e4623eb563192e0f();
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $e018f01e7ae86c9a$export$fd0439ea9a1ac1ea() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitShiftL)) $e018f01e7ae86c9a$var$tsParseTypeArgumentsWithPossibleBitshift();
    (0, $1eea8ad3ef6f406b$export$50c128b10ac5ea5b)();
}


/**
 * Read token with JSX contents.
 *
 * In addition to detecting jsxTagStart and also regular tokens that might be
 * part of an expression, this code detects the start and end of text ranges
 * within JSX children. In order to properly count the number of children, we
 * distinguish jsxText from jsxEmptyText, which is a text range that simplifies
 * to the empty string after JSX whitespace trimming.
 *
 * It turns out that a JSX text range will simplify to the empty string if and
 * only if both of these conditions hold:
 * - The range consists entirely of whitespace characters (only counting space,
 *   tab, \r, and \n).
 * - The range has at least one newline.
 * This can be proven by analyzing any implementation of whitespace trimming,
 * e.g. formatJSXTextLiteral in Sucrase or cleanJSXElementLiteralChild in Babel.
 */ function $c87336ed1c501cb2$var$jsxReadToken() {
    let sawNewline = false;
    let sawNonWhitespace = false;
    while(true){
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos >= (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) {
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("Unterminated JSX contents");
            return;
        }
        const ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lessThan || ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftCurlyBrace) {
            if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos === (0, $d9d7db628df75264$export$ca000e230c0caa3e).start) {
                if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lessThan) {
                    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
                    (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart);
                    return;
                }
                (0, $d45b756a11a5dc19$export$e0ebb9fd4c2c4701)(ch);
                return;
            }
            if (sawNewline && !sawNonWhitespace) (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxEmptyText);
            else (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxText);
            return;
        }
        // This is part of JSX text.
        if (ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lineFeed) sawNewline = true;
        else if (ch !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).space && ch !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).carriageReturn && ch !== (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).tab) sawNonWhitespace = true;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
    }
}
function $c87336ed1c501cb2$var$jsxReadString(quote) {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
    for(;;){
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos >= (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) {
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("Unterminated string constant");
            return;
        }
        const ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
        if (ch === quote) {
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
            break;
        }
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos++;
    }
    (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).string);
}
// Read a JSX identifier (valid tag or attribute name).
//
// Optimized version since JSX identifiers can't contain
// escape characters and so can be read as single slice.
// Also assumes that first character was already checked
// by isIdentifierStart in readToken.
function $c87336ed1c501cb2$var$jsxReadWord() {
    let ch;
    do {
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos > (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length) {
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("Unexpectedly reached the end of input.");
            return;
        }
        ch = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
    }while ((0, $d6dc0379bdf024ad$export$d19df39e3926cfef)[ch] || ch === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dash);
    (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName);
}
// Parse next token as JSX identifier
function $c87336ed1c501cb2$var$jsxParseIdentifier() {
    $c87336ed1c501cb2$export$a1b2c368381052e6();
}
// Parse namespaced identifier.
function $c87336ed1c501cb2$var$jsxParseNamespacedName(identifierRole) {
    $c87336ed1c501cb2$var$jsxParseIdentifier();
    if (!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) {
        // Plain identifier, so this is an access.
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
        return;
    }
    // Process the second half of the namespaced name.
    $c87336ed1c501cb2$var$jsxParseIdentifier();
}
// Parses element name in any form - namespaced, member
// or single identifier.
function $c87336ed1c501cb2$var$jsxParseElementName() {
    const firstTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    $c87336ed1c501cb2$var$jsxParseNamespacedName((0, $d45b756a11a5dc19$export$99f888ada3c99de3).Access);
    let hadDot = false;
    while((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)){
        hadDot = true;
        $c87336ed1c501cb2$export$a1b2c368381052e6();
        $c87336ed1c501cb2$var$jsxParseIdentifier();
    }
    // For tags like <div> with a lowercase letter and no dots, the name is
    // actually *not* an identifier access, since it's referring to a built-in
    // tag name. Remove the identifier role in this case so that it's not
    // accidentally transformed by the imports transform when preserving JSX.
    if (!hadDot) {
        const firstToken = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[firstTokenIndex];
        const firstChar = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(firstToken.start);
        if (firstChar >= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseA && firstChar <= (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseZ) firstToken.identifierRole = null;
    }
}
// Parses any type of JSX attribute value.
function $c87336ed1c501cb2$var$jsxParseAttributeValue() {
    switch((0, $d9d7db628df75264$export$ca000e230c0caa3e).type){
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            (0, $33716cdef222842d$export$ed9c825e502c46c8)();
            $c87336ed1c501cb2$export$a1b2c368381052e6();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart:
            $c87336ed1c501cb2$export$7cbe8c53d909e342();
            $c87336ed1c501cb2$export$a1b2c368381052e6();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).string:
            $c87336ed1c501cb2$export$a1b2c368381052e6();
            return;
        default:
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("JSX value should be either an expression or a quoted JSX text");
    }
}
// Parse JSX spread child, after already processing the {
// Does not parse the closing }
function $c87336ed1c501cb2$var$jsxParseSpreadChild() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis);
    (0, $33716cdef222842d$export$ed9c825e502c46c8)();
}
// Parses JSX opening tag starting after "<".
// Returns true if the tag was self-closing.
// Does not parse the last token.
function $c87336ed1c501cb2$var$jsxParseOpeningElement(initialTokenIndex) {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd)) // This is an open-fragment.
    return false;
    $c87336ed1c501cb2$var$jsxParseElementName();
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$382de4b7ab7e7990)();
    let hasSeenPropSpread = false;
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).slash) && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            hasSeenPropSpread = true;
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis);
            (0, $33716cdef222842d$export$b97bbe8a7805284f)();
            // }
            $c87336ed1c501cb2$export$a1b2c368381052e6();
            continue;
        }
        if (hasSeenPropSpread && (0, $d9d7db628df75264$export$ca000e230c0caa3e).end - (0, $d9d7db628df75264$export$ca000e230c0caa3e).start === 3 && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).start) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseK && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).start + 1) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseE && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).start + 2) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lowercaseY) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).KeyAfterPropSpread;
        $c87336ed1c501cb2$var$jsxParseNamespacedName((0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectKey);
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
            $c87336ed1c501cb2$export$a1b2c368381052e6();
            $c87336ed1c501cb2$var$jsxParseAttributeValue();
        }
    }
    const isSelfClosing = (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).slash);
    if (isSelfClosing) // /
    $c87336ed1c501cb2$export$a1b2c368381052e6();
    return isSelfClosing;
}
// Parses JSX closing tag starting after "</".
// Does not parse the last token.
function $c87336ed1c501cb2$var$jsxParseClosingElement() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd)) // Fragment syntax, so we immediately have a tag end.
    return;
    $c87336ed1c501cb2$var$jsxParseElementName();
}
// Parses entire JSX element, including its opening tag
// (starting after "<"), attributes, contents and closing tag.
// Does not parse the last token.
function $c87336ed1c501cb2$var$jsxParseElementAt() {
    const initialTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).NoChildren;
    let numExplicitChildren = 0;
    const isSelfClosing = $c87336ed1c501cb2$var$jsxParseOpeningElement(initialTokenIndex);
    if (!isSelfClosing) {
        $c87336ed1c501cb2$var$nextJSXExprToken();
        while(true)switch((0, $d9d7db628df75264$export$ca000e230c0caa3e).type){
            case (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart:
                $c87336ed1c501cb2$export$a1b2c368381052e6();
                if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).slash)) {
                    $c87336ed1c501cb2$export$a1b2c368381052e6();
                    $c87336ed1c501cb2$var$jsxParseClosingElement();
                    // Key after prop spread takes precedence over number of children,
                    // since it means we switch to createElement, which doesn't care
                    // about number of children.
                    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole !== (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).KeyAfterPropSpread) {
                        if (numExplicitChildren === 1) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).OneChild;
                        else if (numExplicitChildren > 1) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[initialTokenIndex].jsxRole = (0, $d45b756a11a5dc19$export$4620c92ad8b511d9).StaticChildren;
                    }
                    return;
                }
                numExplicitChildren++;
                $c87336ed1c501cb2$var$jsxParseElementAt();
                $c87336ed1c501cb2$var$nextJSXExprToken();
                break;
            case (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxText:
                numExplicitChildren++;
                $c87336ed1c501cb2$var$nextJSXExprToken();
                break;
            case (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxEmptyText:
                $c87336ed1c501cb2$var$nextJSXExprToken();
                break;
            case (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL:
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) {
                    $c87336ed1c501cb2$var$jsxParseSpreadChild();
                    $c87336ed1c501cb2$var$nextJSXExprToken();
                    // Spread children are a mechanism to explicitly mark children as
                    // static, so count it as 2 children to satisfy the "more than one
                    // child" condition.
                    numExplicitChildren += 2;
                } else {
                    // If we see {}, this is an empty pseudo-expression that doesn't
                    // count as a child.
                    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                        numExplicitChildren++;
                        (0, $33716cdef222842d$export$ed9c825e502c46c8)();
                    }
                    $c87336ed1c501cb2$var$nextJSXExprToken();
                }
                break;
            // istanbul ignore next - should never happen
            default:
                (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
                return;
        }
    }
}
function $c87336ed1c501cb2$export$7cbe8c53d909e342() {
    $c87336ed1c501cb2$export$a1b2c368381052e6();
    $c87336ed1c501cb2$var$jsxParseElementAt();
}
function $c87336ed1c501cb2$export$a1b2c368381052e6() {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.push(new (0, $d45b756a11a5dc19$export$50792b0e93539fde)());
    (0, $d45b756a11a5dc19$export$b240c79c2d18160)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).start = (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    const code = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos);
    if ((0, $d6dc0379bdf024ad$export$dc1d1d7d9fdffb8)[code]) $c87336ed1c501cb2$var$jsxReadWord();
    else if (code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).quotationMark || code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).apostrophe) $c87336ed1c501cb2$var$jsxReadString(code);
    else {
        // The following tokens are just one character each.
        ++(0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
        switch(code){
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).greaterThan:
                (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagEnd);
                break;
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).lessThan:
                (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart);
                break;
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).slash:
                (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).slash);
                break;
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).equalsTo:
                (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq);
                break;
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftCurlyBrace:
                (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
                break;
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).dot:
                (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot);
                break;
            case (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).colon:
                (0, $d45b756a11a5dc19$export$58122cd1933ef607)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
                break;
            default:
                (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
        }
    }
}
function $c87336ed1c501cb2$var$nextJSXExprToken() {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.push(new (0, $d45b756a11a5dc19$export$50792b0e93539fde)());
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).start = (0, $d9d7db628df75264$export$ca000e230c0caa3e).pos;
    $c87336ed1c501cb2$var$jsxReadToken();
}








function $a2a0a59f54890825$export$a1aa0436beedb1fa(noIn) {
    // If we see ?:, this can't possibly be a valid conditional. typedParseParenItem will be called
    // later to finish off the arrow parameter. We also need to handle bare ? tokens for optional
    // parameters without type annotations, i.e. ?, and ?) .
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).question)) {
        const nextType = (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)();
        if (nextType === (0, $c455753917f2f29d$export$f435f793048e7a0f).colon || nextType === (0, $c455753917f2f29d$export$f435f793048e7a0f).comma || nextType === (0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) return;
    }
    (0, $33716cdef222842d$export$a3d1b6cb707072ce)(noIn);
}
function $a2a0a59f54890825$export$72bae99899f77e0f() {
    (0, $d45b756a11a5dc19$export$cb3e65614411a57c)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) {
        if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$728a3256ac690042)();
        else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$6c833037db1a1e96)();
    }
}













class $33716cdef222842d$export$8cd93656cd4760 {
    constructor(stop){
        this.stop = stop;
    }
}
function $33716cdef222842d$export$ed9c825e502c46c8(noIn = false) {
    $33716cdef222842d$export$b97bbe8a7805284f(noIn);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) while((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma))$33716cdef222842d$export$b97bbe8a7805284f(noIn);
}
function $33716cdef222842d$export$b97bbe8a7805284f(noIn = false, isWithinParens = false) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) return (0, $e018f01e7ae86c9a$export$daa24143ef798a56)(noIn, isWithinParens);
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) return (0, $f67d067f0232af34$export$abad2599830a7c66)(noIn, isWithinParens);
    else return $33716cdef222842d$export$bb0065dd8e05bcbd(noIn, isWithinParens);
}
function $33716cdef222842d$export$bb0065dd8e05bcbd(noIn, isWithinParens) {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._yield)) {
        $33716cdef222842d$var$parseYield();
        return false;
    }
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._yield)) (0, $d9d7db628df75264$export$ca000e230c0caa3e).potentialArrowAt = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
    const wasArrow = $33716cdef222842d$var$parseMaybeConditional(noIn);
    if (isWithinParens) $33716cdef222842d$var$parseParenItem();
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_ASSIGN) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        $33716cdef222842d$export$b97bbe8a7805284f(noIn);
        return false;
    }
    return wasArrow;
}
// Parse a ternary conditional (`?:`) operator.
// Returns true if the expression was an arrow function.
function $33716cdef222842d$var$parseMaybeConditional(noIn) {
    const wasArrow = $33716cdef222842d$var$parseExprOps(noIn);
    if (wasArrow) return true;
    $33716cdef222842d$var$parseConditional(noIn);
    return false;
}
function $33716cdef222842d$var$parseConditional(noIn) {
    if ((0, $d9d7db628df75264$export$757c2735689d2de8) || (0, $d9d7db628df75264$export$92e334f8fe49aa94)) (0, $a2a0a59f54890825$export$a1aa0436beedb1fa)(noIn);
    else $33716cdef222842d$export$a3d1b6cb707072ce(noIn);
}
function $33716cdef222842d$export$a3d1b6cb707072ce(noIn) {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question)) {
        $33716cdef222842d$export$b97bbe8a7805284f();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
        $33716cdef222842d$export$b97bbe8a7805284f(noIn);
    }
}
// Start the precedence parser.
// Returns true if this was an arrow function
function $33716cdef222842d$var$parseExprOps(noIn) {
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    const wasArrow = $33716cdef222842d$export$165911d2b803e372();
    if (wasArrow) return true;
    $33716cdef222842d$var$parseExprOp(startTokenIndex, -1, noIn);
    return false;
}
// Parse binary operators with the operator precedence parsing
// algorithm. `left` is the left-hand side of the operator.
// `minPrec` provides context that allows the function to stop and
// defer further parser to one of its callers when it encounters an
// operator that has a lower precedence than the set it is parsing.
function $33716cdef222842d$var$parseExprOp(startTokenIndex, minPrec, noIn) {
    if ((0, $d9d7db628df75264$export$757c2735689d2de8) && ((0, $c455753917f2f29d$export$f435f793048e7a0f)._in & (0, $c455753917f2f29d$export$f435f793048e7a0f).PRECEDENCE_MASK) > minPrec && !(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)() && ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as) || (0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._satisfies))) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
        (0, $e018f01e7ae86c9a$export$13a289e680c077c1)();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        (0, $d45b756a11a5dc19$export$4d00b4f4d9d7a9b3)();
        $33716cdef222842d$var$parseExprOp(startTokenIndex, minPrec, noIn);
        return;
    }
    const prec = (0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).PRECEDENCE_MASK;
    if (prec > 0 && (!noIn || !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._in))) {
        if (prec > minPrec) {
            const op = (0, $d9d7db628df75264$export$ca000e230c0caa3e).type;
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            if (op === (0, $c455753917f2f29d$export$f435f793048e7a0f).nullishCoalescing) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].nullishStartIndex = startTokenIndex;
            const rhsStartTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
            $33716cdef222842d$export$165911d2b803e372();
            // Extend the right operand of this operator if possible.
            $33716cdef222842d$var$parseExprOp(rhsStartTokenIndex, op & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_RIGHT_ASSOCIATIVE ? prec - 1 : prec, noIn);
            if (op === (0, $c455753917f2f29d$export$f435f793048e7a0f).nullishCoalescing) {
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[startTokenIndex].numNullishCoalesceStarts++;
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].numNullishCoalesceEnds++;
            }
            // Continue with any future operator holding this expression as the left operand.
            $33716cdef222842d$var$parseExprOp(startTokenIndex, minPrec, noIn);
        }
    }
}
function $33716cdef222842d$export$165911d2b803e372() {
    if ((0, $d9d7db628df75264$export$757c2735689d2de8) && !(0, $d9d7db628df75264$export$43bb667a94af025a) && (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
        (0, $e018f01e7ae86c9a$export$ecfac1712a900e29)();
        return false;
    }
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module) && (0, $d45b756a11a5dc19$export$847169391b2516b8)() === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).leftCurlyBrace && !(0, $85f046d5f58d0c41$export$a4f1ee8cbd9b31ba)()) {
        $33716cdef222842d$var$parseModuleExpression();
        return false;
    }
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_PREFIX) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        $33716cdef222842d$export$165911d2b803e372();
        return false;
    }
    const wasArrow = $33716cdef222842d$export$dba7f678c228244a();
    if (wasArrow) return true;
    while((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_POSTFIX && !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)()){
        // The tokenizer calls everything a preincrement, so make it a postincrement when
        // we see it in that context.
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f).preIncDec) (0, $d9d7db628df75264$export$ca000e230c0caa3e).type = (0, $c455753917f2f29d$export$f435f793048e7a0f).postIncDec;
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    }
    return false;
}
function $33716cdef222842d$export$dba7f678c228244a() {
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    const wasArrow = $33716cdef222842d$export$fa61731cf32bc243();
    if (wasArrow) return true;
    $33716cdef222842d$var$parseSubscripts(startTokenIndex);
    // If there was any optional chain operation, the start token would be marked
    // as such, so also mark the end now.
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length > startTokenIndex && (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isOptionalChainEnd = true;
    return false;
}
function $33716cdef222842d$var$parseSubscripts(startTokenIndex, noCalls = false) {
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$7c7ba3c0c5ae1f67)(startTokenIndex, noCalls);
    else $33716cdef222842d$export$c2cc03eea353aa42(startTokenIndex, noCalls);
}
function $33716cdef222842d$export$c2cc03eea353aa42(startTokenIndex, noCalls = false) {
    const stopState = new $33716cdef222842d$export$8cd93656cd4760(false);
    do $33716cdef222842d$var$parseSubscript(startTokenIndex, noCalls, stopState);
    while (!stopState.stop && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error);
}
function $33716cdef222842d$var$parseSubscript(startTokenIndex, noCalls, stopState) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$f6cd10065188a17f)(startTokenIndex, noCalls, stopState);
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$4eb11794b3b71235)(startTokenIndex, noCalls, stopState);
    else $33716cdef222842d$export$31dc8e486c1a1be6(startTokenIndex, noCalls, stopState);
}
function $33716cdef222842d$export$31dc8e486c1a1be6(startTokenIndex, noCalls, stopState) {
    if (!noCalls && (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).doubleColon)) {
        $33716cdef222842d$var$parseNoCallExpr();
        stopState.stop = true;
        // Propagate startTokenIndex so that `a::b?.()` will keep `a` as the first token. We may want
        // to revisit this in the future when fully supporting bind syntax.
        $33716cdef222842d$var$parseSubscripts(startTokenIndex, noCalls);
    } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[startTokenIndex].isOptionalChainStart = true;
        if (noCalls && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) {
            stopState.stop = true;
            return;
        }
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) {
            $33716cdef222842d$export$ed9c825e502c46c8();
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
        } else if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) $33716cdef222842d$export$970763873d9efa73();
        else $33716cdef222842d$var$parseMaybePrivateName();
    } else if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $33716cdef222842d$var$parseMaybePrivateName();
    } else if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
        $33716cdef222842d$export$ed9c825e502c46c8();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
    } else if (!noCalls && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
        if ($33716cdef222842d$export$960e7b0728d0d49e()) {
            // We see "async", but it's possible it's a usage of the name "async". Parse as if it's a
            // function call, and if we see an arrow later, backtrack and re-parse as a parameter list.
            const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
            const asyncStartTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            const callContextId = (0, $d9d7db628df75264$export$d0c215ddd78b3d24)();
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            $33716cdef222842d$export$970763873d9efa73();
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            if ($33716cdef222842d$var$shouldParseAsyncArrow()) {
                // We hit an arrow, so backtrack and start again parsing function parameters.
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
                stopState.stop = true;
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
                (0, $1eea8ad3ef6f406b$export$dd0fc1c64275f2c4)();
                $33716cdef222842d$var$parseAsyncArrowFromCallExpression(asyncStartTokenIndex);
            }
        } else {
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].subscriptStartIndex = startTokenIndex;
            const callContextId = (0, $d9d7db628df75264$export$d0c215ddd78b3d24)();
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
            $33716cdef222842d$export$970763873d9efa73();
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = callContextId;
        }
    } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).backQuote)) // Tagged template expression.
    $33716cdef222842d$export$2e2dbd43b49fd373();
    else stopState.stop = true;
}
function $33716cdef222842d$export$960e7b0728d0d49e() {
    // This was made less strict than the original version to avoid passing around nodes, but it
    // should be safe to have rare false positives here.
    return (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async && !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)();
}
function $33716cdef222842d$export$970763873d9efa73() {
    let first = true;
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR)) break;
        }
        $33716cdef222842d$var$parseExprListItem(false);
    }
}
function $33716cdef222842d$var$shouldParseAsyncArrow() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
}
function $33716cdef222842d$var$parseAsyncArrowFromCallExpression(startTokenIndex) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$490a9bc22f3cab3f)();
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$6c11d14a2632a0dc)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
    $33716cdef222842d$export$9286d8f9fb90b029(startTokenIndex);
}
// Parse a no-call expression (like argument of `new` or `::` operators).
function $33716cdef222842d$var$parseNoCallExpr() {
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    $33716cdef222842d$export$fa61731cf32bc243();
    $33716cdef222842d$var$parseSubscripts(startTokenIndex, true);
}
function $33716cdef222842d$export$fa61731cf32bc243() {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).modulo)) {
        // V8 intrinsic expression. Just parse the identifier, and the function invocation is parsed
        // naturally.
        $33716cdef222842d$export$321543c11f6250ad();
        return false;
    }
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxText) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxEmptyText)) {
        $33716cdef222842d$export$d1b3e78ad34a47ef();
        return false;
    } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) && (0, $d9d7db628df75264$export$43bb667a94af025a)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).type = (0, $c455753917f2f29d$export$f435f793048e7a0f).jsxTagStart;
        (0, $c87336ed1c501cb2$export$7cbe8c53d909e342)();
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        return false;
    }
    const canBeArrow = (0, $d9d7db628df75264$export$ca000e230c0caa3e).potentialArrowAt === (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
    switch((0, $d9d7db628df75264$export$ca000e230c0caa3e).type){
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).slash:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).assign:
            (0, $d45b756a11a5dc19$export$f6864f1ed2347988)();
        // Fall through.
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._super:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._this:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).regexp:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).num:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).bigint:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).decimal:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).string:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._null:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._true:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._false:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._import:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) {
                // import.meta
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f).name;
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                $33716cdef222842d$export$321543c11f6250ad();
            }
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).name:
            {
                const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
                const functionStart = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
                const contextualKeyword = (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword;
                $33716cdef222842d$export$321543c11f6250ad();
                if (contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._await) {
                    $33716cdef222842d$var$parseAwait();
                    return false;
                } else if (contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function) && !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)()) {
                    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                    (0, $1eea8ad3ef6f406b$export$ba3dc2bd7c065219)(functionStart, false);
                    return false;
                } else if (canBeArrow && contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async && !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)() && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
                    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
                    (0, $24b5f7a89f6adf6c$export$7538cb03fa894c83)(false);
                    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
                    // let foo = async bar => {};
                    $33716cdef222842d$export$9286d8f9fb90b029(startTokenIndex);
                    return true;
                } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._do) && !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)()) {
                    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                    (0, $1eea8ad3ef6f406b$export$4aed668c47d45036)();
                    return false;
                }
                if (canBeArrow && !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)() && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow)) {
                    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
                    (0, $24b5f7a89f6adf6c$export$80e4117797ed03a6)(false);
                    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
                    $33716cdef222842d$export$9286d8f9fb90b029(startTokenIndex);
                    return true;
                }
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).Access;
                return false;
            }
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._do:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            (0, $1eea8ad3ef6f406b$export$4aed668c47d45036)();
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL:
            {
                const wasArrow = $33716cdef222842d$var$parseParenAndDistinguishExpression(canBeArrow);
                return wasArrow;
            }
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            $33716cdef222842d$var$parseExprList((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR, true);
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL:
            $33716cdef222842d$export$908e61e44ae774e(false, false);
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._function:
            $33716cdef222842d$var$parseFunctionExpression();
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).at:
            (0, $1eea8ad3ef6f406b$export$3f4d9519f687227a)();
        // Fall through.
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._class:
            (0, $1eea8ad3ef6f406b$export$542081d93172af)(false);
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._new:
            $33716cdef222842d$var$parseNew();
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).backQuote:
            $33716cdef222842d$export$2e2dbd43b49fd373();
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).doubleColon:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            $33716cdef222842d$var$parseNoCallExpr();
            return false;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).hash:
            {
                const code = (0, $d45b756a11a5dc19$export$847169391b2516b8)();
                if ((0, $d6dc0379bdf024ad$export$dc1d1d7d9fdffb8)[code] || code === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).backslash) $33716cdef222842d$var$parseMaybePrivateName();
                else (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                // Smart pipeline topic reference.
                return false;
            }
        default:
            (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
            return false;
    }
}
function $33716cdef222842d$var$parseMaybePrivateName() {
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).hash);
    $33716cdef222842d$export$321543c11f6250ad();
}
function $33716cdef222842d$var$parseFunctionExpression() {
    const functionStart = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
    $33716cdef222842d$export$321543c11f6250ad();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) // function.sent
    $33716cdef222842d$export$321543c11f6250ad();
    (0, $1eea8ad3ef6f406b$export$ba3dc2bd7c065219)(functionStart, false);
}
function $33716cdef222842d$export$d1b3e78ad34a47ef() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
}
function $33716cdef222842d$export$d5ddb48bead5eb08() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    $33716cdef222842d$export$ed9c825e502c46c8();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
}
// Returns true if this was an arrow expression.
function $33716cdef222842d$var$parseParenAndDistinguishExpression(canBeArrow) {
    // Assume this is a normal parenthesized expression, but if we see an arrow, we'll bail and
    // start over as a parameter list.
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    let first = true;
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR)) break;
        }
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) {
            (0, $24b5f7a89f6adf6c$export$9504bd2748b5750c)(false);
            $33716cdef222842d$var$parseParenItem();
            break;
        } else $33716cdef222842d$export$b97bbe8a7805284f(false, true);
    }
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    if (canBeArrow && $33716cdef222842d$var$shouldParseArrow()) {
        const wasArrow = $33716cdef222842d$export$92291a002e3a40fe();
        if (wasArrow) {
            // It was an arrow function this whole time, so start over and parse it as params so that we
            // get proper token annotations.
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
            // Don't specify a context ID because arrow functions don't need a context ID.
            (0, $1eea8ad3ef6f406b$export$dd0fc1c64275f2c4)();
            $33716cdef222842d$export$92291a002e3a40fe();
            $33716cdef222842d$export$9286d8f9fb90b029(startTokenIndex);
            if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) {
                // Nevermind! This must have been something that looks very much like an
                // arrow function but where its "parameter list" isn't actually a valid
                // parameter list. Force non-arrow parsing.
                // See https://github.com/alangpierce/sucrase/issues/666 for an example.
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
                $33716cdef222842d$var$parseParenAndDistinguishExpression(false);
                return false;
            }
            return true;
        }
    }
    return false;
}
function $33716cdef222842d$var$shouldParseArrow() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon) || !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)();
}
function $33716cdef222842d$export$92291a002e3a40fe() {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) return (0, $e018f01e7ae86c9a$export$e20067ab7c70da1d)();
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) return (0, $f67d067f0232af34$export$1ee5238ec4961bad)();
    else return (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
}
function $33716cdef222842d$var$parseParenItem() {
    if ((0, $d9d7db628df75264$export$757c2735689d2de8) || (0, $d9d7db628df75264$export$92e334f8fe49aa94)) (0, $a2a0a59f54890825$export$72bae99899f77e0f)();
}
// New's precedence is slightly tricky. It must allow its argument to
// be a `[]` or dot subscript expression, but not a call — at least,
// not without wrapping it in parentheses. Thus, it uses the noCalls
// argument to parseSubscripts to prevent it from consuming the
// argument list.
function $33716cdef222842d$var$parseNew() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._new);
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) {
        // new.target
        $33716cdef222842d$export$321543c11f6250ad();
        return;
    }
    $33716cdef222842d$var$parseNewCallee();
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$3d50348827f45b9a)();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) $33716cdef222842d$var$parseExprList((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
}
function $33716cdef222842d$var$parseNewCallee() {
    $33716cdef222842d$var$parseNoCallExpr();
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot);
}
function $33716cdef222842d$export$2e2dbd43b49fd373() {
    // Finish `, read quasi
    (0, $d45b756a11a5dc19$export$e4355ff2fab571ee)();
    // Finish quasi, read ${
    (0, $d45b756a11a5dc19$export$e4355ff2fab571ee)();
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).backQuote) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).dollarBraceL);
        $33716cdef222842d$export$ed9c825e502c46c8();
        // Finish }, read quasi
        (0, $d45b756a11a5dc19$export$e4355ff2fab571ee)();
        // Finish quasi, read either ${ or `
        (0, $d45b756a11a5dc19$export$e4355ff2fab571ee)();
    }
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
}
function $33716cdef222842d$export$908e61e44ae774e(isPattern, isBlockScope) {
    // Attach a context ID to the object open and close brace and each object key.
    const contextId = (0, $d9d7db628df75264$export$d0c215ddd78b3d24)();
    let first = true;
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) break;
        }
        let isGenerator = false;
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) {
            const previousIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
            (0, $24b5f7a89f6adf6c$export$83bfd0877be8807a)();
            if (isPattern) {
                // Mark role when the only thing being spread over is an identifier.
                if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length === previousIndex + 2) (0, $24b5f7a89f6adf6c$export$80e4117797ed03a6)(isBlockScope);
                if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) break;
            }
            continue;
        }
        if (!isPattern) isGenerator = (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).star);
        if (!isPattern && (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async)) {
            if (isGenerator) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
            $33716cdef222842d$export$321543c11f6250ad();
            if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) ;
            else {
                if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star)) {
                    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                    isGenerator = true;
                }
                $33716cdef222842d$export$ab65037f9c8fb3d3(contextId);
            }
        } else $33716cdef222842d$export$ab65037f9c8fb3d3(contextId);
        $33716cdef222842d$var$parseObjPropValue(isPattern, isBlockScope, contextId);
    }
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
}
function $33716cdef222842d$var$isGetterOrSetterMethod(isPattern) {
    // We go off of the next and don't bother checking if the node key is actually "get" or "set".
    // This lets us avoid generating a node, and should only make the validation worse.
    return !isPattern && ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string) || // get "string"() {}
    (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).num) || // get 1() {}
    (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL) || // get ["string"]() {}
    (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || // get foo() {}
    !!((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_KEYWORD) // get debugger() {}
    );
}
// Returns true if this was a method.
function $33716cdef222842d$var$parseObjectMethod(isPattern, objectContextId) {
    // We don't need to worry about modifiers because object methods can't have optional bodies, so
    // the start will never be used.
    const functionStart = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
        if (isPattern) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
        $33716cdef222842d$export$9b0b57f9abc43790(functionStart, /* isConstructor */ false);
        return true;
    }
    if ($33716cdef222842d$var$isGetterOrSetterMethod(isPattern)) {
        $33716cdef222842d$export$ab65037f9c8fb3d3(objectContextId);
        $33716cdef222842d$export$9b0b57f9abc43790(functionStart, /* isConstructor */ false);
        return true;
    }
    return false;
}
function $33716cdef222842d$var$parseObjectProperty(isPattern, isBlockScope) {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) {
        if (isPattern) (0, $24b5f7a89f6adf6c$export$867fe1bcec5186c9)(isBlockScope);
        else $33716cdef222842d$export$b97bbe8a7805284f(false);
        return;
    }
    // Since there's no colon, we assume this is an object shorthand.
    // If we're in a destructuring, we've now discovered that the key was actually an assignee, so
    // we need to tag it as a declaration with the appropriate scope. Otherwise, we might need to
    // transform it on access, so mark it as a normal object shorthand.
    let identifierRole;
    if (isPattern) {
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth === 0) identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectShorthandTopLevelDeclaration;
        else if (isBlockScope) identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectShorthandBlockScopedDeclaration;
        else identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectShorthandFunctionScopedDeclaration;
    } else identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectShorthand;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = identifierRole;
    // Regardless of whether we know this to be a pattern or if we're in an ambiguous context, allow
    // parsing as if there's a default value.
    (0, $24b5f7a89f6adf6c$export$867fe1bcec5186c9)(isBlockScope, true);
}
function $33716cdef222842d$var$parseObjPropValue(isPattern, isBlockScope, objectContextId) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$f7c2ce498525881a)();
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$73c225682ce16be1)();
    const wasMethod = $33716cdef222842d$var$parseObjectMethod(isPattern, objectContextId);
    if (!wasMethod) $33716cdef222842d$var$parseObjectProperty(isPattern, isBlockScope);
}
function $33716cdef222842d$export$ab65037f9c8fb3d3(objectContextId) {
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$addd776ef798f4b2)();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
        $33716cdef222842d$export$b97bbe8a7805284f();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
    } else {
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).num) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bigint) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).decimal)) $33716cdef222842d$export$fa61731cf32bc243();
        else $33716cdef222842d$var$parseMaybePrivateName();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectKey;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = objectContextId;
    }
}
function $33716cdef222842d$export$9b0b57f9abc43790(functionStart, isConstructor) {
    const funcContextId = (0, $d9d7db628df75264$export$d0c215ddd78b3d24)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    const allowModifiers = isConstructor; // For TypeScript parameter properties
    (0, $1eea8ad3ef6f406b$export$dd0fc1c64275f2c4)(allowModifiers, funcContextId);
    $33716cdef222842d$export$85b927192bdce5b9(functionStart, funcContextId);
    const endTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
}
function $33716cdef222842d$export$9286d8f9fb90b029(startTokenIndex) {
    $33716cdef222842d$export$50f85c246417e18(true);
    const endTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
}
function $33716cdef222842d$export$85b927192bdce5b9(functionStart, funcContextId = 0) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$3c36bc5140dd8c64)(functionStart, funcContextId);
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$8dd4098a83322b31)(funcContextId);
    else $33716cdef222842d$export$50f85c246417e18(false, funcContextId);
}
function $33716cdef222842d$export$50f85c246417e18(allowExpression, funcContextId = 0) {
    const isExpression = allowExpression && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    if (isExpression) $33716cdef222842d$export$b97bbe8a7805284f();
    else (0, $1eea8ad3ef6f406b$export$4aed668c47d45036)(true, funcContextId);
}
// Parses a comma-separated list of expressions, and returns them as
// an array. `close` is the token type that ends the list, and
// `allowEmpty` can be turned on to allow subsequent commas with
// nothing in between them to be parsed as `null` (which is needed
// for array literals).
function $33716cdef222842d$var$parseExprList(close, allowEmpty = false) {
    let first = true;
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)(close) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)(close)) break;
        }
        $33716cdef222842d$var$parseExprListItem(allowEmpty);
    }
}
function $33716cdef222842d$var$parseExprListItem(allowEmpty) {
    if (allowEmpty && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) ;
    else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) {
        (0, $24b5f7a89f6adf6c$export$83bfd0877be8807a)();
        $33716cdef222842d$var$parseParenItem();
    } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).question)) // Partial function application proposal.
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    else $33716cdef222842d$export$b97bbe8a7805284f(false, true);
}
function $33716cdef222842d$export$321543c11f6250ad() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f).name;
}
// Parses await expression inside async function.
function $33716cdef222842d$var$parseAwait() {
    $33716cdef222842d$export$165911d2b803e372();
}
// Parses yield expression inside generator.
function $33716cdef222842d$var$parseYield() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi) && !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)()) {
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).star);
        $33716cdef222842d$export$b97bbe8a7805284f();
    }
}
// https://github.com/tc39/proposal-js-module-blocks
function $33716cdef222842d$var$parseModuleExpression() {
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    // For now, just call parseBlockBody to parse the block. In the future when we
    // implement full support, we'll want to emit scopes and possibly other
    // information.
    (0, $1eea8ad3ef6f406b$export$e5110a9b2ab486ee)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
}




function $f67d067f0232af34$var$isMaybeDefaultImport(lookahead) {
    return (lookahead.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name || !!(lookahead.type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_KEYWORD)) && lookahead.contextualKeyword !== (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from;
}
function $f67d067f0232af34$var$flowParseTypeInitialiser(tok) {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)(tok || (0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    $f67d067f0232af34$var$flowParseType();
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $f67d067f0232af34$var$flowParsePredicate() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).modulo);
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._checks);
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
        (0, $33716cdef222842d$export$ed9c825e502c46c8)();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    }
}
function $f67d067f0232af34$var$flowParseTypeAndPredicateInitialiser() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).modulo)) $f67d067f0232af34$var$flowParsePredicate();
    else {
        $f67d067f0232af34$var$flowParseType();
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).modulo)) $f67d067f0232af34$var$flowParsePredicate();
    }
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $f67d067f0232af34$var$flowParseDeclareClass() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $f67d067f0232af34$var$flowParseInterfaceish(/* isClass */ true);
}
function $f67d067f0232af34$var$flowParseDeclareFunction() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$export$d1d23833c686097a();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    $f67d067f0232af34$var$flowParseFunctionTypeParams();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    $f67d067f0232af34$var$flowParseTypeAndPredicateInitialiser();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $f67d067f0232af34$var$flowParseDeclare() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._class)) $f67d067f0232af34$var$flowParseDeclareClass();
    else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function)) $f67d067f0232af34$var$flowParseDeclareFunction();
    else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._var)) $f67d067f0232af34$var$flowParseDeclareVariable();
    else if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module)) {
        if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) $f67d067f0232af34$var$flowParseDeclareModuleExports();
        else $f67d067f0232af34$var$flowParseDeclareModule();
    } else if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) $f67d067f0232af34$var$flowParseDeclareTypeAlias();
    else if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._opaque)) $f67d067f0232af34$var$flowParseDeclareOpaqueType();
    else if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface)) $f67d067f0232af34$var$flowParseDeclareInterface();
    else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._export)) $f67d067f0232af34$var$flowParseDeclareExportDeclaration();
    else (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
}
function $f67d067f0232af34$var$flowParseDeclareVariable() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $f67d067f0232af34$var$flowParseTypeAnnotatableIdentifier();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $f67d067f0232af34$var$flowParseDeclareModule() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) (0, $33716cdef222842d$export$fa61731cf32bc243)();
    else (0, $33716cdef222842d$export$321543c11f6250ad)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error)if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._import)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $1eea8ad3ef6f406b$export$532df1d0416e9789)();
    } else (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
}
function $f67d067f0232af34$var$flowParseDeclareExportDeclaration() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._export);
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._default)) {
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._class)) // declare export default class ...
        // declare export default function ...
        $f67d067f0232af34$var$flowParseDeclare();
        else {
            // declare export default [type];
            $f67d067f0232af34$var$flowParseType();
            (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
        }
    } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._var) || // declare export var ...
    (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function) || // declare export function ...
    (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._class) || // declare export class ...
    (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._opaque) // declare export opaque ..
    ) $f67d067f0232af34$var$flowParseDeclare();
    else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star) || // declare export * from ''
    (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || // declare export {} ...
    (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface) || // declare export interface ...
    (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type) || // declare export type ...
    (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._opaque) // declare export opaque type ...
    ) (0, $1eea8ad3ef6f406b$export$3d6d7ef9486a61c3)();
    else (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
}
function $f67d067f0232af34$var$flowParseDeclareModuleExports() {
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._exports);
    $f67d067f0232af34$export$6c833037db1a1e96();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $f67d067f0232af34$var$flowParseDeclareTypeAlias() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $f67d067f0232af34$var$flowParseTypeAlias();
}
function $f67d067f0232af34$var$flowParseDeclareOpaqueType() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $f67d067f0232af34$var$flowParseOpaqueType(true);
}
function $f67d067f0232af34$var$flowParseDeclareInterface() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $f67d067f0232af34$var$flowParseInterfaceish();
}
// Interfaces
function $f67d067f0232af34$var$flowParseInterfaceish(isClass = false) {
    $f67d067f0232af34$var$flowParseRestrictedIdentifier();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$export$d1d23833c686097a();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends)) do $f67d067f0232af34$var$flowParseInterfaceExtends();
    while (!isClass && (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma));
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._mixins)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        do $f67d067f0232af34$var$flowParseInterfaceExtends();
        while ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma));
    }
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._implements)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        do $f67d067f0232af34$var$flowParseInterfaceExtends();
        while ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma));
    }
    $f67d067f0232af34$var$flowParseObjectType(isClass, false, isClass);
}
function $f67d067f0232af34$var$flowParseInterfaceExtends() {
    $f67d067f0232af34$var$flowParseQualifiedTypeIdentifier(false);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$var$flowParseTypeParameterInstantiation();
}
function $f67d067f0232af34$var$flowParseInterface() {
    $f67d067f0232af34$var$flowParseInterfaceish();
}
function $f67d067f0232af34$var$flowParseRestrictedIdentifier() {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
}
function $f67d067f0232af34$var$flowParseTypeAlias() {
    $f67d067f0232af34$var$flowParseRestrictedIdentifier();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$export$d1d23833c686097a();
    $f67d067f0232af34$var$flowParseTypeInitialiser((0, $c455753917f2f29d$export$f435f793048e7a0f).eq);
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $f67d067f0232af34$var$flowParseOpaqueType(declare) {
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type);
    $f67d067f0232af34$var$flowParseRestrictedIdentifier();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$export$d1d23833c686097a();
    // Parse the supertype
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $f67d067f0232af34$var$flowParseTypeInitialiser((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    if (!declare) $f67d067f0232af34$var$flowParseTypeInitialiser((0, $c455753917f2f29d$export$f435f793048e7a0f).eq);
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $f67d067f0232af34$var$flowParseTypeParameter() {
    $f67d067f0232af34$export$addd776ef798f4b2();
    $f67d067f0232af34$var$flowParseTypeAnnotatableIdentifier();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) $f67d067f0232af34$var$flowParseType();
}
function $f67d067f0232af34$export$d1d23833c686097a() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    // istanbul ignore else: this condition is already checked at all call sites
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).typeParameterStart)) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    else (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    do {
        $f67d067f0232af34$var$flowParseTypeParameter();
        if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan)) (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }while (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan);
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $f67d067f0232af34$var$flowParseTypeParameterInstantiation() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan);
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        $f67d067f0232af34$var$flowParseType();
        if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan)) (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).greaterThan);
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $f67d067f0232af34$var$flowParseInterfaceType() {
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface);
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends)) do $f67d067f0232af34$var$flowParseInterfaceExtends();
    while ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma));
    $f67d067f0232af34$var$flowParseObjectType(false, false, false);
}
function $f67d067f0232af34$var$flowParseObjectPropertyKey() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).num) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) (0, $33716cdef222842d$export$fa61731cf32bc243)();
    else (0, $33716cdef222842d$export$321543c11f6250ad)();
}
function $f67d067f0232af34$var$flowParseObjectTypeIndexer() {
    // Note: bracketL has already been consumed
    if ((0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).colon) {
        $f67d067f0232af34$var$flowParseObjectPropertyKey();
        $f67d067f0232af34$var$flowParseTypeInitialiser();
    } else $f67d067f0232af34$var$flowParseType();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
    $f67d067f0232af34$var$flowParseTypeInitialiser();
}
function $f67d067f0232af34$var$flowParseObjectTypeInternalSlot() {
    // Note: both bracketL have already been consumed
    $f67d067f0232af34$var$flowParseObjectPropertyKey();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) $f67d067f0232af34$var$flowParseObjectTypeMethodish();
    else {
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
        $f67d067f0232af34$var$flowParseTypeInitialiser();
    }
}
function $f67d067f0232af34$var$flowParseObjectTypeMethodish() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$export$d1d23833c686097a();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        $f67d067f0232af34$var$flowParseFunctionTypeParam();
        if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR)) (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) $f67d067f0232af34$var$flowParseFunctionTypeParam();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    $f67d067f0232af34$var$flowParseTypeInitialiser();
}
function $f67d067f0232af34$var$flowParseObjectTypeCallProperty() {
    $f67d067f0232af34$var$flowParseObjectTypeMethodish();
}
function $f67d067f0232af34$var$flowParseObjectType(allowStatic, allowExact, allowProto) {
    let endDelim;
    if (allowExact && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceBarL)) {
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceBarL);
        endDelim = (0, $c455753917f2f29d$export$f435f793048e7a0f).braceBarR;
    } else {
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
        endDelim = (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR;
    }
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)(endDelim) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if (allowProto && (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._proto)) {
            const lookahead = (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)();
            if (lookahead !== (0, $c455753917f2f29d$export$f435f793048e7a0f).colon && lookahead !== (0, $c455753917f2f29d$export$f435f793048e7a0f).question) {
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                allowStatic = false;
            }
        }
        if (allowStatic && (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._static)) {
            const lookahead = (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)();
            if (lookahead !== (0, $c455753917f2f29d$export$f435f793048e7a0f).colon && lookahead !== (0, $c455753917f2f29d$export$f435f793048e7a0f).question) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        }
        $f67d067f0232af34$export$addd776ef798f4b2();
        if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) {
            if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) $f67d067f0232af34$var$flowParseObjectTypeInternalSlot();
            else $f67d067f0232af34$var$flowParseObjectTypeIndexer();
        } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$var$flowParseObjectTypeCallProperty();
        else {
            if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._get) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._set)) {
                const lookahead = (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)();
                if (lookahead === (0, $c455753917f2f29d$export$f435f793048e7a0f).name || lookahead === (0, $c455753917f2f29d$export$f435f793048e7a0f).string || lookahead === (0, $c455753917f2f29d$export$f435f793048e7a0f).num) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            }
            $f67d067f0232af34$var$flowParseObjectTypeProperty();
        }
        $f67d067f0232af34$var$flowObjectTypeSemicolon();
    }
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)(endDelim);
}
function $f67d067f0232af34$var$flowParseObjectTypeProperty() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) {
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis);
        if (!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi);
        // Explicit inexact object syntax.
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) return;
        $f67d067f0232af34$var$flowParseType();
    } else {
        $f67d067f0232af34$var$flowParseObjectPropertyKey();
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) // This is a method property
        $f67d067f0232af34$var$flowParseObjectTypeMethodish();
        else {
            (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
            $f67d067f0232af34$var$flowParseTypeInitialiser();
        }
    }
}
function $f67d067f0232af34$var$flowObjectTypeSemicolon() {
    if (!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi) && !(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceBarR)) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
}
function $f67d067f0232af34$var$flowParseQualifiedTypeIdentifier(initialIdAlreadyParsed) {
    if (!initialIdAlreadyParsed) (0, $33716cdef222842d$export$321543c11f6250ad)();
    while((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot))(0, $33716cdef222842d$export$321543c11f6250ad)();
}
function $f67d067f0232af34$var$flowParseGenericType() {
    $f67d067f0232af34$var$flowParseQualifiedTypeIdentifier(true);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$var$flowParseTypeParameterInstantiation();
}
function $f67d067f0232af34$var$flowParseTypeofType() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._typeof);
    $f67d067f0232af34$var$flowParsePrimaryType();
}
function $f67d067f0232af34$var$flowParseTupleType() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL);
    // We allow trailing commas
    while((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos < (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).length && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR)){
        $f67d067f0232af34$var$flowParseType();
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR)) break;
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
}
function $f67d067f0232af34$var$flowParseFunctionTypeParam() {
    const lookahead = (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)();
    if (lookahead === (0, $c455753917f2f29d$export$f435f793048e7a0f).colon || lookahead === (0, $c455753917f2f29d$export$f435f793048e7a0f).question) {
        (0, $33716cdef222842d$export$321543c11f6250ad)();
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
        $f67d067f0232af34$var$flowParseTypeInitialiser();
    } else $f67d067f0232af34$var$flowParseType();
}
function $f67d067f0232af34$var$flowParseFunctionTypeParams() {
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        $f67d067f0232af34$var$flowParseFunctionTypeParam();
        if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR)) (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) $f67d067f0232af34$var$flowParseFunctionTypeParam();
}
// The parsing of types roughly parallels the parsing of expressions, and
// primary types are kind of like primary expressions...they're the
// primitives with which other types are constructed.
function $f67d067f0232af34$var$flowParsePrimaryType() {
    let isGroupedType = false;
    const oldNoAnonFunctionType = (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType;
    switch((0, $d9d7db628df75264$export$ca000e230c0caa3e).type){
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).name:
            if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface)) {
                $f67d067f0232af34$var$flowParseInterfaceType();
                return;
            }
            (0, $33716cdef222842d$export$321543c11f6250ad)();
            $f67d067f0232af34$var$flowParseGenericType();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL:
            $f67d067f0232af34$var$flowParseObjectType(false, false, false);
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).braceBarL:
            $f67d067f0232af34$var$flowParseObjectType(false, true, false);
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL:
            $f67d067f0232af34$var$flowParseTupleType();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan:
            $f67d067f0232af34$export$d1d23833c686097a();
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
            $f67d067f0232af34$var$flowParseFunctionTypeParams();
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
            $f67d067f0232af34$var$flowParseType();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            // Check to see if this is actually a grouped type
            if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) {
                if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
                    const token = (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)();
                    isGroupedType = token !== (0, $c455753917f2f29d$export$f435f793048e7a0f).question && token !== (0, $c455753917f2f29d$export$f435f793048e7a0f).colon;
                } else isGroupedType = true;
            }
            if (isGroupedType) {
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType = false;
                $f67d067f0232af34$var$flowParseType();
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
                // A `,` or a `) =>` means this is an anonymous function type
                if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType || !((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).arrow)) {
                    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
                    return;
                } else // Eat a comma if there is one
                (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            }
            $f67d067f0232af34$var$flowParseFunctionTypeParams();
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
            $f67d067f0232af34$var$flowParseType();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).minus:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            (0, $33716cdef222842d$export$d1b3e78ad34a47ef)();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).string:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).num:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._true:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._false:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._null:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._this:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._void:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).star:
            (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
            return;
        default:
            if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._typeof) {
                $f67d067f0232af34$var$flowParseTypeofType();
                return;
            } else if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_KEYWORD) {
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f).name;
                return;
            }
    }
    (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
}
function $f67d067f0232af34$var$flowParsePostfixType() {
    $f67d067f0232af34$var$flowParsePrimaryType();
    while(!(0, $85f046d5f58d0c41$export$1c0919cee6560c3)() && ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot))){
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot);
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL);
        if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR)) ;
        else {
            // Indexed access type
            $f67d067f0232af34$var$flowParseType();
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR);
        }
    }
}
function $f67d067f0232af34$var$flowParsePrefixType() {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question)) $f67d067f0232af34$var$flowParsePrefixType();
    else $f67d067f0232af34$var$flowParsePostfixType();
}
function $f67d067f0232af34$var$flowParseAnonFunctionWithoutParens() {
    $f67d067f0232af34$var$flowParsePrefixType();
    if (!(0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType && (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow)) $f67d067f0232af34$var$flowParseType();
}
function $f67d067f0232af34$var$flowParseIntersectionType() {
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseAND);
    $f67d067f0232af34$var$flowParseAnonFunctionWithoutParens();
    while((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseAND))$f67d067f0232af34$var$flowParseAnonFunctionWithoutParens();
}
function $f67d067f0232af34$var$flowParseUnionType() {
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseOR);
    $f67d067f0232af34$var$flowParseIntersectionType();
    while((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).bitwiseOR))$f67d067f0232af34$var$flowParseIntersectionType();
}
function $f67d067f0232af34$var$flowParseType() {
    $f67d067f0232af34$var$flowParseUnionType();
}
function $f67d067f0232af34$export$6c833037db1a1e96() {
    $f67d067f0232af34$var$flowParseTypeInitialiser();
}
function $f67d067f0232af34$var$flowParseTypeAnnotatableIdentifier() {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $f67d067f0232af34$export$6c833037db1a1e96();
}
function $f67d067f0232af34$export$addd776ef798f4b2() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).plus) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).minus)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isType = true;
    }
}
function $f67d067f0232af34$export$8dd4098a83322b31(funcContextId) {
    // For arrow functions, `parseArrow` handles the return type itself.
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $f67d067f0232af34$var$flowParseTypeAndPredicateInitialiser();
    (0, $33716cdef222842d$export$50f85c246417e18)(false, funcContextId);
}
function $f67d067f0232af34$export$4eb11794b3b71235(startTokenIndex, noCalls, stopState) {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) {
        if (noCalls) {
            stopState.stop = true;
            return;
        }
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        $f67d067f0232af34$var$flowParseTypeParameterInstantiation();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
        (0, $33716cdef222842d$export$970763873d9efa73)();
        return;
    } else if (!noCalls && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
        $f67d067f0232af34$var$flowParseTypeParameterInstantiation();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
        (0, $33716cdef222842d$export$970763873d9efa73)();
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        else return;
    }
    (0, $33716cdef222842d$export$31dc8e486c1a1be6)(startTokenIndex, noCalls, stopState);
}
function $f67d067f0232af34$export$3d50348827f45b9a() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
        $f67d067f0232af34$var$flowParseTypeParameterInstantiation();
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
}
function $f67d067f0232af34$export$d29f5a1d65cdba9d() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) && (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        $f67d067f0232af34$var$flowParseInterface();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        return true;
    } else if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum)) {
        $f67d067f0232af34$var$flowParseEnumDeclaration();
        return true;
    }
    return false;
}
function $f67d067f0232af34$export$c6f815d203f26c4f() {
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum)) {
        $f67d067f0232af34$var$flowParseEnumDeclaration();
        return true;
    }
    return false;
}
function $f67d067f0232af34$export$3b5c354482eb1586(contextualKeyword) {
    if (contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._declare) {
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._class) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._var) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._export)) {
            const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
            $f67d067f0232af34$var$flowParseDeclare();
            (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        }
    } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
        if (contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface) {
            const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
            $f67d067f0232af34$var$flowParseInterface();
            (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        } else if (contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type) {
            const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
            $f67d067f0232af34$var$flowParseTypeAlias();
            (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        } else if (contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._opaque) {
            const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
            $f67d067f0232af34$var$flowParseOpaqueType(false);
            (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        }
    }
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $f67d067f0232af34$export$74061750bc0f2203() {
    return (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._opaque) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum);
}
function $f67d067f0232af34$export$8a047f67d2009628() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) && ((0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type || (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface || (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._opaque || (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum);
}
function $f67d067f0232af34$export$64e87490a40a8a82() {
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            // export type { foo, bar };
            (0, $1eea8ad3ef6f406b$export$909d3b50f7924101)();
            (0, $1eea8ad3ef6f406b$export$49b6f13e189abea3)();
        } else // export type Foo = Bar;
        $f67d067f0232af34$var$flowParseTypeAlias();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    } else if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._opaque)) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        // export opaque type Foo = Bar;
        $f67d067f0232af34$var$flowParseOpaqueType(false);
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    } else if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._interface)) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(1);
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        $f67d067f0232af34$var$flowParseInterface();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    } else (0, $1eea8ad3ef6f406b$export$68b986de0b252bc8)(true);
}
function $f67d067f0232af34$export$563bbc61583bd08() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).star;
}
function $f67d067f0232af34$export$dc2ba80ebf42d8d6() {
    if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(2);
        (0, $1eea8ad3ef6f406b$export$18fb3cb64b956ba0)();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    } else (0, $1eea8ad3ef6f406b$export$18fb3cb64b956ba0)();
}
function $f67d067f0232af34$export$131557296be11580(hasSuper) {
    if (hasSuper && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$var$flowParseTypeParameterInstantiation();
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._implements)) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._implements;
        do {
            $f67d067f0232af34$var$flowParseRestrictedIdentifier();
            if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) $f67d067f0232af34$var$flowParseTypeParameterInstantiation();
        }while ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma));
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    }
}
function $f67d067f0232af34$export$73c225682ce16be1() {
    // method shorthand
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
        $f67d067f0232af34$export$d1d23833c686097a();
        if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    }
}
function $f67d067f0232af34$export$a9031cdcb39989e3() {
    const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $f67d067f0232af34$export$6c833037db1a1e96();
    (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
}
function $f67d067f0232af34$export$2ca2c81ecd0ec221() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._typeof) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
        const lh = (0, $d45b756a11a5dc19$export$ef1b94c514fc060a)();
        if ($f67d067f0232af34$var$isMaybeDefaultImport(lh) || lh.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL || lh.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).star) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    }
}
function $f67d067f0232af34$export$217da275bf556fe8() {
    const isTypeKeyword = (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type || (0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._typeof;
    if (isTypeKeyword) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    else (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as) && !(0, $85f046d5f58d0c41$export$d1b5391c35999eba)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as)) {
        (0, $33716cdef222842d$export$321543c11f6250ad)();
        if (isTypeKeyword && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) && !((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_KEYWORD)) ;
        else // `import {type as foo`
        (0, $33716cdef222842d$export$321543c11f6250ad)();
    } else {
        if (isTypeKeyword && ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || !!((0, $d9d7db628df75264$export$ca000e230c0caa3e).type & (0, $c455753917f2f29d$export$f435f793048e7a0f).IS_KEYWORD))) // `import {type foo`
        (0, $33716cdef222842d$export$321543c11f6250ad)();
        if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as)) (0, $33716cdef222842d$export$321543c11f6250ad)();
    }
}
function $f67d067f0232af34$export$e3b9ccf4c3c69613() {
    // Originally this checked if the method is a getter/setter, but if it was, we'd crash soon
    // anyway, so don't try to propagate that information.
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
        $f67d067f0232af34$export$d1d23833c686097a();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    }
}
function $f67d067f0232af34$export$273b459834534d69() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $f67d067f0232af34$export$6c833037db1a1e96();
}
function $f67d067f0232af34$export$6c11d14a2632a0dc() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) {
        const oldNoAnonFunctionType = (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType = true;
        $f67d067f0232af34$export$6c833037db1a1e96();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
    }
}
function $f67d067f0232af34$export$abad2599830a7c66(noIn, isWithinParens) {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
        let wasArrow = (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) {
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).type = (0, $c455753917f2f29d$export$f435f793048e7a0f).typeParameterStart;
        } else return wasArrow;
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
        $f67d067f0232af34$export$d1d23833c686097a();
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
        wasArrow = (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
        if (wasArrow) return true;
        (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    }
    return (0, $33716cdef222842d$export$bb0065dd8e05bcbd)(noIn, isWithinParens);
}
function $f67d067f0232af34$export$1ee5238ec4961bad() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
        const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
        const oldNoAnonFunctionType = (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType = true;
        $f67d067f0232af34$var$flowParseTypeAndPredicateInitialiser();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).noAnonFunctionType = oldNoAnonFunctionType;
        if ((0, $85f046d5f58d0c41$export$1c0919cee6560c3)()) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
        if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow)) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
        if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    }
    return (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).arrow);
}
function $f67d067f0232af34$export$7c7ba3c0c5ae1f67(startTokenIndex, noCalls = false) {
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
        const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
        const wasArrow = $f67d067f0232af34$var$parseAsyncArrowWithTypeParameters();
        if (wasArrow && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error) return;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    }
    (0, $33716cdef222842d$export$c2cc03eea353aa42)(startTokenIndex, noCalls);
}
// Returns true if there was an arrow function here.
function $f67d067f0232af34$var$parseAsyncArrowWithTypeParameters() {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $1eea8ad3ef6f406b$export$dd0fc1c64275f2c4)();
    if (!(0, $33716cdef222842d$export$92291a002e3a40fe)()) return false;
    (0, $33716cdef222842d$export$9286d8f9fb90b029)(startTokenIndex);
    return true;
}
function $f67d067f0232af34$var$flowParseEnumDeclaration() {
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._enum);
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum;
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    $f67d067f0232af34$var$flowParseEnumBody();
}
function $f67d067f0232af34$var$flowParseEnumBody() {
    if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._of)) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    $f67d067f0232af34$var$flowParseEnumMembers();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
}
function $f67d067f0232af34$var$flowParseEnumMembers() {
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) break;
        $f67d067f0232af34$var$flowParseEnumMember();
        if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
    }
}
function $f67d067f0232af34$var$flowParseEnumMember() {
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) // Flow enum values are always just one token (a string, number, or boolean literal).
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
}












function $1eea8ad3ef6f406b$export$cb09d803724ddba2() {
    $1eea8ad3ef6f406b$export$e5110a9b2ab486ee((0, $c455753917f2f29d$export$f435f793048e7a0f).eof);
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(0, (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length, true));
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth !== 0) throw new Error(`Invalid scope depth at end of file: ${(0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth}`);
    return new (0, $d4d47ec13fa63669$export$b6afa8811b7e644e)((0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens, (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes);
}
function $1eea8ad3ef6f406b$export$68b986de0b252bc8(declaration) {
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) {
        if ((0, $f67d067f0232af34$export$d29f5a1d65cdba9d)()) return;
    }
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).at)) $1eea8ad3ef6f406b$export$3f4d9519f687227a();
    $1eea8ad3ef6f406b$var$parseStatementContent(declaration);
}
function $1eea8ad3ef6f406b$var$parseStatementContent(declaration) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) {
        if ((0, $e018f01e7ae86c9a$export$bd8d07f8ee509b14)()) return;
    }
    const starttype = (0, $d9d7db628df75264$export$ca000e230c0caa3e).type;
    // Most types of statements are recognized by the keyword they
    // start with. Many are trivial to parse, some require a bit of
    // complexity.
    switch(starttype){
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._break:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._continue:
            $1eea8ad3ef6f406b$var$parseBreakContinueStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._debugger:
            $1eea8ad3ef6f406b$var$parseDebuggerStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._do:
            $1eea8ad3ef6f406b$var$parseDoStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._for:
            $1eea8ad3ef6f406b$var$parseForStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._function:
            if ((0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).dot) break;
            if (!declaration) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
            $1eea8ad3ef6f406b$var$parseFunctionStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._class:
            if (!declaration) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
            $1eea8ad3ef6f406b$export$542081d93172af(true);
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._if:
            $1eea8ad3ef6f406b$var$parseIfStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._return:
            $1eea8ad3ef6f406b$var$parseReturnStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._switch:
            $1eea8ad3ef6f406b$var$parseSwitchStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._throw:
            $1eea8ad3ef6f406b$var$parseThrowStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._try:
            $1eea8ad3ef6f406b$var$parseTryStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._let:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._const:
            if (!declaration) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)(); // NOTE: falls through to _var
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._var:
            $1eea8ad3ef6f406b$export$73f0614724a3919a(starttype !== (0, $c455753917f2f29d$export$f435f793048e7a0f)._var);
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._while:
            $1eea8ad3ef6f406b$var$parseWhileStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL:
            $1eea8ad3ef6f406b$export$4aed668c47d45036();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).semi:
            $1eea8ad3ef6f406b$var$parseEmptyStatement();
            return;
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._export:
        case (0, $c455753917f2f29d$export$f435f793048e7a0f)._import:
            {
                const nextType = (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)();
                if (nextType === (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL || nextType === (0, $c455753917f2f29d$export$f435f793048e7a0f).dot) break;
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                if (starttype === (0, $c455753917f2f29d$export$f435f793048e7a0f)._import) $1eea8ad3ef6f406b$export$532df1d0416e9789();
                else $1eea8ad3ef6f406b$export$3d6d7ef9486a61c3();
                return;
            }
        case (0, $c455753917f2f29d$export$f435f793048e7a0f).name:
            if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async) {
                const functionStart = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
                // peek ahead and see if next token is a function
                const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
                (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
                if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function) && !(0, $85f046d5f58d0c41$export$1c0919cee6560c3)()) {
                    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function);
                    $1eea8ad3ef6f406b$export$ba3dc2bd7c065219(functionStart, true);
                    return;
                } else (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            } else if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._using && !(0, $85f046d5f58d0c41$export$a4f1ee8cbd9b31ba)() && // Statements like `using[0]` and `using in foo` aren't actual using
            // declarations.
            (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).name) {
                $1eea8ad3ef6f406b$export$73f0614724a3919a(true);
                return;
            } else if ($1eea8ad3ef6f406b$var$startsAwaitUsing()) {
                (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._await);
                $1eea8ad3ef6f406b$export$73f0614724a3919a(true);
                return;
            }
        default:
            break;
    }
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    const initialTokensLength = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $33716cdef222842d$export$ed9c825e502c46c8)();
    let simpleName = null;
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length === initialTokensLength + 1) {
        const token = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1];
        if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name) simpleName = token.contextualKeyword;
    }
    if (simpleName == null) {
        (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
        return;
    }
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) $1eea8ad3ef6f406b$var$parseLabeledStatement();
    else // This was an identifier, so we might want to handle flow/typescript-specific cases.
    $1eea8ad3ef6f406b$var$parseIdentifierStatement(simpleName);
}
/**
 * Determine if we're positioned at an `await using` declaration.
 *
 * Note that this can happen either in place of a regular variable declaration
 * or in a loop body, and in both places, there are similar-looking cases where
 * we need to return false.
 *
 * Examples returning true:
 * await using foo = bar();
 * for (await using a of b) {}
 *
 * Examples returning false:
 * await using
 * await using + 1
 * await using instanceof T
 * for (await using;;) {}
 *
 * For now, we early return if we don't see `await`, then do a simple
 * backtracking-based lookahead for the `using` and identifier tokens. In the
 * future, this could be optimized with a character-based approach.
 */ function $1eea8ad3ef6f406b$var$startsAwaitUsing() {
    if (!(0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._await)) return false;
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    // await
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if (!(0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._using) || (0, $85f046d5f58d0c41$export$942fa35f3a7c108c)()) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    // using
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || (0, $85f046d5f58d0c41$export$942fa35f3a7c108c)()) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    }
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
    return true;
}
function $1eea8ad3ef6f406b$export$3f4d9519f687227a() {
    while((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).at))$1eea8ad3ef6f406b$var$parseDecorator();
}
function $1eea8ad3ef6f406b$var$parseDecorator() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
        (0, $33716cdef222842d$export$ed9c825e502c46c8)();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    } else {
        (0, $33716cdef222842d$export$321543c11f6250ad)();
        while((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).dot))(0, $33716cdef222842d$export$321543c11f6250ad)();
        $1eea8ad3ef6f406b$var$parseMaybeDecoratorArguments();
    }
}
function $1eea8ad3ef6f406b$var$parseMaybeDecoratorArguments() {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$fd0439ea9a1ac1ea)();
    else $1eea8ad3ef6f406b$export$50c128b10ac5ea5b();
}
function $1eea8ad3ef6f406b$export$50c128b10ac5ea5b() {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) (0, $33716cdef222842d$export$970763873d9efa73)();
}
function $1eea8ad3ef6f406b$var$parseBreakContinueStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if (!(0, $85f046d5f58d0c41$export$12d132b6e81066e4)()) {
        (0, $33716cdef222842d$export$321543c11f6250ad)();
        (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
    }
}
function $1eea8ad3ef6f406b$var$parseDebuggerStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $1eea8ad3ef6f406b$var$parseDoStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $1eea8ad3ef6f406b$export$68b986de0b252bc8(false);
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f)._while);
    (0, $33716cdef222842d$export$d5ddb48bead5eb08)();
    (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi);
}
function $1eea8ad3ef6f406b$var$parseForStatement() {
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    $1eea8ad3ef6f406b$var$parseAmbiguousForStatement();
    const endTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, false));
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
}
/**
 * Determine if this token is a `using` declaration (explicit resource
 * management) as part of a loop.
 * https://github.com/tc39/proposal-explicit-resource-management
 */ function $1eea8ad3ef6f406b$var$isUsingInLoop() {
    if (!(0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._using)) return false;
    // This must be `for (using of`, where `using` is the name of the loop
    // variable.
    if ((0, $85f046d5f58d0c41$export$d1b5391c35999eba)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._of)) return false;
    return true;
}
// Disambiguating between a `for` and a `for`/`in` or `for`/`of`
// loop is non-trivial. Basically, we have to parse the init `var`
// statement or expression, disallowing the `in` operator (see
// the second parameter to `parseExpression`), and then check
// whether the next token is `in` or `of`. When there is no init
// part (semicolon immediately after the opening parenthesis), it
// is a regular `for` loop.
function $1eea8ad3ef6f406b$var$parseAmbiguousForStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    let forAwait = false;
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._await)) {
        forAwait = true;
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    }
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi)) {
        if (forAwait) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
        $1eea8ad3ef6f406b$var$parseFor();
        return;
    }
    const isAwaitUsing = $1eea8ad3ef6f406b$var$startsAwaitUsing();
    if (isAwaitUsing || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._var) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._let) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._const) || $1eea8ad3ef6f406b$var$isUsingInLoop()) {
        if (isAwaitUsing) (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._await);
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        $1eea8ad3ef6f406b$var$parseVar(true, (0, $d9d7db628df75264$export$ca000e230c0caa3e).type !== (0, $c455753917f2f29d$export$f435f793048e7a0f)._var);
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._in) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._of)) {
            $1eea8ad3ef6f406b$var$parseForIn(forAwait);
            return;
        }
        $1eea8ad3ef6f406b$var$parseFor();
        return;
    }
    (0, $33716cdef222842d$export$ed9c825e502c46c8)(true);
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._in) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._of)) {
        $1eea8ad3ef6f406b$var$parseForIn(forAwait);
        return;
    }
    if (forAwait) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    $1eea8ad3ef6f406b$var$parseFor();
}
function $1eea8ad3ef6f406b$var$parseFunctionStatement() {
    const functionStart = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $1eea8ad3ef6f406b$export$ba3dc2bd7c065219(functionStart, true);
}
function $1eea8ad3ef6f406b$var$parseIfStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $33716cdef222842d$export$d5ddb48bead5eb08)();
    $1eea8ad3ef6f406b$export$68b986de0b252bc8(false);
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._else)) $1eea8ad3ef6f406b$export$68b986de0b252bc8(false);
}
function $1eea8ad3ef6f406b$var$parseReturnStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    // In `return` (and `break`/`continue`), the keywords with
    // optional arguments, we eagerly look for a semicolon or the
    // possibility to insert one.
    if (!(0, $85f046d5f58d0c41$export$12d132b6e81066e4)()) {
        (0, $33716cdef222842d$export$ed9c825e502c46c8)();
        (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
    }
}
function $1eea8ad3ef6f406b$var$parseSwitchStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $33716cdef222842d$export$d5ddb48bead5eb08)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    // Don't bother validation; just go through any sequence of cases, defaults, and statements.
    while(!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error)if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._case) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._default)) {
        const isCase = (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._case);
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        if (isCase) (0, $33716cdef222842d$export$ed9c825e502c46c8)();
        (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
    } else $1eea8ad3ef6f406b$export$68b986de0b252bc8(true);
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)(); // Closing brace
    const endTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, false));
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
}
function $1eea8ad3ef6f406b$var$parseThrowStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $33716cdef222842d$export$ed9c825e502c46c8)();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $1eea8ad3ef6f406b$var$parseCatchClauseParam() {
    (0, $24b5f7a89f6adf6c$export$e1f90e6766854abd)(true);
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$e4623eb563192e0f)();
}
function $1eea8ad3ef6f406b$var$parseTryStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $1eea8ad3ef6f406b$export$4aed668c47d45036();
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._catch)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        let catchBindingStartTokenIndex = null;
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
            catchBindingStartTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
            $1eea8ad3ef6f406b$var$parseCatchClauseParam();
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
        }
        $1eea8ad3ef6f406b$export$4aed668c47d45036();
        if (catchBindingStartTokenIndex != null) {
            // We need a special scope for the catch binding which includes the binding itself and the
            // catch block.
            const endTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(catchBindingStartTokenIndex, endTokenIndex, false));
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
        }
    }
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._finally)) $1eea8ad3ef6f406b$export$4aed668c47d45036();
}
function $1eea8ad3ef6f406b$export$73f0614724a3919a(isBlockScope) {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    $1eea8ad3ef6f406b$var$parseVar(false, isBlockScope);
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $1eea8ad3ef6f406b$var$parseWhileStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $33716cdef222842d$export$d5ddb48bead5eb08)();
    $1eea8ad3ef6f406b$export$68b986de0b252bc8(false);
}
function $1eea8ad3ef6f406b$var$parseEmptyStatement() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
}
function $1eea8ad3ef6f406b$var$parseLabeledStatement() {
    $1eea8ad3ef6f406b$export$68b986de0b252bc8(true);
}
/**
 * Parse a statement starting with an identifier of the given name. Subclasses match on the name
 * to handle statements like "declare".
 */ function $1eea8ad3ef6f406b$var$parseIdentifierStatement(contextualKeyword) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$a642c15f5070c816)(contextualKeyword);
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$3b5c354482eb1586)(contextualKeyword);
    else (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $1eea8ad3ef6f406b$export$4aed668c47d45036(isFunctionScope = false, contextId = 0) {
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    if (contextId) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    $1eea8ad3ef6f406b$export$e5110a9b2ab486ee((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
    if (contextId) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    const endTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, isFunctionScope));
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
}
function $1eea8ad3ef6f406b$export$e5110a9b2ab486ee(end) {
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)(end) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error)$1eea8ad3ef6f406b$export$68b986de0b252bc8(true);
}
// Parse a regular `for` loop. The disambiguation code in
// `parseStatement` will already have parsed the init statement or
// expression.
function $1eea8ad3ef6f406b$var$parseFor() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi);
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi)) (0, $33716cdef222842d$export$ed9c825e502c46c8)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi);
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR)) (0, $33716cdef222842d$export$ed9c825e502c46c8)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    $1eea8ad3ef6f406b$export$68b986de0b252bc8(false);
}
// Parse a `for`/`in` and `for`/`of` loop, which are almost
// same from parser's perspective.
function $1eea8ad3ef6f406b$var$parseForIn(forAwait) {
    if (forAwait) (0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._of);
    else (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $33716cdef222842d$export$ed9c825e502c46c8)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    $1eea8ad3ef6f406b$export$68b986de0b252bc8(false);
}
// Parse a list of variable declarations.
function $1eea8ad3ef6f406b$var$parseVar(isFor, isBlockScope) {
    while(true){
        $1eea8ad3ef6f406b$var$parseVarHead(isBlockScope);
        if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
            const eqIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1;
            (0, $33716cdef222842d$export$b97bbe8a7805284f)(isFor);
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[eqIndex].rhsEndIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
        }
        if (!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) break;
    }
}
function $1eea8ad3ef6f406b$var$parseVarHead(isBlockScope) {
    (0, $24b5f7a89f6adf6c$export$e1f90e6766854abd)(isBlockScope);
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$41c8703baf1bbf07)();
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$273b459834534d69)();
}
function $1eea8ad3ef6f406b$export$ba3dc2bd7c065219(functionStart, isStatement, optionalId = false) {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star)) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    if (isStatement && !optionalId && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) && !(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._yield)) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
    let nameScopeStartTokenIndex = null;
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
        // Expression-style functions should limit their name's scope to the function body, so we make
        // a new function scope to enforce that.
        if (!isStatement) {
            nameScopeStartTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
        }
        (0, $24b5f7a89f6adf6c$export$7538cb03fa894c83)(false);
    }
    const startTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
    $1eea8ad3ef6f406b$export$dd0fc1c64275f2c4();
    (0, $33716cdef222842d$export$85b927192bdce5b9)(functionStart);
    const endTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    // In addition to the block scope of the function body, we need a separate function-style scope
    // that includes the params.
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(startTokenIndex, endTokenIndex, true));
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
    if (nameScopeStartTokenIndex !== null) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(nameScopeStartTokenIndex, endTokenIndex, true));
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
    }
}
function $1eea8ad3ef6f406b$export$dd0fc1c64275f2c4(allowModifiers = false, funcContextId = 0) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$ba34d58430377f94)();
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$e3b9ccf4c3c69613)();
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
    if (funcContextId) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = funcContextId;
    (0, $24b5f7a89f6adf6c$export$befa6d966a25698e)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR, false, false, allowModifiers, funcContextId);
    if (funcContextId) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = funcContextId;
}
function $1eea8ad3ef6f406b$export$542081d93172af(isStatement, optionalId = false) {
    // Put a context ID on the class keyword, the open-brace, and the close-brace, so that later
    // code can easily navigate to meaningful points on the class.
    const contextId = (0, $d9d7db628df75264$export$d0c215ddd78b3d24)();
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].isExpression = !isStatement;
    // Like with functions, we declare a special "name scope" from the start of the name to the end
    // of the class, but only with expression-style classes, to represent the fact that the name is
    // available to the body of the class but not an outer declaration.
    let nameScopeStartTokenIndex = null;
    if (!isStatement) {
        nameScopeStartTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth++;
    }
    $1eea8ad3ef6f406b$var$parseClassId(isStatement, optionalId);
    $1eea8ad3ef6f406b$var$parseClassSuper();
    const openBraceIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    $1eea8ad3ef6f406b$var$parseClassBody(contextId);
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) return;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[openBraceIndex].contextId = contextId;
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = contextId;
    if (nameScopeStartTokenIndex !== null) {
        const endTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopes.push(new (0, $dfae9c1b3c46b56f$export$775b6bb06e53a214)(nameScopeStartTokenIndex, endTokenIndex, false));
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).scopeDepth--;
    }
}
function $1eea8ad3ef6f406b$var$isClassProperty() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).bang) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon);
}
function $1eea8ad3ef6f406b$var$isClassMethod() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan);
}
function $1eea8ad3ef6f406b$var$parseClassBody(classContextId) {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).semi)) continue;
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).at)) {
            $1eea8ad3ef6f406b$var$parseDecorator();
            continue;
        }
        const memberStart = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
        $1eea8ad3ef6f406b$var$parseClassMember(memberStart, classContextId);
    }
}
function $1eea8ad3ef6f406b$var$parseClassMember(memberStart, classContextId) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$77616e6d401f584a)([
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._declare,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._public,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._protected,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._private,
        (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._override
    ]);
    let isStatic = false;
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) && (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._static) {
        (0, $33716cdef222842d$export$321543c11f6250ad)(); // eats 'static'
        if ($1eea8ad3ef6f406b$var$isClassMethod()) {
            $1eea8ad3ef6f406b$var$parseClassMethod(memberStart, /* isConstructor */ false);
            return;
        } else if ($1eea8ad3ef6f406b$var$isClassProperty()) {
            $1eea8ad3ef6f406b$export$8c8d5281ed4948bc();
            return;
        }
        // otherwise something static
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._static;
        isStatic = true;
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            // This is a static block. Mark the word "static" with the class context ID for class element
            // detection and parse as a regular block.
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].contextId = classContextId;
            $1eea8ad3ef6f406b$export$4aed668c47d45036();
            return;
        }
    }
    $1eea8ad3ef6f406b$var$parseClassMemberWithIsStatic(memberStart, isStatic, classContextId);
}
function $1eea8ad3ef6f406b$var$parseClassMemberWithIsStatic(memberStart, isStatic, classContextId) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) {
        if ((0, $e018f01e7ae86c9a$export$9d02a6e20851f734)(isStatic)) return;
    }
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).star)) {
        // a generator
        $1eea8ad3ef6f406b$export$763528f37ffee534(classContextId);
        $1eea8ad3ef6f406b$var$parseClassMethod(memberStart, /* isConstructor */ false);
        return;
    }
    // Get the identifier name so we can tell if it's actually a keyword like "async", "get", or
    // "set".
    $1eea8ad3ef6f406b$export$763528f37ffee534(classContextId);
    let isConstructor = false;
    const token = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1];
    // We allow "constructor" as either an identifier or a string.
    if (token.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._constructor) isConstructor = true;
    $1eea8ad3ef6f406b$export$be741144f2438eed();
    if ($1eea8ad3ef6f406b$var$isClassMethod()) $1eea8ad3ef6f406b$var$parseClassMethod(memberStart, isConstructor);
    else if ($1eea8ad3ef6f406b$var$isClassProperty()) $1eea8ad3ef6f406b$export$8c8d5281ed4948bc();
    else if (token.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async && !(0, $85f046d5f58d0c41$export$12d132b6e81066e4)()) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._async;
        // an async method
        const isGenerator = (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star);
        if (isGenerator) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        // The so-called parsed name would have been "async": get the real name.
        $1eea8ad3ef6f406b$export$763528f37ffee534(classContextId);
        $1eea8ad3ef6f406b$export$be741144f2438eed();
        $1eea8ad3ef6f406b$var$parseClassMethod(memberStart, false);
    } else if ((token.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._get || token.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._set) && !((0, $85f046d5f58d0c41$export$12d132b6e81066e4)() && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star))) {
        if (token.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._get) (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._get;
        else (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._set;
        // `get\n*` is an uninitialized property named 'get' followed by a generator.
        // a getter or setter
        // The so-called parsed name would have been "get/set": get the real name.
        $1eea8ad3ef6f406b$export$763528f37ffee534(classContextId);
        $1eea8ad3ef6f406b$var$parseClassMethod(memberStart, /* isConstructor */ false);
    } else if (token.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._accessor && !(0, $85f046d5f58d0c41$export$12d132b6e81066e4)()) {
        $1eea8ad3ef6f406b$export$763528f37ffee534(classContextId);
        $1eea8ad3ef6f406b$export$8c8d5281ed4948bc();
    } else if ((0, $85f046d5f58d0c41$export$12d132b6e81066e4)()) // an uninitialized class property (due to ASI, since we don't otherwise recognize the next token)
    $1eea8ad3ef6f406b$export$8c8d5281ed4948bc();
    else (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)();
}
function $1eea8ad3ef6f406b$var$parseClassMethod(functionStart, isConstructor) {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$827faab4e65d5897)();
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) {
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) (0, $f67d067f0232af34$export$d1d23833c686097a)();
    }
    (0, $33716cdef222842d$export$9b0b57f9abc43790)(functionStart, isConstructor);
}
function $1eea8ad3ef6f406b$export$763528f37ffee534(classContextId) {
    (0, $33716cdef222842d$export$ab65037f9c8fb3d3)(classContextId);
}
function $1eea8ad3ef6f406b$export$be741144f2438eed() {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) {
        const oldIsType = (0, $d45b756a11a5dc19$export$218282073d8f0a8b)(0);
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).question);
        (0, $d45b756a11a5dc19$export$89977347ddb984a8)(oldIsType);
    }
}
function $1eea8ad3ef6f406b$export$8c8d5281ed4948bc() {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) {
        (0, $d45b756a11a5dc19$export$cb3e65614411a57c)((0, $c455753917f2f29d$export$f435f793048e7a0f).bang);
        (0, $e018f01e7ae86c9a$export$e4623eb563192e0f)();
    } else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) {
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) (0, $f67d067f0232af34$export$6c833037db1a1e96)();
    }
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
        const equalsTokenIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $33716cdef222842d$export$b97bbe8a7805284f)();
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[equalsTokenIndex].rhsEndIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
    }
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $1eea8ad3ef6f406b$var$parseClassId(isStatement, optionalId = false) {
    if ((0, $d9d7db628df75264$export$757c2735689d2de8) && (!isStatement || optionalId) && (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._implements)) return;
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) (0, $24b5f7a89f6adf6c$export$7538cb03fa894c83)(true);
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$827faab4e65d5897)();
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) {
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) (0, $f67d067f0232af34$export$d1d23833c686097a)();
    }
}
// Returns true if there was a superclass.
function $1eea8ad3ef6f406b$var$parseClassSuper() {
    let hasSuper = false;
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends)) {
        (0, $33716cdef222842d$export$dba7f678c228244a)();
        hasSuper = true;
    } else hasSuper = false;
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$ea9d02c53bf69095)(hasSuper);
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$131557296be11580)(hasSuper);
}
function $1eea8ad3ef6f406b$export$3d6d7ef9486a61c3() {
    const exportIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1;
    if (0, $d9d7db628df75264$export$757c2735689d2de8) {
        if ((0, $e018f01e7ae86c9a$export$6714566ca8db2f39)()) return;
    }
    // export * from '...'
    if ($1eea8ad3ef6f406b$var$shouldParseExportStar()) $1eea8ad3ef6f406b$var$parseExportStar();
    else if ($1eea8ad3ef6f406b$var$isExportDefaultSpecifier()) {
        // export default from
        (0, $33716cdef222842d$export$321543c11f6250ad)();
        if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).star) {
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).star);
            (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as);
            (0, $33716cdef222842d$export$321543c11f6250ad)();
        } else $1eea8ad3ef6f406b$var$parseExportSpecifiersMaybe();
        $1eea8ad3ef6f406b$export$49b6f13e189abea3();
    } else if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._default)) // export default ...
    $1eea8ad3ef6f406b$var$parseExportDefaultExpression();
    else if ($1eea8ad3ef6f406b$var$shouldParseExportDeclaration()) $1eea8ad3ef6f406b$var$parseExportDeclaration();
    else {
        // export { x, y as z } [from '...']
        $1eea8ad3ef6f406b$export$909d3b50f7924101();
        $1eea8ad3ef6f406b$export$49b6f13e189abea3();
    }
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[exportIndex].rhsEndIndex = (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length;
}
function $1eea8ad3ef6f406b$var$parseExportDefaultExpression() {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) {
        if ((0, $e018f01e7ae86c9a$export$95d54e02ae7a0197)()) return;
    }
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) {
        if ((0, $f67d067f0232af34$export$c6f815d203f26c4f)()) return;
    }
    const functionStart = (0, $d9d7db628df75264$export$ca000e230c0caa3e).start;
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function)) $1eea8ad3ef6f406b$export$ba3dc2bd7c065219(functionStart, true, true);
    else if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f)._function) {
        // async function declaration
        (0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async);
        (0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f)._function);
        $1eea8ad3ef6f406b$export$ba3dc2bd7c065219(functionStart, true, true);
    } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._class)) $1eea8ad3ef6f406b$export$542081d93172af(true, true);
    else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).at)) {
        $1eea8ad3ef6f406b$export$3f4d9519f687227a();
        $1eea8ad3ef6f406b$export$542081d93172af(true, true);
    } else {
        (0, $33716cdef222842d$export$b97bbe8a7805284f)();
        (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
    }
}
function $1eea8ad3ef6f406b$var$parseExportDeclaration() {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) (0, $e018f01e7ae86c9a$export$b29e6741ccf6da0a)();
    else if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$64e87490a40a8a82)();
    else $1eea8ad3ef6f406b$export$68b986de0b252bc8(true);
}
function $1eea8ad3ef6f406b$var$isExportDefaultSpecifier() {
    if ((0, $d9d7db628df75264$export$757c2735689d2de8) && (0, $e018f01e7ae86c9a$export$5df75dadb7a629b6)()) return false;
    else if ((0, $d9d7db628df75264$export$92e334f8fe49aa94) && (0, $f67d067f0232af34$export$8a047f67d2009628)()) return false;
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) return (0, $d9d7db628df75264$export$ca000e230c0caa3e).contextualKeyword !== (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async;
    if (!(0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._default)) return false;
    const _next = (0, $d45b756a11a5dc19$export$1678d89ce52f4a6)();
    const lookahead = (0, $d45b756a11a5dc19$export$ef1b94c514fc060a)();
    const hasFrom = lookahead.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name && lookahead.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from;
    if (lookahead.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).comma) return true;
    // lookahead again when `export default from` is seen
    if (hasFrom) {
        const nextAfterFrom = (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt((0, $d45b756a11a5dc19$export$b8d8ba48247ea123)(_next + 4));
        return nextAfterFrom === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).quotationMark || nextAfterFrom === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).apostrophe;
    }
    return false;
}
function $1eea8ad3ef6f406b$var$parseExportSpecifiersMaybe() {
    if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) $1eea8ad3ef6f406b$export$909d3b50f7924101();
}
function $1eea8ad3ef6f406b$export$49b6f13e189abea3() {
    if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) {
        (0, $33716cdef222842d$export$fa61731cf32bc243)();
        $1eea8ad3ef6f406b$var$maybeParseImportAttributes();
    }
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
function $1eea8ad3ef6f406b$var$shouldParseExportStar() {
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) return (0, $f67d067f0232af34$export$563bbc61583bd08)();
    else return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star);
}
function $1eea8ad3ef6f406b$var$parseExportStar() {
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$dc2ba80ebf42d8d6)();
    else $1eea8ad3ef6f406b$export$18fb3cb64b956ba0();
}
function $1eea8ad3ef6f406b$export$18fb3cb64b956ba0() {
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).star);
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as)) $1eea8ad3ef6f406b$var$parseExportNamespace();
    else $1eea8ad3ef6f406b$export$49b6f13e189abea3();
}
function $1eea8ad3ef6f406b$var$parseExportNamespace() {
    (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].type = (0, $c455753917f2f29d$export$f435f793048e7a0f)._as;
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    $1eea8ad3ef6f406b$var$parseExportSpecifiersMaybe();
    $1eea8ad3ef6f406b$export$49b6f13e189abea3();
}
function $1eea8ad3ef6f406b$var$shouldParseExportDeclaration() {
    return (0, $d9d7db628df75264$export$757c2735689d2de8) && (0, $e018f01e7ae86c9a$export$5df75dadb7a629b6)() || (0, $d9d7db628df75264$export$92e334f8fe49aa94) && (0, $f67d067f0232af34$export$74061750bc0f2203)() || (0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._var || (0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._const || (0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._let || (0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._function || (0, $d9d7db628df75264$export$ca000e230c0caa3e).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._class || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async) || (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).at);
}
function $1eea8ad3ef6f406b$export$909d3b50f7924101() {
    let first = true;
    // export { x, y as z } [from '...']
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) break;
        }
        $1eea8ad3ef6f406b$var$parseExportSpecifier();
    }
}
function $1eea8ad3ef6f406b$var$parseExportSpecifier() {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) {
        (0, $e018f01e7ae86c9a$export$7994f3b86b6c7d1e)();
        return;
    }
    (0, $33716cdef222842d$export$321543c11f6250ad)();
    (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ExportAccess;
    if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as)) (0, $33716cdef222842d$export$321543c11f6250ad)();
}
/**
 * Starting at the `module` token in an import, determine if it was truly an
 * import reflection token or just looks like one.
 *
 * Returns true for:
 * import module foo from "foo";
 * import module from from "foo";
 *
 * Returns false for:
 * import module from "foo";
 * import module, {bar} from "foo";
 */ function $1eea8ad3ef6f406b$var$isImportReflection() {
    const snapshot = (0, $d9d7db628df75264$export$ca000e230c0caa3e).snapshot();
    (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module);
    if ((0, $85f046d5f58d0c41$export$b8f8f7fffeb6fb36)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) {
        if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) {
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return true;
        } else {
            (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
            return false;
        }
    } else if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return false;
    } else {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).restoreFromSnapshot(snapshot);
        return true;
    }
}
/**
 * Eat the "module" token from the import reflection proposal.
 * https://github.com/tc39/proposal-import-reflection
 */ function $1eea8ad3ef6f406b$var$parseMaybeImportReflection() {
    // isImportReflection does snapshot/restore, so only run it if we see the word
    // "module".
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module) && $1eea8ad3ef6f406b$var$isImportReflection()) (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
}
function $1eea8ad3ef6f406b$export$532df1d0416e9789() {
    if ((0, $d9d7db628df75264$export$757c2735689d2de8) && (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name) && (0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).eq) {
        (0, $e018f01e7ae86c9a$export$bb14276cd4f56f44)();
        return;
    }
    if ((0, $d9d7db628df75264$export$757c2735689d2de8) && (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
        const lookahead = (0, $d45b756a11a5dc19$export$ef1b94c514fc060a)();
        if (lookahead.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name && lookahead.contextualKeyword !== (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from) {
            // One of these `import type` cases:
            // import type T = require('T');
            // import type A from 'A';
            (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type);
            if ((0, $d45b756a11a5dc19$export$d2a09c60d66edd78)() === (0, $c455753917f2f29d$export$f435f793048e7a0f).eq) {
                (0, $e018f01e7ae86c9a$export$bb14276cd4f56f44)();
                return;
            }
        // If this is an `import type...from` statement, then we already ate the
        // type token, so proceed to the regular import parser.
        } else if (lookahead.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).star || lookahead.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) // One of these `import type` cases, in which case we can eat the type token
        // and proceed as normal:
        // import type * as A from 'A';
        // import type {a} from 'A';
        (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type);
    // Otherwise, we are importing the name "type".
    }
    // import '...'
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) (0, $33716cdef222842d$export$fa61731cf32bc243)();
    else {
        $1eea8ad3ef6f406b$var$parseMaybeImportReflection();
        $1eea8ad3ef6f406b$var$parseImportSpecifiers();
        (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from);
        (0, $33716cdef222842d$export$fa61731cf32bc243)();
    }
    $1eea8ad3ef6f406b$var$maybeParseImportAttributes();
    (0, $85f046d5f58d0c41$export$62fa27d385e555f3)();
}
// eslint-disable-next-line no-unused-vars
function $1eea8ad3ef6f406b$var$shouldParseDefaultImport() {
    return (0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
}
function $1eea8ad3ef6f406b$var$parseImportSpecifierLocal() {
    (0, $24b5f7a89f6adf6c$export$cba413304e86fc0d)();
}
// Parses a comma-separated list of module imports.
function $1eea8ad3ef6f406b$var$parseImportSpecifiers() {
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) (0, $f67d067f0232af34$export$2ca2c81ecd0ec221)();
    let first = true;
    if ($1eea8ad3ef6f406b$var$shouldParseDefaultImport()) {
        // import defaultObj, { x, y as z } from '...'
        $1eea8ad3ef6f406b$var$parseImportSpecifierLocal();
        if (!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) return;
    }
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f).star)) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $85f046d5f58d0c41$export$b8ead11dfed96f19)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as);
        $1eea8ad3ef6f406b$var$parseImportSpecifierLocal();
        return;
    }
    (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
    while(!(0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) && !(0, $d9d7db628df75264$export$ca000e230c0caa3e).error){
        if (first) first = false;
        else {
            // Detect an attempt to deep destructure
            if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).colon)) (0, $85f046d5f58d0c41$export$4c195bc1a97b6f7f)("ES2015 named imports do not destructure. Use another statement for destructuring after the import.");
            (0, $85f046d5f58d0c41$export$3570f33b1a1f3329)((0, $c455753917f2f29d$export$f435f793048e7a0f).comma);
            if ((0, $d45b756a11a5dc19$export$3106cdec37e36f77)((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) break;
        }
        $1eea8ad3ef6f406b$var$parseImportSpecifier();
    }
}
function $1eea8ad3ef6f406b$var$parseImportSpecifier() {
    if (0, $d9d7db628df75264$export$757c2735689d2de8) {
        (0, $e018f01e7ae86c9a$export$718ece2f88417ffd)();
        return;
    }
    if (0, $d9d7db628df75264$export$92e334f8fe49aa94) {
        (0, $f67d067f0232af34$export$217da275bf556fe8)();
        return;
    }
    (0, $24b5f7a89f6adf6c$export$cba413304e86fc0d)();
    if ((0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._as)) {
        (0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens[(0, $d9d7db628df75264$export$ca000e230c0caa3e).tokens.length - 1].identifierRole = (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportAccess;
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $24b5f7a89f6adf6c$export$cba413304e86fc0d)();
    }
}
/**
 * Parse import attributes like `with {type: "json"}`, or the legacy form
 * `assert {type: "json"}`.
 *
 * Import attributes technically have their own syntax, but are always parseable
 * as a plain JS object, so just do that for simplicity.
 */ function $1eea8ad3ef6f406b$var$maybeParseImportAttributes() {
    if ((0, $d45b756a11a5dc19$export$4659b591c19bdf3d)((0, $c455753917f2f29d$export$f435f793048e7a0f)._with) || (0, $85f046d5f58d0c41$export$d382681f238736f1)((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._assert) && !(0, $85f046d5f58d0c41$export$942fa35f3a7c108c)()) {
        (0, $d45b756a11a5dc19$export$48cfd1e771a65c4f)();
        (0, $33716cdef222842d$export$908e61e44ae774e)(false, false);
    }
}


function $c980e7675f428076$export$f1c553d4f1a2351() {
    // If enabled, skip leading hashbang line.
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).pos === 0 && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(0) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).numberSign && (0, $d9d7db628df75264$export$b7e3ae3d7c15e42e).charCodeAt(1) === (0, $b3c56b6031d55b89$export$dbe39bbf2ade60d5).exclamationMark) (0, $d45b756a11a5dc19$export$37e131e7c1112aff)(2);
    (0, $d45b756a11a5dc19$export$be17f8ab6696df13)();
    return (0, $1eea8ad3ef6f406b$export$cb09d803724ddba2)();
}


class $d4d47ec13fa63669$export$b6afa8811b7e644e {
    constructor(tokens, scopes){
        this.tokens = tokens;
        this.scopes = scopes;
    }
}
function $d4d47ec13fa63669$export$98e6a39c04603d36(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled) {
    if (isFlowEnabled && isTypeScriptEnabled) throw new Error("Cannot combine flow and typescript plugins.");
    (0, $d9d7db628df75264$export$84bb9899435eeb61)(input, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
    const result = (0, $c980e7675f428076$export$f1c553d4f1a2351)();
    if ((0, $d9d7db628df75264$export$ca000e230c0caa3e).error) throw (0, $d9d7db628df75264$export$2ca6ff5cad32970a)((0, $d9d7db628df75264$export$ca000e230c0caa3e).error);
    return result;
}




function $40733ab601b41f9c$export$2e2bcd8739ae039(tokens) {
    let index = tokens.currentIndex();
    let depth = 0;
    const startToken = tokens.currentToken();
    do {
        const token = tokens.tokens[index];
        if (token.isOptionalChainStart) depth++;
        if (token.isOptionalChainEnd) depth--;
        depth += token.numNullishCoalesceStarts;
        depth -= token.numNullishCoalesceEnds;
        if (token.contextualKeyword === (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._await && token.identifierRole == null && token.scopeDepth === startToken.scopeDepth) return true;
        index += 1;
    }while (depth > 0 && index < tokens.tokens.length);
    return false;
}


class $61061da4d6cb75fe$export$2e2bcd8739ae039 {
    __init() {
        this.resultCode = "";
    }
    // Array mapping input token index to optional string index position in the
    // output code.
    __init2() {
        this.resultMappings = new Array(this.tokens.length);
    }
    __init3() {
        this.tokenIndex = 0;
    }
    constructor(code, tokens, isFlowEnabled, disableESTransforms, helperManager){
        this.code = code;
        this.tokens = tokens;
        this.isFlowEnabled = isFlowEnabled;
        this.disableESTransforms = disableESTransforms;
        this.helperManager = helperManager;
        $61061da4d6cb75fe$export$2e2bcd8739ae039.prototype.__init.call(this);
        $61061da4d6cb75fe$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $61061da4d6cb75fe$export$2e2bcd8739ae039.prototype.__init3.call(this);
    }
    /**
   * Snapshot the token state in a way that can be restored later, useful for
   * things like lookahead.
   *
   * resultMappings do not need to be copied since in all use cases, they will
   * be overwritten anyway after restore.
   */ snapshot() {
        return {
            resultCode: this.resultCode,
            tokenIndex: this.tokenIndex
        };
    }
    restoreToSnapshot(snapshot) {
        this.resultCode = snapshot.resultCode;
        this.tokenIndex = snapshot.tokenIndex;
    }
    /**
   * Remove and return the code generated since the snapshot, leaving the
   * current token position in-place. Unlike most TokenProcessor operations,
   * this operation can result in input/output line number mismatches because
   * the removed code may contain newlines, so this operation should be used
   * sparingly.
   */ dangerouslyGetAndRemoveCodeSinceSnapshot(snapshot) {
        const result = this.resultCode.slice(snapshot.resultCode.length);
        this.resultCode = snapshot.resultCode;
        return result;
    }
    reset() {
        this.resultCode = "";
        this.resultMappings = new Array(this.tokens.length);
        this.tokenIndex = 0;
    }
    matchesContextualAtIndex(index, contextualKeyword) {
        return this.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) && this.tokens[index].contextualKeyword === contextualKeyword;
    }
    identifierNameAtIndex(index) {
        // TODO: We need to process escapes since technically you can have unicode escapes in variable
        // names.
        return this.identifierNameForToken(this.tokens[index]);
    }
    identifierNameAtRelativeIndex(relativeIndex) {
        return this.identifierNameForToken(this.tokenAtRelativeIndex(relativeIndex));
    }
    identifierName() {
        return this.identifierNameForToken(this.currentToken());
    }
    identifierNameForToken(token) {
        return this.code.slice(token.start, token.end);
    }
    rawCodeForToken(token) {
        return this.code.slice(token.start, token.end);
    }
    stringValueAtIndex(index) {
        return this.stringValueForToken(this.tokens[index]);
    }
    stringValue() {
        return this.stringValueForToken(this.currentToken());
    }
    stringValueForToken(token) {
        // This is used to identify when two imports are the same and to resolve TypeScript enum keys.
        // Ideally we'd process escapes within the strings, but for now we pretty much take the raw
        // code.
        return this.code.slice(token.start + 1, token.end - 1);
    }
    matches1AtIndex(index, t1) {
        return this.tokens[index].type === t1;
    }
    matches2AtIndex(index, t1, t2) {
        return this.tokens[index].type === t1 && this.tokens[index + 1].type === t2;
    }
    matches3AtIndex(index, t1, t2, t3) {
        return this.tokens[index].type === t1 && this.tokens[index + 1].type === t2 && this.tokens[index + 2].type === t3;
    }
    matches1(t1) {
        return this.tokens[this.tokenIndex].type === t1;
    }
    matches2(t1, t2) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2;
    }
    matches3(t1, t2, t3) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3;
    }
    matches4(t1, t2, t3, t4) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3 && this.tokens[this.tokenIndex + 3].type === t4;
    }
    matches5(t1, t2, t3, t4, t5) {
        return this.tokens[this.tokenIndex].type === t1 && this.tokens[this.tokenIndex + 1].type === t2 && this.tokens[this.tokenIndex + 2].type === t3 && this.tokens[this.tokenIndex + 3].type === t4 && this.tokens[this.tokenIndex + 4].type === t5;
    }
    matchesContextual(contextualKeyword) {
        return this.matchesContextualAtIndex(this.tokenIndex, contextualKeyword);
    }
    matchesContextIdAndLabel(type, contextId) {
        return this.matches1(type) && this.currentToken().contextId === contextId;
    }
    previousWhitespaceAndComments() {
        let whitespaceAndComments = this.code.slice(this.tokenIndex > 0 ? this.tokens[this.tokenIndex - 1].end : 0, this.tokenIndex < this.tokens.length ? this.tokens[this.tokenIndex].start : this.code.length);
        if (this.isFlowEnabled) whitespaceAndComments = whitespaceAndComments.replace(/@flow/g, "");
        return whitespaceAndComments;
    }
    replaceToken(newCode) {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += newCode;
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    replaceTokenTrimmingLeftWhitespace(newCode) {
        this.resultCode += this.previousWhitespaceAndComments().replace(/[^\r\n]/g, "");
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += newCode;
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    removeInitialToken() {
        this.replaceToken("");
    }
    removeToken() {
        this.replaceTokenTrimmingLeftWhitespace("");
    }
    /**
   * Remove all code until the next }, accounting for balanced braces.
   */ removeBalancedCode() {
        let braceDepth = 0;
        while(!this.isAtEnd()){
            if (this.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) braceDepth++;
            else if (this.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                if (braceDepth === 0) return;
                braceDepth--;
            }
            this.removeToken();
        }
    }
    copyExpectedToken(tokenType) {
        if (this.tokens[this.tokenIndex].type !== tokenType) throw new Error(`Expected token ${tokenType}`);
        this.copyToken();
    }
    copyToken() {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end);
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    copyTokenWithPrefix(prefix) {
        this.resultCode += this.previousWhitespaceAndComments();
        this.appendTokenPrefix();
        this.resultCode += prefix;
        this.resultMappings[this.tokenIndex] = this.resultCode.length;
        this.resultCode += this.code.slice(this.tokens[this.tokenIndex].start, this.tokens[this.tokenIndex].end);
        this.appendTokenSuffix();
        this.tokenIndex++;
    }
    appendTokenPrefix() {
        const token = this.currentToken();
        if (token.numNullishCoalesceStarts || token.isOptionalChainStart) token.isAsyncOperation = (0, $40733ab601b41f9c$export$2e2bcd8739ae039)(this);
        if (this.disableESTransforms) return;
        if (token.numNullishCoalesceStarts) for(let i = 0; i < token.numNullishCoalesceStarts; i++){
            if (token.isAsyncOperation) {
                this.resultCode += "await ";
                this.resultCode += this.helperManager.getHelperName("asyncNullishCoalesce");
            } else this.resultCode += this.helperManager.getHelperName("nullishCoalesce");
            this.resultCode += "(";
        }
        if (token.isOptionalChainStart) {
            if (token.isAsyncOperation) this.resultCode += "await ";
            if (this.tokenIndex > 0 && this.tokenAtRelativeIndex(-1).type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._delete) {
                if (token.isAsyncOperation) this.resultCode += this.helperManager.getHelperName("asyncOptionalChainDelete");
                else this.resultCode += this.helperManager.getHelperName("optionalChainDelete");
            } else if (token.isAsyncOperation) this.resultCode += this.helperManager.getHelperName("asyncOptionalChain");
            else this.resultCode += this.helperManager.getHelperName("optionalChain");
            this.resultCode += "([";
        }
    }
    appendTokenSuffix() {
        const token = this.currentToken();
        if (token.isOptionalChainEnd && !this.disableESTransforms) this.resultCode += "])";
        if (token.numNullishCoalesceEnds && !this.disableESTransforms) for(let i = 0; i < token.numNullishCoalesceEnds; i++)this.resultCode += "))";
    }
    appendCode(code) {
        this.resultCode += code;
    }
    currentToken() {
        return this.tokens[this.tokenIndex];
    }
    currentTokenCode() {
        const token = this.currentToken();
        return this.code.slice(token.start, token.end);
    }
    tokenAtRelativeIndex(relativeIndex) {
        return this.tokens[this.tokenIndex + relativeIndex];
    }
    currentIndex() {
        return this.tokenIndex;
    }
    /**
   * Move to the next token. Only suitable in preprocessing steps. When
   * generating new code, you should use copyToken or removeToken.
   */ nextToken() {
        if (this.tokenIndex === this.tokens.length) throw new Error("Unexpectedly reached end of input.");
        this.tokenIndex++;
    }
    previousToken() {
        this.tokenIndex--;
    }
    finish() {
        if (this.tokenIndex !== this.tokens.length) throw new Error("Tried to finish processing tokens before reaching the end.");
        this.resultCode += this.previousWhitespaceAndComments();
        return {
            code: this.resultCode,
            mappings: this.resultMappings
        };
    }
    isAtEnd() {
        return this.tokenIndex === this.tokens.length;
    }
}






function $07b593d5ac07c28f$export$2e2bcd8739ae039(rootTransformer, tokens, nameManager, disableESTransforms) {
    const snapshot = tokens.snapshot();
    const headerInfo = $07b593d5ac07c28f$var$processClassHeader(tokens);
    let constructorInitializerStatements = [];
    const instanceInitializerNames = [];
    const staticInitializerNames = [];
    let constructorInsertPos = null;
    const fields = [];
    const rangesToRemove = [];
    const classContextId = tokens.currentToken().contextId;
    if (classContextId == null) throw new Error("Expected non-null class context ID on class open-brace.");
    tokens.nextToken();
    while(!tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR, classContextId)){
        if (tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._constructor) && !tokens.currentToken().isType) ({ constructorInitializerStatements: constructorInitializerStatements, constructorInsertPos: constructorInsertPos } = $07b593d5ac07c28f$var$processConstructor(tokens));
        else if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).semi)) {
            if (!disableESTransforms) rangesToRemove.push({
                start: tokens.currentIndex(),
                end: tokens.currentIndex() + 1
            });
            tokens.nextToken();
        } else if (tokens.currentToken().isType) tokens.nextToken();
        else {
            // Either a method or a field. Skip to the identifier part.
            const statementStartIndex = tokens.currentIndex();
            let isStatic = false;
            let isESPrivate = false;
            let isDeclareOrAbstract = false;
            while($07b593d5ac07c28f$var$isAccessModifier(tokens.currentToken())){
                if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._static)) isStatic = true;
                if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).hash)) isESPrivate = true;
                if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._declare) || tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract)) isDeclareOrAbstract = true;
                tokens.nextToken();
            }
            if (isStatic && tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
                // This is a static block, so don't process it in any special way.
                $07b593d5ac07c28f$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            if (isESPrivate) {
                // Sucrase doesn't attempt to transpile private fields; just leave them as-is.
                $07b593d5ac07c28f$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            if (tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._constructor) && !tokens.currentToken().isType) {
                ({ constructorInitializerStatements: constructorInitializerStatements, constructorInsertPos: constructorInsertPos } = $07b593d5ac07c28f$var$processConstructor(tokens));
                continue;
            }
            const nameStartIndex = tokens.currentIndex();
            $07b593d5ac07c28f$var$skipFieldName(tokens);
            if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan) || tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
                // This is a method, so nothing to process.
                $07b593d5ac07c28f$var$skipToNextClassElement(tokens, classContextId);
                continue;
            }
            // There might be a type annotation that we need to skip.
            while(tokens.currentToken().isType)tokens.nextToken();
            if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
                const equalsIndex = tokens.currentIndex();
                // This is an initializer, so we need to wrap in an initializer method.
                const valueEnd = tokens.currentToken().rhsEndIndex;
                if (valueEnd == null) throw new Error("Expected rhsEndIndex on class field assignment.");
                tokens.nextToken();
                while(tokens.currentIndex() < valueEnd)rootTransformer.processToken();
                let initializerName;
                if (isStatic) {
                    initializerName = nameManager.claimFreeName("__initStatic");
                    staticInitializerNames.push(initializerName);
                } else {
                    initializerName = nameManager.claimFreeName("__init");
                    instanceInitializerNames.push(initializerName);
                }
                // Fields start at the name, so `static x = 1;` has a field range of `x = 1;`.
                fields.push({
                    initializerName: initializerName,
                    equalsIndex: equalsIndex,
                    start: nameStartIndex,
                    end: tokens.currentIndex()
                });
            } else if (!disableESTransforms || isDeclareOrAbstract) // This is a regular field declaration, like `x;`. With the class transform enabled, we just
            // remove the line so that no output is produced. With the class transform disabled, we
            // usually want to preserve the declaration (but still strip types), but if the `declare`
            // or `abstract` keyword is specified, we should remove the line to avoid initializing the
            // value to undefined.
            rangesToRemove.push({
                start: statementStartIndex,
                end: tokens.currentIndex()
            });
        }
    }
    tokens.restoreToSnapshot(snapshot);
    if (disableESTransforms) // With ES transforms disabled, we don't want to transform regular class
    // field declarations, and we don't need to do any additional tricks to
    // reference the constructor for static init, but we still need to transform
    // TypeScript field initializers defined as constructor parameters and we
    // still need to remove `declare` fields. For now, we run the same code
    // path but omit any field information, as if the class had no field
    // declarations. In the future, when we fully drop the class fields
    // transform, we can simplify this code significantly.
    return {
        headerInfo: headerInfo,
        constructorInitializerStatements: constructorInitializerStatements,
        instanceInitializerNames: [],
        staticInitializerNames: [],
        constructorInsertPos: constructorInsertPos,
        fields: [],
        rangesToRemove: rangesToRemove
    };
    else return {
        headerInfo: headerInfo,
        constructorInitializerStatements: constructorInitializerStatements,
        instanceInitializerNames: instanceInitializerNames,
        staticInitializerNames: staticInitializerNames,
        constructorInsertPos: constructorInsertPos,
        fields: fields,
        rangesToRemove: rangesToRemove
    };
}
/**
 * Move the token processor to the next method/field in the class.
 *
 * To do that, we seek forward to the next start of a class name (either an open
 * bracket or an identifier, or the closing curly brace), then seek backward to
 * include any access modifiers.
 */ function $07b593d5ac07c28f$var$skipToNextClassElement(tokens, classContextId) {
    tokens.nextToken();
    while(tokens.currentToken().contextId !== classContextId)tokens.nextToken();
    while($07b593d5ac07c28f$var$isAccessModifier(tokens.tokenAtRelativeIndex(-1)))tokens.previousToken();
}
function $07b593d5ac07c28f$var$processClassHeader(tokens) {
    const classToken = tokens.currentToken();
    const contextId = classToken.contextId;
    if (contextId == null) throw new Error("Expected context ID on class token.");
    const isExpression = classToken.isExpression;
    if (isExpression == null) throw new Error("Expected isExpression on class token.");
    let className = null;
    let hasSuperclass = false;
    tokens.nextToken();
    if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) className = tokens.identifierName();
    while(!tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL, contextId)){
        // If this has a superclass, there will always be an `extends` token. If it doesn't have a
        // superclass, only type parameters and `implements` clauses can show up here, all of which
        // consist only of type tokens. A declaration like `class A<B extends C> {` should *not* count
        // as having a superclass.
        if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._extends) && !tokens.currentToken().isType) hasSuperclass = true;
        tokens.nextToken();
    }
    return {
        isExpression: isExpression,
        className: className,
        hasSuperclass: hasSuperclass
    };
}
/**
 * Extract useful information out of a constructor, starting at the "constructor" name.
 */ function $07b593d5ac07c28f$var$processConstructor(tokens) {
    const constructorInitializerStatements = [];
    tokens.nextToken();
    const constructorContextId = tokens.currentToken().contextId;
    if (constructorContextId == null) throw new Error("Expected context ID on open-paren starting constructor params.");
    // Advance through parameters looking for access modifiers.
    while(!tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR, constructorContextId))if (tokens.currentToken().contextId === constructorContextId) {
        // Current token is an open paren or comma just before a param, so check
        // that param for access modifiers.
        tokens.nextToken();
        if ($07b593d5ac07c28f$var$isAccessModifier(tokens.currentToken())) {
            tokens.nextToken();
            while($07b593d5ac07c28f$var$isAccessModifier(tokens.currentToken()))tokens.nextToken();
            const token = tokens.currentToken();
            if (token.type !== (0, $c455753917f2f29d$export$f435f793048e7a0f).name) throw new Error("Expected identifier after access modifiers in constructor arg.");
            const name = tokens.identifierNameForToken(token);
            constructorInitializerStatements.push(`this.${name} = ${name}`);
        }
    } else tokens.nextToken();
    // )
    tokens.nextToken();
    // Constructor type annotations are invalid, but skip them anyway since
    // they're easy to skip.
    while(tokens.currentToken().isType)tokens.nextToken();
    let constructorInsertPos = tokens.currentIndex();
    // Advance through body looking for a super call.
    let foundSuperCall = false;
    while(!tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR, constructorContextId)){
        if (!foundSuperCall && tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._super, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
            tokens.nextToken();
            const superCallContextId = tokens.currentToken().contextId;
            if (superCallContextId == null) throw new Error("Expected a context ID on the super call");
            while(!tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR, superCallContextId))tokens.nextToken();
            constructorInsertPos = tokens.currentIndex();
            foundSuperCall = true;
        }
        tokens.nextToken();
    }
    // }
    tokens.nextToken();
    return {
        constructorInitializerStatements: constructorInitializerStatements,
        constructorInsertPos: constructorInsertPos
    };
}
/**
 * Determine if this is any token that can go before the name in a method/field.
 */ function $07b593d5ac07c28f$var$isAccessModifier(token) {
    return [
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._async,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._get,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._set,
        (0, $c455753917f2f29d$export$f435f793048e7a0f).plus,
        (0, $c455753917f2f29d$export$f435f793048e7a0f).minus,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._readonly,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._static,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._public,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._private,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._protected,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._override,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract,
        (0, $c455753917f2f29d$export$f435f793048e7a0f).star,
        (0, $c455753917f2f29d$export$f435f793048e7a0f)._declare,
        (0, $c455753917f2f29d$export$f435f793048e7a0f).hash
    ].includes(token.type);
}
/**
 * The next token or set of tokens is either an identifier or an expression in square brackets, for
 * a method or field name.
 */ function $07b593d5ac07c28f$var$skipFieldName(tokens) {
    if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) {
        const startToken = tokens.currentToken();
        const classContextId = startToken.contextId;
        if (classContextId == null) throw new Error("Expected class context ID on computed name open bracket.");
        while(!tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR, classContextId))tokens.nextToken();
        tokens.nextToken();
    } else tokens.nextToken();
}






function $77906839a161f22c$export$2e2bcd8739ae039(tokens) {
    // import
    tokens.removeInitialToken();
    // name
    tokens.removeToken();
    // =
    tokens.removeToken();
    // name or require
    tokens.removeToken();
    // Handle either `import A = require('A')` or `import A = B.C.D`.
    if (tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
        // (
        tokens.removeToken();
        // path string
        tokens.removeToken();
        // )
        tokens.removeToken();
    } else while(tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)){
        // .
        tokens.removeToken();
        // name
        tokens.removeToken();
    }
}




const $9b75ede7b07cec99$export$cab8fec5d7ea8d7 = {
    typeDeclarations: new Set(),
    valueDeclarations: new Set()
};
function $9b75ede7b07cec99$export$2e2bcd8739ae039(tokens) {
    const typeDeclarations = new Set();
    const valueDeclarations = new Set();
    for(let i = 0; i < tokens.tokens.length; i++){
        const token = tokens.tokens[i];
        if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name && (0, $d45b756a11a5dc19$export$c08b4dec8c3c03d)(token)) {
            if (token.isType) typeDeclarations.add(tokens.identifierNameForToken(token));
            else valueDeclarations.add(tokens.identifierNameForToken(token));
        }
    }
    return {
        typeDeclarations: typeDeclarations,
        valueDeclarations: valueDeclarations
    };
}





function $f51788c14f37a410$export$2e2bcd8739ae039(tokens) {
    let closeBraceIndex = tokens.currentIndex();
    while(!tokens.matches1AtIndex(closeBraceIndex, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR))closeBraceIndex++;
    return tokens.matchesContextualAtIndex(closeBraceIndex + 1, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from) && tokens.matches1AtIndex(closeBraceIndex + 2, (0, $c455753917f2f29d$export$f435f793048e7a0f).string);
}




function $c3d89dbae6db348e$export$7e9be594554aa1b0(tokens) {
    if (tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._with, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) && tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._assert)) {
        // assert
        tokens.removeToken();
        // {
        tokens.removeToken();
        tokens.removeBalancedCode();
        // }
        tokens.removeToken();
    }
}



function $862b34e268a7d1da$export$2e2bcd8739ae039(isTypeScriptTransformEnabled, keepUnusedImports, tokens, declarationInfo) {
    if (!isTypeScriptTransformEnabled || keepUnusedImports) return false;
    const exportToken = tokens.currentToken();
    if (exportToken.rhsEndIndex == null) throw new Error("Expected non-null rhsEndIndex on export token.");
    // The export must be of the form `export default a` or `export default a;`.
    const numTokens = exportToken.rhsEndIndex - tokens.currentIndex();
    if (numTokens !== 3 && !(numTokens === 4 && tokens.matches1AtIndex(exportToken.rhsEndIndex - 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).semi))) return false;
    const identifierToken = tokens.tokenAtRelativeIndex(2);
    if (identifierToken.type !== (0, $c455753917f2f29d$export$f435f793048e7a0f).name) return false;
    const exportedName = tokens.identifierNameForToken(identifierToken);
    return declarationInfo.typeDeclarations.has(exportedName) && !declarationInfo.valueDeclarations.has(exportedName);
}



class $4d6246fae0738084$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    __init() {
        this.hadExport = false;
    }
    __init2() {
        this.hadNamedExport = false;
    }
    __init3() {
        this.hadDefaultExport = false;
    }
    constructor(rootTransformer, tokens, importProcessor, nameManager, helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, enableLegacyTypeScriptModuleInterop, isTypeScriptTransformEnabled, isFlowTransformEnabled, preserveDynamicImport, keepUnusedImports){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.nameManager = nameManager;
        this.helperManager = helperManager;
        this.reactHotLoaderTransformer = reactHotLoaderTransformer;
        this.enableLegacyBabel5ModuleInterop = enableLegacyBabel5ModuleInterop;
        this.enableLegacyTypeScriptModuleInterop = enableLegacyTypeScriptModuleInterop;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.isFlowTransformEnabled = isFlowTransformEnabled;
        this.preserveDynamicImport = preserveDynamicImport;
        this.keepUnusedImports = keepUnusedImports;
        $4d6246fae0738084$export$2e2bcd8739ae039.prototype.__init.call(this);
        $4d6246fae0738084$export$2e2bcd8739ae039.prototype.__init2.call(this);
        $4d6246fae0738084$export$2e2bcd8739ae039.prototype.__init3.call(this);
        this.declarationInfo = isTypeScriptTransformEnabled ? (0, $9b75ede7b07cec99$export$2e2bcd8739ae039)(tokens) : (0, $9b75ede7b07cec99$export$cab8fec5d7ea8d7);
    }
    getPrefixCode() {
        let prefix = "";
        if (this.hadExport) prefix += 'Object.defineProperty(exports, "__esModule", {value: true});';
        return prefix;
    }
    getSuffixCode() {
        if (this.enableLegacyBabel5ModuleInterop && this.hadDefaultExport && !this.hadNamedExport) return "\nmodule.exports = exports.default;\n";
        return "";
    }
    process() {
        // TypeScript `import foo = require('foo');` should always just be translated to plain require.
        if (this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._import, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) return this.processImportEquals();
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._import)) {
            this.processImport();
            return true;
        }
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
            this.tokens.replaceToken("module.exports");
            return true;
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._export) && !this.tokens.currentToken().isType) {
            this.hadExport = true;
            return this.processExport();
        }
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).postIncDec)) {
            // Fall through to normal identifier matching if this doesn't apply.
            if (this.processPostIncDec()) return true;
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).jsxName)) return this.processIdentifier();
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) return this.processAssignment();
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).assign)) return this.processComplexAssignment();
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).preIncDec)) return this.processPreIncDec();
        return false;
    }
    processImportEquals() {
        const importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        if (this.importProcessor.shouldAutomaticallyElideImportedName(importName)) // If this name is only used as a type, elide the whole import.
        (0, $77906839a161f22c$export$2e2bcd8739ae039)(this.tokens);
        else // Otherwise, switch `import` to `const`.
        this.tokens.replaceToken("const");
        return true;
    }
    /**
   * Transform this:
   * import foo, {bar} from 'baz';
   * into
   * var _baz = require('baz'); var _baz2 = _interopRequireDefault(_baz);
   *
   * The import code was already generated in the import preprocessing step, so
   * we just need to look it up.
   */ processImport() {
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._import, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
            if (this.preserveDynamicImport) {
                // Bail out, only making progress for this one token.
                this.tokens.copyToken();
                return;
            }
            const requireWrapper = this.enableLegacyTypeScriptModuleInterop ? "" : `${this.helperManager.getHelperName("interopRequireWildcard")}(`;
            this.tokens.replaceToken(`Promise.resolve().then(() => ${requireWrapper}require`);
            const contextId = this.tokens.currentToken().contextId;
            if (contextId == null) throw new Error("Expected context ID on dynamic import invocation.");
            this.tokens.copyToken();
            while(!this.tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR, contextId))this.rootTransformer.processToken();
            this.tokens.replaceToken(requireWrapper ? ")))" : "))");
            return;
        }
        const shouldElideImport = this.removeImportAndDetectIfShouldElide();
        if (shouldElideImport) this.tokens.removeToken();
        else {
            const path = this.tokens.stringValue();
            this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
            this.tokens.appendCode(this.importProcessor.claimImportCode(path));
        }
        (0, $c3d89dbae6db348e$export$7e9be594554aa1b0)(this.tokens);
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    /**
   * Erase this import (since any CJS output would be completely different), and
   * return true if this import is should be elided due to being a type-only
   * import. Such imports will not be emitted at all to avoid side effects.
   *
   * Import elision only happens with the TypeScript or Flow transforms enabled.
   *
   * TODO: This function has some awkward overlap with
   *  CJSImportProcessor.pruneTypeOnlyImports , and the two should be unified.
   *  That function handles TypeScript implicit import name elision, and removes
   *  an import if all typical imported names (without `type`) are removed due
   *  to being type-only imports. This function handles Flow import removal and
   *  properly distinguishes `import 'foo'` from `import {} from 'foo'` for TS
   *  purposes.
   *
   * The position should end at the import string.
   */ removeImportAndDetectIfShouldElide() {
        this.tokens.removeInitialToken();
        if (this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) {
            // This is an "import type" statement, so exit early.
            this.removeRemainingImport();
            return true;
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).name) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).star)) {
            // We have a default import or namespace import, so there must be some
            // non-type import.
            this.removeRemainingImport();
            return false;
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) // This is a bare import, so we should proceed with the import.
        return false;
        let foundNonTypeImport = false;
        let foundAnyNamedImport = false;
        while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).string)){
            // Check if any named imports are of the form "foo" or "foo as bar", with
            // no leading "type".
            if (!foundNonTypeImport && this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) {
                this.tokens.removeToken();
                if (!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) foundAnyNamedImport = true;
                if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) || this.tokens.matches4((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || this.tokens.matches4((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) foundNonTypeImport = true;
            }
            this.tokens.removeToken();
        }
        if (this.keepUnusedImports) return false;
        if (this.isTypeScriptTransformEnabled) return !foundNonTypeImport;
        else if (this.isFlowTransformEnabled) // In Flow, unlike TS, `import {} from 'foo';` preserves the import.
        return foundAnyNamedImport && !foundNonTypeImport;
        else return false;
    }
    removeRemainingImport() {
        while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).string))this.tokens.removeToken();
    }
    processIdentifier() {
        const token = this.tokens.currentToken();
        if (token.shadowsGlobal) return false;
        if (token.identifierRole === (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectShorthand) return this.processObjectShorthand();
        if (token.identifierRole !== (0, $d45b756a11a5dc19$export$99f888ada3c99de3).Access) return false;
        const replacement = this.importProcessor.getIdentifierReplacement(this.tokens.identifierNameForToken(token));
        if (!replacement) return false;
        // Tolerate any number of closing parens while looking for an opening paren
        // that indicates a function call.
        let possibleOpenParenIndex = this.tokens.currentIndex() + 1;
        while(possibleOpenParenIndex < this.tokens.tokens.length && this.tokens.tokens[possibleOpenParenIndex].type === (0, $c455753917f2f29d$export$f435f793048e7a0f).parenR)possibleOpenParenIndex++;
        // Avoid treating imported functions as methods of their `exports` object
        // by using `(0, f)` when the identifier is in a paren expression. Else
        // use `Function.prototype.call` when the identifier is a guaranteed
        // function call. When using `call`, pass undefined as the context.
        if (this.tokens.tokens[possibleOpenParenIndex].type === (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) {
            if (this.tokens.tokenAtRelativeIndex(1).type === (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL && this.tokens.tokenAtRelativeIndex(-1).type !== (0, $c455753917f2f29d$export$f435f793048e7a0f)._new) {
                this.tokens.replaceToken(`${replacement}.call(void 0, `);
                // Remove the old paren.
                this.tokens.removeToken();
                // Balance out the new paren.
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
            } else // See here: http://2ality.com/2015/12/references.html
            this.tokens.replaceToken(`(0, ${replacement})`);
        } else this.tokens.replaceToken(replacement);
        return true;
    }
    processObjectShorthand() {
        const identifier = this.tokens.identifierName();
        const replacement = this.importProcessor.getIdentifierReplacement(identifier);
        if (!replacement) return false;
        this.tokens.replaceToken(`${identifier}: ${replacement}`);
        return true;
    }
    processExport() {
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum) || this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._const, (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum)) {
            this.hadNamedExport = true;
            // Let the TypeScript transform handle it.
            return false;
        }
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default)) {
            if (this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum)) {
                this.hadDefaultExport = true;
                // Flow export default enums need some special handling, so handle them
                // in that tranform rather than this one.
                return false;
            }
            this.processExportDefault();
            return true;
        } else if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            this.processExportBindings();
            return true;
        } else if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
            // export type {a};
            // export type {a as b};
            // export type {a} from './b';
            // export type * from './b';
            // export type * as ns from './b';
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
                while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR))this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                // *
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._as)) {
                    // as
                    this.tokens.removeToken();
                    // ns
                    this.tokens.removeToken();
                }
            }
            // Remove type re-export `... } from './T'`
            if (this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).string)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                (0, $c3d89dbae6db348e$export$7e9be594554aa1b0)(this.tokens);
            }
            return true;
        }
        this.hadNamedExport = true;
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._var) || this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._let) || this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._const)) {
            this.processExportVar();
            return true;
        } else if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function) || // export async function
        this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function)) {
            this.processExportFunction();
            return true;
        } else if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._class) || this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract, (0, $c455753917f2f29d$export$f435f793048e7a0f)._class) || this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).at)) {
            this.processExportClass();
            return true;
        } else if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).star)) {
            this.processExportStar();
            return true;
        } else throw new Error("Unrecognized export syntax.");
    }
    processAssignment() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index - 1];
        // If the LHS is a type identifier, this must be a declaration like `let a: b = c;`,
        // with `b` as the identifier, so nothing needs to be done in that case.
        if (identifierToken.isType || identifierToken.type !== (0, $c455753917f2f29d$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 2 && this.tokens.matches1AtIndex(index - 2, (0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) return false;
        if (index >= 2 && [
            (0, $c455753917f2f29d$export$f435f793048e7a0f)._var,
            (0, $c455753917f2f29d$export$f435f793048e7a0f)._let,
            (0, $c455753917f2f29d$export$f435f793048e7a0f)._const
        ].includes(this.tokens.tokens[index - 2].type)) // Declarations don't need an extra assignment. This doesn't avoid the
        // assignment for comma-separated declarations, but it's still correct
        // since the assignment is just redundant.
        return false;
        const assignmentSnippet = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(identifierToken));
        if (!assignmentSnippet) return false;
        this.tokens.copyToken();
        this.tokens.appendCode(` ${assignmentSnippet} =`);
        return true;
    }
    /**
   * Process something like `a += 3`, where `a` might be an exported value.
   */ processComplexAssignment() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index - 1];
        if (identifierToken.type !== (0, $c455753917f2f29d$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 2 && this.tokens.matches1AtIndex(index - 2, (0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) return false;
        const assignmentSnippet = this.importProcessor.resolveExportBinding(this.tokens.identifierNameForToken(identifierToken));
        if (!assignmentSnippet) return false;
        this.tokens.appendCode(` = ${assignmentSnippet}`);
        this.tokens.copyToken();
        return true;
    }
    /**
   * Process something like `++a`, where `a` might be an exported value.
   */ processPreIncDec() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index + 1];
        if (identifierToken.type !== (0, $c455753917f2f29d$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        // Ignore things like ++a.b and ++a[b] and ++a().b.
        if (index + 2 < this.tokens.tokens.length && (this.tokens.matches1AtIndex(index + 2, (0, $c455753917f2f29d$export$f435f793048e7a0f).dot) || this.tokens.matches1AtIndex(index + 2, (0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL) || this.tokens.matches1AtIndex(index + 2, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL))) return false;
        const identifierName = this.tokens.identifierNameForToken(identifierToken);
        const assignmentSnippet = this.importProcessor.resolveExportBinding(identifierName);
        if (!assignmentSnippet) return false;
        this.tokens.appendCode(`${assignmentSnippet} = `);
        this.tokens.copyToken();
        return true;
    }
    /**
   * Process something like `a++`, where `a` might be an exported value.
   * This starts at the `a`, not at the `++`.
   */ processPostIncDec() {
        const index = this.tokens.currentIndex();
        const identifierToken = this.tokens.tokens[index];
        const operatorToken = this.tokens.tokens[index + 1];
        if (identifierToken.type !== (0, $c455753917f2f29d$export$f435f793048e7a0f).name) return false;
        if (identifierToken.shadowsGlobal) return false;
        if (index >= 1 && this.tokens.matches1AtIndex(index - 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) return false;
        const identifierName = this.tokens.identifierNameForToken(identifierToken);
        const assignmentSnippet = this.importProcessor.resolveExportBinding(identifierName);
        if (!assignmentSnippet) return false;
        const operatorCode = this.tokens.rawCodeForToken(operatorToken);
        // We might also replace the identifier with something like exports.x, so
        // do that replacement here as well.
        const base = this.importProcessor.getIdentifierReplacement(identifierName) || identifierName;
        if (operatorCode === "++") this.tokens.replaceToken(`(${base} = ${assignmentSnippet} = ${base} + 1, ${base} - 1)`);
        else if (operatorCode === "--") this.tokens.replaceToken(`(${base} = ${assignmentSnippet} = ${base} - 1, ${base} + 1)`);
        else throw new Error(`Unexpected operator: ${operatorCode}`);
        this.tokens.removeToken();
        return true;
    }
    processExportDefault() {
        let exportedRuntimeValue = true;
        if (this.tokens.matches4((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) || // export default async function
        this.tokens.matches5((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async)) {
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            // Named function export case: change it to a top-level function
            // declaration followed by exports statement.
            const name = this.processNamedFunction();
            this.tokens.appendCode(` exports.default = ${name};`);
        } else if (this.tokens.matches4((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f)._class, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) || this.tokens.matches5((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract, (0, $c455753917f2f29d$export$f435f793048e7a0f)._class, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) || this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f).at)) {
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.copyDecorators();
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract)) this.tokens.removeToken();
            const name = this.rootTransformer.processNamedClass();
            this.tokens.appendCode(` exports.default = ${name};`);
        // After this point, this is a plain "export default E" statement.
        } else if ((0, $862b34e268a7d1da$export$2e2bcd8739ae039)(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) {
            // If the exported value is just an identifier and should be elided by TypeScript
            // rules, then remove it entirely. It will always have the form `export default e`,
            // where `e` is an identifier.
            exportedRuntimeValue = false;
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.tokens.removeToken();
        } else if (this.reactHotLoaderTransformer) {
            // We need to assign E to a variable. Change "export default E" to
            // "let _default; exports.default = _default = E"
            const defaultVarName = this.nameManager.claimFreeName("_default");
            this.tokens.replaceToken(`let ${defaultVarName}; exports.`);
            this.tokens.copyToken();
            this.tokens.appendCode(` = ${defaultVarName} =`);
            this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
        } else {
            // Change "export default E" to "exports.default = E"
            this.tokens.replaceToken("exports.");
            this.tokens.copyToken();
            this.tokens.appendCode(" =");
        }
        if (exportedRuntimeValue) this.hadDefaultExport = true;
    }
    copyDecorators() {
        while(this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).at)){
            this.tokens.copyToken();
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
            } else {
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
                while(this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)){
                    this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).dot);
                    this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
                }
                if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
                    this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
                    this.rootTransformer.processBalancedCode();
                    this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
                }
            }
        }
    }
    /**
   * Transform a declaration like `export var`, `export let`, or `export const`.
   */ processExportVar() {
        if (this.isSimpleExportVar()) this.processSimpleExportVar();
        else this.processComplexExportVar();
    }
    /**
   * Determine if the export is of the form:
   * export var/let/const [varName] = [expr];
   * In other words, determine if function name inference might apply.
   */ isSimpleExportVar() {
        let tokenIndex = this.tokens.currentIndex();
        // export
        tokenIndex++;
        // var/let/const
        tokenIndex++;
        if (!this.tokens.matches1AtIndex(tokenIndex, (0, $c455753917f2f29d$export$f435f793048e7a0f).name)) return false;
        tokenIndex++;
        while(tokenIndex < this.tokens.tokens.length && this.tokens.tokens[tokenIndex].isType)tokenIndex++;
        if (!this.tokens.matches1AtIndex(tokenIndex, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) return false;
        return true;
    }
    /**
   * Transform an `export var` declaration initializing a single variable.
   *
   * For example, this:
   * export const f = () => {};
   * becomes this:
   * const f = () => {}; exports.f = f;
   *
   * The variable is unused (e.g. exports.f has the true value of the export).
   * We need to produce an assignment of this form so that the function will
   * have an inferred name of "f", which wouldn't happen in the more general
   * case below.
   */ processSimpleExportVar() {
        // export
        this.tokens.removeInitialToken();
        // var/let/const
        this.tokens.copyToken();
        const varName = this.tokens.identifierName();
        // x: number  ->  x
        while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).eq))this.rootTransformer.processToken();
        const endIndex = this.tokens.currentToken().rhsEndIndex;
        if (endIndex == null) throw new Error("Expected = token with an end index.");
        while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
        this.tokens.appendCode(`; exports.${varName} = ${varName}`);
    }
    /**
   * Transform normal declaration exports, including handling destructuring.
   * For example, this:
   * export const {x: [a = 2, b], c} = d;
   * becomes this:
   * ({x: [exports.a = 2, exports.b], c: exports.c} = d;)
   */ processComplexExportVar() {
        this.tokens.removeInitialToken();
        this.tokens.removeToken();
        const needsParens = this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
        if (needsParens) this.tokens.appendCode("(");
        let depth = 0;
        while(true){
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).dollarBraceL) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) {
                depth++;
                this.tokens.copyToken();
            } else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketR)) {
                depth--;
                this.tokens.copyToken();
            } else if (depth === 0 && !this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).name) && !this.tokens.currentToken().isType) break;
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
                // Default values might have assignments in the RHS that we want to ignore, so skip past
                // them.
                const endIndex = this.tokens.currentToken().rhsEndIndex;
                if (endIndex == null) throw new Error("Expected = token with an end index.");
                while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
            } else {
                const token = this.tokens.currentToken();
                if ((0, $d45b756a11a5dc19$export$31dc9881735f7118)(token)) {
                    const name = this.tokens.identifierName();
                    let replacement = this.importProcessor.getIdentifierReplacement(name);
                    if (replacement === null) throw new Error(`Expected a replacement for ${name} in \`export var\` syntax.`);
                    if ((0, $d45b756a11a5dc19$export$dea1d79574e9c731)(token)) replacement = `${name}: ${replacement}`;
                    this.tokens.replaceToken(replacement);
                } else this.rootTransformer.processToken();
            }
        }
        if (needsParens) {
            // Seek to the end of the RHS.
            const endIndex = this.tokens.currentToken().rhsEndIndex;
            if (endIndex == null) throw new Error("Expected = token with an end index.");
            while(this.tokens.currentIndex() < endIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(")");
        }
    }
    /**
   * Transform this:
   * export function foo() {}
   * into this:
   * function foo() {} exports.foo = foo;
   */ processExportFunction() {
        this.tokens.replaceToken("");
        const name = this.processNamedFunction();
        this.tokens.appendCode(` exports.${name} = ${name};`);
    }
    /**
   * Skip past a function with a name and return that name.
   */ processNamedFunction() {
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._function)) this.tokens.copyToken();
        else if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function)) {
            if (!this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async)) throw new Error("Expected async keyword in function export.");
            this.tokens.copyToken();
            this.tokens.copyToken();
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).star)) this.tokens.copyToken();
        if (!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) throw new Error("Expected identifier for exported function name.");
        const name = this.tokens.identifierName();
        this.tokens.copyToken();
        if (this.tokens.currentToken().isType) {
            this.tokens.removeInitialToken();
            while(this.tokens.currentToken().isType)this.tokens.removeToken();
        }
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
        this.rootTransformer.processBalancedCode();
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
        this.rootTransformer.processPossibleTypeRange();
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
        this.rootTransformer.processBalancedCode();
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
        return name;
    }
    /**
   * Transform this:
   * export class A {}
   * into this:
   * class A {} exports.A = A;
   */ processExportClass() {
        this.tokens.removeInitialToken();
        this.copyDecorators();
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract)) this.tokens.removeToken();
        const name = this.rootTransformer.processNamedClass();
        this.tokens.appendCode(` exports.${name} = ${name};`);
    }
    /**
   * Transform this:
   * export {a, b as c};
   * into this:
   * exports.a = a; exports.c = b;
   *
   * OR
   *
   * Transform this:
   * export {a, b as c} from './foo';
   * into the pre-generated Object.defineProperty code from the ImportProcessor.
   *
   * For the first case, if the TypeScript transform is enabled, we need to skip
   * exports that are only defined as types.
   */ processExportBindings() {
        this.tokens.removeInitialToken();
        this.tokens.removeToken();
        const isReExport = (0, $f51788c14f37a410$export$2e2bcd8739ae039)(this.tokens);
        const exportStatements = [];
        while(true){
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                break;
            }
            const specifierInfo = (0, $c66a0329e71568eb$export$2e2bcd8739ae039)(this.tokens);
            while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
            const shouldRemoveExport = specifierInfo.isType || !isReExport && this.shouldElideExportedIdentifier(specifierInfo.leftName);
            if (!shouldRemoveExport) {
                const exportedName = specifierInfo.rightName;
                if (exportedName === "default") this.hadDefaultExport = true;
                else this.hadNamedExport = true;
                const localName = specifierInfo.leftName;
                const newLocalName = this.importProcessor.getIdentifierReplacement(localName);
                exportStatements.push(`exports.${exportedName} = ${newLocalName || localName};`);
            }
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                break;
            }
            if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).comma, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                break;
            } else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            else throw new Error(`Unexpected token: ${JSON.stringify(this.tokens.currentToken())}`);
        }
        if (this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) {
            // This is an export...from, so throw away the normal named export code
            // and use the Object.defineProperty code from ImportProcessor.
            this.tokens.removeToken();
            const path = this.tokens.stringValue();
            this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
            (0, $c3d89dbae6db348e$export$7e9be594554aa1b0)(this.tokens);
        } else // This is a normal named export, so use that.
        this.tokens.appendCode(exportStatements.join(" "));
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    processExportStar() {
        this.tokens.removeInitialToken();
        while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).string))this.tokens.removeToken();
        const path = this.tokens.stringValue();
        this.tokens.replaceTokenTrimmingLeftWhitespace(this.importProcessor.claimImportCode(path));
        (0, $c3d89dbae6db348e$export$7e9be594554aa1b0)(this.tokens);
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
    }
    shouldElideExportedIdentifier(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.declarationInfo.valueDeclarations.has(name);
    }
}












class $36eb0764bcef2f94$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager, helperManager, reactHotLoaderTransformer, isTypeScriptTransformEnabled, isFlowTransformEnabled, keepUnusedImports, options){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
        this.helperManager = helperManager;
        this.reactHotLoaderTransformer = reactHotLoaderTransformer;
        this.isTypeScriptTransformEnabled = isTypeScriptTransformEnabled;
        this.isFlowTransformEnabled = isFlowTransformEnabled;
        this.keepUnusedImports = keepUnusedImports;
        this.nonTypeIdentifiers = isTypeScriptTransformEnabled && !keepUnusedImports ? (0, $4b994eadb2c0f428$export$d0e55db0e89d76b7)(tokens, options) : new Set();
        this.declarationInfo = isTypeScriptTransformEnabled && !keepUnusedImports ? (0, $9b75ede7b07cec99$export$2e2bcd8739ae039)(tokens) : (0, $9b75ede7b07cec99$export$cab8fec5d7ea8d7);
        this.injectCreateRequireForImportRequire = Boolean(options.injectCreateRequireForImportRequire);
    }
    process() {
        // TypeScript `import foo = require('foo');` should always just be translated to plain require.
        if (this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._import, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) return this.processImportEquals();
        if (this.tokens.matches4((0, $c455753917f2f29d$export$f435f793048e7a0f)._import, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
            // import type T = require('T')
            this.tokens.removeInitialToken();
            // This construct is always exactly 8 tokens long, so remove the 7 remaining tokens.
            for(let i = 0; i < 7; i++)this.tokens.removeToken();
            return true;
        }
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) {
            this.tokens.replaceToken("module.exports");
            return true;
        }
        if (this.tokens.matches5((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._import, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
            // export import type T = require('T')
            this.tokens.removeInitialToken();
            // This construct is always exactly 9 tokens long, so remove the 8 remaining tokens.
            for(let i = 0; i < 8; i++)this.tokens.removeToken();
            return true;
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._import)) return this.processImport();
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default)) return this.processExportDefault();
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) return this.processNamedExports();
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type)) {
            // export type {a};
            // export type {a as b};
            // export type {a} from './b';
            // export type * from './b';
            // export type * as ns from './b';
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
                while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR))this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                // *
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._as)) {
                    // as
                    this.tokens.removeToken();
                    // ns
                    this.tokens.removeToken();
                }
            }
            // Remove type re-export `... } from './T'`
            if (this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from) && this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).string)) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                (0, $c3d89dbae6db348e$export$7e9be594554aa1b0)(this.tokens);
            }
            return true;
        }
        return false;
    }
    processImportEquals() {
        const importName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        if (this.shouldAutomaticallyElideImportedName(importName)) // If this name is only used as a type, elide the whole import.
        (0, $77906839a161f22c$export$2e2bcd8739ae039)(this.tokens);
        else if (this.injectCreateRequireForImportRequire) {
            // We're using require in an environment (Node ESM) that doesn't provide
            // it as a global, so generate a helper to import it.
            // import -> const
            this.tokens.replaceToken("const");
            // Foo
            this.tokens.copyToken();
            // =
            this.tokens.copyToken();
            // require
            this.tokens.replaceToken(this.helperManager.getHelperName("require"));
        } else // Otherwise, just switch `import` to `const`.
        this.tokens.replaceToken("const");
        return true;
    }
    processImport() {
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._import, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) // Dynamic imports don't need to be transformed.
        return false;
        const snapshot = this.tokens.snapshot();
        const allImportsRemoved = this.removeImportTypeBindings();
        if (allImportsRemoved) {
            this.tokens.restoreToSnapshot(snapshot);
            while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).string))this.tokens.removeToken();
            this.tokens.removeToken();
            (0, $c3d89dbae6db348e$export$7e9be594554aa1b0)(this.tokens);
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).semi)) this.tokens.removeToken();
        }
        return true;
    }
    /**
   * Remove type bindings from this import, leaving the rest of the import intact.
   *
   * Return true if this import was ONLY types, and thus is eligible for removal. This will bail out
   * of the replacement operation, so we can return early here.
   */ removeImportTypeBindings() {
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f)._import);
        if (this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._type) && !this.tokens.matches1AtIndex(this.tokens.currentIndex() + 1, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma) && !this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 1, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) // This is an "import type" statement, so exit early.
        return true;
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).string)) {
            // This is a bare import, so we should proceed with the import.
            this.tokens.copyToken();
            return false;
        }
        // Skip the "module" token in import reflection.
        if (this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._module) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._from)) this.tokens.copyToken();
        let foundNonTypeImport = false;
        let foundAnyNamedImport = false;
        let needsComma = false;
        // Handle default import.
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
            if (this.shouldAutomaticallyElideImportedName(this.tokens.identifierName())) {
                this.tokens.removeToken();
                if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            } else {
                foundNonTypeImport = true;
                this.tokens.copyToken();
                if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) {
                    // We're in a statement like:
                    // import A, * as B from './A';
                    // or
                    // import A, {foo} from './A';
                    // where the `A` is being kept. The comma should be removed if an only
                    // if the next part of the import statement is elided, but that's hard
                    // to determine at this point in the code. Instead, always remove it
                    // and set a flag to add it back if necessary.
                    needsComma = true;
                    this.tokens.removeToken();
                }
            }
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).star)) {
            if (this.shouldAutomaticallyElideImportedName(this.tokens.identifierNameAtRelativeIndex(2))) {
                this.tokens.removeToken();
                this.tokens.removeToken();
                this.tokens.removeToken();
            } else {
                if (needsComma) this.tokens.appendCode(",");
                foundNonTypeImport = true;
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).star);
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
            }
        } else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            if (needsComma) this.tokens.appendCode(",");
            this.tokens.copyToken();
            while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)){
                foundAnyNamedImport = true;
                const specifierInfo = (0, $c66a0329e71568eb$export$2e2bcd8739ae039)(this.tokens);
                if (specifierInfo.isType || this.shouldAutomaticallyElideImportedName(specifierInfo.rightName)) {
                    while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                    if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
                } else {
                    foundNonTypeImport = true;
                    while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.copyToken();
                    if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
                }
            }
            this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
        }
        if (this.keepUnusedImports) return false;
        if (this.isTypeScriptTransformEnabled) return !foundNonTypeImport;
        else if (this.isFlowTransformEnabled) // In Flow, unlike TS, `import {} from 'foo';` preserves the import.
        return foundAnyNamedImport && !foundNonTypeImport;
        else return false;
    }
    shouldAutomaticallyElideImportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && !this.nonTypeIdentifiers.has(name);
    }
    processExportDefault() {
        if ((0, $862b34e268a7d1da$export$2e2bcd8739ae039)(this.isTypeScriptTransformEnabled, this.keepUnusedImports, this.tokens, this.declarationInfo)) {
            // If the exported value is just an identifier and should be elided by TypeScript
            // rules, then remove it entirely. It will always have the form `export default e`,
            // where `e` is an identifier.
            this.tokens.removeInitialToken();
            this.tokens.removeToken();
            this.tokens.removeToken();
            return true;
        }
        const alreadyHasName = this.tokens.matches4((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) || // export default async function
        this.tokens.matches5((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f)._function, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) && this.tokens.matchesContextualAtIndex(this.tokens.currentIndex() + 2, (0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async) || this.tokens.matches4((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f)._class, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) || this.tokens.matches5((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract, (0, $c455753917f2f29d$export$f435f793048e7a0f)._class, (0, $c455753917f2f29d$export$f435f793048e7a0f).name);
        if (!alreadyHasName && this.reactHotLoaderTransformer) {
            // This is a plain "export default E" statement and we need to assign E to a variable.
            // Change "export default E" to "let _default; export default _default = E"
            const defaultVarName = this.nameManager.claimFreeName("_default");
            this.tokens.replaceToken(`let ${defaultVarName}; export`);
            this.tokens.copyToken();
            this.tokens.appendCode(` ${defaultVarName} =`);
            this.reactHotLoaderTransformer.setExtractedDefaultExportName(defaultVarName);
            return true;
        }
        return false;
    }
    /**
   * Handle a statement with one of these forms:
   * export {a, type b};
   * export {c, type d} from 'foo';
   *
   * In both cases, any explicit type exports should be removed. In the first
   * case, we also need to handle implicit export elision for names declared as
   * types. In the second case, we must NOT do implicit named export elision,
   * but we must remove the runtime import if all exports are type exports.
   */ processNamedExports() {
        if (!this.isTypeScriptTransformEnabled) return false;
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f)._export);
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
        const isReExport = (0, $f51788c14f37a410$export$2e2bcd8739ae039)(this.tokens);
        let foundNonTypeExport = false;
        while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)){
            const specifierInfo = (0, $c66a0329e71568eb$export$2e2bcd8739ae039)(this.tokens);
            if (specifierInfo.isType || !isReExport && this.shouldElideExportedName(specifierInfo.leftName)) {
                // Type export, so remove all tokens, including any comma.
                while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.removeToken();
                if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            } else {
                // Non-type export, so copy all tokens, including any comma.
                foundNonTypeExport = true;
                while(this.tokens.currentIndex() < specifierInfo.endIndex)this.tokens.copyToken();
                if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
            }
        }
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
        if (!this.keepUnusedImports && isReExport && !foundNonTypeExport) {
            // This is a type-only re-export, so skip evaluating the other module. Technically this
            // leaves the statement as `export {}`, but that's ok since that's a no-op.
            this.tokens.removeToken();
            this.tokens.removeToken();
            (0, $c3d89dbae6db348e$export$7e9be594554aa1b0)(this.tokens);
        }
        return true;
    }
    /**
   * ESM elides all imports with the rule that we only elide if we see that it's
   * a type and never see it as a value. This is in contrast to CJS, which
   * elides imports that are completely unknown.
   */ shouldElideExportedName(name) {
        return this.isTypeScriptTransformEnabled && !this.keepUnusedImports && this.declarationInfo.typeDeclarations.has(name) && !this.declarationInfo.valueDeclarations.has(name);
    }
}





class $9d38be6546f2d268$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, isImportsTransformEnabled){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.isImportsTransformEnabled = isImportsTransformEnabled;
    }
    process() {
        if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) return true;
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._enum)) {
            this.processEnum();
            return true;
        }
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum)) {
            this.processNamedExportEnum();
            return true;
        }
        if (this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default, (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum)) {
            this.processDefaultExportEnum();
            return true;
        }
        return false;
    }
    /**
   * Handle a declaration like:
   * export enum E ...
   *
   * With this imports transform, this becomes:
   * const E = [[enum]]; exports.E = E;
   *
   * otherwise, it becomes:
   * export const E = [[enum]];
   */ processNamedExportEnum() {
        if (this.isImportsTransformEnabled) {
            // export
            this.tokens.removeInitialToken();
            const enumName = this.tokens.identifierNameAtRelativeIndex(1);
            this.processEnum();
            this.tokens.appendCode(` exports.${enumName} = ${enumName};`);
        } else {
            this.tokens.copyToken();
            this.processEnum();
        }
    }
    /**
   * Handle a declaration like:
   * export default enum E
   *
   * With the imports transform, this becomes:
   * const E = [[enum]]; exports.default = E;
   *
   * otherwise, it becomes:
   * const E = [[enum]]; export default E;
   */ processDefaultExportEnum() {
        // export
        this.tokens.removeInitialToken();
        // default
        this.tokens.removeToken();
        const enumName = this.tokens.identifierNameAtRelativeIndex(1);
        this.processEnum();
        if (this.isImportsTransformEnabled) this.tokens.appendCode(` exports.default = ${enumName};`);
        else this.tokens.appendCode(` export default ${enumName};`);
    }
    /**
   * Transpile flow enums to invoke the "flow-enums-runtime" library.
   *
   * Currently, the transpiled code always uses `require("flow-enums-runtime")`,
   * but if future flexibility is needed, we could expose a config option for
   * this string (similar to configurable JSX). Even when targeting ESM, the
   * default behavior of babel-plugin-transform-flow-enums is to use require
   * rather than injecting an import.
   *
   * Flow enums are quite a bit simpler than TS enums and have some convenient
   * constraints:
   * - Element initializers must be either always present or always absent. That
   *   means that we can use fixed lookahead on the first element (if any) and
   *   assume that all elements are like that.
   * - The right-hand side of an element initializer must be a literal value,
   *   not a complex expression and not referencing other elements. That means
   *   we can simply copy a single token.
   *
   * Enums can be broken up into three basic cases:
   *
   * Mirrored enums:
   * enum E {A, B}
   *   ->
   * const E = require("flow-enums-runtime").Mirrored(["A", "B"]);
   *
   * Initializer enums:
   * enum E {A = 1, B = 2}
   *   ->
   * const E = require("flow-enums-runtime")({A: 1, B: 2});
   *
   * Symbol enums:
   * enum E of symbol {A, B}
   *   ->
   * const E = require("flow-enums-runtime")({A: Symbol("A"), B: Symbol("B")});
   *
   * We can statically detect which of the three cases this is by looking at the
   * "of" declaration (if any) and seeing if the first element has an initializer.
   * Since the other transform details are so similar between the three cases, we
   * use a single implementation and vary the transform within processEnumElement
   * based on case.
   */ processEnum() {
        // enum E -> const E
        this.tokens.replaceToken("const");
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).name);
        let isSymbolEnum = false;
        if (this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._of)) {
            this.tokens.removeToken();
            isSymbolEnum = this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._symbol);
            this.tokens.removeToken();
        }
        const hasInitializers = this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq);
        this.tokens.appendCode(' = require("flow-enums-runtime")');
        const isMirrored = !isSymbolEnum && !hasInitializers;
        this.tokens.replaceTokenTrimmingLeftWhitespace(isMirrored ? ".Mirrored([" : "({");
        while(!this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)){
            // ... is allowed at the end and has no runtime behavior.
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).ellipsis)) {
                this.tokens.removeToken();
                break;
            }
            this.processEnumElement(isSymbolEnum, hasInitializers);
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) this.tokens.copyToken();
        }
        this.tokens.replaceToken(isMirrored ? "]);" : "});");
    }
    /**
   * Process an individual enum element, producing either an array element or an
   * object element based on what type of enum this is.
   */ processEnumElement(isSymbolEnum, hasInitializers) {
        if (isSymbolEnum) {
            // Symbol enums never have initializers and are expanded to object elements.
            // A, -> A: Symbol("A"),
            const elementName = this.tokens.identifierName();
            this.tokens.copyToken();
            this.tokens.appendCode(`: Symbol("${elementName}")`);
        } else if (hasInitializers) {
            // Initializers are expanded to object elements.
            // A = 1, -> A: 1,
            this.tokens.copyToken();
            this.tokens.replaceTokenTrimmingLeftWhitespace(":");
            this.tokens.copyToken();
        } else // Enum elements without initializers become string literal array elements.
        // A, -> "A",
        this.tokens.replaceToken(`"${this.tokens.identifierName()}"`);
    }
}




function $996ca9989a2aac2c$var$_optionalChain(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $996ca9989a2aac2c$var$JEST_GLOBAL_NAME = "jest";
const $996ca9989a2aac2c$var$HOISTED_METHODS = [
    "mock",
    "unmock",
    "enableAutomock",
    "disableAutomock"
];
class $996ca9989a2aac2c$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    __init() {
        this.hoistedFunctionNames = [];
    }
    constructor(rootTransformer, tokens, nameManager, importProcessor){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.nameManager = nameManager;
        this.importProcessor = importProcessor;
        $996ca9989a2aac2c$export$2e2bcd8739ae039.prototype.__init.call(this);
    }
    process() {
        if (this.tokens.currentToken().scopeDepth === 0 && this.tokens.matches4((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).dot, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) && this.tokens.identifierName() === $996ca9989a2aac2c$var$JEST_GLOBAL_NAME) {
            // TODO: This only works if imports transform is active, which it will be for jest.
            //       But if jest adds module support and we no longer need the import transform, this needs fixing.
            if ($996ca9989a2aac2c$var$_optionalChain([
                this,
                'access',
                (_)=>_.importProcessor,
                'optionalAccess',
                (_2)=>_2.getGlobalNames,
                'call',
                (_3)=>_3(),
                'optionalAccess',
                (_4)=>_4.has,
                'call',
                (_5)=>_5($996ca9989a2aac2c$var$JEST_GLOBAL_NAME)
            ])) return false;
            return this.extractHoistedCalls();
        }
        return false;
    }
    getHoistedCode() {
        if (this.hoistedFunctionNames.length > 0) // This will be placed before module interop code, but that's fine since
        // imports aren't allowed in module mock factories.
        return this.hoistedFunctionNames.map((name)=>`${name}();`).join("");
        return "";
    }
    /**
   * Extracts any methods calls on the jest-object that should be hoisted.
   *
   * According to the jest docs, https://jestjs.io/docs/en/jest-object#jestmockmodulename-factory-options,
   * mock, unmock, enableAutomock, disableAutomock, are the methods that should be hoisted.
   *
   * We do not apply the same checks of the arguments as babel-plugin-jest-hoist does.
   */ extractHoistedCalls() {
        // We're handling a chain of calls where `jest` may or may not need to be inserted for each call
        // in the chain, so remove the initial `jest` to make the loop implementation cleaner.
        this.tokens.removeToken();
        // Track some state so that multiple non-hoisted chained calls in a row keep their chaining
        // syntax.
        let followsNonHoistedJestCall = false;
        // Iterate through all chained calls on the jest object.
        while(this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f).dot, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)){
            const methodName = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
            const shouldHoist = $996ca9989a2aac2c$var$HOISTED_METHODS.includes(methodName);
            if (shouldHoist) {
                // We've matched e.g. `.mock(...)` or similar call.
                // Replace the initial `.` with `function __jestHoist(){jest.`
                const hoistedFunctionName = this.nameManager.claimFreeName("__jestHoist");
                this.hoistedFunctionNames.push(hoistedFunctionName);
                this.tokens.replaceToken(`function ${hoistedFunctionName}(){${$996ca9989a2aac2c$var$JEST_GLOBAL_NAME}.`);
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
                this.tokens.appendCode(";}");
                followsNonHoistedJestCall = false;
            } else {
                // This is a non-hoisted method, so just transform the code as usual.
                if (followsNonHoistedJestCall) // If we didn't hoist the previous call, we can leave the code as-is to chain off of the
                // previous method call. It's important to preserve the code here because we don't know
                // for sure that the method actually returned the jest object for chaining.
                this.tokens.copyToken();
                else // If we hoisted the previous call, we know it returns the jest object back, so we insert
                // the identifier `jest` to continue the chain.
                this.tokens.replaceToken(`${$996ca9989a2aac2c$var$JEST_GLOBAL_NAME}.`);
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.rootTransformer.processBalancedCode();
                this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
                followsNonHoistedJestCall = true;
            }
        }
        return true;
    }
}





class $4b657b2a91bef9d1$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    constructor(tokens){
        super();
        this.tokens = tokens;
    }
    process() {
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).num)) {
            const code = this.tokens.currentTokenCode();
            if (code.includes("_")) {
                this.tokens.replaceToken(code.replace(/_/g, ""));
                return true;
            }
        }
        return false;
    }
}




class $c073ca8cc6fe4846$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
    }
    process() {
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._catch, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
            this.tokens.copyToken();
            this.tokens.appendCode(` (${this.nameManager.claimFreeName("e")})`);
            return true;
        }
        return false;
    }
}




class $7750f5f3178b6075$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    constructor(tokens, nameManager){
        super();
        this.tokens = tokens;
        this.nameManager = nameManager;
    }
    process() {
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).nullishCoalescing)) {
            const token = this.tokens.currentToken();
            if (this.tokens.tokens[token.nullishStartIndex].isAsyncOperation) this.tokens.replaceTokenTrimmingLeftWhitespace(", async () => (");
            else this.tokens.replaceTokenTrimmingLeftWhitespace(", () => (");
            return true;
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._delete)) {
            const nextToken = this.tokens.tokenAtRelativeIndex(1);
            if (nextToken.isOptionalChainStart) {
                this.tokens.removeInitialToken();
                return true;
            }
        }
        const token = this.tokens.currentToken();
        const chainStart = token.subscriptStartIndex;
        if (chainStart != null && this.tokens.tokens[chainStart].isOptionalChainStart && // Super subscripts can't be optional (since super is never null/undefined), and the syntax
        // relies on the subscript being intact, so leave this token alone.
        this.tokens.tokenAtRelativeIndex(-1).type !== (0, $c455753917f2f29d$export$f435f793048e7a0f)._super) {
            const param = this.nameManager.claimFreeName("_");
            let arrowStartSnippet;
            if (chainStart > 0 && this.tokens.matches1AtIndex(chainStart - 1, (0, $c455753917f2f29d$export$f435f793048e7a0f)._delete) && this.isLastSubscriptInChain()) // Delete operations are special: we already removed the delete keyword, and to still
            // perform a delete, we need to insert a delete in the very last part of the chain, which
            // in correct code will always be a property access.
            arrowStartSnippet = `${param} => delete ${param}`;
            else arrowStartSnippet = `${param} => ${param}`;
            if (this.tokens.tokens[chainStart].isAsyncOperation) arrowStartSnippet = `async ${arrowStartSnippet}`;
            if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL) || this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot, (0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan)) {
                if (this.justSkippedSuper()) this.tokens.appendCode(".bind(this)");
                this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalCall', ${arrowStartSnippet}`);
            } else if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot, (0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${arrowStartSnippet}`);
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).questionDot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'optionalAccess', ${arrowStartSnippet}.`);
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).dot)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${arrowStartSnippet}.`);
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'access', ${arrowStartSnippet}[`);
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
                if (this.justSkippedSuper()) this.tokens.appendCode(".bind(this)");
                this.tokens.replaceTokenTrimmingLeftWhitespace(`, 'call', ${arrowStartSnippet}(`);
            } else throw new Error("Unexpected subscript operator in optional chain.");
            return true;
        }
        return false;
    }
    /**
   * Determine if the current token is the last of its chain, so that we know whether it's eligible
   * to have a delete op inserted.
   *
   * We can do this by walking forward until we determine one way or another. Each
   * isOptionalChainStart token must be paired with exactly one isOptionalChainEnd token after it in
   * a nesting way, so we can track depth and walk to the end of the chain (the point where the
   * depth goes negative) and see if any other subscript token is after us in the chain.
   */ isLastSubscriptInChain() {
        let depth = 0;
        for(let i = this.tokens.currentIndex() + 1;; i++){
            if (i >= this.tokens.tokens.length) throw new Error("Reached the end of the code while finding the end of the access chain.");
            if (this.tokens.tokens[i].isOptionalChainStart) depth++;
            else if (this.tokens.tokens[i].isOptionalChainEnd) depth--;
            if (depth < 0) return true;
            // This subscript token is a later one in the same chain.
            if (depth === 0 && this.tokens.tokens[i].subscriptStartIndex != null) return false;
        }
    }
    /**
   * Determine if we are the open-paren in an expression like super.a()?.b.
   *
   * We can do this by walking backward to find the previous subscript. If that subscript was
   * preceded by a super, then we must be the subscript after it, so if this is a call expression,
   * we'll need to attach the right context.
   */ justSkippedSuper() {
        let depth = 0;
        let index = this.tokens.currentIndex() - 1;
        while(true){
            if (index < 0) throw new Error("Reached the start of the code while finding the start of the access chain.");
            if (this.tokens.tokens[index].isOptionalChainStart) depth--;
            else if (this.tokens.tokens[index].isOptionalChainEnd) depth++;
            if (depth < 0) return false;
            // This subscript token is a later one in the same chain.
            if (depth === 0 && this.tokens.tokens[index].subscriptStartIndex != null) return this.tokens.tokens[index - 1].type === (0, $c455753917f2f29d$export$f435f793048e7a0f)._super;
            index--;
        }
    }
}





class $a631f6764ca82d49$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, importProcessor, options){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.importProcessor = importProcessor;
        this.options = options;
    }
    process() {
        const startIndex = this.tokens.currentIndex();
        if (this.tokens.identifierName() === "createReactClass") {
            const newName = this.importProcessor && this.importProcessor.getIdentifierReplacement("createReactClass");
            if (newName) this.tokens.replaceToken(`(0, ${newName})`);
            else this.tokens.copyToken();
            this.tryProcessCreateClassCall(startIndex);
            return true;
        }
        if (this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).dot, (0, $c455753917f2f29d$export$f435f793048e7a0f).name) && this.tokens.identifierName() === "React" && this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 2) === "createClass") {
            const newName = this.importProcessor ? this.importProcessor.getIdentifierReplacement("React") || "React" : "React";
            if (newName) {
                this.tokens.replaceToken(newName);
                this.tokens.copyToken();
                this.tokens.copyToken();
            } else {
                this.tokens.copyToken();
                this.tokens.copyToken();
                this.tokens.copyToken();
            }
            this.tryProcessCreateClassCall(startIndex);
            return true;
        }
        return false;
    }
    /**
   * This is called with the token position at the open-paren.
   */ tryProcessCreateClassCall(startIndex) {
        const displayName = this.findDisplayName(startIndex);
        if (!displayName) return;
        if (this.classNeedsDisplayName()) {
            this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL);
            this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
            this.tokens.appendCode(`displayName: '${displayName}',`);
            this.rootTransformer.processBalancedCode();
            this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
            this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
        }
    }
    findDisplayName(startIndex) {
        if (startIndex < 2) return null;
        if (this.tokens.matches2AtIndex(startIndex - 2, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) // This is an assignment (or declaration) and the LHS is either an identifier or a member
        // expression ending in an identifier, so use that identifier name.
        return this.tokens.identifierNameAtIndex(startIndex - 2);
        if (startIndex >= 2 && this.tokens.tokens[startIndex - 2].identifierRole === (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectKey) // This is an object literal value.
        return this.tokens.identifierNameAtIndex(startIndex - 2);
        if (this.tokens.matches2AtIndex(startIndex - 2, (0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._default)) return this.getDisplayNameFromFilename();
        return null;
    }
    getDisplayNameFromFilename() {
        const filePath = this.options.filePath || "unknown";
        const pathSegments = filePath.split("/");
        const filename = pathSegments[pathSegments.length - 1];
        const dotIndex = filename.lastIndexOf(".");
        const baseFilename = dotIndex === -1 ? filename : filename.slice(0, dotIndex);
        if (baseFilename === "index" && pathSegments[pathSegments.length - 2]) return pathSegments[pathSegments.length - 2];
        else return baseFilename;
    }
    /**
   * We only want to add a display name when this is a function call containing
   * one argument, which is an object literal without `displayName` as an
   * existing key.
   */ classNeedsDisplayName() {
        let index = this.tokens.currentIndex();
        if (!this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) return false;
        // The block starts on the {, and we expect any displayName key to be in
        // that context. We need to ignore other other contexts to avoid matching
        // nested displayName keys.
        const objectStartIndex = index + 1;
        const objectContextId = this.tokens.tokens[objectStartIndex].contextId;
        if (objectContextId == null) throw new Error("Expected non-null context ID on object open-brace.");
        for(; index < this.tokens.tokens.length; index++){
            const token = this.tokens.tokens[index];
            if (token.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR && token.contextId === objectContextId) {
                index++;
                break;
            }
            if (this.tokens.identifierNameAtIndex(index) === "displayName" && this.tokens.tokens[index].identifierRole === (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ObjectKey && token.contextId === objectContextId) // We found a displayName key, so bail out.
            return false;
        }
        if (index === this.tokens.tokens.length) throw new Error("Unexpected end of input when processing React class.");
        // If we got this far, we know we have createClass with an object with no
        // display name, so we want to proceed as long as that was the only argument.
        return this.tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenR) || this.tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenR);
    }
}




class $25a4484519615c9e$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    __init() {
        this.extractedDefaultExportName = null;
    }
    constructor(tokens, filePath){
        super();
        this.tokens = tokens;
        this.filePath = filePath;
        $25a4484519615c9e$export$2e2bcd8739ae039.prototype.__init.call(this);
    }
    setExtractedDefaultExportName(extractedDefaultExportName) {
        this.extractedDefaultExportName = extractedDefaultExportName;
    }
    getPrefixCode() {
        return `
      (function () {
        var enterModule = require('react-hot-loader').enterModule;
        enterModule && enterModule(module);
      })();`.replace(/\s+/g, " ").trim();
    }
    getSuffixCode() {
        const topLevelNames = new Set();
        for (const token of this.tokens.tokens)if (!token.isType && (0, $d45b756a11a5dc19$export$c08b4dec8c3c03d)(token) && token.identifierRole !== (0, $d45b756a11a5dc19$export$99f888ada3c99de3).ImportDeclaration) topLevelNames.add(this.tokens.identifierNameForToken(token));
        const namesToRegister = Array.from(topLevelNames).map((name)=>({
                variableName: name,
                uniqueLocalName: name
            }));
        if (this.extractedDefaultExportName) namesToRegister.push({
            variableName: this.extractedDefaultExportName,
            uniqueLocalName: "default"
        });
        return `
;(function () {
  var reactHotLoader = require('react-hot-loader').default;
  var leaveModule = require('react-hot-loader').leaveModule;
  if (!reactHotLoader) {
    return;
  }
${namesToRegister.map(({ variableName: variableName, uniqueLocalName: uniqueLocalName })=>`  reactHotLoader.register(${variableName}, "${uniqueLocalName}", ${JSON.stringify(this.filePath || "")});`).join("\n")}
  leaveModule(module);
})();`;
    }
    process() {
        return false;
    }
}




// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Lexical_grammar
// Hard-code a list of reserved words rather than trying to use keywords or contextual keywords
// from the parser, since currently there are various exceptions, like `package` being reserved
// but unused and various contextual keywords being reserved. Note that we assume that all code
// compiled by Sucrase is in a module, so strict mode words and await are all considered reserved
// here.
const $508d12abbc8ac13a$var$RESERVED_WORDS = new Set([
    // Reserved keywords as of ECMAScript 2015
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "debugger",
    "default",
    "delete",
    "do",
    "else",
    "export",
    "extends",
    "finally",
    "for",
    "function",
    "if",
    "import",
    "in",
    "instanceof",
    "new",
    "return",
    "super",
    "switch",
    "this",
    "throw",
    "try",
    "typeof",
    "var",
    "void",
    "while",
    "with",
    "yield",
    // Future reserved keywords
    "enum",
    "implements",
    "interface",
    "let",
    "package",
    "private",
    "protected",
    "public",
    "static",
    "await",
    // Literals that cannot be used as identifiers
    "false",
    "null",
    "true"
]);
function $508d12abbc8ac13a$export$2e2bcd8739ae039(name) {
    if (name.length === 0) return false;
    if (!(0, $d6dc0379bdf024ad$export$dc1d1d7d9fdffb8)[name.charCodeAt(0)]) return false;
    for(let i = 1; i < name.length; i++){
        if (!(0, $d6dc0379bdf024ad$export$d19df39e3926cfef)[name.charCodeAt(i)]) return false;
    }
    return !$508d12abbc8ac13a$var$RESERVED_WORDS.has(name);
}



class $802b6309c9ccd399$export$2e2bcd8739ae039 extends (0, $6fa448eb02f0faca$export$2e2bcd8739ae039) {
    constructor(rootTransformer, tokens, isImportsTransformEnabled){
        super();
        this.rootTransformer = rootTransformer;
        this.tokens = tokens;
        this.isImportsTransformEnabled = isImportsTransformEnabled;
    }
    process() {
        if (this.rootTransformer.processPossibleArrowParamEnd() || this.rootTransformer.processPossibleAsyncArrowWithTypeParams() || this.rootTransformer.processPossibleTypeRange()) return true;
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._public) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._protected) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._private) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._abstract) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._readonly) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._override) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).nonNullAssertion)) {
            this.tokens.removeInitialToken();
            return true;
        }
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._enum) || this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._const, (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum)) {
            this.processEnum();
            return true;
        }
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum) || this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f)._export, (0, $c455753917f2f29d$export$f435f793048e7a0f)._const, (0, $c455753917f2f29d$export$f435f793048e7a0f)._enum)) {
            this.processEnum(true);
            return true;
        }
        return false;
    }
    processEnum(isExport = false) {
        // We might have "export const enum", so just remove all relevant tokens.
        this.tokens.removeInitialToken();
        while(this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._const) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._enum))this.tokens.removeToken();
        const enumName = this.tokens.identifierName();
        this.tokens.removeToken();
        if (isExport && !this.isImportsTransformEnabled) this.tokens.appendCode("export ");
        this.tokens.appendCode(`var ${enumName}; (function (${enumName})`);
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
        this.processEnumBody(enumName);
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
        if (isExport && this.isImportsTransformEnabled) this.tokens.appendCode(`)(${enumName} || (exports.${enumName} = ${enumName} = {}));`);
        else this.tokens.appendCode(`)(${enumName} || (${enumName} = {}));`);
    }
    /**
   * Transform an enum into equivalent JS. This has complexity in a few places:
   * - TS allows string enums, numeric enums, and a mix of the two styles within an enum.
   * - Enum keys are allowed to be referenced in later enum values.
   * - Enum keys are allowed to be strings.
   * - When enum values are omitted, they should follow an auto-increment behavior.
   */ processEnumBody(enumName) {
        // Code that can be used to reference the previous enum member, or null if this is the first
        // enum member.
        let previousValueCode = null;
        while(true){
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) break;
            const { nameStringCode: nameStringCode, variableName: variableName } = this.extractEnumKeyInfo(this.tokens.currentToken());
            this.tokens.removeInitialToken();
            if (this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f).eq, (0, $c455753917f2f29d$export$f435f793048e7a0f).string, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma) || this.tokens.matches3((0, $c455753917f2f29d$export$f435f793048e7a0f).eq, (0, $c455753917f2f29d$export$f435f793048e7a0f).string, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) this.processStringLiteralEnumMember(enumName, nameStringCode, variableName);
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) this.processExplicitValueEnumMember(enumName, nameStringCode, variableName);
            else this.processImplicitValueEnumMember(enumName, nameStringCode, variableName, previousValueCode);
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) this.tokens.removeToken();
            if (variableName != null) previousValueCode = variableName;
            else previousValueCode = `${enumName}[${nameStringCode}]`;
        }
    }
    /**
   * Detect name information about this enum key, which will be used to determine which code to emit
   * and whether we should declare a variable as part of this declaration.
   *
   * Some cases to keep in mind:
   * - Enum keys can be implicitly referenced later, e.g. `X = 1, Y = X`. In Sucrase, we implement
   *   this by declaring a variable `X` so that later expressions can use it.
   * - In addition to the usual identifier key syntax, enum keys are allowed to be string literals,
   *   e.g. `"hello world" = 3,`. Template literal syntax is NOT allowed.
   * - Even if the enum key is defined as a string literal, it may still be referenced by identifier
   *   later, e.g. `"X" = 1, Y = X`. That means that we need to detect whether or not a string
   *   literal is identifier-like and emit a variable if so, even if the declaration did not use an
   *   identifier.
   * - Reserved keywords like `break` are valid enum keys, but are not valid to be referenced later
   *   and would be a syntax error if we emitted a variable, so we need to skip the variable
   *   declaration in those cases.
   *
   * The variableName return value captures these nuances: if non-null, we can and must emit a
   * variable declaration, and if null, we can't and shouldn't.
   */ extractEnumKeyInfo(nameToken) {
        if (nameToken.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).name) {
            const name = this.tokens.identifierNameForToken(nameToken);
            return {
                nameStringCode: `"${name}"`,
                variableName: (0, $508d12abbc8ac13a$export$2e2bcd8739ae039)(name) ? name : null
            };
        } else if (nameToken.type === (0, $c455753917f2f29d$export$f435f793048e7a0f).string) {
            const name = this.tokens.stringValueForToken(nameToken);
            return {
                nameStringCode: this.tokens.code.slice(nameToken.start, nameToken.end),
                variableName: (0, $508d12abbc8ac13a$export$2e2bcd8739ae039)(name) ? name : null
            };
        } else throw new Error("Expected name or string at beginning of enum element.");
    }
    /**
   * Handle an enum member where the RHS is just a string literal (not omitted, not a number, and
   * not a complex expression). This is the typical form for TS string enums, and in this case, we
   * do *not* create a reverse mapping.
   *
   * This is called after deleting the key token, when the token processor is at the equals sign.
   *
   * Example 1:
   * someKey = "some value"
   * ->
   * const someKey = "some value"; MyEnum["someKey"] = someKey;
   *
   * Example 2:
   * "some key" = "some value"
   * ->
   * MyEnum["some key"] = "some value";
   */ processStringLiteralEnumMember(enumName, nameStringCode, variableName) {
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName}`);
            // =
            this.tokens.copyToken();
            // value string
            this.tokens.copyToken();
            this.tokens.appendCode(`; ${enumName}[${nameStringCode}] = ${variableName};`);
        } else {
            this.tokens.appendCode(`${enumName}[${nameStringCode}]`);
            // =
            this.tokens.copyToken();
            // value string
            this.tokens.copyToken();
            this.tokens.appendCode(";");
        }
    }
    /**
   * Handle an enum member initialized with an expression on the right-hand side (other than a
   * string literal). In these cases, we should transform the expression and emit code that sets up
   * a reverse mapping.
   *
   * The TypeScript implementation of this operation distinguishes between expressions that can be
   * "constant folded" at compile time (i.e. consist of number literals and simple math operations
   * on those numbers) and ones that are dynamic. For constant expressions, it emits the resolved
   * numeric value, and auto-incrementing is only allowed in that case. Evaluating expressions at
   * compile time would add significant complexity to Sucrase, so Sucrase instead leaves the
   * expression as-is, and will later emit something like `MyEnum["previousKey"] + 1` to implement
   * auto-incrementing.
   *
   * This is called after deleting the key token, when the token processor is at the equals sign.
   *
   * Example 1:
   * someKey = 1 + 1
   * ->
   * const someKey = 1 + 1; MyEnum[MyEnum["someKey"] = someKey] = "someKey";
   *
   * Example 2:
   * "some key" = 1 + 1
   * ->
   * MyEnum[MyEnum["some key"] = 1 + 1] = "some key";
   */ processExplicitValueEnumMember(enumName, nameStringCode, variableName) {
        const rhsEndIndex = this.tokens.currentToken().rhsEndIndex;
        if (rhsEndIndex == null) throw new Error("Expected rhsEndIndex on enum assign.");
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName}`);
            this.tokens.copyToken();
            while(this.tokens.currentIndex() < rhsEndIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(`; ${enumName}[${enumName}[${nameStringCode}] = ${variableName}] = ${nameStringCode};`);
        } else {
            this.tokens.appendCode(`${enumName}[${enumName}[${nameStringCode}]`);
            this.tokens.copyToken();
            while(this.tokens.currentIndex() < rhsEndIndex)this.rootTransformer.processToken();
            this.tokens.appendCode(`] = ${nameStringCode};`);
        }
    }
    /**
   * Handle an enum member with no right-hand side expression. In this case, the value is the
   * previous value plus 1, or 0 if there was no previous value. We should also always emit a
   * reverse mapping.
   *
   * Example 1:
   * someKey2
   * ->
   * const someKey2 = someKey1 + 1; MyEnum[MyEnum["someKey2"] = someKey2] = "someKey2";
   *
   * Example 2:
   * "some key 2"
   * ->
   * MyEnum[MyEnum["some key 2"] = someKey1 + 1] = "some key 2";
   */ processImplicitValueEnumMember(enumName, nameStringCode, variableName, previousValueCode) {
        let valueCode = previousValueCode != null ? `${previousValueCode} + 1` : "0";
        if (variableName != null) {
            this.tokens.appendCode(`const ${variableName} = ${valueCode}; `);
            valueCode = variableName;
        }
        this.tokens.appendCode(`${enumName}[${enumName}[${nameStringCode}] = ${valueCode}] = ${nameStringCode};`);
    }
}


class $55819ac8ee90d6d6$export$2e2bcd8739ae039 {
    __init() {
        this.transformers = [];
    }
    __init2() {
        this.generatedVariables = [];
    }
    constructor(sucraseContext, transforms, enableLegacyBabel5ModuleInterop, options){
        $55819ac8ee90d6d6$export$2e2bcd8739ae039.prototype.__init.call(this);
        $55819ac8ee90d6d6$export$2e2bcd8739ae039.prototype.__init2.call(this);
        this.nameManager = sucraseContext.nameManager;
        this.helperManager = sucraseContext.helperManager;
        const { tokenProcessor: tokenProcessor, importProcessor: importProcessor } = sucraseContext;
        this.tokens = tokenProcessor;
        this.isImportsTransformEnabled = transforms.includes("imports");
        this.isReactHotLoaderTransformEnabled = transforms.includes("react-hot-loader");
        this.disableESTransforms = Boolean(options.disableESTransforms);
        if (!options.disableESTransforms) {
            this.transformers.push(new (0, $7750f5f3178b6075$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager));
            this.transformers.push(new (0, $4b657b2a91bef9d1$export$2e2bcd8739ae039)(tokenProcessor));
            this.transformers.push(new (0, $c073ca8cc6fe4846$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager));
        }
        if (transforms.includes("jsx")) {
            if (options.jsxRuntime !== "preserve") this.transformers.push(new (0, $f3732a5a55888920$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, this.nameManager, options));
            this.transformers.push(new (0, $a631f6764ca82d49$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, options));
        }
        let reactHotLoaderTransformer = null;
        if (transforms.includes("react-hot-loader")) {
            if (!options.filePath) throw new Error("filePath is required when using the react-hot-loader transform.");
            reactHotLoaderTransformer = new (0, $25a4484519615c9e$export$2e2bcd8739ae039)(tokenProcessor, options.filePath);
            this.transformers.push(reactHotLoaderTransformer);
        }
        // Note that we always want to enable the imports transformer, even when the import transform
        // itself isn't enabled, since we need to do type-only import pruning for both Flow and
        // TypeScript.
        if (transforms.includes("imports")) {
            if (importProcessor === null) throw new Error("Expected non-null importProcessor with imports transform enabled.");
            this.transformers.push(new (0, $4d6246fae0738084$export$2e2bcd8739ae039)(this, tokenProcessor, importProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, enableLegacyBabel5ModuleInterop, Boolean(options.enableLegacyTypeScriptModuleInterop), transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.preserveDynamicImport), Boolean(options.keepUnusedImports)));
        } else this.transformers.push(new (0, $36eb0764bcef2f94$export$2e2bcd8739ae039)(tokenProcessor, this.nameManager, this.helperManager, reactHotLoaderTransformer, transforms.includes("typescript"), transforms.includes("flow"), Boolean(options.keepUnusedImports), options));
        if (transforms.includes("flow")) this.transformers.push(new (0, $9d38be6546f2d268$export$2e2bcd8739ae039)(this, tokenProcessor, transforms.includes("imports")));
        if (transforms.includes("typescript")) this.transformers.push(new (0, $802b6309c9ccd399$export$2e2bcd8739ae039)(this, tokenProcessor, transforms.includes("imports")));
        if (transforms.includes("jest")) this.transformers.push(new (0, $996ca9989a2aac2c$export$2e2bcd8739ae039)(this, tokenProcessor, this.nameManager, importProcessor));
    }
    transform() {
        this.tokens.reset();
        this.processBalancedCode();
        const shouldAddUseStrict = this.isImportsTransformEnabled;
        // "use strict" always needs to be first, so override the normal transformer order.
        let prefix = shouldAddUseStrict ? '"use strict";' : "";
        for (const transformer of this.transformers)prefix += transformer.getPrefixCode();
        prefix += this.helperManager.emitHelpers();
        prefix += this.generatedVariables.map((v)=>` var ${v};`).join("");
        for (const transformer of this.transformers)prefix += transformer.getHoistedCode();
        let suffix = "";
        for (const transformer of this.transformers)suffix += transformer.getSuffixCode();
        const result = this.tokens.finish();
        let { code: code } = result;
        if (code.startsWith("#!")) {
            let newlineIndex = code.indexOf("\n");
            if (newlineIndex === -1) {
                newlineIndex = code.length;
                code += "\n";
            }
            return {
                code: code.slice(0, newlineIndex + 1) + prefix + code.slice(newlineIndex + 1) + suffix,
                // The hashbang line has no tokens, so shifting the tokens to account
                // for prefix can happen normally.
                mappings: this.shiftMappings(result.mappings, prefix.length)
            };
        } else return {
            code: prefix + code + suffix,
            mappings: this.shiftMappings(result.mappings, prefix.length)
        };
    }
    processBalancedCode() {
        let braceDepth = 0;
        let parenDepth = 0;
        while(!this.tokens.isAtEnd()){
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).dollarBraceL)) braceDepth++;
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) {
                if (braceDepth === 0) return;
                braceDepth--;
            }
            if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) parenDepth++;
            else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR)) {
                if (parenDepth === 0) return;
                parenDepth--;
            }
            this.processToken();
        }
    }
    processToken() {
        if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._class)) {
            this.processClass();
            return;
        }
        for (const transformer of this.transformers){
            const wasProcessed = transformer.process();
            if (wasProcessed) return;
        }
        this.tokens.copyToken();
    }
    /**
   * Skip past a class with a name and return that name.
   */ processNamedClass() {
        if (!this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f)._class, (0, $c455753917f2f29d$export$f435f793048e7a0f).name)) throw new Error("Expected identifier for exported class name.");
        const name = this.tokens.identifierNameAtIndex(this.tokens.currentIndex() + 1);
        this.processClass();
        return name;
    }
    processClass() {
        const classInfo = (0, $07b593d5ac07c28f$export$2e2bcd8739ae039)(this, this.tokens, this.nameManager, this.disableESTransforms);
        // Both static and instance initializers need a class name to use to invoke the initializer, so
        // assign to one if necessary.
        const needsCommaExpression = (classInfo.headerInfo.isExpression || !classInfo.headerInfo.className) && classInfo.staticInitializerNames.length + classInfo.instanceInitializerNames.length > 0;
        let className = classInfo.headerInfo.className;
        if (needsCommaExpression) {
            className = this.nameManager.claimFreeName("_class");
            this.generatedVariables.push(className);
            this.tokens.appendCode(` (${className} =`);
        }
        const classToken = this.tokens.currentToken();
        const contextId = classToken.contextId;
        if (contextId == null) throw new Error("Expected class to have a context ID.");
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f)._class);
        while(!this.tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL, contextId))this.processToken();
        this.processClassBody(classInfo, className);
        const staticInitializerStatements = classInfo.staticInitializerNames.map((name)=>`${className}.${name}()`);
        if (needsCommaExpression) this.tokens.appendCode(`, ${staticInitializerStatements.map((s)=>`${s}, `).join("")}${className})`);
        else if (classInfo.staticInitializerNames.length > 0) this.tokens.appendCode(` ${staticInitializerStatements.map((s)=>`${s};`).join(" ")}`);
    }
    /**
   * We want to just handle class fields in all contexts, since TypeScript supports them. Later,
   * when some JS implementations support class fields, this should be made optional.
   */ processClassBody(classInfo, className) {
        const { headerInfo: headerInfo, constructorInsertPos: constructorInsertPos, constructorInitializerStatements: constructorInitializerStatements, fields: fields, instanceInitializerNames: instanceInitializerNames, rangesToRemove: rangesToRemove } = classInfo;
        let fieldIndex = 0;
        let rangeToRemoveIndex = 0;
        const classContextId = this.tokens.currentToken().contextId;
        if (classContextId == null) throw new Error("Expected non-null context ID on class.");
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceL);
        if (this.isReactHotLoaderTransformEnabled) this.tokens.appendCode("__reactstandin__regenerateByEval(key, code) {this[key] = eval(code);}");
        const needsConstructorInit = constructorInitializerStatements.length + instanceInitializerNames.length > 0;
        if (constructorInsertPos === null && needsConstructorInit) {
            const constructorInitializersCode = this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className);
            if (headerInfo.hasSuperclass) {
                const argsName = this.nameManager.claimFreeName("args");
                this.tokens.appendCode(`constructor(...${argsName}) { super(...${argsName}); ${constructorInitializersCode}; }`);
            } else this.tokens.appendCode(`constructor() { ${constructorInitializersCode}; }`);
        }
        while(!this.tokens.matchesContextIdAndLabel((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR, classContextId)){
            if (fieldIndex < fields.length && this.tokens.currentIndex() === fields[fieldIndex].start) {
                let needsCloseBrace = false;
                if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).bracketL)) this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this`);
                else if (this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).string) || this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f).num)) {
                    this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this[`);
                    needsCloseBrace = true;
                } else this.tokens.copyTokenWithPrefix(`${fields[fieldIndex].initializerName}() {this.`);
                while(this.tokens.currentIndex() < fields[fieldIndex].end){
                    if (needsCloseBrace && this.tokens.currentIndex() === fields[fieldIndex].equalsIndex) this.tokens.appendCode("]");
                    this.processToken();
                }
                this.tokens.appendCode("}");
                fieldIndex++;
            } else if (rangeToRemoveIndex < rangesToRemove.length && this.tokens.currentIndex() >= rangesToRemove[rangeToRemoveIndex].start) {
                if (this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end) this.tokens.removeInitialToken();
                while(this.tokens.currentIndex() < rangesToRemove[rangeToRemoveIndex].end)this.tokens.removeToken();
                rangeToRemoveIndex++;
            } else if (this.tokens.currentIndex() === constructorInsertPos) {
                this.tokens.copyToken();
                if (needsConstructorInit) this.tokens.appendCode(`;${this.makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className)};`);
                this.processToken();
            } else this.processToken();
        }
        this.tokens.copyExpectedToken((0, $c455753917f2f29d$export$f435f793048e7a0f).braceR);
    }
    makeConstructorInitCode(constructorInitializerStatements, instanceInitializerNames, className) {
        return [
            ...constructorInitializerStatements,
            ...instanceInitializerNames.map((name)=>`${className}.prototype.${name}.call(this)`)
        ].join(";");
    }
    /**
   * Normally it's ok to simply remove type tokens, but we need to be more careful when dealing with
   * arrow function return types since they can confuse the parser. In that case, we want to move
   * the close-paren to the same line as the arrow.
   *
   * See https://github.com/alangpierce/sucrase/issues/391 for more details.
   */ processPossibleArrowParamEnd() {
        if (this.tokens.matches2((0, $c455753917f2f29d$export$f435f793048e7a0f).parenR, (0, $c455753917f2f29d$export$f435f793048e7a0f).colon) && this.tokens.tokenAtRelativeIndex(1).isType) {
            let nextNonTypeIndex = this.tokens.currentIndex() + 1;
            // Look ahead to see if this is an arrow function or something else.
            while(this.tokens.tokens[nextNonTypeIndex].isType)nextNonTypeIndex++;
            if (this.tokens.matches1AtIndex(nextNonTypeIndex, (0, $c455753917f2f29d$export$f435f793048e7a0f).arrow)) {
                this.tokens.removeInitialToken();
                while(this.tokens.currentIndex() < nextNonTypeIndex)this.tokens.removeToken();
                this.tokens.replaceTokenTrimmingLeftWhitespace(") =>");
                return true;
            }
        }
        return false;
    }
    /**
   * An async arrow function might be of the form:
   *
   * async <
   *   T
   * >() => {}
   *
   * in which case, removing the type parameters will cause a syntax error. Detect this case and
   * move the open-paren earlier.
   */ processPossibleAsyncArrowWithTypeParams() {
        if (!this.tokens.matchesContextual((0, $0e760627819a3d75$export$ee633ab6cd0138cc)._async) && !this.tokens.matches1((0, $c455753917f2f29d$export$f435f793048e7a0f)._async)) return false;
        const nextToken = this.tokens.tokenAtRelativeIndex(1);
        if (nextToken.type !== (0, $c455753917f2f29d$export$f435f793048e7a0f).lessThan || !nextToken.isType) return false;
        let nextNonTypeIndex = this.tokens.currentIndex() + 1;
        // Look ahead to see if this is an arrow function or something else.
        while(this.tokens.tokens[nextNonTypeIndex].isType)nextNonTypeIndex++;
        if (this.tokens.matches1AtIndex(nextNonTypeIndex, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) {
            this.tokens.replaceToken("async (");
            this.tokens.removeInitialToken();
            while(this.tokens.currentIndex() < nextNonTypeIndex)this.tokens.removeToken();
            this.tokens.removeToken();
            // We ate a ( token, so we need to process the tokens in between and then the ) token so that
            // we remain balanced.
            this.processBalancedCode();
            this.processToken();
            return true;
        }
        return false;
    }
    processPossibleTypeRange() {
        if (this.tokens.currentToken().isType) {
            this.tokens.removeInitialToken();
            while(this.tokens.currentToken().isType)this.tokens.removeToken();
            return true;
        }
        return false;
    }
    shiftMappings(mappings, prefixLength) {
        for(let i = 0; i < mappings.length; i++){
            const mapping = mappings[i];
            if (mapping !== undefined) mappings[i] = mapping + prefixLength;
        }
        return mappings;
    }
}


var $6f9543070afb913f$export$1e511d4a378977f5;
var $6f9543070afb913f$export$f2e513d2bc4a3b5a;
var $6f9543070afb913f$export$2e2bcd8739ae039;
"use strict";
$6f9543070afb913f$export$1e511d4a378977f5 = true;
$6f9543070afb913f$export$f2e513d2bc4a3b5a = void 0;
var $6f9543070afb913f$var$LF = '\n';
var $6f9543070afb913f$var$CR = '\r';
var $6f9543070afb913f$var$LinesAndColumns = /** @class */ function() {
    function LinesAndColumns(string) {
        this.string = string;
        var offsets = [
            0
        ];
        for(var offset = 0; offset < string.length;)switch(string[offset]){
            case $6f9543070afb913f$var$LF:
                offset += $6f9543070afb913f$var$LF.length;
                offsets.push(offset);
                break;
            case $6f9543070afb913f$var$CR:
                offset += $6f9543070afb913f$var$CR.length;
                if (string[offset] === $6f9543070afb913f$var$LF) offset += $6f9543070afb913f$var$LF.length;
                offsets.push(offset);
                break;
            default:
                offset++;
                break;
        }
        this.offsets = offsets;
    }
    LinesAndColumns.prototype.locationForIndex = function(index) {
        if (index < 0 || index > this.string.length) return null;
        var line = 0;
        var offsets = this.offsets;
        while(offsets[line + 1] <= index)line++;
        var column = index - offsets[line];
        return {
            line: line,
            column: column
        };
    };
    LinesAndColumns.prototype.indexForLocation = function(location) {
        var line = location.line, column = location.column;
        if (line < 0 || line >= this.offsets.length) return null;
        if (column < 0 || column > this.lengthOfLine(line)) return null;
        return this.offsets[line] + column;
    };
    LinesAndColumns.prototype.lengthOfLine = function(line) {
        var offset = this.offsets[line];
        var nextOffset = line === this.offsets.length - 1 ? this.string.length : this.offsets[line + 1];
        return nextOffset - offset;
    };
    return LinesAndColumns;
}();
$6f9543070afb913f$export$f2e513d2bc4a3b5a = $6f9543070afb913f$var$LinesAndColumns;
$6f9543070afb913f$export$2e2bcd8739ae039 = $6f9543070afb913f$var$LinesAndColumns;



function $9bd9f0955aa94f97$export$2e2bcd8739ae039(code, tokens) {
    if (tokens.length === 0) return "";
    const tokenKeys = Object.keys(tokens[0]).filter((k)=>k !== "type" && k !== "value" && k !== "start" && k !== "end" && k !== "loc");
    const typeKeys = Object.keys(tokens[0].type).filter((k)=>k !== "label" && k !== "keyword");
    const headings = [
        "Location",
        "Label",
        "Raw",
        ...tokenKeys,
        ...typeKeys
    ];
    const lines = new (0, $6f9543070afb913f$export$2e2bcd8739ae039)(code);
    const rows = [
        headings,
        ...tokens.map(getTokenComponents)
    ];
    const padding = headings.map(()=>0);
    for (const components of rows)for(let i = 0; i < components.length; i++)padding[i] = Math.max(padding[i], components[i].length);
    return rows.map((components)=>components.map((component, i)=>component.padEnd(padding[i])).join(" ")).join("\n");
    function getTokenComponents(token) {
        const raw = code.slice(token.start, token.end);
        return [
            formatRange(token.start, token.end),
            (0, $c455753917f2f29d$export$b78065ce79336a93)(token.type),
            $9bd9f0955aa94f97$var$truncate(String(raw), 14),
            // @ts-ignore: Intentional dynamic access by key.
            ...tokenKeys.map((key)=>formatValue(token[key], key)),
            // @ts-ignore: Intentional dynamic access by key.
            ...typeKeys.map((key)=>formatValue(token.type[key], key))
        ];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function formatValue(value, key) {
        if (value === true) return key;
        else if (value === false || value === null) return "";
        else return String(value);
    }
    function formatRange(start, end) {
        return `${formatPos(start)}-${formatPos(end)}`;
    }
    function formatPos(pos) {
        const location = lines.locationForIndex(pos);
        if (!location) return "Unknown";
        else return `${location.line + 1}:${location.column + 1}`;
    }
}
function $9bd9f0955aa94f97$var$truncate(s, length) {
    if (s.length > length) return `${s.slice(0, length - 3)}...`;
    else return s;
}




function $8120cb26967b58d6$export$2e2bcd8739ae039(tokens) {
    const importedNames = new Set();
    for(let i = 0; i < tokens.tokens.length; i++)if (tokens.matches1AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f)._import) && !tokens.matches3AtIndex(i, (0, $c455753917f2f29d$export$f435f793048e7a0f)._import, (0, $c455753917f2f29d$export$f435f793048e7a0f).name, (0, $c455753917f2f29d$export$f435f793048e7a0f).eq)) $8120cb26967b58d6$var$collectNamesForImport(tokens, i, importedNames);
    return importedNames;
}
function $8120cb26967b58d6$var$collectNamesForImport(tokens, index, importedNames) {
    index++;
    if (tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).parenL)) // Dynamic import, so nothing to do
    return;
    if (tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).name)) {
        importedNames.add(tokens.identifierNameAtIndex(index));
        index++;
        if (tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) index++;
    }
    if (tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).star)) {
        // * as
        index += 2;
        importedNames.add(tokens.identifierNameAtIndex(index));
        index++;
    }
    if (tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceL)) {
        index++;
        $8120cb26967b58d6$var$collectNamesForNamedImport(tokens, index, importedNames);
    }
}
function $8120cb26967b58d6$var$collectNamesForNamedImport(tokens, index, importedNames) {
    while(true){
        if (tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) return;
        const specifierInfo = (0, $c66a0329e71568eb$export$2e2bcd8739ae039)(tokens, index);
        index = specifierInfo.endIndex;
        if (!specifierInfo.isType) importedNames.add(specifierInfo.rightName);
        if (tokens.matches2AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) return;
        else if (tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).braceR)) return;
        else if (tokens.matches1AtIndex(index, (0, $c455753917f2f29d$export$f435f793048e7a0f).comma)) index++;
        else throw new Error(`Unexpected token: ${JSON.stringify(tokens.tokens[index])}`);
    }
}


function $8d35fcad3f72dcf4$export$c506eb22e615ba4a() {
    /* istanbul ignore next */ return "3.35.1";
}
function $8d35fcad3f72dcf4$export$51186ad6e864892a(code, options) {
    (0, $6af1ca2bc9e09530$export$1dd09873c1bdd0fc)(options);
    try {
        const sucraseContext = $8d35fcad3f72dcf4$var$getSucraseContext(code, options);
        const transformer = new (0, $55819ac8ee90d6d6$export$2e2bcd8739ae039)(sucraseContext, options.transforms, Boolean(options.enableLegacyBabel5ModuleInterop), options);
        const transformerResult = transformer.transform();
        let result = {
            code: transformerResult.code
        };
        if (options.sourceMapOptions) {
            if (!options.filePath) throw new Error("filePath must be specified when generating a source map.");
            result = {
                ...result,
                sourceMap: (0, $9cb824f031f73e03$export$2e2bcd8739ae039)(transformerResult, options.filePath, options.sourceMapOptions, code, sucraseContext.tokenProcessor.tokens)
            };
        }
        return result;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        if (options.filePath) e.message = `Error transforming ${options.filePath}: ${e.message}`;
        throw e;
    }
}
function $8d35fcad3f72dcf4$export$fd97d3ecabd3e6b7(code, options) {
    const tokens = $8d35fcad3f72dcf4$var$getSucraseContext(code, options).tokenProcessor.tokens;
    return (0, $9bd9f0955aa94f97$export$2e2bcd8739ae039)(code, tokens);
}
/**
 * Call into the parser/tokenizer and do some further preprocessing:
 * - Come up with a set of used names so that we can assign new names.
 * - Preprocess all import/export statements so we know which globals we are interested in.
 * - Compute situations where any of those globals are shadowed.
 *
 * In the future, some of these preprocessing steps can be skipped based on what actual work is
 * being done.
 */ function $8d35fcad3f72dcf4$var$getSucraseContext(code, options) {
    const isJSXEnabled = options.transforms.includes("jsx");
    const isTypeScriptEnabled = options.transforms.includes("typescript");
    const isFlowEnabled = options.transforms.includes("flow");
    const disableESTransforms = options.disableESTransforms === true;
    const file = (0, $d4d47ec13fa63669$export$98e6a39c04603d36)(code, isJSXEnabled, isTypeScriptEnabled, isFlowEnabled);
    const tokens = file.tokens;
    const scopes = file.scopes;
    const nameManager = new (0, $f08dedf1f2b42140$export$2e2bcd8739ae039)(code, tokens);
    const helperManager = new (0, $b7aa5fc22eb1b7f3$export$b203ad16abdeb845)(nameManager);
    const tokenProcessor = new (0, $61061da4d6cb75fe$export$2e2bcd8739ae039)(code, tokens, isFlowEnabled, disableESTransforms, helperManager);
    const enableLegacyTypeScriptModuleInterop = Boolean(options.enableLegacyTypeScriptModuleInterop);
    let importProcessor = null;
    if (options.transforms.includes("imports")) {
        importProcessor = new (0, $4996bcadbc7ee7a7$export$2e2bcd8739ae039)(nameManager, tokenProcessor, enableLegacyTypeScriptModuleInterop, options, options.transforms.includes("typescript"), Boolean(options.keepUnusedImports), helperManager);
        importProcessor.preprocessTokens();
        // We need to mark shadowed globals after processing imports so we know that the globals are,
        // but before type-only import pruning, since that relies on shadowing information.
        (0, $f280165de0013836$export$2e2bcd8739ae039)(tokenProcessor, scopes, importProcessor.getGlobalNames());
        if (options.transforms.includes("typescript") && !options.keepUnusedImports) importProcessor.pruneTypeOnlyImports();
    } else if (options.transforms.includes("typescript") && !options.keepUnusedImports) // Shadowed global detection is needed for TS implicit elision of imported names.
    (0, $f280165de0013836$export$2e2bcd8739ae039)(tokenProcessor, scopes, (0, $8120cb26967b58d6$export$2e2bcd8739ae039)(tokenProcessor));
    return {
        tokenProcessor: tokenProcessor,
        scopes: scopes,
        nameManager: nameManager,
        importProcessor: importProcessor,
        helperManager: helperManager
    };
}


var $2826e017902e2c4c$var$__defProp = Object.defineProperty;
var $2826e017902e2c4c$var$__defProps = Object.defineProperties;
var $2826e017902e2c4c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $2826e017902e2c4c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $2826e017902e2c4c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $2826e017902e2c4c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $2826e017902e2c4c$var$__defNormalProp = (obj, key, value)=>key in obj ? $2826e017902e2c4c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $2826e017902e2c4c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($2826e017902e2c4c$var$__hasOwnProp.call(b, prop)) $2826e017902e2c4c$var$__defNormalProp(a, prop, b[prop]);
    if ($2826e017902e2c4c$var$__getOwnPropSymbols) {
        for (var prop of $2826e017902e2c4c$var$__getOwnPropSymbols(b))if ($2826e017902e2c4c$var$__propIsEnum.call(b, prop)) $2826e017902e2c4c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $2826e017902e2c4c$var$__spreadProps = (a, b)=>$2826e017902e2c4c$var$__defProps(a, $2826e017902e2c4c$var$__getOwnPropDescs(b));
var $2826e017902e2c4c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($2826e017902e2c4c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $2826e017902e2c4c$var$__getOwnPropSymbols) {
        for (var prop of $2826e017902e2c4c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $2826e017902e2c4c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $2826e017902e2c4c$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $2826e017902e2c4c$var$CodeEditor = (props)=>{
    const { tabMode: tabMode = "indentation" } = props;
    const editorRef = (0, $jmWak.useRef)(null);
    const [code, setCode] = (0, $jmWak.useState)(props.code || "");
    const { theme: theme } = props;
    (0, $jmWak.useEffect)(()=>{
        setCode(props.code);
    }, [
        props.code
    ]);
    (0, $e67c660f54f67ced$export$52a148af2bad544)(editorRef, (text)=>{
        const t = text.slice(0, -1);
        setCode(t);
        if (props.onChange) props.onChange(t);
    }, {
        disabled: props.disabled,
        indentation: tabMode === "indentation" ? 2 : void 0
    });
    return /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        className: props.className,
        style: props.style,
        children: /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $2e16598ba480dcca$export$39dbc3f558091353), {
            code: code,
            theme: props.theme || (0, $2e16598ba480dcca$export$d9a33280f07116d9).nightOwl,
            language: props.language,
            children: ({ className: _className, tokens: tokens, getLineProps: getLineProps, getTokenProps: getTokenProps, style: _style })=>/* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)("pre", {
                    className: _className,
                    style: $2826e017902e2c4c$var$__spreadValues($2826e017902e2c4c$var$__spreadValues({
                        margin: 0,
                        outline: "none",
                        padding: 10,
                        fontFamily: "inherit"
                    }, theme && typeof theme.plain === "object" ? theme.plain : {}), _style),
                    ref: editorRef,
                    spellCheck: "false",
                    children: tokens.map((line, lineIndex)=>/* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", $2826e017902e2c4c$var$__spreadProps($2826e017902e2c4c$var$__spreadValues({}, getLineProps({
                            line: line
                        })), {
                            children: [
                                line.filter((token)=>!token.empty).map((token, tokenIndex)=>/* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", $2826e017902e2c4c$var$__spreadValues({}, getTokenProps({
                                        token: token
                                    })), `token-${tokenIndex}`)),
                                "\n"
                            ]
                        }), `line-${lineIndex}`))
                })
        })
    });
};
var $2826e017902e2c4c$export$7cda8d932e2f33c0 = $2826e017902e2c4c$var$CodeEditor;
var $2826e017902e2c4c$var$LiveContext = (0, $3lE4N.createContext)({});
var $2826e017902e2c4c$export$5a6106fef69bde7b = $2826e017902e2c4c$var$LiveContext;
var $2826e017902e2c4c$var$defaultTransforms = [
    "jsx",
    "imports"
];
function $2826e017902e2c4c$var$transform(opts = {}) {
    const transforms = Array.isArray(opts.transforms) ? opts.transforms.filter(Boolean) : $2826e017902e2c4c$var$defaultTransforms;
    return (code)=>(0, $8d35fcad3f72dcf4$export$51186ad6e864892a)(code, {
            transforms: transforms
        }).code;
}
var $2826e017902e2c4c$var$errorBoundary = (Element, errorCallback)=>{
    return class ErrorBoundary extends (0, $3lE4N.Component) {
        componentDidCatch(error) {
            errorCallback(error);
        }
        render() {
            return typeof Element === "function" ? /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Element, {}) : (0, $kzd8a.default).isValidElement(Element) ? Element : null;
        }
    };
};
var $2826e017902e2c4c$var$errorBoundary_default = $2826e017902e2c4c$var$errorBoundary;
// src/utils/transpile/evalCode.ts
var $2826e017902e2c4c$var$evalCode = (code, scope)=>{
    const scopeKeys = Object.keys(scope);
    const scopeValues = scopeKeys.map((key)=>scope[key]);
    return new Function(...scopeKeys, code)(...scopeValues);
};
var $2826e017902e2c4c$var$evalCode_default = $2826e017902e2c4c$var$evalCode;
// src/utils/transpile/compose.ts
function $2826e017902e2c4c$var$compose(...functions) {
    return functions.reduce((acc, currentFn)=>(...args)=>acc(currentFn(...args)));
}
// src/utils/transpile/index.ts
var $2826e017902e2c4c$var$jsxConst = 'const _jsxFileName = "";';
var $2826e017902e2c4c$var$trimCode = (code)=>code.trim().replace(/;$/, "");
var $2826e017902e2c4c$var$spliceJsxConst = (code)=>code.replace($2826e017902e2c4c$var$jsxConst, "").trim();
var $2826e017902e2c4c$var$addJsxConst = (code)=>$2826e017902e2c4c$var$jsxConst + code;
var $2826e017902e2c4c$var$wrapReturn = (code)=>`return (${code})`;
var $2826e017902e2c4c$export$129b3480f9fbae0c = ({ code: code = "", scope: scope = {}, enableTypeScript: enableTypeScript = true }, errorCallback)=>{
    const firstPassTransforms = [
        "jsx"
    ];
    enableTypeScript && firstPassTransforms.push("typescript");
    const transformed = $2826e017902e2c4c$var$compose($2826e017902e2c4c$var$addJsxConst, $2826e017902e2c4c$var$transform({
        transforms: [
            "imports"
        ]
    }), $2826e017902e2c4c$var$spliceJsxConst, $2826e017902e2c4c$var$trimCode, $2826e017902e2c4c$var$transform({
        transforms: firstPassTransforms
    }), $2826e017902e2c4c$var$wrapReturn, $2826e017902e2c4c$var$trimCode)(code);
    return $2826e017902e2c4c$var$errorBoundary_default($2826e017902e2c4c$var$evalCode_default(transformed, $2826e017902e2c4c$var$__spreadValues({
        React: (0, $kzd8a.default)
    }, scope)), errorCallback);
};
var $2826e017902e2c4c$export$f4350c01fab98156 = ({ code: code = "", scope: scope = {}, enableTypeScript: enableTypeScript = true }, resultCallback, errorCallback)=>{
    const render = (element)=>{
        if (typeof element === "undefined") errorCallback(new SyntaxError("`render` must be called with valid JSX."));
        else resultCallback($2826e017902e2c4c$var$errorBoundary_default(element, errorCallback));
    };
    if (!/render\s*\(/.test(code)) return errorCallback(new SyntaxError("No-Inline evaluations must call `render`."));
    const transforms = [
        "jsx",
        "imports"
    ];
    enableTypeScript && transforms.splice(1, 0, "typescript");
    $2826e017902e2c4c$var$evalCode_default($2826e017902e2c4c$var$transform({
        transforms: transforms
    })(code), $2826e017902e2c4c$var$__spreadProps($2826e017902e2c4c$var$__spreadValues({
        React: (0, $kzd8a.default)
    }, scope), {
        render: render
    }));
};
function $2826e017902e2c4c$var$LiveProvider({ children: children, code: code = "", language: language = "tsx", theme: theme, enableTypeScript: enableTypeScript = true, disabled: disabled = false, scope: scope, transformCode: transformCode, noInline: noInline = false }) {
    const [state, setState] = (0, $jmWak.useState)({
        error: void 0,
        element: void 0
    });
    function transpileAsync(newCode) {
        return $2826e017902e2c4c$var$__async(this, null, function*() {
            const errorCallback = (error)=>{
                setState((previousState)=>$2826e017902e2c4c$var$__spreadProps($2826e017902e2c4c$var$__spreadValues({}, previousState), {
                        error: error.toString(),
                        element: void 0
                    }));
            };
            try {
                const transformResult = transformCode ? transformCode(newCode) : newCode;
                try {
                    const transformedCode = yield Promise.resolve(transformResult);
                    const renderElement = (element)=>setState({
                            error: void 0,
                            element: element,
                            newCode: newCode
                        });
                    if (typeof transformedCode !== "string") throw new Error("Code failed to transform");
                    const input = {
                        code: transformedCode,
                        scope: scope,
                        enableTypeScript: enableTypeScript
                    };
                    if (noInline) {
                        setState((previousState)=>$2826e017902e2c4c$var$__spreadProps($2826e017902e2c4c$var$__spreadValues({}, previousState), {
                                error: void 0,
                                element: null
                            }));
                        $2826e017902e2c4c$export$f4350c01fab98156(input, renderElement, errorCallback);
                    } else renderElement($2826e017902e2c4c$export$129b3480f9fbae0c(input, errorCallback));
                } catch (error) {
                    return errorCallback(error);
                }
            } catch (e) {
                errorCallback(e);
                return Promise.resolve();
            }
        });
    }
    const onError = (error)=>setState({
            error: error.toString()
        });
    (0, $jmWak.useEffect)(()=>{
        transpileAsync(code).catch(onError);
    }, [
        code,
        scope,
        noInline,
        transformCode
    ]);
    const onChange = (newCode)=>{
        transpileAsync(newCode).catch(onError);
    };
    return /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)($2826e017902e2c4c$export$5a6106fef69bde7b.Provider, {
        value: $2826e017902e2c4c$var$__spreadProps($2826e017902e2c4c$var$__spreadValues({}, state), {
            code: code,
            language: language,
            theme: theme,
            disabled: disabled,
            onError: onError,
            onChange: onChange
        }),
        children: children
    });
}
var $2826e017902e2c4c$export$7f6f1b77ca3c3ed3 = $2826e017902e2c4c$var$LiveProvider;
function $2826e017902e2c4c$export$f8f60579bb81d0e5(props) {
    const { code: code, language: language, theme: theme, disabled: disabled, onChange: onChange } = (0, $jmWak.useContext)($2826e017902e2c4c$export$5a6106fef69bde7b);
    return /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)($2826e017902e2c4c$export$7cda8d932e2f33c0, $2826e017902e2c4c$var$__spreadValues({
        theme: theme,
        code: code,
        language: language,
        disabled: disabled,
        onChange: onChange
    }, props));
}
function $2826e017902e2c4c$export$1991b613205b2adc(props) {
    const { error: error } = (0, $jmWak.useContext)($2826e017902e2c4c$export$5a6106fef69bde7b);
    return error ? /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)("pre", $2826e017902e2c4c$var$__spreadProps($2826e017902e2c4c$var$__spreadValues({}, props), {
        children: error
    })) : null;
}
var $2826e017902e2c4c$var$ErrorBoundary = class extends (0, $3lE4N.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(err) {
        var _a, _b;
        (_b = (_a = this.props).onError) == null || _b.call(_a, err);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
};
function $2826e017902e2c4c$var$LivePreview(_a) {
    var _b = _a, { Component: Component3 = "div" } = _b, rest = $2826e017902e2c4c$var$__objRest(_b, [
        "Component"
    ]);
    const { element: Element, onError: onError, newCode: newCode } = (0, $jmWak.useContext)($2826e017902e2c4c$export$5a6106fef69bde7b);
    return /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)($2826e017902e2c4c$var$ErrorBoundary, {
        onError: onError,
        children: /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component3, $2826e017902e2c4c$var$__spreadProps($2826e017902e2c4c$var$__spreadValues({}, rest), {
            children: Element ? /* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Element, {}) : null
        }))
    }, newCode);
}
var $2826e017902e2c4c$export$ba3ca6901d2e4f5f = $2826e017902e2c4c$var$LivePreview;
function $2826e017902e2c4c$export$3039ad97e9f7b4e0(WrappedComponent) {
    const WithLive = (props)=>/* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)($2826e017902e2c4c$export$5a6106fef69bde7b.Consumer, {
            children: (live)=>/* @__PURE__ */ (0, $833f543b429117ba$export$34b9dba7ce09269b)(WrappedComponent, $2826e017902e2c4c$var$__spreadValues({
                    live: live
                }, props))
        });
    WithLive.displayName = "WithLive";
    return WithLive;
}




var $kzd8a = parcelRequire("kzd8a");


"use client";
const $877fb262e9f1190e$var$Badge = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$877fb262e9f1190e$var$Badge.displayName = 'Badge';
var $877fb262e9f1190e$export$2e2bcd8739ae039 = $877fb262e9f1190e$var$Badge;



var $kzd8a = parcelRequire("kzd8a");

var $kzd8a = parcelRequire("kzd8a");

const $d638157d1263108f$var$_excluded = [
    "as",
    "disabled"
];
function $d638157d1263108f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $d638157d1263108f$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $d638157d1263108f$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $d638157d1263108f$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $d638157d1263108f$var$Button = /*#__PURE__*/ $kzd8a.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $d638157d1263108f$var$_objectWithoutPropertiesLoose(_ref, $d638157d1263108f$var$_excluded);
    const [buttonProps, { tagName: Component }] = $d638157d1263108f$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$d638157d1263108f$var$Button.displayName = 'Button';
var $d638157d1263108f$export$2e2bcd8739ae039 = $d638157d1263108f$var$Button;




"use client";
const $85e8222bbf1762c5$var$Button = /*#__PURE__*/ $kzd8a.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $d638157d1263108f$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$85e8222bbf1762c5$var$Button.displayName = 'Button';
var $85e8222bbf1762c5$export$2e2bcd8739ae039 = $85e8222bbf1762c5$var$Button;



var $kzd8a = parcelRequire("kzd8a");


var $kzd8a = parcelRequire("kzd8a");



"use client";
const $0bff3bf28cbe0ffe$var$CardBody = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$0bff3bf28cbe0ffe$var$CardBody.displayName = 'CardBody';
var $0bff3bf28cbe0ffe$export$2e2bcd8739ae039 = $0bff3bf28cbe0ffe$var$CardBody;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $269f62c5e2de2ab5$var$CardFooter = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$269f62c5e2de2ab5$var$CardFooter.displayName = 'CardFooter';
var $269f62c5e2de2ab5$export$2e2bcd8739ae039 = $269f62c5e2de2ab5$var$CardFooter;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
"use client";
const $1a62add9ae3ebec5$var$context = /*#__PURE__*/ $3lE4N.createContext(null);
$1a62add9ae3ebec5$var$context.displayName = 'CardHeaderContext';
var $1a62add9ae3ebec5$export$2e2bcd8739ae039 = $1a62add9ae3ebec5$var$context;



"use client";
const $d288c48682876398$var$CardHeader = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $jmWak.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $1a62add9ae3ebec5$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix)
        })
    });
});
$d288c48682876398$var$CardHeader.displayName = 'CardHeader';
var $d288c48682876398$export$2e2bcd8739ae039 = $d288c48682876398$var$CardHeader;




var $kzd8a = parcelRequire("kzd8a");


"use client";
const $ce481db8c15bb209$var$CardImg = /*#__PURE__*/ $kzd8a.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$ce481db8c15bb209$var$CardImg.displayName = 'CardImg';
var $ce481db8c15bb209$export$2e2bcd8739ae039 = $ce481db8c15bb209$var$CardImg;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $b1cfa0a0f3b3b9bf$var$CardImgOverlay = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$b1cfa0a0f3b3b9bf$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $b1cfa0a0f3b3b9bf$export$2e2bcd8739ae039 = $b1cfa0a0f3b3b9bf$var$CardImgOverlay;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $61d9dbe2951c8113$var$CardLink = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$61d9dbe2951c8113$var$CardLink.displayName = 'CardLink';
var $61d9dbe2951c8113$export$2e2bcd8739ae039 = $61d9dbe2951c8113$var$CardLink;



var $kzd8a = parcelRequire("kzd8a");



var $kzd8a = parcelRequire("kzd8a");


var $f36469d8e9627b22$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $kzd8a.forwardRef((p, ref)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(p.className, className)
        }));



"use client";
const $a3f93e488efe3af1$var$DivStyledAsH6 = (0, $f36469d8e9627b22$export$2e2bcd8739ae039)('h6');
const $a3f93e488efe3af1$var$CardSubtitle = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $a3f93e488efe3af1$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$a3f93e488efe3af1$var$CardSubtitle.displayName = 'CardSubtitle';
var $a3f93e488efe3af1$export$2e2bcd8739ae039 = $a3f93e488efe3af1$var$CardSubtitle;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $44fd5f556138460e$var$CardText = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$44fd5f556138460e$var$CardText.displayName = 'CardText';
var $44fd5f556138460e$export$2e2bcd8739ae039 = $44fd5f556138460e$var$CardText;



var $kzd8a = parcelRequire("kzd8a");




"use client";
const $9baff68cd76c4631$var$DivStyledAsH5 = (0, $f36469d8e9627b22$export$2e2bcd8739ae039)('h5');
const $9baff68cd76c4631$var$CardTitle = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $9baff68cd76c4631$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$9baff68cd76c4631$var$CardTitle.displayName = 'CardTitle';
var $9baff68cd76c4631$export$2e2bcd8739ae039 = $9baff68cd76c4631$var$CardTitle;



"use client";
const $95b0e632403c19f5$var$Card = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $0bff3bf28cbe0ffe$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$95b0e632403c19f5$var$Card.displayName = 'Card';
var $95b0e632403c19f5$export$2e2bcd8739ae039 = Object.assign($95b0e632403c19f5$var$Card, {
    Img: (0, $ce481db8c15bb209$export$2e2bcd8739ae039),
    Title: (0, $9baff68cd76c4631$export$2e2bcd8739ae039),
    Subtitle: (0, $a3f93e488efe3af1$export$2e2bcd8739ae039),
    Body: (0, $0bff3bf28cbe0ffe$export$2e2bcd8739ae039),
    Link: (0, $61d9dbe2951c8113$export$2e2bcd8739ae039),
    Text: (0, $44fd5f556138460e$export$2e2bcd8739ae039),
    Header: (0, $d288c48682876398$export$2e2bcd8739ae039),
    Footer: (0, $269f62c5e2de2ab5$export$2e2bcd8739ae039),
    ImgOverlay: (0, $b1cfa0a0f3b3b9bf$export$2e2bcd8739ae039)
});



var $kzd8a = parcelRequire("kzd8a");


"use client";
function $ca4e55525ae20d35$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $b6315234e77a11f8$export$8970c8db816a5863)();
    const minBreakpoint = (0, $b6315234e77a11f8$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $ca4e55525ae20d35$var$Col = /*#__PURE__*/ $kzd8a.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $ca4e55525ae20d35$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, !spans.length && bsPrefix)
    });
});
$ca4e55525ae20d35$var$Col.displayName = 'Col';
var $ca4e55525ae20d35$export$2e2bcd8739ae039 = $ca4e55525ae20d35$var$Col;



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
var $0a134cba80b47542$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $0a134cba80b47542$export$2e2bcd8739ae039(element, selector) {
    return $0a134cba80b47542$var$toArray(element.querySelectorAll(selector));
}


/* eslint-disable no-return-assign */ var $53e6d5b016eb161e$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $39288ac6dc5c98da$export$63fefd044b2bc624 = false;
var $39288ac6dc5c98da$export$a614c6b395900f69 = false;
try {
    var $39288ac6dc5c98da$var$options = {
        get passive () {
            return $39288ac6dc5c98da$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $39288ac6dc5c98da$export$a614c6b395900f69 = $39288ac6dc5c98da$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $53e6d5b016eb161e$export$2e2bcd8739ae039) {
        window.addEventListener('test', $39288ac6dc5c98da$var$options, $39288ac6dc5c98da$var$options);
        window.removeEventListener('test', $39288ac6dc5c98da$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $39288ac6dc5c98da$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$39288ac6dc5c98da$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$39288ac6dc5c98da$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $39288ac6dc5c98da$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $39288ac6dc5c98da$export$2e2bcd8739ae039 = $39288ac6dc5c98da$var$addEventListener;


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $3b44bc62a3d0f2fa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3b44bc62a3d0f2fa$var$_toPropertyKey(arg) {
    var key = $3b44bc62a3d0f2fa$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $3b44bc62a3d0f2fa$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3b44bc62a3d0f2fa$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $3b44bc62a3d0f2fa$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $jmWak.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $jmWak.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $jmWak.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $3b44bc62a3d0f2fa$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $3b44bc62a3d0f2fa$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $3b44bc62a3d0f2fa$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($3b44bc62a3d0f2fa$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $3b44bc62a3d0f2fa$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $8009ad784162cfb1$export$2e2bcd8739ae039(value) {
    const ref = (0, $jmWak.useRef)(null);
    (0, $jmWak.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $cd6c4c5a7fbf988d$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $jmWak.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $f237c53fabb60d48$var$useCommittedRef(value) {
    const ref = (0, $jmWak.useRef)(value);
    (0, $jmWak.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $f237c53fabb60d48$export$2e2bcd8739ae039 = $f237c53fabb60d48$var$useCommittedRef;


function $0f6b648eaf3ae889$export$2e2bcd8739ae039(fn) {
    const ref = (0, $f237c53fabb60d48$export$2e2bcd8739ae039)(fn);
    return (0, $jmWak.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


function $9616d45d3b57ab64$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)(listener);
    (0, $jmWak.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}



parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
const $7f6bf662c8128446$var$DropdownContext = /*#__PURE__*/ $3lE4N.createContext(null);
var $7f6bf662c8128446$export$2e2bcd8739ae039 = $7f6bf662c8128446$var$DropdownContext;


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $8387f71283271058$export$2e2bcd8739ae039() {
    return (0, $jmWak.useState)(null);
}



parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
var $4acd931b6f5f6b58$var$has = Object.prototype.hasOwnProperty;
function $4acd931b6f5f6b58$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($4acd931b6f5f6b58$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $4acd931b6f5f6b58$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $4acd931b6f5f6b58$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $4acd931b6f5f6b58$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $4acd931b6f5f6b58$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$4acd931b6f5f6b58$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($4acd931b6f5f6b58$var$has.call(foo, ctor) && ++len && !$4acd931b6f5f6b58$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$4acd931b6f5f6b58$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $c0f31806b1391f8e$export$2e2bcd8739ae039() {
    const mounted = (0, $jmWak.useRef)(true);
    const isMounted = (0, $jmWak.useRef)(()=>mounted.current);
    (0, $jmWak.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $32dcb21dc179f5f0$var$useSafeState(state) {
    const isMounted = (0, $c0f31806b1391f8e$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $jmWak.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $32dcb21dc179f5f0$export$2e2bcd8739ae039 = $32dcb21dc179f5f0$var$useSafeState;



function $48bb75d5bf3c287d$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $61b65052593cce67$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $61b65052593cce67$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $61b65052593cce67$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $ebf8c7f5a1da6f9a$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $61b65052593cce67$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $47e2f793e6db6001$export$8960430cfd85939f = Math.max;
var $47e2f793e6db6001$export$96ec731ed4dcb222 = Math.min;
var $47e2f793e6db6001$export$2077e0241d6afd3c = Math.round;



function $8ecbe53684bd7b48$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $eec2a55e9af96354$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $8ecbe53684bd7b48$export$2e2bcd8739ae039)());
}


function $5a3919fd7116f891$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(element) ? (0, $61b65052593cce67$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $eec2a55e9af96354$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0aa5be651923dfbb$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $4c9ec00b782551f7$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $ebf8c7f5a1da6f9a$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $5cab22a6b884c3d9$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $60d1639ab565e3e4$export$2e2bcd8739ae039(element) {
    return (0, $61b65052593cce67$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $368606681b890691$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(element)) >= 0;
}




function $55a71246ec6b8be3$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $375e027f2230e225$export$2e2bcd8739ae039(element) {
    if ((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $ebf8c7f5a1da6f9a$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $717b277afd92e276$var$getTrueOffsetParent(element) {
    if (!(0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $717b277afd92e276$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $8ecbe53684bd7b48$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $8ecbe53684bd7b48$export$2e2bcd8739ae039)());
    if (isIE && (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $375e027f2230e225$export$2e2bcd8739ae039)(element);
    if ((0, $ebf8c7f5a1da6f9a$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $717b277afd92e276$export$2e2bcd8739ae039(element) {
    var window = (0, $61b65052593cce67$export$2e2bcd8739ae039)(element);
    var offsetParent = $717b277afd92e276$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $368606681b890691$export$2e2bcd8739ae039)(offsetParent) && (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $717b277afd92e276$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $717b277afd92e276$var$getContainingBlock(element) || window;
}


function $8664aca5c419c963$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $891a462c23ca7b5d$export$f28d906d67a997f3(min, value, max) {
    return (0, $47e2f793e6db6001$export$8960430cfd85939f)(min, (0, $47e2f793e6db6001$export$96ec731ed4dcb222)(value, max));
}
function $891a462c23ca7b5d$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $891a462c23ca7b5d$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $f61daa9e4ec37835$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $5a0e8fa0789ad2aa$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $f61daa9e4ec37835$export$2e2bcd8739ae039)(), paddingObject);
}


function $9bd77f53938bd74f$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $ae039e4f0d49d659$export$1e95b668f3b82d = 'top';
var $ae039e4f0d49d659$export$40e543e69a8b3fbb = 'bottom';
var $ae039e4f0d49d659$export$79ffe56a765070d2 = 'right';
var $ae039e4f0d49d659$export$eabcd2c8791e7bf4 = 'left';
var $ae039e4f0d49d659$export$dfb5619354ba860 = 'auto';
var $ae039e4f0d49d659$export$aec2ce47c367b8c3 = [
    $ae039e4f0d49d659$export$1e95b668f3b82d,
    $ae039e4f0d49d659$export$40e543e69a8b3fbb,
    $ae039e4f0d49d659$export$79ffe56a765070d2,
    $ae039e4f0d49d659$export$eabcd2c8791e7bf4
];
var $ae039e4f0d49d659$export$b3571188c770cc5a = 'start';
var $ae039e4f0d49d659$export$bd5df0f255a350f8 = 'end';
var $ae039e4f0d49d659$export$390fd549c5303b4d = 'clippingParents';
var $ae039e4f0d49d659$export$d7b7311ec04a3e8f = 'viewport';
var $ae039e4f0d49d659$export$ae5ab1c730825774 = 'popper';
var $ae039e4f0d49d659$export$ca50aac9f3ba507f = 'reference';
var $ae039e4f0d49d659$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ae039e4f0d49d659$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ae039e4f0d49d659$export$b3571188c770cc5a,
        placement + "-" + $ae039e4f0d49d659$export$bd5df0f255a350f8
    ]);
}, []);
var $ae039e4f0d49d659$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ae039e4f0d49d659$export$aec2ce47c367b8c3, [
    $ae039e4f0d49d659$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ae039e4f0d49d659$export$b3571188c770cc5a,
        placement + "-" + $ae039e4f0d49d659$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ae039e4f0d49d659$export$421679a7c3d56e = 'beforeRead';
var $ae039e4f0d49d659$export$aafa59e2e03f2942 = 'read';
var $ae039e4f0d49d659$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $ae039e4f0d49d659$export$c65e99957a05207c = 'beforeMain';
var $ae039e4f0d49d659$export$f22da7240b7add18 = 'main';
var $ae039e4f0d49d659$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ae039e4f0d49d659$export$8d4d2d70e7d46032 = 'beforeWrite';
var $ae039e4f0d49d659$export$68d8715fc104d294 = 'write';
var $ae039e4f0d49d659$export$70a6e5159acce2e6 = 'afterWrite';
var $ae039e4f0d49d659$export$d087d3878fdf71d5 = [
    $ae039e4f0d49d659$export$421679a7c3d56e,
    $ae039e4f0d49d659$export$aafa59e2e03f2942,
    $ae039e4f0d49d659$export$6964f6c886723980,
    $ae039e4f0d49d659$export$c65e99957a05207c,
    $ae039e4f0d49d659$export$f22da7240b7add18,
    $ae039e4f0d49d659$export$bab79516f2d662fe,
    $ae039e4f0d49d659$export$8d4d2d70e7d46032,
    $ae039e4f0d49d659$export$68d8715fc104d294,
    $ae039e4f0d49d659$export$70a6e5159acce2e6
];


var $c81aadba3facd31a$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $5a0e8fa0789ad2aa$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $9bd77f53938bd74f$export$2e2bcd8739ae039)(padding, (0, $ae039e4f0d49d659$export$aec2ce47c367b8c3)));
};
function $c81aadba3facd31a$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $8664aca5c419c963$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4),
        (0, $ae039e4f0d49d659$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $c81aadba3facd31a$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0aa5be651923dfbb$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $ae039e4f0d49d659$export$1e95b668f3b82d) : (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb) : (0, $ae039e4f0d49d659$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $717b277afd92e276$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $891a462c23ca7b5d$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $c81aadba3facd31a$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $4c9ec00b782551f7$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $c81aadba3facd31a$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $c81aadba3facd31a$var$arrow,
    effect: $c81aadba3facd31a$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $6685b38147ddeec8$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $625bb50c8847a2cc$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $625bb50c8847a2cc$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $625bb50c8847a2cc$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4);
    var sideY = (0, $ae039e4f0d49d659$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $717b277afd92e276$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $61b65052593cce67$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(popper);
            if ((0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $ae039e4f0d49d659$export$1e95b668f3b82d) || (placement === (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4) || placement === (0, $ae039e4f0d49d659$export$79ffe56a765070d2)) && variation === (0, $ae039e4f0d49d659$export$bd5df0f255a350f8)) {
            sideY = (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4) || (placement === (0, $ae039e4f0d49d659$export$1e95b668f3b82d) || placement === (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb)) && variation === (0, $ae039e4f0d49d659$export$bd5df0f255a350f8)) {
            sideX = (0, $ae039e4f0d49d659$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $625bb50c8847a2cc$var$unsetSides);
    var _ref4 = roundOffsets === true ? $625bb50c8847a2cc$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $61b65052593cce67$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $625bb50c8847a2cc$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $625bb50c8847a2cc$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $625bb50c8847a2cc$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $625bb50c8847a2cc$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $625bb50c8847a2cc$var$computeStyles,
    data: {}
};



var $543972eb5fd21065$var$passive = {
    passive: true
};
function $543972eb5fd21065$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $61b65052593cce67$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $543972eb5fd21065$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $543972eb5fd21065$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $543972eb5fd21065$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $543972eb5fd21065$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $543972eb5fd21065$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $543972eb5fd21065$var$effect,
    data: {}
};


var $fd277c2f1b2fdd45$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $fd277c2f1b2fdd45$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $fd277c2f1b2fdd45$var$hash[matched];
    });
}



var $feb66e05f65f002d$var$hash = {
    start: 'end',
    end: 'start'
};
function $feb66e05f65f002d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $feb66e05f65f002d$var$hash[matched];
    });
}








function $f805881890c4a8ae$export$2e2bcd8739ae039(node) {
    var win = (0, $61b65052593cce67$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $66cc7bcd3398f9f0$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $5a3919fd7116f891$export$2e2bcd8739ae039)((0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element)).left + (0, $f805881890c4a8ae$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $3d9f2682e8b46ad0$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $61b65052593cce67$export$2e2bcd8739ae039)(element);
    var html = (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $eec2a55e9af96354$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $66cc7bcd3398f9f0$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $c41321b0f5f2650f$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $f805881890c4a8ae$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $47e2f793e6db6001$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $47e2f793e6db6001$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $66cc7bcd3398f9f0$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $47e2f793e6db6001$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $62dd7a1e768b8c7b$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $3dd4d705a60d837f$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(node) && (0, $62dd7a1e768b8c7b$export$2e2bcd8739ae039)(node)) return node;
    return $3dd4d705a60d837f$export$2e2bcd8739ae039((0, $375e027f2230e225$export$2e2bcd8739ae039)(node));
}





function $808134ffcafa23ab$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3dd4d705a60d837f$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $61b65052593cce67$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $62dd7a1e768b8c7b$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($808134ffcafa23ab$export$2e2bcd8739ae039((0, $375e027f2230e225$export$2e2bcd8739ae039)(target)));
}










function $ed98f3c8e193990a$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $da676012f58a8d10$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $da676012f58a8d10$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $ae039e4f0d49d659$export$d7b7311ec04a3e8f) ? (0, $ed98f3c8e193990a$export$2e2bcd8739ae039)((0, $3d9f2682e8b46ad0$export$2e2bcd8739ae039)(element, strategy)) : (0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(clippingParent) ? $da676012f58a8d10$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ed98f3c8e193990a$export$2e2bcd8739ae039)((0, $c41321b0f5f2650f$export$2e2bcd8739ae039)((0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $da676012f58a8d10$var$getClippingParents(element) {
    var clippingParents = (0, $808134ffcafa23ab$export$2e2bcd8739ae039)((0, $375e027f2230e225$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $60d1639ab565e3e4$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(element) ? (0, $717b277afd92e276$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(clippingParent) && (0, $4c9ec00b782551f7$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $da676012f58a8d10$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $da676012f58a8d10$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $da676012f58a8d10$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $47e2f793e6db6001$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $47e2f793e6db6001$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $47e2f793e6db6001$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $47e2f793e6db6001$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $da676012f58a8d10$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $b7686cfa0bad79fe$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $ae039e4f0d49d659$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $ae039e4f0d49d659$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $ae039e4f0d49d659$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $8664aca5c419c963$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $ae039e4f0d49d659$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $ae039e4f0d49d659$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $b4e02f68dba27cf0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $ae039e4f0d49d659$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $ae039e4f0d49d659$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $ae039e4f0d49d659$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $5a0e8fa0789ad2aa$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $9bd77f53938bd74f$export$2e2bcd8739ae039)(padding, (0, $ae039e4f0d49d659$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $ae039e4f0d49d659$export$ae5ab1c730825774) ? (0, $ae039e4f0d49d659$export$ca50aac9f3ba507f) : (0, $ae039e4f0d49d659$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $da676012f58a8d10$export$2e2bcd8739ae039)((0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $b7686cfa0bad79fe$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $ed98f3c8e193990a$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $ae039e4f0d49d659$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $ae039e4f0d49d659$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $ae039e4f0d49d659$export$79ffe56a765070d2),
                (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $ae039e4f0d49d659$export$1e95b668f3b82d),
                (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $bee67608fa020610$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $ae039e4f0d49d659$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $ae039e4f0d49d659$export$368f9a87e87fa4e1) : (0, $ae039e4f0d49d659$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $ae039e4f0d49d659$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $ef83021c7d12dc40$var$getExpandedFallbackPlacements(placement) {
    if ((0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement) === (0, $ae039e4f0d49d659$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $fd277c2f1b2fdd45$export$2e2bcd8739ae039)(placement);
    return [
        (0, $feb66e05f65f002d$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $feb66e05f65f002d$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $ef83021c7d12dc40$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $fd277c2f1b2fdd45$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $ef83021c7d12dc40$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement) === (0, $ae039e4f0d49d659$export$dfb5619354ba860) ? (0, $bee67608fa020610$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(placement) === (0, $ae039e4f0d49d659$export$b3571188c770cc5a);
        var isVertical = [
            (0, $ae039e4f0d49d659$export$1e95b668f3b82d),
            (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $ae039e4f0d49d659$export$79ffe56a765070d2) : (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb) : (0, $ae039e4f0d49d659$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $fd277c2f1b2fdd45$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $fd277c2f1b2fdd45$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $ef83021c7d12dc40$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $ef83021c7d12dc40$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $3cb23a9df881f494$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $3cb23a9df881f494$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $ae039e4f0d49d659$export$1e95b668f3b82d),
        (0, $ae039e4f0d49d659$export$79ffe56a765070d2),
        (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb),
        (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $3cb23a9df881f494$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $3cb23a9df881f494$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $3cb23a9df881f494$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $3cb23a9df881f494$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $3cb23a9df881f494$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $3cb23a9df881f494$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $3cb23a9df881f494$var$hide
};




function $17febcad75c34150$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4),
        (0, $ae039e4f0d49d659$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4),
        (0, $ae039e4f0d49d659$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $17febcad75c34150$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $ae039e4f0d49d659$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $17febcad75c34150$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $17febcad75c34150$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $17febcad75c34150$var$offset
};



function $838c56d274cf33c2$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $b7686cfa0bad79fe$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $838c56d274cf33c2$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $838c56d274cf33c2$var$popperOffsets,
    data: {}
};





function $4ca6267150d720be$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $db925e83491d082b$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $b4e02f68dba27cf0$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $48bb75d5bf3c287d$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $6685b38147ddeec8$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $8664aca5c419c963$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $4ca6267150d720be$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $ae039e4f0d49d659$export$1e95b668f3b82d) : (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb) : (0, $ae039e4f0d49d659$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $ae039e4f0d49d659$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $ae039e4f0d49d659$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0aa5be651923dfbb$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $f61daa9e4ec37835$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $891a462c23ca7b5d$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $717b277afd92e276$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $891a462c23ca7b5d$export$f28d906d67a997f3)(tether ? (0, $47e2f793e6db6001$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $47e2f793e6db6001$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $ae039e4f0d49d659$export$1e95b668f3b82d) : (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $ae039e4f0d49d659$export$40e543e69a8b3fbb) : (0, $ae039e4f0d49d659$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $ae039e4f0d49d659$export$1e95b668f3b82d),
            (0, $ae039e4f0d49d659$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $891a462c23ca7b5d$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $891a462c23ca7b5d$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $db925e83491d082b$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $db925e83491d082b$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $16b4c6f5959333e9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $e54e832a2669b203$export$2e2bcd8739ae039(node) {
    if (node === (0, $61b65052593cce67$export$2e2bcd8739ae039)(node) || !(0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(node)) return (0, $f805881890c4a8ae$export$2e2bcd8739ae039)(node);
    else return (0, $16b4c6f5959333e9$export$2e2bcd8739ae039)(node);
}








function $fecbc57855d29bfb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $47e2f793e6db6001$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $fecbc57855d29bfb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(offsetParent) && $fecbc57855d29bfb$var$isElementScaled(offsetParent);
    var documentElement = (0, $55a71246ec6b8be3$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $5cab22a6b884c3d9$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $62dd7a1e768b8c7b$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $e54e832a2669b203$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $ebf8c7f5a1da6f9a$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $5a3919fd7116f891$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $66cc7bcd3398f9f0$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $48549fee1e8e137f$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $48549fee1e8e137f$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $48549fee1e8e137f$var$order(modifiers); // order based on phase
    return (0, $ae039e4f0d49d659$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9f32f692269a213b$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $ef4d0de54045ec9e$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $dc3c055f8bfc86cb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $dc3c055f8bfc86cb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $dc3c055f8bfc86cb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $dc3c055f8bfc86cb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $dc3c055f8bfc86cb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $ebf8c7f5a1da6f9a$export$45a5e7f76e0caa8d)(reference) ? (0, $808134ffcafa23ab$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $808134ffcafa23ab$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $808134ffcafa23ab$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $48549fee1e8e137f$export$2e2bcd8739ae039)((0, $ef4d0de54045ec9e$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$dc3c055f8bfc86cb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $fecbc57855d29bfb$export$2e2bcd8739ae039)(reference, (0, $717b277afd92e276$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $0aa5be651923dfbb$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9f32f692269a213b$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$dc3c055f8bfc86cb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $dc3c055f8bfc86cb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $dc3c055f8bfc86cb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $362d9670f21bc297$export$8f7491d57c8f97a9 = (0, $dc3c055f8bfc86cb$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $3cb23a9df881f494$export$2e2bcd8739ae039),
        (0, $838c56d274cf33c2$export$2e2bcd8739ae039),
        (0, $625bb50c8847a2cc$export$2e2bcd8739ae039),
        (0, $543972eb5fd21065$export$2e2bcd8739ae039),
        (0, $17febcad75c34150$export$2e2bcd8739ae039),
        (0, $ef83021c7d12dc40$export$2e2bcd8739ae039),
        (0, $db925e83491d082b$export$2e2bcd8739ae039),
        (0, $c81aadba3facd31a$export$2e2bcd8739ae039)
    ]
});


const $d7c4c83fe391df48$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $d7c4c83fe391df48$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $d7c4c83fe391df48$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $d7c4c83fe391df48$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $d7c4c83fe391df48$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $d7c4c83fe391df48$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $d7c4c83fe391df48$var$EMPTY_MODIFIERS } = _ref, config = $d7c4c83fe391df48$var$_objectWithoutPropertiesLoose(_ref, $d7c4c83fe391df48$var$_excluded);
    const prevModifiers = (0, $jmWak.useRef)(modifiers);
    const popperInstanceRef = (0, $jmWak.useRef)();
    const update = (0, $jmWak.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $jmWak.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $32dcb21dc179f5f0$export$2e2bcd8739ae039)((0, $jmWak.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $jmWak.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $jmWak.useMemo)(()=>{
        if (!(0, $4acd931b6f5f6b58$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $jmWak.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $d7c4c83fe391df48$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $jmWak.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $362d9670f21bc297$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $d7c4c83fe391df48$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $d7c4c83fe391df48$export$2e2bcd8739ae039 = $d7c4c83fe391df48$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $321b0569c1d3b241$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $bf50d51abf54f84c$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $bf50d51abf54f84c$export$2e2bcd8739ae039 = $bf50d51abf54f84c$var$removeEventListener;


function $c19f71e61aa90e5d$var$listen(node, eventName, handler, options) {
    (0, $39288ac6dc5c98da$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $bf50d51abf54f84c$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $c19f71e61aa90e5d$export$2e2bcd8739ae039 = $c19f71e61aa90e5d$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $0ddd9f7131150c10$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

var $ced47db6f467fbae$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ced47db6f467fbae$var$__DEV__ = false;
var $ced47db6f467fbae$var$warning = function() {};
if ($ced47db6f467fbae$var$__DEV__) {
    var $ced47db6f467fbae$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ced47db6f467fbae$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ced47db6f467fbae$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$ced47db6f467fbae$exports = $ced47db6f467fbae$var$warning;


const $b071c25977405a0c$var$noop = ()=>{};
function $b071c25977405a0c$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $b071c25977405a0c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $b071c25977405a0c$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $b071c25977405a0c$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $b071c25977405a0c$var$useClickOutside(ref, onClickOutside = $b071c25977405a0c$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $jmWak.useRef)(false);
    const waitingForTrigger = (0, $jmWak.useRef)(false);
    const handleMouseCapture = (0, $jmWak.useCallback)((e)=>{
        const currentTarget = $b071c25977405a0c$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($ced47db6f467fbae$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $b071c25977405a0c$var$isModifiedEvent(e) || !$b071c25977405a0c$var$isLeftClickEvent(e) || !!(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $b071c25977405a0c$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $321b0569c1d3b241$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $jmWak.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)($b071c25977405a0c$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($b071c25977405a0c$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, $b071c25977405a0c$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(el, 'mousemove', $b071c25977405a0c$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $b071c25977405a0c$export$2e2bcd8739ae039 = $b071c25977405a0c$var$useClickOutside;


function $9a400fe382ed5c7b$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $9a400fe382ed5c7b$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $9a400fe382ed5c7b$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $9a400fe382ed5c7b$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $9a400fe382ed5c7b$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



var $3lE4N = parcelRequire("3lE4N");
const $be09164d3c547be5$var$_excluded = [
    "children",
    "usePopper"
];
function $be09164d3c547be5$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $be09164d3c547be5$var$noop = ()=>{};
function $be09164d3c547be5$export$133c4d08f3775d64(options = {}) {
    const context = (0, $jmWak.useContext)((0, $7f6bf662c8128446$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $8387f71283271058$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $jmWak.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $d7c4c83fe391df48$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $9a400fe382ed5c7b$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $be09164d3c547be5$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $b071c25977405a0c$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $be09164d3c547be5$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $be09164d3c547be5$var$_objectWithoutPropertiesLoose(_ref, $be09164d3c547be5$var$_excluded);
    const [props, meta] = $be09164d3c547be5$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
        children: children(props, meta)
    });
}
$be09164d3c547be5$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $be09164d3c547be5$export$2e2bcd8739ae039 = $be09164d3c547be5$var$DropdownMenu;


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $9df8964a61108436$var$$c7eafbbe1ea5834e$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $9df8964a61108436$var$$c7eafbbe1ea5834e$var$SSRContext = (0, $kzd8a.default).createContext($9df8964a61108436$var$$c7eafbbe1ea5834e$var$defaultContext);
const $9df8964a61108436$var$$c7eafbbe1ea5834e$var$IsSSRContext = (0, $kzd8a.default).createContext(false);
// This is only used in React < 18.
function $9df8964a61108436$var$$c7eafbbe1ea5834e$var$LegacySSRProvider(props) {
    let cur = (0, $jmWak.useContext)($9df8964a61108436$var$$c7eafbbe1ea5834e$var$SSRContext);
    let counter = $9df8964a61108436$var$$c7eafbbe1ea5834e$var$useCounter(cur === $9df8964a61108436$var$$c7eafbbe1ea5834e$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $jmWak.useState)(true);
    let value = (0, $jmWak.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $9df8964a61108436$var$$c7eafbbe1ea5834e$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $jmWak.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, $kzd8a.default).createElement($9df8964a61108436$var$$c7eafbbe1ea5834e$var$SSRContext.Provider, {
        value: value
    }, (0, $kzd8a.default).createElement($9df8964a61108436$var$$c7eafbbe1ea5834e$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $9df8964a61108436$var$$c7eafbbe1ea5834e$var$warnedAboutSSRProvider = false;
function $9df8964a61108436$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, $kzd8a.default)['useId'] === 'function') return (0, $kzd8a.default).createElement((0, $kzd8a.default).Fragment, null, props.children);
    return (0, $kzd8a.default).createElement($9df8964a61108436$var$$c7eafbbe1ea5834e$var$LegacySSRProvider, props);
}
let $9df8964a61108436$var$$c7eafbbe1ea5834e$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $9df8964a61108436$var$$c7eafbbe1ea5834e$var$componentIds = new WeakMap();
function $9df8964a61108436$var$$c7eafbbe1ea5834e$var$useCounter(isDisabled = false) {
    let ctx = (0, $jmWak.useContext)($9df8964a61108436$var$$c7eafbbe1ea5834e$var$SSRContext);
    let ref = (0, $jmWak.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (0, $kzd8a.default).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current;
        if (currentOwner) {
            let prevComponentValue = $9df8964a61108436$var$$c7eafbbe1ea5834e$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $9df8964a61108436$var$$c7eafbbe1ea5834e$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $9df8964a61108436$var$$c7eafbbe1ea5834e$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    return ref.current;
}
function $9df8964a61108436$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $jmWak.useContext)($9df8964a61108436$var$$c7eafbbe1ea5834e$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $9df8964a61108436$var$$c7eafbbe1ea5834e$var$defaultContext && $9df8964a61108436$var$$c7eafbbe1ea5834e$var$canUseDOM;
    let counter = $9df8964a61108436$var$$c7eafbbe1ea5834e$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $9df8964a61108436$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId(defaultId) {
    let id = (0, $kzd8a.default).useId();
    let [didSSR] = (0, $jmWak.useState)($9df8964a61108436$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$9df8964a61108436$var$$c7eafbbe1ea5834e$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $9df8964a61108436$export$619500959fc48b26 = typeof (0, $kzd8a.default)['useId'] === 'function' ? $9df8964a61108436$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId : $9df8964a61108436$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId;
function $9df8964a61108436$var$$c7eafbbe1ea5834e$var$getSnapshot() {
    return false;
}
function $9df8964a61108436$var$$c7eafbbe1ea5834e$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $9df8964a61108436$var$$c7eafbbe1ea5834e$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $9df8964a61108436$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, $kzd8a.default)['useSyncExternalStore'] === 'function') return (0, $kzd8a.default)['useSyncExternalStore']($9df8964a61108436$var$$c7eafbbe1ea5834e$var$subscribe, $9df8964a61108436$var$$c7eafbbe1ea5834e$var$getSnapshot, $9df8964a61108436$var$$c7eafbbe1ea5834e$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $jmWak.useContext)($9df8964a61108436$var$$c7eafbbe1ea5834e$var$IsSSRContext);
}




var $3lE4N = parcelRequire("3lE4N");
const $6cacd0fff1c5811a$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $6cacd0fff1c5811a$var$noop = ()=>{};
function $6cacd0fff1c5811a$export$96df6c7c5036b9a2() {
    const id = (0, $9df8964a61108436$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $6cacd0fff1c5811a$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $jmWak.useContext)((0, $7f6bf662c8128446$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $jmWak.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $6cacd0fff1c5811a$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $6cacd0fff1c5811a$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $6cacd0fff1c5811a$var$DropdownToggle({ children: children }) {
    const [props, meta] = $6cacd0fff1c5811a$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
        children: children(props, meta)
    });
}
$6cacd0fff1c5811a$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $6cacd0fff1c5811a$export$2e2bcd8739ae039 = $6cacd0fff1c5811a$var$DropdownToggle;



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
const $bc7b7daa54233ac1$var$SelectableContext = /*#__PURE__*/ $3lE4N.createContext(null);
const $bc7b7daa54233ac1$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $bc7b7daa54233ac1$export$2e2bcd8739ae039 = $bc7b7daa54233ac1$var$SelectableContext;


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
const $516613c20571fa2a$var$NavContext = /*#__PURE__*/ $3lE4N.createContext(null);
$516613c20571fa2a$var$NavContext.displayName = 'NavContext';
var $516613c20571fa2a$export$2e2bcd8739ae039 = $516613c20571fa2a$var$NavContext;



const $7ab87372f8393f88$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $7ab87372f8393f88$export$635202801f9383a0 = `rrUi`;
function $7ab87372f8393f88$export$5cc3b7b83e34ade7(property) {
    return `${$7ab87372f8393f88$export$fd7bcb7e9bef4e8a}${property}`;
}
function $7ab87372f8393f88$export$7776c0a7cd2eb3e0(property) {
    return `${$7ab87372f8393f88$export$635202801f9383a0}${property}`;
}



const $ef4ec5dc00ac9e8d$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $ef4ec5dc00ac9e8d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ef4ec5dc00ac9e8d$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $jmWak.useContext)((0, $bc7b7daa54233ac1$export$2e2bcd8739ae039));
    const navContext = (0, $jmWak.useContext)((0, $516613c20571fa2a$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $bc7b7daa54233ac1$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $bc7b7daa54233ac1$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $7ab87372f8393f88$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $ef4ec5dc00ac9e8d$var$DropdownItem = /*#__PURE__*/ $kzd8a.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $d638157d1263108f$export$2e2bcd8739ae039) } = _ref, props = $ef4ec5dc00ac9e8d$var$_objectWithoutPropertiesLoose(_ref, $ef4ec5dc00ac9e8d$var$_excluded);
    const [dropdownItemProps] = $ef4ec5dc00ac9e8d$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$ef4ec5dc00ac9e8d$var$DropdownItem.displayName = 'DropdownItem';
var $ef4ec5dc00ac9e8d$export$2e2bcd8739ae039 = $ef4ec5dc00ac9e8d$var$DropdownItem;




parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
var $jmWak = parcelRequire("jmWak");

const $d1e03f98782c825e$var$Context = /*#__PURE__*/ (0, $3lE4N.createContext)((0, $53e6d5b016eb161e$export$2e2bcd8739ae039) ? window : undefined);
const $d1e03f98782c825e$export$f7d306aeb1cf5fbc = $d1e03f98782c825e$var$Context.Provider;
function $d1e03f98782c825e$export$2e2bcd8739ae039() {
    return (0, $jmWak.useContext)($d1e03f98782c825e$var$Context);
}



function $eae0fe4d9c56494e$var$useRefWithUpdate() {
    const forceUpdate = (0, $cd6c4c5a7fbf988d$export$2e2bcd8739ae039)();
    const ref = (0, $jmWak.useRef)(null);
    const attachRef = (0, $jmWak.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $eae0fe4d9c56494e$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $7ab87372f8393f88$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $d1e03f98782c825e$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $3b44bc62a3d0f2fa$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $eae0fe4d9c56494e$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $eae0fe4d9c56494e$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $8009ad784162cfb1$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $jmWak.useRef)(null);
    const focusInDropdown = (0, $jmWak.useRef)(false);
    const onSelectCtx = (0, $jmWak.useContext)((0, $bc7b7daa54233ac1$export$2e2bcd8739ae039));
    const toggle = (0, $jmWak.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $jmWak.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $6cacd0fff1c5811a$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $0a134cba80b47542$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $jmWak.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $jmWak.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $0a134cba80b47542$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $9616d45d3b57ab64$export$2e2bcd8739ae039)((0, $jmWak.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $39288ac6dc5c98da$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $bc7b7daa54233ac1$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $7f6bf662c8128446$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$eae0fe4d9c56494e$var$Dropdown.displayName = 'Dropdown';
$eae0fe4d9c56494e$var$Dropdown.Menu = (0, $be09164d3c547be5$export$2e2bcd8739ae039);
$eae0fe4d9c56494e$var$Dropdown.Toggle = (0, $6cacd0fff1c5811a$export$2e2bcd8739ae039);
$eae0fe4d9c56494e$var$Dropdown.Item = (0, $ef4ec5dc00ac9e8d$export$2e2bcd8739ae039);
var $eae0fe4d9c56494e$export$2e2bcd8739ae039 = $eae0fe4d9c56494e$var$Dropdown;


function $5a6f4bc12a5bea7b$export$2e2bcd8739ae039() {
    return $5a6f4bc12a5bea7b$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5a6f4bc12a5bea7b$export$2e2bcd8739ae039.apply(null, arguments);
}


function $71f411081f13ec29$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
var $250d2e1099d426ec$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $250d2e1099d426ec$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$250d2e1099d426ec$exports = $250d2e1099d426ec$var$invariant;


var $f654fba14224ad9b$var$noop = function noop() {};
function $f654fba14224ad9b$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $f654fba14224ad9b$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $f654fba14224ad9b$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$f654fba14224ad9b$export$26cbf8c37e721e67(prop)] = $f654fba14224ad9b$var$noop;
        var handler;
    });
    return propTypes;
}
function $f654fba14224ad9b$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $f654fba14224ad9b$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $f654fba14224ad9b$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $dbe139f5a1e72daf$var$_toPropertyKey(arg) {
    var key = $dbe139f5a1e72daf$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $dbe139f5a1e72daf$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $dbe139f5a1e72daf$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $jmWak.useRef)(propValue !== undefined);
    var _useState = (0, $jmWak.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $jmWak.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $dbe139f5a1e72daf$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$f654fba14224ad9b$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $71f411081f13ec29$export$2e2bcd8739ae039)(_ref, [
            $f654fba14224ad9b$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($dbe139f5a1e72daf$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $dbe139f5a1e72daf$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $5a6f4bc12a5bea7b$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $c94029e6cb443566$export$2e2bcd8739ae039(t, e) {
    return $c94029e6cb443566$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $c94029e6cb443566$export$2e2bcd8739ae039(t, e);
}


function $73dfd8d150dd9096$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $c94029e6cb443566$export$2e2bcd8739ae039)(t, o);
}



var $kzd8a = parcelRequire("kzd8a");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $e60c074f0cb8bafe$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $e60c074f0cb8bafe$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $e60c074f0cb8bafe$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$e60c074f0cb8bafe$var$componentWillMount.__suppressDeprecationWarning = true;
$e60c074f0cb8bafe$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$e60c074f0cb8bafe$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $e60c074f0cb8bafe$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $e60c074f0cb8bafe$var$componentWillMount;
        prototype.componentWillReceiveProps = $e60c074f0cb8bafe$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $e60c074f0cb8bafe$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $d3587d281f317e63$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $d3587d281f317e63$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $f654fba14224ad9b$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($f654fba14224ad9b$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($250d2e1099d426ec$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $73dfd8d150dd9096$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $5a6f4bc12a5bea7b$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$f654fba14224ad9b$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $5a6f4bc12a5bea7b$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$f654fba14224ad9b$export$12ae2baa35bd9b8b(props, key) && $f654fba14224ad9b$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$f654fba14224ad9b$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $71f411081f13ec29$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, $kzd8a.default).createElement(Component, (0, $5a6f4bc12a5bea7b$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, $kzd8a.default).Component);
    (0, $e60c074f0cb8bafe$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $5a6f4bc12a5bea7b$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $f654fba14224ad9b$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, $kzd8a.default).forwardRef) {
        WrappedComponent = (0, $kzd8a.default).forwardRef(function(props, ref) {
            return (0, $kzd8a.default).createElement(UncontrolledComponent, (0, $5a6f4bc12a5bea7b$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $d3587d281f317e63$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $d3587d281f317e63$export$2e2bcd8739ae039(newComponent, (0, $5a6f4bc12a5bea7b$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}




parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $ad00749031c80cc6$var$useCommittedRef(value) {
    const ref = (0, $jmWak.useRef)(value);
    (0, $jmWak.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $ad00749031c80cc6$export$2e2bcd8739ae039 = $ad00749031c80cc6$var$useCommittedRef;


function $2f6fbb54e1cff0d3$export$2e2bcd8739ae039(fn) {
    const ref = (0, $ad00749031c80cc6$export$2e2bcd8739ae039)(fn);
    return (0, $jmWak.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
"use client";
const $7b33ca40b1d2fb29$var$DropdownContext = /*#__PURE__*/ $3lE4N.createContext({});
$7b33ca40b1d2fb29$var$DropdownContext.displayName = 'DropdownContext';
var $7b33ca40b1d2fb29$export$2e2bcd8739ae039 = $7b33ca40b1d2fb29$var$DropdownContext;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $f4a2ffc765504944$var$DropdownDivider = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$f4a2ffc765504944$var$DropdownDivider.displayName = 'DropdownDivider';
var $f4a2ffc765504944$export$2e2bcd8739ae039 = $f4a2ffc765504944$var$DropdownDivider;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $22ece414b343e250$var$DropdownHeader = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$22ece414b343e250$var$DropdownHeader.displayName = 'DropdownHeader';
var $22ece414b343e250$export$2e2bcd8739ae039 = $22ece414b343e250$var$DropdownHeader;




var $kzd8a = parcelRequire("kzd8a");


var $kzd8a = parcelRequire("kzd8a");





parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $dc4d27de15382529$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $jmWak.useCallback)(()=>document, []);
    return (0, $9616d45d3b57ab64$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $f762276df8721ff8$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $f237c53fabb60d48$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $f237c53fabb60d48$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $jmWak.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $f762276df8721ff8$export$2e2bcd8739ae039 = $f762276df8721ff8$var$useInterval;


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

function $a466d523794bc560$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $f237c53fabb60d48$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $f237c53fabb60d48$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $jmWak.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $a466d523794bc560$export$2e2bcd8739ae039 = $a466d523794bc560$var$useRafInterval;


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $ca09b1f3005f4ebc$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $jmWak.useState)(initialState);
    const updater = (0, $jmWak.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $575e08ed54535e00$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $ca09b1f3005f4ebc$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}




parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $1567f858b868f04b$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $jmWak.useState)({
        image: null,
        error: null
    });
    (0, $jmWak.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
const $dbb9bfdbd2327c7b$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $dbb9bfdbd2327c7b$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $dbb9bfdbd2327c7b$export$2e2bcd8739ae039 = $dbb9bfdbd2327c7b$var$isDOM || $dbb9bfdbd2327c7b$var$isReactNative ? (0, $jmWak.useLayoutEffect) : (0, $jmWak.useEffect);


const $914b4875358c6a6c$var$targetMap = new WeakMap();
let $914b4875358c6a6c$var$resizeObserver;
function $914b4875358c6a6c$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $914b4875358c6a6c$var$resizeObserver = $914b4875358c6a6c$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $914b4875358c6a6c$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $914b4875358c6a6c$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $jmWak.useState)(null);
    (0, $dbb9bfdbd2327c7b$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $914b4875358c6a6c$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $914b4875358c6a6c$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $914b4875358c6a6c$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $cc7927a2f489791a$var$_excluded = [
    "onKeyDown"
];
function $cc7927a2f489791a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $cc7927a2f489791a$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $cc7927a2f489791a$var$Anchor = /*#__PURE__*/ $kzd8a.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $cc7927a2f489791a$var$_objectWithoutPropertiesLoose(_ref, $cc7927a2f489791a$var$_excluded);
    const [buttonProps] = (0, $d638157d1263108f$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($cc7927a2f489791a$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$cc7927a2f489791a$var$Anchor.displayName = 'Anchor';
var $cc7927a2f489791a$export$2e2bcd8739ae039 = $cc7927a2f489791a$var$Anchor;




"use client";
const $dd142b3010e5fca4$var$DropdownItem = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $cc7927a2f489791a$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $ef4ec5dc00ac9e8d$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$dd142b3010e5fca4$var$DropdownItem.displayName = 'DropdownItem';
var $dd142b3010e5fca4$export$2e2bcd8739ae039 = $dd142b3010e5fca4$var$DropdownItem;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $d2f87a2302aee6a6$var$DropdownItemText = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$d2f87a2302aee6a6$var$DropdownItemText.displayName = 'DropdownItemText';
var $d2f87a2302aee6a6$export$2e2bcd8739ae039 = $d2f87a2302aee6a6$var$DropdownItemText;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
const $706e9d3c9d2a9e53$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $706e9d3c9d2a9e53$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $706e9d3c9d2a9e53$export$2e2bcd8739ae039 = $706e9d3c9d2a9e53$var$isDOM || $706e9d3c9d2a9e53$var$isReactNative ? (0, $jmWak.useLayoutEffect) : (0, $jmWak.useEffect);


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
const $c526d8453c8f93e6$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $c526d8453c8f93e6$export$c9058316764c140e(refA, refB) {
    const a = $c526d8453c8f93e6$var$toFnRef(refA);
    const b = $c526d8453c8f93e6$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $c526d8453c8f93e6$var$useMergedRefs(refA, refB) {
    return (0, $jmWak.useMemo)(()=>$c526d8453c8f93e6$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $c526d8453c8f93e6$export$2e2bcd8739ae039 = $c526d8453c8f93e6$var$useMergedRefs;




parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
"use client";
const $85f137ee157233e9$var$context = /*#__PURE__*/ $3lE4N.createContext(null);
$85f137ee157233e9$var$context.displayName = 'InputGroupContext';
var $85f137ee157233e9$export$2e2bcd8739ae039 = $85f137ee157233e9$var$context;


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
"use client";
// TODO: check
const $e00fc39f9e2ca031$var$context = /*#__PURE__*/ $3lE4N.createContext(null);
$e00fc39f9e2ca031$var$context.displayName = 'NavbarContext';
var $e00fc39f9e2ca031$export$2e2bcd8739ae039 = $e00fc39f9e2ca031$var$context;




parcelRequire("kzd8a");

function $ae3684eb0bb6355b$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $c2cdb917681c5aca$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $c2cdb917681c5aca$var$DropdownMenu = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $jmWak.useContext)((0, $e00fc39f9e2ca031$export$2e2bcd8739ae039));
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $jmWak.useContext)((0, $7b33ca40b1d2fb29$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $jmWak.useContext)((0, $85f137ee157233e9$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $c2cdb917681c5aca$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $be09164d3c547be5$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $c526d8453c8f93e6$export$2e2bcd8739ae039)((0, $ae3684eb0bb6355b$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $706e9d3c9d2a9e53$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$c2cdb917681c5aca$var$DropdownMenu.displayName = 'DropdownMenu';
var $c2cdb917681c5aca$export$2e2bcd8739ae039 = $c2cdb917681c5aca$var$DropdownMenu;







var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");




"use client";
const $d0be2da0f6817fcd$var$DropdownToggle = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $85e8222bbf1762c5$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $jmWak.useContext)((0, $7f6bf662c8128446$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $6cacd0fff1c5811a$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $c526d8453c8f93e6$export$2e2bcd8739ae039)(toggleProps.ref, (0, $ae3684eb0bb6355b$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$d0be2da0f6817fcd$var$DropdownToggle.displayName = 'DropdownToggle';
var $d0be2da0f6817fcd$export$2e2bcd8739ae039 = $d0be2da0f6817fcd$var$DropdownToggle;






"use client";
const $eaba73858d72bf09$var$Dropdown = /*#__PURE__*/ $kzd8a.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $dbe139f5a1e72daf$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $jmWak.useContext)((0, $85f137ee157233e9$export$2e2bcd8739ae039));
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $b6315234e77a11f8$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $c2cdb917681c5aca$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $jmWak.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $7b33ca40b1d2fb29$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $eae0fe4d9c56494e$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$eaba73858d72bf09$var$Dropdown.displayName = 'Dropdown';
var $eaba73858d72bf09$export$2e2bcd8739ae039 = Object.assign($eaba73858d72bf09$var$Dropdown, {
    Toggle: (0, $d0be2da0f6817fcd$export$2e2bcd8739ae039),
    Menu: (0, $c2cdb917681c5aca$export$2e2bcd8739ae039),
    Item: (0, $dd142b3010e5fca4$export$2e2bcd8739ae039),
    ItemText: (0, $d2f87a2302aee6a6$export$2e2bcd8739ae039),
    Divider: (0, $f4a2ffc765504944$export$2e2bcd8739ae039),
    Header: (0, $22ece414b343e250$export$2e2bcd8739ae039)
});



var $kzd8a = parcelRequire("kzd8a");
var $a53fecd73fa4e68d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a53fecd73fa4e68d$var$ReactIs, $a53fecd73fa4e68d$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$a53fecd73fa4e68d$exports = (parcelRequire("3p0ZA"))();




"use client";
const $6061a0f906a555ad$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool
};
const $6061a0f906a555ad$var$Image = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$6061a0f906a555ad$var$Image.displayName = 'Image';
var $6061a0f906a555ad$export$2e2bcd8739ae039 = $6061a0f906a555ad$var$Image;



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
const $dc86920ffa69da6e$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $dc86920ffa69da6e$export$c9058316764c140e(refA, refB) {
    const a = $dc86920ffa69da6e$var$toFnRef(refA);
    const b = $dc86920ffa69da6e$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $dc86920ffa69da6e$var$useMergedRefs(refA, refB) {
    return (0, $jmWak.useMemo)(()=>$dc86920ffa69da6e$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $dc86920ffa69da6e$export$2e2bcd8739ae039 = $dc86920ffa69da6e$var$useMergedRefs;




parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
const $16fff16e93a297be$var$TabContext = /*#__PURE__*/ $3lE4N.createContext(null);
var $16fff16e93a297be$export$2e2bcd8739ae039 = $16fff16e93a297be$var$TabContext;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");







const $d7cb8d1a1d173352$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $d7cb8d1a1d173352$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $d7cb8d1a1d173352$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $jmWak.useContext)((0, $bc7b7daa54233ac1$export$2e2bcd8739ae039));
    const navContext = (0, $jmWak.useContext)((0, $516613c20571fa2a$export$2e2bcd8739ae039));
    const tabContext = (0, $jmWak.useContext)((0, $16fff16e93a297be$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $7ab87372f8393f88$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $d7cb8d1a1d173352$var$NavItem = /*#__PURE__*/ $kzd8a.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $d638157d1263108f$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $d7cb8d1a1d173352$var$_objectWithoutPropertiesLoose(_ref, $d7cb8d1a1d173352$var$_excluded);
    const [props, meta] = $d7cb8d1a1d173352$export$d7a68693710982a(Object.assign({
        key: (0, $bc7b7daa54233ac1$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $7ab87372f8393f88$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$d7cb8d1a1d173352$var$NavItem.displayName = 'NavItem';
var $d7cb8d1a1d173352$export$2e2bcd8739ae039 = $d7cb8d1a1d173352$var$NavItem;



const $4793a074f4c7972f$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $4793a074f4c7972f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $4793a074f4c7972f$var$noop = ()=>{};
const $4793a074f4c7972f$var$EVENT_KEY_ATTR = (0, $7ab87372f8393f88$export$5cc3b7b83e34ade7)('event-key');
const $4793a074f4c7972f$var$Nav = /*#__PURE__*/ $kzd8a.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $4793a074f4c7972f$var$_objectWithoutPropertiesLoose(_ref, $4793a074f4c7972f$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $cd6c4c5a7fbf988d$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $jmWak.useRef)(false);
    const parentOnSelect = (0, $jmWak.useContext)((0, $bc7b7daa54233ac1$export$2e2bcd8739ae039));
    const tabContext = (0, $jmWak.useContext)((0, $16fff16e93a297be$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $jmWak.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $0a134cba80b47542$export$2e2bcd8739ae039)(currentListNode, `[${$4793a074f4c7972f$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $7ab87372f8393f88$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $jmWak.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$4793a074f4c7972f$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $dc86920ffa69da6e$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $bc7b7daa54233ac1$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $516613c20571fa2a$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $bc7b7daa54233ac1$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $4793a074f4c7972f$var$noop,
                getControllerId: getControllerId || $4793a074f4c7972f$var$noop
            },
            children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$4793a074f4c7972f$var$Nav.displayName = 'Nav';
var $4793a074f4c7972f$export$2e2bcd8739ae039 = Object.assign($4793a074f4c7972f$var$Nav, {
    Item: (0, $d7cb8d1a1d173352$export$2e2bcd8739ae039)
});






var $kzd8a = parcelRequire("kzd8a");



"use client";
const $88b5f5d07d81c6fa$var$NavItem = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$88b5f5d07d81c6fa$var$NavItem.displayName = 'NavItem';
var $88b5f5d07d81c6fa$export$2e2bcd8739ae039 = $88b5f5d07d81c6fa$var$NavItem;




var $kzd8a = parcelRequire("kzd8a");





"use client";
const $a46b60776de26373$var$NavLink = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $cc7927a2f489791a$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $d7cb8d1a1d173352$export$d7a68693710982a)({
        key: (0, $bc7b7daa54233ac1$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$a46b60776de26373$var$NavLink.displayName = 'NavLink';
var $a46b60776de26373$export$2e2bcd8739ae039 = $a46b60776de26373$var$NavLink;



"use client";
const $f103ad69c50f21fa$var$Nav = /*#__PURE__*/ $kzd8a.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $dbe139f5a1e72daf$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $jmWak.useContext)((0, $e00fc39f9e2ca031$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $jmWak.useContext)((0, $1a62add9ae3ebec5$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $4793a074f4c7972f$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$f103ad69c50f21fa$var$Nav.displayName = 'Nav';
var $f103ad69c50f21fa$export$2e2bcd8739ae039 = Object.assign($f103ad69c50f21fa$var$Nav, {
    Item: (0, $88b5f5d07d81c6fa$export$2e2bcd8739ae039),
    Link: (0, $a46b60776de26373$export$2e2bcd8739ae039)
});




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $59245fa2796b38aa$export$2e2bcd8739ae039() {
    const mounted = (0, $jmWak.useRef)(true);
    const isMounted = (0, $jmWak.useRef)(()=>mounted.current);
    (0, $jmWak.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $1d49b791c1753893$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $jmWak.useRef)(value);
    valueRef.current = value;
    return valueRef;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $384c5eee45df98a8$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $1d49b791c1753893$export$2e2bcd8739ae039)(fn);
    (0, $jmWak.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $2983924f26b3e9d0$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $2983924f26b3e9d0$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $2983924f26b3e9d0$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$2983924f26b3e9d0$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $2983924f26b3e9d0$var$MAX_DELAY_MS);
}
function $2983924f26b3e9d0$export$2e2bcd8739ae039() {
    const isMounted = (0, $59245fa2796b38aa$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $jmWak.useRef)();
    (0, $384c5eee45df98a8$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $jmWak.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $2983924f26b3e9d0$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $2983924f26b3e9d0$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}






var $kzd8a = parcelRequire("kzd8a");
function $b77d92dd97828230$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $b77d92dd97828230$export$13e065f3a74cfe36() {
    const parts = $kzd8a.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $b77d92dd97828230$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $b77d92dd97828230$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");


var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

var $kzd8a = parcelRequire("kzd8a");





parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



const $4f258e841807f427$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $4f258e841807f427$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $4f258e841807f427$var$noop;
    (0, $b071c25977405a0c$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((e)=>{
        if ((0, $b77d92dd97828230$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $jmWak.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)((0, $b071c25977405a0c$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $4f258e841807f427$export$2e2bcd8739ae039 = $4f258e841807f427$var$useRootClose;




parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

const $4aed94df0fa027d2$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $53e6d5b016eb161e$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $4aed94df0fa027d2$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $d1e03f98782c825e$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $jmWak.useState)(()=>$4aed94df0fa027d2$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $4aed94df0fa027d2$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $jmWak.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $jmWak.useEffect)(()=>{
        const nextRef = $4aed94df0fa027d2$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

function $435de291754340c8$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $jmWak.useRef)(null);
    const hasEnteredRef = (0, $jmWak.useRef)(inProp);
    const handleExited = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)(onExited);
    (0, $jmWak.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $dc86920ffa69da6e$export$2e2bcd8739ae039)(ref, (0, $b77d92dd97828230$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $kzd8a.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $435de291754340c8$export$2e2bcd8739ae039 = $435de291754340c8$var$NoopTransition;



var $kzd8a = parcelRequire("kzd8a");

var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");


const $a9287adac8011a95$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $a9287adac8011a95$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a9287adac8011a95$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $a9287adac8011a95$var$_objectWithoutPropertiesLoose(_ref, $a9287adac8011a95$var$_excluded);
    const nodeRef = (0, $jmWak.useRef)(null);
    const mergedRef = (0, $dc86920ffa69da6e$export$2e2bcd8739ae039)(nodeRef, (0, $b77d92dd97828230$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $jmWak.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $jmWak.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $jmWak.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $jmWak.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $jmWak.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $jmWak.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $jmWak.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $kzd8a.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $3585baec0689192c$var$_excluded = [
    "component"
];
function $3585baec0689192c$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $3585baec0689192c$var$RTGTransition = /*#__PURE__*/ $kzd8a.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $3585baec0689192c$var$_objectWithoutPropertiesLoose(_ref, $3585baec0689192c$var$_excluded);
    const transitionProps = (0, $a9287adac8011a95$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $3585baec0689192c$export$2e2bcd8739ae039 = $3585baec0689192c$var$RTGTransition;




function $de13092707d80aed$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $jmWak.useRef)(null);
    const isInitialRef = (0, $jmWak.useRef)(true);
    const handleTransition = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)(onTransition);
    (0, $dbb9bfdbd2327c7b$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $dbb9bfdbd2327c7b$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $de13092707d80aed$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $jmWak.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $de13092707d80aed$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $dc86920ffa69da6e$export$2e2bcd8739ae039)(ref, (0, $b77d92dd97828230$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $kzd8a.cloneElement)(children, {
        ref: combinedRef
    });
}
function $de13092707d80aed$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3585baec0689192c$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)($de13092707d80aed$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $435de291754340c8$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $9feb4dc2ca440cd8$var$Overlay = /*#__PURE__*/ $kzd8a.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $8387f71283271058$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $8387f71283271058$export$2e2bcd8739ae039)();
    const mergedRef = (0, $dc86920ffa69da6e$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $4aed94df0fa027d2$export$2e2bcd8739ae039)(props.container);
    const target = (0, $4aed94df0fa027d2$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $jmWak.useState)(!props.show);
    const popper = (0, $d7c4c83fe391df48$export$2e2bcd8739ae039)(target, rootElement, (0, $9a400fe382ed5c7b$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $4f258e841807f427$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $de13092707d80aed$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, $kzd8a.default).createPortal(child, container) : null;
});
$9feb4dc2ca440cd8$var$Overlay.displayName = 'Overlay';
var $9feb4dc2ca440cd8$export$2e2bcd8739ae039 = $9feb4dc2ca440cd8$var$Overlay;





parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $720e403436e1555a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}





var $kzd8a = parcelRequire("kzd8a");


var $kzd8a = parcelRequire("kzd8a");



"use client";
const $f3aeba856b136568$var$PopoverHeader = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$f3aeba856b136568$var$PopoverHeader.displayName = 'PopoverHeader';
var $f3aeba856b136568$export$2e2bcd8739ae039 = $f3aeba856b136568$var$PopoverHeader;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $637dd56e459fe757$var$PopoverBody = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$637dd56e459fe757$var$PopoverBody.displayName = 'PopoverBody';
var $637dd56e459fe757$export$2e2bcd8739ae039 = $637dd56e459fe757$var$PopoverBody;


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
class $a29ca447553a14e0$export$34582a676b91ff07 extends $3lE4N.Component {
}
function $a29ca447553a14e0$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $5c0f2956c6c00c0b$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $caa3bf6f0f8ef133$var$Popover = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $b6315234e77a11f8$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $a29ca447553a14e0$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $5c0f2956c6c00c0b$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $637dd56e459fe757$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$caa3bf6f0f8ef133$var$Popover.displayName = 'Popover';
var $caa3bf6f0f8ef133$export$2e2bcd8739ae039 = Object.assign($caa3bf6f0f8ef133$var$Popover, {
    Header: (0, $f3aeba856b136568$export$2e2bcd8739ae039),
    Body: (0, $637dd56e459fe757$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $kzd8a = parcelRequire("kzd8a");




"use client";
const $59cf90befc289c47$var$Tooltip = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $b6315234e77a11f8$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $a29ca447553a14e0$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $5c0f2956c6c00c0b$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$59cf90befc289c47$var$Tooltip.displayName = 'Tooltip';
var $59cf90befc289c47$export$2e2bcd8739ae039 = Object.assign($59cf90befc289c47$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $da4fe629aedb6511$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $jmWak.useRef)(null);
    const popoverClass = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $jmWak.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $720e403436e1555a$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $caa3bf6f0f8ef133$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $720e403436e1555a$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $59cf90befc289c47$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");




var $kzd8a = parcelRequire("kzd8a");

var $kzd8a = parcelRequire("kzd8a");
var $c9e4b83806e255ea$export$2e2bcd8739ae039 = {
    disabled: false
};




var $kzd8a = parcelRequire("kzd8a");
var $59c8ab121109abcd$export$2e2bcd8739ae039 = (0, $kzd8a.default).createContext(null);


var $7c2c9d31fb947efd$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $8fbdf14957a5f265$export$bb38bb9a1161268 = 'unmounted';
var $8fbdf14957a5f265$export$84cbff306f539230 = 'exited';
var $8fbdf14957a5f265$export$df38205c966be359 = 'entering';
var $8fbdf14957a5f265$export$78e9e6e3e014d60a = 'entered';
var $8fbdf14957a5f265$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $8fbdf14957a5f265$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $73dfd8d150dd9096$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $8fbdf14957a5f265$export$84cbff306f539230;
                _this.appearStatus = $8fbdf14957a5f265$export$df38205c966be359;
            } else initialStatus = $8fbdf14957a5f265$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $8fbdf14957a5f265$export$bb38bb9a1161268;
        else initialStatus = $8fbdf14957a5f265$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $8fbdf14957a5f265$export$bb38bb9a1161268) return {
            status: $8fbdf14957a5f265$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $8fbdf14957a5f265$export$df38205c966be359 && status !== $8fbdf14957a5f265$export$78e9e6e3e014d60a) nextStatus = $8fbdf14957a5f265$export$df38205c966be359;
            } else if (status === $8fbdf14957a5f265$export$df38205c966be359 || status === $8fbdf14957a5f265$export$78e9e6e3e014d60a) nextStatus = $8fbdf14957a5f265$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $8fbdf14957a5f265$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, $kzd8a.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $7c2c9d31fb947efd$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $8fbdf14957a5f265$export$84cbff306f539230) this.setState({
            status: $8fbdf14957a5f265$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, $kzd8a.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $c9e4b83806e255ea$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $8fbdf14957a5f265$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $8fbdf14957a5f265$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $8fbdf14957a5f265$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, $kzd8a.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $c9e4b83806e255ea$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $8fbdf14957a5f265$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $8fbdf14957a5f265$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $8fbdf14957a5f265$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, $kzd8a.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $8fbdf14957a5f265$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $71f411081f13ec29$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, $kzd8a.default).createElement((0, $59c8ab121109abcd$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, $kzd8a.default).cloneElement((0, $kzd8a.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, $kzd8a.default).Component);
$8fbdf14957a5f265$var$Transition.contextType = (0, $59c8ab121109abcd$export$2e2bcd8739ae039);
$8fbdf14957a5f265$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $8fbdf14957a5f265$var$noop() {}
$8fbdf14957a5f265$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $8fbdf14957a5f265$var$noop,
    onEntering: $8fbdf14957a5f265$var$noop,
    onEntered: $8fbdf14957a5f265$var$noop,
    onExit: $8fbdf14957a5f265$var$noop,
    onExiting: $8fbdf14957a5f265$var$noop,
    onExited: $8fbdf14957a5f265$var$noop
};
$8fbdf14957a5f265$var$Transition.UNMOUNTED = $8fbdf14957a5f265$export$bb38bb9a1161268;
$8fbdf14957a5f265$var$Transition.EXITED = $8fbdf14957a5f265$export$84cbff306f539230;
$8fbdf14957a5f265$var$Transition.ENTERING = $8fbdf14957a5f265$export$df38205c966be359;
$8fbdf14957a5f265$var$Transition.ENTERED = $8fbdf14957a5f265$export$78e9e6e3e014d60a;
$8fbdf14957a5f265$var$Transition.EXITING = $8fbdf14957a5f265$export$4aacc83d4d59139f;
var $8fbdf14957a5f265$export$2e2bcd8739ae039 = $8fbdf14957a5f265$var$Transition;




function $32111235bb00f3df$export$2e2bcd8739ae039(node) {
    var doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $7f1da6e4e2ccffac$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $32111235bb00f3df$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $93dc448587824ba2$var$rUpper = /([A-Z])/g;
function $93dc448587824ba2$export$2e2bcd8739ae039(string) {
    return string.replace($93dc448587824ba2$var$rUpper, '-$1').toLowerCase();
}


var $fc9e0f35a4611ba5$var$msPattern = /^ms-/;
function $fc9e0f35a4611ba5$export$2e2bcd8739ae039(string) {
    return (0, $93dc448587824ba2$export$2e2bcd8739ae039)(string).replace($fc9e0f35a4611ba5$var$msPattern, '-ms-');
}


var $8daf33ed3a5b05b4$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $8daf33ed3a5b05b4$export$2e2bcd8739ae039(value) {
    return !!(value && $8daf33ed3a5b05b4$var$supportedTransforms.test(value));
}


function $6a01e84b1d47be46$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(property)) || (0, $7f1da6e4e2ccffac$export$2e2bcd8739ae039)(node).getPropertyValue((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(key));
        else if ((0, $8daf33ed3a5b05b4$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $fc9e0f35a4611ba5$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $6a01e84b1d47be46$export$2e2bcd8739ae039 = $6a01e84b1d47be46$var$style;




/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $3d98db97c6f46e5c$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $8061db448c42d261$var$parseDuration(node) {
    var str = (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $8061db448c42d261$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $3d98db97c6f46e5c$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $8061db448c42d261$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $8061db448c42d261$var$parseDuration(element) || 0;
    var removeEmulate = $8061db448c42d261$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $a6a537e724a25cd3$var$parseDuration(node, property) {
    const str = (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $a6a537e724a25cd3$export$2e2bcd8739ae039(element, handler) {
    const duration = $a6a537e724a25cd3$var$parseDuration(element, 'transitionDuration');
    const delay = $a6a537e724a25cd3$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $8061db448c42d261$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $25028194e22c049f$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



var $kzd8a = parcelRequire("kzd8a");
function $9fb300623b3f9534$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, $kzd8a.default).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $e56a76b3d61aacf5$var$TransitionWrapper = /*#__PURE__*/ (0, $kzd8a.default).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $jmWak.useRef)(null);
    const mergedRef = (0, $c526d8453c8f93e6$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $9fb300623b3f9534$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $jmWak.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $jmWak.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $jmWak.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $jmWak.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $jmWak.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $jmWak.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $jmWak.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $8fbdf14957a5f265$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, $kzd8a.default).cloneElement(children, {
            ref: attachRef
        })
    });
});
$e56a76b3d61aacf5$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $e56a76b3d61aacf5$export$2e2bcd8739ae039 = $e56a76b3d61aacf5$var$TransitionWrapper;



const $9c83adfb94811f58$var$fadeStyles = {
    [(0, $8fbdf14957a5f265$export$df38205c966be359)]: 'show',
    [(0, $8fbdf14957a5f265$export$78e9e6e3e014d60a)]: 'show'
};
const $9c83adfb94811f58$var$Fade = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $jmWak.useCallback)((node, isAppearing)=>{
        (0, $25028194e22c049f$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $e56a76b3d61aacf5$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $a6a537e724a25cd3$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $b77d92dd97828230$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $kzd8a.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('fade', className, children.props.className, $9c83adfb94811f58$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$9c83adfb94811f58$var$Fade.displayName = 'Fade';
var $9c83adfb94811f58$export$2e2bcd8739ae039 = $9c83adfb94811f58$var$Fade;




"use client";
function $479ec124d689adb0$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $9fb300623b3f9534$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $9fb300623b3f9534$export$2e2bcd8739ae039)(r)));
}
const $479ec124d689adb0$var$Overlay = /*#__PURE__*/ $kzd8a.forwardRef(({ children: overlay, transition: transition = (0, $9c83adfb94811f58$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $jmWak.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $jmWak.useState)(null);
    const [ref, modifiers] = (0, $da4fe629aedb6511$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $c526d8453c8f93e6$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $9c83adfb94811f58$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $706e9d3c9d2a9e53$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $jmWak.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $9feb4dc2ca440cd8$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $479ec124d689adb0$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $kzd8a.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$479ec124d689adb0$var$Overlay.displayName = 'Overlay';
var $479ec124d689adb0$export$2e2bcd8739ae039 = $479ec124d689adb0$var$Overlay;




var $3lE4N = parcelRequire("3lE4N");
"use client";
function $61083e4a4c1c7431$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $61083e4a4c1c7431$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $61083e4a4c1c7431$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $61083e4a4c1c7431$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $jmWak.useRef)(null);
    const mergedRef = (0, $c526d8453c8f93e6$export$2e2bcd8739ae039)(triggerNodeRef, (0, $b77d92dd97828230$export$87943f2672146d57)(children));
    const timeout = (0, $2983924f26b3e9d0$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $jmWak.useRef)('');
    const [show, setShow] = (0, $dbe139f5a1e72daf$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $61083e4a4c1c7431$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $kzd8a.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $9fb300623b3f9534$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $jmWak.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $jmWak.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $jmWak.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $jmWak.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $jmWak.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $jmWak.useCallback)((...args)=>{
        $61083e4a4c1c7431$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $jmWak.useCallback)((...args)=>{
        $61083e4a4c1c7431$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $kzd8a.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $479ec124d689adb0$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $61083e4a4c1c7431$export$2e2bcd8739ae039 = $61083e4a4c1c7431$var$OverlayTrigger;



var $kzd8a = parcelRequire("kzd8a");


"use client";
const $3337fdcef7a6ae36$var$Row = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $b6315234e77a11f8$export$8970c8db816a5863)();
    const minBreakpoint = (0, $b6315234e77a11f8$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$3337fdcef7a6ae36$var$Row.displayName = 'Row';
var $3337fdcef7a6ae36$export$2e2bcd8739ae039 = $3337fdcef7a6ae36$var$Row;



var $kzd8a = parcelRequire("kzd8a");


"use client";
const $32f816caebe11677$var$Spinner = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$32f816caebe11677$var$Spinner.displayName = 'Spinner';
var $32f816caebe11677$export$2e2bcd8739ae039 = $32f816caebe11677$var$Spinner;



var $kzd8a = parcelRequire("kzd8a");


"use client";
const $71c6da7a2e5aef0a$var$Table = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$71c6da7a2e5aef0a$var$Table.displayName = 'Table';
var $71c6da7a2e5aef0a$export$2e2bcd8739ae039 = $71c6da7a2e5aef0a$var$Table;


var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



var $kzd8a = parcelRequire("kzd8a");



const $2191b7ee852b87f0$var$fadeStyles = {
    [(0, $8fbdf14957a5f265$export$df38205c966be359)]: 'showing',
    [(0, $8fbdf14957a5f265$export$4aacc83d4d59139f)]: 'showing show'
};
const $2191b7ee852b87f0$var$ToastFade = /*#__PURE__*/ $kzd8a.forwardRef((props, ref)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $9c83adfb94811f58$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        transitionClasses: $2191b7ee852b87f0$var$fadeStyles
    }));
$2191b7ee852b87f0$var$ToastFade.displayName = 'ToastFade';
var $2191b7ee852b87f0$export$2e2bcd8739ae039 = $2191b7ee852b87f0$var$ToastFade;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");




var $kzd8a = parcelRequire("kzd8a");


const $0406b4accb6865c0$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).oneOf([
        'white'
    ])
};
const $0406b4accb6865c0$var$CloseButton = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$0406b4accb6865c0$var$CloseButton.displayName = 'CloseButton';
$0406b4accb6865c0$var$CloseButton.propTypes = $0406b4accb6865c0$var$propTypes;
var $0406b4accb6865c0$export$2e2bcd8739ae039 = $0406b4accb6865c0$var$CloseButton;


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
"use client";
const $4a8650888f4bc366$var$ToastContext = /*#__PURE__*/ $3lE4N.createContext({
    onClose () {}
});
var $4a8650888f4bc366$export$2e2bcd8739ae039 = $4a8650888f4bc366$var$ToastContext;



"use client";
const $1b6c06a2f11fa379$var$ToastHeader = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = true, className: className, children: children, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'toast-header');
    const context = (0, $jmWak.useContext)((0, $4a8650888f4bc366$export$2e2bcd8739ae039));
    const handleClick = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)((e)=>{
        context == null || context.onClose == null || context.onClose(e);
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(bsPrefix, className),
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $0406b4accb6865c0$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick,
                "data-dismiss": "toast"
            })
        ]
    });
});
$1b6c06a2f11fa379$var$ToastHeader.displayName = 'ToastHeader';
var $1b6c06a2f11fa379$export$2e2bcd8739ae039 = $1b6c06a2f11fa379$var$ToastHeader;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $da10c779db917468$var$ToastBody = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'toast-body');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$da10c779db917468$var$ToastBody.displayName = 'ToastBody';
var $da10c779db917468$export$2e2bcd8739ae039 = $da10c779db917468$var$ToastBody;





"use client";
const $598ec01b79b05a61$var$Toast = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, transition: Transition = (0, $2191b7ee852b87f0$export$2e2bcd8739ae039), show: show = true, animation: animation = true, delay: delay = 5000, autohide: autohide = false, onClose: onClose, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, bg: bg, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'toast');
    // We use refs for these, because we don't want to restart the autohide
    // timer in case these values change.
    const delayRef = (0, $jmWak.useRef)(delay);
    const onCloseRef = (0, $jmWak.useRef)(onClose);
    (0, $jmWak.useEffect)(()=>{
        delayRef.current = delay;
        onCloseRef.current = onClose;
    }, [
        delay,
        onClose
    ]);
    const autohideTimeout = (0, $2983924f26b3e9d0$export$2e2bcd8739ae039)();
    const autohideToast = !!(autohide && show);
    const autohideFunc = (0, $jmWak.useCallback)(()=>{
        if (autohideToast) onCloseRef.current == null || onCloseRef.current();
    }, [
        autohideToast
    ]);
    (0, $jmWak.useEffect)(()=>{
        // Only reset timer if show or autohide changes.
        autohideTimeout.set(autohideFunc, delayRef.current);
    }, [
        autohideTimeout,
        autohideFunc
    ]);
    const toastContext = (0, $jmWak.useMemo)(()=>({
            onClose: onClose
        }), [
        onClose
    ]);
    const hasAnimation = !!(Transition && animation);
    const toast = /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(bsPrefix, className, bg && `bg-${bg}`, !hasAnimation && (show ? 'show' : 'hide')),
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $4a8650888f4bc366$export$2e2bcd8739ae039).Provider, {
        value: toastContext,
        children: hasAnimation && Transition ? /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Transition, {
            in: show,
            onEnter: onEnter,
            onEntering: onEntering,
            onEntered: onEntered,
            onExit: onExit,
            onExiting: onExiting,
            onExited: onExited,
            unmountOnExit: true,
            children: toast
        }) : toast
    });
});
$598ec01b79b05a61$var$Toast.displayName = 'Toast';
var $598ec01b79b05a61$export$2e2bcd8739ae039 = Object.assign($598ec01b79b05a61$var$Toast, {
    Body: (0, $da10c779db917468$export$2e2bcd8739ae039),
    Header: (0, $1b6c06a2f11fa379$export$2e2bcd8739ae039)
});



var $kzd8a = parcelRequire("kzd8a");


"use client";
const $6ff9bd29c9865658$var$positionClasses = {
    'top-start': 'top-0 start-0',
    'top-center': 'top-0 start-50 translate-middle-x',
    'top-end': 'top-0 end-0',
    'middle-start': 'top-50 start-0 translate-middle-y',
    'middle-center': 'top-50 start-50 translate-middle',
    'middle-end': 'top-50 end-0 translate-middle-y',
    'bottom-start': 'bottom-0 start-0',
    'bottom-center': 'bottom-0 start-50 translate-middle-x',
    'bottom-end': 'bottom-0 end-0'
};
const $6ff9bd29c9865658$var$ToastContainer = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, position: position, containerPosition: containerPosition, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'toast-container');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(bsPrefix, position && $6ff9bd29c9865658$var$positionClasses[position], containerPosition && `position-${containerPosition}`, className)
    });
});
$6ff9bd29c9865658$var$ToastContainer.displayName = 'ToastContainer';
var $6ff9bd29c9865658$export$2e2bcd8739ae039 = $6ff9bd29c9865658$var$ToastContainer;


var $eec13e6b5a0b94b3$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $eec13e6b5a0b94b3$exports = factory();
})($eec13e6b5a0b94b3$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = 'AAAAAAAAAAAAEA4AGBkAAFAaAAACAAAAAAAIABAAGAAwADgACAAQAAgAEAAIABAACAAQAAgAEAAIABAACAAQAAgAEAAIABAAQABIAEQATAAIABAACAAQAAgAEAAIABAAVABcAAgAEAAIABAACAAQAGAAaABwAHgAgACIAI4AlgAIABAAmwCjAKgAsAC2AL4AvQDFAMoA0gBPAVYBWgEIAAgACACMANoAYgFkAWwBdAF8AX0BhQGNAZUBlgGeAaMBlQGWAasBswF8AbsBwwF0AcsBYwHTAQgA2wG/AOMBdAF8AekB8QF0AfkB+wHiAHQBfAEIAAMC5gQIAAsCEgIIAAgAFgIeAggAIgIpAggAMQI5AkACygEIAAgASAJQAlgCYAIIAAgACAAKBQoFCgUTBRMFGQUrBSsFCAAIAAgACAAIAAgACAAIAAgACABdAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABoAmgCrwGvAQgAbgJ2AggAHgEIAAgACADnAXsCCAAIAAgAgwIIAAgACAAIAAgACACKAggAkQKZAggAPADJAAgAoQKkAqwCsgK6AsICCADJAggA0AIIAAgACAAIANYC3gIIAAgACAAIAAgACABAAOYCCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAkASoB+QIEAAgACAA8AEMCCABCBQgACABJBVAFCAAIAAgACAAIAAgACAAIAAgACABTBVoFCAAIAFoFCABfBWUFCAAIAAgACAAIAAgAbQUIAAgACAAIAAgACABzBXsFfQWFBYoFigWKBZEFigWKBYoFmAWfBaYFrgWxBbkFCAAIAAgACAAIAAgACAAIAAgACAAIAMEFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAMgFCADQBQgACAAIAAgACAAIAAgACAAIAAgACAAIAO4CCAAIAAgAiQAIAAgACABAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAD0AggACAD8AggACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIANYFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAMDvwAIAAgAJAIIAAgACAAIAAgACAAIAAgACwMTAwgACAB9BOsEGwMjAwgAKwMyAwsFYgE3A/MEPwMIAEUDTQNRAwgAWQOsAGEDCAAIAAgACAAIAAgACABpAzQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFIQUoBSwFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABtAwgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABMAEwACAAIAAgACAAIABgACAAIAAgACAC/AAgACAAyAQgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACAAIAAwAAgACAAIAAgACAAIAAgACAAIAAAARABIAAgACAAIABQASAAIAAgAIABwAEAAjgCIABsAqAC2AL0AigDQAtwC+IJIQqVAZUBWQqVAZUBlQGVAZUBlQGrC5UBlQGVAZUBlQGVAZUBlQGVAXsKlQGVAbAK6wsrDGUMpQzlDJUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAfAKAAuZA64AtwCJALoC6ADwAAgAuACgA/oEpgO6AqsD+AAIAAgAswMIAAgACAAIAIkAuwP5AfsBwwPLAwgACAAIAAgACADRA9kDCAAIAOED6QMIAAgACAAIAAgACADuA/YDCAAIAP4DyQAIAAgABgQIAAgAXQAOBAgACAAIAAgACAAIABMECAAIAAgACAAIAAgACAD8AAQBCAAIAAgAGgQiBCoECAExBAgAEAEIAAgACAAIAAgACAAIAAgACAAIAAgACAA4BAgACABABEYECAAIAAgATAQYAQgAVAQIAAgACAAIAAgACAAIAAgACAAIAFoECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAOQEIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAB+BAcACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAEABhgSMBAgACAAIAAgAlAQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAwAEAAQABAADAAMAAwADAAQABAAEAAQABAAEAAQABHATAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAdQMIAAgACAAIAAgACAAIAMkACAAIAAgAfQMIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACFA4kDCAAIAAgACAAIAOcBCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAIcDCAAIAAgACAAIAAgACAAIAAgACAAIAJEDCAAIAAgACADFAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABgBAgAZgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAbAQCBXIECAAIAHkECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABAAJwEQACjBKoEsgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAC6BMIECAAIAAgACAAIAAgACABmBAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAxwQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAGYECAAIAAgAzgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBd0FXwUIAOIF6gXxBYoF3gT5BQAGCAaKBYoFigWKBYoFigWKBYoFigWKBYoFigXWBIoFigWKBYoFigWKBYoFigWKBYsFEAaKBYoFigWKBYoFigWKBRQGCACKBYoFigWKBQgACAAIANEECAAIABgGigUgBggAJgYIAC4GMwaKBYoF0wQ3Bj4GigWKBYoFigWKBYoFigWKBYoFigWKBYoFigUIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWLBf///////wQABAAEAAQABAAEAAQABAAEAAQAAwAEAAQAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAQADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUAAAAFAAUAAAAFAAUAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAQAAAAUABQAFAAUABQAFAAAAAAAFAAUAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAFAAUAAQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAAABwAHAAcAAAAHAAcABwAFAAEAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAcABwAFAAUAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAQABAAAAAAAAAAAAAAAFAAUABQAFAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAHAAcAAAAHAAcAAAAAAAUABQAHAAUAAQAHAAEABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwABAAUABQAFAAUAAAAAAAAAAAAAAAEAAQABAAEAAQABAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABQANAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAABQAHAAUABQAFAAAAAAAAAAcABQAFAAUABQAFAAQABAAEAAQABAAEAAQABAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUAAAAFAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAUAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAcABwAFAAcABwAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUABwAHAAUABQAFAAUAAAAAAAcABwAAAAAABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAAAAAAAAAAABQAFAAAAAAAFAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAFAAUABQAFAAUAAAAFAAUABwAAAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABwAFAAUABQAFAAAAAAAHAAcAAAAAAAcABwAFAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAAAAAAAAAHAAcABwAAAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAUABQAFAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAHAAcABQAHAAcAAAAFAAcABwAAAAcABwAFAAUAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAFAAcABwAFAAUABQAAAAUAAAAHAAcABwAHAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAHAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUAAAAFAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAUAAAAFAAUAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABwAFAAUABQAFAAUABQAAAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABQAFAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAFAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAHAAUABQAFAAUABQAFAAUABwAHAAcABwAHAAcABwAHAAUABwAHAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABwAHAAcABwAFAAUABwAHAAcAAAAAAAAAAAAHAAcABQAHAAcABwAHAAcABwAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAUABQAFAAUABQAFAAUAAAAFAAAABQAAAAAABQAFAAUABQAFAAUABQAFAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAUABQAFAAUABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABwAFAAcABwAHAAcABwAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAUABQAFAAUABwAHAAUABQAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABQAFAAcABwAHAAUABwAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAcABQAFAAUABQAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAAAAAABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAAAAAAAAAFAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAUABQAHAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAFAAUABQAFAAcABwAFAAUABwAHAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAcABwAFAAUABwAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABQAAAAAABQAFAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAcABwAAAAAAAAAAAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAcABwAFAAcABwAAAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAFAAUABQAAAAUABQAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABwAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAHAAcABQAHAAUABQAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAAABwAHAAAAAAAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAFAAUABwAFAAcABwAFAAcABQAFAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAAAAAABwAHAAcABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAFAAcABwAFAAUABQAFAAUABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAUABQAFAAcABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABQAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAAAAAAFAAUABwAHAAcABwAFAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAHAAUABQAFAAUABQAFAAUABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAABQAAAAUABQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcAAAAFAAUAAAAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABQAFAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAABQAFAAUABQAFAAUABQAAAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAFAAUABQAFAAUADgAOAA4ADgAOAA4ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAMAAwADAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAAAAAAAAAAAAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAAAAAAAAAAAAsADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwACwAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAADgAOAA4AAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAAAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4AAAAOAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAAAAAAAAAAAA4AAAAOAAAAAAAAAAAADgAOAA4AAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAA=';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


function $b8df73c80b604f74$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $b8df73c80b604f74$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
function $b8df73c80b604f74$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
var $b8df73c80b604f74$var$$fd019656019bb4f3$exports = {};
function $b8df73c80b604f74$var$$fd019656019bb4f3$export$e3607ec2d7a891c4(e) {
    return function(t) {
        return t && new IntersectionObserver(function(t, r) {
            var a, c, n = (0, $a8a036b4881ec134$export$71511d61b312f219)(t, 1)[0], i = n.isIntersecting, o = n.target;
            if (i) {
                var s = [
                    "animate__animated",
                    "animate__".concat(e)
                ];
                (a = o.classList).add.apply(a, (0, $ba6b19be90dbdadc$export$71511d61b312f219)(s)), o.addEventListener("animationend", function() {
                    return (c = o.classList).remove.apply(c, (0, $ba6b19be90dbdadc$export$71511d61b312f219)(s));
                }, {
                    once: !0
                }), r.disconnect();
            }
        }).observe(t);
    };
}
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$fd019656019bb4f3$exports, "animate", function() {
    return $b8df73c80b604f74$var$$fd019656019bb4f3$export$e3607ec2d7a891c4;
});
var $b8df73c80b604f74$var$$757747c0209676cc$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$757747c0209676cc$exports, "Avatar", function() {
    return $b8df73c80b604f74$var$$757747c0209676cc$export$e2255cf6045e8d47;
});
var $b8df73c80b604f74$var$$757747c0209676cc$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$757747c0209676cc$export$e2255cf6045e8d47 = function(e) {
    var t = e.className, r = e.style, a = e.size, c = void 0 === a ? 3 : a, n = $b8df73c80b604f74$var$$757747c0209676cc$var$__rest(e, [
        "className",
        "style",
        "size"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("img", Object.assign({
        className: $b8df73c80b604f74$var$$parcel$interopDefault($46a03b660b5bd4f2$exports)("object-fit-cover rounded-circle", t),
        style: Object.assign({
            width: "".concat(c, "rem"),
            height: "".concat(c, "rem")
        }, r)
    }, n));
};
$b8df73c80b604f74$var$$757747c0209676cc$export$e2255cf6045e8d47.displayName = "Avatar";
var $b8df73c80b604f74$var$$a40a1c3d6dc84a7a$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$a40a1c3d6dc84a7a$exports, "ClickBoundary", function() {
    return $b8df73c80b604f74$var$$a40a1c3d6dc84a7a$export$707fce199b8e37aa;
});
var $b8df73c80b604f74$var$$a40a1c3d6dc84a7a$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$a40a1c3d6dc84a7a$export$707fce199b8e37aa = function(e) {
    "use strict";
    function t() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "root", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, $3lE4N.createRef)()
        }), Object.defineProperty(e, "switchClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                var r, a = e.props, c = a.onInnerClick, n = a.onOuterClick;
                (null == (r = e.root.current) ? void 0 : r.contains(t.target)) ? null == c || c(t) : null == n || n(t);
            }
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
        {
            key: "componentDidMount",
            value: function() {
                window.addEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                window.removeEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = e.children, r = (e.onInnerClick, e.onOuterClick, $b8df73c80b604f74$var$$a40a1c3d6dc84a7a$var$__rest(e, [
                    "children",
                    "onInnerClick",
                    "onOuterClick"
                ]));
                return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({
                    ref: this.root
                }, r, {
                    children: t
                }));
            }
        }
    ]), t;
}($kzd8a.PureComponent), $b8df73c80b604f74$var$$89fa9a64cf869995$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$89fa9a64cf869995$exports, "CodeBlock", function() {
    return $b8df73c80b604f74$var$$89fa9a64cf869995$export$6c415d1fdae3dfdb;
});
var $b8df73c80b604f74$var$$89fa9a64cf869995$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$89fa9a64cf869995$export$6c415d1fdae3dfdb = function(e) {
    var t = e.className, r = e.language, a = e.children, c = $b8df73c80b604f74$var$$89fa9a64cf869995$var$__rest(e, [
        "className",
        "language",
        "children"
    ]), n = "string" == typeof a ? a : $b8df73c80b604f74$var$$parcel$interopDefault($fd3df234846bf672$exports)((0, $kzd8a.isValidElement)(a) ? a : (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
        children: a
    })), i = (0, $77a3cf6ce43ba174$exports.highlight)(n, $77a3cf6ce43ba174$exports.languages[r], r);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("pre", Object.assign({
        className: "language-".concat(r, " ").concat(void 0 === t ? "" : t)
    }, c, {
        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("code", {
            dangerouslySetInnerHTML: {
                __html: i
            },
            className: "language-".concat(r)
        })
    }));
}, $b8df73c80b604f74$var$$924d73683971f901$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$924d73683971f901$exports, "VariantColors", function() {
    return $b8df73c80b604f74$var$$924d73683971f901$export$50b010be9260e56b;
}), $b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$924d73683971f901$exports, "text2color", function() {
    return $b8df73c80b604f74$var$$924d73683971f901$export$b480d00b75c9ac2d;
});
var $b8df73c80b604f74$var$$924d73683971f901$export$50b010be9260e56b = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "dark",
    "light"
];
function $b8df73c80b604f74$var$$924d73683971f901$export$b480d00b75c9ac2d(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = t[0] ? $b8df73c80b604f74$var$$924d73683971f901$export$50b010be9260e56b.filter(function(e) {
        return !t.find(function(t) {
            return t === e;
        });
    }) : $b8df73c80b604f74$var$$924d73683971f901$export$50b010be9260e56b;
    return r[(0, $ba6b19be90dbdadc$export$71511d61b312f219)(e).reduce(function(e, t) {
        return e + t.charCodeAt(0);
    }, 0) % r.length];
}
var $b8df73c80b604f74$var$$9dab2fd0b4033192$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$9dab2fd0b4033192$exports, "Countdown", function() {
    return $b8df73c80b604f74$var$$9dab2fd0b4033192$export$53819c0e58f98d49;
});
var $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$9dab2fd0b4033192$export$53819c0e58f98d49 = function() {
    var e, t, r, a, c, n, i, o, s = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], l = [], $ = $97ddcb8d2dacc617$exports.ObservedComponent, u = [], d = [], f = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, ($b8df73c80b604f74$var$$9dab2fd0b4033192$var$__runInitializers(e, u), $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__runInitializers(e, d, 0))), Object.defineProperty(e, "timer", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$9dab2fd0b4033192$var$__runInitializers(e, f), 0)
            }), Object.defineProperty(e, "tick", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    var t = e.props, r = t.onEnd, a = t.endTime, c = e.endTimestamp - Date.now();
                    c > 0 ? e.rest = c : (e.rest = 0, e.stop(), null == r || r(a));
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "rest",
                get: function() {
                    return $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "endTimestamp",
                get: function() {
                    return +new Date(this.props.endTime || Date.now());
                }
            },
            {
                key: "timeSections",
                get: function() {
                    var e = this.observedProps.units, t = this.rest;
                    return e.reduce(function(r, a, c) {
                        var n = a.label, i = e.slice(c).map(function(e) {
                            return e.scale;
                        }).reduce(function(e, t) {
                            return e * t;
                        }, 1), o = ~~(t / i);
                        return t -= o * i, r.push({
                            value: o,
                            label: n
                        }), r;
                    }, []);
                }
            },
            {
                key: "stop",
                value: function() {
                    this.timer && (window.clearInterval(this.timer), this.timer = 0);
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.initTimer();
                }
            },
            {
                key: "initTimer",
                value: function() {
                    this.stop(), this.tick(), this.timer = window.setInterval(this.tick, $iob0w.Second);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "componentWillUnmount", this).call(this), this.stop();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.className, r = e.itemClassName, a = void 0 === r ? "border rounded px-4 py-3 d-flex flex-column justify-content-center align-items-center" : r, c = (e.units, e.endTime, e.onEnd, $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__rest(e, [
                        "className",
                        "itemClassName",
                        "units",
                        "endTime",
                        "onEnd"
                    ])), n = this.timeSections;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("ol", Object.assign({
                        className: "list-unstyled m-0 ".concat(void 0 === t ? "" : t)
                    }, c, {
                        children: n.map(function(e) {
                            var t = e.value, r = e.label;
                            return (0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
                                className: a,
                                children: [
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("strong", {
                                        children: (t + "").padStart(2, "0")
                                    }),
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                                        children: r
                                    })
                                ]
                            }, r);
                        })
                    }));
                }
            }
        ]), t;
    }($), r = new WeakMap, $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__setFunctionName(c, "Countdown"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, n = [
        $cF2Ke.observable
    ], i = [
        $cF2Ke.computed
    ], o = [
        (0, $97ddcb8d2dacc617$exports.reaction)(function(e) {
            return e.observedProps.endTime;
        })
    ], $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__esDecorate(c, null, n, {
        kind: "accessor",
        name: "rest",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "rest" in e;
            },
            get: function(e) {
                return e.rest;
            },
            set: function(e, t) {
                e.rest = t;
            }
        },
        metadata: t
    }, d, f), $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__esDecorate(c, null, i, {
        kind: "getter",
        name: "timeSections",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "timeSections" in e;
            },
            get: function(e) {
                return e.timeSections;
            }
        },
        metadata: t
    }, null, u), $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__esDecorate(c, null, o, {
        kind: "method",
        name: "initTimer",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "initTimer" in e;
            },
            get: function(e) {
                return e.initTimer;
            }
        },
        metadata: t
    }, null, u), $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__esDecorate(null, a = {
        value: c
    }, s, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Countdown"
    }), $b8df73c80b604f74$var$$9dab2fd0b4033192$var$__runInitializers(c, l), c;
}(), $b8df73c80b604f74$var$$e308f4ff6755d29b$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$e308f4ff6755d29b$exports, "DialogClose", function() {
    return $b8df73c80b604f74$var$$e308f4ff6755d29b$export$fba2fb7cd781b7ac;
}), $b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$e308f4ff6755d29b$exports, "Dialog", function() {
    return $b8df73c80b604f74$var$$e308f4ff6755d29b$export$3ddf2d174ce01153;
});
var $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$e308f4ff6755d29b$export$fba2fb7cd781b7ac = function(e) {
    "use strict";
    function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Dialog closed";
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, [
            e
        ]);
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), t;
}((0, $24e24f69a9339c74$export$71511d61b312f219)(Error)), $b8df73c80b604f74$var$$e308f4ff6755d29b$export$3ddf2d174ce01153 = function() {
    var e, t, r, a, c, n, i = [], o = [], s = [], l = [];
    return t = function() {
        "use strict";
        function e(t) {
            var c = this;
            (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, e), r.set(this, $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__runInitializers(this, i, {})), a.set(this, ($b8df73c80b604f74$var$$e308f4ff6755d29b$var$__runInitializers(this, o), $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__runInitializers(this, s, void 0))), Object.defineProperty(this, "Component", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__runInitializers(this, l)
            }), this.Component = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(function(e) {
                return (0, $833f543b429117ba$export$34b9dba7ce09269b)(t, Object.assign({}, e, c.input, {
                    defer: c.defer
                }));
            }), this.Component.displayName = "DialogComponent";
        }
        return (0, $30088f375ab7517b$export$71511d61b312f219)(e, [
            {
                key: "input",
                get: function() {
                    return $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "defer",
                get: function() {
                    return $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "open",
                value: function(e) {
                    var t = this;
                    return e && (this.input = e), this.defer = new $630535246db4a983$export$c7e91f8aec23ae14, this.defer.promise.finally(function() {
                        return t.defer = void 0;
                    }), this.defer.promise;
                }
            }
        ]), e;
    }(), r = new WeakMap, a = new WeakMap, e = "function" == typeof Symbol && Symbol.metadata ? Object.create(null) : void 0, c = [
        $cF2Ke.observable
    ], n = [
        $cF2Ke.observable
    ], $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__esDecorate(t, null, c, {
        kind: "accessor",
        name: "input",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "input" in e;
            },
            get: function(e) {
                return e.input;
            },
            set: function(e, t) {
                e.input = t;
            }
        },
        metadata: e
    }, i, o), $b8df73c80b604f74$var$$e308f4ff6755d29b$var$__esDecorate(t, null, n, {
        kind: "accessor",
        name: "defer",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "defer" in e;
            },
            get: function(e) {
                return e.defer;
            },
            set: function(e, t) {
                e.defer = t;
            }
        },
        metadata: e
    }, s, l), e && Object.defineProperty(t, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }), t;
}(), $b8df73c80b604f74$var$$68aab1d0e8e5016c$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$68aab1d0e8e5016c$exports, "Editor", function() {
    return $b8df73c80b604f74$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0;
});
var $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function i(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function o(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var t;
            e.done ? c(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(i, o);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$ReactEditorJS = (0, $2ba9136349711d35$export$da8ca15f4115b46e)(), $b8df73c80b604f74$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0 = function() {
    var e, t, r, a, c, n = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], i = [], o = $3lE4N.Component, s = [], l = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "core", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), r.set(e, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__runInitializers(e, s, e.props.defaultValue)), Object.defineProperty(e, "save", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__runInitializers(e, l), function() {
                    return $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__awaiter(e, void 0, void 0, function() {
                        var e, t;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(r) {
                            switch(r.label){
                                case 0:
                                    if (!(e = this.core)) return [
                                        3,
                                        2
                                    ];
                                    return t = this, [
                                        4,
                                        this.core.save()
                                    ];
                                case 1:
                                    e = t.innerValue = r.sent(), r.label = 2;
                                case 2:
                                    return [
                                        2,
                                        e
                                    ];
                            }
                        });
                    });
                })
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "innerValue",
                get: function() {
                    return $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.props, r = t.name, a = t.required, c = (t.children, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__rest(t, [
                        "name",
                        "required",
                        "children"
                    ])), n = this.innerValue;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                        className: "form-control",
                        tabIndex: -1,
                        onBlur: this.save,
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
                                hidden: !0,
                                name: r,
                                required: a,
                                value: JSON.stringify(n)
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$68aab1d0e8e5016c$var$ReactEditorJS, Object.assign({}, c, {
                                onInitialize: function(t) {
                                    var r;
                                    e.core = t, null == (r = c.onInitialize) || r.call(c, t);
                                }
                            }))
                        ]
                    });
                }
            }
        ]), t;
    }(o), r = new WeakMap, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__setFunctionName(c, "Editor"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = o[Symbol.metadata]) ? e : null) : void 0, $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__esDecorate(c, null, [
        $cF2Ke.observable
    ], {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "innerValue" in e;
            },
            get: function(e) {
                return e.innerValue;
            },
            set: function(e, t) {
                e.innerValue = t;
            }
        },
        metadata: t
    }, s, l), $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__esDecorate(null, a = {
        value: c
    }, n, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, i), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Editor"
    }), $b8df73c80b604f74$var$$68aab1d0e8e5016c$var$__runInitializers(c, i), c;
}(), $b8df73c80b604f74$var$$db3d9d99c159855a$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$db3d9d99c159855a$exports, "parser", function() {
    return $b8df73c80b604f74$var$$db3d9d99c159855a$export$8f49e4af10703ce3;
}), $b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$db3d9d99c159855a$exports, "EditorHTML", function() {
    return $b8df73c80b604f74$var$$db3d9d99c159855a$export$f9c5335a01b13a5a;
});
var $b8df73c80b604f74$var$$db3d9d99c159855a$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$db3d9d99c159855a$export$8f49e4af10703ce3 = $b8df73c80b604f74$var$$parcel$interopDefault($c6df664a4c0f994d$exports)({
    link: function(e) {
        var t = e.data.link;
        return '<a href="'.concat(t, '">').concat(t, "</a>");
    }
}), $b8df73c80b604f74$var$$db3d9d99c159855a$export$f9c5335a01b13a5a = function(e) {
    var t = e.data, r = $b8df73c80b604f74$var$$db3d9d99c159855a$var$__rest(e, [
        "data"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("article", Object.assign({}, r, {
        dangerouslySetInnerHTML: {
            __html: $b8df73c80b604f74$var$$db3d9d99c159855a$export$8f49e4af10703ce3.parse(t)
        }
    }));
};
$b8df73c80b604f74$var$$db3d9d99c159855a$export$f9c5335a01b13a5a.displayName = "EditorHTML";
var $b8df73c80b604f74$var$$e400f030e8cea549$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$e400f030e8cea549$exports, "HorizontalMarquee", function() {
    return $b8df73c80b604f74$var$$e400f030e8cea549$export$4eb895ecfe5a67d5;
}), $b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$e400f030e8cea549$exports, "HorizontalMarqueeBox", function() {
    return $b8df73c80b604f74$var$$e400f030e8cea549$export$e22877062eb47c32;
}), $b8df73c80b604f74$var$$14c85ffeff1ab241$export$fad3c8302a7540c6 = "_4_3lnG_scrollContainer", $b8df73c80b604f74$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd = "_4_3lnG_scrollHeightWrap", $b8df73c80b604f74$var$$14c85ffeff1ab241$export$1a22ace05a045e3f = "_4_3lnG_scrollItem", $b8df73c80b604f74$var$$14c85ffeff1ab241$export$c7aa240077ad8340 = "_4_3lnG_scrollWrap", $b8df73c80b604f74$var$$14c85ffeff1ab241$export$5add10f2a1e13991 = "_4_3lnG_unScrollItem";
var $b8df73c80b604f74$var$$e400f030e8cea549$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$e400f030e8cea549$export$4eb895ecfe5a67d5 = function(e) {
    var t = e.className, r = e.children, a = e.maxWidth, c = e.duration, n = e.height, i = $b8df73c80b604f74$var$$e400f030e8cea549$var$__rest(e, [
        "className",
        "children",
        "maxWidth",
        "duration",
        "height"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({
        className: "overflow-hidden mw-100 ".concat(void 0 === t ? "" : t)
    }, i, {
        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block align-top text-nowrap ".concat($b8df73c80b604f74$var$$14c85ffeff1ab241$export$c7aa240077ad8340),
            style: {
                maxWidth: void 0 === a ? "100%" : a,
                animationDuration: c,
                height: n,
                lineHeight: n
            },
            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: "d-inline-block ".concat($b8df73c80b604f74$var$$14c85ffeff1ab241$export$1a22ace05a045e3f),
                style: {
                    animationDuration: c
                },
                children: r
            })
        })
    }));
}, $b8df73c80b604f74$var$$e400f030e8cea549$export$e22877062eb47c32 = function(e) {
    var t = e.children, r = e.maxWidth, a = e.duration, c = e.height;
    return c ? (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        className: "overflow-hidden ".concat($b8df73c80b604f74$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd),
        style: {
            maxWidth: r,
            "--scroll-height": c
        },
        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block overflow-hidden mw-100 ".concat($b8df73c80b604f74$var$$14c85ffeff1ab241$export$fad3c8302a7540c6),
            children: [
                (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                    className: "d-block overflow-hidden text-wrap text-break ".concat($b8df73c80b604f74$var$$14c85ffeff1ab241$export$5add10f2a1e13991),
                    children: t
                }),
                (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$e400f030e8cea549$export$4eb895ecfe5a67d5, {
                    duration: a,
                    children: t
                })
            ]
        })
    }) : (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$e400f030e8cea549$export$4eb895ecfe5a67d5, {
        maxWidth: r,
        duration: a,
        height: c,
        children: t
    });
};
$b8df73c80b604f74$var$$e400f030e8cea549$export$4eb895ecfe5a67d5.displayName = "HorizontalMarquee";
var $b8df73c80b604f74$var$$cf5cdc2ffed4bc45$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$cf5cdc2ffed4bc45$exports, "Icon", function() {
    return $b8df73c80b604f74$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f;
});
var $b8df73c80b604f74$var$$cf5cdc2ffed4bc45$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f = function(e) {
    var t = e.className, r = e.style, a = e.name, c = e.size, n = $b8df73c80b604f74$var$$cf5cdc2ffed4bc45$var$__rest(e, [
        "className",
        "style",
        "name",
        "size"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", Object.assign({
        className: $b8df73c80b604f74$var$$parcel$interopDefault($46a03b660b5bd4f2$exports)("bi-".concat(a), t),
        style: Object.assign({
            fontSize: c && "".concat(c, "rem")
        }, r)
    }, n));
};
$b8df73c80b604f74$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f.displayName = "Icon";
var $b8df73c80b604f74$var$$44176234dcaa70a7$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$44176234dcaa70a7$exports, "LiveTSX", function() {
    return $b8df73c80b604f74$var$$44176234dcaa70a7$export$965592ed152e8e7f;
});
var $b8df73c80b604f74$var$$44176234dcaa70a7$export$965592ed152e8e7f = function(e) {
    var t = e.scope, r = e.children, a = (0, $kzd8a.isValidElement)(r) ? r : (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
        children: r
    }), c = "string" == typeof r ? r : $b8df73c80b604f74$var$$parcel$interopDefault($fd3df234846bf672$exports)(a);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($2826e017902e2c4c$export$7f6f1b77ca3c3ed3, {
        code: c,
        scope: t,
        language: "tsx",
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($2826e017902e2c4c$export$ba3ca6901d2e4f5f, {
                className: "mb-3"
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($2826e017902e2c4c$export$f8f60579bb81d0e5, {}),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($2826e017902e2c4c$export$1991b613205b2adc, {
                className: "text-danger small p-2"
            })
        ]
    });
}, $b8df73c80b604f74$var$$1f7252b8d0187295$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$1f7252b8d0187295$exports, "Loading", function() {
    return $b8df73c80b604f74$var$$1f7252b8d0187295$export$669f6ea7d267feaf;
});
var $b8df73c80b604f74$var$$1f7252b8d0187295$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$1f7252b8d0187295$export$669f6ea7d267feaf = function(e) {
    var t = e.className, r = e.children, a = $b8df73c80b604f74$var$$1f7252b8d0187295$var$__rest(e, [
        "className",
        "children"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({
        className: "fixed-top h-100 w-100 d-flex justify-content-center align-items-center opacity-25 bg-black ".concat(void 0 === t ? "" : t)
    }, a, {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($32f816caebe11677$export$2e2bcd8739ae039, {
                animation: "border",
                variant: "success"
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                className: "ml-3 text-white",
                children: void 0 === r ? "Loading..." : r
            })
        ]
    }));
};
$b8df73c80b604f74$var$$1f7252b8d0187295$export$669f6ea7d267feaf.displayName = "Loading";
var $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$exports, "MonthCalendar", function() {
    return $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$export$d7a7c85c0f5afc4a;
});
var $b8df73c80b604f74$var$$a121893c5bead7fc$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$a121893c5bead7fc$exports, "OverlayBox", function() {
    return $b8df73c80b604f74$var$$a121893c5bead7fc$export$5169ff31790bf260;
});
var $b8df73c80b604f74$var$$a121893c5bead7fc$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$a121893c5bead7fc$export$5169ff31790bf260 = function(e) {
    var t = e.title, r = e.detail, a = e.children, c = $b8df73c80b604f74$var$$a121893c5bead7fc$var$__rest(e, [
        "title",
        "detail",
        "children"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($61083e4a4c1c7431$export$2e2bcd8739ae039, Object.assign({}, c, {
        overlay: r ? (0, $833f543b429117ba$export$34b9dba7ce09269b)($caa3bf6f0f8ef133$export$2e2bcd8739ae039, {
            children: [
                (0, $833f543b429117ba$export$34b9dba7ce09269b)($caa3bf6f0f8ef133$export$2e2bcd8739ae039.Header, {
                    children: t
                }),
                (0, $833f543b429117ba$export$34b9dba7ce09269b)($caa3bf6f0f8ef133$export$2e2bcd8739ae039.Body, {
                    children: r
                })
            ]
        }) : (0, $833f543b429117ba$export$34b9dba7ce09269b)($59cf90befc289c47$export$2e2bcd8739ae039, {
            children: t
        }),
        children: a
    }));
};
$b8df73c80b604f74$var$$a121893c5bead7fc$export$5169ff31790bf260.displayName = "OverlayBox";
var $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$export$d7a7c85c0f5afc4a = function() {
    var e, t, r, a, c, n, i, o, s = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], l = [], $ = $97ddcb8d2dacc617$exports.ObservedComponent, u = [], d = [], f = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, ($b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__runInitializers(e, u), $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__runInitializers(e, d, new Date))), Object.defineProperty(e, "renderDate", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__runInitializers(e, f), function(t) {
                    var r = e.observedProps, a = (r.variant, r.value), c = r.onSelect, n = (0, $iob0w.formatDate)(t, "YYYY-MM-DD"), i = null == a ? void 0 : a.filter(function(e) {
                        var t = e.date;
                        return (0, $iob0w.formatDate)(t, "YYYY-MM-DD") === n;
                    });
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                        className: $b8df73c80b604f74$var$$parcel$interopDefault($46a03b660b5bd4f2$exports)({
                            "opacity-50": t.getMonth() !== e.currentDate.getMonth(),
                            "fw-bold": n === (0, $iob0w.formatDate)(new Date, "YYYY-MM-DD")
                        }),
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("time", {
                                className: "d-block",
                                dateTime: t.toJSON(),
                                children: t.getDate()
                            }),
                            null == i ? void 0 : i.map(function(e) {
                                return "object" === (0, $52f9d16dafc91847$export$71511d61b312f219)(e.content) ? e.content : (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$a121893c5bead7fc$export$5169ff31790bf260, {
                                    title: e.content,
                                    children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($877fb262e9f1190e$export$2e2bcd8739ae039, {
                                        as: "a",
                                        className: "d-inline-block text-decoration-none w-100 text-truncate",
                                        bg: $b8df73c80b604f74$var$$924d73683971f901$export$b480d00b75c9ac2d(e.content + "", [
                                            "light"
                                        ]),
                                        href: e.link,
                                        onClick: function() {
                                            return null == c ? void 0 : c(e);
                                        },
                                        children: e.content
                                    })
                                }, e.date + "");
                            })
                        ]
                    }, t + "");
                })
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "weekFormatter",
                get: function() {
                    var e, t = this.observedProps.locale, r = void 0 === t ? null == (e = globalThis.navigator) ? void 0 : e.language : t;
                    return new Intl.DateTimeFormat(r, {
                        weekday: "long"
                    });
                }
            },
            {
                key: "currentDate",
                get: function() {
                    return $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "dateGrid",
                get: function() {
                    var e = new Date(this.currentDate);
                    e.setDate(1), e = new Date(e - e.getDay() * $iob0w.Day);
                    var t = Array.from(Array(42), function(t, r) {
                        return new Date(+e + r * $iob0w.Day);
                    });
                    return (0, $iob0w.splitArray)(t, 7);
                }
            },
            {
                key: "changeMonth",
                value: function(e) {
                    var t, r;
                    this.currentDate = (0, $iob0w.changeMonth)(this.currentDate, e), null == (r = (t = this.props).onChange) || r.call(t, this.currentDate);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.weekFormatter, r = this.currentDate, a = this.dateGrid, c = this.observedProps, n = c.style, i = c.variant, o = void 0 === i ? "primary" : i, s = (c.onChange, c.onSelect, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__rest(c, [
                        "style",
                        "variant",
                        "onChange",
                        "onSelect"
                    ]));
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($71c6da7a2e5aef0a$export$2e2bcd8739ae039, Object.assign({}, s, {
                        style: Object.assign({
                            tableLayout: "fixed"
                        }, n),
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("caption", {
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                    className: "d-flex justify-content-between align-items-center",
                                    children: [
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                            variant: o,
                                            onClick: function() {
                                                return e.changeMonth(-1);
                                            },
                                            children: "<"
                                        }),
                                        (0, $iob0w.formatDate)(r, "YYYY-MM"),
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                            variant: o,
                                            onClick: function() {
                                                return e.changeMonth(1);
                                            },
                                            children: ">"
                                        })
                                    ]
                                })
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("thead", {
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", {
                                    children: a[0].map(function(e, r, a) {
                                        var c = a.length;
                                        return (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                                            className: "bg-".concat(o, " text-white"),
                                            style: {
                                                width: "calc(100% / ".concat(c, ")")
                                            },
                                            children: t.format(e)
                                        }, r);
                                    })
                                })
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("tbody", {
                                children: a.map(function(t) {
                                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", {
                                        children: t.map(e.renderDate)
                                    }, t[0] + "");
                                })
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($), r = new WeakMap, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__setFunctionName(c, "MonthCalendar"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, n = [
        $cF2Ke.computed
    ], i = [
        $cF2Ke.observable
    ], o = [
        $cF2Ke.computed
    ], $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, n, {
        kind: "getter",
        name: "weekFormatter",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "weekFormatter" in e;
            },
            get: function(e) {
                return e.weekFormatter;
            }
        },
        metadata: t
    }, null, u), $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, i, {
        kind: "accessor",
        name: "currentDate",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "currentDate" in e;
            },
            get: function(e) {
                return e.currentDate;
            },
            set: function(e, t) {
                e.currentDate = t;
            }
        },
        metadata: t
    }, d, f), $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, o, {
        kind: "getter",
        name: "dateGrid",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "dateGrid" in e;
            },
            get: function(e) {
                return e.dateGrid;
            }
        },
        metadata: t
    }, null, u), $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__esDecorate(null, a = {
        value: c
    }, s, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "MonthCalendar"
    }), $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$var$__runInitializers(c, l), c;
}(), $b8df73c80b604f74$var$$4f69bf8d62d4bac9$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$4f69bf8d62d4bac9$exports, "Nameplate", function() {
    return $b8df73c80b604f74$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601;
});
var $b8df73c80b604f74$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601 = function(e) {
    var t = e.avatar, r = e.name;
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$757747c0209676cc$export$e2255cf6045e8d47, {
                size: 2,
                style: {
                    marginRight: "0.5rem"
                },
                src: t
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                className: "align-middle",
                children: r
            })
        ]
    });
};
$b8df73c80b604f74$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601.displayName = "Nameplate";
var $b8df73c80b604f74$var$$d78fd73e1713e936$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$d78fd73e1713e936$exports, "PageNav", function() {
    return $b8df73c80b604f74$var$$d78fd73e1713e936$export$f24150b9675a2c65;
});
var $b8df73c80b604f74$var$$d78fd73e1713e936$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$d78fd73e1713e936$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$d78fd73e1713e936$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$d78fd73e1713e936$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$d78fd73e1713e936$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$d78fd73e1713e936$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$d78fd73e1713e936$var$HeadingSelector = Array.from(Array(6), function(e, t) {
    return "h".concat(++t);
}) + "", $b8df73c80b604f74$var$$d78fd73e1713e936$export$f24150b9675a2c65 = function() {
    var e, t, r, a, c, n, i, o, s, l = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], $ = [], u = $3lE4N.Component, d = [], f = [], p = [], b = [], v = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, ($b8df73c80b604f74$var$$d78fd73e1713e936$var$__runInitializers(e, d), $b8df73c80b604f74$var$$d78fd73e1713e936$var$__runInitializers(e, f, []))), a.set(e, ($b8df73c80b604f74$var$$d78fd73e1713e936$var$__runInitializers(e, p), $b8df73c80b604f74$var$$d78fd73e1713e936$var$__runInitializers(e, b, 0))), Object.defineProperty(e, "updateScrollY", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$d78fd73e1713e936$var$__runInitializers(e, v), function() {
                    return e.scrollY = window.scrollY;
                })
            }), Object.defineProperty(e, "scrollTo", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return function() {
                        var r, a;
                        setTimeout(function() {
                            return (0, $iob0w.scrollTo)('[id="'.concat(t.id, '"]'));
                        }), null == (a = (r = e.props).onItemClick) || a.call(r, t);
                    };
                }
            }), Object.defineProperty(e, "renderLink", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.id, a = t.level, c = t.text, n = t.top, i = e.currentActiveId, o = e.props.depth;
                    return a <= (void 0 === o ? 1 / 0 : o) && (0, $833f543b429117ba$export$34b9dba7ce09269b)($f103ad69c50f21fa$export$2e2bcd8739ae039.Item, {
                        style: {
                            textIndent: "".concat(a - 1, "rem")
                        },
                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($f103ad69c50f21fa$export$2e2bcd8739ae039.Link, {
                            href: "#".concat(r),
                            active: i === r,
                            onClick: e.scrollTo({
                                id: r,
                                level: a,
                                text: c,
                                top: n
                            }),
                            children: c
                        })
                    }, r);
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "list",
                get: function() {
                    return $b8df73c80b604f74$var$$d78fd73e1713e936$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$d78fd73e1713e936$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "scrollY",
                get: function() {
                    return $b8df73c80b604f74$var$$d78fd73e1713e936$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$d78fd73e1713e936$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "currentActiveId",
                get: function() {
                    var e, t = this.list, r = this.scrollY, a = t.findIndex(function(e) {
                        return e.top > r;
                    });
                    return null == (e = t[a - 1]) ? void 0 : e.id;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    globalThis.document && (window.addEventListener("scroll", this.updateScrollY), this.list = Array.from(document.querySelectorAll($b8df73c80b604f74$var$$d78fd73e1713e936$var$HeadingSelector), function(e) {
                        e.id || (e.id = (0, $iob0w.uniqueID)());
                        var t = e.id, r = e.tagName, a = e.textContent, c = e.offsetTop;
                        return {
                            id: t,
                            level: +r[1],
                            text: a.trim(),
                            top: c
                        };
                    }));
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    null == (e = globalThis.removeEventListener) || e.call(globalThis, "scroll", this.updateScrollY);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.list, t = this.props, r = t.style, a = t.variant, c = $b8df73c80b604f74$var$$d78fd73e1713e936$var$__rest(t, [
                        "style",
                        "variant"
                    ]);
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($f103ad69c50f21fa$export$2e2bcd8739ae039, Object.assign({}, c, {
                        variant: void 0 === a ? "underline" : a,
                        style: Object.assign({
                            flexDirection: "column"
                        }, r),
                        children: e.map(this.renderLink)
                    }));
                }
            }
        ]), t;
    }(u), r = new WeakMap, a = new WeakMap, $b8df73c80b604f74$var$$d78fd73e1713e936$var$__setFunctionName(n, "PageNav"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = u[Symbol.metadata]) ? e : null) : void 0, i = [
        $cF2Ke.observable
    ], o = [
        $cF2Ke.observable
    ], s = [
        $cF2Ke.computed
    ], $b8df73c80b604f74$var$$d78fd73e1713e936$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "list",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "list" in e;
            },
            get: function(e) {
                return e.list;
            },
            set: function(e, t) {
                e.list = t;
            }
        },
        metadata: t
    }, f, p), $b8df73c80b604f74$var$$d78fd73e1713e936$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "scrollY",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "scrollY" in e;
            },
            get: function(e) {
                return e.scrollY;
            },
            set: function(e, t) {
                e.scrollY = t;
            }
        },
        metadata: t
    }, b, v), $b8df73c80b604f74$var$$d78fd73e1713e936$var$__esDecorate(n, null, s, {
        kind: "getter",
        name: "currentActiveId",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "currentActiveId" in e;
            },
            get: function(e) {
                return e.currentActiveId;
            }
        },
        metadata: t
    }, null, d), $b8df73c80b604f74$var$$d78fd73e1713e936$var$__esDecorate(null, c = {
        value: n
    }, l, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, $), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "PageNav"
    }), $b8df73c80b604f74$var$$d78fd73e1713e936$var$__runInitializers(n, $), n;
}(), $b8df73c80b604f74$var$$ce59ae9613bac5f2$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$ce59ae9613bac5f2$exports, "ScrollNav", function() {
    return $b8df73c80b604f74$var$$ce59ae9613bac5f2$export$c57977d1ebb6ef1d;
}), $b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$70443d1bfecdb242 = "_1MZNfG_scrollButtonLeft", $b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$a025291d1676ce41 = "_1MZNfG_scrollButtonRight", $b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$2585081e06ef4cbf = "_1MZNfG_scrollerInner";
var $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$ce59ae9613bac5f2$export$c57977d1ebb6ef1d = function() {
    var e, t, r, a, c, n, i, o, s, l, $, u, d = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], f = [], p = $3lE4N.Component, b = [], v = [], m = [], h = [], x = [], _ = [], j = [];
    return i = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "scrollerRef", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers(e, b), (0, $3lE4N.createRef)())
            }), r.set(e, $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers(e, v, 0)), a.set(e, ($b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers(e, m), $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers(e, h, 0))), c.set(e, ($b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers(e, x), $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers(e, _, 0))), Object.defineProperty(e, "updateScroll", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers(e, j), function() {
                    var t = e.scrollerRef.current;
                    return t && (e.scrollLeft = t.scrollLeft, e.scrollWidth = t.scrollWidth, e.clientWidth = t.clientWidth), t;
                })
            }), Object.defineProperty(e, "resizeObserver", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), Object.defineProperty(e, "scrollBy", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return function() {
                        var r = e.scrollerRef.current;
                        r && r.scrollBy({
                            left: t * r.clientWidth * .8,
                            behavior: "smooth"
                        });
                    };
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "scrollLeft",
                get: function() {
                    return $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "scrollWidth",
                get: function() {
                    return $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "clientWidth",
                get: function() {
                    return $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__classPrivateFieldGet(this, c, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__classPrivateFieldSet(this, c, e, "f");
                }
            },
            {
                key: "canScrollLeft",
                get: function() {
                    return this.scrollLeft > 0;
                }
            },
            {
                key: "canScrollRight",
                get: function() {
                    return this.scrollLeft + this.clientWidth < this.scrollWidth;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.updateScroll();
                    e && (e.addEventListener("scroll", this.updateScroll), this.resizeObserver = new ResizeObserver(this.updateScroll), this.resizeObserver.observe(e));
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e, t;
                    null == (e = this.resizeObserver) || e.disconnect(), null == (t = this.scrollerRef.current) || t.removeEventListener("scroll", this.updateScroll);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.canScrollLeft, t = this.canScrollRight, r = this.props, a = r.className, c = r.children, n = $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__rest(r, [
                        "className",
                        "children"
                    ]);
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                        className: "position-relative overflow-y-hidden ".concat(void 0 === a ? "" : a),
                        children: [
                            e && (0, $833f543b429117ba$export$34b9dba7ce09269b)("button", {
                                type: "button",
                                className: "position-absolute top-0 bottom-0 start-0 z-1 border-0 px-2 ".concat($b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$70443d1bfecdb242),
                                "aria-label": "Scroll left",
                                onClick: this.scrollBy(-1),
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                                    name: "caret-left-fill"
                                })
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                ref: this.scrollerRef,
                                className: "overflow-x-auto ".concat($b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$2585081e06ef4cbf),
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($f103ad69c50f21fa$export$2e2bcd8739ae039, Object.assign({}, n, {
                                    className: "flex-nowrap",
                                    children: c
                                }))
                            }),
                            t && (0, $833f543b429117ba$export$34b9dba7ce09269b)("button", {
                                type: "button",
                                className: "position-absolute top-0 bottom-0 end-0 z-1 border-0 px-2 ".concat($b8df73c80b604f74$var$$cb8a09c271d9e2a2$export$a025291d1676ce41),
                                "aria-label": "Scroll right",
                                onClick: this.scrollBy(1),
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                                    name: "caret-right-fill"
                                })
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(p), r = new WeakMap, a = new WeakMap, c = new WeakMap, $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__setFunctionName(i, "ScrollNav"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = p[Symbol.metadata]) ? e : null) : void 0, o = [
        $cF2Ke.observable
    ], s = [
        $cF2Ke.observable
    ], l = [
        $cF2Ke.observable
    ], $ = [
        $cF2Ke.computed
    ], u = [
        $cF2Ke.computed
    ], $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, o, {
        kind: "accessor",
        name: "scrollLeft",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "scrollLeft" in e;
            },
            get: function(e) {
                return e.scrollLeft;
            },
            set: function(e, t) {
                e.scrollLeft = t;
            }
        },
        metadata: t
    }, v, m), $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, s, {
        kind: "accessor",
        name: "scrollWidth",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "scrollWidth" in e;
            },
            get: function(e) {
                return e.scrollWidth;
            },
            set: function(e, t) {
                e.scrollWidth = t;
            }
        },
        metadata: t
    }, h, x), $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, l, {
        kind: "accessor",
        name: "clientWidth",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "clientWidth" in e;
            },
            get: function(e) {
                return e.clientWidth;
            },
            set: function(e, t) {
                e.clientWidth = t;
            }
        },
        metadata: t
    }, _, j), $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, $, {
        kind: "getter",
        name: "canScrollLeft",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "canScrollLeft" in e;
            },
            get: function(e) {
                return e.canScrollLeft;
            }
        },
        metadata: t
    }, null, b), $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__esDecorate(i, null, u, {
        kind: "getter",
        name: "canScrollRight",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "canScrollRight" in e;
            },
            get: function(e) {
                return e.canScrollRight;
            }
        },
        metadata: t
    }, null, b), $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__esDecorate(null, n = {
        value: i
    }, d, {
        kind: "class",
        name: i.name,
        metadata: t
    }, null, f), i = n.value, t && Object.defineProperty(i, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(i, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ScrollNav"
    }), $b8df73c80b604f74$var$$ce59ae9613bac5f2$var$__runInitializers(i, f), i;
}(), $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$exports, "Option", function() {
    return $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20;
}), $b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$exports, "Select", function() {
    return $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f;
});
var $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20 = function(e) {
    var t = e.value, r = e.children, a = $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$var$__rest(e, [
        "value",
        "children"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($eaba73858d72bf09$export$2e2bcd8739ae039.Item, Object.assign({}, a, {
        "data-value": t,
        children: r
    }));
};
$b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20.displayName = "Option";
var $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f = function(e) {
    var t = e.className, r = e.style, a = e.variant, c = e.menuVariant, n = e.children, i = e.value, o = e.onChange, s = e.valueRender, l = (0, $iob0w.makeArray)(n).flat(1 / 0).find(function(e) {
        return (0, $kzd8a.isValidElement)(e) && e.type === $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20 && e.props.value === i;
    });
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($eaba73858d72bf09$export$2e2bcd8739ae039, {
        onClick: function(e) {
            var t = e.target.closest(".dropdown-item");
            if (t) {
                var r = t.dataset.value;
                null == o || o(r);
            }
        },
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($eaba73858d72bf09$export$2e2bcd8739ae039.Toggle, {
                className: $b8df73c80b604f74$var$$parcel$interopDefault($46a03b660b5bd4f2$exports)("w-100", "d-flex", "justify-content-between", "align-items-center", !a && "bg-white text-dark", t),
                style: r,
                variant: a,
                children: (null == s ? void 0 : s(i)) || (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                    className: null == l ? void 0 : l.props.className,
                    children: null == l ? void 0 : l.props.children
                })
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($eaba73858d72bf09$export$2e2bcd8739ae039.Menu, {
                variant: c,
                children: n
            })
        ]
    });
};
$b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f.displayName = "Select";
var $b8df73c80b604f74$var$$5c7497f9f3fe6432$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$5c7497f9f3fe6432$exports, "elementToImage", function() {
    return $b8df73c80b604f74$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc;
}), $b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$5c7497f9f3fe6432$exports, "ShareBox", function() {
    return $b8df73c80b604f74$var$$5c7497f9f3fe6432$export$e15a265ebbd5ca8c;
});
var $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function i(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function o(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var t;
            e.done ? c(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(i, o);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
};
function $b8df73c80b604f74$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc(e, t, r) {
    return $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__awaiter(this, void 0, void 0, function() {
        var a;
        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(c) {
            switch(c.label){
                case 0:
                    return [
                        4,
                        $b8df73c80b604f74$var$$parcel$interopDefault($eec13e6b5a0b94b3$exports)(e, {
                            useCORS: !0
                        })
                    ];
                case 1:
                    return a = c.sent(), [
                        2,
                        new Promise(function(e, c) {
                            return a.toBlob(function(t) {
                                return t ? e(URL.createObjectURL(t)) : c();
                            }, t, r);
                        })
                    ];
            }
        });
    });
}
var $b8df73c80b604f74$var$$5c7497f9f3fe6432$export$e15a265ebbd5ca8c = function() {
    var e, t, r, a, c, n, i, o, s = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], l = [], $ = $3lE4N.Component, u = [], d = [], f = [], p = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "root", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $3lE4N.createRef)()
            }), r.set(e, $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__runInitializers(e, u, !1)), a.set(e, ($b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__runInitializers(e, d), $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__runInitializers(e, f, ""))), Object.defineProperty(e, "generateImage", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__runInitializers(e, p), function() {
                    return $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__awaiter(e, void 0, void 0, function() {
                        var e;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.imageURI && (URL.revokeObjectURL(this.imageURI), this.imageURI = ""), this.loading = !0, e = this, [
                                        4,
                                        $b8df73c80b604f74$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc(this.root.current)
                                    ];
                                case 1:
                                    return e.imageURI = t.sent(), this.loading = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                })
            }), Object.defineProperty(e, "share", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__awaiter(e, void 0, void 0, function() {
                        var e, r, a;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(c) {
                            switch(c.label){
                                case 0:
                                    return t.stopPropagation(), [
                                        4,
                                        (0, $iob0w.blobOf)(this.imageURI)
                                    ];
                                case 1:
                                    return a = new File([
                                        r = c.sent()
                                    ], "".concat(this.props.title, ".png"), {
                                        type: r.type
                                    }), [
                                        4,
                                        null == (e = navigator.share) ? void 0 : e.call(navigator, Object.assign({
                                            files: [
                                                a
                                            ]
                                        }, this.props))
                                    ];
                                case 2:
                                    return c.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "loading",
                get: function() {
                    return $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "imageURI",
                get: function() {
                    return $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e;
                    null == (e = globalThis.addEventListener) || e.call(globalThis, "resize", this.generateImage);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    null == (e = globalThis.removeEventListener) || e.call(globalThis, "resize", this.generateImage);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.className, r = e.children, a = $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__rest(e, [
                        "className",
                        "children"
                    ]), c = this.loading, n = this.imageURI;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
                        children: [
                            c && (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$1f7252b8d0187295$export$669f6ea7d267feaf, {}),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({}, a, {
                                ref: this.root,
                                className: "position-relative ".concat(void 0 === t ? "" : t),
                                onMouseEnter: n ? void 0 : this.generateImage,
                                onTouchStart: n ? void 0 : this.generateImage,
                                children: [
                                    r,
                                    n && (0, $833f543b429117ba$export$34b9dba7ce09269b)($6061a0f906a555ad$export$2e2bcd8739ae039, {
                                        className: "position-absolute start-0 top-0 w-100 h-100",
                                        src: n,
                                        alt: "Share Image",
                                        fluid: !0,
                                        onClick: this.share
                                    })
                                ]
                            }))
                        ]
                    });
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__setFunctionName(n, "ShareBox"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, i = [
        $cF2Ke.observable
    ], o = [
        $cF2Ke.observable
    ], $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "loading",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "loading" in e;
            },
            get: function(e) {
                return e.loading;
            },
            set: function(e, t) {
                e.loading = t;
            }
        },
        metadata: t
    }, u, d), $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "imageURI",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "imageURI" in e;
            },
            get: function(e) {
                return e.imageURI;
            },
            set: function(e, t) {
                e.imageURI = t;
            }
        },
        metadata: t
    }, f, p), $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__esDecorate(null, c = {
        value: n
    }, s, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, l), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ShareBox"
    }), $b8df73c80b604f74$var$$5c7497f9f3fe6432$var$__runInitializers(n, l), n;
}(), $b8df73c80b604f74$var$$ad4a2cea628613d5$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$ad4a2cea628613d5$exports, "SpinnerButton", function() {
    return $b8df73c80b604f74$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb;
});
var $b8df73c80b604f74$var$$ad4a2cea628613d5$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb = function(e) {
    var t = e.animation, r = e.loading, a = e.disabled, c = e.children, n = $b8df73c80b604f74$var$$ad4a2cea628613d5$var$__rest(e, [
        "animation",
        "loading",
        "disabled",
        "children"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, Object.assign({}, n, {
        disabled: r || a,
        children: [
            r && (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
                children: [
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($32f816caebe11677$export$2e2bcd8739ae039, {
                        as: "span",
                        className: c ? "me-2" : "",
                        size: "sm",
                        animation: t,
                        role: "status",
                        "aria-hidden": "true"
                    }),
                    !c && (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                ]
            }),
            c
        ]
    }));
};
$b8df73c80b604f74$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb.displayName = "SpinnerButton";
var $b8df73c80b604f74$var$$53fa7c21606566cb$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$53fa7c21606566cb$exports, "TableSpinner", function() {
    return $b8df73c80b604f74$var$$53fa7c21606566cb$export$4706ba151aa92b7e;
});
var $b8df73c80b604f74$var$$53fa7c21606566cb$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$53fa7c21606566cb$export$4706ba151aa92b7e = function(e) {
    var t = e.animation, r = e.variant, a = e.size, c = e.colSpan, n = $b8df73c80b604f74$var$$53fa7c21606566cb$var$__rest(e, [
        "animation",
        "variant",
        "size",
        "colSpan"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", Object.assign({}, n, {
        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
            className: "text-center p-4",
            colSpan: c,
            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($32f816caebe11677$export$2e2bcd8739ae039, {
                animation: void 0 === t ? "border" : t,
                variant: void 0 === r ? "primary" : r,
                size: a
            })
        })
    }));
};
$b8df73c80b604f74$var$$53fa7c21606566cb$export$4706ba151aa92b7e.displayName = "TableSpinner";
var $b8df73c80b604f74$var$$295b3641db3d8c33$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$295b3641db3d8c33$exports, "TextTruncate", function() {
    return $b8df73c80b604f74$var$$295b3641db3d8c33$export$ee6221c372f955f;
});
var $b8df73c80b604f74$var$$295b3641db3d8c33$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$295b3641db3d8c33$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$295b3641db3d8c33$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$295b3641db3d8c33$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$295b3641db3d8c33$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$295b3641db3d8c33$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$295b3641db3d8c33$export$ee6221c372f955f = function() {
    var e, t, r, a, c, n, i, o, s = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], l = [], $ = $3lE4N.Component, u = [], d = [], f = [], p = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, $b8df73c80b604f74$var$$295b3641db3d8c33$var$__runInitializers(e, u, !1)), a.set(e, ($b8df73c80b604f74$var$$295b3641db3d8c33$var$__runInitializers(e, d), $b8df73c80b604f74$var$$295b3641db3d8c33$var$__runInitializers(e, f, !1))), Object.defineProperty(e, "contentRef", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$295b3641db3d8c33$var$__runInitializers(e, p), (0, $3lE4N.createRef)())
            }), Object.defineProperty(e, "checkOverflow", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    var t = e.contentRef.current;
                    t && (e.overflowed = t.scrollHeight > t.clientHeight);
                }
            }), Object.defineProperty(e, "toggle", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    e.expanded = !e.expanded, e.expanded || requestAnimationFrame(e.checkOverflow);
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "expanded",
                get: function() {
                    return $b8df73c80b604f74$var$$295b3641db3d8c33$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$295b3641db3d8c33$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "overflowed",
                get: function() {
                    return $b8df73c80b604f74$var$$295b3641db3d8c33$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$295b3641db3d8c33$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    this.checkOverflow(), window.addEventListener("resize", this.checkOverflow);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    var t = e.rows, r = e.children;
                    this.expanded || r === this.props.children && t === this.props.rows || this.checkOverflow();
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    window.removeEventListener("resize", this.checkOverflow);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.children, r = e.rows, a = e.expandText, c = e.collapseText, n = $b8df73c80b604f74$var$$295b3641db3d8c33$var$__rest(e, [
                        "children",
                        "rows",
                        "expandText",
                        "collapseText"
                    ]), i = this.expanded, o = this.overflowed;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({}, n, {
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("p", {
                                ref: this.contentRef,
                                style: i ? void 0 : {
                                    overflow: "hidden",
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: void 0 === r ? 3 : r
                                },
                                children: t
                            }),
                            (o || i) && (0, $833f543b429117ba$export$34b9dba7ce09269b)("button", {
                                type: "button",
                                className: "bg-transparent border-0 p-0",
                                "aria-expanded": i,
                                onClick: this.toggle,
                                children: i ? void 0 === c ? "\u23EB" : c : void 0 === a ? "\u23EC" : a
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $b8df73c80b604f74$var$$295b3641db3d8c33$var$__setFunctionName(n, "TextTruncate"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, i = [
        $cF2Ke.observable
    ], o = [
        $cF2Ke.observable
    ], $b8df73c80b604f74$var$$295b3641db3d8c33$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "expanded",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "expanded" in e;
            },
            get: function(e) {
                return e.expanded;
            },
            set: function(e, t) {
                e.expanded = t;
            }
        },
        metadata: t
    }, u, d), $b8df73c80b604f74$var$$295b3641db3d8c33$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "overflowed",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "overflowed" in e;
            },
            get: function(e) {
                return e.overflowed;
            },
            set: function(e, t) {
                e.overflowed = t;
            }
        },
        metadata: t
    }, f, p), $b8df73c80b604f74$var$$295b3641db3d8c33$var$__esDecorate(null, c = {
        value: n
    }, s, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, l), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "TextTruncate"
    }), $b8df73c80b604f74$var$$295b3641db3d8c33$var$__runInitializers(n, l), n;
}(), $b8df73c80b604f74$var$$03c0468daff9422a$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$03c0468daff9422a$exports, "Time", function() {
    return $b8df73c80b604f74$var$$03c0468daff9422a$export$680ea196effce5f;
});
var $b8df73c80b604f74$var$$03c0468daff9422a$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$03c0468daff9422a$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$03c0468daff9422a$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$03c0468daff9422a$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$03c0468daff9422a$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$03c0468daff9422a$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$03c0468daff9422a$export$680ea196effce5f = function() {
    var e, t, r, a, c, n, i, o = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], s = [], l = $97ddcb8d2dacc617$exports.ObservedComponent, $ = [], u = [], d = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, ($b8df73c80b604f74$var$$03c0468daff9422a$var$__runInitializers(e, $), $b8df73c80b604f74$var$$03c0468daff9422a$var$__runInitializers(e, u, e.updateText()))), $b8df73c80b604f74$var$$03c0468daff9422a$var$__runInitializers(e, d), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "updateText",
                value: function() {
                    var e = this.props, t = e.dateTime, r = e.format;
                    return (0, $iob0w.formatDate)(t, r);
                }
            },
            {
                key: "timeText",
                get: function() {
                    return $b8df73c80b604f74$var$$03c0468daff9422a$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$03c0468daff9422a$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.timeText = this.updateText();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.dateTime, r = $b8df73c80b604f74$var$$03c0468daff9422a$var$__rest(e, [
                        "dateTime"
                    ]);
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("time", Object.assign({
                        dateTime: new Date(t).toJSON()
                    }, r, {
                        children: this.timeText
                    }));
                }
            }
        ]), t;
    }(l), r = new WeakMap, $b8df73c80b604f74$var$$03c0468daff9422a$var$__setFunctionName(c, "Time"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = l[Symbol.metadata]) ? e : null) : void 0, n = [
        (0, $97ddcb8d2dacc617$exports.reaction)(function(e) {
            var t = e.observedProps;
            return t.dateTime + t.format;
        })
    ], i = [
        $cF2Ke.observable
    ], $b8df73c80b604f74$var$$03c0468daff9422a$var$__esDecorate(c, null, n, {
        kind: "method",
        name: "updateText",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "updateText" in e;
            },
            get: function(e) {
                return e.updateText;
            }
        },
        metadata: t
    }, null, $), $b8df73c80b604f74$var$$03c0468daff9422a$var$__esDecorate(c, null, i, {
        kind: "accessor",
        name: "timeText",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "timeText" in e;
            },
            get: function(e) {
                return e.timeText;
            },
            set: function(e, t) {
                e.timeText = t;
            }
        },
        metadata: t
    }, u, d), $b8df73c80b604f74$var$$03c0468daff9422a$var$__esDecorate(null, a = {
        value: c
    }, o, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, s), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Time"
    }), $b8df73c80b604f74$var$$03c0468daff9422a$var$__runInitializers(c, s), c;
}(), $b8df73c80b604f74$var$$2f5f9093a9aac8ee$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$2f5f9093a9aac8ee$exports, "TimeDistance", function() {
    return $b8df73c80b604f74$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969;
});
var $b8df73c80b604f74$var$$2f5f9093a9aac8ee$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$2f5f9093a9aac8ee$var$UnitWords = {
    ms: "millisecond(s)",
    s: "second(s)",
    m: "minute(s)",
    H: "hour(s)",
    D: "day(s)",
    W: "week(s)",
    M: "month(s)",
    Y: "year(s)"
}, $b8df73c80b604f74$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969 = function(e) {
    var t = e.date, r = e.unitWords, a = e.beforeWord, c = e.afterWord, n = $b8df73c80b604f74$var$$2f5f9093a9aac8ee$var$__rest(e, [
        "date",
        "unitWords",
        "beforeWord",
        "afterWord"
    ]);
    t = new Date(t);
    var i = (0, $iob0w.diffTime)(t), o = i.distance, s = i.unit;
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("time", Object.assign({}, n, {
        dateTime: t.toJSON(),
        title: t.toLocaleString(),
        children: [
            Math.abs(o),
            " ",
            (void 0 === r ? $b8df73c80b604f74$var$$2f5f9093a9aac8ee$var$UnitWords : r)[s],
            o < 0 ? void 0 === a ? " before" : a : void 0 === c ? " after" : c
        ]
    }));
};
$b8df73c80b604f74$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969.displayName = "TimeDistance";
var $b8df73c80b604f74$var$$31b55198d5058ded$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$31b55198d5058ded$exports, "Timeline", function() {
    return $b8df73c80b604f74$var$$31b55198d5058ded$export$e6a97ba2cae5bb94;
}), $b8df73c80b604f74$var$$4bfbcb67a3daf664$export$79ffe56a765070d2 = "TOztta_right", $b8df73c80b604f74$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461 = "TOztta_timeline", $b8df73c80b604f74$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7 = "TOztta_timelineItem";
var $b8df73c80b604f74$var$$31b55198d5058ded$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$31b55198d5058ded$export$e6a97ba2cae5bb94 = function(e) {
    var t = e.className, r = e.events, a = e.timeFormat, c = $b8df73c80b604f74$var$$31b55198d5058ded$var$__rest(e, [
        "className",
        "events",
        "timeFormat"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("ol", Object.assign({
        className: "list-unstyled ".concat($b8df73c80b604f74$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461, " ").concat(t)
    }, c, {
        children: r.map(function(e) {
            var t = e.title, r = e.summary, c = e.time, n = e.link, i = e.people;
            return (0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
                className: "position-relative ".concat($b8df73c80b604f74$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7, " ").concat($b8df73c80b604f74$var$$4bfbcb67a3daf664$export$79ffe56a765070d2),
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($95b0e632403c19f5$export$2e2bcd8739ae039, {
                    children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($95b0e632403c19f5$export$2e2bcd8739ae039.Body, {
                        className: "p-4 d-flex flex-column gap-3 align-items-center",
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("h3", {
                                className: "h5 m-0",
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                                    className: "text-decoration-none stretched-link",
                                    href: n,
                                    children: t
                                })
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                className: "small text-muted d-flex gap-2",
                                children: [
                                    "\u23F2\uFE0F",
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$03c0468daff9422a$export$680ea196effce5f, {
                                        dateTime: c[0],
                                        format: a
                                    }),
                                    c[1] && "~",
                                    c[1] && (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$03c0468daff9422a$export$680ea196effce5f, {
                                        dateTime: c[1],
                                        format: a
                                    })
                                ]
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("ul", {
                                className: "list-unstyled m-0 d-flex gap-2 flex-wrap justify-content-around",
                                children: null == i ? void 0 : i.map(function(e) {
                                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
                                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601, Object.assign({}, e))
                                    }, e.name);
                                })
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("p", {
                                className: "m-0",
                                children: r
                            })
                        ]
                    })
                })
            }, t);
        })
    }));
};
$b8df73c80b604f74$var$$31b55198d5058ded$export$e6a97ba2cae5bb94.displayName = "Timeline";
var $b8df73c80b604f74$var$$27e13b1ac3fbb57c$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$27e13b1ac3fbb57c$exports, "Toast", function() {
    return $b8df73c80b604f74$var$$27e13b1ac3fbb57c$export$8d8dc7d5f743331b;
});
var $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$LIGHT_TEXT_VARIANTS = new Set([
    "warning",
    "info",
    "light"
]), $b8df73c80b604f74$var$$27e13b1ac3fbb57c$export$8d8dc7d5f743331b = function() {
    var e, t, r, a = [], c = [];
    return t = function() {
        "use strict";
        function e() {
            var t = this, n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $iob0w.Timestamp;
            (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, e), Object.defineProperty(this, "TimeScalar", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: n
            }), r.set(this, $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__runInitializers(this, a, [])), Object.defineProperty(this, "Component", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__runInitializers(this, c), (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(function(e) {
                    var r = e.position;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($6ff9bd29c9865658$export$2e2bcd8739ae039, {
                        position: void 0 === r ? "top-end" : r,
                        className: "position-fixed p-3",
                        children: t.messages.map(t.renderMessage)
                    });
                }))
            }), Object.defineProperty(this, "renderMessage", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(e) {
                    var r = e.id, a = e.openedAt, c = e.title, n = e.body, i = e.variant, o = e.delay, s = void 0 === o ? 3e3 : o, l = i && !$b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$LIGHT_TEXT_VARIANTS.has(i) ? "text-white" : void 0, $ = t.TimeScalar.distanceOf(Date.now(), a).toShortString();
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($598ec01b79b05a61$export$2e2bcd8739ae039, {
                        bg: i,
                        delay: s,
                        autohide: 0 !== s,
                        onClose: function() {
                            return t.close(r);
                        },
                        children: [
                            (!!c || 0 === s) && (0, $833f543b429117ba$export$34b9dba7ce09269b)($598ec01b79b05a61$export$2e2bcd8739ae039.Header, {
                                children: [
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("strong", {
                                        className: "me-auto",
                                        children: c
                                    }),
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("small", {
                                        children: $
                                    })
                                ]
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)($598ec01b79b05a61$export$2e2bcd8739ae039.Body, {
                                className: l,
                                children: n
                            })
                        ]
                    }, r);
                }
            }), this.Component.displayName = "ToastComponent";
        }
        return (0, $30088f375ab7517b$export$71511d61b312f219)(e, [
            {
                key: "messages",
                get: function() {
                    return $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "open",
                value: function(e) {
                    var t = (0, $iob0w.uniqueID)(), r = Date.now(), a = Promise.withResolvers(), c = a.promise, n = a.resolve;
                    return this.messages = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(this.messages).concat([
                        Object.assign(Object.assign({
                            id: t
                        }, e), {
                            openedAt: r,
                            resolve: n
                        })
                    ]), c;
                }
            },
            {
                key: "close",
                value: function(e) {
                    var t = this.messages.find(function(t) {
                        return t.id === e;
                    }) || {}, r = t.resolve, a = $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__rest(t, [
                        "resolve"
                    ]);
                    null == r || r(Object.assign(Object.assign({}, a), {
                        closedAt: Date.now()
                    })), this.messages = this.messages.filter(function(t) {
                        return t.id !== e;
                    });
                }
            }
        ]), e;
    }(), r = new WeakMap, e = "function" == typeof Symbol && Symbol.metadata ? Object.create(null) : void 0, $b8df73c80b604f74$var$$27e13b1ac3fbb57c$var$__esDecorate(t, null, [
        $cF2Ke.observable
    ], {
        kind: "accessor",
        name: "messages",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "messages" in e;
            },
            get: function(e) {
                return e.messages;
            },
            set: function(e, t) {
                e.messages = t;
            }
        },
        metadata: e
    }, a, c), e && Object.defineProperty(t, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }), t;
}(), $b8df73c80b604f74$var$$f4c02b33c4295ca8$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$f4c02b33c4295ca8$exports, "TypeEcho", function() {
    return $b8df73c80b604f74$var$$f4c02b33c4295ca8$export$2fe61c915a9818e6;
});
var $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__esDecorate = function(e, t, r, a, c, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var o, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (o = i(v.get)) && (u.get = o), (o = i(v.set)) && (u.set = o), (o = i(v.init)) && c.unshift(o);
        } else (o = i(v)) && ("field" === s ? c.unshift(o) : u[l] = o);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function i(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function o(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var t;
            e.done ? c(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(i, o);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$f4c02b33c4295ca8$export$2fe61c915a9818e6 = function() {
    var e, t, r, a, c, n = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], i = [], o = $3lE4N.Component, s = [], l = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__runInitializers(e, s, "")), Object.defineProperty(e, "init", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__runInitializers(e, l), function(t) {
                    return t && new IntersectionObserver(function(t, r) {
                        return $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__awaiter(e, [
                            t,
                            r
                        ], void 0, function(e, t) {
                            var r, a, c, n, i, o, s, l, $, u, d;
                            return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(f) {
                                switch(f.label){
                                    case 0:
                                        if (!(0, $a8a036b4881ec134$export$71511d61b312f219)(e, 1)[0].isIntersecting) return [
                                            2
                                        ];
                                        t.disconnect(), a = (r = this.props).text, n = void 0 === (c = r.intervals) ? 150 : c, i = !0, o = !1, s = void 0, f.label = 1;
                                    case 1:
                                        f.trys.push([
                                            1,
                                            6,
                                            7,
                                            8
                                        ]), l = a[Symbol.iterator](), f.label = 2;
                                    case 2:
                                        if (i = ($ = l.next()).done) return [
                                            3,
                                            5
                                        ];
                                        return u = $.value, [
                                            4,
                                            (0, $iob0w.sleep)(n / 1e3)
                                        ];
                                    case 3:
                                        f.sent(), this.echoed += u, f.label = 4;
                                    case 4:
                                        return i = !0, [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 6:
                                        return d = f.sent(), o = !0, s = d, [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        try {
                                            i || null == l.return || l.return();
                                        } finally{
                                            if (o) throw s;
                                        }
                                        return [
                                            7
                                        ];
                                    case 8:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }).observe(t);
                })
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "echoed",
                get: function() {
                    return $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.className, r = e.text, a = $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__rest(e, [
                        "className",
                        "text"
                    ]), c = this.echoed;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("pre", Object.assign({}, a, {
                        ref: this.init,
                        className: $b8df73c80b604f74$var$$parcel$interopDefault($46a03b660b5bd4f2$exports)("text-wrap", t),
                        children: c + (c === r ? "" : "_")
                    }));
                }
            }
        ]), t;
    }(o), r = new WeakMap, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__setFunctionName(c, "TypeEcho"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = o[Symbol.metadata]) ? e : null) : void 0, $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__esDecorate(c, null, [
        $cF2Ke.observable
    ], {
        kind: "accessor",
        name: "echoed",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "echoed" in e;
            },
            get: function(e) {
                return e.echoed;
            },
            set: function(e, t) {
                e.echoed = t;
            }
        },
        metadata: t
    }, s, l), $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__esDecorate(null, a = {
        value: c
    }, n, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, i), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "TypeEcho"
    }), $b8df73c80b604f74$var$$f4c02b33c4295ca8$var$__runInitializers(c, i), c;
}(), $b8df73c80b604f74$var$$77dc12b8e0b9d622$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$77dc12b8e0b9d622$exports, "UserRankView", function() {
    return $b8df73c80b604f74$var$$77dc12b8e0b9d622$export$4ed039229ec81818;
});
var $b8df73c80b604f74$var$$c5da9bad1903a67d$export$5f821f795e2d2901 = function(e) {
    var t = e.email, r = e.website;
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("address", {
        className: "mb-0 d-flex justify-content-around gap-2",
        children: [
            t && (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: "mailto:" + t,
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                    name: "envelope"
                })
            }),
            r && (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: r,
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                    name: "globe2"
                })
            })
        ]
    });
};
$b8df73c80b604f74$var$$7d37db9df1578ff2$export$5c452ff88e35e47d = "WavURG_image", $b8df73c80b604f74$var$$7d37db9df1578ff2$export$30d389775d7a0f3c = "WavURG_medal", $b8df73c80b604f74$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6 = "WavURG_name", $b8df73c80b604f74$var$$7d37db9df1578ff2$export$896c314ae37c4db9 = "WavURG_rankBox", $b8df73c80b604f74$var$$7d37db9df1578ff2$export$717db1a952ac2d26 = "WavURG_restUsers", $b8df73c80b604f74$var$$7d37db9df1578ff2$export$74fdf2685172213b = "WavURG_suspension", $b8df73c80b604f74$var$$7d37db9df1578ff2$export$fb184b623420d9be = "WavURG_title", $b8df73c80b604f74$var$$7d37db9df1578ff2$export$ec176431609ba4c9 = "WavURG_topUser", $b8df73c80b604f74$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b = "WavURG_topUsers";
var $b8df73c80b604f74$var$$77dc12b8e0b9d622$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$77dc12b8e0b9d622$export$4ed039229ec81818 = function(e) {
    "use strict";
    function t() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "renderMedal", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                var r, a;
                return (0, $833f543b429117ba$export$34b9dba7ce09269b)($ca4e55525ae20d35$export$2e2bcd8739ae039, {
                    as: "li",
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                            className: "shadow-lg overflow-hidden rounded-circle m-auto ".concat($b8df73c80b604f74$var$$7d37db9df1578ff2$export$5c452ff88e35e47d),
                            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($6061a0f906a555ad$export$2e2bcd8739ae039, {
                                src: t.avatar,
                                alt: t.name,
                                loading: "lazy",
                                fluid: !0
                            })
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                            className: "position-relative overflow-hidden ".concat($b8df73c80b604f74$var$$7d37db9df1578ff2$export$ec176431609ba4c9),
                            children: [
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                    className: "position-relative",
                                    children: [
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("i", {
                                            className: "d-block overflow-hidden m-auto mb-1 rounded-circle"
                                        }),
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                                            className: "d-block mb-0 stretched-link",
                                            href: (null == (a = (r = e.props).linkOf) ? void 0 : a.call(r, t)) || "#",
                                            children: t.name
                                        }),
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("strong", {
                                            children: t.score
                                        })
                                    ]
                                }),
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$c5da9bad1903a67d$export$5f821f795e2d2901, Object.assign({}, t))
                            ]
                        })
                    ]
                }, t.id);
            }
        }), Object.defineProperty(e, "renderRow", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t, r, a) {
                var c, n, i = a.length;
                return (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", {
                    className: "position-relative",
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($877fb262e9f1190e$export$2e2bcd8739ae039, {
                                className: "fw-bold fst-italic",
                                children: (r + 4 + "").padStart((i + "").length, "0")
                            })
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                            className: "position-relative mw-50 text-truncate ".concat($b8df73c80b604f74$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6),
                            children: [
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                    className: "d-inline-block overflow-hidden align-middle rounded-circle ".concat($b8df73c80b604f74$var$$7d37db9df1578ff2$export$5c452ff88e35e47d),
                                    children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($6061a0f906a555ad$export$2e2bcd8739ae039, {
                                        src: t.avatar,
                                        alt: t.name,
                                        loading: "lazy",
                                        fluid: !0
                                    })
                                }),
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                                    className: "ms-2 d-inline-block align-middle stretched-link",
                                    style: {
                                        color: "rgb(248, ".concat((r + 2) * 15, ", ").concat((r + 2) * 35, ")")
                                    },
                                    href: (null == (n = (c = e.props).linkOf) ? void 0 : n.call(c, t)) || "#",
                                    children: t.name
                                })
                            ]
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: t.score
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                            className: "align-middle",
                            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($b8df73c80b604f74$var$$c5da9bad1903a67d$export$5f821f795e2d2901, Object.assign({}, t))
                        })
                    ]
                }, t.id);
            }
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
        {
            key: "render",
            value: function() {
                var e = this.props, t = e.className, r = e.title, a = e.rank, c = void 0 === a ? [] : a, n = (e.linkOf, $b8df73c80b604f74$var$$77dc12b8e0b9d622$var$__rest(e, [
                    "className",
                    "title",
                    "rank",
                    "linkOf"
                ]));
                return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3337fdcef7a6ae36$export$2e2bcd8739ae039, Object.assign({
                    className: "".concat($b8df73c80b604f74$var$$7d37db9df1578ff2$export$896c314ae37c4db9, " ").concat(void 0 === t ? "" : t)
                }, n, {
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)($ca4e55525ae20d35$export$2e2bcd8739ae039, {
                            sm: 12,
                            xs: 12,
                            lg: 7,
                            children: [
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                    className: "shadow rounded-3 ".concat($b8df73c80b604f74$var$$7d37db9df1578ff2$export$fb184b623420d9be),
                                    children: [
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                            className: $b8df73c80b604f74$var$$7d37db9df1578ff2$export$30d389775d7a0f3c,
                                            children: [
                                                (0, $833f543b429117ba$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                }),
                                                (0, $833f543b429117ba$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                }),
                                                (0, $833f543b429117ba$export$34b9dba7ce09269b)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                })
                                            ]
                                        }),
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("h3", {
                                            "data-text": r,
                                            className: "position-relative m-auto mb-0 fw-bold text-center",
                                            children: r
                                        })
                                    ]
                                }),
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)($3337fdcef7a6ae36$export$2e2bcd8739ae039, {
                                    as: "ul",
                                    className: "mt-2 g-0 align-items-end text-center ps-0 pt-2 list-unstyled ".concat($b8df73c80b604f74$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b),
                                    children: c.slice(0, 3).map(this.renderMedal)
                                })
                            ]
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)($ca4e55525ae20d35$export$2e2bcd8739ae039, {
                            xs: 12,
                            sm: 12,
                            lg: 5,
                            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($71c6da7a2e5aef0a$export$2e2bcd8739ae039, {
                                className: "my-3 pt-2 ".concat($b8df73c80b604f74$var$$7d37db9df1578ff2$export$717db1a952ac2d26),
                                responsive: !0,
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("tbody", {
                                    children: c.slice(3, 10).map(this.renderRow)
                                })
                            })
                        })
                    ]
                }));
            }
        }
    ]), t;
}($kzd8a.PureComponent);
Object.defineProperty($b8df73c80b604f74$var$$77dc12b8e0b9d622$export$4ed039229ec81818, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "UserRankView"
});
var $b8df73c80b604f74$var$$42613c749094b4e3$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$42613c749094b4e3$exports, "VerticalMarquee", function() {
    return $b8df73c80b604f74$var$$42613c749094b4e3$export$125576d08e40b98f;
}), $b8df73c80b604f74$var$$c628d4ba96623bb8$export$1a22ace05a045e3f = "QSMqAq_scrollItem", $b8df73c80b604f74$var$$c628d4ba96623bb8$export$c7aa240077ad8340 = "QSMqAq_scrollWrap";
var $b8df73c80b604f74$var$$42613c749094b4e3$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$42613c749094b4e3$export$125576d08e40b98f = function(e) {
    var t = e.className, r = e.children, a = e.duration, c = $b8df73c80b604f74$var$$42613c749094b4e3$var$__rest(e, [
        "className",
        "children",
        "duration"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({
        className: "overflow-hidden ".concat(void 0 === t ? "" : t)
    }, c, {
        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            className: "d-inline-block mw-100 mh-100 ".concat($b8df73c80b604f74$var$$c628d4ba96623bb8$export$c7aa240077ad8340),
            style: {
                "--duration": a
            },
            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: "d-inline-block ".concat($b8df73c80b604f74$var$$c628d4ba96623bb8$export$1a22ace05a045e3f),
                children: r
            })
        })
    }));
};
$b8df73c80b604f74$var$$42613c749094b4e3$export$125576d08e40b98f.displayName = "VerticalMarquee";
var $b8df73c80b604f74$var$$228d0ac8aef325ed$exports = {};
$b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$228d0ac8aef325ed$exports, "ZodiacSigns", function() {
    return $b8df73c80b604f74$var$$228d0ac8aef325ed$export$c0efdd35897a499c;
}), $b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$228d0ac8aef325ed$exports, "zodiacOf", function() {
    return $b8df73c80b604f74$var$$228d0ac8aef325ed$export$1ace452aebce17cb;
}), $b8df73c80b604f74$var$$parcel$export($b8df73c80b604f74$var$$228d0ac8aef325ed$exports, "ZodiacBar", function() {
    return $b8df73c80b604f74$var$$228d0ac8aef325ed$export$de26cde43ba4c348;
});
var $b8df73c80b604f74$var$$228d0ac8aef325ed$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $b8df73c80b604f74$var$$228d0ac8aef325ed$export$c0efdd35897a499c = [
    "\uD83D\uDC35",
    "\uD83D\uDC14",
    "\uD83D\uDC36",
    "\uD83D\uDC37",
    "\uD83D\uDC2D",
    "\uD83D\uDC2E",
    "\uD83D\uDC2F",
    "\uD83D\uDC30",
    "\uD83D\uDC32",
    "\uD83D\uDC0D",
    "\uD83D\uDC34",
    "\uD83D\uDC10"
], $b8df73c80b604f74$var$$228d0ac8aef325ed$export$1ace452aebce17cb = function(e) {
    return $b8df73c80b604f74$var$$228d0ac8aef325ed$export$c0efdd35897a499c[((e < 0 ? e + 1 : e) % 12 + 12) % 12];
}, $b8df73c80b604f74$var$$228d0ac8aef325ed$export$de26cde43ba4c348 = function(e) {
    var t = e.className, r = e.itemClassName, a = void 0 === r ? "border rounded px-4 py-3 d-flex flex-column justify-content-center align-items-center" : r, c = e.startYear, n = e.endYear, i = void 0 === n ? new Date().getFullYear() : n, o = e.itemOf, s = $b8df73c80b604f74$var$$228d0ac8aef325ed$var$__rest(e, [
        "className",
        "itemClassName",
        "startYear",
        "endYear",
        "itemOf"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("ol", Object.assign({
        className: "list-unstyled m-0 d-flex flex-wrap justify-content-center gap-3 ".concat(void 0 === t ? "" : t)
    }, s, {
        children: Array.from({
            length: i - c + 1
        }, function(e, t) {
            var r = i - t;
            if (0 === r) return null;
            var c = $b8df73c80b604f74$var$$228d0ac8aef325ed$export$1ace452aebce17cb(r), n = (null == o ? void 0 : o(r, c)) || {}, s = n.link, l = n.title;
            return (0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
                className: a,
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                    className: "d-inline-block p-3 text-decoration-none text-center",
                    href: void 0 === s ? "#" : s,
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                            className: "fs-1",
                            children: c
                        }),
                        l
                    ]
                })
            }, r);
        })
    }));
};
$b8df73c80b604f74$var$$228d0ac8aef325ed$export$de26cde43ba4c348.displayName = "ZodiacBar", $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$fd019656019bb4f3$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$757747c0209676cc$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$a40a1c3d6dc84a7a$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$89fa9a64cf869995$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$924d73683971f901$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$9dab2fd0b4033192$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$e308f4ff6755d29b$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$68aab1d0e8e5016c$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$db3d9d99c159855a$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$e400f030e8cea549$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$cf5cdc2ffed4bc45$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$44176234dcaa70a7$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$1f7252b8d0187295$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$ec6e3ccd45c7b7c0$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$4f69bf8d62d4bac9$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$a121893c5bead7fc$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$d78fd73e1713e936$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$ce59ae9613bac5f2$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$5d0c8d8af5c3c7e5$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$5c7497f9f3fe6432$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$ad4a2cea628613d5$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$53fa7c21606566cb$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$295b3641db3d8c33$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$03c0468daff9422a$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$2f5f9093a9aac8ee$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$31b55198d5058ded$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$27e13b1ac3fbb57c$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$f4c02b33c4295ca8$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$77dc12b8e0b9d622$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$42613c749094b4e3$exports), $b8df73c80b604f74$var$$parcel$exportWildcard($b8df73c80b604f74$exports, $b8df73c80b604f74$var$$228d0ac8aef325ed$exports); //# sourceMappingURL=index.js.map





var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");




var $kzd8a = parcelRequire("kzd8a");


"use client";
const $53f4ac4d53fcde99$var$NavbarBrand = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix)
    });
});
$53f4ac4d53fcde99$var$NavbarBrand.displayName = 'NavbarBrand';
var $53f4ac4d53fcde99$export$2e2bcd8739ae039 = $53f4ac4d53fcde99$var$NavbarBrand;



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $357a62bb1232c0f1$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $357a62bb1232c0f1$export$2e2bcd8739ae039 = $357a62bb1232c0f1$var$createChainedFunction;





const $9b1fc8607eb76e48$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $9b1fc8607eb76e48$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $9b1fc8607eb76e48$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $9b1fc8607eb76e48$var$collapseStyles = {
    [(0, $8fbdf14957a5f265$export$84cbff306f539230)]: 'collapse',
    [(0, $8fbdf14957a5f265$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $8fbdf14957a5f265$export$df38205c966be359)]: 'collapsing',
    [(0, $8fbdf14957a5f265$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $9b1fc8607eb76e48$var$Collapse = /*#__PURE__*/ (0, $kzd8a.default).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $9b1fc8607eb76e48$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $jmWak.useMemo)(()=>(0, $357a62bb1232c0f1$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $jmWak.useMemo)(()=>(0, $357a62bb1232c0f1$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $jmWak.useMemo)(()=>(0, $357a62bb1232c0f1$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $jmWak.useMemo)(()=>(0, $357a62bb1232c0f1$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $25028194e22c049f$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $jmWak.useMemo)(()=>(0, $357a62bb1232c0f1$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $e56a76b3d61aacf5$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $a6a537e724a25cd3$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $b77d92dd97828230$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, $kzd8a.default).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, children.props.className, $9b1fc8607eb76e48$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$9b1fc8607eb76e48$var$Collapse.displayName = 'Collapse';
var $9b1fc8607eb76e48$export$2e2bcd8739ae039 = $9b1fc8607eb76e48$var$Collapse;





"use client";
const $82b483c8b726ccd1$var$NavbarCollapse = /*#__PURE__*/ $kzd8a.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $jmWak.useContext)((0, $e00fc39f9e2ca031$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $9b1fc8607eb76e48$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$82b483c8b726ccd1$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $82b483c8b726ccd1$export$2e2bcd8739ae039 = $82b483c8b726ccd1$var$NavbarCollapse;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");




"use client";
const $32ba307cb63f538e$var$NavbarToggle = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $jmWak.useContext)((0, $e00fc39f9e2ca031$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$32ba307cb63f538e$var$NavbarToggle.displayName = 'NavbarToggle';
var $32ba307cb63f538e$export$2e2bcd8739ae039 = $32ba307cb63f538e$var$NavbarToggle;



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
const $13c926dd71fd4184$var$matchersByWindow = new WeakMap();
const $13c926dd71fd4184$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $13c926dd71fd4184$var$matchersByWindow.get(targetWindow) || new Map();
    $13c926dd71fd4184$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $13c926dd71fd4184$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $13c926dd71fd4184$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $jmWak.useState)(()=>mql ? mql.matches : false);
    (0, $706e9d3c9d2a9e53$export$2e2bcd8739ae039)(()=>{
        let mql = $13c926dd71fd4184$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $13c926dd71fd4184$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $a766e8ca1f153918$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $jmWak.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $13c926dd71fd4184$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $a766e8ca1f153918$var$useBreakpoint = $a766e8ca1f153918$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $a766e8ca1f153918$export$2e2bcd8739ae039 = $a766e8ca1f153918$var$useBreakpoint;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

function $6efacf96f2f861d9$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}






var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");

var $kzd8a = parcelRequire("kzd8a");

parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $eb9ef40168d7b1c7$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $jmWak.useRef)(value);
    valueRef.current = value;
    return valueRef;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $8b2730f2d57ef4a5$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $eb9ef40168d7b1c7$export$2e2bcd8739ae039)(fn);
    (0, $jmWak.useEffect)(()=>()=>onUnmount.current(), []);
}






/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $9de93e5c1f627e5f$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $1dc2847f5876484d$export$1a88c12b8b979fa0 = (0, $7ab87372f8393f88$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $1dc2847f5876484d$var$ModalManager {
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
    getScrollbarWidth() {
        return (0, $9de93e5c1f627e5f$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($1dc2847f5876484d$export$1a88c12b8b979fa0, '');
        (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($1dc2847f5876484d$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
}
var $1dc2847f5876484d$export$2e2bcd8739ae039 = $1dc2847f5876484d$var$ModalManager;







var $3lE4N = parcelRequire("3lE4N");
const $fe27af560ebec39d$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $fe27af560ebec39d$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $fe27af560ebec39d$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $fe27af560ebec39d$var$getManager(window) {
    if (!$fe27af560ebec39d$var$manager) $fe27af560ebec39d$var$manager = new (0, $1dc2847f5876484d$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $fe27af560ebec39d$var$manager;
}
function $fe27af560ebec39d$var$useModalManager(provided) {
    const window = (0, $d1e03f98782c825e$export$2e2bcd8739ae039)();
    const modalManager = provided || $fe27af560ebec39d$var$getManager(window);
    const modal = (0, $jmWak.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $jmWak.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $jmWak.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $fe27af560ebec39d$var$Modal = /*#__PURE__*/ (0, $kzd8a.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $fe27af560ebec39d$var$_objectWithoutPropertiesLoose(_ref, $fe27af560ebec39d$var$_excluded);
    const ownerWindow = (0, $d1e03f98782c825e$export$2e2bcd8739ae039)();
    const container = (0, $4aed94df0fa027d2$export$2e2bcd8739ae039)(containerRef);
    const modal = $fe27af560ebec39d$var$useModalManager(providedManager);
    const isMounted = (0, $c0f31806b1391f8e$export$2e2bcd8739ae039)();
    const prevShow = (0, $8009ad784162cfb1$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $jmWak.useState)(!show);
    const lastFocusRef = (0, $jmWak.useRef)(null);
    (0, $jmWak.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $53e6d5b016eb161e$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $c19f71e61aa90e5d$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $jmWak.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $jmWak.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $8b2730f2d57ef4a5$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $6efacf96f2f861d9$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $321b0569c1d3b241$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $0f6b648eaf3ae889$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $b77d92dd97828230$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $jmWak.useRef)();
    const removeKeydownListenerRef = (0, $jmWak.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $kzd8a.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $de13092707d80aed$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $de13092707d80aed$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
        children: /*#__PURE__*/ (0, $kzd8a.default).createPortal(/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$fe27af560ebec39d$var$Modal.displayName = 'Modal';
var $fe27af560ebec39d$export$2e2bcd8739ae039 = Object.assign($fe27af560ebec39d$var$Modal, {
    Manager: (0, $1dc2847f5876484d$export$2e2bcd8739ae039)
});




var $kzd8a = parcelRequire("kzd8a");



"use client";
const $7af2bf7e127dffbb$var$OffcanvasBody = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$7af2bf7e127dffbb$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $7af2bf7e127dffbb$export$2e2bcd8739ae039 = $7af2bf7e127dffbb$var$OffcanvasBody;




var $kzd8a = parcelRequire("kzd8a");






"use client";
const $6f41158dee17c0e4$var$transitionStyles = {
    [(0, $8fbdf14957a5f265$export$df38205c966be359)]: 'show',
    [(0, $8fbdf14957a5f265$export$78e9e6e3e014d60a)]: 'show'
};
const $6f41158dee17c0e4$var$OffcanvasToggling = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $e56a76b3d61aacf5$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $a6a537e724a25cd3$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $b77d92dd97828230$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $kzd8a.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, children.props.className, (status === (0, $8fbdf14957a5f265$export$df38205c966be359) || status === (0, $8fbdf14957a5f265$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $6f41158dee17c0e4$var$transitionStyles[status])
            })
    });
});
$6f41158dee17c0e4$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $6f41158dee17c0e4$export$2e2bcd8739ae039 = $6f41158dee17c0e4$var$OffcanvasToggling;


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
"use client";
const $95d2c97ad9caa734$var$ModalContext = /*#__PURE__*/ $3lE4N.createContext({
    onHide () {}
});
var $95d2c97ad9caa734$export$2e2bcd8739ae039 = $95d2c97ad9caa734$var$ModalContext;




var $kzd8a = parcelRequire("kzd8a");


var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");




"use client";
const $ae30e06286dea93c$var$AbstractModalHeader = /*#__PURE__*/ $kzd8a.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $jmWak.useContext)((0, $95d2c97ad9caa734$export$2e2bcd8739ae039));
    const handleClick = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $0406b4accb6865c0$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$ae30e06286dea93c$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $ae30e06286dea93c$export$2e2bcd8739ae039 = $ae30e06286dea93c$var$AbstractModalHeader;



"use client";
const $13f0584e3d6f81b1$var$OffcanvasHeader = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ae30e06286dea93c$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$13f0584e3d6f81b1$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $13f0584e3d6f81b1$export$2e2bcd8739ae039 = $13f0584e3d6f81b1$var$OffcanvasHeader;



var $kzd8a = parcelRequire("kzd8a");




"use client";
const $9b48fee957aa3e8d$var$DivStyledAsH5 = (0, $f36469d8e9627b22$export$2e2bcd8739ae039)('h5');
const $9b48fee957aa3e8d$var$OffcanvasTitle = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $9b48fee957aa3e8d$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$9b48fee957aa3e8d$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $9b48fee957aa3e8d$export$2e2bcd8739ae039 = $9b48fee957aa3e8d$var$OffcanvasTitle;




function $abf72811607b651f$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $720e403436e1555a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}




function $37a47d2269fc3066$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $37a47d2269fc3066$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $37a47d2269fc3066$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $37a47d2269fc3066$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $6e5209f3a28bd586$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $6e5209f3a28bd586$var$BootstrapModalManager extends (0, $1dc2847f5876484d$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $6a01e84b1d47be46$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $abf72811607b651f$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $6e5209f3a28bd586$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $6e5209f3a28bd586$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $6e5209f3a28bd586$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $37a47d2269fc3066$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $6e5209f3a28bd586$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $6e5209f3a28bd586$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $0a134cba80b47542$export$2e2bcd8739ae039)(container, $6e5209f3a28bd586$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $6e5209f3a28bd586$var$sharedManager;
function $6e5209f3a28bd586$export$a03641438014b436(options) {
    if (!$6e5209f3a28bd586$var$sharedManager) $6e5209f3a28bd586$var$sharedManager = new $6e5209f3a28bd586$var$BootstrapModalManager(options);
    return $6e5209f3a28bd586$var$sharedManager;
}
var $6e5209f3a28bd586$export$2e2bcd8739ae039 = $6e5209f3a28bd586$var$BootstrapModalManager;



var $3lE4N = parcelRequire("3lE4N");
"use client";
function $6203fac9d5313531$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6f41158dee17c0e4$export$2e2bcd8739ae039), {
        ...props
    });
}
function $6203fac9d5313531$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $9c83adfb94811f58$export$2e2bcd8739ae039), {
        ...props
    });
}
const $6203fac9d5313531$var$Offcanvas = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $jmWak.useRef)();
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $jmWak.useState)(false);
    const handleHide = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $a766e8ca1f153918$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $jmWak.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $jmWak.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $6e5209f3a28bd586$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $6e5209f3a28bd586$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $jmWak.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95d2c97ad9caa734$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $fe27af560ebec39d$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $6203fac9d5313531$var$DialogTransition,
                    backdropTransition: $6203fac9d5313531$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$6203fac9d5313531$var$Offcanvas.displayName = 'Offcanvas';
var $6203fac9d5313531$export$2e2bcd8739ae039 = Object.assign($6203fac9d5313531$var$Offcanvas, {
    Body: (0, $7af2bf7e127dffbb$export$2e2bcd8739ae039),
    Header: (0, $13f0584e3d6f81b1$export$2e2bcd8739ae039),
    Title: (0, $9b48fee957aa3e8d$export$2e2bcd8739ae039)
});




"use client";
const $ef790a814a28c2c6$var$NavbarOffcanvas = /*#__PURE__*/ $kzd8a.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $jmWak.useContext)((0, $e00fc39f9e2ca031$export$2e2bcd8739ae039));
    const handleHide = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6203fac9d5313531$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$ef790a814a28c2c6$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $ef790a814a28c2c6$export$2e2bcd8739ae039 = $ef790a814a28c2c6$var$NavbarOffcanvas;





var $kzd8a = parcelRequire("kzd8a");



"use client";
const $65f3a3815d2944f3$var$NavbarText = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$65f3a3815d2944f3$var$NavbarText.displayName = 'NavbarText';
var $65f3a3815d2944f3$export$2e2bcd8739ae039 = $65f3a3815d2944f3$var$NavbarText;



"use client";
const $78ba6c7ac2efa658$var$Navbar = /*#__PURE__*/ $kzd8a.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $dbe139f5a1e72daf$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $jmWak.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $jmWak.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $e00fc39f9e2ca031$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $bc7b7daa54233ac1$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$78ba6c7ac2efa658$var$Navbar.displayName = 'Navbar';
var $78ba6c7ac2efa658$export$2e2bcd8739ae039 = Object.assign($78ba6c7ac2efa658$var$Navbar, {
    Brand: (0, $53f4ac4d53fcde99$export$2e2bcd8739ae039),
    Collapse: (0, $82b483c8b726ccd1$export$2e2bcd8739ae039),
    Offcanvas: (0, $ef790a814a28c2c6$export$2e2bcd8739ae039),
    Text: (0, $65f3a3815d2944f3$export$2e2bcd8739ae039),
    Toggle: (0, $32ba307cb63f538e$export$2e2bcd8739ae039)
});



var $cF2Ke = parcelRequire("cF2Ke");

var $iob0w = parcelRequire("iob0w");
function $85ae22ec5ab7b0e8$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$exports = {};
$85ae22ec5ab7b0e8$var$$parcel$export($85ae22ec5ab7b0e8$var$$c6af500b4433b08b$exports, "SpeechSynthesisState", function() {
    return $85ae22ec5ab7b0e8$export$bf098d6e10b5582a;
});
$85ae22ec5ab7b0e8$var$$parcel$export($85ae22ec5ab7b0e8$var$$c6af500b4433b08b$exports, "SpeechSynthesisModel", function() {
    return $85ae22ec5ab7b0e8$export$6c5d58455f3ab236;
});
var $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $85ae22ec5ab7b0e8$export$bf098d6e10b5582a;
(function(SpeechSynthesisState) {
    SpeechSynthesisState[SpeechSynthesisState["Clear"] = 0] = "Clear";
    SpeechSynthesisState[SpeechSynthesisState["Speaking"] = 1] = "Speaking";
    SpeechSynthesisState[SpeechSynthesisState["Pause"] = 2] = "Pause";
})($85ae22ec5ab7b0e8$export$bf098d6e10b5582a || ($85ae22ec5ab7b0e8$export$bf098d6e10b5582a = {}));
let $85ae22ec5ab7b0e8$export$6c5d58455f3ab236 = (()=>{
    var _a, _SpeechSynthesisModel_disposer, _SpeechSynthesisModel_state_accessor_storage;
    let _instanceExtraInitializers = [];
    let _state_decorators;
    let _state_initializers = [];
    let _state_extraInitializers = [];
    let _get_language_decorators;
    return _a = class SpeechSynthesisModel {
        get state() {
            return $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_state_accessor_storage, "f");
        }
        set state(value) {
            $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_state_accessor_storage, value, "f");
        }
        get language() {
            var _b, _c;
            return ((_b = this.i18n) === null || _b === void 0 ? void 0 : _b.currentLanguage) || ((_c = globalThis.navigator) === null || _c === void 0 ? void 0 : _c.language);
        }
        constructor(i18n){
            Object.defineProperty(this, "i18n", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__runInitializers(this, _instanceExtraInitializers), i18n)
            });
            _SpeechSynthesisModel_state_accessor_storage.set(this, $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__runInitializers(this, _state_initializers, $85ae22ec5ab7b0e8$export$bf098d6e10b5582a.Clear));
            _SpeechSynthesisModel_disposer.set(this, $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__runInitializers(this, _state_extraInitializers));
            Object.defineProperty(this, "clear", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ()=>{
                    var _b;
                    this.state = $85ae22ec5ab7b0e8$export$bf098d6e10b5582a.Clear;
                    (_b = $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__classPrivateFieldGet(this, _SpeechSynthesisModel_disposer, "f")) === null || _b === void 0 || _b.call(this);
                    speechSynthesis.cancel();
                }
            });
            if (i18n) $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__classPrivateFieldSet(this, _SpeechSynthesisModel_disposer, (0, $cF2Ke.reaction)(()=>i18n.currentLanguage, this.clear), "f");
            globalThis.addEventListener('unload', this.clear);
        }
        static getVoices() {
            const voices = speechSynthesis.getVoices();
            return voices[0] ? Promise.resolve(voices) : new Promise((resolve)=>{
                (0, $iob0w.sleep)(1).then(()=>resolve([]));
                speechSynthesis.onvoiceschanged = ()=>resolve(speechSynthesis.getVoices());
            });
        }
        speak(text) {
            return $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__awaiter(this, void 0, void 0, function*() {
                const { language: language } = this, content = new SpeechSynthesisUtterance(text), voices = yield _a.getVoices();
                content.voice = voices.find(({ localService: localService, lang: lang })=>localService && lang === language) || voices.find(({ default: backup })=>backup);
                const result = new Promise((resolve, reject)=>{
                    content.onend = resolve;
                    content.onerror = reject;
                });
                speechSynthesis.speak(content);
                this.state = $85ae22ec5ab7b0e8$export$bf098d6e10b5582a.Speaking;
                try {
                    yield result;
                } finally{
                    this.clear();
                }
            });
        }
        toggle() {
            if (this.state === $85ae22ec5ab7b0e8$export$bf098d6e10b5582a.Speaking) {
                speechSynthesis.pause();
                this.state = $85ae22ec5ab7b0e8$export$bf098d6e10b5582a.Pause;
            } else {
                speechSynthesis.resume();
                this.state = $85ae22ec5ab7b0e8$export$bf098d6e10b5582a.Speaking;
            }
        }
        static *walk(range) {
            const { commonAncestorContainer: commonAncestorContainer, endContainer: endContainer } = range;
            const walker = document.createNodeIterator(commonAncestorContainer);
            var current;
            while(current = walker.nextNode()){
                if (range.intersectsNode(current)) yield current;
                if (commonAncestorContainer !== endContainer && current === endContainer) break;
            }
        }
        static getSelectedText(box) {
            var _b;
            const range = (_b = getSelection()) === null || _b === void 0 ? void 0 : _b.getRangeAt(0);
            if (!(range === null || range === void 0 ? void 0 : range.toString()) || !(box === null || box === void 0 ? void 0 : box.contains(range.commonAncestorContainer))) throw new RangeError('No text selected');
            return [
                ...this.walk(range)
            ].filter(({ nodeType: nodeType, parentNode: parentNode })=>{
                if (nodeType !== 3) return;
                const { width: width, height: height } = parentNode.getBoundingClientRect();
                return width && height;
            }).map(({ nodeValue: nodeValue }, index, { length: length })=>nodeValue.slice(index === 0 ? range.startOffset : 0, index === length - 1 ? range.endOffset : Infinity)).filter((text)=>text.trim()).join('').trim();
        }
        static getReadableText(box) {
            try {
                return this.getSelectedText(box);
            } catch (_b) {
                return (0, $iob0w.getVisibleText)(box);
            }
        }
    }, _SpeechSynthesisModel_disposer = new WeakMap(), _SpeechSynthesisModel_state_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _state_decorators = [
            (0, $cF2Ke.observable)
        ];
        _get_language_decorators = [
            (0, $cF2Ke.computed)
        ];
        $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _state_decorators, {
            kind: "accessor",
            name: "state",
            static: false,
            private: false,
            access: {
                has: (obj)=>"state" in obj,
                get: (obj)=>obj.state,
                set: (obj, value)=>{
                    obj.state = value;
                }
            },
            metadata: _metadata
        }, _state_initializers, _state_extraInitializers);
        $85ae22ec5ab7b0e8$var$$c6af500b4433b08b$var$__esDecorate(_a, null, _get_language_decorators, {
            kind: "getter",
            name: "language",
            static: false,
            private: false,
            access: {
                has: (obj)=>"language" in obj,
                get: (obj)=>obj.language
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$exports = {};
$85ae22ec5ab7b0e8$var$$parcel$export($85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$exports, "TranslationModel", function() {
    return $85ae22ec5ab7b0e8$export$d91823dfc159395b;
});
$85ae22ec5ab7b0e8$var$$parcel$export($85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$exports, "loadLanguageMap", function() {
    return $85ae22ec5ab7b0e8$export$745e12634107cb52;
});
$85ae22ec5ab7b0e8$var$$parcel$export($85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$exports, "loadLanguageMapFrom", function() {
    return $85ae22ec5ab7b0e8$export$b9f85f5ba933b8e7;
});
var $85ae22ec5ab7b0e8$var$$552a56cc5ff3f479$exports = {};
$85ae22ec5ab7b0e8$var$$parcel$export($85ae22ec5ab7b0e8$var$$552a56cc5ff3f479$exports, "isNumberLetter", function() {
    return $85ae22ec5ab7b0e8$export$df0b442c7f8df5c1;
});
$85ae22ec5ab7b0e8$var$$parcel$export($85ae22ec5ab7b0e8$var$$552a56cc5ff3f479$exports, "textJoin", function() {
    return $85ae22ec5ab7b0e8$export$d977f7cd0cb45fe1;
});
$85ae22ec5ab7b0e8$var$$parcel$export($85ae22ec5ab7b0e8$var$$552a56cc5ff3f479$exports, "parseLanguageHeader", function() {
    return $85ae22ec5ab7b0e8$export$2557e81a557a81ea;
});
const $85ae22ec5ab7b0e8$export$df0b442c7f8df5c1 = (raw = '')=>new RegExp('\\p{N}', 'u').test(raw) || new RegExp('\\p{Ll}', 'u').test(raw.toLowerCase());
const $85ae22ec5ab7b0e8$export$d977f7cd0cb45fe1 = (...parts)=>parts.map((raw, index)=>{
        var _a;
        const isNL = $85ae22ec5ab7b0e8$export$df0b442c7f8df5c1(raw.slice(-1));
        if (index + 1 === parts.length) return raw;
        const diff = isNL !== $85ae22ec5ab7b0e8$export$df0b442c7f8df5c1((_a = parts[index + 1]) === null || _a === void 0 ? void 0 : _a.trim()[0]);
        return raw + (diff || isNL ? ' ' : '');
    }).join('');
const $85ae22ec5ab7b0e8$export$2557e81a557a81ea = (value)=>value.split(',').map((language)=>{
        const [name, quantity = ''] = language.split(';');
        const [_, value = '1'] = quantity.split('=');
        return [
            name.trim(),
            +value
        ];
    }).sort(([_, a], [__, b])=>b - a).map(([name])=>name);
var $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $85ae22ec5ab7b0e8$export$d91823dfc159395b = (()=>{
    var _a, _TranslationModel_loading_accessor_storage, _TranslationModel_currentLanguage_accessor_storage, _TranslationModel_currentMap_accessor_storage;
    let _instanceExtraInitializers = [];
    let _loading_decorators;
    let _loading_initializers = [];
    let _loading_extraInitializers = [];
    let _currentLanguage_decorators;
    let _currentLanguage_initializers = [];
    let _currentLanguage_extraInitializers = [];
    let _currentMap_decorators;
    let _currentMap_initializers = [];
    let _currentMap_extraInitializers = [];
    let _get_defaultMap_decorators;
    let _loadLanguages_decorators;
    return _a = class TranslationModel {
        get loading() {
            return $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_loading_accessor_storage, "f");
        }
        set loading(value) {
            $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_loading_accessor_storage, value, "f");
        }
        get currentLanguage() {
            return $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentLanguage_accessor_storage, "f");
        }
        set currentLanguage(value) {
            $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentLanguage_accessor_storage, value, "f");
        }
        get currentMap() {
            return $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__classPrivateFieldGet(this, _TranslationModel_currentMap_accessor_storage, "f");
        }
        set currentMap(value) {
            $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__classPrivateFieldSet(this, _TranslationModel_currentMap_accessor_storage, value, "f");
        }
        get defaultMap() {
            return this.configuration[this.defaultLanguage];
        }
        constructor(configuration){
            Object.defineProperty(this, "configuration", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _instanceExtraInitializers), configuration)
            });
            _TranslationModel_loading_accessor_storage.set(this, $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_initializers, false));
            Object.defineProperty(this, "defaultLanguage", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _loading_extraInitializers)
            });
            _TranslationModel_currentLanguage_accessor_storage.set(this, $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_initializers, ''));
            _TranslationModel_currentMap_accessor_storage.set(this, ($85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentLanguage_extraInitializers), $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_initializers, {})));
            Object.defineProperty(this, "t", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__runInitializers(this, _currentMap_extraInitializers), this.textOf.bind(this))
            });
            for(const name in configuration)if (typeof configuration[name] !== 'function') this.defaultLanguage = name;
            if (!this.defaultLanguage) throw ReferenceError('One static language map is required');
            if (!globalThis.window) return;
            const languages = [
                (0, $iob0w.parseCookie)().language,
                ...navigator.languages || [
                    this.defaultLanguage
                ],
                document.documentElement.lang
            ].filter(Boolean);
            this.loadLanguages(...languages);
            window.addEventListener('languagechange', ()=>this.loadLanguages(navigator.language));
        }
        onLanguageChange(handler) {
            (0, $cF2Ke.reaction)(()=>this.currentLanguage, (currentLanguage, lastLanguage)=>{
                if (lastLanguage) handler.call(this, currentLanguage);
            });
        }
        setLanguage(name) {
            var _b;
            this.currentLanguage = name;
            if ((_b = globalThis.document) === null || _b === void 0 ? void 0 : _b.documentElement) (0, $iob0w.setCookie)('language', document.documentElement.lang = name, {
                path: '/'
            });
        }
        loadLanguages(...names) {
            return $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__awaiter(this, void 0, void 0, function*() {
                this.loading = true;
                const { language: language = this.defaultLanguage, languageMap: languageMap = this.configuration[this.defaultLanguage] } = (yield $85ae22ec5ab7b0e8$export$745e12634107cb52(this.configuration, names)) || {};
                this.loading = false;
                this.setLanguage(language);
                return this.currentMap = languageMap;
            });
        }
        textOf(key, data) {
            const value = this.currentMap[key] || this.defaultMap[key];
            if (typeof value !== 'function') return value;
            if (!data) throw ReferenceError('Input data is required for Translation Resolver');
            return value(data);
        }
    }, _TranslationModel_loading_accessor_storage = new WeakMap(), _TranslationModel_currentLanguage_accessor_storage = new WeakMap(), _TranslationModel_currentMap_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _loading_decorators = [
            (0, $cF2Ke.observable)
        ];
        _currentLanguage_decorators = [
            (0, $cF2Ke.observable)
        ];
        _currentMap_decorators = [
            (0, $cF2Ke.observable)
        ];
        _get_defaultMap_decorators = [
            (0, $cF2Ke.computed)
        ];
        _loadLanguages_decorators = [
            (0, $cF2Ke.action)
        ];
        $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loading_decorators, {
            kind: "accessor",
            name: "loading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loading" in obj,
                get: (obj)=>obj.loading,
                set: (obj, value)=>{
                    obj.loading = value;
                }
            },
            metadata: _metadata
        }, _loading_initializers, _loading_extraInitializers);
        $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentLanguage_decorators, {
            kind: "accessor",
            name: "currentLanguage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentLanguage" in obj,
                get: (obj)=>obj.currentLanguage,
                set: (obj, value)=>{
                    obj.currentLanguage = value;
                }
            },
            metadata: _metadata
        }, _currentLanguage_initializers, _currentLanguage_extraInitializers);
        $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _currentMap_decorators, {
            kind: "accessor",
            name: "currentMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentMap" in obj,
                get: (obj)=>obj.currentMap,
                set: (obj, value)=>{
                    obj.currentMap = value;
                }
            },
            metadata: _metadata
        }, _currentMap_initializers, _currentMap_extraInitializers);
        $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _get_defaultMap_decorators, {
            kind: "getter",
            name: "defaultMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"defaultMap" in obj,
                get: (obj)=>obj.defaultMap
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__esDecorate(_a, null, _loadLanguages_decorators, {
            kind: "method",
            name: "loadLanguages",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadLanguages" in obj,
                get: (obj)=>obj.loadLanguages
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
const $85ae22ec5ab7b0e8$export$745e12634107cb52 = (configuration, names)=>$85ae22ec5ab7b0e8$var$$d1a4b21e19b1b67c$var$__awaiter(void 0, void 0, void 0, function*() {
        const languages = Object.keys(configuration).sort(({ length: a }, { length: b })=>b - a);
        for (const name of names){
            const language = languages.includes(name) ? name : languages.find((language)=>name.startsWith(language) || language.startsWith(name));
            if (!language) continue;
            try {
                const languageMap = configuration[language];
                if (typeof languageMap !== 'function') return {
                    language: language,
                    languageMap: languageMap
                };
                const { default: data } = yield languageMap();
                configuration[language] = data;
                return {
                    language: language,
                    languageMap: data
                };
            } catch (_a) {}
        }
    });
const $85ae22ec5ab7b0e8$export$b9f85f5ba933b8e7 = (configuration, { 'accept-language': acceptLanguage, cookie: cookie })=>{
    const { language: language } = (0, $iob0w.parseCookie)(cookie || ''), languages = $85ae22ec5ab7b0e8$export$2557e81a557a81ea(acceptLanguage || '');
    return $85ae22ec5ab7b0e8$export$745e12634107cb52(configuration, [
        language,
        ...languages
    ].filter(Boolean));
};


var $0aee7432c9e4f521$export$2e2bcd8739ae039 = {
    welcome: "\u6B22\u8FCE",
    upstream_projects: "\u4E0A\u6E38\u9879\u76EE",
    home_page: "\u4E3B\u9875",
    source_code: "\u6E90\u4EE3\u7801",
    component: "\u7EC4\u4EF6",
    pagination: "\u5206\u9875",
    chart: "\u56FE\u8868",
    downloader: "\u4E0B\u8F7D\u5668",
    powered_by: "\u5F3A\u529B\u9A71\u52A8\u81EA",
    documentation: "\u6587\u6863",
    learn: "\u5B66\u4E60",
    examples: "\u793A\u4F8B",
    deploy: "\u90E8\u7F72",
    // REST table
    create: "\u65B0\u589E",
    submit: "\u63D0\u4EA4",
    cancel: "\u53D6\u6D88",
    edit: "\u7F16\u8F91",
    delete: "\u5220\u9664",
    total_x_rows: ({ totalCount: totalCount })=>`\u{5171} ${totalCount} \u{884C}`,
    sure_to_delete_x: ({ keys: keys })=>`\u{60A8}\u{786E}\u{5B9A}\u{5220}\u{9664} ${keys.join("\u3001")} \u{5417}\u{FF1F}`,
    repository_name: "\u4ED3\u5E93\u540D",
    programming_language: "\u7F16\u7A0B\u8BED\u8A00",
    topic: "\u8BDD\u9898",
    star_count: "\u661F\u6807\u6570",
    // Scroll List
    scroll_list: "\u6EDA\u52A8\u5217\u8868",
    load_more: "\u52A0\u8F7D\u66F4\u591A\u2026\u2026",
    no_more: "\u6CA1\u6709\u66F4\u591A"
};




const $cdcfc036668a4ffd$export$a7357cdd1f0b0168 = new (0, $85ae22ec5ab7b0e8$export$d91823dfc159395b)({
    'zh-CN': (0, $0aee7432c9e4f521$export$2e2bcd8739ae039),
    'zh-TW': ()=>(parcelRequire("2jKnB")),
    'en-US': ()=>(parcelRequire("pwgmx"))
});
const $cdcfc036668a4ffd$export$4b3850bcaaad82f1 = {
    'zh-CN': "\u7B80\u4F53\u4E2D\u6587",
    'zh-TW': "\u7E41\u9AD4\u4E2D\u6587",
    'en-US': 'English'
};


const { t: $a3f4ff3ffbf2acb3$var$t } = (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168);
const $a3f4ff3ffbf2acb3$export$3baea55415cc8bd1 = ()=>[
        {
            href: '#/',
            title: $a3f4ff3ffbf2acb3$var$t('home_page')
        },
        {
            href: '#/component',
            title: $a3f4ff3ffbf2acb3$var$t('component')
        },
        {
            href: '#/pagination',
            title: $a3f4ff3ffbf2acb3$var$t('pagination')
        },
        {
            href: '#/scroll-list',
            title: $a3f4ff3ffbf2acb3$var$t('scroll_list')
        },
        {
            href: '#/chart',
            title: $a3f4ff3ffbf2acb3$var$t('chart')
        },
        {
            href: '#/downloader',
            title: $a3f4ff3ffbf2acb3$var$t('downloader')
        },
        {
            href: 'https://github.com/idea2app/React-MobX-Bootstrap-ts',
            title: $a3f4ff3ffbf2acb3$var$t('source_code')
        }
    ];



var $7eb6f6c751b65708$export$db3c28d99448dcff;
$7eb6f6c751b65708$export$db3c28d99448dcff = `MgokeW_logo`;


const $5c7d45190b2b9254$export$8b543871300e74c2 = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(()=>{
    const { currentLanguage: currentLanguage } = (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $78ba6c7ac2efa658$export$2e2bcd8739ae039), {
        style: {
            zIndex: 1030
        },
        bg: "primary",
        variant: "dark",
        sticky: "top",
        expand: "lg",
        collapseOnSelect: true,
        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $5f7777a6b14048f7$export$2e2bcd8739ae039), {
            children: [
                (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $78ba6c7ac2efa658$export$2e2bcd8739ae039).Brand, {
                    href: ".",
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("img", {
                            className: `${$7eb6f6c751b65708$export$db3c28d99448dcff} me-2`,
                            src: "https://github.com/react-bootstrap.png"
                        }),
                        document.title
                    ]
                }),
                (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $78ba6c7ac2efa658$export$2e2bcd8739ae039).Toggle, {
                    "aria-controls": "navbar-inner"
                }),
                (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $78ba6c7ac2efa658$export$2e2bcd8739ae039).Collapse, {
                    id: "navbar-inner",
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $f103ad69c50f21fa$export$2e2bcd8739ae039), {
                            className: "me-auto",
                            children: (0, $a3f4ff3ffbf2acb3$export$3baea55415cc8bd1)().map(({ title: title, href: href })=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $f103ad69c50f21fa$export$2e2bcd8739ae039).Link, {
                                    className: "text-white",
                                    href: href,
                                    children: title
                                }, title))
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Select), {
                            value: currentLanguage,
                            onChange: (key)=>(0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168).loadLanguages(key),
                            children: Object.entries((0, $cdcfc036668a4ffd$export$4b3850bcaaad82f1)).map(([key, name])=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Option), {
                                    value: key,
                                    children: name
                                }, key))
                        })
                    ]
                })
            ]
        })
    });
});



var $3lE4N = parcelRequire("3lE4N");
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $21e3a120f93644c0$var$extendStatics = function(d, b) {
    $21e3a120f93644c0$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $21e3a120f93644c0$var$extendStatics(d, b);
};
function $21e3a120f93644c0$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $21e3a120f93644c0$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $21e3a120f93644c0$export$18ce0697a983be9b = function() {
    $21e3a120f93644c0$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $21e3a120f93644c0$export$18ce0697a983be9b.apply(this, arguments);
};
function $21e3a120f93644c0$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $21e3a120f93644c0$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $21e3a120f93644c0$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $21e3a120f93644c0$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $21e3a120f93644c0$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $21e3a120f93644c0$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $21e3a120f93644c0$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $21e3a120f93644c0$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $21e3a120f93644c0$export$45d3717a4c69092e(o, m, p);
}
function $21e3a120f93644c0$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $21e3a120f93644c0$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $21e3a120f93644c0$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($21e3a120f93644c0$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $21e3a120f93644c0$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $21e3a120f93644c0$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $21e3a120f93644c0$export$10c90e4f7922046c(v) {
    return this instanceof $21e3a120f93644c0$export$10c90e4f7922046c ? (this.v = v, this) : new $21e3a120f93644c0$export$10c90e4f7922046c(v);
}
function $21e3a120f93644c0$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $21e3a120f93644c0$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $21e3a120f93644c0$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $21e3a120f93644c0$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $21e3a120f93644c0$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $21e3a120f93644c0$export$19a8beecd37a4c45 === "function" ? $21e3a120f93644c0$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $21e3a120f93644c0$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $21e3a120f93644c0$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $21e3a120f93644c0$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $21e3a120f93644c0$export$45d3717a4c69092e(result, mod, k);
    }
    $21e3a120f93644c0$var$__setModuleDefault(result, mod);
    return result;
}
function $21e3a120f93644c0$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $21e3a120f93644c0$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $21e3a120f93644c0$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE
*/ var $d461075057ee3466$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $d461075057ee3466$var$Env = function() {
    function Env() {
        this.browser = new $d461075057ee3466$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== 'undefined';
    }
    return Env;
}();
var $d461075057ee3466$var$env = new $d461075057ee3466$var$Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $d461075057ee3466$var$env.wxa = true;
    $d461075057ee3466$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') $d461075057ee3466$var$env.worker = true;
else if (!$d461075057ee3466$var$env.hasGlobalWindow || 'Deno' in window || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Node.js') > -1) {
    $d461075057ee3466$var$env.node = true;
    $d461075057ee3466$var$env.svgSupported = true;
} else $d461075057ee3466$var$detect(navigator.userAgent, $d461075057ee3466$var$env);
function $d461075057ee3466$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    var domSupported = env.domSupported = typeof document !== 'undefined';
    if (domSupported) {
        var style = document.documentElement.style;
        env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
        env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
    }
}
var $d461075057ee3466$export$2e2bcd8739ae039 = $d461075057ee3466$var$env;


var $fd1433555986e896$export$b1461457ea2c1179 = 12;
var $fd1433555986e896$export$2653e0d5dd45b294 = 'sans-serif';
var $fd1433555986e896$export$7d7a232b6d2cc80c = $fd1433555986e896$export$b1461457ea2c1179 + "px " + $fd1433555986e896$export$2653e0d5dd45b294;
var $fd1433555986e896$var$OFFSET = 20;
var $fd1433555986e896$var$SCALE = 100;
var $fd1433555986e896$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $fd1433555986e896$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === 'undefined') return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $fd1433555986e896$var$OFFSET) / $fd1433555986e896$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $fd1433555986e896$export$69462fcc6bf851a4 = $fd1433555986e896$var$getTextWidthMap($fd1433555986e896$var$defaultWidthMapStr);
var $fd1433555986e896$export$ef5e599365494451 = {
    createCanvas: function() {
        return typeof document !== 'undefined' && document.createElement('canvas');
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $fd1433555986e896$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext('2d');
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $fd1433555986e896$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || '';
                font = font || $fd1433555986e896$export$7d7a232b6d2cc80c;
                var res = /((?:\d+)?\.?\d*)px/.exec(font);
                var fontSize = res && +res[1] || $fd1433555986e896$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf('mono') >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $fd1433555986e896$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    },
    getTime: function() {
        return Date.now ? Date.now() : +new Date();
    }
};
function $fd1433555986e896$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $fd1433555986e896$export$ef5e599365494451)if ($fd1433555986e896$export$ef5e599365494451.hasOwnProperty(key) && newPlatformApis[key]) $fd1433555986e896$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $e4c0c902d0f4f283$var$BUILTIN_OBJECT = $e4c0c902d0f4f283$export$533b26079ad0b4b([
    'Function',
    'RegExp',
    'Date',
    'Error',
    'CanvasGradient',
    'CanvasPattern',
    'Image',
    'Canvas'
], function(obj, val) {
    obj['[object ' + val + ']'] = true;
    return obj;
}, {});
var $e4c0c902d0f4f283$var$TYPED_ARRAY = $e4c0c902d0f4f283$export$533b26079ad0b4b([
    'Int8',
    'Uint8',
    'Uint8Clamped',
    'Int16',
    'Uint16',
    'Int32',
    'Uint32',
    'Float32',
    'Float64'
], function(obj, val) {
    obj['[object ' + val + 'Array]'] = true;
    return obj;
}, {});
var $e4c0c902d0f4f283$var$objToString = Object.prototype.toString;
var $e4c0c902d0f4f283$var$arrayProto = Array.prototype;
var $e4c0c902d0f4f283$var$nativeForEach = $e4c0c902d0f4f283$var$arrayProto.forEach;
var $e4c0c902d0f4f283$var$nativeFilter = $e4c0c902d0f4f283$var$arrayProto.filter;
var $e4c0c902d0f4f283$var$nativeSlice = $e4c0c902d0f4f283$var$arrayProto.slice;
var $e4c0c902d0f4f283$var$nativeMap = $e4c0c902d0f4f283$var$arrayProto.map;
var $e4c0c902d0f4f283$var$ctorFunction = (function() {}).constructor;
var $e4c0c902d0f4f283$var$protoFunction = $e4c0c902d0f4f283$var$ctorFunction ? $e4c0c902d0f4f283$var$ctorFunction.prototype : null;
var $e4c0c902d0f4f283$var$protoKey = '__proto__';
var $e4c0c902d0f4f283$var$idStart = 0x0907;
var $e4c0c902d0f4f283$var$MAX_SAFE_INTEGER = Math.pow(2, 53) - 1;
function $e4c0c902d0f4f283$export$46e8f25c7328f77e() {
    if ($e4c0c902d0f4f283$var$idStart >= $e4c0c902d0f4f283$var$MAX_SAFE_INTEGER) $e4c0c902d0f4f283$var$idStart = 0;
    return $e4c0c902d0f4f283$var$idStart++;
}
function $e4c0c902d0f4f283$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $e4c0c902d0f4f283$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== 'object') return source;
    var result = source;
    var typeStr = $e4c0c902d0f4f283$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$e4c0c902d0f4f283$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $e4c0c902d0f4f283$export$9cd59f9826255e47(source[i]);
        }
    } else if ($e4c0c902d0f4f283$var$TYPED_ARRAY[typeStr]) {
        if (!$e4c0c902d0f4f283$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$e4c0c902d0f4f283$var$BUILTIN_OBJECT[typeStr] && !$e4c0c902d0f4f283$export$c3825b437cbdea5c(source) && !$e4c0c902d0f4f283$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $e4c0c902d0f4f283$var$protoKey) result[key] = $e4c0c902d0f4f283$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $e4c0c902d0f4f283$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$e4c0c902d0f4f283$export$a6cdc56e425d0d0a(source) || !$e4c0c902d0f4f283$export$a6cdc56e425d0d0a(target)) return overwrite ? $e4c0c902d0f4f283$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $e4c0c902d0f4f283$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($e4c0c902d0f4f283$export$a6cdc56e425d0d0a(sourceProp) && $e4c0c902d0f4f283$export$a6cdc56e425d0d0a(targetProp) && !$e4c0c902d0f4f283$export$43bee75e5e14138e(sourceProp) && !$e4c0c902d0f4f283$export$43bee75e5e14138e(targetProp) && !$e4c0c902d0f4f283$export$9f57505b7bd8dae(sourceProp) && !$e4c0c902d0f4f283$export$9f57505b7bd8dae(targetProp) && !$e4c0c902d0f4f283$export$fa523b2c4941fd4f(sourceProp) && !$e4c0c902d0f4f283$export$fa523b2c4941fd4f(targetProp) && !$e4c0c902d0f4f283$export$c3825b437cbdea5c(sourceProp) && !$e4c0c902d0f4f283$export$c3825b437cbdea5c(targetProp)) $e4c0c902d0f4f283$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $e4c0c902d0f4f283$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $e4c0c902d0f4f283$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $e4c0c902d0f4f283$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $e4c0c902d0f4f283$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $e4c0c902d0f4f283$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $e4c0c902d0f4f283$export$2b3af8009eff404f(tar, src, props) {
    tar = tar || {};
    for(var idx = 0; idx < props.length; idx++){
        var prop = props[idx];
        tar[prop] = src[prop];
    }
    return tar;
}
function $e4c0c902d0f4f283$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $e4c0c902d0f4f283$export$ed97f33186d4b816(source);
    for(var i = 0, len = keysArr.length; i < len; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $e4c0c902d0f4f283$export$cd3d1f114b139967 = (0, $fd1433555986e896$export$ef5e599365494451).createCanvas;
function $e4c0c902d0f4f283$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $e4c0c902d0f4f283$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $e4c0c902d0f4f283$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $e4c0c902d0f4f283$export$ebe90cb607ad99e(target, source, override);
}
function $e4c0c902d0f4f283$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $e4c0c902d0f4f283$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $e4c0c902d0f4f283$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $e4c0c902d0f4f283$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $e4c0c902d0f4f283$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $e4c0c902d0f4f283$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $e4c0c902d0f4f283$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $e4c0c902d0f4f283$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $e4c0c902d0f4f283$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $e4c0c902d0f4f283$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $e4c0c902d0f4f283$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $e4c0c902d0f4f283$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $e4c0c902d0f4f283$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($e4c0c902d0f4f283$var$nativeSlice.call(arguments)));
    };
}
var $e4c0c902d0f4f283$export$2385a24977818dd0 = $e4c0c902d0f4f283$var$protoFunction && $e4c0c902d0f4f283$export$f6e2535fb5126e54($e4c0c902d0f4f283$var$protoFunction.bind) ? $e4c0c902d0f4f283$var$protoFunction.call.bind($e4c0c902d0f4f283$var$protoFunction.bind) : $e4c0c902d0f4f283$var$bindPolyfill;
function $e4c0c902d0f4f283$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($e4c0c902d0f4f283$var$nativeSlice.call(arguments)));
    };
}
function $e4c0c902d0f4f283$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $e4c0c902d0f4f283$var$objToString.call(value) === '[object Array]';
}
function $e4c0c902d0f4f283$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $e4c0c902d0f4f283$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $e4c0c902d0f4f283$export$29d0bb2a4e07b252(value) {
    return $e4c0c902d0f4f283$var$objToString.call(value) === '[object String]';
}
function $e4c0c902d0f4f283$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $e4c0c902d0f4f283$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === 'function' || !!value && type === 'object';
}
function $e4c0c902d0f4f283$export$fa523b2c4941fd4f(value) {
    return !!$e4c0c902d0f4f283$var$BUILTIN_OBJECT[$e4c0c902d0f4f283$var$objToString.call(value)];
}
function $e4c0c902d0f4f283$export$b119cc7e1840e59c(value) {
    return !!$e4c0c902d0f4f283$var$TYPED_ARRAY[$e4c0c902d0f4f283$var$objToString.call(value)];
}
function $e4c0c902d0f4f283$export$9f57505b7bd8dae(value) {
    return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
function $e4c0c902d0f4f283$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $e4c0c902d0f4f283$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $e4c0c902d0f4f283$export$49841c62b9eff15(value) {
    return $e4c0c902d0f4f283$var$objToString.call(value) === '[object RegExp]';
}
function $e4c0c902d0f4f283$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $e4c0c902d0f4f283$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $e4c0c902d0f4f283$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $e4c0c902d0f4f283$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $e4c0c902d0f4f283$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $e4c0c902d0f4f283$var$nativeSlice.apply(arr, args);
}
function $e4c0c902d0f4f283$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $e4c0c902d0f4f283$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $e4c0c902d0f4f283$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $e4c0c902d0f4f283$var$primitiveKey = '__ec_primitive__';
function $e4c0c902d0f4f283$export$112e66431016387b(obj) {
    obj[$e4c0c902d0f4f283$var$primitiveKey] = true;
}
function $e4c0c902d0f4f283$export$c3825b437cbdea5c(obj) {
    return obj[$e4c0c902d0f4f283$var$primitiveKey];
}
var $e4c0c902d0f4f283$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $e4c0c902d0f4f283$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $e4c0c902d0f4f283$var$isNativeMapSupported = typeof Map === 'function';
function $e4c0c902d0f4f283$var$maybeNativeMap() {
    return $e4c0c902d0f4f283$var$isNativeMapSupported ? new Map() : new $e4c0c902d0f4f283$var$MapPolyfill();
}
var $e4c0c902d0f4f283$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $e4c0c902d0f4f283$export$43bee75e5e14138e(obj);
        this.data = $e4c0c902d0f4f283$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $e4c0c902d0f4f283$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $e4c0c902d0f4f283$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $e4c0c902d0f4f283$export$55f8aa7ef875b0a4(obj) {
    return new $e4c0c902d0f4f283$export$60ef0b43d585640a(obj);
}
function $e4c0c902d0f4f283$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $e4c0c902d0f4f283$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $e4c0c902d0f4f283$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $e4c0c902d0f4f283$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = 'none';
    domStyle.userSelect = 'none';
    domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
    domStyle['-webkit-touch-callout'] = 'none';
}
function $e4c0c902d0f4f283$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $e4c0c902d0f4f283$export$8793edee2d425525() {}
var $e4c0c902d0f4f283$export$bce8e055322a0ce6 = 180 / Math.PI;
var $e4c0c902d0f4f283$export$fd293b15f47e270 = Number.EPSILON || Math.pow(2, -52);




function $c20a2855346046a3$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $c20a2855346046a3$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $c20a2855346046a3$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $c20a2855346046a3$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $c20a2855346046a3$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $c20a2855346046a3$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $c20a2855346046a3$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $c20a2855346046a3$export$fc1400facf92c78(v) {
    return Math.sqrt($c20a2855346046a3$export$48e33bc611e4c25a(v));
}
var $c20a2855346046a3$export$f24224f1c91d8156 = $c20a2855346046a3$export$fc1400facf92c78;
function $c20a2855346046a3$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $c20a2855346046a3$export$2f106540dd9a5136 = $c20a2855346046a3$export$48e33bc611e4c25a;
function $c20a2855346046a3$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $c20a2855346046a3$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $c20a2855346046a3$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $c20a2855346046a3$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $c20a2855346046a3$export$a3295358bff77e(out, v) {
    var d = $c20a2855346046a3$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $c20a2855346046a3$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $c20a2855346046a3$export$6c4a311cc157c764 = $c20a2855346046a3$export$9f17032d917177de;
function $c20a2855346046a3$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $c20a2855346046a3$export$c68db45a034c13b0 = $c20a2855346046a3$export$137c0a69d1ff4a79;
function $c20a2855346046a3$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $c20a2855346046a3$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $c20a2855346046a3$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $c20a2855346046a3$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $c20a2855346046a3$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $0fefdcb71fb40c56$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $0fefdcb71fb40c56$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $0fefdcb71fb40c56$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $0fefdcb71fb40c56$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $0fefdcb71fb40c56$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $0fefdcb71fb40c56$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $0fefdcb71fb40c56$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $0fefdcb71fb40c56$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $0fefdcb71fb40c56$export$2e2bcd8739ae039 = $0fefdcb71fb40c56$var$Draggable;


var $770990963ee378bd$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $770990963ee378bd$export$2e2bcd8739ae039 = $770990963ee378bd$var$Eventful;





var $1cd3935125194f83$var$LN2 = Math.log(2);
function $1cd3935125194f83$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $1cd3935125194f83$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $1cd3935125194f83$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $1cd3935125194f83$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $1cd3935125194f83$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $1cd3935125194f83$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}



var $342f62d58312c6d1$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $342f62d58312c6d1$var$_calcOut = [];
function $342f62d58312c6d1$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $342f62d58312c6d1$export$1219648acc517df4($342f62d58312c6d1$var$_calcOut, elFrom, inX, inY, true) && $342f62d58312c6d1$export$1219648acc517df4(out, elTarget, $342f62d58312c6d1$var$_calcOut[0], $342f62d58312c6d1$var$_calcOut[1]);
}
function $342f62d58312c6d1$export$a29dbe4b7d3cd586(elFrom, elTarget) {
    elFrom && dealClear(elFrom);
    elTarget && dealClear(elTarget);
    function dealClear(el) {
        var saved = el[$342f62d58312c6d1$var$EVENT_SAVED_PROP];
        if (saved) {
            saved.clearMarkers && saved.clearMarkers();
            delete el[$342f62d58312c6d1$var$EVENT_SAVED_PROP];
        }
    }
}
function $342f62d58312c6d1$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $d461075057ee3466$export$2e2bcd8739ae039).domSupported && !$342f62d58312c6d1$export$1b92e4fe606eff6d(el)) {
        var saved = el[$342f62d58312c6d1$var$EVENT_SAVED_PROP] || (el[$342f62d58312c6d1$var$EVENT_SAVED_PROP] = {});
        var markers = $342f62d58312c6d1$var$prepareCoordMarkers(el, saved);
        var transformer = $342f62d58312c6d1$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $342f62d58312c6d1$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    saved.clearMarkers = function() {
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(markers, function(marker) {
            marker.parentNode && marker.parentNode.removeChild(marker);
        });
    };
    return markers;
}
function $342f62d58312c6d1$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $1cd3935125194f83$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $1cd3935125194f83$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $342f62d58312c6d1$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}
var $342f62d58312c6d1$var$replaceReg = /([&<>"'])/g;
var $342f62d58312c6d1$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $342f62d58312c6d1$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($342f62d58312c6d1$var$replaceReg, function(str, c) {
        return $342f62d58312c6d1$var$replaceMap[c];
    });
}


var $1aba4b63ed27962a$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $1aba4b63ed27962a$var$_calcOut = [];
var $1aba4b63ed27962a$var$firefoxNotSupportOffsetXY = (0, $d461075057ee3466$export$2e2bcd8739ae039).browser.firefox && +(0, $d461075057ee3466$export$2e2bcd8739ae039).browser.version.split('.')[0] < 39;
function $1aba4b63ed27962a$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $1aba4b63ed27962a$var$calculateZrXY(el, e, out);
    else if ($1aba4b63ed27962a$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $1aba4b63ed27962a$var$calculateZrXY(el, e, out);
    return out;
}
function $1aba4b63ed27962a$var$calculateZrXY(el, e, out) {
    if ((0, $d461075057ee3466$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $342f62d58312c6d1$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $342f62d58312c6d1$export$1219648acc517df4)($1aba4b63ed27962a$var$_calcOut, el, ex, ey)) {
            out.zrX = $1aba4b63ed27962a$var$_calcOut[0];
            out.zrY = $1aba4b63ed27962a$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $1aba4b63ed27962a$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $1aba4b63ed27962a$export$40fadb093aebad71(el, e, calculate) {
    e = $1aba4b63ed27962a$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $1aba4b63ed27962a$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $1aba4b63ed27962a$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $1aba4b63ed27962a$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $1aba4b63ed27962a$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $1aba4b63ed27962a$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $1aba4b63ed27962a$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $1aba4b63ed27962a$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $1aba4b63ed27962a$export$fa6813432f753b0d = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $1aba4b63ed27962a$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $91892c1b288ca357$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $1aba4b63ed27962a$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $91892c1b288ca357$var$recognizers)if ($91892c1b288ca357$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $91892c1b288ca357$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $91892c1b288ca357$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $91892c1b288ca357$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $91892c1b288ca357$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $91892c1b288ca357$var$dist(pinchEnd) / $91892c1b288ca357$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $91892c1b288ca357$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};


function $97681aabb80d556d$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $97681aabb80d556d$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $97681aabb80d556d$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $97681aabb80d556d$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $97681aabb80d556d$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $97681aabb80d556d$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $97681aabb80d556d$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $97681aabb80d556d$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $97681aabb80d556d$export$9cd59f9826255e47(a) {
    var b = $97681aabb80d556d$export$185802fd694ee1f5();
    $97681aabb80d556d$export$784d13d8ee351f07(b, a);
    return b;
}



var $0a729ce3d8741684$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $0a729ce3d8741684$export$2e2bcd8739ae039 = $0a729ce3d8741684$var$Point;


var $8d3017bded1ca21b$var$mathMin = Math.min;
var $8d3017bded1ca21b$var$mathMax = Math.max;
var $8d3017bded1ca21b$var$mathAbs = Math.abs;
var $8d3017bded1ca21b$var$XY = [
    'x',
    'y'
];
var $8d3017bded1ca21b$var$WH = [
    'width',
    'height'
];
var $8d3017bded1ca21b$var$lt = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
var $8d3017bded1ca21b$var$rb = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
var $8d3017bded1ca21b$var$lb = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
var $8d3017bded1ca21b$var$rt = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
var $8d3017bded1ca21b$var$_intersectCtx = $8d3017bded1ca21b$export$a0be2bdbd2369e0e();
var $8d3017bded1ca21b$var$_minTv = $8d3017bded1ca21b$var$_intersectCtx.minTv;
var $8d3017bded1ca21b$var$_maxTv = $8d3017bded1ca21b$var$_intersectCtx.maxTv;
var $8d3017bded1ca21b$var$_lenMinMax = [
    0,
    0
];
var $8d3017bded1ca21b$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        $8d3017bded1ca21b$export$6bf07b1ffc18797f(this, x, y, width, height);
    }
    BoundingRect.set = function(target, x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        target.x = x;
        target.y = y;
        target.width = width;
        target.height = height;
        return target;
    };
    BoundingRect.prototype.union = function(other) {
        var x = $8d3017bded1ca21b$var$mathMin(other.x, this.x);
        var y = $8d3017bded1ca21b$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $8d3017bded1ca21b$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $8d3017bded1ca21b$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        return $8d3017bded1ca21b$export$92d3eaad4f1a1f35($97681aabb80d556d$export$185802fd694ee1f5(), this, b);
    };
    BoundingRect.prototype.intersect = function(b, mtv, opt) {
        return BoundingRect.intersect(this, b, mtv, opt);
    };
    BoundingRect.intersect = function(a, b, mtv, opt) {
        if (mtv) (0, $0a729ce3d8741684$export$2e2bcd8739ae039).set(mtv, 0, 0);
        var outIntersectRect = opt && opt.outIntersectRect || null;
        var clamp = opt && opt.clamp;
        if (outIntersectRect) outIntersectRect.x = outIntersectRect.y = outIntersectRect.width = outIntersectRect.height = NaN;
        if (!a || !b) return false;
        if (!(a instanceof BoundingRect)) a = $8d3017bded1ca21b$export$6bf07b1ffc18797f($8d3017bded1ca21b$var$_tmpIntersectA, a.x, a.y, a.width, a.height);
        if (!(b instanceof BoundingRect)) b = $8d3017bded1ca21b$export$6bf07b1ffc18797f($8d3017bded1ca21b$var$_tmpIntersectB, b.x, b.y, b.width, b.height);
        var useMTV = !!mtv;
        $8d3017bded1ca21b$var$_intersectCtx.reset(opt, useMTV);
        var touchThreshold = $8d3017bded1ca21b$var$_intersectCtx.touchThreshold;
        var ax0 = a.x + touchThreshold;
        var ax1 = a.x + a.width - touchThreshold;
        var ay0 = a.y + touchThreshold;
        var ay1 = a.y + a.height - touchThreshold;
        var bx0 = b.x + touchThreshold;
        var bx1 = b.x + b.width - touchThreshold;
        var by0 = b.y + touchThreshold;
        var by1 = b.y + b.height - touchThreshold;
        if (ax0 > ax1 || ay0 > ay1 || bx0 > bx1 || by0 > by1) return false;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (useMTV || outIntersectRect) {
            $8d3017bded1ca21b$var$_lenMinMax[0] = Infinity;
            $8d3017bded1ca21b$var$_lenMinMax[1] = 0;
            $8d3017bded1ca21b$var$intersectOneDim(ax0, ax1, bx0, bx1, 0, useMTV, outIntersectRect, clamp);
            $8d3017bded1ca21b$var$intersectOneDim(ay0, ay1, by0, by1, 1, useMTV, outIntersectRect, clamp);
            if (useMTV) (0, $0a729ce3d8741684$export$2e2bcd8739ae039).copy(mtv, overlap ? $8d3017bded1ca21b$var$_intersectCtx.useDir ? $8d3017bded1ca21b$var$_intersectCtx.dirMinTv : $8d3017bded1ca21b$var$_minTv : $8d3017bded1ca21b$var$_maxTv);
        }
        return overlap;
    };
    BoundingRect.contain = function(rect, x, y) {
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.contain = function(x, y) {
        return BoundingRect.contain(this, x, y);
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        $8d3017bded1ca21b$export$241114a7b05054e(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect ? rect.x : 0, rect ? rect.y : 0, rect ? rect.width : 0, rect ? rect.height : 0);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
        return target;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) $8d3017bded1ca21b$export$241114a7b05054e(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $8d3017bded1ca21b$var$lt.x = $8d3017bded1ca21b$var$lb.x = source.x;
        $8d3017bded1ca21b$var$lt.y = $8d3017bded1ca21b$var$rt.y = source.y;
        $8d3017bded1ca21b$var$rb.x = $8d3017bded1ca21b$var$rt.x = source.x + source.width;
        $8d3017bded1ca21b$var$rb.y = $8d3017bded1ca21b$var$lb.y = source.y + source.height;
        $8d3017bded1ca21b$var$lt.transform(m);
        $8d3017bded1ca21b$var$rt.transform(m);
        $8d3017bded1ca21b$var$rb.transform(m);
        $8d3017bded1ca21b$var$lb.transform(m);
        target.x = $8d3017bded1ca21b$var$mathMin($8d3017bded1ca21b$var$lt.x, $8d3017bded1ca21b$var$rb.x, $8d3017bded1ca21b$var$lb.x, $8d3017bded1ca21b$var$rt.x);
        target.y = $8d3017bded1ca21b$var$mathMin($8d3017bded1ca21b$var$lt.y, $8d3017bded1ca21b$var$rb.y, $8d3017bded1ca21b$var$lb.y, $8d3017bded1ca21b$var$rt.y);
        var maxX = $8d3017bded1ca21b$var$mathMax($8d3017bded1ca21b$var$lt.x, $8d3017bded1ca21b$var$rb.x, $8d3017bded1ca21b$var$lb.x, $8d3017bded1ca21b$var$rt.x);
        var maxY = $8d3017bded1ca21b$var$mathMax($8d3017bded1ca21b$var$lt.y, $8d3017bded1ca21b$var$rb.y, $8d3017bded1ca21b$var$lb.y, $8d3017bded1ca21b$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    BoundingRect.calculateTransform = function(out, a, b) {
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        out = $97681aabb80d556d$export$f0954fd7d5368655(out || []);
        $97681aabb80d556d$export$d73ee8ef04f5226a(out, out, $c20a2855346046a3$export$adaa4cf7ef1b65be($8d3017bded1ca21b$var$_tmpCalcTrans, -a.x, -a.y));
        $97681aabb80d556d$export$dcdf75081b88279d(out, out, $c20a2855346046a3$export$adaa4cf7ef1b65be($8d3017bded1ca21b$var$_tmpCalcTrans, sx, sy));
        $97681aabb80d556d$export$d73ee8ef04f5226a(out, out, $c20a2855346046a3$export$adaa4cf7ef1b65be($8d3017bded1ca21b$var$_tmpCalcTrans, b.x, b.y));
        return out;
    };
    return BoundingRect;
}();
var $8d3017bded1ca21b$export$cd9abb76972ddc89 = $8d3017bded1ca21b$var$BoundingRect.create;
var $8d3017bded1ca21b$export$6bf07b1ffc18797f = $8d3017bded1ca21b$var$BoundingRect.set;
var $8d3017bded1ca21b$export$241114a7b05054e = $8d3017bded1ca21b$var$BoundingRect.copy;
var $8d3017bded1ca21b$export$92d3eaad4f1a1f35 = $8d3017bded1ca21b$var$BoundingRect.calculateTransform;
var $8d3017bded1ca21b$export$738b31304fd07ad0 = $8d3017bded1ca21b$var$BoundingRect.applyTransform;
var $8d3017bded1ca21b$export$39177876d76f05b = $8d3017bded1ca21b$var$BoundingRect.contain;
var $8d3017bded1ca21b$var$_tmpIntersectA = new $8d3017bded1ca21b$var$BoundingRect(0, 0, 0, 0);
var $8d3017bded1ca21b$var$_tmpIntersectB = new $8d3017bded1ca21b$var$BoundingRect(0, 0, 0, 0);
var $8d3017bded1ca21b$var$_tmpCalcTrans = [];
function $8d3017bded1ca21b$var$intersectOneDim(a0, a1, b0, b1, updateDimIdx, useMTV, outIntersectRect, clamp) {
    var d0 = $8d3017bded1ca21b$var$mathAbs(a1 - b0);
    var d1 = $8d3017bded1ca21b$var$mathAbs(b1 - a0);
    var d01min = $8d3017bded1ca21b$var$mathMin(d0, d1);
    var updateDim = $8d3017bded1ca21b$var$XY[updateDimIdx];
    var zeroDim = $8d3017bded1ca21b$var$XY[1 - updateDimIdx];
    var wh = $8d3017bded1ca21b$var$WH[updateDimIdx];
    if (a1 < b0 || b1 < a0) {
        if (d0 < d1) {
            if (useMTV) $8d3017bded1ca21b$var$_maxTv[updateDim] = -d0;
            if (clamp) {
                outIntersectRect[updateDim] = a1;
                outIntersectRect[wh] = 0;
            }
        } else {
            if (useMTV) $8d3017bded1ca21b$var$_maxTv[updateDim] = d1;
            if (clamp) {
                outIntersectRect[updateDim] = a0;
                outIntersectRect[wh] = 0;
            }
        }
    } else {
        if (outIntersectRect) {
            outIntersectRect[updateDim] = $8d3017bded1ca21b$var$mathMax(a0, b0);
            outIntersectRect[wh] = $8d3017bded1ca21b$var$mathMin(a1, b1) - outIntersectRect[updateDim];
        }
        if (useMTV) {
            if (d01min < $8d3017bded1ca21b$var$_lenMinMax[0] || $8d3017bded1ca21b$var$_intersectCtx.useDir) {
                $8d3017bded1ca21b$var$_lenMinMax[0] = $8d3017bded1ca21b$var$mathMin(d01min, $8d3017bded1ca21b$var$_lenMinMax[0]);
                if (d0 < d1 || !$8d3017bded1ca21b$var$_intersectCtx.bidirectional) {
                    $8d3017bded1ca21b$var$_minTv[updateDim] = d0;
                    $8d3017bded1ca21b$var$_minTv[zeroDim] = 0;
                    if ($8d3017bded1ca21b$var$_intersectCtx.useDir) $8d3017bded1ca21b$var$_intersectCtx.calcDirMTV();
                }
                if (d0 >= d1 || !$8d3017bded1ca21b$var$_intersectCtx.bidirectional) {
                    $8d3017bded1ca21b$var$_minTv[updateDim] = -d1;
                    $8d3017bded1ca21b$var$_minTv[zeroDim] = 0;
                    if ($8d3017bded1ca21b$var$_intersectCtx.useDir) $8d3017bded1ca21b$var$_intersectCtx.calcDirMTV();
                }
            }
        }
    }
}
function $8d3017bded1ca21b$export$a0be2bdbd2369e0e() {
    var _direction = 0;
    var _dirCheckVec = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
    var _dirTmp = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
    var _ctx = {
        minTv: new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)(),
        maxTv: new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)(),
        useDir: false,
        dirMinTv: new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)(),
        touchThreshold: 0,
        bidirectional: true,
        negativeSize: false,
        reset: function(opt, useMTV) {
            _ctx.touchThreshold = 0;
            if (opt && opt.touchThreshold != null) _ctx.touchThreshold = $8d3017bded1ca21b$var$mathMax(0, opt.touchThreshold);
            _ctx.negativeSize = false;
            if (!useMTV) return;
            _ctx.minTv.set(Infinity, Infinity);
            _ctx.maxTv.set(0, 0);
            _ctx.useDir = false;
            if (opt && opt.direction != null) {
                _ctx.useDir = true;
                _ctx.dirMinTv.copy(_ctx.minTv);
                _dirTmp.copy(_ctx.minTv);
                _direction = opt.direction;
                _ctx.bidirectional = opt.bidirectional == null || !!opt.bidirectional;
                if (!_ctx.bidirectional) _dirCheckVec.set(Math.cos(_direction), Math.sin(_direction));
            }
        },
        calcDirMTV: function() {
            var minTv = _ctx.minTv;
            var dirMinTv = _ctx.dirMinTv;
            var squareMag = minTv.y * minTv.y + minTv.x * minTv.x;
            var dirSin = Math.sin(_direction);
            var dirCos = Math.cos(_direction);
            var dotProd = dirSin * minTv.y + dirCos * minTv.x;
            if (nearZero(dotProd)) {
                if (nearZero(minTv.x) && nearZero(minTv.y)) dirMinTv.set(0, 0);
                return;
            }
            _dirTmp.x = squareMag * dirCos / dotProd;
            _dirTmp.y = squareMag * dirSin / dotProd;
            if (nearZero(_dirTmp.x) && nearZero(_dirTmp.y)) {
                dirMinTv.set(0, 0);
                return;
            }
            if ((_ctx.bidirectional || _dirCheckVec.dot(_dirTmp) > 0) && _dirTmp.len() < dirMinTv.len()) dirMinTv.copy(_dirTmp);
        }
    };
    function nearZero(val) {
        return $8d3017bded1ca21b$var$mathAbs(val) < 1e-10;
    }
    return _ctx;
}
var $8d3017bded1ca21b$export$2e2bcd8739ae039 = $8d3017bded1ca21b$var$BoundingRect;


var $4ad45f3f2946b0f8$var$SILENT = 'silent';
function $4ad45f3f2946b0f8$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $4ad45f3f2946b0f8$var$stopEvent
    };
}
function $4ad45f3f2946b0f8$var$stopEvent() {
    $1aba4b63ed27962a$export$fa6813432f753b0d(this.event);
}
var $4ad45f3f2946b0f8$var$EmptyProxy = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $770990963ee378bd$export$2e2bcd8739ae039));
var $4ad45f3f2946b0f8$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $4ad45f3f2946b0f8$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $4ad45f3f2946b0f8$var$tmpRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $4ad45f3f2946b0f8$var$Handler = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $4ad45f3f2946b0f8$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $4ad45f3f2946b0f8$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $0fefdcb71fb40c56$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $e4c0c902d0f4f283$export$79b2f7037acddd43($4ad45f3f2946b0f8$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $4ad45f3f2946b0f8$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $4ad45f3f2946b0f8$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $4ad45f3f2946b0f8$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $4ad45f3f2946b0f8$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $4ad45f3f2946b0f8$var$HoveredResult(x, y);
        $4ad45f3f2946b0f8$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $4ad45f3f2946b0f8$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $4ad45f3f2946b0f8$var$tmpRect.applyTransform(el.transform);
                    if ($4ad45f3f2946b0f8$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $4ad45f3f2946b0f8$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $91892c1b288ca357$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $4ad45f3f2946b0f8$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $770990963ee378bd$export$2e2bcd8739ae039));
$e4c0c902d0f4f283$export$79b2f7037acddd43([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $4ad45f3f2946b0f8$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $4ad45f3f2946b0f8$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $c20a2855346046a3$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $4ad45f3f2946b0f8$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return isSilent ? $4ad45f3f2946b0f8$var$SILENT : true;
    }
    return false;
}
function $4ad45f3f2946b0f8$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $4ad45f3f2946b0f8$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $4ad45f3f2946b0f8$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $4ad45f3f2946b0f8$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $4ad45f3f2946b0f8$export$2e2bcd8739ae039 = $4ad45f3f2946b0f8$var$Handler;



var $9e91dd6172c91368$var$DEFAULT_MIN_MERGE = 32;
var $9e91dd6172c91368$var$DEFAULT_MIN_GALLOPING = 7;
function $9e91dd6172c91368$var$minRunLength(n) {
    var r = 0;
    while(n >= $9e91dd6172c91368$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $9e91dd6172c91368$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $9e91dd6172c91368$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $9e91dd6172c91368$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $9e91dd6172c91368$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $9e91dd6172c91368$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $9e91dd6172c91368$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $9e91dd6172c91368$var$TimSort(array, compare) {
    var minGallop = $9e91dd6172c91368$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $9e91dd6172c91368$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $9e91dd6172c91368$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $9e91dd6172c91368$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $9e91dd6172c91368$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $9e91dd6172c91368$var$DEFAULT_MIN_GALLOPING || count2 >= $9e91dd6172c91368$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $9e91dd6172c91368$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $9e91dd6172c91368$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $9e91dd6172c91368$var$DEFAULT_MIN_GALLOPING || count2 >= $9e91dd6172c91368$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $9e91dd6172c91368$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $9e91dd6172c91368$var$DEFAULT_MIN_MERGE) {
        runLength = $9e91dd6172c91368$var$makeAscendingRun(array, lo, hi, compare);
        $9e91dd6172c91368$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $9e91dd6172c91368$var$TimSort(array, compare);
    var minRun = $9e91dd6172c91368$var$minRunLength(remaining);
    do {
        runLength = $9e91dd6172c91368$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $9e91dd6172c91368$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $be8577c7cd53a73f$export$a7b6db622c6c7dbd = 1;
var $be8577c7cd53a73f$export$ada8b2beb3d76671 = 2;
var $be8577c7cd53a73f$export$f75fe89a33ebe115 = 4;


var $f96a98bd8a655bf7$var$invalidZErrorLogged = false;
function $f96a98bd8a655bf7$var$logInvalidZError() {
    if ($f96a98bd8a655bf7$var$invalidZErrorLogged) return;
    $f96a98bd8a655bf7$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $f96a98bd8a655bf7$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $f96a98bd8a655bf7$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $f96a98bd8a655bf7$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $9e91dd6172c91368$export$2e2bcd8739ae039)(displayList, $f96a98bd8a655bf7$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, parentClipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        var parentHasClipPaths = parentClipPaths && parentClipPaths.length;
        var clipPathIdx = 0;
        var thisClipPaths = el.__clipPaths;
        if (!el.ignoreClip && (parentHasClipPaths || userSetClipPath)) {
            if (!thisClipPaths) thisClipPaths = el.__clipPaths = [];
            if (parentHasClipPaths) for(var idx = 0; idx < parentClipPaths.length; idx++)thisClipPaths[clipPathIdx++] = parentClipPaths[idx];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                thisClipPaths[clipPathIdx++] = currentClipPath;
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (thisClipPaths) thisClipPaths.length = clipPathIdx;
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, thisClipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (isNaN(disp.z)) {
                $f96a98bd8a655bf7$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $f96a98bd8a655bf7$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $f96a98bd8a655bf7$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, thisClipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, thisClipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, thisClipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $e4c0c902d0f4f283$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $f96a98bd8a655bf7$export$2e2bcd8739ae039 = $f96a98bd8a655bf7$var$Storage;





var $707ec6f7b7c4c326$var$requestAnimationFrame;
$707ec6f7b7c4c326$var$requestAnimationFrame = (0, $d461075057ee3466$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $707ec6f7b7c4c326$export$2e2bcd8739ae039 = $707ec6f7b7c4c326$var$requestAnimationFrame;


var $e53df830e851fea1$var$easingFuncs = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $e53df830e851fea1$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $e53df830e851fea1$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $e53df830e851fea1$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $e53df830e851fea1$export$2e2bcd8739ae039 = $e53df830e851fea1$var$easingFuncs;




var $7734ff3f5891b22b$var$mathPow = Math.pow;
var $7734ff3f5891b22b$var$mathSqrt = Math.sqrt;
var $7734ff3f5891b22b$var$EPSILON = 1e-8;
var $7734ff3f5891b22b$var$EPSILON_NUMERIC = 1e-4;
var $7734ff3f5891b22b$var$THREE_SQRT = $7734ff3f5891b22b$var$mathSqrt(3);
var $7734ff3f5891b22b$var$ONE_THIRD = 1 / 3;
var $7734ff3f5891b22b$var$_v0 = (0, $c20a2855346046a3$export$185802fd694ee1f5)();
var $7734ff3f5891b22b$var$_v1 = (0, $c20a2855346046a3$export$185802fd694ee1f5)();
var $7734ff3f5891b22b$var$_v2 = (0, $c20a2855346046a3$export$185802fd694ee1f5)();
function $7734ff3f5891b22b$var$isAroundZero(val) {
    return val > -$7734ff3f5891b22b$var$EPSILON && val < $7734ff3f5891b22b$var$EPSILON;
}
function $7734ff3f5891b22b$var$isNotAroundZero(val) {
    return val > $7734ff3f5891b22b$var$EPSILON || val < -$7734ff3f5891b22b$var$EPSILON;
}
function $7734ff3f5891b22b$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $7734ff3f5891b22b$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $7734ff3f5891b22b$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($7734ff3f5891b22b$var$isAroundZero(A) && $7734ff3f5891b22b$var$isAroundZero(B)) {
        if ($7734ff3f5891b22b$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($7734ff3f5891b22b$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $7734ff3f5891b22b$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$7734ff3f5891b22b$var$mathPow(-Y1, $7734ff3f5891b22b$var$ONE_THIRD);
            else Y1 = $7734ff3f5891b22b$var$mathPow(Y1, $7734ff3f5891b22b$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$7734ff3f5891b22b$var$mathPow(-Y2, $7734ff3f5891b22b$var$ONE_THIRD);
            else Y2 = $7734ff3f5891b22b$var$mathPow(Y2, $7734ff3f5891b22b$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $7734ff3f5891b22b$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $7734ff3f5891b22b$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $7734ff3f5891b22b$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $7734ff3f5891b22b$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $7734ff3f5891b22b$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($7734ff3f5891b22b$var$isAroundZero(a)) {
        if ($7734ff3f5891b22b$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($7734ff3f5891b22b$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $7734ff3f5891b22b$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $7734ff3f5891b22b$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $7734ff3f5891b22b$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $7734ff3f5891b22b$var$_v0[0] = x;
    $7734ff3f5891b22b$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $7734ff3f5891b22b$var$_v1[0] = $7734ff3f5891b22b$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $7734ff3f5891b22b$var$_v1[1] = $7734ff3f5891b22b$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $c20a2855346046a3$export$c68db45a034c13b0)($7734ff3f5891b22b$var$_v0, $7734ff3f5891b22b$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $7734ff3f5891b22b$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $7734ff3f5891b22b$var$_v1[0] = $7734ff3f5891b22b$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $7734ff3f5891b22b$var$_v1[1] = $7734ff3f5891b22b$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $c20a2855346046a3$export$c68db45a034c13b0)($7734ff3f5891b22b$var$_v1, $7734ff3f5891b22b$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $7734ff3f5891b22b$var$_v2[0] = $7734ff3f5891b22b$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $7734ff3f5891b22b$var$_v2[1] = $7734ff3f5891b22b$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $c20a2855346046a3$export$c68db45a034c13b0)($7734ff3f5891b22b$var$_v2, $7734ff3f5891b22b$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $7734ff3f5891b22b$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $7734ff3f5891b22b$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $7734ff3f5891b22b$var$mathSqrt(d);
}
function $7734ff3f5891b22b$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $7734ff3f5891b22b$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $7734ff3f5891b22b$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $7734ff3f5891b22b$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $7734ff3f5891b22b$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $7734ff3f5891b22b$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($7734ff3f5891b22b$var$isAroundZero(a)) {
        if ($7734ff3f5891b22b$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($7734ff3f5891b22b$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $7734ff3f5891b22b$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $7734ff3f5891b22b$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $7734ff3f5891b22b$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $7734ff3f5891b22b$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $7734ff3f5891b22b$var$_v0[0] = x;
    $7734ff3f5891b22b$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $7734ff3f5891b22b$var$_v1[0] = $7734ff3f5891b22b$export$af17094a950f5073(x0, x1, x2, _t);
        $7734ff3f5891b22b$var$_v1[1] = $7734ff3f5891b22b$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $c20a2855346046a3$export$c68db45a034c13b0)($7734ff3f5891b22b$var$_v0, $7734ff3f5891b22b$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $7734ff3f5891b22b$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $7734ff3f5891b22b$var$_v1[0] = $7734ff3f5891b22b$export$af17094a950f5073(x0, x1, x2, prev);
        $7734ff3f5891b22b$var$_v1[1] = $7734ff3f5891b22b$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $c20a2855346046a3$export$c68db45a034c13b0)($7734ff3f5891b22b$var$_v1, $7734ff3f5891b22b$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $7734ff3f5891b22b$var$_v2[0] = $7734ff3f5891b22b$export$af17094a950f5073(x0, x1, x2, next);
            $7734ff3f5891b22b$var$_v2[1] = $7734ff3f5891b22b$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $c20a2855346046a3$export$c68db45a034c13b0)($7734ff3f5891b22b$var$_v2, $7734ff3f5891b22b$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $7734ff3f5891b22b$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $7734ff3f5891b22b$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $7734ff3f5891b22b$var$mathSqrt(d);
}
function $7734ff3f5891b22b$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $7734ff3f5891b22b$export$af17094a950f5073(x0, x1, x2, t);
        var y = $7734ff3f5891b22b$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $48f0ff660a125306$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $48f0ff660a125306$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $48f0ff660a125306$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(',');
        var a_1 = +(0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $7734ff3f5891b22b$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $7734ff3f5891b22b$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $dd9c41a13cbef7b5$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $e4c0c902d0f4f283$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $e4c0c902d0f4f283$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $e4c0c902d0f4f283$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(easing) ? easing : (0, $e53df830e851fea1$export$2e2bcd8739ae039)[easing] || (0, $48f0ff660a125306$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $dd9c41a13cbef7b5$export$2e2bcd8739ae039 = $dd9c41a13cbef7b5$var$Clip;


var $cdadfc83391b9630$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $cdadfc83391b9630$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $cdadfc83391b9630$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $cdadfc83391b9630$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $cdadfc83391b9630$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $cdadfc83391b9630$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $cdadfc83391b9630$export$2e2bcd8739ae039 = $cdadfc83391b9630$var$LRU;



var $30eadc8c092f368d$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $30eadc8c092f368d$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $30eadc8c092f368d$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $30eadc8c092f368d$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $30eadc8c092f368d$export$e6be818e738239a(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $30eadc8c092f368d$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $30eadc8c092f368d$var$clampCssByte(parseInt(str, 10));
}
function $30eadc8c092f368d$export$7638a67891c3b497(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $30eadc8c092f368d$var$clampCssFloat(parseFloat(str) / 100);
    return $30eadc8c092f368d$var$clampCssFloat(parseFloat(str));
}
function $30eadc8c092f368d$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $30eadc8c092f368d$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $30eadc8c092f368d$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $30eadc8c092f368d$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $30eadc8c092f368d$var$colorCache = new (0, $cdadfc83391b9630$export$2e2bcd8739ae039)(20);
var $30eadc8c092f368d$var$lastRemovedArr = null;
function $30eadc8c092f368d$var$putToCache(colorStr, rgbaArr) {
    if ($30eadc8c092f368d$var$lastRemovedArr) $30eadc8c092f368d$var$copyRgba($30eadc8c092f368d$var$lastRemovedArr, rgbaArr);
    $30eadc8c092f368d$var$lastRemovedArr = $30eadc8c092f368d$var$colorCache.put(colorStr, $30eadc8c092f368d$var$lastRemovedArr || rgbaArr.slice());
}
function $30eadc8c092f368d$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $30eadc8c092f368d$var$colorCache.get(colorStr);
    if (cached) return $30eadc8c092f368d$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $30eadc8c092f368d$var$kCSSColorTable) {
        $30eadc8c092f368d$var$copyRgba(rgbaArr, $30eadc8c092f368d$var$kCSSColorTable[str]);
        $30eadc8c092f368d$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $30eadc8c092f368d$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $30eadc8c092f368d$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $30eadc8c092f368d$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $30eadc8c092f368d$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $30eadc8c092f368d$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $30eadc8c092f368d$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $30eadc8c092f368d$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $30eadc8c092f368d$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $30eadc8c092f368d$export$7638a67891c3b497(params.pop());
            case 'rgb':
                if (params.length >= 3) {
                    $30eadc8c092f368d$var$setRgba(rgbaArr, $30eadc8c092f368d$export$e6be818e738239a(params[0]), $30eadc8c092f368d$export$e6be818e738239a(params[1]), $30eadc8c092f368d$export$e6be818e738239a(params[2]), params.length === 3 ? alpha : $30eadc8c092f368d$export$7638a67891c3b497(params[3]));
                    $30eadc8c092f368d$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $30eadc8c092f368d$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case 'hsla':
                if (params.length !== 4) {
                    $30eadc8c092f368d$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $30eadc8c092f368d$export$7638a67891c3b497(params[3]);
                $30eadc8c092f368d$var$hsla2rgba(params, rgbaArr);
                $30eadc8c092f368d$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $30eadc8c092f368d$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $30eadc8c092f368d$var$hsla2rgba(params, rgbaArr);
                $30eadc8c092f368d$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $30eadc8c092f368d$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $30eadc8c092f368d$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $30eadc8c092f368d$export$7638a67891c3b497(hsla[1]);
    var l = $30eadc8c092f368d$export$7638a67891c3b497(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $30eadc8c092f368d$var$setRgba(rgba, $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$cssHueToRgb(m1, m2, h) * 255), $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $30eadc8c092f368d$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $30eadc8c092f368d$export$590e8b2c435046d9(color, level) {
    var colorArr = $30eadc8c092f368d$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $30eadc8c092f368d$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $30eadc8c092f368d$export$7ea66e3774a60b67(color) {
    var colorArr = $30eadc8c092f368d$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $30eadc8c092f368d$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $30eadc8c092f368d$var$clampCssFloat($30eadc8c092f368d$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $30eadc8c092f368d$export$daa5a65daad5df58 = $30eadc8c092f368d$export$66cb3c0e9efc61c8;
function $30eadc8c092f368d$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $30eadc8c092f368d$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $30eadc8c092f368d$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $30eadc8c092f368d$export$fac44ee5b035f737([
        $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $30eadc8c092f368d$var$clampCssByte($30eadc8c092f368d$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $30eadc8c092f368d$var$clampCssFloat($30eadc8c092f368d$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $30eadc8c092f368d$export$296e08242b78a3ec = $30eadc8c092f368d$export$3a89f8d6f6bf6c9f;
function $30eadc8c092f368d$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $30eadc8c092f368d$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $30eadc8c092f368d$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $30eadc8c092f368d$var$clampCssAngle((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(h) ? h(colorArr[0]) : h));
        s != null && (colorArr[1] = $30eadc8c092f368d$export$7638a67891c3b497((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(s) ? s(colorArr[1]) : s));
        l != null && (colorArr[2] = $30eadc8c092f368d$export$7638a67891c3b497((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(l) ? l(colorArr[2]) : l));
        return $30eadc8c092f368d$export$fac44ee5b035f737($30eadc8c092f368d$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $30eadc8c092f368d$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $30eadc8c092f368d$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $30eadc8c092f368d$var$clampCssFloat(alpha);
        return $30eadc8c092f368d$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $30eadc8c092f368d$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $30eadc8c092f368d$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $30eadc8c092f368d$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $30eadc8c092f368d$export$4385e60b38654f68() {
    return $30eadc8c092f368d$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], 'rgb');
}
var $30eadc8c092f368d$var$liftedColorCache = new (0, $cdadfc83391b9630$export$2e2bcd8739ae039)(100);
function $30eadc8c092f368d$export$2b47e247dfb87a73(color) {
    if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(color)) {
        var liftedColor = $30eadc8c092f368d$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $30eadc8c092f368d$export$590e8b2c435046d9(color, -0.1);
            $30eadc8c092f368d$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $e4c0c902d0f4f283$export$fa2c283003ed971c)(color)) {
        var ret = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $30eadc8c092f368d$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}








var $76BgN = parcelRequire("76BgN");
var $3128be478e7c4137$require$Buffer = $76BgN.Buffer;
var $3128be478e7c4137$var$mathRound = Math.round;
function $3128be478e7c4137$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === 'transparent') color = 'none';
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = (0, $30eadc8c092f368d$export$98e6a39c04603d36)(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $3128be478e7c4137$var$EPSILON = 1e-4;
function $3128be478e7c4137$export$4701367f5b4de464(transform) {
    return transform < $3128be478e7c4137$var$EPSILON && transform > -$3128be478e7c4137$var$EPSILON;
}
function $3128be478e7c4137$export$4b9074ac37ee5a23(transform) {
    return $3128be478e7c4137$var$mathRound(transform * 1e3) / 1e3;
}
function $3128be478e7c4137$export$52bfc6d3e2ff0fc2(transform) {
    return $3128be478e7c4137$var$mathRound(transform * 1e4) / 1e4;
}
function $3128be478e7c4137$export$19676ab5cb1de150(transform) {
    return $3128be478e7c4137$var$mathRound(transform * 10) / 10;
}
function $3128be478e7c4137$export$f29a4456cf56ff21(m) {
    return 'matrix(' + $3128be478e7c4137$export$4b9074ac37ee5a23(m[0]) + ',' + $3128be478e7c4137$export$4b9074ac37ee5a23(m[1]) + ',' + $3128be478e7c4137$export$4b9074ac37ee5a23(m[2]) + ',' + $3128be478e7c4137$export$4b9074ac37ee5a23(m[3]) + ',' + $3128be478e7c4137$export$52bfc6d3e2ff0fc2(m[4]) + ',' + $3128be478e7c4137$export$52bfc6d3e2ff0fc2(m[5]) + ')';
}
var $3128be478e7c4137$export$4062150f0600d971 = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function $3128be478e7c4137$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') y += lineHeight / 2;
    else if (textBaseline === 'bottom') y -= lineHeight / 2;
    return y;
}
function $3128be478e7c4137$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $3128be478e7c4137$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}
function $3128be478e7c4137$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(',');
}
function $3128be478e7c4137$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $3128be478e7c4137$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $3128be478e7c4137$export$41a28f5a000a9d0f(val) {
    return $3128be478e7c4137$export$2ade673ac4f85dfe(val) || $3128be478e7c4137$export$30352f47600a13cd(val);
}
function $3128be478e7c4137$export$7d961bca9d3b47d0(val) {
    return val.type === 'linear';
}
function $3128be478e7c4137$export$2a9cca6692a0ce3a(val) {
    return val.type === 'radial';
}
function $3128be478e7c4137$export$545e02bbd5f8fe95(val) {
    return val && (val.type === 'linear' || val.type === 'radial');
}
function $3128be478e7c4137$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $3128be478e7c4137$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $3128be478e7c4137$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $e4c0c902d0f4f283$export$bce8e055322a0ce6);
    var scaleX = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $3128be478e7c4137$var$mathRound(skewX * (0, $e4c0c902d0f4f283$export$bce8e055322a0ce6)) + "deg, " + $3128be478e7c4137$var$mathRound(skewY * (0, $e4c0c902d0f4f283$export$bce8e055322a0ce6)) + "deg)");
    return res.join(' ');
}
var $3128be478e7c4137$export$8fb536984ec8b4d7 = function() {
    if (typeof $3128be478e7c4137$require$Buffer !== 'undefined' && typeof $3128be478e7c4137$require$Buffer.from === 'function') return function(str) {
        return $3128be478e7c4137$require$Buffer.from(str).toString('base64');
    };
    if (typeof btoa === 'function' && typeof unescape === 'function' && typeof encodeURIComponent === 'function') return function(str) {
        return btoa(unescape(encodeURIComponent(str)));
    };
    return function(str) {
        return null;
    };
}();


var $e078a8fa7b44bc64$var$arraySlice = Array.prototype.slice;
function $e078a8fa7b44bc64$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $e078a8fa7b44bc64$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $e078a8fa7b44bc64$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $e078a8fa7b44bc64$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $e078a8fa7b44bc64$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $e078a8fa7b44bc64$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $e078a8fa7b44bc64$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $e078a8fa7b44bc64$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $e078a8fa7b44bc64$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $e078a8fa7b44bc64$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $e078a8fa7b44bc64$export$c5e92b7f105af84e(value) {
    if ((0, $e4c0c902d0f4f283$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $e4c0c902d0f4f283$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($e078a8fa7b44bc64$var$arraySlice.call(value[i]));
            return ret;
        }
        return $e078a8fa7b44bc64$var$arraySlice.call(value);
    }
    return value;
}
function $e078a8fa7b44bc64$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return 'rgba(' + rgba.join(',') + ')';
}
function $e078a8fa7b44bc64$var$guessArrayDim(value) {
    return (0, $e4c0c902d0f4f283$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $e078a8fa7b44bc64$var$VALUE_TYPE_NUMBER = 0;
var $e078a8fa7b44bc64$var$VALUE_TYPE_1D_ARRAY = 1;
var $e078a8fa7b44bc64$var$VALUE_TYPE_2D_ARRAY = 2;
var $e078a8fa7b44bc64$var$VALUE_TYPE_COLOR = 3;
var $e078a8fa7b44bc64$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $e078a8fa7b44bc64$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $e078a8fa7b44bc64$var$VALUE_TYPE_UNKOWN = 6;
function $e078a8fa7b44bc64$var$isGradientValueType(valType) {
    return valType === $e078a8fa7b44bc64$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $e078a8fa7b44bc64$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $e078a8fa7b44bc64$var$isArrayValueType(valType) {
    return valType === $e078a8fa7b44bc64$var$VALUE_TYPE_1D_ARRAY || valType === $e078a8fa7b44bc64$var$VALUE_TYPE_2D_ARRAY;
}
var $e078a8fa7b44bc64$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $e078a8fa7b44bc64$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $e078a8fa7b44bc64$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $e4c0c902d0f4f283$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $e078a8fa7b44bc64$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(rawValue) && !(0, $e4c0c902d0f4f283$export$7d667b9a0c48c975)(rawValue)) valType = $e078a8fa7b44bc64$var$VALUE_TYPE_NUMBER;
            else if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $e078a8fa7b44bc64$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $30eadc8c092f368d$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $e078a8fa7b44bc64$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $e4c0c902d0f4f283$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $30eadc8c092f368d$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $3128be478e7c4137$export$7d961bca9d3b47d0)(rawValue)) valType = $e078a8fa7b44bc64$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $3128be478e7c4137$export$2a9cca6692a0ce3a)(rawValue)) valType = $e078a8fa7b44bc64$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $e078a8fa7b44bc64$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(easing) ? easing : (0, $e53df830e851fea1$export$2e2bcd8739ae039)[easing] || (0, $48f0ff660a125306$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $e078a8fa7b44bc64$var$isArrayValueType(valType);
        var isGradient = $e078a8fa7b44bc64$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $e078a8fa7b44bc64$var$fillArray(value, lastValue, valType);
                else if (isGradient) $e078a8fa7b44bc64$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $e078a8fa7b44bc64$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $e078a8fa7b44bc64$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $e078a8fa7b44bc64$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $e078a8fa7b44bc64$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($e078a8fa7b44bc64$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $e078a8fa7b44bc64$var$VALUE_TYPE_1D_ARRAY ? $e078a8fa7b44bc64$var$add1DArray([], kfs[i].value, startValue, -1) : $e078a8fa7b44bc64$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $e078a8fa7b44bc64$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $e078a8fa7b44bc64$var$tmpRgba : target[propName];
        if (($e078a8fa7b44bc64$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($e078a8fa7b44bc64$var$isArrayValueType(valType)) valType === $e078a8fa7b44bc64$var$VALUE_TYPE_1D_ARRAY ? $e078a8fa7b44bc64$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $e078a8fa7b44bc64$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($e078a8fa7b44bc64$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $e078a8fa7b44bc64$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? 'linear' : 'radial',
                x: $e078a8fa7b44bc64$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $e078a8fa7b44bc64$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $e078a8fa7b44bc64$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $e078a8fa7b44bc64$var$rgba2String($e078a8fa7b44bc64$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $e078a8fa7b44bc64$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $e078a8fa7b44bc64$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $e078a8fa7b44bc64$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $e078a8fa7b44bc64$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $e078a8fa7b44bc64$var$rgba2String(targetArr);
        } else {
            var value = $e078a8fa7b44bc64$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $e078a8fa7b44bc64$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $e078a8fa7b44bc64$var$VALUE_TYPE_COLOR) {
            $30eadc8c092f368d$export$98e6a39c04603d36(target[propName], $e078a8fa7b44bc64$var$tmpRgba);
            $e078a8fa7b44bc64$var$add1DArray($e078a8fa7b44bc64$var$tmpRgba, $e078a8fa7b44bc64$var$tmpRgba, additiveValue, 1);
            target[propName] = $e078a8fa7b44bc64$var$rgba2String($e078a8fa7b44bc64$var$tmpRgba);
        } else if (valType === $e078a8fa7b44bc64$var$VALUE_TYPE_1D_ARRAY) $e078a8fa7b44bc64$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $e078a8fa7b44bc64$var$VALUE_TYPE_2D_ARRAY) $e078a8fa7b44bc64$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $e078a8fa7b44bc64$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $e4c0c902d0f4f283$export$58da9968c3170cb1)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $e078a8fa7b44bc64$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $e078a8fa7b44bc64$var$VALUE_TYPE_COLOR && initialValue) initialValue = $e078a8fa7b44bc64$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $e078a8fa7b44bc64$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $e078a8fa7b44bc64$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $dd9c41a13cbef7b5$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $e078a8fa7b44bc64$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $e078a8fa7b44bc64$export$2e2bcd8739ae039 = $e078a8fa7b44bc64$var$Animator;


function $71beffd00399d8ee$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $71beffd00399d8ee$var$Animation = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $71beffd00399d8ee$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $707ec6f7b7c4c326$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $707ec6f7b7c4c326$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $71beffd00399d8ee$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $71beffd00399d8ee$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $71beffd00399d8ee$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $e078a8fa7b44bc64$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $770990963ee378bd$export$2e2bcd8739ae039));
var $71beffd00399d8ee$export$2e2bcd8739ae039 = $71beffd00399d8ee$var$Animation;







var $5a2b3fa322e5ec14$var$TOUCH_CLICK_DELAY = 300;
var $5a2b3fa322e5ec14$var$globalEventSupported = (0, $d461075057ee3466$export$2e2bcd8739ae039).domSupported;
var $5a2b3fa322e5ec14$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $e4c0c902d0f4f283$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $5a2b3fa322e5ec14$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $5a2b3fa322e5ec14$var$wheelEventSupported = false;
function $5a2b3fa322e5ec14$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $5a2b3fa322e5ec14$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $5a2b3fa322e5ec14$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $5a2b3fa322e5ec14$var$normalizeGlobalEvent(instance, event) {
    return (0, $1aba4b63ed27962a$export$40fadb093aebad71)(instance.dom, new $5a2b3fa322e5ec14$var$FakeGlobalEvent(instance, event), true);
}
function $5a2b3fa322e5ec14$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $5a2b3fa322e5ec14$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $e4c0c902d0f4f283$export$8793edee2d425525;
        this.stopImmediatePropagation = $e4c0c902d0f4f283$export$8793edee2d425525;
        this.preventDefault = $e4c0c902d0f4f283$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $5a2b3fa322e5ec14$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function(event) {
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function(event) {
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$5a2b3fa322e5ec14$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function(event) {
        $5a2b3fa322e5ec14$var$wheelEventSupported = true;
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function(event) {
        if ($5a2b3fa322e5ec14$var$wheelEventSupported) return;
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function(event) {
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        $5a2b3fa322e5ec14$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $5a2b3fa322e5ec14$var$localDOMHandlers.mousemove.call(this, event);
        $5a2b3fa322e5ec14$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        $5a2b3fa322e5ec14$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $5a2b3fa322e5ec14$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        $5a2b3fa322e5ec14$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $5a2b3fa322e5ec14$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $5a2b3fa322e5ec14$var$TOUCH_CLICK_DELAY) $5a2b3fa322e5ec14$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $5a2b3fa322e5ec14$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$5a2b3fa322e5ec14$var$isPointerFromTouch(event)) $5a2b3fa322e5ec14$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $5a2b3fa322e5ec14$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$5a2b3fa322e5ec14$var$isPointerFromTouch(event)) $5a2b3fa322e5ec14$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$e4c0c902d0f4f283$export$79b2f7037acddd43([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $5a2b3fa322e5ec14$var$localDOMHandlers[name] = function(event) {
        event = (0, $1aba4b63ed27962a$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $5a2b3fa322e5ec14$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$5a2b3fa322e5ec14$var$isPointerFromTouch(event)) $5a2b3fa322e5ec14$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $5a2b3fa322e5ec14$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $5a2b3fa322e5ec14$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $d461075057ee3466$export$2e2bcd8739ae039).pointerEventsSupported) $e4c0c902d0f4f283$export$79b2f7037acddd43($5a2b3fa322e5ec14$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $5a2b3fa322e5ec14$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $d461075057ee3466$export$2e2bcd8739ae039).touchEventsSupported) $e4c0c902d0f4f283$export$79b2f7037acddd43($5a2b3fa322e5ec14$var$localNativeListenerNames.touch, function(nativeEventName) {
            $5a2b3fa322e5ec14$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $5a2b3fa322e5ec14$var$setTouchTimer(scope);
            });
        });
        $e4c0c902d0f4f283$export$79b2f7037acddd43($5a2b3fa322e5ec14$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $5a2b3fa322e5ec14$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $1aba4b63ed27962a$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $5a2b3fa322e5ec14$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $d461075057ee3466$export$2e2bcd8739ae039).pointerEventsSupported) $e4c0c902d0f4f283$export$79b2f7037acddd43($5a2b3fa322e5ec14$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $d461075057ee3466$export$2e2bcd8739ae039).touchEventsSupported) $e4c0c902d0f4f283$export$79b2f7037acddd43($5a2b3fa322e5ec14$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $1aba4b63ed27962a$export$4abe0e945399ac1d)(event);
            if (!$5a2b3fa322e5ec14$var$isLocalEl(instance, event.target)) {
                event = $5a2b3fa322e5ec14$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $5a2b3fa322e5ec14$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $5a2b3fa322e5ec14$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $1aba4b63ed27962a$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $5a2b3fa322e5ec14$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $1aba4b63ed27962a$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $5a2b3fa322e5ec14$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $5a2b3fa322e5ec14$var$HandlerDomProxy = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $5a2b3fa322e5ec14$var$DOMHandlerScope(dom, $5a2b3fa322e5ec14$var$localDOMHandlers);
        if ($5a2b3fa322e5ec14$var$globalEventSupported) _this._globalHandlerScope = new $5a2b3fa322e5ec14$var$DOMHandlerScope(document, $5a2b3fa322e5ec14$var$globalDOMHandlers);
        $5a2b3fa322e5ec14$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $5a2b3fa322e5ec14$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($5a2b3fa322e5ec14$var$globalEventSupported) $5a2b3fa322e5ec14$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($5a2b3fa322e5ec14$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $5a2b3fa322e5ec14$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $5a2b3fa322e5ec14$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $770990963ee378bd$export$2e2bcd8739ae039));
var $5a2b3fa322e5ec14$export$2e2bcd8739ae039 = $5a2b3fa322e5ec14$var$HandlerDomProxy;




var $f6a6510de8fe71ae$var$dpr = 1;
if ((0, $d461075057ee3466$export$2e2bcd8739ae039).hasGlobalWindow) $f6a6510de8fe71ae$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $f6a6510de8fe71ae$export$7cdcde344c85339c = 0;
var $f6a6510de8fe71ae$export$508f096bfcdaac40 = $f6a6510de8fe71ae$var$dpr;
var $f6a6510de8fe71ae$export$fd81e7ebc7dae256 = 0.4;
var $f6a6510de8fe71ae$export$f8ce94761f39398d = '#333';
var $f6a6510de8fe71ae$export$3c6e95f318c8369b = '#ccc';
var $f6a6510de8fe71ae$export$27682248795c3c6b = '#eee';







var $82e5b6aba13917b1$var$mIdentity = $97681aabb80d556d$export$f0954fd7d5368655;
var $82e5b6aba13917b1$var$EPSILON = 5e-5;
function $82e5b6aba13917b1$var$isNotAroundZero(val) {
    return val > $82e5b6aba13917b1$var$EPSILON || val < -$82e5b6aba13917b1$var$EPSILON;
}
var $82e5b6aba13917b1$var$scaleTmp = [];
var $82e5b6aba13917b1$var$tmpTransform = [];
var $82e5b6aba13917b1$var$originTransform = $97681aabb80d556d$export$185802fd694ee1f5();
var $82e5b6aba13917b1$var$abs = Math.abs;
var $82e5b6aba13917b1$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return $82e5b6aba13917b1$export$1157cd5386cdcc1b(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $82e5b6aba13917b1$var$isNotAroundZero(this.rotation) || $82e5b6aba13917b1$var$isNotAroundZero(this.x) || $82e5b6aba13917b1$var$isNotAroundZero(this.y) || $82e5b6aba13917b1$var$isNotAroundZero(this.scaleX - 1) || $82e5b6aba13917b1$var$isNotAroundZero(this.scaleY - 1) || $82e5b6aba13917b1$var$isNotAroundZero(this.skewX) || $82e5b6aba13917b1$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $82e5b6aba13917b1$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $97681aabb80d556d$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $82e5b6aba13917b1$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $97681aabb80d556d$export$6e3a27864ab166fe(m, parentTransform, m);
            else $97681aabb80d556d$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
        this.invTransform = this.invTransform || $97681aabb80d556d$export$185802fd694ee1f5();
        $97681aabb80d556d$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($82e5b6aba13917b1$var$scaleTmp);
            var relX = $82e5b6aba13917b1$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $82e5b6aba13917b1$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($82e5b6aba13917b1$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $82e5b6aba13917b1$var$scaleTmp[0] || 0;
            var sy = (($82e5b6aba13917b1$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $82e5b6aba13917b1$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $97681aabb80d556d$export$185802fd694ee1f5();
            $97681aabb80d556d$export$6e3a27864ab166fe($82e5b6aba13917b1$var$tmpTransform, parent.invTransform, m);
            m = $82e5b6aba13917b1$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $82e5b6aba13917b1$var$originTransform[4] = ox;
            $82e5b6aba13917b1$var$originTransform[5] = oy;
            $97681aabb80d556d$export$6e3a27864ab166fe($82e5b6aba13917b1$var$tmpTransform, m, $82e5b6aba13917b1$var$originTransform);
            $82e5b6aba13917b1$var$tmpTransform[4] -= ox;
            $82e5b6aba13917b1$var$tmpTransform[5] -= oy;
            m = $82e5b6aba13917b1$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $c20a2855346046a3$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $c20a2855346046a3$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $82e5b6aba13917b1$var$abs(m[0] - 1) > 1e-10 && $82e5b6aba13917b1$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($82e5b6aba13917b1$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $82e5b6aba13917b1$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $97681aabb80d556d$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $82e5b6aba13917b1$export$1157cd5386cdcc1b = $82e5b6aba13917b1$var$Transformable.getLocalTransform;
function $82e5b6aba13917b1$export$b78f9cf796c6d361() {
    return new $82e5b6aba13917b1$var$Transformable();
}
var $82e5b6aba13917b1$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'anchorX',
    'anchorY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
function $82e5b6aba13917b1$export$234b1c16dfa57d6a(target, source) {
    return (0, $e4c0c902d0f4f283$export$2b3af8009eff404f)(target, source, $82e5b6aba13917b1$export$98ab6203ec3396e2);
}
var $82e5b6aba13917b1$export$2e2bcd8739ae039 = $82e5b6aba13917b1$var$Transformable;








function $211780946ab71638$export$3c49c185de0c2bfc(text, font) {
    return $211780946ab71638$export$e6849d91c2a0b61f($211780946ab71638$export$23ef3ef10b010856(font), text);
}
function $211780946ab71638$export$23ef3ef10b010856(font) {
    if (!$211780946ab71638$var$_fontMeasureInfoCache) $211780946ab71638$var$_fontMeasureInfoCache = new (0, $cdadfc83391b9630$export$2e2bcd8739ae039)(100);
    font = font || (0, $fd1433555986e896$export$7d7a232b6d2cc80c);
    var measureInfo = $211780946ab71638$var$_fontMeasureInfoCache.get(font);
    if (!measureInfo) {
        measureInfo = {
            font: font,
            strWidthCache: new (0, $cdadfc83391b9630$export$2e2bcd8739ae039)(500),
            asciiWidthMap: null,
            asciiWidthMapTried: false,
            stWideCharWidth: (0, $fd1433555986e896$export$ef5e599365494451).measureText("\u56FD", font).width,
            asciiCharWidth: (0, $fd1433555986e896$export$ef5e599365494451).measureText('a', font).width
        };
        $211780946ab71638$var$_fontMeasureInfoCache.put(font, measureInfo);
    }
    return measureInfo;
}
var $211780946ab71638$var$_fontMeasureInfoCache;
function $211780946ab71638$var$tryCreateASCIIWidthMap(font) {
    if ($211780946ab71638$var$_getASCIIWidthMapLongCount >= $211780946ab71638$var$GET_ASCII_WIDTH_LONG_COUNT_MAX) return;
    font = font || (0, $fd1433555986e896$export$7d7a232b6d2cc80c);
    var asciiWidthMap = [];
    var start = +new Date();
    for(var code = 0; code <= 127; code++)asciiWidthMap[code] = (0, $fd1433555986e896$export$ef5e599365494451).measureText(String.fromCharCode(code), font).width;
    var cost = +new Date() - start;
    if (cost > 16) $211780946ab71638$var$_getASCIIWidthMapLongCount = $211780946ab71638$var$GET_ASCII_WIDTH_LONG_COUNT_MAX;
    else if (cost > 2) $211780946ab71638$var$_getASCIIWidthMapLongCount++;
    return asciiWidthMap;
}
var $211780946ab71638$var$_getASCIIWidthMapLongCount = 0;
var $211780946ab71638$var$GET_ASCII_WIDTH_LONG_COUNT_MAX = 5;
function $211780946ab71638$export$4e92f5603b5c7bb3(fontMeasureInfo, charCode) {
    if (!fontMeasureInfo.asciiWidthMapTried) {
        fontMeasureInfo.asciiWidthMap = $211780946ab71638$var$tryCreateASCIIWidthMap(fontMeasureInfo.font);
        fontMeasureInfo.asciiWidthMapTried = true;
    }
    return 0 <= charCode && charCode <= 127 ? fontMeasureInfo.asciiWidthMap != null ? fontMeasureInfo.asciiWidthMap[charCode] : fontMeasureInfo.asciiCharWidth : fontMeasureInfo.stWideCharWidth;
}
function $211780946ab71638$export$e6849d91c2a0b61f(fontMeasureInfo, text) {
    var strWidthCache = fontMeasureInfo.strWidthCache;
    var width = strWidthCache.get(text);
    if (width == null) {
        width = (0, $fd1433555986e896$export$ef5e599365494451).measureText(text, fontMeasureInfo.font).width;
        strWidthCache.put(text, width);
    }
    return width;
}
function $211780946ab71638$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $211780946ab71638$export$e6849d91c2a0b61f($211780946ab71638$export$23ef3ef10b010856(font), text);
    var height = $211780946ab71638$export$56204a27a2958a55(font);
    var x = $211780946ab71638$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $211780946ab71638$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $211780946ab71638$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $211780946ab71638$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $211780946ab71638$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $211780946ab71638$export$eb5a525ef00ef9a4(x, width, textAlign, inverse) {
    if (textAlign === 'right') !inverse ? x -= width : x += width;
    else if (textAlign === 'center') !inverse ? x -= width / 2 : x += width / 2;
    return x;
}
function $211780946ab71638$export$bf7d6802d2badd9(y, height, verticalAlign, inverse) {
    if (verticalAlign === 'middle') !inverse ? y -= height / 2 : y += height / 2;
    else if (verticalAlign === 'bottom') !inverse ? y -= height : y += height;
    return y;
}
function $211780946ab71638$export$56204a27a2958a55(font) {
    return $211780946ab71638$export$23ef3ef10b010856(font).stWideCharWidth;
}
function $211780946ab71638$export$866cc30a33805630(text, font) {
    return (0, $fd1433555986e896$export$ef5e599365494451).measureText(text, font);
}
function $211780946ab71638$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $211780946ab71638$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $211780946ab71638$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $211780946ab71638$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}







var $07809a3d2222d60e$export$97b5e845c7286801 = '__zr_normal__';
var $07809a3d2222d60e$var$PRIMARY_STATES_KEYS = (0, $82e5b6aba13917b1$export$98ab6203ec3396e2).concat([
    'ignore'
]);
var $07809a3d2222d60e$var$DEFAULT_ANIMATABLE_MAP = (0, $e4c0c902d0f4f283$export$533b26079ad0b4b)((0, $82e5b6aba13917b1$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $07809a3d2222d60e$var$tmpTextPosCalcRes = {};
var $07809a3d2222d60e$var$tmpBoundingRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $07809a3d2222d60e$var$tmpInnerTextTrans = [];
var $07809a3d2222d60e$export$afb92d844f688c8d = 0;
var $07809a3d2222d60e$export$f5347ae640a7f0d0 = 1;
var $07809a3d2222d60e$var$Element = function() {
    function Element(props) {
        this.id = (0, $e4c0c902d0f4f283$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            var hasPosition = textConfig.position != null;
            var autoOverflowArea = textConfig.autoOverflowArea;
            var layoutRect = void 0;
            if (autoOverflowArea || hasPosition) {
                layoutRect = $07809a3d2222d60e$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
            }
            if (hasPosition) {
                if (this.calculateTextPosition) this.calculateTextPosition($07809a3d2222d60e$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $211780946ab71638$export$eee3603b512feab7)($07809a3d2222d60e$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $07809a3d2222d60e$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $07809a3d2222d60e$var$tmpTextPosCalcRes.y;
                textAlign = $07809a3d2222d60e$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $07809a3d2222d60e$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $211780946ab71638$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $211780946ab71638$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            if (autoOverflowArea) {
                var overflowRect = innerTextDefaultStyle.overflowRect = innerTextDefaultStyle.overflowRect || new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
                innerTransformable.getLocalTransform($07809a3d2222d60e$var$tmpInnerTextTrans);
                (0, $97681aabb80d556d$export$6897c284b6f9f4dc)($07809a3d2222d60e$var$tmpInnerTextTrans, $07809a3d2222d60e$var$tmpInnerTextTrans);
                (0, $8d3017bded1ca21b$export$2e2bcd8739ae039).copy(overflowRect, layoutRect);
                overflowRect.applyTransform($07809a3d2222d60e$var$tmpInnerTextTrans);
            } else innerTextDefaultStyle.overflowRect = null;
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $f6a6510de8fe71ae$export$3c6e95f318c8369b) : (0, $f6a6510de8fe71ae$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $30eadc8c092f368d$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $30eadc8c092f368d$export$fac44ee5b035f737)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $07809a3d2222d60e$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $07809a3d2222d60e$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($07809a3d2222d60e$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $07809a3d2222d60e$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $e4c0c902d0f4f283$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var textContent = this._textContent;
        var useHoverLayer = $07809a3d2222d60e$var$shouldUseHoverLayer(this, textContent, state, forceUseHoverLayer);
        if (useHoverLayer && !this.__inHover) this.__inHover = useHoverLayer;
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, $07809a3d2222d60e$var$canTransition(this, noAnimation, animationCfg), animationCfg);
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, !!useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, !!useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this.__inHover = $07809a3d2222d60e$export$afb92d844f688c8d;
            this.__dirty &= ~(0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var textContent = this._textContent;
            var useHoverLayer = $07809a3d2222d60e$var$shouldUseHoverLayer(this, textContent, lastStateObj, forceUseHoverLayer);
            if (useHoverLayer && !this.__inHover) this.__inHover = useHoverLayer;
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, $07809a3d2222d60e$var$canTransition(this, noAnimation, animationCfg), animationCfg);
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, !!useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, !!useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this.__inHover = $07809a3d2222d60e$export$afb92d844f688c8d;
                this.__dirty &= ~(0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var el = this;
        while(el){
            if (el.silent) return true;
            var hostEl = el.__hostTarget;
            el = hostEl ? el.ignoreHostSilent ? null : hostEl : el.parent;
        }
        return false;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        if (this.__inHover === $07809a3d2222d60e$export$f5347ae640a7f0d0) return;
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $07809a3d2222d60e$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $07809a3d2222d60e$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $07809a3d2222d60e$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $82e5b6aba13917b1$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $e078a8fa7b44bc64$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $07809a3d2222d60e$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $07809a3d2222d60e$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $07809a3d2222d60e$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = elProto.silent = elProto.ignoreHostSilent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = false;
        elProto.__inHover = $07809a3d2222d60e$export$afb92d844f688c8d;
        elProto.__dirty = (0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $e4c0c902d0f4f283$export$e36fc9d62a853069)($07809a3d2222d60e$var$Element, (0, $770990963ee378bd$export$2e2bcd8739ae039));
(0, $e4c0c902d0f4f283$export$e36fc9d62a853069)($07809a3d2222d60e$var$Element, (0, $82e5b6aba13917b1$export$2e2bcd8739ae039));
function $07809a3d2222d60e$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $07809a3d2222d60e$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $07809a3d2222d60e$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $07809a3d2222d60e$var$is2DArray(value) {
    return (0, $e4c0c902d0f4f283$export$1e2f57719e155213)(value[0]);
}
function $07809a3d2222d60e$var$copyValue(target, source, key) {
    if ((0, $e4c0c902d0f4f283$export$1e2f57719e155213)(source[key])) {
        if (!(0, $e4c0c902d0f4f283$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $07809a3d2222d60e$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($07809a3d2222d60e$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $07809a3d2222d60e$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $07809a3d2222d60e$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $07809a3d2222d60e$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $e4c0c902d0f4f283$export$1e2f57719e155213)(val1) && (0, $e4c0c902d0f4f283$export$1e2f57719e155213)(val2) && $07809a3d2222d60e$var$is1DArraySame(val1, val2);
}
function $07809a3d2222d60e$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $07809a3d2222d60e$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(targetVal) && !(0, $e4c0c902d0f4f283$export$1e2f57719e155213)(targetVal) && !(0, $e4c0c902d0f4f283$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $07809a3d2222d60e$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$07809a3d2222d60e$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $e078a8fa7b44bc64$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $07809a3d2222d60e$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $e078a8fa7b44bc64$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
function $07809a3d2222d60e$var$shouldUseHoverLayer(el, textContent, nextState, forceUseHoverLayer) {
    return !(nextState && nextState.hoverLayer || forceUseHoverLayer) || $07809a3d2222d60e$var$isTextRelatedEl(el) || textContent && $07809a3d2222d60e$var$isTextRelatedEl(textContent) ? $07809a3d2222d60e$export$afb92d844f688c8d : $07809a3d2222d60e$export$f5347ae640a7f0d0;
}
function $07809a3d2222d60e$var$isTextRelatedEl(el) {
    return el.type === 'text' || el.type === 'tspan';
}
function $07809a3d2222d60e$var$canTransition(el, noAnimation, animationCfg) {
    return !noAnimation && !el.__inHover && animationCfg && animationCfg.duration > 0;
}
var $07809a3d2222d60e$export$2e2bcd8739ae039 = $07809a3d2222d60e$var$Element;



var $0c53f0d63dde8266$var$Group = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $e4c0c902d0f4f283$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $e4c0c902d0f4f283$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $8d3017bded1ca21b$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $07809a3d2222d60e$export$2e2bcd8739ae039));
$0c53f0d63dde8266$var$Group.prototype.type = 'group';
var $0c53f0d63dde8266$export$2e2bcd8739ae039 = $0c53f0d63dde8266$var$Group;


var $aae635f77c3c70af$var$painterCtors = {};
var $aae635f77c3c70af$var$instances = {};
function $aae635f77c3c70af$var$delInstance(id) {
    delete $aae635f77c3c70af$var$instances[id];
}
function $aae635f77c3c70af$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $30eadc8c092f368d$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $f6a6510de8fe71ae$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $30eadc8c092f368d$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $f6a6510de8fe71ae$export$fd81e7ebc7dae256);
    }
    return false;
}
var $aae635f77c3c70af$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = false;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $f96a98bd8a655bf7$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || 'canvas';
        if (!$aae635f77c3c70af$var$painterCtors[rendererType]) rendererType = $e4c0c902d0f4f283$export$ed97f33186d4b816($aae635f77c3c70af$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $aae635f77c3c70af$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $d461075057ee3466$export$2e2bcd8739ae039).node && !(0, $d461075057ee3466$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $5a2b3fa322e5ec14$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === 'auto' ? (0, $d461075057ee3466$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $e4c0c902d0f4f283$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $4ad45f3f2946b0f8$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $71beffd00399d8ee$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(false);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $aae635f77c3c70af$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(noAnimationUpdate) {
        if (this._disposed) return;
        this._refresh({
            animUpdate: !noAnimationUpdate,
            refresh: true,
            refreshHover: false
        });
    };
    ZRender.prototype._refresh = function(opt) {
        if (opt.animUpdate) this.animation.update(true);
        this._needsRefresh = this._needsRefreshHover = false;
        this.painter.refresh({
            refresh: opt.refresh,
            refreshHover: opt.refreshHover
        });
        this._needsRefresh = this._needsRefreshHover = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(true);
    };
    ZRender.prototype._flush = function(animationUpdate) {
        var triggerRendered;
        var start = (0, $71beffd00399d8ee$export$1428f42a7de81803)();
        var needsRefresh = this._needsRefresh;
        var needsRefreshHover = this._needsRefreshHover;
        if (needsRefresh || needsRefreshHover) {
            triggerRendered = true;
            this._refresh({
                animUpdate: animationUpdate,
                refresh: needsRefresh,
                refreshHover: needsRefreshHover
            });
        }
        var end = (0, $71beffd00399d8ee$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._refresh({
            animUpdate: false,
            refresh: false,
            refreshHover: true
        });
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $0c53f0d63dde8266$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $aae635f77c3c70af$var$delInstance(this.id);
    };
    return ZRender;
}();
function $aae635f77c3c70af$export$2cd8252107eb640b(dom, opts) {
    var zr = new $aae635f77c3c70af$var$ZRender($e4c0c902d0f4f283$export$46e8f25c7328f77e(), dom, opts);
    $aae635f77c3c70af$var$instances[zr.id] = zr;
    return zr;
}
function $aae635f77c3c70af$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $aae635f77c3c70af$export$825f692fb04800ef() {
    for(var key in $aae635f77c3c70af$var$instances)if ($aae635f77c3c70af$var$instances.hasOwnProperty(key)) $aae635f77c3c70af$var$instances[key].dispose();
    $aae635f77c3c70af$var$instances = {};
}
function $aae635f77c3c70af$export$8bedcca5bbd73999(id) {
    return $aae635f77c3c70af$var$instances[id];
}
function $aae635f77c3c70af$export$a3e793ccb11823a5(name, Ctor) {
    $aae635f77c3c70af$var$painterCtors[name] = Ctor;
}
var $aae635f77c3c70af$var$ssrDataGetter;
function $aae635f77c3c70af$export$dd7015a5412ca583(el) {
    if (typeof $aae635f77c3c70af$var$ssrDataGetter === 'function') return $aae635f77c3c70af$var$ssrDataGetter(el);
}
function $aae635f77c3c70af$export$e7a09d7fe68a4f7(getter) {
    $aae635f77c3c70af$var$ssrDataGetter = getter;
}
var $aae635f77c3c70af$export$83d89fbfd8236492 = '6.1.0';






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $0b2f7076fd7740ca$var$RADIAN_EPSILON = 1e-4;
// A `RangeError` may be thrown if `n` is out of this range when calling `toFixed(n)`.
// Although Chrome and ES2017+ have enlarged this number to 100, but we sill follow
// the ES3~ES6 spec (0 <= n <= 20) for backward and cross-platform compatibility.
var $0b2f7076fd7740ca$var$TO_FIXED_SUPPORTED_PRECISION_MAX = 20;
var $0b2f7076fd7740ca$export$8ba97c21efb02ba7 = 14;
function $0b2f7076fd7740ca$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
var $0b2f7076fd7740ca$export$e411eeaf23dccbe8 = Math.min;
var $0b2f7076fd7740ca$export$2ca8010d037f830f = Math.max;
var $0b2f7076fd7740ca$export$5860c226b237d9a6 = Math.abs;
var $0b2f7076fd7740ca$export$42cacde8c45786ff = Math.round;
var $0b2f7076fd7740ca$export$c6301bc99a7f80a7 = Math.floor;
var $0b2f7076fd7740ca$export$cf129980c996e186 = Math.ceil;
var $0b2f7076fd7740ca$export$858b42c97efc7084 = Math.pow;
var $0b2f7076fd7740ca$export$f0e980411e05f912 = Math.log;
var $0b2f7076fd7740ca$export$37fe35d0539e4a76 = Math.LN10;
var $0b2f7076fd7740ca$export$14727c6ff83b55d = Math.PI;
var $0b2f7076fd7740ca$export$9b2865e267c5db1d = Math.random;
function $0b2f7076fd7740ca$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
var $0b2f7076fd7740ca$export$e8514cb5a5e2b40f = $0b2f7076fd7740ca$export$249e1c100b47bcef;
function $0b2f7076fd7740ca$export$249e1c100b47bcef(option, percentBase, percentOffset) {
    switch(option){
        case 'center':
        case 'middle':
            option = '50%';
            break;
        case 'left':
        case 'top':
            option = '0%';
            break;
        case 'right':
        case 'bottom':
            option = '100%';
            break;
    }
    return $0b2f7076fd7740ca$export$6b392db7c2374a1a(option, percentBase, percentOffset);
}
function $0b2f7076fd7740ca$export$6b392db7c2374a1a(option, percentBase, // Typical usage of `percentOffset`: percent value is based on an specific rect rather than canvas viewport:
//  `parsePercent(percentOrAbsoluteLeft, rect.width, rect.x)`
percentOffset) {
    if ($e4c0c902d0f4f283$export$844ec244b1367d54(option)) {
        if ($0b2f7076fd7740ca$var$isOptionStringPercent(option)) return parseFloat(option) / 100 * percentBase + (percentOffset || 0);
        return parseFloat(option);
    }
    // Allow flexible input due to backward compatibility.
    return option == null ? NaN : +option;
}
function $0b2f7076fd7740ca$export$44c0eb10d342c176(option) {
    return $e4c0c902d0f4f283$export$844ec244b1367d54(option) && $0b2f7076fd7740ca$var$isOptionStringPercent(option);
}
function $0b2f7076fd7740ca$var$isOptionStringPercent(option) {
    return !!$0b2f7076fd7740ca$var$_trim(option).match(/%$/);
}
function $0b2f7076fd7740ca$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (isNaN(precision)) // precision utils (such as getAcceptableTickPrecision) may return NaN.
    return returnStr ? '' + x : +x;
    // Avoid range error
    precision = $0b2f7076fd7740ca$export$e411eeaf23dccbe8($0b2f7076fd7740ca$export$2ca8010d037f830f(0, precision), $0b2f7076fd7740ca$var$TO_FIXED_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $0b2f7076fd7740ca$export$d6af03b9b5dd06d7(x, precision, returnStr) {
    if (precision == null) precision = 10;
    return $0b2f7076fd7740ca$export$2077e0241d6afd3c(x, precision, returnStr);
}
function $0b2f7076fd7740ca$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $0b2f7076fd7740ca$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if ($0b2f7076fd7740ca$export$42cacde8c45786ff(val * e) / e === val) return i;
        }
    }
    return $0b2f7076fd7740ca$export$6d86ba4ca4984d31(val);
}
function $0b2f7076fd7740ca$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return $0b2f7076fd7740ca$export$2ca8010d037f830f(0, decimalPartLen - exp);
}
function $0b2f7076fd7740ca$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var dataQuantity = $0b2f7076fd7740ca$export$c6301bc99a7f80a7($0b2f7076fd7740ca$export$f0e980411e05f912(dataExtent[1] - dataExtent[0]) / $0b2f7076fd7740ca$export$37fe35d0539e4a76);
    var sizeQuantity = $0b2f7076fd7740ca$export$42cacde8c45786ff($0b2f7076fd7740ca$export$f0e980411e05f912($0b2f7076fd7740ca$export$5860c226b237d9a6(pixelExtent[1] - pixelExtent[0])) / $0b2f7076fd7740ca$export$37fe35d0539e4a76);
    // toFixed() digits argument must be between 0 and 20.
    var precision = $0b2f7076fd7740ca$export$e411eeaf23dccbe8($0b2f7076fd7740ca$export$2ca8010d037f830f(-dataQuantity + sizeQuantity, 0), $0b2f7076fd7740ca$var$TO_FIXED_SUPPORTED_PRECISION_MAX);
    return !isFinite(precision) ? $0b2f7076fd7740ca$var$TO_FIXED_SUPPORTED_PRECISION_MAX : precision;
}
function $0b2f7076fd7740ca$export$de3fddfc2aec84e4(dataExtent, // Typically, `Math.abs(pixelExtent[1] - pixelExtent[0])`.
pxSpan, // By default, `1`.
pxDiffAcceptable) {
    var dataSpan = $0b2f7076fd7740ca$export$5860c226b237d9a6(dataExtent[1] - dataExtent[0]);
    if (!isFinite(dataSpan) || dataSpan === 0) return NaN;
    // Formula for choosing an acceptable precision:
    //  Let `pxDiff = abs(dataSpan - round(dataSpan, precision))`.
    //  We require `pxDiff <= dataSpan * pxDiffAcceptable / pxSpan`.
    //  Consider the nature of "round", the max `pxDiff` is: `pow(10, -precision) / 2`,
    //  Hence: `pow(10, -precision) / 2 <= dataSpan * pxDiffAcceptable / pxSpan`
    //  Hence: `precision >= -log10(2 * dataSpan * pxDiffAcceptable / pxSpan)`
    var dataExp2 = $0b2f7076fd7740ca$export$f0e980411e05f912(2 * $0b2f7076fd7740ca$export$5860c226b237d9a6(pxDiffAcceptable || 1) * $0b2f7076fd7740ca$export$5860c226b237d9a6(dataSpan)) / $0b2f7076fd7740ca$export$37fe35d0539e4a76;
    var pxExp = $0b2f7076fd7740ca$export$f0e980411e05f912($0b2f7076fd7740ca$export$5860c226b237d9a6(pxSpan)) / $0b2f7076fd7740ca$export$37fe35d0539e4a76;
    // PENDING: Rounding error generally does not matter; do not fix it before `Math.ceil`
    // until bad case occur.
    var precision = $0b2f7076fd7740ca$export$2ca8010d037f830f(0, $0b2f7076fd7740ca$export$cf129980c996e186(-dataExp2 + pxExp));
    if (!isFinite(precision)) // If dataSpan is near `0`, the result should not be too big or even `Infinity`.
    precision = NaN;
    return precision;
}
function $0b2f7076fd7740ca$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $0b2f7076fd7740ca$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $0b2f7076fd7740ca$export$222dabb13d5320df(valueList, precision) {
    var sum = $e4c0c902d0f4f283$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = $0b2f7076fd7740ca$export$858b42c97efc7084(10, precision);
    var votesPerQuota = $e4c0c902d0f4f283$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $e4c0c902d0f4f283$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return $0b2f7076fd7740ca$export$c6301bc99a7f80a7(votes);
    });
    var currentSum = $e4c0c902d0f4f283$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $e4c0c902d0f4f283$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $e4c0c902d0f4f283$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $0b2f7076fd7740ca$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = $0b2f7076fd7740ca$export$2ca8010d037f830f($0b2f7076fd7740ca$export$e0c74b50bbd10f68(val0), $0b2f7076fd7740ca$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (mathRound(val0 * multiplier) + mathRound(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $0b2f7076fd7740ca$var$TO_FIXED_SUPPORTED_PRECISION_MAX ? sum : $0b2f7076fd7740ca$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $0b2f7076fd7740ca$export$18510406f204a1b9 = $0b2f7076fd7740ca$export$858b42c97efc7084(2, 53) - 1;
function $0b2f7076fd7740ca$export$2ca6dd70a288b1c3(radian) {
    var pi2 = $0b2f7076fd7740ca$export$14727c6ff83b55d * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $0b2f7076fd7740ca$export$d1df570aea2868f(val) {
    return val > -$0b2f7076fd7740ca$var$RADIAN_EPSILON && val < $0b2f7076fd7740ca$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $0b2f7076fd7740ca$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $0b2f7076fd7740ca$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($e4c0c902d0f4f283$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $0b2f7076fd7740ca$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date($0b2f7076fd7740ca$export$42cacde8c45786ff(value));
}
function $0b2f7076fd7740ca$export$82dd68b83a44b253(val) {
    return $0b2f7076fd7740ca$export$858b42c97efc7084(10, $0b2f7076fd7740ca$export$97256a17b20a0c24(val));
}
function $0b2f7076fd7740ca$export$97256a17b20a0c24(val) {
    if (val === 0) // PENDING: like IEEE754 use exponent `0` in this case.
    // but methematically, exponent of zero is `-Infinity`.
    return 0;
    var exp = $0b2f7076fd7740ca$export$c6301bc99a7f80a7($0b2f7076fd7740ca$export$f0e980411e05f912(val) / $0b2f7076fd7740ca$export$37fe35d0539e4a76);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / $0b2f7076fd7740ca$export$858b42c97efc7084(10, exp) >= 10) exp++;
    return exp;
}
var $0b2f7076fd7740ca$export$50cf7838cdf68969 = 1;
var $0b2f7076fd7740ca$export$492adb595f875f4e = 2;
function $0b2f7076fd7740ca$export$7a695fe44258210b(val, // All non-`NICE_MODE_MIN`-truthy values means `NICE_MODE_ROUND`, for backward compatibility.
mode) {
    // Consider the scientific notation of `val`:
    //  - `exponent` is its exponent.
    //  - `f` is its coefficient. `1 <= f < 10`.
    //  e.g., if `val` is `0.0054321`, `exponent` is `-3`, `f` is `5.4321`,
    //      The result is `0.005` on NICE_MODE_ROUND.
    //  e.g., if `val` is `987.12345`, `exponent` is `2`, `f` is `9.8712345`,
    //      The result is `1000` on NICE_MODE_ROUND.
    //  e.g., if `val` is `0`,
    //      The result is `1`.
    var exponent = $0b2f7076fd7740ca$export$97256a17b20a0c24(val);
    // No rounding error in Math.pow(10, integer).
    var exp10 = $0b2f7076fd7740ca$export$858b42c97efc7084(10, exponent);
    var f = val / exp10;
    var nf;
    if (mode === $0b2f7076fd7740ca$export$492adb595f875f4e) nf = 1;
    else if (mode) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix IEEE 754 float rounding error
    return $0b2f7076fd7740ca$export$2077e0241d6afd3c(val, -exponent);
}
function $0b2f7076fd7740ca$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = $0b2f7076fd7740ca$export$c6301bc99a7f80a7(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $0b2f7076fd7740ca$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $0b2f7076fd7740ca$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$e4c0c902d0f4f283$export$844ec244b1367d54(val) || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $0b2f7076fd7740ca$export$e90fb89750dba83f(val) {
    return !isNaN($0b2f7076fd7740ca$export$8b4007b942b45a96(val));
}
function $0b2f7076fd7740ca$export$474d2ec9aa44a22() {
    return $0b2f7076fd7740ca$export$42cacde8c45786ff($0b2f7076fd7740ca$export$9b2865e267c5db1d() * 9);
}
function $0b2f7076fd7740ca$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $0b2f7076fd7740ca$export$a368fd580c0d0fe4(b, a % b);
}
function $0b2f7076fd7740ca$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $0b2f7076fd7740ca$export$a368fd580c0d0fe4(a, b);
}
function $0b2f7076fd7740ca$export$b5c30d4208814a65(val) {
    return val != null && isFinite(val);
}



function $939d3a4c11ee87fd$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $939d3a4c11ee87fd$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $939d3a4c11ee87fd$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $939d3a4c11ee87fd$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $939d3a4c11ee87fd$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $939d3a4c11ee87fd$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
];
function $939d3a4c11ee87fd$export$2c944e12edb48d4b(dataItem) {
    return (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(dataItem) && !(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $939d3a4c11ee87fd$export$3e1a543f33ef6883(dataItem) {
    return (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $939d3a4c11ee87fd$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $939d3a4c11ee87fd$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $939d3a4c11ee87fd$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $939d3a4c11ee87fd$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $939d3a4c11ee87fd$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $939d3a4c11ee87fd$var$mappingInReplaceAllMode(result, newCmptOptions);
    $939d3a4c11ee87fd$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $939d3a4c11ee87fd$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $939d3a4c11ee87fd$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $939d3a4c11ee87fd$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $939d3a4c11ee87fd$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $939d3a4c11ee87fd$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$939d3a4c11ee87fd$export$feece3e7d52a102b(cmptOption) && !$939d3a4c11ee87fd$export$feece3e7d52a102b(existing) && $939d3a4c11ee87fd$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $939d3a4c11ee87fd$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $939d3a4c11ee87fd$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$939d3a4c11ee87fd$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $939d3a4c11ee87fd$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $939d3a4c11ee87fd$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $939d3a4c11ee87fd$var$makeComparableKey(opt.name) : existing ? existing.name : $939d3a4c11ee87fd$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $939d3a4c11ee87fd$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $939d3a4c11ee87fd$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $939d3a4c11ee87fd$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $939d3a4c11ee87fd$var$makeComparableKey(val) {
    return $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(val, '');
}
function $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(idOrName) || (0, $e4c0c902d0f4f283$export$29d0bb2a4e07b252)(idOrName) ? idOrName + '' : defaultValue;
}
function $939d3a4c11ee87fd$var$warnInvalidateIdOrName(idOrName) {}
function $939d3a4c11ee87fd$var$isValidIdOrName(idOrName) {
    return (0, $e4c0c902d0f4f283$export$29d0bb2a4e07b252)(idOrName) || (0, $0b2f7076fd7740ca$export$e90fb89750dba83f)(idOrName);
}
function $939d3a4c11ee87fd$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($939d3a4c11ee87fd$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $939d3a4c11ee87fd$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $939d3a4c11ee87fd$var$makeComparableKey(cmptOption.id).indexOf($939d3a4c11ee87fd$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $939d3a4c11ee87fd$export$1753133c42e665e8(idSuffix) {
    return $939d3a4c11ee87fd$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $939d3a4c11ee87fd$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $939d3a4c11ee87fd$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $939d3a4c11ee87fd$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $939d3a4c11ee87fd$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $939d3a4c11ee87fd$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $939d3a4c11ee87fd$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(payload.name) ? (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $939d3a4c11ee87fd$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $939d3a4c11ee87fd$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $939d3a4c11ee87fd$var$innerUniqueIndex = (0, $0b2f7076fd7740ca$export$474d2ec9aa44a22)();
function $939d3a4c11ee87fd$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $939d3a4c11ee87fd$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $939d3a4c11ee87fd$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $939d3a4c11ee87fd$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illegal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $939d3a4c11ee87fd$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $939d3a4c11ee87fd$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $939d3a4c11ee87fd$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $939d3a4c11ee87fd$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        if (opt.enableNone) {
            result.models = [];
            return result;
        } else indexOption = -1; // Can not query by index but may still query by id/name if specified.
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        if (opt.enableAll) indexOption = idOption = nameOption = null;
        else indexOption = -1;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $939d3a4c11ee87fd$export$c064a542e5272c93(payload, // `mainType` is mandatory to restrict the range of query,
// since `payload` in an user input.
mainType, // subType may be '' by `parseClassType`
subType) {
    var query = {};
    query[mainType + 'Id'] = payload[mainType + 'Id'];
    query[mainType + 'Index'] = payload[mainType + 'Index'];
    query[mainType + 'Name'] = payload[mainType + 'Name'];
    var condition = {
        mainType: mainType,
        query: query
    };
    subType && (condition.subType = subType); // subType is determined by `hasOwnProperty`.
    return condition;
}
function $939d3a4c11ee87fd$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $939d3a4c11ee87fd$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $939d3a4c11ee87fd$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $d461075057ee3466$export$2e2bcd8739ae039).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $939d3a4c11ee87fd$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $939d3a4c11ee87fd$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if ((0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(targetValue)) {
        var value = $939d3a4c11ee87fd$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $0b2f7076fd7740ca$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $0b2f7076fd7740ca$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $939d3a4c11ee87fd$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $0b2f7076fd7740ca$export$e0c74b50bbd10f68)(leftVal), (0, $0b2f7076fd7740ca$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}
/**
 * Use an iterator to avoid exposing the internal list or duplicating it
 * for the outside traveller, and no extra heap allocation.
 * @usage
 *  for (const it = resetIterator(); it.next();) {
 *      const item = it.item;
 *      const key = it.key;
 *      const itIdx = it.itIdx;
 *      // ...
 *  }
 * @usage
 *  const it = resetIterator();
 *  while (it.next()) { ... }
 * @usage
 *  for (resetIterator(it); it.next();) { ... }
 */ var $939d3a4c11ee87fd$export$4e38036c4470d56c = /** @class */ function() {
    function ListIterator() {}
    /**
   * The loop condition is `idx < end` if `step > 0`;
   * The loop condition is `idx >= end` if `step < 0`.
   *
   * @param end By default `list.length` if `step > 0`; `0` if `step < 0`.
   * @param step By default `1`.
   */ ListIterator.prototype.reset = function(list, start, end, step) {
        this._list = list;
        this._step = step = step || 1;
        this._idx = start;
        this._end = end != null ? end : step > 0 ? list.length : 0;
        this.item = null;
        this.key = NaN;
        return this;
    };
    ListIterator.prototype.next = function() {
        if (this._step > 0 ? this._idx < this._end : this._idx >= this._end) {
            this.item = this._list[this._idx];
            this.key = this._idx = this._idx + this._step;
            return true;
        }
        return false;
    };
    return ListIterator;
}();
function $939d3a4c11ee87fd$export$be44d6593b016f3e(model) {
    // Clear to avoid memory leak.
    model.option = model.parentModel = model.ecModel = null;
}
function $939d3a4c11ee87fd$export$62e5f07ab009f3b() {
    return [
        Infinity,
        -Infinity
    ];
}
function $939d3a4c11ee87fd$export$c28a8a63acb35a19(extent, val) {
    if ($939d3a4c11ee87fd$export$5af06089290883e2(val)) {
        val < extent[0] && (extent[0] = val);
        val > extent[1] && (extent[1] = val);
    }
}
function $939d3a4c11ee87fd$export$a7951d5427fae7a0(extent, val) {
    if ($939d3a4c11ee87fd$export$5af06089290883e2(val) && val < extent[0]) extent[0] = val;
}
function $939d3a4c11ee87fd$export$707ef09fb8bbaa0e(extent, val) {
    if ($939d3a4c11ee87fd$export$5af06089290883e2(val) && val > extent[1]) extent[1] = val;
}
function $939d3a4c11ee87fd$export$380d5a0634ac86f8(tarExtent, srcExtent) {
    // Accept both or neither.
    if ($939d3a4c11ee87fd$export$d386653f29930adb(srcExtent[0], srcExtent[1])) {
        srcExtent[0] < tarExtent[0] && (tarExtent[0] = srcExtent[0]);
        srcExtent[1] > tarExtent[1] && (tarExtent[1] = srcExtent[1]);
    }
}
function $939d3a4c11ee87fd$export$5af06089290883e2(val) {
    // Considered that number could be `NaN` and `Infinity` and should not write into the extent.
    // Note that `Infinity` is the initialized value from `initExtentForUnion` and may be inputted.
    return val != null && isFinite(val);
}
function $939d3a4c11ee87fd$export$d386653f29930adb(start, end) {
    return $939d3a4c11ee87fd$export$5af06089290883e2(start) && $939d3a4c11ee87fd$export$5af06089290883e2(end) && start <= end;
}
function $939d3a4c11ee87fd$export$622ca7efe3351d22(extent) {
    // Also considered extent may have `NaN` and `Infinity`.
    var span = extent[1] - extent[0];
    return isFinite(span) && span >= 0;
}
function $939d3a4c11ee87fd$export$fca8d858e99f6a42(extent) {
    if ($939d3a4c11ee87fd$export$d386653f29930adb(extent[0], extent[1]) && extent[0] > extent[1]) extent[0] = extent[1];
}
function $939d3a4c11ee87fd$export$a305e9b27fd23ae3() {
    var hiddenKey = '__ec_once_' + $939d3a4c11ee87fd$var$onceUniqueIndex++;
    return function(hostObj, cb) {
        if (!(0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(hostObj, hiddenKey)) {
            hostObj[hiddenKey] = 1;
            cb();
        }
    };
}
var $939d3a4c11ee87fd$var$onceUniqueIndex = (0, $0b2f7076fd7740ca$export$474d2ec9aa44a22)();
function $939d3a4c11ee87fd$export$2e2262a44ac61957(arr, getKey, // `existingCount`: the count before this item is added.
resolve) {
    var dupMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    var writeIdx = 0;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(arr, function(item) {
        var key = getKey(item);
        var count = dupMap.get(key) || 0;
        if (resolve) resolve(item, count);
        if (!count && !resolve) arr[writeIdx++] = item;
        dupMap.set(key, count + 1);
    });
    if (!resolve) arr.length = writeIdx;
}
function $939d3a4c11ee87fd$export$605c429b4975bbd7(item) {
    return item.value + '';
}
function $939d3a4c11ee87fd$export$fec5e8fdd97d769b(item) {
    return item + '';
}
function $939d3a4c11ee87fd$export$4496820b7f3d3e98(seriesModel, useIncremental) {
    // 0 means disable incremental.
    // 1 is preserved for backward compatibility.
    return (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(useIncremental, true) ? seriesModel.seriesIndex + 2 : 0;
}
function $939d3a4c11ee87fd$export$3b33f7e0868ca070(seriesModel, view, pipeline) {
    var dataLen = seriesModel.getData().count();
    return {
        progressiveRender: pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold,
        large: seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'),
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        modDataCount: seriesModel.get('progressiveChunkMode') === 'mod' ? seriesModel.getData().count() : null
    };
}
function $939d3a4c11ee87fd$export$e9d2910fc7a89b3c(// null/undefined is not allowed, otherwise bug-prone.
upstreamOutputRange, thisTaskPlannedRange) {
    (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(upstreamOutputRange.start === thisTaskPlannedRange.start && upstreamOutputRange.end === thisTaskPlannedRange.end);
}
function $939d3a4c11ee87fd$export$c635911e41d20ada(seriesType, overallReset) {
    return {
        seriesType: seriesType,
        overallReset: overallReset
    };
}
function $939d3a4c11ee87fd$export$d62c61cad9d1ab83(overallReset) {
    return {
        overallReset: overallReset
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $01f767c32eb84395$var$TYPE_DELIMITER = '.';
var $01f767c32eb84395$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $01f767c32eb84395$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $01f767c32eb84395$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($01f767c32eb84395$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $01f767c32eb84395$var$checkClassType(componentType) {
    $e4c0c902d0f4f283$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $01f767c32eb84395$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$01f767c32eb84395$var$IS_EXTENDED_CLASS]);
}
function $01f767c32eb84395$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($01f767c32eb84395$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $e4c0c902d0f4f283$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $e4c0c902d0f4f283$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$01f767c32eb84395$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $01f767c32eb84395$var$superCall;
        ExtendedClass.superApply = $01f767c32eb84395$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $01f767c32eb84395$var$isESClass(fn) {
    return $e4c0c902d0f4f283$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $01f767c32eb84395$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $01f767c32eb84395$var$classBase = Math.round(Math.random() * 10);
function $01f767c32eb84395$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $01f767c32eb84395$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $01f767c32eb84395$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $01f767c32eb84395$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $01f767c32eb84395$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $01f767c32eb84395$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $01f767c32eb84395$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $01f767c32eb84395$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$01f767c32eb84395$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $01f767c32eb84395$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$01f767c32eb84395$var$IS_CONTAINER]) $e4c0c902d0f4f283$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $01f767c32eb84395$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $01f767c32eb84395$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $e4c0c902d0f4f283$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $01f767c32eb84395$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$01f767c32eb84395$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$01f767c32eb84395$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$01f767c32eb84395$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $9d61ee6de44e4c40$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $e4c0c902d0f4f283$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $e4c0c902d0f4f283$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $7667a8c4ff8696d4$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ]
];
var $7667a8c4ff8696d4$var$getAreaStyle = (0, $9d61ee6de44e4c40$export$2e2bcd8739ae039)($7667a8c4ff8696d4$export$52de6e304d934d85);
var $7667a8c4ff8696d4$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $7667a8c4ff8696d4$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $fe811193fee9631f$var$globalImageCache = new (0, $cdadfc83391b9630$export$2e2bcd8739ae039)(50);
function $fe811193fee9631f$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $fe811193fee9631f$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $fe811193fee9631f$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $fe811193fee9631f$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$fe811193fee9631f$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $fd1433555986e896$export$ef5e599365494451).loadImage(newImageOrSrc, $fe811193fee9631f$var$imageOnLoad, $fe811193fee9631f$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $fe811193fee9631f$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $fe811193fee9631f$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $fe811193fee9631f$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}





var $2f165f94ff51cf78$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $2f165f94ff51cf78$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    var out = {};
    $2f165f94ff51cf78$var$truncateText2(out, text, containerWidth, font, ellipsis, options);
    return out.text;
}
function $2f165f94ff51cf78$var$truncateText2(out, text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        out.text = '';
        out.isTruncated = false;
        return;
    }
    var textLines = (text + '').split('\n');
    options = $2f165f94ff51cf78$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    var isTruncated = false;
    var truncateOut = {};
    for(var i = 0, len = textLines.length; i < len; i++){
        $2f165f94ff51cf78$var$truncateSingleLine(truncateOut, textLines[i], options);
        textLines[i] = truncateOut.textLine;
        isTruncated = isTruncated || truncateOut.isTruncated;
    }
    out.text = textLines.join('\n');
    out.isTruncated = isTruncated;
}
function $2f165f94ff51cf78$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, options);
    ellipsis = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(options.minChar, 0);
    var fontMeasureInfo = preparedOpts.fontMeasureInfo = (0, $211780946ab71638$export$23ef3ef10b010856)(font);
    var ascCharWidth = fontMeasureInfo.asciiCharWidth;
    preparedOpts.placeholder = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $211780946ab71638$export$e6849d91c2a0b61f)(fontMeasureInfo, ellipsis);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $2f165f94ff51cf78$var$truncateSingleLine(out, textLine, options) {
    var containerWidth = options.containerWidth;
    var contentWidth = options.contentWidth;
    var fontMeasureInfo = options.fontMeasureInfo;
    if (!containerWidth) {
        out.textLine = '';
        out.isTruncated = false;
        return;
    }
    var lineWidth = (0, $211780946ab71638$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    if (lineWidth <= containerWidth) {
        out.textLine = textLine;
        out.isTruncated = false;
        return;
    }
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $2f165f94ff51cf78$var$estimateLength(textLine, contentWidth, fontMeasureInfo) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $211780946ab71638$export$e6849d91c2a0b61f)(fontMeasureInfo, textLine);
    }
    if (textLine === '') textLine = options.placeholder;
    out.textLine = textLine;
    out.isTruncated = true;
}
function $2f165f94ff51cf78$var$estimateLength(text, contentWidth, fontMeasureInfo) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++)width += (0, $211780946ab71638$export$4e92f5603b5c7bb3)(fontMeasureInfo, text.charCodeAt(i));
    return i;
}
function $2f165f94ff51cf78$export$5772575e34ef80f9(rawText, style, defaultOuterWidth, defaultOuterHeight) {
    var text = $2f165f94ff51cf78$var$formatText(rawText);
    var overflow = style.overflow;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var paddingV = padding ? padding[0] + padding[2] : 0;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $211780946ab71638$export$56204a27a2958a55)(font);
    var lineHeight = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var isTruncated = false;
    var width = style.width;
    if (width == null && defaultOuterWidth != null) width = defaultOuterWidth - paddingH;
    var height = style.height;
    if (height == null && defaultOuterHeight != null) height = defaultOuterHeight - paddingV;
    var lines;
    if (width != null && (overflow === 'break' || overflow === 'breakAll')) lines = text ? $2f165f94ff51cf78$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    if (height == null) height = contentHeight;
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        isTruncated = isTruncated || lines.length > lineCount;
        lines = lines.slice(0, lineCount);
        contentHeight = lines.length * lineHeight;
    }
    if (text && truncate && width != null) {
        var options = $2f165f94ff51cf78$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        var singleOut = {};
        for(var i = 0; i < lines.length; i++){
            $2f165f94ff51cf78$var$truncateSingleLine(singleOut, lines[i], options);
            lines[i] = singleOut.textLine;
            isTruncated = isTruncated || singleOut.isTruncated;
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    var fontMeasureInfo = (0, $211780946ab71638$export$23ef3ef10b010856)(font);
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $211780946ab71638$export$e6849d91c2a0b61f)(fontMeasureInfo, lines[i]), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = width;
    outerHeight += paddingV;
    outerWidth += paddingH;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width,
        isTruncated: isTruncated
    };
}
var $2f165f94ff51cf78$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $2f165f94ff51cf78$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $2f165f94ff51cf78$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
        this.isTruncated = false;
    }
    return RichTextContentBlock;
}();
function $2f165f94ff51cf78$export$15ec9472ff2d721(rawText, style, defaultOuterWidth, defaultOuterHeight, topTextAlign) {
    var contentBlock = new $2f165f94ff51cf78$export$ca607d3c98caaf7e();
    var text = $2f165f94ff51cf78$var$formatText(rawText);
    if (!text) return contentBlock;
    var stlPadding = style.padding;
    var stlPaddingH = stlPadding ? stlPadding[1] + stlPadding[3] : 0;
    var stlPaddingV = stlPadding ? stlPadding[0] + stlPadding[2] : 0;
    var topWidth = style.width;
    if (topWidth == null && defaultOuterWidth != null) topWidth = defaultOuterWidth - stlPaddingH;
    var topHeight = style.height;
    if (topHeight == null && defaultOuterHeight != null) topHeight = defaultOuterHeight - stlPaddingV;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $2f165f94ff51cf78$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $2f165f94ff51cf78$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $2f165f94ff51cf78$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $2f165f94ff51cf78$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $2f165f94ff51cf78$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $2f165f94ff51cf78$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    var tmpTruncateOut = {};
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $211780946ab71638$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $e4c0c902d0f4f283$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || topTextAlign;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                var originalLength = contentBlock.lines.length;
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                contentBlock.isTruncated = contentBlock.isTruncated || contentBlock.lines.length < originalLength;
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $211780946ab71638$export$e6849d91c2a0b61f)((0, $211780946ab71638$export$23ef3ef10b010856)(font), token.text);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $fe811193fee9631f$export$1b614f30ac2c8867(bgImg);
                        if ($fe811193fee9631f$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        $2f165f94ff51cf78$var$truncateText2(tmpTruncateOut, token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.text = tmpTruncateOut.text;
                        contentBlock.isTruncated = contentBlock.isTruncated || tmpTruncateOut.isTruncated;
                        token.width = token.contentWidth = (0, $211780946ab71638$export$e6849d91c2a0b61f)((0, $211780946ab71638$export$23ef3ef10b010856)(font), token.text);
                    }
                } else token.contentWidth = (0, $211780946ab71638$export$e6849d91c2a0b61f)((0, $211780946ab71638$export$23ef3ef10b010856)(font), token.text);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    contentBlock.outerWidth += stlPaddingH;
    contentBlock.outerHeight += stlPaddingV;
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $2f165f94ff51cf78$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $211780946ab71638$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $2f165f94ff51cf78$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    }
    if (!strLines) strLines = str.split('\n');
    var fontMeasureInfo = (0, $211780946ab71638$export$23ef3ef10b010856)(font);
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $2f165f94ff51cf78$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $211780946ab71638$export$e6849d91c2a0b61f)(fontMeasureInfo, text);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $2f165f94ff51cf78$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $2f165f94ff51cf78$var$RichTextLine([
            token
        ]));
    }
}
function $2f165f94ff51cf78$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $2f165f94ff51cf78$var$breakCharMap = (0, $e4c0c902d0f4f283$export$533b26079ad0b4b)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $2f165f94ff51cf78$var$isWordBreakChar(ch) {
    if ($2f165f94ff51cf78$var$isAlphabeticLetter(ch)) {
        if ($2f165f94ff51cf78$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $2f165f94ff51cf78$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    var fontMeasureInfo = (0, $211780946ab71638$export$23ef3ef10b010856)(font);
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $211780946ab71638$export$4e92f5603b5c7bb3)(fontMeasureInfo, ch.charCodeAt(0));
        var inWord = isBreakAll ? false : !$2f165f94ff51cf78$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}
function $2f165f94ff51cf78$export$9a4428591d825b14(out, overflowRect, baseX, baseY, textAlign, textVerticalAlign) {
    out.baseX = baseX;
    out.baseY = baseY;
    out.outerWidth = out.outerHeight = null;
    if (!overflowRect) return;
    var textWidth = overflowRect.width * 2;
    var textHeight = overflowRect.height * 2;
    (0, $8d3017bded1ca21b$export$2e2bcd8739ae039).set($2f165f94ff51cf78$var$tmpCITCTextRect, (0, $211780946ab71638$export$eb5a525ef00ef9a4)(baseX, textWidth, textAlign), (0, $211780946ab71638$export$bf7d6802d2badd9)(baseY, textHeight, textVerticalAlign), textWidth, textHeight);
    (0, $8d3017bded1ca21b$export$2e2bcd8739ae039).intersect(overflowRect, $2f165f94ff51cf78$var$tmpCITCTextRect, null, $2f165f94ff51cf78$var$tmpCITCIntersectRectOpt);
    var outIntersectRect = $2f165f94ff51cf78$var$tmpCITCIntersectRectOpt.outIntersectRect;
    out.outerWidth = outIntersectRect.width;
    out.outerHeight = outIntersectRect.height;
    out.baseX = (0, $211780946ab71638$export$eb5a525ef00ef9a4)(outIntersectRect.x, outIntersectRect.width, textAlign, true);
    out.baseY = (0, $211780946ab71638$export$bf7d6802d2badd9)(outIntersectRect.y, outIntersectRect.height, textVerticalAlign, true);
}
var $2f165f94ff51cf78$var$tmpCITCTextRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $2f165f94ff51cf78$var$tmpCITCIntersectRectOpt = {
    outIntersectRect: {},
    clamp: true
};
function $2f165f94ff51cf78$var$formatText(text) {
    return text != null ? text += '' : text = '';
}
function $2f165f94ff51cf78$export$d79289ac0f53b974(style) {
    var text = $2f165f94ff51cf78$var$formatText(style.text);
    var font = style.font;
    var contentWidth = (0, $211780946ab71638$export$e6849d91c2a0b61f)((0, $211780946ab71638$export$23ef3ef10b010856)(font), text);
    var contentHeight = (0, $211780946ab71638$export$56204a27a2958a55)(font);
    return $2f165f94ff51cf78$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, null);
}
function $2f165f94ff51cf78$export$bd5d12d7bf7c9027(style, contentWidth, contentHeight, forceLineWidth) {
    var rect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)((0, $211780946ab71638$export$eb5a525ef00ef9a4)(style.x || 0, contentWidth, style.textAlign), (0, $211780946ab71638$export$bf7d6802d2badd9)(style.y || 0, contentHeight, style.textBaseline), contentWidth, contentHeight);
    var lineWidth = forceLineWidth != null ? forceLineWidth : $2f165f94ff51cf78$export$c7aae0ffd99a8643(style) ? style.lineWidth : 0;
    if (lineWidth > 0) {
        rect.x -= lineWidth / 2;
        rect.y -= lineWidth / 2;
        rect.width += lineWidth;
        rect.height += lineWidth;
    }
    return rect;
}
function $2f165f94ff51cf78$export$c7aae0ffd99a8643(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== 'none' && style.lineWidth > 0;
}








var $4aa50d5371582059$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $4aa50d5371582059$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $4aa50d5371582059$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$4aa50d5371582059$export$737672163db00fe3[$4aa50d5371582059$var$STYLE_MAGIC_KEY] = true;
var $4aa50d5371582059$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $4aa50d5371582059$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $4aa50d5371582059$var$Displayable = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function(param) {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $4aa50d5371582059$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths && this.__clipPaths.length) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $8d3017bded1ca21b$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $be8577c7cd53a73f$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $be8577c7cd53a73f$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $be8577c7cd53a73f$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $e4c0c902d0f4f283$export$79c7e160a7743efd)($4aa50d5371582059$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$4aa50d5371582059$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype._useHoverStyle = function(obj) {
        this.__hoverStyle = obj;
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$4aa50d5371582059$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $4aa50d5371582059$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var inHoverOnlyStyleChange = this.__inHover === (0, $07809a3d2222d60e$export$f5347ae640a7f0d0);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else if (inHoverOnlyStyleChange) this._useHoverStyle(targetStyle);
            else this.useStyle(targetStyle);
        }
        if (!inHoverOnlyStyleChange) {
            var statesKeys = this.__inHover ? $4aa50d5371582059$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $4aa50d5371582059$var$PRIMARY_STATES_KEYS;
            for(var i = 0; i < statesKeys.length; i++){
                var key = statesKeys[i];
                if (state && state[key] != null) this[key] = state[key];
                else if (needsRestoreToNormal) {
                    if (normalState[key] != null) this[key] = normalState[key];
                }
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $4aa50d5371582059$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = 0;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd) | (0, $be8577c7cd53a73f$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $07809a3d2222d60e$export$2e2bcd8739ae039));
var $4aa50d5371582059$var$tmpRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $4aa50d5371582059$var$viewRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $4aa50d5371582059$var$isDisplayableCulled(el, width, height) {
    $4aa50d5371582059$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $4aa50d5371582059$var$tmpRect.applyTransform(el.transform);
    $4aa50d5371582059$var$viewRect.width = width;
    $4aa50d5371582059$var$viewRect.height = height;
    return !$4aa50d5371582059$var$tmpRect.intersect($4aa50d5371582059$var$viewRect);
}
var $4aa50d5371582059$export$2e2bcd8739ae039 = $4aa50d5371582059$var$Displayable;










var $f61a58690caca8b6$var$mathMin = Math.min;
var $f61a58690caca8b6$var$mathMax = Math.max;
var $f61a58690caca8b6$var$mathSin = Math.sin;
var $f61a58690caca8b6$var$mathCos = Math.cos;
var $f61a58690caca8b6$var$PI2 = Math.PI * 2;
var $f61a58690caca8b6$var$start = $c20a2855346046a3$export$185802fd694ee1f5();
var $f61a58690caca8b6$var$end = $c20a2855346046a3$export$185802fd694ee1f5();
var $f61a58690caca8b6$var$extremity = $c20a2855346046a3$export$185802fd694ee1f5();
function $f61a58690caca8b6$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $f61a58690caca8b6$var$mathMin(left, p[0]);
        right = $f61a58690caca8b6$var$mathMax(right, p[0]);
        top = $f61a58690caca8b6$var$mathMin(top, p[1]);
        bottom = $f61a58690caca8b6$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $f61a58690caca8b6$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $f61a58690caca8b6$var$mathMin(x0, x1);
    min[1] = $f61a58690caca8b6$var$mathMin(y0, y1);
    max[0] = $f61a58690caca8b6$var$mathMax(x0, x1);
    max[1] = $f61a58690caca8b6$var$mathMax(y0, y1);
}
var $f61a58690caca8b6$var$xDim = [];
var $f61a58690caca8b6$var$yDim = [];
function $f61a58690caca8b6$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $7734ff3f5891b22b$export$df1a172f100d0457;
    var cubicAt = $7734ff3f5891b22b$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $f61a58690caca8b6$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $f61a58690caca8b6$var$xDim[i]);
        min[0] = $f61a58690caca8b6$var$mathMin(x, min[0]);
        max[0] = $f61a58690caca8b6$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $f61a58690caca8b6$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $f61a58690caca8b6$var$yDim[i]);
        min[1] = $f61a58690caca8b6$var$mathMin(y, min[1]);
        max[1] = $f61a58690caca8b6$var$mathMax(y, max[1]);
    }
    min[0] = $f61a58690caca8b6$var$mathMin(x0, min[0]);
    max[0] = $f61a58690caca8b6$var$mathMax(x0, max[0]);
    min[0] = $f61a58690caca8b6$var$mathMin(x3, min[0]);
    max[0] = $f61a58690caca8b6$var$mathMax(x3, max[0]);
    min[1] = $f61a58690caca8b6$var$mathMin(y0, min[1]);
    max[1] = $f61a58690caca8b6$var$mathMax(y0, max[1]);
    min[1] = $f61a58690caca8b6$var$mathMin(y3, min[1]);
    max[1] = $f61a58690caca8b6$var$mathMax(y3, max[1]);
}
function $f61a58690caca8b6$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $7734ff3f5891b22b$export$752e1f8c6e7f7e11;
    var quadraticAt = $7734ff3f5891b22b$export$af17094a950f5073;
    var tx = $f61a58690caca8b6$var$mathMax($f61a58690caca8b6$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $f61a58690caca8b6$var$mathMax($f61a58690caca8b6$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $f61a58690caca8b6$var$mathMin(x0, x2, x);
    min[1] = $f61a58690caca8b6$var$mathMin(y0, y2, y);
    max[0] = $f61a58690caca8b6$var$mathMax(x0, x2, x);
    max[1] = $f61a58690caca8b6$var$mathMax(y0, y2, y);
}
function $f61a58690caca8b6$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $c20a2855346046a3$export$96ec731ed4dcb222;
    var vec2Max = $c20a2855346046a3$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $f61a58690caca8b6$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $f61a58690caca8b6$var$start[0] = $f61a58690caca8b6$var$mathCos(startAngle) * rx + x;
    $f61a58690caca8b6$var$start[1] = $f61a58690caca8b6$var$mathSin(startAngle) * ry + y;
    $f61a58690caca8b6$var$end[0] = $f61a58690caca8b6$var$mathCos(endAngle) * rx + x;
    $f61a58690caca8b6$var$end[1] = $f61a58690caca8b6$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $f61a58690caca8b6$var$start, $f61a58690caca8b6$var$end);
    vec2Max(max, $f61a58690caca8b6$var$start, $f61a58690caca8b6$var$end);
    startAngle = startAngle % $f61a58690caca8b6$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $f61a58690caca8b6$var$PI2;
    endAngle = endAngle % $f61a58690caca8b6$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $f61a58690caca8b6$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $f61a58690caca8b6$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $f61a58690caca8b6$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $f61a58690caca8b6$var$extremity[0] = $f61a58690caca8b6$var$mathCos(angle) * rx + x;
        $f61a58690caca8b6$var$extremity[1] = $f61a58690caca8b6$var$mathSin(angle) * ry + y;
        vec2Min(min, $f61a58690caca8b6$var$extremity, min);
        vec2Max(max, $f61a58690caca8b6$var$extremity, max);
    }
}



var $4454211f949588ae$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $4454211f949588ae$var$tmpOutX = [];
var $4454211f949588ae$var$tmpOutY = [];
var $4454211f949588ae$var$min = [];
var $4454211f949588ae$var$max = [];
var $4454211f949588ae$var$min2 = [];
var $4454211f949588ae$var$max2 = [];
var $4454211f949588ae$var$mathMin = Math.min;
var $4454211f949588ae$var$mathMax = Math.max;
var $4454211f949588ae$var$mathCos = Math.cos;
var $4454211f949588ae$var$mathSin = Math.sin;
var $4454211f949588ae$var$mathAbs = Math.abs;
var $4454211f949588ae$var$PI = Math.PI;
var $4454211f949588ae$var$PI2 = $4454211f949588ae$var$PI * 2;
var $4454211f949588ae$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $4454211f949588ae$var$tmpAngles = [];
function $4454211f949588ae$var$modPI2(radian) {
    var n = Math.round(radian / $4454211f949588ae$var$PI * 1e8) / 1e8;
    return n % 2 * $4454211f949588ae$var$PI;
}
function $4454211f949588ae$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $4454211f949588ae$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $4454211f949588ae$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $4454211f949588ae$var$PI2) newEndAngle = newStartAngle + $4454211f949588ae$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $4454211f949588ae$var$PI2) newEndAngle = newStartAngle - $4454211f949588ae$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($4454211f949588ae$var$PI2 - $4454211f949588ae$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($4454211f949588ae$var$PI2 - $4454211f949588ae$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $4454211f949588ae$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $4454211f949588ae$var$mathAbs(segmentIgnoreThreshold / (0, $f6a6510de8fe71ae$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $4454211f949588ae$var$mathAbs(segmentIgnoreThreshold / (0, $f6a6510de8fe71ae$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($4454211f949588ae$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $4454211f949588ae$var$mathAbs(x - this._xi);
        var dy = $4454211f949588ae$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($4454211f949588ae$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($4454211f949588ae$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($4454211f949588ae$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $4454211f949588ae$var$tmpAngles[0] = startAngle;
        $4454211f949588ae$var$tmpAngles[1] = endAngle;
        $4454211f949588ae$export$bc668021e937022a($4454211f949588ae$var$tmpAngles, anticlockwise);
        startAngle = $4454211f949588ae$var$tmpAngles[0];
        endAngle = $4454211f949588ae$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($4454211f949588ae$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $4454211f949588ae$var$mathCos(endAngle) * r + cx;
        this._yi = $4454211f949588ae$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($4454211f949588ae$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($4454211f949588ae$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        if (!this._saveData) return;
        var len = data.length;
        if (!(this.data && this.data.length === len) && $4454211f949588ae$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!this._saveData) return;
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        var oldData = this.data;
        if ($4454211f949588ae$var$hasTypedArray && (oldData instanceof Float32Array || !oldData)) {
            this.data = new Float32Array(offset + appendSize);
            if (offset > 0 && oldData) for(var k = 0; k < offset; k++)this.data[k] = oldData[k];
        }
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($4454211f949588ae$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $4454211f949588ae$var$min[0] = $4454211f949588ae$var$min[1] = $4454211f949588ae$var$min2[0] = $4454211f949588ae$var$min2[1] = Number.MAX_VALUE;
        $4454211f949588ae$var$max[0] = $4454211f949588ae$var$max[1] = $4454211f949588ae$var$max2[0] = $4454211f949588ae$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $4454211f949588ae$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $4454211f949588ae$var$min2[0] = x0;
                    $4454211f949588ae$var$min2[1] = y0;
                    $4454211f949588ae$var$max2[0] = x0;
                    $4454211f949588ae$var$max2[1] = y0;
                    break;
                case $4454211f949588ae$var$CMD.L:
                    (0, $f61a58690caca8b6$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $4454211f949588ae$var$min2, $4454211f949588ae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $4454211f949588ae$var$CMD.C:
                    (0, $f61a58690caca8b6$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $4454211f949588ae$var$min2, $4454211f949588ae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $4454211f949588ae$var$CMD.Q:
                    (0, $f61a58690caca8b6$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $4454211f949588ae$var$min2, $4454211f949588ae$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $4454211f949588ae$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $4454211f949588ae$var$mathCos(startAngle) * rx + cx;
                        y0 = $4454211f949588ae$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $f61a58690caca8b6$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $4454211f949588ae$var$min2, $4454211f949588ae$var$max2);
                    xi = $4454211f949588ae$var$mathCos(endAngle) * rx + cx;
                    yi = $4454211f949588ae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $4454211f949588ae$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $f61a58690caca8b6$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $4454211f949588ae$var$min2, $4454211f949588ae$var$max2);
                    break;
                case $4454211f949588ae$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $c20a2855346046a3$export$96ec731ed4dcb222($4454211f949588ae$var$min, $4454211f949588ae$var$min, $4454211f949588ae$var$min2);
            $c20a2855346046a3$export$8960430cfd85939f($4454211f949588ae$var$max, $4454211f949588ae$var$max, $4454211f949588ae$var$max2);
        }
        if (i === 0) $4454211f949588ae$var$min[0] = $4454211f949588ae$var$min[1] = $4454211f949588ae$var$max[0] = $4454211f949588ae$var$max[1] = 0;
        return new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)($4454211f949588ae$var$min[0], $4454211f949588ae$var$min[1], $4454211f949588ae$var$max[0] - $4454211f949588ae$var$min[0], $4454211f949588ae$var$max[1] - $4454211f949588ae$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $4454211f949588ae$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $4454211f949588ae$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($4454211f949588ae$var$mathAbs(dx) > ux || $4454211f949588ae$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $4454211f949588ae$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $7734ff3f5891b22b$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $4454211f949588ae$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $7734ff3f5891b22b$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $4454211f949588ae$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $4454211f949588ae$var$mathCos(startAngle) * rx + cx;
                        y0 = $4454211f949588ae$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $4454211f949588ae$var$mathMax(rx, ry) * $4454211f949588ae$var$mathMin($4454211f949588ae$var$PI2, Math.abs(delta));
                    xi = $4454211f949588ae$var$mathCos(endAngle) * rx + cx;
                    yi = $4454211f949588ae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $4454211f949588ae$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $4454211f949588ae$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $4454211f949588ae$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $4454211f949588ae$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $4454211f949588ae$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $4454211f949588ae$var$mathAbs(x - xi);
                    var dy = $4454211f949588ae$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $4454211f949588ae$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $7734ff3f5891b22b$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $4454211f949588ae$var$tmpOutX);
                            (0, $7734ff3f5891b22b$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $4454211f949588ae$var$tmpOutY);
                            ctx.bezierCurveTo($4454211f949588ae$var$tmpOutX[1], $4454211f949588ae$var$tmpOutY[1], $4454211f949588ae$var$tmpOutX[2], $4454211f949588ae$var$tmpOutY[2], $4454211f949588ae$var$tmpOutX[3], $4454211f949588ae$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $4454211f949588ae$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $7734ff3f5891b22b$export$117c659e21a7a060)(xi, x1, x2, t, $4454211f949588ae$var$tmpOutX);
                            (0, $7734ff3f5891b22b$export$117c659e21a7a060)(yi, y1, y2, t, $4454211f949588ae$var$tmpOutY);
                            ctx.quadraticCurveTo($4454211f949588ae$var$tmpOutX[1], $4454211f949588ae$var$tmpOutY[1], $4454211f949588ae$var$tmpOutX[2], $4454211f949588ae$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $4454211f949588ae$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $4454211f949588ae$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $4454211f949588ae$var$mathCos(startAngle) * rx + cx;
                        y0 = $4454211f949588ae$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $4454211f949588ae$var$mathCos(endAngle) * rx + cx;
                    yi = $4454211f949588ae$var$mathSin(endAngle) * ry + cy;
                    break;
                case $4454211f949588ae$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $4454211f949588ae$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $4454211f949588ae$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $4454211f949588ae$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $4454211f949588ae$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $4454211f949588ae$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.prototype.canSave = function() {
        return !!this._saveData;
    };
    PathProxy.CMD = $4454211f949588ae$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $4454211f949588ae$export$2e2bcd8739ae039 = $4454211f949588ae$var$PathProxy;



function $cec13a07527b11b6$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $94f691eb8df89e0e$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $7734ff3f5891b22b$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $62a4dca530904546$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $7734ff3f5891b22b$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $f7fc7515c998ef35$var$PI2 = Math.PI * 2;
function $f7fc7515c998ef35$export$d44861331f213635(angle) {
    angle %= $f7fc7515c998ef35$var$PI2;
    if (angle < 0) angle += $f7fc7515c998ef35$var$PI2;
    return angle;
}


var $e5597369e2d6b8aa$var$PI2 = Math.PI * 2;
function $e5597369e2d6b8aa$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $e5597369e2d6b8aa$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $f7fc7515c998ef35$export$d44861331f213635)(endAngle);
        endAngle = (0, $f7fc7515c998ef35$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $f7fc7515c998ef35$export$d44861331f213635)(startAngle);
        endAngle = (0, $f7fc7515c998ef35$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $e5597369e2d6b8aa$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $e5597369e2d6b8aa$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $e5597369e2d6b8aa$var$PI2 >= startAngle && angle + $e5597369e2d6b8aa$var$PI2 <= endAngle;
}



function $5bacf484cf37a266$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $e67a332329073f5c$var$CMD = (0, $4454211f949588ae$export$2e2bcd8739ae039).CMD;
var $e67a332329073f5c$var$PI2 = Math.PI * 2;
var $e67a332329073f5c$var$EPSILON = 1e-4;
function $e67a332329073f5c$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $e67a332329073f5c$var$EPSILON;
}
var $e67a332329073f5c$var$roots = [
    -1,
    -1,
    -1
];
var $e67a332329073f5c$var$extrema = [
    -1,
    -1
];
function $e67a332329073f5c$var$swapExtrema() {
    var tmp = $e67a332329073f5c$var$extrema[0];
    $e67a332329073f5c$var$extrema[0] = $e67a332329073f5c$var$extrema[1];
    $e67a332329073f5c$var$extrema[1] = tmp;
}
function $e67a332329073f5c$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $7734ff3f5891b22b$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $e67a332329073f5c$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $e67a332329073f5c$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $7734ff3f5891b22b$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $7734ff3f5891b22b$export$df1a172f100d0457(y0, y1, y2, y3, $e67a332329073f5c$var$extrema);
                if ($e67a332329073f5c$var$extrema[1] < $e67a332329073f5c$var$extrema[0] && nExtrema > 1) $e67a332329073f5c$var$swapExtrema();
                y0_ = $7734ff3f5891b22b$export$547c21de482bbcb2(y0, y1, y2, y3, $e67a332329073f5c$var$extrema[0]);
                if (nExtrema > 1) y1_ = $7734ff3f5891b22b$export$547c21de482bbcb2(y0, y1, y2, y3, $e67a332329073f5c$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $e67a332329073f5c$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $e67a332329073f5c$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $e67a332329073f5c$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $e67a332329073f5c$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $7734ff3f5891b22b$export$fd895ac7ee764967(y0, y1, y2, y, $e67a332329073f5c$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $7734ff3f5891b22b$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $7734ff3f5891b22b$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $e67a332329073f5c$var$roots[i] === 0 || $e67a332329073f5c$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $7734ff3f5891b22b$export$af17094a950f5073(x0, x1, x2, $e67a332329073f5c$var$roots[i]);
                if (x_ < x) continue;
                if ($e67a332329073f5c$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $e67a332329073f5c$var$roots[0] === 0 || $e67a332329073f5c$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $7734ff3f5891b22b$export$af17094a950f5073(x0, x1, x2, $e67a332329073f5c$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $e67a332329073f5c$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $e67a332329073f5c$var$roots[0] = -tmp;
    $e67a332329073f5c$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $e67a332329073f5c$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $e67a332329073f5c$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $e67a332329073f5c$var$roots[0] + cx && x <= $e67a332329073f5c$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $e67a332329073f5c$var$PI2;
        endAngle += $e67a332329073f5c$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $e67a332329073f5c$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $e67a332329073f5c$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $e67a332329073f5c$var$PI2 >= startAngle && angle + $e67a332329073f5c$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $e67a332329073f5c$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $e67a332329073f5c$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $5bacf484cf37a266$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $e67a332329073f5c$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $e67a332329073f5c$var$CMD.L:
                if (isStroke) {
                    if ($cec13a07527b11b6$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $5bacf484cf37a266$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e67a332329073f5c$var$CMD.C:
                if (isStroke) {
                    if ($94f691eb8df89e0e$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $e67a332329073f5c$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e67a332329073f5c$var$CMD.Q:
                if (isStroke) {
                    if ($62a4dca530904546$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $e67a332329073f5c$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $e67a332329073f5c$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $5bacf484cf37a266$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($e5597369e2d6b8aa$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $e67a332329073f5c$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $e67a332329073f5c$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($cec13a07527b11b6$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $cec13a07527b11b6$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $cec13a07527b11b6$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $cec13a07527b11b6$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $5bacf484cf37a266$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $5bacf484cf37a266$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $e67a332329073f5c$var$CMD.Z:
                if (isStroke) {
                    if ($cec13a07527b11b6$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $5bacf484cf37a266$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$e67a332329073f5c$var$isAroundEqual(yi, y0)) w += (0, $5bacf484cf37a266$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $e67a332329073f5c$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $e67a332329073f5c$var$containPath(pathProxy, 0, false, x, y);
}
function $e67a332329073f5c$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $e67a332329073f5c$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $27b47789cc8143e1$export$deade517576e293a = (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $4aa50d5371582059$export$737672163db00fe3));
var $27b47789cc8143e1$export$71bb6c3c6862c6a5 = {
    style: (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $4aa50d5371582059$export$9908943fb57fbe51).style)
};
var $27b47789cc8143e1$var$pathCopyParams = (0, $82e5b6aba13917b1$export$98ab6203ec3396e2).concat([
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
]);
var $27b47789cc8143e1$var$Path = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $27b47789cc8143e1$var$pathCopyParams.length; ++i)decalEl[$27b47789cc8143e1$var$pathCopyParams[i]] = this[$27b47789cc8143e1$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(this.style, value);
            } else if (key === 'shape') (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $30eadc8c092f368d$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $f6a6510de8fe71ae$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $f6a6510de8fe71ae$export$27682248795c3c6b;
                return 0, $f6a6510de8fe71ae$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $f6a6510de8fe71ae$export$3c6e95f318c8369b;
        }
        return 0, $f6a6510de8fe71ae$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $30eadc8c092f368d$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $f6a6510de8fe71ae$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $be8577c7cd53a73f$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $4454211f949588ae$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $be8577c7cd53a73f$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($e67a332329073f5c$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $e67a332329073f5c$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $be8577c7cd53a73f$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $be8577c7cd53a73f$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $e4c0c902d0f4f283$export$79c7e160a7743efd)($27b47789cc8143e1$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        if (this.__inHover === (0, $07809a3d2222d60e$export$f5347ae640a7f0d0)) return;
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $27b47789cc8143e1$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd) | (0, $be8577c7cd53a73f$export$ada8b2beb3d76671) | (0, $be8577c7cd53a73f$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $4aa50d5371582059$export$2e2bcd8739ae039));
var $27b47789cc8143e1$export$2e2bcd8739ae039 = $27b47789cc8143e1$var$Path;





var $67c55373fdf93a2e$export$5fbb6d98091bcb56 = (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $fd1433555986e896$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $27b47789cc8143e1$export$deade517576e293a));
var $67c55373fdf93a2e$var$TSpan = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        return (0, $2f165f94ff51cf78$export$c7aae0ffd99a8643)(this.style);
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $e4c0c902d0f4f283$export$79c7e160a7743efd)($67c55373fdf93a2e$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        if (!this._rect) this._rect = (0, $2f165f94ff51cf78$export$d79289ac0f53b974)(this.style);
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $4aa50d5371582059$export$2e2bcd8739ae039));
$67c55373fdf93a2e$var$TSpan.prototype.type = 'tspan';
var $67c55373fdf93a2e$export$2e2bcd8739ae039 = $67c55373fdf93a2e$var$TSpan;








var $b5bca30d4a081571$export$8993f922aeeac642 = (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $4aa50d5371582059$export$737672163db00fe3));
var $b5bca30d4a081571$export$4aba8ad70847a488 = {
    style: (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $4aa50d5371582059$export$9908943fb57fbe51).style)
};
function $b5bca30d4a081571$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $b5bca30d4a081571$var$ZRImage = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $e4c0c902d0f4f283$export$79c7e160a7743efd)($b5bca30d4a081571$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $b5bca30d4a081571$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $b5bca30d4a081571$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $4aa50d5371582059$export$2e2bcd8739ae039));
$b5bca30d4a081571$var$ZRImage.prototype.type = 'image';
var $b5bca30d4a081571$export$2e2bcd8739ae039 = $b5bca30d4a081571$var$ZRImage;




function $0b86fd3e95e0ced8$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
    ctx.closePath();
}


var $a64e0537a99e26d1$var$round = Math.round;
function $a64e0537a99e26d1$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($a64e0537a99e26d1$var$round(x1 * 2) === $a64e0537a99e26d1$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $a64e0537a99e26d1$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($a64e0537a99e26d1$var$round(y1 * 2) === $a64e0537a99e26d1$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $a64e0537a99e26d1$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $a64e0537a99e26d1$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $a64e0537a99e26d1$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $a64e0537a99e26d1$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($a64e0537a99e26d1$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($a64e0537a99e26d1$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $a64e0537a99e26d1$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $a64e0537a99e26d1$var$round(position * 2);
    return (doubledPosition + $a64e0537a99e26d1$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $439653c37a0e6e60$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $439653c37a0e6e60$var$subPixelOptimizeOutputShape = {};
var $439653c37a0e6e60$var$Rect = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $439653c37a0e6e60$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $a64e0537a99e26d1$export$60e2aa74957d0b9d)($439653c37a0e6e60$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $0b86fd3e95e0ced8$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$439653c37a0e6e60$var$Rect.prototype.type = 'rect';
var $439653c37a0e6e60$export$2e2bcd8739ae039 = $439653c37a0e6e60$var$Rect;





var $9f8a9b67e62609f8$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $9f8a9b67e62609f8$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut = {};
var $9f8a9b67e62609f8$export$21aaaa0607ee0e2b = {
    style: (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $4aa50d5371582059$export$9908943fb57fbe51).style)
};
var $9f8a9b67e62609f8$var$ZRText = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $9f8a9b67e62609f8$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $9f8a9b67e62609f8$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $9f8a9b67e62609f8$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $9f8a9b67e62609f8$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $fd1433555986e896$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        (0, $2f165f94ff51cf78$export$9a4428591d825b14)($9f8a9b67e62609f8$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut.baseX;
        baseY = $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut.baseY;
        var text = $9f8a9b67e62609f8$var$getStyleText(style);
        var contentBlock = (0, $2f165f94ff51cf78$export$5772575e34ef80f9)(text, style, $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut.outerWidth, $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut.outerHeight);
        var needDrawBg = $9f8a9b67e62609f8$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        this.isTruncated = !!contentBlock.isTruncated;
        var textX = baseX;
        var textY = (0, $211780946ab71638$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $211780946ab71638$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $211780946ab71638$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $9f8a9b67e62609f8$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var useDefaultFill = false;
        var textFill = $9f8a9b67e62609f8$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $9f8a9b67e62609f8$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $9f8a9b67e62609f8$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $67c55373fdf93a2e$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $9f8a9b67e62609f8$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            el.setBoundingRect((0, $2f165f94ff51cf78$export$bd5d12d7bf7c9027)(subElStyle, contentBlock.contentWidth, contentBlock.calculatedLineHeight, usingDefaultStroke ? 0 : null));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        (0, $2f165f94ff51cf78$export$9a4428591d825b14)($9f8a9b67e62609f8$var$tmpCITOverflowAreaOut, defaultStyle.overflowRect, baseX, baseY, textAlign, verticalAlign);
        baseX = $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut.baseX;
        baseY = $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut.baseY;
        var text = $9f8a9b67e62609f8$var$getStyleText(style);
        var contentBlock = (0, $2f165f94ff51cf78$export$15ec9472ff2d721)(text, style, $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut.outerWidth, $9f8a9b67e62609f8$var$tmpCITOverflowAreaOut.outerHeight, textAlign);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        this.isTruncated = !!contentBlock.isTruncated;
        var boxX = (0, $211780946ab71638$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $211780946ab71638$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($9f8a9b67e62609f8$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $9f8a9b67e62609f8$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $9f8a9b67e62609f8$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $67c55373fdf93a2e$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var usingDefaultStroke = false;
        var textFill = $9f8a9b67e62609f8$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $9f8a9b67e62609f8$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $9f8a9b67e62609f8$var$DEFAULT_STROKE_LINE_WIDTH, usingDefaultStroke = true, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $fd1433555986e896$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $e4c0c902d0f4f283$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $9f8a9b67e62609f8$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $e4c0c902d0f4f283$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        el.setBoundingRect((0, $2f165f94ff51cf78$export$bd5d12d7bf7c9027)(subElStyle, token.contentWidth, token.contentHeight, usingDefaultStroke ? 0 : null));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $439653c37a0e6e60$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $b5bca30d4a081571$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $e4c0c902d0f4f283$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if ($9f8a9b67e62609f8$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $9f8a9b67e62609f8$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || 'sans-serif'
        ].join(' ');
        return font && (0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $4aa50d5371582059$export$2e2bcd8739ae039));
var $9f8a9b67e62609f8$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $9f8a9b67e62609f8$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $9f8a9b67e62609f8$var$FONT_PARTS = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily'
];
function $9f8a9b67e62609f8$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === 'string' && (fontSize.indexOf('px') !== -1 || fontSize.indexOf('rem') !== -1 || fontSize.indexOf('em') !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + 'px';
    else return (0, $fd1433555986e896$export$b1461457ea2c1179) + 'px';
}
function $9f8a9b67e62609f8$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $9f8a9b67e62609f8$var$FONT_PARTS.length; i++){
        var fontProp = $9f8a9b67e62609f8$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $9f8a9b67e62609f8$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $9f8a9b67e62609f8$export$176336068cc5371f(style) {
    $9f8a9b67e62609f8$var$normalizeStyle(style);
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(style.rich, $9f8a9b67e62609f8$var$normalizeStyle);
    return style;
}
function $9f8a9b67e62609f8$var$normalizeStyle(style) {
    if (style) {
        style.font = $9f8a9b67e62609f8$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $9f8a9b67e62609f8$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $9f8a9b67e62609f8$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $e4c0c902d0f4f283$export$f3a38102c49f4268)(style.padding);
    }
}
function $9f8a9b67e62609f8$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $9f8a9b67e62609f8$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $9f8a9b67e62609f8$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $9f8a9b67e62609f8$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $9f8a9b67e62609f8$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $9f8a9b67e62609f8$export$2e2bcd8739ae039 = $9f8a9b67e62609f8$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7baa8a5774022ac4$export$b1c39b2bacd1ddc2 = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $7baa8a5774022ac4$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $7baa8a5774022ac4$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = 'chart';
        // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $7baa8a5774022ac4$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = 'chart';
        });
    }
};





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0f5447108b4a27a4$export$5ba2cba1cb566d7a = 'undefined';
var $0f5447108b4a27a4$export$68ebcbce21494007 = 'series';
var $0f5447108b4a27a4$export$cd51b5ca77f6f0e4 = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'itemChildGroupId',
    'seriesName'
]);
var $0f5447108b4a27a4$export$2823037fb9d8f0c6 = 'original';
var $0f5447108b4a27a4$export$fcd62ebf51387903 = 'arrayRows';
var $0f5447108b4a27a4$export$703ae8a2d83f441 = 'objectRows';
var $0f5447108b4a27a4$export$6a32b42c754a3cb8 = 'keyedColumns';
var $0f5447108b4a27a4$export$a918cb016a382d45 = 'typedArray';
var $0f5447108b4a27a4$export$c78f1330778d30d = 'unknown';
var $0f5447108b4a27a4$export$7b3f3c6551b4949b = 'column';
var $0f5447108b4a27a4$export$d55da1467cdf7804 = 'row';
var $0f5447108b4a27a4$export$4ca176c09704a32 = 'Roam';


var $fa04f8f648e70374$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isSSR',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    // 'getModel',
    'getOption',
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $fa04f8f648e70374$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $e4c0c902d0f4f283$export$79b2f7037acddd43($fa04f8f648e70374$var$availableMethods, function(methodName) {
            this[methodName] = $e4c0c902d0f4f283$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
function $fa04f8f648e70374$export$2b32bcfeffd624a6(api, componentOrSeries) {
    return componentOrSeries.mainType === (0, $0f5447108b4a27a4$export$68ebcbce21494007) ? api.getViewOfSeriesModel(componentOrSeries) : api.getViewOfComponentModel(componentOrSeries);
}
var $fa04f8f648e70374$export$2e2bcd8739ae039 = $fa04f8f648e70374$var$ExtensionAPI;



// Reserve 0 as default.
var $6243d8dbb37d6b0d$var$_highlightNextDigit = 1;
var $6243d8dbb37d6b0d$var$_highlightKeyMap = {};
var $6243d8dbb37d6b0d$var$getSavedStates = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $6243d8dbb37d6b0d$var$getComponentStates = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $6243d8dbb37d6b0d$export$5542daa30722333e = 0;
var $6243d8dbb37d6b0d$export$1307d6a87d56baa = 1;
var $6243d8dbb37d6b0d$export$f0f2bee145debb31 = 2;
var $6243d8dbb37d6b0d$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $6243d8dbb37d6b0d$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $6243d8dbb37d6b0d$export$1cb9fc6ed5b9836c = 10;
var $6243d8dbb37d6b0d$export$3a2f97d39514bbc = 9;
var $6243d8dbb37d6b0d$export$df035d873a9de64f = 'highlight';
var $6243d8dbb37d6b0d$export$f8a2f7807cc185ea = 'downplay';
var $6243d8dbb37d6b0d$export$89616263e7d38fe9 = 'select';
var $6243d8dbb37d6b0d$export$7636ad95c0f68a79 = 'unselect';
var $6243d8dbb37d6b0d$export$1e90ed8a25542516 = 'toggleSelect';
var $6243d8dbb37d6b0d$export$67f8c62bcdfbd39f = 'selectchanged';
function $6243d8dbb37d6b0d$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
}
function $6243d8dbb37d6b0d$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $6243d8dbb37d6b0d$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $6243d8dbb37d6b0d$var$doChangeHoverState(el, 'emphasis', $6243d8dbb37d6b0d$export$f0f2bee145debb31);
}
function $6243d8dbb37d6b0d$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $6243d8dbb37d6b0d$export$f0f2bee145debb31) $6243d8dbb37d6b0d$var$doChangeHoverState(el, 'normal', $6243d8dbb37d6b0d$export$5542daa30722333e);
}
function $6243d8dbb37d6b0d$var$singleEnterBlur(el) {
    $6243d8dbb37d6b0d$var$doChangeHoverState(el, 'blur', $6243d8dbb37d6b0d$export$1307d6a87d56baa);
}
function $6243d8dbb37d6b0d$var$singleLeaveBlur(el) {
    if (el.hoverState === $6243d8dbb37d6b0d$export$1307d6a87d56baa) $6243d8dbb37d6b0d$var$doChangeHoverState(el, 'normal', $6243d8dbb37d6b0d$export$5542daa30722333e);
}
function $6243d8dbb37d6b0d$var$singleEnterSelect(el) {
    el.selected = true;
}
function $6243d8dbb37d6b0d$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $6243d8dbb37d6b0d$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $6243d8dbb37d6b0d$var$traverseUpdateState(el, updater, commonParam) {
    $6243d8dbb37d6b0d$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $6243d8dbb37d6b0d$var$updateElementState(child, updater, commonParam);
    });
}
function $6243d8dbb37d6b0d$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $6243d8dbb37d6b0d$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $6243d8dbb37d6b0d$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $6243d8dbb37d6b0d$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $6243d8dbb37d6b0d$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $6243d8dbb37d6b0d$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveTo(fromState, props);
    }
    return fromState;
}
function $6243d8dbb37d6b0d$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $27b47789cc8143e1$export$2e2bcd8739ae039)) {
        var store = $6243d8dbb37d6b0d$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($6243d8dbb37d6b0d$var$hasFillOrStroke(fromFill) || $6243d8dbb37d6b0d$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$6243d8dbb37d6b0d$var$hasFillOrStroke(emphasisStyle.fill) && $6243d8dbb37d6b0d$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $30eadc8c092f368d$export$2b47e247dfb87a73)(fromFill);
            } else if (!$6243d8dbb37d6b0d$var$hasFillOrStroke(emphasisStyle.stroke) && $6243d8dbb37d6b0d$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $30eadc8c092f368d$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $6243d8dbb37d6b0d$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $6243d8dbb37d6b0d$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $6243d8dbb37d6b0d$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $6243d8dbb37d6b0d$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $6243d8dbb37d6b0d$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $6243d8dbb37d6b0d$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $6243d8dbb37d6b0d$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $6243d8dbb37d6b0d$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $6243d8dbb37d6b0d$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $6243d8dbb37d6b0d$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $6243d8dbb37d6b0d$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $6243d8dbb37d6b0d$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $6243d8dbb37d6b0d$var$elementStateProxy;
}
function $6243d8dbb37d6b0d$export$d899507e2598e4ae(el, e) {
    !$6243d8dbb37d6b0d$var$shouldSilent(el, e) && !el.__highByOuter && $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$var$singleEnterEmphasis);
}
function $6243d8dbb37d6b0d$export$784cba1f7fe58cca(el, e) {
    !$6243d8dbb37d6b0d$var$shouldSilent(el, e) && !el.__highByOuter && $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$var$singleLeaveEmphasis);
}
function $6243d8dbb37d6b0d$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$var$singleEnterEmphasis);
}
function $6243d8dbb37d6b0d$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$var$singleLeaveEmphasis);
}
function $6243d8dbb37d6b0d$export$207f9cb3e1099375(el) {
    $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$var$singleEnterBlur);
}
function $6243d8dbb37d6b0d$export$fd4a9ec75456d3c1(el) {
    $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$var$singleLeaveBlur);
}
function $6243d8dbb37d6b0d$export$252d028dda8ef765(el) {
    $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$var$singleEnterSelect);
}
function $6243d8dbb37d6b0d$export$ea9a904bd6e32bd3(el) {
    $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$var$singleLeaveSelect);
}
function $6243d8dbb37d6b0d$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $6243d8dbb37d6b0d$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $6243d8dbb37d6b0d$var$getComponentStates(componentModel);
        var view = (0, $fa04f8f648e70374$export$2b32bcfeffd624a6)(api, componentModel);
        var isSeries = componentType === 'series';
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $6243d8dbb37d6b0d$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $6243d8dbb37d6b0d$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $6243d8dbb37d6b0d$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === 'self') return;
                $6243d8dbb37d6b0d$var$singleEnterBlur(child);
            });
            if ((0, $e4c0c902d0f4f283$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $6243d8dbb37d6b0d$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $6243d8dbb37d6b0d$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $6243d8dbb37d6b0d$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $6243d8dbb37d6b0d$var$singleEnterBlur(child);
    });
}
function $6243d8dbb37d6b0d$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $939d3a4c11ee87fd$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el);
        $6243d8dbb37d6b0d$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $6243d8dbb37d6b0d$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $6243d8dbb37d6b0d$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $6243d8dbb37d6b0d$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $6243d8dbb37d6b0d$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $6243d8dbb37d6b0d$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $6243d8dbb37d6b0d$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $6243d8dbb37d6b0d$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $6243d8dbb37d6b0d$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $6243d8dbb37d6b0d$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $6243d8dbb37d6b0d$export$bb1c7b62436282a(dispatcher, e, api) {
    $6243d8dbb37d6b0d$export$b2a593c7b5243584(api);
    var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $6243d8dbb37d6b0d$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $6243d8dbb37d6b0d$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $6243d8dbb37d6b0d$export$784cba1f7fe58cca(dispatcher, e);
}
function $6243d8dbb37d6b0d$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$6243d8dbb37d6b0d$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $939d3a4c11ee87fd$export$42b26cae8b8d10)(data, payload);
    if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $6243d8dbb37d6b0d$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $6243d8dbb37d6b0d$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $6243d8dbb37d6b0d$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $6243d8dbb37d6b0d$export$252d028dda8ef765(el) : $6243d8dbb37d6b0d$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $6243d8dbb37d6b0d$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $6243d8dbb37d6b0d$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $6243d8dbb37d6b0d$export$9ba15aea1e048d48(el, true);
    $6243d8dbb37d6b0d$var$traverseUpdateState(el, $6243d8dbb37d6b0d$export$20f39bbe322fb9ab);
    $6243d8dbb37d6b0d$export$24972466b2b62ac2(el, focus, blurScope);
}
function $6243d8dbb37d6b0d$export$912cae7b47c8e437(el) {
    $6243d8dbb37d6b0d$export$9ba15aea1e048d48(el, false);
}
function $6243d8dbb37d6b0d$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $6243d8dbb37d6b0d$export$912cae7b47c8e437(el) : $6243d8dbb37d6b0d$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $6243d8dbb37d6b0d$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $6243d8dbb37d6b0d$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $6243d8dbb37d6b0d$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $6243d8dbb37d6b0d$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $6243d8dbb37d6b0d$var$OTHER_STATES.length; i++){
        var stateName = $6243d8dbb37d6b0d$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$6243d8dbb37d6b0d$var$defaultStyleGetterMap[styleType]]();
    }
}
function $6243d8dbb37d6b0d$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $6243d8dbb37d6b0d$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $6243d8dbb37d6b0d$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $6243d8dbb37d6b0d$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $6243d8dbb37d6b0d$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $6243d8dbb37d6b0d$var$_highlightNextDigit <= 32) highlightDigit = $6243d8dbb37d6b0d$var$_highlightKeyMap[highlightKey] = $6243d8dbb37d6b0d$var$_highlightNextDigit++;
    return highlightDigit;
}
function $6243d8dbb37d6b0d$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $6243d8dbb37d6b0d$export$89616263e7d38fe9 || payloadType === $6243d8dbb37d6b0d$export$7636ad95c0f68a79 || payloadType === $6243d8dbb37d6b0d$export$1e90ed8a25542516;
}
function $6243d8dbb37d6b0d$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $6243d8dbb37d6b0d$export$df035d873a9de64f || payloadType === $6243d8dbb37d6b0d$export$f8a2f7807cc185ea;
}
function $6243d8dbb37d6b0d$export$9fe78019e6f395b6(el) {
    var store = $6243d8dbb37d6b0d$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $97d0e733871fae49$export$ae7433df314f6ec3 = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
function $97d0e733871fae49$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $97d0e733871fae49$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'leave';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('leave');
    var animationConfig = $97d0e733871fae49$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $97d0e733871fae49$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $97d0e733871fae49$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $97d0e733871fae49$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $97d0e733871fae49$var$animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
}
function $97d0e733871fae49$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'leave') return true;
    }
    return false;
}
function $97d0e733871fae49$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($97d0e733871fae49$export$5b89d4b643713034(el)) return;
    $97d0e733871fae49$var$animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
}
function $97d0e733871fae49$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $97d0e733871fae49$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $97d0e733871fae49$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $97d0e733871fae49$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $97d0e733871fae49$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $97d0e733871fae49$export$bca7290a9faf0ec9(el) {
    $97d0e733871fae49$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $97d0e733871fae49$export$ccb1f1e4d2fa86ac(el) {
    return $97d0e733871fae49$export$ae7433df314f6ec3(el).oldStyle;
}

var $05f852c7feb2d530$exports = {};

$parcel$export($05f852c7feb2d530$exports, "XY", function () { return $05f852c7feb2d530$export$cb4c12294149dd2d; });
$parcel$export($05f852c7feb2d530$exports, "WH", function () { return $05f852c7feb2d530$export$a3fe6d967173a3ac; });
$parcel$export($05f852c7feb2d530$exports, "HOVER_LAYER_NO", function () { return $05f852c7feb2d530$export$3e67317617241636; });
$parcel$export($05f852c7feb2d530$exports, "HOVER_LAYER_FROM_THRESHOLD", function () { return $05f852c7feb2d530$export$3c339ce201e4ce4d; });
$parcel$export($05f852c7feb2d530$exports, "HOVER_LAYER_FOR_INCREMENTAL", function () { return $05f852c7feb2d530$export$2ed770cec6ef78e8; });
$parcel$export($05f852c7feb2d530$exports, "extendShape", function () { return $05f852c7feb2d530$export$d0d5398c9d612037; });
$parcel$export($05f852c7feb2d530$exports, "extendPath", function () { return $05f852c7feb2d530$export$53b54a3137026af0; });
$parcel$export($05f852c7feb2d530$exports, "registerShape", function () { return $05f852c7feb2d530$export$2b95b62e3aaf6fdd; });
$parcel$export($05f852c7feb2d530$exports, "getShapeClass", function () { return $05f852c7feb2d530$export$51df4b5565a58189; });
$parcel$export($05f852c7feb2d530$exports, "makePath", function () { return $05f852c7feb2d530$export$aa9bab72412f5613; });
$parcel$export($05f852c7feb2d530$exports, "resizePath", function () { return $05f852c7feb2d530$export$566dbf1c62b04fc7; });
$parcel$export($05f852c7feb2d530$exports, "makeImage", function () { return $05f852c7feb2d530$export$7a2bdede98851ac5; });
$parcel$export($05f852c7feb2d530$exports, "mergePath", function () { return $05f852c7feb2d530$export$7b1dd269fbc4e903; });
$parcel$export($05f852c7feb2d530$exports, "subPixelOptimizeLine", function () { return $05f852c7feb2d530$export$8b4b620d7f4aad1b; });
$parcel$export($05f852c7feb2d530$exports, "subPixelOptimizeRect", function () { return $05f852c7feb2d530$export$60e2aa74957d0b9d; });
$parcel$export($05f852c7feb2d530$exports, "subPixelOptimize", function () { return $05f852c7feb2d530$export$72c4fd4c1b8fcb10; });
$parcel$export($05f852c7feb2d530$exports, "getTransform", function () { return $05f852c7feb2d530$export$fce0c6cfca85ed96; });
$parcel$export($05f852c7feb2d530$exports, "applyTransform", function () { return $05f852c7feb2d530$export$9f9dcb98c894b623; });
$parcel$export($05f852c7feb2d530$exports, "transformDirection", function () { return $05f852c7feb2d530$export$fff94e9792354cfa; });
$parcel$export($05f852c7feb2d530$exports, "groupTransition", function () { return $05f852c7feb2d530$export$64fcab7860c216ae; });
$parcel$export($05f852c7feb2d530$exports, "clipPointsByRect", function () { return $05f852c7feb2d530$export$e2f409471bbbc1dc; });
$parcel$export($05f852c7feb2d530$exports, "clipRectByRect", function () { return $05f852c7feb2d530$export$d0d3709202b8b2a; });
$parcel$export($05f852c7feb2d530$exports, "createIcon", function () { return $05f852c7feb2d530$export$274edc73af1ae9c8; });
$parcel$export($05f852c7feb2d530$exports, "linePolygonIntersect", function () { return $05f852c7feb2d530$export$4f47c855a5e9ae9; });
$parcel$export($05f852c7feb2d530$exports, "lineLineIntersect", function () { return $05f852c7feb2d530$export$6c0a70ea1d8d158b; });
$parcel$export($05f852c7feb2d530$exports, "expandOrShrinkRect", function () { return $05f852c7feb2d530$export$81ed941fdeb91c7c; });
$parcel$export($05f852c7feb2d530$exports, "setTooltipConfig", function () { return $05f852c7feb2d530$export$fc6410d97fab306c; });
$parcel$export($05f852c7feb2d530$exports, "traverseElements", function () { return $05f852c7feb2d530$export$3e564442729bf048; });
$parcel$export($05f852c7feb2d530$exports, "isBoundingRectAxisAligned", function () { return $05f852c7feb2d530$export$576610ccf2234b72; });
$parcel$export($05f852c7feb2d530$exports, "ensureCopyRect", function () { return $05f852c7feb2d530$export$38128dfd9a498e1; });
$parcel$export($05f852c7feb2d530$exports, "ensureCopyTransform", function () { return $05f852c7feb2d530$export$4d61283a070e0362; });
$parcel$export($05f852c7feb2d530$exports, "retrieveZInfo", function () { return $05f852c7feb2d530$export$1500a631bea5adda; });
$parcel$export($05f852c7feb2d530$exports, "calcZ2Range", function () { return $05f852c7feb2d530$export$8215ea00957327f2; });
$parcel$export($05f852c7feb2d530$exports, "traverseUpdateZ", function () { return $05f852c7feb2d530$export$d31cf465bf5e8879; });
$parcel$export($05f852c7feb2d530$exports, "payloadDisableAnimation", function () { return $05f852c7feb2d530$export$6f963a8600ad6f65; });
$parcel$export($05f852c7feb2d530$exports, "decomposeTransform", function () { return $05f852c7feb2d530$export$31f224ae9d6cf05; });
$parcel$export($05f852c7feb2d530$exports, "getCurrentCanvasPainter", function () { return $05f852c7feb2d530$export$e8e725f22cc8ef79; });
$parcel$export($05f852c7feb2d530$exports, "updateProps", function () { return $97d0e733871fae49$export$c8dce3c08436e91e; });
$parcel$export($05f852c7feb2d530$exports, "initProps", function () { return $97d0e733871fae49$export$a121566aadcfe021; });
$parcel$export($05f852c7feb2d530$exports, "removeElement", function () { return $97d0e733871fae49$export$f883456a56996078; });
$parcel$export($05f852c7feb2d530$exports, "removeElementWithFadeOut", function () { return $97d0e733871fae49$export$6d0fd725cb4aee8a; });
$parcel$export($05f852c7feb2d530$exports, "isElementRemoved", function () { return $97d0e733871fae49$export$5b89d4b643713034; });
$parcel$export($05f852c7feb2d530$exports, "Group", function () { return $0c53f0d63dde8266$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Image", function () { return $b5bca30d4a081571$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Text", function () { return $9f8a9b67e62609f8$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Circle", function () { return $f43fbde6d03c3be0$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Ellipse", function () { return $b501654321051d8e$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Sector", function () { return $bf363fc63c6d894e$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Ring", function () { return $b1fbe9680b181e60$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Polygon", function () { return $84715c109614a262$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Polyline", function () { return $00ca553820255831$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Rect", function () { return $439653c37a0e6e60$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Line", function () { return $8ae349726e18597f$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "BezierCurve", function () { return $90d1bc3a88017526$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Arc", function () { return $8c43921d92adb726$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "IncrementalDisplayable", function () { return $a1941e9865cb8512$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "CompoundPath", function () { return $99b65ca521b3dde4$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "LinearGradient", function () { return $6ba6385ab560fa15$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "RadialGradient", function () { return $fa057c419d5bc7e2$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "BoundingRect", function () { return $8d3017bded1ca21b$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "OrientedBoundingRect", function () { return $e393b99a004f81fd$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Point", function () { return $0a729ce3d8741684$export$2e2bcd8739ae039; });
$parcel$export($05f852c7feb2d530$exports, "Path", function () { return $27b47789cc8143e1$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $9799b088bf499eca$var$CMD = (0, $4454211f949588ae$export$2e2bcd8739ae039).CMD;
var $9799b088bf499eca$var$points = [
    [],
    [],
    []
];
var $9799b088bf499eca$var$mathSqrt = Math.sqrt;
var $9799b088bf499eca$var$mathAtan2 = Math.atan2;
function $9799b088bf499eca$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $9799b088bf499eca$var$CMD.M;
    var C = $9799b088bf499eca$var$CMD.C;
    var L = $9799b088bf499eca$var$CMD.L;
    var R = $9799b088bf499eca$var$CMD.R;
    var A = $9799b088bf499eca$var$CMD.A;
    var Q = $9799b088bf499eca$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $9799b088bf499eca$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $9799b088bf499eca$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $9799b088bf499eca$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $c20a2855346046a3$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $c20a2855346046a3$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $9799b088bf499eca$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $c20a2855346046a3$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $914b298901567cdf$var$mathSqrt = Math.sqrt;
var $914b298901567cdf$var$mathSin = Math.sin;
var $914b298901567cdf$var$mathCos = Math.cos;
var $914b298901567cdf$var$PI = Math.PI;
function $914b298901567cdf$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $914b298901567cdf$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($914b298901567cdf$var$vMag(u) * $914b298901567cdf$var$vMag(v));
}
function $914b298901567cdf$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($914b298901567cdf$var$vRatio(u, v));
}
function $914b298901567cdf$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($914b298901567cdf$var$PI / 180.0);
    var xp = $914b298901567cdf$var$mathCos(psi) * (x1 - x2) / 2.0 + $914b298901567cdf$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $914b298901567cdf$var$mathSin(psi) * (x1 - x2) / 2.0 + $914b298901567cdf$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $914b298901567cdf$var$mathSqrt(lambda);
        ry *= $914b298901567cdf$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $914b298901567cdf$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $914b298901567cdf$var$mathCos(psi) * cxp - $914b298901567cdf$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $914b298901567cdf$var$mathSin(psi) * cxp + $914b298901567cdf$var$mathCos(psi) * cyp;
    var theta = $914b298901567cdf$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $914b298901567cdf$var$vAngle(u, v);
    if ($914b298901567cdf$var$vRatio(u, v) <= -1) dTheta = $914b298901567cdf$var$PI;
    if ($914b298901567cdf$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $914b298901567cdf$var$PI * 1e6) / 1e6;
        dTheta = $914b298901567cdf$var$PI * 2 + n % 2 * $914b298901567cdf$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $914b298901567cdf$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $914b298901567cdf$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $914b298901567cdf$var$createPathProxyFromString(data) {
    var path = new (0, $4454211f949588ae$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $4454211f949588ae$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($914b298901567cdf$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($914b298901567cdf$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $914b298901567cdf$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $914b298901567cdf$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $914b298901567cdf$var$SVGPath = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
function $914b298901567cdf$var$isPathProxy(path) {
    return path.setData != null;
}
function $914b298901567cdf$var$createPathOptions(str, opts) {
    var pathProxy = $914b298901567cdf$var$createPathProxyFromString(str);
    var innerOpts = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        var beProxy = $914b298901567cdf$var$isPathProxy(path);
        if (beProxy && path.canSave()) {
            path.appendPath(pathProxy);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = beProxy ? path.getContext() : path;
            if (ctx) pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $9799b088bf499eca$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $914b298901567cdf$export$ae5b259626f00aeb(str, opts) {
    return new $914b298901567cdf$var$SVGPath($914b298901567cdf$var$createPathOptions(str, opts));
}
function $914b298901567cdf$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $914b298901567cdf$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($914b298901567cdf$var$SVGPath);
    return Sub;
}
function $914b298901567cdf$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $27b47789cc8143e1$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($914b298901567cdf$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $914b298901567cdf$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $27b47789cc8143e1$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $9799b088bf499eca$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $f43fbde6d03c3be0$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $f43fbde6d03c3be0$var$Circle = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $f43fbde6d03c3be0$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$f43fbde6d03c3be0$var$Circle.prototype.type = 'circle';
var $f43fbde6d03c3be0$export$2e2bcd8739ae039 = $f43fbde6d03c3be0$var$Circle;




var $b501654321051d8e$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $b501654321051d8e$var$Ellipse = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $b501654321051d8e$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$b501654321051d8e$var$Ellipse.prototype.type = 'ellipse';
var $b501654321051d8e$export$2e2bcd8739ae039 = $b501654321051d8e$var$Ellipse;





var $b6abbb7b9662a42b$var$PI = Math.PI;
var $b6abbb7b9662a42b$var$PI2 = $b6abbb7b9662a42b$var$PI * 2;
var $b6abbb7b9662a42b$var$mathSin = Math.sin;
var $b6abbb7b9662a42b$var$mathCos = Math.cos;
var $b6abbb7b9662a42b$var$mathACos = Math.acos;
var $b6abbb7b9662a42b$var$mathATan2 = Math.atan2;
var $b6abbb7b9662a42b$var$mathAbs = Math.abs;
var $b6abbb7b9662a42b$var$mathSqrt = Math.sqrt;
var $b6abbb7b9662a42b$var$mathMax = Math.max;
var $b6abbb7b9662a42b$var$mathMin = Math.min;
var $b6abbb7b9662a42b$var$e = 1e-4;
function $b6abbb7b9662a42b$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $b6abbb7b9662a42b$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $b6abbb7b9662a42b$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $b6abbb7b9662a42b$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $b6abbb7b9662a42b$var$mathSqrt($b6abbb7b9662a42b$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $b6abbb7b9662a42b$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $b6abbb7b9662a42b$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $b6abbb7b9662a42b$var$mathMax(shape.r, 0);
    var innerRadius = $b6abbb7b9662a42b$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $b6abbb7b9662a42b$var$mathAbs(endAngle - startAngle);
    var mod = arc > $b6abbb7b9662a42b$var$PI2 && arc % $b6abbb7b9662a42b$var$PI2;
    mod > $b6abbb7b9662a42b$var$e && (arc = mod);
    if (!(radius > $b6abbb7b9662a42b$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $b6abbb7b9662a42b$var$PI2 - $b6abbb7b9662a42b$var$e) {
        ctx.moveTo(cx + radius * $b6abbb7b9662a42b$var$mathCos(startAngle), cy + radius * $b6abbb7b9662a42b$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $b6abbb7b9662a42b$var$e) {
            ctx.moveTo(cx + innerRadius * $b6abbb7b9662a42b$var$mathCos(endAngle), cy + innerRadius * $b6abbb7b9662a42b$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $b6abbb7b9662a42b$var$mathCos(startAngle);
        var yrs = radius * $b6abbb7b9662a42b$var$mathSin(startAngle);
        var xire = innerRadius * $b6abbb7b9662a42b$var$mathCos(endAngle);
        var yire = innerRadius * $b6abbb7b9662a42b$var$mathSin(endAngle);
        var hasArc = arc > $b6abbb7b9662a42b$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $b6abbb7b9662a42b$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $b6abbb7b9662a42b$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $b6abbb7b9662a42b$var$mathMin(halfRd, ocrStart);
            ocre = $b6abbb7b9662a42b$var$mathMin(halfRd, ocrEnd);
            icrs = $b6abbb7b9662a42b$var$mathMin(halfRd, icrStart);
            icre = $b6abbb7b9662a42b$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $b6abbb7b9662a42b$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $b6abbb7b9662a42b$var$mathMax(icrs, icre);
            if (ocrMax > $b6abbb7b9662a42b$var$e || icrMax > $b6abbb7b9662a42b$var$e) {
                xre = radius * $b6abbb7b9662a42b$var$mathCos(endAngle);
                yre = radius * $b6abbb7b9662a42b$var$mathSin(endAngle);
                xirs = innerRadius * $b6abbb7b9662a42b$var$mathCos(startAngle);
                yirs = innerRadius * $b6abbb7b9662a42b$var$mathSin(startAngle);
                if (arc < $b6abbb7b9662a42b$var$PI) {
                    var it_1 = $b6abbb7b9662a42b$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $b6abbb7b9662a42b$var$mathSin($b6abbb7b9662a42b$var$mathACos((x0 * x1 + y0 * y1) / ($b6abbb7b9662a42b$var$mathSqrt(x0 * x0 + y0 * y0) * $b6abbb7b9662a42b$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $b6abbb7b9662a42b$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $b6abbb7b9662a42b$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $b6abbb7b9662a42b$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $b6abbb7b9662a42b$var$e) {
            var crStart = $b6abbb7b9662a42b$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $b6abbb7b9662a42b$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $b6abbb7b9662a42b$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $b6abbb7b9662a42b$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $b6abbb7b9662a42b$var$mathATan2(ct0.y0, ct0.x0), $b6abbb7b9662a42b$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $b6abbb7b9662a42b$var$mathATan2(ct0.y0, ct0.x0), $b6abbb7b9662a42b$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $b6abbb7b9662a42b$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $b6abbb7b9662a42b$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $b6abbb7b9662a42b$var$mathATan2(ct1.y1, ct1.x1), $b6abbb7b9662a42b$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $b6abbb7b9662a42b$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $b6abbb7b9662a42b$var$e) {
            var crStart = $b6abbb7b9662a42b$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $b6abbb7b9662a42b$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $b6abbb7b9662a42b$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $b6abbb7b9662a42b$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $b6abbb7b9662a42b$var$mathATan2(ct0.y0, ct0.x0), $b6abbb7b9662a42b$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $b6abbb7b9662a42b$var$mathATan2(ct0.y0, ct0.x0), $b6abbb7b9662a42b$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $b6abbb7b9662a42b$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $b6abbb7b9662a42b$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $b6abbb7b9662a42b$var$mathATan2(ct1.y1, ct1.x1), $b6abbb7b9662a42b$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $bf363fc63c6d894e$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $bf363fc63c6d894e$var$Sector = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $bf363fc63c6d894e$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $b6abbb7b9662a42b$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$bf363fc63c6d894e$var$Sector.prototype.type = 'sector';
var $bf363fc63c6d894e$export$2e2bcd8739ae039 = $bf363fc63c6d894e$var$Sector;




var $b1fbe9680b181e60$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $b1fbe9680b181e60$var$Ring = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $b1fbe9680b181e60$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$b1fbe9680b181e60$var$Ring.prototype.type = 'ring';
var $b1fbe9680b181e60$export$2e2bcd8739ae039 = $b1fbe9680b181e60$var$Ring;





function $1058d1b6c9dc01d4$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $c20a2855346046a3$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $c20a2855346046a3$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $c20a2855346046a3$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $c20a2855346046a3$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $c20a2855346046a3$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $c20a2855346046a3$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $c20a2855346046a3$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $c20a2855346046a3$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $c20a2855346046a3$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $c20a2855346046a3$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $c20a2855346046a3$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $c20a2855346046a3$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $c20a2855346046a3$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $c20a2855346046a3$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $c20a2855346046a3$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $c20a2855346046a3$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $c20a2855346046a3$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $e0166c9b7727890b$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $1058d1b6c9dc01d4$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $84715c109614a262$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $84715c109614a262$var$Polygon = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $84715c109614a262$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $e0166c9b7727890b$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$84715c109614a262$var$Polygon.prototype.type = 'polygon';
var $84715c109614a262$export$2e2bcd8739ae039 = $84715c109614a262$var$Polygon;





var $00ca553820255831$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $00ca553820255831$var$Polyline = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $00ca553820255831$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $e0166c9b7727890b$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$00ca553820255831$var$Polyline.prototype.type = 'polyline';
var $00ca553820255831$export$2e2bcd8739ae039 = $00ca553820255831$var$Polyline;






var $8ae349726e18597f$var$subPixelOptimizeOutputShape = {};
var $8ae349726e18597f$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $8ae349726e18597f$var$Line = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $8ae349726e18597f$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $a64e0537a99e26d1$export$8b4b620d7f4aad1b)($8ae349726e18597f$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$8ae349726e18597f$var$Line.prototype.type = 'line';
var $8ae349726e18597f$export$2e2bcd8739ae039 = $8ae349726e18597f$var$Line;






var $90d1bc3a88017526$var$out = [];
var $90d1bc3a88017526$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $90d1bc3a88017526$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $7734ff3f5891b22b$export$55fce925c60b6271) : (0, $7734ff3f5891b22b$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $7734ff3f5891b22b$export$55fce925c60b6271) : (0, $7734ff3f5891b22b$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $7734ff3f5891b22b$export$7e161e77e6fff8cb) : (0, $7734ff3f5891b22b$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $7734ff3f5891b22b$export$7e161e77e6fff8cb) : (0, $7734ff3f5891b22b$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $90d1bc3a88017526$var$BezierCurve = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $90d1bc3a88017526$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $7734ff3f5891b22b$export$117c659e21a7a060)(x1, cpx1, x2, percent, $90d1bc3a88017526$var$out);
                cpx1 = $90d1bc3a88017526$var$out[1];
                x2 = $90d1bc3a88017526$var$out[2];
                (0, $7734ff3f5891b22b$export$117c659e21a7a060)(y1, cpy1, y2, percent, $90d1bc3a88017526$var$out);
                cpy1 = $90d1bc3a88017526$var$out[1];
                y2 = $90d1bc3a88017526$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $7734ff3f5891b22b$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $90d1bc3a88017526$var$out);
                cpx1 = $90d1bc3a88017526$var$out[1];
                cpx2 = $90d1bc3a88017526$var$out[2];
                x2 = $90d1bc3a88017526$var$out[3];
                (0, $7734ff3f5891b22b$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $90d1bc3a88017526$var$out);
                cpy1 = $90d1bc3a88017526$var$out[1];
                cpy2 = $90d1bc3a88017526$var$out[2];
                y2 = $90d1bc3a88017526$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $90d1bc3a88017526$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $90d1bc3a88017526$var$someVectorAt(this.shape, t, true);
        return $c20a2855346046a3$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$90d1bc3a88017526$var$BezierCurve.prototype.type = 'bezier-curve';
var $90d1bc3a88017526$export$2e2bcd8739ae039 = $90d1bc3a88017526$var$BezierCurve;




var $8c43921d92adb726$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $8c43921d92adb726$var$Arc = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $8c43921d92adb726$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
$8c43921d92adb726$var$Arc.prototype.type = 'arc';
var $8c43921d92adb726$export$2e2bcd8739ae039 = $8c43921d92adb726$var$Arc;




var $99b65ca521b3dde4$var$CompoundPath = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $27b47789cc8143e1$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
var $99b65ca521b3dde4$export$2e2bcd8739ae039 = $99b65ca521b3dde4$var$CompoundPath;



var $a0279f21d4bd25c6$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $a0279f21d4bd25c6$export$2e2bcd8739ae039 = $a0279f21d4bd25c6$var$Gradient;


var $6ba6385ab560fa15$var$LinearGradient = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $a0279f21d4bd25c6$export$2e2bcd8739ae039));
var $6ba6385ab560fa15$export$2e2bcd8739ae039 = $6ba6385ab560fa15$var$LinearGradient;




var $fa057c419d5bc7e2$var$RadialGradient = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $a0279f21d4bd25c6$export$2e2bcd8739ae039));
var $fa057c419d5bc7e2$export$2e2bcd8739ae039 = $fa057c419d5bc7e2$var$RadialGradient;





var $e393b99a004f81fd$var$mathMin = Math.min;
var $e393b99a004f81fd$var$mathMax = Math.max;
var $e393b99a004f81fd$var$mathAbs = Math.abs;
var $e393b99a004f81fd$var$_extent = [
    0,
    0
];
var $e393b99a004f81fd$var$_extent2 = [
    0,
    0
];
var $e393b99a004f81fd$var$_intersectCtx = (0, $8d3017bded1ca21b$export$a0be2bdbd2369e0e)();
var $e393b99a004f81fd$var$_minTv = $e393b99a004f81fd$var$_intersectCtx.minTv;
var $e393b99a004f81fd$var$_maxTv = $e393b99a004f81fd$var$_intersectCtx.maxTv;
var $e393b99a004f81fd$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $0a729ce3d8741684$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $0a729ce3d8741684$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv, opt) {
        var overlapped = true;
        var noMtv = !mtv;
        if (mtv) (0, $0a729ce3d8741684$export$2e2bcd8739ae039).set(mtv, 0, 0);
        $e393b99a004f81fd$var$_intersectCtx.reset(opt, !noMtv);
        if (!this._intersectCheckOneSide(this, other, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv && !$e393b99a004f81fd$var$_intersectCtx.negativeSize) (0, $0a729ce3d8741684$export$2e2bcd8739ae039).copy(mtv, overlapped ? $e393b99a004f81fd$var$_intersectCtx.useDir ? $e393b99a004f81fd$var$_intersectCtx.dirMinTv : $e393b99a004f81fd$var$_minTv : $e393b99a004f81fd$var$_maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = self._axes[i];
            self._getProjMinMaxOnAxis(i, self._corners, $e393b99a004f81fd$var$_extent);
            self._getProjMinMaxOnAxis(i, other._corners, $e393b99a004f81fd$var$_extent2);
            if ($e393b99a004f81fd$var$_intersectCtx.negativeSize || $e393b99a004f81fd$var$_extent[1] < $e393b99a004f81fd$var$_extent2[0] || $e393b99a004f81fd$var$_extent[0] > $e393b99a004f81fd$var$_extent2[1]) {
                overlapped = false;
                if ($e393b99a004f81fd$var$_intersectCtx.negativeSize || noMtv) return overlapped;
                var dist0 = $e393b99a004f81fd$var$mathAbs($e393b99a004f81fd$var$_extent2[0] - $e393b99a004f81fd$var$_extent[1]);
                var dist1 = $e393b99a004f81fd$var$mathAbs($e393b99a004f81fd$var$_extent[0] - $e393b99a004f81fd$var$_extent2[1]);
                if ($e393b99a004f81fd$var$mathMin(dist0, dist1) > $e393b99a004f81fd$var$_maxTv.len()) {
                    if (dist0 < dist1) (0, $0a729ce3d8741684$export$2e2bcd8739ae039).scale($e393b99a004f81fd$var$_maxTv, axis, -dist0 * inverse);
                    else (0, $0a729ce3d8741684$export$2e2bcd8739ae039).scale($e393b99a004f81fd$var$_maxTv, axis, dist1 * inverse);
                }
            } else if (!noMtv) {
                var dist0 = $e393b99a004f81fd$var$mathAbs($e393b99a004f81fd$var$_extent2[0] - $e393b99a004f81fd$var$_extent[1]);
                var dist1 = $e393b99a004f81fd$var$mathAbs($e393b99a004f81fd$var$_extent[0] - $e393b99a004f81fd$var$_extent2[1]);
                if ($e393b99a004f81fd$var$_intersectCtx.useDir || $e393b99a004f81fd$var$mathMin(dist0, dist1) < $e393b99a004f81fd$var$_minTv.len()) {
                    if (dist0 < dist1 || !$e393b99a004f81fd$var$_intersectCtx.bidirectional) {
                        (0, $0a729ce3d8741684$export$2e2bcd8739ae039).scale($e393b99a004f81fd$var$_minTv, axis, dist0 * inverse);
                        if ($e393b99a004f81fd$var$_intersectCtx.useDir) $e393b99a004f81fd$var$_intersectCtx.calcDirMTV();
                    }
                    if (dist0 >= dist1 || !$e393b99a004f81fd$var$_intersectCtx.bidirectional) {
                        (0, $0a729ce3d8741684$export$2e2bcd8739ae039).scale($e393b99a004f81fd$var$_minTv, axis, -dist1 * inverse);
                        if ($e393b99a004f81fd$var$_intersectCtx.useDir) $e393b99a004f81fd$var$_intersectCtx.calcDirMTV();
                    }
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = $e393b99a004f81fd$var$mathMin(proj_1, min);
            max = $e393b99a004f81fd$var$mathMax(proj_1, max);
        }
        out[0] = min + $e393b99a004f81fd$var$_intersectCtx.touchThreshold;
        out[1] = max - $e393b99a004f81fd$var$_intersectCtx.touchThreshold;
        $e393b99a004f81fd$var$_intersectCtx.negativeSize = out[1] < out[0];
    };
    return OrientedBoundingRect;
}();
var $e393b99a004f81fd$export$2e2bcd8739ae039 = $e393b99a004f81fd$var$OrientedBoundingRect;






var $5b65cbcc2b100605$export$2dc95e9f4fd018cd = 0;
var $5b65cbcc2b100605$export$a0377e544ceae7da = 1;
var $5b65cbcc2b100605$export$f2b95933e1444751 = 2;
var $5b65cbcc2b100605$export$5bf503311eda4292 = 1;
var $5b65cbcc2b100605$export$63f5564428138c5e = 0;


var $a1941e9865cb8512$var$m = [];
var $a1941e9865cb8512$var$IncrementalDisplayable = function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = (0, $5b65cbcc2b100605$export$a0377e544ceae7da);
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype._useHoverStyle = function() {
        this.__hoverStyle = null;
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($a1941e9865cb8512$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $4aa50d5371582059$export$2e2bcd8739ae039));
var $a1941e9865cb8512$export$2e2bcd8739ae039 = $a1941e9865cb8512$var$IncrementalDisplayable;







var $05f852c7feb2d530$var$_customShapeMap = {};
var $05f852c7feb2d530$export$cb4c12294149dd2d = [
    'x',
    'y'
];
var $05f852c7feb2d530$export$a3fe6d967173a3ac = [
    'width',
    'height'
];
var $05f852c7feb2d530$export$3e67317617241636 = 0;
var $05f852c7feb2d530$export$3c339ce201e4ce4d = 1;
var $05f852c7feb2d530$export$2ed770cec6ef78e8 = 2;
function $05f852c7feb2d530$export$d0d5398c9d612037(opts) {
    return (0, $27b47789cc8143e1$export$2e2bcd8739ae039).extend(opts);
}
var $05f852c7feb2d530$var$extendPathFromString = $914b298901567cdf$export$68e3a51ba2ed417c;
function $05f852c7feb2d530$export$53b54a3137026af0(pathData, opts) {
    return $05f852c7feb2d530$var$extendPathFromString(pathData, opts);
}
function $05f852c7feb2d530$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $05f852c7feb2d530$var$_customShapeMap[name] = ShapeClass;
}
function $05f852c7feb2d530$export$51df4b5565a58189(name) {
    if ($05f852c7feb2d530$var$_customShapeMap.hasOwnProperty(name)) return $05f852c7feb2d530$var$_customShapeMap[name];
}
function $05f852c7feb2d530$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $914b298901567cdf$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $05f852c7feb2d530$var$centerGraphic(rect, path.getBoundingRect());
        $05f852c7feb2d530$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $05f852c7feb2d530$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $b5bca30d4a081571$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($05f852c7feb2d530$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $05f852c7feb2d530$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $05f852c7feb2d530$export$7b1dd269fbc4e903 = $914b298901567cdf$export$7b1dd269fbc4e903;
function $05f852c7feb2d530$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $05f852c7feb2d530$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $a64e0537a99e26d1$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $05f852c7feb2d530$export$60e2aa74957d0b9d(shape, style) {
    $a64e0537a99e26d1$export$60e2aa74957d0b9d(shape, shape, style);
    return shape;
}
var $05f852c7feb2d530$export$72c4fd4c1b8fcb10 = $a64e0537a99e26d1$export$72c4fd4c1b8fcb10;
function $05f852c7feb2d530$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $97681aabb80d556d$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $97681aabb80d556d$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $05f852c7feb2d530$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $e4c0c902d0f4f283$export$1e2f57719e155213)(transform)) transform = (0, $82e5b6aba13917b1$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $97681aabb80d556d$export$6897c284b6f9f4dc([], transform);
    return $c20a2855346046a3$export$9f9dcb98c894b623([], target, transform);
}
function $05f852c7feb2d530$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $05f852c7feb2d530$export$9f9dcb98c894b623(vertex, transform, invert);
    return (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(vertex[0]) > (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $05f852c7feb2d530$var$isNotGroup(el) {
    return !el.isGroup;
}
function $05f852c7feb2d530$var$isPath(el) {
    return el.shape != null;
}
function $05f852c7feb2d530$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($05f852c7feb2d530$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($05f852c7feb2d530$var$isPath(el)) obj.shape = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($05f852c7feb2d530$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $97d0e733871fae49$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $05f852c7feb2d530$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(x, rect.x);
        x = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(x, rect.x + rect.width);
        var y = point[1];
        y = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(y, rect.y);
        y = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $05f852c7feb2d530$export$d0d3709202b8b2a(targetRect, rect) {
    var x = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(targetRect.x, rect.x);
    var x2 = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(targetRect.y, rect.y);
    var y2 = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $05f852c7feb2d530$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(style, rect), new (0, $b5bca30d4a081571$export$2e2bcd8739ae039)(innerOpts)) : $05f852c7feb2d530$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $05f852c7feb2d530$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($05f852c7feb2d530$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $05f852c7feb2d530$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $05f852c7feb2d530$var$crossProduct2d(nx, ny, mx, my);
    if ($05f852c7feb2d530$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $05f852c7feb2d530$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $05f852c7feb2d530$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $05f852c7feb2d530$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $05f852c7feb2d530$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $05f852c7feb2d530$export$81ed941fdeb91c7c(rect, delta, shrinkOrExpand, noNegative, minSize // by default [0, 0].
) {
    if (delta == null) return rect;
    else if ((0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(delta)) $05f852c7feb2d530$var$_tmpExpandRectDelta[0] = $05f852c7feb2d530$var$_tmpExpandRectDelta[1] = $05f852c7feb2d530$var$_tmpExpandRectDelta[2] = $05f852c7feb2d530$var$_tmpExpandRectDelta[3] = delta;
    else {
        $05f852c7feb2d530$var$_tmpExpandRectDelta[0] = delta[0];
        $05f852c7feb2d530$var$_tmpExpandRectDelta[1] = delta[1];
        $05f852c7feb2d530$var$_tmpExpandRectDelta[2] = delta[2];
        $05f852c7feb2d530$var$_tmpExpandRectDelta[3] = delta[3];
    }
    if (noNegative) {
        $05f852c7feb2d530$var$_tmpExpandRectDelta[0] = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(0, $05f852c7feb2d530$var$_tmpExpandRectDelta[0]);
        $05f852c7feb2d530$var$_tmpExpandRectDelta[1] = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(0, $05f852c7feb2d530$var$_tmpExpandRectDelta[1]);
        $05f852c7feb2d530$var$_tmpExpandRectDelta[2] = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(0, $05f852c7feb2d530$var$_tmpExpandRectDelta[2]);
        $05f852c7feb2d530$var$_tmpExpandRectDelta[3] = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(0, $05f852c7feb2d530$var$_tmpExpandRectDelta[3]);
    }
    if (shrinkOrExpand) {
        $05f852c7feb2d530$var$_tmpExpandRectDelta[0] = -$05f852c7feb2d530$var$_tmpExpandRectDelta[0];
        $05f852c7feb2d530$var$_tmpExpandRectDelta[1] = -$05f852c7feb2d530$var$_tmpExpandRectDelta[1];
        $05f852c7feb2d530$var$_tmpExpandRectDelta[2] = -$05f852c7feb2d530$var$_tmpExpandRectDelta[2];
        $05f852c7feb2d530$var$_tmpExpandRectDelta[3] = -$05f852c7feb2d530$var$_tmpExpandRectDelta[3];
    }
    $05f852c7feb2d530$var$expandRectOnOneDimension(rect, $05f852c7feb2d530$var$_tmpExpandRectDelta, 'x', 'width', 3, 1, minSize && minSize[0] || 0);
    $05f852c7feb2d530$var$expandRectOnOneDimension(rect, $05f852c7feb2d530$var$_tmpExpandRectDelta, 'y', 'height', 0, 2, minSize && minSize[1] || 0);
    return rect;
}
var $05f852c7feb2d530$var$_tmpExpandRectDelta = [
    0,
    0,
    0,
    0
];
function $05f852c7feb2d530$var$expandRectOnOneDimension(rect, delta, xy, wh, ltIdx, rbIdx, minSize) {
    var deltaSum = delta[rbIdx] + delta[ltIdx];
    var oldSize = rect[wh];
    rect[wh] += deltaSum;
    minSize = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(0, (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(minSize, oldSize));
    if (rect[wh] < minSize) {
        rect[wh] = minSize;
        // Try to make the position of the zero rect reasonable in most visual cases.
        rect[xy] += delta[ltIdx] >= 0 ? -delta[ltIdx] : delta[rbIdx] >= 0 ? oldSize + delta[rbIdx] : (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(deltaSum) > 1e-8 ? (oldSize - minSize) * delta[ltIdx] / deltaSum : 0;
    } else rect[xy] -= delta[ltIdx];
}
function $05f852c7feb2d530$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)((0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
            content: itemName,
            encodeHTMLContent: true,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $05f852c7feb2d530$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $05f852c7feb2d530$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$05f852c7feb2d530$var$traverseElement(els[i], cb);
        else $05f852c7feb2d530$var$traverseElement(els, cb);
    }
}
function $05f852c7feb2d530$export$576610ccf2234b72(transform) {
    return !transform || (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(transform[1]) < $05f852c7feb2d530$var$AXIS_ALIGN_EPSILON && (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(transform[2]) < $05f852c7feb2d530$var$AXIS_ALIGN_EPSILON || (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(transform[0]) < $05f852c7feb2d530$var$AXIS_ALIGN_EPSILON && (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(transform[3]) < $05f852c7feb2d530$var$AXIS_ALIGN_EPSILON;
}
var $05f852c7feb2d530$var$AXIS_ALIGN_EPSILON = 1e-5;
function $05f852c7feb2d530$export$38128dfd9a498e1(target, source) {
    return target ? (0, $8d3017bded1ca21b$export$2e2bcd8739ae039).copy(target, source) : source.clone();
}
function $05f852c7feb2d530$export$4d61283a070e0362(target, source) {
    return source ? $97681aabb80d556d$export$784d13d8ee351f07(target || $97681aabb80d556d$export$185802fd694ee1f5(), source) : undefined;
}
function $05f852c7feb2d530$export$1500a631bea5adda(model) {
    return {
        z: model.get('z') || 0,
        zlevel: model.get('zlevel') || 0
    };
}
function $05f852c7feb2d530$export$8215ea00957327f2(el) {
    var max = -Infinity;
    var min = Infinity;
    $05f852c7feb2d530$var$traverseElement(el, function(el) {
        visitEl(el);
        visitEl(el.getTextContent());
        visitEl(el.getTextGuideLine());
    });
    function visitEl(el) {
        if (!el || el.isGroup) return;
        var currentStates = el.currentStates;
        if (currentStates.length) for(var idx = 0; idx < currentStates.length; idx++)calcZ2(el.states[currentStates[idx]]);
        calcZ2(el);
    }
    function calcZ2(entity) {
        if (entity) {
            var z2 = entity.z2;
            // Consider z2 may be NullUndefined
            if (z2 > max) max = z2;
            if (z2 < min) min = z2;
        }
    }
    if (min > max) min = max = 0;
    return {
        min: min,
        max: max
    };
}
function $05f852c7feb2d530$export$d31cf465bf5e8879(el, z, zlevel) {
    $05f852c7feb2d530$var$doUpdateZ(el, z, zlevel, -Infinity);
}
function $05f852c7feb2d530$var$doUpdateZ(el, z, zlevel, // FIXME: Ideally all the labels should be above all the glyphs by default,
//  e.g. in graph, edge labels should be above node elements.
//  Currently impl does not guarantee that.
maxZ2) {
    // `ignoreModelZ` is used to intentionally lift elements to cover other elements,
    // where maxZ2 (for label.z2) should also not be counted for its parents.
    if (el.ignoreModelZ) return maxZ2;
    // Group may also have textContent
    var label = el.getTextContent();
    var labelLine = el.getTextGuideLine();
    var isGroup = el.isGroup;
    if (isGroup) {
        // set z & zlevel of children elements of Group
        var children = el.childrenRef();
        for(var i = 0; i < children.length; i++)maxZ2 = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)($05f852c7feb2d530$var$doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
    } else {
        // not Group
        el.z = z;
        el.zlevel = zlevel;
        maxZ2 = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(el.z2 || 0, maxZ2);
    }
    // NOTICE: Do not call any method that can set REDRAW_BIT,
    // otherwise progressive rendering is broken.
    // always set z and zlevel if label/labelLine exists
    if (label) {
        label.z = z;
        label.zlevel = zlevel;
        // lift z2 of text content
        // TODO if el.emphasis.z2 is spcefied, what about textContent.
        isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
    }
    if (labelLine) {
        var textGuideLineConfig = el.textGuideLineConfig;
        labelLine.z = z;
        labelLine.zlevel = zlevel;
        isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
    }
    return maxZ2;
}
function $05f852c7feb2d530$export$6f963a8600ad6f65(payload) {
    // Disable animation in `updateProps` of `graphic.ts`.
    payload.animation = {
        duration: 0
    };
    return payload;
}
function $05f852c7feb2d530$export$31f224ae9d6cf05(out, mt) {
    mt ? $97681aabb80d556d$export$784d13d8ee351f07($05f852c7feb2d530$var$tmpDTR.transform, mt) : $97681aabb80d556d$export$f0954fd7d5368655($05f852c7feb2d530$var$tmpDTR.transform);
    // Use a tmp transformable to avoid effects from parent.
    $05f852c7feb2d530$var$tmpDTR.decomposeTransform();
    (0, $82e5b6aba13917b1$export$234b1c16dfa57d6a)(out, $05f852c7feb2d530$var$tmpDTR);
    return out;
}
var $05f852c7feb2d530$var$tmpDTR = new (0, $82e5b6aba13917b1$export$2e2bcd8739ae039)();
$05f852c7feb2d530$var$tmpDTR.transform = $97681aabb80d556d$export$185802fd694ee1f5();
function $05f852c7feb2d530$export$e8e725f22cc8ef79(api) {
    var painter = api.getZr().painter;
    return painter.getType() === 'canvas' ? painter : null;
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('circle', (0, $f43fbde6d03c3be0$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('ellipse', (0, $b501654321051d8e$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('sector', (0, $bf363fc63c6d894e$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('ring', (0, $b1fbe9680b181e60$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('polygon', (0, $84715c109614a262$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('polyline', (0, $00ca553820255831$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('rect', (0, $439653c37a0e6e60$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('line', (0, $8ae349726e18597f$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('bezierCurve', (0, $90d1bc3a88017526$export$2e2bcd8739ae039));
$05f852c7feb2d530$export$2b95b62e3aaf6fdd('arc', (0, $8c43921d92adb726$export$2e2bcd8739ae039));


var $83b5345ce49bb659$var$EMPTY_OBJ = {};
function $83b5345ce49bb659$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $6243d8dbb37d6b0d$export$151308dceb52d5b).length; i++){
        var stateName = (0, $6243d8dbb37d6b0d$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $83b5345ce49bb659$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $6243d8dbb37d6b0d$export$151308dceb52d5b).length; i++){
        var stateName = (0, $6243d8dbb37d6b0d$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $83b5345ce49bb659$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $83b5345ce49bb659$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $9f8a9b67e62609f8$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $6243d8dbb37d6b0d$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $6243d8dbb37d6b0d$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $9f8a9b67e62609f8$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $83b5345ce49bb659$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $83b5345ce49bb659$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($83b5345ce49bb659$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $6243d8dbb37d6b0d$export$151308dceb52d5b).length; i++){
            var stateName = (0, $6243d8dbb37d6b0d$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $83b5345ce49bb659$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $83b5345ce49bb659$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow('silent');
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $83b5345ce49bb659$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $83b5345ce49bb659$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $83b5345ce49bb659$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $83b5345ce49bb659$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $6243d8dbb37d6b0d$export$151308dceb52d5b).length; i++){
        var stateName = (0, $6243d8dbb37d6b0d$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $83b5345ce49bb659$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $83b5345ce49bb659$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $83b5345ce49bb659$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magic type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    if (opt.autoOverflowArea != null) textConfig.autoOverflowArea = opt.autoOverflowArea;
    if (opt.layoutRect != null) textConfig.layoutRect = opt.layoutRect;
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $83b5345ce49bb659$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $83b5345ce49bb659$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $83b5345ce49bb659$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        var richInheritPlainLabelOptionName = 'richInheritPlainLabel';
        var richInheritPlainLabel = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(textStyleModel.get(richInheritPlainLabelOptionName), ecModel ? ecModel.get(richInheritPlainLabelOptionName) : undefined);
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]);
            // In rich, never `disableBox`.
            // consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            // Since v6, the rich style inherits plain label by default
            // but this behavior can be disabled by setting `richInheritPlainLabel` to `false`.
            $83b5345ce49bb659$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, textStyleModel, richInheritPlainLabel, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var lineOverflow = textStyleModel.get('lineOverflow');
    if (lineOverflow) textStyle.lineOverflow = lineOverflow;
    var labelTextStyle = textStyle;
    // `minMargin` has a higher precedence than `textMargin`, because `textMargin` is allowed
    // to be set in `defaultOption`.
    var minMargin = textStyleModel.get('minMargin');
    if (minMargin != null) {
        // `minMargin` only support number value.
        minMargin = !(0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(minMargin) ? 0 : minMargin / 2;
        labelTextStyle.margin = [
            minMargin,
            minMargin,
            minMargin,
            minMargin
        ];
        labelTextStyle.__marginType = $83b5345ce49bb659$export$2b18df2bc75ae422.minMargin;
    } else {
        var textMargin = textStyleModel.get('textMargin');
        if (textMargin != null) {
            labelTextStyle.margin = (0, $e4c0c902d0f4f283$export$f3a38102c49f4268)(textMargin);
            labelTextStyle.__marginType = $83b5345ce49bb659$export$2b18df2bc75ae422.textMargin;
        }
    }
    $83b5345ce49bb659$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, null, null, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $83b5345ce49bb659$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $83b5345ce49bb659$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $83b5345ce49bb659$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $83b5345ce49bb659$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign',
    'ellipsis'
];
var $83b5345ce49bb659$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $83b5345ce49bb659$var$setTokenTextStyle(textStyle, // FIXME: check/refactor for ellipsis handling of rich text.
textStyleModel, globalTextStyle, plainTextModel, richInheritPlainLabel, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $83b5345ce49bb659$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) // Might not be a string, e.g, it's a function in axisLabel case; but assume that it will
    // be erased by a correct value outside.
    textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $83b5345ce49bb659$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $83b5345ce49bb659$var$TEXT_PROPS_WITH_GLOBAL[i];
        // props width, height, padding, margin, tag, backgroundColor, borderColor,
        // borderWidth, borderRadius, shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY
        // may inappropriate to inherit from plainTextStyle.
        // And if some props is specified in default options, users may have to reset them one by one.
        // Therefore, we only allow these props to inherit from plainTextStyle.
        // `richInheritPlainLabel` is switch for backward compatibility
        var val = richInheritPlainLabel !== false && plainTextModel ? (0, $e4c0c902d0f4f283$export$2e94551289abb95b)(textStyleModel.getShallow(key), plainTextModel.getShallow(key), globalTextStyle[key]) : (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $83b5345ce49bb659$var$TEXT_PROPS_SELF.length; i++){
        var key = $83b5345ce49bb659$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $83b5345ce49bb659$var$TEXT_PROPS_BOX.length; i++){
            var key = $83b5345ce49bb659$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $83b5345ce49bb659$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $83b5345ce49bb659$export$f62786d3261ab0f4 = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
function $83b5345ce49bb659$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $83b5345ce49bb659$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $83b5345ce49bb659$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $83b5345ce49bb659$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $939d3a4c11ee87fd$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $83b5345ce49bb659$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $83b5345ce49bb659$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $97d0e733871fae49$export$a121566aadcfe021) : (0, $97d0e733871fae49$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}
var $83b5345ce49bb659$export$2b18df2bc75ae422 = {
    minMargin: 1,
    textMargin: 2
};



var $e74715ce3216c4c6$var$PATH_COLOR = [
    'textStyle',
    'color'
];
var $e74715ce3216c4c6$var$textStyleParams = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'padding',
    'lineHeight',
    'rich',
    'width',
    'height',
    'overflow'
];
// TODO Performance improvement?
var $e74715ce3216c4c6$var$tmpText = new (0, $9f8a9b67e62609f8$export$2e2bcd8739ae039)();
var $e74715ce3216c4c6$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($e74715ce3216c4c6$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $83b5345ce49bb659$export$155316a870a9d61e)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
        };
        for(var i = 0; i < $e74715ce3216c4c6$var$textStyleParams.length; i++)style[$e74715ce3216c4c6$var$textStyleParams[i]] = this.getShallow($e74715ce3216c4c6$var$textStyleParams[i]);
        $e74715ce3216c4c6$var$tmpText.useStyle(style);
        $e74715ce3216c4c6$var$tmpText.update();
        return $e74715ce3216c4c6$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $e74715ce3216c4c6$export$2e2bcd8739ae039 = $e74715ce3216c4c6$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $141ad3c336686acb$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ]
];
var $141ad3c336686acb$var$getLineStyle = (0, $9d61ee6de44e4c40$export$2e2bcd8739ae039)($141ad3c336686acb$export$9f34de5b59222949);
var $141ad3c336686acb$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $141ad3c336686acb$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c8bd8d6b286b16e5$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ]
];
var $c8bd8d6b286b16e5$var$getItemStyle = (0, $9d61ee6de44e4c40$export$2e2bcd8739ae039)($c8bd8d6b286b16e5$export$ffb0bba5dde0130b);
var $c8bd8d6b286b16e5$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $c8bd8d6b286b16e5$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $7232b75992df3b9d$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $d461075057ee3466$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $01f767c32eb84395$export$cd4c3a4dca301c70)($7232b75992df3b9d$var$Model);
(0, $01f767c32eb84395$export$e1aac4552ae82081)($7232b75992df3b9d$var$Model);
(0, $e4c0c902d0f4f283$export$e36fc9d62a853069)($7232b75992df3b9d$var$Model, (0, $141ad3c336686acb$export$91eeeeed4a69a7e7));
(0, $e4c0c902d0f4f283$export$e36fc9d62a853069)($7232b75992df3b9d$var$Model, (0, $c8bd8d6b286b16e5$export$e4f01e48d6fda412));
(0, $e4c0c902d0f4f283$export$e36fc9d62a853069)($7232b75992df3b9d$var$Model, (0, $7667a8c4ff8696d4$export$a3a0ed7e2dd84c9e));
(0, $e4c0c902d0f4f283$export$e36fc9d62a853069)($7232b75992df3b9d$var$Model, (0, $e74715ce3216c4c6$export$2e2bcd8739ae039));
var $7232b75992df3b9d$export$2e2bcd8739ae039 = $7232b75992df3b9d$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $b08603d2997306ff$var$base = Math.round(Math.random() * 10);
function $b08603d2997306ff$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $b08603d2997306ff$var$base++
    ].join('_');
}
function $b08603d2997306ff$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $01f767c32eb84395$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $01f767c32eb84395$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $b08603d2997306ff$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $e4c0c902d0f4f283$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $e4c0c902d0f4f283$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $e4c0c902d0f4f283$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $e4c0c902d0f4f283$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $e4c0c902d0f4f283$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($e4c0c902d0f4f283$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($e4c0c902d0f4f283$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $e4c0c902d0f4f283$export$79b2f7037acddd43(originalDeps, function(dep) {
            $e4c0c902d0f4f283$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $b08603d2997306ff$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $e4c0c902d0f4f283$export$4950aa0f605343fb($e4c0c902d0f4f283$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $4b4e053c63a2e814$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst',
            custom: 'Custom chart',
            chart: 'Chart'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $9e4276a11248abf0$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};



var $e96c473e8bd88107$var$LOCALE_ZH = 'ZH';
var $e96c473e8bd88107$var$LOCALE_EN = 'EN';
var $e96c473e8bd88107$var$DEFAULT_LOCALE = $e96c473e8bd88107$var$LOCALE_EN;
var $e96c473e8bd88107$var$localeStorage = {};
var $e96c473e8bd88107$var$localeModels = {};
var $e96c473e8bd88107$export$9a2147b3808d4c6b = !(0, $d461075057ee3466$export$2e2bcd8739ae039).domSupported ? $e96c473e8bd88107$var$DEFAULT_LOCALE : function() {
    var langStr = (document.documentElement.lang || navigator.language || navigator.browserLanguage || $e96c473e8bd88107$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($e96c473e8bd88107$var$LOCALE_ZH) > -1 ? $e96c473e8bd88107$var$LOCALE_ZH : $e96c473e8bd88107$var$DEFAULT_LOCALE;
}();
function $e96c473e8bd88107$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $e96c473e8bd88107$var$localeModels[locale] = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(localeObj);
    $e96c473e8bd88107$var$localeStorage[locale] = localeObj;
}
function $e96c473e8bd88107$export$ddc371781a6af754(locale) {
    if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(locale)) {
        var localeObj = $e96c473e8bd88107$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $e96c473e8bd88107$var$LOCALE_ZH || locale === $e96c473e8bd88107$var$LOCALE_EN) return (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(localeObj);
        else return (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)((0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(localeObj), (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)($e96c473e8bd88107$var$localeStorage[$e96c473e8bd88107$var$DEFAULT_LOCALE]), false);
    } else return (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)((0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(locale), (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)($e96c473e8bd88107$var$localeStorage[$e96c473e8bd88107$var$DEFAULT_LOCALE]), false);
}
function $e96c473e8bd88107$export$37cc638e0e11865f(lang) {
    return $e96c473e8bd88107$var$localeModels[lang];
}
function $e96c473e8bd88107$export$1188f179b2597821() {
    return $e96c473e8bd88107$var$localeModels[$e96c473e8bd88107$var$DEFAULT_LOCALE];
}
// Default locale
$e96c473e8bd88107$export$bab6a7822cc1e2cd($e96c473e8bd88107$var$LOCALE_EN, (0, $4b4e053c63a2e814$export$2e2bcd8739ae039));
$e96c473e8bd88107$export$bab6a7822cc1e2cd($e96c473e8bd88107$var$LOCALE_ZH, (0, $9e4276a11248abf0$export$2e2bcd8739ae039));



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $88f2be8efb09cff5$var$_impl = null;
function $88f2be8efb09cff5$export$11977f1e90ef55cf(impl) {
    if (!$88f2be8efb09cff5$var$_impl) $88f2be8efb09cff5$var$_impl = impl;
}
function $88f2be8efb09cff5$export$e79b20ac82c2d660() {
    return $88f2be8efb09cff5$var$_impl;
}
function $88f2be8efb09cff5$export$770ec3eb53b5689b(scale, opt) {
    var scaleBreakHelper = $88f2be8efb09cff5$export$e79b20ac82c2d660();
    var breakOption = opt.breakOption;
    var breakParsed = opt.breakParsed;
    if (!breakParsed && scaleBreakHelper) breakParsed = scaleBreakHelper.parseAxisBreakOption(breakOption, scale);
    return breakParsed;
}
function $88f2be8efb09cff5$export$20734ee5f1d5720f(scale) {
    var brk = scale.brk;
    return brk ? brk.breaks : [];
}
function $88f2be8efb09cff5$export$fec008222a1db2dc(scale) {
    var brk = scale.brk;
    return brk ? brk.hasBreaks() : false;
}


var $a8ce5c3e1c58d573$export$32c0454ceff7f92d = 1000;
var $a8ce5c3e1c58d573$export$35acaebf644db34e = $a8ce5c3e1c58d573$export$32c0454ceff7f92d * 60;
var $a8ce5c3e1c58d573$export$82541edf19e5e3b0 = $a8ce5c3e1c58d573$export$35acaebf644db34e * 60;
var $a8ce5c3e1c58d573$export$a97a1358cbb650ab = $a8ce5c3e1c58d573$export$82541edf19e5e3b0 * 24;
var $a8ce5c3e1c58d573$export$99cafda57477293d = $a8ce5c3e1c58d573$export$a97a1358cbb650ab * 365;
var $a8ce5c3e1c58d573$var$primaryTimeUnitFormatterMatchers = {
    year: /({yyyy}|{yy})/,
    month: /({MMMM}|{MMM}|{MM}|{M})/,
    day: /({dd}|{d})/,
    hour: /({HH}|{H}|{hh}|{h})/,
    minute: /({mm}|{m})/,
    second: /({ss}|{s})/,
    millisecond: /({SSS}|{S})/
};
var $a8ce5c3e1c58d573$var$defaultFormatterSeed = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}'
};
var $a8ce5c3e1c58d573$var$defaultFullFormatter = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}';
var $a8ce5c3e1c58d573$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $a8ce5c3e1c58d573$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $a8ce5c3e1c58d573$var$fullDayFormatter,
    hour: $a8ce5c3e1c58d573$var$fullDayFormatter + ' ' + $a8ce5c3e1c58d573$var$defaultFormatterSeed.hour,
    minute: $a8ce5c3e1c58d573$var$fullDayFormatter + ' ' + $a8ce5c3e1c58d573$var$defaultFormatterSeed.minute,
    second: $a8ce5c3e1c58d573$var$fullDayFormatter + ' ' + $a8ce5c3e1c58d573$var$defaultFormatterSeed.second,
    millisecond: $a8ce5c3e1c58d573$var$defaultFullFormatter
};
var $a8ce5c3e1c58d573$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $a8ce5c3e1c58d573$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $a8ce5c3e1c58d573$export$f16a827770bdffb5(formatter) {
    // Keep the logic the same with function `leveledFormat`.
    return !$e4c0c902d0f4f283$export$844ec244b1367d54(formatter) && !$e4c0c902d0f4f283$export$f6e2535fb5126e54(formatter) ? $a8ce5c3e1c58d573$var$parseTimeAxisLabelFormatterDictionary(formatter) : formatter;
}
/**
 * The final generated dictionary is like:
 *  generated_dict = {
 *      year: {
 *          year: ['{yyyy}', ...<higher_levels_if_any>]
 *      },
 *      month: {
 *          year: ['{yyyy} {MMM}', ...<higher_levels_if_any>],
 *          month: ['{MMM}', ...<higher_levels_if_any>]
 *      },
 *      day: {
 *          year: ['{yyyy} {MMM} {d}', ...<higher_levels_if_any>],
 *          month: ['{MMM} {d}', ...<higher_levels_if_any>],
 *          day: ['{d}', ...<higher_levels_if_any>]
 *      },
 *      ...
 *  }
 *
 * In echarts option, users can specify the entire dictionary or typically just:
 *  {formatter: {
 *      year: '{yyyy}', // Or an array of leveled templates: `['{yyyy}', '{bold1|{yyyy}}', ...]`,
 *                      // corresponding to `[level0, level1, level2, ...]`.
 *      month: '{MMM}',
 *      day: '{d}',
 *      hour: '{HH}:{mm}',
 *      second: '{HH}:{mm}',
 *      ...
 *  }}
 *  If any time unit is not specified in echarts option, the default template is used,
 *  such as `['{yyyy}', {primary|{yyyy}']`.
 *
 * The `tick.level` is only used to read string from each array, meaning the style type.
 *
 * Let `lowerUnit = getUnitFromValue(tick.value)`.
 * The non-break axis ticks only use `generated_dict[lowerUnit][lowerUnit][level]`.
 * The break axis ticks may use `generated_dict[lowerUnit][upperUnit][level]`, because:
 *  Consider the case: the non-break ticks are `16th, 23th, Feb, 7th, ...`, where `Feb` is in the break
 *  range and pruned by breaks, and the break ends might be in lower time unit than day. e.g., break start
 *  is `Jan 25th 18:00`(in unit `hour`) and break end is `Feb 6th 18:30` (in unit `minute`). Thus the break
 *  label prefers `Jan 25th 18:00` and `Feb 6th 18:30` rather than only `18:00` and `18:30`, otherwise it
 *  causes misleading.
 *  In this case, the tick of the break start and end will both be:
 *      `{level: 1, lowerTimeUnit: 'minute', upperTimeUnit: 'month'}`
 *  And get the final template by `generated_dict[lowerTimeUnit][upperTimeUnit][level]`.
 *  Note that the time unit can not be calculated directly by a single tick value, since the two breaks have
 *  to be at the same time unit to avoid awkward appearance. i.e., `Jan 25th 18:00` is in the time unit "hour"
 *  but we need it to be "minute", following `Feb 6th 18:30`.
 */ function $a8ce5c3e1c58d573$var$parseTimeAxisLabelFormatterDictionary(dictOption) {
    dictOption = dictOption || {};
    var dict = {};
    // Currently if any template is specified by user, it may contain rich text tag,
    // such as `'{my_bold|{YYYY}}'`, thus we do add highlight style to it.
    // (Note that nested tag (`'{some|{some2|xxx}}'`) in rich text is not supported yet.)
    var canAddHighlight = true;
    $e4c0c902d0f4f283$export$79b2f7037acddd43($a8ce5c3e1c58d573$export$87100da04d711986, function(lowestUnit) {
        canAddHighlight && (canAddHighlight = dictOption[lowestUnit] == null);
    });
    $e4c0c902d0f4f283$export$79b2f7037acddd43($a8ce5c3e1c58d573$export$87100da04d711986, function(lowestUnit, lowestUnitIdx) {
        var upperDictOption = dictOption[lowestUnit];
        dict[lowestUnit] = {};
        var lowerTpl = null;
        for(var upperUnitIdx = lowestUnitIdx; upperUnitIdx >= 0; upperUnitIdx--){
            var upperUnit = $a8ce5c3e1c58d573$export$87100da04d711986[upperUnitIdx];
            var upperDictItemOption = $e4c0c902d0f4f283$export$a6cdc56e425d0d0a(upperDictOption) && !$e4c0c902d0f4f283$export$43bee75e5e14138e(upperDictOption) ? upperDictOption[upperUnit] : upperDictOption;
            var tplArr = void 0;
            if ($e4c0c902d0f4f283$export$43bee75e5e14138e(upperDictItemOption)) {
                tplArr = upperDictItemOption.slice();
                lowerTpl = tplArr[0] || '';
            } else if ($e4c0c902d0f4f283$export$844ec244b1367d54(upperDictItemOption)) {
                lowerTpl = upperDictItemOption;
                tplArr = [
                    lowerTpl
                ];
            } else {
                if (lowerTpl == null) lowerTpl = $a8ce5c3e1c58d573$var$defaultFormatterSeed[lowestUnit];
                else if (!$a8ce5c3e1c58d573$var$primaryTimeUnitFormatterMatchers[upperUnit].test(lowerTpl)) lowerTpl = dict[upperUnit][upperUnit][0] + " " + lowerTpl;
                tplArr = [
                    lowerTpl
                ];
                if (canAddHighlight) tplArr[1] = "{primary|" + lowerTpl + "}";
            }
            dict[lowestUnit][upperUnit] = tplArr;
        }
    });
    return dict;
}
function $a8ce5c3e1c58d573$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $a8ce5c3e1c58d573$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $a8ce5c3e1c58d573$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $a8ce5c3e1c58d573$export$1da4b91a25d7e1c8(timeUnit);
}
function $a8ce5c3e1c58d573$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $a8ce5c3e1c58d573$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $0b2f7076fd7740ca$export$6b862160d295c8e(time);
    var y = date[$a8ce5c3e1c58d573$export$8d046fefed9a548e(isUTC)]();
    var M = date[$a8ce5c3e1c58d573$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$a8ce5c3e1c58d573$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$a8ce5c3e1c58d573$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$a8ce5c3e1c58d573$export$8807847c5c71eded(isUTC)]();
    var s = date[$a8ce5c3e1c58d573$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$a8ce5c3e1c58d573$export$312207a92d041116(isUTC)]();
    var a = H >= 12 ? 'pm' : 'am';
    var A = a.toUpperCase();
    var localeModel = lang instanceof (0, $7232b75992df3b9d$export$2e2bcd8739ae039) ? lang : (0, $e96c473e8bd88107$export$37cc638e0e11865f)(lang || (0, $e96c473e8bd88107$export$9a2147b3808d4c6b)) || (0, $e96c473e8bd88107$export$1188f179b2597821)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{a}/g, a + '').replace(/{A}/g, A + '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, $a8ce5c3e1c58d573$export$5d04458e2a6c373e(y % 100 + '', 2)).replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $a8ce5c3e1c58d573$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $a8ce5c3e1c58d573$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $a8ce5c3e1c58d573$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $a8ce5c3e1c58d573$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $a8ce5c3e1c58d573$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $a8ce5c3e1c58d573$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $a8ce5c3e1c58d573$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $a8ce5c3e1c58d573$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($e4c0c902d0f4f283$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(formatter)) {
        var extra = {
            time: tick.time,
            level: tick.time ? tick.time.level : 0
        };
        var scaleBreakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
        if (scaleBreakHelper) scaleBreakHelper.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
        template = formatter(tick.value, idx, extra);
    } else {
        var tickTime = tick.time;
        if (tickTime) {
            var leveledTplArr = formatter[tickTime.lowerTimeUnit][tickTime.upperTimeUnit];
            template = leveledTplArr[Math.min(tickTime.level, leveledTplArr.length - 1)] || '';
        } else {
            // tick may be from customTicks or timeline therefore no tick.time.
            var unit = $a8ce5c3e1c58d573$export$4dfb0417ad6555b7(tick.value, isUTC);
            template = formatter[unit][unit][0];
        }
    }
    return $a8ce5c3e1c58d573$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $a8ce5c3e1c58d573$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $0b2f7076fd7740ca$export$6b862160d295c8e(value);
    var M = date[$a8ce5c3e1c58d573$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$a8ce5c3e1c58d573$export$4189e6cbc9753260(isUTC)]();
    var h = date[$a8ce5c3e1c58d573$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$a8ce5c3e1c58d573$export$8807847c5c71eded(isUTC)]();
    var s = date[$a8ce5c3e1c58d573$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$a8ce5c3e1c58d573$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $a8ce5c3e1c58d573$export$2ed3384313b02c28(date, timeUnit, isUTC) {
    switch(timeUnit){
        case 'year':
            date[$a8ce5c3e1c58d573$export$233f59998ed71c09(isUTC)](0);
        case 'month':
            date[$a8ce5c3e1c58d573$export$82fd379a67f37fa0(isUTC)](1);
        case 'day':
            date[$a8ce5c3e1c58d573$export$b6f943e8d23c15bb(isUTC)](0);
        case 'hour':
            date[$a8ce5c3e1c58d573$export$50303078793fc7d(isUTC)](0);
        case 'minute':
            date[$a8ce5c3e1c58d573$export$a4a908acda9c3118(isUTC)](0);
        case 'second':
            date[$a8ce5c3e1c58d573$export$c047afab75f6d84(isUTC)](0);
    }
    return date;
}
function $a8ce5c3e1c58d573$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $a8ce5c3e1c58d573$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $a8ce5c3e1c58d573$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $a8ce5c3e1c58d573$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $a8ce5c3e1c58d573$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $a8ce5c3e1c58d573$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $a8ce5c3e1c58d573$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $a8ce5c3e1c58d573$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $a8ce5c3e1c58d573$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $a8ce5c3e1c58d573$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $a8ce5c3e1c58d573$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $a8ce5c3e1c58d573$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $a8ce5c3e1c58d573$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $a8ce5c3e1c58d573$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}





function $c09e8b26bdb81866$export$b6fe44657ce35c42(x) {
    if (!(0, $0b2f7076fd7740ca$export$e90fb89750dba83f)(x)) return $e4c0c902d0f4f283$export$844ec244b1367d54(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $c09e8b26bdb81866$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $c09e8b26bdb81866$export$f3a38102c49f4268 = $e4c0c902d0f4f283$export$f3a38102c49f4268;
function $c09e8b26bdb81866$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $e4c0c902d0f4f283$export$87c2784dc9fc4ab(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return (0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(num);
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $0b2f7076fd7740ca$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $a8ce5c3e1c58d573$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $e4c0c902d0f4f283$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $e4c0c902d0f4f283$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
    // By default.
    var numericResult = (0, $0b2f7076fd7740ca$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $c09e8b26bdb81866$export$b6fe44657ce35c42(numericResult) : $e4c0c902d0f4f283$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
}
var $c09e8b26bdb81866$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $c09e8b26bdb81866$var$wrapVar = function(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $c09e8b26bdb81866$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$e4c0c902d0f4f283$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $c09e8b26bdb81866$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($c09e8b26bdb81866$var$wrapVar(alias), $c09e8b26bdb81866$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($c09e8b26bdb81866$var$wrapVar($c09e8b26bdb81866$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $c09e8b26bdb81866$export$2fa08233ee42f8e1(tpl, param, encode) {
    $e4c0c902d0f4f283$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $c09e8b26bdb81866$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $e4c0c902d0f4f283$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $c09e8b26bdb81866$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $0b2f7076fd7740ca$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? 'getUTC' : 'get';
    var y = date[getUTC + 'FullYear']();
    var M = date[getUTC + 'Month']() + 1;
    var d = date[getUTC + 'Date']();
    var h = date[getUTC + 'Hours']();
    var m = date[getUTC + 'Minutes']();
    var s = date[getUTC + 'Seconds']();
    var S = date[getUTC + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $a8ce5c3e1c58d573$export$5d04458e2a6c373e)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', (0, $a8ce5c3e1c58d573$export$5d04458e2a6c373e)(y % 100 + '', 2)).replace('dd', (0, $a8ce5c3e1c58d573$export$5d04458e2a6c373e)(d, 2)).replace('d', d).replace('hh', (0, $a8ce5c3e1c58d573$export$5d04458e2a6c373e)(h, 2)).replace('h', h).replace('mm', (0, $a8ce5c3e1c58d573$export$5d04458e2a6c373e)(m, 2)).replace('m', m).replace('ss', (0, $a8ce5c3e1c58d573$export$5d04458e2a6c373e)(s, 2)).replace('s', s).replace('SSS', (0, $a8ce5c3e1c58d573$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $c09e8b26bdb81866$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $c09e8b26bdb81866$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $e4c0c902d0f4f283$export$844ec244b1367d54(color) ? color : $e4c0c902d0f4f283$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $c09e8b26bdb81866$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/**
 * FIXME:
 * `nonSeriesBoxCoordSysCreators` and `_nonSeriesBoxMasterList` are hardcoded implementations.
 * Regarding "coord sys layout based on another coord sys", currently we only experimentally support one level
 * dependency, such as, "grid(cartesian)s can be laid out based on matrix/calendar coord sys."
 * But a comprehensive implementation may need to support:
 *  - Recursive dependencies. e.g., a matrix coord sys lays out based on another matrix coord sys.
 *    That requires in the implementation `create` and `update` of coord sys are called by a dependency graph.
 *    (@see enableTopologicalTravel in `util/component.ts`)
 */ var $65108a454a48746f$var$nonSeriesBoxCoordSysCreators = {};
var $65108a454a48746f$var$normalCoordSysCreators = {};
var $65108a454a48746f$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._normalMasterList = [];
        this._nonSeriesBoxMasterList = [];
    }
    /**
   * Typically,
   *  - in `create`, a coord sys lays out based on a given rect;
   *  - in `update`, update the pixel and data extent of there axes (if any) based on processed `series.data`.
   * After that, a coord sys can serve (typically by `dataToPoint`/`dataToLayout`/`pointToData`).
   * If the coordinate system do not lay out based on `series.data`, `update` is not needed.
   */ CoordinateSystemManager.prototype.create = function(ecModel, api) {
        this._nonSeriesBoxMasterList = dealCreate($65108a454a48746f$var$nonSeriesBoxCoordSysCreators, true);
        this._normalMasterList = dealCreate($65108a454a48746f$var$normalCoordSysCreators, false);
        function dealCreate(creatorMap, canBeNonSeriesBox) {
            var coordinateSystems = [];
            $e4c0c902d0f4f283$export$79b2f7037acddd43(creatorMap, function(creator, type) {
                var list = creator.create(ecModel, api);
                coordinateSystems = coordinateSystems.concat(list || []);
            });
            return coordinateSystems;
        }
    };
    /**
   * @see CoordinateSystem['create']
   */ CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $e4c0c902d0f4f283$export$79b2f7037acddd43(this._normalMasterList, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._normalMasterList.concat(this._nonSeriesBoxMasterList);
    };
    CoordinateSystemManager.register = function(type, creator) {
        if (type === 'matrix' || type === 'calendar') {
            // FIXME: hardcode, @see nonSeriesBoxCoordSysCreators
            $65108a454a48746f$var$nonSeriesBoxCoordSysCreators[type] = creator;
            return;
        }
        $65108a454a48746f$var$normalCoordSysCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $65108a454a48746f$var$normalCoordSysCreators[type] || $65108a454a48746f$var$nonSeriesBoxCoordSysCreators[type];
    };
    return CoordinateSystemManager;
}();
function $65108a454a48746f$var$canBeNonSeriesBoxCoordSys(coordSysType) {
    return !!$65108a454a48746f$var$nonSeriesBoxCoordSysCreators[coordSysType];
}
var $65108a454a48746f$export$6755bb1cf0b796be = 1;
var $65108a454a48746f$export$d88bf84633e72240 = 2;
function $65108a454a48746f$export$b8fb890203e861d5(opt) {
    $65108a454a48746f$var$coordSysUseMap.set(opt.fullType, {
        getCoord2: undefined
    }).getCoord2 = opt.getCoord2;
}
var $65108a454a48746f$var$coordSysUseMap = $e4c0c902d0f4f283$export$55f8aa7ef875b0a4();
function $65108a454a48746f$export$4818264084d885e(model) {
    var coord = model.getShallow('coord', true);
    var from = $65108a454a48746f$export$6755bb1cf0b796be;
    if (coord == null) {
        var store = $65108a454a48746f$var$coordSysUseMap.get(model.type);
        if (store && store.getCoord2) {
            from = $65108a454a48746f$export$d88bf84633e72240;
            coord = store.getCoord2(model);
        }
    }
    return {
        coord: coord,
        from: from
    };
}
var $65108a454a48746f$export$bd9a7aa65874feb1 = 0;
var $65108a454a48746f$export$87a00611f63b7e87 = 1;
var $65108a454a48746f$export$e670080ba75bc9e9 = 2;
function $65108a454a48746f$export$29cb72d70b6b3a71(// Component or series
model, printError) {
    // For backward compat, still not use `true` in model.get.
    var coordSysType = model.getShallow('coordinateSystem');
    var coordSysUsageOption = model.getShallow('coordinateSystemUsage', true);
    var isDeclaredExplicitly = coordSysUsageOption != null;
    var kind = $65108a454a48746f$export$bd9a7aa65874feb1;
    if (coordSysType) {
        var isSeries = model.mainType === 'series';
        if (coordSysUsageOption == null) coordSysUsageOption = isSeries ? 'data' : 'box';
        if (coordSysUsageOption === 'data') {
            kind = $65108a454a48746f$export$87a00611f63b7e87;
            if (!isSeries) kind = $65108a454a48746f$export$bd9a7aa65874feb1;
        } else if (coordSysUsageOption === 'box') {
            kind = $65108a454a48746f$export$e670080ba75bc9e9;
            if (!isSeries && !$65108a454a48746f$var$canBeNonSeriesBoxCoordSys(coordSysType)) kind = $65108a454a48746f$export$bd9a7aa65874feb1;
        }
    }
    return {
        coordSysType: coordSysType,
        kind: kind
    };
}
function $65108a454a48746f$export$7ed0c09d4f5c932e(opt) {
    var targetModel = opt.targetModel, coordSysType = opt.coordSysType, coordSysProvider = opt.coordSysProvider, isDefaultDataCoordSys = opt.isDefaultDataCoordSys, allowNotFound = opt.allowNotFound;
    var _a = $65108a454a48746f$export$29cb72d70b6b3a71(targetModel, true), kind = _a.kind, declaredType = _a.coordSysType;
    if (isDefaultDataCoordSys && kind !== $65108a454a48746f$export$87a00611f63b7e87) {
        // If both `COORD_SYS_USAGE_KIND_DATA` and `COORD_SYS_USAGE_KIND_BOX` declared in one model.
        // There is the only case in series-graph, and no other cases yet.
        kind = $65108a454a48746f$export$87a00611f63b7e87;
        declaredType = coordSysType;
    }
    if (kind === $65108a454a48746f$export$bd9a7aa65874feb1 || declaredType !== coordSysType) return $65108a454a48746f$export$bd9a7aa65874feb1;
    var coordSys = coordSysProvider(coordSysType, targetModel);
    if (!coordSys) return $65108a454a48746f$export$bd9a7aa65874feb1;
    if (kind === $65108a454a48746f$export$87a00611f63b7e87) targetModel.coordinateSystem = coordSys;
    else // kind === COORD_SYS_USAGE_KIND_BOX
    targetModel.boxCoordinateSystem = coordSys;
    return kind;
}
var $65108a454a48746f$export$33b06c851894cd19 = function(coordSysType, injectTargetModel) {
    var coordSysModel = injectTargetModel.getReferringComponents(coordSysType, (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
    return coordSysModel && coordSysModel.coordinateSystem;
};
var $65108a454a48746f$export$2e2bcd8739ae039 = $65108a454a48746f$var$CoordinateSystemManager;


var $52313d605bb144f5$var$each = $e4c0c902d0f4f283$export$79b2f7037acddd43;
var $52313d605bb144f5$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $52313d605bb144f5$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $52313d605bb144f5$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $52313d605bb144f5$export$827f4ee28efc37 = $52313d605bb144f5$var$boxLayout;
var $52313d605bb144f5$export$be20d9158c17374c = $e4c0c902d0f4f283$export$c3095a23b368d1f2($52313d605bb144f5$var$boxLayout, 'vertical');
var $52313d605bb144f5$export$ae65a483d943e7a7 = $e4c0c902d0f4f283$export$c3095a23b368d1f2($52313d605bb144f5$var$boxLayout, 'horizontal');
function $52313d605bb144f5$export$22344244a123da8(boxLayoutModel, ignoreParent) {
    return {
        left: boxLayoutModel.getShallow('left', ignoreParent),
        top: boxLayoutModel.getShallow('top', ignoreParent),
        right: boxLayoutModel.getShallow('right', ignoreParent),
        bottom: boxLayoutModel.getShallow('bottom', ignoreParent),
        width: boxLayoutModel.getShallow('width', ignoreParent),
        height: boxLayoutModel.getShallow('height', ignoreParent)
    };
}
function $52313d605bb144f5$var$getViewRectAndCenterForCircleLayout(seriesModel, api) {
    var layoutRef = $52313d605bb144f5$export$5aec1e94f566e59f(seriesModel, api, {
        enableLayoutOnlyByCenter: true
    });
    var boxLayoutParams = seriesModel.getBoxLayoutParams();
    var viewRect;
    var center;
    if (layoutRef.type === $52313d605bb144f5$export$953b11ffc6912560.point) {
        center = layoutRef.refPoint;
        // `viewRect` is required in `pie/labelLayout.ts`.
        viewRect = $52313d605bb144f5$export$4517a5ca639a7293(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
    } else {
        // layoutRef.type === layout.BoxLayoutReferenceType.rect
        var centerOption = seriesModel.get('center');
        var centerOptionArr = $e4c0c902d0f4f283$export$43bee75e5e14138e(centerOption) ? centerOption : [
            centerOption,
            centerOption
        ];
        viewRect = $52313d605bb144f5$export$4517a5ca639a7293(boxLayoutParams, layoutRef.refContainer);
        center = layoutRef.boxCoordFrom === (0, $65108a454a48746f$export$d88bf84633e72240) ? layoutRef.refPoint // option `series.center` has been used as coord.
         : [
            (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(centerOptionArr[0], viewRect.width) + viewRect.x,
            (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(centerOptionArr[1], viewRect.height) + viewRect.y
        ];
    }
    return {
        viewRect: viewRect,
        center: center
    };
}
function $52313d605bb144f5$export$3101c00baac0ee1f(seriesModel, api) {
    // center can be string or number when coordinateSystem is specified
    var _a = $52313d605bb144f5$var$getViewRectAndCenterForCircleLayout(seriesModel, api), viewRect = _a.viewRect, center = _a.center;
    var radius = seriesModel.get('radius');
    if (!$e4c0c902d0f4f283$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    return {
        cx: center[0],
        cy: center[1],
        r0: r0,
        r: r,
        viewRect: viewRect
    };
}
function $52313d605bb144f5$export$4517a5ca639a7293(positionInfo, containerRect, // This is the space from the `containerRect` to the returned bounding rect.
// Commonly used in option `legend.padding`, `timeline.padding`, `title.padding`,
//  `visualMap.padding`, ...
// [NOTICE]:
//  It's named `margin`, because it's the space that outside the bounding rect. But from
//  the perspective of the the caller, it's commonly used as the `padding` of a component,
//  because conventionally background color covers this space.
// [BEHAVIOR]:
//  - If width/height is specified, `margin` does not effect them.
//  - Otherwise, they are calculated based on the rect that `containerRect` shrinked by `margin`.
//  - left/right/top/bottom are based on the rect that `containerRect` shrinked by `margin`.
margin) {
    margin = $c09e8b26bdb81866$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            // PENDING: if only `left` or `right` is defined, perhaps it's more preferable to
            // calculate size based on `containerWidth - left` or `containerWidth - left` here,
            // but for backward compatibility we do not change it.
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)((containerRect.x || 0) + left + margin[3], (containerRect.y || 0) + top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $52313d605bb144f5$export$9fec79e40d579ea7(component, layoutRect, // That is, `width / height`.
// Assume `aspect` is positive.
aspect) {
    var preserveAspect = component.getShallow('preserveAspect', true);
    if (!preserveAspect) return layoutRect;
    var actualAspect = layoutRect.width / layoutRect.height;
    if (Math.abs(Math.atan(aspect) - Math.atan(actualAspect)) < 1e-9) return layoutRect;
    var preserveAspectAlign = component.getShallow('preserveAspectAlign', true);
    var preserveAspectVerticalAlign = component.getShallow('preserveAspectVerticalAlign', true);
    var layoutOptInner = {
        width: layoutRect.width,
        height: layoutRect.height
    };
    var isCover = preserveAspect === 'cover';
    if (actualAspect > aspect && !isCover || actualAspect < aspect && isCover) {
        layoutOptInner.width = layoutRect.height * aspect;
        preserveAspectAlign === 'left' ? layoutOptInner.left = 0 : preserveAspectAlign === 'right' ? layoutOptInner.right = 0 : layoutOptInner.left = 'center';
    } else {
        layoutOptInner.height = layoutRect.width / aspect;
        preserveAspectVerticalAlign === 'top' ? layoutOptInner.top = 0 : preserveAspectVerticalAlign === 'bottom' ? layoutOptInner.bottom = 0 : layoutOptInner.top = 'middle';
    }
    return $52313d605bb144f5$export$4517a5ca639a7293(layoutOptInner, layoutRect);
}
var $52313d605bb144f5$export$953b11ffc6912560 = {
    rect: 1,
    point: 2
};
function $52313d605bb144f5$export$5aec1e94f566e59f(model, api, opt) {
    var refContainer;
    var refPoint;
    var layoutRefType;
    var boxCoordSys = model.boxCoordinateSystem;
    var boxCoordFrom;
    if (boxCoordSys) {
        var _a = (0, $65108a454a48746f$export$4818264084d885e)(model), coord = _a.coord, from = _a.from;
        // Do not use `clamp` in `dataToLayout` and `dataToPoint`, because:
        //  1. Should support overflow (such as, by dataZoom), where NaN should be in the result.
        //  2. Be consistent with the way used in `series.data`
        if (boxCoordSys.dataToLayout) {
            layoutRefType = $52313d605bb144f5$export$953b11ffc6912560.rect;
            boxCoordFrom = from;
            var result = boxCoordSys.dataToLayout(coord);
            refContainer = result.contentRect || result.rect;
        } else if (opt && opt.enableLayoutOnlyByCenter && boxCoordSys.dataToPoint) {
            layoutRefType = $52313d605bb144f5$export$953b11ffc6912560.point;
            boxCoordFrom = from;
            refPoint = boxCoordSys.dataToPoint(coord);
        }
    }
    if (layoutRefType == null) layoutRefType = $52313d605bb144f5$export$953b11ffc6912560.rect;
    if (layoutRefType === $52313d605bb144f5$export$953b11ffc6912560.rect) {
        if (!refContainer) refContainer = {
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        };
        refPoint = [
            refContainer.x + refContainer.width / 2,
            refContainer.y + refContainer.height / 2
        ];
    }
    return {
        type: layoutRefType,
        refContainer: refContainer,
        refPoint: refPoint,
        boxCoordFrom: boxCoordFrom
    };
}
function $52313d605bb144f5$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $52313d605bb144f5$export$4517a5ca639a7293($e4c0c902d0f4f283$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $52313d605bb144f5$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$52313d605bb144f5$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$52313d605bb144f5$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$52313d605bb144f5$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $52313d605bb144f5$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $e4c0c902d0f4f283$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $52313d605bb144f5$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$e4c0c902d0f4f283$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($52313d605bb144f5$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($52313d605bb144f5$export$d7fd4338c7b20804[1], 1);
    copy($52313d605bb144f5$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($52313d605bb144f5$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $52313d605bb144f5$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $52313d605bb144f5$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            $e4c0c902d0f4f283$export$b5a638e9b3fff9f3(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!$e4c0c902d0f4f283$export$b5a638e9b3fff9f3(newParams, name_1) && $e4c0c902d0f4f283$export$b5a638e9b3fff9f3(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $52313d605bb144f5$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $52313d605bb144f5$export$4b0d20af19c9875e(source) {
    return $52313d605bb144f5$export$7438999faea9b6cc({}, source);
}
function $52313d605bb144f5$export$7438999faea9b6cc(target, source) {
    source && target && $52313d605bb144f5$var$each($52313d605bb144f5$export$a9aa2cc018afbed, function(name) {
        $e4c0c902d0f4f283$export$b5a638e9b3fff9f3(source, name) && (target[name] = source[name]);
    });
    return target;
}


var $879a47e830ab7f41$var$inner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $879a47e830ab7f41$var$ComponentModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $b08603d2997306ff$export$6d2b3473b0986646('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $52313d605bb144f5$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $52313d605bb144f5$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $e4c0c902d0f4f283$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $e4c0c902d0f4f283$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $52313d605bb144f5$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $e4c0c902d0f4f283$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $52313d605bb144f5$export$3968a28a7cbd6063(this);
        if (layoutMode) $52313d605bb144f5$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {
    // MUST NOT do anything here.
    };
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        if (!(0, $01f767c32eb84395$export$4f3b818f3dd2d182)(ctor)) // When using ES class declaration, defaultOption must be declared as static.
        // And manually inherit the defaultOption from its parent class if needed, such as,
        //  ```ts
        //  static defaultOption = inheritDefaultOption(ParentModel.defaultOption, {...});
        //  ```
        return ctor.defaultOption;
        // FIXME: remove this approach?
        // Legacy: auto merge defaultOption from ancestor classes if using ParentClass.extend(subProto)
        var fields = $879a47e830ab7f41$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $e4c0c902d0f4f283$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $939d3a4c11ee87fd$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        // For backward compatibility, by default do not `ignoreParent`.
        return $52313d605bb144f5$export$22344244a123da8(this, false);
    };
    /**
   * If developers don't configure zlevel. We will assign zlevel to series based on the key, if provided.
   * For example, lines with trail effect is expected to be in an individual zlevel.
   *
   * @tutorial [GET_ZLEVEL_KEY_FOR_PROGRESSIVE]
   * Regarding "progressive rendering", zrender can automatically assign a dedicated "incremental layer"
   * for `el.incremental` per zlevel. But there is a trade-off:
   *  - If we do not provide different zlevelKey for different series here, all incremental elements from
   *    different series will be assigned to one incremental layer, which causes them to cover each other
   *    in an order depending on progressive steps.
   *      i.e., seriesA_el1 -covered_by-> seriesB_el1 -covered_by-> seriesC_el1 -> seriesA_el2 -> seriesB_el2 ...
   *    This order may causes an unexpected visual result: series with small data are likely to be completely
   *    covered by series with large data. (like in test/scatter-weibo.html)
   *  - If we assign a different zlevelKey to each series, the "covering issue" above can be resolved,
   *    but having one HTML Canvas per series may be excessively memory-consuming.
   *  Therefore, we only automatically assign zlevelKey on `ScatterSeries` and `LinesSeries` for backward
   *  compatibility, and not to other series. Users can explicitly assign zlevel if they encouter above
   *  "covering issue".
   */ ComponentModel.prototype.getZLevelKey = function() {
        return '';
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $7232b75992df3b9d$export$2e2bcd8739ae039));
(0, $01f767c32eb84395$export$c9c2d87774f1275d)($879a47e830ab7f41$var$ComponentModel, (0, $7232b75992df3b9d$export$2e2bcd8739ae039));
(0, $01f767c32eb84395$export$241315e45585454d)($879a47e830ab7f41$var$ComponentModel);
$b08603d2997306ff$export$b9faf30b7d655a6f($879a47e830ab7f41$var$ComponentModel);
$b08603d2997306ff$export$ce592d345a3ec040($879a47e830ab7f41$var$ComponentModel, $879a47e830ab7f41$var$getDependencies);
function $879a47e830ab7f41$var$getDependencies(componentType) {
    var deps = [];
    $e4c0c902d0f4f283$export$79b2f7037acddd43($879a47e830ab7f41$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $e4c0c902d0f4f283$export$871de8747c9eaa88(deps, function(type) {
        return (0, $01f767c32eb84395$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== 'dataset' && $e4c0c902d0f4f283$export$305f7d4e9d4624f2(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $879a47e830ab7f41$export$2e2bcd8739ae039 = $879a47e830ab7f41$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $c9f6a1a0ed0e91a6$var$tokens = {
    color: {},
    darkColor: {},
    size: {}
};
var $c9f6a1a0ed0e91a6$var$color = $c9f6a1a0ed0e91a6$var$tokens.color = {
    theme: [
        '#5070dd',
        '#b6d634',
        '#505372',
        '#ff994d',
        '#0ca8df',
        '#ffd10a',
        '#fb628b',
        '#785db0',
        '#3fbe95'
    ],
    neutral00: '#fff',
    neutral05: '#f4f7fd',
    neutral10: '#e8ebf0',
    neutral15: '#dbdee4',
    neutral20: '#cfd2d7',
    neutral25: '#c3c5cb',
    neutral30: '#b7b9be',
    neutral35: '#aaacb2',
    neutral40: '#9ea0a5',
    neutral45: '#929399',
    neutral50: '#86878c',
    neutral55: '#797b7f',
    neutral60: '#6d6e73',
    neutral65: '#616266',
    neutral70: '#54555a',
    neutral75: '#48494d',
    neutral80: '#3c3c41',
    neutral85: '#303034',
    neutral90: '#232328',
    neutral95: '#17171b',
    neutral99: '#000',
    accent05: '#eff1f9',
    accent10: '#e0e4f2',
    accent15: '#d0d6ec',
    accent20: '#c0c9e6',
    accent25: '#b1bbdf',
    accent30: '#a1aed9',
    accent35: '#91a0d3',
    accent40: '#8292cc',
    accent45: '#7285c6',
    accent50: '#6578ba',
    accent55: '#5c6da9',
    accent60: '#536298',
    accent65: '#4a5787',
    accent70: '#404c76',
    accent75: '#374165',
    accent80: '#2e3654',
    accent85: '#252b43',
    accent90: '#1b2032',
    accent95: '#121521',
    transparent: 'rgba(0,0,0,0)',
    highlight: 'rgba(255,231,130,0.8)'
};
(0, $e4c0c902d0f4f283$export$8b58be045bf06082)($c9f6a1a0ed0e91a6$var$color, {
    primary: $c9f6a1a0ed0e91a6$var$color.neutral80,
    secondary: $c9f6a1a0ed0e91a6$var$color.neutral70,
    tertiary: $c9f6a1a0ed0e91a6$var$color.neutral60,
    quaternary: $c9f6a1a0ed0e91a6$var$color.neutral50,
    disabled: $c9f6a1a0ed0e91a6$var$color.neutral20,
    border: $c9f6a1a0ed0e91a6$var$color.neutral30,
    borderTint: $c9f6a1a0ed0e91a6$var$color.neutral20,
    borderShade: $c9f6a1a0ed0e91a6$var$color.neutral40,
    background: $c9f6a1a0ed0e91a6$var$color.neutral05,
    backgroundTint: 'rgba(234,237,245,0.5)',
    backgroundTransparent: 'rgba(255,255,255,0)',
    backgroundShade: $c9f6a1a0ed0e91a6$var$color.neutral10,
    shadow: 'rgba(0,0,0,0.2)',
    shadowTint: 'rgba(129,130,136,0.2)',
    axisLine: $c9f6a1a0ed0e91a6$var$color.neutral70,
    axisLineTint: $c9f6a1a0ed0e91a6$var$color.neutral40,
    axisTick: $c9f6a1a0ed0e91a6$var$color.neutral70,
    axisTickMinor: $c9f6a1a0ed0e91a6$var$color.neutral60,
    axisLabel: $c9f6a1a0ed0e91a6$var$color.neutral70,
    axisSplitLine: $c9f6a1a0ed0e91a6$var$color.neutral15,
    axisMinorSplitLine: $c9f6a1a0ed0e91a6$var$color.neutral05
});
for(var $c9f6a1a0ed0e91a6$var$key in $c9f6a1a0ed0e91a6$var$color)if ($c9f6a1a0ed0e91a6$var$color.hasOwnProperty($c9f6a1a0ed0e91a6$var$key)) {
    var $c9f6a1a0ed0e91a6$var$hex = $c9f6a1a0ed0e91a6$var$color[$c9f6a1a0ed0e91a6$var$key];
    if ($c9f6a1a0ed0e91a6$var$key === 'theme') // Don't modify theme colors.
    $c9f6a1a0ed0e91a6$var$tokens.darkColor.theme = $c9f6a1a0ed0e91a6$var$color.theme.slice();
    else if ($c9f6a1a0ed0e91a6$var$key === 'highlight') $c9f6a1a0ed0e91a6$var$tokens.darkColor.highlight = 'rgba(255,231,130,0.4)';
    else if ($c9f6a1a0ed0e91a6$var$key.indexOf('accent') === 0) // Desaturate and lighten accent colors.
    $c9f6a1a0ed0e91a6$var$tokens.darkColor[$c9f6a1a0ed0e91a6$var$key] = (0, $30eadc8c092f368d$export$d898ae866e27bf18)($c9f6a1a0ed0e91a6$var$hex, null, function(s) {
        return s * 0.5;
    }, function(l) {
        return Math.min(1, 1.3 - l);
    });
    else $c9f6a1a0ed0e91a6$var$tokens.darkColor[$c9f6a1a0ed0e91a6$var$key] = (0, $30eadc8c092f368d$export$d898ae866e27bf18)($c9f6a1a0ed0e91a6$var$hex, null, function(s) {
        return s * 0.9;
    }, function(l) {
        return 1 - Math.pow(l, 1.5);
    });
}
$c9f6a1a0ed0e91a6$var$tokens.size = {
    xxs: 2,
    xs: 5,
    s: 10,
    m: 15,
    l: 20,
    xl: 30,
    xxl: 40,
    xxxl: 50
};
var $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039 = $c9f6a1a0ed0e91a6$var$tokens;


var $428b03089c527ed2$var$platform = '';
// Navigator not exists in node
if (typeof navigator !== 'undefined') $428b03089c527ed2$var$platform = navigator.platform || '';
var $428b03089c527ed2$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $428b03089c527ed2$var$themeColor = (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.theme[0];
var $428b03089c527ed2$var$lightThemeColor = (0, $30eadc8c092f368d$export$d898ae866e27bf18)($428b03089c527ed2$var$themeColor, null, null, 0.9);
var $428b03089c527ed2$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.theme,
    gradientColor: [
        $428b03089c527ed2$var$lightThemeColor,
        $428b03089c527ed2$var$themeColor
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $428b03089c527ed2$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $428b03089c527ed2$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $428b03089c527ed2$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $428b03089c527ed2$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $428b03089c527ed2$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $428b03089c527ed2$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $428b03089c527ed2$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $395b6c5de5b92774$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $395b6c5de5b92774$var$innerGlobalModel = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
function $395b6c5de5b92774$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $395b6c5de5b92774$var$innerGlobalModel(ecModel).datasetMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
}
function $395b6c5de5b92774$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $395b6c5de5b92774$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $395b6c5de5b92774$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $395b6c5de5b92774$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $395b6c5de5b92774$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $0f5447108b4a27a4$export$703ae8a2d83f441) || sourceFormat === (0, $0f5447108b4a27a4$export$6a32b42c754a3cb8)) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $395b6c5de5b92774$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $395b6c5de5b92774$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $395b6c5de5b92774$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $395b6c5de5b92774$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $395b6c5de5b92774$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $395b6c5de5b92774$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $939d3a4c11ee87fd$export$dc741340f7e5f186)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
}
function $395b6c5de5b92774$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $939d3a4c11ee87fd$export$dc741340f7e5f186)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models;
}
function $395b6c5de5b92774$export$c51adf1a2be01b9c(source, dimIndex) {
    return $395b6c5de5b92774$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $395b6c5de5b92774$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(data)) return $395b6c5de5b92774$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $395b6c5de5b92774$export$328749e9c5b40760.Must : $395b6c5de5b92774$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $0f5447108b4a27a4$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $0f5447108b4a27a4$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $0f5447108b4a27a4$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $395b6c5de5b92774$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $0f5447108b4a27a4$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $395b6c5de5b92774$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(sample)) return $395b6c5de5b92774$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $939d3a4c11ee87fd$export$2c944e12edb48d4b)(item);
            if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(val)) return $395b6c5de5b92774$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `Number('')` (or any whitespace) is `0`.
        // `Number(val)` prevents error for BigInt.
        if (val != null && isFinite(Number(val)) && val !== '') return beStr ? $395b6c5de5b92774$export$328749e9c5b40760.Might : $395b6c5de5b92774$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $395b6c5de5b92774$export$328749e9c5b40760.Must;
    }
    return $395b6c5de5b92774$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $670727df122cba0f$var$internalOptionCreatorMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
function $670727df122cba0f$export$5a90be4668898d38(mainType, creator) {
    (0, $e4c0c902d0f4f283$export$a7a9523472993e97)($670727df122cba0f$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $670727df122cba0f$var$internalOptionCreatorMap.set(mainType, creator);
}
function $670727df122cba0f$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $670727df122cba0f$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $866152e684dd44d9$var$innerColor = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $866152e684dd44d9$var$innerDecal = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $866152e684dd44d9$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $866152e684dd44d9$var$getFromPalette(this, $866152e684dd44d9$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $866152e684dd44d9$var$clearPalette(this, $866152e684dd44d9$var$innerColor);
    };
    return PaletteMixin;
}();
function $866152e684dd44d9$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $866152e684dd44d9$var$getFromPalette(ecModel, $866152e684dd44d9$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $866152e684dd44d9$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $866152e684dd44d9$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $866152e684dd44d9$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $866152e684dd44d9$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e5cdafd3d57b0dbf$var$ECHARTS_PREFIX = '[ECharts] ';
var $e5cdafd3d57b0dbf$var$storedLogs = {};
var $e5cdafd3d57b0dbf$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
function $e5cdafd3d57b0dbf$var$outputLog(type, str, onlyOnce) {
    if ($e5cdafd3d57b0dbf$var$hasConsole) {
        if (onlyOnce) {
            if ($e5cdafd3d57b0dbf$var$storedLogs[str]) return;
            $e5cdafd3d57b0dbf$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($e5cdafd3d57b0dbf$var$ECHARTS_PREFIX + str);
    }
}
function $e5cdafd3d57b0dbf$export$bef1f36f5486a6a3(str, onlyOnce) {
    $e5cdafd3d57b0dbf$var$outputLog('log', str, onlyOnce);
}
function $e5cdafd3d57b0dbf$export$c106dd0671a0fc2d(str, onlyOnce) {
    $e5cdafd3d57b0dbf$var$outputLog('warn', str, onlyOnce);
}
function $e5cdafd3d57b0dbf$export$a3bc9b8ed74fc(str, onlyOnce) {
    $e5cdafd3d57b0dbf$var$outputLog('error', str, onlyOnce);
}
function $e5cdafd3d57b0dbf$export$4a9c0b74eb885aa1(str) {}
function $e5cdafd3d57b0dbf$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $e5cdafd3d57b0dbf$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $74c729a11d908314$var$reCreateSeriesIndices;
var $74c729a11d908314$var$assertSeriesInitialized;
var $74c729a11d908314$var$initBase;
var $74c729a11d908314$var$OPTION_INNER_KEY = '\0_ec_inner';
var $74c729a11d908314$var$OPTION_INNER_VALUE = 1;
var $74c729a11d908314$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    matrix: 'MatrixComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $74c729a11d908314$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    chord: 'ChordChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $74c729a11d908314$var$componetsMissingLogPrinted = {};
function $74c729a11d908314$var$checkMissingComponents(option) {
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $879a47e830ab7f41$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $74c729a11d908314$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$74c729a11d908314$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $e5cdafd3d57b0dbf$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $74c729a11d908314$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $74c729a11d908314$var$GlobalModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $74c729a11d908314$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $74c729a11d908314$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $74c729a11d908314$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $395b6c5de5b92774$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $879a47e830ab7f41$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(componentOption) : (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $879a47e830ab7f41$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $879a47e830ab7f41$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $879a47e830ab7f41$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $670727df122cba0f$export$c713a6a3b43f401d)(this, mainType, $939d3a4c11ee87fd$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $939d3a4c11ee87fd$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $939d3a4c11ee87fd$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $879a47e830ab7f41$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $879a47e830ab7f41$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === 'tooltip') {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === 'series') $74c729a11d908314$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $74c729a11d908314$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(this.option);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $879a47e830ab7f41$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $939d3a4c11ee87fd$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$939d3a4c11ee87fd$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$74c729a11d908314$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.setTheme = function(theme) {
        this._theme = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(theme);
        this._resetOption('recreate', null);
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($939d3a4c11ee87fd$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $74c729a11d908314$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $74c729a11d908314$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $74c729a11d908314$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, component1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($74c729a11d908314$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(name, null);
        return (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $74c729a11d908314$var$assertSeriesInitialized(this);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $74c729a11d908314$var$assertSeriesInitialized(this);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    /**
   * It means "filtered out".
   */ GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $74c729a11d908314$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $74c729a11d908314$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $74c729a11d908314$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $879a47e830ab7f41$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $879a47e830ab7f41$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $879a47e830ab7f41$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$74c729a11d908314$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $74c729a11d908314$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $74c729a11d908314$var$assertSeriesInitialized = function(ecModel) {};
        $74c729a11d908314$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$74c729a11d908314$var$OPTION_INNER_KEY] = $74c729a11d908314$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $74c729a11d908314$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)(baseOption, (0, $428b03089c527ed2$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $7232b75992df3b9d$export$2e2bcd8739ae039));
function $74c729a11d908314$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $74c729a11d908314$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer || name === 'color' && option.color) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $879a47e830ab7f41$export$2e2bcd8739ae039).hasClass(name)) {
            if (typeof themeItem === 'object') option[name] = !option[name] ? (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(themeItem) : (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $74c729a11d908314$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $74c729a11d908314$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $74c729a11d908314$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    opts && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($939d3a4c11ee87fd$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $e4c0c902d0f4f283$export$e36fc9d62a853069)($74c729a11d908314$var$GlobalModel, (0, $866152e684dd44d9$export$55a3c39e852b90f4));
var $74c729a11d908314$export$2e2bcd8739ae039 = $74c729a11d908314$var$GlobalModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ed9a7f817daff166$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $ed9a7f817daff166$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)((0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(series.data) && (0, $e4c0c902d0f4f283$export$112e66431016387b)(series.data);
            });
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)((0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(dataset.source) && (0, $e4c0c902d0f4f283$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $ed9a7f817daff166$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($ed9a7f817daff166$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$ed9a7f817daff166$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $ed9a7f817daff166$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(mediaOnRoot)) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $ed9a7f817daff166$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($ed9a7f817daff166$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$ed9a7f817daff166$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $ed9a7f817daff166$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $ed9a7f817daff166$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$ed9a7f817daff166$export$2e2bcd8739ae039 = $ed9a7f817daff166$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $666e5897ac6e875c$var$each = $e4c0c902d0f4f283$export$79b2f7037acddd43;
var $666e5897ac6e875c$var$isObject = $e4c0c902d0f4f283$export$a6cdc56e425d0d0a;
var $666e5897ac6e875c$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $666e5897ac6e875c$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $666e5897ac6e875c$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $666e5897ac6e875c$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $e4c0c902d0f4f283$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $e4c0c902d0f4f283$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $666e5897ac6e875c$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $e4c0c902d0f4f283$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $666e5897ac6e875c$var$removeEC3NormalStatus(opt) {
    $666e5897ac6e875c$var$convertNormalEmphasis(opt, 'itemStyle');
    $666e5897ac6e875c$var$convertNormalEmphasis(opt, 'lineStyle');
    $666e5897ac6e875c$var$convertNormalEmphasis(opt, 'areaStyle');
    $666e5897ac6e875c$var$convertNormalEmphasis(opt, 'label');
    $666e5897ac6e875c$var$convertNormalEmphasis(opt, 'labelLine');
    // treemap
    $666e5897ac6e875c$var$convertNormalEmphasis(opt, 'upperLabel');
    // graph
    $666e5897ac6e875c$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $666e5897ac6e875c$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $666e5897ac6e875c$var$isObject(opt) && opt[propName];
    var textStyle = $666e5897ac6e875c$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $939d3a4c11ee87fd$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $939d3a4c11ee87fd$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $666e5897ac6e875c$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $666e5897ac6e875c$var$removeEC3NormalStatus(opt);
        $666e5897ac6e875c$var$compatTextStyle(opt, 'label');
        opt.emphasis && $666e5897ac6e875c$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $666e5897ac6e875c$var$processSeries(seriesOpt) {
    if (!$666e5897ac6e875c$var$isObject(seriesOpt)) return;
    $666e5897ac6e875c$var$compatEC2ItemStyle(seriesOpt);
    $666e5897ac6e875c$var$removeEC3NormalStatus(seriesOpt);
    $666e5897ac6e875c$var$compatTextStyle(seriesOpt, 'label');
    // treemap
    $666e5897ac6e875c$var$compatTextStyle(seriesOpt, 'upperLabel');
    // graph
    $666e5897ac6e875c$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $666e5897ac6e875c$var$compatTextStyle(seriesOpt.emphasis, 'label');
        // treemap
        $666e5897ac6e875c$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
        // graph
        $666e5897ac6e875c$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $666e5897ac6e875c$var$compatEC2ItemStyle(markPoint);
        $666e5897ac6e875c$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $666e5897ac6e875c$var$compatEC2ItemStyle(markLine);
        $666e5897ac6e875c$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $666e5897ac6e875c$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$e4c0c902d0f4f283$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$666e5897ac6e875c$var$compatEC3CommonStyles(edgeData[i]);
        $e4c0c902d0f4f283$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $666e5897ac6e875c$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$e4c0c902d0f4f283$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$666e5897ac6e875c$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$666e5897ac6e875c$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($e4c0c902d0f4f283$export$43bee75e5e14138e(mlData[i])) {
            $666e5897ac6e875c$var$compatEC3CommonStyles(mlData[i][0]);
            $666e5897ac6e875c$var$compatEC3CommonStyles(mlData[i][1]);
        } else $666e5897ac6e875c$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === 'gauge') {
        $666e5897ac6e875c$var$compatTextStyle(seriesOpt, 'axisLabel');
        $666e5897ac6e875c$var$compatTextStyle(seriesOpt, 'title');
        $666e5897ac6e875c$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $666e5897ac6e875c$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $e4c0c902d0f4f283$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $666e5897ac6e875c$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $666e5897ac6e875c$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $666e5897ac6e875c$var$toArr(o) {
    return $e4c0c902d0f4f283$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $666e5897ac6e875c$var$toObj(o) {
    return ($e4c0c902d0f4f283$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $666e5897ac6e875c$export$2e2bcd8739ae039(option, isTheme) {
    $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(option.series), function(seriesOpt) {
        $666e5897ac6e875c$var$isObject(seriesOpt) && $666e5897ac6e875c$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $666e5897ac6e875c$var$each(axes, function(axisName) {
        $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $666e5897ac6e875c$var$compatTextStyle(axisOpt, 'axisLabel');
                $666e5897ac6e875c$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $666e5897ac6e875c$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $666e5897ac6e875c$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(option.calendar), function(calendarOpt) {
        $666e5897ac6e875c$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $666e5897ac6e875c$var$compatTextStyle(calendarOpt, 'dayLabel');
        $666e5897ac6e875c$var$compatTextStyle(calendarOpt, 'monthLabel');
        $666e5897ac6e875c$var$compatTextStyle(calendarOpt, 'yearLabel');
    });
    // radar.name.textStyle
    $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(option.radar), function(radarOpt) {
        $666e5897ac6e875c$var$compatTextStyle(radarOpt, 'name');
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(option.geo), function(geoOpt) {
        if ($666e5897ac6e875c$var$isObject(geoOpt)) {
            $666e5897ac6e875c$var$compatEC3CommonStyles(geoOpt);
            $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(geoOpt.regions), function(regionObj) {
                $666e5897ac6e875c$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(option.timeline), function(timelineOpt) {
        $666e5897ac6e875c$var$compatEC3CommonStyles(timelineOpt);
        $666e5897ac6e875c$var$convertNormalEmphasis(timelineOpt, 'label');
        $666e5897ac6e875c$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $666e5897ac6e875c$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $e4c0c902d0f4f283$export$43bee75e5e14138e(data) && $e4c0c902d0f4f283$export$79b2f7037acddd43(data, function(item) {
            if ($e4c0c902d0f4f283$export$a6cdc56e425d0d0a(item)) {
                $666e5897ac6e875c$var$convertNormalEmphasis(item, 'label');
                $666e5897ac6e875c$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $666e5897ac6e875c$var$each($666e5897ac6e875c$var$toArr(option.toolbox), function(toolboxOpt) {
        $666e5897ac6e875c$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $666e5897ac6e875c$var$each(toolboxOpt.feature, function(featureOpt) {
            $666e5897ac6e875c$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $666e5897ac6e875c$var$compatTextStyle($666e5897ac6e875c$var$toObj(option.axisPointer), 'label');
    $666e5897ac6e875c$var$compatTextStyle($666e5897ac6e875c$var$toObj(option.tooltip).axisPointer, 'label');
// Clean logs
// storedLogs = {};
}




function $e1495634306e9aeb$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $e1495634306e9aeb$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $e1495634306e9aeb$var$compatLayoutProperties(option) {
    option && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($e1495634306e9aeb$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $e1495634306e9aeb$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $e1495634306e9aeb$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $e1495634306e9aeb$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $e1495634306e9aeb$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $e1495634306e9aeb$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $e1495634306e9aeb$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $e1495634306e9aeb$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $e1495634306e9aeb$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $e1495634306e9aeb$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $e1495634306e9aeb$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $e1495634306e9aeb$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $e1495634306e9aeb$var$traverseTree(data[i].children, cb);
    }
}
function $e1495634306e9aeb$export$2e2bcd8739ae039(option, isTheme) {
    (0, $666e5897ac6e875c$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(option.series);
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $e1495634306e9aeb$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$e1495634306e9aeb$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $e1495634306e9aeb$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $e1495634306e9aeb$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $e1495634306e9aeb$var$compatBarItemStyle(seriesOpt);
            $e1495634306e9aeb$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $e1495634306e9aeb$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                    $e1495634306e9aeb$var$compatBarItemStyle(data[i]);
                    $e1495634306e9aeb$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $e1495634306e9aeb$var$compatSunburstState(seriesOpt);
            $e1495634306e9aeb$var$traverseTree(seriesOpt.data, $e1495634306e9aeb$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $e1495634306e9aeb$var$compatGraphFocus(seriesOpt);
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $e1495634306e9aeb$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($e1495634306e9aeb$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(options, function(option) {
                $e1495634306e9aeb$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $2d3c837239acfcdb$export$dc018729d9e78c17 = (0, $939d3a4c11ee87fd$export$d62c61cad9d1ab83)($2d3c837239acfcdb$var$dataStack);
// (1) [Caution]: the logic is correct based on the premises:
//     data processing stage is blocked in stream.
//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
// (2) Only register once when import repeatedly.
//     Should be executed after series is filtered and before stack calculation.
function $2d3c837239acfcdb$var$dataStack(ecModel) {
    var stackInfoMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack');
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.push(stackInfo);
        }
    });
    // Process each stack group
    stackInfoMap.each(function(stackInfoList) {
        if (stackInfoList.length === 0) return;
        // Check if stack order needs to be reversed
        var firstSeries = stackInfoList[0].seriesModel;
        var stackOrder = firstSeries.get('stackOrder') || 'seriesAsc';
        if (stackOrder === 'seriesDesc') stackInfoList.reverse();
        // Set stackedOnSeries for each series in the final order
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(stackInfoList, function(stackInfo, index) {
            stackInfo.data.setCalculationInfo('stackedOnSeries', index > 0 ? stackInfoList[index - 1].seriesModel : null);
        });
        // Calculate stack values
        $2d3c837239acfcdb$var$calculateStack(stackInfoList);
    });
}
function $2d3c837239acfcdb$var$calculateStack(stackInfoList) {
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get('stackStrategy') || 'samesign';
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === 'all' // single stack group
                     || stackStrategy === 'positive' && val > 0 || stackStrategy === 'negative' && val < 0 || stackStrategy === 'samesign' && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === 'samesign' && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $0b2f7076fd7740ca$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $bbaae55b69ad01c5$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $0f5447108b4a27a4$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $0f5447108b4a27a4$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $395b6c5de5b92774$export$c51adf1a2be01b9c)(this, i) === (0, $395b6c5de5b92774$export$328749e9c5b40760).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $bbaae55b69ad01c5$export$22b808bc02a60488(val) {
    return val instanceof $bbaae55b69ad01c5$var$SourceImpl;
}
function $bbaae55b69ad01c5$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $bbaae55b69ad01c5$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $bbaae55b69ad01c5$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $bbaae55b69ad01c5$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $bbaae55b69ad01c5$export$75aef3f97c0a5edf(data) {
    return new $bbaae55b69ad01c5$var$SourceImpl({
        data: data,
        sourceFormat: (0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(data) ? (0, $0f5447108b4a27a4$export$a918cb016a382d45) : (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6)
    });
}
function $bbaae55b69ad01c5$export$e0365e7e3555ddd4(source) {
    return new $bbaae55b69ad01c5$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $bbaae55b69ad01c5$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $0f5447108b4a27a4$export$c78f1330778d30d);
    if ((0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $0f5447108b4a27a4$export$a918cb016a382d45);
    else if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $0f5447108b4a27a4$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(item) || (0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $0f5447108b4a27a4$export$fcd62ebf51387903);
                break;
            } else if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $0f5447108b4a27a4$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(data, key) && (0, $e4c0c902d0f4f283$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $0f5447108b4a27a4$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $bbaae55b69ad01c5$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $bbaae55b69ad01c5$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $0f5447108b4a27a4$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $bbaae55b69ad01c5$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $bbaae55b69ad01c5$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $0f5447108b4a27a4$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $0f5447108b4a27a4$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $bbaae55b69ad01c5$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $0f5447108b4a27a4$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6)) {
        var value0 = (0, $939d3a4c11ee87fd$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $bbaae55b69ad01c5$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $bbaae55b69ad01c5$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $bbaae55b69ad01c5$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += '';
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $bbaae55b69ad01c5$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $0f5447108b4a27a4$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $bbaae55b69ad01c5$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $0f5447108b4a27a4$export$703ae8a2d83f441) || sourceFormat === (0, $0f5447108b4a27a4$export$6a32b42c754a3cb8);
}




var $35510f45b1caf446$var$_a, $35510f45b1caf446$var$_b, $35510f45b1caf446$var$_c, $35510f45b1caf446$var$_d;
var $35510f45b1caf446$var$providerMethods;
var $35510f45b1caf446$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $35510f45b1caf446$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $bbaae55b69ad01c5$export$22b808bc02a60488)(sourceParam) ? (0, $bbaae55b69ad01c5$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        var sourceFormat = source.sourceFormat;
        var seriesLayoutBy = source.seriesLayoutBy;
        // Typed array. TODO IE10+?
        if (sourceFormat === (0, $0f5447108b4a27a4$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        var validator;
        $35510f45b1caf446$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $35510f45b1caf446$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $35510f45b1caf446$var$providerMethods[$35510f45b1caf446$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $0f5447108b4a27a4$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $35510f45b1caf446$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $35510f45b1caf446$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $35510f45b1caf446$var$providerMethods = (_a = {}, _a[(0, $0f5447108b4a27a4$export$fcd62ebf51387903) + '_' + (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $0f5447108b4a27a4$export$fcd62ebf51387903) + '_' + (0, $0f5447108b4a27a4$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $0f5447108b4a27a4$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $0f5447108b4a27a4$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $0f5447108b4a27a4$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $0f5447108b4a27a4$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $35510f45b1caf446$var$validateSimply = function(rawData) {
    if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(rawData)) (0, $e5cdafd3d57b0dbf$export$a3bc9b8ed74fc)('series.data or dataset.source must be an array.');
};
/**
 * Only run in dev mode - hint users for debug.
 */ var $35510f45b1caf446$var$rawSourceDataValidatorMap = ($35510f45b1caf446$var$_a = {}, $35510f45b1caf446$var$_a[(0, $0f5447108b4a27a4$export$fcd62ebf51387903) + '_' + (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b)] = $35510f45b1caf446$var$validateSimply, $35510f45b1caf446$var$_a[(0, $0f5447108b4a27a4$export$fcd62ebf51387903) + '_' + (0, $0f5447108b4a27a4$export$d55da1467cdf7804)] = $35510f45b1caf446$var$validateSimply, $35510f45b1caf446$var$_a[0, $0f5447108b4a27a4$export$703ae8a2d83f441] = $35510f45b1caf446$var$validateSimply, $35510f45b1caf446$var$_a[0, $0f5447108b4a27a4$export$6a32b42c754a3cb8] = function(rawData, dimsDef) {
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        if (dimName == null) (0, $e5cdafd3d57b0dbf$export$a3bc9b8ed74fc)('dimension name must not be null/undefined.');
    }
}, $35510f45b1caf446$var$_a[0, $0f5447108b4a27a4$export$2823037fb9d8f0c6] = $35510f45b1caf446$var$validateSimply, $35510f45b1caf446$var$_a);
var $35510f45b1caf446$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $35510f45b1caf446$var$rawSourceItemGetterMap = ($35510f45b1caf446$var$_b = {}, $35510f45b1caf446$var$_b[(0, $0f5447108b4a27a4$export$fcd62ebf51387903) + '_' + (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $35510f45b1caf446$var$_b[(0, $0f5447108b4a27a4$export$fcd62ebf51387903) + '_' + (0, $0f5447108b4a27a4$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $35510f45b1caf446$var$_b[0, $0f5447108b4a27a4$export$703ae8a2d83f441] = $35510f45b1caf446$var$getItemSimply, $35510f45b1caf446$var$_b[0, $0f5447108b4a27a4$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = dimName != null ? rawData[dimName] : null;
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $35510f45b1caf446$var$_b[0, $0f5447108b4a27a4$export$2823037fb9d8f0c6] = $35510f45b1caf446$var$getItemSimply, $35510f45b1caf446$var$_b);
function $35510f45b1caf446$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $35510f45b1caf446$var$rawSourceItemGetterMap[$35510f45b1caf446$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $35510f45b1caf446$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $35510f45b1caf446$var$rawSourceDataCounterMap = ($35510f45b1caf446$var$_c = {}, $35510f45b1caf446$var$_c[(0, $0f5447108b4a27a4$export$fcd62ebf51387903) + '_' + (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $35510f45b1caf446$var$_c[(0, $0f5447108b4a27a4$export$fcd62ebf51387903) + '_' + (0, $0f5447108b4a27a4$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $35510f45b1caf446$var$_c[0, $0f5447108b4a27a4$export$703ae8a2d83f441] = $35510f45b1caf446$var$countSimply, $35510f45b1caf446$var$_c[0, $0f5447108b4a27a4$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = dimName != null ? rawData[dimName] : null;
    return col ? col.length : 0;
}, $35510f45b1caf446$var$_c[0, $0f5447108b4a27a4$export$2823037fb9d8f0c6] = $35510f45b1caf446$var$countSimply, $35510f45b1caf446$var$_c);
function $35510f45b1caf446$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $35510f45b1caf446$var$rawSourceDataCounterMap[$35510f45b1caf446$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $35510f45b1caf446$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $35510f45b1caf446$var$rawSourceValueGetterMap = ($35510f45b1caf446$var$_d = {}, $35510f45b1caf446$var$_d[0, $0f5447108b4a27a4$export$fcd62ebf51387903] = $35510f45b1caf446$var$getRawValueSimply, $35510f45b1caf446$var$_d[0, $0f5447108b4a27a4$export$703ae8a2d83f441] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $35510f45b1caf446$var$_d[0, $0f5447108b4a27a4$export$6a32b42c754a3cb8] = $35510f45b1caf446$var$getRawValueSimply, $35510f45b1caf446$var$_d[0, $0f5447108b4a27a4$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $939d3a4c11ee87fd$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $35510f45b1caf446$var$_d[0, $0f5447108b4a27a4$export$a918cb016a382d45] = $35510f45b1caf446$var$getRawValueSimply, $35510f45b1caf446$var$_d);
function $35510f45b1caf446$export$1752de8084789a14(sourceFormat) {
    var method = $35510f45b1caf446$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $35510f45b1caf446$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $0f5447108b4a27a4$export$fcd62ebf51387903) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
}
function $35510f45b1caf446$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $35510f45b1caf446$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6)) result = (0, $939d3a4c11ee87fd$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $35510f45b1caf446$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6) && sourceFormat !== (0, $0f5447108b4a27a4$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6) && !(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $0acf4888a62e52cf$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $0acf4888a62e52cf$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $e4c0c902d0f4f283$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($e4c0c902d0f4f283$export$844ec244b1367d54(formatter)) {
            var str = (0, $c09e8b26bdb81866$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($0acf4888a62e52cf$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $35510f45b1caf446$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $e4c0c902d0f4f283$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $35510f45b1caf446$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $0acf4888a62e52cf$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($e4c0c902d0f4f283$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $1d561c9acefaeb0e$export$f7292ab7796be73c(define) {
    return new $1d561c9acefaeb0e$export$2dea7024bcdd7731(define);
}
var $1d561c9acefaeb0e$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    /**
   * @tutorial [EC_TASK_DIRTY]
   *  Task `dirty()` calls typically originate from a trigger of EC_FULL_UPDATE_CYCLE and
   *  EC_PARTIAL_UPDATE_CYCLE) (See comments in EC_CYCLE. Generally, task dirty propagates
   *  to downstream tasks.
   *  Task dirty leads to the `StageHandler['reset']` or `StageHandler['overallReset']` call,
   *  which discards the previous result and starts over the processing.
   */ Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $1d561c9acefaeb0e$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $1d561c9acefaeb0e$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $1d561c9acefaeb0e$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $84c3b22514de3d05$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' && !(0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(value) && value != null && value !== '-') value = +(0, $0b2f7076fd7740ca$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN : Number(value);
}
var $84c3b22514de3d05$var$valueParserMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $0b2f7076fd7740ca$export$6b862160d295c8e)(val);
    },
    'trim': function(val) {
        return (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(val) ? (0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $84c3b22514de3d05$export$c88237b7c265b36b(type) {
    return $84c3b22514de3d05$var$valueParserMap.get(type);
}
var $84c3b22514de3d05$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $84c3b22514de3d05$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(rval)) {
            var errMsg = '';
            (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $84c3b22514de3d05$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $0b2f7076fd7740ca$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $0b2f7076fd7740ca$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $84c3b22514de3d05$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(lval) ? lval : (0, $0b2f7076fd7740ca$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(rval) ? rval : (0, $0b2f7076fd7740ca$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $84c3b22514de3d05$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $0b2f7076fd7740ca$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $0b2f7076fd7740ca$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $84c3b22514de3d05$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $84c3b22514de3d05$var$FilterEqualityComparator(op === 'eq', rval) : (0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)($84c3b22514de3d05$var$ORDER_COMPARISON_OP_MAP, op) ? new $84c3b22514de3d05$var$FilterOrderComparator(op, rval) : null;
}
function $84c3b22514de3d05$export$1b2aa782dfdf5700(filter) {
    var filterKey = '';
    var filterG = -Infinity;
    var filterGE = -Infinity;
    var filterL = Infinity;
    var filterLE = Infinity;
    if (filter) {
        if (filter.g != null) {
            filterKey += 'G' + filter.g;
            filterG = filter.g;
        }
        if (filter.ge != null) {
            filterKey += 'GE' + filter.ge;
            filterGE = filter.ge;
        }
        if (filter.l != null) {
            filterKey += 'L' + filter.l;
            filterL = filter.l;
        }
        if (filter.le != null) {
            filterKey += 'LE' + filter.le;
            filterLE = filter.le;
        }
    }
    return {
        key: filterKey,
        g: filterG,
        ge: filterGE,
        l: filterL,
        le: filterLE
    };
}
function $84c3b22514de3d05$export$49bf74cb3f1b6c80(filterParsed, value) {
    return value > filterParsed.g && value >= filterParsed.ge && value < filterParsed.l && value <= filterParsed.le;
} // --------- END: Data store sanitization filters ---------




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $130e4ec8184881d3$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $84c3b22514de3d05$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $130e4ec8184881d3$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $130e4ec8184881d3$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b)) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $35510f45b1caf446$export$92c8ea8642b3957d)(sourceFormat, (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)($130e4ec8184881d3$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)($130e4ec8184881d3$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $35510f45b1caf446$export$803742e832f4b52c)(sourceFormat, (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b));
    extSource.count = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $35510f45b1caf446$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)($130e4ec8184881d3$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)($130e4ec8184881d3$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $130e4ec8184881d3$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$130e4ec8184881d3$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $130e4ec8184881d3$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$130e4ec8184881d3$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $0f5447108b4a27a4$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $0f5447108b4a27a4$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $130e4ec8184881d3$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $130e4ec8184881d3$var$cloneAllDimensionInfo(dimensions) {
    return (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(dimensions);
}
var $130e4ec8184881d3$var$externalTransformMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
function $130e4ec8184881d3$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $130e4ec8184881d3$var$externalTransformMap.set(type, externalTransform);
}
function $130e4ec8184881d3$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $130e4ec8184881d3$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $130e4ec8184881d3$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(transOption)) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $130e4ec8184881d3$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $130e4ec8184881d3$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(result)) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $bbaae55b69ad01c5$export$52a469afa4653e57)(result.data);
        if (!$130e4ec8184881d3$var$isSupportedSourceFormat(sourceFormat)) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $0f5447108b4a27a4$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $bbaae55b69ad01c5$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $130e4ec8184881d3$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $0f5447108b4a27a4$export$fcd62ebf51387903) || sourceFormat === (0, $0f5447108b4a27a4$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $91c1d6712d761710$export$859a1fa4f1106aa0 = typeof Uint32Array === (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Array : Uint32Array;
var $91c1d6712d761710$export$78cf73566f32c185 = typeof Uint16Array === (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Array : Uint16Array;
var $91c1d6712d761710$export$b60d945128546f53 = typeof Int32Array === (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Array : Int32Array;
var $91c1d6712d761710$export$365b104db51a490a = typeof Float64Array === (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $91c1d6712d761710$var$dataCtors = {
    'float': $91c1d6712d761710$export$365b104db51a490a,
    'int': $91c1d6712d761710$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $91c1d6712d761710$export$365b104db51a490a
};
var $91c1d6712d761710$var$defaultDimValueGetters;
function $91c1d6712d761710$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $91c1d6712d761710$export$859a1fa4f1106aa0 : $91c1d6712d761710$export$78cf73566f32c185;
}
function $91c1d6712d761710$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $91c1d6712d761710$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $91c1d6712d761710$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $91c1d6712d761710$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        // structure:
        //  `const extentOnFilterOnDimension = this._extent[dim][extentFilterKey]`
        this._extent = [];
        // Count after filtered.
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $91c1d6712d761710$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $bbaae55b69ad01c5$export$8911336b527f8517)(source);
        this._dimensions = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $91c1d6712d761710$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            // See also CATEGORY_AXIS_MODEL_DATA_IS_EMPTY_ARRAY.
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $91c1d6712d761710$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $91c1d6712d761710$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)();
            $91c1d6712d761710$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        (0, $0b2f7076fd7740ca$export$debe6e778e0a6d32)(dimDataArray);
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? dimDataArray[(len - 1) / 2] : (dimDataArray[len / 2] + dimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $91c1d6712d761710$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * [NOTICE]: Performance-sensitive for large data.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $91c1d6712d761710$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $91c1d6712d761710$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in ordinal dimension)?
                if (typeof retValue !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($91c1d6712d761710$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ DataStore.prototype.minmaxDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        // Each frame results in 2 data points, one for min and one for max
        var newIndices = new ($91c1d6712d761710$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) * 2);
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            var minIndex = i;
            var minValue = dimStore[this.getRawIndex(minIndex)];
            var maxIndex = i;
            var maxValue = dimStore[this.getRawIndex(maxIndex)];
            var thisFrameSize = frameSize;
            // Handle final smaller frame
            if (i + frameSize > len) thisFrameSize = len - i;
            // Determine min and max within the current frame
            for(var k = 0; k < thisFrameSize; k++){
                var rawIndex = this.getRawIndex(i + k);
                var value = dimStore[rawIndex];
                if (value < minValue) {
                    minValue = value;
                    minIndex = i + k;
                }
                if (value > maxValue) {
                    maxValue = value;
                    maxIndex = i + k;
                }
            }
            var rawMinIndex = this.getRawIndex(minIndex);
            var rawMaxIndex = this.getRawIndex(maxIndex);
            // Set the order of the min and max values, based on their ordering in the frame
            if (minIndex < maxIndex) {
                newIndices[offset++] = rawMinIndex;
                newIndices[offset++] = rawMaxIndex;
            } else {
                newIndices[offset++] = rawMaxIndex;
                newIndices[offset++] = rawMinIndex;
            }
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)();
        var newIndices = new ($91c1d6712d761710$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each(0, function (x, idx) {});
   *  list.each([0, 1], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    DataStore.prototype.getDataExtent = function(dim, filter) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices && !filter;
        if (useRaw) return this._rawExtent[dim].slice();
        // NOTE:
        //  - In logarithm axis, zero should be excluded, therefore the `extent[0]` should be less or equal
        //    than the min positive data item, which requires the special handling here.
        //  - "Filter non-positive values for logarithm axis" can also be implemented in a data processor
        //    but that requires more complicated code to not break all streams under the current architecture,
        //    therefore we simply implement it here.
        //  - Performance is sensitive for large data, therefore inline filters rather than cb is used here.
        var thisExtent = this._extent;
        var dimExtentRecord = thisExtent[dim] || (thisExtent[dim] = {});
        var filterParsed = (0, $84c3b22514de3d05$export$1b2aa782dfdf5700)(filter);
        var filterKey = filterParsed.key;
        var dimExtent = dimExtentRecord[filterKey];
        if (dimExtent) return dimExtent.slice();
        var min = initialExtent[0];
        var max = initialExtent[1];
        for(var i = 0; i < currEnd; i++){
            // NOTICE: Manually inline some code for performance of large data.
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            // NOTE: in most cases, filter does not exist.
            if (!filter || (0, $84c3b22514de3d05$export$49bf74cb3f1b6c80)(filterParsed, value)) {
                if (value < min) min = value;
                if (value > max) max = value;
            }
        }
        return dimExtentRecord[filterKey] = [
            min,
            max
        ];
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $e4c0c902d0f4f283$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $91c1d6712d761710$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $84c3b22514de3d05$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $91c1d6712d761710$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $84c3b22514de3d05$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $84c3b22514de3d05$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $91c1d6712d761710$export$2e2bcd8739ae039 = $91c1d6712d761710$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $cf16695c85c855fd$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($cf16695c85c855fd$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $e4c0c902d0f4f283$export$b119cc7e1840e59c)(data) ? (0, $0f5447108b4a27a4$export$a918cb016a382d45) : (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $bbaae55b69ad01c5$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $bbaae55b69ad01c5$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $cf16695c85c855fd$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $cf16695c85c855fd$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $130e4ec8184881d3$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $bbaae55b69ad01c5$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($cf16695c85c855fd$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $91c1d6712d761710$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $35510f45b1caf446$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($cf16695c85c855fd$var$isSeries(sourceHost)) {
            var datasetModel = (0, $395b6c5de5b92774$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)((0, $395b6c5de5b92774$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($cf16695c85c855fd$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $cf16695c85c855fd$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $e4c0c902d0f4f283$export$112e66431016387b)(datasetModel.option.transform);
}
function $cf16695c85c855fd$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $cf16695c85c855fd$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $b8b42d608e86874b$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
function $b8b42d608e86874b$var$getTooltipLineHeight(textStyle) {
    var lineHeight = textStyle.lineHeight;
    if (lineHeight == null) return $b8b42d608e86874b$var$TOOLTIP_LINE_HEIGHT_CSS;
    else return "line-height:" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(lineHeight + '') + "px";
}
// TODO: more textStyle option
function $b8b42d608e86874b$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.tertiary;
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.secondary;
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(nameFontSize + '') + "px;color:" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(valueFontSize + '') + "px;color:" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $b8b42d608e86874b$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $b8b42d608e86874b$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
];
function $b8b42d608e86874b$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $b8b42d608e86874b$var$isSectionFragment(frag) {
    return frag.type === 'section';
}
function $b8b42d608e86874b$var$getBuilder(frag) {
    return $b8b42d608e86874b$var$isSectionFragment(frag) ? $b8b42d608e86874b$var$buildSection : $b8b42d608e86874b$var$buildNameValue;
}
function $b8b42d608e86874b$var$getBlockGapLevel(frag) {
    if ($b8b42d608e86874b$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $b8b42d608e86874b$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $b8b42d608e86874b$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $b8b42d608e86874b$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $b8b42d608e86874b$var$getGap($b8b42d608e86874b$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(!subBlocks || (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $84c3b22514de3d05$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $b8b42d608e86874b$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $e4c0c902d0f4f283$export$8b58be045bf06082)((0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $b8b42d608e86874b$var$wrapBlockHTML(toolTipTextStyle, subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $c09e8b26bdb81866$export$3cd8db88714decfc)(fragment.header, 'ordinal', ctx.useUTC);
    var nameStyle = $b8b42d608e86874b$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    var tooltipLineHeight = $b8b42d608e86874b$var$getTooltipLineHeight(toolTipTextStyle);
    if (ctx.renderMode === 'richText') return $b8b42d608e86874b$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $b8b42d608e86874b$var$wrapBlockHTML(toolTipTextStyle, "<div style=\"" + nameStyle + ";" + tooltipLineHeight + ";\">" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
}
function $b8b42d608e86874b$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $c09e8b26bdb81866$export$3cd8db88714decfc)(val, (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.secondary, renderMode);
    var readableName = noName ? '' : (0, $c09e8b26bdb81866$export$3cd8db88714decfc)(name, 'ordinal', useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.rawDataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $b8b42d608e86874b$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $b8b42d608e86874b$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $b8b42d608e86874b$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $b8b42d608e86874b$var$wrapBlockHTML(toolTipTextStyle, (noMarker ? '' : markerStr) + (noName ? '' : $b8b42d608e86874b$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $b8b42d608e86874b$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $b8b42d608e86874b$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $b8b42d608e86874b$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $b8b42d608e86874b$var$getGap(gapLevel) {
    return {
        html: $b8b42d608e86874b$var$HTML_GAPS[gapLevel],
        richText: $b8b42d608e86874b$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $b8b42d608e86874b$var$wrapBlockHTML(textStyle, encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    var tooltipLineHeight = $b8b42d608e86874b$var$getTooltipLineHeight(textStyle);
    return "<div style=\"" + marginCSS + ";" + tooltipLineHeight + ";\">" + encodedContent + clearfix + '</div>';
}
function $b8b42d608e86874b$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(name) + '</span>';
}
function $b8b42d608e86874b$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    valueList = (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $b8b42d608e86874b$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $b8b42d608e86874b$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(values) ? values.join('  ') : values, styles);
}
function $b8b42d608e86874b$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $c09e8b26bdb81866$export$cda04d03233e5555)(color);
}
function $b8b42d608e86874b$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $b8b42d608e86874b$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $0b2f7076fd7740ca$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $c09e8b26bdb81866$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(styles)) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $b4dd8326243601f0$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(value);
    var markerColor = (0, $b8b42d608e86874b$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $b4dd8326243601f0$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $35510f45b1caf446$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $939d3a4c11ee87fd$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $b8b42d608e86874b$export$cf63b23ce77d1921)('section', {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $b8b42d608e86874b$export$cf63b23ce77d1921)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                rawDataIndex: data.getRawIndex(dataIndex)
            })
        ].concat(subBlocks || [])
    });
}
function $b4dd8326243601f0$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $e4c0c902d0f4f283$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $35510f45b1caf446$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $b8b42d608e86874b$export$cf63b23ce77d1921)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $be83ac5e1b26ee48$var$inner = $939d3a4c11ee87fd$export$64df9f8d92ae083f();
function $be83ac5e1b26ee48$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $be83ac5e1b26ee48$export$e960441116ae2799 = '__universalTransitionEnabled';
var $be83ac5e1b26ee48$var$SeriesModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $1d561c9acefaeb0e$export$f7292ab7796be73c)({
            count: $be83ac5e1b26ee48$var$dataTaskCount,
            reset: $be83ac5e1b26ee48$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $be83ac5e1b26ee48$var$inner(this).sourceManager = new (0, $cf16695c85c855fd$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $be83ac5e1b26ee48$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $be83ac5e1b26ee48$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $be83ac5e1b26ee48$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $52313d605bb144f5$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $52313d605bb144f5$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $879a47e830ab7f41$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += 'Series';
        $e4c0c902d0f4f283$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $e4c0c902d0f4f283$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $939d3a4c11ee87fd$export$abdcc6a26372f94b(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $52313d605bb144f5$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $e4c0c902d0f4f283$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $52313d605bb144f5$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $52313d605bb144f5$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $be83ac5e1b26ee48$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $be83ac5e1b26ee48$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $be83ac5e1b26ee48$var$inner(this).dataBeforeProcessed = data;
        $be83ac5e1b26ee48$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$e4c0c902d0f4f283$export$b119cc7e1840e59c(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $939d3a4c11ee87fd$export$abdcc6a26372f94b(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $be83ac5e1b26ee48$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null || !data.getLinkedData ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $be83ac5e1b26ee48$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $be83ac5e1b26ee48$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $be83ac5e1b26ee48$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $e4c0c902d0f4f283$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $be83ac5e1b26ee48$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $be83ac5e1b26ee48$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Retrieve the index of nearest value in the view coordinate.
   * Data position is compared with each axis's dataToCoord.
   *
   * @param axisDim axis dimension
   * @param dim data dimension
   * @param value
   * @param [maxDistance=Infinity] The maximum distance in view coordinate space
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesModel.prototype.indicesOfNearest = function(axisDim, dim, value, maxDistance) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var axis = coordSys && coordSys.getAxis(axisDim);
        if (!coordSys || !axis) return [];
        var targetCoord = axis.dataToCoord(value);
        if (maxDistance == null) maxDistance = Infinity;
        var nearestIndices = [];
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        // Performance-sensitive on large data (triggered by `tooltip`/`axisPointer` frequently).
        var dimIdx = data.getDimensionIndex(dim);
        var store = data.getStore();
        for(var idx = 0, len = store.count(); idx < len; idx++){
            var dimValue = store.get(dimIdx, idx);
            var dataCoord = axis.dataToCoord(dimValue);
            var diff = targetCoord - dataCoord;
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = idx;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $b4dd8326243601f0$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $d461075057ee3466$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        // See `dataTaskReset`.
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $866152e684dd44d9$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === 'series' || selectedMap === 'all') {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $be83ac5e1b26ee48$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === 'all') return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $e4c0c902d0f4f283$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === 'all' || selectedMap[$be83ac5e1b26ee48$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            'select',
            'disabled'
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$be83ac5e1b26ee48$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'series') option.selectedMap = 'all';
        else if (selectedMode === 'multiple') {
            if (!$e4c0c902d0f4f283$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $be83ac5e1b26ee48$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $be83ac5e1b26ee48$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $879a47e830ab7f41$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle';
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $879a47e830ab7f41$export$2e2bcd8739ae039));
$e4c0c902d0f4f283$export$e36fc9d62a853069($be83ac5e1b26ee48$var$SeriesModel, (0, $0acf4888a62e52cf$export$f23396ae04ea95a7));
$e4c0c902d0f4f283$export$e36fc9d62a853069($be83ac5e1b26ee48$var$SeriesModel, (0, $866152e684dd44d9$export$55a3c39e852b90f4));
(0, $01f767c32eb84395$export$c9c2d87774f1275d)($be83ac5e1b26ee48$var$SeriesModel, (0, $879a47e830ab7f41$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $be83ac5e1b26ee48$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$939d3a4c11ee87fd$export$beae19a2652b3368(seriesModel)) seriesModel.name = $be83ac5e1b26ee48$var$getSeriesAutoName(seriesModel) || name;
}
function $be83ac5e1b26ee48$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $e4c0c902d0f4f283$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $be83ac5e1b26ee48$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $be83ac5e1b26ee48$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $be83ac5e1b26ee48$var$dataTaskProgress;
}
function $be83ac5e1b26ee48$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $be83ac5e1b26ee48$var$wrapData(data, seriesModel) {
    $e4c0c902d0f4f283$export$79b2f7037acddd43($e4c0c902d0f4f283$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $e4c0c902d0f4f283$export$c3095a23b368d1f2($be83ac5e1b26ee48$var$onDataChange, seriesModel));
    });
}
function $be83ac5e1b26ee48$var$onDataChange(seriesModel, newList) {
    var task = $be83ac5e1b26ee48$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $be83ac5e1b26ee48$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $be83ac5e1b26ee48$export$2e2bcd8739ae039 = $be83ac5e1b26ee48$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $4f2cae7dfb9fed2a$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $0c53f0d63dde8266$export$2e2bcd8739ae039)();
        this.uid = $b08603d2997306ff$export$6d2b3473b0986646('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$01f767c32eb84395$export$cd4c3a4dca301c70($4f2cae7dfb9fed2a$var$ComponentView);
$01f767c32eb84395$export$241315e45585454d($4f2cae7dfb9fed2a$var$ComponentView);
var $4f2cae7dfb9fed2a$export$2e2bcd8739ae039 = $4f2cae7dfb9fed2a$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $ea696ac69c1e8dff$export$2e2bcd8739ae039() {
    var inner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}




var $2c3bdaabdaf03627$var$inner = $939d3a4c11ee87fd$export$64df9f8d92ae083f();
var $2c3bdaabdaf03627$var$renderPlanner = (0, $ea696ac69c1e8dff$export$2e2bcd8739ae039)();
var $2c3bdaabdaf03627$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $0c53f0d63dde8266$export$2e2bcd8739ae039)();
        this.uid = $b08603d2997306ff$export$6d2b3473b0986646('viewChart');
        this.renderTask = (0, $1d561c9acefaeb0e$export$f7292ab7796be73c)({
            plan: $2c3bdaabdaf03627$var$renderTaskPlan,
            reset: $2c3bdaabdaf03627$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $2c3bdaabdaf03627$var$toggleHighlight(data, payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $2c3bdaabdaf03627$var$toggleHighlight(data, payload, 'normal');
    };
    /**
   * `remove` only occurs when series is filtered out, typically by legend.
   * And theirafter the view can only be rendered again via
   * `ChartView['render']` or `ChartView['incrementalPrepareRender']`.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    // updateLayout(seriesModel: SeriesModel, ecModel: GlobalModel, api: ExtensionAPI, payload: Payload): void {
    //     this.render(seriesModel, ecModel, api, payload);
    // }
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $05f852c7feb2d530$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $2c3bdaabdaf03627$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $2c3bdaabdaf03627$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $6243d8dbb37d6b0d$export$77d1445f699c58b5)(el)) (state === 'emphasis' ? (0, $6243d8dbb37d6b0d$export$b2d02638cc34c042) : (0, $6243d8dbb37d6b0d$export$11be6f716239ac55))(el, highlightDigit);
}
function $2c3bdaabdaf03627$var$toggleHighlight(data, payload, state) {
    var dataIndex = $939d3a4c11ee87fd$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $6243d8dbb37d6b0d$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($939d3a4c11ee87fd$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $2c3bdaabdaf03627$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else // In progressive mode, `data._graphicEls` has typically no items,
    // thereby skipping this hover style changing.
    // PENDING: more robust approaches?
    data.eachItemGraphicEl(function(el) {
        $2c3bdaabdaf03627$var$elSetState(el, state, highlightDigit);
    });
}
$01f767c32eb84395$export$cd4c3a4dca301c70($2c3bdaabdaf03627$var$ChartView, [
    'dispose'
]);
$01f767c32eb84395$export$241315e45585454d($2c3bdaabdaf03627$var$ChartView);
function $2c3bdaabdaf03627$var$renderTaskPlan(context) {
    return $2c3bdaabdaf03627$var$renderPlanner(context.model);
}
function $2c3bdaabdaf03627$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $2c3bdaabdaf03627$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $2c3bdaabdaf03627$var$progressMethodMap[methodName];
}
var $2c3bdaabdaf03627$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $2c3bdaabdaf03627$export$2e2bcd8739ae039 = $2c3bdaabdaf03627$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3a19e7f2dc31be9c$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $3a19e7f2dc31be9c$var$RATE = '\0__throttleRate';
var $3a19e7f2dc31be9c$var$THROTTLE_TYPE = '\0__throttleType';
function $3a19e7f2dc31be9c$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $3a19e7f2dc31be9c$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$3a19e7f2dc31be9c$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$3a19e7f2dc31be9c$var$THROTTLE_TYPE];
    var lastRate = fn[$3a19e7f2dc31be9c$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $3a19e7f2dc31be9c$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$3a19e7f2dc31be9c$var$ORIGIN_METHOD] = originFn;
        fn[$3a19e7f2dc31be9c$var$THROTTLE_TYPE] = throttleType;
        fn[$3a19e7f2dc31be9c$var$RATE] = rate;
    }
    return fn;
}
function $3a19e7f2dc31be9c$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$3a19e7f2dc31be9c$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$3a19e7f2dc31be9c$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $acfb34f329927a44$var$inner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $acfb34f329927a44$var$defaultStyleMappers = {
    itemStyle: (0, $9d61ee6de44e4c40$export$2e2bcd8739ae039)((0, $c8bd8d6b286b16e5$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $9d61ee6de44e4c40$export$2e2bcd8739ae039)((0, $141ad3c336686acb$export$9f34de5b59222949), true)
};
var $acfb34f329927a44$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $acfb34f329927a44$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $acfb34f329927a44$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $acfb34f329927a44$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $acfb34f329927a44$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $acfb34f329927a44$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $acfb34f329927a44$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $acfb34f329927a44$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $acfb34f329927a44$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $acfb34f329927a44$var$sharedModel = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)();
var $acfb34f329927a44$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var getStyle = $acfb34f329927a44$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $acfb34f329927a44$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($acfb34f329927a44$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(existsStyle, style);
                    if ($acfb34f329927a44$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $acfb34f329927a44$var$sharedModel.option.decal);
                        $acfb34f329927a44$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $acfb34f329927a44$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            if (!seriesModel.isColorBySeries()) {
                var key = seriesModel.type + '-' + seriesModel.getColorBy();
                $acfb34f329927a44$var$inner(seriesModel).scope = paletteScopeGroupByType.get(key) || paletteScopeGroupByType.set(key, {});
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries()) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $acfb34f329927a44$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $acfb34f329927a44$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $173a947350700d3d$var$PI = Math.PI;
function $173a947350700d3d$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $e4c0c902d0f4f283$export$ebe90cb607ad99e(opts, {
        text: 'loading',
        textColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.primary,
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255,255,255,0.8)',
        showSpinner: true,
        color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.theme[0],
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $0c53f0d63dde8266$export$2e2bcd8739ae039();
    var mask = new $439653c37a0e6e60$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $9f8a9b67e62609f8$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $439653c37a0e6e60$export$2e2bcd8739ae039({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $8c43921d92adb726$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$173a947350700d3d$var$PI / 2,
                endAngle: -$173a947350700d3d$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $173a947350700d3d$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $173a947350700d3d$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $078f2454358d723a$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on several series, specified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case `chart.appendData`.
        // Regarding zrender, both echarts "progressive" and "incremental" use `el.incremental: true`.
        var context = seriesModel.__preparePipelineContext ? seriesModel.__preparePipelineContext(view, pipeline) : (0, $939d3a4c11ee87fd$export$3b33f7e0868ca070)(seriesModel, view, pipeline);
        seriesModel.pipelineContext = pipeline.context = context;
    };
    Scheduler.prototype.restorePipelines = function(zr, ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = zr.painter.type === 'canvas' && seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $1d561c9acefaeb0e$export$f7292ab7796be73c)({
                plan: $078f2454358d723a$var$seriesTaskPlan,
                reset: $078f2454358d723a$var$seriesTaskReset,
                count: $078f2454358d723a$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $1d561c9acefaeb0e$export$f7292ab7796be73c)({
            reset: $078f2454358d723a$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var dirtyOnOverallProgress = stageHandler.dirtyOnOverallProgress;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines to receive dirty info from upstream.
        var errMsg = '';
        (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $1d561c9acefaeb0e$export$f7292ab7796be73c)({
                reset: $078f2454358d723a$var$stubReset,
                onDirty: $078f2454358d723a$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                dirtyOnOverallProgress: dirtyOnOverallProgress
            };
            stub.agent = overallTask;
            stub.__block = dirtyOnOverallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $078f2454358d723a$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $b08603d2997306ff$export$6d2b3473b0986646)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $078f2454358d723a$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $078f2454358d723a$var$stubReset(context) {
    return context.dirtyOnOverallProgress && $078f2454358d723a$var$stubProgress;
}
function $078f2454358d723a$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $078f2454358d723a$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $078f2454358d723a$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $078f2454358d723a$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $078f2454358d723a$var$makeSeriesTaskProgress(idx);
    }) : $078f2454358d723a$var$singleSeriesTaskProgress;
}
var $078f2454358d723a$var$singleSeriesTaskProgress = $078f2454358d723a$var$makeSeriesTaskProgress(0);
function $078f2454358d723a$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $078f2454358d723a$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $078f2454358d723a$var$detectSeriseType(legacyFunc) {
    $078f2454358d723a$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($078f2454358d723a$var$ecModelMock, $078f2454358d723a$var$apiMock);
    } catch (e) {}
    return $078f2454358d723a$var$seriesType;
}
var $078f2454358d723a$var$ecModelMock = {};
var $078f2454358d723a$var$apiMock = {};
var $078f2454358d723a$var$seriesType;
$078f2454358d723a$var$mockMethods($078f2454358d723a$var$ecModelMock, (0, $74c729a11d908314$export$2e2bcd8739ae039));
$078f2454358d723a$var$mockMethods($078f2454358d723a$var$apiMock, (0, $fa04f8f648e70374$export$2e2bcd8739ae039));
$078f2454358d723a$var$ecModelMock.eachSeriesByType = $078f2454358d723a$var$ecModelMock.eachRawSeriesByType = function(type) {
    $078f2454358d723a$var$seriesType = type;
};
$078f2454358d723a$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $078f2454358d723a$var$seriesType = cond.subType;
};
function $078f2454358d723a$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $e4c0c902d0f4f283$export$8793edee2d425525);
/* eslint-enable */ }
var $078f2454358d723a$export$2e2bcd8739ae039 = $078f2454358d723a$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $138e752359922fa8$var$color = (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).darkColor;
var $138e752359922fa8$var$backgroundColor = $138e752359922fa8$var$color.background;
var $138e752359922fa8$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $138e752359922fa8$var$color.axisLine
            }
        },
        splitLine: {
            lineStyle: {
                color: $138e752359922fa8$var$color.axisSplitLine
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    $138e752359922fa8$var$color.backgroundTint,
                    $138e752359922fa8$var$color.backgroundTransparent
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: $138e752359922fa8$var$color.axisMinorSplitLine
            }
        },
        axisLabel: {
            color: $138e752359922fa8$var$color.axisLabel
        },
        axisName: {}
    };
};
var $138e752359922fa8$var$matrixAxis = {
    label: {
        color: $138e752359922fa8$var$color.secondary
    },
    itemStyle: {
        borderColor: $138e752359922fa8$var$color.borderTint
    },
    dividerLineStyle: {
        color: $138e752359922fa8$var$color.border
    }
};
var $138e752359922fa8$var$theme = {
    darkMode: true,
    color: $138e752359922fa8$var$color.theme,
    backgroundColor: $138e752359922fa8$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: $138e752359922fa8$var$color.border
        },
        crossStyle: {
            color: $138e752359922fa8$var$color.borderShade
        },
        label: {
            color: $138e752359922fa8$var$color.tertiary
        }
    },
    legend: {
        textStyle: {
            color: $138e752359922fa8$var$color.secondary
        },
        pageTextStyle: {
            color: $138e752359922fa8$var$color.tertiary
        }
    },
    textStyle: {
        color: $138e752359922fa8$var$color.secondary
    },
    title: {
        textStyle: {
            color: $138e752359922fa8$var$color.primary
        },
        subtextStyle: {
            color: $138e752359922fa8$var$color.quaternary
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $138e752359922fa8$var$color.accent50
        },
        feature: {
            dataView: {
                backgroundColor: $138e752359922fa8$var$backgroundColor,
                textColor: $138e752359922fa8$var$color.primary,
                textareaColor: $138e752359922fa8$var$color.background,
                textareaBorderColor: $138e752359922fa8$var$color.border,
                buttonColor: $138e752359922fa8$var$color.accent50,
                buttonTextColor: $138e752359922fa8$var$color.neutral00
            }
        }
    },
    tooltip: {
        backgroundColor: $138e752359922fa8$var$color.neutral20,
        defaultBorderColor: $138e752359922fa8$var$color.border,
        textStyle: {
            color: $138e752359922fa8$var$color.tertiary
        }
    },
    dataZoom: {
        borderColor: $138e752359922fa8$var$color.accent10,
        textStyle: {
            color: $138e752359922fa8$var$color.tertiary
        },
        brushStyle: {
            color: $138e752359922fa8$var$color.backgroundTint
        },
        handleStyle: {
            color: $138e752359922fa8$var$color.neutral00,
            borderColor: $138e752359922fa8$var$color.accent20
        },
        moveHandleStyle: {
            color: $138e752359922fa8$var$color.accent40
        },
        emphasis: {
            handleStyle: {
                borderColor: $138e752359922fa8$var$color.accent50
            }
        },
        dataBackground: {
            lineStyle: {
                color: $138e752359922fa8$var$color.accent30
            },
            areaStyle: {
                color: $138e752359922fa8$var$color.accent20
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: $138e752359922fa8$var$color.accent50
            },
            areaStyle: {
                color: $138e752359922fa8$var$color.accent30
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $138e752359922fa8$var$color.secondary
        },
        handleStyle: {
            borderColor: $138e752359922fa8$var$color.neutral30
        }
    },
    timeline: {
        lineStyle: {
            color: $138e752359922fa8$var$color.accent10
        },
        label: {
            color: $138e752359922fa8$var$color.tertiary
        },
        controlStyle: {
            color: $138e752359922fa8$var$color.accent30,
            borderColor: $138e752359922fa8$var$color.accent30
        }
    },
    calendar: {
        itemStyle: {
            color: $138e752359922fa8$var$color.neutral00,
            borderColor: $138e752359922fa8$var$color.neutral20
        },
        dayLabel: {
            color: $138e752359922fa8$var$color.tertiary
        },
        monthLabel: {
            color: $138e752359922fa8$var$color.secondary
        },
        yearLabel: {
            color: $138e752359922fa8$var$color.secondary
        }
    },
    matrix: {
        x: $138e752359922fa8$var$matrixAxis,
        y: $138e752359922fa8$var$matrixAxis,
        backgroundColor: {
            borderColor: $138e752359922fa8$var$color.axisLine
        },
        body: {
            itemStyle: {
                borderColor: $138e752359922fa8$var$color.borderTint
            }
        }
    },
    timeAxis: $138e752359922fa8$var$axisCommon(),
    logAxis: $138e752359922fa8$var$axisCommon(),
    valueAxis: $138e752359922fa8$var$axisCommon(),
    categoryAxis: $138e752359922fa8$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $138e752359922fa8$var$color.theme
    },
    gauge: {
        title: {
            color: $138e752359922fa8$var$color.secondary
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        $138e752359922fa8$var$color.neutral05
                    ]
                ]
            }
        },
        axisLabel: {
            color: $138e752359922fa8$var$color.axisLabel
        },
        detail: {
            color: $138e752359922fa8$var$color.primary
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92'
        }
    },
    funnel: {
        itemStyle: {
            borderColor: $138e752359922fa8$var$color.background
        }
    },
    radar: function() {
        var radar = $138e752359922fa8$var$axisCommon();
        radar.axisName = {
            color: $138e752359922fa8$var$color.axisLabel
        };
        radar.axisLine.lineStyle.color = $138e752359922fa8$var$color.neutral20;
        return radar;
    }(),
    treemap: {
        breadcrumb: {
            itemStyle: {
                color: $138e752359922fa8$var$color.neutral20,
                textStyle: {
                    color: $138e752359922fa8$var$color.secondary
                }
            },
            emphasis: {
                itemStyle: {
                    color: $138e752359922fa8$var$color.neutral30
                }
            }
        }
    },
    sunburst: {
        itemStyle: {
            borderColor: $138e752359922fa8$var$color.background
        }
    },
    map: {
        itemStyle: {
            borderColor: $138e752359922fa8$var$color.border,
            areaColor: $138e752359922fa8$var$color.neutral10
        },
        label: {
            color: $138e752359922fa8$var$color.tertiary
        },
        emphasis: {
            label: {
                color: $138e752359922fa8$var$color.primary
            },
            itemStyle: {
                areaColor: $138e752359922fa8$var$color.highlight
            }
        },
        select: {
            label: {
                color: $138e752359922fa8$var$color.primary
            },
            itemStyle: {
                areaColor: $138e752359922fa8$var$color.highlight
            }
        }
    },
    geo: {
        itemStyle: {
            borderColor: $138e752359922fa8$var$color.border,
            areaColor: $138e752359922fa8$var$color.neutral10
        },
        emphasis: {
            label: {
                color: $138e752359922fa8$var$color.primary
            },
            itemStyle: {
                areaColor: $138e752359922fa8$var$color.highlight
            }
        },
        select: {
            label: {
                color: $138e752359922fa8$var$color.primary
            },
            itemStyle: {
                color: $138e752359922fa8$var$color.highlight
            }
        }
    }
};
$138e752359922fa8$var$theme.categoryAxis.splitLine.show = false;
var $138e752359922fa8$export$2e2bcd8739ae039 = $138e752359922fa8$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $ca37aa7928bf4f39$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($e4c0c902d0f4f283$export$844ec244b1367d54(query)) {
            var condCptType = (0, $01f767c32eb84395$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $e4c0c902d0f4f283$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $2f1892f181bfdf72$var$SYMBOL_PROPS_WITH_CB = [
    'symbol',
    'symbolSize',
    'symbolRotate',
    'symbolOffset'
];
var $2f1892f181bfdf72$var$SYMBOL_PROPS = $2f1892f181bfdf72$var$SYMBOL_PROPS_WITH_CB.concat([
    'symbolKeepAspect'
]);
// Encoding visual for all series include which is filtered for legend drawing
var $2f1892f181bfdf72$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $2f1892f181bfdf72$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $2f1892f181bfdf72$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get('symbolKeepAspect')
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $2f1892f181bfdf72$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $2f1892f181bfdf72$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $2f1892f181bfdf72$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8e9640738fc92e9b$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $8e9640738fc92e9b$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $8e9640738fc92e9b$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $37b950dbb69299a0$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $e4c0c902d0f4f283$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $37b950dbb69299a0$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $939d3a4c11ee87fd$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $37b950dbb69299a0$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $37b950dbb69299a0$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $37b950dbb69299a0$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $37b950dbb69299a0$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $37b950dbb69299a0$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $37b950dbb69299a0$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $37b950dbb69299a0$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c9d8ac168c7942c2$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $48bee0c8f46ee18d$var$lifecycle = new (0, $770990963ee378bd$export$2e2bcd8739ae039)();
var $48bee0c8f46ee18d$export$2e2bcd8739ae039 = $48bee0c8f46ee18d$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $7d34afedff90144f$var$implsStore = {};
function $7d34afedff90144f$export$9b808fd12256ddd3(name, impl) {
    $7d34afedff90144f$var$implsStore[name] = impl;
}
function $7d34afedff90144f$export$73333eb8a09d5f61(name) {
    return $7d34afedff90144f$var$implsStore[name];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $371689911d44ce92$var$customRenderers = {};
function $371689911d44ce92$export$c3e61191887968da(type, renderItem) {
    $371689911d44ce92$var$customRenderers[type] = renderItem;
}
function $371689911d44ce92$export$2b5db8e5650e8d15(type) {
    return $371689911d44ce92$var$customRenderers[type];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6e6e84884711664e$var$ecModelCacheInner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
function $6e6e84884711664e$export$54b70eb74482271e(ecModel) {
    $6e6e84884711664e$var$ecModelCacheInner(ecModel).prepare = {};
}
function $6e6e84884711664e$export$7a0372e5df3ca6f4(ecModel) {
    $6e6e84884711664e$var$ecModelCacheInner(ecModel).fullUpdate = {};
}
function $6e6e84884711664e$export$67fb26d0f4e31b9e(ecModel) {
    return $6e6e84884711664e$var$ecModelCacheInner(ecModel).prepare;
}
function $6e6e84884711664e$export$14434b56aab40385(ecModel) {
    return $6e6e84884711664e$var$ecModelCacheInner(ecModel).fullUpdate;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a81e598b979e08f2$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $a81e598b979e08f2$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $a81e598b979e08f2$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $a81e598b979e08f2$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($a81e598b979e08f2$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $a81e598b979e08f2$export$2e2bcd8739ae039 = $a81e598b979e08f2$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory






/**
 * Triangle shape
 * @inner
 */ var $b6180ec78eaf8763$var$Triangle = $27b47789cc8143e1$export$2e2bcd8739ae039.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $b6180ec78eaf8763$var$Diamond = $27b47789cc8143e1$export$2e2bcd8739ae039.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $b6180ec78eaf8763$var$Pin = $27b47789cc8143e1$export$2e2bcd8739ae039.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $b6180ec78eaf8763$var$Arrow = $27b47789cc8143e1$export$2e2bcd8739ae039.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $b6180ec78eaf8763$var$symbolCtors = {
    line: $8ae349726e18597f$export$2e2bcd8739ae039,
    rect: $439653c37a0e6e60$export$2e2bcd8739ae039,
    roundRect: $439653c37a0e6e60$export$2e2bcd8739ae039,
    square: $439653c37a0e6e60$export$2e2bcd8739ae039,
    circle: $f43fbde6d03c3be0$export$2e2bcd8739ae039,
    diamond: $b6180ec78eaf8763$var$Diamond,
    pin: $b6180ec78eaf8763$var$Pin,
    arrow: $b6180ec78eaf8763$var$Arrow,
    triangle: $b6180ec78eaf8763$var$Triangle
};
var $b6180ec78eaf8763$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $b6180ec78eaf8763$export$33fc3b478d332725 = {};
(0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($b6180ec78eaf8763$var$symbolCtors, function(Ctor, name) {
    $b6180ec78eaf8763$export$33fc3b478d332725[name] = new Ctor();
});
var $b6180ec78eaf8763$var$SymbolClz = $27b47789cc8143e1$export$2e2bcd8739ae039.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $211780946ab71638$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $b6180ec78eaf8763$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $b6180ec78eaf8763$export$33fc3b478d332725[symbolType];
            }
            $b6180ec78eaf8763$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $b6180ec78eaf8763$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.neutral00;
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $b6180ec78eaf8763$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $05f852c7feb2d530$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $05f852c7feb2d530$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $b6180ec78eaf8763$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $b6180ec78eaf8763$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $b6180ec78eaf8763$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $b6180ec78eaf8763$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)((0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $13757e5a67c3b637$var$isSafeNum(num) {
    return isFinite(num);
}
function $13757e5a67c3b637$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $13757e5a67c3b637$var$isSafeNum(x) ? x : 0;
    x2 = $13757e5a67c3b637$var$isSafeNum(x2) ? x2 : 1;
    y = $13757e5a67c3b637$var$isSafeNum(y) ? y : 0;
    y2 = $13757e5a67c3b637$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $13757e5a67c3b637$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $13757e5a67c3b637$var$isSafeNum(x) ? x : 0.5;
    y = $13757e5a67c3b637$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $13757e5a67c3b637$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $13757e5a67c3b637$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $13757e5a67c3b637$export$57f098206d57a443(ctx, obj, rect) : $13757e5a67c3b637$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $13757e5a67c3b637$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $13757e5a67c3b637$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $13757e5a67c3b637$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        'width',
        'height'
    ][whIdx];
    var cwh = [
        'clientWidth',
        'clientHeight'
    ][whIdx];
    var plt = [
        'paddingLeft',
        'paddingTop'
    ][whIdx];
    var prb = [
        'paddingRight',
        'paddingBottom'
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $13757e5a67c3b637$var$parseInt10(stl[wh]) || $13757e5a67c3b637$var$parseInt10(root.style[wh])) - ($13757e5a67c3b637$var$parseInt10(stl[plt]) || 0) - ($13757e5a67c3b637$var$parseInt10(stl[prb]) || 0) || 0;
}







function $33078477762969e9$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $33078477762969e9$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $33078477762969e9$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $cda32a88b3a3e852$var$pathProxyForDraw = new (0, $4454211f949588ae$export$2e2bcd8739ae039)(true);
function $cda32a88b3a3e852$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $cda32a88b3a3e852$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $cda32a88b3a3e852$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $cda32a88b3a3e852$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $cda32a88b3a3e852$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $cda32a88b3a3e852$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $fe811193fee9631f$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $fe811193fee9631f$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $e4c0c902d0f4f283$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $cda32a88b3a3e852$var$brushPath(ctx, el, style, canBatch, scope) {
    var _a;
    var hasStroke = $cda32a88b3a3e852$var$styleHasStroke(style);
    var hasFill = $cda32a88b3a3e852$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $cda32a88b3a3e852$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!canBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $13757e5a67c3b637$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $13757e5a67c3b637$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $cda32a88b3a3e852$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $cda32a88b3a3e852$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = strokePattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $33078477762969e9$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $be8577c7cd53a73f$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, canBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!canBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $cda32a88b3a3e852$var$doStrokePath(ctx, style);
            if (hasFill) $cda32a88b3a3e852$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $cda32a88b3a3e852$var$doFillPath(ctx, style);
            if (hasStroke) $cda32a88b3a3e852$var$doStrokePath(ctx, style);
        }
    } else {
        scope.batchFill = hasFill;
        scope.batchStroke = hasStroke;
    }
    if (lineDash) ctx.setLineDash([]);
}
function $cda32a88b3a3e852$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $fe811193fee9631f$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $fe811193fee9631f$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $cda32a88b3a3e852$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $fd1433555986e896$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $33078477762969e9$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($cda32a88b3a3e852$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($cda32a88b3a3e852$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($cda32a88b3a3e852$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($cda32a88b3a3e852$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $cda32a88b3a3e852$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $cda32a88b3a3e852$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $cda32a88b3a3e852$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $4aa50d5371582059$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $4aa50d5371582059$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $cda32a88b3a3e852$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $cda32a88b3a3e852$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $4aa50d5371582059$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $cda32a88b3a3e852$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = el.style;
    var prevStyle = forceSetAll ? null : prevEl && prevEl.style || {};
    if (style === prevStyle) return false;
    var styleChanged = $cda32a88b3a3e852$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $cda32a88b3a3e852$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $cda32a88b3a3e852$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $cda32a88b3a3e852$var$STROKE_PROPS.length; i++){
        var prop = $cda32a88b3a3e852$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $cda32a88b3a3e852$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $cda32a88b3a3e852$var$bindCommonProps(ctx, el.style, prevEl && prevEl.style, forceSetAll, scope);
}
function $cda32a88b3a3e852$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $cda32a88b3a3e852$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $cda32a88b3a3e852$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $cda32a88b3a3e852$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $cda32a88b3a3e852$var$DRAW_TYPE_PATH = 1;
var $cda32a88b3a3e852$var$DRAW_TYPE_IMAGE = 2;
var $cda32a88b3a3e852$var$DRAW_TYPE_TEXT = 3;
var $cda32a88b3a3e852$var$DRAW_TYPE_INCREMENTAL = 4;
function $cda32a88b3a3e852$var$canPathBatch(style) {
    var hasFill = $cda32a88b3a3e852$var$styleHasFill(style);
    var hasStroke = $cda32a88b3a3e852$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope) {
    if (scope.batchFill) {
        scope.batchFill = false;
        ctx.fill();
    }
    if (scope.batchStroke) {
        scope.batchStroke = false;
        ctx.stroke();
    }
}
function $cda32a88b3a3e852$export$567881adfc3eb7f3(ctx, el) {
    var scope = {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0,
        beforeBrushParam: {}
    };
    $cda32a88b3a3e852$export$da5d6544e8c27bc1(ctx, el, scope);
    $cda32a88b3a3e852$export$aa9c98b43779289a(ctx, scope);
}
function $cda32a88b3a3e852$export$da5d6544e8c27bc1(ctx, el, scope) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var style = el.style;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $13757e5a67c3b637$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths) {
            $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $cda32a88b3a3e852$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
            scope.prevElClipPaths = clipPaths;
        }
    }
    if (scope.allClipped) {
        el.__dirty &= ~(0, $be8577c7cd53a73f$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush(scope.beforeBrushParam);
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $27b47789cc8143e1$export$2e2bcd8739ae039) && el.autoBatch && $cda32a88b3a3e852$var$canPathBatch(style);
    if (forceSetTransform || $cda32a88b3a3e852$var$isTransformChanged(m, prevEl.transform)) {
        $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
        $cda32a88b3a3e852$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
    if (el instanceof (0, $27b47789cc8143e1$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $cda32a88b3a3e852$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $cda32a88b3a3e852$var$DRAW_TYPE_PATH;
        }
        $cda32a88b3a3e852$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $cda32a88b3a3e852$var$brushPath(ctx, el, style, canBatchPath, scope);
    } else {
        if (el instanceof (0, $67c55373fdf93a2e$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $cda32a88b3a3e852$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $cda32a88b3a3e852$var$DRAW_TYPE_TEXT;
            }
            $cda32a88b3a3e852$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $cda32a88b3a3e852$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $b5bca30d4a081571$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $cda32a88b3a3e852$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $cda32a88b3a3e852$var$DRAW_TYPE_IMAGE;
            }
            $cda32a88b3a3e852$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $cda32a88b3a3e852$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $cda32a88b3a3e852$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $cda32a88b3a3e852$var$DRAW_TYPE_INCREMENTAL;
            }
            $cda32a88b3a3e852$var$brushIncremental(ctx, el, scope);
        }
    }
    el.innerAfterBrush();
    if (el.afterBrush) {
        if (canBatchPath) $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
        el.afterBrush();
    }
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $cda32a88b3a3e852$export$aa9c98b43779289a(ctx, scope) {
    $cda32a88b3a3e852$var$flushPathDrawn(ctx, scope);
    if (scope.prevElClipPaths) ctx.restore();
}
function $cda32a88b3a3e852$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover,
        beforeBrushParam: {}
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush(scope.beforeBrushParam);
        displayable.innerBeforeBrush();
        $cda32a88b3a3e852$export$da5d6544e8c27bc1(ctx, displayable, innerScope);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    $cda32a88b3a3e852$export$aa9c98b43779289a(ctx, innerScope);
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush(scope.beforeBrushParam);
        displayable.innerBeforeBrush();
        $cda32a88b3a3e852$export$da5d6544e8c27bc1(ctx, displayable, innerScope);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    $cda32a88b3a3e852$export$aa9c98b43779289a(ctx, innerScope);
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $0481b5c792b5cb84$var$decalMap = new (0, $a81e598b979e08f2$export$2e2bcd8739ae039)();
var $0481b5c792b5cb84$var$decalCache = new (0, $cdadfc83391b9630$export$2e2bcd8739ae039)(100);
var $0481b5c792b5cb84$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $0481b5c792b5cb84$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $0481b5c792b5cb84$var$decalMap["delete"](decalObject);
    var oldPattern = $0481b5c792b5cb84$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $0481b5c792b5cb84$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $0481b5c792b5cb84$var$decalKeys.length; ++i){
            var value = decalOpt[$0481b5c792b5cb84$var$decalKeys[i]];
            if (value != null && !(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(value) && !(0, $e4c0c902d0f4f283$export$844ec244b1367d54)(value) && !(0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(value) && typeof value !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $0481b5c792b5cb84$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $0481b5c792b5cb84$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $0481b5c792b5cb84$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $0481b5c792b5cb84$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $0481b5c792b5cb84$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $0481b5c792b5cb84$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $fd1433555986e896$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: 'g',
            attrs: {},
            key: 'dcl',
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $0481b5c792b5cb84$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $0b2f7076fd7740ca$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $0b2f7076fd7740ca$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $b6180ec78eaf8763$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $cda32a88b3a3e852$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $0481b5c792b5cb84$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $e4c0c902d0f4f283$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $0481b5c792b5cb84$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $0481b5c792b5cb84$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $0481b5c792b5cb84$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $0481b5c792b5cb84$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $0481b5c792b5cb84$var$getLineBlockLengthX(dash) {
    return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(dash, function(line) {
        return $0481b5c792b5cb84$var$getLineBlockLengthY(line);
    });
}
function $0481b5c792b5cb84$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}



var $17a04d2ccc4434e3$export$218eea02a2a96fb4 = (0, $939d3a4c11ee87fd$export$d62c61cad9d1ab83)($17a04d2ccc4434e3$var$decalVisual);
function $17a04d2ccc4434e3$var$decalVisual(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $0481b5c792b5cb84$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $0481b5c792b5cb84$export$a3ba048e1a648972)(decal, api);
        }
    });
}


var $34de22b7c8cf03f7$export$83d89fbfd8236492 = '6.1.0';
var $34de22b7c8cf03f7$export$b74ff737e0e298b5 = {
    zrender: '6.1.0'
};
var $34de22b7c8cf03f7$var$TEST_FRAME_REMAIN_TIME = 1;
var $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// In the current impl, "data stack" will modifies the original "series data extent". Some data
// processors rely on the stack result dimension to calculate extents. So data stack
// should be in front of other data processors.
var $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// AXIS_STATISTICS should be after SERIES_FILTER, as it may change the statistics result (like min gap).
// AXIS_STATISTICS should be before filter (dataZoom), as dataZoom require the result in "containShape" calculation.
var $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_AXIS_STATISTICS = 920;
// `PRIORITY_PROCESSOR_FILTER` is typically used by `dataZoom` (see `AxisProxy`), which relies
// on the initialized "axis extent".
var $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_STATISTICS = 5000;
// NOTICE: Data processors above block the stream (especially time-consuming processors like data filters).
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_CHART = 3000;
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the visual result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_BRUSH = 5000;
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_ARIA = 6000;
var $34de22b7c8cf03f7$var$PRIORITY_VISUAL_DECAL = 7000;
var $34de22b7c8cf03f7$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        SERIES_FILTER: $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        AXIS_STATISTICS: $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_AXIS_STATISTICS,
        FILTER: $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_FILTER,
        STATISTIC: $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_STATISTICS,
        STATISTICS: $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_STATISTICS
    },
    VISUAL: {
        LAYOUT: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_ARIA,
        DECAL: $34de22b7c8cf03f7$var$PRIORITY_VISUAL_DECAL
    }
};
/**
 * @tutorial [EC_CYCLE] (ec updating/rendering cycles):
 *
 *  - Common Rules:
 *    - Nested entry is not allowed. If triggering a new run of EC_CYCLE during a
 *      unfinished run, the new run will be delayed until the current run finishes
 *      (if triggered by `dispatchAction`), or throw error (if triggered by other API calls).
 *    - All user-visible ec events are triggered outside EC_CYCLE.
 *      (i.e. be triggered after `this[IN_EC_CYCLE_KEY]` becoming `false`).
 *
 *  - [EC_FULL_UPDATE_CYCLE]:
 *    - It designates a run of a series of processing/updating/rendering.
 *    - It is triggered by:
 *      - `setOption`
 *      - `dispatchAction`
 *        (It is typically internally triggered by user inputs; but can also an explicit API call.)
 *      - `resize`
 *      - The next "animation frame" if in `lazyMode: true`.
 *    - A run of EC_FULL_UPDATE_CYCLE comprises:
 *      - EC_PREPARE (may be absent)
 *      - EC_FULL_UPDATE:
 *        - CoordinateSystem['create']
 *        - Data processing (may be absent) (see `registerProcessor`)
 *        - CoordinateSystem['update'] (may be absent)
 *        - Visual encoding (may be absent) (see `registerVisual`)
 *        - Layout (may be absent) (see `registerLayout`)
 *        - Rendering (`ComponentView` or `SeriesView`)
 *
 *  - [EC_PARTIAL_UPDATE_CYCLE]s:
 *      - They are shortcuts for performance.
 *      - They are triggered by:
 *        - `dispatchAction`
 *      - These steps are typically omitted:
 *        - No EC_PREPARE
 *        - No CoordinateSystem['create'] and CoordinateSystem['update']
 *      - They require careful implementation, otherwise inconsistency may be introduced.
 *
 *  - [EC_PROGRESSIVE_CYCLE]:
 *    - It also carries out a series of processing/updating/rendering.
 *    - It is performed in each subsequent "animation frame" until finished.
 *    - It can be triggered by EC_FULL_UPDATE_CYCLE, EC_PARTIAL_UPDATE_CYCLE or EC_APPEND_DATA_CYCLE.
 *    - A run of EC_PROGRESSIVE_CYCLE comprises:
 *      - Data processing (may be absent) (see `registerProcessor`)
 *      - Visual encoding (may be absent) (see `registerVisual`)
 *      - Layout (may be absent) (see `registerLayout`)
 *      - Rendering (`ComponentView` or `SeriesView`)
 *    - PENDING: currently all data processing tasks (via `registerProcessor`) run in "block" mode.
 *      (see `performDataProcessorTasks`).
 *
 *  - [EC_APPEND_DATA_CYCLE]:
 *    - See `appendData`. It is only supported for some special cases.
 *
 *  - [SERIES_SPECIFIC_CYCLE]s:
 *    - Series may have specific update/render cycles. For example, graph force layout performs
 *      layout and rendering in each "animation frame".
 *
 *  - Model updating:
 *    - Model can only be modified at the beginning of ec cycles, including only:
 *      - EC_PREPARE (see method `prepare()`) in `setOption` call.
 *      - EC action handlers in `dispatchAction` call.
 *      - `appendData` (a special case, where only data can be modified).
 *
 *  - The lifetime of CoordinateSystem/Axis/Scale instances:
 *    - They are only re-created per run of EC_FULL_UPDATE_CYCLE.
 *
 *  - Global caches: see `cycleCache.ts`
 */ // See comments in EC_CYCLE.
var $34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY = '__flagInMainProcess';
// Useful for detecting outdated rendering results for the following scenarios:
//  - In EC_PARTIAL_UPDATE_CYCLE, some rendering may be skipped.
//  - Asynchronously update rendered view (e.g., graph force layout).
//  - Multiple ChartView/ComponentView render to one group cooperatively.
var $34de22b7c8cf03f7$var$EC_UPDATE_CYCLE_VERSION_KEY = '__mainProcessVersion';
var $34de22b7c8cf03f7$var$PENDING_UPDATE = '__pendingUpdate';
var $34de22b7c8cf03f7$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $34de22b7c8cf03f7$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $34de22b7c8cf03f7$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $34de22b7c8cf03f7$var$CONNECT_STATUS_PENDING = 0;
var $34de22b7c8cf03f7$var$CONNECT_STATUS_UPDATING = 1;
var $34de22b7c8cf03f7$var$CONNECT_STATUS_UPDATED = 2;
function $34de22b7c8cf03f7$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        return $34de22b7c8cf03f7$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $34de22b7c8cf03f7$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $34de22b7c8cf03f7$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $34de22b7c8cf03f7$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $770990963ee378bd$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $34de22b7c8cf03f7$var$MessageCenter = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $770990963ee378bd$export$2e2bcd8739ae039));
var $34de22b7c8cf03f7$var$messageCenterProto = $34de22b7c8cf03f7$var$MessageCenter.prototype;
$34de22b7c8cf03f7$var$messageCenterProto.on = $34de22b7c8cf03f7$var$createRegisterEventWithLowercaseMessageCenter('on');
$34de22b7c8cf03f7$var$messageCenterProto.off = $34de22b7c8cf03f7$var$createRegisterEventWithLowercaseMessageCenter('off');
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
// This is [EC_PREPARE].
var $34de22b7c8cf03f7$var$prepare;
var $34de22b7c8cf03f7$var$prepareView;
var $34de22b7c8cf03f7$var$updateDirectly;
var $34de22b7c8cf03f7$var$updateMethods;
var $34de22b7c8cf03f7$var$doConvertPixel;
var $34de22b7c8cf03f7$var$updateStreamModes;
var $34de22b7c8cf03f7$var$doDispatchAction;
var $34de22b7c8cf03f7$var$flushPendingActions;
var $34de22b7c8cf03f7$var$triggerUpdatedEvent;
var $34de22b7c8cf03f7$var$bindRenderedEvent;
var $34de22b7c8cf03f7$var$bindMouseEvent;
var $34de22b7c8cf03f7$var$render;
var $34de22b7c8cf03f7$var$renderComponents;
var $34de22b7c8cf03f7$var$renderSeries;
var $34de22b7c8cf03f7$var$createExtensionAPI;
var $34de22b7c8cf03f7$var$enableConnect;
var $34de22b7c8cf03f7$var$markStatusToUpdate;
var $34de22b7c8cf03f7$var$applyChangedStates;
var $34de22b7c8cf03f7$var$updateECUpdateCycleVersion;
var $34de22b7c8cf03f7$var$ECharts = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $ca37aa7928bf4f39$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        // mark the echarts instance as raw in Vue 3 to prevent the object being converted to be a proxy.
        _this.__v_skip = true;
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultCoarsePointer = 'auto';
        var defaultUseDirtyRect = false;
        _this[$34de22b7c8cf03f7$var$EC_UPDATE_CYCLE_VERSION_KEY] = 1;
        var root;
        if (opts.ssr) $aae635f77c3c70af$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
            hashMap.set('series_index', ecData.seriesIndex);
            hashMap.set('data_index', dataIndex);
            ecData.ssrType && hashMap.set('ssr_type', ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $aae635f77c3c70af$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $3a19e7f2dc31be9c$export$de363e709c412c8a)((0, $e4c0c902d0f4f283$export$2385a24977818dd0)(zr.flush, zr), 17);
        _this._updateTheme(theme);
        _this._locale = (0, $e96c473e8bd88107$export$ddc371781a6af754)(opts.locale || (0, $e96c473e8bd88107$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $65108a454a48746f$export$2e2bcd8739ae039)();
        var api = _this._api = $34de22b7c8cf03f7$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $9e91dd6172c91368$export$2e2bcd8739ae039)($34de22b7c8cf03f7$var$visualFuncs, prioritySortFunc);
        (0, $9e91dd6172c91368$export$2e2bcd8739ae039)($34de22b7c8cf03f7$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $078f2454358d723a$export$2e2bcd8739ae039)(_this, api, $34de22b7c8cf03f7$var$dataProcessorFuncs, $34de22b7c8cf03f7$var$visualFuncs);
        _this._messageCenter = new $34de22b7c8cf03f7$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $34de22b7c8cf03f7$var$bindRenderedEvent(zr, _this);
        $34de22b7c8cf03f7$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $e4c0c902d0f4f283$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        var scheduler = this._scheduler;
        var ecModel = this._model;
        var api = this._api;
        $34de22b7c8cf03f7$var$applyChangedStates(this);
        // Lazy update
        if (this[$34de22b7c8cf03f7$var$PENDING_UPDATE]) {
            var silent = this[$34de22b7c8cf03f7$var$PENDING_UPDATE].silent;
            this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = true;
            $34de22b7c8cf03f7$var$updateECUpdateCycleVersion(this);
            try {
                $34de22b7c8cf03f7$var$prepare(this);
                $34de22b7c8cf03f7$var$updateMethods.update.call(this, null, this[$34de22b7c8cf03f7$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
                this[$34de22b7c8cf03f7$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
            this[$34de22b7c8cf03f7$var$PENDING_UPDATE] = null;
            $34de22b7c8cf03f7$var$flushPendingActions.call(this, silent);
            $34de22b7c8cf03f7$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $34de22b7c8cf03f7$var$TEST_FRAME_REMAIN_TIME;
            // PENDING: guard the following by `this[IN_EC_CYCLE_KEY] = true`?
            do {
                // Reset to false per iteration. Otherwise the last zr.flush
                // can not be triggered and 'finish' event can not be triggered.
                scheduler.unfinished = false;
                var startTime = (0, $fd1433555986e896$export$ef5e599365494451).getTime();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $34de22b7c8cf03f7$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $34de22b7c8cf03f7$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= (0, $fd1433555986e896$export$ef5e599365494451).getTime() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = true;
        $34de22b7c8cf03f7$var$updateECUpdateCycleVersion(this);
        if (!this._model || notMerge) {
            var optionManager = new (0, $ed9a7f817daff166$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $74c729a11d908314$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $34de22b7c8cf03f7$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$34de22b7c8cf03f7$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $34de22b7c8cf03f7$var$prepare(this);
                $34de22b7c8cf03f7$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$34de22b7c8cf03f7$var$PENDING_UPDATE] = null;
                this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$34de22b7c8cf03f7$var$PENDING_UPDATE] = null;
            this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
            $34de22b7c8cf03f7$var$flushPendingActions.call(this, silent);
            $34de22b7c8cf03f7$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * Update theme with name or theme option and repaint the chart.
   * @param theme Theme name or theme option.
   * @param opts Optional settings
   */ ECharts.prototype.setTheme = function(theme, opts) {
        if (this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        if (!ecModel) return;
        var silent = opts && opts.silent;
        var updateParams = null;
        if (this[$34de22b7c8cf03f7$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$34de22b7c8cf03f7$var$PENDING_UPDATE].silent;
            updateParams = this[$34de22b7c8cf03f7$var$PENDING_UPDATE].updateParams;
            this[$34de22b7c8cf03f7$var$PENDING_UPDATE] = null;
        }
        this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = true;
        $34de22b7c8cf03f7$var$updateECUpdateCycleVersion(this);
        try {
            this._updateTheme(theme);
            ecModel.setTheme(this._theme);
            $34de22b7c8cf03f7$var$prepare(this);
            $34de22b7c8cf03f7$var$updateMethods.update.call(this, {
                type: 'setTheme'
            }, updateParams);
        } catch (e) {
            this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
            throw e;
        }
        this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
        $34de22b7c8cf03f7$var$flushPendingActions.call(this, silent);
        $34de22b7c8cf03f7$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype._updateTheme = function(theme) {
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(theme)) theme = $34de22b7c8cf03f7$var$themeStorage[theme];
        if (theme) {
            theme = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(theme);
            theme && (0, $e1495634306e9aeb$export$2e2bcd8739ae039)(theme, true);
            this._theme = theme;
        }
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $d461075057ee3466$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($34de22b7c8cf03f7$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($34de22b7c8cf03f7$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $fd1433555986e896$export$ef5e599365494451).createCanvas();
            var zr_1 = $aae635f77c3c70af$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $439653c37a0e6e60$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $b5bca30d4a081571$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value, opt) {
        return $34de22b7c8cf03f7$var$doConvertPixel(this, 'convertToPixel', finder, value, opt);
    };
    /**
   * Convert from logical coordinate system to pixel coordinate system.
   * See CoordinateSystem#convertToPixel.
   *
   * @see CoordinateSystem['dataToLayout'] for parameters and return.
   * @see CoordinateSystemDataCoord
   */ ECharts.prototype.convertToLayout = function(finder, value, opt) {
        return $34de22b7c8cf03f7$var$doConvertPixel(this, 'convertToLayout', finder, value, opt);
    };
    // The above are signatures from before v6, thus they should be preserved for backward compat.
    ECharts.prototype.convertFromPixel = function(finder, value, opt) {
        return $34de22b7c8cf03f7$var$doConvertPixel(this, 'convertFromPixel', finder, value, opt);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $939d3a4c11ee87fd$export$95de80076abac814(ecModel, finder);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $939d3a4c11ee87fd$export$95de80076abac814(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $8e9640738fc92e9b$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $8e9640738fc92e9b$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($34de22b7c8cf03f7$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout';
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $c9d8ac168c7942c2$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        var messageCenter = this._messageCenter;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($34de22b7c8cf03f7$var$publicEventTypeMap, function(_, eventType) {
            messageCenter.on(eventType, function(event) {
                _this.trigger(eventType, event);
            });
        });
        (0, $37b950dbb69299a0$export$2575c83262e49d0c)(messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $939d3a4c11ee87fd$export$9fec4d97f1922e0b(this.getDom(), $34de22b7c8cf03f7$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $34de22b7c8cf03f7$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY]) return;
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$34de22b7c8cf03f7$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$34de22b7c8cf03f7$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$34de22b7c8cf03f7$var$PENDING_UPDATE] = null;
        }
        this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = true;
        $34de22b7c8cf03f7$var$updateECUpdateCycleVersion(this);
        try {
            needPrepare && $34de22b7c8cf03f7$var$prepare(this);
            $34de22b7c8cf03f7$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
            throw e;
        }
        this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
        $34de22b7c8cf03f7$var$flushPendingActions.call(this, silent);
        $34de22b7c8cf03f7$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$34de22b7c8cf03f7$var$loadingEffects[name]) return;
        var el = $34de22b7c8cf03f7$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, eventObj);
        payload.type = $34de22b7c8cf03f7$var$connectionEventRevertMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$34de22b7c8cf03f7$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $34de22b7c8cf03f7$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $d461075057ee3466$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $34de22b7c8cf03f7$var$flushPendingActions.call(this, silent);
        $34de22b7c8cf03f7$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $34de22b7c8cf03f7$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // NOTICE:
        // `appendData` does not support to update axis scale extent of coordinate
        // systems. In the expected usage of `appendData`, the initial extent of
        // coordinate system should be explicitly specified (by `xxxAxis.data` for
        // 'category' axis or by `xxxAxis.min/max` for other axes). Otherwise, if
        // the extent keep changing while `appendData`, the location of the painted
        // graphic elements have to be changed frequently.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $34de22b7c8cf03f7$var$prepare = function(ecIns) {
            (0, $6e6e84884711664e$export$54b70eb74482271e)(ecIns._model);
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._zr, ecIns._model);
            scheduler.prepareStageTasks();
            $34de22b7c8cf03f7$var$prepareView(ecIns, true);
            $34de22b7c8cf03f7$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $34de22b7c8cf03f7$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $01f767c32eb84395$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $2c3bdaabdaf03627$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $34de22b7c8cf03f7$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast (e.g., for ':updateAxisPointer')
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var condition = $939d3a4c11ee87fd$export$c064a542e5272c93(payload, mainType, subType);
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($939d3a4c11ee87fd$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $939d3a4c11ee87fd$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $6243d8dbb37d6b0d$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $be83ac5e1b26ee48$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $6243d8dbb37d6b0d$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            'emphasis',
                            'disabled'
                        ])) (0, $6243d8dbb37d6b0d$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $6243d8dbb37d6b0d$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $6243d8dbb37d6b0d$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $6243d8dbb37d6b0d$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $6243d8dbb37d6b0d$export$df035d873a9de64f) ? (0, $6243d8dbb37d6b0d$export$b2d02638cc34c042)(dispatcher) : (0, $6243d8dbb37d6b0d$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $6243d8dbb37d6b0d$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $be83ac5e1b26ee48$export$2e2bcd8739ae039)) {
                        (0, $6243d8dbb37d6b0d$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $6243d8dbb37d6b0d$export$e4ea08ef52e0a73)(model);
                        $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $34de22b7c8cf03f7$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $34de22b7c8cf03f7$var$prepare(this);
                $34de22b7c8cf03f7$var$updateMethods.update.call(this, payload, payload && {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                (0, $6e6e84884711664e$export$7a0372e5df3ca6f4)(ecModel);
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('coordsys:aftercreate', ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $34de22b7c8cf03f7$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                // Set background and dark mode before rendering, because they affect auto-color-determination
                // in zrender Text, and consequently affect the bounding rect if stroke is added.
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                var darkMode = ecModel.get('darkMode');
                if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                $34de22b7c8cf03f7$var$render(this, ecModel, api, payload, updateParams);
                (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            /**
       * PENDING: See INCONSISTENCY_OF_BRUSH_SELECTED_EVENT_IN_UPDATE_TRANSFORM
       */ updateTransform: function(payload) {
                var ecIns = this;
                var ecModel = ecIns._model;
                var api = ecIns._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(mainType, componentModel) {
                    if (mainType === (0, $0f5447108b4a27a4$export$68ebcbce21494007)) return;
                    var componentView = ecIns.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    var pipelineContext = seriesModel.pipelineContext;
                    if (chartView.updateTransform && !pipelineContext.progressiveRender) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                // Palette should not be cleared, otherwise the variation of dirty series
                // can cause color change unexpectedly.
                // clearColorPalette(ecModel);
                // NOTICE: series data tasks must NOT be dirty, otherwise series data will be recreated.
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                ecIns._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $34de22b7c8cf03f7$var$renderSeries(ecIns, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $2c3bdaabdaf03627$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateView');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $34de22b7c8cf03f7$var$render(this, ecModel, this._api, payload, {});
                (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function(payload) {
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $2c3bdaabdaf03627$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateVisual');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                // FIXME: `visualType` may be removed, since it conflicts with `priority` of task. `updateVisual`
                // can be altered to start the pipeline with a certain priority, rather than only execute tasks
                // with `visualType: 'visual'`, otherwise, PRIORITY_VISUAL_POST_CHART_LAYOUT is omitted in this
                // case. Currently, only "brush" uses `updateVisual`, and it works by coincidence.
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            /**
       * @deprecated
       */ updateLayout: function(payload) {
                $34de22b7c8cf03f7$var$updateMethods.update.call(this, payload);
            }
        };
        function doConvertPixelImpl(ecIns, methodName, finder, value, opt) {
            if (ecIns._disposed) {
                $34de22b7c8cf03f7$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $939d3a4c11ee87fd$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value, opt)) != null) return result;
            }
        }
        $34de22b7c8cf03f7$var$doConvertPixel = doConvertPixelImpl;
        $34de22b7c8cf03f7$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $34de22b7c8cf03f7$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionInfo = $34de22b7c8cf03f7$var$actions[payloadType];
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $01f767c32eb84395$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = true;
            $34de22b7c8cf03f7$var$updateECUpdateCycleVersion(this);
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)((0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var actionResultBatch = [];
            var nonRefinedEventType = actionInfo.nonRefinedEventType;
            var isSelectChange = (0, $6243d8dbb37d6b0d$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $6243d8dbb37d6b0d$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $6243d8dbb37d6b0d$export$b2a593c7b5243584)(this._api);
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                var actionResult = actionInfo.action(batchItem, ecModel, _this._api);
                if (actionInfo.refineEvent) actionResultBatch.push(actionResult);
                else eventObj = actionResult;
                eventObj = eventObj || (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, batchItem);
                eventObj.type = nonRefinedEventType;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $939d3a4c11ee87fd$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $34de22b7c8cf03f7$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $34de22b7c8cf03f7$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $34de22b7c8cf03f7$var$markStatusToUpdate(_this);
                } else if (cptType) $34de22b7c8cf03f7$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$34de22b7c8cf03f7$var$PENDING_UPDATE]) {
                    $34de22b7c8cf03f7$var$prepare(this);
                    $34de22b7c8cf03f7$var$updateMethods.update.call(this, payload);
                    this[$34de22b7c8cf03f7$var$PENDING_UPDATE] = null;
                } else $34de22b7c8cf03f7$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: nonRefinedEventType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$34de22b7c8cf03f7$var$IN_EC_CYCLE_KEY] = false;
            if (!silent) {
                var refinedEvent = void 0;
                if (actionInfo.refineEvent) {
                    var eventContent = actionInfo.refineEvent(actionResultBatch, payload, ecModel, this._api).eventContent;
                    (0, $e4c0c902d0f4f283$export$a7a9523472993e97)((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(eventContent));
                    refinedEvent = (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
                        type: actionInfo.refinedEventType
                    }, eventContent);
                    refinedEvent.fromAction = payload.type;
                    refinedEvent.fromActionPayload = payload;
                    refinedEvent.escapeConnect = true;
                }
                var messageCenter = this._messageCenter;
                // - If `refineEvent` created a `refinedEvent`, `eventObj` (replicated from the original payload)
                //  is still needed to be triggered for the feature `connect`. But it will not be triggered to
                //  users in this case.
                // - If no `refineEvent` used, `eventObj` will be triggered for both `connect` and users.
                messageCenter.trigger(eventObj.type, eventObj);
                if (refinedEvent) messageCenter.trigger(refinedEvent.type, refinedEvent);
            }
        };
        $34de22b7c8cf03f7$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $34de22b7c8cf03f7$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $34de22b7c8cf03f7$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $34de22b7c8cf03f7$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dispatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$34de22b7c8cf03f7$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
                else // Make sure this method can be entered again in next frames.
                zr.refresh();
            });
        };
        $34de22b7c8cf03f7$var$bindMouseEvent = function(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $c9d8ac168c7942c2$export$8a4fca9e04eb4df6)(el, (0, $6243d8dbb37d6b0d$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $6243d8dbb37d6b0d$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $c9d8ac168c7942c2$export$8a4fca9e04eb4df6)(el, (0, $6243d8dbb37d6b0d$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $6243d8dbb37d6b0d$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $c9d8ac168c7942c2$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get('zlevel') || 0;
                var z = componentModel.get('z') || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === 'series' ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $9e91dd6172c91368$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = '';
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $34de22b7c8cf03f7$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $34de22b7c8cf03f7$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $34de22b7c8cf03f7$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $34de22b7c8cf03f7$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $34de22b7c8cf03f7$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent');
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $6243d8dbb37d6b0d$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('series:layoutlabels', ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $34de22b7c8cf03f7$var$markStatusToUpdate = function(ecIns) {
            ecIns[$34de22b7c8cf03f7$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $34de22b7c8cf03f7$var$updateECUpdateCycleVersion = function(ecIns) {
            ecIns[$34de22b7c8cf03f7$var$EC_UPDATE_CYCLE_VERSION_KEY] = (ecIns[$34de22b7c8cf03f7$var$EC_UPDATE_CYCLE_VERSION_KEY] + 1) % 1e6;
        };
        $34de22b7c8cf03f7$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$34de22b7c8cf03f7$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($97d0e733871fae49$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$34de22b7c8cf03f7$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $6243d8dbb37d6b0d$export$f0f2bee145debb31) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $6243d8dbb37d6b0d$export$1307d6a87d56baa) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            if (zr.painter.type !== 'canvas') return;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            var shouldUseHoverLayer = elCount > (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(ecModel.get('hoverLayerThreshold'), (0, $428b03089c527ed2$export$2e2bcd8739ae039).hoverLayerThreshold) && !(0, $d461075057ee3466$export$2e2bcd8739ae039).node && !(0, $d461075057ee3466$export$2e2bcd8739ae039).worker;
            if (ecIns._usingTHL || shouldUseHoverLayer) {
                ecModel.eachSeries(function(seriesModel) {
                    if (seriesModel.preventUsingHoverLayer) return;
                    var chartView = ecIns._chartsMap[seriesModel.__viewId];
                    if (chartView.__alive) chartView.eachRendered(function(el) {
                        // NOTICE: Do not call any method that can set REDRAW_BIT,
                        // otherwise progressive rendering is broken.
                        var emphasis = el.states.emphasis;
                        if (emphasis && emphasis.hoverLayer !== $05f852c7feb2d530$export$2ed770cec6ef78e8) emphasis.hoverLayer = shouldUseHoverLayer ? $05f852c7feb2d530$export$3c339ce201e4ce4d : $05f852c7feb2d530$export$3e67317617241636;
                    });
                });
                ecIns._usingTHL = shouldUseHoverLayer;
            }
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.eachRendered(function(el) {
                // NOTICE: Do not call any method that can set REDRAW_BIT,
                // otherwise progressive rendering is broken.
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var zInfo = $05f852c7feb2d530$export$1500a631bea5adda(model);
            // Set z and zlevel
            view.eachRendered(function(el) {
                $05f852c7feb2d530$export$d31cf465bf5e8879(el, zInfo.z, zInfo.zlevel);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($97d0e733871fae49$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing')
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($97d0e733871fae49$export$5b89d4b643713034(el)) return;
                    if (el instanceof $27b47789cc8143e1$export$2e2bcd8739ae039) (0, $6243d8dbb37d6b0d$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $34de22b7c8cf03f7$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $6243d8dbb37d6b0d$export$b2d02638cc34c042)(el, highlightDigit);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $6243d8dbb37d6b0d$export$11be6f716239ac55)(el, highlightDigit);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $6243d8dbb37d6b0d$export$207f9cb3e1099375)(el);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $6243d8dbb37d6b0d$export$fd4a9ec75456d3c1)(el);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $6243d8dbb37d6b0d$export$252d028dda8ef765)(el);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $6243d8dbb37d6b0d$export$ea9a904bd6e32bd3)(el);
                    $34de22b7c8cf03f7$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                class_1.prototype.getECUpdateCycleVersion = function() {
                    return ecIns[$34de22b7c8cf03f7$var$EC_UPDATE_CYCLE_VERSION_KEY];
                };
                class_1.prototype.usingTHL = function() {
                    return ecIns._usingTHL;
                };
                return class_1;
            }((0, $fa04f8f648e70374$export$2e2bcd8739ae039)))(ecIns);
        };
        $34de22b7c8cf03f7$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$34de22b7c8cf03f7$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($34de22b7c8cf03f7$var$connectionEventRevertMap, function(_, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($34de22b7c8cf03f7$var$connectedGroups[chart.group] && chart[$34de22b7c8cf03f7$var$CONNECT_STATUS_KEY] !== $34de22b7c8cf03f7$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($34de22b7c8cf03f7$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $34de22b7c8cf03f7$var$CONNECT_STATUS_PENDING);
                        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$34de22b7c8cf03f7$var$CONNECT_STATUS_KEY] !== $34de22b7c8cf03f7$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $34de22b7c8cf03f7$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $770990963ee378bd$export$2e2bcd8739ae039));
var $34de22b7c8cf03f7$var$echartsProto = $34de22b7c8cf03f7$var$ECharts.prototype;
$34de22b7c8cf03f7$var$echartsProto.on = $34de22b7c8cf03f7$var$createRegisterEventWithLowercaseECharts('on');
$34de22b7c8cf03f7$var$echartsProto.off = $34de22b7c8cf03f7$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$34de22b7c8cf03f7$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $e5cdafd3d57b0dbf$export$4a9c0b74eb885aa1)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $34de22b7c8cf03f7$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $34de22b7c8cf03f7$var$disposedWarning(id) {}
var $34de22b7c8cf03f7$var$actions = {};
/**
 * Map event type to action type for reproducing action from event for `connect`.
 */ var $34de22b7c8cf03f7$var$connectionEventRevertMap = {};
/**
 * To remove duplication.
 */ var $34de22b7c8cf03f7$var$publicEventTypeMap = {};
var $34de22b7c8cf03f7$var$dataProcessorFuncs = [];
var $34de22b7c8cf03f7$var$optionPreprocessorFuncs = [];
var $34de22b7c8cf03f7$var$visualFuncs = [];
var $34de22b7c8cf03f7$var$themeStorage = {};
var $34de22b7c8cf03f7$var$loadingEffects = {};
var $34de22b7c8cf03f7$var$instances = {};
var $34de22b7c8cf03f7$var$connectedGroups = {};
var $34de22b7c8cf03f7$var$idBase = +new Date() - 0;
var $34de22b7c8cf03f7$var$groupIdBase = +new Date() - 0;
var $34de22b7c8cf03f7$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $34de22b7c8cf03f7$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $34de22b7c8cf03f7$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $34de22b7c8cf03f7$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $34de22b7c8cf03f7$var$idBase++;
    $34de22b7c8cf03f7$var$instances[chart.id] = chart;
    isClient && $939d3a4c11ee87fd$export$9fec4d97f1922e0b(dom, $34de22b7c8cf03f7$var$DOM_ATTRIBUTE_KEY, chart.id);
    $34de22b7c8cf03f7$var$enableConnect(chart);
    (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).trigger('afterinit', chart);
    return chart;
}
function $34de22b7c8cf03f7$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $34de22b7c8cf03f7$var$groupIdBase++;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $34de22b7c8cf03f7$var$connectedGroups[groupId] = true;
    return groupId;
}
function $34de22b7c8cf03f7$export$37dfea93db2e14ed(groupId) {
    $34de22b7c8cf03f7$var$connectedGroups[groupId] = false;
}
var $34de22b7c8cf03f7$export$87cd6834112ecb52 = $34de22b7c8cf03f7$export$37dfea93db2e14ed;
function $34de22b7c8cf03f7$export$fcfbbcec2cb820d5(chart) {
    if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(chart)) chart = $34de22b7c8cf03f7$var$instances[chart];
    else if (!(chart instanceof $34de22b7c8cf03f7$var$ECharts)) // Try to treat as dom
    chart = $34de22b7c8cf03f7$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $34de22b7c8cf03f7$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $34de22b7c8cf03f7$export$33b6fbccd4f643f8(dom) {
    return $34de22b7c8cf03f7$var$instances[$939d3a4c11ee87fd$export$735ee1799fd02602(dom, $34de22b7c8cf03f7$var$DOM_ATTRIBUTE_KEY)];
}
function $34de22b7c8cf03f7$export$89b4be35062c4a3f(key) {
    return $34de22b7c8cf03f7$var$instances[key];
}
function $34de22b7c8cf03f7$export$f9c59eed5de5ff80(name, theme) {
    $34de22b7c8cf03f7$var$themeStorage[name] = theme;
}
function $34de22b7c8cf03f7$export$77095792a057b768(preprocessorFunc) {
    if ((0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)($34de22b7c8cf03f7$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $34de22b7c8cf03f7$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $34de22b7c8cf03f7$export$d575e6557ac1729f(priority, processor) {
    $34de22b7c8cf03f7$var$normalizeRegister($34de22b7c8cf03f7$var$dataProcessorFuncs, priority, processor, $34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $34de22b7c8cf03f7$export$c8c249911ee8c1ed(postInitFunc) {
    $34de22b7c8cf03f7$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $34de22b7c8cf03f7$export$99560909c18c76bb(postUpdateFunc) {
    $34de22b7c8cf03f7$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $34de22b7c8cf03f7$export$c9ec4b5faef04865(name, cb) {
    (0, $48bee0c8f46ee18d$export$2e2bcd8739ae039).on(name, cb);
}
function $34de22b7c8cf03f7$export$408c24786cd729c6(arg0, arg1, action) {
    var actionType;
    var publicEventType;
    var refineEvent;
    var update;
    var publishNonRefinedEvent;
    if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(arg1)) {
        action = arg1;
        arg1 = '';
    }
    if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(arg0)) {
        actionType = arg0.type;
        publicEventType = arg0.event;
        update = arg0.update;
        publishNonRefinedEvent = arg0.publishNonRefinedEvent;
        if (!action) action = arg0.action;
        refineEvent = arg0.refineEvent;
    } else {
        actionType = arg0;
        publicEventType = arg1;
    }
    function createEventType(actionOrEventType) {
        // Event type should be all lowercase
        return actionOrEventType.toLowerCase();
    }
    publicEventType = createEventType(publicEventType || actionType);
    // See comments on {ActionInfo} for the reason.
    var nonRefinedEventType = refineEvent ? createEventType(actionType) : publicEventType;
    // Support calling `registerAction` multiple times with the same action
    // type; subsequent calls have no effect.
    if ($34de22b7c8cf03f7$var$actions[actionType]) return;
    // Validate action type and event name.
    (0, $e4c0c902d0f4f283$export$a7a9523472993e97)($34de22b7c8cf03f7$var$ACTION_REG.test(actionType) && $34de22b7c8cf03f7$var$ACTION_REG.test(publicEventType));
    if (refineEvent) // An event replicated from the action will be triggered internally for `connect` in this case.
    (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(publicEventType !== actionType);
    $34de22b7c8cf03f7$var$actions[actionType] = {
        actionType: actionType,
        refinedEventType: publicEventType,
        nonRefinedEventType: nonRefinedEventType,
        update: update,
        action: action,
        refineEvent: refineEvent
    };
    $34de22b7c8cf03f7$var$publicEventTypeMap[publicEventType] = 1;
    if (refineEvent && publishNonRefinedEvent) $34de22b7c8cf03f7$var$publicEventTypeMap[nonRefinedEventType] = 1;
    $34de22b7c8cf03f7$var$connectionEventRevertMap[nonRefinedEventType] = actionType;
}
function $34de22b7c8cf03f7$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $65108a454a48746f$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $34de22b7c8cf03f7$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $65108a454a48746f$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $34de22b7c8cf03f7$export$c3e61191887968da(seriesType, renderItem) {
    (0, $371689911d44ce92$export$c3e61191887968da)(seriesType, renderItem);
}
function $34de22b7c8cf03f7$export$d768f97700ca6bea(priority, layoutTask) {
    $34de22b7c8cf03f7$var$normalizeRegister($34de22b7c8cf03f7$var$visualFuncs, priority, layoutTask, $34de22b7c8cf03f7$var$PRIORITY_VISUAL_LAYOUT, 'layout', true);
}
function $34de22b7c8cf03f7$export$5f32c1eb94c381bb(priority, visualTask) {
    $34de22b7c8cf03f7$var$normalizeRegister($34de22b7c8cf03f7$var$visualFuncs, priority, visualTask, $34de22b7c8cf03f7$var$PRIORITY_VISUAL_CHART, 'visual', true);
}
var $34de22b7c8cf03f7$var$registeredTasks = [];
function $34de22b7c8cf03f7$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType, checkBlock) {
    if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(priority) || (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)($34de22b7c8cf03f7$var$registeredTasks, fn) >= 0) return;
    $34de22b7c8cf03f7$var$registeredTasks.push(fn);
    var stageHandler = (0, $078f2454358d723a$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $34de22b7c8cf03f7$export$e06b68a82007c015(name, loadingFx) {
    $34de22b7c8cf03f7$var$loadingEffects[name] = loadingFx;
}
function $34de22b7c8cf03f7$export$10425ea7a243b114(creator) {
    (0, $fd1433555986e896$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $34de22b7c8cf03f7$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $7d34afedff90144f$export$73333eb8a09d5f61)('registerMap');
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $34de22b7c8cf03f7$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $7d34afedff90144f$export$73333eb8a09d5f61)('getMap');
    return getMap && getMap(mapName);
}
var $34de22b7c8cf03f7$export$f01d71dd0389d7e4 = (0, $130e4ec8184881d3$export$92c96c6d8b255b7d);
/**
 * Global dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$34de22b7c8cf03f7$export$5f32c1eb94c381bb($34de22b7c8cf03f7$var$PRIORITY_VISUAL_GLOBAL, (0, $acfb34f329927a44$export$7ce4d65f9b69240));
$34de22b7c8cf03f7$export$5f32c1eb94c381bb($34de22b7c8cf03f7$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $acfb34f329927a44$export$f7dcb66a065003d1));
$34de22b7c8cf03f7$export$5f32c1eb94c381bb($34de22b7c8cf03f7$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $acfb34f329927a44$export$cf9758b0d6dc0aa9));
$34de22b7c8cf03f7$export$5f32c1eb94c381bb($34de22b7c8cf03f7$var$PRIORITY_VISUAL_GLOBAL, (0, $2f1892f181bfdf72$export$144ac3beded415d9));
$34de22b7c8cf03f7$export$5f32c1eb94c381bb($34de22b7c8cf03f7$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $2f1892f181bfdf72$export$435b956f7f1071fb));
$34de22b7c8cf03f7$export$5f32c1eb94c381bb($34de22b7c8cf03f7$var$PRIORITY_VISUAL_DECAL, (0, $17a04d2ccc4434e3$export$218eea02a2a96fb4));
$34de22b7c8cf03f7$export$77095792a057b768((0, $e1495634306e9aeb$export$2e2bcd8739ae039));
$34de22b7c8cf03f7$export$d575e6557ac1729f($34de22b7c8cf03f7$var$PRIORITY_PROCESSOR_DATASTACK, (0, $2d3c837239acfcdb$export$dc018729d9e78c17));
$34de22b7c8cf03f7$export$e06b68a82007c015('default', (0, $173a947350700d3d$export$2e2bcd8739ae039));
// Default actions
$34de22b7c8cf03f7$export$408c24786cd729c6({
    type: (0, $6243d8dbb37d6b0d$export$df035d873a9de64f),
    event: (0, $6243d8dbb37d6b0d$export$df035d873a9de64f),
    update: (0, $6243d8dbb37d6b0d$export$df035d873a9de64f)
}, (0, $e4c0c902d0f4f283$export$8793edee2d425525));
$34de22b7c8cf03f7$export$408c24786cd729c6({
    type: (0, $6243d8dbb37d6b0d$export$f8a2f7807cc185ea),
    event: (0, $6243d8dbb37d6b0d$export$f8a2f7807cc185ea),
    update: (0, $6243d8dbb37d6b0d$export$f8a2f7807cc185ea)
}, (0, $e4c0c902d0f4f283$export$8793edee2d425525));
$34de22b7c8cf03f7$export$408c24786cd729c6({
    type: (0, $6243d8dbb37d6b0d$export$89616263e7d38fe9),
    event: (0, $6243d8dbb37d6b0d$export$67f8c62bcdfbd39f),
    update: (0, $6243d8dbb37d6b0d$export$89616263e7d38fe9),
    action: (0, $e4c0c902d0f4f283$export$8793edee2d425525),
    refineEvent: $34de22b7c8cf03f7$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$34de22b7c8cf03f7$export$408c24786cd729c6({
    type: (0, $6243d8dbb37d6b0d$export$7636ad95c0f68a79),
    event: (0, $6243d8dbb37d6b0d$export$67f8c62bcdfbd39f),
    update: (0, $6243d8dbb37d6b0d$export$7636ad95c0f68a79),
    action: (0, $e4c0c902d0f4f283$export$8793edee2d425525),
    refineEvent: $34de22b7c8cf03f7$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
$34de22b7c8cf03f7$export$408c24786cd729c6({
    type: (0, $6243d8dbb37d6b0d$export$1e90ed8a25542516),
    event: (0, $6243d8dbb37d6b0d$export$67f8c62bcdfbd39f),
    update: (0, $6243d8dbb37d6b0d$export$1e90ed8a25542516),
    action: (0, $e4c0c902d0f4f283$export$8793edee2d425525),
    refineEvent: $34de22b7c8cf03f7$var$makeSelectChangedEvent,
    publishNonRefinedEvent: true
});
function $34de22b7c8cf03f7$var$makeSelectChangedEvent(actionResultBatch, payload, ecModel, api) {
    return {
        eventContent: {
            selected: (0, $6243d8dbb37d6b0d$export$c529643b619af6b3)(ecModel),
            isFromClick: payload.isFromClick || false
        }
    };
}
// Default theme, so that we can use `chart.setTheme('default')` to revert to
// the default theme after changing to other themes.
$34de22b7c8cf03f7$export$f9c59eed5de5ff80('default', {});
$34de22b7c8cf03f7$export$f9c59eed5de5ff80('dark', (0, $138e752359922fa8$export$2e2bcd8739ae039));
var $34de22b7c8cf03f7$export$73cae5e090579589 = {};










var $fc909a89248875c1$var$extensions = [];
var $fc909a89248875c1$var$extensionRegisters = {
    registerPreprocessor: (0, $34de22b7c8cf03f7$export$77095792a057b768),
    registerProcessor: (0, $34de22b7c8cf03f7$export$d575e6557ac1729f),
    registerPostInit: (0, $34de22b7c8cf03f7$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $34de22b7c8cf03f7$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $34de22b7c8cf03f7$export$c9ec4b5faef04865),
    registerAction: (0, $34de22b7c8cf03f7$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $34de22b7c8cf03f7$export$1dd5e025a8a37dd),
    registerLayout: (0, $34de22b7c8cf03f7$export$d768f97700ca6bea),
    registerVisual: (0, $34de22b7c8cf03f7$export$5f32c1eb94c381bb),
    registerTransform: (0, $34de22b7c8cf03f7$export$f01d71dd0389d7e4),
    registerLoading: (0, $34de22b7c8cf03f7$export$e06b68a82007c015),
    registerMap: (0, $34de22b7c8cf03f7$export$d456de060be2dba1),
    registerImpl: (0, $7d34afedff90144f$export$9b808fd12256ddd3),
    PRIORITY: (0, $34de22b7c8cf03f7$export$bb34f3538ba26c7e),
    ComponentModel: (0, $879a47e830ab7f41$export$2e2bcd8739ae039),
    ComponentView: (0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039),
    SeriesModel: (0, $be83ac5e1b26ee48$export$2e2bcd8739ae039),
    ChartView: (0, $2c3bdaabdaf03627$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $879a47e830ab7f41$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $be83ac5e1b26ee48$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $2c3bdaabdaf03627$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerCustomSeries: function(seriesType, renderItem) {
        (0, $371689911d44ce92$export$c3e61191887968da)(seriesType, renderItem);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $879a47e830ab7f41$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $aae635f77c3c70af$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $fc909a89248875c1$export$1f96ae73734a86cc(ext) {
    if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(ext, function(singleExt) {
            $fc909a89248875c1$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)($fc909a89248875c1$var$extensions, ext) >= 0) return;
    $fc909a89248875c1$var$extensions.push(ext);
    if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($fc909a89248875c1$var$extensionRegisters);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $704a4c2ca701710b$var$mathSin = Math.sin;
var $704a4c2ca701710b$var$mathCos = Math.cos;
var $704a4c2ca701710b$var$PI = Math.PI;
var $704a4c2ca701710b$var$PI2 = Math.PI * 2;
var $704a4c2ca701710b$var$degree = 180 / $704a4c2ca701710b$var$PI;
var $704a4c2ca701710b$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = '';
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $3128be478e7c4137$export$4701367f5b4de464)(dThetaPositive - $704a4c2ca701710b$var$PI2) || (clockwise ? dTheta >= $704a4c2ca701710b$var$PI2 : -dTheta >= $704a4c2ca701710b$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $704a4c2ca701710b$var$PI2 : dTheta % $704a4c2ca701710b$var$PI2 + $704a4c2ca701710b$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $3128be478e7c4137$export$4701367f5b4de464)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $704a4c2ca701710b$var$PI === !!clockwise;
        var x0 = cx + rx * $704a4c2ca701710b$var$mathCos(startAngle);
        var y0 = cy + ry * $704a4c2ca701710b$var$mathSin(startAngle);
        if (this._start) this._add('M', x0, y0);
        var xRot = Math.round(psi * $704a4c2ca701710b$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($704a4c2ca701710b$var$PI2 - p);
            this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * $704a4c2ca701710b$var$mathCos(startAngle + dTheta_1), cy + ry * $704a4c2ca701710b$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $704a4c2ca701710b$var$mathCos(endAngle);
            var y = cy + ry * $704a4c2ca701710b$var$mathSin(endAngle);
            this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add('M', x, y);
        this._add('l', w, 0);
        this._add('l', 0, h);
        this._add('l', -w, 0);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add('Z');
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(' '));
        this._start = cmd === 'Z';
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? '' : this._d.join('');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $704a4c2ca701710b$export$2e2bcd8739ae039 = $704a4c2ca701710b$var$SVGPathRebuilder;







var $3c62684f032f59ad$var$NONE = 'none';
var $3c62684f032f59ad$var$mathRound = Math.round;
function $3c62684f032f59ad$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $3c62684f032f59ad$var$NONE;
}
function $3c62684f032f59ad$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $3c62684f032f59ad$var$NONE;
}
var $3c62684f032f59ad$var$strokeProps = [
    'lineCap',
    'miterLimit',
    'lineJoin'
];
var $3c62684f032f59ad$var$svgStrokeProps = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)($3c62684f032f59ad$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $3c62684f032f59ad$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $b5bca30d4a081571$export$2e2bcd8739ae039)) {
        updateAttr('opacity', opacity);
        return;
    }
    if ($3c62684f032f59ad$var$pathHasFill(style)) {
        var fill = (0, $3128be478e7c4137$export$4cde5df63f53f473)(style.fill);
        updateAttr('fill', fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr('fill-opacity', fillOpacity);
    } else updateAttr('fill', $3c62684f032f59ad$var$NONE);
    if ($3c62684f032f59ad$var$pathHasStroke(style)) {
        var stroke = (0, $3128be478e7c4137$export$4cde5df63f53f473)(style.stroke);
        updateAttr('stroke', stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr('stroke-width', strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
        if (forceUpdate || strokeOpacity < 1) updateAttr('stroke-opacity', strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $33078477762969e9$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $3c62684f032f59ad$var$mathRound(lineDashOffset || 0);
                updateAttr('stroke-dasharray', lineDash.join(','));
                if (lineDashOffset || forceUpdate) updateAttr('stroke-dashoffset', lineDashOffset);
            }
        } else if (forceUpdate) updateAttr('stroke-dasharray', $3c62684f032f59ad$var$NONE);
        for(var i = 0; i < $3c62684f032f59ad$var$strokeProps.length; i++){
            var propName = $3c62684f032f59ad$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $27b47789cc8143e1$export$deade517576e293a)[propName]) {
                var val = style[propName] || (0, $27b47789cc8143e1$export$deade517576e293a)[propName];
                val && updateAttr($3c62684f032f59ad$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr('stroke', $3c62684f032f59ad$var$NONE);
}




var $dd8123400aca4a3f$export$a690ad4c9a38f86e = 'http://www.w3.org/2000/svg';
var $dd8123400aca4a3f$export$b22c6da1792ecec8 = 'http://www.w3.org/1999/xlink';
var $dd8123400aca4a3f$export$fac09d762d15fa3b = 'http://www.w3.org/2000/xmlns/';
var $dd8123400aca4a3f$export$ad4c4fdecd3b4156 = 'http://www.w3.org/XML/1998/namespace';
var $dd8123400aca4a3f$export$d3f79611f155197c = 'ecmeta_';
function $dd8123400aca4a3f$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($dd8123400aca4a3f$export$a690ad4c9a38f86e, name);
}
function $dd8123400aca4a3f$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $dd8123400aca4a3f$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += "=\"" + val + "\"";
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(' ') + ">";
}
function $dd8123400aca4a3f$var$createElementClose(name) {
    return "</" + name + ">";
}
function $dd8123400aca4a3f$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $dd8123400aca4a3f$var$createElementOpen(tag, attrs) + (tag !== 'style' ? (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(text) : text || '') + (children ? "" + S + (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : '') + $dd8123400aca4a3f$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $dd8123400aca4a3f$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)((0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)((0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)((0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)((0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)((0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === 'd') val = "path(\"" + val + "\")";
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return '';
    return [
        '<![CDATA[',
        selectors,
        animations,
        ']]>'
    ].join(S);
}
function $dd8123400aca4a3f$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $dd8123400aca4a3f$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $dd8123400aca4a3f$export$bf5c4cf060303d58('svg', 'root', {
        'width': width,
        'height': height,
        'xmlns': $dd8123400aca4a3f$export$a690ad4c9a38f86e,
        'xmlns:xlink': $dd8123400aca4a3f$export$b22c6da1792ecec8,
        'version': '1.1',
        'baseProfile': 'full',
        'viewBox': useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}












var $b250b10ce9b1f7a1$var$cssClassIdx = 0;
function $b250b10ce9b1f7a1$export$9c80c36b7367fb56() {
    return $b250b10ce9b1f7a1$var$cssClassIdx++;
}


var $1697b3eae850650b$export$54ee1847795bcf37 = {
    cubicIn: '0.32,0,0.67,0',
    cubicOut: '0.33,1,0.68,1',
    cubicInOut: '0.65,0,0.35,1',
    quadraticIn: '0.11,0,0.5,0',
    quadraticOut: '0.5,1,0.89,1',
    quadraticInOut: '0.45,0,0.55,1',
    quarticIn: '0.5,0,0.75,0',
    quarticOut: '0.25,1,0.5,1',
    quarticInOut: '0.76,0,0.24,1',
    quinticIn: '0.64,0,0.78,0',
    quinticOut: '0.22,1,0.36,1',
    quinticInOut: '0.83,0,0.17,1',
    sinusoidalIn: '0.12,0,0.39,0',
    sinusoidalOut: '0.61,1,0.88,1',
    sinusoidalInOut: '0.37,0,0.63,1',
    exponentialIn: '0.7,0,0.84,0',
    exponentialOut: '0.16,1,0.3,1',
    exponentialInOut: '0.87,0,0.13,1',
    circularIn: '0.55,0,1,0.45',
    circularOut: '0,0.55,0.45,1',
    circularInOut: '0.85,0,0.15,1'
};
var $1697b3eae850650b$var$transformOriginKey = 'transform-origin';
function $1697b3eae850650b$var$buildPathString(el, kfShape, path) {
    var shape = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, el.shape);
    (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $704a4c2ca701710b$export$2e2bcd8739ae039)();
    svgPathBuilder.reset((0, $3128be478e7c4137$export$93fa1ae8a509371c)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $1697b3eae850650b$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$1697b3eae850650b$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $1697b3eae850650b$export$f0dede2064ee89d7 = {
    fill: 'fill',
    opacity: 'opacity',
    lineWidth: 'stroke-width',
    lineDashOffset: 'stroke-dashoffset'
};
function $1697b3eae850650b$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $1697b3eae850650b$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(paths, function(path) {
        var subScope = (0, $dd8123400aca4a3f$export$96fee5f38ed01741)(scope.zrId);
        subScope.animation = true;
        $1697b3eae850650b$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ''
            };
            composedAnim[percent].d += kf.d || '';
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $1697b3eae850650b$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $1697b3eae850650b$var$getEasingFunc(easing) {
    return (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(easing) ? $1697b3eae850650b$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $1697b3eae850650b$export$54ee1847795bcf37[easing] + ")" : (0, $48f0ff660a125306$export$ec0863d806fd857e)(easing) ? easing : '' : '';
}
function $1697b3eae850650b$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $99b65ca521b3dde4$export$2e2bcd8739ae039)) {
        var animationCfg = $1697b3eae850650b$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + 's'
        ];
        var easing = $1697b3eae850650b$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push('linear');
        if (delay) cfgArr.push(delay / 1000 + 's');
        if (animator.getLoop()) cfgArr.push('infinite');
        var cfg = cfgArr.join(' ');
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = 'animation-timing-function';
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + '%';
                        var kfEasing = $1697b3eae850650b$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(rawValue) || (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === 'shape') saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $82e5b6aba13917b1$export$234b1c16dfa57d6a)(transform, el);
            (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(transform, transformKfs[percent]);
            var str = (0, $3128be478e7c4137$export$3fe07c0888ff6164)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $1697b3eae850650b$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $4454211f949588ae$export$2e2bcd8739ae039)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $1697b3eae850650b$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === 'style') saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $1697b3eae850650b$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$1697b3eae850650b$var$transformOriginKey] !== finalKfs[p1][$1697b3eae850650b$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$1697b3eae850650b$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$1697b3eae850650b$var$transformOriginKey]) delete finalKfs[percent][$1697b3eae850650b$var$transformOriginKey];
            attrs[$1697b3eae850650b$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(percents, function(percent) {
            return (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $1697b3eae850650b$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + '-cls-' + (0, $b250b10ce9b1f7a1$export$9c80c36b7367fb56)();
        scope.cssNodes['.' + className] = {
            animation: cssAnimations.join(',')
        };
        attrs["class"] = className;
    }
}






function $858b1d7dad3e7ff9$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                'pointer-events': 'none'
            };
            $858b1d7dad3e7ff9$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf('select') >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $30eadc8c092f368d$export$2b47e247dfb87a73)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: 'pointer'
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style['stroke-width'] = lineWidth;
            $858b1d7dad3e7ff9$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $858b1d7dad3e7ff9$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + '-cls-' + (0, $b250b10ce9b1f7a1$export$9c80c36b7367fb56)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes['.' + className + (withHover ? ':hover' : '')] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + ' ' + className : className;
}



var $b32abc9d8efded02$var$round = Math.round;
function $b32abc9d8efded02$var$isImageLike(val) {
    return val && (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(val.src);
}
function $b32abc9d8efded02$var$isCanvasLike(val) {
    return val && (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(val.toDataURL);
}
function $b32abc9d8efded02$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $3c62684f032f59ad$export$2e2bcd8739ae039)(function(key, val) {
        var isFillStroke = key === 'fill' || key === 'stroke';
        if (isFillStroke && (0, $3128be478e7c4137$export$545e02bbd5f8fe95)(val)) $b32abc9d8efded02$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $3128be478e7c4137$export$41a28f5a000a9d0f)(val)) $b32abc9d8efded02$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else attrs[key] = val;
        if (isFillStroke && scope.ssr && val === 'none') attrs['pointer-events'] = 'visible';
    }, style, el, false);
    $b32abc9d8efded02$var$setShadow(el, attrs, scope);
}
function $b32abc9d8efded02$var$setMetaData(attrs, el) {
    var metaData = (0, $aae635f77c3c70af$export$dd7015a5412ca583)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $dd8123400aca4a3f$export$d3f79611f155197c) + key).toLowerCase()] = val + '');
        });
        if (el.isSilent()) attrs[(0, $dd8123400aca4a3f$export$d3f79611f155197c) + 'silent'] = 'true';
    }
}
function $b32abc9d8efded02$var$noRotateScale(m) {
    return (0, $3128be478e7c4137$export$4701367f5b4de464)(m[0] - 1) && (0, $3128be478e7c4137$export$4701367f5b4de464)(m[1]) && (0, $3128be478e7c4137$export$4701367f5b4de464)(m[2]) && (0, $3128be478e7c4137$export$4701367f5b4de464)(m[3] - 1);
}
function $b32abc9d8efded02$var$noTranslate(m) {
    return (0, $3128be478e7c4137$export$4701367f5b4de464)(m[4]) && (0, $3128be478e7c4137$export$4701367f5b4de464)(m[5]);
}
function $b32abc9d8efded02$var$setTransform(attrs, m, compress) {
    if (m && !($b32abc9d8efded02$var$noTranslate(m) && $b32abc9d8efded02$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $b32abc9d8efded02$var$noRotateScale(m) ? "translate(" + $b32abc9d8efded02$var$round(m[4] * mul) / mul + " " + $b32abc9d8efded02$var$round(m[5] * mul) / mul + ")" : (0, $3128be478e7c4137$export$f29a4456cf56ff21)(m);
    }
}
function $b32abc9d8efded02$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($b32abc9d8efded02$var$round(points[i][0] * mul) / mul);
        strArr.push($b32abc9d8efded02$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(' ');
}
function $b32abc9d8efded02$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $b32abc9d8efded02$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(desc, function(item) {
        return typeof item === 'string' ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $b32abc9d8efded02$var$round(val * mul) / mul;
        }
    };
}
var $b32abc9d8efded02$var$builtinShapesDef = {
    circle: [
        $b32abc9d8efded02$var$createAttrsConvert([
            'cx',
            'cy',
            'r'
        ])
    ],
    polyline: [
        $b32abc9d8efded02$var$convertPolyShape,
        $b32abc9d8efded02$var$validatePolyShape
    ],
    polygon: [
        $b32abc9d8efded02$var$convertPolyShape,
        $b32abc9d8efded02$var$validatePolyShape
    ]
};
function $b32abc9d8efded02$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === 'shape') return true;
    }
    return false;
}
function $b32abc9d8efded02$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $b32abc9d8efded02$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = 'path';
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $3128be478e7c4137$export$93fa1ae8a509371c)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $b32abc9d8efded02$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $704a4c2ca701710b$export$2e2bcd8739ae039)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $b32abc9d8efded02$var$setTransform(attrs, el.transform);
    $b32abc9d8efded02$var$setStyleAttrs(attrs, style, el, scope);
    $b32abc9d8efded02$var$setMetaData(attrs, el);
    scope.animation && (0, $1697b3eae850650b$export$dc9722e37397d426)(el, attrs, scope);
    scope.emphasis && (0, $858b1d7dad3e7ff9$export$b4c8f742d3cb22ba)(el, attrs, scope);
    return (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)(svgElType, el.id + '', attrs);
}
function $b32abc9d8efded02$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $e4c0c902d0f4f283$export$844ec244b1367d54)(image)) {
        if ($b32abc9d8efded02$var$isImageLike(image)) image = image.src;
        else if ($b32abc9d8efded02$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $b32abc9d8efded02$var$setTransform(attrs, el.transform);
    $b32abc9d8efded02$var$setStyleAttrs(attrs, style, el, scope);
    $b32abc9d8efded02$var$setMetaData(attrs, el);
    scope.animation && (0, $1697b3eae850650b$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('image', el.id + '', attrs);
}
function $b32abc9d8efded02$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += '');
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $fd1433555986e896$export$7d7a232b6d2cc80c);
    var x = style.x || 0;
    var y = (0, $3128be478e7c4137$export$bf7d6802d2badd9)(style.y || 0, (0, $211780946ab71638$export$56204a27a2958a55)(font), style.textBaseline);
    var textAlign = (0, $3128be478e7c4137$export$4062150f0600d971)[style.textAlign] || style.textAlign;
    var attrs = {
        'dominant-baseline': 'central',
        'text-anchor': textAlign
    };
    if ((0, $9f8a9b67e62609f8$export$4685c95d5118e76a)(style)) {
        var separatedFontStr = '';
        var fontStyle = style.fontStyle;
        var fontSize = (0, $9f8a9b67e62609f8$export$51b066d9cfc2578e)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $fd1433555986e896$export$2653e0d5dd45b294);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== 'normal') separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== 'normal') separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs['xml:space'] = 'preserve';
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $b32abc9d8efded02$var$setTransform(attrs, el.transform);
    $b32abc9d8efded02$var$setStyleAttrs(attrs, style, el, scope);
    $b32abc9d8efded02$var$setMetaData(attrs, el);
    scope.animation && (0, $1697b3eae850650b$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('text', el.id + '', attrs, undefined, text);
}
function $b32abc9d8efded02$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $27b47789cc8143e1$export$2e2bcd8739ae039)) return $b32abc9d8efded02$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $b5bca30d4a081571$export$2e2bcd8739ae039)) return $b32abc9d8efded02$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $67c55373fdf93a2e$export$2e2bcd8739ae039)) return $b32abc9d8efded02$export$d506f5385e62a84a(el, scope);
}
function $b32abc9d8efded02$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $3128be478e7c4137$export$c62076b3a966c94b)(style)) {
        var shadowKey = (0, $3128be478e7c4137$export$9e4c657be710688a)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $3128be478e7c4137$export$4cde5df63f53f473)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            shadowId = scope.zrId + '-s' + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('filter', shadowId, {
                'id': shadowId,
                'x': '-100%',
                'y': '-100%',
                'width': '300%',
                'height': '300%'
            }, [
                (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('feDropShadow', '', {
                    'dx': offsetX / scaleX,
                    'dy': offsetY / scaleY,
                    'stdDeviation': stdDeviation,
                    'flood-color': color,
                    'flood-opacity': opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $3128be478e7c4137$export$bb094196179998a5)(shadowId);
    }
}
function $b32abc9d8efded02$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        'gradientUnits': val.global ? 'userSpaceOnUse' : 'objectBoundingBox'
    };
    if ((0, $3128be478e7c4137$export$7d961bca9d3b47d0)(val)) {
        gradientTag = 'linearGradient';
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $3128be478e7c4137$export$2a9cca6692a0ce3a)(val)) {
        gradientTag = 'radialGradient';
        gradientAttrs.cx = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(val.x, 0.5);
        gradientAttrs.cy = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(val.y, 0.5);
        gradientAttrs.r = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $3128be478e7c4137$export$52bfc6d3e2ff0fc2)(colors[i].offset) * 100 + '%';
        var stopColor = colors[i].color;
        var _a = (0, $3128be478e7c4137$export$4cde5df63f53f473)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            'offset': offset
        };
        stopsAttrs['stop-color'] = color;
        if (opacity < 1) stopsAttrs['stop-opacity'] = opacity;
        colorStops.push((0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('stop', i + '', stopsAttrs));
    }
    var gradientVNode = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)(gradientTag, '', gradientAttrs, colorStops);
    var gradientKey = (0, $dd8123400aca4a3f$export$f5c4a9a0e027f2b)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + '-g' + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $3128be478e7c4137$export$bb094196179998a5)(gradientId);
}
function $b32abc9d8efded02$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === 'no-repeat';
    var repeatX = repeat === 'repeat-x';
    var repeatY = repeat === 'repeat-y';
    var child;
    if ((0, $3128be478e7c4137$export$2ade673ac4f85dfe)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(patternImage)) imageSrc = patternImage;
        else if ($b32abc9d8efded02$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($b32abc9d8efded02$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === 'undefined') {
            var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
            (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(imageWidth_1, errMsg);
            (0, $e4c0c902d0f4f283$export$a7a9523472993e97)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === 'pattern') {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute('width', width);
                        svgEl.setAttribute('height', height);
                    }
                }
            };
            var createdImage = (0, $fe811193fee9631f$export$46c791b69ff9a0f)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('image', 'img', {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = 'userSpaceOnUse';
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $3128be478e7c4137$export$3fe07c0888ff6164)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('pattern', '', patternAttrs, [
        child
    ]);
    var patternKey = (0, $dd8123400aca4a3f$export$f5c4a9a0e027f2b)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + '-p' + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('pattern', patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $3128be478e7c4137$export$bb094196179998a5)(patternId);
}
function $b32abc9d8efded02$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('clipPath', clipPathId, clipPathAttrs, [
            $b32abc9d8efded02$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs['clip-path'] = (0, $3128be478e7c4137$export$bb094196179998a5)(clipPathId);
}







function $fbd961cf909d6611$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $fbd961cf909d6611$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $fbd961cf909d6611$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $fbd961cf909d6611$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $fbd961cf909d6611$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $fbd961cf909d6611$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $fbd961cf909d6611$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $fbd961cf909d6611$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $fbd961cf909d6611$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $fbd961cf909d6611$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $fbd961cf909d6611$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $fbd961cf909d6611$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $fbd961cf909d6611$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}


var $569bbd7358f6ae3d$var$colonChar = 58;
var $569bbd7358f6ae3d$var$xChar = 120;
var $569bbd7358f6ae3d$var$emptyNode = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('', '');
function $569bbd7358f6ae3d$var$isUndef(s) {
    return s === undefined;
}
function $569bbd7358f6ae3d$var$isDef(s) {
    return s !== undefined;
}
function $569bbd7358f6ae3d$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $569bbd7358f6ae3d$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $569bbd7358f6ae3d$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($569bbd7358f6ae3d$var$isDef(tag)) {
        var elm = vnode.elm = (0, $dd8123400aca4a3f$export$c8a8987d4410bf2d)(tag);
        $569bbd7358f6ae3d$export$277dcc6f06048f24($569bbd7358f6ae3d$var$emptyNode, vnode);
        if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $fbd961cf909d6611$export$1b8e57c9ea42f1d2(elm, $569bbd7358f6ae3d$var$createElm(ch));
        }
        else if ($569bbd7358f6ae3d$var$isDef(vnode.text) && !(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(vnode.text)) $fbd961cf909d6611$export$1b8e57c9ea42f1d2(elm, $fbd961cf909d6611$export$b2ce9ad90858ed7a(vnode.text));
    } else vnode.elm = $fbd961cf909d6611$export$b2ce9ad90858ed7a(vnode.text);
    return vnode.elm;
}
function $569bbd7358f6ae3d$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $fbd961cf909d6611$export$86b68c7dbeb53c22(parentElm, $569bbd7358f6ae3d$var$createElm(ch), before);
    }
}
function $569bbd7358f6ae3d$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($569bbd7358f6ae3d$var$isDef(ch.tag)) {
                var parent_1 = $fbd961cf909d6611$export$b54be7ce267a037b(ch.elm);
                $fbd961cf909d6611$export$7ae609f7af59e4f7(parent_1, ch.elm);
            } else $fbd961cf909d6611$export$7ae609f7af59e4f7(parentElm, ch.elm);
        }
    }
}
function $569bbd7358f6ae3d$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, '');
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === 'style') elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $569bbd7358f6ae3d$var$xChar) elm.setAttribute(key, cur);
                else if (key === 'xmlns:xlink' || key === 'xmlns') elm.setAttributeNS((0, $dd8123400aca4a3f$export$fac09d762d15fa3b), key, cur);
                else if (key.charCodeAt(3) === $569bbd7358f6ae3d$var$colonChar) elm.setAttributeNS((0, $dd8123400aca4a3f$export$ad4c4fdecd3b4156), key, cur);
                else if (key.charCodeAt(5) === $569bbd7358f6ae3d$var$colonChar) elm.setAttributeNS((0, $dd8123400aca4a3f$export$b22c6da1792ecec8), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $569bbd7358f6ae3d$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($569bbd7358f6ae3d$var$sameVnode(oldStartVnode, newStartVnode)) {
            $569bbd7358f6ae3d$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($569bbd7358f6ae3d$var$sameVnode(oldEndVnode, newEndVnode)) {
            $569bbd7358f6ae3d$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($569bbd7358f6ae3d$var$sameVnode(oldStartVnode, newEndVnode)) {
            $569bbd7358f6ae3d$var$patchVnode(oldStartVnode, newEndVnode);
            $fbd961cf909d6611$export$86b68c7dbeb53c22(parentElm, oldStartVnode.elm, $fbd961cf909d6611$export$335219007e689d29(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($569bbd7358f6ae3d$var$sameVnode(oldEndVnode, newStartVnode)) {
            $569bbd7358f6ae3d$var$patchVnode(oldEndVnode, newStartVnode);
            $fbd961cf909d6611$export$86b68c7dbeb53c22(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($569bbd7358f6ae3d$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $569bbd7358f6ae3d$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($569bbd7358f6ae3d$var$isUndef(idxInOld)) $fbd961cf909d6611$export$86b68c7dbeb53c22(parentElm, $569bbd7358f6ae3d$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $fbd961cf909d6611$export$86b68c7dbeb53c22(parentElm, $569bbd7358f6ae3d$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $569bbd7358f6ae3d$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $fbd961cf909d6611$export$86b68c7dbeb53c22(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $569bbd7358f6ae3d$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $569bbd7358f6ae3d$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $569bbd7358f6ae3d$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $569bbd7358f6ae3d$export$277dcc6f06048f24(oldVnode, vnode);
    if ($569bbd7358f6ae3d$var$isUndef(vnode.text)) {
        if ($569bbd7358f6ae3d$var$isDef(oldCh) && $569bbd7358f6ae3d$var$isDef(ch)) {
            if (oldCh !== ch) $569bbd7358f6ae3d$var$updateChildren(elm, oldCh, ch);
        } else if ($569bbd7358f6ae3d$var$isDef(ch)) {
            if ($569bbd7358f6ae3d$var$isDef(oldVnode.text)) $fbd961cf909d6611$export$94b0296cab6203e(elm, '');
            $569bbd7358f6ae3d$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($569bbd7358f6ae3d$var$isDef(oldCh)) $569bbd7358f6ae3d$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($569bbd7358f6ae3d$var$isDef(oldVnode.text)) $fbd961cf909d6611$export$94b0296cab6203e(elm, '');
    } else if (oldVnode.text !== vnode.text) {
        if ($569bbd7358f6ae3d$var$isDef(oldCh)) $569bbd7358f6ae3d$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $fbd961cf909d6611$export$94b0296cab6203e(elm, vnode.text);
    }
}
function $569bbd7358f6ae3d$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($569bbd7358f6ae3d$var$sameVnode(oldVnode, vnode)) $569bbd7358f6ae3d$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $fbd961cf909d6611$export$b54be7ce267a037b(elm);
        $569bbd7358f6ae3d$var$createElm(vnode);
        if (parent_2 !== null) {
            $fbd961cf909d6611$export$86b68c7dbeb53c22(parent_2, vnode.elm, $fbd961cf909d6611$export$335219007e689d29(elm));
            $569bbd7358f6ae3d$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}



var $d5c8549853679242$var$svgId = 0;
var $d5c8549853679242$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = 'svg';
        this.configLayer = $d5c8549853679242$var$createMethodNotSupport('configLayer');
        this.storage = storage;
        this._opts = opts = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, opts);
        this.root = root;
        this._id = 'zr' + $d5c8549853679242$var$svgId++;
        this._oldVNode = (0, $dd8123400aca4a3f$export$5529a6aad332ee75)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement('div');
            viewport.style.cssText = 'position:relative;overflow:hidden';
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $dd8123400aca4a3f$export$c8a8987d4410bf2d)('svg');
            (0, $569bbd7358f6ae3d$export$277dcc6f06048f24)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
            (0, $569bbd7358f6ae3d$export$2e2bcd8739ae039)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $b32abc9d8efded02$export$da5d6544e8c27bc1)(el, (0, $dd8123400aca4a3f$export$96fee5f38ed01741)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $dd8123400aca4a3f$export$96fee5f38ed01741)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        scope.ssr = this._opts.ssr;
        var children = [];
        var bgVNode = this._bgVNode = $d5c8549853679242$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('g', 'main', {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)((0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('defs', 'defs', {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $dd8123400aca4a3f$export$e2b4f3597c7a7dcb)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('style', 'stl', {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $dd8123400aca4a3f$export$5529a6aad332ee75)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $dd8123400aca4a3f$export$f5c4a9a0e027f2b)(this.renderToVNode({
            animation: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(opts.cssAnimation, true),
            emphasis: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $b32abc9d8efded02$export$8f1d80b445d4fc)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $b32abc9d8efded02$export$da5d6544e8c27bc1)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = 'none';
            width = (0, $13757e5a67c3b637$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $13757e5a67c3b637$export$31b21d0167753bb4)(root, 1, opts);
            viewport.style.display = '';
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
            }
            if (!(0, $3128be478e7c4137$export$41a28f5a000a9d0f)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute('width', width);
                    svgDom.setAttribute('height', height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute('width', width);
                    bgEl.setAttribute('height', height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = '';
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = 'data:image/svg+xml;';
        if (base64) {
            str = (0, $3128be478e7c4137$export$8fb536984ec8b4d7)(str);
            return str && prefix + 'base64,' + str;
        }
        return prefix + 'charset=UTF-8,' + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $d5c8549853679242$var$createMethodNotSupport(method) {
    return function() {};
}
function $d5c8549853679242$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== 'none') {
        bgVNode = (0, $dd8123400aca4a3f$export$bf5c4cf060303d58)('rect', 'bg', {
            width: width,
            height: height,
            x: '0',
            y: '0'
        });
        if ((0, $3128be478e7c4137$export$545e02bbd5f8fe95)(backgroundColor)) (0, $b32abc9d8efded02$export$afaa8352c6a43a44)({
            fill: backgroundColor
        }, bgVNode.attrs, 'fill', scope);
        else if ((0, $3128be478e7c4137$export$41a28f5a000a9d0f)(backgroundColor)) (0, $b32abc9d8efded02$export$faed90dbedc3b6d5)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $e4c0c902d0f4f283$export$8793edee2d425525),
            getBoundingRect: function() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, 'fill', scope);
        else {
            var _a = (0, $3128be478e7c4137$export$4cde5df63f53f473)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs['fill-opacity'] = opacity);
        }
    }
    return bgVNode;
}
var $d5c8549853679242$export$2e2bcd8739ae039 = $d5c8549853679242$var$SVGPainter;


function $35c87b14430b3d6b$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('svg', (0, $d5c8549853679242$export$2e2bcd8739ae039));
}




var $gkgmt = parcelRequire("gkgmt");

var $iob0w = parcelRequire("iob0w");

var $iob0w = parcelRequire("iob0w");

var $bI3eA = parcelRequire("bI3eA");
function $9e02e27251675feb$export$99096e10de875468() {
    var handler;
    const stream = new (0, $bI3eA.ReadableStream)({
        start: (controller)=>{
            handler = controller;
        }
    });
    function call(...input) {
        const request = {
            context: this,
            input: input,
            output: Promise.withResolvers()
        };
        handler.enqueue(request);
        return request.output.promise;
    }
    return Object.assign(call, {
        stream: stream
    });
}
const $9e02e27251675feb$export$db26ce94c7abc843 = /^on(\w+)/;
const $9e02e27251675feb$var$EventHandlerMap = new WeakMap();
function $9e02e27251675feb$export$d09f5504a38c35a6(name, handler) {
    const wrapper = (detail)=>{
        const event = new CustomEvent(name, {
            detail: detail
        }), meta = {
            enumerable: true,
            value: this
        };
        Object.defineProperties(event, {
            eventPhase: Object.assign(Object.assign({}, meta), {
                value: Event.AT_TARGET
            }),
            srcElement: meta,
            target: meta,
            currentTarget: meta
        });
        handler.call(this, event);
    };
    $9e02e27251675feb$var$EventHandlerMap.set(handler, wrapper);
    return wrapper;
}
const $9e02e27251675feb$export$7c4c84635886a982 = (handler)=>$9e02e27251675feb$var$EventHandlerMap.get(handler);


var $0036c3b3c1214d9e$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $0036c3b3c1214d9e$var$_ProxyElement_data;
class $0036c3b3c1214d9e$export$dfca55cafbce2a44 extends HTMLElement {
    toJSON() {
        return Object.fromEntries(Object.entries($0036c3b3c1214d9e$var$__classPrivateFieldGet(this, $0036c3b3c1214d9e$var$_ProxyElement_data, "f")).filter(([key, value])=>typeof value !== 'function' && !key.startsWith('__react')));
    }
    constructor(){
        super();
        $0036c3b3c1214d9e$var$_ProxyElement_data.set(this, {});
        (0, $iob0w.proxyPrototype)(this, $0036c3b3c1214d9e$var$__classPrivateFieldGet(this, $0036c3b3c1214d9e$var$_ProxyElement_data, "f"), (key, value)=>this.setProperty(key.toString(), value));
    }
    connectedCallback() {
        const prototype = Object.getPrototypeOf(this);
        const customAttributes = [
            ...this.attributes
        ].filter(({ name: name })=>!(name in prototype));
        if (customAttributes[0] && !Object.keys(this.toJSON())[0]) for (const { name: name, value: value } of customAttributes)this.setAttribute(name, value);
    }
    setProperty(key, value) {
        const oldValue = $0036c3b3c1214d9e$var$__classPrivateFieldGet(this, $0036c3b3c1214d9e$var$_ProxyElement_data, "f")[key], name = (0, $iob0w.toHyphenCase)(key), eventName = key.slice(2);
        $0036c3b3c1214d9e$var$__classPrivateFieldGet(this, $0036c3b3c1214d9e$var$_ProxyElement_data, "f")[key] = value;
        switch(typeof value){
            case 'boolean':
                if (value) super.setAttribute(name, name + '');
                else super.removeAttribute(name);
                break;
            case 'function':
                if ((0, $9e02e27251675feb$export$db26ce94c7abc843).test(key)) {
                    this.removeEventListener(eventName, oldValue);
                    this.addEventListener(eventName, value);
                }
                break;
            default:
                if (value != null) super.setAttribute(name, typeof value === 'object' ? JSON.stringify(value) : value);
                else if ((0, $9e02e27251675feb$export$db26ce94c7abc843).test(key) && typeof oldValue === 'function') this.removeEventListener(eventName, value);
                else super.removeAttribute(name);
        }
    }
    setAttribute(name, value) {
        super.setAttribute(name, value);
        const key = (0, $iob0w.toCamelCase)(name);
        if (key in Object.getPrototypeOf(this)) return;
        this[key] = name === value || (0, $iob0w.parseJSON)(value);
    }
}
$0036c3b3c1214d9e$var$_ProxyElement_data = new WeakMap();



var $4b99920129a0ab10$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4b99920129a0ab10$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $4b99920129a0ab10$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $4b99920129a0ab10$var$__asyncValues = undefined && undefined.__asyncValues || function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $4b99920129a0ab10$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4b99920129a0ab10$var$_EChartsElement_instances, $4b99920129a0ab10$var$_EChartsElement_core, $4b99920129a0ab10$var$_EChartsElement_coreDefer, $4b99920129a0ab10$var$_EChartsElement_init;
class $4b99920129a0ab10$export$653143645409d056 extends (0, $0036c3b3c1214d9e$export$dfca55cafbce2a44) {
    get renderer() {
        const [_, type] = this.tagName.toLowerCase().split('-');
        return type;
    }
    get options() {
        return $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f").getOption();
    }
    constructor(){
        super();
        $4b99920129a0ab10$var$_EChartsElement_instances.add(this);
        $4b99920129a0ab10$var$_EChartsElement_core.set(this, void 0);
        $4b99920129a0ab10$var$_EChartsElement_coreDefer.set(this, Promise.withResolvers());
        Object.defineProperty(this, "setOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $9e02e27251675feb$export$99096e10de875468)()
        });
        Object.defineProperty(this, "connectOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.connectChildStream((option)=>this.setOption(option))
        });
        Object.defineProperty(this, "connectAddListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.connectChildStream((event, selector, handler)=>{
                $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f").on(event, selector, handler);
            })
        });
        Object.defineProperty(this, "connectRemoveListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.connectChildStream((event, handler)=>{
                $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f").off(event, handler);
            })
        });
        Object.defineProperty(this, "addEventListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $9e02e27251675feb$export$99096e10de875468)()
        });
        Object.defineProperty(this, "removeEventListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $9e02e27251675feb$export$99096e10de875468)()
        });
        Object.defineProperty(this, "handleResize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $gkgmt.debounce)(()=>$4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f").resize(this.toJSON().resizeOptions))
        });
        this.attachShadow({
            mode: 'open'
        }).append((0, $iob0w.parseDOM)('<div style="height: 100%" />')[0]);
    }
    connectedCallback() {
        var _a;
        if ($4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f")) return;
        super.connectedCallback();
        this.style.display = 'block';
        $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_instances, "m", $4b99920129a0ab10$var$_EChartsElement_init).call(this);
        (_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.handleResize);
    }
    disconnectedCallback() {
        var _a, _b;
        (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.handleResize);
        (_b = $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f")) === null || _b === void 0 || _b.dispose();
        $4b99920129a0ab10$var$__classPrivateFieldSet(this, $4b99920129a0ab10$var$_EChartsElement_core, undefined, "f");
    }
    setProperty(key, value) {
        super.setProperty(key, value);
        this.setOption(this.toJSON());
    }
    processStream(stream, executor, context) {
        return $4b99920129a0ab10$var$__awaiter(this, void 0, void 0, function*() {
            var _a, stream_1, stream_1_1;
            var _b, e_1, _c, _d;
            yield $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_coreDefer, "f").promise;
            try {
                for(_a = true, stream_1 = $4b99920129a0ab10$var$__asyncValues(stream); stream_1_1 = yield stream_1.next(), _b = stream_1_1.done, !_b; _a = true){
                    _d = stream_1_1.value;
                    _a = false;
                    const request = _d;
                    const { input: input, output: output } = request;
                    try {
                        const data = executor.apply(context, input);
                        output.resolve(data);
                    } catch (error) {
                        output.reject(error);
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (!_a && !_b && (_c = stream_1.return)) yield _c.call(stream_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        });
    }
    connectChildStream(executor) {
        const that = this;
        return function(stream) {
            return that.processStream(stream, executor, this);
        };
    }
}
$4b99920129a0ab10$var$_EChartsElement_core = new WeakMap(), $4b99920129a0ab10$var$_EChartsElement_coreDefer = new WeakMap(), $4b99920129a0ab10$var$_EChartsElement_instances = new WeakSet(), $4b99920129a0ab10$var$_EChartsElement_init = function _EChartsElement_init() {
    var _a = this.toJSON(), { theme: theme, initOptions: initOptions, setOptions: setOptions } = _a, props = $4b99920129a0ab10$var$__rest(_a, [
        "theme",
        "initOptions",
        "setOptions"
    ]);
    $4b99920129a0ab10$var$__classPrivateFieldSet(this, $4b99920129a0ab10$var$_EChartsElement_core, (0, $34de22b7c8cf03f7$export$2cd8252107eb640b)(this.shadowRoot.firstElementChild, theme, Object.assign(Object.assign({}, initOptions), {
        renderer: this.renderer
    })), "f");
    $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_coreDefer, "f").resolve();
    // @ts-ignore
    this.setOption(Object.assign({
        grid: {}
    }, props));
    this.processStream(this.setOption.stream, (data)=>{
        $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f").setOption(data, Object.assign({
            notMerge: false,
            lazyUpdate: true
        }, setOptions));
    });
    this.processStream(this.removeEventListener.stream, (event, handler)=>{
        $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f").getZr().off(event, (0, $9e02e27251675feb$export$7c4c84635886a982)(handler));
    });
    this.processStream(this.addEventListener.stream, (name, handler)=>{
        $4b99920129a0ab10$var$__classPrivateFieldGet(this, $4b99920129a0ab10$var$_EChartsElement_core, "f").getZr().on(name, (0, $9e02e27251675feb$export$d09f5504a38c35a6).call(this, name, handler));
    });
};


var $8cad68c911a6c170$var$_a;
(0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $35c87b14430b3d6b$export$4b3e715f166fdd78));
class $8cad68c911a6c170$export$14625ca68d894a68 extends (0, $4b99920129a0ab10$export$653143645409d056) {
}
($8cad68c911a6c170$var$_a = globalThis.customElements) === null || $8cad68c911a6c170$var$_a === void 0 || $8cad68c911a6c170$var$_a.define('ec-svg-renderer', $8cad68c911a6c170$export$14625ca68d894a68);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $28f1917f7e93ebb8$var$TitleModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = 'title';
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: '',
        target: 'blank',
        subtext: '',
        subtarget: 'blank',
        left: 'center',
        top: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).size.m,
        backgroundColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.primary,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: 'bold',
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.primary
        },
        subtextStyle: {
            fontSize: 12,
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.quaternary
        }
    };
    return TitleModel;
}((0, $879a47e830ab7f41$export$2e2bcd8739ae039));
// View
var $28f1917f7e93ebb8$var$TitleView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get('show')) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel('textStyle');
        var subtextStyleModel = titleModel.getModel('subtextStyle');
        var textAlign = titleModel.get('textAlign');
        var textVerticalAlign = $e4c0c902d0f4f283$export$995e01f2f5c9d030(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
        var textEl = new $9f8a9b67e62609f8$export$2e2bcd8739ae039({
            style: (0, $83b5345ce49bb659$export$f8998c3d0a13de59)(textStyleModel, {
                text: titleModel.get('text'),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get('subtext');
        var subTextEl = new $9f8a9b67e62609f8$export$2e2bcd8739ae039({
            style: (0, $83b5345ce49bb659$export$f8998c3d0a13de59)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get('itemGap'),
                verticalAlign: 'top'
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get('link');
        var sublink = titleModel.get('sublink');
        var triggerEvent = titleModel.get('triggerEvent', true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on('click', function() {
            (0, $c09e8b26bdb81866$export$13e13f9b96dbe8fa)(link, '_' + titleModel.get('target'));
        });
        if (sublink) subTextEl.on('click', function() {
            (0, $c09e8b26bdb81866$export$13e13f9b96dbe8fa)(sublink, '_' + titleModel.get('subtarget'));
        });
        (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(textEl).eventData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(subTextEl).eventData = triggerEvent ? {
            componentType: 'title',
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRef = (0, $52313d605bb144f5$export$5aec1e94f566e59f)(titleModel, api);
        var layoutRect = (0, $52313d605bb144f5$export$4517a5ca639a7293)(layoutOption, layoutRef.refContainer, titleModel.get('padding'));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get('left') || titleModel.get('right');
            // @ts-ignore
            if (textAlign === 'middle') textAlign = 'center';
            // Adjust layout by text align
            if (textAlign === 'right') layoutRect.x += layoutRect.width;
            else if (textAlign === 'center') layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
            // @ts-ignore
            if (textVerticalAlign === 'center') textVerticalAlign = 'middle';
            if (textVerticalAlign === 'bottom') layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === 'middle') layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || 'top';
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            'color',
            'opacity'
        ]);
        style.fill = titleModel.get('backgroundColor');
        var rect = new $439653c37a0e6e60$export$2e2bcd8739ae039({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get('borderRadius')
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = 'title';
    return TitleView;
}((0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039));
function $28f1917f7e93ebb8$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($28f1917f7e93ebb8$var$TitleModel);
    registers.registerComponentView($28f1917f7e93ebb8$var$TitleView);
}




var $iob0w = parcelRequire("iob0w");



var $e105d0ae0b8f861c$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e105d0ae0b8f861c$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e105d0ae0b8f861c$var$_ECOptionElement_id, $e105d0ae0b8f861c$var$_ECOptionElement_renderer, $e105d0ae0b8f861c$var$_ECOptionElement_nextTick;
class $e105d0ae0b8f861c$export$37de6f71bb86a769 extends (0, $0036c3b3c1214d9e$export$dfca55cafbce2a44) {
    constructor(){
        super(...arguments);
        $e105d0ae0b8f861c$var$_ECOptionElement_id.set(this, (0, $iob0w.uniqueID)());
        $e105d0ae0b8f861c$var$_ECOptionElement_renderer.set(this, void 0);
        $e105d0ae0b8f861c$var$_ECOptionElement_nextTick.set(this, void 0);
        Object.defineProperty(this, "emitOption", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $9e02e27251675feb$export$99096e10de875468)()
        });
        Object.defineProperty(this, "emitAddListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $9e02e27251675feb$export$99096e10de875468)()
        });
        Object.defineProperty(this, "emitRemoveListener", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (0, $9e02e27251675feb$export$99096e10de875468)()
        });
    }
    get chartTagName() {
        return (0, $iob0w.toCamelCase)(this.tagName.replace(/^ec-/i, '').toLowerCase());
    }
    get isSeries() {
        return this.chartTagName.endsWith('Chart');
    }
    get chartName() {
        return this.isSeries ? this.chartTagName.replace(/Chart$/, '') : null;
    }
    get eventSelector() {
        return [
            this.isSeries && 'series',
            this.chartName || this.chartTagName,
            this['type']
        ].filter(Boolean).join('.');
    }
    connectedCallback() {
        if ($e105d0ae0b8f861c$var$__classPrivateFieldGet(this, $e105d0ae0b8f861c$var$_ECOptionElement_renderer, "f")) return;
        super.connectedCallback();
        if (!this.attributes[0]) this.updateOption();
        for(let parent = this.parentElement; parent; parent = parent.parentElement)if (parent instanceof (0, $4b99920129a0ab10$export$653143645409d056)) $e105d0ae0b8f861c$var$__classPrivateFieldSet(this, $e105d0ae0b8f861c$var$_ECOptionElement_renderer, parent, "f");
        if (!$e105d0ae0b8f861c$var$__classPrivateFieldGet(this, $e105d0ae0b8f861c$var$_ECOptionElement_renderer, "f")) throw new ReferenceError(`<${this.tagName.toLowerCase()} /> should be append to a DOM tree within <ec-svg-renderer /> or <ec-canvas-renderer />`);
        $e105d0ae0b8f861c$var$__classPrivateFieldGet(this, $e105d0ae0b8f861c$var$_ECOptionElement_renderer, "f").connectOption(this.emitOption.stream);
        $e105d0ae0b8f861c$var$__classPrivateFieldGet(this, $e105d0ae0b8f861c$var$_ECOptionElement_renderer, "f").connectRemoveListener(this.emitRemoveListener.stream);
        $e105d0ae0b8f861c$var$__classPrivateFieldGet(this, $e105d0ae0b8f861c$var$_ECOptionElement_renderer, "f").connectAddListener(this.emitAddListener.stream);
    }
    setProperty(key, value) {
        var _a;
        super.setProperty(key, value);
        $e105d0ae0b8f861c$var$__classPrivateFieldSet(this, $e105d0ae0b8f861c$var$_ECOptionElement_nextTick, (_a = $e105d0ae0b8f861c$var$__classPrivateFieldGet(this, $e105d0ae0b8f861c$var$_ECOptionElement_nextTick, "f")) !== null && _a !== void 0 ? _a : Promise.resolve().then(()=>{
            this.updateOption();
            $e105d0ae0b8f861c$var$__classPrivateFieldSet(this, $e105d0ae0b8f861c$var$_ECOptionElement_nextTick, null, "f");
        }), "f");
    }
    updateOption() {
        const data = this.toJSON(), { formatter: formatter } = this;
        const option = this.isSeries ? {
            series: [
                Object.assign(Object.assign({
                    id: $e105d0ae0b8f861c$var$__classPrivateFieldGet(this, $e105d0ae0b8f861c$var$_ECOptionElement_id, "f")
                }, data), {
                    type: this.chartName
                })
            ]
        } : {
            [this.chartTagName]: Object.assign(Object.assign({}, data), {
                formatter: formatter
            })
        };
        return this.emitOption(option);
    }
    addEventListener(name, handler) {
        return this.emitAddListener(name, this.eventSelector, (0, $9e02e27251675feb$export$d09f5504a38c35a6).call(this, name, handler));
    }
    removeEventListener(event, handler) {
        return this.emitRemoveListener(event, (0, $9e02e27251675feb$export$7c4c84635886a982)(handler));
    }
}
$e105d0ae0b8f861c$var$_ECOptionElement_id = new WeakMap(), $e105d0ae0b8f861c$var$_ECOptionElement_renderer = new WeakMap(), $e105d0ae0b8f861c$var$_ECOptionElement_nextTick = new WeakMap();


var $24ed66363f414d64$var$_a;
(0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $28f1917f7e93ebb8$export$4b3e715f166fdd78));
class $24ed66363f414d64$export$a07c56df7267ad6f extends (0, $e105d0ae0b8f861c$export$37de6f71bb86a769) {
}
($24ed66363f414d64$var$_a = globalThis.customElements) === null || $24ed66363f414d64$var$_a === void 0 || $24ed66363f414d64$var$_a.define('ec-title', $24ed66363f414d64$export$a07c56df7267ad6f);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $7c4774fdb8782d51$var$getDefaultSelectorOptions = function(ecModel, type) {
    if (type === 'all') return {
        type: 'all',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'all'
        ])
    };
    else if (type === 'inverse') return {
        type: 'inverse',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'inverse'
        ])
    };
};
var $7c4774fdb8782d51$var$LegendModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: 'box',
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            'all',
            'inverse'
        ];
        if ($e4c0c902d0f4f283$export$43bee75e5e14138e(selector)) $e4c0c902d0f4f283$export$79b2f7037acddd43(selector, function(item, index) {
            $e4c0c902d0f4f283$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $e4c0c902d0f4f283$export$4950aa0f605343fb(item, $7c4774fdb8782d51$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get('selectedMode') === 'single') {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get('name');
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get('name'));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $939d3a4c11ee87fd$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get('data') || potentialData;
        var legendNameMap = $e4c0c902d0f4f283$export$55f8aa7ef875b0a4();
        var legendData = $e4c0c902d0f4f283$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($e4c0c902d0f4f283$export$844ec244b1367d54(dataItem) || $e4c0c902d0f4f283$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $e4c0c902d0f4f283$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get('selectedMode');
        if (selectedMode === 'single') {
            var data = this._data;
            $e4c0c902d0f4f283$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get('name')] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get('selectedMode') !== 'single') this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? 'unSelect' : 'select'](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $e4c0c902d0f4f283$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get('name', true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $e4c0c902d0f4f283$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get('name', true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $e4c0c902d0f4f283$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get('orient') === 'vertical' ? {
            index: 1,
            name: 'vertical'
        } : {
            index: 0,
            name: 'horizontal'
        };
    };
    LegendModel.type = 'legend.plain';
    LegendModel.dependencies = [
        'series'
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: 'horizontal',
        left: 'center',
        // right: 'center',
        // top: 0,
        bottom: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).size.m,
        align: 'auto',
        backgroundColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.transparent,
        borderColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.border,
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 8,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: 'inherit',
        symbolKeepAspect: true,
        inactiveColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.disabled,
        inactiveBorderWidth: 'auto',
        itemStyle: {
            color: 'inherit',
            opacity: 'inherit',
            borderColor: 'inherit',
            borderWidth: 'auto',
            borderCap: 'inherit',
            borderJoin: 'inherit',
            borderDashOffset: 'inherit',
            borderMiterLimit: 'inherit'
        },
        lineStyle: {
            width: 'auto',
            color: 'inherit',
            inactiveColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.disabled,
            inactiveWidth: 2,
            opacity: 'inherit',
            type: 'inherit',
            cap: 'inherit',
            join: 'inherit',
            dashOffset: 'inherit',
            miterLimit: 'inherit'
        },
        textStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.secondary
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: 'sans-serif',
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.tertiary,
            borderWidth: 1,
            borderColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.border
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.quaternary
            }
        },
        selectorPosition: 'auto',
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        },
        triggerEvent: false
    };
    return LegendModel;
}((0, $879a47e830ab7f41$export$2e2bcd8739ae039));
var $7c4774fdb8782d51$export$2e2bcd8739ae039 = $7c4774fdb8782d51$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $4be4ada7c4405f26$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $c09e8b26bdb81866$export$f3a38102c49f4268(componentModel.get('padding'));
    var style = componentModel.getItemStyle([
        'color',
        'opacity'
    ]);
    style.fill = componentModel.get('backgroundColor');
    var bgRect = new $439653c37a0e6e60$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get('borderRadius')
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return bgRect;
}








var $7d83012add212fc5$var$curry = $e4c0c902d0f4f283$export$c3095a23b368d1f2;
var $7d83012add212fc5$var$each = $e4c0c902d0f4f283$export$79b2f7037acddd43;
var $7d83012add212fc5$var$Group = $0c53f0d63dde8266$export$2e2bcd8739ae039;
var $7d83012add212fc5$var$LegendView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $7d83012add212fc5$var$Group());
        this.group.add(this._selectorGroup = new $7d83012add212fc5$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get('show', true)) return;
        var itemAlign = legendModel.get('align');
        var orient = legendModel.get('orient');
        if (!itemAlign || itemAlign === 'auto') itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
        // selector has been normalized to an array in model
        var selector = legendModel.get('selector', true);
        var selectorPosition = legendModel.get('selectorPosition', true);
        if (selector && (!selectorPosition || selectorPosition === 'auto')) selectorPosition = orient === 'horizontal' ? 'end' : 'start';
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var refContainer = $52313d605bb144f5$export$5aec1e94f566e59f(legendModel, api).refContainer;
        var positionInfo = legendModel.getBoxLayoutParams();
        var padding = legendModel.get('padding');
        var maxSize = $52313d605bb144f5$export$4517a5ca639a7293(positionInfo, refContainer, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $52313d605bb144f5$export$4517a5ca639a7293($e4c0c902d0f4f283$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), refContainer, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $4be4ada7c4405f26$export$fae23936eedfad4f)(mainRect, // FXIME: most itemStyle options does not work in background because inherit is not handled yet.
        legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $e4c0c902d0f4f283$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get('selectedMode');
        var triggerEvent = legendModel.get('triggerEvent');
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
        });
        $7d83012add212fc5$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var _this = this;
            var name = legendItemModel.get('name');
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === '' || name === '\n')) {
                var g = new $7d83012add212fc5$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual('legendLineStyle') || {};
                var legendIcon = data.getVisual('legendIcon');
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual('style');
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on('click', $7d83012add212fc5$var$curry($7d83012add212fc5$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', $7d83012add212fc5$var$curry($7d83012add212fc5$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', $7d83012add212fc5$var$curry($7d83012add212fc5$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = 'legend';
                });
                if (triggerEvent) itemGroup.eachChild(function(child) {
                    _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                var _this = this;
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, 'style');
                    var legendIcon = provider.getItemVisual(idx, 'legendIcon');
                    var colorArr = (0, $30eadc8c092f368d$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $e4c0c902d0f4f283$export$8b58be045bf06082($e4c0c902d0f4f283$export$8b58be045bf06082({}, style), {
                            fill: (0, $30eadc8c092f368d$export$fac44ee5b035f737)(colorArr, 'rgba')
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on('click', $7d83012add212fc5$var$curry($7d83012add212fc5$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on('mouseover', $7d83012add212fc5$var$curry($7d83012add212fc5$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', $7d83012add212fc5$var$curry($7d83012add212fc5$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = 'legend';
                    });
                    if (triggerEvent) itemGroup.eachChild(function(child) {
                        _this.packEventData(child, legendModel, seriesModel, dataIndex, name);
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype.packEventData = function(el, legendModel, seriesModel, dataIndex, name) {
        var eventData = {
            componentType: 'legend',
            componentIndex: legendModel.componentIndex,
            dataIndex: dataIndex,
            value: name,
            seriesIndex: seriesModel.seriesIndex
        };
        (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el).eventData = eventData;
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $7d83012add212fc5$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $9f8a9b67e62609f8$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: 'center',
                    verticalAlign: 'middle'
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect',
                        legendId: legendModel.id
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel('selectorLabel');
            var emphasisLabelModel = legendModel.getModel([
                'emphasis',
                'selectorLabel'
            ]);
            (0, $83b5345ce49bb659$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $6243d8dbb37d6b0d$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get('itemWidth');
        var itemHeight = legendModel.get('itemHeight');
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get('symbolRotate');
        var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
        var legendIconType = legendItemModel.get('icon');
        legendIcon = legendIconType || legendIcon || 'roundRect';
        var style = $7d83012add212fc5$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $7d83012add212fc5$var$Group();
        var textStyleModel = legendItemModel.getModel('textStyle');
        if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon
            itemGroup.add($7d83012add212fc5$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get('formatter');
        var content = name;
        if ($e4c0c902d0f4f283$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace('{name}', name != null ? name : '');
        else if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get('inactiveColor');
        itemGroup.add(new $9f8a9b67e62609f8$export$2e2bcd8739ae039({
            style: (0, $83b5345ce49bb659$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: 'middle'
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $439653c37a0e6e60$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: 'transparent'
            }
        });
        var tooltipModel = legendItemModel.getModel('tooltip');
        if (tooltipModel.get('show')) $05f852c7feb2d530$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $6243d8dbb37d6b0d$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $52313d605bb144f5$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $52313d605bb144f5$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get('selectorButtonGap', true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? 'width' : 'height';
            var hw = orientIdx === 0 ? 'height' : 'width';
            var yx = orientIdx === 0 ? 'y' : 'x';
            if (selectorPosition === 'end') selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = 'legend.plain';
    return LegendView;
}((0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039));
function $7d83012add212fc5$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === 'auto') style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $7d83012add212fc5$var$each(style, function(propVal, propName) {
            style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel('itemStyle');
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
    var decalStyle = itemStyleModel.getShallow('decal');
    itemStyle.decal = !decalStyle || decalStyle === 'inherit' ? itemVisualStyle.decal : (0, $0481b5c792b5cb84$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === 'inherit') /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === 'inherit') /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === 'inherit') /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel('lineStyle');
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get('inactiveBorderWidth');
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get('inactiveColor');
        itemStyle.stroke = legendItemModel.get('inactiveBorderColor');
        lineStyle.stroke = legendLineModel.get('inactiveColor');
        lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $7d83012add212fc5$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || 'roundRect';
    var icon = (0, $b6180ec78eaf8763$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf('empty') > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.neutral00;
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $7d83012add212fc5$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $7d83012add212fc5$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: 'legendToggleSelect',
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $7d83012add212fc5$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $7d83012add212fc5$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    if (!api.usingTHL()) api.dispatchAction({
        type: 'highlight',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $7d83012add212fc5$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    if (!api.usingTHL()) api.dispatchAction({
        type: 'downplay',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $7d83012add212fc5$export$2e2bcd8739ae039 = $7d83012add212fc5$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $7a1b706f58b5b101$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var isAllSelect = methodName === 'allSelect' || methodName === 'inverseSelect';
    var selectedMap = {};
    var actionLegendIndices = [];
    ecModel.eachComponent({
        mainType: 'legend',
        query: payload
    }, function(legendModel) {
        if (isAllSelect) legendModel[methodName]();
        else legendModel[methodName](payload.name);
        $7a1b706f58b5b101$var$makeSelectedMap(legendModel, selectedMap);
        actionLegendIndices.push(legendModel.componentIndex);
    });
    var allSelectedMap = {};
    // make selectedMap from all legend components
    ecModel.eachComponent('legend', function(legendModel) {
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(selectedMap, function(isSelected, name) {
            // Force other legend has same selected status
            // Or the first is toggled to true and other are toggled to false
            // In the case one legend has some item unSelected in option. And if other legend
            // doesn't has the item, they will assume it is selected.
            legendModel[isSelected ? 'select' : 'unSelect'](name);
        });
        $7a1b706f58b5b101$var$makeSelectedMap(legendModel, allSelectedMap);
    });
    // Return the event explicitly
    return isAllSelect ? {
        selected: allSelectedMap,
        // return legendIndex array to tell the developers which legends are allSelect / inverseSelect
        legendIndex: actionLegendIndices
    } : {
        name: payload.name,
        selected: allSelectedMap
    };
}
function $7a1b706f58b5b101$var$makeSelectedMap(legendModel, out) {
    var selectedMap = out || {};
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(legendModel.getData(), function(model) {
        var name = model.get('name');
        // Wrap element
        if (name === '\n' || name === '') return;
        var isItemSelected = legendModel.isSelected(name);
        if ((0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(selectedMap, name)) // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
        else selectedMap[name] = isItemSelected;
    });
    return selectedMap;
}
function $7a1b706f58b5b101$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendToggleSelect', 'legendselectchanged', (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)($7a1b706f58b5b101$var$legendSelectActionHandler, 'toggleSelected'));
    registers.registerAction('legendAllSelect', 'legendselectall', (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)($7a1b706f58b5b101$var$legendSelectActionHandler, 'allSelect'));
    registers.registerAction('legendInverseSelect', 'legendinverseselect', (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)($7a1b706f58b5b101$var$legendSelectActionHandler, 'inverseSelect'));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendSelect', 'legendselected', (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)($7a1b706f58b5b101$var$legendSelectActionHandler, 'select'));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendUnSelect', 'legendunselected', (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)($7a1b706f58b5b101$var$legendSelectActionHandler, 'unSelect'));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $693a9bc7dc19b83d$export$93f5c873e193c7e3 = (0, $939d3a4c11ee87fd$export$d62c61cad9d1ab83)($693a9bc7dc19b83d$var$legendFilter);
function $693a9bc7dc19b83d$var$legendFilter(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


function $38b0c905b0735fb7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $7c4774fdb8782d51$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $7d83012add212fc5$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $693a9bc7dc19b83d$export$93f5c873e193c7e3));
    registers.registerSubTypeDefaulter('legend', function() {
        return 'plain';
    });
    (0, $7a1b706f58b5b101$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $5fc7533485eeabaa$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $52313d605bb144f5$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $5fc7533485eeabaa$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $5fc7533485eeabaa$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = 'legend.scroll';
    ScrollableLegendModel.defaultOption = (0, $b08603d2997306ff$export$68acc510e46fef2)((0, $7c4774fdb8782d51$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: 'end',
        pageFormatter: '{current}/{total}',
        pageIcons: {
            horizontal: [
                'M0,0L12,-10L12,10z',
                'M0,0L-12,-10L-12,10z'
            ],
            vertical: [
                'M0,0L20,0L10,-20z',
                'M0,0L20,0L10,20z'
            ]
        },
        pageIconColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.accent50,
        pageIconInactiveColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.accent10,
        pageIconSize: 15,
        pageTextStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.tertiary
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $7c4774fdb8782d51$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $5fc7533485eeabaa$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $52313d605bb144f5$export$1754cb91f16ca028)(target, raw, {
        type: 'box',
        ignoreSize: !!ignoreSize
    });
}
var $5fc7533485eeabaa$export$2e2bcd8739ae039 = $5fc7533485eeabaa$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $9deeafa6e1f1a96a$var$Group = $0c53f0d63dde8266$export$2e2bcd8739ae039;
var $9deeafa6e1f1a96a$var$WH = [
    'width',
    'height'
];
var $9deeafa6e1f1a96a$var$XY = [
    'x',
    'y'
];
var $9deeafa6e1f1a96a$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $9deeafa6e1f1a96a$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $9deeafa6e1f1a96a$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get('pageIconSize', true);
        var pageIconSizeArr = $e4c0c902d0f4f283$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton('pagePrev', 0);
        var pageTextStyleModel = legendModel.getModel('pageTextStyle');
        controllerGroup.add(new $9f8a9b67e62609f8$export$2e2bcd8739ae039({
            name: 'pageText',
            style: {
                // Placeholder to calculate a proper layout.
                text: 'xx/xx',
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: 'middle',
                align: 'center'
            },
            silent: true
        }));
        createPageButton('pageNext', 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + 'DataIndex';
            var icon = $05f852c7feb2d530$export$274edc73af1ae9c8(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $e4c0c902d0f4f283$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $9deeafa6e1f1a96a$var$WH[orientIdx];
        var xy = $9deeafa6e1f1a96a$var$XY[orientIdx];
        var hw = $9deeafa6e1f1a96a$var$WH[1 - orientIdx];
        var yx = $9deeafa6e1f1a96a$var$XY[1 - orientIdx];
        selector && $52313d605bb144f5$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
        var selectorButtonGap = legendModel.get('selectorButtonGap', true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $e4c0c902d0f4f283$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === 'end') selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $52313d605bb144f5$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $52313d605bb144f5$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $e4c0c902d0f4f283$export$995e01f2f5c9d030(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get('pageButtonPosition', true);
            // controller is on the right / bottom.
            if (pageButtonPosition === 'end') controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $439653c37a0e6e60$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $97d0e733871fae49$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: 'legendScroll',
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $e4c0c902d0f4f283$export$79b2f7037acddd43([
            'pagePrev',
            'pageNext'
        ], function(name) {
            var key = name + 'DataIndex';
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
                icon.cursor = canJump ? 'pointer' : 'default';
            }
        });
        var pageText = controllerGroup.childOfName('pageText');
        var pageFormatter = legendModel.get('pageFormatter');
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle('text', $e4c0c902d0f4f283$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get('scrollDataIndex', true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $9deeafa6e1f1a96a$var$WH[orientIdx];
        var xy = $9deeafa6e1f1a96a$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = 'legend.scroll';
    return ScrollableLegendView;
}((0, $7d83012add212fc5$export$2e2bcd8739ae039));
var $9deeafa6e1f1a96a$export$2e2bcd8739ae039 = $9deeafa6e1f1a96a$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $6c1704ae58ee03a9$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction('legendScroll', 'legendscroll', function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: 'legend',
            subType: 'scroll',
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $2a91fa8656cea346$export$4b3e715f166fdd78(registers) {
    (0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $38b0c905b0735fb7$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $5fc7533485eeabaa$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $9deeafa6e1f1a96a$export$2e2bcd8739ae039));
    (0, $6c1704ae58ee03a9$export$2e2bcd8739ae039)(registers);
}


function $2a9d99f4d461b636$export$4b3e715f166fdd78(registers) {
    (0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $38b0c905b0735fb7$export$4b3e715f166fdd78));
    (0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $2a91fa8656cea346$export$4b3e715f166fdd78));
}




var $752fdce10a450379$var$_a;
(0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $2a9d99f4d461b636$export$4b3e715f166fdd78));
class $752fdce10a450379$export$daedb98adc4e100e extends (0, $e105d0ae0b8f861c$export$37de6f71bb86a769) {
}
($752fdce10a450379$var$_a = globalThis.customElements) === null || $752fdce10a450379$var$_a === void 0 || $752fdce10a450379$var$_a.define('ec-legend', $752fdce10a450379$export$daedb98adc4e100e);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $6254c6bba0f480c8$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $6254c6bba0f480c8$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $6254c6bba0f480c8$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $6254c6bba0f480c8$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer');
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $6254c6bba0f480c8$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)(saveTooltipAxisInfo, 'cross', false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$6254c6bba0f480c8$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $6254c6bba0f480c8$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var triggerEmphasis = axisPointerModel.get('triggerEmphasis');
            var axisKey = $6254c6bba0f480c8$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category';
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $6254c6bba0f480c8$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $6254c6bba0f480c8$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $6254c6bba0f480c8$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $6254c6bba0f480c8$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || !coordSys.model // PENDING: radar do not have a model.
         || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(result.coordSysAxesInfo[$6254c6bba0f480c8$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $6254c6bba0f480c8$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($6254c6bba0f480c8$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $6254c6bba0f480c8$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $6254c6bba0f480c8$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $6254c6bba0f480c8$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(linkPropValue) && (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $6254c6bba0f480c8$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $6254c6bba0f480c8$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value');
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $6254c6bba0f480c8$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $6254c6bba0f480c8$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$6254c6bba0f480c8$export$d01b444bafb1a792(axisModel)];
}
function $6254c6bba0f480c8$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $6254c6bba0f480c8$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $6254c6bba0f480c8$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $6254c6bba0f480c8$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}



var $7341328d5e8aa244$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $7341328d5e8aa244$var$AxisView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $6254c6bba0f480c8$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $6254c6bba0f480c8$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $7341328d5e8aa244$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $7341328d5e8aa244$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039));
var $7341328d5e8aa244$export$2e2bcd8739ae039 = $7341328d5e8aa244$var$AxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $9073f5835d31d063$export$c884056e529a2c7a = 0;
var $9073f5835d31d063$export$a9efb7aa6faff3f6 = 1;
var $9073f5835d31d063$var$SCALE_MAPPER_METHOD_NAMES_MAP = {
    needTransform: 1,
    normalize: 1,
    scale: 1,
    transformIn: 1,
    transformOut: 1,
    contain: 1,
    getExtent: 1,
    getExtentUnsafe: 1,
    setExtent: 1,
    setExtent2: 1,
    getFilter: 1,
    sanitize: 1,
    getDefaultStartValue: 1,
    freeze: 1
};
var $9073f5835d31d063$var$SCALE_MAPPER_METHOD_NAMES = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)($9073f5835d31d063$var$SCALE_MAPPER_METHOD_NAMES_MAP);
var $9073f5835d31d063$export$2734d952320c7be9 = 2;
var $9073f5835d31d063$export$64ac424f47d39348 = 3;
function $9073f5835d31d063$export$acfc4e2d986326b7(// If input `null/undefined`, a mapper will be created.
mapper, breakParsed, initialExtent) {
    var brk;
    mapper = mapper || {};
    var scaleBreakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
    if (scaleBreakHelper) {
        var brkMapper_1 = scaleBreakHelper.createBreakScaleMapper(breakParsed, initialExtent);
        if (brkMapper_1.hasBreaks()) {
            // Some `ScaleMapper` methods (such as `normalize`) needs to be fast for large data
            // when no breaks, so mount break methods only when breaks really exist.
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($9073f5835d31d063$var$SCALE_MAPPER_METHOD_NAMES, function(methodName) {
                if (brkMapper_1[methodName]) mapper[methodName] = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(brkMapper_1[methodName], brkMapper_1);
            });
            brk = brkMapper_1;
        }
    }
    if (brk == null) $9073f5835d31d063$export$e394430c37f37688(mapper, initialExtent);
    return {
        brk: brk,
        mapper: mapper
    };
}
function $9073f5835d31d063$export$994b6d163a064f23(host, decoratedMapperMethods) {
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($9073f5835d31d063$var$SCALE_MAPPER_METHOD_NAMES, function(methodName) {
        host[methodName] = decoratedMapperMethods[methodName];
    });
}
function $9073f5835d31d063$export$85c5c680f14cd13c(host, subMapper) {
    host.freeze = (0, $e4c0c902d0f4f283$export$8793edee2d425525);
}
function $9073f5835d31d063$export$87f6c9bc988c4378(mapper) {
    return mapper.getExtentUnsafe($9073f5835d31d063$export$c884056e529a2c7a, $9073f5835d31d063$export$2734d952320c7be9);
}
function $9073f5835d31d063$export$e182c528b7826102(mapper, // NullUndefined means the outermost space.
depth) {
    return mapper.getExtentUnsafe($9073f5835d31d063$export$a9efb7aa6faff3f6, depth) || mapper.getExtentUnsafe($9073f5835d31d063$export$c884056e529a2c7a, depth);
}
function $9073f5835d31d063$export$285c6793ade939bf(mapper) {
    var extent = $9073f5835d31d063$export$e182c528b7826102(mapper, $9073f5835d31d063$export$64ac424f47d39348);
    return extent[1] - extent[0];
}
function $9073f5835d31d063$export$9a49fe71267af794(mapper) {
    var extent = mapper.getExtentUnsafe($9073f5835d31d063$export$c884056e529a2c7a, $9073f5835d31d063$export$64ac424f47d39348);
    return extent[1] - extent[0];
}
function $9073f5835d31d063$export$e394430c37f37688(// If input `null/undefined`, a mapper will be created.
mapper, initialExtent) {
    var linearMapper = mapper || {};
    var extendList = [];
    // @ts-ignore
    linearMapper._extents = extendList;
    extendList[$9073f5835d31d063$export$c884056e529a2c7a] = initialExtent ? initialExtent.slice() : (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)();
    (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(linearMapper, $9073f5835d31d063$var$linearScaleMapperMethods);
    return linearMapper;
}
var $9073f5835d31d063$var$linearScaleMapperMethods = {
    needTransform: function() {
        return false;
    },
    normalize: function(val) {
        var extent = this._extents[$9073f5835d31d063$export$a9efb7aa6faff3f6] || this._extents[$9073f5835d31d063$export$c884056e529a2c7a];
        if (extent[1] === extent[0]) return 0.5;
        return (val - extent[0]) / (extent[1] - extent[0]);
    },
    scale: function(val) {
        var extent = this._extents[$9073f5835d31d063$export$a9efb7aa6faff3f6] || this._extents[$9073f5835d31d063$export$c884056e529a2c7a];
        return val * (extent[1] - extent[0]) + extent[0];
    },
    transformIn: function(val) {
        return val;
    },
    transformOut: function(val) {
        return val;
    },
    contain: function(val) {
        // This method is typically used in axis trigger and markers.
        // Users may be confused if the extent is restricted to `SCALE_EXTENT_KIND_EFFECTIVE`.
        var extent = $9073f5835d31d063$export$e182c528b7826102(this, null);
        return val >= extent[0] && val <= extent[1];
    },
    getExtent: function() {
        return this._extents[$9073f5835d31d063$export$c884056e529a2c7a].slice();
    },
    getExtentUnsafe: function(kind) {
        return this._extents[kind];
    },
    setExtent: function(start, end) {
        $9073f5835d31d063$var$writeExtent(this._extents, $9073f5835d31d063$export$c884056e529a2c7a, start, end);
    },
    setExtent2: function(kind, start, end) {
        var extentList = this._extents;
        if (!extentList[kind]) extentList[kind] = extentList[$9073f5835d31d063$export$c884056e529a2c7a].slice();
        $9073f5835d31d063$var$writeExtent(extentList, kind, start, end);
    },
    freeze: function() {}
};
function $9073f5835d31d063$var$writeExtent(extentList, kind, start, end) {
    // NOTE: `NaN` should be excluded. e.g., `scaleRawExtentInfo.resultMinMax` may be `[NaN, NaN]`.
    if ((0, $939d3a4c11ee87fd$export$d386653f29930adb)(start, end)) {
        extentList[kind][0] = start;
        extentList[kind][1] = end;
    }
} // ------ END: Linear Scale Mapper ------


function $27a07c2e80a6e56f$export$dfc8cd28ed7b22a0(scale) {
    return $27a07c2e80a6e56f$export$ba0fcad386c5c7e6(scale) || $27a07c2e80a6e56f$export$8b1d8a59aa13c502(scale);
}
function $27a07c2e80a6e56f$export$cd3b833884a8d62c(scale) {
    return $27a07c2e80a6e56f$export$ba0fcad386c5c7e6(scale) || $27a07c2e80a6e56f$export$c9b71a3750db342f(scale);
}
function $27a07c2e80a6e56f$export$ba0fcad386c5c7e6(scale) {
    return scale.type === 'interval';
}
function $27a07c2e80a6e56f$export$c9b71a3750db342f(scale) {
    return scale.type === 'time';
}
function $27a07c2e80a6e56f$export$8b1d8a59aa13c502(scale) {
    return scale.type === 'log';
}
function $27a07c2e80a6e56f$export$61579433626afe87(scale) {
    return scale.type === 'ordinal';
}
function $27a07c2e80a6e56f$export$eeea879a611eb991(extent, spanWithBreaks, splitNumber, minInterval, maxInterval) {
    var result = {};
    var interval = result.interval = (0, $0b2f7076fd7740ca$export$7a695fe44258210b)(spanWithBreaks / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    var precision = result.intervalPrecision = $27a07c2e80a6e56f$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    result.niceTickExtent = [
        (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$cf129980c996e186)(extent[0] / interval) * interval, precision),
        (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$c6301bc99a7f80a7)(extent[1] / interval) * interval, precision)
    ];
    return result;
}
function $27a07c2e80a6e56f$export$f39031e8422f329d(niceInterval) {
    var exponent = (0, $0b2f7076fd7740ca$export$97256a17b20a0c24)(niceInterval);
    // No rounding error in Math.pow(10, integer).
    var exp10 = (0, $0b2f7076fd7740ca$export$858b42c97efc7084)(10, exponent);
    // Fix IEEE 754 float rounding error
    var f = (0, $0b2f7076fd7740ca$export$42cacde8c45786ff)(niceInterval / exp10);
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    // Fix IEEE 754 float rounding error
    return (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(f * exp10, -exponent);
}
function $27a07c2e80a6e56f$export$86a060b060d3d31a(niceInterval) {
    // Tow more digital for tick.
    // NOTE: `2` was introduced in commit `af2a2a9f6303081d7c3b52f0a38add07b4c6e0c7`;
    // it works on "nice" interval, but seems not necessarily mathematically required.
    return (0, $0b2f7076fd7740ca$export$e0c74b50bbd10f68)(niceInterval) + 2;
}
function $27a07c2e80a6e56f$export$7854dd225b5d5704(val, base) {
    // NOTE:
    //  - rounding error may happen above, typically expecting `log10(1000)` but actually
    //    getting `2.9999999999999996`, but generally it does not matter since they are not
    //    used to display.
    //  - Consider backward compatibility and other log bases, do not use `Math.log10`.
    return (0, $0b2f7076fd7740ca$export$f0e980411e05f912)(val) / (0, $0b2f7076fd7740ca$export$f0e980411e05f912)(base);
}
function $27a07c2e80a6e56f$export$73e21863d9c0dcd3(// `tickVal` should be in the linear space.
linearTickVal, base, opt) {
    var lookup = opt && opt.lookup;
    if (lookup) for(var i = 0; i < lookup.from.length; i++){
        if (linearTickVal === lookup.from[i]) return lookup.to[i];
    }
    return (0, $0b2f7076fd7740ca$export$858b42c97efc7084)(base, linearTickVal);
}
function $27a07c2e80a6e56f$export$e279d7ed1695209d(rawExtent, fixMinMax, rawExtentResult) {
    var extent = rawExtent.slice();
    // PENDING:
    //  This implementation is not rigorous, but has long been in use.
    // If extent start and end are same, expand them
    if (extent[0] === extent[1]) {
        // If `containShape`, the extent must be evenly distributed to both sides;
        // otherwise, shape (e.g., bars) may be overflow and clipped.
        var containShapeRequired = rawExtentResult && rawExtentResult.ctnShp;
        if (extent[0] !== 0) {
            // Expand extent
            // Note that extents can be both negative. See #13154
            var expandSize = (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(extent[0]);
            // In the fowllowing case
            //      Axis has been fixed max 100
            //      Plus data are all 100 and axis extent are [100, 100].
            // Extend to the both side will cause expanded max is larger than fixed max.
            // So only expand to the smaller side.
            if (!fixMinMax[1]) {
                extent[1] += expandSize / 2;
                extent[0] -= expandSize / 2;
            } else extent[0] -= expandSize / 2;
        } else if (containShapeRequired) {
            extent[0] = -1;
            extent[1] = 1;
        } else extent[1] = 1;
    }
    // For example, if there are no series data, extent may be `[Infinity, -Infinity]` here.
    if (!(0, $939d3a4c11ee87fd$export$5af06089290883e2)(extent[0]) || !(0, $939d3a4c11ee87fd$export$5af06089290883e2)(extent[1])) {
        extent[0] = 0;
        extent[1] = 1;
    }
    if (extent[1] < extent[0]) extent.reverse();
    return extent;
}
function $27a07c2e80a6e56f$export$2b240c817ac5c4f(extent1, extent2) {
    return [
        extent1[0] !== extent2[0],
        extent1[1] !== extent2[1]
    ];
}
function $27a07c2e80a6e56f$export$b801ba4e5ad70a4a(rawSplitNumber, defaultSplitNumber) {
    rawSplitNumber = rawSplitNumber || defaultSplitNumber;
    return (0, $0b2f7076fd7740ca$export$42cacde8c45786ff)((0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(rawSplitNumber, 1));
}
function $27a07c2e80a6e56f$export$1039c7e66c46a7fd(ordinalScale, // `categoryInterval` is the number part of `CategoryTickLabelSplitIntervalOption`.
categoryInterval, addItem) {
    var extent = (0, $9073f5835d31d063$export$87f6c9bc988c4378)(ordinalScale);
    var startTick = extent[0];
    var tickCount = ordinalScale.count();
    var step = Math.max((categoryInterval || 0) + 1, 1);
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // min max labels may be excluded if `startTick > 0`, but they should be always
    // included and the label display strategy is adopted uniformly later in `AxisBuilder`.
    if (startTick !== extent[0]) addItemInternally(extent[0], true, true);
    var tickValue = startTick;
    for(; tickValue <= extent[1]; tickValue += step)addItemInternally(tickValue, false, tickValue === extent[0] || tickValue === extent[1]);
    if (tickValue - step !== extent[1]) addItemInternally(extent[1], true, true);
    function addItemInternally(tickValue, offInterval, isExtentBoundary) {
        addItem({
            value: tickValue,
            offInterval: offInterval
        }, isExtentBoundary);
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $e25c2a392bb1e248$var$callOnlyOnce = (0, $939d3a4c11ee87fd$export$a305e9b27fd23ae3)();
var $e25c2a392bb1e248$export$ba567ca71745149b = '|&';
var $e25c2a392bb1e248$var$ecModelCacheFullUpdateInner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $e25c2a392bb1e248$export$3faff2d166c13471 = -2;
var $e25c2a392bb1e248$export$5e218fe556c51ff0 = -1;
var $e25c2a392bb1e248$var$ecModelCachePrepareInner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $e25c2a392bb1e248$var$validateInputAxis;
function $e25c2a392bb1e248$var$getAxisStatPerKeyPerAxis(axis, axisStatKey) {
    var axisModel = axis.model;
    var keyed = $e25c2a392bb1e248$var$ecModelCacheFullUpdateInner((0, $6e6e84884711664e$export$14434b56aab40385)(axisModel.ecModel)).keyed;
    var perKey = keyed && keyed.get(axisStatKey);
    return perKey && perKey.get(axisModel.uid);
}
function $e25c2a392bb1e248$export$bf9727b05f222b53(axis, axisStatKey) {
    return $e25c2a392bb1e248$var$wrapStatResult($e25c2a392bb1e248$var$getAxisStatPerKeyPerAxis(axis, axisStatKey));
}
function $e25c2a392bb1e248$export$89af6c808d6573fd(axis, seriesList) {
    var result = [];
    $e25c2a392bb1e248$var$eachKeyEachAxis(axis.model.ecModel, function(perKeyPerAxis) {
        for(var idx = 0; idx < seriesList.length; idx++)if (seriesList[idx] && perKeyPerAxis.serByIdx[seriesList[idx].seriesIndex]) result.push($e25c2a392bb1e248$var$wrapStatResult(perKeyPerAxis));
    });
    return result;
}
function $e25c2a392bb1e248$var$eachKeyEachAxis(ecModel, cb) {
    var keyed = $e25c2a392bb1e248$var$ecModelCacheFullUpdateInner((0, $6e6e84884711664e$export$14434b56aab40385)(ecModel)).keyed;
    keyed && keyed.each(function(perKey, axisStatKey) {
        perKey.each(function(perKeyPerAxis, axisModelUid) {
            cb(perKeyPerAxis, axisStatKey, axisModelUid);
        });
    });
}
function $e25c2a392bb1e248$var$wrapStatResult(record) {
    return {
        liPosMinGap: record ? record.liPosMinGap : undefined
    };
}
function $e25c2a392bb1e248$export$cee01bd2e39d754e(axis, cb) {
    var ecModel = axis.model.ecModel;
    var seriesOnAxisMap = $e25c2a392bb1e248$var$ecModelCacheFullUpdateInner((0, $6e6e84884711664e$export$14434b56aab40385)(ecModel)).axSer;
    seriesOnAxisMap && $e25c2a392bb1e248$export$bf07bebae360b2fc(ecModel, seriesOnAxisMap.get(axis.model.uid), cb);
}
function $e25c2a392bb1e248$export$ef6bd388c274421f(axis, axisStatKey, cb) {
    var perKeyPerAxis = $e25c2a392bb1e248$var$getAxisStatPerKeyPerAxis(axis, axisStatKey);
    perKeyPerAxis && $e25c2a392bb1e248$export$bf07bebae360b2fc(axis.model.ecModel, perKeyPerAxis.sers, cb);
}
function $e25c2a392bb1e248$export$bf07bebae360b2fc(ecModel, seriesList, cb) {
    if (!seriesList) return;
    for(var i = 0; i < seriesList.length; i++){
        var seriesModel = seriesList[i];
        // Legend-filtered series need to be ignored since series are registered before `legendFilter`.
        if (!ecModel.isSeriesFiltered(seriesModel)) cb(seriesModel);
    }
}
function $e25c2a392bb1e248$export$5351a7fee08ae808(axis, axisStatKey) {
    var perKeyPerAxis = $e25c2a392bb1e248$var$getAxisStatPerKeyPerAxis(axis, axisStatKey);
    if (!perKeyPerAxis || !perKeyPerAxis.sers.length) return 0;
    var count = 0;
    $e25c2a392bb1e248$export$bf07bebae360b2fc(axis.model.ecModel, perKeyPerAxis.sers, function() {
        count++;
    });
    return count;
}
function $e25c2a392bb1e248$export$37f432351be0ca61(ecModel, axisStatKey, cb) {
    var keyed = $e25c2a392bb1e248$var$ecModelCacheFullUpdateInner((0, $6e6e84884711664e$export$14434b56aab40385)(ecModel)).keyed;
    var perKey = keyed && keyed.get(axisStatKey);
    perKey && perKey.each(function(perKeyPerAxis) {
        cb(perKeyPerAxis.axis);
    });
}
function $e25c2a392bb1e248$export$21f2993d5751eb66(axis, cb) {
    var model = axis.model;
    var keysByAxisModelUid = $e25c2a392bb1e248$var$ecModelCacheFullUpdateInner((0, $6e6e84884711664e$export$14434b56aab40385)(model.ecModel)).keys;
    keysByAxisModelUid && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(keysByAxisModelUid.get(model.uid), function(axisStatKey) {
        var stat;
        cb(axisStatKey);
    });
}
/**
 * NOTICE: this processor may be omitted - it is registered only if required.
 */ function $e25c2a392bb1e248$var$performAxisStatisticsOnOverallReset(ecModel) {
    var ecPrepareCache = $e25c2a392bb1e248$var$ecModelCachePrepareInner((0, $6e6e84884711664e$export$67fb26d0f4e31b9e)(ecModel));
    var ecPrepareCacheKeyed = ecPrepareCache.keyed || (ecPrepareCache.keyed = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)());
    $e25c2a392bb1e248$var$eachKeyEachAxis(ecModel, function(perKeyPerAxis, axisStatKey, axisModelUid) {
        var ecPrepareCachePerKey = ecPrepareCacheKeyed.get(axisStatKey) || ecPrepareCacheKeyed.set(axisStatKey, (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)());
        var ecPreparePerKeyPerAxis = ecPrepareCachePerKey.get(axisModelUid) || ecPrepareCachePerKey.set(axisModelUid, {});
        if (perKeyPerAxis.metrics.liPosMinGap) // We should assert the impl exists -- fail-fast if missing `registerMetricImpl`.
        $e25c2a392bb1e248$var$_metricImpl.liPosMinGap(ecModel, perKeyPerAxis, ecPreparePerKeyPerAxis);
    });
}
function $e25c2a392bb1e248$export$5ce2ad54acb7c055(metricType, impl) {
    $e25c2a392bb1e248$var$_metricImpl[metricType] = impl;
}
var $e25c2a392bb1e248$var$_metricImpl = {};
function $e25c2a392bb1e248$export$48507d392d1d4894(axis, seriesModel, coordSysType) {
    if (!axis) return;
    var ecModel = seriesModel.ecModel;
    var ecFullUpdateCache = $e25c2a392bb1e248$var$ecModelCacheFullUpdateInner((0, $6e6e84884711664e$export$14434b56aab40385)(ecModel));
    var axisModelUid = axis.model.uid;
    var axSerPairCheck, pairKey;
    var seriesOnAxisMap = ecFullUpdateCache.axSer || (ecFullUpdateCache.axSer = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)());
    var seriesListPerAxis = seriesOnAxisMap.get(axisModelUid) || seriesOnAxisMap.set(axisModelUid, []);
    var lastSeries;
    seriesListPerAxis.push(seriesModel);
    var seriesType = seriesModel.subType;
    var isBaseAxis = seriesModel.getBaseAxis() === axis;
    var client = $e25c2a392bb1e248$var$clientsForLookup.get($e25c2a392bb1e248$var$makeClientLookupKey(seriesType, isBaseAxis, coordSysType)) || $e25c2a392bb1e248$var$clientsForLookup.get($e25c2a392bb1e248$var$makeClientLookupKey(seriesType, isBaseAxis, null));
    if (!client) return;
    var keyed = ecFullUpdateCache.keyed || (ecFullUpdateCache.keyed = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)());
    var keys = ecFullUpdateCache.keys || (ecFullUpdateCache.keys = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)());
    var axisStatKey = client.key;
    var perKey = keyed.get(axisStatKey) || keyed.set(axisStatKey, (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)());
    var perKeyPerAxis = perKey.get(axisModelUid);
    if (!perKeyPerAxis) {
        perKeyPerAxis = perKey.set(axisModelUid, {
            axis: axis,
            sers: [],
            serByIdx: []
        });
        // They should only be executed for each <key, axis> pair once:
        perKeyPerAxis.metrics = client.getMetrics(axis);
        (keys.get(axisModelUid) || keys.set(axisModelUid, [])).push(axisStatKey);
    }
    // series order should respect to the input order.
    perKeyPerAxis.sers.push(seriesModel);
    perKeyPerAxis.serByIdx[seriesModel.seriesIndex] = seriesModel;
}
/**
 * NOTE: Currently, the scenario is simple enough to look up clients by hash map.
 * Otherwise, a caller-provided `filter` may be an alternative if more complex requirements arise.
 */ function $e25c2a392bb1e248$var$makeClientLookupKey(seriesType, isBaseAxis, coordSysType) {
    return seriesType + $e25c2a392bb1e248$export$ba567ca71745149b + (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(isBaseAxis, true) + $e25c2a392bb1e248$export$ba567ca71745149b + (coordSysType || '');
}
function $e25c2a392bb1e248$export$ad2364183e23f875(registers, client) {
    var clientKey = $e25c2a392bb1e248$var$makeClientLookupKey(client.seriesType, client.baseAxis, client.coordSysType);
    $e25c2a392bb1e248$var$clientsForLookup.set(clientKey, client);
    $e25c2a392bb1e248$var$callOnlyOnce(registers, function() {
        registers.registerProcessor(registers.PRIORITY.PROCESSOR.AXIS_STATISTICS, {
            // NOTE: Theoretically, `appendData` requires `dirtyOnOverallProgress: true` here to re-calculate them.
            // But this OVERALL_STAGE_TASK is applied to all series (no `getTargetSeries` specified),
            // `dirtyOnOverallProgress: true` can cause irrelevant series (e.g., series on geo)
            // to be re-rendered when `appendData` is called, which cause `appendData` meaningless,
            // thereby not setting `dirtyOnOverallProgress: true`.
            overallReset: $e25c2a392bb1e248$var$performAxisStatisticsOnOverallReset
        });
    });
}
var $e25c2a392bb1e248$var$clientsForCheckingStatKey;
var $e25c2a392bb1e248$var$clientsForLookup = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();



// Arbitrary, leave some space to avoid overflowing when dataZoom moving.
var $6d521ceff1ab94af$var$FALLBACK_BAND_WIDTH_RATIO = 0.8;
function $6d521ceff1ab94af$export$141021262b29d96e(axis, opt) {
    opt = opt || {};
    var out = {
        w: NaN,
        w2: NaN
    };
    var scale = axis.scale;
    var fromStat = opt.fromStat;
    var min = opt.min;
    // [BAND_WIDTH_USED_SCALE_LINEAR_SPAN]
    //  - Band width should always respect to the currently specified extent, and `SCALE_EXTENT_KIND_MAPPING`
    //    should be used if specified.
    //    Otherwise, the result may incorrect, especially when data count is small.
    //    For example, when "containShape" is calculating, no `SCALE_EXTENT_KIND_MAPPING` is set, so here only
    //    `SCALE_EXTENT_KIND_EFFECTIVE` is returned, say, `[3, 5]`, based on which a `SCALE_EXTENT_KIND_MAPPING`
    //    is calculated, say `[2.5, 5.5]` (expanded by `0.5`). Then when rendering, that `SCALE_EXTENT_KIND_MAPPING`
    //    is returned here.
    //    See AXIS_CONTAIN_SHAPE_COMMON_STRATEGY for more details.
    //  - The span should be in the linear space (typically, the innermost space).
    //  - We use the scale extent after being zoommed and `intervalScaleEnsureValidExtent`-ish applied and
    //    "nice"/"align" applied, because:
    //    - For OrdinalScale, fine;
    //    - For numeric scale, `scaleLinearSpan` is normally not used for a consistent result when `dataZoom`
    //      is applied, but used when none or single data item case.
    var scaleLinearSpan = (0, $9073f5835d31d063$export$285c6793ade939bf)(scale);
    if (!(0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(scaleLinearSpan)) // scale may be `[Infinity, -Infinity]`.
    scaleLinearSpan = NaN;
    var axisExtent = axis.getExtent();
    // Always use a new pxSpan because it may be changed in `grid` contain label calculation.
    var pxSpan = (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(axisExtent[1] - axisExtent[0]);
    if ((0, $27a07c2e80a6e56f$export$61579433626afe87)(scale)) $6d521ceff1ab94af$var$calcBandWidthForCategoryAxis(out, axis, scaleLinearSpan, pxSpan);
    else if (fromStat) $6d521ceff1ab94af$var$calcBandWidthForNumericAxis(out, axis, scaleLinearSpan, pxSpan, fromStat);
    else min;
    if (min != null) out.w = (0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(out.w) ? (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(min, out.w) : min;
    return out;
}
function $6d521ceff1ab94af$var$calcBandWidthForCategoryAxis(out, axis, scaleLinearSpan, pxSpan) {
    var onBand = axis.onBand;
    var len = scaleLinearSpan + (onBand ? 1 : 0);
    // Fix #2728, avoid NaN when only one data.
    len === 0 && (len = 1);
    out.w = pxSpan / len;
    // NOTE:
    //  - When `scaleLinearSpan === 0`, no need to expand extent.
    //  - `onBand: true` (`boundaryGap: true`) does not need to support `containShape`,
    //    thereby no `invRatio`.
    if (!onBand && scaleLinearSpan && pxSpan) out.w2 = out.w * scaleLinearSpan / pxSpan;
}
function $6d521ceff1ab94af$var$calcBandWidthForNumericAxis(out, axis, scaleLinearSpan, pxSpan, fromStat) {
    var onlySingular = false;
    var bandWidthInData = -Infinity;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(fromStat.key ? [
        (0, $e25c2a392bb1e248$export$bf9727b05f222b53)(axis, fromStat.key)
    ] : (0, $e25c2a392bb1e248$export$89af6c808d6573fd)(axis, fromStat.sers || []), function(stat) {
        var liPosMinGap = stat.liPosMinGap;
        // NOTE: `liPosMinGap == null` may indicate that `requireAxisStatistics`
        // is not used by any series on this axis. We should not make `bandWidth`
        // for this case.
        if (liPosMinGap != null) {
            if (liPosMinGap > 0) {
                if (liPosMinGap > bandWidthInData) bandWidthInData = liPosMinGap;
                onlySingular = false;
            } else if (liPosMinGap === (0, $e25c2a392bb1e248$export$3faff2d166c13471)) onlySingular = true;
        }
    });
    if ((0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(scaleLinearSpan) && scaleLinearSpan > 0 && (0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(bandWidthInData)) {
        out.w = pxSpan / scaleLinearSpan * bandWidthInData;
        out.w2 = bandWidthInData;
    } else if (onlySingular) {
        // This is the special handing for single value case, where min gap can not
        // be calculated, but `w` and `w2` (for "containShape") are still needed.
        out.w = pxSpan * $6d521ceff1ab94af$var$FALLBACK_BAND_WIDTH_RATIO;
        out.w2 = out.w * scaleLinearSpan / pxSpan;
    // Consider an axis has both candlestick and bar series, where candlestick has multiple data
    // but the bar series has no data. In this case, that bar series should be ignored; otherwise,
    // the axis will be significantly expanded by "containShape" but no bar shape displayed.
    }
}


var $f3964596ebdf82ae$var$inner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $f3964596ebdf82ae$var$clone = $e4c0c902d0f4f283$export$9cd59f9826255e47;
var $f3964596ebdf82ae$var$bind = $e4c0c902d0f4f283$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $f3964596ebdf82ae$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status');
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $05f852c7feb2d530$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $e4c0c902d0f4f283$export$c3095a23b368d1f2($f3964596ebdf82ae$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $f3964596ebdf82ae$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap');
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && (0, $6d521ceff1ab94af$export$141021262b29d96e)(axis).w > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $6254c6bba0f480c8$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $f3964596ebdf82ae$var$inner(group).pointerEl = new $05f852c7feb2d530$exports[pointerOption.type]($f3964596ebdf82ae$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $f3964596ebdf82ae$var$inner(group).labelEl = new $05f852c7feb2d530$exports.Text($f3964596ebdf82ae$var$clone(elOption.label));
            group.add(labelEl);
            $f3964596ebdf82ae$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $f3964596ebdf82ae$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $f3964596ebdf82ae$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $f3964596ebdf82ae$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $05f852c7feb2d530$exports.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function(e) {
                    // For mobile device, prevent screen slider on the button.
                    $1aba4b63ed27962a$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $f3964596ebdf82ae$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $f3964596ebdf82ae$var$bind(this._onHandleDragMove, this),
                ondragend: $f3964596ebdf82ae$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $f3964596ebdf82ae$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ]));
        // update position
        var handleSize = handleModel.get('size');
        if (!$e4c0c902d0f4f283$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $3a19e7f2dc31be9c$export$958e3e1a02eac4b6(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $f3964596ebdf82ae$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $f3964596ebdf82ae$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($f3964596ebdf82ae$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($f3964596ebdf82ae$var$getHandleTransProps(trans));
        $f3964596ebdf82ae$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value');
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $3a19e7f2dc31be9c$export$42ffd38884aecdac(this, '_doDispatchAxisPointer');
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $f3964596ebdf82ae$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$f3964596ebdf82ae$var$propsEqual($f3964596ebdf82ae$var$inner(el).lastProp, props)) {
        $f3964596ebdf82ae$var$inner(el).lastProp = props;
        moveAnimation ? $05f852c7feb2d530$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $f3964596ebdf82ae$var$propsEqual(lastProps, newProps) {
    if ($e4c0c902d0f4f283$export$a6cdc56e425d0d0a(lastProps) && $e4c0c902d0f4f283$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $e4c0c902d0f4f283$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $f3964596ebdf82ae$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $f3964596ebdf82ae$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $f3964596ebdf82ae$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $f3964596ebdf82ae$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $f3964596ebdf82ae$export$2e2bcd8739ae039 = $f3964596ebdf82ae$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1f14cdb63fc595e5$var$Scale = /** @class */ function() {
    function Scale() {}
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   *
   * @final NEVER override!
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   *
   * @final NEVER override!
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$01f767c32eb84395$export$241315e45585454d($1f14cdb63fc595e5$var$Scale);
var $1f14cdb63fc595e5$export$2e2bcd8739ae039 = $1f14cdb63fc595e5$var$Scale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $62a778875ac6ef86$var$uidBase = 0;
var $62a778875ac6ef86$var$OrdinalMeta = /** @class */ function() {
    /**
   * PENDING - Regarding forcibly converting to string:
   *  In the early days, the underlying hash map impl used JS plain object and converted the key to
   *  string; later in https://github.com/ecomfe/zrender/pull/966 it was changed to a JS Map (in supported
   *  platforms), which does not require string keys. But consider any input that `scale/Ordinal['parse']`
   *  is involved, a number input represents an `OrdinalNumber` (i.e., an index), and affect the query
   *  behavior:
   *    - If forcbily converting to string:
   *      pros: users can use numeric string (such as, '123') to query the raw data (123), tho it's probably
   *      still confusing.
   *      cons: NaN/null/undefined in data will be equals to 'NaN'/'null'/'undefined', if simply using
   *      `val + ''` to convert them, like currently `getName` does.
   *    - Otherwise:
   *      pros: see NaN/null/undefined case above.
   *      cons: users cannot query the raw data (123) any more.
   *  There are two inconsistent behaviors in the current impl:
   *    - Force conversion is applied on the case `xAxis{data: ['aaa', 'bbb', ...]}`,
   *      but no conversion applied to the case `xAxis{data: [{value: 'aaa'}, ...]}` and
   *      the case `dataset: {source: [['aaa', 123], ['bbb', 234], ...]}`.
   *    - behaves differently according to whether JS Map is supported (the polyfill is simply using JS
   *      plain object) (tho it seems rare platform that do not support it).
   *  Since there's no sufficient good solution to offset cost of the breaking change, we preserve the
   *  current behavior, until real issues is reported.
   */ function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$62a778875ac6ef86$var$uidBase;
        this._onCollect = opt.onCollect;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(data, $62a778875ac6ef86$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $e4c0c902d0f4f283$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            this._onCollect && this._onCollect(category, index);
            return index;
        }
        var map = this._getOrCreateMap();
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                map.set(category, index);
                this._onCollect && this._onCollect(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $62a778875ac6ef86$var$getName(obj) {
    if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $62a778875ac6ef86$export$2e2bcd8739ae039 = $62a778875ac6ef86$var$OrdinalMeta;






var $ebeae9bf0b90a070$var$OrdinalScale = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = 'ordinal';
        _this.parse = OrdinalScale.parse;
        (0, $9073f5835d31d063$export$994b6d163a064f23)(_this, OrdinalScale.decoratedMethods);
        var ordinalMeta = setting.ordinalMeta;
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $62a778875ac6ef86$export$2e2bcd8739ae039)({});
        if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $62a778875ac6ef86$export$2e2bcd8739ae039)({
            categories: (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        // Create an interval LinearScaleMapper, and decorate it.
        var res = (0, $9073f5835d31d063$export$acfc4e2d986326b7)(null, null, // Do not support break in OrdinalScale yet.
        setting.extent || [
            0,
            ordinalMeta.categories.length - 1
        ]);
        _this._mapper = res.mapper;
        (0, $9073f5835d31d063$export$85c5c680f14cd13c)(_this, res.mapper);
        return _this;
    }
    OrdinalScale.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) val = NaN;
        else if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(val)) {
            val = this._ordinalMeta.getOrdinal(val);
            if (val == null) val = NaN;
        } else // The val from user input might be float.
        val = (0, $0b2f7076fd7740ca$export$42cacde8c45786ff)(val);
        return val;
    };
    /**
   * PENDING: currently this method is not used.
   * `makeCategoryTicks` is effectively used.
   */ OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        (0, $27a07c2e80a6e56f$export$1039c7e66c46a7fd)(this, 0, function(tick) {
            ticks.push(tick);
        });
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = ordinalsByTick[tickNum] = infoOrdinalNumbers[tickNum];
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick[tickNum] = unusedOrdinal;
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tick.value);
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * value may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`,
   * where ordinal numbers are used as tick value directly.
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickValue) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        return ordinalNumbersByTick && tickValue >= 0 && tickValue < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickValue] : tickValue;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var category = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return category == null ? '' : category + '';
        }
    };
    /**
   * NOTICE: This is different from `.getOrdinalMeta().length` when extent
   * is specified by `xxxAxis.min/max` or by `dataZoom`.
   */ OrdinalScale.prototype.count = function() {
        var extent = (0, $9073f5835d31d063$export$87f6c9bc988c4378)(this._mapper);
        return extent[1] - extent[0] + 1;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.type = 'ordinal';
    OrdinalScale.decoratedMethods = {
        needTransform: function() {
            return this._mapper.needTransform();
        },
        contain: function(val) {
            return this._mapper.contain(this._getTickNumber(val)) && val >= 0 && val < this._ordinalMeta.categories.length;
        },
        normalize: function(val) {
            return this._mapper.normalize(this._getTickNumber(val));
        },
        scale: function(val) {
            return this.getRawOrdinalNumber((0, $0b2f7076fd7740ca$export$42cacde8c45786ff)(this._mapper.scale(val)));
        },
        transformIn: function(val, opt) {
            return this._mapper.transformIn(this._getTickNumber(val), opt);
        },
        transformOut: function(val, opt) {
            return this.getRawOrdinalNumber(this._mapper.transformOut(val, opt));
        },
        getExtent: function() {
            return this._mapper.getExtent();
        },
        getExtentUnsafe: function(kind, depth) {
            return this._mapper.getExtentUnsafe(kind, depth);
        },
        /**
     * NOTICE: OrdinalScale extent should always originates from
     * `[0, ordinalMeta.categories.length - 1]`, regardless of min/max of `series.data`.
     * But settings like `xxxAxis.min/max` can still modify the extent.
     * It is handled by constructor of `ScaleRawExtentInfo`.
     */ setExtent: function(start, end) {
            return this._mapper.setExtent(start, end);
        },
        setExtent2: function(kind, start, end) {
            return this._mapper.setExtent2(kind, start, end);
        }
    };
    return OrdinalScale;
}((0, $1f14cdb63fc595e5$export$2e2bcd8739ae039));
(0, $1f14cdb63fc595e5$export$2e2bcd8739ae039).registerClass($ebeae9bf0b90a070$var$OrdinalScale);
var $ebeae9bf0b90a070$export$2e2bcd8739ae039 = $ebeae9bf0b90a070$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $37aae0fe210a1ee2$export$e2d43952c5db22bb(scale, splitNumber, breaks, scaleInterval) {
    var ticks = scale.getTicks({
        expandToNicedExtent: true
    });
    // NOTE: In log-scale, do not support minor ticks when breaks exist.
    //  because currently log-scale minor ticks is calculated based on raw values
    //  rather than log-transformed value, due to an odd effect when breaks exist.
    var minorTicks = [];
    var extent = scale.getExtent();
    for(var i = 1; i < ticks.length; i++){
        var nextTick = ticks[i];
        var prevTick = ticks[i - 1];
        if (prevTick["break"] || nextTick["break"]) continue;
        var count = 0;
        var minorTicksGroup = [];
        var interval = nextTick.value - prevTick.value;
        var minorInterval = interval / splitNumber;
        var minorIntervalPrecision = (0, $27a07c2e80a6e56f$export$86a060b060d3d31a)(minorInterval);
        while(count < splitNumber - 1){
            var minorTick = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(prevTick.value + (count + 1) * minorInterval, minorIntervalPrecision);
            // For the first and last interval. The count may be less than splitNumber.
            if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
            count++;
        }
        var scaleBreakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
        scaleBreakHelper && scaleBreakHelper.pruneTicksByBreak('auto', minorTicksGroup, breaks, function(value) {
            return value;
        }, scaleInterval, extent);
        minorTicks.push(minorTicksGroup);
    }
    return minorTicks;
}




var $ce5a28c78d8c3fff$var$IntervalScale = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = 'interval';
        _this.parse = IntervalScale.parse;
        setting = setting || {};
        var breakParsed = (0, $88f2be8efb09cff5$export$770ec3eb53b5689b)(_this, setting);
        var res = (0, $9073f5835d31d063$export$acfc4e2d986326b7)(_this, breakParsed, null);
        // @ts-ignore
        _this.brk = res.brk;
        _this._cfg = {
            interval: 0,
            intervalPrecision: 2,
            intervalCount: undefined,
            niceExtent: undefined
        };
        return _this;
    }
    IntervalScale.parse = function(val) {
        // `Scale#parse` (and its overrids) are typically applied at the axis values input
        // in echarts option. e.g., `axis.min/max`, `dataZoom.min/max`, etc.
        // but `series.data` is not included, which uses `dataValueHelper.ts`#`parseDataValue`.
        // `Scale#parse` originally introduced in fb8c813215098b9d2458966229bb95c510883d5e
        // at 2016 for dataZoom start/end settings (See `parseAxisModelMinMax`).
        //
        // Historically `scale/Interval.ts` returns the input value directly. But numeric
        // values (such as a number-like string '123') effectively passed through here and
        // were involved in calculations, which was error-prone and inconsistent with the
        // declared TS return type. Previously such issues are fixed separately in different
        // places case by case (such as #2475).
        //
        // Now, we perform actual parse to ensure its `number` type here. The parsing rule
        // follows the series data parsing rule (`dataValueHelper.ts`#`parseDataValue`)
        // and maintains compatibility as much as possible (thus a more strict parsing
        // `number.ts`#`numericToNumber` is not used here.)
        //
        // FIXME: `ScaleDataValue` also need to be modified to include numeric string type,
        //  since it effectively does.
        return val == null || val === '' ? NaN : Number(val);
    };
    IntervalScale.prototype.getConfig = function() {
        return (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(this._cfg);
    };
    IntervalScale.prototype.setConfig = function(cfg) {
        var extent = (0, $9073f5835d31d063$export$87f6c9bc988c4378)(this);
        // Reset all.
        this._cfg = cfg = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(cfg);
        if (cfg.niceExtent == null) // Dropped the auto calculated niceExtent and use user-set extent.
        // We assume users want to set both interval and extent to get a better result.
        cfg.niceExtent = extent.slice();
        if (cfg.intervalPrecision == null) cfg.intervalPrecision = (0, $27a07c2e80a6e56f$export$86a060b060d3d31a)(cfg.interval);
    };
    /**
   * In ascending order.
   */ IntervalScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var cfg = this._cfg;
        var interval = cfg.interval;
        var extent = (0, $9073f5835d31d063$export$87f6c9bc988c4378)(this);
        var niceExtent = cfg.niceExtent;
        var intervalPrecision = cfg.intervalPrecision;
        var scaleBreakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
        var brk = this.brk;
        var brkAvailable = scaleBreakHelper && brk;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        if (opt.breakTicks === 'only_break' && brkAvailable) {
            scaleBreakHelper.addBreaksToTicks(ticks, brk.breaks, extent);
            return ticks;
        }
        // [CAVEAT]: If changing this logic, must sync it to `axisAlignTicks.ts`.
        // A fail-safe is required since `interval` can be user specified, or for the case
        // that using dataZoom toolbox and zoom repeatedly.
        var safeLimit = 3000;
        if (extent[0] < niceExtent[0]) ticks.push({
            value: opt.expandToNicedExtent ? (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(niceExtent[0] - interval, intervalPrecision) : extent[0]
        });
        var estimateNiceMultiple = function(tickVal, targetTick) {
            return (0, $0b2f7076fd7740ca$export$42cacde8c45786ff)((targetTick - tickVal) / interval);
        };
        var intervalCount = cfg.intervalCount;
        for(var tick = niceExtent[0], niceTickIdx = 0;; niceTickIdx++){
            // Consider case `_extent: [5.2, 5.8], _niceExtent: [6, 5], interval: 1`,
            //  `_intervalCount` makes sense iff `-1`.
            // Consider case `_extent: [5, 5.8], _niceExtent: [5, 5], interval: 1`,
            //  `_intervalCount` makes sense iff `0`.
            if (intervalCount == null) {
                if (tick > niceExtent[1] || !isFinite(tick) || !isFinite(niceExtent[1])) break;
            } else {
                if (niceTickIdx > intervalCount) break;
                // Consider cumulative error, especially caused by rounding, the last nice
                // `tick` may be less than or greater than `niceExtent[1]` slightly.
                tick = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(tick, niceExtent[1]);
                if (niceTickIdx === intervalCount) tick = niceExtent[1];
            }
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(tick + interval, intervalPrecision);
            if (brk) {
                var moreMultiple = brk.calcNiceTickMultiple(tick, estimateNiceMultiple);
                if (moreMultiple >= 0) tick = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(tick + moreMultiple * interval, intervalPrecision);
            }
            if (ticks.length > 0 && tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceExtent[1] and niceExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceExtent[1];
        if (extent[1] > lastNiceTick) ticks.push({
            value: opt.expandToNicedExtent ? (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(lastNiceTick + interval, intervalPrecision) : extent[1]
        });
        if (brkAvailable) scaleBreakHelper.pruneTicksByBreak(opt.pruneByBreak, ticks, brk.breaks, function(item) {
            return item.value;
        }, cfg.interval, extent);
        if (brkAvailable && opt.breakTicks !== 'none') scaleBreakHelper.addBreaksToTicks(ticks, brk.breaks, extent);
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $37aae0fe210a1ee2$export$e2d43952c5db22bb)(this, splitNumber, (0, $88f2be8efb09cff5$export$20734ee5f1d5720f)(this), this._cfg.interval);
    };
    IntervalScale.prototype.getLabel = function(tick, opt) {
        if (tick == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = (0, $0b2f7076fd7740ca$export$e0c74b50bbd10f68)(tick.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._cfg.intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use `round` (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(tick.value, precision, true);
        return (0, $c09e8b26bdb81866$export$b6fe44657ce35c42)(dataNum);
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $1f14cdb63fc595e5$export$2e2bcd8739ae039));
(0, $1f14cdb63fc595e5$export$2e2bcd8739ae039).registerClass($ce5a28c78d8c3fff$var$IntervalScale);
var $ce5a28c78d8c3fff$export$2e2bcd8739ae039 = $ce5a28c78d8c3fff$var$IntervalScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










// FIXME 公用？
var $869abcb8e0d51e8b$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $869abcb8e0d51e8b$var$TimeScale = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = 'time';
        _this.parse = TimeScale.parse;
        _this._locale = setting.locale;
        _this._useUTC = setting.useUTC;
        _this._interval = 0;
        var breakParsed = (0, $88f2be8efb09cff5$export$770ec3eb53b5689b)(_this, setting);
        var res = (0, $9073f5835d31d063$export$acfc4e2d986326b7)(_this, breakParsed, null);
        // @ts-ignore
        _this.brk = res.brk;
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        return (0, $a8ce5c3e1c58d573$export$d9468344d3651243)(tick.value, (0, $a8ce5c3e1c58d573$export$445bdbd8d2334e40)[(0, $a8ce5c3e1c58d573$export$124c820721c4f66b)((0, $a8ce5c3e1c58d573$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $a8ce5c3e1c58d573$export$445bdbd8d2334e40).second, this._useUTC, this._locale);
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        return (0, $a8ce5c3e1c58d573$export$fe777b6293828b5d)(tick, idx, labelFormatter, this._locale, this._useUTC);
    };
    TimeScale.prototype.getTicks = function(opt) {
        opt = opt || {};
        var interval = this._interval;
        var extent = (0, $9073f5835d31d063$export$87f6c9bc988c4378)(this);
        var scaleBreakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
        var brk = this.brk;
        var brkAvailable = scaleBreakHelper && brk;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        var useUTC = this._useUTC;
        if (brkAvailable && opt.breakTicks === 'only_break') {
            (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, brk.breaks, extent);
            return ticks;
        }
        ticks = $869abcb8e0d51e8b$var$createIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent, (0, $9073f5835d31d063$export$9a49fe71267af794)(this), brk);
        var upperUnitIndex = (0, $a8ce5c3e1c58d573$export$87100da04d711986).length - 1;
        var maxLevel = 0;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(ticks, function(tick) {
            if (tick.time) {
                upperUnitIndex = Math.min(upperUnitIndex, (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)((0, $a8ce5c3e1c58d573$export$87100da04d711986), tick.time.upperTimeUnit));
                maxLevel = Math.max(maxLevel, tick.time.level);
            }
        });
        if (brkAvailable) (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)().pruneTicksByBreak(opt.pruneByBreak, ticks, brk.breaks, function(item) {
            return item.value;
        }, this._approxInterval, extent);
        if (brkAvailable && opt.breakTicks !== 'none') (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)().addBreaksToTicks(ticks, brk.breaks, extent, function(trimmedBrk) {
            // @see `parseTimeAxisLabelFormatterDictionary`.
            var lowerBrkUnitIndex = Math.max((0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)((0, $a8ce5c3e1c58d573$export$87100da04d711986), (0, $a8ce5c3e1c58d573$export$4dfb0417ad6555b7)(trimmedBrk.vmin, useUTC)), (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)((0, $a8ce5c3e1c58d573$export$87100da04d711986), (0, $a8ce5c3e1c58d573$export$4dfb0417ad6555b7)(trimmedBrk.vmax, useUTC)));
            var upperBrkUnitIndex = 0;
            for(var unitIdx = 0; unitIdx < (0, $a8ce5c3e1c58d573$export$87100da04d711986).length; unitIdx++)if (!$869abcb8e0d51e8b$var$isPrimaryUnitValueAndGreaterSame((0, $a8ce5c3e1c58d573$export$87100da04d711986)[unitIdx], trimmedBrk.vmin, trimmedBrk.vmax, useUTC)) {
                upperBrkUnitIndex = unitIdx;
                break;
            }
            var upperIdx = Math.min(upperBrkUnitIndex, upperUnitIndex);
            var lowerIdx = Math.max(upperIdx, lowerBrkUnitIndex);
            return {
                level: maxLevel,
                lowerTimeUnit: (0, $a8ce5c3e1c58d573$export$87100da04d711986)[lowerIdx],
                upperTimeUnit: (0, $a8ce5c3e1c58d573$export$87100da04d711986)[upperIdx]
            };
        });
        return ticks;
    };
    TimeScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $37aae0fe210a1ee2$export$e2d43952c5db22bb)(this, splitNumber, (0, $88f2be8efb09cff5$export$20734ee5f1d5720f)(this), this._interval);
    };
    TimeScale.prototype.setTimeInterval = function(opt) {
        this._interval = opt.interval;
        this._approxInterval = opt.approxInterval;
        this._minLevelUnit = opt.minLevelUnit;
    };
    TimeScale.parse = function(val) {
        // `val` might be a float (e.g., calculated from percent), so call `round`.
        return (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(val) ? Math.round(val) : +$0b2f7076fd7740ca$export$6b862160d295c8e(val);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $1f14cdb63fc595e5$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $869abcb8e0d51e8b$var$scaleIntervals = [
    // Format                           interval
    [
        'second',
        (0, $a8ce5c3e1c58d573$export$32c0454ceff7f92d)
    ],
    [
        'minute',
        (0, $a8ce5c3e1c58d573$export$35acaebf644db34e)
    ],
    [
        'hour',
        (0, $a8ce5c3e1c58d573$export$82541edf19e5e3b0)
    ],
    [
        'quarter-day',
        (0, $a8ce5c3e1c58d573$export$82541edf19e5e3b0) * 6
    ],
    [
        'half-day',
        (0, $a8ce5c3e1c58d573$export$82541edf19e5e3b0) * 12
    ],
    [
        'day',
        (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab) * 1.2
    ],
    [
        'half-week',
        (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab) * 3.5
    ],
    [
        'week',
        (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab) * 7
    ],
    [
        'month',
        (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab) * 31
    ],
    [
        'quarter',
        (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab) * 95
    ],
    [
        'half-year',
        (0, $a8ce5c3e1c58d573$export$99cafda57477293d) / 2
    ],
    [
        'year',
        (0, $a8ce5c3e1c58d573$export$99cafda57477293d)
    ] // 1Y
];
function $869abcb8e0d51e8b$var$isPrimaryUnitValueAndGreaterSame(unit, valueA, valueB, isUTC) {
    return (0, $a8ce5c3e1c58d573$export$2ed3384313b02c28)(new Date(valueA), unit, isUTC).getTime() === (0, $a8ce5c3e1c58d573$export$2ed3384313b02c28)(new Date(valueB), unit, isUTC).getTime();
}
// function isUnitValueSame(
//     unit: PrimaryTimeUnit,
//     valueA: number,
//     valueB: number,
//     isUTC: boolean
// ): boolean {
//     const dateA = numberUtil.parseDate(valueA) as any;
//     const dateB = numberUtil.parseDate(valueB) as any;
//     const isSame = (unit: PrimaryTimeUnit) => {
//         return getUnitValue(dateA, unit, isUTC)
//             === getUnitValue(dateB, unit, isUTC);
//     };
//     const isSameYear = () => isSame('year');
//     // const isSameHalfYear = () => isSameYear() && isSame('half-year');
//     // const isSameQuater = () => isSameYear() && isSame('quarter');
//     const isSameMonth = () => isSameYear() && isSame('month');
//     const isSameDay = () => isSameMonth() && isSame('day');
//     // const isSameHalfDay = () => isSameDay() && isSame('half-day');
//     const isSameHour = () => isSameDay() && isSame('hour');
//     const isSameMinute = () => isSameHour() && isSame('minute');
//     const isSameSecond = () => isSameMinute() && isSame('second');
//     const isSameMilliSecond = () => isSameSecond() && isSame('millisecond');
//     switch (unit) {
//         case 'year':
//             return isSameYear();
//         case 'month':
//             return isSameMonth();
//         case 'day':
//             return isSameDay();
//         case 'hour':
//             return isSameHour();
//         case 'minute':
//             return isSameMinute();
//         case 'second':
//             return isSameSecond();
//         case 'millisecond':
//             return isSameMilliSecond();
//     }
// }
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $869abcb8e0d51e8b$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $869abcb8e0d51e8b$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $869abcb8e0d51e8b$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $a8ce5c3e1c58d573$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $869abcb8e0d51e8b$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $a8ce5c3e1c58d573$export$35acaebf644db34e) : (0, $a8ce5c3e1c58d573$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $869abcb8e0d51e8b$var$getMillisecondsInterval(approxInterval) {
    // If less than 1, the getTicks loop will inevitably deed loop and read safeLimit.
    return $0b2f7076fd7740ca$export$2ca8010d037f830f($0b2f7076fd7740ca$export$7a695fe44258210b(approxInterval, true), 1);
}
// e.g., if the input unit is 'day', start calculate ticks from the first day of
// that month to make ticks "nice".
function $869abcb8e0d51e8b$var$getFirstTimestampOfUnit(timestamp, unitName, isUTC) {
    var upperUnitIdx = Math.max(0, (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)((0, $a8ce5c3e1c58d573$export$87100da04d711986), unitName) - 1);
    return (0, $a8ce5c3e1c58d573$export$2ed3384313b02c28)(new Date(timestamp), (0, $a8ce5c3e1c58d573$export$87100da04d711986)[upperUnitIdx], isUTC).getTime();
}
function $869abcb8e0d51e8b$var$createEstimateNiceMultiple(setMethodName, dateMethodInterval) {
    var tmpDate = new Date(0);
    tmpDate[setMethodName](1);
    var tmpTime = tmpDate.getTime();
    tmpDate[setMethodName](1 + dateMethodInterval);
    var approxTimeInterval = tmpDate.getTime() - tmpTime;
    return function(tickVal, targetValue) {
        // Only in month that accurate result can not get by division of
        // timestamp interval, but no need accurate here.
        return Math.max(0, Math.round((targetValue - tickVal) / approxTimeInterval));
    };
}
function $869abcb8e0d51e8b$var$createIntervalTicks(bottomUnitName, approxInterval, isUTC, extent, innermostSpan, brk) {
    // A fail-safe is required since `interval` can be user specified, or for the case
    // that using dataZoom toolbox and zoom repeatedly.
    var safeLimit = 3000;
    var unitNames = (0, $a8ce5c3e1c58d573$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var estimateNiceMultiple = $869abcb8e0d51e8b$var$createEstimateNiceMultiple(setMethodName, interval);
        var dateTime = minTimestamp;
        var date = new Date(dateTime);
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            if (iter++ > safeLimit) break;
            date[setMethodName](date[getMethodName]() + interval);
            dateTime = date.getTime();
            if (brk) {
                var moreMultiple = brk.calcNiceTickMultiple(dateTime, estimateNiceMultiple);
                if (moreMultiple > 0) {
                    date[setMethodName](date[getMethodName]() + moreMultiple * interval);
                    dateTime = date.getTime();
                }
            }
        }
        // This extra tick is for calculating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            // extent[1] should be added; deduplication will be performed later.
            notAdd: dateTime > extent[1]
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($869abcb8e0d51e8b$var$isPrimaryUnitValueAndGreaterSame((0, $a8ce5c3e1c58d573$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                value: $869abcb8e0d51e8b$var$getFirstTimestampOfUnit(extent[0], unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $a8ce5c3e1c58d573$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $a8ce5c3e1c58d573$export$43fbeac90913b151)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $869abcb8e0d51e8b$var$getMonthInterval(approxInterval);
                    getterName = (0, $a8ce5c3e1c58d573$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $a8ce5c3e1c58d573$export$233f59998ed71c09)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $869abcb8e0d51e8b$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $a8ce5c3e1c58d573$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $a8ce5c3e1c58d573$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $869abcb8e0d51e8b$var$getHourInterval(approxInterval);
                    getterName = (0, $a8ce5c3e1c58d573$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $a8ce5c3e1c58d573$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case 'minute':
                    interval = $869abcb8e0d51e8b$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $a8ce5c3e1c58d573$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $a8ce5c3e1c58d573$export$50303078793fc7d)(isUTC);
                    break;
                case 'second':
                    interval = $869abcb8e0d51e8b$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $a8ce5c3e1c58d573$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $a8ce5c3e1c58d573$export$a4a908acda9c3118)(isUTC);
                    break;
                case 'millisecond':
                    interval = $869abcb8e0d51e8b$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $a8ce5c3e1c58d573$export$312207a92d041116)(isUTC);
                    setterName = (0, $a8ce5c3e1c58d573$export$c047afab75f6d84)(isUTC);
                    break;
            }
            // Notice: This expansion by `getFirstTimestampOfUnit` may cause too many ticks and
            // iteration. e.g., when three levels of ticks is displayed, which can be caused by
            // data zoom and axis breaks. Thus trim them here.
            if (endTick >= extent[0] && startTick <= extent[1]) addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length; ++i){
        var primaryTimeUnit = (0, $a8ce5c3e1c58d573$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $a8ce5c3e1c58d573$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $a8ce5c3e1c58d573$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = innermostSpan / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)((0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var maxLevel = levelsTicksInExtent.length - 1;
    var ticks = [];
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k){
            var unit = (0, $a8ce5c3e1c58d573$export$4dfb0417ad6555b7)(levelTicks[k].value, isUTC);
            ticks.push({
                value: levelTicks[k].value,
                time: {
                    level: maxLevel - i,
                    upperTimeUnit: unit,
                    lowerTimeUnit: unit
                }
            });
        }
    }
    // Remove duplicates, which may cause jitter of `splitArea` and other bad cases.
    (0, $939d3a4c11ee87fd$export$2e2262a44ac61957)(ticks, (0, $939d3a4c11ee87fd$export$605c429b4975bbd7), null);
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    var currMinTick = ticks[0];
    var currMaxTick = ticks[ticks.length - 1];
    var extent0Unit = (0, $a8ce5c3e1c58d573$export$4dfb0417ad6555b7)(extent[0], isUTC);
    var extent1Unit = (0, $a8ce5c3e1c58d573$export$4dfb0417ad6555b7)(extent[1], isUTC);
    if (!currMinTick || currMinTick.value > extent[0]) ticks.unshift({
        value: extent[0],
        time: {
            level: 0,
            upperTimeUnit: extent0Unit,
            lowerTimeUnit: extent0Unit
        },
        notNice: true
    });
    if (!currMaxTick || currMaxTick.value < extent[1]) ticks.push({
        value: extent[1],
        time: {
            level: 0,
            upperTimeUnit: extent1Unit,
            lowerTimeUnit: extent1Unit
        },
        notNice: true
    });
    return ticks;
}
var $869abcb8e0d51e8b$export$b0ab84ebd823da11 = function(scale, opt) {
    var extent = scale.getExtent();
    // If extent start and end are same, expand them
    if (extent[0] === extent[1]) {
        // Expand extent
        extent[0] -= (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab);
        extent[1] += (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab);
    }
    // If there are no data and extent are [Infinity, -Infinity]
    if (extent[1] === -Infinity && extent[0] === Infinity) {
        var d = new Date();
        extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
        extent[0] = extent[1] - (0, $a8ce5c3e1c58d573$export$a97a1358cbb650ab);
    }
    scale.setExtent(extent[0], extent[1]);
    var splitNumber = (0, $27a07c2e80a6e56f$export$b801ba4e5ad70a4a)(opt.splitNumber, 10);
    var approxInterval = (0, $9073f5835d31d063$export$9a49fe71267af794)(scale) / splitNumber;
    var minInterval = opt.minInterval;
    var maxInterval = opt.maxInterval;
    if (minInterval != null && approxInterval < minInterval) approxInterval = minInterval;
    if (maxInterval != null && approxInterval > maxInterval) approxInterval = maxInterval;
    var scaleIntervalsLen = $869abcb8e0d51e8b$var$scaleIntervals.length;
    var idx = Math.min($869abcb8e0d51e8b$var$bisect($869abcb8e0d51e8b$var$scaleIntervals, approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
    // Interval that can be used to calculate ticks
    var interval = $869abcb8e0d51e8b$var$scaleIntervals[idx][1];
    // Min level used when picking ticks from top down.
    // We check one more level to avoid the ticks are to sparse in some case.
    var minLevelUnit = $869abcb8e0d51e8b$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    scale.setTimeInterval({
        approxInterval: approxInterval,
        interval: interval,
        minLevelUnit: minLevelUnit
    });
};
(0, $1f14cdb63fc595e5$export$2e2bcd8739ae039).registerClass($869abcb8e0d51e8b$var$TimeScale);
var $869abcb8e0d51e8b$export$2e2bcd8739ae039 = $869abcb8e0d51e8b$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $e4538487165101b9$var$LOOKUP_IDX_EXTENT_START = 0;
var $e4538487165101b9$var$LOOKUP_IDX_EXTENT_END = 1;
var $e4538487165101b9$var$LOOKUP_IDX_BREAK_START = 2;
/**
 * @final NEVER inherit me!
 */ var $e4538487165101b9$var$LogScale = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale(setting) {
        var _this = _super.call(this) || this;
        _this.type = 'log';
        _this.parse = (0, $ce5a28c78d8c3fff$export$2e2bcd8739ae039).parse;
        _this.base = setting.logBase || 10;
        var lookupFrom = [];
        var lookupTo = [];
        var lookup = _this._lookup = {
            from: lookupFrom,
            to: lookupTo
        };
        lookupFrom[$e4538487165101b9$var$LOOKUP_IDX_EXTENT_START] = lookupFrom[$e4538487165101b9$var$LOOKUP_IDX_EXTENT_END] = lookupTo[$e4538487165101b9$var$LOOKUP_IDX_EXTENT_START] = lookupTo[$e4538487165101b9$var$LOOKUP_IDX_EXTENT_END] = NaN;
        (0, $9073f5835d31d063$export$994b6d163a064f23)(_this, LogScale.mapperMethods);
        var scaleBreakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
        var breakOption = setting.breakOption;
        var out = {
            lookup: lookup
        };
        if (scaleBreakHelper) scaleBreakHelper.parseAxisBreakOptionInwardTransform(breakOption, _this, {
            noNegative: true
        }, $e4538487165101b9$var$LOOKUP_IDX_BREAK_START, out);
        _this.powStub = new (0, $ce5a28c78d8c3fff$export$2e2bcd8739ae039)({
            breakParsed: out.original
        });
        _this.intervalStub = new (0, $ce5a28c78d8c3fff$export$2e2bcd8739ae039)({
            breakParsed: out.transformed
        });
        (0, $9073f5835d31d063$export$85c5c680f14cd13c)(_this, _this.intervalStub);
        return _this;
    }
    LogScale.prototype.getTicks = function(opt) {
        var base = this.base;
        var powStub = this.powStub;
        var scaleBreakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
        var intervalStub = this.intervalStub;
        var intervalExtent = intervalStub.getExtent();
        var powExtent = powStub.getExtent();
        var powOpt = {
            lookup: {
                from: intervalExtent,
                to: powExtent
            }
        };
        return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(intervalStub.getTicks(opt || {}), function(tick) {
            var val = tick.value;
            var powVal = (0, $27a07c2e80a6e56f$export$73e21863d9c0dcd3)(val, base, powOpt);
            var vBreak;
            if (scaleBreakHelper) {
                var brkPowResult = scaleBreakHelper.getTicksBreakOutwardTransform(this, tick, (0, $88f2be8efb09cff5$export$20734ee5f1d5720f)(powStub), this._lookup);
                if (brkPowResult) {
                    vBreak = brkPowResult.vBreak;
                    powVal = brkPowResult.tickVal;
                }
            }
            return {
                value: powVal,
                "break": vBreak
            };
        }, this);
    };
    LogScale.prototype.getMinorTicks = function(splitNumber) {
        return (0, $37aae0fe210a1ee2$export$e2d43952c5db22bb)(this, splitNumber, (0, $88f2be8efb09cff5$export$20734ee5f1d5720f)(this.powStub), // NOTE: minor ticks are in the log scale value to visually hint users "logarithm".
        this.intervalStub.getConfig().interval);
    };
    LogScale.prototype.getLabel = function(data, opt) {
        return this.intervalStub.getLabel(data, opt);
    };
    LogScale.type = 'log';
    LogScale.mapperMethods = {
        needTransform: function() {
            return true;
        },
        normalize: function(val) {
            return this.intervalStub.normalize((0, $27a07c2e80a6e56f$export$7854dd225b5d5704)(val, this.base));
        },
        scale: function(val) {
            // PENDING: Input `intervalStub.getExtent()` and `powStub.getExtent()` may
            // break monotonicity. Do not do it until real problems found.
            return (0, $27a07c2e80a6e56f$export$73e21863d9c0dcd3)(this.intervalStub.scale(val), this.base, null);
        },
        transformIn: function(val, opt) {
            val = (0, $27a07c2e80a6e56f$export$7854dd225b5d5704)(val, this.base);
            return opt && opt.depth === (0, $9073f5835d31d063$export$2734d952320c7be9) ? val : this.intervalStub.transformIn(val, opt);
        },
        transformOut: function(val, opt) {
            var depth = opt ? opt.depth : null;
            $e4538487165101b9$var$tmpTransformOutOpt1.depth = depth;
            $e4538487165101b9$var$tmpTransformOutOpt2.lookup = this._lookup;
            return (0, $27a07c2e80a6e56f$export$73e21863d9c0dcd3)(depth === (0, $9073f5835d31d063$export$2734d952320c7be9) ? val : this.intervalStub.transformOut(val, $e4538487165101b9$var$tmpTransformOutOpt1), this.base, $e4538487165101b9$var$tmpTransformOutOpt2);
        },
        contain: function(val) {
            return this.powStub.contain(val);
        },
        /**
     * NOTICE: The caller should ensure `start` and `end` are both non-negative.
     */ setExtent: function(start, end) {
            this.setExtent2((0, $9073f5835d31d063$export$c884056e529a2c7a), start, end);
        },
        setExtent2: function(kind, start, end) {
            if (!(0, $939d3a4c11ee87fd$export$d386653f29930adb)(start, end) || start <= 0 || end <= 0) return;
            var lookupTo = $e4538487165101b9$var$tmpNotUsedArr;
            var lookupFrom = $e4538487165101b9$var$tmpNotUsedArr;
            if (kind === (0, $9073f5835d31d063$export$c884056e529a2c7a)) {
                var lookup = this._lookup;
                lookupTo = lookup.to;
                lookupFrom = lookup.from;
            }
            this.powStub.setExtent2(kind, lookupTo[$e4538487165101b9$var$LOOKUP_IDX_EXTENT_START] = start, lookupTo[$e4538487165101b9$var$LOOKUP_IDX_EXTENT_END] = end);
            var base = this.base;
            this.intervalStub.setExtent2(kind, lookupFrom[$e4538487165101b9$var$LOOKUP_IDX_EXTENT_START] = (0, $27a07c2e80a6e56f$export$7854dd225b5d5704)(start, base), lookupFrom[$e4538487165101b9$var$LOOKUP_IDX_EXTENT_END] = (0, $27a07c2e80a6e56f$export$7854dd225b5d5704)(end, base));
        },
        getFilter: function() {
            return {
                g: 0
            };
        },
        sanitize: function(value, dataExtent) {
            // Conservative - if dataExtent is invalid, do not sanitize.
            if ((0, $939d3a4c11ee87fd$export$d386653f29930adb)(dataExtent[0], dataExtent[1]) && (0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(value) && value <= 0) // `DataStore` has ensured that `dataExtent` is valid for LogScale.
            value = dataExtent[0];
            return value;
        },
        getDefaultStartValue: function() {
            return 1;
        },
        getExtent: function() {
            return this.powStub.getExtent();
        },
        getExtentUnsafe: function(kind, depth) {
            return depth === null ? this.powStub.getExtentUnsafe(kind, null) : this.intervalStub.getExtentUnsafe(kind, depth);
        }
    };
    return LogScale;
}((0, $1f14cdb63fc595e5$export$2e2bcd8739ae039));
(0, $1f14cdb63fc595e5$export$2e2bcd8739ae039).registerClass($e4538487165101b9$var$LogScale);
var $e4538487165101b9$var$tmpTransformOutOpt1 = {};
var $e4538487165101b9$var$tmpTransformOutOpt2 = {};
var $e4538487165101b9$var$tmpNotUsedArr = [];
var $e4538487165101b9$export$2e2bcd8739ae039 = $e4538487165101b9$var$LogScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $e709aeec1a12055b$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8adb494c9e76f9e1$var$inner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $8adb494c9e76f9e1$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $8adb494c9e76f9e1$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $8adb494c9e76f9e1$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $bbaae55b69ad01c5$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$8adb494c9e76f9e1$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
            dimHash += '$';
            dimHash += $8adb494c9e76f9e1$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $8adb494c9e76f9e1$export$fafbc856132a3a0e(schema) {
    return schema instanceof $8adb494c9e76f9e1$export$a1ef064685775f3e;
}
function $8adb494c9e76f9e1$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $8adb494c9e76f9e1$export$be39ae17310c33f7(source) {
    var innerSource = $8adb494c9e76f9e1$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $8adb494c9e76f9e1$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $8adb494c9e76f9e1$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


function $e66556952e0bcd49$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($e66556952e0bcd49$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // compatible: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    var allDimTypesAreNotOrdinalAndTime = true;
    function dimTypeIsNotOrdinalAndTime(dimensionInfo) {
        return dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time';
    }
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (!dimTypeIsNotOrdinalAndTime(dimensionInfo)) allDimTypesAreNotOrdinalAndTime = false;
    });
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimTypeIsNotOrdinalAndTime(dimensionInfo) && (!allDimTypesAreNotOrdinalAndTime || dimensionInfo.coordDim !== 'x' && dimensionInfo.coordDim !== 'angle') && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // "Stack by data index" makes sense only if users provide carefully constructed data - any
    // mismatch or absence of data items can cause incorrect results. By "Stack by data index"
    // is more performant - no hashmap is required.
    // PENDING:
    //  Compatible with previous design, non-category axis ("value"/"log"/"time" axis) can only
    //  stack by index. "Stack by value" will not be supported until concrete requirements arise.
    byIndex = true;
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $e66556952e0bcd49$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $8adb494c9e76f9e1$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $e66556952e0bcd49$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $e66556952e0bcd49$export$909db2be4938fbdf(data, targetDim) {
    return $e66556952e0bcd49$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}









var $7d2ffa192ebbc43e$var$axisInner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
function $7d2ffa192ebbc43e$export$a0edf4de19b45ee7(model) {
    var type = model.get('type');
    if (// In ec option, `xxxAxis.type` may be undefined.
    type == null || !$e4c0c902d0f4f283$export$b5a638e9b3fff9f3((0, $e709aeec1a12055b$export$2e0057d176d6f690), type) && !(0, $1f14cdb63fc595e5$export$2e2bcd8739ae039).getClass(type)) type = 'value';
    return type;
}
function $7d2ffa192ebbc43e$export$8941c4cacdc8f5a5(model, type, coordSysSupportAxisBreaks) {
    var breakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
    var breakOption;
    if (breakHelper) breakOption = $7d2ffa192ebbc43e$export$8094779d9b724f85(model, type, coordSysSupportAxisBreaks);
    switch(type){
        case 'category':
            return new (0, $ebeae9bf0b90a070$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)()
            });
        case 'time':
            return new (0, $869abcb8e0d51e8b$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC'),
                breakOption: breakOption
            });
        case 'log':
            // See also #3749
            return new (0, $e4538487165101b9$export$2e2bcd8739ae039)({
                logBase: model.get('logBase'),
                breakOption: breakOption
            });
        case 'value':
            return new (0, $ce5a28c78d8c3fff$export$2e2bcd8739ae039)({
                breakOption: breakOption
            });
        default:
            // case others.
            return new ((0, $1f14cdb63fc595e5$export$2e2bcd8739ae039).getClass(type) || (0, $ce5a28c78d8c3fff$export$2e2bcd8739ae039))({});
    }
}
function $7d2ffa192ebbc43e$export$99e0963eefdef8b2(scale, value, considerMappingExtent) {
    var dataExtent = considerMappingExtent ? (0, $9073f5835d31d063$export$e182c528b7826102)(scale, null) : scale.getExtentUnsafe((0, $9073f5835d31d063$export$c884056e529a2c7a), null);
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(0, $939d3a4c11ee87fd$export$d386653f29930adb)(min, max) ? $7d2ffa192ebbc43e$export$8b1206c1406788fd : min === value || max === value ? $7d2ffa192ebbc43e$export$d0bab53331033bdf : min < value && max > value ? $7d2ffa192ebbc43e$export$18028792a61d93c4 : $7d2ffa192ebbc43e$export$8b1206c1406788fd;
}
var $7d2ffa192ebbc43e$export$18028792a61d93c4 = 1;
var $7d2ffa192ebbc43e$export$d0bab53331033bdf = 2;
var $7d2ffa192ebbc43e$export$8b1206c1406788fd = 3;
function $7d2ffa192ebbc43e$export$3a3942ca9637d423(axis) {
    $7d2ffa192ebbc43e$var$axisInner(axis).noOnMyZero = true;
}
function $7d2ffa192ebbc43e$export$2204fb02f43463b7(axis) {
    return $7d2ffa192ebbc43e$var$axisInner(axis).noOnMyZero;
}
function $7d2ffa192ebbc43e$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    if (axis.type === 'time') {
        var parsed_1 = (0, $a8ce5c3e1c58d573$export$f16a827770bdffb5)(labelFormatter);
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, parsed_1);
        };
    } else if ($e4c0c902d0f4f283$export$844ec244b1367d54(labelFormatter)) return function(tick) {
        // For category axis, get raw value; for numeric axis,
        // get formatted label like '1,333,444'.
        var label = axis.scale.getLabel(tick);
        var text = labelFormatter.replace('{value}', label != null ? label : '');
        return text;
    };
    else if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(labelFormatter)) {
        if (axis.type === 'category') return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            return labelFormatter($7d2ffa192ebbc43e$export$a5a32f324c1fa457(axis, tick), tick.value - axis.scale.getExtent()[0], null // Using `null` just for backward compat.
            );
        };
        var scaleBreakHelper_1 = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
        return function(tick, idx) {
            // Using `null` just for backward compat. It's been found that in the `test/axis-customTicks.html`,
            // there is a formatter `function (value, index, revers = true) { ... }`. Although the third param
            // `revers` is incorrect and always `null`, changing it might introduce a breaking change.
            var extra = null;
            if (scaleBreakHelper_1) extra = scaleBreakHelper_1.makeAxisLabelFormatterParamBreak(extra, tick["break"]);
            return labelFormatter($7d2ffa192ebbc43e$export$a5a32f324c1fa457(axis, tick), idx, extra);
        };
    } else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $7d2ffa192ebbc43e$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    var scale = axis.scale;
    return (0, $27a07c2e80a6e56f$export$61579433626afe87)(scale) ? scale.getLabel(tick) : tick.value;
}
function $7d2ffa192ebbc43e$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $7d2ffa192ebbc43e$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $7d2ffa192ebbc43e$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $7d2ffa192ebbc43e$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $e4c0c902d0f4f283$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $e66556952e0bcd49$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $e4c0c902d0f4f283$export$ed97f33186d4b816(dataDimMap);
}
function $7d2ffa192ebbc43e$export$c06aa22293dea9d2(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $7d2ffa192ebbc43e$export$75b737736393e03c(axisModel) {
    return axisModel.getShallow('show');
}
function $7d2ffa192ebbc43e$export$8094779d9b724f85(model, axisType, coordSysSupportAxisBreaks) {
    var option = model.get('breaks', true);
    if (option != null) {
        if (!(0, $88f2be8efb09cff5$export$e79b20ac82c2d660)()) return undefined;
        if (!coordSysSupportAxisBreaks || !$7d2ffa192ebbc43e$var$isAxisTypeSupportAxisBreak(axisType)) {
            var axisInfo;
            return undefined;
        }
        return option;
    }
}
function $7d2ffa192ebbc43e$var$isAxisTypeSupportAxisBreak(axisType) {
    return axisType !== 'category';
}
function $7d2ffa192ebbc43e$export$8135db7762247d65(scale, fixMinMax, oldIntervalExtent, newIntervalExtent, oldOutermostExtent, cfg) {
    var isTargetLogScale = (0, $27a07c2e80a6e56f$export$8b1d8a59aa13c502)(scale);
    var intervalStub = isTargetLogScale ? scale.intervalStub : scale;
    intervalStub.setExtent(newIntervalExtent[0], newIntervalExtent[1]);
    if (isTargetLogScale) {
        // Sync intervalStub extent to the outermost extent (i.e., `powStub` for `LogScale`).
        var powStub = scale.powStub;
        var opt = {
            depth: (0, $9073f5835d31d063$export$2734d952320c7be9)
        };
        var minPow = scale.transformOut(newIntervalExtent[0], opt);
        var maxPow = scale.transformOut(newIntervalExtent[1], opt);
        // Log transform is probably not inversible by rounding error, which causes min/max tick may be
        // displayed as `5.999999999999999` unexpectedly when min/max are required to be fixed (specified
        // by users or by dataZoom). Therefore we set `powStub` with respect to `oldOutermostExtent` if
        // interval extent is not changed. But `intervalStub` should not be inversely changed by this
        // handling, otherwise its monotonicity between `niceExtent` and `extent` may be broken and cause
        // unexpected ticks generation.
        var extentChanged = (0, $27a07c2e80a6e56f$export$2b240c817ac5c4f)(oldIntervalExtent, newIntervalExtent);
        // NOTE: extent may still be changed even when min/max are required to be fixed,
        // e.g., by `intervalScaleEnsureValidExtent`.
        if (fixMinMax[0] && !extentChanged[0]) minPow = oldOutermostExtent[0];
        if (fixMinMax[1] && !extentChanged[1]) maxPow = oldOutermostExtent[1];
        powStub.setExtent(minPow, maxPow);
    }
    intervalStub.setConfig(cfg);
}
function $7d2ffa192ebbc43e$export$889d2956111fd257(scale, tick) {
    return (0, $27a07c2e80a6e56f$export$61579433626afe87)(scale) ? scale.getRawOrdinalNumber(tick.value) : tick.value;
}
function $7d2ffa192ebbc43e$export$43d51f65881fb080(scale, axisModel) {
    return (0, $27a07c2e80a6e56f$export$61579433626afe87)(scale) && !!axisModel.get('boundaryGap');
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8c471445a7dfad38$var$LABEL_LAYOUT_BASE_PROPS = [
    'label',
    'labelLine',
    'layoutOption',
    'priority',
    'defaultAttr',
    'marginForce',
    'minMarginForce',
    'marginDefault',
    'suggestIgnore'
];
var $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS = 1;
var $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_BIT_OBB = 2;
var $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_ALL = $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_BIT_OTHERS | $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_BIT_OBB;
function $8c471445a7dfad38$export$1551ece3f059eafb(labelGeometry, dirtyOrClear, dirtyBits) {
    dirtyBits = dirtyBits || $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_ALL;
    dirtyOrClear ? labelGeometry.dirty |= dirtyBits : labelGeometry.dirty &= ~dirtyBits;
}
function $8c471445a7dfad38$var$isLabelLayoutDirty(labelGeometry, dirtyBits) {
    dirtyBits = dirtyBits || $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_ALL;
    return labelGeometry.dirty == null || !!(labelGeometry.dirty & dirtyBits);
}
function $8c471445a7dfad38$export$471916f4e89eb5da(labelLayout) {
    if (!labelLayout) return;
    if ($8c471445a7dfad38$var$isLabelLayoutDirty(labelLayout)) $8c471445a7dfad38$export$af9bffc2d00de2cc(labelLayout, labelLayout.label, labelLayout);
    return labelLayout;
}
function $8c471445a7dfad38$export$af9bffc2d00de2cc(out, label, opt) {
    // [CAUTION] These props may be modified directly for performance consideration,
    //  therefore, do not output the internal data structure of zrender Element.
    var rawTransform = label.getComputedTransform();
    out.transform = (0, $05f852c7feb2d530$export$4d61283a070e0362)(out.transform, rawTransform);
    // NOTE: should call `getBoundingRect` after `getComputedTransform`, or may get an inaccurate bounding rect.
    //  The reason is that `getComputedTransform` calls `__host.updateInnerText()` internally, which updates the label
    //  by `textConfig` mounted on the host.
    // PENDING: add a dirty bit for that in zrender?
    var outLocalRect = out.localRect = (0, $05f852c7feb2d530$export$38128dfd9a498e1)(out.localRect, label.getBoundingRect());
    var labelStyleExt = label.style;
    var margin = labelStyleExt.margin;
    var marginForce = opt && opt.marginForce;
    var minMarginForce = opt && opt.minMarginForce;
    var marginDefault = opt && opt.marginDefault;
    var marginType = labelStyleExt.__marginType;
    if (marginType == null && marginDefault) {
        margin = marginDefault;
        marginType = (0, $83b5345ce49bb659$export$2b18df2bc75ae422).textMargin;
    }
    // `textMargin` and `minMargin` can not exist both.
    for(var i = 0; i < 4; i++)$8c471445a7dfad38$var$_tmpLabelMargin[i] = marginType === (0, $83b5345ce49bb659$export$2b18df2bc75ae422).minMargin && minMarginForce && minMarginForce[i] != null ? minMarginForce[i] : marginForce && marginForce[i] != null ? marginForce[i] : margin ? margin[i] : 0;
    if (marginType === (0, $83b5345ce49bb659$export$2b18df2bc75ae422).textMargin) (0, $05f852c7feb2d530$export$81ed941fdeb91c7c)(outLocalRect, $8c471445a7dfad38$var$_tmpLabelMargin, false, false);
    var outGlobalRect = out.rect = (0, $05f852c7feb2d530$export$38128dfd9a498e1)(out.rect, outLocalRect);
    if (rawTransform) outGlobalRect.applyTransform(rawTransform);
    // Notice: label.style.margin is actually `minMargin / 2`, handled by `setTextStyleCommon`.
    if (marginType === (0, $83b5345ce49bb659$export$2b18df2bc75ae422).minMargin) (0, $05f852c7feb2d530$export$81ed941fdeb91c7c)(outGlobalRect, $8c471445a7dfad38$var$_tmpLabelMargin, false, false);
    out.axisAligned = (0, $05f852c7feb2d530$export$576610ccf2234b72)(rawTransform);
    (out.label = out.label || {}).ignore = label.ignore;
    $8c471445a7dfad38$export$1551ece3f059eafb(out, false);
    $8c471445a7dfad38$export$1551ece3f059eafb(out, true, $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    // Do not remove `obb` (if existing) for reuse, just reset the dirty bit.
    return out;
}
var $8c471445a7dfad38$var$_tmpLabelMargin = [
    0,
    0,
    0,
    0
];
function $8c471445a7dfad38$export$bc37ae3f8412d105(out, rawLocalRect, rawTransform) {
    out.transform = (0, $05f852c7feb2d530$export$4d61283a070e0362)(out.transform, rawTransform);
    out.localRect = (0, $05f852c7feb2d530$export$38128dfd9a498e1)(out.localRect, rawLocalRect);
    out.rect = (0, $05f852c7feb2d530$export$38128dfd9a498e1)(out.rect, rawLocalRect);
    if (rawTransform) out.rect.applyTransform(rawTransform);
    out.axisAligned = (0, $05f852c7feb2d530$export$576610ccf2234b72)(rawTransform);
    out.obb = undefined; // Reset to undefined, will be created by `ensureOBB` when using.
    (out.label = out.label || {}).ignore = false;
    return out;
}
function $8c471445a7dfad38$export$91f733c27ab0712f(labelLayout, offset) {
    if (!labelLayout) return;
    labelLayout.label.x += offset.x;
    labelLayout.label.y += offset.y;
    labelLayout.label.markRedraw();
    var transform = labelLayout.transform;
    if (transform) {
        transform[4] += offset.x;
        transform[5] += offset.y;
    }
    var globalRect = labelLayout.rect;
    if (globalRect) {
        globalRect.x += offset.x;
        globalRect.y += offset.y;
    }
    var obb = labelLayout.obb;
    if (obb) obb.fromBoundingRect(labelLayout.localRect, transform);
}
function $8c471445a7dfad38$export$a1cfd37e9b88106b(newBaseWithDefaults, source) {
    for(var i = 0; i < $8c471445a7dfad38$var$LABEL_LAYOUT_BASE_PROPS.length; i++){
        var prop = $8c471445a7dfad38$var$LABEL_LAYOUT_BASE_PROPS[i];
        if (newBaseWithDefaults[prop] == null) newBaseWithDefaults[prop] = source[prop];
    }
    return $8c471445a7dfad38$export$471916f4e89eb5da(newBaseWithDefaults);
}
/**
 * Create obb if no one, can cache it.
 */ function $8c471445a7dfad38$var$ensureOBB(labelGeometry) {
    var obb = labelGeometry.obb;
    if (!obb || $8c471445a7dfad38$var$isLabelLayoutDirty(labelGeometry, $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_BIT_OBB)) {
        labelGeometry.obb = obb = obb || new (0, $e393b99a004f81fd$export$2e2bcd8739ae039)();
        obb.fromBoundingRect(labelGeometry.localRect, labelGeometry.transform);
        $8c471445a7dfad38$export$1551ece3f059eafb(labelGeometry, false, $8c471445a7dfad38$var$LABEL_LAYOUT_DIRTY_BIT_OBB);
    }
    return obb;
}
function $8c471445a7dfad38$export$73ee08bc808f6f3f(list, xyDimIdx, // 0 for x, 1 for y
minBound, // for x, leftBound; for y, topBound
maxBound, // for x, rightBound; for y, bottomBound
// If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    var len = list.length;
    var xyDim = (0, $05f852c7feb2d530$export$cb4c12294149dd2d)[xyDimIdx];
    var sizeDim = (0, $05f852c7feb2d530$export$a3fe6d967173a3ac)[xyDimIdx];
    if (len < 2) return false;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    // const shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        // shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $8c471445a7dfad38$export$ff775ae4fbb23435(labelList) {
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var defaultAttr = labelItem.defaultAttr;
        var labelLine = labelItem.labelLine;
        labelItem.label.attr('ignore', defaultAttr.ignore);
        labelLine && labelLine.attr('ignore', defaultAttr.labelGuideIgnore);
    }
}
function $8c471445a7dfad38$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return (b.suggestIgnore ? 1 : 0) - (a.suggestIgnore ? 1 : 0) || b.priority - a.priority;
    });
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = $8c471445a7dfad38$export$471916f4e89eb5da(labelList[i]);
        // The current `el.ignore` is involved, since some previous overlap
        // resolving strategies may have set `el.ignore` to true.
        if (labelItem.label.ignore) continue;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        // NOTICE: even when the with/height of globalRect of a label is 0, the label line should
        // still be displayed, since we should follow the concept of "truncation", meaning that
        // something exists even if it cannot be fully displayed. A visible label line is necessary
        // to allow users to get a tooltip with label info on hover.
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++)if ($8c471445a7dfad38$export$f28bfabef115ba96(labelItem, displayedLabels[j], null, {
            touchThreshold: 0.05
        })) {
            overlapped = true;
            break;
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else displayedLabels.push(labelItem);
    }
}
function $8c471445a7dfad38$export$f28bfabef115ba96(baseLayoutInfo, targetLayoutInfo, mtv, intersectOpt) {
    if (!baseLayoutInfo || !targetLayoutInfo) return false;
    if (baseLayoutInfo.label && baseLayoutInfo.label.ignore || targetLayoutInfo.label && targetLayoutInfo.label.ignore) return false;
    // Fast rejection.
    if (!baseLayoutInfo.rect.intersect(targetLayoutInfo.rect, mtv, intersectOpt)) return false;
    if (baseLayoutInfo.axisAligned && targetLayoutInfo.axisAligned) return true; // obb is the same as the normal bounding rect.
    return $8c471445a7dfad38$var$ensureOBB(baseLayoutInfo).intersect($8c471445a7dfad38$var$ensureOBB(targetLayoutInfo), mtv, intersectOpt);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $b57a96a87112d85a$var$_impl = null;
function $b57a96a87112d85a$export$f5ec8c7ef7a59f4c(impl) {
    if (!$b57a96a87112d85a$var$_impl) $b57a96a87112d85a$var$_impl = impl;
}
function $b57a96a87112d85a$export$c1d9b2cc33e7e5e() {
    return $b57a96a87112d85a$var$_impl;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $28bb3b6b8ff7ea29$export$12319e2083cd71ce = 'expandAxisBreak';
var $28bb3b6b8ff7ea29$export$8ba710d11f5d9b28 = 'collapseAxisBreak';
var $28bb3b6b8ff7ea29$export$cfaa507333440c5e = 'toggleAxisBreak';
var $28bb3b6b8ff7ea29$var$AXIS_BREAK_CHANGED_EVENT_TYPE = 'axisbreakchanged';
var $28bb3b6b8ff7ea29$var$expandAxisBreakActionInfo = {
    type: $28bb3b6b8ff7ea29$export$12319e2083cd71ce,
    event: $28bb3b6b8ff7ea29$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $28bb3b6b8ff7ea29$var$refineAxisBreakChangeEvent
};
var $28bb3b6b8ff7ea29$var$collapseAxisBreakActionInfo = {
    type: $28bb3b6b8ff7ea29$export$8ba710d11f5d9b28,
    event: $28bb3b6b8ff7ea29$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $28bb3b6b8ff7ea29$var$refineAxisBreakChangeEvent
};
var $28bb3b6b8ff7ea29$var$toggleAxisBreakActionInfo = {
    type: $28bb3b6b8ff7ea29$export$cfaa507333440c5e,
    event: $28bb3b6b8ff7ea29$var$AXIS_BREAK_CHANGED_EVENT_TYPE,
    update: 'update',
    refineEvent: $28bb3b6b8ff7ea29$var$refineAxisBreakChangeEvent
};
function $28bb3b6b8ff7ea29$var$refineAxisBreakChangeEvent(actionResultBatch, payload, ecModel, api) {
    var breaks = [];
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(actionResultBatch, function(actionResult) {
        breaks = breaks.concat(actionResult.eventBreaks);
    });
    return {
        eventContent: {
            breaks: breaks
        }
    };
}
function $28bb3b6b8ff7ea29$export$408c24786cd729c6(registers) {
    registers.registerAction($28bb3b6b8ff7ea29$var$expandAxisBreakActionInfo, actionHandler);
    registers.registerAction($28bb3b6b8ff7ea29$var$collapseAxisBreakActionInfo, actionHandler);
    registers.registerAction($28bb3b6b8ff7ea29$var$toggleAxisBreakActionInfo, actionHandler);
    function actionHandler(payload, ecModel) {
        var eventBreaks = [];
        var finderResult = (0, $939d3a4c11ee87fd$export$95de80076abac814)(ecModel, payload);
        function dealUpdate(modelProp, indexProp) {
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(finderResult[modelProp], function(axisModel) {
                var result = axisModel.updateAxisBreaks(payload);
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(result.breaks, function(item) {
                    var _a;
                    eventBreaks.push((0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)((_a = {}, _a[indexProp] = axisModel.componentIndex, _a), item));
                });
            });
        }
        dealUpdate('xAxisModels', 'xAxisIndex');
        dealUpdate('yAxisModels', 'yAxisIndex');
        dealUpdate('singleAxisModels', 'singleAxisIndex');
        return {
            eventBreaks: eventBreaks
        };
    }
}






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $bcb4c3869b07ba10$var$modelInner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $bcb4c3869b07ba10$var$axisInner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $bcb4c3869b07ba10$export$31cba7db0a663292 = {
    estimate: 1,
    determine: 2
};
function $bcb4c3869b07ba10$export$12d6ac38274c43e7(kind) {
    return {
        out: {
            noPxChangeTryDetermine: []
        },
        kind: kind
    };
}
function $bcb4c3869b07ba10$export$10216ebd3e3e485e(axis, ctx) {
    var custom = axis.getLabelModel().get('customValues');
    if (custom) {
        var scale_1 = axis.scale;
        return {
            labels: $e4c0c902d0f4f283$export$871de8747c9eaa88($bcb4c3869b07ba10$var$parseTickLabelCustomValues(custom, scale_1), function(tick, index) {
                return {
                    formattedLabel: (0, $7d2ffa192ebbc43e$export$742f19a75415b2ae)(axis)(tick, index),
                    rawLabel: scale_1.getLabel(tick),
                    tick: tick
                };
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $bcb4c3869b07ba10$var$makeCategoryLabels(axis, ctx) : $bcb4c3869b07ba10$var$makeRealNumberLabels(axis);
}
function $bcb4c3869b07ba10$export$7cccf6836ae8323c(axis, tickModel, opt) {
    var scale = axis.scale;
    var custom = axis.getTickModel().get('customValues');
    if (custom) return {
        ticks: $bcb4c3869b07ba10$var$parseTickLabelCustomValues(custom, scale)
    };
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $bcb4c3869b07ba10$var$makeCategoryTicks(axis, tickModel) : {
        ticks: scale.getTicks(opt)
    };
}
function $bcb4c3869b07ba10$var$parseTickLabelCustomValues(customValues, scale) {
    var extent = scale.getExtent();
    var tickNumbers = [];
    $e4c0c902d0f4f283$export$79b2f7037acddd43(customValues, function(val) {
        val = scale.parse(val);
        if (val >= extent[0] && val <= extent[1]) tickNumbers.push(val);
    });
    (0, $939d3a4c11ee87fd$export$2e2262a44ac61957)(tickNumbers, (0, $939d3a4c11ee87fd$export$fec5e8fdd97d769b), null);
    (0, $0b2f7076fd7740ca$export$debe6e778e0a6d32)(tickNumbers);
    return $e4c0c902d0f4f283$export$871de8747c9eaa88(tickNumbers, function(tickVal) {
        return {
            value: tickVal
        };
    });
}
function $bcb4c3869b07ba10$var$makeCategoryLabels(axis, ctx) {
    var labelModel = axis.getLabelModel();
    var result = $bcb4c3869b07ba10$var$makeCategoryLabelsActually(axis, labelModel, ctx);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: []
    } : result;
}
function $bcb4c3869b07ba10$var$makeCategoryLabelsActually(axis, labelModel, ctx) {
    var labelsCache = $bcb4c3869b07ba10$var$ensureCategoryLabelCache(axis);
    var optionLabelInterval = (0, $7d2ffa192ebbc43e$export$6d0bc2429155c088)(labelModel);
    var isEstimate = ctx.kind === $bcb4c3869b07ba10$export$31cba7db0a663292.estimate;
    // In AxisTickLabelComputingKind.estimate, the result likely varies during a single
    // pass of ec main process,due to the change of axisExtent, and will not be shared with
    // splitLine. Therefore no cache is used.
    if (!isEstimate) {
        // PENDING: check necessary?
        var result_1 = $bcb4c3869b07ba10$var$axisCacheGet(labelsCache, optionLabelInterval);
        if (result_1) return result_1;
    }
    var labels;
    var numericLabelInterval;
    if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(optionLabelInterval)) labels = $bcb4c3869b07ba10$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, optionLabelInterval, false);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $bcb4c3869b07ba10$var$makeAutoCategoryInterval(axis, ctx) : optionLabelInterval;
        labels = $bcb4c3869b07ba10$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, numericLabelInterval, false);
    }
    var result = {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    };
    if (!isEstimate) $bcb4c3869b07ba10$var$axisCacheSet(labelsCache, optionLabelInterval, result);
    else ctx.out.noPxChangeTryDetermine.push(function() {
        $bcb4c3869b07ba10$var$axisCacheSet(labelsCache, optionLabelInterval, result);
        return true;
    });
    return result;
}
function $bcb4c3869b07ba10$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $bcb4c3869b07ba10$var$ensureCategoryTickCache(axis);
    var optionTickInterval = (0, $7d2ffa192ebbc43e$export$6d0bc2429155c088)(tickModel);
    var result = $bcb4c3869b07ba10$var$axisCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(optionTickInterval)) ticks = $bcb4c3869b07ba10$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $bcb4c3869b07ba10$var$makeCategoryLabelsActually(axis, axis.getLabelModel(), $bcb4c3869b07ba10$export$12d6ac38274c43e7($bcb4c3869b07ba10$export$31cba7db0a663292.determine));
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $e4c0c902d0f4f283$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tick;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $bcb4c3869b07ba10$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $bcb4c3869b07ba10$var$axisCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $bcb4c3869b07ba10$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $7d2ffa192ebbc43e$export$742f19a75415b2ae)(axis);
    return {
        labels: $e4c0c902d0f4f283$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tick: tick
            };
        })
    };
}
// Large category data calculation is performance sensitive, and ticks and label probably will
// be fetched multiple times (e.g. shared by splitLine and axisTick). So we cache the result.
// axis is created each time during a ec process, so we do not need to clear cache.
var $bcb4c3869b07ba10$var$ensureCategoryTickCache = $bcb4c3869b07ba10$var$initAxisCacheMethod('axisTick');
var $bcb4c3869b07ba10$var$ensureCategoryLabelCache = $bcb4c3869b07ba10$var$initAxisCacheMethod('axisLabel');
/**
 * PENDING: refactor to JS Map? Because key can be a function or more complicated object, and
 * cache size always is small, and currently no JS Map object key polyfill, we use a simple
 * array cache instead of plain object hash.
 */ function $bcb4c3869b07ba10$var$initAxisCacheMethod(prop) {
    return function ensureCache(axis) {
        return $bcb4c3869b07ba10$var$axisInner(axis)[prop] || ($bcb4c3869b07ba10$var$axisInner(axis)[prop] = {
            list: []
        });
    };
}
function $bcb4c3869b07ba10$var$axisCacheGet(cache, key) {
    for(var i = 0; i < cache.list.length; i++){
        if (cache.list[i].key === key) return cache.list[i].value;
    }
}
function $bcb4c3869b07ba10$var$axisCacheSet(cache, key, value) {
    cache.list.push({
        key: key,
        value: value
    });
    return value;
}
function $bcb4c3869b07ba10$var$makeAutoCategoryInterval(axis, ctx) {
    if (ctx.kind === $bcb4c3869b07ba10$export$31cba7db0a663292.estimate) {
        // Currently axisTick is not involved in estimate kind, and the result likely varies during a
        // single pass of ec main process, due to the change of axisExtent. Therefore no cache is used.
        var result_2 = axis.calculateCategoryInterval(ctx);
        ctx.out.noPxChangeTryDetermine.push(function() {
            $bcb4c3869b07ba10$var$axisInner(axis).autoInterval = result_2;
            return true;
        });
        return result_2;
    }
    // Both tick and label uses this result, cacah it to avoid recompute.
    var result = $bcb4c3869b07ba10$var$axisInner(axis).autoInterval;
    return result != null ? result : $bcb4c3869b07ba10$var$axisInner(axis).autoInterval = axis.calculateCategoryInterval(ctx);
}
function $bcb4c3869b07ba10$export$9ea1d3f146a5a65f(axis, ctx) {
    var kind = ctx.kind;
    var params = $bcb4c3869b07ba10$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $7d2ffa192ebbc43e$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Arbitrary value.
    var maxCount = 40;
    if (tickCount > maxCount) step = Math.max(1, Math.floor(tickCount / maxCount));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $211780946ab71638$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top');
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    if (kind === $bcb4c3869b07ba10$export$31cba7db0a663292.estimate) {
        // In estimate kind, the inteval likely varies, thus do not erase the cache.
        ctx.out.noPxChangeTryDetermine.push($e4c0c902d0f4f283$export$2385a24977818dd0($bcb4c3869b07ba10$var$calculateCategoryIntervalTryDetermine, null, axis, interval, tickCount));
        return interval;
    }
    var lastInterval = $bcb4c3869b07ba10$var$calculateCategoryIntervalDealCache(axis, interval, tickCount);
    return lastInterval != null ? lastInterval : interval;
}
function $bcb4c3869b07ba10$var$calculateCategoryIntervalTryDetermine(axis, interval, tickCount) {
    return $bcb4c3869b07ba10$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) == null;
}
// Return the lastInterval if need to use it, otherwise return NullUndefined and save cache.
function $bcb4c3869b07ba10$var$calculateCategoryIntervalDealCache(axis, interval, tickCount) {
    var cache = $bcb4c3869b07ba10$var$modelInner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) return lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
}
function $bcb4c3869b07ba10$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $bcb4c3869b07ba10$var$makeTicksLabelsByCategoryIntervalNumOrCb(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $7d2ffa192ebbc43e$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var result = [];
    var categoryIntervalIsCb = $e4c0c902d0f4f283$export$f6e2535fb5126e54(categoryInterval);
    (0, $27a07c2e80a6e56f$export$1039c7e66c46a7fd)(ordinalScale, categoryIntervalIsCb ? 0 : categoryInterval, function(tickObj, isExtentBoundary) {
        var tickLabel = ordinalScale.getLabel(tickObj);
        if (categoryIntervalIsCb) {
            // When interval is function, a falsy return means ignore the tick.
            // It is time consuming for large category data.
            var isOnInterval = !!categoryInterval(tickObj.value, tickLabel);
            tickObj.offInterval = !isOnInterval;
            // axis extent min max labels should be always included and the display strategy
            // is adopted uniformly later in `AxisBuilder`.
            if (!isOnInterval && !isExtentBoundary) return;
        }
        result.push(onlyTick ? tickObj : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: tickLabel,
            tick: tickObj
        });
    });
    return result;
}



var $6d659ef54222f15c$var$PI = Math.PI;
var $6d659ef54222f15c$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS = [
    [
        1,
        2,
        1,
        2
    ],
    [
        5,
        3,
        5,
        3
    ],
    [
        8,
        3,
        8,
        3
    ]
];
var $6d659ef54222f15c$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS = [
    [
        0,
        1,
        0,
        1
    ],
    [
        0,
        3,
        0,
        3
    ],
    [
        0,
        3,
        0,
        3
    ]
];
var $6d659ef54222f15c$export$c392b818a26a879e = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $6d659ef54222f15c$var$getTickInner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
/**
 * A context shared by difference axisBuilder instances.
 * For cross-axes overlap resolving.
 *
 * Lifecycle constraint: should not over a pass of ec main process.
 *  If model is changed, the context must be disposed.
 *
 * @see AxisBuilderLocalContext
 */ var $6d659ef54222f15c$export$f2e237206f7393f5 = /** @class */ function() {
    function AxisBuilderSharedContext(resolveAxisNameOverlap) {
        /**
     * [CAUTION] Do not modify this data structure outside this class.
     */ this.recordMap = {};
        this.resolveAxisNameOverlap = resolveAxisNameOverlap;
    }
    AxisBuilderSharedContext.prototype.ensureRecord = function(axisModel) {
        var dim = axisModel.axis.dim;
        var idx = axisModel.componentIndex;
        var recordMap = this.recordMap;
        var records = recordMap[dim] || (recordMap[dim] = []);
        return records[idx] || (records[idx] = {
            ready: {}
        });
    };
    return AxisBuilderSharedContext;
}();
/**
 * [CAUTION]
 *  1. The call of this function must be after axisLabel overlap handlings
 *     (such as `hideOverlap`, `fixMinMaxLabelShow`) and after transform calculating.
 *  2. Can be called multiple times and should be idempotent.
 */ function $6d659ef54222f15c$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList) {
    var axis = axisModel.axis;
    var record = shared.ensureRecord(axisModel);
    var labelInfoList = [];
    var stOccupiedRect;
    var useStOccupiedRect = $6d659ef54222f15c$var$hasAxisName(cfg.axisName) && (0, $7d2ffa192ebbc43e$export$c06aa22293dea9d2)(cfg.nameLocation);
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(labelLayoutList, function(layout) {
        var layoutInfo = (0, $8c471445a7dfad38$export$471916f4e89eb5da)(layout);
        if (!layoutInfo || layoutInfo.label.ignore) return;
        labelInfoList.push(layoutInfo);
        var transGroup = record.transGroup;
        if (useStOccupiedRect) {
            // Transform to "standard axis" for creating stOccupiedRect (the label rects union).
            transGroup.transform ? $97681aabb80d556d$export$6897c284b6f9f4dc($6d659ef54222f15c$var$_stTransTmp, transGroup.transform) : $97681aabb80d556d$export$f0954fd7d5368655($6d659ef54222f15c$var$_stTransTmp);
            if (layoutInfo.transform) $97681aabb80d556d$export$6e3a27864ab166fe($6d659ef54222f15c$var$_stTransTmp, $6d659ef54222f15c$var$_stTransTmp, layoutInfo.transform);
            (0, $8d3017bded1ca21b$export$2e2bcd8739ae039).copy($6d659ef54222f15c$var$_stLabelRectTmp, layoutInfo.localRect);
            $6d659ef54222f15c$var$_stLabelRectTmp.applyTransform($6d659ef54222f15c$var$_stTransTmp);
            stOccupiedRect ? stOccupiedRect.union($6d659ef54222f15c$var$_stLabelRectTmp) : (0, $8d3017bded1ca21b$export$2e2bcd8739ae039).copy(stOccupiedRect = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0), $6d659ef54222f15c$var$_stLabelRectTmp);
        }
    });
    var sortByDim = Math.abs(record.dirVec.x) > 0.1 ? 'x' : 'y';
    var sortByValue = record.transGroup[sortByDim];
    labelInfoList.sort(function(info1, info2) {
        return Math.abs(info1.label[sortByDim] - sortByValue) - Math.abs(info2.label[sortByDim] - sortByValue);
    });
    if (useStOccupiedRect && stOccupiedRect) {
        var extent = axis.getExtent();
        var axisLineX = Math.min(extent[0], extent[1]);
        var axisLineWidth = Math.max(extent[0], extent[1]) - axisLineX;
        // If `nameLocation` is 'middle', enlarge axis labels boundingRect to axisLine to avoid bad
        //  case like that axis name is placed in the gap between axis labels and axis line.
        // If only one label exists, the entire band should be occupied for
        // visual consistency, so extent it to [0, canvas width].
        stOccupiedRect.union(new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(axisLineX, 0, axisLineWidth, 1));
    }
    record.stOccupiedRect = stOccupiedRect;
    record.labelInfoList = labelInfoList;
}
var $6d659ef54222f15c$var$_stTransTmp = $97681aabb80d556d$export$185802fd694ee1f5();
var $6d659ef54222f15c$var$_stLabelRectTmp = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $6d659ef54222f15c$export$7fcb8742f5816cae = function(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    if ((0, $7d2ffa192ebbc43e$export$c06aa22293dea9d2)(cfg.nameLocation)) {
        var stOccupiedRect = thisRecord.stOccupiedRect;
        if (stOccupiedRect) $6d659ef54222f15c$var$moveIfOverlap((0, $8c471445a7dfad38$export$bc37ae3f8412d105)({}, stOccupiedRect, thisRecord.transGroup.transform), nameLayoutInfo, nameMoveDirVec);
    } else $6d659ef54222f15c$export$e033c6449cc6f6a1(thisRecord.labelInfoList, thisRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
};
// [NOTICE] not consider ignore.
function $6d659ef54222f15c$var$moveIfOverlap(basedLayoutInfo, movableLayoutInfo, moveDirVec) {
    var mtv = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)();
    if ((0, $8c471445a7dfad38$export$f28bfabef115ba96)(basedLayoutInfo, movableLayoutInfo, mtv, {
        direction: Math.atan2(moveDirVec.y, moveDirVec.x),
        bidirectional: false,
        touchThreshold: 0.05
    })) (0, $8c471445a7dfad38$export$91f733c27ab0712f)(movableLayoutInfo, mtv);
}
function $6d659ef54222f15c$export$e033c6449cc6f6a1(baseLayoutInfoList, baseDirVec, movableLayoutInfo, moveDirVec) {
    // Detect and move from far to close.
    var sameDir = (0, $0a729ce3d8741684$export$2e2bcd8739ae039).dot(moveDirVec, baseDirVec) >= 0;
    for(var idx = 0, len = baseLayoutInfoList.length; idx < len; idx++){
        var labelInfo = baseLayoutInfoList[sameDir ? idx : len - 1 - idx];
        if (!labelInfo.label.ignore) $6d659ef54222f15c$var$moveIfOverlap(labelInfo, movableLayoutInfo, moveDirVec);
    }
}
/**
 * @caution
 * - Ensure it is called after the data processing stage finished.
 * - It might be called before `CahrtView#render`, sush as called at `CoordinateSystem#update`,
 *  thus ensure the result the same whenever it is called.
 *
 * A builder for a straight-line axis.
 *
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A "standard axis" is the axis [0,0]-->[abs(axisExtent[1]-axisExtent[0]),0]
 * for example: [0,0]-->[50,0]
 */ var $6d659ef54222f15c$var$AxisBuilder = /** @class */ function() {
    /**
   * [CAUTION]: axisModel.axis.extent/scale must be ready to use.
   */ function AxisBuilder(axisModel, api, opt, shared) {
        this.group = new $0c53f0d63dde8266$export$2e2bcd8739ae039();
        this._axisModel = axisModel;
        this._api = api;
        this._local = {};
        this._shared = shared || new $6d659ef54222f15c$export$f2e237206f7393f5($6d659ef54222f15c$export$7fcb8742f5816cae);
        this._resetCfgDetermined(opt);
    }
    /**
   * Regarding axis label related configurations, only the change of label.x/y is supported; other
   * changes are not necessary and not performant. To be specific, only `axis.position`
   * (and consequently `labelOffset`) and `axis.extent` can be changed, and assume everything in
   * `axisModel` are not changed.
   * Axis line related configurations can be changed since this method can only be called
   * before they are created.
   */ AxisBuilder.prototype.updateCfg = function(opt) {
        var ready;
        var raw = this._cfg.raw;
        raw.position = opt.position;
        raw.labelOffset = opt.labelOffset;
        this._resetCfgDetermined(raw);
    };
    /**
   * [CAUTION] For debug usage. Never change it outside!
   */ AxisBuilder.prototype.__getRawCfg = function() {
        return this._cfg.raw;
    };
    AxisBuilder.prototype._resetCfgDetermined = function(raw) {
        var axisModel = this._axisModel;
        // FIXME:
        //  Currently there is no uniformed way to set default values if an option
        //  is specified null/undefined by user (intentionally or unintentionally),
        //  e.g. null/undefined is not a illegal value for `nameLocation`.
        //  Try to use `getDefaultOption` to address it. But radar has no `getDefaultOption`.
        var axisModelDefaultOption = axisModel.getDefaultOption ? axisModel.getDefaultOption() : {};
        // Default value
        var axisName = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(raw.axisName, axisModel.get('name'));
        var nameMoveOverlapOption = axisModel.get('nameMoveOverlap');
        if (nameMoveOverlapOption == null || nameMoveOverlapOption === 'auto') nameMoveOverlapOption = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(raw.defaultNameMoveOverlap, true);
        var cfg = {
            raw: raw,
            position: raw.position,
            rotation: raw.rotation,
            nameDirection: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(raw.nameDirection, 1),
            tickDirection: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(raw.tickDirection, 1),
            labelDirection: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(raw.labelDirection, 1),
            labelOffset: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(raw.labelOffset, 0),
            silent: (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(raw.silent, true),
            axisName: axisName,
            nameLocation: (0, $e4c0c902d0f4f283$export$2e94551289abb95b)(axisModel.get('nameLocation'), axisModelDefaultOption.nameLocation, 'end'),
            shouldNameMoveOverlap: $6d659ef54222f15c$var$hasAxisName(axisName) && nameMoveOverlapOption,
            optionHideOverlap: axisModel.get([
                'axisLabel',
                'hideOverlap'
            ]),
            showMinorTicks: axisModel.get([
                'minorTick',
                'show'
            ])
        };
        this._cfg = cfg;
        // FIXME Not use a separate text group?
        var transformGroup = new $0c53f0d63dde8266$export$2e2bcd8739ae039({
            x: cfg.position[0],
            y: cfg.position[1],
            rotation: cfg.rotation
        });
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
        var record = this._shared.ensureRecord(axisModel);
        record.transGroup = this._transformGroup;
        record.dirVec = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)(Math.cos(-cfg.rotation), Math.sin(-cfg.rotation));
    };
    AxisBuilder.prototype.build = function(axisPartNameMap, extraParams) {
        var _this = this;
        if (!axisPartNameMap) axisPartNameMap = {
            axisLine: true,
            axisTickLabelEstimate: false,
            axisTickLabelDetermine: true,
            axisName: true
        };
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)($6d659ef54222f15c$var$AXIS_BUILDER_AXIS_PART_NAMES, function(partName) {
            if (axisPartNameMap[partName]) $6d659ef54222f15c$var$builders[partName](_this._cfg, _this._local, _this._shared, _this._axisModel, _this.group, _this._transformGroup, _this._api, extraParams || {});
        });
        return this;
    };
    /**
   * Currently only get text align/verticalAlign by rotation.
   * NO `position` is involved, otherwise it have to be performed for each `updateAxisLabelChangableProps`.
   */ AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $0b2f7076fd7740ca$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $0b2f7076fd7740ca$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $0b2f7076fd7740ca$export$d1df570aea2868f)(rotationDiff - $6d659ef54222f15c$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $6d659ef54222f15c$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
// Sorted by dependency order.
var $6d659ef54222f15c$var$AXIS_BUILDER_AXIS_PART_NAMES = [
    'axisLine',
    'axisTickLabelEstimate',
    'axisTickLabelDetermine',
    'axisName'
];
var $6d659ef54222f15c$var$builders = {
    axisLine: function(cfg, local, shared, axisModel, group, transformGroup, api) {
        var ready;
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto') {
            shown = true;
            if (cfg.raw.axisLineAutoShow != null) shown = !!cfg.raw.axisLineAutoShow;
        }
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $c20a2855346046a3$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $c20a2855346046a3$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var pathBaseProp = {
            strokeContainThreshold: cfg.raw.strokeContainThreshold || 5,
            silent: true,
            z2: 1,
            style: lineStyle
        };
        if (axisModel.get([
            'axisLine',
            'breakLine'
        ]) && (0, $88f2be8efb09cff5$export$fec008222a1db2dc)(axisModel.axis.scale)) (0, $b57a96a87112d85a$export$c1d9b2cc33e7e5e)().buildAxisBreakLine(axisModel, group, transformGroup, pathBaseProp);
        else {
            var line = new $8ae349726e18597f$export$2e2bcd8739ae039((0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
                shape: {
                    x1: pt1[0],
                    y1: pt1[1],
                    x2: pt2[0],
                    y2: pt2[1]
                }
            }, pathBaseProp));
            $05f852c7feb2d530$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
            line.anid = 'line';
            group.add(line);
        }
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(arrowSize) || (0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $b6180ec78eaf8763$export$e3e292895c033f6d)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)([
                {
                    rotate: cfg.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: cfg.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $b6180ec78eaf8763$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(cfg.rotation),
                        y: pt[1] - r * Math.sin(cfg.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisTickLabelEstimate: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $6d659ef54222f15c$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $6d659ef54222f15c$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $bcb4c3869b07ba10$export$31cba7db0a663292).estimate);
    },
    /**
   * Finish axis tick label build.
   * Can be only called once.
   */ axisTickLabelDetermine: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var ready;
        var needCallLayout = $6d659ef54222f15c$var$dealLastTickLabelResultReusable(local, group, extraParams);
        if (needCallLayout) $6d659ef54222f15c$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, (0, $bcb4c3869b07ba10$export$31cba7db0a663292).determine);
        var ticksEls = $6d659ef54222f15c$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel);
        $6d659ef54222f15c$var$syncLabelIgnoreToMajorTicks(cfg, local.labelLayoutList, ticksEls);
        $6d659ef54222f15c$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, cfg.tickDirection);
    },
    /**
   * [CAUTION] This method can be called multiple times, following the change due to `resetCfg` called
   *  in size measurement. Thus this method should be idempotent, and should be performant.
   */ axisName: function(cfg, local, shared, axisModel, group, transformGroup, api, extraParams) {
        var sharedRecord = shared.ensureRecord(axisModel);
        var ready;
        // Remove the existing name result created in estimation phase.
        if (local.nameEl) {
            group.remove(local.nameEl);
            local.nameEl = sharedRecord.nameLayout = sharedRecord.nameLocation = null;
        }
        var name = cfg.axisName;
        if (!$6d659ef54222f15c$var$hasAxisName(name)) return;
        var nameLocation = cfg.nameLocation;
        var nameDirection = cfg.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapStartEndSignal = axisModel.axis.inverse ? -1 : 1;
        var pos = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)(0, 0);
        var nameMoveDirVec = new (0, $0a729ce3d8741684$export$2e2bcd8739ae039)(0, 0);
        if (nameLocation === 'start') {
            pos.x = extent[0] - gapStartEndSignal * gap;
            nameMoveDirVec.x = -gapStartEndSignal;
        } else if (nameLocation === 'end') {
            pos.x = extent[1] + gapStartEndSignal * gap;
            nameMoveDirVec.x = gapStartEndSignal;
        } else {
            // 'middle' or 'center'
            pos.x = (extent[0] + extent[1]) / 2;
            pos.y = cfg.labelOffset + nameDirection * gap;
            nameMoveDirVec.y = nameDirection;
        }
        var mt = $97681aabb80d556d$export$185802fd694ee1f5();
        nameMoveDirVec.transform($97681aabb80d556d$export$bb628a54ab399bc9(mt, mt, cfg.rotation));
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $6d659ef54222f15c$var$PI / 180; // To radian.
        var labelLayout;
        var axisNameAvailableWidth;
        if ((0, $7d2ffa192ebbc43e$export$c06aa22293dea9d2)(nameLocation)) labelLayout = $6d659ef54222f15c$var$AxisBuilder.innerTextLayout(cfg.rotation, nameRotation != null ? nameRotation : cfg.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $6d659ef54222f15c$var$endTextLayout(cfg.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = cfg.raw.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $e4c0c902d0f4f283$export$8a4d17b6e8486e66)(cfg.raw.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var nameMarginLevel = extraParams.nameMarginLevel || 0;
        var textEl = new $9f8a9b67e62609f8$export$2e2bcd8739ae039({
            x: pos.x,
            y: pos.y,
            rotation: labelLayout.rotation,
            silent: $6d659ef54222f15c$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $83b5345ce49bb659$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $05f852c7feb2d530$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $6d659ef54222f15c$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        transformGroup.add(textEl);
        textEl.updateTransform();
        local.nameEl = textEl;
        var nameLayout = sharedRecord.nameLayout = (0, $8c471445a7dfad38$export$471916f4e89eb5da)({
            label: textEl,
            priority: textEl.z2,
            defaultAttr: {
                ignore: textEl.ignore
            },
            marginDefault: (0, $7d2ffa192ebbc43e$export$c06aa22293dea9d2)(nameLocation) ? $6d659ef54222f15c$var$DEFAULT_CENTER_NAME_MARGIN_LEVELS[nameMarginLevel] : $6d659ef54222f15c$var$DEFAULT_ENDS_NAME_MARGIN_LEVELS[nameMarginLevel]
        });
        sharedRecord.nameLocation = nameLocation;
        group.add(textEl);
        textEl.decomposeTransform();
        if (cfg.shouldNameMoveOverlap && nameLayout) {
            var record = shared.ensureRecord(axisModel);
            shared.resolveAxisNameOverlap(cfg, shared, axisModel, nameLayout, nameMoveDirVec, record);
        }
    }
};
function $6d659ef54222f15c$var$layOutAxisTickLabel(cfg, local, shared, axisModel, group, transformGroup, api, kind) {
    if (!$6d659ef54222f15c$var$axisLabelBuildResultExists(local)) $6d659ef54222f15c$var$buildAxisLabel(cfg, local, group, kind, axisModel, api);
    var labelLayoutList = local.labelLayoutList;
    $6d659ef54222f15c$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup);
    $6d659ef54222f15c$var$adjustBreakLabels(axisModel, cfg.rotation, labelLayoutList);
    var optionHideOverlap = cfg.optionHideOverlap;
    $6d659ef54222f15c$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap);
    if (optionHideOverlap) // This bit fixes the label overlap issue for the time chart.
    // See https://github.com/apache/echarts/issues/14266 for more.
    (0, $8c471445a7dfad38$export$8ce774e164a49410)(// Filter the already ignored labels by the previous overlap resolving methods.
    (0, $e4c0c902d0f4f283$export$3dea766d36a8935f)(labelLayoutList, function(layout) {
        return layout && !layout.label.ignore;
    }));
    // Always call it even this axis has no name, since it serves in overlapping detection
    // and grid outerBounds on other axis.
    $6d659ef54222f15c$var$resetOverlapRecordToShared(cfg, shared, axisModel, labelLayoutList);
}
function $6d659ef54222f15c$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $0b2f7076fd7740ca$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $0b2f7076fd7740ca$export$d1df570aea2868f)(rotationDiff - $6d659ef54222f15c$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $0b2f7076fd7740ca$export$d1df570aea2868f)(rotationDiff - $6d659ef54222f15c$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $6d659ef54222f15c$var$PI * 1.5 && rotationDiff > $6d659ef54222f15c$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
/**
 * Assume `labelLayoutList` has no `label.ignore: true`.
 * Assume `labelLayoutList` have been sorted by value ascending order.
 */ function $6d659ef54222f15c$var$fixMinMaxLabelShow(axisModel, labelLayoutList, optionHideOverlap) {
    var axis = axisModel.axis;
    var customValuesOption = axisModel.get([
        'axisLabel',
        'customValues'
    ]);
    if ((0, $7d2ffa192ebbc43e$export$c2911c025243d6a6)(axis)) return;
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    // Assert no ignore in labels.
    function deal(showMinMaxLabelOption, outmostLabelIdx, innerLabelIdx) {
        var outmostLabelLayout = (0, $8c471445a7dfad38$export$471916f4e89eb5da)(labelLayoutList[outmostLabelIdx]);
        var innerLabelLayout = (0, $8c471445a7dfad38$export$471916f4e89eb5da)(labelLayoutList[innerLabelIdx]);
        var scale = axis.scale;
        if (!outmostLabelLayout || !innerLabelLayout) return;
        if (showMinMaxLabelOption == null) {
            if (!optionHideOverlap && customValuesOption) // In this case, users are unlikely to expect labels to be hidden.
            return;
            var tick = $6d659ef54222f15c$export$c392b818a26a879e(outmostLabelLayout.label).labelInfo.tick;
            if (// TimeScale does not expand extent to "nice", so eliminate labels that are not nice.
            (0, $27a07c2e80a6e56f$export$c9b71a3750db342f)(scale) && tick.notNice || (0, $27a07c2e80a6e56f$export$61579433626afe87)(scale) && tick.offInterval) {
                $6d659ef54222f15c$var$ignoreEl(outmostLabelLayout.label);
                return;
            }
        }
        if (showMinMaxLabelOption === false || outmostLabelLayout.suggestIgnore) {
            $6d659ef54222f15c$var$ignoreEl(outmostLabelLayout.label);
            return;
        }
        if (innerLabelLayout.suggestIgnore) {
            $6d659ef54222f15c$var$ignoreEl(innerLabelLayout.label);
            return;
        }
        // PENDING: Originally we thought `optionHideOverlap === false` means do not hide anything,
        //  since currently the bounding rect of text might not accurate enough and might slightly bigger,
        //  which causes false positive. But `optionHideOverlap: null/undfined` is falsy and likely
        //  be treated as false.
        // In most fonts the glyph does not reach the boundary of the bounding rect.
        // This is needed to avoid too aggressive to hide two elements that meet at the edge
        // due to compact layout by the same bounding rect or OBB.
        var touchThreshold = 0.1;
        // This treatment is for backward compatibility. And `!optionHideOverlap` implies that
        // the user accepts the visual touch between adjacent labels, thus "hide min/max label"
        // should be conservative, since the space might be sufficient in this case.
        if (!optionHideOverlap) {
            var marginForce = [
                0,
                0,
                0,
                0
            ];
            // Make a copy to apply `ignoreMargin`.
            outmostLabelLayout = (0, $8c471445a7dfad38$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, outmostLabelLayout);
            innerLabelLayout = (0, $8c471445a7dfad38$export$a1cfd37e9b88106b)({
                marginForce: marginForce
            }, innerLabelLayout);
        }
        if ((0, $8c471445a7dfad38$export$f28bfabef115ba96)(outmostLabelLayout, innerLabelLayout, null, {
            touchThreshold: touchThreshold
        })) {
            if (showMinMaxLabelOption) $6d659ef54222f15c$var$ignoreEl(innerLabelLayout.label);
            else $6d659ef54222f15c$var$ignoreEl(outmostLabelLayout.label);
        }
    }
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabelOption = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabelOption = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]);
    var labelsLen = labelLayoutList.length;
    deal(showMinLabelOption, 0, 1);
    deal(showMaxLabelOption, labelsLen - 1, labelsLen - 2);
}
// Under default settings, it is visually odd to display a tick without its label,
// since ticks extend from axis line towards labels and serve as visual guide.
// PENDING: Is there opposite cases?
function $6d659ef54222f15c$var$syncLabelIgnoreToMajorTicks(cfg, labelLayoutList, tickEls) {
    if (cfg.showMinorTicks) // It probably unreasonable to hide major ticks when show minor ticks.
    return;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(labelLayoutList, function(labelLayout) {
        if (labelLayout && labelLayout.label.ignore) for(var idx = 0; idx < tickEls.length; idx++){
            var tickEl = tickEls[idx];
            // Assume small array, linear search is fine for performance.
            // PENDING: measure?
            var tickInner = $6d659ef54222f15c$var$getTickInner(tickEl);
            var labelInner = $6d659ef54222f15c$export$c392b818a26a879e(labelLayout.label);
            if (tickInner.tickValue != null && !tickInner.onBand && tickInner.tickValue === labelInner.labelInfo.tick.value) {
                $6d659ef54222f15c$var$ignoreEl(tickEl);
                return;
            }
        }
    });
}
function $6d659ef54222f15c$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $6d659ef54222f15c$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $c20a2855346046a3$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $c20a2855346046a3$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $8ae349726e18597f$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $05f852c7feb2d530$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
        var inner = $6d659ef54222f15c$var$getTickInner(tickEl);
        inner.onBand = !!ticksCoords[i].onBand;
        inner.tickValue = ticksCoords[i].tickValue;
    }
    return tickEls;
}
function $6d659ef54222f15c$var$buildAxisMajorTicks(cfg, group, transformGroup, axisModel) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto') {
        shown = true;
        if (cfg.raw.axisTickAutoShow != null) shown = !!cfg.raw.axisTickAutoShow;
    }
    if (!shown || axis.scale.isBlank()) return [];
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = cfg.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $6d659ef54222f15c$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $6d659ef54222f15c$var$buildAxisMinorTicks(cfg, group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!cfg.showMinorTicks || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $6d659ef54222f15c$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
// Return whether need to call `layOutAxisTickLabel` again.
function $6d659ef54222f15c$var$dealLastTickLabelResultReusable(local, group, extraParams) {
    if ($6d659ef54222f15c$var$axisLabelBuildResultExists(local)) {
        var axisLabelsCreationContext = local.axisLabelsCreationContext;
        var noPxChangeTryDetermine = axisLabelsCreationContext.out.noPxChangeTryDetermine;
        if (extraParams.noPxChange) {
            var canDetermine = true;
            for(var idx = 0; idx < noPxChangeTryDetermine.length; idx++)canDetermine = canDetermine && noPxChangeTryDetermine[idx]();
            if (canDetermine) return false;
        }
        if (noPxChangeTryDetermine.length) {
            // Remove the result of `buildAxisLabel`
            group.remove(local.labelGroup);
            $6d659ef54222f15c$var$axisLabelBuildResultSet(local, null, null, null);
        }
    }
    return true;
}
function $6d659ef54222f15c$var$buildAxisLabel(cfg, local, group, kind, axisModel, api) {
    var axis = axisModel.axis;
    var show = (0, $e4c0c902d0f4f283$export$8a4d17b6e8486e66)(cfg.raw.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    var labelGroup = new $0c53f0d63dde8266$export$2e2bcd8739ae039();
    group.add(labelGroup);
    var axisLabelCreationCtx = (0, $bcb4c3869b07ba10$export$12d6ac38274c43e7)(kind);
    if (!show || axis.scale.isBlank()) {
        $6d659ef54222f15c$var$axisLabelBuildResultSet(local, [], labelGroup, axisLabelCreationCtx);
        return;
    }
    var labelModel = axisModel.getModel('axisLabel');
    var labels = axis.getViewLabels(axisLabelCreationCtx);
    // Special label rotate.
    var labelRotation = ((0, $e4c0c902d0f4f283$export$8a4d17b6e8486e66)(cfg.raw.labelRotate, labelModel.get('rotate')) || 0) * $6d659ef54222f15c$var$PI / 180;
    var labelLayout = $6d659ef54222f15c$var$AxisBuilder.innerTextLayout(cfg.rotation, labelRotation, cfg.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var triggerEvent = axisModel.get('triggerEvent');
    var z2Min = Infinity;
    var z2Max = -Infinity;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var _a;
        var labelItemTick = labelItem.tick;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        var tickValue = (0, $7d2ffa192ebbc43e$export$889d2956111fd257)(axis.scale, labelItemTick);
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var align = itemLabelModel.getShallow('align', true) || labelLayout.textAlign;
        var alignMin = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMinLabel', true), align);
        var alignMax = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMaxLabel', true), align);
        var verticalAlign = itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMinLabel', true), verticalAlign);
        var verticalAlignMax = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMaxLabel', true), verticalAlign);
        var z2 = 10 + (((_a = labelItemTick.time) === null || _a === void 0 ? void 0 : _a.level) || 0);
        z2Min = Math.min(z2Min, z2);
        z2Max = Math.max(z2Max, z2);
        var textEl = new $9f8a9b67e62609f8$export$2e2bcd8739ae039({
            // --- transform props start ---
            // All of the transform props MUST not be set here, but should be set in
            // `updateAxisLabelChangableProps`, because they may change in estimation,
            // and need to calculate based on global coord sys by `decomposeTransform`.
            x: 0,
            y: 0,
            rotation: 0,
            // --- transform props end ---
            silent: $6d659ef54222f15c$var$AxisBuilder.isLabelSilent(axisModel),
            z2: z2,
            style: (0, $83b5345ce49bb659$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue;
        var inner = $6d659ef54222f15c$export$c392b818a26a879e(textEl);
        inner.labelInfo = labelItem;
        inner.layoutRotation = labelLayout.rotation;
        $05f852c7feb2d530$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: formattedLabel,
            formatterParamsExtra: {
                isTruncated: function() {
                    return textEl.isTruncated;
                },
                value: rawLabel,
                tickIndex: index
            }
        });
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $6d659ef54222f15c$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            var labelItemTickBreak = labelItem.tick["break"];
            if (labelItemTickBreak) {
                var labelItemTickBreakParsedBreak = labelItemTickBreak.parsedBreak;
                eventData["break"] = {
                    // type: labelItem.break.type,
                    start: labelItemTickBreakParsedBreak.vmin,
                    end: labelItemTickBreakParsedBreak.vmax
                };
            }
            if (axis.type === 'category') eventData.dataIndex = tickValue;
            (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            if (labelItemTickBreak) $6d659ef54222f15c$var$addBreakEventHandler(axisModel, api, textEl, labelItemTickBreak);
        }
        labelEls.push(textEl);
        labelGroup.add(textEl);
    });
    var labelLayoutList = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(labelEls, function(label) {
        return {
            label: label,
            priority: $6d659ef54222f15c$export$c392b818a26a879e(label).labelInfo.tick["break"] ? label.z2 + (z2Max - z2Min + 1 // Make break labels be highest priority.
            ) : label.z2,
            defaultAttr: {
                ignore: label.ignore
            }
        };
    });
    $6d659ef54222f15c$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelCreationCtx);
}
// Indicate that `layOutAxisTickLabel` has been called.
function $6d659ef54222f15c$var$axisLabelBuildResultExists(local) {
    return !!local.labelLayoutList;
}
function $6d659ef54222f15c$var$axisLabelBuildResultSet(local, labelLayoutList, labelGroup, axisLabelsCreationContext) {
    // Ensure the same lifetime.
    local.labelLayoutList = labelLayoutList;
    local.labelGroup = labelGroup;
    local.axisLabelsCreationContext = axisLabelsCreationContext;
}
function $6d659ef54222f15c$var$updateAxisLabelChangableProps(cfg, axisModel, labelLayoutList, transformGroup) {
    var labelMargin = axisModel.get([
        'axisLabel',
        'margin'
    ]);
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(labelLayoutList, function(layout, idx) {
        var geometry = (0, $8c471445a7dfad38$export$471916f4e89eb5da)(layout);
        if (!geometry) return;
        var labelEl = geometry.label;
        var inner = $6d659ef54222f15c$export$c392b818a26a879e(labelEl);
        // See the comment in `suggestIgnore`.
        geometry.suggestIgnore = labelEl.ignore;
        // Currently no `ignore:true` is set in `buildAxisLabel`
        // But `ignore:true` may be set subsequently for overlap handling, thus reset it here.
        labelEl.ignore = false;
        (0, $82e5b6aba13917b1$export$234b1c16dfa57d6a)($6d659ef54222f15c$var$_tmpLayoutEl, $6d659ef54222f15c$var$_tmpLayoutElReset);
        var axis = axisModel.axis;
        $6d659ef54222f15c$var$_tmpLayoutEl.x = axis.dataToCoord((0, $7d2ffa192ebbc43e$export$889d2956111fd257)(axis.scale, inner.labelInfo.tick));
        $6d659ef54222f15c$var$_tmpLayoutEl.y = cfg.labelOffset + cfg.labelDirection * labelMargin;
        $6d659ef54222f15c$var$_tmpLayoutEl.rotation = inner.layoutRotation;
        transformGroup.add($6d659ef54222f15c$var$_tmpLayoutEl);
        $6d659ef54222f15c$var$_tmpLayoutEl.updateTransform();
        transformGroup.remove($6d659ef54222f15c$var$_tmpLayoutEl);
        $6d659ef54222f15c$var$_tmpLayoutEl.decomposeTransform();
        (0, $82e5b6aba13917b1$export$234b1c16dfa57d6a)(labelEl, $6d659ef54222f15c$var$_tmpLayoutEl);
        labelEl.markRedraw();
        (0, $8c471445a7dfad38$export$1551ece3f059eafb)(geometry, true);
        (0, $8c471445a7dfad38$export$471916f4e89eb5da)(geometry);
    });
}
var $6d659ef54222f15c$var$_tmpLayoutEl = new $439653c37a0e6e60$export$2e2bcd8739ae039();
var $6d659ef54222f15c$var$_tmpLayoutElReset = new $439653c37a0e6e60$export$2e2bcd8739ae039();
function $6d659ef54222f15c$var$hasAxisName(axisName) {
    return !!axisName;
}
function $6d659ef54222f15c$var$addBreakEventHandler(axisModel, api, textEl, visualBreak) {
    textEl.on('click', function(params) {
        var payload = {
            type: (0, $28bb3b6b8ff7ea29$export$12319e2083cd71ce),
            breaks: [
                {
                    start: visualBreak.parsedBreak.breakOption.start,
                    end: visualBreak.parsedBreak.breakOption.end
                }
            ]
        };
        payload[axisModel.axis.dim + "AxisIndex"] = axisModel.componentIndex;
        api.dispatchAction(payload);
    });
}
function $6d659ef54222f15c$var$adjustBreakLabels(axisModel, axisRotation, labelLayoutList) {
    var scaleBreakHelper = (0, $88f2be8efb09cff5$export$e79b20ac82c2d660)();
    if (!scaleBreakHelper) return;
    var breakLabelIndexPairs = scaleBreakHelper.retrieveAxisBreakPairs(labelLayoutList, function(layoutInfo) {
        return layoutInfo && $6d659ef54222f15c$export$c392b818a26a879e(layoutInfo.label).labelInfo.tick["break"];
    }, true);
    var moveOverlap = axisModel.get([
        'breakLabelLayout',
        'moveOverlap'
    ], true);
    if (moveOverlap === true || moveOverlap === 'auto') (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(breakLabelIndexPairs, function(idxPair) {
        (0, $b57a96a87112d85a$export$c1d9b2cc33e7e5e)().adjustBreakLabelPair(axisModel.axis.inverse, axisRotation, [
            (0, $8c471445a7dfad38$export$471916f4e89eb5da)(labelLayoutList[idxPair[0]]),
            (0, $8c471445a7dfad38$export$471916f4e89eb5da)(labelLayoutList[idxPair[1]])
        ]);
    });
}
var $6d659ef54222f15c$export$2e2bcd8739ae039 = $6d659ef54222f15c$var$AxisBuilder;





function $d12268f449565e1b$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $d12268f449565e1b$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $d12268f449565e1b$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $c09e8b26bdb81866$export$f3a38102c49f4268(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $211780946ab71638$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2);
    // Not overflow ec container
    $d12268f449565e1b$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $83b5345ce49bb659$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $d12268f449565e1b$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $d12268f449565e1b$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $7d2ffa192ebbc43e$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $e4c0c902d0f4f283$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($e4c0c902d0f4f283$export$844ec244b1367d54(formatter)) text = formatter.replace('{value}', text);
        else if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $d12268f449565e1b$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $97681aabb80d556d$export$185802fd694ee1f5();
    $97681aabb80d556d$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $97681aabb80d556d$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $05f852c7feb2d530$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $d12268f449565e1b$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    var textLayout = (0, $6d659ef54222f15c$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $d12268f449565e1b$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $d12268f449565e1b$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $d12268f449565e1b$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $d12268f449565e1b$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $d12268f449565e1b$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}
function $d12268f449565e1b$export$19cae73ec299246f(axis, seriesDataIndices, ecModel) {
    return (0, $6d521ceff1ab94af$export$141021262b29d96e)(axis, {
        fromStat: {
            sers: $e4c0c902d0f4f283$export$871de8747c9eaa88(seriesDataIndices, function(item) {
                return ecModel.getSeriesByIndex(item.seriesIndex);
            })
        },
        min: 1
    }).w;
}
function $d12268f449565e1b$export$a1c116ca0a73a1a2(val, axisExtent, bandWidth) {
    return [
        (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)((0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(axisExtent[0], axisExtent[1]), val - bandWidth / 2),
        (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(val + bandWidth / 2, (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(axisExtent[0], axisExtent[1]))
    ];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $11f3c53f4277ae1d$export$b3219800bda33a1f(rect, axisModel, opt) {
    opt = opt || {};
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($e4c0c902d0f4f283$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $11f3c53f4277ae1d$export$1a2a248dbebc52b5(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $11f3c53f4277ae1d$export$e447722773749af(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $11f3c53f4277ae1d$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $e4c0c902d0f4f283$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}
function $11f3c53f4277ae1d$export$2b2ce820c3e1e776(gridRect, cartesians, axisModel, api, ctx, defaultNameMoveOverlap) {
    var layoutResult = $11f3c53f4277ae1d$export$b3219800bda33a1f(gridRect, axisModel);
    var axisLineAutoShow = false;
    var axisTickAutoShow = false;
    // Not show axisTick or axisLine if other axis is category / time
    for(var i = 0; i < cartesians.length; i++)if ((0, $27a07c2e80a6e56f$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) {
        // Still show axis tick or axisLine if other axis is value / log
        axisLineAutoShow = axisTickAutoShow = true;
        if (axisModel.axis.type === 'category' && axisModel.axis.onBand) axisTickAutoShow = false;
    }
    layoutResult.axisLineAutoShow = axisLineAutoShow;
    layoutResult.axisTickAutoShow = axisTickAutoShow;
    layoutResult.defaultNameMoveOverlap = defaultNameMoveOverlap;
    return new (0, $6d659ef54222f15c$export$2e2bcd8739ae039)(axisModel, api, layoutResult, ctx);
}
function $11f3c53f4277ae1d$export$3e8d41f03e1a6a39(axisBuilder, gridRect, axisModel) {
    var newRaw = $11f3c53f4277ae1d$export$b3219800bda33a1f(gridRect, axisModel);
    var oldRaw_1;
    axisBuilder.updateCfg(newRaw);
}
function $11f3c53f4277ae1d$export$3fa527f4e8efeff2(axis) {
    return axis.dim + '_' + axis.index;
}



var $75c487bce4982510$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var thisExtent = axis.getGlobalExtent();
        var otherExtent = $75c487bce4982510$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $d12268f449565e1b$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $75c487bce4982510$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, thisExtent, otherExtent, axisPointerModel.get('seriesDataIndices'), axisPointerModel.ecModel);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $11f3c53f4277ae1d$export$b3219800bda33a1f(grid.getRect(), axisModel);
        $d12268f449565e1b$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $11f3c53f4277ae1d$export$b3219800bda33a1f(axisModel.axis.grid.getRect(), axisModel, {
            labelInside: false
        });
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $d12268f449565e1b$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $75c487bce4982510$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $f3964596ebdf82ae$export$2e2bcd8739ae039));
function $75c487bce4982510$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $75c487bce4982510$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, thisExtent, otherExtent) {
        var targetShape = $d12268f449565e1b$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $75c487bce4982510$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, thisExtent, otherExtent, seriesDataIndices, ecModel) {
        var bandWidth = $d12268f449565e1b$export$19cae73ec299246f(axis, seriesDataIndices, ecModel);
        var otherSpan = otherExtent[1] - otherExtent[0];
        var _a = $d12268f449565e1b$export$a1c116ca0a73a1a2(pixelValue, thisExtent, bandWidth), min = _a[0], max = _a[1];
        return {
            type: 'Rect',
            shape: $d12268f449565e1b$export$a8b35248bcc02756([
                min,
                otherExtent[0]
            ], [
                max - min,
                otherSpan
            ], $75c487bce4982510$var$getAxisDimIndex(axis))
        };
    }
};
function $75c487bce4982510$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $75c487bce4982510$export$2e2bcd8739ae039 = $75c487bce4982510$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $3ce383264b863165$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        // zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.border,
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.shadowTint
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.neutral00,
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.accent60,
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.accent40,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $879a47e830ab7f41$export$2e2bcd8739ae039));
var $3ce383264b863165$export$2e2bcd8739ae039 = $3ce383264b863165$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $749ea2aefe76bf8f$var$inner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $749ea2aefe76bf8f$var$each = $e4c0c902d0f4f283$export$79b2f7037acddd43;
function $749ea2aefe76bf8f$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $d461075057ee3466$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $749ea2aefe76bf8f$var$inner(zr).records || ($749ea2aefe76bf8f$var$inner(zr).records = {});
    $749ea2aefe76bf8f$var$initGlobalListeners(zr, api);
    var record = $749ea2aefe76bf8f$var$inner(zr).records[key] || ($749ea2aefe76bf8f$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $749ea2aefe76bf8f$var$initGlobalListeners(zr, api) {
    if ($749ea2aefe76bf8f$var$inner(zr).initialized) return;
    $749ea2aefe76bf8f$var$inner(zr).initialized = true;
    useHandler('click', $e4c0c902d0f4f283$export$c3095a23b368d1f2($749ea2aefe76bf8f$var$doEnter, 'click'));
    useHandler('mousemove', $e4c0c902d0f4f283$export$c3095a23b368d1f2($749ea2aefe76bf8f$var$doEnter, 'mousemove'));
    // For example, dataZoom may update series layout while mousewheel,
    // axisPointer and tooltip need to follow that updates, otherwise,
    // highlighted items (by axisPointer) may have no chance to downplay.
    useHandler('mousewheel', $e4c0c902d0f4f283$export$c3095a23b368d1f2($749ea2aefe76bf8f$var$doEnter, 'mousewheel'));
    // useHandler('mouseout', onLeave);
    useHandler('globalout', $749ea2aefe76bf8f$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $749ea2aefe76bf8f$var$makeDispatchAction(api);
            $749ea2aefe76bf8f$var$each($749ea2aefe76bf8f$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $749ea2aefe76bf8f$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $749ea2aefe76bf8f$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $749ea2aefe76bf8f$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $749ea2aefe76bf8f$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $749ea2aefe76bf8f$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $749ea2aefe76bf8f$export$d07f55d4c15c0440(key, api) {
    if ((0, $d461075057ee3466$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($749ea2aefe76bf8f$var$inner(zr).records || {})[key];
    if (record) $749ea2aefe76bf8f$var$inner(zr).records[key] = null;
}



var $dddf5969da35cc0b$var$AxisPointerView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click|mousewheel';
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $749ea2aefe76bf8f$export$6503ec6e8aabbaf('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $749ea2aefe76bf8f$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $749ea2aefe76bf8f$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039));
var $dddf5969da35cc0b$export$2e2bcd8739ae039 = $dddf5969da35cc0b$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $006f7b7b99267dac$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $939d3a4c11ee87fd$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $e4c0c902d0f4f283$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($e4c0c902d0f4f283$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}




var $cd631fc2327f45aa$var$inner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
function $cd631fc2327f45aa$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($cd631fc2327f45aa$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $006f7b7b99267dac$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $cd631fc2327f45aa$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $cd631fc2327f45aa$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)($cd631fc2327f45aa$var$showPointer, showValueMap),
        showTooltip: (0, $e4c0c902d0f4f283$export$c3095a23b368d1f2)($cd631fc2327f45aa$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $cd631fc2327f45aa$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $cd631fc2327f45aa$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $cd631fc2327f45aa$var$makeMapperParam(srcAxisInfo), $cd631fc2327f45aa$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $cd631fc2327f45aa$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $cd631fc2327f45aa$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $cd631fc2327f45aa$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $cd631fc2327f45aa$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $cd631fc2327f45aa$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $cd631fc2327f45aa$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $cd631fc2327f45aa$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.indicesOfNearest(dim, dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (!(0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $cd631fc2327f45aa$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $cd631fc2327f45aa$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $6254c6bba0f480c8$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caution: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $cd631fc2327f45aa$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
        // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $cd631fc2327f45aa$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($cd631fc2327f45aa$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $cd631fc2327f45aa$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider conflict (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $cd631fc2327f45aa$var$inner(zr)[highDownKey] || {};
    var newHighlights = $cd631fc2327f45aa$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && axisInfo.triggerEmphasis && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            newHighlights[batchItem.seriesIndex + '|' + batchItem.dataIndex] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    function makeHighDownItem(batchItem) {
        // `dataIndexInside` should be removed, since the last recorded `dataIndexInside` may have
        // been changed if `dataZoomInside` changed the view. Only `dataIndex` will suffice.
        return {
            seriesIndex: batchItem.seriesIndex,
            dataIndex: batchItem.dataIndex
        };
    }
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(makeHighDownItem(batchItem));
    });
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(makeHighDownItem(batchItem));
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $cd631fc2327f45aa$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $cd631fc2327f45aa$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $cd631fc2327f45aa$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $539fac72a5ff49ed$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $7341328d5e8aa244$export$2e2bcd8739ae039).registerAxisPointerClass('CartesianAxisPointer', (0, $75c487bce4982510$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $3ce383264b863165$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $dddf5969da35cc0b$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, {
        overallReset: function(ecModel, api) {
            // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
            // allAxesInfo should be updated when setOption performed.
            ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $6254c6bba0f480c8$export$bb44f104e3c54dae)(ecModel, api);
        }
    });
    // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $cd631fc2327f45aa$export$2e2bcd8739ae039));
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $20423702b6b38674$var$TooltipModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click|mousewheel',
        alwaysShowContent: false,
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaults to `false` (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        displayTransition: true,
        enterable: false,
        backgroundColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.neutral00,
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        defaultBorderColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.border,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.borderShade,
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.tertiary,
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $879a47e830ab7f41$export$2e2bcd8739ae039));
var $20423702b6b38674$export$2e2bcd8739ae039 = $20423702b6b38674$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $0d4253f44fb70c8c$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption : tooltipModel.get('renderMode') === 'richText';
}
function $0d4253f44fb70c8c$var$testStyle(styleProps) {
    if (!(0, $d461075057ee3466$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $0d4253f44fb70c8c$export$7b4286b1e4a23439 = $0d4253f44fb70c8c$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $0d4253f44fb70c8c$export$70a631ae991b5e76 = $0d4253f44fb70c8c$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $0d4253f44fb70c8c$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $c09e8b26bdb81866$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $0d4253f44fb70c8c$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $8b3bb31d5f59ebd9$var$CSS_TRANSITION_VENDOR = (0, $0d4253f44fb70c8c$export$5886acafe29a08d1)((0, $0d4253f44fb70c8c$export$70a631ae991b5e76), 'transition');
var $8b3bb31d5f59ebd9$var$CSS_TRANSFORM_VENDOR = (0, $0d4253f44fb70c8c$export$5886acafe29a08d1)((0, $0d4253f44fb70c8c$export$7b4286b1e4a23439), 'transform');
// eslint-disable-next-line
var $8b3bb31d5f59ebd9$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $d461075057ee3466$export$2e2bcd8739ae039).transform3dSupported ? 'will-change:transform;' : '');
function $8b3bb31d5f59ebd9$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $8b3bb31d5f59ebd9$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $e4c0c902d0f4f283$export$844ec244b1367d54)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $c09e8b26bdb81866$export$cda04d03233e5555)(borderColor);
    var arrowPos = $8b3bb31d5f59ebd9$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $8b3bb31d5f59ebd9$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $8b3bb31d5f59ebd9$var$assembleTransition(duration, onlyFadeTransition, enableDisplayTransition) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = '';
    var transitionText = '';
    if (enableDisplayTransition) {
        transitionOption = " " + duration / 2 + "s " + transitionCurve;
        transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    }
    if (!onlyFadeTransition) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (transitionText.length ? ',' : '') + ((0, $d461075057ee3466$export$2e2bcd8739ae039).transformSupported ? "" + $8b3bb31d5f59ebd9$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption);
    }
    return $8b3bb31d5f59ebd9$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $8b3bb31d5f59ebd9$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px';
    // not support transform, use `left` and `top` instead.
    if (!(0, $d461075057ee3466$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
    // support transform
    var is3d = (0, $d461075057ee3466$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $8b3bb31d5f59ebd9$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $0d4253f44fb70c8c$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $8b3bb31d5f59ebd9$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    // @ts-ignore, leave it to the tooltip refactor.
    var lineHeight = (0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(textStyleModel.get('lineHeight'), Math.round(fontSize * 3 / 2));
    fontSize && cssText.push('line-height:' + lineHeight + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $8b3bb31d5f59ebd9$var$assembleCssText(tooltipModel, enableTransition, onlyFadeTransition, enableDisplayTransition) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $b8b42d608e86874b$export$3048212c802df496)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow);
    // Animation transition. Do not animate when transitionDuration <= 0.
    enableTransition && transitionDuration > 0 && cssText.push($8b3bb31d5f59ebd9$var$assembleTransition(transitionDuration, onlyFadeTransition, enableDisplayTransition));
    if (backgroundColor) cssText.push('background-color:' + backgroundColor);
    // Border style
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $c09e8b26bdb81866$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    });
    // Text style
    cssText.push($8b3bb31d5f59ebd9$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push('padding:' + (0, $c09e8b26bdb81866$export$f3a38102c49f4268)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
}
// If not able to make, do not modify the input `out`.
function $8b3bb31d5f59ebd9$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $342f62d58312c6d1$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $8b3bb31d5f59ebd9$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $d461075057ee3466$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement('div');
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $e4c0c902d0f4f283$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $8b3bb31d5f59ebd9$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $1aba4b63ed27962a$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $0d4253f44fb70c8c$export$3735103072e4a80)(container, 'position');
            var domStyle = container.style;
            if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        this._enableDisplayTransition = tooltipModel.get('displayTransition') && tooltipModel.get('transitionDuration') > 0;
        // update className
        this.el.className = tooltipModel.get('className') || '';
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $8b3bb31d5f59ebd9$var$gCssText + $8b3bb31d5f59ebd9$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide, this._enableDisplayTransition) + $8b3bb31d5f59ebd9$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $c09e8b26bdb81866$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $0d4253f44fb70c8c$export$a309528050824ba4)(tooltipModel)) arrow = $8b3bb31d5f59ebd9$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $e4c0c902d0f4f283$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return el ? [
            el.offsetWidth,
            el.offsetHeight
        ] : [
            0,
            0
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        if (!this.el) return;
        var styleCoord = this._styleCoord;
        $8b3bb31d5f59ebd9$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $8b3bb31d5f59ebd9$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        if (this._enableDisplayTransition) {
            style.visibility = 'hidden';
            style.opacity = '0';
        } else style.display = 'none';
        (0, $d461075057ee3466$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $e4c0c902d0f4f283$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var zr = this._zr;
        (0, $342f62d58312c6d1$export$a29dbe4b7d3cd586)(zr && zr.painter && zr.painter.getViewportRoot(), this._container);
        var el = this.el;
        if (el) {
            el.onmouseenter = el.onmousemove = el.onmouseleave = null;
            var parentNode = el.parentNode;
            parentNode && parentNode.removeChild(el);
        }
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $8b3bb31d5f59ebd9$export$2e2bcd8739ae039 = $8b3bb31d5f59ebd9$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $c8c8514313ed58f8$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $c8c8514313ed58f8$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($e4c0c902d0f4f283$export$a6cdc56e425d0d0a(content)) (0, $e5cdafd3d57b0dbf$export$8bf7aba4a9e09055)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $9f8a9b67e62609f8$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get('textShadowColor'),
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $b8b42d608e86874b$export$3048212c802df496)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        $e4c0c902d0f4f283$export$79b2f7037acddd43([
            'backgroundColor',
            'borderRadius',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $e4c0c902d0f4f283$export$79b2f7037acddd43([
            'textShadowBlur',
            'textShadowOffsetX',
            'textShadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $c8c8514313ed58f8$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $c8c8514313ed58f8$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $c8c8514313ed58f8$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $c8c8514313ed58f8$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($e4c0c902d0f4f283$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $c8c8514313ed58f8$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $c8c8514313ed58f8$var$calcShadowOuterSize(style) {
    var shadowBlur = $c8c8514313ed58f8$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $c8c8514313ed58f8$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $c8c8514313ed58f8$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $c8c8514313ed58f8$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $c8c8514313ed58f8$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $c8c8514313ed58f8$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $c8c8514313ed58f8$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $c8c8514313ed58f8$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $c8c8514313ed58f8$export$2e2bcd8739ae039 = $c8c8514313ed58f8$var$TooltipRichContent;




















var $08373dab4df8d3f7$var$proxyRect = new (0, $439653c37a0e6e60$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $08373dab4df8d3f7$var$TooltipView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $d461075057ee3466$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = this._renderMode = (0, $939d3a4c11ee87fd$export$cc0a17a5d27b4e17)(tooltipModel.get('renderMode'));
        this._tooltipContent = renderMode === 'richText' ? new (0, $c8c8514313ed58f8$export$2e2bcd8739ae039)(api) : new (0, $8b3bb31d5f59ebd9$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get('appendToBody', true) ? 'body' : tooltipModel.get('appendTo', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $d461075057ee3466$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) (0, $3a19e7f2dc31be9c$export$958e3e1a02eac4b6)(this, '_updatePosition', 50, 'fixRate');
        else (0, $3a19e7f2dc31be9c$export$42ffd38884aecdac)(this, '_updatePosition');
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $749ea2aefe76bf8f$export$6503ec6e8aabbaf('itemTooltip', this._api, (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get('triggerOn');
        if (tooltipModel.get('trigger') !== 'axis') {
            // _lastDataByCoordSys and _cbParamsList are used for axis tooltip only.
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
        }
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== 'none' && triggerOn !== 'click') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $d461075057ee3466$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $08373dab4df8d3f7$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = '';
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $08373dab4df8d3f7$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $08373dab4df8d3f7$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $006f7b7b99267dac$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        this._cbParamsList = null;
        if (payload.from !== this.uid) this._hide($08373dab4df8d3f7$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $08373dab4df8d3f7$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === 'legend') // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $c9d8ac168c7942c2$export$8a4fca9e04eb4df6)(el, function(target) {
                if (target.tooltipDisabled) {
                    seriesDispatcher_1 = cmptDispatcher_1 = null;
                    return true;
                }
                if (seriesDispatcher_1 || cmptDispatcher_1) return;
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(target).dataIndex != null) seriesDispatcher_1 = target;
                else if ((0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) cmptDispatcher_1 = target;
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._cbParamsList = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $08373dab4df8d3f7$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $b8b42d608e86874b$export$cf63b23ce77d1921)('section', {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $b8b42d608e86874b$export$2fba3afbcdcf3e18)();
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                var axis = axisModel.axis;
                var axisValueParsed = axis.scale.parse(axisValue);
                if (!axisModel || axisValue == null) return;
                // FIXME: when using `tooltip.trigger: 'axis'`, the precision of the axis value displayed in tooltip
                //  should match the original series values rather than using the default strategy in Interval.ts
                //  (getPrecision(interval) + 2); otherwise it may cause confusion.
                var axisValueLabel = $d12268f449565e1b$export$7cffee0f9aed39d0(axisValue, axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $b8b42d608e86874b$export$cf63b23ce77d1921)('section', {
                    header: axisValueLabel,
                    noHeader: !(0, $e4c0c902d0f4f283$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $7d2ffa192ebbc43e$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValueParsed
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', (0, $c09e8b26bdb81866$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $0acf4888a62e52cf$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $08373dab4df8d3f7$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get('valueFormatter');
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $b8b42d608e86874b$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $08373dab4df8d3f7$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $b8b42d608e86874b$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', (0, $c09e8b26bdb81866$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $0acf4888a62e52cf$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var valueFormatter = tooltipModel.get('valueFormatter');
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $b8b42d608e86874b$export$6969ffb02c1cb49a)(valueFormatter ? (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var isHTMLRenderMode = this._renderMode === 'html';
        var ecData = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        var encodeHTMLContent = tooltipOpt.encodeHTMLContent;
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
            // when `tooltipConfig.option` is a string rather than an object,
            // we can't know if the content needs to be encoded
            // for the sake of security, encode it by default.
            encodeHTMLContent = true;
        }
        if (encodeHTMLContent && isHTMLRenderMode && tooltipOpt.content) {
            // clone might be unnecessary?
            tooltipOpt = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(tooltipOpt);
            tooltipOpt.content = (0, $342f62d58312c6d1$export$f9d6449b9af28dc1)(tooltipOpt.content);
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $08373dab4df8d3f7$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + '';
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $b8b42d608e86874b$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $e4c0c902d0f4f283$export$9cd59f9826255e47)(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> instead of TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'), tooltipModel.get('defaultBorderColor', true));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $a8ce5c3e1c58d573$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $c09e8b26bdb81866$export$2028496a35766e41)(html, params, true);
            } else if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor, defaultBorderColor) {
        if (trigger === 'axis' || (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || defaultBorderColor
        };
        if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $52313d605bb144f5$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $08373dab4df8d3f7$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $08373dab4df8d3f7$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $08373dab4df8d3f7$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $08373dab4df8d3f7$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $0d4253f44fb70c8c$export$a309528050824ba4)(tooltipModel)) {
            var pos = $08373dab4df8d3f7$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        this._cbParamsList = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $d461075057ee3466$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $3a19e7f2dc31be9c$export$42ffd38884aecdac)(this, '_updatePosition');
        this._tooltipContent.dispose();
        $749ea2aefe76bf8f$export$d07f55d4c15c0440('itemTooltip', api);
        this._tooltipContent = null;
        this._tooltipModel = null;
        this._lastDataByCoordSys = null;
        this._cbParamsList = null;
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $08373dab4df8d3f7$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $7232b75992df3b9d$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get('tooltip', true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $08373dab4df8d3f7$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $e4c0c902d0f4f283$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $08373dab4df8d3f7$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $08373dab4df8d3f7$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $08373dab4df8d3f7$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $08373dab4df8d3f7$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $08373dab4df8d3f7$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $939d3a4c11ee87fd$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $939d3a4c11ee87fd$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $08373dab4df8d3f7$export$2e2bcd8739ae039 = $08373dab4df8d3f7$var$TooltipView;



function $59a15150201fb27a$export$4b3e715f166fdd78(registers) {
    (0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $539fac72a5ff49ed$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $20423702b6b38674$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $08373dab4df8d3f7$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, (0, $e4c0c902d0f4f283$export$8793edee2d425525));
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, (0, $e4c0c902d0f4f283$export$8793edee2d425525));
}




var $f87d65de6f7c0111$var$_a;
(0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $59a15150201fb27a$export$4b3e715f166fdd78));
class $f87d65de6f7c0111$export$639fd784fb67c186 extends (0, $e105d0ae0b8f861c$export$37de6f71bb86a769) {
}
($f87d65de6f7c0111$var$_a = globalThis.customElements) === null || $f87d65de6f7c0111$var$_a === void 0 || $f87d65de6f7c0111$var$_a.define('ec-tooltip', $f87d65de6f7c0111$export$639fd784fb67c186);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $6681f912fa623077$export$57b4bb4ff2a0950c = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var $6681f912fa623077$export$e78e6bf4dcc3e485 = [
    '25%',
    '25%'
];
var $6681f912fa623077$export$d0b4e8fdb7a13c60 = 'cartesian2d';
var $6681f912fa623077$var$GridModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var outerBoundsCp = (0, $52313d605bb144f5$export$4b0d20af19c9875e)(option.outerBounds);
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        if (outerBoundsCp && option.outerBounds) (0, $52313d605bb144f5$export$1754cb91f16ca028)(option.outerBounds, outerBoundsCp);
    };
    GridModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.apply(this, arguments);
        if (this.option.outerBounds && newOption.outerBounds) (0, $52313d605bb144f5$export$1754cb91f16ca028)(this.option.outerBounds, newOption.outerBounds);
    };
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: '15%',
        top: 65,
        right: '10%',
        bottom: 80,
        // If grid size contain label
        containLabel: false,
        outerBoundsMode: 'auto',
        outerBounds: $6681f912fa623077$export$57b4bb4ff2a0950c,
        outerBoundsContain: 'all',
        outerBoundsClampWidth: $6681f912fa623077$export$e78e6bf4dcc3e485[0],
        outerBoundsClampHeight: $6681f912fa623077$export$e78e6bf4dcc3e485[1],
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.transparent,
        borderWidth: 1,
        borderColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.neutral30
    };
    return GridModel;
}((0, $879a47e830ab7f41$export$2e2bcd8739ae039));
var $6681f912fa623077$export$2e2bcd8739ae039 = $6681f912fa623077$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $00c8269055b87df0$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.needIncludeZero = function() {
        return !this.option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();



var $92601769bcc35bf4$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $879a47e830ab7f41$export$2e2bcd8739ae039));
$e4c0c902d0f4f283$export$e36fc9d62a853069($92601769bcc35bf4$export$483dc37e6ad83a3c, (0, $00c8269055b87df0$export$5c54b224726edb5a));
var $92601769bcc35bf4$export$2e2bcd8739ae039 = $92601769bcc35bf4$export$483dc37e6ad83a3c;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8dbab0a7a852518b$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {
    },
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: 'auto',
        onZeroAxisIndex: null,
        lineStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.axisLine,
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ],
        breakLine: true
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12,
        color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.axisLabel,
        // In scenarios like axis labels, when labels text's progression direction matches the label
        // layout direction (e.g., when all letters are in a single line), extra start/end margin is
        // needed to prevent the text from appearing visually joined. In the other case, when lables
        // are stacked (e.g., having rotation or horizontal labels on yAxis), the layout needs to be
        // compact, so NO extra top/bottom margin should be applied.
        textMargin: [
            0,
            3
        ]
    },
    splitLine: {
        show: true,
        showMinLine: true,
        showMaxLine: true,
        lineStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.axisSplitLine,
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.backgroundTint,
                (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.backgroundTransparent
            ]
        }
    },
    breakArea: {
        show: true,
        itemStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.neutral00,
            // Break border color should be darker than the splitLine
            // because it has opacity and should be more prominent
            borderColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.border,
            borderWidth: 1,
            borderType: [
                3,
                3
            ],
            opacity: 0.6
        },
        zigzagAmplitude: 4,
        zigzagMinSpan: 4,
        zigzagMaxSpan: 20,
        zigzagZ: 100,
        expandOnClick: true
    },
    breakLabelLayout: {
        moveOverlap: 'auto'
    }
};
var $8dbab0a7a852518b$var$categoryAxis = $e4c0c902d0f4f283$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    jitter: 0,
    jitterOverlap: true,
    jitterMargin: 2,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto',
        show: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $8dbab0a7a852518b$var$defaultOption);
var $8dbab0a7a852518b$var$valueAxis = $e4c0c902d0f4f283$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.axisMinorSplitLine,
            width: 1
        }
    }
}, $8dbab0a7a852518b$var$defaultOption);
var $8dbab0a7a852518b$var$timeAxis = $e4c0c902d0f4f283$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // The default value of TimeScale is determined in `AxisBuilder`
        // showMinLabel: false,
        // showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $8dbab0a7a852518b$var$valueAxis);
var $8dbab0a7a852518b$var$logAxis = $e4c0c902d0f4f283$export$ebe90cb607ad99e({
    logBase: 10
}, $8dbab0a7a852518b$var$valueAxis);
var $8dbab0a7a852518b$export$2e2bcd8739ae039 = {
    category: $8dbab0a7a852518b$var$categoryAxis,
    value: $8dbab0a7a852518b$var$valueAxis,
    time: $8dbab0a7a852518b$var$timeAxis,
    log: $8dbab0a7a852518b$var$logAxis
};







function $9a42483783371e08$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)((0, $e709aeec1a12055b$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)((0, $e4c0c902d0f4f283$export$4950aa0f605343fb)({}, (0, $8dbab0a7a852518b$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $52313d605bb144f5$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $52313d605bb144f5$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)(option, themeModel.get(axisType + 'Axis'));
                (0, $e4c0c902d0f4f283$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $9a42483783371e08$var$getAxisType(option);
                if (layoutMode) (0, $52313d605bb144f5$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $62a778875ac6ef86$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) // NOTICE: return the raw data even if not existing; never use a fallback like `[]`;
                    // Its existence matters in some legacy cases.
                    return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.prototype.updateAxisBreaks = function(payload) {
                var axisBreakHelper = (0, $b57a96a87112d85a$export$c1d9b2cc33e7e5e)();
                return axisBreakHelper ? axisBreakHelper.updateModelAxisBreak(this, payload) : {
                    breaks: []
                };
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $9a42483783371e08$var$getAxisType);
}
function $9a42483783371e08$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $0c928317dd48690c$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $e4c0c902d0f4f283$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $e4c0c902d0f4f283$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $0c928317dd48690c$export$2e2bcd8739ae039 = $0c928317dd48690c$var$Cartesian;







var $8c2130a63785ce17$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $8c2130a63785ce17$var$canCalculateAffineTransform(scale) {
    // Only supported on linear space.
    return (scale.type === 'interval' || scale.type === 'time') && !(0, $88f2be8efb09cff5$export$fec008222a1db2dc)(scale);
}
var $8c2130a63785ce17$var$Cartesian2D = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = (0, $6681f912fa623077$export$d0b4e8fdb7a13c60);
        _this.dimensions = $8c2130a63785ce17$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$8c2130a63785ce17$var$canCalculateAffineTransform(xAxisScale) || !$8c2130a63785ce17$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = (0, $9073f5835d31d063$export$e182c528b7826102)(xAxisScale, null);
        var yScaleExtent = (0, $9073f5835d31d063$export$e182c528b7826102)(yAxisScale, null);
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $97681aabb80d556d$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking and series such as 'bar', 'pictorialBar', etc.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        // FIXME:
        //  (1) We should allow series (e.g., bar) to specify a base axis when
        //      both axes are type "value", rather than force to xAxis or angleAxis.
        //      NOTE: At present BoxplotSeries has its own overide `getBaseAxis`.
        //      `CoordinateSystem['getBaseAxis']` probably should not exist, since it
        //      may introduce inconsistency with `Series['getBaseAxis']`.
        //  (2) "base axis" info is required in "createSeriesData" stage for "stack",
        //      (see `dataStackHelper.ts` for details). Currently it is hard coded there.
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // [CAVEAT]: Do not add time consuming operation within and before fast path.
        // Fast path.
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $c20a2855346046a3$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp, out) {
        out = out || [];
        if (this._invTransform) return (0, $c20a2855346046a3$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $8d3017bded1ca21b$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $0c928317dd48690c$export$2e2bcd8739ae039));
var $8c2130a63785ce17$export$2e2bcd8739ae039 = $8c2130a63785ce17$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $462e7ece45712126$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 *
 * Lifetime: recreate for each main process.
 * [NOTICE]: Some caches is stored on the axis instance (e.g., `axisTickLabelBuilder.ts`, `scaleRawExtentInfo.ts`),
 *  which is based on this lifetime.
 */ var $462e7ece45712126$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        // NOTICE: Must ensure `true` is only available on 'category' axis.
        this.onBand = false;
        // Make sure that `extent[0] > extent[1]` only if `inverse: true`.
        // `inverse` can be inferred by `extent` unless `extent[0] === extent[1]`.
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(this.scale.parse(data));
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var scale = this.scale;
        data = scale.normalize(scale.parse(data));
        return (0, $0b2f7076fd7740ca$export$d3f68fbaa670562)(data, $462e7ece45712126$var$NORMALIZED_EXTENT, $462e7ece45712126$var$makeExtentWithBands(this), clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var t = (0, $0b2f7076fd7740ca$export$d3f68fbaa670562)(coord, $462e7ece45712126$var$makeExtentWithBands(this), $462e7ece45712126$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $bcb4c3869b07ba10$export$7cccf6836ae8323c)(this, tickModel, {
            breakTicks: opt.breakTicks,
            pruneByBreak: opt.pruneByBreak
        });
        var preTicksCoords = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(result.ticks, function(tick) {
            return {
                coord: this.dataToCoord((0, $7d2ffa192ebbc43e$export$889d2956111fd257)(this.scale, tick)),
                tick: tick
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        var onBandModified = $462e7ece45712126$var$fixOnBandTicksCoords(this, preTicksCoords, alignWithLabel);
        return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(preTicksCoords, function(item) {
            return {
                coord: item.coord,
                tickValue: item.tick.value,
                onBand: onBandModified
            };
        });
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if ((0, $27a07c2e80a6e56f$export$61579433626afe87)(this.scale)) // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber');
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function(ctx) {
        ctx = ctx || (0, $bcb4c3869b07ba10$export$12d6ac38274c43e7)((0, $bcb4c3869b07ba10$export$31cba7db0a663292).determine);
        return (0, $bcb4c3869b07ba10$export$10216ebd3e3e485e)(this, ctx).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * @deprecated Use `calcBandWidth` instead.
   */ Axis.prototype.getBandWidth = function() {
        return (0, $6d521ceff1ab94af$export$141021262b29d96e)(this, {
            min: 1
        }).w;
    // NOTICE: Do not add logic here. Implement everthing in `calcBandWidth`.
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for category axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function(ctx) {
        ctx = ctx || (0, $bcb4c3869b07ba10$export$12d6ac38274c43e7)((0, $bcb4c3869b07ba10$export$31cba7db0a663292).determine);
        return (0, $bcb4c3869b07ba10$export$9ea1d3f146a5a65f)(this, ctx);
    };
    return Axis;
}();
function $462e7ece45712126$var$makeExtentWithBands(axis) {
    var extent = axis.getExtent();
    if (axis.onBand) {
        var size = extent[1] - extent[0];
        var margin = size / axis.scale.count() / 2;
        extent[0] += margin;
        extent[1] -= margin;
    }
    return extent;
}
/**
 * `axis.onBand: true` (i.e., `boundaryGap: true` in ec option) and `CategoryTickLabelSplitIntervalOption`
 *  affects `axisTick`/`axisLabel`/`splitLine`/`splitArea`.
 *
 * Currently, the visual result is best only when `axisTick/splitLine/splitArea.interval === 0`.
 * The typical case is:
 *      |---|---|---|     <= This is the input `preTicksCoords`
 *      0   1   2   3        (having been added half band width by `makeExtentWithBands`).
 *    |---|---|---|---|  <= This is the result.
 *      0   1   2   3
 *
 * When `interval > 0`, the visual result may be odd for `axisLabel` and `customValues`, but acceptable
 * for `axisTick` `splitLine` and `splitArea`:
 *      |---~---|---~---~---|---|    <= This is the input `preTicksCoords`; `interval: 2; min: 1; max: 7`.
 *      ₁   ₂   3   ₄   ₅   6   ₇       Subscript numbers (`₀`, `₁`, `₃`) indicate axis labels are hidden
 *                                      (by default settings) due to off-interval.
 *                                      A tilde (`~`) indicates a tick ignored due to off-interval.
 *    |---~---|---~---~---|---~---|  <= This is the result.
 *      ₁   ₂   3   ₄   ₅   6   ₇
 *
 * NOTE:
 *  - A inappropriate result may cause misleading (e.g., split 2 bars of a single data item when there
 *    are two bar series).
 *  - See also #11176 #11186 .
 * PENDING:
 *  - The show/hide of `axisLabel` may be optimized when `interval > 1 and be an even number`,
 *    but that may introduce complex and still not perfect in odd number, and may not necessary if
 *    `axisTick: {show: false}` and `axisLabel` can auto hidden when overlapping.
 */ function $462e7ece45712126$var$fixOnBandTicksCoords(axis, preTicksCoords, alignWithLabel) {
    var ticksLen = preTicksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return false;
    // Assume:
    //  - If `onBand: true`, `bandWidth` has been calculated by `ticksLen + 1` rather than `ticksLen`.
    //  - If `interval > 0`, some ticks may be ignored, but `ticksCoords` has always included boundary
    //    ticks of axis extent, and be `offInterval: true` if off-interval.
    //  - No need to consider breaks, since axis break is not supported in category axis.
    var bandWidth = (0, $6d521ceff1ab94af$export$141021262b29d96e)(axis).w;
    if (!bandWidth) return false;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(preTicksCoords, function(ticksItem) {
        ticksItem.coord -= bandWidth / 2;
    });
    var dataExtent = axis.scale.getExtent();
    var oldLast = preTicksCoords[ticksLen - 1];
    if (oldLast.tick.offInterval) preTicksCoords.pop();
    preTicksCoords.push({
        coord: oldLast.coord + bandWidth,
        tick: {
            value: dataExtent[1] + 1
        }
    });
    return true;
}
var $462e7ece45712126$export$2e2bcd8739ae039 = $462e7ece45712126$var$Axis;


var $d51f3c9a0e832182$var$Axis2D = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $462e7ece45712126$export$2e2bcd8739ae039));
var $d51f3c9a0e832182$export$2e2bcd8739ae039 = $d51f3c9a0e832182$var$Axis2D;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/**
 * NOTICE: Can be only used in `ensureScaleStore(axisLike)`.
 *
 * In most cases the instances of `Axis` and `Scale` are one-to-one mapping and share the same lifecycle.
 * But in some external usage (such as echarts-gl), axis instance does not necessarily exist, and only
 * scale instance and axisModel are used. Therefore we store the internal info on scale instance directly.
 */ var $10061a7e816c9eb5$var$scaleInner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
var $10061a7e816c9eb5$export$c4999badb722a7d7 = 1;
var $10061a7e816c9eb5$export$f9ee28ea7363d798 = 2;
var $10061a7e816c9eb5$var$AXIS_EXTENT_INFO_BUILD_FROM_EMPTY = 3;
var $10061a7e816c9eb5$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Typically: data extent from all series on this axis.
    dataExtent, requireStartValue, requireContainShape) {
        var isOrdinal = (0, $27a07c2e80a6e56f$export$61579433626afe87)(scale);
        var axisDataLen = isOrdinal ? model.getCategories().length : null;
        // [CATEGORY_AXIS_MODEL_DATA_IS_EMPTY_ARRAY]:
        // This is only for backward compatibility - `xxxAxis: {data: []}` can declare this axis as
        // a "category" axis and use `series.data` to determine its extent but the axis is blank - only
        // axis line is displayed. This is a conincidence, but it is used in some cases.
        var categoryAxisModelDataIsEmptyArray;
        if (isOrdinal) {
            var axisModelDataArray = model.getCategories(true);
            categoryAxisModelDataIsEmptyArray = axisModelDataArray && !axisModelDataArray.length;
        }
        // NOTE: also considered the input dataExtent may be still in the initialized state `[Infinity, -Infinity]`.
        var dataMM = dataExtent.slice();
        // custom dataMin/dataMax.
        // Also considered `modelDataMinMax[0] > modelDataMinMax[1]` may occur.
        if ((0, $27a07c2e80a6e56f$export$ba0fcad386c5c7e6)(scale) || (0, $27a07c2e80a6e56f$export$8b1d8a59aa13c502)(scale) || (0, $27a07c2e80a6e56f$export$c9b71a3750db342f)(scale)) {
            (0, $939d3a4c11ee87fd$export$a7951d5427fae7a0)(dataMM, $10061a7e816c9eb5$var$parseAxisModelMinMax(scale, model.get('dataMin', true)));
            (0, $939d3a4c11ee87fd$export$707ef09fb8bbaa0e)(dataMM, $10061a7e816c9eb5$var$parseAxisModelMinMax(scale, model.get('dataMax', true)));
        }
        if (!(0, $939d3a4c11ee87fd$export$622ca7efe3351d22)(dataMM)) // dataMM may be still `[Infinity, -Infinity]`, we use `NaN` on the subsequent calculations
        // to force the `noZoomEffMM` to be `[NaN, NaN]` if needed.
        dataMM[0] = dataMM[1] = NaN;
        var noZoomEffMM = [];
        var fixMM = [
            false,
            false
        ];
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needIncludeZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var modelMinRaw = model.get('min', true);
        if (modelMinRaw === 'dataMin') {
            noZoomEffMM[0] = dataMM[0];
            fixMM[0] = true;
        } else {
            noZoomEffMM[0] = $10061a7e816c9eb5$var$parseAxisModelMinMax(scale, (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(modelMinRaw) ? modelMinRaw({
                min: dataMM[0],
                max: dataMM[1]
            }) : modelMinRaw);
            // If `xxxAxis.min: null/undefined`, min should not be fixed.
            fixMM[0] = noZoomEffMM[0] != null;
        }
        var modelMaxRaw = model.get('max', true);
        if (modelMaxRaw === 'dataMax') {
            noZoomEffMM[1] = dataMM[1];
            fixMM[1] = true;
        } else {
            noZoomEffMM[1] = $10061a7e816c9eb5$var$parseAxisModelMinMax(scale, (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(modelMaxRaw) ? modelMaxRaw({
                min: dataMM[0],
                max: dataMM[1]
            }) : modelMaxRaw);
            // If `xxxAxis.max: null/undefined`, max should not be fixed.
            fixMM[1] = noZoomEffMM[1] != null;
        }
        var boundaryGap = $10061a7e816c9eb5$var$parseBoundaryGapOption(scale, model);
        var span = !isOrdinal ? dataMM[1] - dataMM[0] || Math.abs(dataMM[0]) : null;
        // NOTE: If a numeric axis min/max is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used.
        if (noZoomEffMM[0] == null) noZoomEffMM[0] = isOrdinal ? categoryAxisModelDataIsEmptyArray ? dataMM[0] : axisDataLen ? 0 : NaN : dataMM[0] - boundaryGap[0] * span;
        if (noZoomEffMM[1] == null) noZoomEffMM[1] = isOrdinal ? categoryAxisModelDataIsEmptyArray ? dataMM[1] : axisDataLen ? axisDataLen - 1 : NaN : dataMM[1] + boundaryGap[1] * span;
        // Normalize to `NaN` if invalid; e.g., this may occur when `dataMM` has Infinity.
        !(0, $939d3a4c11ee87fd$export$5af06089290883e2)(noZoomEffMM[0]) && (noZoomEffMM[0] = NaN);
        !(0, $939d3a4c11ee87fd$export$5af06089290883e2)(noZoomEffMM[1]) && (noZoomEffMM[1] = NaN);
        var isBlank = categoryAxisModelDataIsEmptyArray || (0, $e4c0c902d0f4f283$export$7d667b9a0c48c975)(noZoomEffMM[0]) || (0, $e4c0c902d0f4f283$export$7d667b9a0c48c975)(noZoomEffMM[1]) || isOrdinal && !axisDataLen;
        // NOTE: `needIncludeZero` is not applicable to LogScale, TimeScale, OrdinalScale.
        var needIncludeZeroApplicable = (0, $27a07c2e80a6e56f$export$ba0fcad386c5c7e6)(scale);
        var needIncludeZero = needIncludeZeroApplicable && model.needIncludeZero && model.needIncludeZero();
        if (needIncludeZero) {
            if (noZoomEffMM[0] > 0 && noZoomEffMM[1] > 0 && !fixMM[0]) noZoomEffMM[0] = 0;
            if (noZoomEffMM[0] < 0 && noZoomEffMM[1] < 0 && !fixMM[1]) noZoomEffMM[1] = 0;
        }
        var needToggleAxisInverse = false;
        if (noZoomEffMM[0] > noZoomEffMM[1]) {
            // Historically, if users set `xxxAxis.min > xxxAxis.max`, or `xxxAxis.max < dataExtent[0]`,
            // or `xxxAxis.min > dataExtent[1]` the behavior is sometimes like `xxxAxis.inverse = true`,
            // sometimes abnormal. We remain backward compatible with the former one, though this feature
            // may not be reasonable.
            // And handle it after "needIncludeZero" is also for backward compatibility.
            noZoomEffMM.reverse();
            needToggleAxisInverse = true;
        }
        var startValue = $10061a7e816c9eb5$var$parseAxisModelMinMax(scale, model.get('startValue', true));
        var startValueSpecified = startValue != null;
        if (!(0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(startValue) && requireStartValue) startValue = scale.getDefaultStartValue ? scale.getDefaultStartValue() : 0;
        if ((0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(startValue) && (startValueSpecified || !needIncludeZeroApplicable || needIncludeZero)) {
            if (startValue < noZoomEffMM[0] && !fixMM[0]) {
                noZoomEffMM[0] = startValue;
                fixMM[0] = true;
            } else if (startValue > noZoomEffMM[1] && !fixMM[1]) {
                noZoomEffMM[1] = startValue;
                fixMM[1] = true;
            }
        }
        var internal = this._i = {
            scale: scale,
            dataMM: dataMM,
            noZoomEffMM: noZoomEffMM,
            zoomMM: [],
            fixMM: fixMM,
            zoomFixMM: [
                false,
                false
            ],
            startValue: startValue,
            isBlank: isBlank,
            incl0: needIncludeZero,
            tggAxInv: needToggleAxisInverse,
            ctnShp: requireContainShape
        };
        $10061a7e816c9eb5$var$sanitizeExtent(internal, noZoomEffMM);
    }
    ScaleRawExtentInfo.prototype.makeNoZoom = function() {
        return this._i.noZoomEffMM.slice();
    };
    ScaleRawExtentInfo.prototype.makeFinal = function() {
        var internal = this._i;
        var zoomMM = internal.zoomMM;
        var noZoomEffMM = internal.noZoomEffMM;
        var zoomFixMM = internal.zoomFixMM;
        var fixMM = internal.fixMM;
        var result = {
            fixMM: fixMM,
            zoomFixMM: zoomFixMM,
            isBlank: internal.isBlank,
            incl0: internal.incl0,
            tggAxInv: internal.tggAxInv,
            ctnShp: internal.ctnShp,
            effMM: noZoomEffMM.slice()
        };
        var effMM = result.effMM;
        // NOTE: Switching `fixMM` probably leads to abrupt extent changes when draging a `dataZoom`
        //  handle, since `fixMM` impact the "nice extent" and "nice ticks" calculation.
        //  Consider a case:
        //    dataZoom `start` is 2% but its `end` is 100%, (or vice versa), we currently only set `fixMM[0]`
        //    as `true` but remain `fixMM[1]` as `false` for this case to avoid unnecessary abrupt change.
        //    Incidentally, the effect is not unacceptable if we set both `fixMM[0]/[1]` as `true`.
        if (zoomMM[0] != null) {
            effMM[0] = zoomMM[0];
            fixMM[0] = zoomFixMM[0] = true;
        }
        if (zoomMM[1] != null) {
            effMM[1] = zoomMM[1];
            fixMM[1] = zoomFixMM[1] = true;
        }
        $10061a7e816c9eb5$var$sanitizeExtent(internal, effMM);
        return result;
    };
    ScaleRawExtentInfo.prototype.makeRenderInfo = function() {
        return {
            startValue: this._i.startValue
        };
    };
    /**
   * NOTICE:
   *  - Do not set them if the percent are 0% or 100%. (See `AxisProxy['reset']`.)
   *  - The caller must ensure `start <= end` and the range is equal or less then `noZoomEffMM`.
   *    (See `AxisProxy['calculateDataWindow']`.)
   *  - The outcome `_zoomMM` may have both `NullUndefined` and a finite value, like `[undefined, 123]`.
   */ ScaleRawExtentInfo.prototype.setZoomMM = function(idxMinMax, val) {
        this._i.zoomMM[idxMinMax] = val;
    };
    return ScaleRawExtentInfo;
}();
/**
 * Should be called when a new extent is created or modified.
 */ function $10061a7e816c9eb5$var$sanitizeExtent(internal, mm) {
    var scale = internal.scale;
    var dataMM = internal.dataMM;
    if (scale.sanitize) {
        mm[0] = scale.sanitize(mm[0], dataMM);
        mm[1] = scale.sanitize(mm[1], dataMM);
        (0, $939d3a4c11ee87fd$export$fca8d858e99f6a42)(mm);
    }
}
function $10061a7e816c9eb5$var$parseAxisModelMinMax(scale, minMax) {
    return minMax == null ? null // null/undefined means not specified and other default values can be applied.
     : (0, $e4c0c902d0f4f283$export$7d667b9a0c48c975)(minMax) ? NaN // NaN means a deliberate invalid number.
     : scale.parse(minMax);
}
function $10061a7e816c9eb5$var$parseBoundaryGapOption(scale, model) {
    var boundaryGapOptionArr;
    if ((0, $27a07c2e80a6e56f$export$61579433626afe87)(scale)) boundaryGapOptionArr = [
        0,
        0
    ];
    else {
        var boundaryGap = model.get('boundaryGap');
        if (typeof boundaryGap === 'boolean') boundaryGap = null;
        boundaryGapOptionArr = (0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
            boundaryGap,
            boundaryGap
        ];
    }
    return [
        $10061a7e816c9eb5$var$parseBoundaryGapOptionItem(boundaryGapOptionArr[0]),
        $10061a7e816c9eb5$var$parseBoundaryGapOptionItem(boundaryGapOptionArr[1])
    ];
}
function $10061a7e816c9eb5$var$parseBoundaryGapOptionItem(opt) {
    return (0, $211780946ab71638$export$e8514cb5a5e2b40f)(typeof opt === 'boolean' ? 0 : opt, 1) || 0;
}
/**
 * NOTE: `associateSeriesWithAxis` is not necessarily called, e.g., when
 * an axis is not used by any series.
 */ function $10061a7e816c9eb5$var$ensureScaleStore(axisLike) {
    var store = $10061a7e816c9eb5$var$scaleInner(axisLike.scale);
    if (!store.extent) store.extent = (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)();
    return store;
}
function $10061a7e816c9eb5$export$710d8a038761b881(axisLike, coordSysDimIdxMap) {
    $10061a7e816c9eb5$var$ensureScaleStore(axisLike).dimIdxInCoord = coordSysDimIdxMap.get(axisLike.dim);
}
function $10061a7e816c9eb5$export$113bceb7edf323a4(axis, from) {
    var scale = axis.scale;
    var model = axis.model;
    var axisDim = axis.dim;
    if (scale.rawExtentInfo) return;
    $10061a7e816c9eb5$var$scaleRawExtentInfoCreateDeal(scale, axis, axisDim, model, from);
}
function $10061a7e816c9eb5$var$scaleRawExtentInfoCreateDeal(scale, axis, axisDim, model, from) {
    var scaleStore = $10061a7e816c9eb5$var$ensureScaleStore(axis);
    var extent = scaleStore.extent;
    var requireStartValue = false;
    (0, $e25c2a392bb1e248$export$cee01bd2e39d754e)(axis, function(seriesModel) {
        if (seriesModel.boxCoordinateSystem) {
            // This supports union extent on case like: pie (or other similar series)
            // lays out on cartesian2d.
            var coord = (0, $65108a454a48746f$export$4818264084d885e)(seriesModel).coord;
            var dimIdx = scaleStore.dimIdxInCoord;
            if (!(dimIdx >= 0)) ;
            else if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(coord)) {
                var coordItem = coord[dimIdx];
                if (coordItem != null && !(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(coordItem)) (0, $939d3a4c11ee87fd$export$c28a8a63acb35a19)(extent, scale.parse(coordItem));
            }
        } else if (seriesModel.coordinateSystem) {
            // NOTE: This data may have been filtered by dataZoom on orthogonal axes.
            var data_1 = seriesModel.getData();
            if (data_1) {
                var filter_1 = scale.getFilter ? scale.getFilter() : null;
                (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)((0, $7d2ffa192ebbc43e$export$e4cf30b1e74cd69d)(data_1, axisDim), function(dim) {
                    (0, $939d3a4c11ee87fd$export$380d5a0634ac86f8)(extent, data_1.getApproximateExtent(dim, filter_1));
                });
            }
            if (seriesModel.__requireStartValue && seriesModel.__requireStartValue(axis)) requireStartValue = true;
        }
    });
    var requireContainShape = $10061a7e816c9eb5$var$determineRequireContainShape(scale, axis, model);
    var rawExtentInfo = new $10061a7e816c9eb5$export$c35454f678e99c82(scale, model, extent, requireStartValue, requireContainShape);
    $10061a7e816c9eb5$var$injectScaleRawExtentInfo(scale, rawExtentInfo, from);
    scaleStore.extent = null; // Clean up
}
/**
 * `rawExtentInfo` may not be created in some cases, such as no series declared or extra useless
 * axes declared in ec option. In this case we still create a default one for that empty axis.
 */ function $10061a7e816c9eb5$var$scaleRawExtentInfoBuildDefault(axisLike, dataExtent) {
    var scale = axisLike.scale;
    $10061a7e816c9eb5$var$injectScaleRawExtentInfo(scale, new $10061a7e816c9eb5$export$c35454f678e99c82(scale, axisLike.model, dataExtent, false, false), $10061a7e816c9eb5$var$AXIS_EXTENT_INFO_BUILD_FROM_EMPTY);
}
function $10061a7e816c9eb5$var$injectScaleRawExtentInfo(scale, scaleRawExtentInfo, from) {
    // @ts-ignore
    scale.rawExtentInfo = scaleRawExtentInfo;
    // @ts-ignore
    scaleRawExtentInfo.from = from;
}
function $10061a7e816c9eb5$export$7b3647d53bcfcf4e(// `axisStatKey` is used to quickly omit irrelevant handlers,
// since handlers need to be iterated per axis.
axisStatKey, handler) {
    $10061a7e816c9eb5$var$axisContainShapeHandlerMap.set(axisStatKey, handler);
}
var $10061a7e816c9eb5$var$axisContainShapeHandlerMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
function $10061a7e816c9eb5$export$b9937565663b5dda(scale, model, ecModel, axis, externalDataExtent) {
    if (!scale.rawExtentInfo) $10061a7e816c9eb5$var$scaleRawExtentInfoBuildDefault({
        scale: scale,
        model: model
    }, externalDataExtent || (0, $939d3a4c11ee87fd$export$62e5f07ab009f3b)());
    var rawExtentResult = scale.rawExtentInfo.makeFinal();
    // NOTE: This `scale.setExtent()` is required by:
    //  - `axisNiceTicks.ts` and `axisAlignTicks.ts`, where the internal `scaleMapper` may be required.
    var effectiveMinMax = rawExtentResult.effMM;
    scale.setExtent(effectiveMinMax[0], effectiveMinMax[1]);
    scale.setBlank(rawExtentResult.isBlank);
    if (axis && rawExtentResult.tggAxInv && ecModel && !ecModel.get('legacyMinMaxDontInverseAxis')) axis.inverse = !axis.inverse;
    return rawExtentResult;
}
function $10061a7e816c9eb5$var$determineRequireContainShape(scale, axis, model) {
    var onBand = (0, $7d2ffa192ebbc43e$export$43d51f65881fb080)(scale, model);
    var modelContainShape = model.get('containShape', true);
    if (modelContainShape == null && !onBand) modelContainShape = true;
    if (!modelContainShape) return false;
    var requireContainShape = false;
    (0, $e25c2a392bb1e248$export$21f2993d5751eb66)(axis, function(axisStatKey) {
        requireContainShape = !!$10061a7e816c9eb5$var$axisContainShapeHandlerMap.get(axisStatKey) || requireContainShape;
    });
    return requireContainShape;
}
function $10061a7e816c9eb5$export$922e3b0bde7215c8(axis, scale, rawExtentResult, ecModel) {
    if (!rawExtentResult.ctnShp) return;
    var linearSupplement;
    (0, $e25c2a392bb1e248$export$21f2993d5751eb66)(axis, function(axisStatKey) {
        var handler = $10061a7e816c9eb5$var$axisContainShapeHandlerMap.get(axisStatKey);
        if (handler) {
            // This feature can be implemented by either expanding axis extent or scale extent. The choice depends
            // on whether series shape sizes are defined in pixels or data space. For example, scatter series glyph
            // sizes is mainly defined in pixel, while bar series `bandWidth` is mainly determined by given percents
            // of data scale. Since currently scatter does not require this feature, we implement it only on the
            // data scale.
            var singleLinearSupplement = handler(axis, ecModel);
            if (singleLinearSupplement) {
                linearSupplement = linearSupplement || [
                    0,
                    0
                ];
                (0, $939d3a4c11ee87fd$export$a7951d5427fae7a0)(linearSupplement, singleLinearSupplement[0]);
                (0, $939d3a4c11ee87fd$export$707ef09fb8bbaa0e)(linearSupplement, singleLinearSupplement[1]);
                // Consider the consistency of `onZero` behavior (not varying by series data; otherwise error-prone
                // to users), if any `containShape` really performed on this axis, discourage `onZero`.
                (0, $7d2ffa192ebbc43e$export$3a3942ca9637d423)(axis);
            }
        }
    });
    if (!linearSupplement) return;
    var scaleExtent = scale.getExtent();
    if ((0, $27a07c2e80a6e56f$export$61579433626afe87)(scale)) {
        if (!axis.onBand) // - Zooming on `OrdinalScale` auto "snaps" to integer ticks, which causes edge shapes to
        //   always overlap and be clipped at the boundaries. Therefore we always supplement it with
        //   half bandWith to avoid that overlapping.
        // - `linearSupplement` is typically [-0.5, 0.5] in this case. `linearSupplement` exists only
        //   if any series call `registerAxisContainShapeHandler`.
        // - PENDING: For historical reason, `onBand: true` has another implementation to handle
        //   this case. Merge them to this?
        scale.setExtent2((0, $9073f5835d31d063$export$a9efb7aa6faff3f6), (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(scaleExtent[0], scaleExtent[0] + linearSupplement[0]), (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(scaleExtent[1], scaleExtent[1] + linearSupplement[1]));
    } else {
        // For other cases, `SCALE_EXTENT_KIND_MAPPING` is only used on the full window of `dataZoom`,
        // where the visual result is more intuitive when zooming: when dataZoom is applied and its ends
        // (i.e., `zoomMM`) do not reach 0% or 100%, the axis ends should exactly respect to the dataZoom
        // ends, and shapes are clipped if overflowing.
        var scaleExtentExpanded = scaleExtent.slice();
        if (!rawExtentResult.zoomFixMM[0]) scaleExtentExpanded[0] = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(scaleExtentExpanded[0], scale.transformOut(scale.transformIn(scaleExtentExpanded[0], null) + linearSupplement[0], null));
        if (!rawExtentResult.zoomFixMM[1]) scaleExtentExpanded[1] = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(scaleExtentExpanded[1], scale.transformOut(scale.transformIn(scaleExtentExpanded[1], null) + linearSupplement[1], null));
        if (scaleExtentExpanded[0] < scaleExtent[0] || scaleExtentExpanded[1] > scaleExtent[1]) scale.setExtent2((0, $9073f5835d31d063$export$a9efb7aa6faff3f6), scaleExtentExpanded[0], scaleExtentExpanded[1]);
    }
// NOTE: since currently `SCALE_EXTENT_KIND_MAPPING` is never required to be displayed, we
// do not need to find a proper precision for that. But if it is required in the future, We
// can use `getAcceptableTickPrecision` to find a proper precision.
}



function $cbffa79ff5cf1ac8$export$a54aa0aabf394e1b(targetAxis, alignToScale) {
    var targetScale = targetAxis.scale;
    var targetAxisModel = targetAxis.model;
    var targetExtentInfo = (0, $10061a7e816c9eb5$export$b9937565663b5dda)(targetScale, targetAxisModel, targetAxisModel.ecModel, targetAxis, null);
    // FIXME:
    //  (1) Axis inverse is not considered yet.
    //  (2) `SCALE_EXTENT_KIND_MAPPING` is not considered yet.
    var isTargetLogScale = (0, $27a07c2e80a6e56f$export$8b1d8a59aa13c502)(targetScale);
    var alignToScaleLinear = (0, $27a07c2e80a6e56f$export$8b1d8a59aa13c502)(alignToScale) ? alignToScale.intervalStub : alignToScale;
    var targetIntervalStub = isTargetLogScale ? targetScale.intervalStub : targetScale;
    var targetLogScaleBase = targetScale.base;
    var alignToTicks = alignToScaleLinear.getTicks();
    var alignToExpNiceTicks = alignToScaleLinear.getTicks({
        expandToNicedExtent: true
    });
    var alignToSegCount = alignToTicks.length - 1;
    // The Current strategy: Find a proper interval and an extent for the target scale to derive ticks
    // matching exactly to ticks of `alignTo` scale.
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0; // diff ratio on min not-nice segment. 0 <= t0 < 1
    var t1; // diff ratio on max not-nice segment. 0 <= t1 < 1
    var alignToNiceSegCount; // >= 1
    // Consider ticks of `alignTo`, only these cases below may occur:
    if (alignToSegCount === 1) {
        // `alignToTicks` is like:
        //  |--|
        // In this case, we make the corresponding 2 target ticks "nice".
        t0 = t1 = 0;
        alignToNiceSegCount = 1;
    } else if (alignToSegCount === 2) {
        // `alignToTicks` is like:
        //  |-|-----| or
        //  |-----|-| or
        //  |-----|-----|
        // Notices that nice ticks do not necessarily exist in this case.
        // In this case, we choose the larger segment as the "nice segment" and
        // the corresponding target ticks are made "nice".
        var interval0 = (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(alignToTicks[0].value - alignToTicks[1].value);
        var interval1 = (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(alignToTicks[1].value - alignToTicks[2].value);
        t0 = t1 = 0;
        if (interval0 === interval1) alignToNiceSegCount = 2;
        else {
            alignToNiceSegCount = 1;
            if (interval0 < interval1) t0 = interval0 / interval1;
            else t1 = interval1 / interval0;
        }
    } else {
        // alignToSegCount >= 3
        // `alignToTicks` is like:
        //  |-|-----|-----|-| or
        //  |-----|-----|-| or
        //  |-|-----|-----| or ...
        // At least one nice segment is present, and not-nice segments are only present on
        // the start and/or the end.
        // In this case, ticks corresponding to nice segments are made "nice".
        var alignToInterval = alignToScaleLinear.getConfig().interval;
        t0 = (1 - (alignToTicks[0].value - alignToExpNiceTicks[0].value) / alignToInterval) % 1;
        t1 = (1 - (alignToExpNiceTicks[alignToSegCount].value - alignToTicks[alignToSegCount].value) / alignToInterval) % 1;
        alignToNiceSegCount = alignToSegCount - (t0 ? 1 : 0) - (t1 ? 1 : 0);
    }
    // NOTE:
    //  Consider a case:
    //    dataZoom controls all Y axes;
    //    dataZoom end is 90% (maxFixed: true, dataZoomFixMinMax[0]: true);
    //    but dataZoom start is 0% (minFixed: false, dataZoomFixMinMax[1]: false);
    //  In this case,
    //    - `Interval#calcNiceTicks` only uses `targetExtentInfo.max` as the upper bound, but expand the
    //      lower bound to a "nice" tick and can get an acceptable result.
    //    - `scaleCalcAlign` has to use both `targetExtentInfo.min/max` as the bounds without any expansion,
    //      otherwise the lower bound may become negative unexpectedly, especially for all positive series data.
    var dataZoomFixMinMax = targetExtentInfo.zoomFixMM;
    var hasDataZoomFixMinMax = dataZoomFixMinMax[0] || dataZoomFixMinMax[1];
    var targetMinMaxFixed = [
        targetExtentInfo.fixMM[0] || hasDataZoomFixMinMax,
        targetExtentInfo.fixMM[1] || hasDataZoomFixMinMax
    ];
    // MEMO: When only `xxxAxis.min` or `xxxAxis.max` is fixed,
    //  - Even a "nice" interval can be calculated, ticks accumulated based on `min`/`max` can be "nice" only if
    //    `min` or `max` is a "nice" number.
    //  - Generating a "nice" interval may cause the extent have both positive and negative ticks, which may be
    //    not preferable for all positive (very common) or all negative series data. But it can be simply resolved
    //    by specifying `xxxAxis.min: 0`/`xxxAxis.max: 0`, so we do not specially handle this case here.
    //  Therefore, we prioritize generating "nice" interval over preventing from crossing zero.
    //  e.g., if series data are all positive and the max data is `11739`,
    //      If setting `yAxis.max: 'dataMax'`, ticks may be like:
    //          `11739, 8739, 5739, 2739, -1739` (not "nice" enough)
    //      If setting `yAxis.max: 'dataMax', yAxis.min: 0`, ticks may be like:
    //          `11739, 8805, 5870, 2935, 0` (not "nice" enough but may be acceptable)
    //      If setting `yAxis.max: 12000, yAxis.min: 0`, ticks may be like:
    //          `12000, 9000, 6000, 3000, 0` ("nice")
    var targetOldOutermostExtent = targetScale.getExtent();
    var targetOldIntervalExtent = targetIntervalStub.getExtent();
    var targetExtent = (0, $27a07c2e80a6e56f$export$e279d7ed1695209d)(targetOldIntervalExtent, targetMinMaxFixed);
    var min;
    var max;
    var interval;
    var intervalPrecision;
    var maxNice;
    var minNice;
    function loopIncreaseInterval(cb) {
        // Typically this loop runs less than 5 times. But we still
        // use a fail-safe for future changes.
        var LOOP_MAX = 50;
        var loopGuard = 0;
        for(; loopGuard < LOOP_MAX; loopGuard++){
            if (cb()) break;
            interval = isTargetLogScale ? interval * (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(targetLogScaleBase, 2) : (0, $27a07c2e80a6e56f$export$f39031e8422f329d)(interval);
            intervalPrecision = (0, $27a07c2e80a6e56f$export$86a060b060d3d31a)(interval);
        }
    }
    function updateMinFromMinNice() {
        min = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(minNice - interval * t0, intervalPrecision);
    }
    function updateMaxFromMaxNice() {
        max = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(maxNice + interval * t1, intervalPrecision);
    }
    function updateMinNiceFromMinT0Interval() {
        minNice = t0 ? (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(min + interval * t0, intervalPrecision) : min;
    }
    function updateMaxNiceFromMaxT1Interval() {
        maxNice = t1 ? (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(max - interval * t1, intervalPrecision) : max;
    }
    // NOTE: The new calculated `min`/`max` must NOT shrink the original extent; otherwise some series
    // data may be outside of the extent. They can expand the original extent slightly to align with
    // ticks of `alignTo`. In this case, more blank space is added but visually fine.
    if (targetMinMaxFixed[0] && targetMinMaxFixed[1]) {
        // Both `min` and `max` are specified (via dataZoom or ec option; consider both Cartesian, radar and
        // other possible axes). In this case, "nice" ticks can hardly be calculated, but reasonable ticks should
        // still be calculated whenever possible, especially `intervalPrecision` should be tuned for better
        // appearance and lower cumulative error.
        min = targetExtent[0];
        max = targetExtent[1];
        interval = (max - min) / (alignToNiceSegCount + t0 + t1);
        // Typically axis pixel extent is ready here. See `create` in `Grid.ts`.
        var axisPxExtent = targetAxis.getExtent();
        // NOTICE: this pxSpan may be not accurate yet due to "outerBounds" logic, but acceptable so far.
        var pxSpan = (0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(axisPxExtent[1] - axisPxExtent[0]);
        // We imperically choose `pxDiffAcceptable` as `0.5 / alignToNiceSegCount` for reduce cumulative
        // error, otherwise a discernible misalign (> 1px) may occur.
        // PENDING: We do not find a acceptable precision for LogScale here.
        //  Theoretically it can be addressed but introduce more complexity. Is it necessary?
        intervalPrecision = (0, $0b2f7076fd7740ca$export$de3fddfc2aec84e4)([
            max,
            min
        ], pxSpan, 0.5 / alignToNiceSegCount);
        updateMinNiceFromMinT0Interval();
        updateMaxNiceFromMaxT1Interval();
        if ((0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(intervalPrecision)) interval = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(interval, intervalPrecision);
    } else {
        // Make a minimal enough `interval`, increase it later.
        // It is a similar logic as `IntervalScale#calcNiceTicks` and `LogScale#calcNiceTicks`.
        // Axis break is not supported, which is guranteed by the caller of this function.
        var targetSpan = targetExtent[1] - targetExtent[0];
        interval = isTargetLogScale ? (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)((0, $0b2f7076fd7740ca$export$82dd68b83a44b253)(targetSpan), 1) : (0, $0b2f7076fd7740ca$export$7a695fe44258210b)(targetSpan / alignToNiceSegCount, (0, $0b2f7076fd7740ca$export$492adb595f875f4e));
        intervalPrecision = (0, $27a07c2e80a6e56f$export$86a060b060d3d31a)(interval);
        if (targetMinMaxFixed[0]) {
            min = targetExtent[0];
            loopIncreaseInterval(function() {
                updateMinNiceFromMinT0Interval();
                maxNice = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(minNice + interval * alignToNiceSegCount, intervalPrecision);
                updateMaxFromMaxNice();
                if (max >= targetExtent[1]) return true;
            });
        } else if (targetMinMaxFixed[1]) {
            max = targetExtent[1];
            loopIncreaseInterval(function() {
                updateMaxNiceFromMaxT1Interval();
                minNice = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(maxNice - interval * alignToNiceSegCount, intervalPrecision);
                updateMinFromMinNice();
                if (min <= targetExtent[0]) return true;
            });
        } else loopIncreaseInterval(function() {
            minNice = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$cf129980c996e186)(targetExtent[0] / interval) * interval, intervalPrecision);
            maxNice = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$c6301bc99a7f80a7)(targetExtent[1] / interval) * interval, intervalPrecision);
            // NOTE:
            //  - `maxNice - minNice >= -interval` here.
            //  - While `interval` increases, `currIntervalCount` decreases, minimum `-1`.
            var currIntervalCount = (0, $0b2f7076fd7740ca$export$42cacde8c45786ff)((maxNice - minNice) / interval);
            if (currIntervalCount <= alignToNiceSegCount) {
                var moreCount = alignToNiceSegCount - currIntervalCount;
                // Consider cases that negative tick do not make sense (or vice versa), users can simply
                // specify `xxxAxis.min/max: 0` to avoid negative. But we still automatically handle it
                // for some common cases whenever possible:
                //  - When ec option is `xxxAxis.scale: false` (the default), it is usually unexpected if
                //    negative (or positive) ticks are introduced.
                //  - In LogScale, series data are usually either all > 1 or all < 1, rather than both,
                //    that is, logarithm result is typically either all positive or all negative.
                var moreCountPair = void 0;
                var mayEnhanceZero = targetExtentInfo.incl0 || isTargetLogScale;
                // `bounds < 0` or `bounds > 0` may require more complex handling, so we only auto handle
                // `bounds === 0`.
                if (mayEnhanceZero && targetExtent[0] === 0) // 0 has been included in extent and all positive.
                moreCountPair = [
                    0,
                    moreCount
                ];
                else if (mayEnhanceZero && targetExtent[1] === 0) // 0 has been included in extent and all negative.
                moreCountPair = [
                    moreCount,
                    0
                ];
                else {
                    // Try to center ticks in axis space whenever possible, which is especially preferable
                    // in `LogScale`.
                    var lessHalfCount = (0, $0b2f7076fd7740ca$export$c6301bc99a7f80a7)(moreCount / 2);
                    moreCountPair = moreCount % 2 === 0 ? [
                        lessHalfCount,
                        lessHalfCount
                    ] : min + max < targetExtent[0] + targetExtent[1] ? [
                        lessHalfCount,
                        lessHalfCount + 1
                    ] : [
                        lessHalfCount + 1,
                        lessHalfCount
                    ];
                }
                minNice = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(minNice - interval * moreCountPair[0], intervalPrecision);
                maxNice = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(maxNice + interval * moreCountPair[1], intervalPrecision);
                updateMinFromMinNice();
                updateMaxFromMaxNice();
                if (min <= targetExtent[0] && max >= targetExtent[1]) return true;
            }
        });
    }
    (0, $7d2ffa192ebbc43e$export$8135db7762247d65)(targetScale, targetMinMaxFixed, targetOldIntervalExtent, [
        min,
        max
    ], targetOldOutermostExtent, {
        // NOTE: Even in LogScale, `interval` should not be in log space.
        interval: interval,
        // Force ticks count, otherwise cumulative error may cause more unexpected ticks to be generated.
        // Though the overlapping tick labels may be auto-ignored, but probably unexpected, e.g., the min
        // tick label is ignored but the secondary min tick label is shown, which is unexpected when
        // `axis.min` is user-specified or dataZoom-specified.
        intervalCount: alignToNiceSegCount,
        intervalPrecision: intervalPrecision,
        niceExtent: [
            minNice,
            maxNice
        ]
    });
}








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






// ------ START: LinearIntervalScaleStub Nice ------
function $40056739f94b65c9$var$calcNiceForIntervalOrLogScale(scale, opt) {
    // [CAVEAT]: If updating this impl, need to sync it to `axisAlignTicks.ts`.
    var isTargetLogScale = (0, $27a07c2e80a6e56f$export$8b1d8a59aa13c502)(scale);
    var intervalStub = isTargetLogScale ? scale.intervalStub : scale;
    var fixMinMax = opt.fixMinMax || [];
    var oldOutermostExtent = isTargetLogScale ? scale.getExtent() : null;
    var oldIntervalExtent = intervalStub.getExtent();
    var newIntervalExtent = (0, $27a07c2e80a6e56f$export$e279d7ed1695209d)(oldIntervalExtent, fixMinMax, opt.rawExtentResult);
    intervalStub.setExtent(newIntervalExtent[0], newIntervalExtent[1]);
    newIntervalExtent = intervalStub.getExtent();
    var config = isTargetLogScale ? $40056739f94b65c9$var$logScaleCalcNiceTicks(intervalStub, opt) : $40056739f94b65c9$var$intervalScaleCalcNiceTicks(intervalStub, opt);
    var autoIntervalPrecision = config.intervalPrecision;
    var autoInterval = config.interval;
    // When auto calculated interval is not preferable, users are allowed to explicity specify
    // `interval`, `min`, `max` to customize the axis. A typical case is, in angle axis with angle
    // 0 - 360, where the internally calculated interval is not 60-based.
    // NOTICE:
    //  - In `xxxAxis.type: 'log'`, ec option `xxxAxis.interval` requires a logarithm-applied
    //    value rather than a value in the raw scale.
    //  - Follow the historical behavior:
    //    - even `interval` is specified, the scale extent is still expanded based on the auto-calculated
    //      interval.
    //    - No validation to the specified `interval`.
    var userInterval = opt.userInterval;
    if (userInterval != null) {
        config.interval = userInterval;
        config.intervalPrecision = (0, $27a07c2e80a6e56f$export$86a060b060d3d31a)(userInterval);
    }
    if (!fixMinMax[0]) newIntervalExtent[0] = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$c6301bc99a7f80a7)(newIntervalExtent[0] / autoInterval) * autoInterval, autoIntervalPrecision);
    if (!fixMinMax[1]) newIntervalExtent[1] = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$cf129980c996e186)(newIntervalExtent[1] / autoInterval) * autoInterval, autoIntervalPrecision);
    if (userInterval != null) // Historical behavior.
    config.niceExtent = newIntervalExtent.slice();
    (0, $7d2ffa192ebbc43e$export$8135db7762247d65)(scale, fixMinMax, oldIntervalExtent, newIntervalExtent, oldOutermostExtent, config);
}
// ------ END: LinearIntervalScaleStub Nice ------
// ------ START: IntervalScale Nice ------
function $40056739f94b65c9$var$intervalScaleCalcNiceTicks(scale, opt) {
    var splitNumber = (0, $27a07c2e80a6e56f$export$b801ba4e5ad70a4a)(opt.splitNumber, 5);
    // Use the span in the innermost linear space to calculate nice ticks.
    var span = (0, $9073f5835d31d063$export$9a49fe71267af794)(scale);
    var minInterval = opt.minInterval;
    var maxInterval = opt.maxInterval;
    var interval = (0, $0b2f7076fd7740ca$export$7a695fe44258210b)(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = maxInterval;
    var intervalPrecision = (0, $27a07c2e80a6e56f$export$86a060b060d3d31a)(interval);
    var extent = scale.getExtent();
    // By design, the `niceExtent` is inside the original extent
    var niceExtent = [
        (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$cf129980c996e186)(extent[0] / interval) * interval, intervalPrecision),
        (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$c6301bc99a7f80a7)(extent[1] / interval) * interval, intervalPrecision)
    ];
    return {
        interval: interval,
        intervalPrecision: intervalPrecision,
        niceExtent: niceExtent
    };
}
// ------ END: IntervalScale Nice ------
// ------ START: LogScale Nice ------
function $40056739f94b65c9$var$logScaleCalcNiceTicks(intervalStub, opt) {
    // [CAVEAT]: If updating this impl, need to sync it to `axisAlignTicks.ts`.
    var splitNumber = (0, $27a07c2e80a6e56f$export$b801ba4e5ad70a4a)(opt.splitNumber, 10);
    // Find nice ticks in the "logarithmic space". Notice that "logarithmic space" is a middle space
    // rather than the innermost linear space when axis breaks exist.
    var intervalExtent = intervalStub.getExtent();
    // But use the span in the innermost linear space to calculate nice ticks.
    var span = (0, $9073f5835d31d063$export$9a49fe71267af794)(intervalStub);
    // Interval should be integer
    var interval = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)((0, $0b2f7076fd7740ca$export$82dd68b83a44b253)(span), 1);
    var err = splitNumber / span * interval;
    // Filter ticks to get closer to the desired count.
    if (err <= 0.5) // TODO: support other bases other than 10?
    interval *= 10;
    var intervalPrecision = (0, $27a07c2e80a6e56f$export$86a060b060d3d31a)(interval);
    // For LogScale, we use a `niceExtent` in the "logarithmic space" rather than
    // the original "pow space", because it is used in `intervalStub.getTicks()` thereafter.
    var niceExtent = [
        (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$cf129980c996e186)(intervalExtent[0] / interval) * interval, intervalPrecision),
        (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)((0, $0b2f7076fd7740ca$export$c6301bc99a7f80a7)(intervalExtent[1] / interval) * interval, intervalPrecision)
    ];
    return {
        intervalPrecision: intervalPrecision,
        interval: interval,
        niceExtent: niceExtent
    };
}
function $40056739f94b65c9$export$6aaaea8da7d6b895(axisLike) {
    var scale = axisLike.scale;
    var model = axisLike.model;
    var axis = model.axis;
    var ecModel = model.ecModel;
    $40056739f94b65c9$export$35f94b1dd0b73915(scale, model, axis, ecModel, null);
}
function $40056739f94b65c9$export$35f94b1dd0b73915(scale, model, // Some call from external source, such as echarts-gl, may have no `axis` and `ecModel`,
// but has `externalDataExtent`.
axis, ecModel, externalDataExtent) {
    var rawExtentResult = (0, $10061a7e816c9eb5$export$b9937565663b5dda)(scale, model, ecModel, axis, externalDataExtent);
    var isIntervalOrTime = (0, $27a07c2e80a6e56f$export$ba0fcad386c5c7e6)(scale) || (0, $27a07c2e80a6e56f$export$c9b71a3750db342f)(scale);
    $40056739f94b65c9$export$1b1041112fbfff22(scale, {
        splitNumber: model.get('splitNumber'),
        fixMinMax: rawExtentResult.fixMM,
        userInterval: model.get('interval'),
        minInterval: isIntervalOrTime ? model.get('minInterval') : null,
        maxInterval: isIntervalOrTime ? model.get('maxInterval') : null,
        rawExtentResult: rawExtentResult
    });
    if (axis && ecModel) (0, $10061a7e816c9eb5$export$922e3b0bde7215c8)(axis, scale, rawExtentResult, ecModel);
}
function $40056739f94b65c9$export$1b1041112fbfff22(scale, opt) {
    $40056739f94b65c9$var$scaleCalcNiceMethods[scale.type](scale, opt);
}
var $40056739f94b65c9$var$scaleCalcNiceMethods = {
    interval: $40056739f94b65c9$var$calcNiceForIntervalOrLogScale,
    log: $40056739f94b65c9$var$calcNiceForIntervalOrLogScale,
    time: (0, $869abcb8e0d51e8b$export$b0ab84ebd823da11),
    ordinal: (0, $e4c0c902d0f4f283$export$8793edee2d425525)
}; // ------ END: scaleCalcNice Entry ------






// margin is [top, right, bottom, left]
var $5414d0f47d974b04$var$XY_TO_MARGIN_IDX = [
    [
        3,
        1
    ],
    [
        0,
        2
    ] // xyIdx 1 => 'y'
];
var $5414d0f47d974b04$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $8c2130a63785ce17$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this._axesList, function(axis) {
            (0, $10061a7e816c9eb5$export$113bceb7edf323a4)(axis, (0, $10061a7e816c9eb5$export$c4999badb722a7d7));
            var scale = axis.scale;
            if ((0, $27a07c2e80a6e56f$export$61579433626afe87)(scale)) scale.setSortInfo(axis.model.get('categorySortInfo'));
        });
        function updateAxisTicks(axes) {
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(axes);
            var axisNeedsAlign = [];
            for(var i = axesIndices.length - 1; i >= 0; i--){
                // Reverse order
                var axis = axes[+axesIndices[i]];
                if (axis.__alignTo) axisNeedsAlign.push(axis);
                else (0, $40056739f94b65c9$export$6aaaea8da7d6b895)(axis);
            }
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                if ($5414d0f47d974b04$var$incapableOfAlignNeedFallback(axis, axis.__alignTo)) (0, $40056739f94b65c9$export$6aaaea8da7d6b895)(axis);
                else (0, $cbffa79ff5cf1ac8$export$a54aa0aabf394e1b)(axis, axis.__alignTo.scale);
            });
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $5414d0f47d974b04$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $5414d0f47d974b04$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid.
   *
   * [NOTE]
   * If both "grid.containLabel/grid.contain" and pixel-required-data-processing (such as, "dataSampling")
   * exist, circular dependency occurs in logic.
   * The final compromised sequence is:
   *  1. Calculate "axis.extent" (pixel extent) and AffineTransform based on only "grid layout options".
   *      Not accurate if "grid.containLabel/grid.contain" is required, but it is a compromise to avoid
   *      circular dependency.
   *  2. Perform "series data processing" (where "dataSampling" requires "axis.extent").
   *  3. Calculate "scale.extent" (data extent) based on "processed series data".
   *  4. Modify "axis.extent" for "grid.containLabel/grid.contain":
   *      4.1. Calculate "axis labels" based on "scale.extent".
   *      4.2. Modify "axis.extent" by the bounding rects of "axis labels and names".
   */ Grid.prototype.resize = function(gridModel, api, beforeDataProcessing) {
        var layoutRef = (0, $52313d605bb144f5$export$5aec1e94f566e59f)(gridModel, api);
        var gridRect = this._rect = (0, $52313d605bb144f5$export$4517a5ca639a7293)(gridModel.getBoxLayoutParams(), layoutRef.refContainer);
        // PENDING: whether to support that if the input `coord` is out of the base coord sys,
        //  do not render anything. At present, the behavior is undefined.
        var axesMap = this._axesMap;
        var coordsList = this._coordsList;
        var optionContainLabel = gridModel.get('containLabel'); // No `.get(, true)` for backward compat.
        // NOTE: The axis pixel extent is also required by some estimation, e.g., in coord sys update stage,
        // bars on 'time'/'value' axis need it to calculate the supplementary scale extent to avoid edge bars
        // overflowing the axis (see `barGrid.ts`). Therefore, axis pixel extent need to be set early, even
        // may not be accurate.
        $5414d0f47d974b04$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
        if (!beforeDataProcessing) {
            var axisBuilderSharedCtx = $5414d0f47d974b04$var$createAxisBiulders(gridRect, coordsList, axesMap, optionContainLabel, api);
            var noPxChange = void 0;
            if (optionContainLabel) {
                if ($5414d0f47d974b04$var$legacyLayOutGridByContainLabel) {
                    // console.time('legacyLayOutGridByContainLabel');
                    $5414d0f47d974b04$var$legacyLayOutGridByContainLabel(this._axesList, gridRect);
                    $5414d0f47d974b04$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
                // console.timeEnd('legacyLayOutGridByContainLabel');
                } else noPxChange = $5414d0f47d974b04$var$layOutGridByOuterBounds(gridRect.clone(), 'axisLabel', null, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            } else {
                var _a = $5414d0f47d974b04$var$prepareOuterBounds(gridModel, gridRect, layoutRef), outerBoundsRect = _a.outerBoundsRect, parsedOuterBoundsContain = _a.parsedOuterBoundsContain, outerBoundsClamp = _a.outerBoundsClamp;
                if (outerBoundsRect) // console.time('layOutGridByOuterBounds');
                noPxChange = $5414d0f47d974b04$var$layOutGridByOuterBounds(outerBoundsRect, parsedOuterBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef);
            }
            // console.time('buildAxesView_determine');
            $5414d0f47d974b04$var$createOrUpdateAxesView(gridRect, axesMap, (0, $bcb4c3869b07ba10$export$31cba7db0a663292).determine, null, noPxChange, layoutRef);
            // console.timeEnd('buildAxesView_determine');
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this._coordsList, function(coord) {
                // Calculate affine matrix to accelerate the data to point transform.
                // If all the axes scales are time or value.
                coord.calcAffineTransform();
            });
        } // End of beforeDataProcessing
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $8c2130a63785ce17$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        $5414d0f47d974b04$var$prepareAlignToInCoordSysCreate(axesMap.x);
        $5414d0f47d974b04$var$prepareAlignToInCoordSysCreate(axesMap.y);
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$5414d0f47d974b04$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axisType = (0, $7d2ffa192ebbc43e$export$a0edf4de19b45ee7)(axisModel);
                var axis = new (0, $d51f3c9a0e832182$export$2e2bcd8739ae039)(dimName, (0, $7d2ffa192ebbc43e$export$8941c4cacdc8f5a5)(axisModel, axisType, true), [
                    0,
                    0
                ], axisType, axisPosition);
                axis.onBand = (0, $7d2ffa192ebbc43e$export$43d51f65881fb080)(axis.scale, axisModel);
                axis.inverse = axisModel.get('inverse');
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
            (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(grid._axesList, function(axis) {
                (0, $10061a7e816c9eb5$export$710d8a038761b881)(axis, Grid.dimIdxMap);
            });
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            var xAxis;
            var yAxis;
            (0, $65108a454a48746f$export$7ed0c09d4f5c932e)({
                targetModel: seriesModel,
                coordSysType: (0, $6681f912fa623077$export$d0b4e8fdb7a13c60),
                coordSysProvider: coordSysProvider
            });
            function coordSysProvider() {
                var axesModelMap = (0, $11f3c53f4277ae1d$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                xAxis = xAxisModel.axis;
                yAxis = yAxisModel.axis;
                var gridModel = xAxisModel.getCoordSysModel();
                var grid = gridModel.coordinateSystem;
                return grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
            }
            if (xAxis && yAxis) {
                (0, $e25c2a392bb1e248$export$48507d392d1d4894)(xAxis, seriesModel, (0, $6681f912fa623077$export$d0b4e8fdb7a13c60));
                (0, $e25c2a392bb1e248$export$48507d392d1d4894)(yAxis, seriesModel, (0, $6681f912fa623077$export$d0b4e8fdb7a13c60));
            }
        }, this);
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $8c2130a63785ce17$export$988a008d2b9120f4);
    Grid.dimIdxMap = (0, $8adb494c9e76f9e1$export$a477f5bebfd07944)((0, $8c2130a63785ce17$export$988a008d2b9120f4));
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $5414d0f47d974b04$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $5414d0f47d974b04$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    // For historical reason, ec option `axisLine.onZero: undefined` leads to "not on zero"
    // while leaving `axisLine.onZero` unspecified causes "on zero". This inconsistency goes
    // against common sense, but is preserved for backward compatibility.
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($5414d0f47d974b04$var$canOnZeroToAxis(onZero, otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if ((0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(otherAxes, idx) && $5414d0f47d974b04$var$canOnZeroToAxis(onZero, otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
/**
 * CAVEAT: Must not be called before `CoordinateSystem#update` due to `__dontOnMyZero`.
 */ function $5414d0f47d974b04$var$canOnZeroToAxis(onZeroOption, axis) {
    if (!axis) return false;
    var scale = axis.scale;
    var kindEffective = (0, $7d2ffa192ebbc43e$export$99e0963eefdef8b2)(scale, 0, false);
    var can = axis && axis.type !== 'category' && axis.type !== 'time' && kindEffective !== (0, $7d2ffa192ebbc43e$export$8b1206c1406788fd);
    if (can && onZeroOption === 'auto' && (0, $7d2ffa192ebbc43e$export$2204fb02f43463b7)(axis)) can = false;
    // falsy value of `onZeroOption` has been handled in the previous logic.
    return can;
}
/**
 * [CAVEAT] This method is called before data processing stage.
 *  Do not rely on any info that is determined afterward.
 */ function $5414d0f47d974b04$var$prepareAlignToInCoordSysCreate(axes) {
    // Axis is added in order of axisIndex.
    var axesIndices = (0, $e4c0c902d0f4f283$export$ed97f33186d4b816)(axes);
    var alignTo;
    var axisNeedsAlign = [];
    for(var i = axesIndices.length - 1; i >= 0; i--){
        // Reverse order
        var axis = axes[+axesIndices[i]];
        if ((0, $27a07c2e80a6e56f$export$dfc8cd28ed7b22a0)(axis.scale) && (0, $7d2ffa192ebbc43e$export$8094779d9b724f85)(axis.model, axis.type, true) == null) {
            // Request `alignTicks`.
            if (axis.model.get('alignTicks') && axis.model.get('interval') == null) axisNeedsAlign.push(axis);
            else // `alignTo` the last one that does not request `alignTicks`
            // (This rule is retained for backward compat).
            alignTo = axis;
        }
    }
    // If all axes has set alignTicks, pick the first one as alignTo.
    // PENDING. Should we find the axis that both set interval, min, max and align to this one?
    // PENDING. Should we allow specifying alignTo via ec option?
    if (!alignTo) alignTo = axisNeedsAlign.pop();
    if (alignTo) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
        axis.__alignTo = alignTo;
    });
}
/**
 * This is just a defence code. They are unlikely to be actually `true`,
 * since these cases have been addressed in `prepareAlignToInCoordSysCreate`.
 *
 * Can not be called BEFORE "nice" performed.
 */ function $5414d0f47d974b04$var$incapableOfAlignNeedFallback(targetAxis, alignTo) {
    return (0, $88f2be8efb09cff5$export$fec008222a1db2dc)(targetAxis.scale) || (0, $88f2be8efb09cff5$export$fec008222a1db2dc)(alignTo.scale) || alignTo.scale.getTicks().length < 2;
}
function $5414d0f47d974b04$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
function $5414d0f47d974b04$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect) {
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap.x, function(axis) {
        return $5414d0f47d974b04$var$updateAxisExtentTransByGridRect(axis, gridRect.x, gridRect.width);
    });
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap.y, function(axis) {
        return $5414d0f47d974b04$var$updateAxisExtentTransByGridRect(axis, gridRect.y, gridRect.height);
    });
}
function $5414d0f47d974b04$var$updateAxisExtentTransByGridRect(axis, gridXY, gridWH) {
    var extent = [
        0,
        gridWH
    ];
    var idx = axis.inverse ? 1 : 0;
    axis.setExtent(extent[idx], extent[1 - idx]);
    $5414d0f47d974b04$var$updateAxisTransform(axis, gridXY);
}
var $5414d0f47d974b04$var$legacyLayOutGridByContainLabel;
function $5414d0f47d974b04$export$9da5287b2e41f334(impl) {
    $5414d0f47d974b04$var$legacyLayOutGridByContainLabel = impl;
}
// Return noPxChange.
function $5414d0f47d974b04$var$layOutGridByOuterBounds(outerBoundsRect, outerBoundsContain, outerBoundsClamp, gridRect, axesMap, axisBuilderSharedCtx, layoutRef) {
    // Assume `updateAllAxisExtentTransByGridRect` has been performed once before this call.
    // [NOTE]:
    // - The bounding rect of the axis elements might be sensitve to variations in `axis.extent` due to strategies
    //  like hideOverlap/moveOverlap. @see the comment in `LabelLayoutBase['suggestIgnore']`.
    // - The final `gridRect` might be slightly smaller than the ideally expected result if labels are giant and
    //  get hidden due to overlapping. More iterations could improve precision, but not performant. We consider
    //  the current result acceptable, since no alignment among charts can be guaranteed when using this feature.
    $5414d0f47d974b04$var$createOrUpdateAxesView(gridRect, axesMap, (0, $bcb4c3869b07ba10$export$31cba7db0a663292).estimate, outerBoundsContain, false, layoutRef);
    var margin = [
        0,
        0,
        0,
        0
    ];
    fillLabelNameOverflowOnOneDimension(0);
    fillLabelNameOverflowOnOneDimension(1);
    // If axis is blank, no label can be used to detect overflow.
    // gridRect itself should not overflow.
    fillMarginOnOneDimension(gridRect, 0, NaN);
    fillMarginOnOneDimension(gridRect, 1, NaN);
    var noPxChange = (0, $e4c0c902d0f4f283$export$71aa6c912b956294)(margin, function(item) {
        return item > 0;
    }) == null;
    (0, $05f852c7feb2d530$export$81ed941fdeb91c7c)(gridRect, margin, true, true, outerBoundsClamp);
    $5414d0f47d974b04$var$updateAllAxisExtentTransByGridRect(axesMap, gridRect);
    return noPxChange;
    function fillLabelNameOverflowOnOneDimension(xyIdx) {
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap[(0, $05f852c7feb2d530$export$cb4c12294149dd2d)[xyIdx]], function(axis) {
            if (!(0, $7d2ffa192ebbc43e$export$75b737736393e03c)(axis.model)) return;
            // FIXME: zr Group.union may wrongly union (0, 0, 0, 0) and not performant.
            // unionRect.union(axis.axisBuilder.group.getBoundingRect());
            // If ussing Group.getBoundingRect to calculate shrink space, it is not strictly accurate when
            // the outermost label is ignored and the secondary label is very long and contribute to the
            // union extension:
            //      -|---|---|---|
            //         1,000,000,000
            // Therefore we calculate them one by one.
            // Also considered axis may be blank or no labels.
            var sharedRecord = axisBuilderSharedCtx.ensureRecord(axis.model);
            var labelInfoList = sharedRecord.labelInfoList;
            if (labelInfoList) for(var idx = 0; idx < labelInfoList.length; idx++){
                var labelInfo = labelInfoList[idx];
                var proportion = axis.scale.normalize((0, $7d2ffa192ebbc43e$export$889d2956111fd257)(axis.scale, (0, $6d659ef54222f15c$export$c392b818a26a879e)(labelInfo.label).labelInfo.tick));
                proportion = xyIdx === 1 ? 1 - proportion : proportion;
                // xAxis use proportion on x, yAxis use proprotion on y, otherwise not.
                fillMarginOnOneDimension(labelInfo.rect, xyIdx, proportion);
                fillMarginOnOneDimension(labelInfo.rect, 1 - xyIdx, NaN);
            }
            var nameLayout = sharedRecord.nameLayout;
            if (nameLayout) {
                var proportion = (0, $7d2ffa192ebbc43e$export$c06aa22293dea9d2)(sharedRecord.nameLocation) ? 0.5 : NaN;
                fillMarginOnOneDimension(nameLayout.rect, xyIdx, proportion);
                fillMarginOnOneDimension(nameLayout.rect, 1 - xyIdx, NaN);
            }
        });
    }
    function fillMarginOnOneDimension(itemRect, xyIdx, proportion // NaN mean no use proportion
    ) {
        var overflow1 = outerBoundsRect[(0, $05f852c7feb2d530$export$cb4c12294149dd2d)[xyIdx]] - itemRect[(0, $05f852c7feb2d530$export$cb4c12294149dd2d)[xyIdx]];
        var overflow2 = itemRect[(0, $05f852c7feb2d530$export$a3fe6d967173a3ac)[xyIdx]] + itemRect[(0, $05f852c7feb2d530$export$cb4c12294149dd2d)[xyIdx]] - (outerBoundsRect[(0, $05f852c7feb2d530$export$a3fe6d967173a3ac)[xyIdx]] + outerBoundsRect[(0, $05f852c7feb2d530$export$cb4c12294149dd2d)[xyIdx]]);
        overflow1 = applyProportion(overflow1, 1 - proportion);
        overflow2 = applyProportion(overflow2, proportion);
        var minIdx = $5414d0f47d974b04$var$XY_TO_MARGIN_IDX[xyIdx][0];
        var maxIdx = $5414d0f47d974b04$var$XY_TO_MARGIN_IDX[xyIdx][1];
        margin[minIdx] = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(margin[minIdx], overflow1);
        margin[maxIdx] = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(margin[maxIdx], overflow2);
    }
    function applyProportion(overflow, proportion) {
        // proportion is not likely to near zero. If so, give up shrink
        if (overflow > 0 && !(0, $e4c0c902d0f4f283$export$7d667b9a0c48c975)(proportion) && proportion > 1e-4) overflow /= proportion;
        return overflow;
    }
}
function $5414d0f47d974b04$var$createAxisBiulders(gridRect, cartesians, axesMap, optionContainLabel, api) {
    var axisBuilderSharedCtx = new (0, $6d659ef54222f15c$export$f2e237206f7393f5)($5414d0f47d974b04$var$resolveAxisNameOverlapForGrid);
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $7d2ffa192ebbc43e$export$75b737736393e03c)(axis.model)) {
                // See `AxisBaseOptionCommon['nameMoveOverlap']`.
                var defaultNameMoveOverlap = !optionContainLabel;
                axis.axisBuilder = (0, $11f3c53f4277ae1d$export$2b2ce820c3e1e776)(gridRect, cartesians, axis.model, api, axisBuilderSharedCtx, defaultNameMoveOverlap);
            }
        });
    });
    return axisBuilderSharedCtx;
}
/**
 * Promote the axis-elements-building from "view render" stage to "coordinate system resize" stage.
 * This is aimed to resovle overlap across multiple axes, since currently it's hard to reconcile
 * multiple axes in "view render" stage.
 *
 * [CAUTION] But this promotion assumes that the subsequent "visual mapping" stage does not affect
 * this axis-elements-building; otherwise we have to refactor it again.
 */ function $5414d0f47d974b04$var$createOrUpdateAxesView(gridRect, axesMap, kind, outerBoundsContain, noPxChange, layoutRef) {
    var isDetermine = kind === (0, $bcb4c3869b07ba10$export$31cba7db0a663292).determine;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap, function(axisList) {
        return (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $7d2ffa192ebbc43e$export$75b737736393e03c)(axis.model)) {
                (0, $11f3c53f4277ae1d$export$3e8d41f03e1a6a39)(axis.axisBuilder, gridRect, axis.model);
                axis.axisBuilder.build(isDetermine ? {
                    axisTickLabelDetermine: true
                } : {
                    axisTickLabelEstimate: true
                }, {
                    noPxChange: noPxChange
                });
            }
        });
    });
    var nameMarginLevelMap = {
        x: 0,
        y: 0
    };
    calcNameMarginLevel(0);
    calcNameMarginLevel(1);
    function calcNameMarginLevel(xyIdx) {
        nameMarginLevelMap[(0, $05f852c7feb2d530$export$cb4c12294149dd2d)[1 - xyIdx]] = gridRect[(0, $05f852c7feb2d530$export$a3fe6d967173a3ac)[xyIdx]] <= layoutRef.refContainer[(0, $05f852c7feb2d530$export$a3fe6d967173a3ac)[xyIdx]] * 0.5 ? 0 : 1 - xyIdx === 1 ? 2 : 1;
    }
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axesMap, function(axisList, xy) {
        return (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(axisList, function(axis) {
            if ((0, $7d2ffa192ebbc43e$export$75b737736393e03c)(axis.model)) {
                if (outerBoundsContain === 'all' || isDetermine) // To resolve overlap, `axisName` layout depends on `axisTickLabel` layout result
                // (all of the axes of the same `grid`; consider multiple x or y axes).
                axis.axisBuilder.build({
                    axisName: true
                }, {
                    nameMarginLevel: nameMarginLevelMap[xy]
                });
                if (isDetermine) axis.axisBuilder.build({
                    axisLine: true
                });
            }
        });
    });
}
function $5414d0f47d974b04$var$prepareOuterBounds(gridModel, rawGridRect, layoutRef) {
    var outerBoundsRect;
    var optionOuterBoundsMode = gridModel.get('outerBoundsMode', true);
    if (optionOuterBoundsMode === 'same') outerBoundsRect = rawGridRect.clone();
    else if (optionOuterBoundsMode == null || optionOuterBoundsMode === 'auto') outerBoundsRect = (0, $52313d605bb144f5$export$4517a5ca639a7293)(gridModel.get('outerBounds', true) || (0, $6681f912fa623077$export$57b4bb4ff2a0950c), layoutRef.refContainer);
    else optionOuterBoundsMode;
    var optionOuterBoundsContain = gridModel.get('outerBoundsContain', true);
    var parsedOuterBoundsContain;
    if (optionOuterBoundsContain == null || optionOuterBoundsContain === 'auto') parsedOuterBoundsContain = 'all';
    else if ((0, $e4c0c902d0f4f283$export$305f7d4e9d4624f2)([
        'all',
        'axisLabel'
    ], optionOuterBoundsContain) < 0) parsedOuterBoundsContain = 'all';
    else parsedOuterBoundsContain = optionOuterBoundsContain;
    var outerBoundsClamp = [
        (0, $0b2f7076fd7740ca$export$6b392db7c2374a1a)((0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(gridModel.get('outerBoundsClampWidth', true), (0, $6681f912fa623077$export$e78e6bf4dcc3e485)[0]), rawGridRect.width),
        (0, $0b2f7076fd7740ca$export$6b392db7c2374a1a)((0, $e4c0c902d0f4f283$export$995e01f2f5c9d030)(gridModel.get('outerBoundsClampHeight', true), (0, $6681f912fa623077$export$e78e6bf4dcc3e485)[1]), rawGridRect.height)
    ];
    return {
        outerBoundsRect: outerBoundsRect,
        parsedOuterBoundsContain: parsedOuterBoundsContain,
        outerBoundsClamp: outerBoundsClamp
    };
}
var $5414d0f47d974b04$var$resolveAxisNameOverlapForGrid = function(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord) {
    var perpendicularDim = axisModel.axis.dim === 'x' ? 'y' : 'x';
    (0, $6d659ef54222f15c$export$7fcb8742f5816cae)(cfg, ctx, axisModel, nameLayoutInfo, nameMoveDirVec, thisRecord);
    // If nameLocation 'center', and there are multiple axes parallel to this axis, do not adjust by
    //  other axes, because the axis name should be close to its axis line as much as possible even
    //  if overlapping; otherwise it might cause misleading.
    // If nameLocation 'center', do not adjust by perpendicular axes, since they are not likely to overlap.
    // If nameLocation 'start'/'end', move name within the same direction to escape overlap with the
    //  perpendicular axes.
    if (!(0, $7d2ffa192ebbc43e$export$c06aa22293dea9d2)(cfg.nameLocation)) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(ctx.recordMap[perpendicularDim], function(perpenRecord) {
        // perpendicular axis may be no name.
        if (perpenRecord && perpenRecord.labelInfoList && perpenRecord.dirVec) (0, $6d659ef54222f15c$export$e033c6449cc6f6a1)(perpenRecord.labelInfoList, perpenRecord.dirVec, nameLayoutInfo, nameMoveDirVec);
    });
};
var $5414d0f47d974b04$export$2e2bcd8739ae039 = $5414d0f47d974b04$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $fb2890488620c302$var$inner = (0, $939d3a4c11ee87fd$export$64df9f8d92ae083f)();
function $fb2890488620c302$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        breakTicks: 'none',
        pruneByBreak: 'preserve_extent_bound'
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $fb2890488620c302$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $e4c0c902d0f4f283$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $e4c0c902d0f4f283$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $439653c37a0e6e60$export$2e2bcd8739ae039({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $e4c0c902d0f4f283$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $fb2890488620c302$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $fb2890488620c302$export$48ebf2d6ce8ad076(axisView) {
    $fb2890488620c302$var$inner(axisView).splitAreaColors = null;
}




var $df3ce6dc45a4e1e6$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine',
    'breakArea'
];
var $df3ce6dc45a4e1e6$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $0c53f0d63dde8266$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!(0, $7d2ffa192ebbc43e$export$75b737736393e03c)(axisModel)) return;
        this._axisGroup.add(axisModel.axis.axisBuilder.group);
        $e4c0c902d0f4f283$export$79b2f7037acddd43($df3ce6dc45a4e1e6$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $df3ce6dc45a4e1e6$var$axisElementBuilders[name](this, this._axisGroup, axisModel, axisModel.getCoordSysModel(), api);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $05f852c7feb2d530$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $fb2890488620c302$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $7341328d5e8aa244$export$2e2bcd8739ae039));
var $df3ce6dc45a4e1e6$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var showMinLine = splitLineModel.get('showMinLine') !== false;
        var showMaxLine = splitLineModel.get('showMaxLine') !== false;
        lineColors = $e4c0c902d0f4f283$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel,
            breakTicks: 'none',
            pruneByBreak: 'preserve_extent_bound'
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (i === 0 && !showMinLine || i === ticksCoords.length - 1 && !showMaxLine) continue;
            var tickValue = ticksCoords[i].tickValue;
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var line = new $8ae349726e18597f$export$2e2bcd8739ae039({
                anid: tickValue != null ? 'line_' + tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $e4c0c902d0f4f283$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $05f852c7feb2d530$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $8ae349726e18597f$export$2e2bcd8739ae039({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $05f852c7feb2d530$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel, api) {
        (0, $fb2890488620c302$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    },
    breakArea: function(axisView, axisGroup, axisModel, gridModel, api) {
        var axisBreakHelper = (0, $b57a96a87112d85a$export$c1d9b2cc33e7e5e)();
        var scale = axisModel.axis.scale;
        if (axisBreakHelper && scale.type !== 'ordinal') axisBreakHelper.rectCoordBuildBreakAxis(axisGroup, axisView, axisModel, gridModel.coordinateSystem.getRect(), api);
    }
};
var $df3ce6dc45a4e1e6$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($df3ce6dc45a4e1e6$var$CartesianAxisView);
var $df3ce6dc45a4e1e6$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $df3ce6dc45a4e1e6$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($df3ce6dc45a4e1e6$var$CartesianAxisView);
var $df3ce6dc45a4e1e6$export$2e2bcd8739ae039 = $df3ce6dc45a4e1e6$var$CartesianAxisView;


// Grid view
var $e0662d12b16b0207$var$GridView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $439653c37a0e6e60$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $4f2cae7dfb9fed2a$export$2e2bcd8739ae039));
var $e0662d12b16b0207$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $e0662d12b16b0207$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($e0662d12b16b0207$var$GridView);
    registers.registerComponentModel((0, $6681f912fa623077$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('cartesian2d', (0, $5414d0f47d974b04$export$2e2bcd8739ae039));
    (0, $9a42483783371e08$export$2e2bcd8739ae039)(registers, 'x', (0, $92601769bcc35bf4$export$483dc37e6ad83a3c), $e0662d12b16b0207$var$extraOption);
    (0, $9a42483783371e08$export$2e2bcd8739ae039)(registers, 'y', (0, $92601769bcc35bf4$export$483dc37e6ad83a3c), $e0662d12b16b0207$var$extraOption);
    registers.registerComponentView((0, $df3ce6dc45a4e1e6$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $df3ce6dc45a4e1e6$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}




function $75f7be5173396b7d$export$4b3e715f166fdd78(registers) {
    (0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $e0662d12b16b0207$export$4b3e715f166fdd78));
    (0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $539fac72a5ff49ed$export$4b3e715f166fdd78));
}




var $652cda81c992e605$var$_a;
(0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $75f7be5173396b7d$export$4b3e715f166fdd78));
class $652cda81c992e605$export$7f67bc504bca3675 extends (0, $e105d0ae0b8f861c$export$37de6f71bb86a769) {
}
($652cda81c992e605$var$_a = globalThis.customElements) === null || $652cda81c992e605$var$_a === void 0 || $652cda81c992e605$var$_a.define('ec-x-axis', $652cda81c992e605$export$7f67bc504bca3675);





var $5365af60b5c2b0c4$var$_a;
(0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $75f7be5173396b7d$export$4b3e715f166fdd78));
class $5365af60b5c2b0c4$export$6c73b4102a25a459 extends (0, $e105d0ae0b8f861c$export$37de6f71bb86a769) {
}
($5365af60b5c2b0c4$var$_a = globalThis.customElements) === null || $5365af60b5c2b0c4$var$_a === void 0 || $5365af60b5c2b0c4$var$_a.define('ec-y-axis', $5365af60b5c2b0c4$export$6c73b4102a25a459);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $209806a7434b1d09$export$4c40490832d9cdb0 = typeof Int8Array !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Int8Array : undefined;
var $209806a7434b1d09$export$111fe31494f58dc3 = typeof Int16Array !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Int16Array : undefined;
var $209806a7434b1d09$export$b18d4ae90391caf = typeof Int32Array !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Int32Array : undefined;
var $209806a7434b1d09$export$14996b0f94ec6069 = typeof Uint8Array !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Uint8Array : undefined;
var $209806a7434b1d09$export$3899859b7677d71 = typeof Uint16Array !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Uint16Array : undefined;
var $209806a7434b1d09$export$f46ab92cd13bdf8 = typeof Uint32Array !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Uint32Array : undefined;
var $209806a7434b1d09$export$9f6b2141b0069558 = typeof Uint8ClampedArray !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Uint8ClampedArray : undefined;
var $209806a7434b1d09$export$e39334316500bbe = typeof Float32Array !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Float32Array : undefined;
var $209806a7434b1d09$export$8b884c4a18b44713 = typeof Float64Array !== (0, $0f5447108b4a27a4$export$5ba2cba1cb566d7a) ? Float64Array : undefined;
function $209806a7434b1d09$export$21d2298f3f56bbaf(capacity) {
    return $209806a7434b1d09$export$d47152ac0737a5e9({
        ctor: $209806a7434b1d09$export$e39334316500bbe
    }, capacity).arr;
}
function $209806a7434b1d09$export$d47152ac0737a5e9(tyArr, // Can add more types if needed.
// NOTICE: Callers need to manage data length themselves.
// Do not consider `capacity` as the data length.
capacity) {
    var existingArr = tyArr.arr;
    var ctor = tyArr.ctor;
    if (capacity > (0, $0b2f7076fd7740ca$export$18510406f204a1b9)) capacity = (0, $0b2f7076fd7740ca$export$18510406f204a1b9);
    if (!existingArr || tyArr.typed && existingArr.length < capacity) {
        var nextArr = void 0;
        if (ctor) try {
            // A large contiguous memory allocation may cause OOM.
            nextArr = new ctor(capacity);
            tyArr.typed = true;
            existingArr && nextArr.set(existingArr);
        } catch (e) {}
        if (!nextArr) {
            nextArr = [];
            tyArr.typed = false;
            if (existingArr) for(var i = 0, len = existingArr.length; i < len; i++)nextArr[i] = existingArr[i];
        }
        tyArr.arr = nextArr;
    }
    return tyArr;
}








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $c8790514e4af23c9$export$303243915ac59737() {
    (0, $e25c2a392bb1e248$export$5ce2ad54acb7c055)('liPosMinGap', $c8790514e4af23c9$var$metricLiPosMinGapImpl);
}
function $c8790514e4af23c9$var$metricLiPosMinGapImpl(ecModel, perKeyPerAxis, ecPreparePerKeyPerAxis) {
    var newSerUids = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    var ecPrepareSerUids = ecPreparePerKeyPerAxis.serUids;
    var ecPrepareLiPosMinGap = ecPreparePerKeyPerAxis.liPosMinGap;
    var ecPrepareCacheMiss;
    var axis = perKeyPerAxis.axis;
    var scale = axis.scale;
    // const linearValueExtent = initExtentForUnion();
    var needTransform = scale.needTransform();
    var filter = scale.getFilter ? scale.getFilter() : null;
    var filterParsed = (0, $84c3b22514de3d05$export$1b2aa782dfdf5700)(filter);
    // const timeRetrieve: number[] = []; // _EC_PERF_
    // const timeSort: number[] = []; // _EC_PERF_
    // const timeAll: number[] = []; // _EC_PERF_
    // timeAll[0] = Date.now(); // _EC_PERF_
    function eachSeries(cb) {
        (0, $e25c2a392bb1e248$export$bf07bebae360b2fc)(ecModel, perKeyPerAxis.sers, function(seriesModel) {
            var rawData = seriesModel.getRawData();
            // NOTE: Currently there is no series that a "base axis" can map to multiple dimensions.
            var dimStoreIdx = rawData.getDimensionIndex(rawData.mapDimension(axis.dim));
            if (dimStoreIdx >= 0) cb(dimStoreIdx, seriesModel, rawData.getStore());
        });
    }
    var bufferCapacity = 0;
    eachSeries(function(dimStoreIdx, seriesModel, rawDataStore) {
        newSerUids.set(seriesModel.uid, 1);
        if (!ecPrepareSerUids || !ecPrepareSerUids.hasKey(seriesModel.uid)) ecPrepareCacheMiss = true;
        bufferCapacity += rawDataStore.count();
    });
    if (!ecPrepareSerUids || ecPrepareSerUids.keys().length !== newSerUids.keys().length) ecPrepareCacheMiss = true;
    if (!ecPrepareCacheMiss && ecPrepareLiPosMinGap != null) {
        // Consider the fact in practice:
        //  - Series data can only be changed in EC_PREPARE.
        //  - The relationship between series and axes can only be changed in EC_PREPARE and
        //    SERIES_FILTER.
        //  (See EC_CYCLE for more info)
        // Therefore, some statistics results can be cached in `GlobalModelCachePerECPrepare` to avoid
        // repeated time-consuming calculation for large data (e.g., over 1e5 data items).
        perKeyPerAxis.liPosMinGap = ecPrepareLiPosMinGap;
        return;
    }
    (0, $209806a7434b1d09$export$d47152ac0737a5e9)($c8790514e4af23c9$var$tmpValueBuffer, bufferCapacity);
    // timeRetrieve[0] = Date.now(); // _EC_PERF_
    var writeIdx = 0;
    eachSeries(function(dimStoreIdx, seriesModel, store) {
        // NOTE: It appears to be optimized by traveling only in a specific window (e.g., the current window)
        // instead of the entire data, but that would likely generate inconsistent result and bring
        // jitter when dataZoom roaming.
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            // Manually inline some code for performance, since no other optimization
            // (such as, progressive) can be applied here.
            var val = store.get(dimStoreIdx, i);
            // NOTE: in most cases, filter does not exist.
            if (isFinite(val) && (!filter || (0, $84c3b22514de3d05$export$49bf74cb3f1b6c80)(filterParsed, val))) {
                if (needTransform) // PENDING: time-consuming if axis break is applied.
                val = scale.transformIn(val, null);
                $c8790514e4af23c9$var$tmpValueBuffer.arr[writeIdx++] = val;
            // val < linearValueExtent[0] && (linearValueExtent[0] = val);
            // val > linearValueExtent[1] && (linearValueExtent[1] = val);
            }
        }
    });
    // Indicatively, retrieving values above costs 40ms for 1e6 values in a certain platform.
    // timeRetrieve[1] = Date.now(); // _EC_PERF_
    var tmpValueBufferView = $c8790514e4af23c9$var$tmpValueBuffer.typed ? $c8790514e4af23c9$var$tmpValueBuffer.arr.subarray(0, writeIdx) : ($c8790514e4af23c9$var$tmpValueBuffer.arr.length = writeIdx, $c8790514e4af23c9$var$tmpValueBuffer.arr);
    // timeSort[0] = Date.now(); // _EC_PERF_
    // Sort axis values into ascending order to calculate gaps.
    if ($c8790514e4af23c9$var$tmpValueBuffer.typed) // Indicatively, 5ms for 1e6 values in a certain platform.
    tmpValueBufferView.sort();
    else (0, $0b2f7076fd7740ca$export$debe6e778e0a6d32)(tmpValueBufferView);
    // timeAll[1] = timeSort[1] = Date.now(); // _EC_PERF_
    // console.log('axisStatistics_minGap_retrieve', timeRetrieve[1] - timeRetrieve[0]); // _EC_PERF_
    // console.log('axisStatistics_minGap_sort', timeSort[1] - timeSort[0]); // _EC_PERF_
    // console.log('axisStatistics_minGap_all', timeAll[1] - timeAll[0]); // _EC_PERF_
    var min = Infinity;
    for(var j = 1; j < writeIdx; ++j){
        var delta = tmpValueBufferView[j] - tmpValueBufferView[j - 1];
        if (// - Different series normally have the same values (e.g., barA, barB, barC),
        //   which should be ignored.
        // - A single series with multiple same values is often not meaningful to
        //   create `bandWidth`, so it is also ignored.
        delta > 0 && delta < min) min = delta;
    }
    ecPreparePerKeyPerAxis.liPosMinGap = perKeyPerAxis.liPosMinGap = (0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(min) ? min : writeIdx > 0 ? (0, $e25c2a392bb1e248$export$3faff2d166c13471) : (0, $e25c2a392bb1e248$export$5e218fe556c51ff0);
    ecPreparePerKeyPerAxis.serUids = newSerUids;
}
// For performance optimization.
var $c8790514e4af23c9$var$tmpValueBuffer = (0, $209806a7434b1d09$export$d47152ac0737a5e9)({
    ctor: (0, $209806a7434b1d09$export$8b884c4a18b44713)
}, 50 // An arbitrary initial capability.
);




function $464b8b93b80c1759$export$a8febf733c5b3d4e(axisStatKey) {
    // [AXIS_CONTAIN_SHAPE_COMMON_STRATEGY]:
    //  The calculation below is based on a proportion mapping
    //  from `[barsBoundVal[0], barsBoundVal[1]]` to `[minValNew, maxValNew]`:
    //                  |------|------------------------------|---|
    //     barsBoundVal[0]   minValOld                 maxValOld barsBoundVal[1]
    //                         |----|----------------------|--|
    //                  minValNew    minValOld     maxValOld maxValNew
    //     (Note: `|---|` above represents "pixels" rather than "data".)
    return function(axis, ecModel) {
        var bandWidthResult = (0, $6d521ceff1ab94af$export$141021262b29d96e)(axis, {
            fromStat: {
                key: axisStatKey
            }
        });
        if ((0, $0b2f7076fd7740ca$export$b5c30d4208814a65)(bandWidthResult.w2)) return [
            -bandWidthResult.w2 / 2,
            bandWidthResult.w2 / 2
        ];
    };
}
function $464b8b93b80c1759$export$e42e3d4e9c56410(seriesType) {
    return seriesType + (0, $e25c2a392bb1e248$export$ba567ca71745149b);
}
function $464b8b93b80c1759$export$6e465398bf63b595(seriesType, coordSysType) {
    return seriesType + (0, $e25c2a392bb1e248$export$ba567ca71745149b) + coordSysType;
}
function $464b8b93b80c1759$export$7a00bf58e60fc739(axis) {
    (0, $c8790514e4af23c9$export$303243915ac59737)();
    return {
        // non-category scale do not use `liPosMinGap` to calculate `bandWidth`.
        liPosMinGap: !(0, $27a07c2e80a6e56f$export$61579433626afe87)(axis.scale)
    };
}




var $e724ef2bcde89fa5$export$c34a2bf62ca07d83 = 'bar';
var $e724ef2bcde89fa5$export$4d5ca1757c2395af = 'pictorialBar';
function $e724ef2bcde89fa5$export$7374d3b28c4a7327(registers, axisStatKey, seriesType, coordSysType) {
    (0, $e25c2a392bb1e248$export$ad2364183e23f875)(registers, {
        key: axisStatKey,
        seriesType: seriesType,
        coordSysType: coordSysType,
        getMetrics: (0, $464b8b93b80c1759$export$7a00bf58e60fc739)
    });
}
function $e724ef2bcde89fa5$export$e2d7eaa2ea5b61c4(baseAxis) {
    var val = baseAxis.scale.rawExtentInfo.makeRenderInfo().startValue;
    return val;
}




var $c9eff090db8f10c2$var$callOnlyOnce = (0, $939d3a4c11ee87fd$export$a305e9b27fd23ae3)();
var $c9eff090db8f10c2$var$STACK_PREFIX = '__ec_stack_';
function $c9eff090db8f10c2$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $c9eff090db8f10c2$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $c9eff090db8f10c2$export$20316ec86014c315(opt) {
    if (!(0, $27a07c2e80a6e56f$export$61579433626afe87)(opt.axis.scale)) return;
    var bandWidthResult = (0, $6d521ceff1ab94af$export$141021262b29d96e)(opt.axis);
    var params = [];
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)({
        stackId: $c9eff090db8f10c2$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $c9eff090db8f10c2$var$calcBarWidthAndOffset({
        bandWidthResult: bandWidthResult,
        seriesInfo: params
    });
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[$c9eff090db8f10c2$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
/**
 * NOTICE: This layout is based on axis pixel extent and scale extent.
 *  It may be used on estimation, where axis pixel extent and scale extent
 *  are approximately set. But the result should not be cached since the
 *  axis pixel extent and scale extent may be changed finally.
 */ function $c9eff090db8f10c2$var$makeColumnLayoutOnAxisReal(baseAxis, seriesType) {
    var seriesInfoListOnAxis = $c9eff090db8f10c2$var$createLayoutInfoListOnAxis(baseAxis, seriesType);
    seriesInfoListOnAxis.columnMap = $c9eff090db8f10c2$var$calcBarWidthAndOffset(seriesInfoListOnAxis);
    return seriesInfoListOnAxis;
}
function $c9eff090db8f10c2$var$createLayoutInfoListOnAxis(baseAxis, seriesType) {
    var axisStatKey = (0, $464b8b93b80c1759$export$6e465398bf63b595)(seriesType, (0, $6681f912fa623077$export$d0b4e8fdb7a13c60));
    var seriesInfoOnAxis = [];
    var bandWidthResult = (0, $6d521ceff1ab94af$export$141021262b29d96e)(baseAxis, {
        fromStat: {
            key: axisStatKey
        },
        min: 1
    });
    (0, $e25c2a392bb1e248$export$ef6bd388c274421f)(baseAxis, axisStatKey, function(seriesModel) {
        seriesInfoOnAxis.push({
            barWidth: (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(seriesModel.get('barWidth'), bandWidthResult.w),
            barMaxWidth: (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(seriesModel.get('barMaxWidth'), bandWidthResult.w),
            barMinWidth: (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
            // the auto-calculated bar width might be less than 0.5 / 1.
            seriesModel.get('barMinWidth') || ($c9eff090db8f10c2$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidthResult.w),
            barGap: seriesModel.get('barGap'),
            barCategoryGap: seriesModel.get('barCategoryGap'),
            defaultBarGap: seriesModel.get('defaultBarGap'),
            stackId: $c9eff090db8f10c2$var$getSeriesStackId(seriesModel)
        });
    });
    return {
        bandWidthResult: bandWidthResult,
        seriesInfo: seriesInfoOnAxis
    };
}
/**
 * CAUTION: When multiple series are laid out on one axis, relevant ec options effect all series.
 * But for historical reason, these options are configured on each series option, which may
 * introduce confliction. The legacy implementation uses some options (e.g., `defaultBarGap`)
 * from the first declared series, and other options (e.g., `barGap`, `barCategoryGap`) from the last declared
 * series. Nevertheless, We remain this design to avoid breaking change.
 */ function $c9eff090db8f10c2$var$calcBarWidthAndOffset(seriesInfoOnAxis) {
    var bandWidth = seriesInfoOnAxis.bandWidthResult.w;
    var remainedWidth = bandWidth;
    var autoWidthCount = 0;
    var barCategoryGapOption;
    var barGapOption;
    var stackIdList = [];
    var stackMap = {};
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(seriesInfoOnAxis.seriesInfo, function(seriesInfo, idx) {
        if (!idx) barGapOption = seriesInfo.defaultBarGap || 0;
        var stackId = seriesInfo.stackId;
        if (!(0, $e4c0c902d0f4f283$export$b5a638e9b3fff9f3)(stackMap, stackId)) autoWidthCount++;
        var stackItem = stackMap[stackId];
        if (!stackItem) {
            stackItem = stackMap[stackId] = {
                width: 0,
                maxWidth: 0
            };
            stackIdList.push(stackId);
        }
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stackItem.width) {
            // See #6312, do not restrict width.
            stackItem.width = barWidth;
            barWidth = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(remainedWidth, barWidth);
            remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stackItem.maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stackItem.minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (barGapOption = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (barCategoryGapOption = barCategoryGap);
    });
    if (barCategoryGapOption == null) // More columns in one group
    // the spaces between group is smaller. Or the column will be too thin.
    barCategoryGapOption = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(35 - stackIdList.length * 4, 15) + '%';
    var barCategoryGapNum = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(barCategoryGapOption, bandWidth);
    var barGapPercent = (0, $0b2f7076fd7740ca$export$e8514cb5a5e2b40f)(barGapOption, 1);
    var autoWidth = (remainedWidth - barCategoryGapNum) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(autoWidth, 0);
    // Find if any auto calculated bar exceeded maxBarWidth
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(stackIdList, function(stackId) {
        var column = stackMap[stackId];
        var maxWidth = column.maxWidth;
        var minWidth = column.minWidth;
        if (!column.width) {
            var finalWidth = autoWidth;
            if (maxWidth && maxWidth < finalWidth) finalWidth = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(maxWidth, remainedWidth);
            // `minWidth` has higher priority. `minWidth` decide that whether the
            // bar is able to be visible. So `minWidth` should not be restricted
            // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
            // the extreme cases for `value` axis, bars are allowed to overlap
            // with each other if `minWidth` specified.
            if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
            if (finalWidth !== autoWidth) {
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        } else {
            // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
            // CSS does. Because barWidth can be a percent value, where
            // `barMaxWidth` can be used to restrict the final width.
            var finalWidth = column.width;
            if (maxWidth) finalWidth = (0, $0b2f7076fd7740ca$export$e411eeaf23dccbe8)(finalWidth, maxWidth);
            // `minWidth` has higher priority, as described above
            if (minWidth) finalWidth = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(finalWidth, minWidth);
            column.width = finalWidth;
            remainedWidth -= finalWidth + barGapPercent * finalWidth;
            autoWidthCount--;
        }
    });
    // Recalculate width again
    autoWidth = (remainedWidth - barCategoryGapNum) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
    autoWidth = (0, $0b2f7076fd7740ca$export$2ca8010d037f830f)(autoWidth, 0);
    var widthSum = 0;
    var lastColumn;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(stackIdList, function(stackId) {
        var column = stackMap[stackId];
        if (!column.width) column.width = autoWidth;
        lastColumn = column;
        widthSum += column.width * (1 + barGapPercent);
    });
    if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
    var result = {};
    var offset = -widthSum / 2;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(stackIdList, function(stackId) {
        var column = stackMap[stackId];
        result[stackId] = result[stackId] || {
            bandWidth: bandWidth,
            offset: offset,
            width: column.width
        };
        offset += column.width * (1 + barGapPercent);
    });
    return result;
}
function $c9eff090db8f10c2$export$13922fb2a9d75502(seriesType) {
    return {
        seriesType: seriesType,
        overallReset: function(ecModel) {
            var axisStatKey = (0, $464b8b93b80c1759$export$6e465398bf63b595)(seriesType, (0, $6681f912fa623077$export$d0b4e8fdb7a13c60));
            (0, $e25c2a392bb1e248$export$37f432351be0ca61)(ecModel, axisStatKey, function(axis) {
                var columnLayout = $c9eff090db8f10c2$var$makeColumnLayoutOnAxisReal(axis, seriesType);
                (0, $e25c2a392bb1e248$export$ef6bd388c274421f)(axis, axisStatKey, function(seriesModel) {
                    var columnLayoutInfo = columnLayout.columnMap[$c9eff090db8f10c2$var$getSeriesStackId(seriesModel)];
                    seriesModel.getData().setLayout({
                        bandWidth: columnLayoutInfo.bandWidth,
                        offset: columnLayoutInfo.offset,
                        size: columnLayoutInfo.width
                    });
                });
            });
        }
    };
}
function $c9eff090db8f10c2$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $ea696ac69c1e8dff$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            if (!(0, $11f3c53f4277ae1d$export$e447722773749af)(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get('showBackground', true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            var stacked = (0, $e66556952e0bcd49$export$1dedc39359ae35c)(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = valueAxis.toGlobalCoord(valueAxis.dataToCoord((0, $e724ef2bcde89fa5$export$e2d7eaa2ea5b61c4)(valueAxis)));
            var isLarge = $c9eff090db8f10c2$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout('size');
            var columnOffset = data.getLayout('offset');
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $209806a7434b1d09$export$21d2298f3f56bbaf)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $209806a7434b1d09$export$21d2298f3f56bbaf)(count * 3);
                    var largeDataIndices = isLarge && (0, $209806a7434b1d09$export$21d2298f3f56bbaf)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var stackStartValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) stackStartValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) baseCoord = cartesian.dataToPoint([
                                stackStartValue,
                                baseValue
                            ])[0];
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if ((0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) baseCoord = cartesian.dataToPoint([
                                baseValue,
                                stackStartValue
                            ])[1];
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if ((0, $0b2f7076fd7740ca$export$5860c226b237d9a6)(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $c9eff090db8f10c2$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
function $c9eff090db8f10c2$var$barGridCreateAxisContainShapeHandler(seriesType) {
    // See also #6728, #4862, `test/bar-overflow-time-plot.html` `test/bar-overflow-plot2.html`
    // NOTE:
    //  Series shapes may overflow `bandWidth` when ec option is set like:
    //    - `barWidth` > 100%.
    //    - `barWidth` is set as absolute pixel values and `dataZoom` is used, since `bandWidth` is
    //      calculated on data space rather than pixel space.
    //  We originally used `calcShapeOverflowSupplement` to cover this case, but it still can not
    //  resolve pixel `barWidth` case perfectly. A thorough solution may introduce considerable complex,
    //  but may not necessary, since users can avoid it by proper ec option settings.
    //  Therefore, we use simply `createBandWidthBasedAxisContainShapeHandler` to calculate "containShape"
    //  only based on `bandWidth`.
    return (0, $464b8b93b80c1759$export$a8febf733c5b3d4e)((0, $464b8b93b80c1759$export$6e465398bf63b595)(seriesType, (0, $6681f912fa623077$export$d0b4e8fdb7a13c60)));
// return function (axis, scale, ecModel) {
//     if (!countSeriesOnAxisOnKey(axis, makeAxisStatKey2(seriesType, COORD_SYS_TYPE_CARTESIAN_2D))) {
//         return; // Quick path - in most cases there is no bar on non-ordinal axis.
//     }
//     const columnLayout = makeColumnLayoutOnAxisReal(axis, seriesType);
//     return calcShapeOverflowSupplement(columnLayout);
// };
}
function $c9eff090db8f10c2$export$f94e305d0960f41c(registers) {
    $c9eff090db8f10c2$var$callOnlyOnce(registers, function() {
        function register(seriesType) {
            var axisStatKey = (0, $464b8b93b80c1759$export$6e465398bf63b595)(seriesType, (0, $6681f912fa623077$export$d0b4e8fdb7a13c60));
            (0, $e724ef2bcde89fa5$export$7374d3b28c4a7327)(registers, axisStatKey, seriesType, (0, $6681f912fa623077$export$d0b4e8fdb7a13c60));
            (0, $10061a7e816c9eb5$export$7b3647d53bcfcf4e)(axisStatKey, $c9eff090db8f10c2$var$barGridCreateAxisContainShapeHandler(seriesType));
        }
        register('bar');
        register('pictorialBar');
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f9df1893296f7a23$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $f9df1893296f7a23$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $f9df1893296f7a23$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    else if (sampling === 'minmax') seriesModel.setData(data.minmaxDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(sampling)) sampler = $f9df1893296f7a23$var$samplers[sampling];
                    else if ((0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $f9df1893296f7a23$var$indexSampler));
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c1cbc84f29de5963$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $c1cbc84f29de5963$var$defaultKeyGetter(item) {
    return item;
}
var $c1cbc84f29de5963$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $c1cbc84f29de5963$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $c1cbc84f29de5963$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $c1cbc84f29de5963$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $c1cbc84f29de5963$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $c1cbc84f29de5963$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $c1cbc84f29de5963$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $c1cbc84f29de5963$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $c1cbc84f29de5963$export$2e2bcd8739ae039 = $c1cbc84f29de5963$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $2d562ffbdbcb3738$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $2d562ffbdbcb3738$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $2d562ffbdbcb3738$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($2d562ffbdbcb3738$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $2d562ffbdbcb3738$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $0f5447108b4a27a4$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $2d562ffbdbcb3738$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $2d562ffbdbcb3738$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $2d562ffbdbcb3738$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $2d562ffbdbcb3738$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $2d562ffbdbcb3738$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $363f2ea205bc9d32$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The term "other" means "other than coord".
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $e4c0c902d0f4f283$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $363f2ea205bc9d32$export$2e2bcd8739ae039 = $363f2ea205bc9d32$var$SeriesDimensionDefine;








var $dea8d81f89b2ca4e$var$isObject = $e4c0c902d0f4f283$export$a6cdc56e425d0d0a;
var $dea8d81f89b2ca4e$var$map = $e4c0c902d0f4f283$export$871de8747c9eaa88;
var $dea8d81f89b2ca4e$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $dea8d81f89b2ca4e$var$ID_PREFIX = 'e\0\0';
var $dea8d81f89b2ca4e$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $dea8d81f89b2ca4e$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $dea8d81f89b2ca4e$var$CLONE_PROPERTIES = [
    '_approximateExtent'
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $dea8d81f89b2ca4e$var$prepareInvertedIndex;
var $dea8d81f89b2ca4e$var$getId;
var $dea8d81f89b2ca4e$var$getIdNameFromStore;
var $dea8d81f89b2ca4e$var$normalizeDimensions;
var $dea8d81f89b2ca4e$var$transferProperties;
var $dea8d81f89b2ca4e$var$cloneListForMapAndSample;
var $dea8d81f89b2ca4e$var$makeIdFromName;
var $dea8d81f89b2ca4e$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'minmaxDownSample',
            'lttbDownSample',
            'map'
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'minmaxDownSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $8adb494c9e76f9e1$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $e4c0c902d0f4f283$export$844ec244b1367d54(dimInfoInput) ? new (0, $363f2ea205bc9d32$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $363f2ea205bc9d32$export$2e2bcd8739ae039)) ? new (0, $363f2ea205bc9d32$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
            if (otherDims.itemName === 0) this._nameDimIdx = dimensionInfo.storeDimIndex;
            if (otherDims.itemId === 0) this._idDimIdx = dimensionInfo.storeDimIndex;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $e4c0c902d0f4f283$export$55f8aa7ef875b0a4();
            $e4c0c902d0f4f283$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($e4c0c902d0f4f283$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $91c1d6712d761710$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $bbaae55b69ad01c5$export$22b808bc02a60488)(data) || $e4c0c902d0f4f283$export$1e2f57719e155213(data) ? new (0, $35510f45b1caf446$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $91c1d6712d761710$export$2e2bcd8739ae039)();
            var dimensionInfos = $dea8d81f89b2ca4e$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $2d562ffbdbcb3738$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names && names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $dea8d81f89b2ca4e$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $0f5447108b4a27a4$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $939d3a4c11ee87fd$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $939d3a4c11ee87fd$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $939d3a4c11ee87fd$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$dea8d81f89b2ca4e$var$makeIdFromName(this, idx);
        $dea8d81f89b2ca4e$var$prepareInvertedIndex(this);
    };
    /**
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim, filter) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim), filter);
    };
    /**
   * NOTICE: `_approximateExtent` does not support filter. Callers must ensure the input extent
   * to be handled by `scale.sanitizeExtent`.
   *
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $dea8d81f89b2ca4e$var$isObject(key) ? $e4c0c902d0f4f283$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $dea8d81f89b2ca4e$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $dea8d81f89b2ca4e$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim), null);
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $e4c0c902d0f4f283$export$43bee75e5e14138e(dimensions) ? store.getValues($dea8d81f89b2ca4e$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices && invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $dea8d81f89b2ca4e$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $dea8d81f89b2ca4e$var$map($dea8d81f89b2ca4e$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $e4c0c902d0f4f283$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $dea8d81f89b2ca4e$var$map($dea8d81f89b2ca4e$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $e4c0c902d0f4f283$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $e4c0c902d0f4f283$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $e4c0c902d0f4f283$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if ($e4c0c902d0f4f283$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict';
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $dea8d81f89b2ca4e$var$map($dea8d81f89b2ca4e$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $dea8d81f89b2ca4e$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $e4c0c902d0f4f283$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $dea8d81f89b2ca4e$var$map($dea8d81f89b2ca4e$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $e4c0c902d0f4f283$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $dea8d81f89b2ca4e$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ SeriesData.prototype.minmaxDownSample = function(valueDimension, rate) {
        var list = $dea8d81f89b2ca4e$var$cloneListForMapAndSample(this);
        list._store = this._store.minmaxDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $dea8d81f89b2ca4e$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $7232b75992df3b9d$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $c1cbc84f29de5963$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $dea8d81f89b2ca4e$var$getId(otherList, idx);
        }, function(idx) {
            return $dea8d81f89b2ca4e$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($dea8d81f89b2ca4e$var$isObject(kvObj)) $e4c0c902d0f4f283$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($e4c0c902d0f4f283$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($dea8d81f89b2ca4e$var$isObject(val)) val = $e4c0c902d0f4f283$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($dea8d81f89b2ca4e$var$isObject(key)) $e4c0c902d0f4f283$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $dea8d81f89b2ca4e$var$isObject(key) ? $e4c0c902d0f4f283$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $e4c0c902d0f4f283$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $7baa8a5774022ac4$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $e4c0c902d0f4f283$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $dea8d81f89b2ca4e$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $dea8d81f89b2ca4e$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$e4c0c902d0f4f283$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($e4c0c902d0f4f283$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $dea8d81f89b2ca4e$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $e4c0c902d0f4f283$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $dea8d81f89b2ca4e$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $dea8d81f89b2ca4e$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $dea8d81f89b2ca4e$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $939d3a4c11ee87fd$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $dea8d81f89b2ca4e$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $dea8d81f89b2ca4e$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $dea8d81f89b2ca4e$var$ID_PREFIX + rawIndex;
            return id;
        };
        $dea8d81f89b2ca4e$var$normalizeDimensions = function(dimensions) {
            if (!$e4c0c902d0f4f283$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $dea8d81f89b2ca4e$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $dea8d81f89b2ca4e$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $dea8d81f89b2ca4e$var$transferProperties(list, original);
            return list;
        };
        $dea8d81f89b2ca4e$var$transferProperties = function(target, source) {
            $e4c0c902d0f4f283$export$79b2f7037acddd43($dea8d81f89b2ca4e$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $e4c0c902d0f4f283$export$79b2f7037acddd43($dea8d81f89b2ca4e$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $e4c0c902d0f4f283$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $e4c0c902d0f4f283$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $dea8d81f89b2ca4e$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $dea8d81f89b2ca4e$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $dea8d81f89b2ca4e$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $dea8d81f89b2ca4e$export$2e2bcd8739ae039 = $dea8d81f89b2ca4e$var$SeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $a511b0f5c02704ce$export$8066c1b52b2e9504(source, opt) {
    return $a511b0f5c02704ce$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $a511b0f5c02704ce$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $bbaae55b69ad01c5$export$22b808bc02a60488)(source)) source = (0, $bbaae55b69ad01c5$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $a511b0f5c02704ce$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $8adb494c9e76f9e1$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $8adb494c9e76f9e1$export$be39ae17310c33f7)(source) : (0, $8adb494c9e76f9e1$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $91c1d6712d761710$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $363f2ea205bc9d32$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $e4c0c902d0f4f283$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $e4c0c902d0f4f283$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $e4c0c902d0f4f283$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $939d3a4c11ee87fd$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $e4c0c902d0f4f283$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $0f5447108b4a27a4$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $a511b0f5c02704ce$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $395b6c5de5b92774$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $395b6c5de5b92774$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    (0, $939d3a4c11ee87fd$export$2e2262a44ac61957)(resultList, function(item) {
        return item.name;
    }, function(item, existingCount) {
        if (existingCount > 0) // Starts from 0.
        item.name = item.name + (existingCount - 1);
    });
    return new (0, $8adb494c9e76f9e1$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $a511b0f5c02704ce$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $e4c0c902d0f4f283$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $a511b0f5c02704ce$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $5b764321568fa864$export$7c29393272d112a1 = /** @class */ function() {
    function SeriesModelCoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $e4c0c902d0f4f283$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return SeriesModelCoordSysInfo;
}();
function $5b764321568fa864$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $5b764321568fa864$export$7c29393272d112a1(coordSysName);
    var fetch = $5b764321568fa864$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
// TODO: refactor them to static member of each coord sys, rather than hard code here.
var $5b764321568fa864$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($5b764321568fa864$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($5b764321568fa864$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($5b764321568fa864$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($5b764321568fa864$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($5b764321568fa864$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($5b764321568fa864$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    },
    matrix: function(seriesModel, result, axisMap, categoryAxisMap) {
        var matrixModel = seriesModel.getReferringComponents('matrix', (0, $939d3a4c11ee87fd$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        var xModel = matrixModel.getDimensionModel('x');
        var yModel = matrixModel.getDimensionModel('y');
        axisMap.set('x', xModel);
        axisMap.set('y', yModel);
        categoryAxisMap.set('x', xModel);
        categoryAxisMap.set('y', yModel);
    }
};
function $5b764321568fa864$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}






function $17ab2019151e385b$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $65108a454a48746f$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $e4c0c902d0f4f283$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $2d562ffbdbcb3738$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $17ab2019151e385b$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $e4c0c902d0f4f283$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $17ab2019151e385b$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $bbaae55b69ad01c5$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $5b764321568fa864$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $17ab2019151e385b$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $e4c0c902d0f4f283$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $e4c0c902d0f4f283$export$c3095a23b368d1f2((0, $395b6c5de5b92774$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $a511b0f5c02704ce$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $17ab2019151e385b$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $e66556952e0bcd49$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $dea8d81f89b2ca4e$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $17ab2019151e385b$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $17ab2019151e385b$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $0f5447108b4a27a4$export$2823037fb9d8f0c6)) {
        var sampleItem = $17ab2019151e385b$var$firstDataNotNull(source.data || []);
        return !$e4c0c902d0f4f283$export$43bee75e5e14138e((0, $939d3a4c11ee87fd$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $17ab2019151e385b$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $17ab2019151e385b$export$2e2bcd8739ae039 = $17ab2019151e385b$var$createSeriesData;



var $6ea22aa2bf643e66$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $17ab2019151e385b$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === 'category' && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get('alignWithLabel');
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === 'x1' || dims[idx] === 'y1';
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout('offset');
                var size = data.getLayout('size');
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    /**
   * @implements
   */ BaseBarSeriesModel.prototype.__requireStartValue = function(axis) {
        return this.getBaseAxis() !== axis;
    };
    BaseBarSeriesModel.type = 'series.__base_bar__';
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: 'mod',
        defaultBarGap: '10%'
    };
    return BaseBarSeriesModel;
}((0, $be83ac5e1b26ee48$export$2e2bcd8739ae039));
(0, $be83ac5e1b26ee48$export$2e2bcd8739ae039).registerClass($6ea22aa2bf643e66$var$BaseBarSeriesModel);
var $6ea22aa2bf643e66$export$2e2bcd8739ae039 = $6ea22aa2bf643e66$var$BaseBarSeriesModel;







var $36b495b6c3c853d4$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $17ab2019151e385b$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get('realtimeSort', true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get('large') ? this.get('progressive') : false;
    };
    /**
   * @implement
   */ BarSeriesModel.prototype.__preparePipelineContext = function(view, pipeline) {
        var context = (0, $939d3a4c11ee87fd$export$3b33f7e0868ca070)(this, view, pipeline);
        // Do not support progressive in normal mode.
        if (context.progressiveRender) context.large = true;
        return context;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = 'series.' + (0, $e724ef2bcde89fa5$export$c34a2bf62ca07d83);
    BarSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    BarSeriesModel.defaultOption = (0, $b08603d2997306ff$export$68acc510e46fef2)((0, $6ea22aa2bf643e66$export$2e2bcd8739ae039).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            borderColor: null,
            borderWidth: 0,
            borderType: 'solid',
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: (0, $c9f6a1a0ed0e91a6$export$2e2bcd8739ae039).color.primary,
                borderWidth: 2
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $6ea22aa2bf643e66$export$2e2bcd8739ae039));
var $36b495b6c3c853d4$export$2e2bcd8739ae039 = $36b495b6c3c853d4$var$BarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $0db2de9a8690aeca$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 0;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $439653c37a0e6e60$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $e4c0c902d0f4f283$export$f6e2535fb5126e54)(during) ? function(percent) {
            during(percent, clipPath);
        } : null;
        $97d0e733871fae49$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $0db2de9a8690aeca$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $bf363fc63c6d894e$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $0b2f7076fd7740ca$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $97d0e733871fae49$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $0db2de9a8690aeca$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $0db2de9a8690aeca$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $0db2de9a8690aeca$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}
var $0db2de9a8690aeca$export$50eaf45b617b77da = 0;
var $0db2de9a8690aeca$export$36c0f03caa6071e6 = 1;
var $0db2de9a8690aeca$export$6b0aed6da8ae4f2e = 2;
function $0db2de9a8690aeca$export$e01c1b2ba9fe13e9(clip, symbolEl, clipPath) {
    if (clip) symbolEl.setClipPath(clipPath);
    else symbolEl.removeClipPath();
}
function $0db2de9a8690aeca$export$dd44d434645865fc(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.get('clip', true) && coordSys && (!coordSys.shouldClip || coordSys.shouldClip())) // PENDING make `0.1` configurable, for example, `clipTolerance`?
    return coordSys.getArea && coordSys.getArea(.1);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $c05afb8bdda9c03a$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $c05afb8bdda9c03a$var$SausagePath = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sausage';
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $c05afb8bdda9c03a$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
var $c05afb8bdda9c03a$export$2e2bcd8739ae039 = $c05afb8bdda9c03a$var$SausagePath;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $6f08dc2ea7e9f5bf$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}
function $6f08dc2ea7e9f5bf$export$d3269a273c05cc72(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === 'lng' && dimensions[1] === 'lat' && !!coordSys.getViewRect;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $8d01497ad6f20a54$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $35510f45b1caf446$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $35510f45b1caf446$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $8d01497ad6f20a54$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $3638016ea3bc803c$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $211780946ab71638$export$eee3603b512feab7)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        switch(mappedSectorPosition){
            case 'startArc':
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'insideStartArc':
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'startAngle':
                x = cx + middleR * mathCos(startAngle) + $3638016ea3bc803c$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $3638016ea3bc803c$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideStartAngle':
                x = cx + middleR * mathCos(startAngle) + $3638016ea3bc803c$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $3638016ea3bc803c$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'middle':
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'endArc':
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideEndArc':
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'endAngle':
                x = cx + middleR * mathCos(endAngle) + $3638016ea3bc803c$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $3638016ea3bc803c$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'insideEndAngle':
                x = cx + middleR * mathCos(endAngle) + $3638016ea3bc803c$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $3638016ea3bc803c$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            default:
                return (0, $211780946ab71638$export$eee3603b512feab7)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $3638016ea3bc803c$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $e4c0c902d0f4f283$export$7e4aa119212bc614)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case 'startArc':
        case 'insideStartArc':
        case 'middle':
        case 'insideEndArc':
        case 'endArc':
            anchorAngle = middleAngle;
            break;
        case 'startAngle':
        case 'insideStartAngle':
            anchorAngle = startAngle;
            break;
        case 'endAngle':
        case 'insideEndAngle':
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $3638016ea3bc803c$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $3638016ea3bc803c$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b4b83803ed197fb2$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get('borderRadius');
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $e4c0c902d0f4f283$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $211780946ab71638$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}




var $2862270914bd0b3d$var$mathMax = Math.max;
var $2862270914bd0b3d$var$mathMin = Math.min;
var $2862270914bd0b3d$var$BarView = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = (0, $e724ef2bcde89fa5$export$c34a2bf62ca07d83);
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get('coordinateSystem');
        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset for eachRendered
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $05f852c7feb2d530$export$3e564442729bf048)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $2862270914bd0b3d$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
        // Both `cartesian2d` and `polar` has `getArea()`.
        var coordSysClipArea = coord.getArea();
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        // Instead, `Clipper` is used in normal mode.
        var roundCap = seriesModel.get('roundCap', true);
        var drawBackground = seriesModel.get('showBackground', true);
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
        function createBackground(dataIndex) {
            var bgLayout = $2862270914bd0b3d$var$getLayout[coord.type](data, dataIndex);
            if (!bgLayout) return null;
            var bgEl = $2862270914bd0b3d$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
            else bgEl.setShape('cornerRadius', barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $2862270914bd0b3d$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (!layout) return;
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$2862270914bd0b3d$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $2862270914bd0b3d$var$clip[coord.type](coordSysClipArea, layout);
            var el = $2862270914bd0b3d$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $2862270914bd0b3d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $2862270914bd0b3d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $97d0e733871fae49$export$a121566aadcfe021)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $2862270914bd0b3d$var$getLayout[coord.type](data, newIndex, itemModel);
            if (!layout) return;
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                    else bgEl.setShape('cornerRadius', barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $2862270914bd0b3d$var$getLayout[coord.type](data, newIndex);
                var shape = $2862270914bd0b3d$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $97d0e733871fae49$export$c8dce3c08436e91e)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$2862270914bd0b3d$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $2862270914bd0b3d$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            var roundCapChanged = el && (el.type === 'sector' && roundCap || el.type === 'sausage' && !roundCap);
            if (roundCapChanged) {
                // roundCap changed, there is no way to use animation from a `sector` to a `sausage` shape,
                // so remove the old one and create a new shape
                el && (0, $97d0e733871fae49$export$6d0fd725cb4aee8a)(el, seriesModel, oldIndex);
                el = null;
            }
            if (!el) el = $2862270914bd0b3d$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, true, roundCap);
            else (0, $97d0e733871fae49$export$bca7290a9faf0ec9)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $83b5345ce49bb659$export$f62786d3261ab0f4)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $2862270914bd0b3d$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $2862270914bd0b3d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $97d0e733871fae49$export$c8dce3c08436e91e)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $97d0e733871fae49$export$6d0fd725cb4aee8a)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $0c53f0d63dde8266$export$2e2bcd8739ae039)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $2862270914bd0b3d$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $2862270914bd0b3d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get('clip', true) && (0, $0db2de9a8690aeca$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on('rendered', this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $e4c0c902d0f4f283$export$871de8747c9eaa88)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: 'changeAxisOrder',
            componentType: baseAxis.dim + 'Axis',
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off('rendered', this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $97d0e733871fae49$export$6d0fd725cb4aee8a)(el, model, (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = (0, $e724ef2bcde89fa5$export$c34a2bf62ca07d83);
    return BarView;
}((0, $2c3bdaabdaf03627$export$2e2bcd8739ae039));
var $2862270914bd0b3d$var$clip = {
    cartesian2d: function(coordSysClipArea, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysClipArea.x + coordSysClipArea.width;
        var coordSysY2 = coordSysClipArea.y + coordSysClipArea.height;
        var x = $2862270914bd0b3d$var$mathMax(layout.x, coordSysClipArea.x);
        var x2 = $2862270914bd0b3d$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $2862270914bd0b3d$var$mathMax(layout.y, coordSysClipArea.y);
        var y2 = $2862270914bd0b3d$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $2862270914bd0b3d$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $2862270914bd0b3d$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $2862270914bd0b3d$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $439653c37a0e6e60$export$2e2bcd8739ae039)({
            shape: (0, $e4c0c902d0f4f283$export$8b58be045bf06082)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = 'item';
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? 'height' : 'width';
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $c05afb8bdda9c03a$export$2e2bcd8739ae039) : (0, $bf363fc63c6d894e$export$2e2bcd8739ae039);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = 'item';
        var positionMap = $2862270914bd0b3d$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $3638016ea3bc803c$export$359a1e2d210ed734)(positionMap, {
            isRoundCap: ShapeClass === (0, $c05afb8bdda9c03a$export$2e2bcd8739ae039)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? 'r' : 'endAngle';
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $97d0e733871fae49$export$c8dce3c08436e91e) : (0, $97d0e733871fae49$export$a121566aadcfe021))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $2862270914bd0b3d$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get('realtimeSort', true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $2862270914bd0b3d$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $97d0e733871fae49$export$c8dce3c08436e91e) : (0, $97d0e733871fae49$export$a121566aadcfe021))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $97d0e733871fae49$export$c8dce3c08436e91e) : (0, $97d0e733871fae49$export$a121566aadcfe021))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $2862270914bd0b3d$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $2862270914bd0b3d$var$rectPropties = [
    'x',
    'y',
    'width',
    'height'
];
var $2862270914bd0b3d$var$polarPropties = [
    'cx',
    'cy',
    'r',
    'startAngle',
    'endAngle'
];
var $2862270914bd0b3d$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$2862270914bd0b3d$var$checkPropertiesNotValid(layout, $2862270914bd0b3d$var$rectPropties);
    },
    polar: function(layout) {
        return !$2862270914bd0b3d$var$checkPropertiesNotValid(layout, $2862270914bd0b3d$var$polarPropties);
    }
};
var $2862270914bd0b3d$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        if (!layout) return null;
        var fixedLineWidth = itemModel ? $2862270914bd0b3d$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $2862270914bd0b3d$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $2862270914bd0b3d$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
        return function(position) {
            switch(position){
                case 'start':
                case 'insideStart':
                case 'end':
                case 'insideEnd':
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $2862270914bd0b3d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, 'style');
    if (!isPolar) {
        var borderRadius = itemModel.get([
            'itemStyle',
            'borderRadius'
        ]) || 0;
        el.setShape('r', borderRadius);
    } else if (!seriesModel.get('roundCap')) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $b4b83803ed197fb2$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), sectorShape, true);
        (0, $e4c0c902d0f4f283$export$8b58be045bf06082)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && el.attr('cursor', cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? $2862270914bd0b3d$var$getLabelPositionForHorizontal(layout, seriesModel.coordinateSystem) : $2862270914bd0b3d$var$getLabelPositionForVertical(layout, seriesModel.coordinateSystem);
    var labelStatesModels = (0, $83b5345ce49bb659$export$9739a32674be5893)(itemModel);
    (0, $83b5345ce49bb659$export$9a13992917966657)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $8d01497ad6f20a54$export$5ff20667590927ed)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            'label',
            'position'
        ]);
        el.textConfig.inside = position === 'middle' ? true : null;
        (0, $3638016ea3bc803c$export$672ce504c0db395a)(el, position === 'outside' ? labelPositionOutside : position, $2862270914bd0b3d$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            'label',
            'rotate'
        ]));
    }
    (0, $83b5345ce49bb659$export$7bdbceaf9ab378f2)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $8d01497ad6f20a54$export$5f84815e91ca6775)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        'emphasis'
    ]);
    (0, $6243d8dbb37d6b0d$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    (0, $6243d8dbb37d6b0d$export$48b68047d330bbc9)(el, itemModel);
    if ($2862270914bd0b3d$var$isZeroOnPolar(layout)) {
        el.style.fill = 'none';
        el.style.stroke = 'none';
        (0, $e4c0c902d0f4f283$export$79b2f7037acddd43)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = 'none';
        });
    }
}
// In case width or height are too small.
function $2862270914bd0b3d$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        'itemStyle',
        'borderColor'
    ]);
    if (!borderColor || borderColor === 'none') return 0;
    var lineWidth = itemModel.get([
        'itemStyle',
        'borderWidth'
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $2862270914bd0b3d$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $2862270914bd0b3d$var$LargePath = /** @class */ function(_super) {
    (0, $21e3a120f93644c0$export$a8ba968b8961cb8a)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeBar';
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $2862270914bd0b3d$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $27b47789cc8143e1$export$2e2bcd8739ae039));
function $2862270914bd0b3d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
    var largeDataIndices = data.getLayout('largeDataIndices');
    var barWidth = data.getLayout('size');
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var bgPoints = data.getLayout('largeBackgroundPoints');
    var incrementalId = incremental ? (0, $939d3a4c11ee87fd$export$4496820b7f3d3e98)(seriesModel) : 0;
    if (bgPoints) {
        var bgEl = new $2862270914bd0b3d$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: incrementalId,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $2862270914bd0b3d$var$LargePath({
        shape: {
            points: data.getLayout('largePoints')
        },
        incremental: incrementalId,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual('style'));
    // Stroke is rendered first to avoid overlapping with fill. See #20465
    el.style.stroke = null;
    // Enable tooltip and user mouse/touch event handlers.
    (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get('silent')) {
        el.on('mousedown', $2862270914bd0b3d$var$largePathUpdateDataIndex);
        el.on('mousemove', $2862270914bd0b3d$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $2862270914bd0b3d$var$largePathUpdateDataIndex = (0, $3a19e7f2dc31be9c$export$de363e709c412c8a)(function(event) {
    var largePath = this;
    var dataIndex = $2862270914bd0b3d$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $7baa8a5774022ac4$export$b1c39b2bacd1ddc2)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $2862270914bd0b3d$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $2862270914bd0b3d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $6f08dc2ea7e9f5bf$export$8567506e6336616)(coord, 'cartesian2d')) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $2862270914bd0b3d$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === 'polar' ? (0, $bf363fc63c6d894e$export$2e2bcd8739ae039) : (0, $439653c37a0e6e60$export$2e2bcd8739ae039);
    return new ElementClz({
        shape: $2862270914bd0b3d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
function $2862270914bd0b3d$var$getLabelPositionForHorizontal(layout, coordSys) {
    if (layout.height === 0) {
        // For zero height, determine position based on axis inverse status
        var valueAxis = coordSys.getOtherAxis(coordSys.getBaseAxis());
        return valueAxis.inverse ? 'bottom' : 'top';
    }
    return layout.height > 0 ? 'bottom' : 'top';
}
function $2862270914bd0b3d$var$getLabelPositionForVertical(layout, coordSys) {
    if (layout.width === 0) {
        // For zero width, determine position based on axis inverse status
        var valueAxis = coordSys.getOtherAxis(coordSys.getBaseAxis());
        return valueAxis.inverse ? 'left' : 'right';
    }
    return layout.width >= 0 ? 'right' : 'left';
}
var $2862270914bd0b3d$export$2e2bcd8739ae039 = $2862270914bd0b3d$var$BarView;



function $16dd8dbd4304118c$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $2862270914bd0b3d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $36b495b6c3c853d4$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, $c9eff090db8f10c2$export$13922fb2a9d75502)((0, $e724ef2bcde89fa5$export$c34a2bf62ca07d83)));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $c9eff090db8f10c2$export$16e8685758531cb6)((0, $e724ef2bcde89fa5$export$c34a2bf62ca07d83)));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $f9df1893296f7a23$export$2e2bcd8739ae039)((0, $e724ef2bcde89fa5$export$c34a2bf62ca07d83)));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'changeAxisOrder',
        event: 'changeAxisOrder',
        update: 'update'
    }, function(payload, ecModel) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
    (0, $c9eff090db8f10c2$export$f94e305d0960f41c)(registers);
}




var $6ec20e1555220c4d$var$_a;
(0, $fc909a89248875c1$export$1f96ae73734a86cc)((0, $16dd8dbd4304118c$export$4b3e715f166fdd78));
class $6ec20e1555220c4d$export$66307e3e8fac7e52 extends (0, $e105d0ae0b8f861c$export$37de6f71bb86a769) {
}
($6ec20e1555220c4d$var$_a = globalThis.customElements) === null || $6ec20e1555220c4d$var$_a === void 0 || $6ec20e1555220c4d$var$_a.define('ec-bar-chart', $6ec20e1555220c4d$export$66307e3e8fac7e52);



var $3lE4N = parcelRequire("3lE4N");
parcelRequire("bTKq6");
parcelRequire("84txe");
parcelRequire("8KfTK");
parcelRequire("8GElt");

const $6bc0a6f62aa387be$export$c489dd2bd24850e4 = ({ title: title, children: children })=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("h2", {
                className: "mt-3",
                children: title
            }),
            children,
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.CodeBlock), {
                language: "tsx",
                children: children
            })
        ]
    });


const $b799a869ecb05549$export$200ed0c9cbeb911a = undefined;
function $b799a869ecb05549$var$_createMdxContent(props) {
    const _components = {
        a: "a",
        h1: "h1",
        p: "p",
        ...props.components
    };
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)(_components.h1, {
                children: "Charts in Markdown"
            }),
            "\n",
            (0, $833f543b429117ba$export$34b9dba7ce09269b)(_components.p, {
                children: [
                    "This example is based on ",
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)(_components.a, {
                        href: "https://github.com/idea2app/ECharts-JSX",
                        children: "ECharts-JSX"
                    }),
                    " & ",
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)(_components.a, {
                        href: "https://github.com/EasyWebApp/Parcel-transformer-MDX",
                        children: "Parcel-transformer-MDX"
                    }),
                    "."
                ]
            }),
            "\n",
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "ECharts example",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("ec-svg-renderer", {
                    style: {
                        height: '80vh'
                    },
                    onClick: console.log,
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("ec-title", {
                            text: "ECharts example"
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("ec-legend", {
                            data: [
                                'sales'
                            ]
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("ec-tooltip", {}),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("ec-x-axis", {
                            data: [
                                'Shirts',
                                'Cardigans',
                                'Chiffons',
                                'Pants',
                                'Heels',
                                'Socks'
                            ]
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("ec-y-axis", {}),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("ec-bar-chart", {
                            name: "sales",
                            data: [
                                5,
                                20,
                                36,
                                10,
                                10,
                                20
                            ],
                            onClick: console.log
                        })
                    ]
                })
            })
        ]
    });
}
function $b799a869ecb05549$export$2e2bcd8739ae039(props = {}) {
    const { wrapper: MDXLayout } = props.components || {};
    return MDXLayout ? (0, $833f543b429117ba$export$34b9dba7ce09269b)(MDXLayout, {
        ...props,
        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($b799a869ecb05549$var$_createMdxContent, {
            ...props
        })
    }) : $b799a869ecb05549$var$_createMdxContent(props);
}






var $75acd277c1ee9d2f$exports = {};

var $3lE4N = parcelRequire("3lE4N");




const $9197eb5abb1c09ae$export$5f747a46dc0eb6ee = (()=>{
    if ("undefined" == typeof self) return !1;
    if ("top" in self && self !== top) try {
        top.window.document._ = 0;
    } catch (e) {
        return !1;
    }
    return "showOpenFilePicker" in self;
})(), $9197eb5abb1c09ae$var$t = $9197eb5abb1c09ae$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $9197eb5abb1c09ae$var$c;
}) : Promise.resolve().then(function() {
    return $9197eb5abb1c09ae$var$h;
});
async function $9197eb5abb1c09ae$export$c1bd535e520dbbc3(...e) {
    return (await $9197eb5abb1c09ae$var$t).default(...e);
}
const $9197eb5abb1c09ae$var$r = $9197eb5abb1c09ae$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $9197eb5abb1c09ae$var$y;
}) : Promise.resolve().then(function() {
    return $9197eb5abb1c09ae$var$b;
});
async function $9197eb5abb1c09ae$export$270aed3754275094(...e) {
    return (await $9197eb5abb1c09ae$var$r).default(...e);
}
const $9197eb5abb1c09ae$var$a = $9197eb5abb1c09ae$export$5f747a46dc0eb6ee ? Promise.resolve().then(function() {
    return $9197eb5abb1c09ae$var$m;
}) : Promise.resolve().then(function() {
    return $9197eb5abb1c09ae$var$_;
});
async function $9197eb5abb1c09ae$export$cf414c79194c40b9(...e) {
    return (await $9197eb5abb1c09ae$var$a).default(...e);
}
const $9197eb5abb1c09ae$var$s = async (e)=>{
    const t = await e.getFile();
    return t.handle = e, t;
};
var $9197eb5abb1c09ae$export$73dd4a3df259d52 = async (e = [
    {}
])=>{
    Array.isArray(e) || (e = [
        e
    ]);
    const t = [];
    e.forEach((e, n)=>{
        t[n] = {
            description: e.description || "Files",
            accept: {}
        }, e.mimeTypes ? e.mimeTypes.map((r)=>{
            t[n].accept[r] = e.extensions || [];
        }) : t[n].accept["*/*"] = e.extensions || [];
    });
    const n = await window.showOpenFilePicker({
        id: e[0].id,
        startIn: e[0].startIn,
        types: t,
        multiple: e[0].multiple || !1,
        excludeAcceptAllOption: e[0].excludeAcceptAllOption || !1
    }), r = await Promise.all(n.map($9197eb5abb1c09ae$var$s));
    return e[0].multiple ? r : r[0];
}, $9197eb5abb1c09ae$var$c = {
    __proto__: null,
    default: $9197eb5abb1c09ae$export$73dd4a3df259d52
};
function $9197eb5abb1c09ae$var$u(e) {
    function t(e) {
        if (Object(e) !== e) return Promise.reject(new TypeError(e + " is not an object."));
        var t = e.done;
        return Promise.resolve(e.value).then(function(e) {
            return {
                value: e,
                done: t
            };
        });
    }
    return $9197eb5abb1c09ae$var$u = function(e) {
        this.s = e, this.n = e.next;
    }, $9197eb5abb1c09ae$var$u.prototype = {
        s: null,
        n: null,
        next: function() {
            return t(this.n.apply(this.s, arguments));
        },
        return: function(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.resolve({
                value: e,
                done: !0
            }) : t(n.apply(this.s, arguments));
        },
        throw: function(e) {
            var n = this.s.return;
            return void 0 === n ? Promise.reject(e) : t(n.apply(this.s, arguments));
        }
    }, new $9197eb5abb1c09ae$var$u(e);
}
const $9197eb5abb1c09ae$var$p = async (e, t, n = e.name, r)=>{
    const i = [], a = [];
    var o, s = !1, l = !1;
    try {
        for(var c, d = function(e) {
            var t, n, r, i = 2;
            for("undefined" != typeof Symbol && (n = Symbol.asyncIterator, r = Symbol.iterator); i--;){
                if (n && null != (t = e[n])) return t.call(e);
                if (r && null != (t = e[r])) return new $9197eb5abb1c09ae$var$u(t.call(e));
                n = "@@asyncIterator", r = "@@iterator";
            }
            throw new TypeError("Object is not async iterable");
        }(e.values()); s = !(c = await d.next()).done; s = !1){
            const o = c.value, s = `${n}/${o.name}`;
            "file" === o.kind ? a.push(o.getFile().then((t)=>(t.directoryHandle = e, t.handle = o, Object.defineProperty(t, "webkitRelativePath", {
                    configurable: !0,
                    enumerable: !0,
                    get: ()=>s
                })))) : "directory" !== o.kind || !t || r && r(o) || i.push($9197eb5abb1c09ae$var$p(o, t, s, r));
        }
    } catch (e) {
        l = !0, o = e;
    } finally{
        try {
            s && null != d.return && await d.return();
        } finally{
            if (l) throw o;
        }
    }
    return [
        ...(await Promise.all(i)).flat(),
        ...await Promise.all(a)
    ];
};
var $9197eb5abb1c09ae$export$aeb41617a6d6e89 = async (e = {})=>{
    e.recursive = e.recursive || !1, e.mode = e.mode || "read";
    const t = await window.showDirectoryPicker({
        id: e.id,
        startIn: e.startIn,
        mode: e.mode
    });
    return (await (await t.values()).next()).done ? [
        t
    ] : $9197eb5abb1c09ae$var$p(t, e.recursive, void 0, e.skipDirectory);
}, $9197eb5abb1c09ae$var$y = {
    __proto__: null,
    default: $9197eb5abb1c09ae$export$aeb41617a6d6e89
}, $9197eb5abb1c09ae$export$ff17ca902e7337af = async (e, t = [
    {}
], n = null, r = !1, i = null)=>{
    Array.isArray(t) || (t = [
        t
    ]), t[0].fileName = t[0].fileName || "Untitled";
    const a = [];
    let o = null;
    if (e instanceof Blob && e.type ? o = e.type : e.headers && e.headers.get("content-type") && (o = e.headers.get("content-type")), t.forEach((e, t)=>{
        a[t] = {
            description: e.description || "Files",
            accept: {}
        }, e.mimeTypes ? (0 === t && o && e.mimeTypes.push(o), e.mimeTypes.map((n)=>{
            a[t].accept[n] = e.extensions || [];
        })) : o ? a[t].accept[o] = e.extensions || [] : a[t].accept["*/*"] = e.extensions || [];
    }), n) try {
        await n.getFile();
    } catch (e) {
        if (n = null, r) throw e;
    }
    const s = n || await window.showSaveFilePicker({
        suggestedName: t[0].fileName,
        id: t[0].id,
        startIn: t[0].startIn,
        types: a,
        excludeAcceptAllOption: t[0].excludeAcceptAllOption || !1
    });
    !n && i && i(s);
    const l = await s.createWritable();
    if ("stream" in e) {
        const t = e.stream();
        return await t.pipeTo(l), s;
    }
    return "body" in e ? (await e.body.pipeTo(l), s) : (await l.write(await e), await l.close(), s);
}, $9197eb5abb1c09ae$var$m = {
    __proto__: null,
    default: $9197eb5abb1c09ae$export$ff17ca902e7337af
}, $9197eb5abb1c09ae$export$f1c676766788056a = async (e = [
    {}
])=>(Array.isArray(e) || (e = [
        e
    ]), new Promise((t, n)=>{
        const r = document.createElement("input");
        r.type = "file";
        const i = [
            ...e.map((e)=>e.mimeTypes || []),
            ...e.map((e)=>e.extensions || [])
        ].join();
        r.multiple = e[0].multiple || !1, r.accept = i || "", r.style.display = "none", document.body.append(r), r.addEventListener("cancel", ()=>{
            r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
        }), r.addEventListener("change", ()=>{
            r.remove(), t(r.multiple ? Array.from(r.files) : r.files[0]);
        }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
    })), $9197eb5abb1c09ae$var$h = {
    __proto__: null,
    default: $9197eb5abb1c09ae$export$f1c676766788056a
}, $9197eb5abb1c09ae$export$14ab45eaad58ab5 = async (e = [
    {}
])=>(Array.isArray(e) || (e = [
        e
    ]), e[0].recursive = e[0].recursive || !1, new Promise((t, n)=>{
        const r = document.createElement("input");
        r.type = "file", r.webkitdirectory = !0, r.style.display = "none", document.body.append(r), r.addEventListener("cancel", ()=>{
            r.remove(), n(new DOMException("The user aborted a request.", "AbortError"));
        }), r.addEventListener("change", ()=>{
            r.remove();
            let n = Array.from(r.files);
            e[0].recursive ? e[0].recursive && e[0].skipDirectory && (n = n.filter((t)=>t.webkitRelativePath.split("/").every((t)=>!e[0].skipDirectory({
                        name: t,
                        kind: "directory"
                    })))) : n = n.filter((e)=>2 === e.webkitRelativePath.split("/").length), t(n);
        }), "showPicker" in HTMLInputElement.prototype ? r.showPicker() : r.click();
    })), $9197eb5abb1c09ae$var$b = {
    __proto__: null,
    default: $9197eb5abb1c09ae$export$14ab45eaad58ab5
}, $9197eb5abb1c09ae$export$19f956f8dbe9df86 = async (e, t = {})=>{
    Array.isArray(t) && (t = t[0]);
    const n = document.createElement("a");
    let r = e;
    "body" in e && (r = await async function(e, t) {
        const n = e.getReader(), r = new ReadableStream({
            start: (e)=>(async function t() {
                    return n.read().then(({ done: n, value: r })=>{
                        if (!n) return e.enqueue(r), t();
                        e.close();
                    });
                })()
        }), i = new Response(r), a = await i.blob();
        return n.releaseLock(), new Blob([
            a
        ], {
            type: t
        });
    }(e.body, e.headers.get("content-type"))), n.download = t.fileName || "Untitled", n.href = URL.createObjectURL(await r);
    const i = ()=>{
        "function" == typeof a && a();
    }, a = t.legacySetup && t.legacySetup(i, ()=>a(), n);
    return n.addEventListener("click", ()=>{
        setTimeout(()=>URL.revokeObjectURL(n.href), 3e4), i();
    }), n.click(), null;
}, $9197eb5abb1c09ae$var$_ = {
    __proto__: null,
    default: $9197eb5abb1c09ae$export$19f956f8dbe9df86
};


function $2e2e793cc84f35c5$var$extend(destination) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) destination[key] = source[key];
    }
    return destination;
}
function $2e2e793cc84f35c5$var$repeat(character, count) {
    return Array(count + 1).join(character);
}
function $2e2e793cc84f35c5$var$trimLeadingNewlines(string) {
    return string.replace(/^\n*/, '');
}
function $2e2e793cc84f35c5$var$trimTrailingNewlines(string) {
    // avoid match-at-end regexp bottleneck, see #370
    var indexEnd = string.length;
    while(indexEnd > 0 && string[indexEnd - 1] === '\n')indexEnd--;
    return string.substring(0, indexEnd);
}
function $2e2e793cc84f35c5$var$trimNewlines(string) {
    return $2e2e793cc84f35c5$var$trimTrailingNewlines($2e2e793cc84f35c5$var$trimLeadingNewlines(string));
}
var $2e2e793cc84f35c5$var$blockElements = [
    'ADDRESS',
    'ARTICLE',
    'ASIDE',
    'AUDIO',
    'BLOCKQUOTE',
    'BODY',
    'CANVAS',
    'CENTER',
    'DD',
    'DIR',
    'DIV',
    'DL',
    'DT',
    'FIELDSET',
    'FIGCAPTION',
    'FIGURE',
    'FOOTER',
    'FORM',
    'FRAMESET',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'HEADER',
    'HGROUP',
    'HR',
    'HTML',
    'ISINDEX',
    'LI',
    'MAIN',
    'MENU',
    'NAV',
    'NOFRAMES',
    'NOSCRIPT',
    'OL',
    'OUTPUT',
    'P',
    'PRE',
    'SECTION',
    'TABLE',
    'TBODY',
    'TD',
    'TFOOT',
    'TH',
    'THEAD',
    'TR',
    'UL'
];
function $2e2e793cc84f35c5$var$isBlock(node) {
    return $2e2e793cc84f35c5$var$is(node, $2e2e793cc84f35c5$var$blockElements);
}
var $2e2e793cc84f35c5$var$voidElements = [
    'AREA',
    'BASE',
    'BR',
    'COL',
    'COMMAND',
    'EMBED',
    'HR',
    'IMG',
    'INPUT',
    'KEYGEN',
    'LINK',
    'META',
    'PARAM',
    'SOURCE',
    'TRACK',
    'WBR'
];
function $2e2e793cc84f35c5$var$isVoid(node) {
    return $2e2e793cc84f35c5$var$is(node, $2e2e793cc84f35c5$var$voidElements);
}
function $2e2e793cc84f35c5$var$hasVoid(node) {
    return $2e2e793cc84f35c5$var$has(node, $2e2e793cc84f35c5$var$voidElements);
}
var $2e2e793cc84f35c5$var$meaningfulWhenBlankElements = [
    'A',
    'TABLE',
    'THEAD',
    'TBODY',
    'TFOOT',
    'TH',
    'TD',
    'IFRAME',
    'SCRIPT',
    'AUDIO',
    'VIDEO'
];
function $2e2e793cc84f35c5$var$isMeaningfulWhenBlank(node) {
    return $2e2e793cc84f35c5$var$is(node, $2e2e793cc84f35c5$var$meaningfulWhenBlankElements);
}
function $2e2e793cc84f35c5$var$hasMeaningfulWhenBlank(node) {
    return $2e2e793cc84f35c5$var$has(node, $2e2e793cc84f35c5$var$meaningfulWhenBlankElements);
}
function $2e2e793cc84f35c5$var$is(node, tagNames) {
    return tagNames.indexOf(node.nodeName) >= 0;
}
function $2e2e793cc84f35c5$var$has(node, tagNames) {
    return node.getElementsByTagName && tagNames.some(function(tagName) {
        return node.getElementsByTagName(tagName).length;
    });
}
var $2e2e793cc84f35c5$var$markdownEscapes = [
    [
        /\\/g,
        '\\\\'
    ],
    [
        /\*/g,
        '\\*'
    ],
    [
        /^-/g,
        '\\-'
    ],
    [
        /^\+ /g,
        '\\+ '
    ],
    [
        /^(=+)/g,
        '\\$1'
    ],
    [
        /^(#{1,6}) /g,
        '\\$1 '
    ],
    [
        /`/g,
        '\\`'
    ],
    [
        /^~~~/g,
        '\\~~~'
    ],
    [
        /\[/g,
        '\\['
    ],
    [
        /\]/g,
        '\\]'
    ],
    [
        /^>/g,
        '\\>'
    ],
    [
        /_/g,
        '\\_'
    ],
    [
        /^(\d+)\. /g,
        '$1\\. '
    ]
];
function $2e2e793cc84f35c5$var$escapeMarkdown(string) {
    return $2e2e793cc84f35c5$var$markdownEscapes.reduce(function(accumulator, escape) {
        return accumulator.replace(escape[0], escape[1]);
    }, string);
}
var $2e2e793cc84f35c5$var$rules = {};
$2e2e793cc84f35c5$var$rules.paragraph = {
    filter: 'p',
    replacement: function(content) {
        return '\n\n' + content + '\n\n';
    }
};
$2e2e793cc84f35c5$var$rules.lineBreak = {
    filter: 'br',
    replacement: function(content, node, options) {
        return options.br + '\n';
    }
};
$2e2e793cc84f35c5$var$rules.heading = {
    filter: [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ],
    replacement: function(content, node, options) {
        var hLevel = Number(node.nodeName.charAt(1));
        if (options.headingStyle === 'setext' && hLevel < 3) {
            var underline = $2e2e793cc84f35c5$var$repeat(hLevel === 1 ? '=' : '-', content.length);
            return '\n\n' + content + '\n' + underline + '\n\n';
        } else return '\n\n' + $2e2e793cc84f35c5$var$repeat('#', hLevel) + ' ' + content + '\n\n';
    }
};
$2e2e793cc84f35c5$var$rules.blockquote = {
    filter: 'blockquote',
    replacement: function(content) {
        content = $2e2e793cc84f35c5$var$trimNewlines(content).replace(/^/gm, '> ');
        return '\n\n' + content + '\n\n';
    }
};
$2e2e793cc84f35c5$var$rules.list = {
    filter: [
        'ul',
        'ol'
    ],
    replacement: function(content, node) {
        var parent = node.parentNode;
        if (parent.nodeName === 'LI' && parent.lastElementChild === node) return '\n' + content;
        else return '\n\n' + content + '\n\n';
    }
};
$2e2e793cc84f35c5$var$rules.listItem = {
    filter: 'li',
    replacement: function(content, node, options) {
        var prefix = options.bulletListMarker + '   ';
        var parent = node.parentNode;
        if (parent.nodeName === 'OL') {
            var start = parent.getAttribute('start');
            var index = Array.prototype.indexOf.call(parent.children, node);
            prefix = (start ? Number(start) + index : index + 1) + '.  ';
        }
        var isParagraph = /\n$/.test(content);
        content = $2e2e793cc84f35c5$var$trimNewlines(content) + (isParagraph ? '\n' : '');
        content = content.replace(/\n/gm, '\n' + ' '.repeat(prefix.length)); // indent
        return prefix + content + (node.nextSibling ? '\n' : '');
    }
};
$2e2e793cc84f35c5$var$rules.indentedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === 'indented' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function(content, node, options) {
        return '\n\n    ' + node.firstChild.textContent.replace(/\n/g, '\n    ') + '\n\n';
    }
};
$2e2e793cc84f35c5$var$rules.fencedCodeBlock = {
    filter: function(node, options) {
        return options.codeBlockStyle === 'fenced' && node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
    },
    replacement: function(content, node, options) {
        var className = node.firstChild.getAttribute('class') || '';
        var language = (className.match(/language-(\S+)/) || [
            null,
            ''
        ])[1];
        var code = node.firstChild.textContent;
        var fenceChar = options.fence.charAt(0);
        var fenceSize = 3;
        var fenceInCodeRegex = new RegExp('^' + fenceChar + '{3,}', 'gm');
        var match;
        while(match = fenceInCodeRegex.exec(code))if (match[0].length >= fenceSize) fenceSize = match[0].length + 1;
        var fence = $2e2e793cc84f35c5$var$repeat(fenceChar, fenceSize);
        return '\n\n' + fence + language + '\n' + code.replace(/\n$/, '') + '\n' + fence + '\n\n';
    }
};
$2e2e793cc84f35c5$var$rules.horizontalRule = {
    filter: 'hr',
    replacement: function(content, node, options) {
        return '\n\n' + options.hr + '\n\n';
    }
};
$2e2e793cc84f35c5$var$rules.inlineLink = {
    filter: function(node, options) {
        return options.linkStyle === 'inlined' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function(content, node) {
        var href = $2e2e793cc84f35c5$var$escapeLinkDestination(node.getAttribute('href'));
        var title = $2e2e793cc84f35c5$var$escapeLinkTitle($2e2e793cc84f35c5$var$cleanAttribute(node.getAttribute('title')));
        var titlePart = title ? ' "' + title + '"' : '';
        return '[' + content + '](' + href + titlePart + ')';
    }
};
$2e2e793cc84f35c5$var$rules.referenceLink = {
    filter: function(node, options) {
        return options.linkStyle === 'referenced' && node.nodeName === 'A' && node.getAttribute('href');
    },
    replacement: function(content, node, options) {
        var href = $2e2e793cc84f35c5$var$escapeLinkDestination(node.getAttribute('href'));
        var title = $2e2e793cc84f35c5$var$cleanAttribute(node.getAttribute('title'));
        if (title) title = ' "' + $2e2e793cc84f35c5$var$escapeLinkTitle(title) + '"';
        var replacement;
        var reference;
        switch(options.linkReferenceStyle){
            case 'collapsed':
                replacement = '[' + content + '][]';
                reference = '[' + content + ']: ' + href + title;
                break;
            case 'shortcut':
                replacement = '[' + content + ']';
                reference = '[' + content + ']: ' + href + title;
                break;
            default:
                var id = this.references.length + 1;
                replacement = '[' + content + '][' + id + ']';
                reference = '[' + id + ']: ' + href + title;
        }
        this.references.push(reference);
        return replacement;
    },
    references: [],
    append: function(options) {
        var references = '';
        if (this.references.length) {
            references = '\n\n' + this.references.join('\n') + '\n\n';
            this.references = []; // Reset references
        }
        return references;
    }
};
$2e2e793cc84f35c5$var$rules.emphasis = {
    filter: [
        'em',
        'i'
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return '';
        return options.emDelimiter + content + options.emDelimiter;
    }
};
$2e2e793cc84f35c5$var$rules.strong = {
    filter: [
        'strong',
        'b'
    ],
    replacement: function(content, node, options) {
        if (!content.trim()) return '';
        return options.strongDelimiter + content + options.strongDelimiter;
    }
};
$2e2e793cc84f35c5$var$rules.code = {
    filter: function(node) {
        var hasSiblings = node.previousSibling || node.nextSibling;
        var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings;
        return node.nodeName === 'CODE' && !isCodeBlock;
    },
    replacement: function(content) {
        if (!content) return '';
        content = content.replace(/\r?\n|\r/g, ' ');
        var extraSpace = /^`|^ .*?[^ ].* $|`$/.test(content) ? ' ' : '';
        var delimiter = '`';
        var matches = content.match(/`+/gm) || [];
        while(matches.indexOf(delimiter) !== -1)delimiter = delimiter + '`';
        return delimiter + extraSpace + content + extraSpace + delimiter;
    }
};
$2e2e793cc84f35c5$var$rules.image = {
    filter: 'img',
    replacement: function(content, node) {
        var alt = $2e2e793cc84f35c5$var$escapeMarkdown($2e2e793cc84f35c5$var$cleanAttribute(node.getAttribute('alt')));
        var src = $2e2e793cc84f35c5$var$escapeLinkDestination(node.getAttribute('src') || '');
        var title = $2e2e793cc84f35c5$var$cleanAttribute(node.getAttribute('title'));
        var titlePart = title ? ' "' + $2e2e793cc84f35c5$var$escapeLinkTitle(title) + '"' : '';
        return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : '';
    }
};
function $2e2e793cc84f35c5$var$cleanAttribute(attribute) {
    return attribute ? attribute.replace(/(\n+\s*)+/g, '\n') : '';
}
function $2e2e793cc84f35c5$var$escapeLinkDestination(destination) {
    var escaped = destination.replace(/([<>()])/g, '\\$1');
    return escaped.indexOf(' ') >= 0 ? '<' + escaped + '>' : escaped;
}
function $2e2e793cc84f35c5$var$escapeLinkTitle(title) {
    return title.replace(/"/g, '\\"');
}
/**
 * Manages a collection of rules used to convert HTML to Markdown
 */ function $2e2e793cc84f35c5$var$Rules(options) {
    this.options = options;
    this._keep = [];
    this._remove = [];
    this.blankRule = {
        replacement: options.blankReplacement
    };
    this.keepReplacement = options.keepReplacement;
    this.defaultRule = {
        replacement: options.defaultReplacement
    };
    this.array = [];
    for(var key in options.rules)this.array.push(options.rules[key]);
}
$2e2e793cc84f35c5$var$Rules.prototype = {
    add: function(key, rule) {
        this.array.unshift(rule);
    },
    keep: function(filter) {
        this._keep.unshift({
            filter: filter,
            replacement: this.keepReplacement
        });
    },
    remove: function(filter) {
        this._remove.unshift({
            filter: filter,
            replacement: function() {
                return '';
            }
        });
    },
    forNode: function(node) {
        if (node.isBlank) return this.blankRule;
        var rule;
        if (rule = $2e2e793cc84f35c5$var$findRule(this.array, node, this.options)) return rule;
        if (rule = $2e2e793cc84f35c5$var$findRule(this._keep, node, this.options)) return rule;
        if (rule = $2e2e793cc84f35c5$var$findRule(this._remove, node, this.options)) return rule;
        return this.defaultRule;
    },
    forEach: function(fn) {
        for(var i = 0; i < this.array.length; i++)fn(this.array[i], i);
    }
};
function $2e2e793cc84f35c5$var$findRule(rules, node, options) {
    for(var i = 0; i < rules.length; i++){
        var rule = rules[i];
        if ($2e2e793cc84f35c5$var$filterValue(rule, node, options)) return rule;
    }
    return undefined;
}
function $2e2e793cc84f35c5$var$filterValue(rule, node, options) {
    var filter = rule.filter;
    if (typeof filter === 'string') {
        if (filter === node.nodeName.toLowerCase()) return true;
    } else if (Array.isArray(filter)) {
        if (filter.indexOf(node.nodeName.toLowerCase()) > -1) return true;
    } else if (typeof filter === 'function') {
        if (filter.call(rule, node, options)) return true;
    } else throw new TypeError('`filter` needs to be a string, array, or function');
}
/**
 * The collapseWhitespace function is adapted from collapse-whitespace
 * by Luc Thevenard.
 *
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Luc Thevenard <lucthevenard@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * collapseWhitespace(options) removes extraneous whitespace from an the given element.
 *
 * @param {Object} options
 */ function $2e2e793cc84f35c5$var$collapseWhitespace(options) {
    var element = options.element;
    var isBlock = options.isBlock;
    var isVoid = options.isVoid;
    var isPre = options.isPre || function(node) {
        return node.nodeName === 'PRE';
    };
    if (!element.firstChild || isPre(element)) return;
    var prevText = null;
    var keepLeadingWs = false;
    var prev = null;
    var node = $2e2e793cc84f35c5$var$next(prev, element, isPre);
    while(node !== element){
        if (node.nodeType === 3 || node.nodeType === 4) {
            // Node.TEXT_NODE or Node.CDATA_SECTION_NODE
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !keepLeadingWs && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $2e2e793cc84f35c5$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            // Node.ELEMENT_NODE
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                keepLeadingWs = false;
            } else if (isVoid(node) || isPre(node)) {
                // Avoid trimming space around non-block, non-BR void elements and inline PRE.
                prevText = null;
                keepLeadingWs = true;
            } else if (prevText) // Drop protection if set previously.
            keepLeadingWs = false;
        } else {
            node = $2e2e793cc84f35c5$var$remove(node);
            continue;
        }
        var nextNode = $2e2e793cc84f35c5$var$next(prev, node, isPre);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $2e2e793cc84f35c5$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $2e2e793cc84f35c5$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current, isPre) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @param {Function} isPre
 * @return {Node}
 */ function $2e2e793cc84f35c5$var$next(prev, current, isPre) {
    if (prev && prev.parentNode === current || isPre(current)) return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
/*
 * Set up window for Node.js
 */ var $2e2e793cc84f35c5$var$root = typeof window !== 'undefined' ? window : {};
/*
 * Parsing HTML strings
 */ function $2e2e793cc84f35c5$var$canParseHTMLNatively() {
    var Parser = $2e2e793cc84f35c5$var$root.DOMParser;
    var canParse = false;
    // Adapted from https://gist.github.com/1129031
    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new Parser().parseFromString('', 'text/html')) canParse = true;
    } catch (e) {}
    return canParse;
}
function $2e2e793cc84f35c5$var$createHTMLParser() {
    var Parser = function() {};
    if ($2e2e793cc84f35c5$var$shouldUseActiveX()) Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject('htmlfile');
        doc.designMode = 'on'; // disable on-page scripts
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    else Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument('');
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    return Parser;
}
function $2e2e793cc84f35c5$var$shouldUseActiveX() {
    var useActiveX = false;
    try {
        document.implementation.createHTMLDocument('').open();
    } catch (e) {
        if ($2e2e793cc84f35c5$var$root.ActiveXObject) useActiveX = true;
    }
    return useActiveX;
}
var $2e2e793cc84f35c5$var$HTMLParser = $2e2e793cc84f35c5$var$canParseHTMLNatively() ? $2e2e793cc84f35c5$var$root.DOMParser : $2e2e793cc84f35c5$var$createHTMLParser();
function $2e2e793cc84f35c5$var$RootNode(input, options) {
    var root;
    if (typeof input === 'string') {
        var doc = $2e2e793cc84f35c5$var$htmlParser().parseFromString(// DOM parsers arrange elements in the <head> and <body>.
        // Wrapping in a custom element ensures elements are reliably arranged in
        // a single element.
        '<x-turndown id="turndown-root">' + input + '</x-turndown>', 'text/html');
        root = doc.getElementById('turndown-root');
    } else root = input.cloneNode(true);
    $2e2e793cc84f35c5$var$collapseWhitespace({
        element: root,
        isBlock: $2e2e793cc84f35c5$var$isBlock,
        isVoid: $2e2e793cc84f35c5$var$isVoid,
        isPre: options.preformattedCode ? $2e2e793cc84f35c5$var$isPreOrCode : null
    });
    return root;
}
var $2e2e793cc84f35c5$var$_htmlParser;
function $2e2e793cc84f35c5$var$htmlParser() {
    $2e2e793cc84f35c5$var$_htmlParser = $2e2e793cc84f35c5$var$_htmlParser || new $2e2e793cc84f35c5$var$HTMLParser();
    return $2e2e793cc84f35c5$var$_htmlParser;
}
function $2e2e793cc84f35c5$var$isPreOrCode(node) {
    return node.nodeName === 'PRE' || node.nodeName === 'CODE';
}
function $2e2e793cc84f35c5$var$Node(node, options) {
    node.isBlock = $2e2e793cc84f35c5$var$isBlock(node);
    node.isCode = node.nodeName === 'CODE' || node.parentNode.isCode;
    node.isBlank = $2e2e793cc84f35c5$var$isBlank(node);
    node.flankingWhitespace = $2e2e793cc84f35c5$var$flankingWhitespace(node, options);
    return node;
}
function $2e2e793cc84f35c5$var$isBlank(node) {
    return !$2e2e793cc84f35c5$var$isVoid(node) && !$2e2e793cc84f35c5$var$isMeaningfulWhenBlank(node) && /^\s*$/i.test(node.textContent) && !$2e2e793cc84f35c5$var$hasVoid(node) && !$2e2e793cc84f35c5$var$hasMeaningfulWhenBlank(node);
}
function $2e2e793cc84f35c5$var$flankingWhitespace(node, options) {
    if (node.isBlock || options.preformattedCode && node.isCode) return {
        leading: '',
        trailing: ''
    };
    var edges = $2e2e793cc84f35c5$var$edgeWhitespace(node.textContent);
    // abandon leading ASCII WS if left-flanked by ASCII WS
    if (edges.leadingAscii && $2e2e793cc84f35c5$var$isFlankedByWhitespace('left', node, options)) edges.leading = edges.leadingNonAscii;
    // abandon trailing ASCII WS if right-flanked by ASCII WS
    if (edges.trailingAscii && $2e2e793cc84f35c5$var$isFlankedByWhitespace('right', node, options)) edges.trailing = edges.trailingNonAscii;
    return {
        leading: edges.leading,
        trailing: edges.trailing
    };
}
function $2e2e793cc84f35c5$var$edgeWhitespace(string) {
    var m = string.match(/^(([ \t\r\n]*)(\s*))(?:(?=\S)[\s\S]*\S)?((\s*?)([ \t\r\n]*))$/);
    return {
        leading: m[1],
        // whole string for whitespace-only strings
        leadingAscii: m[2],
        leadingNonAscii: m[3],
        trailing: m[4],
        // empty for whitespace-only strings
        trailingNonAscii: m[5],
        trailingAscii: m[6]
    };
}
function $2e2e793cc84f35c5$var$isFlankedByWhitespace(side, node, options) {
    var sibling;
    var regExp;
    var isFlanked;
    if (side === 'left') {
        sibling = node.previousSibling;
        regExp = / $/;
    } else {
        sibling = node.nextSibling;
        regExp = /^ /;
    }
    if (sibling) {
        if (sibling.nodeType === 3) isFlanked = regExp.test(sibling.nodeValue);
        else if (options.preformattedCode && sibling.nodeName === 'CODE') isFlanked = false;
        else if (sibling.nodeType === 1 && !$2e2e793cc84f35c5$var$isBlock(sibling)) isFlanked = regExp.test(sibling.textContent);
    }
    return isFlanked;
}
var $2e2e793cc84f35c5$var$reduce = Array.prototype.reduce;
function $2e2e793cc84f35c5$export$2e2bcd8739ae039(options) {
    if (!(this instanceof $2e2e793cc84f35c5$export$2e2bcd8739ae039)) return new $2e2e793cc84f35c5$export$2e2bcd8739ae039(options);
    var defaults = {
        rules: $2e2e793cc84f35c5$var$rules,
        headingStyle: 'setext',
        hr: '* * *',
        bulletListMarker: '*',
        codeBlockStyle: 'indented',
        fence: '```',
        emDelimiter: '_',
        strongDelimiter: '**',
        linkStyle: 'inlined',
        linkReferenceStyle: 'full',
        br: '  ',
        preformattedCode: false,
        blankReplacement: function(content, node) {
            return node.isBlock ? '\n\n' : '';
        },
        keepReplacement: function(content, node) {
            return node.isBlock ? '\n\n' + node.outerHTML + '\n\n' : node.outerHTML;
        },
        defaultReplacement: function(content, node) {
            return node.isBlock ? '\n\n' + content + '\n\n' : content;
        }
    };
    this.options = $2e2e793cc84f35c5$var$extend({}, defaults, options);
    this.rules = new $2e2e793cc84f35c5$var$Rules(this.options);
}
$2e2e793cc84f35c5$export$2e2bcd8739ae039.prototype = {
    /**
   * The entry point for converting a string or DOM node to Markdown
   * @public
   * @param {String|HTMLElement} input The string or DOM node to convert
   * @returns A Markdown representation of the input
   * @type String
   */ turndown: function(input) {
        if (!$2e2e793cc84f35c5$var$canConvert(input)) throw new TypeError(input + ' is not a string, or an element/document/fragment node.');
        if (input === '') return '';
        var output = $2e2e793cc84f35c5$var$process.call(this, new $2e2e793cc84f35c5$var$RootNode(input, this.options));
        return $2e2e793cc84f35c5$var$postProcess.call(this, output);
    },
    /**
   * Add one or more plugins
   * @public
   * @param {Function|Array} plugin The plugin or array of plugins to add
   * @returns The Turndown instance for chaining
   * @type Object
   */ use: function(plugin) {
        if (Array.isArray(plugin)) for(var i = 0; i < plugin.length; i++)this.use(plugin[i]);
        else if (typeof plugin === 'function') plugin(this);
        else throw new TypeError('plugin must be a Function or an Array of Functions');
        return this;
    },
    /**
   * Adds a rule
   * @public
   * @param {String} key The unique key of the rule
   * @param {Object} rule The rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ addRule: function(key, rule) {
        this.rules.add(key, rule);
        return this;
    },
    /**
   * Keep a node (as HTML) that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ keep: function(filter) {
        this.rules.keep(filter);
        return this;
    },
    /**
   * Remove a node that matches the filter
   * @public
   * @param {String|Array|Function} filter The unique key of the rule
   * @returns The Turndown instance for chaining
   * @type Object
   */ remove: function(filter) {
        this.rules.remove(filter);
        return this;
    },
    /**
   * Escapes Markdown syntax
   * @public
   * @param {String} string The string to escape
   * @returns A string with Markdown syntax escaped
   * @type String
   */ escape: function(string) {
        return $2e2e793cc84f35c5$var$escapeMarkdown(string);
    }
};
/**
 * Reduces a DOM node down to its Markdown string equivalent
 * @private
 * @param {HTMLElement} parentNode The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $2e2e793cc84f35c5$var$process(parentNode) {
    var self = this;
    return $2e2e793cc84f35c5$var$reduce.call(parentNode.childNodes, function(output, node) {
        node = new $2e2e793cc84f35c5$var$Node(node, self.options);
        var replacement = '';
        if (node.nodeType === 3) replacement = node.isCode ? node.nodeValue : self.escape(node.nodeValue);
        else if (node.nodeType === 1) replacement = $2e2e793cc84f35c5$var$replacementForNode.call(self, node);
        return $2e2e793cc84f35c5$var$join(output, replacement);
    }, '');
}
/**
 * Appends strings as each rule requires and trims the output
 * @private
 * @param {String} output The conversion output
 * @returns A trimmed version of the ouput
 * @type String
 */ function $2e2e793cc84f35c5$var$postProcess(output) {
    var self = this;
    this.rules.forEach(function(rule) {
        if (typeof rule.append === 'function') output = $2e2e793cc84f35c5$var$join(output, rule.append(self.options));
    });
    return output.replace(/^[\t\r\n]+/, '').replace(/[\t\r\n\s]+$/, '');
}
/**
 * Converts an element node to its Markdown equivalent
 * @private
 * @param {HTMLElement} node The node to convert
 * @returns A Markdown representation of the node
 * @type String
 */ function $2e2e793cc84f35c5$var$replacementForNode(node) {
    var rule = this.rules.forNode(node);
    var content = $2e2e793cc84f35c5$var$process.call(this, node);
    var whitespace = node.flankingWhitespace;
    if (whitespace.leading || whitespace.trailing) content = content.trim();
    return whitespace.leading + rule.replacement(content, node, this.options) + whitespace.trailing;
}
/**
 * Joins replacement to the current output with appropriate number of new lines
 * @private
 * @param {String} output The current conversion output
 * @param {String} replacement The string to append to the output
 * @returns Joined output
 * @type String
 */ function $2e2e793cc84f35c5$var$join(output, replacement) {
    var s1 = $2e2e793cc84f35c5$var$trimTrailingNewlines(output);
    var s2 = $2e2e793cc84f35c5$var$trimLeadingNewlines(replacement);
    var nls = Math.max(output.length - s1.length, replacement.length - s2.length);
    var separator = '\n\n'.substring(0, nls);
    return s1 + separator + s2;
}
/**
 * Determines whether an input can be converted
 * @private
 * @param {String|HTMLElement} input Describe this parameter
 * @returns Describe what it returns
 * @type String|Object|Array|Boolean|Number
 */ function $2e2e793cc84f35c5$var$canConvert(input) {
    return input != null && (typeof input === 'string' || input.nodeType && (input.nodeType === 1 || input.nodeType === 9 || input.nodeType === 11));
}


var $39f19696fbebc560$var$highlightRegExp = /highlight-(?:text|source)-([a-z0-9]+)/;
function $39f19696fbebc560$export$c359330ed80b1889(turndownService) {
    turndownService.addRule('highlightedCodeBlock', {
        filter: function(node) {
            var firstChild = node.firstChild;
            return node.nodeName === 'DIV' && $39f19696fbebc560$var$highlightRegExp.test(node.className) && firstChild && firstChild.nodeName === 'PRE';
        },
        replacement: function(content, node, options) {
            var className = node.className || '';
            var language = (className.match($39f19696fbebc560$var$highlightRegExp) || [
                null,
                ''
            ])[1];
            return '\n\n' + options.fence + language + '\n' + node.firstChild.textContent + '\n' + options.fence + '\n\n';
        }
    });
}
function $39f19696fbebc560$export$19426ff118fe8be(turndownService) {
    turndownService.addRule('strikethrough', {
        filter: [
            'del',
            's',
            'strike'
        ],
        replacement: function(content) {
            return '~' + content + '~';
        }
    });
}
var $39f19696fbebc560$var$indexOf = Array.prototype.indexOf;
var $39f19696fbebc560$var$every = Array.prototype.every;
var $39f19696fbebc560$var$rules = {};
$39f19696fbebc560$var$rules.tableCell = {
    filter: [
        'th',
        'td'
    ],
    replacement: function(content, node) {
        return $39f19696fbebc560$var$cell(content, node);
    }
};
$39f19696fbebc560$var$rules.tableRow = {
    filter: 'tr',
    replacement: function(content, node) {
        var borderCells = '';
        var alignMap = {
            left: ':--',
            right: '--:',
            center: ':-:'
        };
        if ($39f19696fbebc560$var$isHeadingRow(node)) for(var i = 0; i < node.childNodes.length; i++){
            var border = '---';
            var align = (node.childNodes[i].getAttribute('align') || '').toLowerCase();
            if (align) border = alignMap[align] || border;
            borderCells += $39f19696fbebc560$var$cell(border, node.childNodes[i]);
        }
        return '\n' + content + (borderCells ? '\n' + borderCells : '');
    }
};
$39f19696fbebc560$var$rules.table = {
    // Only convert tables with a heading row.
    // Tables with no heading row are kept using `keep` (see below).
    filter: function(node) {
        return node.nodeName === 'TABLE' && $39f19696fbebc560$var$isHeadingRow(node.rows[0]);
    },
    replacement: function(content) {
        // Ensure there are no blank lines
        content = content.replace('\n\n', '\n');
        return '\n\n' + content + '\n\n';
    }
};
$39f19696fbebc560$var$rules.tableSection = {
    filter: [
        'thead',
        'tbody',
        'tfoot'
    ],
    replacement: function(content) {
        return content;
    }
};
// A tr is a heading row if:
// - the parent is a THEAD
// - or if its the first child of the TABLE or the first TBODY (possibly
//   following a blank THEAD)
// - and every cell is a TH
function $39f19696fbebc560$var$isHeadingRow(tr) {
    var parentNode = tr.parentNode;
    return parentNode.nodeName === 'THEAD' || parentNode.firstChild === tr && (parentNode.nodeName === 'TABLE' || $39f19696fbebc560$var$isFirstTbody(parentNode)) && $39f19696fbebc560$var$every.call(tr.childNodes, function(n) {
        return n.nodeName === 'TH';
    });
}
function $39f19696fbebc560$var$isFirstTbody(element) {
    var previousSibling = element.previousSibling;
    return element.nodeName === 'TBODY' && (!previousSibling || previousSibling.nodeName === 'THEAD' && /^\s*$/i.test(previousSibling.textContent));
}
function $39f19696fbebc560$var$cell(content, node) {
    var index = $39f19696fbebc560$var$indexOf.call(node.parentNode.childNodes, node);
    var prefix = ' ';
    if (index === 0) prefix = '| ';
    return prefix + content + ' |';
}
function $39f19696fbebc560$export$cc4ff83fc7bd256e(turndownService) {
    turndownService.keep(function(node) {
        return node.nodeName === 'TABLE' && !$39f19696fbebc560$var$isHeadingRow(node.rows[0]);
    });
    for(var key in $39f19696fbebc560$var$rules)turndownService.addRule(key, $39f19696fbebc560$var$rules[key]);
}
function $39f19696fbebc560$export$1f0c2747e2ba0b8d(turndownService) {
    turndownService.addRule('taskListItems', {
        filter: function(node) {
            return node.type === 'checkbox' && node.parentNode.nodeName === 'LI';
        },
        replacement: function(content, node) {
            return (node.checked ? '[x]' : '[ ]') + ' ';
        }
    });
}
function $39f19696fbebc560$export$59ffe8c4d7a4aab2(turndownService) {
    turndownService.use([
        $39f19696fbebc560$export$c359330ed80b1889,
        $39f19696fbebc560$export$19426ff118fe8be,
        $39f19696fbebc560$export$cc4ff83fc7bd256e,
        $39f19696fbebc560$export$1f0c2747e2ba0b8d
    ]);
}



var $iob0w = parcelRequire("iob0w");
/**
 * marked v15.0.12 - a markdown parser
 * Copyright (c) 2011-2025, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ // src/defaults.ts
function $7b384be9e21c489d$export$212bb2fc580a90a8() {
    return {
        async: false,
        breaks: false,
        extensions: null,
        gfm: true,
        hooks: null,
        pedantic: false,
        renderer: null,
        silent: false,
        tokenizer: null,
        walkTokens: null
    };
}
var $7b384be9e21c489d$export$ebe90cb607ad99e = $7b384be9e21c489d$export$212bb2fc580a90a8();
function $7b384be9e21c489d$var$changeDefaults(newDefaults) {
    $7b384be9e21c489d$export$ebe90cb607ad99e = newDefaults;
}
// src/rules.ts
var $7b384be9e21c489d$var$noopTest = {
    exec: ()=>null
};
function $7b384be9e21c489d$var$edit(regex, opt = "") {
    let source = typeof regex === "string" ? regex : regex.source;
    const obj = {
        replace: (name, val)=>{
            let valSource = typeof val === "string" ? val : val.source;
            valSource = valSource.replace($7b384be9e21c489d$var$other.caret, "$1");
            source = source.replace(name, valSource);
            return obj;
        },
        getRegex: ()=>{
            return new RegExp(source, opt);
        }
    };
    return obj;
}
var $7b384be9e21c489d$var$other = {
    codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
    outputLinkReplace: /\\([\[\]])/g,
    indentCodeCompensation: /^(\s+)(?:```)/,
    beginningSpace: /^\s+/,
    endingHash: /#$/,
    startingSpaceChar: /^ /,
    endingSpaceChar: / $/,
    nonSpaceChar: /[^ ]/,
    newLineCharGlobal: /\n/g,
    tabCharGlobal: /\t/g,
    multipleSpaceGlobal: /\s+/g,
    blankLine: /^[ \t]*$/,
    doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
    blockquoteStart: /^ {0,3}>/,
    blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
    blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
    listReplaceTabs: /^\t+/,
    listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
    listIsTask: /^\[[ xX]\] /,
    listReplaceTask: /^\[[ xX]\] +/,
    anyLine: /\n.*\n/,
    hrefBrackets: /^<(.*)>$/,
    tableDelimiter: /[:|]/,
    tableAlignChars: /^\||\| *$/g,
    tableRowBlankLine: /\n[ \t]*$/,
    tableAlignRight: /^ *-+: *$/,
    tableAlignCenter: /^ *:-+: *$/,
    tableAlignLeft: /^ *:-+ *$/,
    startATag: /^<a /i,
    endATag: /^<\/a>/i,
    startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
    endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
    startAngleBracket: /^</,
    endAngleBracket: />$/,
    pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
    unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
    escapeTest: /[&<>"']/,
    escapeReplace: /[&<>"']/g,
    escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
    escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
    unescapeTest: /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig,
    caret: /(^|[^\[])\^/g,
    percentDecode: /%25/g,
    findPipe: /\|/g,
    splitPipe: / \|/,
    slashPipe: /\\\|/g,
    carriageReturn: /\r\n|\r/g,
    spaceLine: /^ +$/gm,
    notSpaceStart: /^\S*/,
    endingNewline: /\n$/,
    listItemRegex: (bull)=>new RegExp(`^( {0,3}${bull})((?:[	 ][^\\n]*)?(?:\\n|$))`),
    nextBulletRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
    hrRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
    fencesBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}(?:\`\`\`|~~~)`),
    headingBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}#`),
    htmlBeginRegex: (indent)=>new RegExp(`^ {0,${Math.min(3, indent - 1)}}<(?:[a-z].*>|!--)`, "i")
};
var $7b384be9e21c489d$var$newline = /^(?:[ \t]*(?:\n|$))+/;
var $7b384be9e21c489d$var$blockCode = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/;
var $7b384be9e21c489d$var$fences = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/;
var $7b384be9e21c489d$var$hr = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/;
var $7b384be9e21c489d$var$heading = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/;
var $7b384be9e21c489d$var$bullet = /(?:[*+-]|\d{1,9}[.)])/;
var $7b384be9e21c489d$var$lheadingCore = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/;
var $7b384be9e21c489d$var$lheading = $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$lheadingCore).replace(/bull/g, $7b384be9e21c489d$var$bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex();
var $7b384be9e21c489d$var$lheadingGfm = $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$lheadingCore).replace(/bull/g, $7b384be9e21c489d$var$bullet).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex();
var $7b384be9e21c489d$var$_paragraph = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/;
var $7b384be9e21c489d$var$blockText = /^[^\n]+/;
var $7b384be9e21c489d$var$_blockLabel = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
var $7b384be9e21c489d$var$def = $7b384be9e21c489d$var$edit(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", $7b384be9e21c489d$var$_blockLabel).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex();
var $7b384be9e21c489d$var$list = $7b384be9e21c489d$var$edit(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, $7b384be9e21c489d$var$bullet).getRegex();
var $7b384be9e21c489d$var$_tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
var $7b384be9e21c489d$var$_comment = /<!--(?:-?>|[\s\S]*?(?:-->|$))/;
var $7b384be9e21c489d$var$html = $7b384be9e21c489d$var$edit("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", $7b384be9e21c489d$var$_comment).replace("tag", $7b384be9e21c489d$var$_tag).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
var $7b384be9e21c489d$var$paragraph = $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$_paragraph).replace("hr", $7b384be9e21c489d$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $7b384be9e21c489d$var$_tag).getRegex();
var $7b384be9e21c489d$var$blockquote = $7b384be9e21c489d$var$edit(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", $7b384be9e21c489d$var$paragraph).getRegex();
var $7b384be9e21c489d$var$blockNormal = {
    blockquote: $7b384be9e21c489d$var$blockquote,
    code: $7b384be9e21c489d$var$blockCode,
    def: $7b384be9e21c489d$var$def,
    fences: $7b384be9e21c489d$var$fences,
    heading: $7b384be9e21c489d$var$heading,
    hr: $7b384be9e21c489d$var$hr,
    html: $7b384be9e21c489d$var$html,
    lheading: $7b384be9e21c489d$var$lheading,
    list: $7b384be9e21c489d$var$list,
    newline: $7b384be9e21c489d$var$newline,
    paragraph: $7b384be9e21c489d$var$paragraph,
    table: $7b384be9e21c489d$var$noopTest,
    text: $7b384be9e21c489d$var$blockText
};
var $7b384be9e21c489d$var$gfmTable = $7b384be9e21c489d$var$edit("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", $7b384be9e21c489d$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $7b384be9e21c489d$var$_tag).getRegex();
var $7b384be9e21c489d$var$blockGfm = {
    ...$7b384be9e21c489d$var$blockNormal,
    lheading: $7b384be9e21c489d$var$lheadingGfm,
    table: $7b384be9e21c489d$var$gfmTable,
    paragraph: $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$_paragraph).replace("hr", $7b384be9e21c489d$var$hr).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", $7b384be9e21c489d$var$gfmTable).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", $7b384be9e21c489d$var$_tag).getRegex()
};
var $7b384be9e21c489d$var$blockPedantic = {
    ...$7b384be9e21c489d$var$blockNormal,
    html: $7b384be9e21c489d$var$edit(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", $7b384be9e21c489d$var$_comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: $7b384be9e21c489d$var$noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$_paragraph).replace("hr", $7b384be9e21c489d$var$hr).replace("heading", " *#{1,6} *[^\n]").replace("lheading", $7b384be9e21c489d$var$lheading).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
};
var $7b384be9e21c489d$var$escape = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/;
var $7b384be9e21c489d$var$inlineCode = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/;
var $7b384be9e21c489d$var$br = /^( {2,}|\\)\n(?!\s*$)/;
var $7b384be9e21c489d$var$inlineText = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/;
var $7b384be9e21c489d$var$_punctuation = /[\p{P}\p{S}]/u;
var $7b384be9e21c489d$var$_punctuationOrSpace = /[\s\p{P}\p{S}]/u;
var $7b384be9e21c489d$var$_notPunctuationOrSpace = /[^\s\p{P}\p{S}]/u;
var $7b384be9e21c489d$var$punctuation = $7b384be9e21c489d$var$edit(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, $7b384be9e21c489d$var$_punctuationOrSpace).getRegex();
var $7b384be9e21c489d$var$_punctuationGfmStrongEm = /(?!~)[\p{P}\p{S}]/u;
var $7b384be9e21c489d$var$_punctuationOrSpaceGfmStrongEm = /(?!~)[\s\p{P}\p{S}]/u;
var $7b384be9e21c489d$var$_notPunctuationOrSpaceGfmStrongEm = /(?:[^\s\p{P}\p{S}]|~)/u;
var $7b384be9e21c489d$var$blockSkip = /\[[^[\]]*?\]\((?:\\.|[^\\\(\)]|\((?:\\.|[^\\\(\)])*\))*\)|`[^`]*?`|<[^<>]*?>/g;
var $7b384be9e21c489d$var$emStrongLDelimCore = /^(?:\*+(?:((?!\*)punct)|[^\s*]))|^_+(?:((?!_)punct)|([^\s_]))/;
var $7b384be9e21c489d$var$emStrongLDelim = $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$emStrongLDelimCore, "u").replace(/punct/g, $7b384be9e21c489d$var$_punctuation).getRegex();
var $7b384be9e21c489d$var$emStrongLDelimGfm = $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$emStrongLDelimCore, "u").replace(/punct/g, $7b384be9e21c489d$var$_punctuationGfmStrongEm).getRegex();
var $7b384be9e21c489d$var$emStrongRDelimAstCore = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)";
var $7b384be9e21c489d$var$emStrongRDelimAst = $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, $7b384be9e21c489d$var$_notPunctuationOrSpace).replace(/punctSpace/g, $7b384be9e21c489d$var$_punctuationOrSpace).replace(/punct/g, $7b384be9e21c489d$var$_punctuation).getRegex();
var $7b384be9e21c489d$var$emStrongRDelimAstGfm = $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$emStrongRDelimAstCore, "gu").replace(/notPunctSpace/g, $7b384be9e21c489d$var$_notPunctuationOrSpaceGfmStrongEm).replace(/punctSpace/g, $7b384be9e21c489d$var$_punctuationOrSpaceGfmStrongEm).replace(/punct/g, $7b384be9e21c489d$var$_punctuationGfmStrongEm).getRegex();
var $7b384be9e21c489d$var$emStrongRDelimUnd = $7b384be9e21c489d$var$edit("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, $7b384be9e21c489d$var$_notPunctuationOrSpace).replace(/punctSpace/g, $7b384be9e21c489d$var$_punctuationOrSpace).replace(/punct/g, $7b384be9e21c489d$var$_punctuation).getRegex();
var $7b384be9e21c489d$var$anyPunctuation = $7b384be9e21c489d$var$edit(/\\(punct)/, "gu").replace(/punct/g, $7b384be9e21c489d$var$_punctuation).getRegex();
var $7b384be9e21c489d$var$autolink = $7b384be9e21c489d$var$edit(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex();
var $7b384be9e21c489d$var$_inlineComment = $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$_comment).replace("(?:-->|$)", "-->").getRegex();
var $7b384be9e21c489d$var$tag = $7b384be9e21c489d$var$edit("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", $7b384be9e21c489d$var$_inlineComment).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex();
var $7b384be9e21c489d$var$_inlineLabel = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
var $7b384be9e21c489d$var$link = $7b384be9e21c489d$var$edit(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]*(?:\n[ \t]*)?)(title))?\s*\)/).replace("label", $7b384be9e21c489d$var$_inlineLabel).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex();
var $7b384be9e21c489d$var$reflink = $7b384be9e21c489d$var$edit(/^!?\[(label)\]\[(ref)\]/).replace("label", $7b384be9e21c489d$var$_inlineLabel).replace("ref", $7b384be9e21c489d$var$_blockLabel).getRegex();
var $7b384be9e21c489d$var$nolink = $7b384be9e21c489d$var$edit(/^!?\[(ref)\](?:\[\])?/).replace("ref", $7b384be9e21c489d$var$_blockLabel).getRegex();
var $7b384be9e21c489d$var$reflinkSearch = $7b384be9e21c489d$var$edit("reflink|nolink(?!\\()", "g").replace("reflink", $7b384be9e21c489d$var$reflink).replace("nolink", $7b384be9e21c489d$var$nolink).getRegex();
var $7b384be9e21c489d$var$inlineNormal = {
    _backpedal: $7b384be9e21c489d$var$noopTest,
    anyPunctuation: // only used for GFM url
    $7b384be9e21c489d$var$anyPunctuation,
    autolink: $7b384be9e21c489d$var$autolink,
    blockSkip: $7b384be9e21c489d$var$blockSkip,
    br: $7b384be9e21c489d$var$br,
    code: $7b384be9e21c489d$var$inlineCode,
    del: $7b384be9e21c489d$var$noopTest,
    emStrongLDelim: $7b384be9e21c489d$var$emStrongLDelim,
    emStrongRDelimAst: $7b384be9e21c489d$var$emStrongRDelimAst,
    emStrongRDelimUnd: $7b384be9e21c489d$var$emStrongRDelimUnd,
    escape: $7b384be9e21c489d$var$escape,
    link: $7b384be9e21c489d$var$link,
    nolink: $7b384be9e21c489d$var$nolink,
    punctuation: $7b384be9e21c489d$var$punctuation,
    reflink: $7b384be9e21c489d$var$reflink,
    reflinkSearch: $7b384be9e21c489d$var$reflinkSearch,
    tag: $7b384be9e21c489d$var$tag,
    text: $7b384be9e21c489d$var$inlineText,
    url: $7b384be9e21c489d$var$noopTest
};
var $7b384be9e21c489d$var$inlinePedantic = {
    ...$7b384be9e21c489d$var$inlineNormal,
    link: $7b384be9e21c489d$var$edit(/^!?\[(label)\]\((.*?)\)/).replace("label", $7b384be9e21c489d$var$_inlineLabel).getRegex(),
    reflink: $7b384be9e21c489d$var$edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", $7b384be9e21c489d$var$_inlineLabel).getRegex()
};
var $7b384be9e21c489d$var$inlineGfm = {
    ...$7b384be9e21c489d$var$inlineNormal,
    emStrongRDelimAst: $7b384be9e21c489d$var$emStrongRDelimAstGfm,
    emStrongLDelim: $7b384be9e21c489d$var$emStrongLDelimGfm,
    url: $7b384be9e21c489d$var$edit(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])((?:\\.|[^\\])*?(?:\\.|[^\s~\\]))\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
};
var $7b384be9e21c489d$var$inlineBreaks = {
    ...$7b384be9e21c489d$var$inlineGfm,
    br: $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$br).replace("{2,}", "*").getRegex(),
    text: $7b384be9e21c489d$var$edit($7b384be9e21c489d$var$inlineGfm.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
};
var $7b384be9e21c489d$var$block = {
    normal: $7b384be9e21c489d$var$blockNormal,
    gfm: $7b384be9e21c489d$var$blockGfm,
    pedantic: $7b384be9e21c489d$var$blockPedantic
};
var $7b384be9e21c489d$var$inline = {
    normal: $7b384be9e21c489d$var$inlineNormal,
    gfm: $7b384be9e21c489d$var$inlineGfm,
    breaks: $7b384be9e21c489d$var$inlineBreaks,
    pedantic: $7b384be9e21c489d$var$inlinePedantic
};
// src/helpers.ts
var $7b384be9e21c489d$var$escapeReplacements = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
var $7b384be9e21c489d$var$getEscapeReplacement = (ch)=>$7b384be9e21c489d$var$escapeReplacements[ch];
function $7b384be9e21c489d$var$escape2(html2, encode) {
    if (encode) {
        if ($7b384be9e21c489d$var$other.escapeTest.test(html2)) return html2.replace($7b384be9e21c489d$var$other.escapeReplace, $7b384be9e21c489d$var$getEscapeReplacement);
    } else {
        if ($7b384be9e21c489d$var$other.escapeTestNoEncode.test(html2)) return html2.replace($7b384be9e21c489d$var$other.escapeReplaceNoEncode, $7b384be9e21c489d$var$getEscapeReplacement);
    }
    return html2;
}
function $7b384be9e21c489d$var$cleanUrl(href) {
    try {
        href = encodeURI(href).replace($7b384be9e21c489d$var$other.percentDecode, "%");
    } catch  {
        return null;
    }
    return href;
}
function $7b384be9e21c489d$var$splitCells(tableRow, count) {
    const row = tableRow.replace($7b384be9e21c489d$var$other.findPipe, (match, offset, str)=>{
        let escaped = false;
        let curr = offset;
        while(--curr >= 0 && str[curr] === "\\")escaped = !escaped;
        if (escaped) return "|";
        else return " |";
    }), cells = row.split($7b384be9e21c489d$var$other.splitPipe);
    let i = 0;
    if (!cells[0].trim()) cells.shift();
    if (cells.length > 0 && !cells.at(-1)?.trim()) cells.pop();
    if (count) {
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push("");
    }
    for(; i < cells.length; i++)cells[i] = cells[i].trim().replace($7b384be9e21c489d$var$other.slashPipe, "|");
    return cells;
}
function $7b384be9e21c489d$var$rtrim(str, c, invert) {
    const l = str.length;
    if (l === 0) return "";
    let suffLen = 0;
    while(suffLen < l){
        const currChar = str.charAt(l - suffLen - 1);
        if (currChar === c && !invert) suffLen++;
        else if (currChar !== c && invert) suffLen++;
        else break;
    }
    return str.slice(0, l - suffLen);
}
function $7b384be9e21c489d$var$findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) return -1;
    let level = 0;
    for(let i = 0; i < str.length; i++){
        if (str[i] === "\\") i++;
        else if (str[i] === b[0]) level++;
        else if (str[i] === b[1]) {
            level--;
            if (level < 0) return i;
        }
    }
    if (level > 0) return -2;
    return -1;
}
// src/Tokenizer.ts
function $7b384be9e21c489d$var$outputLink(cap, link2, raw, lexer2, rules) {
    const href = link2.href;
    const title = link2.title || null;
    const text = cap[1].replace(rules.other.outputLinkReplace, "$1");
    lexer2.state.inLink = true;
    const token = {
        type: cap[0].charAt(0) === "!" ? "image" : "link",
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer2.inlineTokens(text)
    };
    lexer2.state.inLink = false;
    return token;
}
function $7b384be9e21c489d$var$indentCodeCompensation(raw, text, rules) {
    const matchIndentToCode = raw.match(rules.other.indentCodeCompensation);
    if (matchIndentToCode === null) return text;
    const indentToCode = matchIndentToCode[1];
    return text.split("\n").map((node)=>{
        const matchIndentInNode = node.match(rules.other.beginningSpace);
        if (matchIndentInNode === null) return node;
        const [indentInNode] = matchIndentInNode;
        if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
        return node;
    }).join("\n");
}
var $7b384be9e21c489d$export$55e8b082af4aa63e = class {
    options;
    rules;
    // set by the lexer
    lexer;
    // set by the lexer
    constructor(options2){
        this.options = options2 || $7b384be9e21c489d$export$ebe90cb607ad99e;
    }
    space(src) {
        const cap = this.rules.block.newline.exec(src);
        if (cap && cap[0].length > 0) return {
            type: "space",
            raw: cap[0]
        };
    }
    code(src) {
        const cap = this.rules.block.code.exec(src);
        if (cap) {
            const text = cap[0].replace(this.rules.other.codeRemoveIndent, "");
            return {
                type: "code",
                raw: cap[0],
                codeBlockStyle: "indented",
                text: !this.options.pedantic ? $7b384be9e21c489d$var$rtrim(text, "\n") : text
            };
        }
    }
    fences(src) {
        const cap = this.rules.block.fences.exec(src);
        if (cap) {
            const raw = cap[0];
            const text = $7b384be9e21c489d$var$indentCodeCompensation(raw, cap[3] || "", this.rules);
            return {
                type: "code",
                raw: raw,
                lang: cap[2] ? cap[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : cap[2],
                text: text
            };
        }
    }
    heading(src) {
        const cap = this.rules.block.heading.exec(src);
        if (cap) {
            let text = cap[2].trim();
            if (this.rules.other.endingHash.test(text)) {
                const trimmed = $7b384be9e21c489d$var$rtrim(text, "#");
                if (this.options.pedantic) text = trimmed.trim();
                else if (!trimmed || this.rules.other.endingSpaceChar.test(trimmed)) text = trimmed.trim();
            }
            return {
                type: "heading",
                raw: cap[0],
                depth: cap[1].length,
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    hr(src) {
        const cap = this.rules.block.hr.exec(src);
        if (cap) return {
            type: "hr",
            raw: $7b384be9e21c489d$var$rtrim(cap[0], "\n")
        };
    }
    blockquote(src) {
        const cap = this.rules.block.blockquote.exec(src);
        if (cap) {
            let lines = $7b384be9e21c489d$var$rtrim(cap[0], "\n").split("\n");
            let raw = "";
            let text = "";
            const tokens = [];
            while(lines.length > 0){
                let inBlockquote = false;
                const currentLines = [];
                let i;
                for(i = 0; i < lines.length; i++){
                    if (this.rules.other.blockquoteStart.test(lines[i])) {
                        currentLines.push(lines[i]);
                        inBlockquote = true;
                    } else if (!inBlockquote) currentLines.push(lines[i]);
                    else break;
                }
                lines = lines.slice(i);
                const currentRaw = currentLines.join("\n");
                const currentText = currentRaw.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
                raw = raw ? `${raw}
${currentRaw}` : currentRaw;
                text = text ? `${text}
${currentText}` : currentText;
                const top = this.lexer.state.top;
                this.lexer.state.top = true;
                this.lexer.blockTokens(currentText, tokens, true);
                this.lexer.state.top = top;
                if (lines.length === 0) break;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "code") break;
                else if (lastToken?.type === "blockquote") {
                    const oldToken = lastToken;
                    const newText = oldToken.raw + "\n" + lines.join("\n");
                    const newToken = this.blockquote(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - oldToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.text.length) + newToken.text;
                    break;
                } else if (lastToken?.type === "list") {
                    const oldToken = lastToken;
                    const newText = oldToken.raw + "\n" + lines.join("\n");
                    const newToken = this.list(newText);
                    tokens[tokens.length - 1] = newToken;
                    raw = raw.substring(0, raw.length - lastToken.raw.length) + newToken.raw;
                    text = text.substring(0, text.length - oldToken.raw.length) + newToken.raw;
                    lines = newText.substring(tokens.at(-1).raw.length).split("\n");
                    continue;
                }
            }
            return {
                type: "blockquote",
                raw: raw,
                tokens: tokens,
                text: text
            };
        }
    }
    list(src) {
        let cap = this.rules.block.list.exec(src);
        if (cap) {
            let bull = cap[1].trim();
            const isordered = bull.length > 1;
            const list2 = {
                type: "list",
                raw: "",
                ordered: isordered,
                start: isordered ? +bull.slice(0, -1) : "",
                loose: false,
                items: []
            };
            bull = isordered ? `\\d{1,9}\\${bull.slice(-1)}` : `\\${bull}`;
            if (this.options.pedantic) bull = isordered ? bull : "[*+-]";
            const itemRegex = this.rules.other.listItemRegex(bull);
            let endsWithBlankLine = false;
            while(src){
                let endEarly = false;
                let raw = "";
                let itemContents = "";
                if (!(cap = itemRegex.exec(src))) break;
                if (this.rules.block.hr.test(src)) break;
                raw = cap[0];
                src = src.substring(raw.length);
                let line = cap[2].split("\n", 1)[0].replace(this.rules.other.listReplaceTabs, (t)=>" ".repeat(3 * t.length));
                let nextLine = src.split("\n", 1)[0];
                let blankLine = !line.trim();
                let indent = 0;
                if (this.options.pedantic) {
                    indent = 2;
                    itemContents = line.trimStart();
                } else if (blankLine) indent = cap[1].length + 1;
                else {
                    indent = cap[2].search(this.rules.other.nonSpaceChar);
                    indent = indent > 4 ? 1 : indent;
                    itemContents = line.slice(indent);
                    indent += cap[1].length;
                }
                if (blankLine && this.rules.other.blankLine.test(nextLine)) {
                    raw += nextLine + "\n";
                    src = src.substring(nextLine.length + 1);
                    endEarly = true;
                }
                if (!endEarly) {
                    const nextBulletRegex = this.rules.other.nextBulletRegex(indent);
                    const hrRegex = this.rules.other.hrRegex(indent);
                    const fencesBeginRegex = this.rules.other.fencesBeginRegex(indent);
                    const headingBeginRegex = this.rules.other.headingBeginRegex(indent);
                    const htmlBeginRegex = this.rules.other.htmlBeginRegex(indent);
                    while(src){
                        const rawLine = src.split("\n", 1)[0];
                        let nextLineWithoutTabs;
                        nextLine = rawLine;
                        if (this.options.pedantic) {
                            nextLine = nextLine.replace(this.rules.other.listReplaceNesting, "  ");
                            nextLineWithoutTabs = nextLine;
                        } else nextLineWithoutTabs = nextLine.replace(this.rules.other.tabCharGlobal, "    ");
                        if (fencesBeginRegex.test(nextLine)) break;
                        if (headingBeginRegex.test(nextLine)) break;
                        if (htmlBeginRegex.test(nextLine)) break;
                        if (nextBulletRegex.test(nextLine)) break;
                        if (hrRegex.test(nextLine)) break;
                        if (nextLineWithoutTabs.search(this.rules.other.nonSpaceChar) >= indent || !nextLine.trim()) itemContents += "\n" + nextLineWithoutTabs.slice(indent);
                        else {
                            if (blankLine) break;
                            if (line.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4) break;
                            if (fencesBeginRegex.test(line)) break;
                            if (headingBeginRegex.test(line)) break;
                            if (hrRegex.test(line)) break;
                            itemContents += "\n" + nextLine;
                        }
                        if (!blankLine && !nextLine.trim()) blankLine = true;
                        raw += rawLine + "\n";
                        src = src.substring(rawLine.length + 1);
                        line = nextLineWithoutTabs.slice(indent);
                    }
                }
                if (!list2.loose) {
                    if (endsWithBlankLine) list2.loose = true;
                    else if (this.rules.other.doubleBlankLine.test(raw)) endsWithBlankLine = true;
                }
                let istask = null;
                let ischecked;
                if (this.options.gfm) {
                    istask = this.rules.other.listIsTask.exec(itemContents);
                    if (istask) {
                        ischecked = istask[0] !== "[ ] ";
                        itemContents = itemContents.replace(this.rules.other.listReplaceTask, "");
                    }
                }
                list2.items.push({
                    type: "list_item",
                    raw: raw,
                    task: !!istask,
                    checked: ischecked,
                    loose: false,
                    text: itemContents,
                    tokens: []
                });
                list2.raw += raw;
            }
            const lastItem = list2.items.at(-1);
            if (lastItem) {
                lastItem.raw = lastItem.raw.trimEnd();
                lastItem.text = lastItem.text.trimEnd();
            } else return;
            list2.raw = list2.raw.trimEnd();
            for(let i = 0; i < list2.items.length; i++){
                this.lexer.state.top = false;
                list2.items[i].tokens = this.lexer.blockTokens(list2.items[i].text, []);
                if (!list2.loose) {
                    const spacers = list2.items[i].tokens.filter((t)=>t.type === "space");
                    const hasMultipleLineBreaks = spacers.length > 0 && spacers.some((t)=>this.rules.other.anyLine.test(t.raw));
                    list2.loose = hasMultipleLineBreaks;
                }
            }
            if (list2.loose) for(let i = 0; i < list2.items.length; i++)list2.items[i].loose = true;
            return list2;
        }
    }
    html(src) {
        const cap = this.rules.block.html.exec(src);
        if (cap) {
            const token = {
                type: "html",
                block: true,
                raw: cap[0],
                pre: cap[1] === "pre" || cap[1] === "script" || cap[1] === "style",
                text: cap[0]
            };
            return token;
        }
    }
    def(src) {
        const cap = this.rules.block.def.exec(src);
        if (cap) {
            const tag2 = cap[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " ");
            const href = cap[2] ? cap[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "";
            const title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : cap[3];
            return {
                type: "def",
                tag: tag2,
                raw: cap[0],
                href: href,
                title: title
            };
        }
    }
    table(src) {
        const cap = this.rules.block.table.exec(src);
        if (!cap) return;
        if (!this.rules.other.tableDelimiter.test(cap[2])) return;
        const headers = $7b384be9e21c489d$var$splitCells(cap[1]);
        const aligns = cap[2].replace(this.rules.other.tableAlignChars, "").split("|");
        const rows = cap[3]?.trim() ? cap[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [];
        const item = {
            type: "table",
            raw: cap[0],
            header: [],
            align: [],
            rows: []
        };
        if (headers.length !== aligns.length) return;
        for (const align of aligns){
            if (this.rules.other.tableAlignRight.test(align)) item.align.push("right");
            else if (this.rules.other.tableAlignCenter.test(align)) item.align.push("center");
            else if (this.rules.other.tableAlignLeft.test(align)) item.align.push("left");
            else item.align.push(null);
        }
        for(let i = 0; i < headers.length; i++)item.header.push({
            text: headers[i],
            tokens: this.lexer.inline(headers[i]),
            header: true,
            align: item.align[i]
        });
        for (const row of rows)item.rows.push($7b384be9e21c489d$var$splitCells(row, item.header.length).map((cell, i)=>{
            return {
                text: cell,
                tokens: this.lexer.inline(cell),
                header: false,
                align: item.align[i]
            };
        }));
        return item;
    }
    lheading(src) {
        const cap = this.rules.block.lheading.exec(src);
        if (cap) return {
            type: "heading",
            raw: cap[0],
            depth: cap[2].charAt(0) === "=" ? 1 : 2,
            text: cap[1],
            tokens: this.lexer.inline(cap[1])
        };
    }
    paragraph(src) {
        const cap = this.rules.block.paragraph.exec(src);
        if (cap) {
            const text = cap[1].charAt(cap[1].length - 1) === "\n" ? cap[1].slice(0, -1) : cap[1];
            return {
                type: "paragraph",
                raw: cap[0],
                text: text,
                tokens: this.lexer.inline(text)
            };
        }
    }
    text(src) {
        const cap = this.rules.block.text.exec(src);
        if (cap) return {
            type: "text",
            raw: cap[0],
            text: cap[0],
            tokens: this.lexer.inline(cap[0])
        };
    }
    escape(src) {
        const cap = this.rules.inline.escape.exec(src);
        if (cap) return {
            type: "escape",
            raw: cap[0],
            text: cap[1]
        };
    }
    tag(src) {
        const cap = this.rules.inline.tag.exec(src);
        if (cap) {
            if (!this.lexer.state.inLink && this.rules.other.startATag.test(cap[0])) this.lexer.state.inLink = true;
            else if (this.lexer.state.inLink && this.rules.other.endATag.test(cap[0])) this.lexer.state.inLink = false;
            if (!this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = true;
            else if (this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(cap[0])) this.lexer.state.inRawBlock = false;
            return {
                type: "html",
                raw: cap[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: false,
                text: cap[0]
            };
        }
    }
    link(src) {
        const cap = this.rules.inline.link.exec(src);
        if (cap) {
            const trimmedUrl = cap[2].trim();
            if (!this.options.pedantic && this.rules.other.startAngleBracket.test(trimmedUrl)) {
                if (!this.rules.other.endAngleBracket.test(trimmedUrl)) return;
                const rtrimSlash = $7b384be9e21c489d$var$rtrim(trimmedUrl.slice(0, -1), "\\");
                if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
            } else {
                const lastParenIndex = $7b384be9e21c489d$var$findClosingBracket(cap[2], "()");
                if (lastParenIndex === -2) return;
                if (lastParenIndex > -1) {
                    const start = cap[0].indexOf("!") === 0 ? 5 : 4;
                    const linkLen = start + cap[1].length + lastParenIndex;
                    cap[2] = cap[2].substring(0, lastParenIndex);
                    cap[0] = cap[0].substring(0, linkLen).trim();
                    cap[3] = "";
                }
            }
            let href = cap[2];
            let title = "";
            if (this.options.pedantic) {
                const link2 = this.rules.other.pedanticHrefTitle.exec(href);
                if (link2) {
                    href = link2[1];
                    title = link2[3];
                }
            } else title = cap[3] ? cap[3].slice(1, -1) : "";
            href = href.trim();
            if (this.rules.other.startAngleBracket.test(href)) {
                if (this.options.pedantic && !this.rules.other.endAngleBracket.test(trimmedUrl)) href = href.slice(1);
                else href = href.slice(1, -1);
            }
            return $7b384be9e21c489d$var$outputLink(cap, {
                href: href ? href.replace(this.rules.inline.anyPunctuation, "$1") : href,
                title: title ? title.replace(this.rules.inline.anyPunctuation, "$1") : title
            }, cap[0], this.lexer, this.rules);
        }
    }
    reflink(src, links) {
        let cap;
        if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
            const linkString = (cap[2] || cap[1]).replace(this.rules.other.multipleSpaceGlobal, " ");
            const link2 = links[linkString.toLowerCase()];
            if (!link2) {
                const text = cap[0].charAt(0);
                return {
                    type: "text",
                    raw: text,
                    text: text
                };
            }
            return $7b384be9e21c489d$var$outputLink(cap, link2, cap[0], this.lexer, this.rules);
        }
    }
    emStrong(src, maskedSrc, prevChar = "") {
        let match = this.rules.inline.emStrongLDelim.exec(src);
        if (!match) return;
        if (match[3] && prevChar.match(this.rules.other.unicodeAlphaNumeric)) return;
        const nextChar = match[1] || match[2] || "";
        if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
            const lLength = [
                ...match[0]
            ].length - 1;
            let rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
            const endReg = match[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
            endReg.lastIndex = 0;
            maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
            while((match = endReg.exec(maskedSrc)) != null){
                rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                if (!rDelim) continue;
                rLength = [
                    ...rDelim
                ].length;
                if (match[3] || match[4]) {
                    delimTotal += rLength;
                    continue;
                } else if (match[5] || match[6]) {
                    if (lLength % 3 && !((lLength + rLength) % 3)) {
                        midDelimTotal += rLength;
                        continue;
                    }
                }
                delimTotal -= rLength;
                if (delimTotal > 0) continue;
                rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                const lastCharLength = [
                    ...match[0]
                ][0].length;
                const raw = src.slice(0, lLength + match.index + lastCharLength + rLength);
                if (Math.min(lLength, rLength) % 2) {
                    const text2 = raw.slice(1, -1);
                    return {
                        type: "em",
                        raw: raw,
                        text: text2,
                        tokens: this.lexer.inlineTokens(text2)
                    };
                }
                const text = raw.slice(2, -2);
                return {
                    type: "strong",
                    raw: raw,
                    text: text,
                    tokens: this.lexer.inlineTokens(text)
                };
            }
        }
    }
    codespan(src) {
        const cap = this.rules.inline.code.exec(src);
        if (cap) {
            let text = cap[2].replace(this.rules.other.newLineCharGlobal, " ");
            const hasNonSpaceChars = this.rules.other.nonSpaceChar.test(text);
            const hasSpaceCharsOnBothEnds = this.rules.other.startingSpaceChar.test(text) && this.rules.other.endingSpaceChar.test(text);
            if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
            return {
                type: "codespan",
                raw: cap[0],
                text: text
            };
        }
    }
    br(src) {
        const cap = this.rules.inline.br.exec(src);
        if (cap) return {
            type: "br",
            raw: cap[0]
        };
    }
    del(src) {
        const cap = this.rules.inline.del.exec(src);
        if (cap) return {
            type: "del",
            raw: cap[0],
            text: cap[2],
            tokens: this.lexer.inlineTokens(cap[2])
        };
    }
    autolink(src) {
        const cap = this.rules.inline.autolink.exec(src);
        if (cap) {
            let text, href;
            if (cap[2] === "@") {
                text = cap[1];
                href = "mailto:" + text;
            } else {
                text = cap[1];
                href = text;
            }
            return {
                type: "link",
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    url(src) {
        let cap;
        if (cap = this.rules.inline.url.exec(src)) {
            let text, href;
            if (cap[2] === "@") {
                text = cap[0];
                href = "mailto:" + text;
            } else {
                let prevCapZero;
                do {
                    prevCapZero = cap[0];
                    cap[0] = this.rules.inline._backpedal.exec(cap[0])?.[0] ?? "";
                }while (prevCapZero !== cap[0]);
                text = cap[0];
                if (cap[1] === "www.") href = "http://" + cap[0];
                else href = cap[0];
            }
            return {
                type: "link",
                raw: cap[0],
                text: text,
                href: href,
                tokens: [
                    {
                        type: "text",
                        raw: text,
                        text: text
                    }
                ]
            };
        }
    }
    inlineText(src) {
        const cap = this.rules.inline.text.exec(src);
        if (cap) {
            const escaped = this.lexer.state.inRawBlock;
            return {
                type: "text",
                raw: cap[0],
                text: cap[0],
                escaped: escaped
            };
        }
    }
};
// src/Lexer.ts
var $7b384be9e21c489d$export$6168dc8908a6c652 = class __Lexer {
    tokens;
    options;
    state;
    tokenizer;
    inlineQueue;
    constructor(options2){
        this.tokens = [];
        this.tokens.links = /* @__PURE__ */ Object.create(null);
        this.options = options2 || $7b384be9e21c489d$export$ebe90cb607ad99e;
        this.options.tokenizer = this.options.tokenizer || new $7b384be9e21c489d$export$55e8b082af4aa63e();
        this.tokenizer = this.options.tokenizer;
        this.tokenizer.options = this.options;
        this.tokenizer.lexer = this;
        this.inlineQueue = [];
        this.state = {
            inLink: false,
            inRawBlock: false,
            top: true
        };
        const rules = {
            other: $7b384be9e21c489d$var$other,
            block: $7b384be9e21c489d$var$block.normal,
            inline: $7b384be9e21c489d$var$inline.normal
        };
        if (this.options.pedantic) {
            rules.block = $7b384be9e21c489d$var$block.pedantic;
            rules.inline = $7b384be9e21c489d$var$inline.pedantic;
        } else if (this.options.gfm) {
            rules.block = $7b384be9e21c489d$var$block.gfm;
            if (this.options.breaks) rules.inline = $7b384be9e21c489d$var$inline.breaks;
            else rules.inline = $7b384be9e21c489d$var$inline.gfm;
        }
        this.tokenizer.rules = rules;
    }
    /**
   * Expose Rules
   */ static get rules() {
        return {
            block: $7b384be9e21c489d$var$block,
            inline: $7b384be9e21c489d$var$inline
        };
    }
    /**
   * Static Lex Method
   */ static lex(src, options2) {
        const lexer2 = new __Lexer(options2);
        return lexer2.lex(src);
    }
    /**
   * Static Lex Inline Method
   */ static lexInline(src, options2) {
        const lexer2 = new __Lexer(options2);
        return lexer2.inlineTokens(src);
    }
    /**
   * Preprocessing
   */ lex(src) {
        src = src.replace($7b384be9e21c489d$var$other.carriageReturn, "\n");
        this.blockTokens(src, this.tokens);
        for(let i = 0; i < this.inlineQueue.length; i++){
            const next = this.inlineQueue[i];
            this.inlineTokens(next.src, next.tokens);
        }
        this.inlineQueue = [];
        return this.tokens;
    }
    blockTokens(src, tokens = [], lastParagraphClipped = false) {
        if (this.options.pedantic) src = src.replace($7b384be9e21c489d$var$other.tabCharGlobal, "    ").replace($7b384be9e21c489d$var$other.spaceLine, "");
        while(src){
            let token;
            if (this.options.extensions?.block?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            if (token = this.tokenizer.space(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.raw.length === 1 && lastToken !== void 0) lastToken.raw += "\n";
                else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.code(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.fences(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.heading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.hr(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.blockquote(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.list(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.html(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.def(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "paragraph" || lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.raw;
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                    href: token.href,
                    title: token.title
                };
                continue;
            }
            if (token = this.tokenizer.table(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.lheading(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            let cutSrc = src;
            if (this.options.extensions?.startBlock) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startBlock.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                const lastToken = tokens.at(-1);
                if (lastParagraphClipped && lastToken?.type === "paragraph") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                lastParagraphClipped = cutSrc.length !== src.length;
                src = src.substring(token.raw.length);
                continue;
            }
            if (token = this.tokenizer.text(src)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "text") {
                    lastToken.raw += "\n" + token.raw;
                    lastToken.text += "\n" + token.text;
                    this.inlineQueue.pop();
                    this.inlineQueue.at(-1).src = lastToken.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        this.state.top = true;
        return tokens;
    }
    inline(src, tokens = []) {
        this.inlineQueue.push({
            src: src,
            tokens: tokens
        });
        return tokens;
    }
    /**
   * Lexing/Compiling
   */ inlineTokens(src, tokens = []) {
        let maskedSrc = src;
        let match = null;
        if (this.tokens.links) {
            const links = Object.keys(this.tokens.links);
            if (links.length > 0) {
                while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf("[") + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
        }
        while((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "++" + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
        while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + "[" + "a".repeat(match[0].length - 2) + "]" + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
        let keepPrevChar = false;
        let prevChar = "";
        while(src){
            if (!keepPrevChar) prevChar = "";
            keepPrevChar = false;
            let token;
            if (this.options.extensions?.inline?.some((extTokenizer)=>{
                if (token = extTokenizer.call({
                    lexer: this
                }, src, tokens)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    return true;
                }
                return false;
            })) continue;
            if (token = this.tokenizer.escape(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.tag(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.link(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                src = src.substring(token.raw.length);
                const lastToken = tokens.at(-1);
                if (token.type === "text" && lastToken?.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.codespan(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.br(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.del(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (token = this.tokenizer.autolink(src)) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            if (!this.state.inLink && (token = this.tokenizer.url(src))) {
                src = src.substring(token.raw.length);
                tokens.push(token);
                continue;
            }
            let cutSrc = src;
            if (this.options.extensions?.startInline) {
                let startIndex = Infinity;
                const tempSrc = src.slice(1);
                let tempStart;
                this.options.extensions.startInline.forEach((getStartIndex)=>{
                    tempStart = getStartIndex.call({
                        lexer: this
                    }, tempSrc);
                    if (typeof tempStart === "number" && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                });
                if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
            }
            if (token = this.tokenizer.inlineText(cutSrc)) {
                src = src.substring(token.raw.length);
                if (token.raw.slice(-1) !== "_") prevChar = token.raw.slice(-1);
                keepPrevChar = true;
                const lastToken = tokens.at(-1);
                if (lastToken?.type === "text") {
                    lastToken.raw += token.raw;
                    lastToken.text += token.text;
                } else tokens.push(token);
                continue;
            }
            if (src) {
                const errMsg = "Infinite loop on byte: " + src.charCodeAt(0);
                if (this.options.silent) {
                    console.error(errMsg);
                    break;
                } else throw new Error(errMsg);
            }
        }
        return tokens;
    }
};
// src/Renderer.ts
var $7b384be9e21c489d$export$88530751e3977073 = class {
    options;
    parser;
    // set by the parser
    constructor(options2){
        this.options = options2 || $7b384be9e21c489d$export$ebe90cb607ad99e;
    }
    space(token) {
        return "";
    }
    code({ text: text, lang: lang, escaped: escaped }) {
        const langString = (lang || "").match($7b384be9e21c489d$var$other.notSpaceStart)?.[0];
        const code = text.replace($7b384be9e21c489d$var$other.endingNewline, "") + "\n";
        if (!langString) return "<pre><code>" + (escaped ? code : $7b384be9e21c489d$var$escape2(code, true)) + "</code></pre>\n";
        return '<pre><code class="language-' + $7b384be9e21c489d$var$escape2(langString) + '">' + (escaped ? code : $7b384be9e21c489d$var$escape2(code, true)) + "</code></pre>\n";
    }
    blockquote({ tokens: tokens }) {
        const body = this.parser.parse(tokens);
        return `<blockquote>
${body}</blockquote>
`;
    }
    html({ text: text }) {
        return text;
    }
    heading({ tokens: tokens, depth: depth }) {
        return `<h${depth}>${this.parser.parseInline(tokens)}</h${depth}>
`;
    }
    hr(token) {
        return "<hr>\n";
    }
    list(token) {
        const ordered = token.ordered;
        const start = token.start;
        let body = "";
        for(let j = 0; j < token.items.length; j++){
            const item = token.items[j];
            body += this.listitem(item);
        }
        const type = ordered ? "ol" : "ul";
        const startAttr = ordered && start !== 1 ? ' start="' + start + '"' : "";
        return "<" + type + startAttr + ">\n" + body + "</" + type + ">\n";
    }
    listitem(item) {
        let itemBody = "";
        if (item.task) {
            const checkbox = this.checkbox({
                checked: !!item.checked
            });
            if (item.loose) {
                if (item.tokens[0]?.type === "paragraph") {
                    item.tokens[0].text = checkbox + " " + item.tokens[0].text;
                    if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === "text") {
                        item.tokens[0].tokens[0].text = checkbox + " " + $7b384be9e21c489d$var$escape2(item.tokens[0].tokens[0].text);
                        item.tokens[0].tokens[0].escaped = true;
                    }
                } else item.tokens.unshift({
                    type: "text",
                    raw: checkbox + " ",
                    text: checkbox + " ",
                    escaped: true
                });
            } else itemBody += checkbox + " ";
        }
        itemBody += this.parser.parse(item.tokens, !!item.loose);
        return `<li>${itemBody}</li>
`;
    }
    checkbox({ checked: checked }) {
        return "<input " + (checked ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
    }
    paragraph({ tokens: tokens }) {
        return `<p>${this.parser.parseInline(tokens)}</p>
`;
    }
    table(token) {
        let header = "";
        let cell = "";
        for(let j = 0; j < token.header.length; j++)cell += this.tablecell(token.header[j]);
        header += this.tablerow({
            text: cell
        });
        let body = "";
        for(let j = 0; j < token.rows.length; j++){
            const row = token.rows[j];
            cell = "";
            for(let k = 0; k < row.length; k++)cell += this.tablecell(row[k]);
            body += this.tablerow({
                text: cell
            });
        }
        if (body) body = `<tbody>${body}</tbody>`;
        return "<table>\n<thead>\n" + header + "</thead>\n" + body + "</table>\n";
    }
    tablerow({ text: text }) {
        return `<tr>
${text}</tr>
`;
    }
    tablecell(token) {
        const content = this.parser.parseInline(token.tokens);
        const type = token.header ? "th" : "td";
        const tag2 = token.align ? `<${type} align="${token.align}">` : `<${type}>`;
        return tag2 + content + `</${type}>
`;
    }
    /**
   * span level renderer
   */ strong({ tokens: tokens }) {
        return `<strong>${this.parser.parseInline(tokens)}</strong>`;
    }
    em({ tokens: tokens }) {
        return `<em>${this.parser.parseInline(tokens)}</em>`;
    }
    codespan({ text: text }) {
        return `<code>${$7b384be9e21c489d$var$escape2(text, true)}</code>`;
    }
    br(token) {
        return "<br>";
    }
    del({ tokens: tokens }) {
        return `<del>${this.parser.parseInline(tokens)}</del>`;
    }
    link({ href: href, title: title, tokens: tokens }) {
        const text = this.parser.parseInline(tokens);
        const cleanHref = $7b384be9e21c489d$var$cleanUrl(href);
        if (cleanHref === null) return text;
        href = cleanHref;
        let out = '<a href="' + href + '"';
        if (title) out += ' title="' + $7b384be9e21c489d$var$escape2(title) + '"';
        out += ">" + text + "</a>";
        return out;
    }
    image({ href: href, title: title, text: text, tokens: tokens }) {
        if (tokens) text = this.parser.parseInline(tokens, this.parser.textRenderer);
        const cleanHref = $7b384be9e21c489d$var$cleanUrl(href);
        if (cleanHref === null) return $7b384be9e21c489d$var$escape2(text);
        href = cleanHref;
        let out = `<img src="${href}" alt="${text}"`;
        if (title) out += ` title="${$7b384be9e21c489d$var$escape2(title)}"`;
        out += ">";
        return out;
    }
    text(token) {
        return "tokens" in token && token.tokens ? this.parser.parseInline(token.tokens) : "escaped" in token && token.escaped ? token.text : $7b384be9e21c489d$var$escape2(token.text);
    }
};
// src/TextRenderer.ts
var $7b384be9e21c489d$export$75ebcd2c8ed5b901 = class {
    // no need for block level renderers
    strong({ text: text }) {
        return text;
    }
    em({ text: text }) {
        return text;
    }
    codespan({ text: text }) {
        return text;
    }
    del({ text: text }) {
        return text;
    }
    html({ text: text }) {
        return text;
    }
    text({ text: text }) {
        return text;
    }
    link({ text: text }) {
        return "" + text;
    }
    image({ text: text }) {
        return "" + text;
    }
    br() {
        return "";
    }
};
// src/Parser.ts
var $7b384be9e21c489d$export$7acfa6ed01010e37 = class __Parser {
    options;
    renderer;
    textRenderer;
    constructor(options2){
        this.options = options2 || $7b384be9e21c489d$export$ebe90cb607ad99e;
        this.options.renderer = this.options.renderer || new $7b384be9e21c489d$export$88530751e3977073();
        this.renderer = this.options.renderer;
        this.renderer.options = this.options;
        this.renderer.parser = this;
        this.textRenderer = new $7b384be9e21c489d$export$75ebcd2c8ed5b901();
    }
    /**
   * Static Parse Method
   */ static parse(tokens, options2) {
        const parser2 = new __Parser(options2);
        return parser2.parse(tokens);
    }
    /**
   * Static Parse Inline Method
   */ static parseInline(tokens, options2) {
        const parser2 = new __Parser(options2);
        return parser2.parseInline(tokens);
    }
    /**
   * Parse Loop
   */ parse(tokens, top = true) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const genericToken = anyToken;
                const ret = this.options.extensions.renderers[genericToken.type].call({
                    parser: this
                }, genericToken);
                if (ret !== false || ![
                    "space",
                    "hr",
                    "heading",
                    "code",
                    "table",
                    "blockquote",
                    "list",
                    "html",
                    "paragraph",
                    "text"
                ].includes(genericToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case "space":
                    out += this.renderer.space(token);
                    continue;
                case "hr":
                    out += this.renderer.hr(token);
                    continue;
                case "heading":
                    out += this.renderer.heading(token);
                    continue;
                case "code":
                    out += this.renderer.code(token);
                    continue;
                case "table":
                    out += this.renderer.table(token);
                    continue;
                case "blockquote":
                    out += this.renderer.blockquote(token);
                    continue;
                case "list":
                    out += this.renderer.list(token);
                    continue;
                case "html":
                    out += this.renderer.html(token);
                    continue;
                case "paragraph":
                    out += this.renderer.paragraph(token);
                    continue;
                case "text":
                    {
                        let textToken = token;
                        let body = this.renderer.text(textToken);
                        while(i + 1 < tokens.length && tokens[i + 1].type === "text"){
                            textToken = tokens[++i];
                            body += "\n" + this.renderer.text(textToken);
                        }
                        if (top) out += this.renderer.paragraph({
                            type: "paragraph",
                            raw: body,
                            text: body,
                            tokens: [
                                {
                                    type: "text",
                                    raw: body,
                                    text: body,
                                    escaped: true
                                }
                            ]
                        });
                        else out += body;
                        continue;
                    }
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
    /**
   * Parse Inline Tokens
   */ parseInline(tokens, renderer = this.renderer) {
        let out = "";
        for(let i = 0; i < tokens.length; i++){
            const anyToken = tokens[i];
            if (this.options.extensions?.renderers?.[anyToken.type]) {
                const ret = this.options.extensions.renderers[anyToken.type].call({
                    parser: this
                }, anyToken);
                if (ret !== false || ![
                    "escape",
                    "html",
                    "link",
                    "image",
                    "strong",
                    "em",
                    "codespan",
                    "br",
                    "del",
                    "text"
                ].includes(anyToken.type)) {
                    out += ret || "";
                    continue;
                }
            }
            const token = anyToken;
            switch(token.type){
                case "escape":
                    out += renderer.text(token);
                    break;
                case "html":
                    out += renderer.html(token);
                    break;
                case "link":
                    out += renderer.link(token);
                    break;
                case "image":
                    out += renderer.image(token);
                    break;
                case "strong":
                    out += renderer.strong(token);
                    break;
                case "em":
                    out += renderer.em(token);
                    break;
                case "codespan":
                    out += renderer.codespan(token);
                    break;
                case "br":
                    out += renderer.br(token);
                    break;
                case "del":
                    out += renderer.del(token);
                    break;
                case "text":
                    out += renderer.text(token);
                    break;
                default:
                    {
                        const errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return "";
                        } else throw new Error(errMsg);
                    }
            }
        }
        return out;
    }
};
// src/Hooks.ts
var $7b384be9e21c489d$export$5fbefe39e79899a6 = class {
    options;
    block;
    constructor(options2){
        this.options = options2 || $7b384be9e21c489d$export$ebe90cb607ad99e;
    }
    static passThroughHooks = /* @__PURE__ */ new Set([
        "preprocess",
        "postprocess",
        "processAllTokens"
    ]);
    /**
   * Process markdown before marked
   */ preprocess(markdown) {
        return markdown;
    }
    /**
   * Process HTML after marked is finished
   */ postprocess(html2) {
        return html2;
    }
    /**
   * Process all tokens before walk tokens
   */ processAllTokens(tokens) {
        return tokens;
    }
    /**
   * Provide function to tokenize markdown
   */ provideLexer() {
        return this.block ? $7b384be9e21c489d$export$6168dc8908a6c652.lex : $7b384be9e21c489d$export$6168dc8908a6c652.lexInline;
    }
    /**
   * Provide function to parse tokens
   */ provideParser() {
        return this.block ? $7b384be9e21c489d$export$7acfa6ed01010e37.parse : $7b384be9e21c489d$export$7acfa6ed01010e37.parseInline;
    }
};
// src/Instance.ts
var $7b384be9e21c489d$export$164128c95a350e30 = class {
    defaults = $7b384be9e21c489d$export$212bb2fc580a90a8();
    options = this.setOptions;
    parse = this.parseMarkdown(true);
    parseInline = this.parseMarkdown(false);
    Parser = $7b384be9e21c489d$export$7acfa6ed01010e37;
    Renderer = $7b384be9e21c489d$export$88530751e3977073;
    TextRenderer = $7b384be9e21c489d$export$75ebcd2c8ed5b901;
    Lexer = $7b384be9e21c489d$export$6168dc8908a6c652;
    Tokenizer = $7b384be9e21c489d$export$55e8b082af4aa63e;
    Hooks = $7b384be9e21c489d$export$5fbefe39e79899a6;
    constructor(...args){
        this.use(...args);
    }
    /**
   * Run callback for every token
   */ walkTokens(tokens, callback) {
        let values = [];
        for (const token of tokens){
            values = values.concat(callback.call(this, token));
            switch(token.type){
                case "table":
                    {
                        const tableToken = token;
                        for (const cell of tableToken.header)values = values.concat(this.walkTokens(cell.tokens, callback));
                        for (const row of tableToken.rows)for (const cell of row)values = values.concat(this.walkTokens(cell.tokens, callback));
                        break;
                    }
                case "list":
                    {
                        const listToken = token;
                        values = values.concat(this.walkTokens(listToken.items, callback));
                        break;
                    }
                default:
                    {
                        const genericToken = token;
                        if (this.defaults.extensions?.childTokens?.[genericToken.type]) this.defaults.extensions.childTokens[genericToken.type].forEach((childTokens)=>{
                            const tokens2 = genericToken[childTokens].flat(Infinity);
                            values = values.concat(this.walkTokens(tokens2, callback));
                        });
                        else if (genericToken.tokens) values = values.concat(this.walkTokens(genericToken.tokens, callback));
                    }
            }
        }
        return values;
    }
    use(...args) {
        const extensions = this.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        args.forEach((pack)=>{
            const opts = {
                ...pack
            };
            opts.async = this.defaults.async || opts.async || false;
            if (pack.extensions) {
                pack.extensions.forEach((ext)=>{
                    if (!ext.name) throw new Error("extension name required");
                    if ("renderer" in ext) {
                        const prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) extensions.renderers[ext.name] = function(...args2) {
                            let ret = ext.renderer.apply(this, args2);
                            if (ret === false) ret = prevRenderer.apply(this, args2);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if ("tokenizer" in ext) {
                        if (!ext.level || ext.level !== "block" && ext.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        const extLevel = extensions[ext.level];
                        if (extLevel) extLevel.unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            if (ext.level === "block") {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === "inline") {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if ("childTokens" in ext && ext.childTokens) extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            if (pack.renderer) {
                const renderer = this.defaults.renderer || new $7b384be9e21c489d$export$88530751e3977073(this.defaults);
                for(const prop in pack.renderer){
                    if (!(prop in renderer)) throw new Error(`renderer '${prop}' does not exist`);
                    if ([
                        "options",
                        "parser"
                    ].includes(prop)) continue;
                    const rendererProp = prop;
                    const rendererFunc = pack.renderer[rendererProp];
                    const prevRenderer = renderer[rendererProp];
                    renderer[rendererProp] = (...args2)=>{
                        let ret = rendererFunc.apply(renderer, args2);
                        if (ret === false) ret = prevRenderer.apply(renderer, args2);
                        return ret || "";
                    };
                }
                opts.renderer = renderer;
            }
            if (pack.tokenizer) {
                const tokenizer = this.defaults.tokenizer || new $7b384be9e21c489d$export$55e8b082af4aa63e(this.defaults);
                for(const prop in pack.tokenizer){
                    if (!(prop in tokenizer)) throw new Error(`tokenizer '${prop}' does not exist`);
                    if ([
                        "options",
                        "rules",
                        "lexer"
                    ].includes(prop)) continue;
                    const tokenizerProp = prop;
                    const tokenizerFunc = pack.tokenizer[tokenizerProp];
                    const prevTokenizer = tokenizer[tokenizerProp];
                    tokenizer[tokenizerProp] = (...args2)=>{
                        let ret = tokenizerFunc.apply(tokenizer, args2);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args2);
                        return ret;
                    };
                }
                opts.tokenizer = tokenizer;
            }
            if (pack.hooks) {
                const hooks = this.defaults.hooks || new $7b384be9e21c489d$export$5fbefe39e79899a6();
                for(const prop in pack.hooks){
                    if (!(prop in hooks)) throw new Error(`hook '${prop}' does not exist`);
                    if ([
                        "options",
                        "block"
                    ].includes(prop)) continue;
                    const hooksProp = prop;
                    const hooksFunc = pack.hooks[hooksProp];
                    const prevHook = hooks[hooksProp];
                    if ($7b384be9e21c489d$export$5fbefe39e79899a6.passThroughHooks.has(prop)) hooks[hooksProp] = (arg)=>{
                        if (this.defaults.async) return Promise.resolve(hooksFunc.call(hooks, arg)).then((ret2)=>{
                            return prevHook.call(hooks, ret2);
                        });
                        const ret = hooksFunc.call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[hooksProp] = (...args2)=>{
                        let ret = hooksFunc.apply(hooks, args2);
                        if (ret === false) ret = prevHook.apply(hooks, args2);
                        return ret;
                    };
                }
                opts.hooks = hooks;
            }
            if (pack.walkTokens) {
                const walkTokens2 = this.defaults.walkTokens;
                const packWalktokens = pack.walkTokens;
                opts.walkTokens = function(token) {
                    let values = [];
                    values.push(packWalktokens.call(this, token));
                    if (walkTokens2) values = values.concat(walkTokens2.call(this, token));
                    return values;
                };
            }
            this.defaults = {
                ...this.defaults,
                ...opts
            };
        });
        return this;
    }
    setOptions(opt) {
        this.defaults = {
            ...this.defaults,
            ...opt
        };
        return this;
    }
    lexer(src, options2) {
        return $7b384be9e21c489d$export$6168dc8908a6c652.lex(src, options2 ?? this.defaults);
    }
    parser(tokens, options2) {
        return $7b384be9e21c489d$export$7acfa6ed01010e37.parse(tokens, options2 ?? this.defaults);
    }
    parseMarkdown(blockType) {
        const parse2 = (src, options2)=>{
            const origOpt = {
                ...options2
            };
            const opt = {
                ...this.defaults,
                ...origOpt
            };
            const throwError = this.onError(!!opt.silent, !!opt.async);
            if (this.defaults.async === true && origOpt.async === false) return throwError(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
            if (typeof src === "undefined" || src === null) return throwError(new Error("marked(): input parameter is undefined or null"));
            if (typeof src !== "string") return throwError(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(src) + ", string expected"));
            if (opt.hooks) {
                opt.hooks.options = opt;
                opt.hooks.block = blockType;
            }
            const lexer2 = opt.hooks ? opt.hooks.provideLexer() : blockType ? $7b384be9e21c489d$export$6168dc8908a6c652.lex : $7b384be9e21c489d$export$6168dc8908a6c652.lexInline;
            const parser2 = opt.hooks ? opt.hooks.provideParser() : blockType ? $7b384be9e21c489d$export$7acfa6ed01010e37.parse : $7b384be9e21c489d$export$7acfa6ed01010e37.parseInline;
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then((src2)=>lexer2(src2, opt)).then((tokens)=>opt.hooks ? opt.hooks.processAllTokens(tokens) : tokens).then((tokens)=>opt.walkTokens ? Promise.all(this.walkTokens(tokens, opt.walkTokens)).then(()=>tokens) : tokens).then((tokens)=>parser2(tokens, opt)).then((html2)=>opt.hooks ? opt.hooks.postprocess(html2) : html2).catch(throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                let tokens = lexer2(src, opt);
                if (opt.hooks) tokens = opt.hooks.processAllTokens(tokens);
                if (opt.walkTokens) this.walkTokens(tokens, opt.walkTokens);
                let html2 = parser2(tokens, opt);
                if (opt.hooks) html2 = opt.hooks.postprocess(html2);
                return html2;
            } catch (e) {
                return throwError(e);
            }
        };
        return parse2;
    }
    onError(silent, async) {
        return (e)=>{
            e.message += "\nPlease report this to https://github.com/markedjs/marked.";
            if (silent) {
                const msg = "<p>An error occurred:</p><pre>" + $7b384be9e21c489d$var$escape2(e.message + "", true) + "</pre>";
                if (async) return Promise.resolve(msg);
                return msg;
            }
            if (async) return Promise.reject(e);
            throw e;
        };
    }
};
// src/marked.ts
var $7b384be9e21c489d$var$markedInstance = new $7b384be9e21c489d$export$164128c95a350e30();
function $7b384be9e21c489d$export$db8f131360c543a5(src, opt) {
    return $7b384be9e21c489d$var$markedInstance.parse(src, opt);
}
$7b384be9e21c489d$export$db8f131360c543a5.options = $7b384be9e21c489d$export$db8f131360c543a5.setOptions = function(options2) {
    $7b384be9e21c489d$var$markedInstance.setOptions(options2);
    $7b384be9e21c489d$export$db8f131360c543a5.defaults = $7b384be9e21c489d$var$markedInstance.defaults;
    $7b384be9e21c489d$var$changeDefaults($7b384be9e21c489d$export$db8f131360c543a5.defaults);
    return $7b384be9e21c489d$export$db8f131360c543a5;
};
$7b384be9e21c489d$export$db8f131360c543a5.getDefaults = $7b384be9e21c489d$export$212bb2fc580a90a8;
$7b384be9e21c489d$export$db8f131360c543a5.defaults = $7b384be9e21c489d$export$ebe90cb607ad99e;
$7b384be9e21c489d$export$db8f131360c543a5.use = function(...args) {
    $7b384be9e21c489d$var$markedInstance.use(...args);
    $7b384be9e21c489d$export$db8f131360c543a5.defaults = $7b384be9e21c489d$var$markedInstance.defaults;
    $7b384be9e21c489d$var$changeDefaults($7b384be9e21c489d$export$db8f131360c543a5.defaults);
    return $7b384be9e21c489d$export$db8f131360c543a5;
};
$7b384be9e21c489d$export$db8f131360c543a5.walkTokens = function(tokens, callback) {
    return $7b384be9e21c489d$var$markedInstance.walkTokens(tokens, callback);
};
$7b384be9e21c489d$export$db8f131360c543a5.parseInline = $7b384be9e21c489d$var$markedInstance.parseInline;
$7b384be9e21c489d$export$db8f131360c543a5.Parser = $7b384be9e21c489d$export$7acfa6ed01010e37;
$7b384be9e21c489d$export$db8f131360c543a5.parser = $7b384be9e21c489d$export$7acfa6ed01010e37.parse;
$7b384be9e21c489d$export$db8f131360c543a5.Renderer = $7b384be9e21c489d$export$88530751e3977073;
$7b384be9e21c489d$export$db8f131360c543a5.TextRenderer = $7b384be9e21c489d$export$75ebcd2c8ed5b901;
$7b384be9e21c489d$export$db8f131360c543a5.Lexer = $7b384be9e21c489d$export$6168dc8908a6c652;
$7b384be9e21c489d$export$db8f131360c543a5.lexer = $7b384be9e21c489d$export$6168dc8908a6c652.lex;
$7b384be9e21c489d$export$db8f131360c543a5.Tokenizer = $7b384be9e21c489d$export$55e8b082af4aa63e;
$7b384be9e21c489d$export$db8f131360c543a5.Hooks = $7b384be9e21c489d$export$5fbefe39e79899a6;
$7b384be9e21c489d$export$db8f131360c543a5.parse = $7b384be9e21c489d$export$db8f131360c543a5;
var $7b384be9e21c489d$export$41c562ebe57d11e2 = $7b384be9e21c489d$export$db8f131360c543a5.options;
var $7b384be9e21c489d$export$add91eafeaeab287 = $7b384be9e21c489d$export$db8f131360c543a5.setOptions;
var $7b384be9e21c489d$export$1f96ae73734a86cc = $7b384be9e21c489d$export$db8f131360c543a5.use;
var $7b384be9e21c489d$export$3eedd5437d43cb76 = $7b384be9e21c489d$export$db8f131360c543a5.walkTokens;
var $7b384be9e21c489d$export$c7679c2b5e355e6f = $7b384be9e21c489d$export$db8f131360c543a5.parseInline;
var $7b384be9e21c489d$export$98e6a39c04603d36 = $7b384be9e21c489d$export$db8f131360c543a5;
var $7b384be9e21c489d$export$8f49e4af10703ce3 = $7b384be9e21c489d$export$7acfa6ed01010e37.parse;
var $7b384be9e21c489d$export$43feed32102720d2 = $7b384be9e21c489d$export$6168dc8908a6c652.lex;


function $59574e52e8f49fa6$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $59574e52e8f49fa6$var$$57ba63c17513cbba$exports = {};
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$57ba63c17513cbba$exports, "getAnchorElement", function() {
    return $59574e52e8f49fa6$export$ac81f1ba58a5f363;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$57ba63c17513cbba$exports, "Tool", function() {
    return $59574e52e8f49fa6$export$724f6b867059ef5f;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$57ba63c17513cbba$exports, "FileTool", function() {
    return $59574e52e8f49fa6$export$de3122b2484864a7;
});
function $59574e52e8f49fa6$export$ac81f1ba58a5f363() {
    const { anchorNode: anchorNode } = globalThis.getSelection?.() || {};
    if (anchorNode) return anchorNode.parentElement;
}
class $59574e52e8f49fa6$export$724f6b867059ef5f {
    get usable() {
        const { command: command } = this;
        return !command || !globalThis.document || document.queryCommandSupported(command) || document.queryCommandEnabled(command);
    }
    getActive() {
        const { command: command, tags: tags } = this;
        if (tags) {
            const box = $59574e52e8f49fa6$export$ac81f1ba58a5f363();
            return !!box && box.matches(tags.map((tag)=>`${tag}, ${tag} *`).join(', '));
        }
        if (command) return !!globalThis.document && document.queryCommandState(command);
        return false;
    }
    get active() {
        return this.getActive();
    }
    get title() {
        const { name: name, keys: keys, usable: usable } = this;
        return `${name}${usable ? keys ? `\n(${keys.join(' + ')})` : '' : '\n(not supported)'}`;
    }
    edit(editor, ...data) {
        editor.focus();
        document.execCommand(this.command, null, ...data);
    }
    execute(editor, ...data) {
        var { inputs: inputs } = this, values = [];
        if (inputs) {
            const data = inputs.map((input)=>self.prompt(input));
            if (!data.filter(Boolean)[0]) return;
            values = data;
        }
        this.edit(editor, ...values);
    }
}
class $59574e52e8f49fa6$export$de3122b2484864a7 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    async save(data) {
        return URL.createObjectURL(data);
    }
    codeOf(path) {
        return path;
    }
    async execute(editor) {
        try {
            var path = await this.save(await (0, $9197eb5abb1c09ae$export$c1bd535e520dbbc3)());
        } catch  {
            var path = self.prompt('No file uploaded, please input an URL');
        }
        if (path) this.edit(editor, this.codeOf(path));
    }
}
var $59574e52e8f49fa6$var$$761e5fca3dae08eb$exports = {};
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "BoldTool", function() {
    return $59574e52e8f49fa6$export$10056a49e3b218eb;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "ItalicTool", function() {
    return $59574e52e8f49fa6$export$edf99d0f51bacb1e;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "UnderlineTool", function() {
    return $59574e52e8f49fa6$export$4b6d9c17188960d2;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "StrikeThroughTool", function() {
    return $59574e52e8f49fa6$export$a35bffaeae8fdda0;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "HeadingTool", function() {
    return $59574e52e8f49fa6$export$85cf7848e2652151;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "H1Tool", function() {
    return $59574e52e8f49fa6$export$30e8c6b428f8749f;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "H2Tool", function() {
    return $59574e52e8f49fa6$export$58443375efa91029;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "H3Tool", function() {
    return $59574e52e8f49fa6$export$75d24d6b8b747307;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "FontSizeDownTool", function() {
    return $59574e52e8f49fa6$export$a20806c6ef6938f8;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "FontSizeUpTool", function() {
    return $59574e52e8f49fa6$export$744da7e24e4a7382;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "SubscriptTool", function() {
    return $59574e52e8f49fa6$export$6137518b4e998008;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "SuperscriptTool", function() {
    return $59574e52e8f49fa6$export$7217f06c61ebd4fc;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$761e5fca3dae08eb$exports, "LinkTool", function() {
    return $59574e52e8f49fa6$export$f6c54364b5332e66;
});
class $59574e52e8f49fa6$export$10056a49e3b218eb extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Bold', this.tags = [
            'b',
            'strong'
        ], this.keys = [
            'Ctrl',
            'B'
        ], this.command = 'bold';
    }
}
class $59574e52e8f49fa6$export$edf99d0f51bacb1e extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Italic', this.tags = [
            'i',
            'em'
        ], this.keys = [
            'Ctrl',
            'I'
        ], this.command = 'italic';
    }
}
class $59574e52e8f49fa6$export$4b6d9c17188960d2 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Underline', this.tags = [
            'u'
        ], this.keys = [
            'Ctrl',
            'U'
        ], this.command = 'underline';
    }
}
class $59574e52e8f49fa6$export$a35bffaeae8fdda0 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Strike through', this.tags = [
            's',
            'del',
            'strike'
        ], this.command = 'strikeThrough';
    }
}
class $59574e52e8f49fa6$export$85cf7848e2652151 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    execute(editor) {
        this.edit(editor, this.name);
    }
    constructor(...args){
        super(...args), this.command = globalThis.document?.queryCommandSupported('heading') ? 'heading' : 'formatBlock';
    }
}
class $59574e52e8f49fa6$export$30e8c6b428f8749f extends $59574e52e8f49fa6$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H1', this.tags = [
            'h1'
        ];
    }
}
class $59574e52e8f49fa6$export$58443375efa91029 extends $59574e52e8f49fa6$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H2', this.tags = [
            'h2'
        ];
    }
}
class $59574e52e8f49fa6$export$75d24d6b8b747307 extends $59574e52e8f49fa6$export$85cf7848e2652151 {
    constructor(...args){
        super(...args), this.name = 'H3', this.tags = [
            'h3'
        ];
    }
}
class $59574e52e8f49fa6$export$a20806c6ef6938f8 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Font Size down', this.tags = [
            'small'
        ], this.command = 'decreaseFontSize';
    }
}
class $59574e52e8f49fa6$export$744da7e24e4a7382 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Font Size up', this.tags = [
            'big'
        ], this.command = 'increaseFontSize';
    }
}
class $59574e52e8f49fa6$export$6137518b4e998008 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Subscript', this.tags = [
            'sub'
        ], this.command = 'subscript';
    }
}
class $59574e52e8f49fa6$export$7217f06c61ebd4fc extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Superscript', this.tags = [
            'sup'
        ], this.command = 'superscript';
    }
}
class $59574e52e8f49fa6$export$f6c54364b5332e66 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Link', this.tags = [
            'a'
        ], this.inputs = [
            'Path'
        ], this.command = 'createLink';
    }
}
var $59574e52e8f49fa6$var$$e999eec76d3b8abe$exports = {};
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$e999eec76d3b8abe$exports, "ColorTool", function() {
    return $59574e52e8f49fa6$export$ba9bbe5370f1bf2f;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$e999eec76d3b8abe$exports, "ForeColorTool", function() {
    return $59574e52e8f49fa6$export$cab0e15cfb8489d7;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$e999eec76d3b8abe$exports, "BackColorTool", function() {
    return $59574e52e8f49fa6$export$92bb6183e7459be2;
});
class $59574e52e8f49fa6$export$ba9bbe5370f1bf2f extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    getColor() {
        const box = $59574e52e8f49fa6$export$ac81f1ba58a5f363(), { colorName: colorName } = this;
        if (!box) return colorName === 'color' ? '#000000' : '#ffffff';
        const { [colorName]: color } = getComputedStyle(box);
        const [red, green, blue] = color.match(/\d+/g);
        return '#' + (+red).toString(16).padStart(2, '0') + (+green).toString(16).padStart(2, '0') + (+blue).toString(16).padStart(2, '0');
    }
    get active() {
        return !!this.getColor();
    }
    execute(editor, color) {
        this.edit(editor, color);
    }
}
class $59574e52e8f49fa6$export$cab0e15cfb8489d7 extends $59574e52e8f49fa6$export$ba9bbe5370f1bf2f {
    constructor(...args){
        super(...args), this.name = 'Fore Color', this.command = 'foreColor', this.colorName = 'color';
    }
}
class $59574e52e8f49fa6$export$92bb6183e7459be2 extends $59574e52e8f49fa6$export$ba9bbe5370f1bf2f {
    constructor(...args){
        super(...args), this.name = 'Back Color', this.command = 'backColor', this.colorName = 'backgroundColor';
    }
}
var $59574e52e8f49fa6$var$$258f24df7a3cbf67$exports = {};
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$258f24df7a3cbf67$exports, "AlignTool", function() {
    return $59574e52e8f49fa6$export$6c1211091eb3b68f;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$258f24df7a3cbf67$exports, "AlignLeftTool", function() {
    return $59574e52e8f49fa6$export$42a444ebfdcfe7b9;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$258f24df7a3cbf67$exports, "AlignCenterTool", function() {
    return $59574e52e8f49fa6$export$9a2e6e0294a984eb;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$258f24df7a3cbf67$exports, "AlignRightTool", function() {
    return $59574e52e8f49fa6$export$22363f91860fc258;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$258f24df7a3cbf67$exports, "AlignFullTool", function() {
    return $59574e52e8f49fa6$export$42827b1362fed748;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$258f24df7a3cbf67$exports, "OrderedListTool", function() {
    return $59574e52e8f49fa6$export$faf4e70f09f43a15;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$258f24df7a3cbf67$exports, "UnorderedListTool", function() {
    return $59574e52e8f49fa6$export$cf4030b57a3fbe37;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$258f24df7a3cbf67$exports, "HorizontalRuleTool", function() {
    return $59574e52e8f49fa6$export$dce8a7d6279fc201;
});
class $59574e52e8f49fa6$export$6c1211091eb3b68f extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    get active() {
        if (super.getActive()) return true;
        const box = $59574e52e8f49fa6$export$ac81f1ba58a5f363();
        return !!box && getComputedStyle(box).textAlign === this.align;
    }
}
class $59574e52e8f49fa6$export$42a444ebfdcfe7b9 extends $59574e52e8f49fa6$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Left', this.command = 'justifyLeft', this.align = 'left';
    }
}
class $59574e52e8f49fa6$export$9a2e6e0294a984eb extends $59574e52e8f49fa6$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Center', this.command = 'justifyCenter', this.align = 'center';
    }
}
class $59574e52e8f49fa6$export$22363f91860fc258 extends $59574e52e8f49fa6$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Right', this.command = 'justifyRight', this.align = 'right';
    }
}
class $59574e52e8f49fa6$export$42827b1362fed748 extends $59574e52e8f49fa6$export$6c1211091eb3b68f {
    constructor(...args){
        super(...args), this.name = 'Align Full', this.command = 'justifyFull', this.align = 'justify';
    }
}
class $59574e52e8f49fa6$export$faf4e70f09f43a15 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Ordered list', this.tags = [
            'ol'
        ], this.command = 'insertOrderedList';
    }
}
class $59574e52e8f49fa6$export$cf4030b57a3fbe37 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Unordered list', this.tags = [
            'ul'
        ], this.command = 'insertUnorderedList';
    }
}
class $59574e52e8f49fa6$export$dce8a7d6279fc201 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Horizontal rule', this.tags = [
            'hr'
        ], this.command = 'insertHorizontalRule';
    }
}
var $59574e52e8f49fa6$var$$0769f8c709024b7a$exports = {};
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$0769f8c709024b7a$exports, "IFrameTool", function() {
    return $59574e52e8f49fa6$export$3e557574863db086;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$0769f8c709024b7a$exports, "ImageTool", function() {
    return $59574e52e8f49fa6$export$982f47444a2f88da;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$0769f8c709024b7a$exports, "AudioTool", function() {
    return $59574e52e8f49fa6$export$6024938f37e646f8;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$0769f8c709024b7a$exports, "VideoTool", function() {
    return $59574e52e8f49fa6$export$932111b8028f79ed;
});
class $59574e52e8f49fa6$export$3e557574863db086 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    execute(editor) {
        const path = self.prompt('Path');
        if (path) this.edit(editor, `<iframe style="width: 100%; height: 50vh; border: none" src="${path}"></iframe>`);
    }
    constructor(...args){
        super(...args), this.name = 'Embed Web page', this.tags = [
            'iframe'
        ], this.command = 'insertHTML';
    }
}
class $59574e52e8f49fa6$export$982f47444a2f88da extends $59574e52e8f49fa6$export$de3122b2484864a7 {
    codeOf(path) {
        return `<img style="max-width: 100%; height: auto" src="${path}"/>`;
    }
    constructor(...args){
        super(...args), this.name = 'Image', this.tags = [
            'img'
        ], this.command = 'insertHTML';
    }
}
class $59574e52e8f49fa6$export$6024938f37e646f8 extends $59574e52e8f49fa6$export$de3122b2484864a7 {
    codeOf(path) {
        return `<audio controls src="${path}"></audio>`;
    }
    constructor(...args){
        super(...args), this.name = 'Audio', this.tags = [
            'audio'
        ], this.command = 'insertHTML';
    }
}
class $59574e52e8f49fa6$export$932111b8028f79ed extends $59574e52e8f49fa6$export$de3122b2484864a7 {
    codeOf(path) {
        return `<video controls src="${path}"></video>`;
    }
    constructor(...args){
        super(...args), this.name = 'Video', this.tags = [
            'video'
        ], this.command = 'insertHTML';
    }
}
var $59574e52e8f49fa6$var$$2c12cf671c105d76$exports = {};
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$2c12cf671c105d76$exports, "UndoTool", function() {
    return $59574e52e8f49fa6$export$65235875731ff287;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$2c12cf671c105d76$exports, "RedoTool", function() {
    return $59574e52e8f49fa6$export$b60f30d254d1e1a6;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$2c12cf671c105d76$exports, "ResetTool", function() {
    return $59574e52e8f49fa6$export$6f46dc3d81fbb4bd;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$2c12cf671c105d76$exports, "ClearTool", function() {
    return $59574e52e8f49fa6$export$25eb377ce1feaada;
});
class $59574e52e8f49fa6$export$65235875731ff287 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Undo', this.command = 'undo';
    }
}
class $59574e52e8f49fa6$export$b60f30d254d1e1a6 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Redo', this.command = 'redo';
    }
}
class $59574e52e8f49fa6$export$6f46dc3d81fbb4bd extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    constructor(...args){
        super(...args), this.name = 'Reset', this.command = 'removeFormat';
    }
}
class $59574e52e8f49fa6$export$25eb377ce1feaada extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    execute(editor) {
        editor.focus();
        document.execCommand('selectAll');
        document.execCommand('delete');
    }
    constructor(...args){
        super(...args), this.name = 'Clear';
    }
}
var $59574e52e8f49fa6$var$$6e883fb0ea04260a$exports = {};
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$6e883fb0ea04260a$exports, "turndown", function() {
    return $59574e52e8f49fa6$export$48d4d6bf65314082;
});
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$6e883fb0ea04260a$exports, "CopyMarkdownTool", function() {
    return $59574e52e8f49fa6$export$4b13df0a6effdd72;
});
const $59574e52e8f49fa6$var$$6e883fb0ea04260a$var$Empty_HREF = /^(#|javascript:\s*void\(0\);?\s*)$/;
const $59574e52e8f49fa6$export$48d4d6bf65314082 = new (0, $2e2e793cc84f35c5$export$2e2bcd8739ae039)({
    hr: '---',
    linkStyle: 'referenced',
    headingStyle: 'atx',
    bulletListMarker: '-',
    codeBlockStyle: 'fenced'
}).use((0, $39f19696fbebc560$export$19426ff118fe8be)).use((0, $39f19696fbebc560$export$cc4ff83fc7bd256e)).use((0, $39f19696fbebc560$export$1f0c2747e2ba0b8d)).use((0, $39f19696fbebc560$export$59ffe8c4d7a4aab2)).addRule('non_url', {
    filter: (node)=>[
            'a',
            'area'
        ].includes(node.nodeName.toLowerCase()) && $59574e52e8f49fa6$var$$6e883fb0ea04260a$var$Empty_HREF.test(node.getAttribute('href') || ''),
    replacement: ()=>''
}).addRule('img-srcset', {
    filter: [
        'img'
    ],
    replacement (_, { alt: alt, title: title, src: src, srcset: srcset }) {
        const [firstSet] = srcset.split(',')[0]?.split(/\s+/) || [];
        const content = [
            src || firstSet,
            title && JSON.stringify(title)
        ].filter(Boolean);
        return `![${alt}](${content.join(' ')})`;
    }
}).addRule('source-srcset', {
    filter: [
        'picture'
    ],
    replacement (_, node) {
        const { src: src, alt: alt, title: title } = node.querySelector('img') || {};
        const sourceList = [
            ...node.querySelectorAll('source')
        ].map(({ sizes: sizes, srcset: srcset })=>{
            const size = Math.max(...sizes.split(/,|\)/).map((pixel)=>parseFloat(pixel.trim())).filter(Boolean));
            const [src] = srcset.split(',')[0]?.split(/\s+/) || [];
            return {
                size: size,
                src: src
            };
        });
        const sources = sourceList.sort(({ size: a }, { size: b })=>b - a);
        const content = [
            src || sources[0]?.src,
            title && JSON.stringify(title)
        ].filter(Boolean);
        return `![${alt}](${content.join(' ')})`;
    }
}).remove((node)=>node.matches('style, script, aside, form, [class*="ads" i]')).keep((node)=>node.matches('kbd, iframe'));
class $59574e52e8f49fa6$export$4b13df0a6effdd72 extends $59574e52e8f49fa6$export$724f6b867059ef5f {
    async execute({ innerHTML: innerHTML }) {
        const markdown = $59574e52e8f49fa6$export$48d4d6bf65314082.turndown(innerHTML);
        await navigator.clipboard.writeText(markdown);
        alert('Markdown copied to clipboard');
    }
    constructor(...args){
        super(...args), this.name = 'Copy Markdown';
    }
}
var $59574e52e8f49fa6$var$$b738b8c7b1139833$exports = {};
$59574e52e8f49fa6$var$$parcel$export($59574e52e8f49fa6$var$$b738b8c7b1139833$exports, "editor", function() {
    return $59574e52e8f49fa6$export$b5d042d2b680aed6;
});
const $59574e52e8f49fa6$export$b5d042d2b680aed6 = (Class, {})=>class EditorTrait extends Class {
        async uploadFile(tool, data) {
            if (typeof data === 'string' && !/^(data|blob):/.test(data)) return data;
            try {
                return await tool.save(typeof data === 'string' ? await (0, $iob0w.blobOf)(data) : data);
            } catch (error) {
                console.error(error);
                if (typeof data === 'string') return data;
            }
        }
        async clearHTML(markup) {
            const { imageTool: imageTool, audioTool: audioTool, videoTool: videoTool } = this, fragment = document.createDocumentFragment();
            fragment.append(...(0, $iob0w.parseDOM)(markup));
            for (const element of (0, $iob0w.walkDOM)(fragment, Node.ELEMENT_NODE)){
                const { style: style, dataset: dataset } = element;
                if ([
                    'nowrap',
                    'pre'
                ].includes(style.whiteSpace)) style.whiteSpace = 'normal';
                for(const key in dataset)delete dataset[key];
                if (element instanceof HTMLImageElement && imageTool) element.src = await this.uploadFile(imageTool, element.src);
                else if (element instanceof HTMLAudioElement && audioTool) element.src = await this.uploadFile(audioTool, element.src);
                else if (element instanceof HTMLVideoElement && videoTool) element.src = await this.uploadFile(videoTool, element.src);
            }
            return fragment;
        }
        async transferMedia(item) {
            const { imageTool: imageTool, audioTool: audioTool, videoTool: videoTool } = this;
            if (item.type === 'text/html') {
                const raw = await new Promise((resolve)=>item.getAsString(resolve));
                (0, $iob0w.insertToCursor)(await this.clearHTML(raw));
            } else if (item.type.startsWith('image/') && imageTool) {
                const URI = await this.uploadFile(imageTool, item.getAsFile());
                if (URI) (0, $iob0w.insertToCursor)((0, $iob0w.parseDOM)(`<img src="${URI}" />`)[0]);
            } else if (item.type.startsWith('audio/') && audioTool) {
                const URI = await this.uploadFile(audioTool, item.getAsFile());
                if (URI) (0, $iob0w.insertToCursor)((0, $iob0w.parseDOM)(`<audio src="${URI}" />`)[0]);
            } else if (item.type.startsWith('video/') && videoTool) {
                const URI = await this.uploadFile(videoTool, item.getAsFile());
                if (URI) (0, $iob0w.insertToCursor)((0, $iob0w.parseDOM)(`<video src="${URI}" />`)[0]);
            }
        }
        constructor(...args){
            super(...args), this.handlePasteDrop = async (event)=>{
                event.preventDefault();
                const root = event.currentTarget;
                const list = event.type === 'paste' ? [
                    ...event.clipboardData.items
                ] : [
                    ...event.dataTransfer.items
                ];
                root.focus();
                const [plainText, htmlText] = list.filter(({ type: type })=>type.startsWith('text/'));
                if (!htmlText && plainText.type === 'text/plain') {
                    const raw = await new Promise((resolve)=>plainText.getAsString(resolve));
                    (0, $iob0w.insertToCursor)(await this.clearHTML((0, $7b384be9e21c489d$export$db8f131360c543a5)(raw)));
                } else for (const item of list)await this.transferMedia(item);
                this.updateValue(root.innerHTML);
            };
        }
    };







var $cF2Ke = parcelRequire("cF2Ke");

var $d5c6a664e7eeafd6$exports = {};








var $ddVow = parcelRequire("ddVow");

var $cF2Ke = parcelRequire("cF2Ke");
parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");

var $iob0w = parcelRequire("iob0w");
function $d5c6a664e7eeafd6$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $d5c6a664e7eeafd6$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $d5c6a664e7eeafd6$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $d5c6a664e7eeafd6$var$$0172b398bee57f0a$exports = {};
$d5c6a664e7eeafd6$var$$parcel$export($d5c6a664e7eeafd6$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $d5c6a664e7eeafd6$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $d5c6a664e7eeafd6$var$$parcel$export($d5c6a664e7eeafd6$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $d5c6a664e7eeafd6$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, $ = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: $.get,
            set: $.set
        } : $[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && ($.get = c), (c = i(v.set)) && ($.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : $[l] = c);
    }
    u && Object.defineProperty(u, a.name, $), f = !0;
}, $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $d5c6a664e7eeafd6$var$$0172b398bee57f0a$export$7112c88e033533b8 = function(e, t) {
    return $d5c6a664e7eeafd6$var$$parcel$interopDefault($ddVow)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $d5c6a664e7eeafd6$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, u, $ = $3lE4N.Component, f = [], d = [], b = [], p = [], v = [], _ = [];
    return r = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), a.set(e, $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__runInitializers(e, f, e.props)), s.set(e, ($d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__runInitializers(e, d), $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__runInitializers(e, b, e.state))), n.set(e, ($d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__runInitializers(e, p), $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__runInitializers(e, v, e.context))), $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__runInitializers(e, _), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function() {
                    return $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "observedState",
                get: function() {
                    return $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function() {
                    return $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function(e) {
                    $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, r, a) {
                    var s;
                    $d5c6a664e7eeafd6$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $d5c6a664e7eeafd6$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }($), a = new WeakMap, s = new WeakMap, n = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, o = [
        (e = $cF2Ke.observable).shallow.bind(e)
    ], l = [
        (i = $cF2Ke.observable).shallow.bind(i)
    ], u = [
        (c = $cF2Ke.observable).shallow.bind(c)
    ], $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__esDecorate(r, null, o, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedProps" in e;
            },
            get: function(e) {
                return e.observedProps;
            },
            set: function(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, f, d), $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedState" in e;
            },
            get: function(e) {
                return e.observedState;
            },
            set: function(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, b, p), $d5c6a664e7eeafd6$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedContext" in e;
            },
            get: function(e) {
                return e.observedContext;
            },
            set: function(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, v, _), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$exports = {};
$d5c6a664e7eeafd6$var$$parcel$export($d5c6a664e7eeafd6$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, $ = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: $.get,
            set: $.set
        } : $[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && ($.get = c), (c = i(v.set)) && ($.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : $[l] = c);
    }
    u && Object.defineProperty(u, a.name, $), f = !0;
}, $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], u = [], $ = [];
    return e = function(e) {
        "use strict";
        function n() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, n), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__runInitializers(e, l), (0, $3lE4N.createRef)())
            }), s.set(e, $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__runInitializers(e, u, e.props.defaultValue)), t.set(e, $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__runInitializers(e, $)), r.set(e, void 0), a.set(e, function(t) {
                !(0, $iob0w.isEmpty)(t) && (0, $iob0w.isEmpty)(e.innerValue) && (e.innerValue = t);
            }), Object.defineProperty(e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r, a;
                    return null == (a = (r = e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "object" ? (0, $cF2Ke.toJS)(t) : t);
                }
            }), Object.defineProperty(e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    return e.innerValue = e.props.defaultValue;
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(n, e), (0, $30088f375ab7517b$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function() {
                    return $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function() {
                    var e;
                    return null != (e = this.observedProps.value) ? e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e, s, n = this;
                    $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $cF2Ke.reaction)(function() {
                        return n.observedProps.defaultValue;
                    }, $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $cF2Ke.reaction)(function() {
                        return n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (e = this.ref.current) ? void 0 : e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e, a, s, n;
                    null == (e = $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || e.call(this), $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (n = null == (s = this.ref.current) ? void 0 : s.form) || n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($d5c6a664e7eeafd6$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $d5c6a664e7eeafd6$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $cF2Ke.observable
    ], i = [
        $cF2Ke.computed
    ], $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "innerValue" in e;
            },
            get: function(e) {
                return e.innerValue;
            },
            set: function(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, u, $), $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "value" in e;
            },
            get: function(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$d5c6a664e7eeafd6$var$$parcel$exportWildcard($d5c6a664e7eeafd6$exports, $d5c6a664e7eeafd6$var$$0172b398bee57f0a$exports), $d5c6a664e7eeafd6$var$$parcel$exportWildcard($d5c6a664e7eeafd6$exports, $d5c6a664e7eeafd6$var$$621b7277d4dc39e9$exports);


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
function $75acd277c1ee9d2f$var$$parcel$exportWildcard(e, r) {
    return Object.keys(r).forEach(function(c) {
        "default" === c || "__esModule" === c || Object.prototype.hasOwnProperty.call(e, c) || Object.defineProperty(e, c, {
            enumerable: !0,
            get: function() {
                return r[c];
            }
        });
    }), e;
}
function $75acd277c1ee9d2f$var$$parcel$export(e, r, c, t) {
    Object.defineProperty(e, r, {
        get: c,
        set: t,
        enumerable: !0,
        configurable: !0
    });
}
var $75acd277c1ee9d2f$var$$73a8882fd67c0324$exports = {};
function $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363(e) {
    var r = this, c = this.title, t = this.active, a = this.icon, $ = this.usable;
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("button", {
        type: "button",
        title: c,
        className: "btn btn-".concat((t ? "" : "outline-") + "secondary", " me-2 mb-2"),
        style: {
            cursor: $ ? "pointer" : "not-allowed"
        },
        disabled: !$,
        onClick: function(c) {
            c.preventDefault(), e.current && r.execute(e.current);
        },
        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("i", {
            className: "bi-".concat(a)
        })
    }, a);
}
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$73a8882fd67c0324$exports, "renderTool", function() {
    return $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363;
});
var $75acd277c1ee9d2f$var$$a01145bb2edfc771$exports = {};
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, "TextTools", function() {
    return $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$e252ba763eff5cdc;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, "ColorTools", function() {
    return $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$bdef6e97a10dbad4;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, "LayoutTools", function() {
    return $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$145c1b37c0810d7;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, "MediaTools", function() {
    return $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$999636c6e25075fb;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, "ControlTools", function() {
    return $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$f35db4b82786c3a4;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, "ExtraTools", function() {
    return $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$b8ecf7d74432d529;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, "OriginalTools", function() {
    return $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$9ddb256264948609;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, "DefaultTools", function() {
    return $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$aa718db1466ce312;
});
var $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports = {};
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "BoldTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "ItalicTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "UnderlineTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "StrikeThroughTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "H1Tool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "H2Tool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$58443375efa91029;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "H3Tool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "FontSizeDownTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "FontSizeUpTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "SubscriptTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$6137518b4e998008;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "SuperscriptTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports, "LinkTool", function() {
    return $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66;
});
var $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-bold"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$10056a49e3b218eb), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-italic"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$edf99d0f51bacb1e), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-underline"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$4b6d9c17188960d2), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-strikethrough"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$a35bffaeae8fdda0), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h1"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$30e8c6b428f8749f), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$58443375efa91029 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h2"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$58443375efa91029), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "type-h3"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$75d24d6b8b747307), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "sort-alpha-down"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$a20806c6ef6938f8), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "sort-alpha-up"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$744da7e24e4a7382), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$6137518b4e998008 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "box-arrow-down-right"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$6137518b4e998008), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "box-arrow-up-right"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$7217f06c61ebd4fc), $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "link"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$f6c54364b5332e66), $75acd277c1ee9d2f$var$$b1f503bd59fa3427$exports = {};
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$b1f503bd59fa3427$exports, "ColorSelector", function() {
    return $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$9012acaf449cdfcb;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$b1f503bd59fa3427$exports, "renderColorTool", function() {
    return $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$b1f503bd59fa3427$exports, "ForeColorTool", function() {
    return $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$b1f503bd59fa3427$exports, "BackColorTool", function() {
    return $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$92bb6183e7459be2;
});
var $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$9012acaf449cdfcb = function(e) {
    var r = e.className, c = e.title, t = e.type, a = e.value, $ = e.onChange, o = e.icon;
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
        className: "d-inline-block align-middle position-relative ".concat(void 0 === r ? "" : r),
        title: c,
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
                className: "position-absolute w-100 h-100 start-0 top-0 z-n1 rounded-3",
                type: "color",
                value: a,
                onChange: function(e) {
                    var r = e.target.value;
                    return null == $ ? void 0 : $(r);
                }
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("button", {
                className: "btn",
                style: {
                    color: "color" === t ? a : "lightgray",
                    backgroundColor: "color" === t ? "white" : a,
                    borderColor: a
                },
                onClick: function(e) {
                    e.preventDefault(), e.currentTarget.previousElementSibling.click();
                },
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("i", {
                    className: "bi-".concat(o)
                })
            })
        ]
    });
};
function $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29(e) {
    var r = this, c = this.icon, t = this.name, a = this.colorName;
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$9012acaf449cdfcb, {
        className: "me-2 mb-2",
        title: t,
        icon: c,
        type: a,
        value: this.getColor(),
        onChange: function(c) {
            return e.current && r.execute(e.current, c);
        }
    }, c);
}
var $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-font"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$cab0e15cfb8489d7), $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$92bb6183e7459be2 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-font-fill"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$e913fac2ab7b6f29
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$92bb6183e7459be2), $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports = {};
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports, "AlignLeftTool", function() {
    return $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports, "AlignCenterTool", function() {
    return $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports, "AlignRightTool", function() {
    return $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$22363f91860fc258;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports, "AlignFullTool", function() {
    return $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$42827b1362fed748;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports, "OrderedListTool", function() {
    return $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports, "UnorderedListTool", function() {
    return $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports, "HorizontalRuleTool", function() {
    return $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201;
});
var $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-left"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$42a444ebfdcfe7b9), $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-center"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$9a2e6e0294a984eb), $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$22363f91860fc258 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "text-right"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$22363f91860fc258), $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$42827b1362fed748 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "justify"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$42827b1362fed748), $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "list-ol"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$faf4e70f09f43a15), $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "list-ul"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$cf4030b57a3fbe37), $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "reception-0"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$dce8a7d6279fc201), $75acd277c1ee9d2f$var$$345f51138f435756$exports = {};
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$345f51138f435756$exports, "IFrameTool", function() {
    return $75acd277c1ee9d2f$var$$345f51138f435756$export$3e557574863db086;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$345f51138f435756$exports, "ImageTool", function() {
    return $75acd277c1ee9d2f$var$$345f51138f435756$export$982f47444a2f88da;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$345f51138f435756$exports, "AudioTool", function() {
    return $75acd277c1ee9d2f$var$$345f51138f435756$export$6024938f37e646f8;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$345f51138f435756$exports, "VideoTool", function() {
    return $75acd277c1ee9d2f$var$$345f51138f435756$export$932111b8028f79ed;
});
var $75acd277c1ee9d2f$var$$345f51138f435756$export$3e557574863db086 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "window"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$3e557574863db086), $75acd277c1ee9d2f$var$$345f51138f435756$export$982f47444a2f88da = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "image"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$982f47444a2f88da), $75acd277c1ee9d2f$var$$345f51138f435756$export$6024938f37e646f8 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "voicemail"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$6024938f37e646f8), $75acd277c1ee9d2f$var$$345f51138f435756$export$932111b8028f79ed = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "camera-video"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$932111b8028f79ed), $75acd277c1ee9d2f$var$$15eac7d4db191f2f$exports = {};
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$15eac7d4db191f2f$exports, "UndoTool", function() {
    return $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$65235875731ff287;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$15eac7d4db191f2f$exports, "RedoTool", function() {
    return $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$15eac7d4db191f2f$exports, "ResetTool", function() {
    return $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd;
}), $75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$15eac7d4db191f2f$exports, "ClearTool", function() {
    return $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$25eb377ce1feaada;
});
var $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$65235875731ff287 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "arrow-counterclockwise"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$65235875731ff287), $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "arrow-clockwise"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$b60f30d254d1e1a6), $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "eraser"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$6f46dc3d81fbb4bd), $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$25eb377ce1feaada = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "file-earmark-x"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$25eb377ce1feaada), $75acd277c1ee9d2f$var$$b9bef41109a8f18c$exports = {};
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$b9bef41109a8f18c$exports, "CopyMarkdownTool", function() {
    return $75acd277c1ee9d2f$var$$b9bef41109a8f18c$export$4b13df0a6effdd72;
});
var $75acd277c1ee9d2f$var$$b9bef41109a8f18c$export$4b13df0a6effdd72 = function(e) {
    "use strict";
    function r() {
        var e;
        return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "icon", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "markdown"
        }), Object.defineProperty(e, "render", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $75acd277c1ee9d2f$var$$73a8882fd67c0324$export$56ccecc1dac11363
        }), e;
    }
    return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), r;
}($59574e52e8f49fa6$export$4b13df0a6effdd72), $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$e252ba763eff5cdc = [
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$58443375efa91029,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$a20806c6ef6938f8,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$744da7e24e4a7382,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$6137518b4e998008,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$f6c54364b5332e66
], $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$bdef6e97a10dbad4 = [
    $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7,
    $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$92bb6183e7459be2
], $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$145c1b37c0810d7 = [
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$22363f91860fc258,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$42827b1362fed748,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201
], $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$999636c6e25075fb = [
    $75acd277c1ee9d2f$var$$345f51138f435756$export$3e557574863db086,
    $75acd277c1ee9d2f$var$$345f51138f435756$export$982f47444a2f88da,
    $75acd277c1ee9d2f$var$$345f51138f435756$export$6024938f37e646f8,
    $75acd277c1ee9d2f$var$$345f51138f435756$export$932111b8028f79ed
], $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$f35db4b82786c3a4 = [
    $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$65235875731ff287,
    $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6,
    $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$6f46dc3d81fbb4bd,
    $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$25eb377ce1feaada
], $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$b8ecf7d74432d529 = [
    $75acd277c1ee9d2f$var$$b9bef41109a8f18c$export$4b13df0a6effdd72
], $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$9ddb256264948609 = (0, $ba6b19be90dbdadc$export$71511d61b312f219)($75acd277c1ee9d2f$var$$a01145bb2edfc771$export$e252ba763eff5cdc).concat((0, $ba6b19be90dbdadc$export$71511d61b312f219)($75acd277c1ee9d2f$var$$a01145bb2edfc771$export$bdef6e97a10dbad4), (0, $ba6b19be90dbdadc$export$71511d61b312f219)($75acd277c1ee9d2f$var$$a01145bb2edfc771$export$145c1b37c0810d7), (0, $ba6b19be90dbdadc$export$71511d61b312f219)($75acd277c1ee9d2f$var$$a01145bb2edfc771$export$999636c6e25075fb), (0, $ba6b19be90dbdadc$export$71511d61b312f219)($75acd277c1ee9d2f$var$$a01145bb2edfc771$export$f35db4b82786c3a4)), $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$aa718db1466ce312 = [
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$10056a49e3b218eb,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$edf99d0f51bacb1e,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$4b6d9c17188960d2,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$a35bffaeae8fdda0,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$30e8c6b428f8749f,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$58443375efa91029,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$75d24d6b8b747307,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$6137518b4e998008,
    $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$export$7217f06c61ebd4fc,
    $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$cab0e15cfb8489d7,
    $75acd277c1ee9d2f$var$$b1f503bd59fa3427$export$92bb6183e7459be2,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$42a444ebfdcfe7b9,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$9a2e6e0294a984eb,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$22363f91860fc258,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$42827b1362fed748,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$faf4e70f09f43a15,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$cf4030b57a3fbe37,
    $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$export$dce8a7d6279fc201,
    $75acd277c1ee9d2f$var$$345f51138f435756$export$982f47444a2f88da,
    $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$65235875731ff287,
    $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$b60f30d254d1e1a6,
    $75acd277c1ee9d2f$var$$15eac7d4db191f2f$export$25eb377ce1feaada
];
$75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, $75acd277c1ee9d2f$var$$fe2cab60e3c7ea35$exports), $75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, $75acd277c1ee9d2f$var$$b1f503bd59fa3427$exports), $75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, $75acd277c1ee9d2f$var$$eb30d0fbb9378b9a$exports), $75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, $75acd277c1ee9d2f$var$$345f51138f435756$exports), $75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, $75acd277c1ee9d2f$var$$15eac7d4db191f2f$exports), $75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$var$$a01145bb2edfc771$exports, $75acd277c1ee9d2f$var$$b9bef41109a8f18c$exports);
var $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$exports = {};
$75acd277c1ee9d2f$var$$parcel$export($75acd277c1ee9d2f$var$$68aab1d0e8e5016c$exports, "Editor", function() {
    return $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0;
});
var $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__runInitializers = function(e, r, c) {
    for(var t = arguments.length > 2, a = 0; a < r.length; a++)c = t ? r[a].call(e, c) : r[a].call(e);
    return t ? c : void 0;
}, $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__esDecorate = function(e, r, c, t, a, $) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var s, n = t.kind, l = "getter" === n ? "get" : "setter" === n ? "set" : "value", i = !r && e ? t.static ? e : e.prototype : null, u = r || (i ? Object.getOwnPropertyDescriptor(i, t.name) : {}), b = !1, p = c.length - 1; p >= 0; p--){
        var f = {};
        for(var d in t)f[d] = "access" === d ? {} : t[d];
        for(var d in t.access)f.access[d] = t.access[d];
        f.addInitializer = function(e) {
            if (b) throw TypeError("Cannot add initializers after decoration has completed");
            $.push(o(e || null));
        };
        var _ = (0, c[p])("accessor" === n ? {
            get: u.get,
            set: u.set
        } : u[l], f);
        if ("accessor" === n) {
            if (void 0 === _) continue;
            if (null === _ || (void 0 === _ ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(_)) !== "object") throw TypeError("Object expected");
            (s = o(_.get)) && (u.get = s), (s = o(_.set)) && (u.set = s), (s = o(_.init)) && a.unshift(s);
        } else (s = o(_)) && ("field" === n ? a.unshift(s) : u[l] = s);
    }
    i && Object.defineProperty(i, t.name, u), b = !0;
}, $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__setFunctionName = function(e, r, c) {
    return (void 0 === r ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(r)) === "symbol" && (r = r.description ? "[".concat(r.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: c ? "".concat(c, " ", r) : r
    });
}, $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet = function(e, r, c, t) {
    if ("a" === c && !t) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof r ? e !== r || !t : !r.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === c ? t : "a" === c ? t.call(e) : t ? t.value : r.get(e);
}, $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet = function(e, r, c, t, a) {
    if ("m" === t) throw TypeError("Private method is not writable");
    if ("a" === t && !a) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof r ? e !== r || !a : !r.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === t ? a.call(e, c) : a ? a.value = c : r.set(e, c), c;
}, $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0 = function() {
    var e, r, c, t, a, $, o, s, n, l, i = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149,
        $59574e52e8f49fa6$export$b5d042d2b680aed6
    ], u = [], b = $d5c6a664e7eeafd6$exports.FormComponent, p = [], f = [], d = [];
    return a = function(e) {
        "use strict";
        function r() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, r), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, r, arguments), Object.defineProperty(e, "box", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__runInitializers(e, p), (0, $3lE4N.createRef)())
            }), c.set(e, $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__runInitializers(e, f, "")), Object.defineProperty(e, "updateTools", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__runInitializers(e, d), function() {
                    if (e.box.current === document.activeElement) {
                        var r, c = (getSelection().getRangeAt(0) || {}).endContainer, t = (null == (r = c instanceof Element ? c : c.parentElement) ? void 0 : r.getBoundingClientRect()) || {};
                        e.cursorPoint = [
                            t.x,
                            t.y
                        ] + "";
                    }
                })
            }), Object.defineProperty(e, "updateValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(r) {
                    return e.innerValue = r.trim();
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(r, e), (0, $30088f375ab7517b$export$71511d61b312f219)(r, [
            {
                key: "cursorPoint",
                get: function() {
                    return $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet(this, c, "f");
                },
                set: function(e) {
                    $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet(this, c, e, "f");
                }
            },
            {
                key: "toolList",
                get: function() {
                    return (this.observedProps.tools || $75acd277c1ee9d2f$var$$a01145bb2edfc771$export$aa718db1466ce312).map(function(e) {
                        return new e;
                    });
                }
            },
            {
                key: "imageTool",
                get: function() {
                    return this.toolList.find(function(e) {
                        return e instanceof $59574e52e8f49fa6$export$982f47444a2f88da;
                    });
                }
            },
            {
                key: "audioTool",
                get: function() {
                    return this.toolList.find(function(e) {
                        return e instanceof $75acd277c1ee9d2f$var$$345f51138f435756$export$6024938f37e646f8;
                    });
                }
            },
            {
                key: "videoTool",
                get: function() {
                    return this.toolList.find(function(e) {
                        return e instanceof $75acd277c1ee9d2f$var$$345f51138f435756$export$932111b8028f79ed;
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(r.prototype), "componentDidMount", this).call(this);
                    var e = this.props.defaultValue;
                    null != e && (this.box.current.innerHTML = e), document.addEventListener("selectionchange", this.updateTools);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(r.prototype), "componentWillUnmount", this).call(this), document.removeEventListener("selectionchange", this.updateTools);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this;
                    this.cursorPoint;
                    var r = this.toolList, c = this.innerValue, t = this.props.name;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("header", {
                                children: r.map(function(r) {
                                    return r.render(e.box);
                                })
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                ref: this.box,
                                className: "form-control h-auto",
                                contentEditable: !0,
                                onInput: function(r) {
                                    var c = r.currentTarget.innerHTML;
                                    return e.updateValue(c);
                                },
                                onPaste: this.handlePasteDrop,
                                onDrop: this.handlePasteDrop
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: t,
                                value: c
                            })
                        ]
                    });
                }
            }
        ]), r;
    }(b), c = new WeakMap, $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__setFunctionName(a, "Editor"), r = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = b[Symbol.metadata]) ? e : null) : void 0, $ = [
        $cF2Ke.observable
    ], o = [
        $cF2Ke.computed
    ], s = [
        $cF2Ke.computed
    ], n = [
        $cF2Ke.computed
    ], l = [
        $cF2Ke.computed
    ], $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, $, {
        kind: "accessor",
        name: "cursorPoint",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "cursorPoint" in e;
            },
            get: function(e) {
                return e.cursorPoint;
            },
            set: function(e, r) {
                e.cursorPoint = r;
            }
        },
        metadata: r
    }, f, d), $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, o, {
        kind: "getter",
        name: "toolList",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "toolList" in e;
            },
            get: function(e) {
                return e.toolList;
            }
        },
        metadata: r
    }, null, p), $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, s, {
        kind: "getter",
        name: "imageTool",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "imageTool" in e;
            },
            get: function(e) {
                return e.imageTool;
            }
        },
        metadata: r
    }, null, p), $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, n, {
        kind: "getter",
        name: "audioTool",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "audioTool" in e;
            },
            get: function(e) {
                return e.audioTool;
            }
        },
        metadata: r
    }, null, p), $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__esDecorate(a, null, l, {
        kind: "getter",
        name: "videoTool",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "videoTool" in e;
            },
            get: function(e) {
                return e.videoTool;
            }
        },
        metadata: r
    }, null, p), $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__esDecorate(null, t = {
        value: a
    }, i, {
        kind: "class",
        name: a.name,
        metadata: r
    }, null, u), a = t.value, r && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Editor"
    }), $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$var$__runInitializers(a, u), a;
}();
$75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$exports, $75acd277c1ee9d2f$var$$73a8882fd67c0324$exports), $75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$exports, $75acd277c1ee9d2f$var$$a01145bb2edfc771$exports), $75acd277c1ee9d2f$var$$parcel$exportWildcard($75acd277c1ee9d2f$exports, $75acd277c1ee9d2f$var$$68aab1d0e8e5016c$exports);



(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-code__textarea{min-height:200px;font-family:Menlo,Monaco,Consolas,Courier New,monospace;color:#41314e;line-height:1.6em;font-size:12px;background:#f8f7fa;border:1px solid #f1f1f4;box-shadow:none;white-space:pre;word-wrap:normal;overflow-x:auto;resize:vertical}")), document.head.appendChild(e);
        }
    } catch (o) {
        console.error("vite-plugin-css-injected-by-js", o);
    }
})();
function $4ab125ac4290e6d4$var$c(l, t) {
    let a = "";
    for(; a !== `
` && t > 0;)t = t - 1, a = l.substr(t, 1);
    return a === `
` && (t += 1), t;
}
const $4ab125ac4290e6d4$var$h = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 8L5 12L9 16"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 8L19 12L15 16"/></svg>';
/**
 * CodeTool for Editor.js
 * @version 2.0.0
 * @license MIT
 */ class $4ab125ac4290e6d4$export$2e2bcd8739ae039 {
    /**
   * Notify core that read-only mode is supported
   * @returns true if read-only mode is supported
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Allows pressing Enter key to create line breaks inside the CodeTool textarea
   * This enables multi-line input within the code editor.
   * @returns true if line breaks are allowed in the textarea
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   * @param options - tool constricting options
   * @param options.data — previously saved plugin code
   * @param options.config - user config for Tool
   * @param options.api - Editor.js API
   * @param options.readOnly - read only mode flag
   */ constructor({ data: t, config: e, api: a, readOnly: s }){
        this.api = a, this.readOnly = s, this.placeholder = this.api.i18n.t(e.placeholder || $4ab125ac4290e6d4$export$2e2bcd8739ae039.DEFAULT_PLACEHOLDER), this.CSS = {
            baseClass: this.api.styles.block,
            input: this.api.styles.input,
            wrapper: "ce-code",
            textarea: "ce-code__textarea"
        }, this.nodes = {
            holder: null,
            textarea: null
        }, this.data = {
            code: t.code ?? ""
        }, this.nodes.holder = this.drawView();
    }
    /**
   * Return Tool's view
   * @returns this.nodes.holder - Code's wrapper
   */ render() {
        return this.nodes.holder;
    }
    /**
   * Extract Tool's data from the view
   * @param codeWrapper - CodeTool's wrapper, containing textarea with code
   * @returns - saved plugin code
   */ save(t) {
        return {
            code: t.querySelector("textarea").value
        };
    }
    /**
   * onPaste callback fired from Editor`s core
   * @param event - event with pasted content
   */ onPaste(t) {
        switch(t.type){
            case "tag":
                {
                    const e = t.detail.data;
                    this.handleHTMLPaste(e);
                    break;
                }
        }
    }
    /**
   * Returns Tool`s data from private property
   * @returns
   */ get data() {
        return this._data;
    }
    /**
   * Set Tool`s data to private property and update view
   * @param data - saved tool data
   */ set data(t) {
        this._data = t, this.nodes.textarea && (this.nodes.textarea.value = t.code);
    }
    /**
   * Get Tool toolbox settings.
   * Provides the icon and title to display in the toolbox for the CodeTool.
   * @returns An object containing:
   * - icon: SVG representation of the Tool's icon
   * - title: Title to show in the toolbox
   */ static get toolbox() {
        return {
            icon: $4ab125ac4290e6d4$var$h,
            title: "Code"
        };
    }
    /**
   * Default placeholder for CodeTool's textarea
   * @returns
   */ static get DEFAULT_PLACEHOLDER() {
        return "Enter a code";
    }
    /**
   *  Used by Editor.js paste handling API.
   *  Provides configuration to handle CODE tag.
   * @returns
   */ static get pasteConfig() {
        return {
            tags: [
                "pre"
            ]
        };
    }
    /**
   * Automatic sanitize config
   * @returns
   */ static get sanitize() {
        return {
            code: !0
        };
    }
    /**
   * Handles Tab key pressing (adds/removes indentations)
   * @param event - keydown
   */ tabHandler(t) {
        t.stopPropagation(), t.preventDefault();
        const e = t.target, a = t.shiftKey, s = e.selectionStart, r = e.value, n = "  ";
        let i;
        if (!a) i = s + n.length, e.value = r.substring(0, s) + n + r.substring(s);
        else {
            const o = $4ab125ac4290e6d4$var$c(r, s);
            if (r.substr(o, n.length) !== n) return;
            e.value = r.substring(0, o) + r.substring(o + n.length), i = s - n.length;
        }
        e.setSelectionRange(i, i);
    }
    /**
   * Create Tool's view
   * @returns
   */ drawView() {
        const t = document.createElement("div"), e = document.createElement("textarea");
        return t.classList.add(this.CSS.baseClass, this.CSS.wrapper), e.classList.add(this.CSS.textarea, this.CSS.input), e.value = this.data.code, e.placeholder = this.placeholder, this.readOnly && (e.disabled = !0), t.appendChild(e), e.addEventListener("keydown", (a)=>{
            switch(a.code){
                case "Tab":
                    this.tabHandler(a);
                    break;
            }
        }), this.nodes.textarea = e, t;
    }
    /**
   * Extracts the code content from the pasted element's innerHTML and populates the tool's data.
   * @param element - pasted HTML element
   */ handleHTMLPaste(t) {
        this.data = {
            code: t.innerHTML
        };
    }
}


(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-header{padding:.6em 0 3px;margin:0;line-height:1.25em;outline:none}.ce-header p,.ce-header div{padding:0!important;margin:0!important}")), document.head.appendChild(e);
        }
    } catch (n) {
        console.error("vite-plugin-css-injected-by-js", n);
    }
})();
const $6fb349d32be9584f$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19 17V10.2135C19 10.1287 18.9011 10.0824 18.836 10.1367L16 12.5"/></svg>', $6fb349d32be9584f$var$h = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 11C16 10 19 9.5 19 12C19 13.9771 16.0684 13.9997 16.0012 16.8981C15.9999 16.9533 16.0448 17 16.1 17L19.3 17"/></svg>', $6fb349d32be9584f$var$d = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 11C16 10.5 16.8323 10 17.6 10C18.3677 10 19.5 10.311 19.5 11.5C19.5 12.5315 18.7474 12.9022 18.548 12.9823C18.5378 12.9864 18.5395 13.0047 18.5503 13.0063C18.8115 13.0456 20 13.3065 20 14.8C20 16 19.5 17 17.8 17C17.8 17 16 17 16 16.3"/></svg>', $6fb349d32be9584f$var$c = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 10L15.2834 14.8511C15.246 14.9178 15.294 15 15.3704 15C16.8489 15 18.7561 15 20.2 15M19 17C19 15.7187 19 14.8813 19 13.6"/></svg>', $6fb349d32be9584f$var$u = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 15.9C16 15.9 16.3768 17 17.8 17C19.5 17 20 15.6199 20 14.7C20 12.7323 17.6745 12.0486 16.1635 12.9894C16.094 13.0327 16 12.9846 16 12.9027V10.1C16 10.0448 16.0448 10 16.1 10H19.8"/></svg>', $6fb349d32be9584f$var$g = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6 7L6 12M6 17L6 12M6 12L12 12M12 7V12M12 17L12 12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M19.5 10C16.5 10.5 16 13.3285 16 15M16 15V15C16 16.1046 16.8954 17 18 17H18.3246C19.3251 17 20.3191 16.3492 20.2522 15.3509C20.0612 12.4958 16 12.6611 16 15Z"/></svg>', $6fb349d32be9584f$var$v = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 7L9 12M9 17V12M9 12L15 12M15 7V12M15 17L15 12"/></svg>';
/**
 * Header block for the Editor.js.
 *
 * @author CodeX (team@ifmo.su)
 * @copyright CodeX 2018
 * @license MIT
 * @version 2.0.0
 */ class $6fb349d32be9584f$export$2e2bcd8739ae039 {
    constructor({ data: e, config: t, api: s, readOnly: r }){
        this.api = s, this.readOnly = r, this._config = t ?? null, this._data = this.normalizeData(e), this._element = this.getTag();
    }
    /**
   * Styles
   */ get _CSS() {
        return {
            block: this.api.styles.block,
            wrapper: "ce-header"
        };
    }
    /**
   * Check if data is valid
   * 
   * @param {any} data - data to check
   * @returns {data is HeaderData}
   * @private
   */ isHeaderData(e) {
        return e.text !== void 0;
    }
    /**
   * Normalize input data
   *
   * @param {HeaderData} data - saved data to process
   *
   * @returns {HeaderData}
   * @private
   */ normalizeData(e) {
        const t = {
            text: "",
            level: this.defaultLevel.number
        };
        return this.isHeaderData(e) && (t.text = e.text || "", e.level !== void 0 && !isNaN(parseInt(e.level.toString())) && (t.level = parseInt(e.level.toString()))), t;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLHeadingElement}
   * @public
   */ render() {
        return this._element;
    }
    /**
   * Returns header block tunes config
   *
   * @returns {Array}
   */ renderSettings() {
        return this.levels.map((e)=>({
                icon: e.svg,
                label: this.api.i18n.t(`Heading ${e.number}`),
                onActivate: ()=>this.setLevel(e.number),
                closeOnActivate: !0,
                isActive: this.currentLevel.number === e.number,
                render: ()=>document.createElement("div")
            }));
    }
    /**
   * Callback for Block's settings buttons
   *
   * @param {number} level - level to set
   */ setLevel(e) {
        this.data = {
            level: e,
            text: this.data.text
        };
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {HeaderData} data - saved data to merger with current block
   * @public
   */ merge(e) {
        this._element.insertAdjacentHTML("beforeend", e.text);
    }
    /**
   * Validate Text block data:
   * - check for emptiness
   *
   * @param {HeaderData} blockData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(e) {
        return e.text.trim() !== "";
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLHeadingElement} toolsContent - Text tools rendered view
   * @returns {HeaderData} - saved data
   * @public
   */ save(e) {
        return {
            text: e.innerHTML,
            level: this.currentLevel.number
        };
    }
    /**
   * Allow Header to be converted to/from other blocks
   */ static get conversionConfig() {
        return {
            export: "text",
            // use 'text' property for other blocks
            import: "text"
        };
    }
    /**
   * Sanitizer Rules
   */ static get sanitize() {
        return {
            level: !1,
            text: {}
        };
    }
    /**
   * Returns true to notify core that read-only is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Get current Tools`s data
   *
   * @returns {HeaderData} Current data
   * @private
   */ get data() {
        return this._data.text = this._element.innerHTML, this._data.level = this.currentLevel.number, this._data;
    }
    /**
   * Store data in plugin:
   * - at the this._data property
   * - at the HTML
   *
   * @param {HeaderData} data — data to set
   * @private
   */ set data(e) {
        if (this._data = this.normalizeData(e), e.level !== void 0 && this._element.parentNode) {
            const t = this.getTag();
            t.innerHTML = this._element.innerHTML, this._element.parentNode.replaceChild(t, this._element), this._element = t;
        }
        e.text !== void 0 && (this._element.innerHTML = this._data.text || "");
    }
    /**
   * Get tag for target level
   * By default returns second-leveled header
   *
   * @returns {HTMLElement}
   */ getTag() {
        var t;
        const e = document.createElement(this.currentLevel.tag);
        return e.innerHTML = this._data.text || "", e.classList.add(this._CSS.wrapper), e.contentEditable = this.readOnly ? "false" : "true", e.dataset.placeholder = this.api.i18n.t(((t = this._config) == null ? void 0 : t.placeholder) || ""), e;
    }
    /**
   * Get current level
   *
   * @returns {level}
   */ get currentLevel() {
        let e = this.levels.find((t)=>t.number === this._data.level);
        return e || (e = this.defaultLevel), e;
    }
    /**
   * Return default level
   *
   * @returns {level}
   */ get defaultLevel() {
        var e;
        if ((e = this._config) != null && e.defaultLevel) {
            const t = this.levels.find((s)=>{
                var r;
                return s.number === ((r = this._config) == null ? void 0 : r.defaultLevel);
            });
            if (t) return t;
            console.warn("(\u0E07'\u0300-'\u0301)\u0E07 Heading Tool: the default level specified was not found in available levels");
        }
        return this.levels[1];
    }
    /**
   * @typedef {object} level
   * @property {number} number - level number
   * @property {string} tag - tag corresponds with level number
   * @property {string} svg - icon
   */ /**
   * Available header levels
   *
   * @returns {level[]}
   */ get levels() {
        var t;
        const e = [
            {
                number: 1,
                tag: "H1",
                svg: $6fb349d32be9584f$var$a
            },
            {
                number: 2,
                tag: "H2",
                svg: $6fb349d32be9584f$var$h
            },
            {
                number: 3,
                tag: "H3",
                svg: $6fb349d32be9584f$var$d
            },
            {
                number: 4,
                tag: "H4",
                svg: $6fb349d32be9584f$var$c
            },
            {
                number: 5,
                tag: "H5",
                svg: $6fb349d32be9584f$var$u
            },
            {
                number: 6,
                tag: "H6",
                svg: $6fb349d32be9584f$var$g
            }
        ];
        return (t = this._config) != null && t.levels ? e.filter((s)=>{
            var r;
            return (r = this._config) == null ? void 0 : r.levels.includes(s.number);
        }) : e;
    }
    /**
   * Handle H1-H6 tags on paste to substitute it with header Tool
   *
   * @param {PasteEvent} event - event with pasted content
   */ onPaste(e) {
        var s, r;
        const t = e.detail;
        if ("data" in t) {
            const i = t.data;
            let n = this.defaultLevel.number;
            switch(i.tagName){
                case "H1":
                    n = 1;
                    break;
                case "H2":
                    n = 2;
                    break;
                case "H3":
                    n = 3;
                    break;
                case "H4":
                    n = 4;
                    break;
                case "H5":
                    n = 5;
                    break;
                case "H6":
                    n = 6;
                    break;
            }
            (s = this._config) != null && s.levels && (n = (r = this._config) == null ? void 0 : r.levels.reduce((o, l)=>Math.abs(l - n) < Math.abs(o - n) ? l : o)), this.data = {
                level: n,
                text: i.innerHTML
            };
        }
    }
    /**
   * Used by Editor.js paste handling API.
   * Provides configuration to handle H1-H6 tags.
   *
   * @returns {{handler: (function(HTMLElement): {text: string}), tags: string[]}}
   */ static get pasteConfig() {
        return {
            tags: [
                "H1",
                "H2",
                "H3",
                "H4",
                "H5",
                "H6"
            ]
        };
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @returns {{icon: string, title: string}}
   */ static get toolbox() {
        return {
            icon: $6fb349d32be9584f$var$v,
            title: "Heading"
        };
    }
}


(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var o = document.createElement("style");
            o.appendChild(document.createTextNode('.image-tool{--bg-color: #cdd1e0;--front-color: #388ae5;--border-color: #e8e8eb}.image-tool__image{border-radius:3px;overflow:hidden;margin-bottom:10px;padding-bottom:0}.image-tool__image-picture{max-width:100%;vertical-align:bottom;display:block}.image-tool__image-preloader{width:50px;height:50px;border-radius:50%;background-size:cover;margin:auto;position:relative;background-color:var(--bg-color);background-position:center center}.image-tool__image-preloader:after{content:"";position:absolute;z-index:3;width:60px;height:60px;border-radius:50%;border:2px solid var(--bg-color);border-top-color:var(--front-color);left:50%;top:50%;margin-top:-30px;margin-left:-30px;animation:image-preloader-spin 2s infinite linear;box-sizing:border-box}.image-tool__caption{visibility:hidden;position:absolute;bottom:0;left:0;margin-bottom:10px}.image-tool__caption[contentEditable=true][data-placeholder]:before{position:absolute!important;content:attr(data-placeholder);color:#707684;font-weight:400;display:none}.image-tool__caption[contentEditable=true][data-placeholder]:empty:before{display:block}.image-tool__caption[contentEditable=true][data-placeholder]:empty:focus:before{display:none}.image-tool--empty .image-tool__image,.image-tool--empty .image-tool__image-preloader{display:none}.image-tool--empty .image-tool__caption,.image-tool--uploading .image-tool__caption{visibility:hidden!important}.image-tool .cdx-button{display:flex;align-items:center;justify-content:center}.image-tool .cdx-button svg{height:auto;margin:0 6px 0 0}.image-tool--filled .cdx-button,.image-tool--filled .image-tool__image-preloader{display:none}.image-tool--uploading .image-tool__image{min-height:200px;display:flex;border:1px solid var(--border-color);background-color:#fff}.image-tool--uploading .image-tool__image-picture,.image-tool--uploading .cdx-button{display:none}.image-tool--withBorder .image-tool__image{border:1px solid var(--border-color)}.image-tool--withBackground .image-tool__image{padding:15px;background:var(--bg-color)}.image-tool--withBackground .image-tool__image-picture{max-width:60%;margin:0 auto}.image-tool--stretched .image-tool__image-picture{width:100%}.image-tool--caption .image-tool__caption{visibility:visible}.image-tool--caption{padding-bottom:50px}@keyframes image-preloader-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}')), document.head.appendChild(o);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $7e68ce1142d8dc67$var$R = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19V19C9.13623 19 8.20435 19 7.46927 18.6955C6.48915 18.2895 5.71046 17.5108 5.30448 16.5307C5 15.7956 5 14.8638 5 13V12C5 9.19108 5 7.78661 5.67412 6.77772C5.96596 6.34096 6.34096 5.96596 6.77772 5.67412C7.78661 5 9.19108 5 12 5H13.5C14.8956 5 15.5933 5 16.1611 5.17224C17.4395 5.56004 18.44 6.56046 18.8278 7.83886C19 8.40666 19 9.10444 19 10.5V10.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 13V16M16 19V16M19 16H16M16 16H13"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6.5 17.5L17.5 6.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.9919 10.5H19.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.9919 19H11.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13L13 5"/></svg>', $7e68ce1142d8dc67$var$I = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.9919 9.5H19.0015"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.5 5H14.5096"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.625 5H15C17.2091 5 19 6.79086 19 9V9.375"/><path stroke="currentColor" stroke-width="2" d="M9.375 5L9 5C6.79086 5 5 6.79086 5 9V9.375"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.3725 5H9.38207"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 9.5H5.00957"/><path stroke="currentColor" stroke-width="2" d="M9.375 19H9C6.79086 19 5 17.2091 5 15V14.625"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.3725 19H9.38207"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 14.55H5.00957"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 13V16M16 19V16M19 16H16M16 16H13"/></svg>', $7e68ce1142d8dc67$var$L = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.13968 15.32L8.69058 11.5661C9.02934 11.2036 9.48873 11 9.96774 11C10.4467 11 10.9061 11.2036 11.2449 11.5661L15.3871 16M13.5806 14.0664L15.0132 12.533C15.3519 12.1705 15.8113 11.9668 16.2903 11.9668C16.7693 11.9668 17.2287 12.1705 17.5675 12.533L18.841 13.9634"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.7778 9.33331H13.7867"/></svg>', $7e68ce1142d8dc67$var$x = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9L20 12L17 15"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 12H20"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 9L4 12L7 15"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 12H10"/></svg>', $7e68ce1142d8dc67$var$B = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $7e68ce1142d8dc67$var$S(C, i = null, a = {}) {
    const s = document.createElement(C);
    Array.isArray(i) ? s.classList.add(...i) : i !== null && s.classList.add(i);
    for(const r in a)a.hasOwnProperty(r) && (s[r] = a[r]);
    return s;
}
var $7e68ce1142d8dc67$var$_ = /* @__PURE__ */ ((C)=>(C.Empty = "empty", C.Uploading = "uploading", C.Filled = "filled", C))($7e68ce1142d8dc67$var$_ || {});
class $7e68ce1142d8dc67$var$D {
    /**
   * @param ui - image tool Ui module
   * @param ui.api - Editor.js API
   * @param ui.config - user config
   * @param ui.onSelectFile - callback for clicks on Select file button
   * @param ui.readOnly - read-only mode flag
   */ constructor({ api: i, config: a, onSelectFile: s, readOnly: r }){
        this.api = i, this.config = a, this.onSelectFile = s, this.readOnly = r, this.nodes = {
            wrapper: $7e68ce1142d8dc67$var$S("div", [
                this.CSS.baseClass,
                this.CSS.wrapper
            ]),
            imageContainer: $7e68ce1142d8dc67$var$S("div", [
                this.CSS.imageContainer
            ]),
            fileButton: this.createFileButton(),
            imageEl: void 0,
            imagePreloader: $7e68ce1142d8dc67$var$S("div", this.CSS.imagePreloader),
            caption: $7e68ce1142d8dc67$var$S("div", [
                this.CSS.input,
                this.CSS.caption
            ], {
                contentEditable: !this.readOnly
            })
        }, this.nodes.caption.dataset.placeholder = this.config.captionPlaceholder, this.nodes.imageContainer.appendChild(this.nodes.imagePreloader), this.nodes.wrapper.appendChild(this.nodes.imageContainer), this.nodes.wrapper.appendChild(this.nodes.caption), this.nodes.wrapper.appendChild(this.nodes.fileButton);
    }
    /**
   * Apply visual representation of activated tune
   * @param tuneName - one of available tunes {@link Tunes.tunes}
   * @param status - true for enable, false for disable
   */ applyTune(i, a) {
        this.nodes.wrapper.classList.toggle(`${this.CSS.wrapper}--${i}`, a);
    }
    /**
   * Renders tool UI
   */ render() {
        return this.toggleStatus("empty"), this.nodes.wrapper;
    }
    /**
   * Shows uploading preloader
   * @param src - preview source
   */ showPreloader(i) {
        this.nodes.imagePreloader.style.backgroundImage = `url(${i})`, this.toggleStatus("uploading");
    }
    /**
   * Hide uploading preloader
   */ hidePreloader() {
        this.nodes.imagePreloader.style.backgroundImage = "", this.toggleStatus("empty");
    }
    /**
   * Shows an image
   * @param url - image source
   */ fillImage(i) {
        const a = /\.mp4$/.test(i) ? "VIDEO" : "IMG", s = {
            src: i
        };
        let r = "load";
        a === "VIDEO" && (s.autoplay = !0, s.loop = !0, s.muted = !0, s.playsinline = !0, r = "loadeddata"), this.nodes.imageEl = $7e68ce1142d8dc67$var$S(a, this.CSS.imageEl, s), this.nodes.imageEl.addEventListener(r, ()=>{
            this.toggleStatus("filled"), this.nodes.imagePreloader !== void 0 && (this.nodes.imagePreloader.style.backgroundImage = "");
        }), this.nodes.imageContainer.appendChild(this.nodes.imageEl);
    }
    /**
   * Shows caption input
   * @param text - caption content text
   */ fillCaption(i) {
        this.nodes.caption !== void 0 && (this.nodes.caption.innerHTML = i);
    }
    /**
   * Changes UI status
   * @param status - see {@link Ui.status} constants
   */ toggleStatus(i) {
        for(const a in $7e68ce1142d8dc67$var$_)if (Object.prototype.hasOwnProperty.call($7e68ce1142d8dc67$var$_, a)) {
            const s = $7e68ce1142d8dc67$var$_[a];
            this.nodes.wrapper.classList.toggle(`${this.CSS.wrapper}--${s}`, s === i);
        }
    }
    /**
   * CSS classes
   */ get CSS() {
        return {
            baseClass: this.api.styles.block,
            loading: this.api.styles.loader,
            input: this.api.styles.input,
            button: this.api.styles.button,
            /**
       * Tool's classes
       */ wrapper: "image-tool",
            imageContainer: "image-tool__image",
            imagePreloader: "image-tool__image-preloader",
            imageEl: "image-tool__image-picture",
            caption: "image-tool__caption"
        };
    }
    /**
   * Creates upload-file button
   */ createFileButton() {
        const i = $7e68ce1142d8dc67$var$S("div", [
            this.CSS.button
        ]);
        return i.innerHTML = this.config.buttonContent ?? `${$7e68ce1142d8dc67$var$L} ${this.api.i18n.t("Select an Image")}`, i.addEventListener("click", ()=>{
            this.onSelectFile();
        }), i;
    }
}
function $7e68ce1142d8dc67$var$U(C) {
    return C && C.__esModule && Object.prototype.hasOwnProperty.call(C, "default") ? C.default : C;
}
var $7e68ce1142d8dc67$var$H = {
    exports: {}
};
(function(C, i) {
    (function(a, s) {
        C.exports = s();
    })(window, function() {
        return function(a) {
            var s = {};
            function r(o) {
                if (s[o]) return s[o].exports;
                var e = s[o] = {
                    i: o,
                    l: !1,
                    exports: {}
                };
                return a[o].call(e.exports, e, e.exports, r), e.l = !0, e.exports;
            }
            return r.m = a, r.c = s, r.d = function(o, e, d) {
                r.o(o, e) || Object.defineProperty(o, e, {
                    enumerable: !0,
                    get: d
                });
            }, r.r = function(o) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(o, "__esModule", {
                    value: !0
                });
            }, r.t = function(o, e) {
                if (1 & e && (o = r(o)), 8 & e || 4 & e && typeof o == "object" && o && o.__esModule) return o;
                var d = /* @__PURE__ */ Object.create(null);
                if (r.r(d), Object.defineProperty(d, "default", {
                    enumerable: !0,
                    value: o
                }), 2 & e && typeof o != "string") for(var v in o)r.d(d, v, (function(l) {
                    return o[l];
                }).bind(null, v));
                return d;
            }, r.n = function(o) {
                var e = o && o.__esModule ? function() {
                    return o.default;
                } : function() {
                    return o;
                };
                return r.d(e, "a", e), e;
            }, r.o = function(o, e) {
                return Object.prototype.hasOwnProperty.call(o, e);
            }, r.p = "", r(r.s = 3);
        }([
            function(a, s) {
                var r;
                r = /* @__PURE__ */ function() {
                    return this;
                }();
                try {
                    r = r || new Function("return this")();
                } catch  {
                    typeof window == "object" && (r = window);
                }
                a.exports = r;
            },
            function(a, s, r) {
                (function(o) {
                    var e = r(2), d = setTimeout;
                    function v() {}
                    function l(n) {
                        if (!(this instanceof l)) throw new TypeError("Promises must be constructed via new");
                        if (typeof n != "function") throw new TypeError("not a function");
                        this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], t(n, this);
                    }
                    function f(n, c) {
                        for(; n._state === 3;)n = n._value;
                        n._state !== 0 ? (n._handled = !0, l._immediateFn(function() {
                            var u = n._state === 1 ? c.onFulfilled : c.onRejected;
                            if (u !== null) {
                                var g;
                                try {
                                    g = u(n._value);
                                } catch (m) {
                                    return void y(c.promise, m);
                                }
                                p(c.promise, g);
                            } else (n._state === 1 ? p : y)(c.promise, n._value);
                        })) : n._deferreds.push(c);
                    }
                    function p(n, c) {
                        try {
                            if (c === n) throw new TypeError("A promise cannot be resolved with itself.");
                            if (c && (typeof c == "object" || typeof c == "function")) {
                                var u = c.then;
                                if (c instanceof l) return n._state = 3, n._value = c, void w(n);
                                if (typeof u == "function") return void t((g = u, m = c, function() {
                                    g.apply(m, arguments);
                                }), n);
                            }
                            n._state = 1, n._value = c, w(n);
                        } catch (h) {
                            y(n, h);
                        }
                        var g, m;
                    }
                    function y(n, c) {
                        n._state = 2, n._value = c, w(n);
                    }
                    function w(n) {
                        n._state === 2 && n._deferreds.length === 0 && l._immediateFn(function() {
                            n._handled || l._unhandledRejectionFn(n._value);
                        });
                        for(var c = 0, u = n._deferreds.length; c < u; c++)f(n, n._deferreds[c]);
                        n._deferreds = null;
                    }
                    function b(n, c, u) {
                        this.onFulfilled = typeof n == "function" ? n : null, this.onRejected = typeof c == "function" ? c : null, this.promise = u;
                    }
                    function t(n, c) {
                        var u = !1;
                        try {
                            n(function(g) {
                                u || (u = !0, p(c, g));
                            }, function(g) {
                                u || (u = !0, y(c, g));
                            });
                        } catch (g) {
                            if (u) return;
                            u = !0, y(c, g);
                        }
                    }
                    l.prototype.catch = function(n) {
                        return this.then(null, n);
                    }, l.prototype.then = function(n, c) {
                        var u = new this.constructor(v);
                        return f(this, new b(n, c, u)), u;
                    }, l.prototype.finally = e.a, l.all = function(n) {
                        return new l(function(c, u) {
                            if (!n || n.length === void 0) throw new TypeError("Promise.all accepts an array");
                            var g = Array.prototype.slice.call(n);
                            if (g.length === 0) return c([]);
                            var m = g.length;
                            function h(T, E) {
                                try {
                                    if (E && (typeof E == "object" || typeof E == "function")) {
                                        var M = E.then;
                                        if (typeof M == "function") return void M.call(E, function(F) {
                                            h(T, F);
                                        }, u);
                                    }
                                    g[T] = E, --m == 0 && c(g);
                                } catch (F) {
                                    u(F);
                                }
                            }
                            for(var k = 0; k < g.length; k++)h(k, g[k]);
                        });
                    }, l.resolve = function(n) {
                        return n && typeof n == "object" && n.constructor === l ? n : new l(function(c) {
                            c(n);
                        });
                    }, l.reject = function(n) {
                        return new l(function(c, u) {
                            u(n);
                        });
                    }, l.race = function(n) {
                        return new l(function(c, u) {
                            for(var g = 0, m = n.length; g < m; g++)n[g].then(c, u);
                        });
                    }, l._immediateFn = typeof o == "function" && function(n) {
                        o(n);
                    } || function(n) {
                        d(n, 0);
                    }, l._unhandledRejectionFn = function(n) {
                        typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", n);
                    }, s.a = l;
                }).call(this, r(5).setImmediate);
            },
            function(a, s, r) {
                s.a = function(o) {
                    var e = this.constructor;
                    return this.then(function(d) {
                        return e.resolve(o()).then(function() {
                            return d;
                        });
                    }, function(d) {
                        return e.resolve(o()).then(function() {
                            return e.reject(d);
                        });
                    });
                };
            },
            function(a, s, r) {
                function o(t) {
                    return (o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
                        return typeof n;
                    } : function(n) {
                        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
                    })(t);
                }
                r(4);
                var e, d, v, l, f, p, y, w = r(8), b = (d = function(t) {
                    return new Promise(function(n, c) {
                        t = l(t), (t = f(t)).beforeSend && t.beforeSend();
                        var u = window.XMLHttpRequest ? new window.XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP");
                        u.open(t.method, t.url), u.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(t.headers).forEach(function(m) {
                            var h = t.headers[m];
                            u.setRequestHeader(m, h);
                        });
                        var g = t.ratio;
                        u.upload.addEventListener("progress", function(m) {
                            var h = Math.round(m.loaded / m.total * 100), k = Math.ceil(h * g / 100);
                            t.progress(Math.min(k, 100));
                        }, !1), u.addEventListener("progress", function(m) {
                            var h = Math.round(m.loaded / m.total * 100), k = Math.ceil(h * (100 - g) / 100) + g;
                            t.progress(Math.min(k, 100));
                        }, !1), u.onreadystatechange = function() {
                            if (u.readyState === 4) {
                                var m = u.response;
                                try {
                                    m = JSON.parse(m);
                                } catch  {}
                                var h = w.parseHeaders(u.getAllResponseHeaders()), k = {
                                    body: m,
                                    code: u.status,
                                    headers: h
                                };
                                y(u.status) ? n(k) : c(k);
                            }
                        }, u.send(t.data);
                    });
                }, v = function(t) {
                    return t.method = "POST", d(t);
                }, l = function() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    if (t.url && typeof t.url != "string") throw new Error("Url must be a string");
                    if (t.url = t.url || "", t.method && typeof t.method != "string") throw new Error("`method` must be a string or null");
                    if (t.method = t.method ? t.method.toUpperCase() : "GET", t.headers && o(t.headers) !== "object") throw new Error("`headers` must be an object or null");
                    if (t.headers = t.headers || {}, t.type && (typeof t.type != "string" || !Object.values(e).includes(t.type))) throw new Error("`type` must be taken from module's \xabcontentType\xbb library");
                    if (t.progress && typeof t.progress != "function") throw new Error("`progress` must be a function or null");
                    if (t.progress = t.progress || function(n) {}, t.beforeSend = t.beforeSend || function(n) {}, t.ratio && typeof t.ratio != "number") throw new Error("`ratio` must be a number");
                    if (t.ratio < 0 || t.ratio > 100) throw new Error("`ratio` must be in a 0-100 interval");
                    if (t.ratio = t.ratio || 90, t.accept && typeof t.accept != "string") throw new Error("`accept` must be a string with a list of allowed mime-types");
                    if (t.accept = t.accept || "*/*", t.multiple && typeof t.multiple != "boolean") throw new Error("`multiple` must be a true or false");
                    if (t.multiple = t.multiple || !1, t.fieldName && typeof t.fieldName != "string") throw new Error("`fieldName` must be a string");
                    return t.fieldName = t.fieldName || "files", t;
                }, f = function(t) {
                    switch(t.method){
                        case "GET":
                            var n = p(t.data, e.URLENCODED);
                            delete t.data, t.url = /\?/.test(t.url) ? t.url + "&" + n : t.url + "?" + n;
                            break;
                        case "POST":
                        case "PUT":
                        case "DELETE":
                        case "UPDATE":
                            var c = function() {
                                return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).type || e.JSON;
                            }(t);
                            (w.isFormData(t.data) || w.isFormElement(t.data)) && (c = e.FORM), t.data = p(t.data, c), c !== b.contentType.FORM && (t.headers["content-type"] = c);
                    }
                    return t;
                }, p = function() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    switch(arguments.length > 1 ? arguments[1] : void 0){
                        case e.URLENCODED:
                            return w.urlEncode(t);
                        case e.JSON:
                            return w.jsonEncode(t);
                        case e.FORM:
                            return w.formEncode(t);
                        default:
                            return t;
                    }
                }, y = function(t) {
                    return t >= 200 && t < 300;
                }, {
                    contentType: e = {
                        URLENCODED: "application/x-www-form-urlencoded; charset=utf-8",
                        FORM: "multipart/form-data",
                        JSON: "application/json; charset=utf-8"
                    },
                    request: d,
                    get: function(t) {
                        return t.method = "GET", d(t);
                    },
                    post: v,
                    transport: function(t) {
                        return t = l(t), w.selectFiles(t).then(function(n) {
                            for(var c = new FormData(), u = 0; u < n.length; u++)c.append(t.fieldName, n[u], n[u].name);
                            w.isObject(t.data) && Object.keys(t.data).forEach(function(m) {
                                var h = t.data[m];
                                c.append(m, h);
                            });
                            var g = t.beforeSend;
                            return t.beforeSend = function() {
                                return g(n);
                            }, t.data = c, v(t);
                        });
                    },
                    selectFiles: function(t) {
                        return delete (t = l(t)).beforeSend, w.selectFiles(t);
                    }
                });
                a.exports = b;
            },
            function(a, s, r) {
                r.r(s);
                var o = r(1);
                window.Promise = window.Promise || o.a;
            },
            function(a, s, r) {
                (function(o) {
                    var e = o !== void 0 && o || typeof self < "u" && self || window, d = Function.prototype.apply;
                    function v(l, f) {
                        this._id = l, this._clearFn = f;
                    }
                    s.setTimeout = function() {
                        return new v(d.call(setTimeout, e, arguments), clearTimeout);
                    }, s.setInterval = function() {
                        return new v(d.call(setInterval, e, arguments), clearInterval);
                    }, s.clearTimeout = s.clearInterval = function(l) {
                        l && l.close();
                    }, v.prototype.unref = v.prototype.ref = function() {}, v.prototype.close = function() {
                        this._clearFn.call(e, this._id);
                    }, s.enroll = function(l, f) {
                        clearTimeout(l._idleTimeoutId), l._idleTimeout = f;
                    }, s.unenroll = function(l) {
                        clearTimeout(l._idleTimeoutId), l._idleTimeout = -1;
                    }, s._unrefActive = s.active = function(l) {
                        clearTimeout(l._idleTimeoutId);
                        var f = l._idleTimeout;
                        f >= 0 && (l._idleTimeoutId = setTimeout(function() {
                            l._onTimeout && l._onTimeout();
                        }, f));
                    }, r(6), s.setImmediate = typeof self < "u" && self.setImmediate || o !== void 0 && o.setImmediate || this && this.setImmediate, s.clearImmediate = typeof self < "u" && self.clearImmediate || o !== void 0 && o.clearImmediate || this && this.clearImmediate;
                }).call(this, r(0));
            },
            function(a, s, r) {
                (function(o, e) {
                    (function(d, v) {
                        if (!d.setImmediate) {
                            var l, f, p, y, w, b = 1, t = {}, n = !1, c = d.document, u = Object.getPrototypeOf && Object.getPrototypeOf(d);
                            u = u && u.setTimeout ? u : d, ({}).toString.call(d.process) === "[object process]" ? l = function(h) {
                                e.nextTick(function() {
                                    m(h);
                                });
                            } : function() {
                                if (d.postMessage && !d.importScripts) {
                                    var h = !0, k = d.onmessage;
                                    return d.onmessage = function() {
                                        h = !1;
                                    }, d.postMessage("", "*"), d.onmessage = k, h;
                                }
                            }() ? (y = "setImmediate$" + Math.random() + "$", w = function(h) {
                                h.source === d && typeof h.data == "string" && h.data.indexOf(y) === 0 && m(+h.data.slice(y.length));
                            }, d.addEventListener ? d.addEventListener("message", w, !1) : d.attachEvent("onmessage", w), l = function(h) {
                                d.postMessage(y + h, "*");
                            }) : d.MessageChannel ? ((p = new MessageChannel()).port1.onmessage = function(h) {
                                m(h.data);
                            }, l = function(h) {
                                p.port2.postMessage(h);
                            }) : c && "onreadystatechange" in c.createElement("script") ? (f = c.documentElement, l = function(h) {
                                var k = c.createElement("script");
                                k.onreadystatechange = function() {
                                    m(h), k.onreadystatechange = null, f.removeChild(k), k = null;
                                }, f.appendChild(k);
                            }) : l = function(h) {
                                setTimeout(m, 0, h);
                            }, u.setImmediate = function(h) {
                                typeof h != "function" && (h = new Function("" + h));
                                for(var k = new Array(arguments.length - 1), T = 0; T < k.length; T++)k[T] = arguments[T + 1];
                                var E = {
                                    callback: h,
                                    args: k
                                };
                                return t[b] = E, l(b), b++;
                            }, u.clearImmediate = g;
                        }
                        function g(h) {
                            delete t[h];
                        }
                        function m(h) {
                            if (n) setTimeout(m, 0, h);
                            else {
                                var k = t[h];
                                if (k) {
                                    n = !0;
                                    try {
                                        (function(T) {
                                            var E = T.callback, M = T.args;
                                            switch(M.length){
                                                case 0:
                                                    E();
                                                    break;
                                                case 1:
                                                    E(M[0]);
                                                    break;
                                                case 2:
                                                    E(M[0], M[1]);
                                                    break;
                                                case 3:
                                                    E(M[0], M[1], M[2]);
                                                    break;
                                                default:
                                                    E.apply(v, M);
                                            }
                                        })(k);
                                    } finally{
                                        g(h), n = !1;
                                    }
                                }
                            }
                        }
                    })(typeof self > "u" ? o === void 0 ? this : o : self);
                }).call(this, r(0), r(7));
            },
            function(a, s) {
                var r, o, e = a.exports = {};
                function d() {
                    throw new Error("setTimeout has not been defined");
                }
                function v() {
                    throw new Error("clearTimeout has not been defined");
                }
                function l(u) {
                    if (r === setTimeout) return setTimeout(u, 0);
                    if ((r === d || !r) && setTimeout) return r = setTimeout, setTimeout(u, 0);
                    try {
                        return r(u, 0);
                    } catch  {
                        try {
                            return r.call(null, u, 0);
                        } catch  {
                            return r.call(this, u, 0);
                        }
                    }
                }
                (function() {
                    try {
                        r = typeof setTimeout == "function" ? setTimeout : d;
                    } catch  {
                        r = d;
                    }
                    try {
                        o = typeof clearTimeout == "function" ? clearTimeout : v;
                    } catch  {
                        o = v;
                    }
                })();
                var f, p = [], y = !1, w = -1;
                function b() {
                    y && f && (y = !1, f.length ? p = f.concat(p) : w = -1, p.length && t());
                }
                function t() {
                    if (!y) {
                        var u = l(b);
                        y = !0;
                        for(var g = p.length; g;){
                            for(f = p, p = []; ++w < g;)f && f[w].run();
                            w = -1, g = p.length;
                        }
                        f = null, y = !1, function(m) {
                            if (o === clearTimeout) return clearTimeout(m);
                            if ((o === v || !o) && clearTimeout) return o = clearTimeout, clearTimeout(m);
                            try {
                                o(m);
                            } catch  {
                                try {
                                    return o.call(null, m);
                                } catch  {
                                    return o.call(this, m);
                                }
                            }
                        }(u);
                    }
                }
                function n(u, g) {
                    this.fun = u, this.array = g;
                }
                function c() {}
                e.nextTick = function(u) {
                    var g = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var m = 1; m < arguments.length; m++)g[m - 1] = arguments[m];
                    p.push(new n(u, g)), p.length !== 1 || y || l(t);
                }, n.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.version = "", e.versions = {}, e.on = c, e.addListener = c, e.once = c, e.off = c, e.removeListener = c, e.removeAllListeners = c, e.emit = c, e.prependListener = c, e.prependOnceListener = c, e.listeners = function(u) {
                    return [];
                }, e.binding = function(u) {
                    throw new Error("process.binding is not supported");
                }, e.cwd = function() {
                    return "/";
                }, e.chdir = function(u) {
                    throw new Error("process.chdir is not supported");
                }, e.umask = function() {
                    return 0;
                };
            },
            function(a, s, r) {
                function o(d, v) {
                    for(var l = 0; l < v.length; l++){
                        var f = v[l];
                        f.enumerable = f.enumerable || !1, f.configurable = !0, "value" in f && (f.writable = !0), Object.defineProperty(d, f.key, f);
                    }
                }
                var e = r(9);
                a.exports = function() {
                    function d() {
                        (function(p, y) {
                            if (!(p instanceof y)) throw new TypeError("Cannot call a class as a function");
                        })(this, d);
                    }
                    var v, l, f;
                    return v = d, f = [
                        {
                            key: "urlEncode",
                            value: function(p) {
                                return e(p);
                            }
                        },
                        {
                            key: "jsonEncode",
                            value: function(p) {
                                return JSON.stringify(p);
                            }
                        },
                        {
                            key: "formEncode",
                            value: function(p) {
                                if (this.isFormData(p)) return p;
                                if (this.isFormElement(p)) return new FormData(p);
                                if (this.isObject(p)) {
                                    var y = new FormData();
                                    return Object.keys(p).forEach(function(w) {
                                        var b = p[w];
                                        y.append(w, b);
                                    }), y;
                                }
                                throw new Error("`data` must be an instance of Object, FormData or <FORM> HTMLElement");
                            }
                        },
                        {
                            key: "isObject",
                            value: function(p) {
                                return Object.prototype.toString.call(p) === "[object Object]";
                            }
                        },
                        {
                            key: "isFormData",
                            value: function(p) {
                                return p instanceof FormData;
                            }
                        },
                        {
                            key: "isFormElement",
                            value: function(p) {
                                return p instanceof HTMLFormElement;
                            }
                        },
                        {
                            key: "selectFiles",
                            value: function() {
                                var p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                return new Promise(function(y, w) {
                                    var b = document.createElement("INPUT");
                                    b.type = "file", p.multiple && b.setAttribute("multiple", "multiple"), p.accept && b.setAttribute("accept", p.accept), b.style.display = "none", document.body.appendChild(b), b.addEventListener("change", function(t) {
                                        var n = t.target.files;
                                        y(n), document.body.removeChild(b);
                                    }, !1), b.click();
                                });
                            }
                        },
                        {
                            key: "parseHeaders",
                            value: function(p) {
                                var y = p.trim().split(/[\r\n]+/), w = {};
                                return y.forEach(function(b) {
                                    var t = b.split(": "), n = t.shift(), c = t.join(": ");
                                    n && (w[n] = c);
                                }), w;
                            }
                        }
                    ], l = null, f && o(v, f), d;
                }();
            },
            function(a, s) {
                var r = function(e) {
                    return encodeURIComponent(e).replace(/[!'()*]/g, escape).replace(/%20/g, "+");
                }, o = function(e, d, v, l) {
                    return d = d || null, v = v || "&", l = l || null, e ? (function(f) {
                        for(var p = new Array(), y = 0; y < f.length; y++)f[y] && p.push(f[y]);
                        return p;
                    })(Object.keys(e).map(function(f) {
                        var p, y, w = f;
                        if (l && (w = l + "[" + w + "]"), typeof e[f] == "object" && e[f] !== null) p = o(e[f], null, v, w);
                        else {
                            d && (y = w, w = !isNaN(parseFloat(y)) && isFinite(y) ? d + Number(w) : w);
                            var b = e[f];
                            b = (b = (b = (b = b === !0 ? "1" : b) === !1 ? "0" : b) === 0 ? "0" : b) || "", p = r(w) + "=" + r(b);
                        }
                        return p;
                    })).join(v).replace(/[!'()*]/g, "") : "";
                };
                a.exports = o;
            }
        ]);
    });
})($7e68ce1142d8dc67$var$H);
var $7e68ce1142d8dc67$var$q = $7e68ce1142d8dc67$var$H.exports;
const $7e68ce1142d8dc67$var$j = /* @__PURE__ */ $7e68ce1142d8dc67$var$U($7e68ce1142d8dc67$var$q);
function $7e68ce1142d8dc67$var$O(C) {
    return C !== void 0 && typeof C.then == "function";
}
class $7e68ce1142d8dc67$var$A {
    /**
   * @param params - uploader module params
   * @param params.config - image tool config
   * @param params.onUpload - one callback for all uploading (file, url, d-n-d, pasting)
   * @param params.onError - callback for uploading errors
   */ constructor({ config: i, onUpload: a, onError: s }){
        this.config = i, this.onUpload = a, this.onError = s;
    }
    /**
   * Handle clicks on the upload file button
   * Fires ajax.transport()
   * @param onPreview - callback fired when preview is ready
   */ uploadSelectedFile({ onPreview: i }) {
        const a = function(r) {
            const o = new FileReader();
            o.readAsDataURL(r), o.onload = (e)=>{
                i(e.target.result);
            };
        };
        let s;
        if (this.config.uploader && typeof this.config.uploader.uploadByFile == "function") {
            const r = this.config.uploader.uploadByFile;
            s = $7e68ce1142d8dc67$var$j.selectFiles({
                accept: this.config.types ?? "image/*"
            }).then((o)=>{
                a(o[0]);
                const e = r(o[0]);
                return $7e68ce1142d8dc67$var$O(e) || console.warn("Custom uploader method uploadByFile should return a Promise"), e;
            });
        } else s = $7e68ce1142d8dc67$var$j.transport({
            url: this.config.endpoints.byFile,
            data: this.config.additionalRequestData,
            accept: this.config.types ?? "image/*",
            headers: this.config.additionalRequestHeaders,
            beforeSend: (r)=>{
                a(r[0]);
            },
            fieldName: this.config.field ?? "image"
        }).then((r)=>r.body);
        s.then((r)=>{
            this.onUpload(r);
        }).catch((r)=>{
            this.onError(r);
        });
    }
    /**
   * Handle clicks on the upload file button
   * Fires ajax.post()
   * @param url - image source url
   */ uploadByUrl(i) {
        let a;
        this.config.uploader && typeof this.config.uploader.uploadByUrl == "function" ? (a = this.config.uploader.uploadByUrl(i), $7e68ce1142d8dc67$var$O(a) || console.warn("Custom uploader method uploadByUrl should return a Promise")) : a = $7e68ce1142d8dc67$var$j.post({
            url: this.config.endpoints.byUrl,
            data: Object.assign({
                url: i
            }, this.config.additionalRequestData),
            type: $7e68ce1142d8dc67$var$j.contentType.JSON,
            headers: this.config.additionalRequestHeaders
        }).then((s)=>s.body), a.then((s)=>{
            this.onUpload(s);
        }).catch((s)=>{
            this.onError(s);
        });
    }
    /**
   * Handle clicks on the upload file button
   * Fires ajax.post()
   * @param file - file pasted by drag-n-drop
   * @param onPreview - file pasted by drag-n-drop
   */ uploadByFile(i, { onPreview: a }) {
        const s = new FileReader();
        s.readAsDataURL(i), s.onload = (o)=>{
            a(o.target.result);
        };
        let r;
        if (this.config.uploader && typeof this.config.uploader.uploadByFile == "function") r = this.config.uploader.uploadByFile(i), $7e68ce1142d8dc67$var$O(r) || console.warn("Custom uploader method uploadByFile should return a Promise");
        else {
            const o = new FormData();
            o.append(this.config.field ?? "image", i), this.config.additionalRequestData && Object.keys(this.config.additionalRequestData).length && Object.entries(this.config.additionalRequestData).forEach(([e, d])=>{
                o.append(e, d);
            }), r = $7e68ce1142d8dc67$var$j.post({
                url: this.config.endpoints.byFile,
                data: o,
                type: $7e68ce1142d8dc67$var$j.contentType.JSON,
                headers: this.config.additionalRequestHeaders
            }).then((e)=>e.body);
        }
        r.then((o)=>{
            this.onUpload(o);
        }).catch((o)=>{
            this.onError(o);
        });
    }
}
/**
 * Image Tool for the Editor.js
 * @author CodeX <team@codex.so>
 * @license MIT
 * @see {@link https://github.com/editor-js/image}
 *
 * To developers.
 * To simplify Tool structure, we split it to 4 parts:
 *  1) index.ts — main Tool's interface, public API and methods for working with data
 *  2) uploader.ts — module that has methods for sending files via AJAX: from device, by URL or File pasting
 *  3) ui.ts — module for UI manipulations: render, showing preloader, etc
 *
 * For debug purposes there is a testing server
 * that can save uploaded files and return a Response {@link UploadResponseFormat}
 *
 *       $ node dev/server.js
 *
 * It will expose 8008 port, so you can pass http://localhost:8008 with the Tools config:
 *
 * image: {
 *   class: ImageTool,
 *   config: {
 *     endpoints: {
 *       byFile: 'http://localhost:8008/uploadFile',
 *       byUrl: 'http://localhost:8008/fetchUrl',
 *     }
 *   },
 * },
 */ class $7e68ce1142d8dc67$export$2e2bcd8739ae039 {
    /**
   * @param tool - tool properties got from editor.js
   * @param tool.data - previously saved data
   * @param tool.config - user config for Tool
   * @param tool.api - Editor.js API
   * @param tool.readOnly - read-only mode flag
   * @param tool.block - current Block API
   */ constructor({ data: i, config: a, api: s, readOnly: r, block: o }){
        this.isCaptionEnabled = null, this.api = s, this.block = o, this.config = {
            endpoints: a.endpoints,
            additionalRequestData: a.additionalRequestData,
            additionalRequestHeaders: a.additionalRequestHeaders,
            field: a.field,
            types: a.types,
            captionPlaceholder: this.api.i18n.t(a.captionPlaceholder ?? "Caption"),
            buttonContent: a.buttonContent,
            uploader: a.uploader,
            actions: a.actions,
            features: a.features || {}
        }, this.uploader = new $7e68ce1142d8dc67$var$A({
            config: this.config,
            onUpload: (e)=>this.onUpload(e),
            onError: (e)=>this.uploadingFailed(e)
        }), this.ui = new $7e68ce1142d8dc67$var$D({
            api: s,
            config: this.config,
            onSelectFile: ()=>{
                this.uploader.uploadSelectedFile({
                    onPreview: (e)=>{
                        this.ui.showPreloader(e);
                    }
                });
            },
            readOnly: r
        }), this._data = {
            caption: "",
            withBorder: !1,
            withBackground: !1,
            stretched: !1,
            file: {
                url: ""
            }
        }, this.data = i;
    }
    /**
   * Notify core that read-only mode is supported
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   */ static get toolbox() {
        return {
            icon: $7e68ce1142d8dc67$var$L,
            title: "Image"
        };
    }
    /**
   * Available image tools
   */ static get tunes() {
        return [
            {
                name: "withBorder",
                icon: $7e68ce1142d8dc67$var$I,
                title: "With border",
                toggle: !0
            },
            {
                name: "stretched",
                icon: $7e68ce1142d8dc67$var$x,
                title: "Stretch image",
                toggle: !0
            },
            {
                name: "withBackground",
                icon: $7e68ce1142d8dc67$var$R,
                title: "With background",
                toggle: !0
            }
        ];
    }
    /**
   * Renders Block content
   */ render() {
        var i, a, s;
        return (((i = this.config.features) == null ? void 0 : i.caption) === !0 || ((a = this.config.features) == null ? void 0 : a.caption) === void 0 || ((s = this.config.features) == null ? void 0 : s.caption) === "optional" && this.data.caption) && (this.isCaptionEnabled = !0, this.ui.applyTune("caption", !0)), this.ui.render();
    }
    /**
   * Validate data: check if Image exists
   * @param savedData — data received after saving
   * @returns false if saved data is not correct, otherwise true
   */ validate(i) {
        return !!i.file.url;
    }
    /**
   * Return Block data
   */ save() {
        const i = this.ui.nodes.caption;
        return this._data.caption = i.innerHTML, this.data;
    }
    /**
   * Returns configuration for block tunes: add background, add border, stretch image
   * @returns TunesMenuConfig
   */ renderSettings() {
        var o;
        const i = $7e68ce1142d8dc67$export$2e2bcd8739ae039.tunes.concat(this.config.actions || []), a = {
            border: "withBorder",
            background: "withBackground",
            stretch: "stretched",
            caption: "caption"
        };
        ((o = this.config.features) == null ? void 0 : o.caption) === "optional" && i.push({
            name: "caption",
            icon: $7e68ce1142d8dc67$var$B,
            title: "With caption",
            toggle: !0
        });
        const s = i.filter((e)=>{
            var v, l;
            const d = Object.keys(a).find((f)=>a[f] === e.name);
            return d === "caption" ? ((v = this.config.features) == null ? void 0 : v.caption) !== !1 : d == null || ((l = this.config.features) == null ? void 0 : l[d]) !== !1;
        }), r = (e)=>{
            let d = this.data[e.name];
            return e.name === "caption" && (d = this.isCaptionEnabled ?? d), d;
        };
        return s.map((e)=>({
                icon: e.icon,
                label: this.api.i18n.t(e.title),
                name: e.name,
                toggle: e.toggle,
                isActive: r(e),
                onActivate: ()=>{
                    if (typeof e.action == "function") {
                        e.action(e.name);
                        return;
                    }
                    let d = !r(e);
                    e.name === "caption" && (this.isCaptionEnabled = !(this.isCaptionEnabled ?? !1), d = this.isCaptionEnabled), this.tuneToggled(e.name, d);
                }
            }));
    }
    /**
   * Fires after clicks on the Toolbox Image Icon
   * Initiates click on the Select File button
   */ appendCallback() {
        this.ui.nodes.fileButton.click();
    }
    /**
   * Specify paste substitutes
   * @see {@link https://github.com/codex-team/editor.js/blob/master/docs/tools.md#paste-handling}
   */ static get pasteConfig() {
        return {
            /**
       * Paste HTML into Editor
       */ tags: [
                {
                    img: {
                        src: !0
                    }
                }
            ],
            /**
       * Paste URL of image into the Editor
       */ patterns: {
                image: /https?:\/\/\S+\.(gif|jpe?g|tiff|png|svg|webp)(\?[a-z0-9=]*)?$/i
            },
            /**
       * Drag n drop file from into the Editor
       */ files: {
                mimeTypes: [
                    "image/*"
                ]
            }
        };
    }
    /**
   * Specify paste handlers
   * @see {@link https://github.com/codex-team/editor.js/blob/master/docs/tools.md#paste-handling}
   * @param event - editor.js custom paste event
   *                              {@link https://github.com/codex-team/editor.js/blob/master/types/tools/paste-events.d.ts}
   */ async onPaste(i) {
        switch(i.type){
            case "tag":
                {
                    const a = i.detail.data;
                    if (/^blob:/.test(a.src)) {
                        const r = await (await fetch(a.src)).blob();
                        this.uploadFile(r);
                        break;
                    }
                    this.uploadUrl(a.src);
                    break;
                }
            case "pattern":
                {
                    const a = i.detail.data;
                    this.uploadUrl(a);
                    break;
                }
            case "file":
                {
                    const a = i.detail.file;
                    this.uploadFile(a);
                    break;
                }
        }
    }
    /**
   * Private methods
   * ̿̿ ̿̿ ̿̿ ̿'̿'\̵͇̿̿\з= ( ▀ ͜͞ʖ▀) =ε/̵͇̿̿/’̿’̿ ̿ ̿̿ ̿̿ ̿̿
   */ /**
   * Stores all Tool's data
   * @param data - data in Image Tool format
   */ set data(i) {
        var a;
        this.image = i.file, this._data.caption = i.caption || "", this.ui.fillCaption(this._data.caption), $7e68ce1142d8dc67$export$2e2bcd8739ae039.tunes.forEach(({ name: s })=>{
            const r = typeof i[s] < "u" ? i[s] === !0 || i[s] === "true" : !1;
            this.setTune(s, r);
        }), i.caption ? this.setTune("caption", !0) : ((a = this.config.features) == null ? void 0 : a.caption) === !0 && this.setTune("caption", !0);
    }
    /**
   * Return Tool data
   */ get data() {
        return this._data;
    }
    /**
   * Set new image file
   * @param file - uploaded file data
   */ set image(i) {
        this._data.file = i || {
            url: ""
        }, i && i.url && this.ui.fillImage(i.url);
    }
    /**
   * File uploading callback
   * @param response - uploading server response
   */ onUpload(i) {
        i.success && i.file ? this.image = i.file : this.uploadingFailed("incorrect response: " + JSON.stringify(i));
    }
    /**
   * Handle uploader errors
   * @param errorText - uploading error info
   */ uploadingFailed(i) {
        console.log("Image Tool: uploading failed because of", i), this.api.notifier.show({
            message: this.api.i18n.t("Couldn\u2019t upload image. Please try another."),
            style: "error"
        }), this.ui.hidePreloader();
    }
    /**
   * Callback fired when Block Tune is activated
   * @param tuneName - tune that has been clicked
   * @param state - new state
   */ tuneToggled(i, a) {
        i === "caption" ? (this.ui.applyTune(i, a), a == !1 && (this._data.caption = "", this.ui.fillCaption(""))) : this.setTune(i, a);
    }
    /**
   * Set one tune
   * @param tuneName - {@link Tunes.tunes}
   * @param value - tune state
   */ setTune(i, a) {
        this._data[i] = a, this.ui.applyTune(i, a), i === "stretched" && Promise.resolve().then(()=>{
            this.block.stretched = a;
        }).catch((s)=>{
            console.error(s);
        });
    }
    /**
   * Show preloader and upload image file
   * @param file - file that is currently uploading (from paste)
   */ uploadFile(i) {
        this.uploader.uploadByFile(i, {
            onPreview: (a)=>{
                this.ui.showPreloader(a);
            }
        });
    }
    /**
   * Show preloader and upload image by target url
   * @param url - url pasted
   */ uploadUrl(i) {
        this.ui.showPreloader(i), this.uploader.uploadByUrl(i);
    }
}


(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var o = document.createElement("style");
            o.appendChild(document.createTextNode(`.link-tool{position:relative}.link-tool__input{padding-left:38px;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath stroke='%23707684' stroke-linecap='round' stroke-width='2' d='m7.7 12.6-.021.02a2.795 2.795 0 0 0-.044 4.005v0a2.795 2.795 0 0 0 3.936.006l1.455-1.438a3 3 0 0 0 .34-3.866l-.146-.207'/%3E%3Cpath stroke='%23707684' stroke-linecap='round' stroke-width='2' d='m16.22 11.12.136-.14c.933-.954.992-2.46.135-3.483v0a2.597 2.597 0 0 0-3.664-.32L11.39 8.386a3 3 0 0 0-.301 4.3l.031.034'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:10px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.link-tool__input-holder{position:relative}.link-tool__input-holder--error .link-tool__input{background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath stroke='rgb(224, 147, 147)' stroke-linecap='round' stroke-width='2' d='m7.7 12.6-.021.02a2.795 2.795 0 0 0-.044 4.005v0a2.795 2.795 0 0 0 3.936.006l1.455-1.438a3 3 0 0 0 .34-3.866l-.146-.207'/%3E%3Cpath stroke='rgb(224, 147, 147)' stroke-linecap='round' stroke-width='2' d='m16.22 11.12.136-.14c.933-.954.992-2.46.135-3.483v0a2.597 2.597 0 0 0-3.664-.32L11.39 8.386a3 3 0 0 0-.301 4.3l.031.034'/%3E%3C/svg%3E");background-color:#fff3f6;border-color:#f3e0e0;color:#a95a5a;box-shadow:inset 0 1px 3px #923e3e0d}.link-tool__input[contentEditable=true][data-placeholder]:before{position:absolute;content:attr(data-placeholder);color:#707684;font-weight:400;opacity:0}.link-tool__input[contentEditable=true][data-placeholder]:empty:before{opacity:1}.link-tool__input[contentEditable=true][data-placeholder]:empty:focus:before{opacity:0}.link-tool__progress{position:absolute;box-shadow:inset 0 1px 3px #66556b0a;height:100%;width:0;background-color:#f4f5f7;z-index:-1}.link-tool__progress--loading{-webkit-animation:progress .5s ease-in;-webkit-animation-fill-mode:forwards}.link-tool__progress--loaded{width:100%}.link-tool__content{display:block;padding:25px;border-radius:2px;box-shadow:0 0 0 2px #fff;color:initial!important;text-decoration:none!important}.link-tool__content:after{content:"";clear:both;display:table}.link-tool__content--rendered{background:#fff;border:1px solid rgba(201,201,204,.48);box-shadow:0 1px 3px #0000001a;border-radius:6px;will-change:filter;animation:link-in .45s 1 cubic-bezier(.215,.61,.355,1)}.link-tool__content--rendered:hover{box-shadow:0 0 3px #00000029}.link-tool__image{background-position:center center;background-repeat:no-repeat;background-size:cover;margin:0 0 0 30px;width:65px;height:65px;border-radius:3px;float:right}.link-tool__title{font-size:17px;font-weight:600;line-height:1.5em;margin:0 0 10px}.link-tool__title+.link-tool__anchor{margin-top:25px}.link-tool__description{margin:0 0 20px;font-size:15px;line-height:1.55em;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.link-tool__anchor{display:block;font-size:15px;line-height:1em;color:#888!important;border:0!important;padding:0!important}@keyframes link-in{0%{filter:blur(5px)}to{filter:none}}.codex-editor--narrow .link-tool__image{display:none}@-webkit-keyframes progress{0%{width:0}to{width:85%}}`)), document.head.appendChild(o);
        }
    } catch (t) {
        console.error("vite-plugin-css-injected-by-js", t);
    }
})();
var $143b355fa5979080$var$C = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $143b355fa5979080$var$O(k) {
    return k && k.__esModule && Object.prototype.hasOwnProperty.call(k, "default") ? k.default : k;
}
(function(k) {
    var w = function() {
        try {
            return !!Symbol.iterator;
        } catch  {
            return !1;
        }
    }, d = w(), v = function(n) {
        var o = {
            next: function() {
                var e = n.shift();
                return {
                    done: e === void 0,
                    value: e
                };
            }
        };
        return d && (o[Symbol.iterator] = function() {
            return o;
        }), o;
    }, c = function(n) {
        return encodeURIComponent(n).replace(/%20/g, "+");
    }, i = function(n) {
        return decodeURIComponent(String(n).replace(/\+/g, " "));
    }, a = function() {
        var n = function(e) {
            Object.defineProperty(this, "_entries", {
                writable: !0,
                value: {}
            });
            var s = typeof e;
            if (s !== "undefined") {
                if (s === "string") e !== "" && this._fromString(e);
                else if (e instanceof n) {
                    var h = this;
                    e.forEach(function(u, f) {
                        h.append(f, u);
                    });
                } else if (e !== null && s === "object") {
                    if (Object.prototype.toString.call(e) === "[object Array]") for(var t = 0; t < e.length; t++){
                        var y = e[t];
                        if (Object.prototype.toString.call(y) === "[object Array]" || y.length !== 2) this.append(y[0], y[1]);
                        else throw new TypeError("Expected [string, any] as entry at index " + t + " of URLSearchParams's input");
                    }
                    else for(var r in e)e.hasOwnProperty(r) && this.append(r, e[r]);
                } else throw new TypeError("Unsupported input's type for URLSearchParams");
            }
        }, o = n.prototype;
        o.append = function(e, s) {
            e in this._entries ? this._entries[e].push(String(s)) : this._entries[e] = [
                String(s)
            ];
        }, o.delete = function(e) {
            delete this._entries[e];
        }, o.get = function(e) {
            return e in this._entries ? this._entries[e][0] : null;
        }, o.getAll = function(e) {
            return e in this._entries ? this._entries[e].slice(0) : [];
        }, o.has = function(e) {
            return e in this._entries;
        }, o.set = function(e, s) {
            this._entries[e] = [
                String(s)
            ];
        }, o.forEach = function(e, s) {
            var h;
            for(var t in this._entries)if (this._entries.hasOwnProperty(t)) {
                h = this._entries[t];
                for(var y = 0; y < h.length; y++)e.call(s, h[y], t, this);
            }
        }, o.keys = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push(h);
            }), v(e);
        }, o.values = function() {
            var e = [];
            return this.forEach(function(s) {
                e.push(s);
            }), v(e);
        }, o.entries = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push([
                    h,
                    s
                ]);
            }), v(e);
        }, d && (o[Symbol.iterator] = o.entries), o.toString = function() {
            var e = [];
            return this.forEach(function(s, h) {
                e.push(c(h) + "=" + c(s));
            }), e.join("&");
        }, k.URLSearchParams = n;
    }, p = function() {
        try {
            var n = k.URLSearchParams;
            return new n("?a=1").toString() === "a=1" && typeof n.prototype.set == "function";
        } catch  {
            return !1;
        }
    };
    p() || a();
    var l = k.URLSearchParams.prototype;
    typeof l.sort != "function" && (l.sort = function() {
        var n = this, o = [];
        this.forEach(function(s, h) {
            o.push([
                h,
                s
            ]), n._entries || n.delete(h);
        }), o.sort(function(s, h) {
            return s[0] < h[0] ? -1 : s[0] > h[0] ? 1 : 0;
        }), n._entries && (n._entries = {});
        for(var e = 0; e < o.length; e++)this.append(o[e][0], o[e][1]);
    }), typeof l._fromString != "function" && Object.defineProperty(l, "_fromString", {
        enumerable: !1,
        configurable: !1,
        writable: !1,
        value: function(n) {
            if (this._entries) this._entries = {};
            else {
                var o = [];
                this.forEach(function(t, y) {
                    o.push(y);
                });
                for(var e = 0; e < o.length; e++)this.delete(o[e]);
            }
            n = n.replace(/^\?/, "");
            for(var s = n.split("&"), h, e = 0; e < s.length; e++)h = s[e].split("="), this.append(i(h[0]), h.length > 1 ? i(h[1]) : "");
        }
    });
})(typeof $143b355fa5979080$var$C < "u" ? $143b355fa5979080$var$C : typeof window < "u" ? window : typeof self < "u" ? self : $143b355fa5979080$var$C);
(function(k) {
    var w = function() {
        try {
            var c = new k.URL("b", "http://a");
            return c.pathname = "c d", c.href === "http://a/c%20d" && c.searchParams;
        } catch  {
            return !1;
        }
    }, d = function() {
        var c = k.URL, i = function(l, n) {
            typeof l != "string" && (l = String(l));
            var o = document, e;
            if (n && (k.location === void 0 || n !== k.location.href)) {
                o = document.implementation.createHTMLDocument(""), e = o.createElement("base"), e.href = n, o.head.appendChild(e);
                try {
                    if (e.href.indexOf(n) !== 0) throw new Error(e.href);
                } catch (m) {
                    throw new Error("URL unable to set base " + n + " due to " + m);
                }
            }
            var s = o.createElement("a");
            s.href = l, e && (o.body.appendChild(s), s.href = s.href);
            var h = o.createElement("input");
            if (h.type = "url", h.value = l, s.protocol === ":" || !/:/.test(s.href) || !h.checkValidity() && !n) throw new TypeError("Invalid URL");
            Object.defineProperty(this, "_anchorElement", {
                value: s
            });
            var t = new k.URLSearchParams(this.search), y = !0, r = !0, u = this;
            [
                "append",
                "delete",
                "set"
            ].forEach(function(m) {
                var b = t[m];
                t[m] = function() {
                    b.apply(t, arguments), y && (r = !1, u.search = t.toString(), r = !0);
                };
            }), Object.defineProperty(this, "searchParams", {
                value: t,
                enumerable: !0
            });
            var f = void 0;
            Object.defineProperty(this, "_updateSearchParams", {
                enumerable: !1,
                configurable: !1,
                writable: !1,
                value: function() {
                    this.search !== f && (f = this.search, r && (y = !1, this.searchParams._fromString(this.search), y = !0));
                }
            });
        }, a = i.prototype, p = function(l) {
            Object.defineProperty(a, l, {
                get: function() {
                    return this._anchorElement[l];
                },
                set: function(n) {
                    this._anchorElement[l] = n;
                },
                enumerable: !0
            });
        };
        [
            "hash",
            "host",
            "hostname",
            "port",
            "protocol"
        ].forEach(function(l) {
            p(l);
        }), Object.defineProperty(a, "search", {
            get: function() {
                return this._anchorElement.search;
            },
            set: function(l) {
                this._anchorElement.search = l, this._updateSearchParams();
            },
            enumerable: !0
        }), Object.defineProperties(a, {
            toString: {
                get: function() {
                    var l = this;
                    return function() {
                        return l.href;
                    };
                }
            },
            href: {
                get: function() {
                    return this._anchorElement.href.replace(/\?$/, "");
                },
                set: function(l) {
                    this._anchorElement.href = l, this._updateSearchParams();
                },
                enumerable: !0
            },
            pathname: {
                get: function() {
                    return this._anchorElement.pathname.replace(/(^\/?)/, "/");
                },
                set: function(l) {
                    this._anchorElement.pathname = l;
                },
                enumerable: !0
            },
            origin: {
                get: function() {
                    var l = {
                        "http:": 80,
                        "https:": 443,
                        "ftp:": 21
                    }[this._anchorElement.protocol], n = this._anchorElement.port != l && this._anchorElement.port !== "";
                    return this._anchorElement.protocol + "//" + this._anchorElement.hostname + (n ? ":" + this._anchorElement.port : "");
                },
                enumerable: !0
            },
            password: {
                // TODO
                get: function() {
                    return "";
                },
                set: function(l) {},
                enumerable: !0
            },
            username: {
                // TODO
                get: function() {
                    return "";
                },
                set: function(l) {},
                enumerable: !0
            }
        }), i.createObjectURL = function(l) {
            return c.createObjectURL.apply(c, arguments);
        }, i.revokeObjectURL = function(l) {
            return c.revokeObjectURL.apply(c, arguments);
        }, k.URL = i;
    };
    if (w() || d(), k.location !== void 0 && !("origin" in k.location)) {
        var v = function() {
            return k.location.protocol + "//" + k.location.hostname + (k.location.port ? ":" + k.location.port : "");
        };
        try {
            Object.defineProperty(k.location, "origin", {
                get: v,
                enumerable: !0
            });
        } catch  {
            setInterval(function() {
                k.location.origin = v();
            }, 100);
        }
    }
})(typeof $143b355fa5979080$var$C < "u" ? $143b355fa5979080$var$C : typeof window < "u" ? window : typeof self < "u" ? self : $143b355fa5979080$var$C);
var $143b355fa5979080$var$j = {
    exports: {}
};
(function(k, w) {
    (function(d, v) {
        k.exports = v();
    })(window, function() {
        return function(d) {
            var v = {};
            function c(i) {
                if (v[i]) return v[i].exports;
                var a = v[i] = {
                    i: i,
                    l: !1,
                    exports: {}
                };
                return d[i].call(a.exports, a, a.exports, c), a.l = !0, a.exports;
            }
            return c.m = d, c.c = v, c.d = function(i, a, p) {
                c.o(i, a) || Object.defineProperty(i, a, {
                    enumerable: !0,
                    get: p
                });
            }, c.r = function(i) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(i, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(i, "__esModule", {
                    value: !0
                });
            }, c.t = function(i, a) {
                if (1 & a && (i = c(i)), 8 & a || 4 & a && typeof i == "object" && i && i.__esModule) return i;
                var p = /* @__PURE__ */ Object.create(null);
                if (c.r(p), Object.defineProperty(p, "default", {
                    enumerable: !0,
                    value: i
                }), 2 & a && typeof i != "string") for(var l in i)c.d(p, l, (function(n) {
                    return i[n];
                }).bind(null, l));
                return p;
            }, c.n = function(i) {
                var a = i && i.__esModule ? function() {
                    return i.default;
                } : function() {
                    return i;
                };
                return c.d(a, "a", a), a;
            }, c.o = function(i, a) {
                return Object.prototype.hasOwnProperty.call(i, a);
            }, c.p = "", c(c.s = 3);
        }([
            function(d, v) {
                var c;
                c = function() {
                    return this;
                }();
                try {
                    c = c || new Function("return this")();
                } catch  {
                    typeof window == "object" && (c = window);
                }
                d.exports = c;
            },
            function(d, v, c) {
                (function(i) {
                    var a = c(2), p = setTimeout;
                    function l() {}
                    function n(r) {
                        if (!(this instanceof n)) throw new TypeError("Promises must be constructed via new");
                        if (typeof r != "function") throw new TypeError("not a function");
                        this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], y(r, this);
                    }
                    function o(r, u) {
                        for(; r._state === 3;)r = r._value;
                        r._state !== 0 ? (r._handled = !0, n._immediateFn(function() {
                            var f = r._state === 1 ? u.onFulfilled : u.onRejected;
                            if (f !== null) {
                                var m;
                                try {
                                    m = f(r._value);
                                } catch (b) {
                                    return void s(u.promise, b);
                                }
                                e(u.promise, m);
                            } else (r._state === 1 ? e : s)(u.promise, r._value);
                        })) : r._deferreds.push(u);
                    }
                    function e(r, u) {
                        try {
                            if (u === r) throw new TypeError("A promise cannot be resolved with itself.");
                            if (u && (typeof u == "object" || typeof u == "function")) {
                                var f = u.then;
                                if (u instanceof n) return r._state = 3, r._value = u, void h(r);
                                if (typeof f == "function") return void y((m = f, b = u, function() {
                                    m.apply(b, arguments);
                                }), r);
                            }
                            r._state = 1, r._value = u, h(r);
                        } catch (g) {
                            s(r, g);
                        }
                        var m, b;
                    }
                    function s(r, u) {
                        r._state = 2, r._value = u, h(r);
                    }
                    function h(r) {
                        r._state === 2 && r._deferreds.length === 0 && n._immediateFn(function() {
                            r._handled || n._unhandledRejectionFn(r._value);
                        });
                        for(var u = 0, f = r._deferreds.length; u < f; u++)o(r, r._deferreds[u]);
                        r._deferreds = null;
                    }
                    function t(r, u, f) {
                        this.onFulfilled = typeof r == "function" ? r : null, this.onRejected = typeof u == "function" ? u : null, this.promise = f;
                    }
                    function y(r, u) {
                        var f = !1;
                        try {
                            r(function(m) {
                                f || (f = !0, e(u, m));
                            }, function(m) {
                                f || (f = !0, s(u, m));
                            });
                        } catch (m) {
                            if (f) return;
                            f = !0, s(u, m);
                        }
                    }
                    n.prototype.catch = function(r) {
                        return this.then(null, r);
                    }, n.prototype.then = function(r, u) {
                        var f = new this.constructor(l);
                        return o(this, new t(r, u, f)), f;
                    }, n.prototype.finally = a.a, n.all = function(r) {
                        return new n(function(u, f) {
                            if (!r || r.length === void 0) throw new TypeError("Promise.all accepts an array");
                            var m = Array.prototype.slice.call(r);
                            if (m.length === 0) return u([]);
                            var b = m.length;
                            function g(T, E) {
                                try {
                                    if (E && (typeof E == "object" || typeof E == "function")) {
                                        var S = E.then;
                                        if (typeof S == "function") return void S.call(E, function(L) {
                                            g(T, L);
                                        }, f);
                                    }
                                    m[T] = E, --b == 0 && u(m);
                                } catch (L) {
                                    f(L);
                                }
                            }
                            for(var _ = 0; _ < m.length; _++)g(_, m[_]);
                        });
                    }, n.resolve = function(r) {
                        return r && typeof r == "object" && r.constructor === n ? r : new n(function(u) {
                            u(r);
                        });
                    }, n.reject = function(r) {
                        return new n(function(u, f) {
                            f(r);
                        });
                    }, n.race = function(r) {
                        return new n(function(u, f) {
                            for(var m = 0, b = r.length; m < b; m++)r[m].then(u, f);
                        });
                    }, n._immediateFn = typeof i == "function" && function(r) {
                        i(r);
                    } || function(r) {
                        p(r, 0);
                    }, n._unhandledRejectionFn = function(r) {
                        typeof console < "u" && console && console.warn("Possible Unhandled Promise Rejection:", r);
                    }, v.a = n;
                }).call(this, c(5).setImmediate);
            },
            function(d, v, c) {
                v.a = function(i) {
                    var a = this.constructor;
                    return this.then(function(p) {
                        return a.resolve(i()).then(function() {
                            return p;
                        });
                    }, function(p) {
                        return a.resolve(i()).then(function() {
                            return a.reject(p);
                        });
                    });
                };
            },
            function(d, v, c) {
                function i(t) {
                    return (i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(y) {
                        return typeof y;
                    } : function(y) {
                        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
                    })(t);
                }
                c(4);
                var a, p, l, n, o, e, s = c(8), h = (p = function(t) {
                    return new Promise(function(y, r) {
                        t = n(t), t = o(t);
                        var u = window.XMLHttpRequest ? new window.XMLHttpRequest() : new window.ActiveXObject("Microsoft.XMLHTTP");
                        u.open(t.method, t.url), u.setRequestHeader("X-Requested-With", "XMLHttpRequest"), Object.keys(t.headers).forEach(function(m) {
                            var b = t.headers[m];
                            u.setRequestHeader(m, b);
                        });
                        var f = t.ratio;
                        u.upload.addEventListener("progress", function(m) {
                            var b = Math.round(m.loaded / m.total * 100), g = Math.ceil(b * f / 100);
                            t.progress(g);
                        }, !1), u.addEventListener("progress", function(m) {
                            var b = Math.round(m.loaded / m.total * 100), g = Math.ceil(b * (100 - f) / 100) + f;
                            t.progress(g);
                        }, !1), u.onreadystatechange = function() {
                            if (u.readyState === 4) {
                                var m = u.response;
                                try {
                                    m = JSON.parse(m);
                                } catch  {}
                                var b = s.parseHeaders(u.getAllResponseHeaders()), g = {
                                    body: m,
                                    code: u.status,
                                    headers: b
                                };
                                u.status === 200 ? y(g) : r(g);
                            }
                        }, u.send(t.data);
                    });
                }, l = function(t) {
                    return t.method = "POST", p(t);
                }, n = function() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    if (t.url && typeof t.url != "string") throw new Error("Url must be a string");
                    if (t.url = t.url || "", t.method && typeof t.method != "string") throw new Error("`method` must be a string or null");
                    if (t.method = t.method ? t.method.toUpperCase() : "GET", t.headers && i(t.headers) !== "object") throw new Error("`headers` must be an object or null");
                    if (t.headers = t.headers || {}, t.type && (typeof t.type != "string" || !Object.values(a).includes(t.type))) throw new Error("`type` must be taken from module's \xabcontentType\xbb library");
                    if (t.progress && typeof t.progress != "function") throw new Error("`progress` must be a function or null");
                    if (t.progress = t.progress || function(y) {}, t.beforeSend = t.beforeSend || function(y) {}, t.ratio && typeof t.ratio != "number") throw new Error("`ratio` must be a number");
                    if (t.ratio < 0 || t.ratio > 100) throw new Error("`ratio` must be in a 0-100 interval");
                    if (t.ratio = t.ratio || 90, t.accept && typeof t.accept != "string") throw new Error("`accept` must be a string with a list of allowed mime-types");
                    if (t.accept = t.accept || "*/*", t.multiple && typeof t.multiple != "boolean") throw new Error("`multiple` must be a true or false");
                    if (t.multiple = t.multiple || !1, t.fieldName && typeof t.fieldName != "string") throw new Error("`fieldName` must be a string");
                    return t.fieldName = t.fieldName || "files", t;
                }, o = function(t) {
                    switch(t.method){
                        case "GET":
                            var y = e(t.data, a.URLENCODED);
                            delete t.data, t.url = /\?/.test(t.url) ? t.url + "&" + y : t.url + "?" + y;
                            break;
                        case "POST":
                        case "PUT":
                        case "DELETE":
                        case "UPDATE":
                            var r = function() {
                                return (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).type || a.JSON;
                            }(t);
                            (s.isFormData(t.data) || s.isFormElement(t.data)) && (r = a.FORM), t.data = e(t.data, r), r !== h.contentType.FORM && (t.headers["content-type"] = r);
                    }
                    return t;
                }, e = function() {
                    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    switch(arguments.length > 1 ? arguments[1] : void 0){
                        case a.URLENCODED:
                            return s.urlEncode(t);
                        case a.JSON:
                            return s.jsonEncode(t);
                        case a.FORM:
                            return s.formEncode(t);
                        default:
                            return t;
                    }
                }, {
                    contentType: a = {
                        URLENCODED: "application/x-www-form-urlencoded; charset=utf-8",
                        FORM: "multipart/form-data",
                        JSON: "application/json; charset=utf-8"
                    },
                    request: p,
                    get: function(t) {
                        return t.method = "GET", p(t);
                    },
                    post: l,
                    transport: function(t) {
                        return t = n(t), s.selectFiles(t).then(function(y) {
                            for(var r = new FormData(), u = 0; u < y.length; u++)r.append(t.fieldName, y[u], y[u].name);
                            return s.isObject(t.data) && Object.keys(t.data).forEach(function(f) {
                                var m = t.data[f];
                                r.append(f, m);
                            }), t.beforeSend && t.beforeSend(y), t.data = r, l(t);
                        });
                    },
                    selectFiles: function(t) {
                        return delete (t = n(t)).beforeSend, s.selectFiles(t);
                    }
                });
                d.exports = h;
            },
            function(d, v, c) {
                c.r(v);
                var i = c(1);
                window.Promise = window.Promise || i.a;
            },
            function(d, v, c) {
                (function(i) {
                    var a = i !== void 0 && i || typeof self < "u" && self || window, p = Function.prototype.apply;
                    function l(n, o) {
                        this._id = n, this._clearFn = o;
                    }
                    v.setTimeout = function() {
                        return new l(p.call(setTimeout, a, arguments), clearTimeout);
                    }, v.setInterval = function() {
                        return new l(p.call(setInterval, a, arguments), clearInterval);
                    }, v.clearTimeout = v.clearInterval = function(n) {
                        n && n.close();
                    }, l.prototype.unref = l.prototype.ref = function() {}, l.prototype.close = function() {
                        this._clearFn.call(a, this._id);
                    }, v.enroll = function(n, o) {
                        clearTimeout(n._idleTimeoutId), n._idleTimeout = o;
                    }, v.unenroll = function(n) {
                        clearTimeout(n._idleTimeoutId), n._idleTimeout = -1;
                    }, v._unrefActive = v.active = function(n) {
                        clearTimeout(n._idleTimeoutId);
                        var o = n._idleTimeout;
                        o >= 0 && (n._idleTimeoutId = setTimeout(function() {
                            n._onTimeout && n._onTimeout();
                        }, o));
                    }, c(6), v.setImmediate = typeof self < "u" && self.setImmediate || i !== void 0 && i.setImmediate || this && this.setImmediate, v.clearImmediate = typeof self < "u" && self.clearImmediate || i !== void 0 && i.clearImmediate || this && this.clearImmediate;
                }).call(this, c(0));
            },
            function(d, v, c) {
                (function(i, a) {
                    (function(p, l) {
                        if (!p.setImmediate) {
                            var n, o, e, s, h, t = 1, y = {}, r = !1, u = p.document, f = Object.getPrototypeOf && Object.getPrototypeOf(p);
                            f = f && f.setTimeout ? f : p, ({}).toString.call(p.process) === "[object process]" ? n = function(g) {
                                a.nextTick(function() {
                                    b(g);
                                });
                            } : function() {
                                if (p.postMessage && !p.importScripts) {
                                    var g = !0, _ = p.onmessage;
                                    return p.onmessage = function() {
                                        g = !1;
                                    }, p.postMessage("", "*"), p.onmessage = _, g;
                                }
                            }() ? (s = "setImmediate$" + Math.random() + "$", h = function(g) {
                                g.source === p && typeof g.data == "string" && g.data.indexOf(s) === 0 && b(+g.data.slice(s.length));
                            }, p.addEventListener ? p.addEventListener("message", h, !1) : p.attachEvent("onmessage", h), n = function(g) {
                                p.postMessage(s + g, "*");
                            }) : p.MessageChannel ? ((e = new MessageChannel()).port1.onmessage = function(g) {
                                b(g.data);
                            }, n = function(g) {
                                e.port2.postMessage(g);
                            }) : u && "onreadystatechange" in u.createElement("script") ? (o = u.documentElement, n = function(g) {
                                var _ = u.createElement("script");
                                _.onreadystatechange = function() {
                                    b(g), _.onreadystatechange = null, o.removeChild(_), _ = null;
                                }, o.appendChild(_);
                            }) : n = function(g) {
                                setTimeout(b, 0, g);
                            }, f.setImmediate = function(g) {
                                typeof g != "function" && (g = new Function("" + g));
                                for(var _ = new Array(arguments.length - 1), T = 0; T < _.length; T++)_[T] = arguments[T + 1];
                                var E = {
                                    callback: g,
                                    args: _
                                };
                                return y[t] = E, n(t), t++;
                            }, f.clearImmediate = m;
                        }
                        function m(g) {
                            delete y[g];
                        }
                        function b(g) {
                            if (r) setTimeout(b, 0, g);
                            else {
                                var _ = y[g];
                                if (_) {
                                    r = !0;
                                    try {
                                        (function(T) {
                                            var E = T.callback, S = T.args;
                                            switch(S.length){
                                                case 0:
                                                    E();
                                                    break;
                                                case 1:
                                                    E(S[0]);
                                                    break;
                                                case 2:
                                                    E(S[0], S[1]);
                                                    break;
                                                case 3:
                                                    E(S[0], S[1], S[2]);
                                                    break;
                                                default:
                                                    E.apply(l, S);
                                            }
                                        })(_);
                                    } finally{
                                        m(g), r = !1;
                                    }
                                }
                            }
                        }
                    })(typeof self > "u" ? i === void 0 ? this : i : self);
                }).call(this, c(0), c(7));
            },
            function(d, v) {
                var c, i, a = d.exports = {};
                function p() {
                    throw new Error("setTimeout has not been defined");
                }
                function l() {
                    throw new Error("clearTimeout has not been defined");
                }
                function n(f) {
                    if (c === setTimeout) return setTimeout(f, 0);
                    if ((c === p || !c) && setTimeout) return c = setTimeout, setTimeout(f, 0);
                    try {
                        return c(f, 0);
                    } catch  {
                        try {
                            return c.call(null, f, 0);
                        } catch  {
                            return c.call(this, f, 0);
                        }
                    }
                }
                (function() {
                    try {
                        c = typeof setTimeout == "function" ? setTimeout : p;
                    } catch  {
                        c = p;
                    }
                    try {
                        i = typeof clearTimeout == "function" ? clearTimeout : l;
                    } catch  {
                        i = l;
                    }
                })();
                var o, e = [], s = !1, h = -1;
                function t() {
                    s && o && (s = !1, o.length ? e = o.concat(e) : h = -1, e.length && y());
                }
                function y() {
                    if (!s) {
                        var f = n(t);
                        s = !0;
                        for(var m = e.length; m;){
                            for(o = e, e = []; ++h < m;)o && o[h].run();
                            h = -1, m = e.length;
                        }
                        o = null, s = !1, function(b) {
                            if (i === clearTimeout) return clearTimeout(b);
                            if ((i === l || !i) && clearTimeout) return i = clearTimeout, clearTimeout(b);
                            try {
                                i(b);
                            } catch  {
                                try {
                                    return i.call(null, b);
                                } catch  {
                                    return i.call(this, b);
                                }
                            }
                        }(f);
                    }
                }
                function r(f, m) {
                    this.fun = f, this.array = m;
                }
                function u() {}
                a.nextTick = function(f) {
                    var m = new Array(arguments.length - 1);
                    if (arguments.length > 1) for(var b = 1; b < arguments.length; b++)m[b - 1] = arguments[b];
                    e.push(new r(f, m)), e.length !== 1 || s || n(y);
                }, r.prototype.run = function() {
                    this.fun.apply(null, this.array);
                }, a.title = "browser", a.browser = !0, a.env = {}, a.argv = [], a.version = "", a.versions = {}, a.on = u, a.addListener = u, a.once = u, a.off = u, a.removeListener = u, a.removeAllListeners = u, a.emit = u, a.prependListener = u, a.prependOnceListener = u, a.listeners = function(f) {
                    return [];
                }, a.binding = function(f) {
                    throw new Error("process.binding is not supported");
                }, a.cwd = function() {
                    return "/";
                }, a.chdir = function(f) {
                    throw new Error("process.chdir is not supported");
                }, a.umask = function() {
                    return 0;
                };
            },
            function(d, v, c) {
                function i(p, l) {
                    for(var n = 0; n < l.length; n++){
                        var o = l[n];
                        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(p, o.key, o);
                    }
                }
                var a = c(9);
                d.exports = function() {
                    function p() {
                        (function(e, s) {
                            if (!(e instanceof s)) throw new TypeError("Cannot call a class as a function");
                        })(this, p);
                    }
                    var l, n, o;
                    return l = p, o = [
                        {
                            key: "urlEncode",
                            value: function(e) {
                                return a(e);
                            }
                        },
                        {
                            key: "jsonEncode",
                            value: function(e) {
                                return JSON.stringify(e);
                            }
                        },
                        {
                            key: "formEncode",
                            value: function(e) {
                                if (this.isFormData(e)) return e;
                                if (this.isFormElement(e)) return new FormData(e);
                                if (this.isObject(e)) {
                                    var s = new FormData();
                                    return Object.keys(e).forEach(function(h) {
                                        var t = e[h];
                                        s.append(h, t);
                                    }), s;
                                }
                                throw new Error("`data` must be an instance of Object, FormData or <FORM> HTMLElement");
                            }
                        },
                        {
                            key: "isObject",
                            value: function(e) {
                                return Object.prototype.toString.call(e) === "[object Object]";
                            }
                        },
                        {
                            key: "isFormData",
                            value: function(e) {
                                return e instanceof FormData;
                            }
                        },
                        {
                            key: "isFormElement",
                            value: function(e) {
                                return e instanceof HTMLFormElement;
                            }
                        },
                        {
                            key: "selectFiles",
                            value: function() {
                                var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                                return new Promise(function(s, h) {
                                    var t = document.createElement("INPUT");
                                    t.type = "file", e.multiple && t.setAttribute("multiple", "multiple"), e.accept && t.setAttribute("accept", e.accept), t.style.display = "none", document.body.appendChild(t), t.addEventListener("change", function(y) {
                                        var r = y.target.files;
                                        s(r), document.body.removeChild(t);
                                    }, !1), t.click();
                                });
                            }
                        },
                        {
                            key: "parseHeaders",
                            value: function(e) {
                                var s = e.trim().split(/[\r\n]+/), h = {};
                                return s.forEach(function(t) {
                                    var y = t.split(": "), r = y.shift(), u = y.join(": ");
                                    r && (h[r] = u);
                                }), h;
                            }
                        }
                    ], n = null, o && i(l, o), p;
                }();
            },
            function(d, v) {
                var c = function(a) {
                    return encodeURIComponent(a).replace(/[!'()*]/g, escape).replace(/%20/g, "+");
                }, i = function(a, p, l, n) {
                    return p = p || null, l = l || "&", n = n || null, a ? (function(o) {
                        for(var e = new Array(), s = 0; s < o.length; s++)o[s] && e.push(o[s]);
                        return e;
                    })(Object.keys(a).map(function(o) {
                        var e, s, h = o;
                        if (n && (h = n + "[" + h + "]"), typeof a[o] == "object" && a[o] !== null) e = i(a[o], null, l, h);
                        else {
                            p && (s = h, h = !isNaN(parseFloat(s)) && isFinite(s) ? p + Number(h) : h);
                            var t = a[o];
                            t = (t = (t = (t = t === !0 ? "1" : t) === !1 ? "0" : t) === 0 ? "0" : t) || "", e = c(h) + "=" + c(t);
                        }
                        return e;
                    })).join(l).replace(/[!'()*]/g, "") : "";
                };
                d.exports = i;
            }
        ]);
    });
})($143b355fa5979080$var$j);
var $143b355fa5979080$var$P = $143b355fa5979080$var$j.exports;
const $143b355fa5979080$var$R = /* @__PURE__ */ $143b355fa5979080$var$O($143b355fa5979080$var$P), $143b355fa5979080$var$F = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.569 6.39509 13.9269 6.25143 12.8271 7.17675L11.39 8.38588C10.0935 9.47674 9.95704 11.4241 11.0887 12.6852L11.12 12.72"/></svg>';
class $143b355fa5979080$export$2e2bcd8739ae039 {
    /**
   * Notify core that read-only mode supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   *
   * @returns {{icon: string, title: string}}
   */ static get toolbox() {
        return {
            icon: $143b355fa5979080$var$F,
            title: "Link"
        };
    }
    /**
   * Allow to press Enter inside the LinkTool input
   *
   * @returns {boolean}
   * @public
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * @param {object} options - Tool constructor options fot from Editor.js
   * @param {LinkToolData} options.data - previously saved data
   * @param {LinkToolConfig} options.config - user config for Tool
   * @param {object} options.api - Editor.js API
   * @param {boolean} options.readOnly - read-only mode flag
   */ constructor({ data: w, config: d, api: v, readOnly: c }){
        this.api = v, this.readOnly = c, this.config = {
            endpoint: d.endpoint || "",
            headers: d.headers || {}
        }, this.nodes = {
            wrapper: null,
            container: null,
            progress: null,
            input: null,
            inputHolder: null,
            linkContent: null,
            linkImage: null,
            linkTitle: null,
            linkDescription: null,
            linkText: null
        }, this._data = {
            link: "",
            meta: {}
        }, this.data = w;
    }
    /**
   * Renders Block content
   *
   * @public
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this.nodes.wrapper = this.make("div", this.CSS.baseClass), this.nodes.container = this.make("div", this.CSS.container), this.nodes.inputHolder = this.makeInputHolder(), this.nodes.linkContent = this.prepareLinkPreview(), Object.keys(this.data.meta).length ? (this.nodes.container.appendChild(this.nodes.linkContent), this.showLinkPreview(this.data.meta)) : this.nodes.container.appendChild(this.nodes.inputHolder), this.nodes.wrapper.appendChild(this.nodes.container), this.nodes.wrapper;
    }
    /**
   * Return Block data
   *
   * @public
   *
   * @returns {LinkToolData}
   */ save() {
        return this.data;
    }
    /**
   * Validate Block data
   * - check if given link is an empty string or not.
   *
   * @public
   *
   * @returns {boolean} false if saved data is incorrect, otherwise true
   */ validate() {
        return this.data.link.trim() !== "";
    }
    /**
   * Stores all Tool's data
   *
   * @param {LinkToolData} data - data to store
   */ set data(w) {
        this._data = Object.assign({}, {
            link: w.link || this._data.link,
            meta: w.meta || this._data.meta
        });
    }
    /**
   * Return Tool data
   *
   * @returns {LinkToolData}
   */ get data() {
        return this._data;
    }
    /**
   * @returns {object} - Link Tool styles
   */ get CSS() {
        return {
            baseClass: this.api.styles.block,
            input: this.api.styles.input,
            /**
       * Tool's classes
       */ container: "link-tool",
            inputEl: "link-tool__input",
            inputHolder: "link-tool__input-holder",
            inputError: "link-tool__input-holder--error",
            linkContent: "link-tool__content",
            linkContentRendered: "link-tool__content--rendered",
            linkImage: "link-tool__image",
            linkTitle: "link-tool__title",
            linkDescription: "link-tool__description",
            linkText: "link-tool__anchor",
            progress: "link-tool__progress",
            progressLoading: "link-tool__progress--loading",
            progressLoaded: "link-tool__progress--loaded"
        };
    }
    /**
   * Prepare input holder
   *
   * @returns {HTMLElement}
   */ makeInputHolder() {
        const w = this.make("div", this.CSS.inputHolder);
        return this.nodes.progress = this.make("label", this.CSS.progress), this.nodes.input = this.make("div", [
            this.CSS.input,
            this.CSS.inputEl
        ], {
            contentEditable: !this.readOnly
        }), this.nodes.input.dataset.placeholder = this.api.i18n.t("Link"), this.readOnly || (this.nodes.input.addEventListener("paste", (d)=>{
            this.startFetching(d);
        }), this.nodes.input.addEventListener("keydown", (d)=>{
            const [v, c] = [
                13,
                65
            ], i = d.ctrlKey || d.metaKey;
            switch(d.keyCode){
                case v:
                    d.preventDefault(), d.stopPropagation(), this.startFetching(d);
                    break;
                case c:
                    i && this.selectLinkUrl(d);
                    break;
            }
        })), w.appendChild(this.nodes.progress), w.appendChild(this.nodes.input), w;
    }
    /**
   * Activates link data fetching by url
   *
   * @param {PasteEvent|KeyboardEvent} event - fetching could be fired by a pase or keydown events
   */ startFetching(w) {
        let d = this.nodes.input.textContent;
        w.type === "paste" && (d = (w.clipboardData || window.clipboardData).getData("text")), this.removeErrorStyle(), this.fetchLinkData(d);
    }
    /**
   * If previous link data fetching failed, remove error styles
   */ removeErrorStyle() {
        this.nodes.inputHolder.classList.remove(this.CSS.inputError), this.nodes.inputHolder.insertBefore(this.nodes.progress, this.nodes.input);
    }
    /**
   * Select LinkTool input content by CMD+A
   *
   * @param {KeyboardEvent} event - keydown
   */ selectLinkUrl(w) {
        w.preventDefault(), w.stopPropagation();
        const d = window.getSelection(), v = new Range(), a = d.anchorNode.parentNode.closest(`.${this.CSS.inputHolder}`).querySelector(`.${this.CSS.inputEl}`);
        v.selectNodeContents(a), d.removeAllRanges(), d.addRange(v);
    }
    /**
   * Prepare link preview holder
   *
   * @returns {HTMLElement}
   */ prepareLinkPreview() {
        const w = this.make("a", this.CSS.linkContent, {
            target: "_blank",
            rel: "nofollow noindex noreferrer"
        });
        return this.nodes.linkImage = this.make("div", this.CSS.linkImage), this.nodes.linkTitle = this.make("div", this.CSS.linkTitle), this.nodes.linkDescription = this.make("p", this.CSS.linkDescription), this.nodes.linkText = this.make("span", this.CSS.linkText), w;
    }
    /**
   * Compose link preview from fetched data
   *
   * @param {metaData} meta - link meta data
   */ showLinkPreview({ image: w, title: d, description: v }) {
        this.nodes.container.appendChild(this.nodes.linkContent), w && w.url && (this.nodes.linkImage.style.backgroundImage = "url(" + w.url + ")", this.nodes.linkContent.appendChild(this.nodes.linkImage)), d && (this.nodes.linkTitle.textContent = d, this.nodes.linkContent.appendChild(this.nodes.linkTitle)), v && (this.nodes.linkDescription.textContent = v, this.nodes.linkContent.appendChild(this.nodes.linkDescription)), this.nodes.linkContent.classList.add(this.CSS.linkContentRendered), this.nodes.linkContent.setAttribute("href", this.data.link), this.nodes.linkContent.appendChild(this.nodes.linkText);
        try {
            this.nodes.linkText.textContent = new URL(this.data.link).hostname;
        } catch  {
            this.nodes.linkText.textContent = this.data.link;
        }
    }
    /**
   * Show loading progress bar
   */ showProgress() {
        this.nodes.progress.classList.add(this.CSS.progressLoading);
    }
    /**
   * Hide loading progress bar
   *
   * @returns {Promise<void>}
   */ hideProgress() {
        return new Promise((w)=>{
            this.nodes.progress.classList.remove(this.CSS.progressLoading), this.nodes.progress.classList.add(this.CSS.progressLoaded), setTimeout(w, 500);
        });
    }
    /**
   * If data fetching failed, set input error style
   */ applyErrorStyle() {
        this.nodes.inputHolder.classList.add(this.CSS.inputError), this.nodes.progress.remove();
    }
    /**
   * Sends to backend pasted url and receives link data
   *
   * @param {string} url - link source url
   */ async fetchLinkData(w) {
        this.showProgress(), this.data = {
            link: w
        };
        try {
            const { body: d } = await $143b355fa5979080$var$R.get({
                url: this.config.endpoint,
                headers: this.config.headers,
                data: {
                    url: w
                }
            });
            this.onFetch(d);
        } catch  {
            this.fetchingFailed(this.api.i18n.t("Couldn't fetch the link data"));
        }
    }
    /**
   * Link data fetching callback
   *
   * @param {UploadResponseFormat} response - backend response
   */ onFetch(w) {
        if (!w || !w.success) {
            this.fetchingFailed(this.api.i18n.t("Couldn't get this link data, try the other one"));
            return;
        }
        const d = w.meta, v = w.link || this.data.link;
        if (this.data = {
            meta: d,
            link: v
        }, !d) {
            this.fetchingFailed(this.api.i18n.t("Wrong response format from the server"));
            return;
        }
        this.hideProgress().then(()=>{
            this.nodes.inputHolder.remove(), this.showLinkPreview(d);
        });
    }
    /**
   * Handle link fetching errors
   *
   * @private
   *
   * @param {string} errorMessage - message to explain user what he should do
   */ fetchingFailed(w) {
        this.api.notifier.show({
            message: w,
            style: "error"
        }), this.applyErrorStyle();
    }
    /**
   * Helper method for elements creation
   *
   * @param {string} tagName - name of creating element
   * @param {string|string[]} [classNames] - list of CSS classes to add
   * @param {object} [attributes] - object with attributes to add
   * @returns {HTMLElement}
   */ make(w, d = null, v = {}) {
        const c = document.createElement(w);
        Array.isArray(d) ? c.classList.add(...d) : d && c.classList.add(d);
        for(const i in v)c[i] = v[i];
        return c;
    }
}


(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode('.cdx-list{margin:0;padding:0;outline:none;display:grid;counter-reset:item;gap:var(--spacing-s);padding:var(--spacing-xs);--spacing-s: 8px;--spacing-xs: 6px;--list-counter-type: numeric;--radius-border: 5px;--checkbox-background: #fff;--color-border: #C9C9C9;--color-bg-checked: #369FFF;--line-height: 1.45em;--color-bg-checked-hover: #0059AB;--color-tick: #fff;--size-checkbox: 1.2em}.cdx-list__item{line-height:var(--line-height);display:grid;grid-template-columns:auto 1fr;grid-template-rows:auto auto;grid-template-areas:"checkbox content" ". child"}.cdx-list__item-children{display:grid;grid-area:child;gap:var(--spacing-s);padding-top:var(--spacing-s)}.cdx-list__item [contenteditable]{outline:none}.cdx-list__item-content{word-break:break-word;white-space:pre-wrap;grid-area:content;padding-left:var(--spacing-s)}.cdx-list__item:before{counter-increment:item;white-space:nowrap}.cdx-list-ordered .cdx-list__item:before{content:counters(item,".",var(--list-counter-type)) "."}.cdx-list-ordered{counter-reset:item}.cdx-list-unordered .cdx-list__item:before{content:"\u2022"}.cdx-list-checklist .cdx-list__item:before{content:""}.cdx-list__settings .cdx-settings-button{width:50%}.cdx-list__checkbox{padding-top:calc((var(--line-height) - var(--size-checkbox)) / 2);grid-area:checkbox;width:var(--size-checkbox);height:var(--size-checkbox);display:flex;cursor:pointer}.cdx-list__checkbox svg{opacity:0;height:var(--size-checkbox);width:var(--size-checkbox);left:-1px;top:-1px;position:absolute}@media (hover: hover){.cdx-list__checkbox:not(.cdx-list__checkbox--no-hover):hover .cdx-list__checkbox-check svg{opacity:1}}.cdx-list__checkbox--checked{line-height:var(--line-height)}@media (hover: hover){.cdx-list__checkbox--checked:not(.cdx-list__checkbox--checked--no-hover):hover .cdx-checklist__checkbox-check{background:var(--color-bg-checked-hover);border-color:var(--color-bg-checked-hover)}}.cdx-list__checkbox--checked .cdx-list__checkbox-check{background:var(--color-bg-checked);border-color:var(--color-bg-checked)}.cdx-list__checkbox--checked .cdx-list__checkbox-check svg{opacity:1}.cdx-list__checkbox--checked .cdx-list__checkbox-check svg path{stroke:var(--color-tick)}.cdx-list__checkbox--checked .cdx-list__checkbox-check:before{opacity:0;visibility:visible;transform:scale(2.5)}.cdx-list__checkbox-check{cursor:pointer;display:inline-block;position:relative;margin:0 auto;width:var(--size-checkbox);height:var(--size-checkbox);box-sizing:border-box;border-radius:var(--radius-border);border:1px solid var(--color-border);background:var(--checkbox-background)}.cdx-list__checkbox-check:before{content:"";position:absolute;top:0;right:0;bottom:0;left:0;border-radius:100%;background-color:var(--color-bg-checked);visibility:hidden;pointer-events:none;transform:scale(1);transition:transform .4s ease-out,opacity .4s}.cdx-list__checkbox-check--disabled{pointer-events:none}.cdx-list-start-with-field{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-list-start-with-field--invalid{background:#FFECED;border:1px solid #E13F3F}.cdx-list-start-with-field--invalid .cdx-list-start-with-field__input{color:#e13f3f}.cdx-list-start-with-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - var(--toolbox-buttons-size) - var(--icon-margin-right))}.cdx-list-start-with-field__input::placeholder{color:var(--grayText);font-weight:500}')), document.head.appendChild(e);
        }
    } catch (c) {
        console.error("vite-plugin-css-injected-by-js", c);
    }
})();
const $e02beda658e54aca$var$Ct = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 12L10.4884 15.8372C10.5677 15.9245 10.705 15.9245 10.7844 15.8372L17 9"/></svg>', $e02beda658e54aca$var$Ae = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.2 12L11.0586 13.8586C11.1367 13.9367 11.2633 13.9367 11.3414 13.8586L14.7 10.5"/><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/></svg>', $e02beda658e54aca$var$$e = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="9" x2="19" y1="7" y2="7" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="9" x2="19" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="9" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 17H4.99002"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 12H4.99002"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5.00001 7H4.99002"/></svg>', $e02beda658e54aca$var$Be = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><line x1="12" x2="19" y1="7" y2="7" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="12" x2="19" y1="12" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><line x1="12" x2="19" y1="17" y2="17" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.79999 14L7.79999 7.2135C7.79999 7.12872 7.7011 7.0824 7.63597 7.13668L4.79999 9.5"/></svg>', $e02beda658e54aca$var$St = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 14.2L10 7.4135C10 7.32872 9.90111 7.28241 9.83598 7.33668L7 9.7" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M13.2087 14.2H13.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/></svg>', $e02beda658e54aca$var$Ot = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2087 14.2H13.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M10 14.2L10 9.5" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M10 7.01L10 7" stroke="black" stroke-width="1.8" stroke-linecap="round"/></svg>', $e02beda658e54aca$var$kt = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.2087 14.2H13.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M10 14.2L10 7.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/></svg>', $e02beda658e54aca$var$_t = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.0087 14.2H16" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M7 14.2L7.78865 12M13 14.2L12.1377 12M7.78865 12C7.78865 12 9.68362 7 10 7C10.3065 7 12.1377 12 12.1377 12M7.78865 12L12.1377 12" stroke="black" stroke-width="1.6" stroke-linecap="round"/></svg>', $e02beda658e54aca$var$Et = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2087 14.2H14.2" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M11.5 14.5C11.5 14.5 11 13.281 11 12.5M7 9.5C7 9.5 7.5 8.5 9 8.5C10.5 8.5 11 9.5 11 10.5L11 11.5M11 11.5L11 12.5M11 11.5C11 11.5 7 11 7 13C7 15.3031 11 15 11 12.5" stroke="black" stroke-width="1.6" stroke-linecap="round"/></svg>', $e02beda658e54aca$var$It = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 14.2L8 7.4135C8 7.32872 7.90111 7.28241 7.83598 7.33668L5 9.7" stroke="black" stroke-width="1.6" stroke-linecap="round"/><path d="M14 13L16.4167 10.7778M16.4167 10.7778L14 8.5M16.4167 10.7778H11.6562" stroke="black" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var $e02beda658e54aca$var$A = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $e02beda658e54aca$var$wt(e) {
    if (e.__esModule) return e;
    var t = e.default;
    if (typeof t == "function") {
        var n = function r() {
            return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
        };
        n.prototype = t.prototype;
    } else n = {};
    return Object.defineProperty(n, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(r) {
        var i = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(n, r, i.get ? i : {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        });
    }), n;
}
var $e02beda658e54aca$var$c = {}, $e02beda658e54aca$var$V = {}, $e02beda658e54aca$var$Y = {};
Object.defineProperty($e02beda658e54aca$var$Y, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$Y.allInputsSelector = $e02beda658e54aca$var$Pt;
function $e02beda658e54aca$var$Pt() {
    var e = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + e.map(function(t) {
        return 'input[type="'.concat(t, '"]');
    }).join(", ");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.allInputsSelector = void 0;
    var t = $e02beda658e54aca$var$Y;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return t.allInputsSelector;
        }
    });
})($e02beda658e54aca$var$V);
var $e02beda658e54aca$var$k = {}, $e02beda658e54aca$var$J = {};
Object.defineProperty($e02beda658e54aca$var$J, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$J.isNativeInput = $e02beda658e54aca$var$jt;
function $e02beda658e54aca$var$jt(e) {
    var t = [
        "INPUT",
        "TEXTAREA"
    ];
    return e && e.tagName ? t.includes(e.tagName) : !1;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNativeInput = void 0;
    var t = $e02beda658e54aca$var$J;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return t.isNativeInput;
        }
    });
})($e02beda658e54aca$var$k);
var $e02beda658e54aca$var$Fe = {}, $e02beda658e54aca$var$Q = {};
Object.defineProperty($e02beda658e54aca$var$Q, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$Q.append = $e02beda658e54aca$var$Tt;
function $e02beda658e54aca$var$Tt(e, t) {
    Array.isArray(t) ? t.forEach(function(n) {
        e.appendChild(n);
    }) : e.appendChild(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.append = void 0;
    var t = $e02beda658e54aca$var$Q;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function() {
            return t.append;
        }
    });
})($e02beda658e54aca$var$Fe);
var $e02beda658e54aca$var$Z = {}, $e02beda658e54aca$var$x = {};
Object.defineProperty($e02beda658e54aca$var$x, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$x.blockElements = $e02beda658e54aca$var$Lt;
function $e02beda658e54aca$var$Lt() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.blockElements = void 0;
    var t = $e02beda658e54aca$var$x;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function() {
            return t.blockElements;
        }
    });
})($e02beda658e54aca$var$Z);
var $e02beda658e54aca$var$Re = {}, $e02beda658e54aca$var$ee = {};
Object.defineProperty($e02beda658e54aca$var$ee, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$ee.calculateBaseline = $e02beda658e54aca$var$Mt;
function $e02beda658e54aca$var$Mt(e) {
    var t = window.getComputedStyle(e), n = parseFloat(t.fontSize), r = parseFloat(t.lineHeight) || n * 1.2, i = parseFloat(t.paddingTop), a = parseFloat(t.borderTopWidth), l = parseFloat(t.marginTop), s = n * 0.8, o = (r - n) / 2, d = l + a + i + o + s;
    return d;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.calculateBaseline = void 0;
    var t = $e02beda658e54aca$var$ee;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return t.calculateBaseline;
        }
    });
})($e02beda658e54aca$var$Re);
var $e02beda658e54aca$var$qe = {}, $e02beda658e54aca$var$te = {}, $e02beda658e54aca$var$ne = {}, $e02beda658e54aca$var$re = {};
Object.defineProperty($e02beda658e54aca$var$re, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$re.isContentEditable = $e02beda658e54aca$var$Nt;
function $e02beda658e54aca$var$Nt(e) {
    return e.contentEditable === "true";
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isContentEditable = void 0;
    var t = $e02beda658e54aca$var$re;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return t.isContentEditable;
        }
    });
})($e02beda658e54aca$var$ne);
Object.defineProperty($e02beda658e54aca$var$te, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$te.canSetCaret = $e02beda658e54aca$var$Bt;
var $e02beda658e54aca$var$At = $e02beda658e54aca$var$k, $e02beda658e54aca$var$$t = $e02beda658e54aca$var$ne;
function $e02beda658e54aca$var$Bt(e) {
    var t = !0;
    if ((0, $e02beda658e54aca$var$At.isNativeInput)(e)) switch(e.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            t = !1;
            break;
    }
    else t = (0, $e02beda658e54aca$var$$t.isContentEditable)(e);
    return t;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.canSetCaret = void 0;
    var t = $e02beda658e54aca$var$te;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return t.canSetCaret;
        }
    });
})($e02beda658e54aca$var$qe);
var $e02beda658e54aca$var$$ = {}, $e02beda658e54aca$var$ie = {};
function $e02beda658e54aca$var$Wt(e, t, n) {
    const r = n.value !== void 0 ? "value" : "get", i = n[r], a = `#${t}Cache`;
    if (n[r] = function(...l) {
        return this[a] === void 0 && (this[a] = i.apply(this, l)), this[a];
    }, r === "get" && n.set) {
        const l = n.set;
        n.set = function(s) {
            delete e[a], l.apply(this, s);
        };
    }
    return n;
}
function $e02beda658e54aca$var$Ue() {
    const e = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, t = Object.keys(e).find((n)=>window.navigator.appVersion.toLowerCase().indexOf(n) !== -1);
    return t !== void 0 && (e[t] = !0), e;
}
function $e02beda658e54aca$var$ae(e) {
    return e != null && e !== "" && (typeof e != "object" || Object.keys(e).length > 0);
}
function $e02beda658e54aca$var$Dt(e) {
    return !$e02beda658e54aca$var$ae(e);
}
const $e02beda658e54aca$var$Ht = ()=>typeof window < "u" && window.navigator !== null && $e02beda658e54aca$var$ae(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $e02beda658e54aca$var$Ft(e) {
    const t = $e02beda658e54aca$var$Ue();
    return e = e.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), t.mac ? e = e.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : e = e.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), e;
}
function $e02beda658e54aca$var$Rt(e) {
    return e[0].toUpperCase() + e.slice(1);
}
function $e02beda658e54aca$var$qt(e) {
    const t = document.createElement("div");
    t.style.position = "absolute", t.style.left = "-999px", t.style.bottom = "-999px", t.innerHTML = e, document.body.appendChild(t);
    const n = window.getSelection(), r = document.createRange();
    if (r.selectNode(t), n === null) throw new Error("Cannot copy text to clipboard");
    n.removeAllRanges(), n.addRange(r), document.execCommand("copy"), document.body.removeChild(t);
}
function $e02beda658e54aca$var$Ut(e, t, n) {
    let r;
    return (...i)=>{
        const a = this, l = ()=>{
            r = void 0, n !== !0 && e.apply(a, i);
        }, s = n === !0 && r !== void 0;
        window.clearTimeout(r), r = window.setTimeout(l, t), s && e.apply(a, i);
    };
}
function $e02beda658e54aca$var$S(e) {
    return Object.prototype.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $e02beda658e54aca$var$Kt(e) {
    return $e02beda658e54aca$var$S(e) === "boolean";
}
function $e02beda658e54aca$var$Ke(e) {
    return $e02beda658e54aca$var$S(e) === "function" || $e02beda658e54aca$var$S(e) === "asyncfunction";
}
function $e02beda658e54aca$var$zt(e) {
    return $e02beda658e54aca$var$Ke(e) && /^\s*class\s+/.test(e.toString());
}
function $e02beda658e54aca$var$Xt(e) {
    return $e02beda658e54aca$var$S(e) === "number";
}
function $e02beda658e54aca$var$M(e) {
    return $e02beda658e54aca$var$S(e) === "object";
}
function $e02beda658e54aca$var$Gt(e) {
    return Promise.resolve(e) === e;
}
function $e02beda658e54aca$var$Vt(e) {
    return $e02beda658e54aca$var$S(e) === "string";
}
function $e02beda658e54aca$var$Yt(e) {
    return $e02beda658e54aca$var$S(e) === "undefined";
}
function $e02beda658e54aca$var$X(e, ...t) {
    if (!t.length) return e;
    const n = t.shift();
    if ($e02beda658e54aca$var$M(e) && $e02beda658e54aca$var$M(n)) for(const r in n)$e02beda658e54aca$var$M(n[r]) ? (e[r] === void 0 && Object.assign(e, {
        [r]: {}
    }), $e02beda658e54aca$var$X(e[r], n[r])) : Object.assign(e, {
        [r]: n[r]
    });
    return $e02beda658e54aca$var$X(e, ...t);
}
function $e02beda658e54aca$var$Jt(e, t, n) {
    const r = `\xab${t}\xbb is deprecated and will be removed in the next major release. Please use the \xab${n}\xbb instead.`;
    e && console.warn(r);
}
function $e02beda658e54aca$var$Qt(e) {
    try {
        return new URL(e).href;
    } catch  {}
    return e.substring(0, 2) === "//" ? window.location.protocol + e : window.location.origin + e;
}
function $e02beda658e54aca$var$Zt(e) {
    return e > 47 && e < 58 || e === 32 || e === 13 || e === 229 || e > 64 && e < 91 || e > 95 && e < 112 || e > 185 && e < 193 || e > 218 && e < 223;
}
const $e02beda658e54aca$var$xt = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $e02beda658e54aca$var$en = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
class $e02beda658e54aca$var$tn {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ add(t) {
        return new Promise((n, r)=>{
            this.completed = this.completed.then(t).then(n).catch(r);
        });
    }
}
function $e02beda658e54aca$var$nn(e, t, n) {
    let r, i, a, l = null, s = 0;
    n || (n = {});
    const o = function() {
        s = n.leading === !1 ? 0 : Date.now(), l = null, a = e.apply(r, i), l === null && (r = i = null);
    };
    return function() {
        const d = Date.now();
        !s && n.leading === !1 && (s = d);
        const u = t - (d - s);
        return r = this, i = arguments, u <= 0 || u > t ? (l && (clearTimeout(l), l = null), s = d, a = e.apply(r, i), l === null && (r = i = null)) : !l && n.trailing !== !1 && (l = setTimeout(o, u)), a;
    };
}
const $e02beda658e54aca$var$rn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $e02beda658e54aca$var$tn,
    beautifyShortcut: $e02beda658e54aca$var$Ft,
    cacheable: $e02beda658e54aca$var$Wt,
    capitalize: $e02beda658e54aca$var$Rt,
    copyTextToClipboard: $e02beda658e54aca$var$qt,
    debounce: $e02beda658e54aca$var$Ut,
    deepMerge: $e02beda658e54aca$var$X,
    deprecationAssert: $e02beda658e54aca$var$Jt,
    getUserOS: $e02beda658e54aca$var$Ue,
    getValidUrl: $e02beda658e54aca$var$Qt,
    isBoolean: $e02beda658e54aca$var$Kt,
    isClass: $e02beda658e54aca$var$zt,
    isEmpty: $e02beda658e54aca$var$Dt,
    isFunction: $e02beda658e54aca$var$Ke,
    isIosDevice: $e02beda658e54aca$var$Ht,
    isNumber: $e02beda658e54aca$var$Xt,
    isObject: $e02beda658e54aca$var$M,
    isPrintableKey: $e02beda658e54aca$var$Zt,
    isPromise: $e02beda658e54aca$var$Gt,
    isString: $e02beda658e54aca$var$Vt,
    isUndefined: $e02beda658e54aca$var$Yt,
    keyCodes: $e02beda658e54aca$var$xt,
    mouseButtons: $e02beda658e54aca$var$en,
    notEmpty: $e02beda658e54aca$var$ae,
    throttle: $e02beda658e54aca$var$nn,
    typeOf: $e02beda658e54aca$var$S
}, Symbol.toStringTag, {
    value: "Module"
})), $e02beda658e54aca$var$le = /* @__PURE__ */ $e02beda658e54aca$var$wt($e02beda658e54aca$var$rn);
Object.defineProperty($e02beda658e54aca$var$ie, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$ie.containsOnlyInlineElements = $e02beda658e54aca$var$sn;
var $e02beda658e54aca$var$an = $e02beda658e54aca$var$le, $e02beda658e54aca$var$ln = $e02beda658e54aca$var$Z;
function $e02beda658e54aca$var$sn(e) {
    var t;
    (0, $e02beda658e54aca$var$an.isString)(e) ? (t = document.createElement("div"), t.innerHTML = e) : t = e;
    var n = function(r) {
        return !(0, $e02beda658e54aca$var$ln.blockElements)().includes(r.tagName.toLowerCase()) && Array.from(r.children).every(n);
    };
    return Array.from(t.children).every(n);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.containsOnlyInlineElements = void 0;
    var t = $e02beda658e54aca$var$ie;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return t.containsOnlyInlineElements;
        }
    });
})($e02beda658e54aca$var$$);
var $e02beda658e54aca$var$ze = {}, $e02beda658e54aca$var$se = {}, $e02beda658e54aca$var$B = {}, $e02beda658e54aca$var$oe = {};
Object.defineProperty($e02beda658e54aca$var$oe, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$oe.make = $e02beda658e54aca$var$on;
function $e02beda658e54aca$var$on(e, t, n) {
    var r;
    t === void 0 && (t = null), n === void 0 && (n = {});
    var i = document.createElement(e);
    if (Array.isArray(t)) {
        var a = t.filter(function(s) {
            return s !== void 0;
        });
        (r = i.classList).add.apply(r, a);
    } else t !== null && i.classList.add(t);
    for(var l in n)Object.prototype.hasOwnProperty.call(n, l) && (i[l] = n[l]);
    return i;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.make = void 0;
    var t = $e02beda658e54aca$var$oe;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function() {
            return t.make;
        }
    });
})($e02beda658e54aca$var$B);
Object.defineProperty($e02beda658e54aca$var$se, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$se.fragmentToString = $e02beda658e54aca$var$cn;
var $e02beda658e54aca$var$un = $e02beda658e54aca$var$B;
function $e02beda658e54aca$var$cn(e) {
    var t = (0, $e02beda658e54aca$var$un.make)("div");
    return t.appendChild(e), t.innerHTML;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.fragmentToString = void 0;
    var t = $e02beda658e54aca$var$se;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return t.fragmentToString;
        }
    });
})($e02beda658e54aca$var$ze);
var $e02beda658e54aca$var$Xe = {}, $e02beda658e54aca$var$ue = {};
Object.defineProperty($e02beda658e54aca$var$ue, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$ue.getContentLength = $e02beda658e54aca$var$fn;
var $e02beda658e54aca$var$dn = $e02beda658e54aca$var$k;
function $e02beda658e54aca$var$fn(e) {
    var t, n;
    return (0, $e02beda658e54aca$var$dn.isNativeInput)(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : (n = (t = e.textContent) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getContentLength = void 0;
    var t = $e02beda658e54aca$var$ue;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function() {
            return t.getContentLength;
        }
    });
})($e02beda658e54aca$var$Xe);
var $e02beda658e54aca$var$ce = {}, $e02beda658e54aca$var$de = {}, $e02beda658e54aca$var$We = $e02beda658e54aca$var$A && $e02beda658e54aca$var$A.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($e02beda658e54aca$var$de, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$de.getDeepestBlockElements = $e02beda658e54aca$var$Ge;
var $e02beda658e54aca$var$pn = $e02beda658e54aca$var$$;
function $e02beda658e54aca$var$Ge(e) {
    return (0, $e02beda658e54aca$var$pn.containsOnlyInlineElements)(e) ? [
        e
    ] : Array.from(e.children).reduce(function(t, n) {
        return $e02beda658e54aca$var$We($e02beda658e54aca$var$We([], t, !0), $e02beda658e54aca$var$Ge(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestBlockElements = void 0;
    var t = $e02beda658e54aca$var$de;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return t.getDeepestBlockElements;
        }
    });
})($e02beda658e54aca$var$ce);
var $e02beda658e54aca$var$Ve = {}, $e02beda658e54aca$var$fe = {}, $e02beda658e54aca$var$W = {}, $e02beda658e54aca$var$pe = {};
Object.defineProperty($e02beda658e54aca$var$pe, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$pe.isLineBreakTag = $e02beda658e54aca$var$hn;
function $e02beda658e54aca$var$hn(e) {
    return [
        "BR",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLineBreakTag = void 0;
    var t = $e02beda658e54aca$var$pe;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return t.isLineBreakTag;
        }
    });
})($e02beda658e54aca$var$W);
var $e02beda658e54aca$var$D = {}, $e02beda658e54aca$var$he = {};
Object.defineProperty($e02beda658e54aca$var$he, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$he.isSingleTag = $e02beda658e54aca$var$mn;
function $e02beda658e54aca$var$mn(e) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isSingleTag = void 0;
    var t = $e02beda658e54aca$var$he;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return t.isSingleTag;
        }
    });
})($e02beda658e54aca$var$D);
Object.defineProperty($e02beda658e54aca$var$fe, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$fe.getDeepestNode = $e02beda658e54aca$var$Ye;
var $e02beda658e54aca$var$gn = $e02beda658e54aca$var$k, $e02beda658e54aca$var$vn = $e02beda658e54aca$var$W, $e02beda658e54aca$var$bn = $e02beda658e54aca$var$D;
function $e02beda658e54aca$var$Ye(e, t) {
    t === void 0 && (t = !1);
    var n = t ? "lastChild" : "firstChild", r = t ? "previousSibling" : "nextSibling";
    if (e.nodeType === Node.ELEMENT_NODE && e[n]) {
        var i = e[n];
        if ((0, $e02beda658e54aca$var$bn.isSingleTag)(i) && !(0, $e02beda658e54aca$var$gn.isNativeInput)(i) && !(0, $e02beda658e54aca$var$vn.isLineBreakTag)(i)) {
            if (i[r]) i = i[r];
            else if (i.parentNode !== null && i.parentNode[r]) i = i.parentNode[r];
            else return i.parentNode;
        }
        return $e02beda658e54aca$var$Ye(i, t);
    }
    return e;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestNode = void 0;
    var t = $e02beda658e54aca$var$fe;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return t.getDeepestNode;
        }
    });
})($e02beda658e54aca$var$Ve);
var $e02beda658e54aca$var$Je = {}, $e02beda658e54aca$var$me = {}, $e02beda658e54aca$var$T = $e02beda658e54aca$var$A && $e02beda658e54aca$var$A.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($e02beda658e54aca$var$me, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$me.findAllInputs = $e02beda658e54aca$var$kn;
var $e02beda658e54aca$var$yn = $e02beda658e54aca$var$$, $e02beda658e54aca$var$Cn = $e02beda658e54aca$var$ce, $e02beda658e54aca$var$Sn = $e02beda658e54aca$var$V, $e02beda658e54aca$var$On = $e02beda658e54aca$var$k;
function $e02beda658e54aca$var$kn(e) {
    return Array.from(e.querySelectorAll((0, $e02beda658e54aca$var$Sn.allInputsSelector)())).reduce(function(t, n) {
        return (0, $e02beda658e54aca$var$On.isNativeInput)(n) || (0, $e02beda658e54aca$var$yn.containsOnlyInlineElements)(n) ? $e02beda658e54aca$var$T($e02beda658e54aca$var$T([], t, !0), [
            n
        ], !1) : $e02beda658e54aca$var$T($e02beda658e54aca$var$T([], t, !0), (0, $e02beda658e54aca$var$Cn.getDeepestBlockElements)(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.findAllInputs = void 0;
    var t = $e02beda658e54aca$var$me;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return t.findAllInputs;
        }
    });
})($e02beda658e54aca$var$Je);
var $e02beda658e54aca$var$Qe = {}, $e02beda658e54aca$var$ge = {};
Object.defineProperty($e02beda658e54aca$var$ge, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$ge.isCollapsedWhitespaces = $e02beda658e54aca$var$_n;
function $e02beda658e54aca$var$_n(e) {
    return !/[^\t\n\r ]/.test(e);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCollapsedWhitespaces = void 0;
    var t = $e02beda658e54aca$var$ge;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return t.isCollapsedWhitespaces;
        }
    });
})($e02beda658e54aca$var$Qe);
var $e02beda658e54aca$var$ve = {}, $e02beda658e54aca$var$be = {};
Object.defineProperty($e02beda658e54aca$var$be, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$be.isElement = $e02beda658e54aca$var$In;
var $e02beda658e54aca$var$En = $e02beda658e54aca$var$le;
function $e02beda658e54aca$var$In(e) {
    return (0, $e02beda658e54aca$var$En.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.ELEMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isElement = void 0;
    var t = $e02beda658e54aca$var$be;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function() {
            return t.isElement;
        }
    });
})($e02beda658e54aca$var$ve);
var $e02beda658e54aca$var$Ze = {}, $e02beda658e54aca$var$ye = {}, $e02beda658e54aca$var$Ce = {}, $e02beda658e54aca$var$Se = {};
Object.defineProperty($e02beda658e54aca$var$Se, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$Se.isLeaf = $e02beda658e54aca$var$wn;
function $e02beda658e54aca$var$wn(e) {
    return e === null ? !1 : e.childNodes.length === 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLeaf = void 0;
    var t = $e02beda658e54aca$var$Se;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function() {
            return t.isLeaf;
        }
    });
})($e02beda658e54aca$var$Ce);
var $e02beda658e54aca$var$Oe = {}, $e02beda658e54aca$var$ke = {};
Object.defineProperty($e02beda658e54aca$var$ke, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$ke.isNodeEmpty = $e02beda658e54aca$var$Mn;
var $e02beda658e54aca$var$Pn = $e02beda658e54aca$var$W, $e02beda658e54aca$var$jn = $e02beda658e54aca$var$ve, $e02beda658e54aca$var$Tn = $e02beda658e54aca$var$k, $e02beda658e54aca$var$Ln = $e02beda658e54aca$var$D;
function $e02beda658e54aca$var$Mn(e, t) {
    var n = "";
    return (0, $e02beda658e54aca$var$Ln.isSingleTag)(e) && !(0, $e02beda658e54aca$var$Pn.isLineBreakTag)(e) ? !1 : ((0, $e02beda658e54aca$var$jn.isElement)(e) && (0, $e02beda658e54aca$var$Tn.isNativeInput)(e) ? n = e.value : e.textContent !== null && (n = e.textContent.replace("\u200B", "")), t !== void 0 && (n = n.replace(new RegExp(t, "g"), "")), n.trim().length === 0);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNodeEmpty = void 0;
    var t = $e02beda658e54aca$var$ke;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return t.isNodeEmpty;
        }
    });
})($e02beda658e54aca$var$Oe);
Object.defineProperty($e02beda658e54aca$var$ye, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$ye.isEmpty = $e02beda658e54aca$var$$n;
var $e02beda658e54aca$var$Nn = $e02beda658e54aca$var$Ce, $e02beda658e54aca$var$An = $e02beda658e54aca$var$Oe;
function $e02beda658e54aca$var$$n(e, t) {
    e.normalize();
    for(var n = [
        e
    ]; n.length > 0;){
        var r = n.shift();
        if (r) {
            if (e = r, (0, $e02beda658e54aca$var$Nn.isLeaf)(e) && !(0, $e02beda658e54aca$var$An.isNodeEmpty)(e, t)) return !1;
            n.push.apply(n, Array.from(e.childNodes));
        }
    }
    return !0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isEmpty = void 0;
    var t = $e02beda658e54aca$var$ye;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function() {
            return t.isEmpty;
        }
    });
})($e02beda658e54aca$var$Ze);
var $e02beda658e54aca$var$xe = {}, $e02beda658e54aca$var$_e = {};
Object.defineProperty($e02beda658e54aca$var$_e, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$_e.isFragment = $e02beda658e54aca$var$Wn;
var $e02beda658e54aca$var$Bn = $e02beda658e54aca$var$le;
function $e02beda658e54aca$var$Wn(e) {
    return (0, $e02beda658e54aca$var$Bn.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isFragment = void 0;
    var t = $e02beda658e54aca$var$_e;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function() {
            return t.isFragment;
        }
    });
})($e02beda658e54aca$var$xe);
var $e02beda658e54aca$var$et = {}, $e02beda658e54aca$var$Ee = {};
Object.defineProperty($e02beda658e54aca$var$Ee, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$Ee.isHTMLString = $e02beda658e54aca$var$Hn;
var $e02beda658e54aca$var$Dn = $e02beda658e54aca$var$B;
function $e02beda658e54aca$var$Hn(e) {
    var t = (0, $e02beda658e54aca$var$Dn.make)("div");
    return t.innerHTML = e, t.childElementCount > 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isHTMLString = void 0;
    var t = $e02beda658e54aca$var$Ee;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return t.isHTMLString;
        }
    });
})($e02beda658e54aca$var$et);
var $e02beda658e54aca$var$tt = {}, $e02beda658e54aca$var$Ie = {};
Object.defineProperty($e02beda658e54aca$var$Ie, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$Ie.offset = $e02beda658e54aca$var$Fn;
function $e02beda658e54aca$var$Fn(e) {
    var t = e.getBoundingClientRect(), n = window.pageXOffset || document.documentElement.scrollLeft, r = window.pageYOffset || document.documentElement.scrollTop, i = t.top + r, a = t.left + n;
    return {
        top: i,
        left: a,
        bottom: i + t.height,
        right: a + t.width
    };
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.offset = void 0;
    var t = $e02beda658e54aca$var$Ie;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function() {
            return t.offset;
        }
    });
})($e02beda658e54aca$var$tt);
var $e02beda658e54aca$var$nt = {}, $e02beda658e54aca$var$we = {};
Object.defineProperty($e02beda658e54aca$var$we, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$we.prepend = $e02beda658e54aca$var$Rn;
function $e02beda658e54aca$var$Rn(e, t) {
    Array.isArray(t) ? (t = t.reverse(), t.forEach(function(n) {
        return e.prepend(n);
    })) : e.prepend(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = void 0;
    var t = $e02beda658e54aca$var$we;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function() {
            return t.prepend;
        }
    });
})($e02beda658e54aca$var$nt);
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = e.offset = e.make = e.isLineBreakTag = e.isSingleTag = e.isNodeEmpty = e.isLeaf = e.isHTMLString = e.isFragment = e.isEmpty = e.isElement = e.isContentEditable = e.isCollapsedWhitespaces = e.findAllInputs = e.isNativeInput = e.allInputsSelector = e.getDeepestNode = e.getDeepestBlockElements = e.getContentLength = e.fragmentToString = e.containsOnlyInlineElements = e.canSetCaret = e.calculateBaseline = e.blockElements = e.append = void 0;
    var t = $e02beda658e54aca$var$V;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return t.allInputsSelector;
        }
    });
    var n = $e02beda658e54aca$var$k;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return n.isNativeInput;
        }
    });
    var r = $e02beda658e54aca$var$Fe;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function() {
            return r.append;
        }
    });
    var i = $e02beda658e54aca$var$Z;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function() {
            return i.blockElements;
        }
    });
    var a = $e02beda658e54aca$var$Re;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return a.calculateBaseline;
        }
    });
    var l = $e02beda658e54aca$var$qe;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return l.canSetCaret;
        }
    });
    var s = $e02beda658e54aca$var$$;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return s.containsOnlyInlineElements;
        }
    });
    var o = $e02beda658e54aca$var$ze;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return o.fragmentToString;
        }
    });
    var d = $e02beda658e54aca$var$Xe;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function() {
            return d.getContentLength;
        }
    });
    var u = $e02beda658e54aca$var$ce;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return u.getDeepestBlockElements;
        }
    });
    var p = $e02beda658e54aca$var$Ve;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return p.getDeepestNode;
        }
    });
    var g = $e02beda658e54aca$var$Je;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return g.findAllInputs;
        }
    });
    var w = $e02beda658e54aca$var$Qe;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return w.isCollapsedWhitespaces;
        }
    });
    var _ = $e02beda658e54aca$var$ne;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return _.isContentEditable;
        }
    });
    var ut = $e02beda658e54aca$var$ve;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function() {
            return ut.isElement;
        }
    });
    var ct = $e02beda658e54aca$var$Ze;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function() {
            return ct.isEmpty;
        }
    });
    var dt = $e02beda658e54aca$var$xe;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function() {
            return dt.isFragment;
        }
    });
    var ft = $e02beda658e54aca$var$et;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return ft.isHTMLString;
        }
    });
    var pt = $e02beda658e54aca$var$Ce;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function() {
            return pt.isLeaf;
        }
    });
    var ht = $e02beda658e54aca$var$Oe;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return ht.isNodeEmpty;
        }
    });
    var mt = $e02beda658e54aca$var$W;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return mt.isLineBreakTag;
        }
    });
    var gt = $e02beda658e54aca$var$D;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return gt.isSingleTag;
        }
    });
    var vt = $e02beda658e54aca$var$B;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function() {
            return vt.make;
        }
    });
    var bt = $e02beda658e54aca$var$tt;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function() {
            return bt.offset;
        }
    });
    var yt = $e02beda658e54aca$var$nt;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function() {
            return yt.prepend;
        }
    });
})($e02beda658e54aca$var$c);
const $e02beda658e54aca$var$m = "cdx-list", $e02beda658e54aca$var$h = {
    wrapper: $e02beda658e54aca$var$m,
    item: `${$e02beda658e54aca$var$m}__item`,
    itemContent: `${$e02beda658e54aca$var$m}__item-content`,
    itemChildren: `${$e02beda658e54aca$var$m}__item-children`
};
class $e02beda658e54aca$var$v {
    /**
   * Getter for all CSS classes used in unordered list rendering
   */ static get CSS() {
        return {
            ...$e02beda658e54aca$var$h,
            orderedList: `${$e02beda658e54aca$var$m}-ordered`
        };
    }
    /**
   * Assign passed readonly mode and config to relevant class properties
   * @param readonly - read-only mode flag
   * @param config - user config for Tool
   */ constructor(t, n){
        this.config = n, this.readOnly = t;
    }
    /**
   * Renders ol wrapper for list
   * @param isRoot - boolean variable that represents level of the wrappre (root or childList)
   * @returns - created html ol element
   */ renderWrapper(t) {
        let n;
        return t === !0 ? n = $e02beda658e54aca$var$c.make("ol", [
            $e02beda658e54aca$var$v.CSS.wrapper,
            $e02beda658e54aca$var$v.CSS.orderedList
        ]) : n = $e02beda658e54aca$var$c.make("ol", [
            $e02beda658e54aca$var$v.CSS.orderedList,
            $e02beda658e54aca$var$v.CSS.itemChildren
        ]), n;
    }
    /**
   * Redners list item element
   * @param content - content used in list item rendering
   * @param _meta - meta of the list item unused in rendering of the ordered list
   * @returns - created html list item element
   */ renderItem(t, n) {
        const r = $e02beda658e54aca$var$c.make("li", $e02beda658e54aca$var$v.CSS.item), i = $e02beda658e54aca$var$c.make("div", $e02beda658e54aca$var$v.CSS.itemContent, {
            innerHTML: t,
            contentEditable: (!this.readOnly).toString()
        });
        return r.appendChild(i), r;
    }
    /**
   * Return the item content
   * @param item - item wrapper (<li>)
   * @returns - item content string
   */ getItemContent(t) {
        const n = t.querySelector(`.${$e02beda658e54aca$var$v.CSS.itemContent}`);
        return !n || $e02beda658e54aca$var$c.isEmpty(n) ? "" : n.innerHTML;
    }
    /**
   * Returns item meta, for ordered list
   * @returns item meta object
   */ getItemMeta() {
        return {};
    }
    /**
   * Returns default item meta used on creation of the new item
   */ composeDefaultMeta() {
        return {};
    }
}
class $e02beda658e54aca$var$b {
    /**
   * Getter for all CSS classes used in unordered list rendering
   */ static get CSS() {
        return {
            ...$e02beda658e54aca$var$h,
            unorderedList: `${$e02beda658e54aca$var$m}-unordered`
        };
    }
    /**
   * Assign passed readonly mode and config to relevant class properties
   * @param readonly - read-only mode flag
   * @param config - user config for Tool
   */ constructor(t, n){
        this.config = n, this.readOnly = t;
    }
    /**
   * Renders ol wrapper for list
   * @param isRoot - boolean variable that represents level of the wrappre (root or childList)
   * @returns - created html ul element
   */ renderWrapper(t) {
        let n;
        return t === !0 ? n = $e02beda658e54aca$var$c.make("ul", [
            $e02beda658e54aca$var$b.CSS.wrapper,
            $e02beda658e54aca$var$b.CSS.unorderedList
        ]) : n = $e02beda658e54aca$var$c.make("ul", [
            $e02beda658e54aca$var$b.CSS.unorderedList,
            $e02beda658e54aca$var$b.CSS.itemChildren
        ]), n;
    }
    /**
   * Redners list item element
   * @param content - content used in list item rendering
   * @param _meta - meta of the list item unused in rendering of the unordered list
   * @returns - created html list item element
   */ renderItem(t, n) {
        const r = $e02beda658e54aca$var$c.make("li", $e02beda658e54aca$var$b.CSS.item), i = $e02beda658e54aca$var$c.make("div", $e02beda658e54aca$var$b.CSS.itemContent, {
            innerHTML: t,
            contentEditable: (!this.readOnly).toString()
        });
        return r.appendChild(i), r;
    }
    /**
   * Return the item content
   * @param item - item wrapper (<li>)
   * @returns - item content string
   */ getItemContent(t) {
        const n = t.querySelector(`.${$e02beda658e54aca$var$b.CSS.itemContent}`);
        return !n || $e02beda658e54aca$var$c.isEmpty(n) ? "" : n.innerHTML;
    }
    /**
   * Returns item meta, for unordered list
   * @returns Item meta object
   */ getItemMeta() {
        return {};
    }
    /**
   * Returns default item meta used on creation of the new item
   */ composeDefaultMeta() {
        return {};
    }
}
function $e02beda658e54aca$var$O(e) {
    return e.nodeType === Node.ELEMENT_NODE;
}
var $e02beda658e54aca$var$j = {}, $e02beda658e54aca$var$Pe = {}, $e02beda658e54aca$var$H = {}, $e02beda658e54aca$var$F = {};
Object.defineProperty($e02beda658e54aca$var$F, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$F.getContenteditableSlice = $e02beda658e54aca$var$Un;
var $e02beda658e54aca$var$qn = $e02beda658e54aca$var$c;
function $e02beda658e54aca$var$Un(e, t, n, r, i) {
    var a;
    i === void 0 && (i = !1);
    var l = document.createRange();
    if (r === "left" ? (l.setStart(e, 0), l.setEnd(t, n)) : (l.setStart(t, n), l.setEnd(e, e.childNodes.length)), i === !0) {
        var s = l.extractContents();
        return (0, $e02beda658e54aca$var$qn.fragmentToString)(s);
    }
    var o = l.cloneContents(), d = document.createElement("div");
    d.appendChild(o);
    var u = (a = d.textContent) !== null && a !== void 0 ? a : "";
    return u;
}
Object.defineProperty($e02beda658e54aca$var$H, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$H.checkContenteditableSliceForEmptiness = $e02beda658e54aca$var$Xn;
var $e02beda658e54aca$var$Kn = $e02beda658e54aca$var$c, $e02beda658e54aca$var$zn = $e02beda658e54aca$var$F;
function $e02beda658e54aca$var$Xn(e, t, n, r) {
    var i = (0, $e02beda658e54aca$var$zn.getContenteditableSlice)(e, t, n, r);
    return (0, $e02beda658e54aca$var$Kn.isCollapsedWhitespaces)(i);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.checkContenteditableSliceForEmptiness = void 0;
    var t = $e02beda658e54aca$var$H;
    Object.defineProperty(e, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return t.checkContenteditableSliceForEmptiness;
        }
    });
})($e02beda658e54aca$var$Pe);
var $e02beda658e54aca$var$rt = {};
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getContenteditableSlice = void 0;
    var t = $e02beda658e54aca$var$F;
    Object.defineProperty(e, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return t.getContenteditableSlice;
        }
    });
})($e02beda658e54aca$var$rt);
var $e02beda658e54aca$var$it = {}, $e02beda658e54aca$var$je = {};
Object.defineProperty($e02beda658e54aca$var$je, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$je.focus = $e02beda658e54aca$var$Vn;
var $e02beda658e54aca$var$Gn = $e02beda658e54aca$var$c;
function $e02beda658e54aca$var$Vn(e, t) {
    var n, r;
    if (t === void 0 && (t = !0), (0, $e02beda658e54aca$var$Gn.isNativeInput)(e)) {
        e.focus();
        var i = t ? 0 : e.value.length;
        e.setSelectionRange(i, i);
    } else {
        var a = document.createRange(), l = window.getSelection();
        if (!l) return;
        var s = function(g, w) {
            w === void 0 && (w = !1);
            var _ = document.createTextNode("");
            w ? g.insertBefore(_, g.firstChild) : g.appendChild(_), a.setStart(_, 0), a.setEnd(_, 0);
        }, o = function(g) {
            return g != null;
        }, d = e.childNodes, u = t ? d[0] : d[d.length - 1];
        if (o(u)) {
            for(; o(u) && u.nodeType !== Node.TEXT_NODE;)u = t ? u.firstChild : u.lastChild;
            if (o(u) && u.nodeType === Node.TEXT_NODE) {
                var p = (r = (n = u.textContent) === null || n === void 0 ? void 0 : n.length) !== null && r !== void 0 ? r : 0, i = t ? 0 : p;
                a.setStart(u, i), a.setEnd(u, i);
            } else s(e, t);
        } else s(e);
        l.removeAllRanges(), l.addRange(a);
    }
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.focus = void 0;
    var t = $e02beda658e54aca$var$je;
    Object.defineProperty(e, "focus", {
        enumerable: !0,
        get: function() {
            return t.focus;
        }
    });
})($e02beda658e54aca$var$it);
var $e02beda658e54aca$var$Te = {}, $e02beda658e54aca$var$R = {};
Object.defineProperty($e02beda658e54aca$var$R, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$R.getCaretNodeAndOffset = $e02beda658e54aca$var$Yn;
function $e02beda658e54aca$var$Yn() {
    var e = window.getSelection();
    if (e === null) return [
        null,
        0
    ];
    var t = e.focusNode, n = e.focusOffset;
    return t === null ? [
        null,
        0
    ] : (t.nodeType !== Node.TEXT_NODE && t.childNodes.length > 0 && (t.childNodes[n] !== void 0 ? (t = t.childNodes[n], n = 0) : (t = t.childNodes[n - 1], t.textContent !== null && (n = t.textContent.length))), [
        t,
        n
    ]);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getCaretNodeAndOffset = void 0;
    var t = $e02beda658e54aca$var$R;
    Object.defineProperty(e, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return t.getCaretNodeAndOffset;
        }
    });
})($e02beda658e54aca$var$Te);
var $e02beda658e54aca$var$at = {}, $e02beda658e54aca$var$q = {};
Object.defineProperty($e02beda658e54aca$var$q, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$q.getRange = $e02beda658e54aca$var$Jn;
function $e02beda658e54aca$var$Jn() {
    var e = window.getSelection();
    return e && e.rangeCount ? e.getRangeAt(0) : null;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getRange = void 0;
    var t = $e02beda658e54aca$var$q;
    Object.defineProperty(e, "getRange", {
        enumerable: !0,
        get: function() {
            return t.getRange;
        }
    });
})($e02beda658e54aca$var$at);
var $e02beda658e54aca$var$lt = {}, $e02beda658e54aca$var$Le = {};
Object.defineProperty($e02beda658e54aca$var$Le, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$Le.isCaretAtEndOfInput = $e02beda658e54aca$var$xn;
var $e02beda658e54aca$var$De = $e02beda658e54aca$var$c, $e02beda658e54aca$var$Qn = $e02beda658e54aca$var$Te, $e02beda658e54aca$var$Zn = $e02beda658e54aca$var$Pe;
function $e02beda658e54aca$var$xn(e) {
    var t = (0, $e02beda658e54aca$var$De.getDeepestNode)(e, !0);
    if (t === null) return !0;
    if ((0, $e02beda658e54aca$var$De.isNativeInput)(t)) return t.selectionEnd === t.value.length;
    var n = (0, $e02beda658e54aca$var$Qn.getCaretNodeAndOffset)(), r = n[0], i = n[1];
    return r === null ? !1 : (0, $e02beda658e54aca$var$Zn.checkContenteditableSliceForEmptiness)(e, r, i, "right");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCaretAtEndOfInput = void 0;
    var t = $e02beda658e54aca$var$Le;
    Object.defineProperty(e, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return t.isCaretAtEndOfInput;
        }
    });
})($e02beda658e54aca$var$lt);
var $e02beda658e54aca$var$st = {}, $e02beda658e54aca$var$Me = {};
Object.defineProperty($e02beda658e54aca$var$Me, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$Me.isCaretAtStartOfInput = $e02beda658e54aca$var$nr;
var $e02beda658e54aca$var$L = $e02beda658e54aca$var$c, $e02beda658e54aca$var$er = $e02beda658e54aca$var$R, $e02beda658e54aca$var$tr = $e02beda658e54aca$var$H;
function $e02beda658e54aca$var$nr(e) {
    var t = (0, $e02beda658e54aca$var$L.getDeepestNode)(e);
    if (t === null || (0, $e02beda658e54aca$var$L.isEmpty)(e)) return !0;
    if ((0, $e02beda658e54aca$var$L.isNativeInput)(t)) return t.selectionEnd === 0;
    if ((0, $e02beda658e54aca$var$L.isEmpty)(e)) return !0;
    var n = (0, $e02beda658e54aca$var$er.getCaretNodeAndOffset)(), r = n[0], i = n[1];
    return r === null ? !1 : (0, $e02beda658e54aca$var$tr.checkContenteditableSliceForEmptiness)(e, r, i, "left");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCaretAtStartOfInput = void 0;
    var t = $e02beda658e54aca$var$Me;
    Object.defineProperty(e, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return t.isCaretAtStartOfInput;
        }
    });
})($e02beda658e54aca$var$st);
var $e02beda658e54aca$var$ot = {}, $e02beda658e54aca$var$Ne = {};
Object.defineProperty($e02beda658e54aca$var$Ne, "__esModule", {
    value: !0
});
$e02beda658e54aca$var$Ne.save = $e02beda658e54aca$var$ar;
var $e02beda658e54aca$var$rr = $e02beda658e54aca$var$c, $e02beda658e54aca$var$ir = $e02beda658e54aca$var$q;
function $e02beda658e54aca$var$ar() {
    var e = (0, $e02beda658e54aca$var$ir.getRange)(), t = (0, $e02beda658e54aca$var$rr.make)("span");
    if (t.id = "cursor", t.hidden = !0, !!e) return e.insertNode(t), function() {
        var r = window.getSelection();
        r && (e.setStartAfter(t), e.setEndAfter(t), r.removeAllRanges(), r.addRange(e), setTimeout(function() {
            t.remove();
        }, 150));
    };
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.save = void 0;
    var t = $e02beda658e54aca$var$Ne;
    Object.defineProperty(e, "save", {
        enumerable: !0,
        get: function() {
            return t.save;
        }
    });
})($e02beda658e54aca$var$ot);
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.save = e.isCaretAtStartOfInput = e.isCaretAtEndOfInput = e.getRange = e.getCaretNodeAndOffset = e.focus = e.getContenteditableSlice = e.checkContenteditableSliceForEmptiness = void 0;
    var t = $e02beda658e54aca$var$Pe;
    Object.defineProperty(e, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return t.checkContenteditableSliceForEmptiness;
        }
    });
    var n = $e02beda658e54aca$var$rt;
    Object.defineProperty(e, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return n.getContenteditableSlice;
        }
    });
    var r = $e02beda658e54aca$var$it;
    Object.defineProperty(e, "focus", {
        enumerable: !0,
        get: function() {
            return r.focus;
        }
    });
    var i = $e02beda658e54aca$var$Te;
    Object.defineProperty(e, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return i.getCaretNodeAndOffset;
        }
    });
    var a = $e02beda658e54aca$var$at;
    Object.defineProperty(e, "getRange", {
        enumerable: !0,
        get: function() {
            return a.getRange;
        }
    });
    var l = $e02beda658e54aca$var$lt;
    Object.defineProperty(e, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return l.isCaretAtEndOfInput;
        }
    });
    var s = $e02beda658e54aca$var$st;
    Object.defineProperty(e, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return s.isCaretAtStartOfInput;
        }
    });
    var o = $e02beda658e54aca$var$ot;
    Object.defineProperty(e, "save", {
        enumerable: !0,
        get: function() {
            return o.save;
        }
    });
})($e02beda658e54aca$var$j);
class $e02beda658e54aca$var$f {
    /**
   * Getter for all CSS classes used in unordered list rendering
   */ static get CSS() {
        return {
            ...$e02beda658e54aca$var$h,
            checklist: `${$e02beda658e54aca$var$m}-checklist`,
            itemChecked: `${$e02beda658e54aca$var$m}__checkbox--checked`,
            noHover: `${$e02beda658e54aca$var$m}__checkbox--no-hover`,
            checkbox: `${$e02beda658e54aca$var$m}__checkbox-check`,
            checkboxContainer: `${$e02beda658e54aca$var$m}__checkbox`,
            checkboxCheckDisabled: `${$e02beda658e54aca$var$m}__checkbox-check--disabled`
        };
    }
    /**
   * Assign passed readonly mode and config to relevant class properties
   * @param readonly - read-only mode flag
   * @param config - user config for Tool
   */ constructor(t, n){
        this.config = n, this.readOnly = t;
    }
    /**
   * Renders ul wrapper for list
   * @param isRoot - boolean variable that represents level of the wrappre (root or childList)
   * @returns - created html ul element
   */ renderWrapper(t) {
        let n;
        return t === !0 ? (n = $e02beda658e54aca$var$c.make("ul", [
            $e02beda658e54aca$var$f.CSS.wrapper,
            $e02beda658e54aca$var$f.CSS.checklist
        ]), n.addEventListener("click", (r)=>{
            const i = r.target;
            if (i) {
                const a = i.closest(`.${$e02beda658e54aca$var$f.CSS.checkboxContainer}`);
                a && a.contains(i) && this.toggleCheckbox(a);
            }
        })) : n = $e02beda658e54aca$var$c.make("ul", [
            $e02beda658e54aca$var$f.CSS.checklist,
            $e02beda658e54aca$var$f.CSS.itemChildren
        ]), n;
    }
    /**
   * Redners list item element
   * @param content - content used in list item rendering
   * @param meta - meta of the list item used in rendering of the checklist
   * @returns - created html list item element
   */ renderItem(t, n) {
        const r = $e02beda658e54aca$var$c.make("li", [
            $e02beda658e54aca$var$f.CSS.item,
            $e02beda658e54aca$var$f.CSS.item
        ]), i = $e02beda658e54aca$var$c.make("div", $e02beda658e54aca$var$f.CSS.itemContent, {
            innerHTML: t,
            contentEditable: (!this.readOnly).toString()
        }), a = $e02beda658e54aca$var$c.make("span", $e02beda658e54aca$var$f.CSS.checkbox), l = $e02beda658e54aca$var$c.make("div", $e02beda658e54aca$var$f.CSS.checkboxContainer);
        return n.checked === !0 && l.classList.add($e02beda658e54aca$var$f.CSS.itemChecked), this.readOnly && l.classList.add($e02beda658e54aca$var$f.CSS.checkboxCheckDisabled), a.innerHTML = $e02beda658e54aca$var$Ct, l.appendChild(a), r.appendChild(l), r.appendChild(i), r;
    }
    /**
   * Return the item content
   * @param item - item wrapper (<li>)
   * @returns - item content string
   */ getItemContent(t) {
        const n = t.querySelector(`.${$e02beda658e54aca$var$f.CSS.itemContent}`);
        return !n || $e02beda658e54aca$var$c.isEmpty(n) ? "" : n.innerHTML;
    }
    /**
   * Return meta object of certain element
   * @param item - will be returned meta information of this item
   * @returns Item meta object
   */ getItemMeta(t) {
        const n = t.querySelector(`.${$e02beda658e54aca$var$f.CSS.checkboxContainer}`);
        return {
            checked: n ? n.classList.contains($e02beda658e54aca$var$f.CSS.itemChecked) : !1
        };
    }
    /**
   * Returns default item meta used on creation of the new item
   */ composeDefaultMeta() {
        return {
            checked: !1
        };
    }
    /**
   * Toggle checklist item state
   * @param checkbox - checkbox element to be toggled
   */ toggleCheckbox(t) {
        t.classList.toggle($e02beda658e54aca$var$f.CSS.itemChecked), t.classList.add($e02beda658e54aca$var$f.CSS.noHover), t.addEventListener("mouseleave", ()=>this.removeSpecialHoverBehavior(t), {
            once: !0
        });
    }
    /**
   * Removes class responsible for special hover behavior on an item
   * @param el - item wrapper
   */ removeSpecialHoverBehavior(t) {
        t.classList.remove($e02beda658e54aca$var$f.CSS.noHover);
    }
}
function $e02beda658e54aca$var$U(e, t = "after") {
    const n = [];
    let r;
    function i(a) {
        switch(t){
            case "after":
                return a.nextElementSibling;
            case "before":
                return a.previousElementSibling;
        }
    }
    for(r = i(e); r !== null;)n.push(r), r = i(r);
    return n.length !== 0 ? n : null;
}
function $e02beda658e54aca$var$y(e, t = !0) {
    let n = e;
    return e.classList.contains($e02beda658e54aca$var$h.item) && (n = e.querySelector(`.${$e02beda658e54aca$var$h.itemChildren}`)), n === null ? [] : t ? Array.from(n.querySelectorAll(`:scope > .${$e02beda658e54aca$var$h.item}`)) : Array.from(n.querySelectorAll(`.${$e02beda658e54aca$var$h.item}`));
}
function $e02beda658e54aca$var$lr(e) {
    return e.nextElementSibling === null;
}
function $e02beda658e54aca$var$sr(e) {
    return e.querySelector(`.${$e02beda658e54aca$var$h.itemChildren}`) !== null;
}
function $e02beda658e54aca$var$C(e) {
    return e.querySelector(`.${$e02beda658e54aca$var$h.itemChildren}`);
}
function $e02beda658e54aca$var$K(e) {
    let t = e;
    e.classList.contains($e02beda658e54aca$var$h.item) && (t = $e02beda658e54aca$var$C(e)), t !== null && $e02beda658e54aca$var$y(t).length === 0 && t.remove();
}
function $e02beda658e54aca$var$N(e) {
    return e.querySelector(`.${$e02beda658e54aca$var$h.itemContent}`);
}
function $e02beda658e54aca$var$E(e, t = !0) {
    const n = $e02beda658e54aca$var$N(e);
    n && $e02beda658e54aca$var$j.focus(n, t);
}
class $e02beda658e54aca$var$z {
    /**
   * Getter method to get current item
   * @returns current list item or null if caret position is not undefined
   */ get currentItem() {
        const t = window.getSelection();
        if (!t) return null;
        let n = t.anchorNode;
        return !n || ($e02beda658e54aca$var$O(n) || (n = n.parentNode), !n) || !$e02beda658e54aca$var$O(n) ? null : n.closest(`.${$e02beda658e54aca$var$h.item}`);
    }
    /**
   * Method that returns nesting level of the current item, null if there is no selection
   */ get currentItemLevel() {
        const t = this.currentItem;
        if (t === null) return null;
        let n = t.parentNode, r = 0;
        for(; n !== null && n !== this.listWrapper;)$e02beda658e54aca$var$O(n) && n.classList.contains($e02beda658e54aca$var$h.item) && (r += 1), n = n.parentNode;
        return r + 1;
    }
    /**
   * Assign all passed params and renderer to relevant class properties
   * @param params - tool constructor options
   * @param params.data - previously saved data
   * @param params.config - user config for Tool
   * @param params.api - Editor.js API
   * @param params.readOnly - read-only mode flag
   * @param renderer - renderer instance initialized in tool class
   */ constructor({ data: t, config: n, api: r, readOnly: i, block: a }, l){
        this.config = n, this.data = t, this.readOnly = i, this.api = r, this.block = a, this.renderer = l;
    }
    /**
   * Function that is responsible for rendering list with contents
   * @returns Filled with content wrapper element of the list
   */ render() {
        return this.listWrapper = this.renderer.renderWrapper(!0), this.data.items.length ? this.appendItems(this.data.items, this.listWrapper) : this.appendItems([
            {
                content: "",
                meta: {},
                items: []
            }
        ], this.listWrapper), this.readOnly || this.listWrapper.addEventListener("keydown", (t)=>{
            switch(t.key){
                case "Enter":
                    t.shiftKey || this.enterPressed(t);
                    break;
                case "Backspace":
                    this.backspace(t);
                    break;
                case "Tab":
                    t.shiftKey ? this.shiftTab(t) : this.addTab(t);
                    break;
            }
        }, !1), "start" in this.data.meta && this.data.meta.start !== void 0 && this.changeStartWith(this.data.meta.start), "counterType" in this.data.meta && this.data.meta.counterType !== void 0 && this.changeCounters(this.data.meta.counterType), this.listWrapper;
    }
    /**
   * Function that is responsible for list content saving
   * @param wrapper - optional argument wrapper
   * @returns whole list saved data if wrapper not passes, otherwise will return data of the passed wrapper
   */ save(t) {
        const n = t ?? this.listWrapper, r = (l)=>$e02beda658e54aca$var$y(l).map((o)=>{
                const d = $e02beda658e54aca$var$C(o), u = this.renderer.getItemContent(o), p = this.renderer.getItemMeta(o), g = d ? r(d) : [];
                return {
                    content: u,
                    meta: p,
                    items: g
                };
            }), i = n ? r(n) : [];
        let a = {
            style: this.data.style,
            meta: {},
            items: i
        };
        return this.data.style === "ordered" && (a.meta = {
            start: this.data.meta.start,
            counterType: this.data.meta.counterType
        }), a;
    }
    /**
   * On paste sanitzation config. Allow only tags that are allowed in the Tool.
   * @returns - config that determines tags supposted by paste handler
   * @todo - refactor and move to list instance
   */ static get pasteConfig() {
        return {
            tags: [
                "OL",
                "UL",
                "LI"
            ]
        };
    }
    /**
   * Method that specified hot to merge two List blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * Content of the first item of the next List would be merged with deepest item in current list
   * Other items of the next List would be appended to the current list without any changes in nesting levels
   * @param data - data of the second list to be merged with current
   */ merge(t) {
        const n = this.block.holder.querySelectorAll(`.${$e02beda658e54aca$var$h.item}`), r = n[n.length - 1], i = $e02beda658e54aca$var$N(r);
        if (r === null || i === null || (i.insertAdjacentHTML("beforeend", t.items[0].content), this.listWrapper === void 0)) return;
        const a = $e02beda658e54aca$var$y(this.listWrapper);
        if (a.length === 0) return;
        const l = a[a.length - 1];
        let s = $e02beda658e54aca$var$C(l);
        const o = t.items.shift();
        o !== void 0 && (o.items.length !== 0 && (s === null && (s = this.renderer.renderWrapper(!1)), this.appendItems(o.items, s)), t.items.length > 0 && this.appendItems(t.items, this.listWrapper));
    }
    /**
   * On paste callback that is fired from Editor.
   * @param event - event with pasted data
   * @todo - refactor and move to list instance
   */ onPaste(t) {
        const n = t.detail.data;
        this.data = this.pasteHandler(n);
        const r = this.listWrapper;
        r && r.parentNode && r.parentNode.replaceChild(this.render(), r);
    }
    /**
   * Handle UL, OL and LI tags paste and returns List data
   * @param element - html element that contains whole list
   * @todo - refactor and move to list instance
   */ pasteHandler(t) {
        const { tagName: n } = t;
        let r = "unordered", i;
        switch(n){
            case "OL":
                r = "ordered", i = "ol";
                break;
            case "UL":
            case "LI":
                r = "unordered", i = "ul";
        }
        const a = {
            style: r,
            meta: {},
            items: []
        };
        r === "ordered" && (this.data.meta.counterType = "numeric", this.data.meta.start = 1);
        const l = (s)=>Array.from(s.querySelectorAll(":scope > li")).map((d)=>{
                const u = d.querySelector(`:scope > ${i}`), p = u ? l(u) : [];
                return {
                    content: d.innerHTML ?? "",
                    meta: {},
                    items: p
                };
            });
        return a.items = l(t), a;
    }
    /**
   * Changes ordered list start property value
   * @param index - new value of the start property
   */ changeStartWith(t) {
        this.listWrapper.style.setProperty("counter-reset", `item ${t - 1}`), this.data.meta.start = t;
    }
    /**
   * Changes ordered list counterType property value
   * @param counterType - new value of the counterType value
   */ changeCounters(t) {
        this.listWrapper.style.setProperty("--list-counter-type", t), this.data.meta.counterType = t;
    }
    /**
   * Handles Enter keypress
   * @param event - keydown
   */ enterPressed(t) {
        var s;
        const n = this.currentItem;
        if (t.stopPropagation(), t.preventDefault(), t.isComposing || n === null) return;
        const r = ((s = this.renderer) == null ? void 0 : s.getItemContent(n).trim().length) === 0, i = n.parentNode === this.listWrapper, a = n.previousElementSibling === null, l = this.api.blocks.getCurrentBlockIndex();
        if (i && r) {
            if ($e02beda658e54aca$var$lr(n) && !$e02beda658e54aca$var$sr(n)) {
                a ? this.convertItemToDefaultBlock(l, !0) : this.convertItemToDefaultBlock();
                return;
            } else {
                this.splitList(n);
                return;
            }
        } else if (r) {
            this.unshiftItem(n);
            return;
        } else this.splitItem(n);
    }
    /**
   * Handle backspace
   * @param event - keydown
   */ backspace(t) {
        var r;
        const n = this.currentItem;
        if (n !== null && $e02beda658e54aca$var$j.isCaretAtStartOfInput(n) && ((r = window.getSelection()) == null ? void 0 : r.isCollapsed) !== !1) {
            if (t.stopPropagation(), n.parentNode === this.listWrapper && n.previousElementSibling === null) {
                this.convertFirstItemToDefaultBlock();
                return;
            }
            t.preventDefault(), this.mergeItemWithPrevious(n);
        }
    }
    /**
   * Reduce indentation for current item
   * @param event - keydown
   */ shiftTab(t) {
        t.stopPropagation(), t.preventDefault(), this.currentItem !== null && this.unshiftItem(this.currentItem);
    }
    /**
   * Decrease indentation of the passed item
   * @param item - list item to be unshifted
   */ unshiftItem(t) {
        if (!t.parentNode || !$e02beda658e54aca$var$O(t.parentNode)) return;
        const n = t.parentNode.closest(`.${$e02beda658e54aca$var$h.item}`);
        if (!n) return;
        let r = $e02beda658e54aca$var$C(t);
        if (t.parentElement === null) return;
        const i = $e02beda658e54aca$var$U(t);
        i !== null && (r === null && (r = this.renderer.renderWrapper(!1)), i.forEach((a)=>{
            r.appendChild(a);
        }), t.appendChild(r)), n.after(t), $e02beda658e54aca$var$E(t, !1), $e02beda658e54aca$var$K(n);
    }
    /**
   * Method that is used for list splitting and moving trailing items to the new separated list
   * @param item - current item html element
   */ splitList(t) {
        const n = $e02beda658e54aca$var$y(t), r = this.block, i = this.api.blocks.getCurrentBlockIndex();
        if (n.length !== 0) {
            const o = n[0];
            this.unshiftItem(o), $e02beda658e54aca$var$E(t, !1);
        }
        if (t.previousElementSibling === null && t.parentNode === this.listWrapper) {
            this.convertItemToDefaultBlock(i);
            return;
        }
        const a = $e02beda658e54aca$var$U(t);
        if (a === null) return;
        const l = this.renderer.renderWrapper(!0);
        a.forEach((o)=>{
            l.appendChild(o);
        });
        const s = this.save(l);
        s.meta.start = this.data.style == "ordered" ? 1 : void 0, this.api.blocks.insert(r == null ? void 0 : r.name, s, this.config, i + 1), this.convertItemToDefaultBlock(i + 1), l.remove();
    }
    /**
   * Method that is used for splitting item content and moving trailing content to the new sibling item
   * @param currentItem - current item html element
   */ splitItem(t) {
        const [n, r] = $e02beda658e54aca$var$j.getCaretNodeAndOffset();
        if (n === null) return;
        const i = $e02beda658e54aca$var$N(t);
        let a;
        i === null ? a = "" : a = $e02beda658e54aca$var$j.getContenteditableSlice(i, n, r, "right", !0);
        const l = $e02beda658e54aca$var$C(t), s = this.renderItem(a);
        t == null || t.after(s), l && s.appendChild(l), $e02beda658e54aca$var$E(s);
    }
    /**
   * Method that is used for merging current item with previous one
   * Content of the current item would be appended to the previous item
   * Current item children would not change nesting level
   * @param item - current item html element
   */ mergeItemWithPrevious(t) {
        const n = t.previousElementSibling, r = t.parentNode;
        if (r === null || !$e02beda658e54aca$var$O(r)) return;
        const i = r.closest(`.${$e02beda658e54aca$var$h.item}`);
        if (!n && !i || n && !$e02beda658e54aca$var$O(n)) return;
        let a;
        if (n) {
            const p = $e02beda658e54aca$var$y(n, !1);
            p.length !== 0 && p.length !== 0 ? a = p[p.length - 1] : a = n;
        } else a = i;
        const l = this.renderer.getItemContent(t);
        if (!a) return;
        $e02beda658e54aca$var$E(a, !1);
        const s = $e02beda658e54aca$var$N(a);
        if (s === null) return;
        s.insertAdjacentHTML("beforeend", l);
        const o = $e02beda658e54aca$var$y(t);
        if (o.length === 0) {
            t.remove(), $e02beda658e54aca$var$K(a);
            return;
        }
        const d = n || i, u = $e02beda658e54aca$var$C(d) ?? this.renderer.renderWrapper(!1);
        n ? o.forEach((p)=>{
            u.appendChild(p);
        }) : o.forEach((p)=>{
            u.prepend(p);
        }), $e02beda658e54aca$var$C(d) === null && a.appendChild(u), t.remove();
    }
    /**
   * Add indentation to current item
   * @param event - keydown
   */ addTab(t) {
        var a;
        t.stopPropagation(), t.preventDefault();
        const n = this.currentItem;
        if (!n) return;
        if (((a = this.config) == null ? void 0 : a.maxLevel) !== void 0) {
            const l = this.currentItemLevel;
            if (l !== null && l === this.config.maxLevel) return;
        }
        const r = n.previousSibling;
        if (r === null || !$e02beda658e54aca$var$O(r)) return;
        const i = $e02beda658e54aca$var$C(r);
        if (i) i.appendChild(n), $e02beda658e54aca$var$y(n).forEach((s)=>{
            i.appendChild(s);
        });
        else {
            const l = this.renderer.renderWrapper(!1);
            l.appendChild(n), $e02beda658e54aca$var$y(n).forEach((o)=>{
                l.appendChild(o);
            }), r.appendChild(l);
        }
        $e02beda658e54aca$var$K(n), $e02beda658e54aca$var$E(n, !1);
    }
    /**
   * Convert current item to default block with passed index
   * @param newBloxkIndex - optional parameter represents index, where would be inseted default block
   * @param removeList - optional parameter, that represents condition, if List should be removed
   */ convertItemToDefaultBlock(t, n) {
        let r;
        const i = this.currentItem, a = i !== null ? this.renderer.getItemContent(i) : "";
        n === !0 && this.api.blocks.delete(), t !== void 0 ? r = this.api.blocks.insert(void 0, {
            text: a
        }, void 0, t) : r = this.api.blocks.insert(), i == null || i.remove(), this.api.caret.setToBlock(r, "start");
    }
    /**
   * Convert first item of the list to default block
   * This method could be called when backspace button pressed at start of the first item of the list
   * First item of the list would be converted to the paragraph and first item children would be unshifted
   */ convertFirstItemToDefaultBlock() {
        const t = this.currentItem;
        if (t === null) return;
        const n = $e02beda658e54aca$var$y(t);
        if (n.length !== 0) {
            const l = n[0];
            this.unshiftItem(l), $e02beda658e54aca$var$E(t);
        }
        const r = $e02beda658e54aca$var$U(t), i = this.api.blocks.getCurrentBlockIndex(), a = r === null;
        this.convertItemToDefaultBlock(i, a);
    }
    /**
   * Method that calls render function of the renderer with a necessary item meta cast
   * @param itemContent - content to be rendered in new item
   * @param meta - meta used in list item rendering
   * @returns html element of the rendered item
   */ renderItem(t, n) {
        const r = n ?? this.renderer.composeDefaultMeta();
        switch(!0){
            case this.renderer instanceof $e02beda658e54aca$var$v:
                return this.renderer.renderItem(t, r);
            case this.renderer instanceof $e02beda658e54aca$var$b:
                return this.renderer.renderItem(t, r);
            default:
                return this.renderer.renderItem(t, r);
        }
    }
    /**
   * Renders children list
   * @param items - list data used in item rendering
   * @param parentElement - where to append passed items
   */ appendItems(t, n) {
        t.forEach((r)=>{
            var a;
            const i = this.renderItem(r.content, r.meta);
            if (n.appendChild(i), r.items.length) {
                const l = (a = this.renderer) == null ? void 0 : a.renderWrapper(!1);
                this.appendItems(r.items, l), i.appendChild(l);
            }
        });
    }
}
const $e02beda658e54aca$var$I = {
    wrapper: `${$e02beda658e54aca$var$m}-start-with-field`,
    input: `${$e02beda658e54aca$var$m}-start-with-field__input`,
    startWithElementWrapperInvalid: `${$e02beda658e54aca$var$m}-start-with-field--invalid`
};
function $e02beda658e54aca$var$or(e, { value: t, placeholder: n, attributes: r, sanitize: i }) {
    const a = $e02beda658e54aca$var$c.make("div", $e02beda658e54aca$var$I.wrapper), l = $e02beda658e54aca$var$c.make("input", $e02beda658e54aca$var$I.input, {
        placeholder: n,
        /**
     * Used to prevent focusing on the input by Tab key
     * (Popover in the Toolbar lays below the blocks,
     * so Tab in the last block will focus this hidden input if this property is not set)
     */ tabIndex: -1,
        /**
     * Value of the start property, if it is not specified, then it is set to one
     */ value: t
    });
    for(const s in r)l.setAttribute(s, r[s]);
    return a.appendChild(l), l.addEventListener("input", ()=>{
        i !== void 0 && (l.value = i(l.value));
        const s = l.checkValidity();
        !s && !a.classList.contains($e02beda658e54aca$var$I.startWithElementWrapperInvalid) && a.classList.add($e02beda658e54aca$var$I.startWithElementWrapperInvalid), s && a.classList.contains($e02beda658e54aca$var$I.startWithElementWrapperInvalid) && a.classList.remove($e02beda658e54aca$var$I.startWithElementWrapperInvalid), s && e(l.value);
    }), a;
}
const $e02beda658e54aca$var$P = /* @__PURE__ */ new Map([
    /**
   * Value that represents default arabic numbers for counters
   */ [
        "Numeric",
        "numeric"
    ],
    /**
   * Value that represents lower roman numbers for counteres
   */ [
        "Lower Roman",
        "lower-roman"
    ],
    /**
   * Value that represents upper roman numbers for counters
   */ [
        "Upper Roman",
        "upper-roman"
    ],
    /**
   * Value that represents lower alpha characters for counters
   */ [
        "Lower Alpha",
        "lower-alpha"
    ],
    /**
   * Value that represents upper alpha characters for counters
   */ [
        "Upper Alpha",
        "upper-alpha"
    ]
]), $e02beda658e54aca$var$He = /* @__PURE__ */ new Map([
    /**
   * Value that represents Icon for Numeric counter type
   */ [
        "numeric",
        $e02beda658e54aca$var$St
    ],
    /**
   * Value that represents Icon for Lower Roman counter type
   */ [
        "lower-roman",
        $e02beda658e54aca$var$Ot
    ],
    /**
   * Value that represents Icon for Upper Roman counter type
   */ [
        "upper-roman",
        $e02beda658e54aca$var$kt
    ],
    /**
   * Value that represents Icon for Lower Alpha counter type
   */ [
        "lower-alpha",
        $e02beda658e54aca$var$Et
    ],
    /**
   * Value that represents Icon for Upper Alpha counter type
   */ [
        "upper-alpha",
        $e02beda658e54aca$var$_t
    ]
]);
function $e02beda658e54aca$var$ur(e) {
    return e.replace(/\D+/g, "");
}
function $e02beda658e54aca$var$cr(e) {
    return typeof e.items[0] == "string";
}
function $e02beda658e54aca$var$dr(e) {
    return !("meta" in e);
}
function $e02beda658e54aca$var$fr(e) {
    return typeof e.items[0] != "string" && "text" in e.items[0] && "checked" in e.items[0] && typeof e.items[0].text == "string" && typeof e.items[0].checked == "boolean";
}
function $e02beda658e54aca$var$pr(e) {
    const t = [];
    return $e02beda658e54aca$var$cr(e) ? (e.items.forEach((n)=>{
        t.push({
            content: n,
            meta: {},
            items: []
        });
    }), {
        style: e.style,
        meta: {},
        items: t
    }) : $e02beda658e54aca$var$fr(e) ? (e.items.forEach((n)=>{
        t.push({
            content: n.text,
            meta: {
                checked: n.checked
            },
            items: []
        });
    }), {
        style: "checklist",
        meta: {},
        items: t
    }) : $e02beda658e54aca$var$dr(e) ? {
        style: e.style,
        meta: {},
        items: e.items
    } : structuredClone(e);
}
class $e02beda658e54aca$export$2e2bcd8739ae039 {
    /**
   * Notify core that read-only mode is supported
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Allow to use native Enter behaviour
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   */ static get toolbox() {
        return [
            {
                icon: $e02beda658e54aca$var$$e,
                title: "Unordered List",
                data: {
                    style: "unordered"
                }
            },
            {
                icon: $e02beda658e54aca$var$Be,
                title: "Ordered List",
                data: {
                    style: "ordered"
                }
            },
            {
                icon: $e02beda658e54aca$var$Ae,
                title: "Checklist",
                data: {
                    style: "checklist"
                }
            }
        ];
    }
    /**
   * On paste sanitzation config. Allow only tags that are allowed in the Tool.
   * @returns - paste config object used in editor
   */ static get pasteConfig() {
        return {
            tags: [
                "OL",
                "UL",
                "LI"
            ]
        };
    }
    /**
   * Convert from text to list with import and export list to text
   */ static get conversionConfig() {
        return {
            export: (t)=>$e02beda658e54aca$export$2e2bcd8739ae039.joinRecursive(t),
            import: (t, n)=>({
                    meta: {},
                    items: [
                        {
                            content: t,
                            meta: {},
                            items: []
                        }
                    ],
                    style: (n == null ? void 0 : n.defaultStyle) !== void 0 ? n.defaultStyle : "unordered"
                })
        };
    }
    /**
   * Get list style name
   */ get listStyle() {
        return this.data.style || this.defaultListStyle;
    }
    /**
   * Set list style
   * @param style - new style to set
   */ set listStyle(t) {
        var r;
        this.data.style = t, this.changeTabulatorByStyle();
        const n = this.list.render();
        (r = this.listElement) == null || r.replaceWith(n), this.listElement = n;
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   * @param params - tool constructor options
   * @param params.data - previously saved data
   * @param params.config - user config for Tool
   * @param params.api - Editor.js API
   * @param params.readOnly - read-only mode flag
   */ constructor({ data: t, config: n, api: r, readOnly: i, block: a }){
        var s;
        this.api = r, this.readOnly = i, this.config = n, this.block = a, this.defaultListStyle = ((s = this.config) == null ? void 0 : s.defaultStyle) || "unordered", this.defaultCounterTypes = this.config.counterTypes || Array.from($e02beda658e54aca$var$P.values());
        const l = {
            style: this.defaultListStyle,
            meta: {},
            items: []
        };
        this.data = Object.keys(t).length ? $e02beda658e54aca$var$pr(t) : l, this.listStyle === "ordered" && this.data.meta.counterType === void 0 && (this.data.meta.counterType = "numeric"), this.changeTabulatorByStyle();
    }
    /**
   * Convert from list to text for conversionConfig
   * @param data - current data of the list
   * @returns - string of the recursively merged contents of the items of the list
   */ static joinRecursive(t) {
        return t.items.map((n)=>`${n.content} ${$e02beda658e54aca$export$2e2bcd8739ae039.joinRecursive(n)}`).join("");
    }
    /**
   * Function that is responsible for content rendering
   * @returns rendered list wrapper with all contents
   */ render() {
        return this.listElement = this.list.render(), this.listElement;
    }
    /**
   * Function that is responsible for content saving
   * @returns formatted content used in editor
   */ save() {
        return this.data = this.list.save(), this.data;
    }
    /**
   * Function that is responsible for mergind two lists into one
   * @param data - data of the next standing list, that should be merged with current
   */ merge(t) {
        this.list.merge(t);
    }
    /**
   * Creates Block Tune allowing to change the list style
   * @returns array of tune configs
   */ renderSettings() {
        const t = [
            {
                label: this.api.i18n.t("Unordered"),
                icon: $e02beda658e54aca$var$$e,
                closeOnActivate: !0,
                isActive: this.listStyle == "unordered",
                onActivate: ()=>{
                    this.listStyle = "unordered";
                }
            },
            {
                label: this.api.i18n.t("Ordered"),
                icon: $e02beda658e54aca$var$Be,
                closeOnActivate: !0,
                isActive: this.listStyle == "ordered",
                onActivate: ()=>{
                    this.listStyle = "ordered";
                }
            },
            {
                label: this.api.i18n.t("Checklist"),
                icon: $e02beda658e54aca$var$Ae,
                closeOnActivate: !0,
                isActive: this.listStyle == "checklist",
                onActivate: ()=>{
                    this.listStyle = "checklist";
                }
            }
        ];
        if (this.listStyle === "ordered") {
            const n = $e02beda658e54aca$var$or((a)=>this.changeStartWith(Number(a)), {
                value: String(this.data.meta.start ?? 1),
                placeholder: "",
                attributes: {
                    required: "true"
                },
                sanitize: (a)=>$e02beda658e54aca$var$ur(a)
            }), r = [
                {
                    label: this.api.i18n.t("Start with"),
                    icon: $e02beda658e54aca$var$It,
                    children: {
                        items: [
                            {
                                element: n,
                                // @ts-expect-error ts(2820) can not use PopoverItem enum from editor.js types
                                type: "html"
                            }
                        ]
                    }
                }
            ], i = {
                label: this.api.i18n.t("Counter type"),
                icon: $e02beda658e54aca$var$He.get(this.data.meta.counterType),
                children: {
                    items: []
                }
            };
            $e02beda658e54aca$var$P.forEach((a, l)=>{
                const s = $e02beda658e54aca$var$P.get(l);
                this.defaultCounterTypes.includes(s) && i.children.items.push({
                    title: this.api.i18n.t(l),
                    icon: $e02beda658e54aca$var$He.get(s),
                    isActive: this.data.meta.counterType === $e02beda658e54aca$var$P.get(l),
                    closeOnActivate: !0,
                    onActivate: ()=>{
                        this.changeCounters($e02beda658e54aca$var$P.get(l));
                    }
                });
            }), i.children.items.length > 1 && r.push(i), t.push({
                type: "separator"
            }, ...r);
        }
        return t;
    }
    /**
   * On paste callback that is fired from Editor.
   * @param event - event with pasted data
   */ onPaste(t) {
        const { tagName: n } = t.detail.data;
        switch(n){
            case "OL":
                this.listStyle = "ordered";
                break;
            case "UL":
            case "LI":
                this.listStyle = "unordered";
        }
        this.list.onPaste(t);
    }
    /**
   * Handle UL, OL and LI tags paste and returns List data
   * @param element - html element that contains whole list
   */ pasteHandler(t) {
        return this.list.pasteHandler(t);
    }
    /**
   * Changes ordered list counterType property value
   * @param counterType - new value of the counterType value
   */ changeCounters(t) {
        var n;
        (n = this.list) == null || n.changeCounters(t), this.data.meta.counterType = t;
    }
    /**
   * Changes ordered list start property value
   * @param index - new value of the start property
   */ changeStartWith(t) {
        var n;
        (n = this.list) == null || n.changeStartWith(t), this.data.meta.start = t;
    }
    /**
   * This method allows changing tabulator respectfully to passed style
   */ changeTabulatorByStyle() {
        switch(this.listStyle){
            case "ordered":
                this.list = new $e02beda658e54aca$var$z({
                    data: this.data,
                    readOnly: this.readOnly,
                    api: this.api,
                    config: this.config,
                    block: this.block
                }, new $e02beda658e54aca$var$v(this.readOnly, this.config));
                break;
            case "unordered":
                this.list = new $e02beda658e54aca$var$z({
                    data: this.data,
                    readOnly: this.readOnly,
                    api: this.api,
                    config: this.config,
                    block: this.block
                }, new $e02beda658e54aca$var$b(this.readOnly, this.config));
                break;
            case "checklist":
                this.list = new $e02beda658e54aca$var$z({
                    data: this.data,
                    readOnly: this.readOnly,
                    api: this.api,
                    config: this.config,
                    block: this.block
                }, new $e02beda658e54aca$var$f(this.readOnly, this.config));
                break;
        }
    }
}


(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var t = document.createElement("style");
            t.appendChild(document.createTextNode(".cdx-quote-icon svg{transform:rotate(180deg)}.cdx-quote{margin:0}.cdx-quote__text{min-height:158px;margin-bottom:10px}.cdx-quote [contentEditable=true][data-placeholder]:before{position:absolute;content:attr(data-placeholder);color:#707684;font-weight:400;opacity:0}.cdx-quote [contentEditable=true][data-placeholder]:empty:before{opacity:1}.cdx-quote [contentEditable=true][data-placeholder]:empty:focus:before{opacity:0}.cdx-quote-settings{display:flex}.cdx-quote-settings .cdx-settings-button{width:50%}")), document.head.appendChild(t);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $a8bdaba10cb74666$var$De = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 7L6 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M18 17H6"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16 12L8 12"/></svg>', $a8bdaba10cb74666$var$He = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17 7L5 7"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17 17H5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13 12L5 12"/></svg>', $a8bdaba10cb74666$var$Re = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 10.8182L9 10.8182C8.80222 10.8182 8.60888 10.7649 8.44443 10.665C8.27998 10.5651 8.15181 10.4231 8.07612 10.257C8.00043 10.0909 7.98063 9.90808 8.01922 9.73174C8.0578 9.55539 8.15304 9.39341 8.29289 9.26627C8.43275 9.13913 8.61093 9.05255 8.80491 9.01747C8.99889 8.98239 9.19996 9.00039 9.38268 9.0692C9.56541 9.13801 9.72159 9.25453 9.83147 9.40403C9.94135 9.55353 10 9.72929 10 9.90909L10 12.1818C10 12.664 9.78929 13.1265 9.41421 13.4675C9.03914 13.8084 8.53043 14 8 14"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 10.8182L15 10.8182C14.8022 10.8182 14.6089 10.7649 14.4444 10.665C14.28 10.5651 14.1518 10.4231 14.0761 10.257C14.0004 10.0909 13.9806 9.90808 14.0192 9.73174C14.0578 9.55539 14.153 9.39341 14.2929 9.26627C14.4327 9.13913 14.6109 9.05255 14.8049 9.01747C14.9989 8.98239 15.2 9.00039 15.3827 9.0692C15.5654 9.13801 15.7216 9.25453 15.8315 9.40403C15.9414 9.55353 16 9.72929 16 9.90909L16 12.1818C16 12.664 15.7893 13.1265 15.4142 13.4675C15.0391 13.8084 14.5304 14 14 14"/></svg>';
var $a8bdaba10cb74666$var$b = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $a8bdaba10cb74666$var$Fe(e) {
    if (e.__esModule) return e;
    var t = e.default;
    if (typeof t == "function") {
        var n = function r() {
            return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
        };
        n.prototype = t.prototype;
    } else n = {};
    return Object.defineProperty(n, "__esModule", {
        value: !0
    }), Object.keys(e).forEach(function(r) {
        var i = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(n, r, i.get ? i : {
            enumerable: !0,
            get: function() {
                return e[r];
            }
        });
    }), n;
}
var $a8bdaba10cb74666$var$v = {}, $a8bdaba10cb74666$var$P = {}, $a8bdaba10cb74666$var$j = {};
Object.defineProperty($a8bdaba10cb74666$var$j, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$j.allInputsSelector = $a8bdaba10cb74666$var$We;
function $a8bdaba10cb74666$var$We() {
    var e = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + e.map(function(t) {
        return 'input[type="'.concat(t, '"]');
    }).join(", ");
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.allInputsSelector = void 0;
    var t = $a8bdaba10cb74666$var$j;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return t.allInputsSelector;
        }
    });
})($a8bdaba10cb74666$var$P);
var $a8bdaba10cb74666$var$c = {}, $a8bdaba10cb74666$var$T = {};
Object.defineProperty($a8bdaba10cb74666$var$T, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$T.isNativeInput = $a8bdaba10cb74666$var$Ue;
function $a8bdaba10cb74666$var$Ue(e) {
    var t = [
        "INPUT",
        "TEXTAREA"
    ];
    return e && e.tagName ? t.includes(e.tagName) : !1;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNativeInput = void 0;
    var t = $a8bdaba10cb74666$var$T;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return t.isNativeInput;
        }
    });
})($a8bdaba10cb74666$var$c);
var $a8bdaba10cb74666$var$ie = {}, $a8bdaba10cb74666$var$C = {};
Object.defineProperty($a8bdaba10cb74666$var$C, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$C.append = $a8bdaba10cb74666$var$qe;
function $a8bdaba10cb74666$var$qe(e, t) {
    Array.isArray(t) ? t.forEach(function(n) {
        e.appendChild(n);
    }) : e.appendChild(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.append = void 0;
    var t = $a8bdaba10cb74666$var$C;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function() {
            return t.append;
        }
    });
})($a8bdaba10cb74666$var$ie);
var $a8bdaba10cb74666$var$L = {}, $a8bdaba10cb74666$var$S = {};
Object.defineProperty($a8bdaba10cb74666$var$S, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$S.blockElements = $a8bdaba10cb74666$var$ze;
function $a8bdaba10cb74666$var$ze() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.blockElements = void 0;
    var t = $a8bdaba10cb74666$var$S;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function() {
            return t.blockElements;
        }
    });
})($a8bdaba10cb74666$var$L);
var $a8bdaba10cb74666$var$ae = {}, $a8bdaba10cb74666$var$M = {};
Object.defineProperty($a8bdaba10cb74666$var$M, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$M.calculateBaseline = $a8bdaba10cb74666$var$Ge;
function $a8bdaba10cb74666$var$Ge(e) {
    var t = window.getComputedStyle(e), n = parseFloat(t.fontSize), r = parseFloat(t.lineHeight) || n * 1.2, i = parseFloat(t.paddingTop), a = parseFloat(t.borderTopWidth), l = parseFloat(t.marginTop), u = n * 0.8, d = (r - n) / 2, s = l + a + i + d + u;
    return s;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.calculateBaseline = void 0;
    var t = $a8bdaba10cb74666$var$M;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return t.calculateBaseline;
        }
    });
})($a8bdaba10cb74666$var$ae);
var $a8bdaba10cb74666$var$le = {}, $a8bdaba10cb74666$var$k = {}, $a8bdaba10cb74666$var$w = {}, $a8bdaba10cb74666$var$N = {};
Object.defineProperty($a8bdaba10cb74666$var$N, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$N.isContentEditable = $a8bdaba10cb74666$var$Ke;
function $a8bdaba10cb74666$var$Ke(e) {
    return e.contentEditable === "true";
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isContentEditable = void 0;
    var t = $a8bdaba10cb74666$var$N;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return t.isContentEditable;
        }
    });
})($a8bdaba10cb74666$var$w);
Object.defineProperty($a8bdaba10cb74666$var$k, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$k.canSetCaret = $a8bdaba10cb74666$var$Qe;
var $a8bdaba10cb74666$var$Xe = $a8bdaba10cb74666$var$c, $a8bdaba10cb74666$var$Ye = $a8bdaba10cb74666$var$w;
function $a8bdaba10cb74666$var$Qe(e) {
    var t = !0;
    if ((0, $a8bdaba10cb74666$var$Xe.isNativeInput)(e)) switch(e.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            t = !1;
            break;
    }
    else t = (0, $a8bdaba10cb74666$var$Ye.isContentEditable)(e);
    return t;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.canSetCaret = void 0;
    var t = $a8bdaba10cb74666$var$k;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return t.canSetCaret;
        }
    });
})($a8bdaba10cb74666$var$le);
var $a8bdaba10cb74666$var$y = {}, $a8bdaba10cb74666$var$I = {};
function $a8bdaba10cb74666$var$Ve(e, t, n) {
    const r = n.value !== void 0 ? "value" : "get", i = n[r], a = `#${t}Cache`;
    if (n[r] = function(...l) {
        return this[a] === void 0 && (this[a] = i.apply(this, l)), this[a];
    }, r === "get" && n.set) {
        const l = n.set;
        n.set = function(u) {
            delete e[a], l.apply(this, u);
        };
    }
    return n;
}
function $a8bdaba10cb74666$var$ue() {
    const e = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, t = Object.keys(e).find((n)=>window.navigator.appVersion.toLowerCase().indexOf(n) !== -1);
    return t !== void 0 && (e[t] = !0), e;
}
function $a8bdaba10cb74666$var$A(e) {
    return e != null && e !== "" && (typeof e != "object" || Object.keys(e).length > 0);
}
function $a8bdaba10cb74666$var$Ze(e) {
    return !$a8bdaba10cb74666$var$A(e);
}
const $a8bdaba10cb74666$var$Je = ()=>typeof window < "u" && window.navigator !== null && $a8bdaba10cb74666$var$A(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $a8bdaba10cb74666$var$xe(e) {
    const t = $a8bdaba10cb74666$var$ue();
    return e = e.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), t.mac ? e = e.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : e = e.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), e;
}
function $a8bdaba10cb74666$var$et(e) {
    return e[0].toUpperCase() + e.slice(1);
}
function $a8bdaba10cb74666$var$tt(e) {
    const t = document.createElement("div");
    t.style.position = "absolute", t.style.left = "-999px", t.style.bottom = "-999px", t.innerHTML = e, document.body.appendChild(t);
    const n = window.getSelection(), r = document.createRange();
    if (r.selectNode(t), n === null) throw new Error("Cannot copy text to clipboard");
    n.removeAllRanges(), n.addRange(r), document.execCommand("copy"), document.body.removeChild(t);
}
function $a8bdaba10cb74666$var$nt(e, t, n) {
    let r;
    return (...i)=>{
        const a = this, l = ()=>{
            r = void 0, n !== !0 && e.apply(a, i);
        }, u = n === !0 && r !== void 0;
        window.clearTimeout(r), r = window.setTimeout(l, t), u && e.apply(a, i);
    };
}
function $a8bdaba10cb74666$var$o(e) {
    return Object.prototype.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $a8bdaba10cb74666$var$rt(e) {
    return $a8bdaba10cb74666$var$o(e) === "boolean";
}
function $a8bdaba10cb74666$var$oe(e) {
    return $a8bdaba10cb74666$var$o(e) === "function" || $a8bdaba10cb74666$var$o(e) === "asyncfunction";
}
function $a8bdaba10cb74666$var$it(e) {
    return $a8bdaba10cb74666$var$oe(e) && /^\s*class\s+/.test(e.toString());
}
function $a8bdaba10cb74666$var$at(e) {
    return $a8bdaba10cb74666$var$o(e) === "number";
}
function $a8bdaba10cb74666$var$g(e) {
    return $a8bdaba10cb74666$var$o(e) === "object";
}
function $a8bdaba10cb74666$var$lt(e) {
    return Promise.resolve(e) === e;
}
function $a8bdaba10cb74666$var$ut(e) {
    return $a8bdaba10cb74666$var$o(e) === "string";
}
function $a8bdaba10cb74666$var$ot(e) {
    return $a8bdaba10cb74666$var$o(e) === "undefined";
}
function $a8bdaba10cb74666$var$O(e, ...t) {
    if (!t.length) return e;
    const n = t.shift();
    if ($a8bdaba10cb74666$var$g(e) && $a8bdaba10cb74666$var$g(n)) for(const r in n)$a8bdaba10cb74666$var$g(n[r]) ? (e[r] === void 0 && Object.assign(e, {
        [r]: {}
    }), $a8bdaba10cb74666$var$O(e[r], n[r])) : Object.assign(e, {
        [r]: n[r]
    });
    return $a8bdaba10cb74666$var$O(e, ...t);
}
function $a8bdaba10cb74666$var$st(e, t, n) {
    const r = `\xab${t}\xbb is deprecated and will be removed in the next major release. Please use the \xab${n}\xbb instead.`;
    e && console.warn(r);
}
function $a8bdaba10cb74666$var$ct(e) {
    try {
        return new URL(e).href;
    } catch  {}
    return e.substring(0, 2) === "//" ? window.location.protocol + e : window.location.origin + e;
}
function $a8bdaba10cb74666$var$dt(e) {
    return e > 47 && e < 58 || e === 32 || e === 13 || e === 229 || e > 64 && e < 91 || e > 95 && e < 112 || e > 185 && e < 193 || e > 218 && e < 223;
}
const $a8bdaba10cb74666$var$ft = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $a8bdaba10cb74666$var$pt = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
class $a8bdaba10cb74666$var$vt {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ add(t) {
        return new Promise((n, r)=>{
            this.completed = this.completed.then(t).then(n).catch(r);
        });
    }
}
function $a8bdaba10cb74666$var$gt(e, t, n) {
    let r, i, a, l = null, u = 0;
    n || (n = {});
    const d = function() {
        u = n.leading === !1 ? 0 : Date.now(), l = null, a = e.apply(r, i), l === null && (r = i = null);
    };
    return function() {
        const s = Date.now();
        !u && n.leading === !1 && (u = s);
        const f = t - (s - u);
        return r = this, i = arguments, f <= 0 || f > t ? (l && (clearTimeout(l), l = null), u = s, a = e.apply(r, i), l === null && (r = i = null)) : !l && n.trailing !== !1 && (l = setTimeout(d, f)), a;
    };
}
const $a8bdaba10cb74666$var$mt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $a8bdaba10cb74666$var$vt,
    beautifyShortcut: $a8bdaba10cb74666$var$xe,
    cacheable: $a8bdaba10cb74666$var$Ve,
    capitalize: $a8bdaba10cb74666$var$et,
    copyTextToClipboard: $a8bdaba10cb74666$var$tt,
    debounce: $a8bdaba10cb74666$var$nt,
    deepMerge: $a8bdaba10cb74666$var$O,
    deprecationAssert: $a8bdaba10cb74666$var$st,
    getUserOS: $a8bdaba10cb74666$var$ue,
    getValidUrl: $a8bdaba10cb74666$var$ct,
    isBoolean: $a8bdaba10cb74666$var$rt,
    isClass: $a8bdaba10cb74666$var$it,
    isEmpty: $a8bdaba10cb74666$var$Ze,
    isFunction: $a8bdaba10cb74666$var$oe,
    isIosDevice: $a8bdaba10cb74666$var$Je,
    isNumber: $a8bdaba10cb74666$var$at,
    isObject: $a8bdaba10cb74666$var$g,
    isPrintableKey: $a8bdaba10cb74666$var$dt,
    isPromise: $a8bdaba10cb74666$var$lt,
    isString: $a8bdaba10cb74666$var$ut,
    isUndefined: $a8bdaba10cb74666$var$ot,
    keyCodes: $a8bdaba10cb74666$var$ft,
    mouseButtons: $a8bdaba10cb74666$var$pt,
    notEmpty: $a8bdaba10cb74666$var$A,
    throttle: $a8bdaba10cb74666$var$gt,
    typeOf: $a8bdaba10cb74666$var$o
}, Symbol.toStringTag, {
    value: "Module"
})), $a8bdaba10cb74666$var$$ = /* @__PURE__ */ $a8bdaba10cb74666$var$Fe($a8bdaba10cb74666$var$mt);
Object.defineProperty($a8bdaba10cb74666$var$I, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$I.containsOnlyInlineElements = $a8bdaba10cb74666$var$_t;
var $a8bdaba10cb74666$var$bt = $a8bdaba10cb74666$var$$, $a8bdaba10cb74666$var$yt = $a8bdaba10cb74666$var$L;
function $a8bdaba10cb74666$var$_t(e) {
    var t;
    (0, $a8bdaba10cb74666$var$bt.isString)(e) ? (t = document.createElement("div"), t.innerHTML = e) : t = e;
    var n = function(r) {
        return !(0, $a8bdaba10cb74666$var$yt.blockElements)().includes(r.tagName.toLowerCase()) && Array.from(r.children).every(n);
    };
    return Array.from(t.children).every(n);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.containsOnlyInlineElements = void 0;
    var t = $a8bdaba10cb74666$var$I;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return t.containsOnlyInlineElements;
        }
    });
})($a8bdaba10cb74666$var$y);
var $a8bdaba10cb74666$var$se = {}, $a8bdaba10cb74666$var$B = {}, $a8bdaba10cb74666$var$_ = {}, $a8bdaba10cb74666$var$D = {};
Object.defineProperty($a8bdaba10cb74666$var$D, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$D.make = $a8bdaba10cb74666$var$ht;
function $a8bdaba10cb74666$var$ht(e, t, n) {
    var r;
    t === void 0 && (t = null), n === void 0 && (n = {});
    var i = document.createElement(e);
    if (Array.isArray(t)) {
        var a = t.filter(function(u) {
            return u !== void 0;
        });
        (r = i.classList).add.apply(r, a);
    } else t !== null && i.classList.add(t);
    for(var l in n)Object.prototype.hasOwnProperty.call(n, l) && (i[l] = n[l]);
    return i;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.make = void 0;
    var t = $a8bdaba10cb74666$var$D;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function() {
            return t.make;
        }
    });
})($a8bdaba10cb74666$var$_);
Object.defineProperty($a8bdaba10cb74666$var$B, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$B.fragmentToString = $a8bdaba10cb74666$var$Ot;
var $a8bdaba10cb74666$var$Et = $a8bdaba10cb74666$var$_;
function $a8bdaba10cb74666$var$Ot(e) {
    var t = (0, $a8bdaba10cb74666$var$Et.make)("div");
    return t.appendChild(e), t.innerHTML;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.fragmentToString = void 0;
    var t = $a8bdaba10cb74666$var$B;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return t.fragmentToString;
        }
    });
})($a8bdaba10cb74666$var$se);
var $a8bdaba10cb74666$var$ce = {}, $a8bdaba10cb74666$var$H = {};
Object.defineProperty($a8bdaba10cb74666$var$H, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$H.getContentLength = $a8bdaba10cb74666$var$jt;
var $a8bdaba10cb74666$var$Pt = $a8bdaba10cb74666$var$c;
function $a8bdaba10cb74666$var$jt(e) {
    var t, n;
    return (0, $a8bdaba10cb74666$var$Pt.isNativeInput)(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : (n = (t = e.textContent) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getContentLength = void 0;
    var t = $a8bdaba10cb74666$var$H;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function() {
            return t.getContentLength;
        }
    });
})($a8bdaba10cb74666$var$ce);
var $a8bdaba10cb74666$var$R = {}, $a8bdaba10cb74666$var$F = {}, $a8bdaba10cb74666$var$re = $a8bdaba10cb74666$var$b && $a8bdaba10cb74666$var$b.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($a8bdaba10cb74666$var$F, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$F.getDeepestBlockElements = $a8bdaba10cb74666$var$de;
var $a8bdaba10cb74666$var$Tt = $a8bdaba10cb74666$var$y;
function $a8bdaba10cb74666$var$de(e) {
    return (0, $a8bdaba10cb74666$var$Tt.containsOnlyInlineElements)(e) ? [
        e
    ] : Array.from(e.children).reduce(function(t, n) {
        return $a8bdaba10cb74666$var$re($a8bdaba10cb74666$var$re([], t, !0), $a8bdaba10cb74666$var$de(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestBlockElements = void 0;
    var t = $a8bdaba10cb74666$var$F;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return t.getDeepestBlockElements;
        }
    });
})($a8bdaba10cb74666$var$R);
var $a8bdaba10cb74666$var$fe = {}, $a8bdaba10cb74666$var$W = {}, $a8bdaba10cb74666$var$h = {}, $a8bdaba10cb74666$var$U = {};
Object.defineProperty($a8bdaba10cb74666$var$U, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$U.isLineBreakTag = $a8bdaba10cb74666$var$Ct;
function $a8bdaba10cb74666$var$Ct(e) {
    return [
        "BR",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLineBreakTag = void 0;
    var t = $a8bdaba10cb74666$var$U;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return t.isLineBreakTag;
        }
    });
})($a8bdaba10cb74666$var$h);
var $a8bdaba10cb74666$var$E = {}, $a8bdaba10cb74666$var$q = {};
Object.defineProperty($a8bdaba10cb74666$var$q, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$q.isSingleTag = $a8bdaba10cb74666$var$Lt;
function $a8bdaba10cb74666$var$Lt(e) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(e.tagName);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isSingleTag = void 0;
    var t = $a8bdaba10cb74666$var$q;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return t.isSingleTag;
        }
    });
})($a8bdaba10cb74666$var$E);
Object.defineProperty($a8bdaba10cb74666$var$W, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$W.getDeepestNode = $a8bdaba10cb74666$var$pe;
var $a8bdaba10cb74666$var$St = $a8bdaba10cb74666$var$c, $a8bdaba10cb74666$var$Mt = $a8bdaba10cb74666$var$h, $a8bdaba10cb74666$var$kt = $a8bdaba10cb74666$var$E;
function $a8bdaba10cb74666$var$pe(e, t) {
    t === void 0 && (t = !1);
    var n = t ? "lastChild" : "firstChild", r = t ? "previousSibling" : "nextSibling";
    if (e.nodeType === Node.ELEMENT_NODE && e[n]) {
        var i = e[n];
        if ((0, $a8bdaba10cb74666$var$kt.isSingleTag)(i) && !(0, $a8bdaba10cb74666$var$St.isNativeInput)(i) && !(0, $a8bdaba10cb74666$var$Mt.isLineBreakTag)(i)) {
            if (i[r]) i = i[r];
            else if (i.parentNode !== null && i.parentNode[r]) i = i.parentNode[r];
            else return i.parentNode;
        }
        return $a8bdaba10cb74666$var$pe(i, t);
    }
    return e;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.getDeepestNode = void 0;
    var t = $a8bdaba10cb74666$var$W;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return t.getDeepestNode;
        }
    });
})($a8bdaba10cb74666$var$fe);
var $a8bdaba10cb74666$var$ve = {}, $a8bdaba10cb74666$var$z = {}, $a8bdaba10cb74666$var$p = $a8bdaba10cb74666$var$b && $a8bdaba10cb74666$var$b.__spreadArray || function(e, t, n) {
    if (n || arguments.length === 2) for(var r = 0, i = t.length, a; r < i; r++)(a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
    return e.concat(a || Array.prototype.slice.call(t));
};
Object.defineProperty($a8bdaba10cb74666$var$z, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$z.findAllInputs = $a8bdaba10cb74666$var$$t;
var $a8bdaba10cb74666$var$wt = $a8bdaba10cb74666$var$y, $a8bdaba10cb74666$var$Nt = $a8bdaba10cb74666$var$R, $a8bdaba10cb74666$var$It = $a8bdaba10cb74666$var$P, $a8bdaba10cb74666$var$At = $a8bdaba10cb74666$var$c;
function $a8bdaba10cb74666$var$$t(e) {
    return Array.from(e.querySelectorAll((0, $a8bdaba10cb74666$var$It.allInputsSelector)())).reduce(function(t, n) {
        return (0, $a8bdaba10cb74666$var$At.isNativeInput)(n) || (0, $a8bdaba10cb74666$var$wt.containsOnlyInlineElements)(n) ? $a8bdaba10cb74666$var$p($a8bdaba10cb74666$var$p([], t, !0), [
            n
        ], !1) : $a8bdaba10cb74666$var$p($a8bdaba10cb74666$var$p([], t, !0), (0, $a8bdaba10cb74666$var$Nt.getDeepestBlockElements)(n), !0);
    }, []);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.findAllInputs = void 0;
    var t = $a8bdaba10cb74666$var$z;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return t.findAllInputs;
        }
    });
})($a8bdaba10cb74666$var$ve);
var $a8bdaba10cb74666$var$ge = {}, $a8bdaba10cb74666$var$G = {};
Object.defineProperty($a8bdaba10cb74666$var$G, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$G.isCollapsedWhitespaces = $a8bdaba10cb74666$var$Bt;
function $a8bdaba10cb74666$var$Bt(e) {
    return !/[^\t\n\r ]/.test(e);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isCollapsedWhitespaces = void 0;
    var t = $a8bdaba10cb74666$var$G;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return t.isCollapsedWhitespaces;
        }
    });
})($a8bdaba10cb74666$var$ge);
var $a8bdaba10cb74666$var$K = {}, $a8bdaba10cb74666$var$X = {};
Object.defineProperty($a8bdaba10cb74666$var$X, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$X.isElement = $a8bdaba10cb74666$var$Ht;
var $a8bdaba10cb74666$var$Dt = $a8bdaba10cb74666$var$$;
function $a8bdaba10cb74666$var$Ht(e) {
    return (0, $a8bdaba10cb74666$var$Dt.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.ELEMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isElement = void 0;
    var t = $a8bdaba10cb74666$var$X;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function() {
            return t.isElement;
        }
    });
})($a8bdaba10cb74666$var$K);
var $a8bdaba10cb74666$var$me = {}, $a8bdaba10cb74666$var$Y = {}, $a8bdaba10cb74666$var$Q = {}, $a8bdaba10cb74666$var$V = {};
Object.defineProperty($a8bdaba10cb74666$var$V, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$V.isLeaf = $a8bdaba10cb74666$var$Rt;
function $a8bdaba10cb74666$var$Rt(e) {
    return e === null ? !1 : e.childNodes.length === 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isLeaf = void 0;
    var t = $a8bdaba10cb74666$var$V;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function() {
            return t.isLeaf;
        }
    });
})($a8bdaba10cb74666$var$Q);
var $a8bdaba10cb74666$var$Z = {}, $a8bdaba10cb74666$var$J = {};
Object.defineProperty($a8bdaba10cb74666$var$J, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$J.isNodeEmpty = $a8bdaba10cb74666$var$zt;
var $a8bdaba10cb74666$var$Ft = $a8bdaba10cb74666$var$h, $a8bdaba10cb74666$var$Wt = $a8bdaba10cb74666$var$K, $a8bdaba10cb74666$var$Ut = $a8bdaba10cb74666$var$c, $a8bdaba10cb74666$var$qt = $a8bdaba10cb74666$var$E;
function $a8bdaba10cb74666$var$zt(e, t) {
    var n = "";
    return (0, $a8bdaba10cb74666$var$qt.isSingleTag)(e) && !(0, $a8bdaba10cb74666$var$Ft.isLineBreakTag)(e) ? !1 : ((0, $a8bdaba10cb74666$var$Wt.isElement)(e) && (0, $a8bdaba10cb74666$var$Ut.isNativeInput)(e) ? n = e.value : e.textContent !== null && (n = e.textContent.replace("\u200B", "")), t !== void 0 && (n = n.replace(new RegExp(t, "g"), "")), n.trim().length === 0);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isNodeEmpty = void 0;
    var t = $a8bdaba10cb74666$var$J;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return t.isNodeEmpty;
        }
    });
})($a8bdaba10cb74666$var$Z);
Object.defineProperty($a8bdaba10cb74666$var$Y, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$Y.isEmpty = $a8bdaba10cb74666$var$Xt;
var $a8bdaba10cb74666$var$Gt = $a8bdaba10cb74666$var$Q, $a8bdaba10cb74666$var$Kt = $a8bdaba10cb74666$var$Z;
function $a8bdaba10cb74666$var$Xt(e, t) {
    e.normalize();
    for(var n = [
        e
    ]; n.length > 0;){
        var r = n.shift();
        if (r) {
            if (e = r, (0, $a8bdaba10cb74666$var$Gt.isLeaf)(e) && !(0, $a8bdaba10cb74666$var$Kt.isNodeEmpty)(e, t)) return !1;
            n.push.apply(n, Array.from(e.childNodes));
        }
    }
    return !0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isEmpty = void 0;
    var t = $a8bdaba10cb74666$var$Y;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function() {
            return t.isEmpty;
        }
    });
})($a8bdaba10cb74666$var$me);
var $a8bdaba10cb74666$var$be = {}, $a8bdaba10cb74666$var$x = {};
Object.defineProperty($a8bdaba10cb74666$var$x, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$x.isFragment = $a8bdaba10cb74666$var$Qt;
var $a8bdaba10cb74666$var$Yt = $a8bdaba10cb74666$var$$;
function $a8bdaba10cb74666$var$Qt(e) {
    return (0, $a8bdaba10cb74666$var$Yt.isNumber)(e) ? !1 : !!e && !!e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isFragment = void 0;
    var t = $a8bdaba10cb74666$var$x;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function() {
            return t.isFragment;
        }
    });
})($a8bdaba10cb74666$var$be);
var $a8bdaba10cb74666$var$ye = {}, $a8bdaba10cb74666$var$ee = {};
Object.defineProperty($a8bdaba10cb74666$var$ee, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$ee.isHTMLString = $a8bdaba10cb74666$var$Zt;
var $a8bdaba10cb74666$var$Vt = $a8bdaba10cb74666$var$_;
function $a8bdaba10cb74666$var$Zt(e) {
    var t = (0, $a8bdaba10cb74666$var$Vt.make)("div");
    return t.innerHTML = e, t.childElementCount > 0;
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.isHTMLString = void 0;
    var t = $a8bdaba10cb74666$var$ee;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return t.isHTMLString;
        }
    });
})($a8bdaba10cb74666$var$ye);
var $a8bdaba10cb74666$var$_e = {}, $a8bdaba10cb74666$var$te = {};
Object.defineProperty($a8bdaba10cb74666$var$te, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$te.offset = $a8bdaba10cb74666$var$Jt;
function $a8bdaba10cb74666$var$Jt(e) {
    var t = e.getBoundingClientRect(), n = window.pageXOffset || document.documentElement.scrollLeft, r = window.pageYOffset || document.documentElement.scrollTop, i = t.top + r, a = t.left + n;
    return {
        top: i,
        left: a,
        bottom: i + t.height,
        right: a + t.width
    };
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.offset = void 0;
    var t = $a8bdaba10cb74666$var$te;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function() {
            return t.offset;
        }
    });
})($a8bdaba10cb74666$var$_e);
var $a8bdaba10cb74666$var$he = {}, $a8bdaba10cb74666$var$ne = {};
Object.defineProperty($a8bdaba10cb74666$var$ne, "__esModule", {
    value: !0
});
$a8bdaba10cb74666$var$ne.prepend = $a8bdaba10cb74666$var$xt;
function $a8bdaba10cb74666$var$xt(e, t) {
    Array.isArray(t) ? (t = t.reverse(), t.forEach(function(n) {
        return e.prepend(n);
    })) : e.prepend(t);
}
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = void 0;
    var t = $a8bdaba10cb74666$var$ne;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function() {
            return t.prepend;
        }
    });
})($a8bdaba10cb74666$var$he);
(function(e) {
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.prepend = e.offset = e.make = e.isLineBreakTag = e.isSingleTag = e.isNodeEmpty = e.isLeaf = e.isHTMLString = e.isFragment = e.isEmpty = e.isElement = e.isContentEditable = e.isCollapsedWhitespaces = e.findAllInputs = e.isNativeInput = e.allInputsSelector = e.getDeepestNode = e.getDeepestBlockElements = e.getContentLength = e.fragmentToString = e.containsOnlyInlineElements = e.canSetCaret = e.calculateBaseline = e.blockElements = e.append = void 0;
    var t = $a8bdaba10cb74666$var$P;
    Object.defineProperty(e, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return t.allInputsSelector;
        }
    });
    var n = $a8bdaba10cb74666$var$c;
    Object.defineProperty(e, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return n.isNativeInput;
        }
    });
    var r = $a8bdaba10cb74666$var$ie;
    Object.defineProperty(e, "append", {
        enumerable: !0,
        get: function() {
            return r.append;
        }
    });
    var i = $a8bdaba10cb74666$var$L;
    Object.defineProperty(e, "blockElements", {
        enumerable: !0,
        get: function() {
            return i.blockElements;
        }
    });
    var a = $a8bdaba10cb74666$var$ae;
    Object.defineProperty(e, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return a.calculateBaseline;
        }
    });
    var l = $a8bdaba10cb74666$var$le;
    Object.defineProperty(e, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return l.canSetCaret;
        }
    });
    var u = $a8bdaba10cb74666$var$y;
    Object.defineProperty(e, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return u.containsOnlyInlineElements;
        }
    });
    var d = $a8bdaba10cb74666$var$se;
    Object.defineProperty(e, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return d.fragmentToString;
        }
    });
    var s = $a8bdaba10cb74666$var$ce;
    Object.defineProperty(e, "getContentLength", {
        enumerable: !0,
        get: function() {
            return s.getContentLength;
        }
    });
    var f = $a8bdaba10cb74666$var$R;
    Object.defineProperty(e, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return f.getDeepestBlockElements;
        }
    });
    var Oe = $a8bdaba10cb74666$var$fe;
    Object.defineProperty(e, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return Oe.getDeepestNode;
        }
    });
    var Pe = $a8bdaba10cb74666$var$ve;
    Object.defineProperty(e, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return Pe.findAllInputs;
        }
    });
    var je = $a8bdaba10cb74666$var$ge;
    Object.defineProperty(e, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return je.isCollapsedWhitespaces;
        }
    });
    var Te = $a8bdaba10cb74666$var$w;
    Object.defineProperty(e, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return Te.isContentEditable;
        }
    });
    var Ce = $a8bdaba10cb74666$var$K;
    Object.defineProperty(e, "isElement", {
        enumerable: !0,
        get: function() {
            return Ce.isElement;
        }
    });
    var Le = $a8bdaba10cb74666$var$me;
    Object.defineProperty(e, "isEmpty", {
        enumerable: !0,
        get: function() {
            return Le.isEmpty;
        }
    });
    var Se = $a8bdaba10cb74666$var$be;
    Object.defineProperty(e, "isFragment", {
        enumerable: !0,
        get: function() {
            return Se.isFragment;
        }
    });
    var Me = $a8bdaba10cb74666$var$ye;
    Object.defineProperty(e, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return Me.isHTMLString;
        }
    });
    var ke = $a8bdaba10cb74666$var$Q;
    Object.defineProperty(e, "isLeaf", {
        enumerable: !0,
        get: function() {
            return ke.isLeaf;
        }
    });
    var we = $a8bdaba10cb74666$var$Z;
    Object.defineProperty(e, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return we.isNodeEmpty;
        }
    });
    var Ne = $a8bdaba10cb74666$var$h;
    Object.defineProperty(e, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return Ne.isLineBreakTag;
        }
    });
    var Ie = $a8bdaba10cb74666$var$E;
    Object.defineProperty(e, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return Ie.isSingleTag;
        }
    });
    var Ae = $a8bdaba10cb74666$var$_;
    Object.defineProperty(e, "make", {
        enumerable: !0,
        get: function() {
            return Ae.make;
        }
    });
    var $e = $a8bdaba10cb74666$var$_e;
    Object.defineProperty(e, "offset", {
        enumerable: !0,
        get: function() {
            return $e.offset;
        }
    });
    var Be = $a8bdaba10cb74666$var$he;
    Object.defineProperty(e, "prepend", {
        enumerable: !0,
        get: function() {
            return Be.prepend;
        }
    });
})($a8bdaba10cb74666$var$v);
var $a8bdaba10cb74666$var$Ee = /* @__PURE__ */ ((e)=>(e.Left = "left", e.Center = "center", e))($a8bdaba10cb74666$var$Ee || {});
class $a8bdaba10cb74666$export$2e2bcd8739ae039 {
    /**
   * Render plugin`s main Element and fill it with saved data
   * @param params - Quote Tool constructor params
   * @param params.data - previously saved data
   * @param params.config - user config for Tool
   * @param params.api - editor.js api
   * @param params.readOnly - read only mode flag
   */ constructor({ data: t, config: n, api: r, readOnly: i, block: a }){
        const { DEFAULT_ALIGNMENT: l } = $a8bdaba10cb74666$export$2e2bcd8739ae039;
        this.api = r, this.readOnly = i, this.quotePlaceholder = r.i18n.t((n == null ? void 0 : n.quotePlaceholder) ?? $a8bdaba10cb74666$export$2e2bcd8739ae039.DEFAULT_QUOTE_PLACEHOLDER), this.captionPlaceholder = r.i18n.t((n == null ? void 0 : n.captionPlaceholder) ?? $a8bdaba10cb74666$export$2e2bcd8739ae039.DEFAULT_CAPTION_PLACEHOLDER), this.data = {
            text: t.text || "",
            caption: t.caption || "",
            alignment: Object.values($a8bdaba10cb74666$var$Ee).includes(t.alignment) ? t.alignment : (n == null ? void 0 : n.defaultAlignment) ?? l
        }, this.css = {
            baseClass: this.api.styles.block,
            wrapper: "cdx-quote",
            text: "cdx-quote__text",
            input: this.api.styles.input,
            caption: "cdx-quote__caption"
        }, this.block = a;
    }
    /**
   * Notify core that read-only mode is supported
   * @returns true
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Get Tool toolbox settings
   * icon - Tool icon's SVG
   * title - title to show in toolbox
   * @returns icon and title of the toolbox
   */ static get toolbox() {
        return {
            icon: $a8bdaba10cb74666$var$Re,
            title: "Quote"
        };
    }
    /**
   * Empty Quote is not empty Block
   * @returns true
   */ static get contentless() {
        return !0;
    }
    /**
   * Allow to press Enter inside the Quote
   * @returns true
   */ static get enableLineBreaks() {
        return !0;
    }
    /**
   * Default placeholder for quote text
   * @returns 'Enter a quote'
   */ static get DEFAULT_QUOTE_PLACEHOLDER() {
        return "Enter a quote";
    }
    /**
   * Default placeholder for quote caption
   * @returns 'Enter a caption'
   */ static get DEFAULT_CAPTION_PLACEHOLDER() {
        return "Enter a caption";
    }
    /**
   * Default quote alignment
   * @returns Alignment.Left
   */ static get DEFAULT_ALIGNMENT() {
        return "left";
    }
    /**
   * Allow Quote to be converted to/from other blocks
   * @returns conversion config object
   */ static get conversionConfig() {
        return {
            /**
       * To create Quote data from string, simple fill 'text' property
       */ import: "text",
            /**
       * To create string from Quote data, concatenate text and caption
       * @param quoteData - Quote data object
       * @returns string
       */ export: function(t) {
                return t.caption ? `${t.text} \u{2014} ${t.caption}` : t.text;
            }
        };
    }
    /**
   * Tool`s styles
   * @returns CSS classes names
   */ get CSS() {
        return {
            baseClass: this.api.styles.block,
            wrapper: "cdx-quote",
            text: "cdx-quote__text",
            input: this.api.styles.input,
            caption: "cdx-quote__caption"
        };
    }
    /**
   * Tool`s settings properties
   * @returns settings properties
   */ get settings() {
        return [
            {
                name: "left",
                icon: $a8bdaba10cb74666$var$He
            },
            {
                name: "center",
                icon: $a8bdaba10cb74666$var$De
            }
        ];
    }
    /**
   * Create Quote Tool container with inputs
   * @returns blockquote DOM element - Quote Tool container
   */ render() {
        const t = $a8bdaba10cb74666$var$v.make("blockquote", [
            this.css.baseClass,
            this.css.wrapper
        ]), n = $a8bdaba10cb74666$var$v.make("div", [
            this.css.input,
            this.css.text
        ], {
            contentEditable: !this.readOnly,
            innerHTML: this.data.text
        }), r = $a8bdaba10cb74666$var$v.make("div", [
            this.css.input,
            this.css.caption
        ], {
            contentEditable: !this.readOnly,
            innerHTML: this.data.caption
        });
        return n.dataset.placeholder = this.quotePlaceholder, r.dataset.placeholder = this.captionPlaceholder, t.appendChild(n), t.appendChild(r), t;
    }
    /**
   * Extract Quote data from Quote Tool element
   * @param quoteElement - Quote DOM element to save
   * @returns Quote data object
   */ save(t) {
        const n = t.querySelector(`.${this.css.text}`), r = t.querySelector(`.${this.css.caption}`);
        return Object.assign(this.data, {
            text: (n == null ? void 0 : n.innerHTML) ?? "",
            caption: (r == null ? void 0 : r.innerHTML) ?? ""
        });
    }
    /**
   * Sanitizer rules
   * @returns sanitizer rules
   */ static get sanitize() {
        return {
            text: {
                br: !0
            },
            caption: {
                br: !0
            },
            alignment: {}
        };
    }
    /**
   * Create wrapper for Tool`s settings buttons:
   * 1. Left alignment
   * 2. Center alignment
   * @returns settings menu
   */ renderSettings() {
        const t = (n)=>n && n[0].toUpperCase() + n.slice(1);
        return this.settings.map((n)=>({
                icon: n.icon,
                label: this.api.i18n.t(`Align ${t(n.name)}`),
                onActivate: ()=>this._toggleTune(n.name),
                isActive: this.data.alignment === n.name,
                closeOnActivate: !0
            }));
    }
    /**
   * Toggle quote`s alignment
   * @param tune - alignment
   */ _toggleTune(t) {
        this.data.alignment = t, this.block.dispatchChange();
    }
}



const $3516c69f9ea40039$var$Tools = {
    list: (0, $e02beda658e54aca$export$2e2bcd8739ae039),
    code: (0, $4ab125ac4290e6d4$export$2e2bcd8739ae039),
    linkTool: (0, $143b355fa5979080$export$2e2bcd8739ae039),
    image: (0, $7e68ce1142d8dc67$export$2e2bcd8739ae039),
    header: (0, $6fb349d32be9584f$export$2e2bcd8739ae039),
    quote: (0, $a8bdaba10cb74666$export$2e2bcd8739ae039)
};
const $3516c69f9ea40039$export$7e39a007f70d82e4 = (props)=>// @ts-expect-error: https://github.com/editor-js/link/issues/88
    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Editor), Object.assign({
        tools: $3516c69f9ea40039$var$Tools
    }, props));



var $c43ddc4192c7b6a6$exports = {};
$c43ddc4192c7b6a6$exports = JSON.parse('{"version":"2.22.2","time":1640560412325,"blocks":[{"id":"-dav4FSc-x","type":"header","data":{"text":"\u7F16\u8F91\u6F14\u793A","level":2}},{"id":"-rN-eVAbuC","type":"paragraph","data":{"text":"something awesome..."}}]}');



(0, $71c6da7a2e5aef0a$export$2e2bcd8739ae039).displayName = 'Table';
const { t: $ef8e9e3f68d8643f$var$t } = (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168);
const $ef8e9e3f68d8643f$export$46af595855840602 = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(()=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $5f7777a6b14048f7$export$2e2bcd8739ae039), {
        className: "my-3",
        fluid: "md",
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("h1", {
                children: $ef8e9e3f68d8643f$var$t('component')
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "Time Distance",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.TimeDistance), {
                    date: "1989-06-04"
                })
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "Icon",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Icon), {
                    name: "bootstrap",
                    size: 2
                })
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "Avatar",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Avatar), {
                    src: "https://github.com/idea2app.png"
                })
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "Nameplate",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Nameplate), {
                    avatar: "https://github.com/idea2app.png",
                    name: "idea2app"
                })
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "Table spinner",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $71c6da7a2e5aef0a$export$2e2bcd8739ae039), {
                    className: "text-center",
                    striped: true,
                    hover: true,
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("thead", {
                            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", {
                                children: [
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("th", {
                                        children: "#"
                                    }),
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("th", {
                                        children: "Content"
                                    })
                                ]
                            })
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)("tbody", {
                            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.TableSpinner), {
                                colSpan: 2
                            })
                        })
                    ]
                })
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "Rich-text editor (HTML)",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $75acd277c1ee9d2f$exports.Editor), {
                    defaultValue: "<p>test</p>",
                    onChange: console.log
                })
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "Rich-text editor (JSON)",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3516c69f9ea40039$export$7e39a007f70d82e4), {
                    name: "content",
                    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c43ddc4192c7b6a6$exports)))
                })
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6bc0a6f62aa387be$export$c489dd2bd24850e4), {
                title: "Editor HTML",
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.EditorHTML), {
                    data: (0, (/*@__PURE__*/$parcel$interopDefault($c43ddc4192c7b6a6$exports)))
                })
            })
        ]
    }));







var $kzd8a = parcelRequire("kzd8a");

var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");
"use client";
// TODO
const $88e0b75512ac1fa3$var$FormContext = /*#__PURE__*/ $3lE4N.createContext({});
var $88e0b75512ac1fa3$export$2e2bcd8739ae039 = $88e0b75512ac1fa3$var$FormContext;



const $a7096e575cf6d24c$var$FormGroup = /*#__PURE__*/ $kzd8a.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $jmWak.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
            ...props,
            ref: ref
        })
    });
});
$a7096e575cf6d24c$var$FormGroup.displayName = 'FormGroup';
var $a7096e575cf6d24c$export$2e2bcd8739ae039 = $a7096e575cf6d24c$var$FormGroup;




"use client";
const $2c58e9b2b24f0ee8$var$FloatingLabel = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $a7096e575cf6d24c$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$2c58e9b2b24f0ee8$var$FloatingLabel.displayName = 'FloatingLabel';
var $2c58e9b2b24f0ee8$export$2e2bcd8739ae039 = $2c58e9b2b24f0ee8$var$FloatingLabel;




var $kzd8a = parcelRequire("kzd8a");


var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");


var $kzd8a = parcelRequire("kzd8a");


const $7dba15f377d24d75$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).elementType
};
const $7dba15f377d24d75$var$Feedback = /*#__PURE__*/ $kzd8a.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$7dba15f377d24d75$var$Feedback.displayName = 'Feedback';
$7dba15f377d24d75$var$Feedback.propTypes = $7dba15f377d24d75$var$propTypes;
var $7dba15f377d24d75$export$2e2bcd8739ae039 = $7dba15f377d24d75$var$Feedback;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



"use client";
const $f7696fd13630ab5a$var$FormCheckInput = /*#__PURE__*/ $kzd8a.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $jmWak.useContext)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039));
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$f7696fd13630ab5a$var$FormCheckInput.displayName = 'FormCheckInput';
var $f7696fd13630ab5a$export$2e2bcd8739ae039 = $f7696fd13630ab5a$var$FormCheckInput;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



"use client";
const $c7aa48b4dd18f620$var$FormCheckLabel = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $jmWak.useContext)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039));
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix)
    });
});
$c7aa48b4dd18f620$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $c7aa48b4dd18f620$export$2e2bcd8739ae039 = $c7aa48b4dd18f620$var$FormCheckLabel;





var $kzd8a = parcelRequire("kzd8a");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $c368dcb79775c8be$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $kzd8a.Children.map(children, (child)=>/*#__PURE__*/ $kzd8a.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $c368dcb79775c8be$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $kzd8a.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $kzd8a.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $c368dcb79775c8be$export$500fd6099226ffae(children, type) {
    return $kzd8a.Children.toArray(children).some((child)=>/*#__PURE__*/ $kzd8a.isValidElement(child) && child.type === type);
}



var $3lE4N = parcelRequire("3lE4N");
"use client";
const $d04e61e9e67a779c$var$FormCheck = /*#__PURE__*/ $kzd8a.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $jmWak.useContext)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039));
    const innerFormContext = (0, $jmWak.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $c368dcb79775c8be$export$500fd6099226ffae)(children, (0, $c7aa48b4dd18f620$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $f7696fd13630ab5a$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $c7aa48b4dd18f620$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $7dba15f377d24d75$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$d04e61e9e67a779c$var$FormCheck.displayName = 'FormCheck';
var $d04e61e9e67a779c$export$2e2bcd8739ae039 = Object.assign($d04e61e9e67a779c$var$FormCheck, {
    Input: (0, $f7696fd13630ab5a$export$2e2bcd8739ae039),
    Label: (0, $c7aa48b4dd18f620$export$2e2bcd8739ae039)
});




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");





"use client";
const $5cb92826437186f1$var$FormControl = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $jmWak.useContext)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039));
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$5cb92826437186f1$var$FormControl.displayName = 'FormControl';
var $5cb92826437186f1$export$2e2bcd8739ae039 = Object.assign($5cb92826437186f1$var$FormControl, {
    Feedback: $7dba15f377d24d75$export$2e2bcd8739ae039
});



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $1a1071611628796d$var$FormFloating = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$1a1071611628796d$var$FormFloating.displayName = 'FormFloating';
var $1a1071611628796d$export$2e2bcd8739ae039 = $1a1071611628796d$var$FormFloating;





var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");





"use client";
const $8a1e29e24c8ac34b$var$FormLabel = /*#__PURE__*/ $kzd8a.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $jmWak.useContext)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039));
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ca4e55525ae20d35$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$8a1e29e24c8ac34b$var$FormLabel.displayName = 'FormLabel';
var $8a1e29e24c8ac34b$export$2e2bcd8739ae039 = $8a1e29e24c8ac34b$var$FormLabel;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



"use client";
const $95ccd842b1151e77$var$FormRange = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $jmWak.useContext)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039));
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$95ccd842b1151e77$var$FormRange.displayName = 'FormRange';
var $95ccd842b1151e77$export$2e2bcd8739ae039 = $95ccd842b1151e77$var$FormRange;




var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");



"use client";
const $c3e026f76a9ee0f1$var$FormSelect = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $jmWak.useContext)((0, $88e0b75512ac1fa3$export$2e2bcd8739ae039));
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$c3e026f76a9ee0f1$var$FormSelect.displayName = 'FormSelect';
var $c3e026f76a9ee0f1$export$2e2bcd8739ae039 = $c3e026f76a9ee0f1$var$FormSelect;




var $kzd8a = parcelRequire("kzd8a");


"use client";
const $101df169a8e6ee0e$var$FormText = /*#__PURE__*/ $kzd8a.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$101df169a8e6ee0e$var$FormText.displayName = 'FormText';
var $101df169a8e6ee0e$export$2e2bcd8739ae039 = $101df169a8e6ee0e$var$FormText;



var $kzd8a = parcelRequire("kzd8a");


const $adc7ac03ecbdf65a$var$Switch = /*#__PURE__*/ $kzd8a.forwardRef((props, ref)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $d04e61e9e67a779c$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$adc7ac03ecbdf65a$var$Switch.displayName = 'Switch';
var $adc7ac03ecbdf65a$export$2e2bcd8739ae039 = Object.assign($adc7ac03ecbdf65a$var$Switch, {
    Input: (0, $d04e61e9e67a779c$export$2e2bcd8739ae039).Input,
    Label: (0, $d04e61e9e67a779c$export$2e2bcd8739ae039).Label
});




const $df771a012e6df6b5$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($a53fecd73fa4e68d$exports))).elementType
};
const $df771a012e6df6b5$var$Form = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, validated && 'was-validated')
    }));
$df771a012e6df6b5$var$Form.displayName = 'Form';
$df771a012e6df6b5$var$Form.propTypes = $df771a012e6df6b5$var$propTypes;
var $df771a012e6df6b5$export$2e2bcd8739ae039 = Object.assign($df771a012e6df6b5$var$Form, {
    Group: (0, $a7096e575cf6d24c$export$2e2bcd8739ae039),
    Control: (0, $5cb92826437186f1$export$2e2bcd8739ae039),
    Floating: (0, $1a1071611628796d$export$2e2bcd8739ae039),
    Check: (0, $d04e61e9e67a779c$export$2e2bcd8739ae039),
    Switch: $adc7ac03ecbdf65a$export$2e2bcd8739ae039,
    Label: (0, $8a1e29e24c8ac34b$export$2e2bcd8739ae039),
    Text: (0, $101df169a8e6ee0e$export$2e2bcd8739ae039),
    Range: (0, $95ccd842b1151e77$export$2e2bcd8739ae039),
    Select: (0, $c3e026f76a9ee0f1$export$2e2bcd8739ae039),
    FloatingLabel: $2c58e9b2b24f0ee8$export$2e2bcd8739ae039
});



var $iob0w = parcelRequire("iob0w");





var $kzd8a = parcelRequire("kzd8a");



"use client";
const $ed158f87a00484bb$var$ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `ProgressBar`.
 */ function $ed158f87a00484bb$var$onlyProgressBar(props, propName, componentName) {
    const children = props[propName];
    if (!children) return null;
    let error = null;
    $kzd8a.Children.forEach(children, (child)=>{
        if (error) return;
        /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */ const element = /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)($ed158f87a00484bb$var$ProgressBar, {});
        if (child.type === element.type) return;
        const childType = child.type;
        const childIdentifier = /*#__PURE__*/ $kzd8a.isValidElement(child) ? childType.displayName || childType.name || childType : child;
        error = new Error(`Children of ${componentName} can contain only ProgressBar ` + `components. Found ${childIdentifier}.`);
    });
    return error;
}
function $ed158f87a00484bb$var$getPercentage(now, min, max) {
    const percentage = (now - min) / (max - min) * 100;
    return Math.round(percentage * $ed158f87a00484bb$var$ROUND_PRECISION) / $ed158f87a00484bb$var$ROUND_PRECISION;
}
function $ed158f87a00484bb$var$renderProgressBar({ min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, className: className, style: style, variant: variant, bsPrefix: bsPrefix, ...props }, ref) {
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        ref: ref,
        ...props,
        role: "progressbar",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, `${bsPrefix}-bar`, {
            [`bg-${variant}`]: variant,
            [`${bsPrefix}-bar-animated`]: animated,
            [`${bsPrefix}-bar-striped`]: animated || striped
        }),
        style: {
            width: `${$ed158f87a00484bb$var$getPercentage(now, min, max)}%`,
            ...style
        },
        "aria-valuenow": now,
        "aria-valuemin": min,
        "aria-valuemax": max,
        children: visuallyHidden ? /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
            className: "visually-hidden",
            children: label
        }) : label
    });
}
const $ed158f87a00484bb$var$ProgressBar = /*#__PURE__*/ $kzd8a.forwardRef(({ isChild: isChild = false, ...rest }, ref)=>{
    const props = {
        min: 0,
        max: 100,
        animated: false,
        visuallyHidden: false,
        striped: false,
        ...rest
    };
    props.bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(props.bsPrefix, 'progress');
    if (isChild) return $ed158f87a00484bb$var$renderProgressBar(props, ref);
    const { min: min, now: now, max: max, label: label, visuallyHidden: visuallyHidden, striped: striped, animated: animated, bsPrefix: bsPrefix, variant: variant, className: className, children: children, ...wrapperProps } = props;
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        ref: ref,
        ...wrapperProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        children: children ? (0, $c368dcb79775c8be$export$871de8747c9eaa88)(children, (child)=>/*#__PURE__*/ (0, $kzd8a.cloneElement)(child, {
                isChild: true
            })) : $ed158f87a00484bb$var$renderProgressBar({
            min: min,
            now: now,
            max: max,
            label: label,
            visuallyHidden: visuallyHidden,
            striped: striped,
            animated: animated,
            bsPrefix: bsPrefix,
            variant: variant
        }, ref)
    });
});
$ed158f87a00484bb$var$ProgressBar.displayName = 'ProgressBar';
var $ed158f87a00484bb$export$2e2bcd8739ae039 = $ed158f87a00484bb$var$ProgressBar;



var $cF2Ke = parcelRequire("cF2Ke");

var $cF2Ke = parcelRequire("cF2Ke");

var $iob0w = parcelRequire("iob0w");
var $23af135f348c25d4$exports = {};

$parcel$export($23af135f348c25d4$exports, "promisifyRequest", function () { return $23af135f348c25d4$export$b327150396135fe7; });
$parcel$export($23af135f348c25d4$exports, "createStore", function () { return $23af135f348c25d4$export$f51a9068ac82ea43; });
$parcel$export($23af135f348c25d4$exports, "get", function () { return $23af135f348c25d4$export$3988ae62b71be9a3; });
$parcel$export($23af135f348c25d4$exports, "set", function () { return $23af135f348c25d4$export$adaa4cf7ef1b65be; });
$parcel$export($23af135f348c25d4$exports, "setMany", function () { return $23af135f348c25d4$export$daa0a5170277c7a8; });
$parcel$export($23af135f348c25d4$exports, "getMany", function () { return $23af135f348c25d4$export$5df405cccea42673; });
$parcel$export($23af135f348c25d4$exports, "update", function () { return $23af135f348c25d4$export$722fbec263ad908a; });
$parcel$export($23af135f348c25d4$exports, "del", function () { return $23af135f348c25d4$export$1d2f21e549771e67; });
$parcel$export($23af135f348c25d4$exports, "delMany", function () { return $23af135f348c25d4$export$c8aa84257229cac8; });
$parcel$export($23af135f348c25d4$exports, "clear", function () { return $23af135f348c25d4$export$42ffd38884aecdac; });
$parcel$export($23af135f348c25d4$exports, "keys", function () { return $23af135f348c25d4$export$ed97f33186d4b816; });
$parcel$export($23af135f348c25d4$exports, "values", function () { return $23af135f348c25d4$export$68c286be0e7e55b7; });
$parcel$export($23af135f348c25d4$exports, "entries", function () { return $23af135f348c25d4$export$3e9f948b41964866; });
function $23af135f348c25d4$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $23af135f348c25d4$export$f51a9068ac82ea43(dbName, storeName) {
    let dbp;
    const getDB = ()=>{
        if (dbp) return dbp;
        const request = indexedDB.open(dbName);
        request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
        dbp = $23af135f348c25d4$export$b327150396135fe7(request);
        dbp.then((db)=>{
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = ()=>dbp = undefined;
        }, ()=>{});
        return dbp;
    };
    return (txMode, callback)=>getDB().then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $23af135f348c25d4$var$defaultGetStoreFunc;
function $23af135f348c25d4$var$defaultGetStore() {
    if (!$23af135f348c25d4$var$defaultGetStoreFunc) $23af135f348c25d4$var$defaultGetStoreFunc = $23af135f348c25d4$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $23af135f348c25d4$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$3988ae62b71be9a3(key, customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$23af135f348c25d4$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$adaa4cf7ef1b65be(key, value, customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $23af135f348c25d4$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$daa0a5170277c7a8(entries, customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $23af135f348c25d4$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$5df405cccea42673(keys, customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$23af135f348c25d4$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$722fbec263ad908a(key, updater, customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            const req = store.get(key);
            req.onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($23af135f348c25d4$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
            req.onerror = ()=>reject(req.error);
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$1d2f21e549771e67(key, customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $23af135f348c25d4$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$c8aa84257229cac8(keys, customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $23af135f348c25d4$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$42ffd38884aecdac(customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $23af135f348c25d4$export$b327150396135fe7(store.transaction);
    });
}
function $23af135f348c25d4$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $23af135f348c25d4$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$ed97f33186d4b816(customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $23af135f348c25d4$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $23af135f348c25d4$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$68c286be0e7e55b7(customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $23af135f348c25d4$export$b327150396135fe7(store.getAll());
        const items = [];
        return $23af135f348c25d4$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $23af135f348c25d4$export$3e9f948b41964866(customStore = $23af135f348c25d4$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $23af135f348c25d4$export$b327150396135fe7(store.getAllKeys()),
            $23af135f348c25d4$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return $23af135f348c25d4$var$eachCursor(store, (cursor)=>items.push([
                cursor.key,
                cursor.value
            ])).then(()=>items);
    });
}


function $7a67b1f7b9b75c34$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
function $7a67b1f7b9b75c34$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $7a67b1f7b9b75c34$var$$082ef78710a13331$exports = {};
var $7a67b1f7b9b75c34$var$$80184bab4212ab17$exports = {};
var $7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports = {};
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports, "toggle", function() {
    return $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports, "toggleNotification", function() {
    return $7a67b1f7b9b75c34$export$6287f85d0f6a9342;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports, "PersistNode", function() {
    return $7a67b1f7b9b75c34$export$d1e7755b007c0847;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports, "persist", function() {
    return $7a67b1f7b9b75c34$export$9a6132153fba2e0;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports, "restore", function() {
    return $7a67b1f7b9b75c34$export$db239ef39aadc7fe;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports, "destroy", function() {
    return $7a67b1f7b9b75c34$export$b1fb4cac938035f7;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports, "persistList", function() {
    return $7a67b1f7b9b75c34$export$8001d3a0cfa5d8fd;
});
var $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7(property) {
    return (origin, {})=>function(...data) {
            return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                var value = Reflect.get(this, property);
                Reflect.set(this, property, typeof value === 'number' ? ++value : true);
                try {
                    return yield origin.apply(this, data);
                } finally{
                    value = Reflect.get(this, property);
                    Reflect.set(this, property, typeof value === 'number' ? --value : false);
                }
            });
        };
}
function $7a67b1f7b9b75c34$export$6287f85d0f6a9342(message) {
    return (origin, {})=>function(...data) {
            return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
                const notification = Notification.requestPermission().then((permission)=>{
                    if (permission === 'granted') return new Notification(typeof message === 'function' ? message(this) : message);
                });
                try {
                    return yield origin.apply(this, data);
                } finally{
                    notification.then((notification)=>notification === null || notification === void 0 ? void 0 : notification.close());
                }
            });
        };
}
class $7a67b1f7b9b75c34$export$d1e7755b007c0847 {
    constructor(meta){
        Object.defineProperty(this, "key", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "value", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "set", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "get", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "expireIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "disposer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.assign(this, meta);
    }
    static detectIDB() {
        return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            if (this.readyIDB) return this.readyIDB;
            const { get: get } = yield $23af135f348c25d4$exports;
            return this.readyIDB = get('ready');
        });
    }
    save(storeKey, value) {
        return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (value != null) this.value = (0, $cF2Ke.toJS)((_b = yield (_a = this.set) === null || _a === void 0 ? void 0 : _a.call(this, value)) !== null && _b !== void 0 ? _b : value);
            const { set: set } = yield $23af135f348c25d4$exports, data = {
                value: this.value,
                expireAt: this.expireIn + Date.now()
            };
            return set(`${storeKey}-${this.key}`, data);
        });
    }
    load(storeKey) {
        return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c;
            const { get: get, del: del } = yield $23af135f348c25d4$exports;
            storeKey += `-${this.key}`;
            const { value: value, expireAt: expireAt } = (_a = yield get(storeKey)) !== null && _a !== void 0 ? _a : {};
            if (expireAt && expireAt < Date.now()) {
                delete this.value;
                return del(storeKey);
            }
            this.value = value;
            return (_c = value != null ? yield (_b = this.get) === null || _b === void 0 ? void 0 : _b.call(this, value) : value) !== null && _c !== void 0 ? _c : value;
        });
    }
    destroy(storeKey) {
        return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            (_a = this.disposer) === null || _a === void 0 || _a.call(this);
            const { del: del } = yield $23af135f348c25d4$exports;
            return del(`${storeKey}-${this.key}`);
        });
    }
}
const $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$PersistNodes = new WeakMap();
function $7a67b1f7b9b75c34$export$9a6132153fba2e0(_a = {}) {
    var { expireIn: expireIn = Infinity } = _a, meta = $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__rest(_a, [
        "expireIn"
    ]);
    return ({}, { name: name, addInitializer: addInitializer })=>{
        addInitializer(function() {
            const list = $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$PersistNodes.get(this) || [];
            list.push(new $7a67b1f7b9b75c34$export$d1e7755b007c0847(Object.assign(Object.assign({}, meta), {
                key: name.toString(),
                expireIn: expireIn
            })));
            $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$PersistNodes.set(this, list);
        });
    };
}
function $7a67b1f7b9b75c34$export$db239ef39aadc7fe(classInstance, storeKey) {
    return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        try {
            yield $7a67b1f7b9b75c34$export$d1e7755b007c0847.detectIDB();
        } catch (_a) {
            return console.warn('IndexedDB or its polyfill is not found in this runtime engine, MobX-RESTful persistence is disabled.');
        }
        const list = $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [], restoredData = {};
        for (const item of list){
            const { key: key } = item, value = yield item.load(storeKey);
            if (value != null) {
                Reflect.set(classInstance, key, value);
                restoredData[key] = value;
            }
            item.disposer = (0, $cF2Ke.reaction)(()=>classInstance[key], (value)=>item.save(storeKey, value));
        }
        if ((0, $iob0w.isEmpty)(restoredData)) return;
        console.group(`Restored ${storeKey}`);
        console.table(restoredData);
        console.groupEnd();
    });
}
function $7a67b1f7b9b75c34$export$b1fb4cac938035f7(classInstance, storeKey) {
    return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__awaiter(this, void 0, void 0, function*() {
        const list = $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$PersistNodes.get(classInstance) || [];
        for (const node of list)yield node.destroy(storeKey);
    });
}
function $7a67b1f7b9b75c34$export$8001d3a0cfa5d8fd({ storeKey: storeKey, expireIn: expireIn = Infinity } = {}) {
    return (Super, {})=>(()=>{
            var _a, _PersistListModel_pageIndex_accessor_storage, _PersistListModel_pageSize_accessor_storage, _PersistListModel_filter_accessor_storage, _PersistListModel_totalCount_accessor_storage, _PersistListModel_pageList_accessor_storage;
            let _classSuper = Super;
            let _pageIndex_decorators;
            let _pageIndex_initializers = [];
            let _pageIndex_extraInitializers = [];
            let _pageSize_decorators;
            let _pageSize_initializers = [];
            let _pageSize_extraInitializers = [];
            let _filter_decorators;
            let _filter_initializers = [];
            let _filter_extraInitializers = [];
            let _totalCount_decorators;
            let _totalCount_initializers = [];
            let _totalCount_extraInitializers = [];
            let _pageList_decorators;
            let _pageList_initializers = [];
            let _pageList_extraInitializers = [];
            return _a = class PersistListModel extends _classSuper {
                constructor(){
                    super(...arguments);
                    _PersistListModel_pageIndex_accessor_storage.set(this, $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_initializers, 0));
                    _PersistListModel_pageSize_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _pageIndex_extraInitializers), $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_initializers, 10)));
                    _PersistListModel_filter_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _pageSize_extraInitializers), $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_initializers, {})));
                    _PersistListModel_totalCount_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _filter_extraInitializers), $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_initializers, undefined)));
                    _PersistListModel_pageList_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _totalCount_extraInitializers), $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_initializers, [])));
                    Object.defineProperty(this, "restored", {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: ($7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__runInitializers(this, _pageList_extraInitializers), globalThis.indexedDB && $7a67b1f7b9b75c34$export$db239ef39aadc7fe(this, typeof storeKey === 'function' ? storeKey(this) : storeKey))
                    });
                }
                get pageIndex() {
                    return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageIndex_accessor_storage, "f");
                }
                set pageIndex(value) {
                    $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageIndex_accessor_storage, value, "f");
                }
                get pageSize() {
                    return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageSize_accessor_storage, "f");
                }
                set pageSize(value) {
                    $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageSize_accessor_storage, value, "f");
                }
                get filter() {
                    return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_filter_accessor_storage, "f");
                }
                set filter(value) {
                    $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_filter_accessor_storage, value, "f");
                }
                get totalCount() {
                    return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_totalCount_accessor_storage, "f");
                }
                set totalCount(value) {
                    $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_totalCount_accessor_storage, value, "f");
                }
                get pageList() {
                    return $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldGet(this, _PersistListModel_pageList_accessor_storage, "f");
                }
                set pageList(value) {
                    $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__classPrivateFieldSet(this, _PersistListModel_pageList_accessor_storage, value, "f");
                }
            }, _PersistListModel_pageIndex_accessor_storage = new WeakMap(), _PersistListModel_pageSize_accessor_storage = new WeakMap(), _PersistListModel_filter_accessor_storage = new WeakMap(), _PersistListModel_totalCount_accessor_storage = new WeakMap(), _PersistListModel_pageList_accessor_storage = new WeakMap(), (()=>{
                var _b;
                const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
                _pageIndex_decorators = [
                    $7a67b1f7b9b75c34$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $cF2Ke.observable)
                ];
                _pageSize_decorators = [
                    $7a67b1f7b9b75c34$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $cF2Ke.observable)
                ];
                _filter_decorators = [
                    $7a67b1f7b9b75c34$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $cF2Ke.observable)
                ];
                _totalCount_decorators = [
                    $7a67b1f7b9b75c34$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $cF2Ke.observable)
                ];
                _pageList_decorators = [
                    $7a67b1f7b9b75c34$export$9a6132153fba2e0({
                        expireIn: expireIn
                    }),
                    (0, $cF2Ke.observable)
                ];
                $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageIndex_decorators, {
                    kind: "accessor",
                    name: "pageIndex",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageIndex" in obj,
                        get: (obj)=>obj.pageIndex,
                        set: (obj, value)=>{
                            obj.pageIndex = value;
                        }
                    },
                    metadata: _metadata
                }, _pageIndex_initializers, _pageIndex_extraInitializers);
                $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageSize_decorators, {
                    kind: "accessor",
                    name: "pageSize",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageSize" in obj,
                        get: (obj)=>obj.pageSize,
                        set: (obj, value)=>{
                            obj.pageSize = value;
                        }
                    },
                    metadata: _metadata
                }, _pageSize_initializers, _pageSize_extraInitializers);
                $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _filter_decorators, {
                    kind: "accessor",
                    name: "filter",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"filter" in obj,
                        get: (obj)=>obj.filter,
                        set: (obj, value)=>{
                            obj.filter = value;
                        }
                    },
                    metadata: _metadata
                }, _filter_initializers, _filter_extraInitializers);
                $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _totalCount_decorators, {
                    kind: "accessor",
                    name: "totalCount",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"totalCount" in obj,
                        get: (obj)=>obj.totalCount,
                        set: (obj, value)=>{
                            obj.totalCount = value;
                        }
                    },
                    metadata: _metadata
                }, _totalCount_initializers, _totalCount_extraInitializers);
                $7a67b1f7b9b75c34$var$$400caf514fe4dd82$var$__esDecorate(_a, null, _pageList_decorators, {
                    kind: "accessor",
                    name: "pageList",
                    static: false,
                    private: false,
                    access: {
                        has: (obj)=>"pageList" in obj,
                        get: (obj)=>obj.pageList,
                        set: (obj, value)=>{
                            obj.pageList = value;
                        }
                    },
                    metadata: _metadata
                }, _pageList_initializers, _pageList_extraInitializers);
                if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: _metadata
                });
            })(), _a;
        })();
}
$7a67b1f7b9b75c34$var$$parcel$exportWildcard($7a67b1f7b9b75c34$var$$082ef78710a13331$exports, $7a67b1f7b9b75c34$var$$80184bab4212ab17$exports);
$7a67b1f7b9b75c34$var$$parcel$exportWildcard($7a67b1f7b9b75c34$var$$082ef78710a13331$exports, $7a67b1f7b9b75c34$var$$400caf514fe4dd82$exports);
var $7a67b1f7b9b75c34$var$$16892940cfb7bd51$exports = {};
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$16892940cfb7bd51$exports, "BaseModel", function() {
    return $7a67b1f7b9b75c34$export$d12e20a4eec10acf;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$16892940cfb7bd51$exports, "BaseListModel", function() {
    return $7a67b1f7b9b75c34$export$673dbc4a8d0cb20a;
});
var $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $7a67b1f7b9b75c34$export$d12e20a4eec10acf = (()=>{
    var _a, _BaseModel_downloading_accessor_storage, _BaseModel_uploading_accessor_storage;
    let _instanceExtraInitializers = [];
    let _downloading_decorators;
    let _downloading_initializers = [];
    let _downloading_extraInitializers = [];
    let _uploading_decorators;
    let _uploading_initializers = [];
    let _uploading_extraInitializers = [];
    let _clear_decorators;
    return _a = class BaseModel {
        get downloading() {
            return $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_downloading_accessor_storage, "f");
        }
        set downloading(value) {
            $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_downloading_accessor_storage, value, "f");
        }
        get uploading() {
            return $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseModel_uploading_accessor_storage, "f");
        }
        set uploading(value) {
            $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseModel_uploading_accessor_storage, value, "f");
        }
        clear() {
            this.downloading = this.uploading = 0;
        }
        constructor(){
            _BaseModel_downloading_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_initializers, 0)));
            _BaseModel_uploading_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers(this, _downloading_extraInitializers), $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_initializers, 0)));
            $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers(this, _uploading_extraInitializers);
        }
    }, _BaseModel_downloading_accessor_storage = new WeakMap(), _BaseModel_uploading_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _downloading_decorators = [
            (0, $cF2Ke.observable)
        ];
        _uploading_decorators = [
            (0, $cF2Ke.observable)
        ];
        _clear_decorators = [
            (0, $cF2Ke.action)
        ];
        $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _downloading_decorators, {
            kind: "accessor",
            name: "downloading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"downloading" in obj,
                get: (obj)=>obj.downloading,
                set: (obj, value)=>{
                    obj.downloading = value;
                }
            },
            metadata: _metadata
        }, _downloading_initializers, _downloading_extraInitializers);
        $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _uploading_decorators, {
            kind: "accessor",
            name: "uploading",
            static: false,
            private: false,
            access: {
                has: (obj)=>"uploading" in obj,
                get: (obj)=>obj.uploading,
                set: (obj, value)=>{
                    obj.uploading = value;
                }
            },
            metadata: _metadata
        }, _uploading_initializers, _uploading_extraInitializers);
        $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clear_decorators, {
            kind: "method",
            name: "clear",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clear" in obj,
                get: (obj)=>obj.clear
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
/**
 * This basic class is a middle class, which isn't for direct using
 */ let $7a67b1f7b9b75c34$export$673dbc4a8d0cb20a = (()=>{
    var _a, _BaseListModel_currentOne_accessor_storage;
    let _classSuper = $7a67b1f7b9b75c34$export$d12e20a4eec10acf;
    let _instanceExtraInitializers = [];
    let _currentOne_decorators;
    let _currentOne_initializers = [];
    let _currentOne_extraInitializers = [];
    let _clearCurrent_decorators;
    let _updateOne_decorators;
    let _getOne_decorators;
    let _deleteOne_decorators;
    return _a = class BaseListModel extends _classSuper {
        get currentOne() {
            return $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__classPrivateFieldGet(this, _BaseListModel_currentOne_accessor_storage, "f");
        }
        set currentOne(value) {
            $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__classPrivateFieldSet(this, _BaseListModel_currentOne_accessor_storage, value, "f");
        }
        // @observable
        // validity: InvalidMessage<D> = {};
        static createNested(parentId) {
            const Model = this;
            const store = new Model();
            store.baseURI = store.baseURI.replace(/:\w+/, parentId + '');
            return store;
        }
        clearCurrent() {
            this.currentOne = {};
        // this.validity = {};
        }
        clear() {
            super.clear();
            this.clearCurrent();
        }
        updateOne(data, id) {
            return $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield id ? this.client.patch(`${this.baseURI}/${id}`, data) : this.client.post(this.baseURI, data);
                return this.currentOne = body;
            });
        }
        getOne(id) {
            return $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${id}`);
                return this.currentOne = body;
            });
        }
        deleteOne(id) {
            return $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__awaiter(this, void 0, void 0, function*() {
                yield this.client.delete(`${this.baseURI}/${id}`);
                if (this.currentOne[this.indexKey] === id) this.clearCurrent();
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers(this, _instanceExtraInitializers), 'id')
            });
            _BaseListModel_currentOne_accessor_storage.set(this, $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_initializers, {}));
            $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__runInitializers(this, _currentOne_extraInitializers);
        }
    }, _BaseListModel_currentOne_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _currentOne_decorators = [
            (0, $cF2Ke.observable)
        ];
        _clearCurrent_decorators = [
            (0, $cF2Ke.action)
        ];
        _updateOne_decorators = [
            $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7('uploading')
        ];
        _getOne_decorators = [
            $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7('downloading')
        ];
        _deleteOne_decorators = [
            $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7('uploading')
        ];
        $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _currentOne_decorators, {
            kind: "accessor",
            name: "currentOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentOne" in obj,
                get: (obj)=>obj.currentOne,
                set: (obj, value)=>{
                    obj.currentOne = value;
                }
            },
            metadata: _metadata
        }, _currentOne_initializers, _currentOne_extraInitializers);
        $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _clearCurrent_decorators, {
            kind: "method",
            name: "clearCurrent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearCurrent" in obj,
                get: (obj)=>obj.clearCurrent
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$16892940cfb7bd51$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$exports = {};
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$exports, "ListModel", function() {
    return $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$exports, "Buffer", function() {
    return $7a67b1f7b9b75c34$export$a143d493d941bafc;
});
$7a67b1f7b9b75c34$var$$parcel$export($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$exports, "Stream", function() {
    return $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903;
});
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__await = function(v) {
    return this instanceof $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__await ? (this.v = v, this) : new $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__await(v);
};
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
let $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3 = (()=>{
    var _a, _ListModel_pageIndex_accessor_storage, _ListModel_pageSize_accessor_storage, _ListModel_filter_accessor_storage, _ListModel_totalCount_accessor_storage, _ListModel_pageList_accessor_storage, _ListModel_statistic_accessor_storage, _b;
    let _classSuper = $7a67b1f7b9b75c34$export$673dbc4a8d0cb20a;
    let _instanceExtraInitializers = [];
    let _pageIndex_decorators;
    let _pageIndex_initializers = [];
    let _pageIndex_extraInitializers = [];
    let _pageSize_decorators;
    let _pageSize_initializers = [];
    let _pageSize_extraInitializers = [];
    let _filter_decorators;
    let _filter_initializers = [];
    let _filter_extraInitializers = [];
    let _totalCount_decorators;
    let _totalCount_initializers = [];
    let _totalCount_extraInitializers = [];
    let _pageList_decorators;
    let _pageList_initializers = [];
    let _pageList_extraInitializers = [];
    let _get_currentPage_decorators;
    let _get_pageCount_decorators;
    let _get_allItems_decorators;
    let _get_noMore_decorators;
    let _statistic_decorators;
    let _statistic_initializers = [];
    let _statistic_extraInitializers = [];
    let _clearList_decorators;
    let _restoreList_decorators;
    let _turnTo_decorators;
    let _getList_decorators;
    let _deleteOne_decorators;
    return _a = class ListModel extends _classSuper {
        constructor(){
            super(...arguments);
            _ListModel_pageIndex_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_initializers, 0)));
            _ListModel_pageSize_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageIndex_extraInitializers), $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_initializers, 10)));
            _ListModel_filter_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageSize_extraInitializers), $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_initializers, {})));
            _ListModel_totalCount_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _filter_extraInitializers), $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_initializers, void 0)));
            _ListModel_pageList_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _totalCount_extraInitializers), $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_initializers, [])));
            _ListModel_statistic_accessor_storage.set(this, ($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _pageList_extraInitializers), $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_initializers, {})));
            Object.defineProperty(this, _b, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _statistic_extraInitializers), this.getAllInStream)
            });
        }
        get pageIndex() {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageIndex_accessor_storage, "f");
        }
        set pageIndex(value) {
            $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageIndex_accessor_storage, value, "f");
        }
        get pageSize() {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageSize_accessor_storage, "f");
        }
        set pageSize(value) {
            $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageSize_accessor_storage, value, "f");
        }
        get filter() {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_filter_accessor_storage, "f");
        }
        set filter(value) {
            $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_filter_accessor_storage, value, "f");
        }
        get totalCount() {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_totalCount_accessor_storage, "f");
        }
        set totalCount(value) {
            $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_totalCount_accessor_storage, value, "f");
        }
        get pageList() {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_pageList_accessor_storage, "f");
        }
        set pageList(value) {
            $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_pageList_accessor_storage, value, "f");
        }
        get currentPage() {
            return this.pageList[this.pageIndex - 1] || [];
        }
        get pageCount() {
            return Math.ceil(this.totalCount / this.pageSize) || this.pageList.length;
        }
        get allItems() {
            const pageList = (0, $cF2Ke.toJS)(this.pageList), { pageSize: pageSize, totalCount: totalCount } = this;
            const index = [
                ...pageList
            ].reverse().findIndex((item)=>(item === null || item === void 0 ? void 0 : item[0]) != null);
            return Array.from(pageList.slice(0, -index || Infinity), (page)=>(page === null || page === void 0 ? void 0 : page[0]) ? page : new Array(pageSize).fill({})).flat().slice(0, totalCount || 0);
        }
        get noMore() {
            return this.pageIndex * this.pageSize >= this.totalCount;
        }
        get statistic() {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldGet(this, _ListModel_statistic_accessor_storage, "f");
        }
        set statistic(value) {
            $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__classPrivateFieldSet(this, _ListModel_statistic_accessor_storage, value, "f");
        }
        clearList() {
            this.pageIndex = 0;
            this.pageSize = 10;
            this.filter = {};
            this.pageList = [];
            this.totalCount = undefined;
        }
        clear() {
            super.clear();
            this.clearList();
        }
        restoreList({ pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
            if (!allItems.length) return;
            this.pageList = (0, $iob0w.splitArray)(allItems, pageSize);
            this.pageIndex = pageIndex;
            this.pageSize = pageSize;
            this.totalCount = totalCount;
        }
        turnTo(pageIndex, pageSize = this.pageSize) {
            this.pageIndex = pageIndex;
            if (this.pageSize !== pageSize) this.pageList = (0, $iob0w.splitArray)(this.allItems, this.pageSize = pageSize);
            return this;
        }
        /**
             * @protected
             */ loadNewPage(pageIndex, pageSize, filter) {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { pageData: pageData, totalCount: totalCount } = yield this.loadPage(pageIndex, pageSize, filter);
                this.pageSize = pageSize;
                const list = [
                    ...this.pageList
                ];
                list[pageIndex - 1] = pageData;
                this.pageList = list;
                this.totalCount = totalCount != null ? isNaN(totalCount) || totalCount < 0 ? Infinity : totalCount : Infinity;
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        // @action  // disabled for @override bug of MobX 6
        getList() {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                const { pageData: pageData } = yield this.loadNewPage(pageIndex, pageSize, filter);
                this.filter = filter;
                this.turnTo(pageIndex, pageSize);
                return pageData;
            });
        }
        refreshList() {
            const { filter: filter, pageSize: pageSize } = this;
            this.clearList();
            return this.getList(filter, 1, pageSize);
        }
        getAllInStream() {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__asyncGenerator(this, arguments, function* getAllInStream_1(filter = this.filter, pageSize = this.pageSize) {
                this.pageIndex = 0;
                while(!this.noMore)yield $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__await((yield* $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__asyncDelegator($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__asyncValues((yield $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__await(this.getList(filter, undefined, pageSize)))))));
            });
        }
        getAll(filter = this.filter, pageSize = this.pageSize) {
            return Array.fromAsync(this.getAllInStream(filter, pageSize));
        }
        countAll(keys_1) {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(keys, filter = this.filter, pageSize = this.pageSize) {
                const allItems = yield this.getAll(filter, pageSize);
                const statistic = Object.fromEntries(keys.map((key)=>[
                        key,
                        (0, $iob0w.countBy)(allItems, key)
                    ]));
                return this.statistic = statistic;
            });
        }
        indexOf(id) {
            const { indexKey: indexKey, allItems: allItems } = this;
            return allItems.findIndex(({ [indexKey]: ID })=>ID === id);
        }
        changeOne(data, id, patch = false) {
            const { pageIndex: pageIndex, allItems: allItems, totalCount: totalCount } = this, index = this.indexOf(id);
            if (index > -1) this.restoreList({
                pageIndex: pageIndex,
                allItems: [
                    ...allItems.slice(0, index),
                    patch ? Object.assign(Object.assign({}, allItems[index]), data) : data,
                    ...allItems.slice(index + 1)
                ],
                totalCount: totalCount
            });
        }
        updateOne(data, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.updateOne.call(this, data, id);
                if (id) this.changeOne(this.currentOne, id);
                return this.currentOne;
            });
        }
        removeOne(id) {
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                const { filter: filter, pageIndex: pageIndex, allItems: allItems } = this, index = this.indexOf(id);
                const { pageData: pageData } = yield this.loadPage(allItems.length + 1, 1, filter);
                return this.restoreList({
                    pageIndex: pageIndex,
                    allItems: [
                        ...allItems.slice(0, index),
                        ...allItems.slice(index + 1),
                        ...pageData
                    ],
                    totalCount: this.totalCount--
                });
            });
        }
        deleteOne(id) {
            const _super = Object.create(null, {
                deleteOne: {
                    get: ()=>super.deleteOne
                }
            });
            return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                yield _super.deleteOne.call(this, id);
                yield this.removeOne(id);
            });
        }
    }, _ListModel_pageIndex_accessor_storage = new WeakMap(), _ListModel_pageSize_accessor_storage = new WeakMap(), _ListModel_filter_accessor_storage = new WeakMap(), _ListModel_totalCount_accessor_storage = new WeakMap(), _ListModel_pageList_accessor_storage = new WeakMap(), _ListModel_statistic_accessor_storage = new WeakMap(), _b = (_pageIndex_decorators = [
        (0, $cF2Ke.observable)
    ], _pageSize_decorators = [
        (0, $cF2Ke.observable)
    ], _filter_decorators = [
        (0, $cF2Ke.observable)
    ], _totalCount_decorators = [
        (0, $cF2Ke.observable)
    ], _pageList_decorators = [
        (0, $cF2Ke.observable)
    ], _get_currentPage_decorators = [
        (0, $cF2Ke.computed)
    ], _get_pageCount_decorators = [
        (0, $cF2Ke.computed)
    ], _get_allItems_decorators = [
        (0, $cF2Ke.computed)
    ], _get_noMore_decorators = [
        (0, $cF2Ke.computed)
    ], _statistic_decorators = [
        (0, $cF2Ke.observable)
    ], _clearList_decorators = [
        (0, $cF2Ke.action)
    ], _restoreList_decorators = [
        (0, $cF2Ke.action)
    ], _turnTo_decorators = [
        (0, $cF2Ke.action)
    ], _getList_decorators = [
        $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7('downloading')
    ], Symbol.asyncIterator), (()=>{
        var _c;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_c = _classSuper[Symbol.metadata]) !== null && _c !== void 0 ? _c : null) : void 0;
        _deleteOne_decorators = [
            $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7('uploading')
        ];
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageIndex_decorators, {
            kind: "accessor",
            name: "pageIndex",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageIndex" in obj,
                get: (obj)=>obj.pageIndex,
                set: (obj, value)=>{
                    obj.pageIndex = value;
                }
            },
            metadata: _metadata
        }, _pageIndex_initializers, _pageIndex_extraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageSize_decorators, {
            kind: "accessor",
            name: "pageSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageSize" in obj,
                get: (obj)=>obj.pageSize,
                set: (obj, value)=>{
                    obj.pageSize = value;
                }
            },
            metadata: _metadata
        }, _pageSize_initializers, _pageSize_extraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _filter_decorators, {
            kind: "accessor",
            name: "filter",
            static: false,
            private: false,
            access: {
                has: (obj)=>"filter" in obj,
                get: (obj)=>obj.filter,
                set: (obj, value)=>{
                    obj.filter = value;
                }
            },
            metadata: _metadata
        }, _filter_initializers, _filter_extraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _totalCount_decorators, {
            kind: "accessor",
            name: "totalCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalCount" in obj,
                get: (obj)=>obj.totalCount,
                set: (obj, value)=>{
                    obj.totalCount = value;
                }
            },
            metadata: _metadata
        }, _totalCount_initializers, _totalCount_extraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _pageList_decorators, {
            kind: "accessor",
            name: "pageList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageList" in obj,
                get: (obj)=>obj.pageList,
                set: (obj, value)=>{
                    obj.pageList = value;
                }
            },
            metadata: _metadata
        }, _pageList_initializers, _pageList_extraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_currentPage_decorators, {
            kind: "getter",
            name: "currentPage",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentPage" in obj,
                get: (obj)=>obj.currentPage
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_pageCount_decorators, {
            kind: "getter",
            name: "pageCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"pageCount" in obj,
                get: (obj)=>obj.pageCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_allItems_decorators, {
            kind: "getter",
            name: "allItems",
            static: false,
            private: false,
            access: {
                has: (obj)=>"allItems" in obj,
                get: (obj)=>obj.allItems
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _get_noMore_decorators, {
            kind: "getter",
            name: "noMore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"noMore" in obj,
                get: (obj)=>obj.noMore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _statistic_decorators, {
            kind: "accessor",
            name: "statistic",
            static: false,
            private: false,
            access: {
                has: (obj)=>"statistic" in obj,
                get: (obj)=>obj.statistic,
                set: (obj, value)=>{
                    obj.statistic = value;
                }
            },
            metadata: _metadata
        }, _statistic_initializers, _statistic_extraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _clearList_decorators, {
            kind: "method",
            name: "clearList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"clearList" in obj,
                get: (obj)=>obj.clearList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
            kind: "method",
            name: "restoreList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"restoreList" in obj,
                get: (obj)=>obj.restoreList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _turnTo_decorators, {
            kind: "method",
            name: "turnTo",
            static: false,
            private: false,
            access: {
                has: (obj)=>"turnTo" in obj,
                get: (obj)=>obj.turnTo
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
            kind: "method",
            name: "getList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getList" in obj,
                get: (obj)=>obj.getList
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _deleteOne_decorators, {
            kind: "method",
            name: "deleteOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"deleteOne" in obj,
                get: (obj)=>obj.deleteOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
function $7a67b1f7b9b75c34$export$a143d493d941bafc(Super) {
    let BufferListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _getList_decorators;
        return _a = class BufferListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "pendingList", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: ($7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers), [])
                });
            }
            clearList() {
                super.clearList();
                this.pendingList = [];
            }
            clear() {
                super.clear();
                this.clearList();
            }
            getList() {
                const _super = Object.create(null, {
                    getList: {
                        get: ()=>super.getList
                    }
                });
                return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*(filter = this.filter, pageIndex = this.pageIndex + 1, pageSize = this.pageSize) {
                    const currentIndex = pageIndex - 1;
                    if (this.pendingList[currentIndex]) {
                        const { pageData: pageData } = yield this.pendingList[currentIndex];
                        this.turnTo(pageIndex, pageSize);
                        return pageData;
                    }
                    if (this.pageList[currentIndex]) this.turnTo(pageIndex, pageSize);
                    else var list = yield _super.getList.call(this, filter, pageIndex, pageSize);
                    const nextIndex = pageIndex + 1;
                    this.pendingList[nextIndex] = this.loadNewPage(nextIndex, pageSize, filter).then((data)=>{
                        this.pendingList[nextIndex] = undefined;
                        return data;
                    });
                    return list;
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _getList_decorators = [
                (0, $cF2Ke.action),
                $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7('downloading')
            ];
            $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _getList_decorators, {
                kind: "method",
                name: "getList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"getList" in obj,
                    get: (obj)=>obj.getList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return BufferListMixin;
}
function $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903(Super) {
    let StreamListMixin = (()=>{
        var _a;
        let _classSuper = Super;
        let _instanceExtraInitializers = [];
        let _restoreList_decorators;
        return _a = class StreamListMixin extends _classSuper {
            constructor(){
                super(...arguments);
                Object.defineProperty(this, "stream", {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__runInitializers(this, _instanceExtraInitializers)
                });
            }
            clearList() {
                super.clearList();
                this.stream = undefined;
            }
            clear() {
                super.clear();
                this.clearList();
            }
            restoreList() {
                const _super = Object.create(null, {
                    restoreList: {
                        get: ()=>super.restoreList
                    }
                });
                return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, arguments, void 0, function*({ filter: filter = this.filter, pageIndex: pageIndex = this.pageIndex + 1, pageSize: pageSize = this.pageSize, allItems: allItems = this.allItems, totalCount: totalCount = Infinity } = {}) {
                    _super.restoreList.call(this, {
                        pageIndex: pageIndex,
                        pageSize: pageSize,
                        allItems: allItems,
                        totalCount: totalCount
                    });
                    if (allItems.length) yield this.loadStream(filter, allItems.length);
                });
            }
            /**
                 * @protected
                 */ loadStream(filter, newCount) {
                return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const newList = [];
                    const stream = this.stream || (this.stream = this.openStream(filter));
                    for(let i = 0; i < newCount; i++){
                        const { done: done, value: value } = yield stream.next();
                        if (done) break;
                        newList.push(value);
                    }
                    return newList;
                });
            }
            /**
                 * @protected
                 */ loadPage(pageIndex, pageSize, filter) {
                return $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__awaiter(this, void 0, void 0, function*() {
                    const { totalCount: totalCount, allItems: allItems } = this, requiredCount = pageIndex * pageSize;
                    const newCount = (totalCount ? Math.min(totalCount, requiredCount) : requiredCount) - allItems.length;
                    const newList = yield this.loadStream(filter, newCount);
                    this.pageList = (0, $iob0w.splitArray)([
                        ...this.allItems,
                        ...newList
                    ], pageSize);
                    return {
                        pageData: this.pageList[pageIndex - 1] || [],
                        totalCount: this.totalCount
                    };
                });
            }
        }, (()=>{
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _restoreList_decorators = [
                $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7('downloading')
            ];
            $7a67b1f7b9b75c34$var$$5766c49bacaeb5b8$var$__esDecorate(_a, null, _restoreList_decorators, {
                kind: "method",
                name: "restoreList",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"restoreList" in obj,
                    get: (obj)=>obj.restoreList
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
        })(), _a;
    })();
    return StreamListMixin;
}



var $8DUxR = parcelRequire("8DUxR");
var $82111daab1cb7b2d$exports = {};

$parcel$export($82111daab1cb7b2d$exports, "FileSystemDirectoryHandle", function () { return (parcelRequire("7LdLi")).default; });
$parcel$export($82111daab1cb7b2d$exports, "FileSystemFileHandle", function () { return (parcelRequire("dPisW")).default; });
$parcel$export($82111daab1cb7b2d$exports, "FileSystemHandle", function () { return (parcelRequire("9QfhF")).default; });
$parcel$export($82111daab1cb7b2d$exports, "FileSystemWritableFileStream", function () { return (parcelRequire("1A4EY")).default; });
$parcel$export($82111daab1cb7b2d$exports, "getOriginPrivateDirectory", function () { return $20ac7021bfef7fb4$export$2e2bcd8739ae039; });
$parcel$export($82111daab1cb7b2d$exports, "showDirectoryPicker", function () { return $c433495088966cc5$export$2e2bcd8739ae039; });
$parcel$export($82111daab1cb7b2d$exports, "showOpenFilePicker", function () { return $1f9e46a93385cc2a$export$2e2bcd8739ae039; });
$parcel$export($82111daab1cb7b2d$exports, "showSaveFilePicker", function () { return $4ed3d0d95c8af78b$export$2e2bcd8739ae039; });
/** @typedef {import('./FileSystemDirectoryHandle.js').default} FileSystemDirectoryHandle */ const $c433495088966cc5$var$native = globalThis.showDirectoryPicker;

/**
 * @param {Object} [options]
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @returns {Promise<FileSystemDirectoryHandle>}
 */ async function $c433495088966cc5$export$6030ffa7b5d2eb28(options = {}) {
    if ($c433495088966cc5$var$native && !options._preferPolyfill) return $c433495088966cc5$var$native(options);
    const input = document.createElement('input');
    input.type = 'file';
    input.webkitdirectory = true;
    // Fallback to multiple files input for iOS Safari
    input.multiple = true;
    // See https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only
    input.style.position = 'fixed';
    input.style.top = '-100000px';
    input.style.left = '-100000px';
    document.body.appendChild(input);
    // Lazy load while the user is choosing the directory
    const p = Promise.resolve((parcelRequire("cFLn4")));
    await new Promise((resolve)=>{
        input.addEventListener('change', resolve);
        input.click();
    });
    return p.then((mod)=>mod.getDirHandlesFromInput(input));
}
var $c433495088966cc5$export$2e2bcd8739ae039 = $c433495088966cc5$export$6030ffa7b5d2eb28;


/** @typedef {import('./FileSystemFileHandle.js').default} FileSystemFileHandle */ const $1f9e46a93385cc2a$var$def = {
    accepts: []
};
const $1f9e46a93385cc2a$var$native = globalThis.showOpenFilePicker;

/**
 * @param {Object} [options]
 * @param {boolean} [options.multiple] If you want to allow more than one file
 * @param {boolean} [options.excludeAcceptAllOption=false] Prevent user for selecting any
 * @param {Object[]} [options.accepts] Files you want to accept
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @returns {Promise<FileSystemFileHandle[]>}
 */ async function $1f9e46a93385cc2a$export$9a17f2258b27c445(options = {}) {
    const opts = {
        ...$1f9e46a93385cc2a$var$def,
        ...options
    };
    if ($1f9e46a93385cc2a$var$native && !options._preferPolyfill) return $1f9e46a93385cc2a$var$native(opts);
    const input = document.createElement('input');
    input.type = 'file';
    input.multiple = opts.multiple;
    input.accept = (opts.accepts || []).map((e)=>[
            ...(e.extensions || []).map((e)=>'.' + e),
            ...e.mimeTypes || []
        ]).flat().join(',');
    // See https://stackoverflow.com/questions/47664777/javascript-file-input-onchange-not-working-ios-safari-only
    Object.assign(input.style, {
        position: 'fixed',
        top: '-100000px',
        left: '-100000px'
    });
    document.body.appendChild(input);
    // Lazy load while the user is choosing the directory
    const p = Promise.resolve((parcelRequire("cFLn4")));
    await new Promise((resolve)=>{
        input.addEventListener('change', resolve, {
            once: true
        });
        input.click();
    });
    input.remove();
    return p.then((m)=>m.getFileHandlesFromInput(input));
}
var $1f9e46a93385cc2a$export$2e2bcd8739ae039 = $1f9e46a93385cc2a$export$9a17f2258b27c445;


/** @typedef {import('./FileSystemFileHandle.js').default} FileSystemFileHandle */ const $4ed3d0d95c8af78b$var$native = globalThis.showSaveFilePicker;


/**
 * @param {Object} [options]
 * @param {boolean} [options.excludeAcceptAllOption=false] Prevent user for selecting any
 * @param {Object[]} [options.types] Files you want to accept
 * @param {string} [options.suggestedName] the name to fall back to when using polyfill
 * @param {string} [options._name] the name to fall back to when using polyfill
 * @param {boolean} [options._preferPolyfill] If you rather want to use the polyfill instead of the native
 * @return {Promise<FileSystemFileHandle>}
 */ async function $4ed3d0d95c8af78b$export$f8b17fb0c2d91989(options = {}) {
    if ($4ed3d0d95c8af78b$var$native && !options._preferPolyfill) return $4ed3d0d95c8af78b$var$native(options);
    if (options._name) {
        console.warn('deprecated _name, spec now have `suggestedName`');
        options.suggestedName = options._name;
    }
    const { FileSystemFileHandle: FileSystemFileHandle } = await Promise.resolve((parcelRequire("dPisW")));
    const { FileHandle: FileHandle } = await (parcelRequire("2eNzN"));
    return new FileSystemFileHandle(new FileHandle(options.suggestedName));
}
var $4ed3d0d95c8af78b$export$2e2bcd8739ae039 = $4ed3d0d95c8af78b$export$f8b17fb0c2d91989;


/** @typedef {import('./FileSystemDirectoryHandle.js').default} FileSystemDirectoryHandle */ 


if (globalThis.DataTransferItem && !DataTransferItem.prototype.getAsFileSystemHandle) DataTransferItem.prototype.getAsFileSystemHandle = async function() {
    const entry = this.webkitGetAsEntry();
    const [{ FileHandle: FileHandle, FolderHandle: FolderHandle }, { FileSystemDirectoryHandle: FileSystemDirectoryHandle }, { FileSystemFileHandle: FileSystemFileHandle }] = await Promise.all([
        (parcelRequire("dYaYn")),
        Promise.resolve((parcelRequire("7LdLi"))),
        Promise.resolve((parcelRequire("dPisW")))
    ]);
    return entry.isFile ? new FileSystemFileHandle(new FileHandle(entry, false)) : new FileSystemDirectoryHandle(new FolderHandle(entry, false));
};

/**
 * @param {object=} driver
 * @return {Promise<FileSystemDirectoryHandle>}
 */ async function $20ac7021bfef7fb4$var$getOriginPrivateDirectory(driver, options = {}) {
    if (!driver) return globalThis.navigator?.storage?.getDirectory() || globalThis.getOriginPrivateDirectory();
    const { FileSystemDirectoryHandle: FileSystemDirectoryHandle } = await Promise.resolve((parcelRequire("7LdLi")));
    const module = await driver;
    const sandbox = await (module.default ? module.default(options) : module(options));
    return new FileSystemDirectoryHandle(sandbox);
}
var $20ac7021bfef7fb4$export$2e2bcd8739ae039 = $20ac7021bfef7fb4$var$getOriginPrivateDirectory;



var $1A4EY = parcelRequire("1A4EY");

var $7LdLi = parcelRequire("7LdLi");

var $dPisW = parcelRequire("dPisW");

var $9QfhF = parcelRequire("9QfhF");



var $iob0w = parcelRequire("iob0w");

var $bI3eA = parcelRequire("bI3eA");
function $0d1ba4dd354e88da$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$exports = {};
$0d1ba4dd354e88da$var$$parcel$export($0d1ba4dd354e88da$var$$eaae1d79f358eeb1$exports, "HTTPDownloadTask", function() {
    return $0d1ba4dd354e88da$export$54a5aef4e85ae85;
});
var $0d1ba4dd354e88da$var$$2305cbd960c24ac6$exports = {};
$0d1ba4dd354e88da$var$$parcel$export($0d1ba4dd354e88da$var$$2305cbd960c24ac6$exports, "DownloadTask", function() {
    return $0d1ba4dd354e88da$export$e9ba70c733fe1cb8;
});
var $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
let $0d1ba4dd354e88da$export$e9ba70c733fe1cb8 = (()=>{
    var _a, _DownloadTask_id_accessor_storage, _DownloadTask_name_accessor_storage, _DownloadTask_path_accessor_storage, _DownloadTask_fsHandle_accessor_storage, _DownloadTask_total_accessor_storage, _DownloadTask_loaded_accessor_storage, _DownloadTask_percent_accessor_storage, _DownloadTask_executing_accessor_storage, _DownloadTask_options_accessor_storage;
    var _b;
    let _instanceExtraInitializers = [];
    let _id_decorators;
    let _id_initializers = [];
    let _id_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    let _fsHandle_decorators;
    let _fsHandle_initializers = [];
    let _fsHandle_extraInitializers = [];
    let _total_decorators;
    let _total_initializers = [];
    let _total_extraInitializers = [];
    let _loaded_decorators;
    let _loaded_initializers = [];
    let _loaded_extraInitializers = [];
    let _percent_decorators;
    let _percent_initializers = [];
    let _percent_extraInitializers = [];
    let _executing_decorators;
    let _executing_initializers = [];
    let _executing_extraInitializers = [];
    let _options_decorators;
    let _options_initializers = [];
    let _options_extraInitializers = [];
    let _get_totalSize_decorators;
    let _get_loadedSize_decorators;
    return _a = class DownloadTask {
        get id() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_id_accessor_storage, "f");
        }
        set id(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_id_accessor_storage, value, "f");
        }
        get name() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_name_accessor_storage, "f");
        }
        set name(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_name_accessor_storage, value, "f");
        }
        get path() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_path_accessor_storage, "f");
        }
        set path(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_path_accessor_storage, value, "f");
        }
        get fsHandle() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_fsHandle_accessor_storage, "f");
        }
        set fsHandle(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_fsHandle_accessor_storage, value, "f");
        }
        get total() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_total_accessor_storage, "f");
        }
        set total(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_total_accessor_storage, value, "f");
        }
        get loaded() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_loaded_accessor_storage, "f");
        }
        set loaded(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_loaded_accessor_storage, value, "f");
        }
        get percent() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_percent_accessor_storage, "f");
        }
        set percent(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_percent_accessor_storage, value, "f");
        }
        get executing() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_executing_accessor_storage, "f");
        }
        set executing(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_executing_accessor_storage, value, "f");
        }
        get options() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldGet(this, _DownloadTask_options_accessor_storage, "f");
        }
        set options(value) {
            $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__classPrivateFieldSet(this, _DownloadTask_options_accessor_storage, value, "f");
        }
        get totalSize() {
            return new (0, $iob0w.ByteSize)(this.total);
        }
        get loadedSize() {
            return new (0, $iob0w.ByteSize)(this.loaded);
        }
        static nameOf(URI) {
            return decodeURI(new URL(URI).pathname.split('/').filter(Boolean).at(-1));
        }
        constructor(path, name = _a.nameOf(path)){
            _DownloadTask_id_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _instanceExtraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _id_initializers, '')));
            _DownloadTask_name_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _id_extraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _name_initializers, '')));
            _DownloadTask_path_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _name_extraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _path_initializers, '')));
            _DownloadTask_fsHandle_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _path_extraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _fsHandle_initializers, void 0)));
            _DownloadTask_total_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _fsHandle_extraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _total_initializers, 0)));
            _DownloadTask_loaded_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _total_extraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _loaded_initializers, 0)));
            _DownloadTask_percent_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _loaded_extraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _percent_initializers, 0)));
            _DownloadTask_executing_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _percent_extraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _executing_initializers, false)));
            _DownloadTask_options_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _executing_extraInitializers), $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _options_initializers, void 0)));
            Object.defineProperty(this, "stream", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__runInitializers(this, _options_extraInitializers)
            });
            this.path = path;
            this.name = name;
        }
        toJSON() {
            const { id: id, name: name, path: path, fsHandle: fsHandle, total: total, loaded: loaded, percent: percent, options: options } = this;
            return Object.assign({
                id: id,
                name: name,
                path: path,
                fsHandle: fsHandle,
                options: options
            }, {
                total: total,
                loaded: loaded,
                percent: percent
            });
        }
        saveMeta(data = {}) {
            const { buffer: buffer } = data, progress = $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__rest(data, [
                "buffer"
            ]);
            Object.assign(this, progress);
            return data;
        }
        start() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__awaiter(this, arguments, void 0, function*(options = this.options) {
                this.options = options;
                const started = Promise.withResolvers();
                const [innerStream, outerStream] = (yield $bI3eA).ReadableStream.from(this.loadStream(options)).tee();
                (()=>$0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__awaiter(this, void 0, void 0, function*() {
                        var _b, e_1, _c, _d;
                        try {
                            try {
                                for(var _e = true, innerStream_1 = $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__asyncValues(innerStream), innerStream_1_1; innerStream_1_1 = yield innerStream_1.next(), _b = innerStream_1_1.done, !_b; _e = true){
                                    _d = innerStream_1_1.value;
                                    _e = false;
                                    const chunk = _d;
                                    started.resolve();
                                    console.table(chunk);
                                }
                            } catch (e_1_1) {
                                e_1 = {
                                    error: e_1_1
                                };
                            } finally{
                                try {
                                    if (!_e && !_b && (_c = innerStream_1.return)) yield _c.call(innerStream_1);
                                } finally{
                                    if (e_1) throw e_1.error;
                                }
                            }
                        } catch (error) {
                            started.reject(error);
                        }
                    }))();
                yield started.promise;
                return this.stream = outerStream;
            });
        }
        pause() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__awaiter(this, void 0, void 0, function*() {
                this.executing = false;
            });
        }
        destroy() {
            return $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__awaiter(this, void 0, void 0, function*() {
                yield this.pause();
                return (0, $7a67b1f7b9b75c34$export$b1fb4cac938035f7)(this, this.id);
            });
        }
    }, _DownloadTask_id_accessor_storage = new WeakMap(), _DownloadTask_name_accessor_storage = new WeakMap(), _DownloadTask_path_accessor_storage = new WeakMap(), _DownloadTask_fsHandle_accessor_storage = new WeakMap(), _DownloadTask_total_accessor_storage = new WeakMap(), _DownloadTask_loaded_accessor_storage = new WeakMap(), _DownloadTask_percent_accessor_storage = new WeakMap(), _DownloadTask_executing_accessor_storage = new WeakMap(), _DownloadTask_options_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _id_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)(),
            (0, $cF2Ke.observable)
        ];
        _name_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)(),
            (0, $cF2Ke.observable)
        ];
        _path_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)(),
            (0, $cF2Ke.observable)
        ];
        _fsHandle_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)(),
            (_b = (0, $cF2Ke.observable)).ref.bind(_b)
        ];
        _total_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)(),
            (0, $cF2Ke.observable)
        ];
        _loaded_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)(),
            (0, $cF2Ke.observable)
        ];
        _percent_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)(),
            (0, $cF2Ke.observable)
        ];
        _executing_decorators = [
            (0, $cF2Ke.observable)
        ];
        _options_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)(),
            (0, $cF2Ke.observable)
        ];
        _get_totalSize_decorators = [
            (0, $cF2Ke.computed)
        ];
        _get_loadedSize_decorators = [
            (0, $cF2Ke.computed)
        ];
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _id_decorators, {
            kind: "accessor",
            name: "id",
            static: false,
            private: false,
            access: {
                has: (obj)=>"id" in obj,
                get: (obj)=>obj.id,
                set: (obj, value)=>{
                    obj.id = value;
                }
            },
            metadata: _metadata
        }, _id_initializers, _id_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _name_decorators, {
            kind: "accessor",
            name: "name",
            static: false,
            private: false,
            access: {
                has: (obj)=>"name" in obj,
                get: (obj)=>obj.name,
                set: (obj, value)=>{
                    obj.name = value;
                }
            },
            metadata: _metadata
        }, _name_initializers, _name_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _fsHandle_decorators, {
            kind: "accessor",
            name: "fsHandle",
            static: false,
            private: false,
            access: {
                has: (obj)=>"fsHandle" in obj,
                get: (obj)=>obj.fsHandle,
                set: (obj, value)=>{
                    obj.fsHandle = value;
                }
            },
            metadata: _metadata
        }, _fsHandle_initializers, _fsHandle_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _total_decorators, {
            kind: "accessor",
            name: "total",
            static: false,
            private: false,
            access: {
                has: (obj)=>"total" in obj,
                get: (obj)=>obj.total,
                set: (obj, value)=>{
                    obj.total = value;
                }
            },
            metadata: _metadata
        }, _total_initializers, _total_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _loaded_decorators, {
            kind: "accessor",
            name: "loaded",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loaded" in obj,
                get: (obj)=>obj.loaded,
                set: (obj, value)=>{
                    obj.loaded = value;
                }
            },
            metadata: _metadata
        }, _loaded_initializers, _loaded_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _percent_decorators, {
            kind: "accessor",
            name: "percent",
            static: false,
            private: false,
            access: {
                has: (obj)=>"percent" in obj,
                get: (obj)=>obj.percent,
                set: (obj, value)=>{
                    obj.percent = value;
                }
            },
            metadata: _metadata
        }, _percent_initializers, _percent_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _executing_decorators, {
            kind: "accessor",
            name: "executing",
            static: false,
            private: false,
            access: {
                has: (obj)=>"executing" in obj,
                get: (obj)=>obj.executing,
                set: (obj, value)=>{
                    obj.executing = value;
                }
            },
            metadata: _metadata
        }, _executing_initializers, _executing_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _options_decorators, {
            kind: "accessor",
            name: "options",
            static: false,
            private: false,
            access: {
                has: (obj)=>"options" in obj,
                get: (obj)=>obj.options,
                set: (obj, value)=>{
                    obj.options = value;
                }
            },
            metadata: _metadata
        }, _options_initializers, _options_extraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _get_totalSize_decorators, {
            kind: "getter",
            name: "totalSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"totalSize" in obj,
                get: (obj)=>obj.totalSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $0d1ba4dd354e88da$var$$2305cbd960c24ac6$var$__esDecorate(_a, null, _get_loadedSize_decorators, {
            kind: "getter",
            name: "loadedSize",
            static: false,
            private: false,
            access: {
                has: (obj)=>"loadedSize" in obj,
                get: (obj)=>obj.loadedSize
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await = function(v) {
    return this instanceof $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await ? (this.v = v, this) : new $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await(v);
};
var $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $0d1ba4dd354e88da$export$54a5aef4e85ae85 extends $0d1ba4dd354e88da$export$e9ba70c733fe1cb8 {
    constructor(path, name){
        super(path, name);
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new (0, $8DUxR.HTTPClient)({
                responseType: 'arraybuffer'
            })
        });
        this.id = `http-download-task-${this.name}`;
        (0, $7a67b1f7b9b75c34$export$db239ef39aadc7fe)(this, this.id);
    }
    loadStream(options) {
        return $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__asyncGenerator(this, arguments, function* loadStream_1() {
            var _a, e_1, _b, _c;
            const { path: path } = this;
            const suggestedName = $0d1ba4dd354e88da$export$e9ba70c733fe1cb8.nameOf(path);
            this.fsHandle || (this.fsHandle = yield $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await((yield $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await($82111daab1cb7b2d$exports)).showSaveFilePicker({
                suggestedName: suggestedName
            })));
            const writer = yield $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await(this.fsHandle.createWritable({
                keepExistingData: true
            })), stream = this.client.download(path, Object.assign({
                range: [
                    this.loaded
                ]
            }, options));
            try {
                this.executing = true;
                try {
                    for(var _d = true, stream_1 = $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__asyncValues(stream), stream_1_1; stream_1_1 = yield $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await(stream_1.next()), _a = stream_1_1.done, !_a; _d = true){
                        _c = stream_1_1.value;
                        _d = false;
                        const chunk = _c;
                        yield $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await(writer.write({
                            type: 'write',
                            position: this.loaded,
                            data: chunk.buffer
                        }));
                        yield yield $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await(this.saveMeta(chunk));
                        if (!this.executing) break;
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_d && !_a && (_b = stream_1.return)) yield $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await(_b.call(stream_1));
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            } finally{
                yield $0d1ba4dd354e88da$var$$eaae1d79f358eeb1$var$__await(writer.close());
                this.executing = false;
            }
        });
    }
}
var $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $0d1ba4dd354e88da$export$ef06e7620d37c296 = (()=>{
    var _a, _Downloader_tasks_accessor_storage;
    let _instanceExtraInitializers = [];
    let _tasks_decorators;
    let _tasks_initializers = [];
    let _tasks_extraInitializers = [];
    let _get_unfinishedCount_decorators;
    let _get_executingCount_decorators;
    return _a = class Downloader {
        static createTask(path, name) {
            const [protocol] = path.split(':');
            const ProtocolTask = _a.protocolMap[protocol];
            if (!ProtocolTask) throw new URIError(`Protocol "${protocol} has not been registered"`);
            return new ProtocolTask(path, name);
        }
        constructor(){
            _Downloader_tasks_accessor_storage.set(this, ($0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__runInitializers(this, _instanceExtraInitializers), $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__runInitializers(this, _tasks_initializers, [])));
            $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__runInitializers(this, _tasks_extraInitializers);
            (0, $7a67b1f7b9b75c34$export$db239ef39aadc7fe)(this, 'downloader');
        }
        get tasks() {
            return $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__classPrivateFieldGet(this, _Downloader_tasks_accessor_storage, "f");
        }
        set tasks(value) {
            $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__classPrivateFieldSet(this, _Downloader_tasks_accessor_storage, value, "f");
        }
        get unfinishedCount() {
            return this.tasks.filter(({ percent: percent })=>percent < 100).length;
        }
        get executingCount() {
            return this.tasks.filter(({ executing: executing })=>executing).length;
        }
        createTask(path, name) {
            const { tasks: tasks } = this;
            const sameTask = tasks.find((task)=>task.path === path);
            if (sameTask) return sameTask;
            const task = _a.createTask(path, name);
            this.tasks = [
                ...tasks,
                task
            ];
            return task;
        }
        destroyTask(name) {
            return $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__awaiter(this, void 0, void 0, function*() {
                const { tasks: tasks } = this;
                const index = tasks.findIndex(({ name: N })=>N === name);
                if (index < 0) throw new ReferenceError(`${name} isn't found`);
                yield tasks[index].destroy();
                this.tasks = [
                    ...tasks.slice(0, index),
                    ...tasks.slice(index + 1)
                ];
            });
        }
    }, _Downloader_tasks_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _tasks_decorators = [
            (0, $7a67b1f7b9b75c34$export$9a6132153fba2e0)({
                set: (tasks)=>tasks.map(({ name: name, path: path })=>({
                            name: name,
                            path: path
                        })),
                get: (list)=>list === null || list === void 0 ? void 0 : list.map(({ name: name, path: path })=>$0d1ba4dd354e88da$export$ef06e7620d37c296.createTask(path, name))
            }),
            (0, $cF2Ke.observable)
        ];
        _get_unfinishedCount_decorators = [
            (0, $cF2Ke.computed)
        ];
        _get_executingCount_decorators = [
            (0, $cF2Ke.computed)
        ];
        $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _tasks_decorators, {
            kind: "accessor",
            name: "tasks",
            static: false,
            private: false,
            access: {
                has: (obj)=>"tasks" in obj,
                get: (obj)=>obj.tasks,
                set: (obj, value)=>{
                    obj.tasks = value;
                }
            },
            metadata: _metadata
        }, _tasks_initializers, _tasks_extraInitializers);
        $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _get_unfinishedCount_decorators, {
            kind: "getter",
            name: "unfinishedCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"unfinishedCount" in obj,
                get: (obj)=>obj.unfinishedCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $0d1ba4dd354e88da$var$$53eb72fe5615c114$var$__esDecorate(_a, null, _get_executingCount_decorators, {
            kind: "getter",
            name: "executingCount",
            static: false,
            private: false,
            access: {
                has: (obj)=>"executingCount" in obj,
                get: (obj)=>obj.executingCount
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), Object.defineProperty(_a, "protocolMap", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: {
            http: $0d1ba4dd354e88da$export$54a5aef4e85ae85,
            https: $0d1ba4dd354e88da$export$54a5aef4e85ae85
        }
    }), _a;
})();



var $8DUxR = parcelRequire("8DUxR");

var $cF2Ke = parcelRequire("cF2Ke");


var $iob0w = parcelRequire("iob0w");

var $gkgmt = parcelRequire("gkgmt");
function $8e2b93540c1d841c$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $8e2b93540c1d841c$var$$d2c94808ccfae153$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$d2c94808ccfae153$exports, "githubClient", function() {
    return $8e2b93540c1d841c$export$660e113192f74c8f;
});
const $8e2b93540c1d841c$export$660e113192f74c8f = new (0, $8DUxR.HTTPClient)({
    baseURI: 'https://api.github.com',
    responseType: 'json'
});
var $8e2b93540c1d841c$var$$e6ce8158e203b92f$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$e6ce8158e203b92f$exports, "UserModel", function() {
    return $8e2b93540c1d841c$export$621c2e9225361608;
});
var $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$59c6fc29dfdfac1b$exports, "OrganizationModel", function() {
    return $8e2b93540c1d841c$export$28c8139b720f2aa8;
});
var $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__await = function(v) {
    return this instanceof $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__await ? (this.v = v, this) : new $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__await(v);
};
var $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
let $8e2b93540c1d841c$export$28c8139b720f2aa8 = (()=>{
    var _a;
    let _classSuper = (0, $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903)((0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    return _a = class OrganizationModel extends _classSuper {
        constructor(user = ''){
            super();
            Object.defineProperty(this, "user", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__runInitializers(this, _instanceExtraInitializers), user)
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $8e2b93540c1d841c$export$660e113192f74c8f
            });
            Object.defineProperty(this, "baseURI", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'orgs'
            });
        }
        openStream() {
            return $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__asyncGenerator(this, arguments, function* openStream_1() {
                var _b;
                var per_page = this.pageSize, since, count = 0;
                const baseURI = this.user ? `users/${this.user}/` : '';
                for(let page = 1;; page++){
                    const { body: body } = yield $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__await(this.client.get(`${baseURI}orgs?${(0, $iob0w.buildURLData)({
                        per_page: per_page,
                        page: page,
                        since: since
                    })}`));
                    if (!body[0]) break;
                    since = (_b = body.at(-1)) === null || _b === void 0 ? void 0 : _b.id;
                    count += body.length;
                    yield $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__await((yield* $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__asyncDelegator($8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__asyncValues(body))));
                    if (body.length < this.pageSize) break;
                }
                this.totalCount = count;
            });
        }
        getOne(name) {
            const _super = Object.create(null, {
                getOne: {
                    get: ()=>super.getOne
                }
            });
            return $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__awaiter(this, void 0, void 0, function*() {
                return this.currentOne.login === name ? this.currentOne : _super.getOne.call(this, name);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7)('downloading')
        ];
        $8e2b93540c1d841c$var$$59c6fc29dfdfac1b$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__classPrivateFieldGet = function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__classPrivateFieldSet = function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $8e2b93540c1d841c$export$621c2e9225361608 = (()=>{
    var _a, _UserModel_session_accessor_storage;
    let _classSuper = (0, $7a67b1f7b9b75c34$export$d12e20a4eec10acf);
    let _instanceExtraInitializers = [];
    let _session_decorators;
    let _session_initializers = [];
    let _session_extraInitializers = [];
    let _get_organizationStore_decorators;
    let _get_namespaces_decorators;
    let _getSession_decorators;
    return _a = class UserModel extends _classSuper {
        get session() {
            return $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__classPrivateFieldGet(this, _UserModel_session_accessor_storage, "f");
        }
        set session(value) {
            $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__classPrivateFieldSet(this, _UserModel_session_accessor_storage, value, "f");
        }
        get organizationStore() {
            var _b;
            return new $8e2b93540c1d841c$export$28c8139b720f2aa8((_b = this.session) === null || _b === void 0 ? void 0 : _b.login);
        }
        get namespaces() {
            return [
                this.session,
                ...this.organizationStore.allItems
            ].filter(Boolean);
        }
        getSession() {
            return $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__awaiter(this, void 0, void 0, function*() {
                if (this.session) return this.session;
                const { body: body } = yield this.client.get('user');
                this.session = body;
                yield this.organizationStore.getAll();
                return body;
            });
        }
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__runInitializers(this, _instanceExtraInitializers), $8e2b93540c1d841c$export$660e113192f74c8f)
            });
            _UserModel_session_accessor_storage.set(this, $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__runInitializers(this, _session_initializers, void 0));
            $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__runInitializers(this, _session_extraInitializers);
        }
    }, _UserModel_session_accessor_storage = new WeakMap(), (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _session_decorators = [
            (0, $cF2Ke.observable)
        ];
        _get_organizationStore_decorators = [
            (0, $cF2Ke.computed)
        ];
        _get_namespaces_decorators = [
            (0, $cF2Ke.computed)
        ];
        _getSession_decorators = [
            (0, $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7)('downloading')
        ];
        $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _session_decorators, {
            kind: "accessor",
            name: "session",
            static: false,
            private: false,
            access: {
                has: (obj)=>"session" in obj,
                get: (obj)=>obj.session,
                set: (obj, value)=>{
                    obj.session = value;
                }
            },
            metadata: _metadata
        }, _session_initializers, _session_extraInitializers);
        $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _get_organizationStore_decorators, {
            kind: "getter",
            name: "organizationStore",
            static: false,
            private: false,
            access: {
                has: (obj)=>"organizationStore" in obj,
                get: (obj)=>obj.organizationStore
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _get_namespaces_decorators, {
            kind: "getter",
            name: "namespaces",
            static: false,
            private: false,
            access: {
                has: (obj)=>"namespaces" in obj,
                get: (obj)=>obj.namespaces
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8e2b93540c1d841c$var$$e6ce8158e203b92f$var$__esDecorate(_a, null, _getSession_decorators, {
            kind: "method",
            name: "getSession",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getSession" in obj,
                get: (obj)=>obj.getSession
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $8e2b93540c1d841c$var$$d3130a010a88f771$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$d3130a010a88f771$exports, "RepositoryModel", function() {
    return $8e2b93540c1d841c$export$e2c4c3b5712a2495;
});
var $8e2b93540c1d841c$var$$dfa451c8fd878073$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$dfa451c8fd878073$exports, "ContributorModel", function() {
    return $8e2b93540c1d841c$export$ebe1058377a924a;
});
var $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__await = function(v) {
    return this instanceof $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__await ? (this.v = v, this) : new $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__await(v);
};
var $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $8e2b93540c1d841c$export$ebe1058377a924a extends (0, $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903)((0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $8e2b93540c1d841c$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/contributors`;
    }
    openStream(filter) {
        return $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__await(client.get(`${baseURI}?${(0, $iob0w.buildURLData)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__await((yield* $8e2b93540c1d841c$var$$dfa451c8fd878073$var$__asyncDelegator($8e2b93540c1d841c$var$$dfa451c8fd878073$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
var $8e2b93540c1d841c$var$$e610a99570571b98$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$e610a99570571b98$exports, "IssueModel", function() {
    return $8e2b93540c1d841c$export$5f96977bde248fb7;
});
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$e610a99570571b98$exports, "IssueCommentModel", function() {
    return $8e2b93540c1d841c$export$3bba9992a4d664e6;
});
var $8e2b93540c1d841c$var$$985c3e5be67a4078$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$985c3e5be67a4078$exports, "PullRequestModel", function() {
    return $8e2b93540c1d841c$export$8b5593d82c2e1a5;
});
var $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__await = function(v) {
    return this instanceof $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__await ? (this.v = v, this) : new $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__await(v);
};
var $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $8e2b93540c1d841c$export$8b5593d82c2e1a5 extends (0, $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903)((0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $8e2b93540c1d841c$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/pulls`;
    }
    openStream(filter) {
        return $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__await(client.get(`${baseURI}?${(0, $iob0w.buildURLData)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__await((yield* $8e2b93540c1d841c$var$$985c3e5be67a4078$var$__asyncDelegator($8e2b93540c1d841c$var$$985c3e5be67a4078$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
var $8e2b93540c1d841c$var$$e610a99570571b98$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8e2b93540c1d841c$var$$e610a99570571b98$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8e2b93540c1d841c$var$$e610a99570571b98$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8e2b93540c1d841c$var$$e610a99570571b98$var$__await = function(v) {
    return this instanceof $8e2b93540c1d841c$var$$e610a99570571b98$var$__await ? (this.v = v, this) : new $8e2b93540c1d841c$var$$e610a99570571b98$var$__await(v);
};
var $8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e2b93540c1d841c$var$$e610a99570571b98$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e2b93540c1d841c$var$$e610a99570571b98$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $8e2b93540c1d841c$var$$e610a99570571b98$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $8e2b93540c1d841c$export$5f96977bde248fb7 = (()=>{
    var _a;
    let _classSuper = (0, $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903)((0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _assignOneToCopilot_decorators;
    let _getLinkedPRs_decorators;
    return _a = class IssueModel extends _classSuper {
        constructor(owner, repository){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($8e2b93540c1d841c$var$$e610a99570571b98$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $8e2b93540c1d841c$export$660e113192f74c8f
            });
            this.baseURI = `repos/${owner}/${repository}/issues`;
        }
        openStream(filter) {
            return $8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncGenerator(this, arguments, function* openStream_1() {
                var per_page = this.pageSize, count = 0;
                for(let page = 1;; page++){
                    const { body: body } = yield $8e2b93540c1d841c$var$$e610a99570571b98$var$__await(this.client.get(`${this.baseURI}?${(0, $iob0w.buildURLData)(Object.assign({
                        per_page: per_page,
                        page: page
                    }, filter))}`));
                    const list = body.filter(({ pull_request: pull_request })=>!pull_request);
                    if (!body[0]) break;
                    count += list.length;
                    yield $8e2b93540c1d841c$var$$e610a99570571b98$var$__await((yield* $8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncDelegator($8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncValues(list))));
                    if (body.length < this.pageSize) break;
                }
                this.totalCount = count;
            });
        }
        /**
             * Create or update an issue, with support for Copilot assignee
             *
             * @see {@link https://docs.github.com/en/rest/issues/issues#create-an-issue}
             * @see {@link https://docs.github.com/en/rest/issues/issues#update-an-issue}
             */ updateOne(_b, id) {
            const _super = Object.create(null, {
                updateOne: {
                    get: ()=>super.updateOne
                }
            });
            return $8e2b93540c1d841c$var$$e610a99570571b98$var$__awaiter(this, void 0, void 0, function*() {
                var { assignees: assignees = [] } = _b, rest = $8e2b93540c1d841c$var$$e610a99570571b98$var$__rest(_b, [
                    "assignees"
                ]);
                const assigneeList = assignees;
                const humanAssignees = assigneeList.filter((login)=>login !== 'copilot-swe-agent');
                const hasCopilotAssignee = assigneeList.length !== humanAssignees.length;
                const issueData = Object.assign(Object.assign({}, rest), humanAssignees && {
                    assignees: humanAssignees
                });
                const issue = yield _super.updateOne.call(this, issueData, id);
                if (hasCopilotAssignee) yield this.assignOneToCopilot(issue);
                return issue;
            });
        }
        /**
             * Assign Copilot bot to an issue using GitHub GraphQL API
             *
             * @see {@link https://docs.github.com/en/copilot/how-tos/use-copilot-agents/coding-agent/create-a-pr#assigning-an-existing-issue}
             * @see {@link https://github.com/orgs/community/discussions/164267}
             */ assignOneToCopilot(issue) {
            return $8e2b93540c1d841c$var$$e610a99570571b98$var$__awaiter(this, void 0, void 0, function*() {
                const getUserQuery = `
            query ($owner: String!, $name: String!) {
                repository(owner: $owner, name: $name) {
                    suggestedActors(
                        loginNames: "copilot"
                        capabilities: [CAN_BE_ASSIGNED]
                        first: 1
                    ) {
                        nodes {
                            login
                            __typename
                            ... on Bot { id }
                        }
                    }
                }
            }`;
                const { body: userResult } = yield this.client.post('https://api.github.com/graphql', {
                    query: getUserQuery,
                    variables: {
                        owner: this.owner,
                        name: this.repository
                    }
                });
                const userId = userResult.data.repository.suggestedActors.nodes[0].id;
                const assignMutation = `
            mutation ($issueId: ID!, $userId: ID!) {
                replaceActorsForAssignable(input: {assignableId: $issueId, actorIds: [$userId]}) {
                    assignable {
                        ... on Issue {
                            id
                            title
                            assignees(first: 10) {
                                nodes { login }
                            }
                        }
                    }
                }
            }`;
                const { body: assignResult } = yield this.client.post('https://api.github.com/graphql', {
                    query: assignMutation,
                    variables: {
                        issueId: issue.id,
                        userId: userId
                    }
                });
                return assignResult;
            });
        }
        /**
             * Get pull requests that close an issue using GraphQL
             *
             * @see {@link https://docs.github.com/en/graphql/reference/objects#pullrequest}
             */ getLinkedPRs(issueNumber_1) {
            return $8e2b93540c1d841c$var$$e610a99570571b98$var$__awaiter(this, arguments, void 0, function*(issueNumber, maxCount = 10) {
                const prNumbers = yield this.getLinkedPRNumbers(issueNumber, maxCount);
                const prModel = new $8e2b93540c1d841c$export$8b5593d82c2e1a5(this.owner, this.repository);
                return Promise.all(prNumbers.map((number)=>prModel.getOne(number)));
            });
        }
        getLinkedPRNumbers(issueNumber_1) {
            return $8e2b93540c1d841c$var$$e610a99570571b98$var$__awaiter(this, arguments, void 0, function*(issueNumber, maxCount = 10) {
                const query = `
            query ($owner: String!, $name: String!, $number: Int!, $maxCount: Int!) {
                repository(owner: $owner, name: $name) {
                    issue(number: $number) {
                        closedByPullRequestsReferences(first: $maxCount) {
                            nodes {
                                number
                            }
                        }
                    }
                }
            }`;
                const { body: body } = yield this.client.post(`https://api.github.com/graphql`, {
                    query: query,
                    variables: {
                        owner: this.owner,
                        name: this.repository,
                        number: issueNumber,
                        maxCount: maxCount
                    }
                });
                return body.data.repository.issue.closedByPullRequestsReferences.nodes.map(({ number: number })=>number);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _assignOneToCopilot_decorators = [
            (0, $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7)('uploading')
        ];
        _getLinkedPRs_decorators = [
            (0, $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7)('downloading')
        ];
        $8e2b93540c1d841c$var$$e610a99570571b98$var$__esDecorate(_a, null, _assignOneToCopilot_decorators, {
            kind: "method",
            name: "assignOneToCopilot",
            static: false,
            private: false,
            access: {
                has: (obj)=>"assignOneToCopilot" in obj,
                get: (obj)=>obj.assignOneToCopilot
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8e2b93540c1d841c$var$$e610a99570571b98$var$__esDecorate(_a, null, _getLinkedPRs_decorators, {
            kind: "method",
            name: "getLinkedPRs",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getLinkedPRs" in obj,
                get: (obj)=>obj.getLinkedPRs
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
class $8e2b93540c1d841c$export$3bba9992a4d664e6 extends (0, $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903)((0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository, issue){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "issue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: issue
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $8e2b93540c1d841c$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/issues/${issue}/comments`;
    }
    openStream(filter) {
        return $8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncGenerator(this, arguments, function* openStream_2() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $8e2b93540c1d841c$var$$e610a99570571b98$var$__await(client.get(`${baseURI}?${(0, $iob0w.buildURLData)(Object.assign(Object.assign({}, filter), {
                    per_page: per_page,
                    page: page
                }))}`));
                if (!body[0]) break;
                count += body.length;
                yield $8e2b93540c1d841c$var$$e610a99570571b98$var$__await((yield* $8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncDelegator($8e2b93540c1d841c$var$$e610a99570571b98$var$__asyncValues(body))));
                if (body.length < per_page) break;
            }
            this.totalCount = count;
        });
    }
}
var $8e2b93540c1d841c$var$$d3130a010a88f771$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8e2b93540c1d841c$var$$d3130a010a88f771$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let $8e2b93540c1d841c$export$e2c4c3b5712a2495 = (()=>{
    var _a;
    let _classSuper = (0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3);
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    return _a = class RepositoryModel extends _classSuper {
        constructor(owner = ''){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($8e2b93540c1d841c$var$$d3130a010a88f771$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $8e2b93540c1d841c$export$660e113192f74c8f
            });
            Object.defineProperty(this, "baseURI", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ''
            });
            Object.defineProperty(this, "indexKey", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'full_name'
            });
            Object.defineProperty(this, "organizationStore", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new $8e2b93540c1d841c$export$28c8139b720f2aa8()
            });
            Object.defineProperty(this, "relation", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: {
                    contributors: (0, $gkgmt.memoize)((URI)=>$8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                            const [owner, repository] = URI.split('/');
                            const body = yield new $8e2b93540c1d841c$export$ebe1058377a924a(owner, repository).getAll();
                            return body.sort((a, b)=>b.contributions - a.contributions) || [];
                        })),
                    issues: (0, $gkgmt.memoize)((URI)=>{
                        const [owner, repository] = URI.split('/');
                        return new $8e2b93540c1d841c$export$5f96977bde248fb7(owner, repository).getAll();
                    }),
                    languages: (0, $gkgmt.memoize)((URI)=>$8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                            const { body: languageCount } = yield this.client.get(`repos/${URI}/languages`);
                            const languageAverage = (0, $iob0w.averageOf)(...Object.values(languageCount));
                            const languageList = Object.entries(languageCount).filter(([_, score])=>score >= languageAverage).sort(([_, a], [__, b])=>b - a);
                            return languageList.map(([name])=>name);
                        }))
                }
            });
            this.baseURI = owner ? `orgs/${owner}/repos` : 'user/repos';
        }
        getOneRelation(URI_1) {
            return $8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(URI, relation = []) {
                const relationData = yield Promise.all(relation.map((key)=>$8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                        const value = yield this.relation[key](URI);
                        return [
                            key,
                            value
                        ];
                    })));
                return Object.fromEntries(relationData);
            });
        }
        getOne(URI_1) {
            return $8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(URI, relation = []) {
                const { body: body } = yield this.client.get(`repos/${URI}`);
                return this.currentOne = Object.assign(Object.assign({}, body), (yield this.getOneRelation(URI, relation)));
            });
        }
        loadPage(page_1, per_page_1, _b) {
            return $8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter(this, arguments, void 0, function*(page, per_page, { relation: relation }) {
                const [kind, namespace] = this.baseURI.split('/'), isUser = kind === 'user';
                const { body: list } = yield this.client.get(`${this.baseURI}?${(0, $iob0w.buildURLData)({
                    type: isUser ? 'owner' : 'public',
                    sort: 'pushed',
                    page: page,
                    per_page: per_page
                })}`);
                const pageData = yield Promise.all(list.map((item)=>$8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                        return Object.assign(Object.assign({}, item), (yield this.getOneRelation(item.full_name, relation)));
                    })));
                var { totalCount: totalCount } = this;
                if (!this.totalCount) {
                    if (!isUser) ({ public_repos: totalCount } = yield this.organizationStore.getOne(namespace));
                    else {
                        const { body: body } = yield this.client.get('user');
                        totalCount = body.public_repos + (body.total_private_repos || 0);
                    }
                }
                return {
                    pageData: pageData,
                    totalCount: totalCount
                };
            });
        }
        getAllContributors() {
            return $8e2b93540c1d841c$var$$d3130a010a88f771$var$__awaiter(this, void 0, void 0, function*() {
                const repositories = yield this.getAll({
                    relation: [
                        'contributors'
                    ]
                });
                const contributors = repositories.filter(({ fork: fork, archived: archived })=>!archived && !fork).flatMap(({ contributors: contributors })=>contributors).filter(({ type: type })=>type === 'User');
                const userGroup = (0, $iob0w.groupBy)(contributors, 'login');
                return Object.entries(userGroup).map(([login, list])=>Object.assign(Object.assign({}, list[0]), {
                        contributions: list.reduce((sum, { contributions: contributions })=>sum + contributions, 0)
                    })).sort((a, b)=>b.contributions - a.contributions);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7)('downloading')
        ];
        $8e2b93540c1d841c$var$$d3130a010a88f771$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $8e2b93540c1d841c$var$$88356f023569df5f$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$88356f023569df5f$exports, "ContentModel", function() {
    return $8e2b93540c1d841c$export$5b988c733cc838bb;
});
var $8e2b93540c1d841c$var$$88356f023569df5f$var$__runInitializers = function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $8e2b93540c1d841c$var$$88356f023569df5f$var$__esDecorate = function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $8e2b93540c1d841c$var$$88356f023569df5f$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $8e2b93540c1d841c$var$$88356f023569df5f$var$__await = function(v) {
    return this instanceof $8e2b93540c1d841c$var$$88356f023569df5f$var$__await ? (this.v = v, this) : new $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(v);
};
var $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e2b93540c1d841c$var$$88356f023569df5f$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
var $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
let $8e2b93540c1d841c$export$5b988c733cc838bb = (()=>{
    var _a;
    let _classSuper = (0, $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903)((0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3));
    let _instanceExtraInitializers = [];
    let _getOne_decorators;
    let _updateOne_decorators;
    return _a = class ContentModel extends _classSuper {
        constructor(owner, repository){
            super();
            Object.defineProperty(this, "owner", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($8e2b93540c1d841c$var$$88356f023569df5f$var$__runInitializers(this, _instanceExtraInitializers), owner)
            });
            Object.defineProperty(this, "repository", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: repository
            });
            Object.defineProperty(this, "client", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: $8e2b93540c1d841c$export$660e113192f74c8f
            });
            this.baseURI = `repos/${owner}/${repository}/contents`;
        }
        /**
             * Get repository content at a specific path
             *
             * @see {@link https://docs.github.com/en/rest/repos/contents#get-repository-content}
             */ getOne(path) {
            return $8e2b93540c1d841c$var$$88356f023569df5f$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.client.get(`${this.baseURI}/${path}`);
                return Array.isArray(body) ? body[0] : body;
            });
        }
        updateOne(_b, path_1) {
            return $8e2b93540c1d841c$var$$88356f023569df5f$var$__awaiter(this, arguments, void 0, function*({ content: content }, path, message = `[update] ${path}`) {
                try {
                    var { sha: sha } = yield this.getOne(path);
                } catch (_c) {}
                const { body: body } = yield this.client.put(`${this.baseURI}/${path}`, {
                    sha: sha,
                    message: message,
                    content: (0, $iob0w.encodeBase64)(content)
                });
                return body.content;
            });
        }
        openStream(_b) {
            return $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* openStream_1({ path: path, name: name }) {
                var _c, e_1, _d, _e;
                const setCount = (total)=>this.totalCount = total;
                const namePattern = name && new RegExp(name);
                const stream = path ? this.traverseChildren(path, setCount) : this.traverseTree(undefined, setCount);
                try {
                    for(var _f = true, stream_1 = $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncValues(stream), stream_1_1; stream_1_1 = yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(stream_1.next()), _c = stream_1_1.done, !_c; _f = true){
                        _e = stream_1_1.value;
                        _f = false;
                        const content = _e;
                        if (!namePattern || namePattern.test(content.name)) yield yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(content);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (!_f && !_c && (_d = stream_1.return)) yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(_d.call(stream_1));
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            });
        }
        /**
             * Get direct children of a directory
             */ traverseChildren() {
            return $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* traverseChildren_1(parentPath = '', onCount = ()=>{}) {
                const { body: body } = yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(this.client.get(`${this.baseURI}/${parentPath}`));
                const contents = (0, $iob0w.makeArray)(body);
                onCount(contents.length);
                for (const content of contents){
                    content.parent_path = parentPath;
                    yield yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(content);
                }
            });
        }
        /**
             * Recursively traverse the entire file tree
             */ traverseTree(parentContent, onCount) {
            return $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncGenerator(this, arguments, function* traverseTree_1() {
                var _b, e_2, _c, _d;
                let totalCount = 0;
                const addCount = (total)=>totalCount += total;
                const stream = this.traverseChildren((parentContent === null || parentContent === void 0 ? void 0 : parentContent.path) || '', addCount);
                try {
                    for(var _e = true, stream_2 = $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncValues(stream), stream_2_1; stream_2_1 = yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(stream_2.next()), _b = stream_2_1.done, !_b; _e = true){
                        _d = stream_2_1.value;
                        _e = false;
                        const content = _d;
                        yield yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(content);
                        if (content.type === 'dir') yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await((yield* $8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncDelegator($8e2b93540c1d841c$var$$88356f023569df5f$var$__asyncValues(this.traverseTree(content, addCount)))));
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (!_e && !_b && (_c = stream_2.return)) yield $8e2b93540c1d841c$var$$88356f023569df5f$var$__await(_c.call(stream_2));
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
                onCount === null || onCount === void 0 || onCount(totalCount);
            });
        }
    }, (()=>{
        var _b;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
        _getOne_decorators = [
            (0, $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7)('downloading')
        ];
        _updateOne_decorators = [
            (0, $7a67b1f7b9b75c34$export$e03c1c3201ee8bb7)('uploading')
        ];
        $8e2b93540c1d841c$var$$88356f023569df5f$var$__esDecorate(_a, null, _getOne_decorators, {
            kind: "method",
            name: "getOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"getOne" in obj,
                get: (obj)=>obj.getOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $8e2b93540c1d841c$var$$88356f023569df5f$var$__esDecorate(_a, null, _updateOne_decorators, {
            kind: "method",
            name: "updateOne",
            static: false,
            private: false,
            access: {
                has: (obj)=>"updateOne" in obj,
                get: (obj)=>obj.updateOne
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$exports, "DiscussionModel", function() {
    return $8e2b93540c1d841c$export$ea22e9ea45676ee3;
});
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$exports, "DiscussionCommentModel", function() {
    return $8e2b93540c1d841c$export$76e6d9690e198c8f;
});
var $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await = function(v) {
    return this instanceof $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await ? (this.v = v, this) : new $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await(v);
};
var $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncValues = function(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
};
var $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncDelegator = function(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
};
var $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncGenerator = function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
class $8e2b93540c1d841c$export$ea22e9ea45676ee3 extends (0, $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903)((0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $8e2b93540c1d841c$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/discussions`;
    }
    openStream(filter) {
        return $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncGenerator(this, arguments, function* openStream_1() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            var count = 0;
            for(let page = 1;; page++){
                const { body: body } = yield $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await(client.get(`${baseURI}?${(0, $iob0w.buildURLData)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                count += body.length;
                yield $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await((yield* $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncDelegator($8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
            this.totalCount = count;
        });
    }
}
class $8e2b93540c1d841c$export$76e6d9690e198c8f extends (0, $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903)((0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3)) {
    constructor(owner, repository, discussion){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "discussion", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: discussion
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $8e2b93540c1d841c$export$660e113192f74c8f
        });
        this.baseURI = `repos/${owner}/${repository}/discussions/${discussion}/comments`;
    }
    openStream(filter) {
        return $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncGenerator(this, arguments, function* openStream_2() {
            const { client: client, baseURI: baseURI, pageSize: per_page } = this;
            const { body: body } = yield $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await(client.get(baseURI.split('/').slice(0, -1).join('/')));
            this.totalCount = body.comments;
            if (!this.totalCount) return yield $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await(void 0);
            for(let page = 1;; page++){
                const { body: body } = yield $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await(client.get(`${baseURI}?${(0, $iob0w.buildURLData)(Object.assign({
                    per_page: per_page,
                    page: page
                }, filter))}`));
                if (!body[0]) break;
                yield $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__await((yield* $8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncDelegator($8e2b93540c1d841c$var$$8f8defdf9fc6f2e7$var$__asyncValues(body))));
                if (body.length < this.pageSize) break;
            }
        });
    }
}
var $8e2b93540c1d841c$var$$131e71a4048073f6$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$131e71a4048073f6$exports, "CheckRunModel", function() {
    return $8e2b93540c1d841c$export$3e1022bc3f07e26a;
});
var $8e2b93540c1d841c$var$$131e71a4048073f6$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8e2b93540c1d841c$var$$131e71a4048073f6$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $8e2b93540c1d841c$export$3e1022bc3f07e26a extends (0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3) {
    constructor(owner, repository, ref){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "ref", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ref
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $8e2b93540c1d841c$export$660e113192f74c8f
        });
        Object.defineProperty(this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        this.baseURI = `repos/${owner}/${repository}/commits/${ref}/check-runs`;
    }
    loadPage(page, per_page, _a) {
        return $8e2b93540c1d841c$var$$131e71a4048073f6$var$__awaiter(this, void 0, void 0, function*() {
            var { name: check_name, filter: filter = 'latest' } = _a, restFilter = $8e2b93540c1d841c$var$$131e71a4048073f6$var$__rest(_a, [
                "name",
                "filter"
            ]);
            const { body: body } = yield this.client.get(`${this.baseURI}?${(0, $iob0w.buildURLData)(Object.assign(Object.assign({
                check_name: check_name,
                filter: filter
            }, restFilter), {
                per_page: per_page,
                page: page
            }))}`);
            return {
                pageData: body.check_runs,
                totalCount: body.total_count
            };
        });
    }
}
var $8e2b93540c1d841c$var$$0ae0bbd5d9d96cbc$exports = {};
$8e2b93540c1d841c$var$$parcel$export($8e2b93540c1d841c$var$$0ae0bbd5d9d96cbc$exports, "WorkflowRunModel", function() {
    return $8e2b93540c1d841c$export$ba933b122214fc50;
});
var $8e2b93540c1d841c$var$$0ae0bbd5d9d96cbc$var$__awaiter = function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8e2b93540c1d841c$var$$0ae0bbd5d9d96cbc$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $8e2b93540c1d841c$export$ba933b122214fc50 extends (0, $7a67b1f7b9b75c34$export$36e5777a1ba4b7c3) {
    constructor(owner, repository){
        super();
        Object.defineProperty(this, "owner", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: owner
        });
        Object.defineProperty(this, "repository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: repository
        });
        Object.defineProperty(this, "client", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: $8e2b93540c1d841c$export$660e113192f74c8f
        });
        Object.defineProperty(this, "baseURI", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: ''
        });
        this.baseURI = `repos/${owner}/${repository}/actions/runs`;
    }
    loadPage(page, per_page, _a) {
        return $8e2b93540c1d841c$var$$0ae0bbd5d9d96cbc$var$__awaiter(this, void 0, void 0, function*() {
            var { head_branch: branch, actor: actor } = _a, restFilter = $8e2b93540c1d841c$var$$0ae0bbd5d9d96cbc$var$__rest(_a, [
                "head_branch",
                "actor"
            ]);
            const { body: body } = yield this.client.get(`${this.baseURI}?${(0, $iob0w.buildURLData)(Object.assign(Object.assign({
                branch: branch,
                actor: actor
            }, restFilter), {
                per_page: per_page,
                page: page
            }))}`);
            return {
                pageData: body.workflow_runs,
                totalCount: body.total_count
            };
        });
    }
}


const $b16be82c38219c2b$var$GithubToken = undefined;
(0, $8e2b93540c1d841c$export$660e113192f74c8f).use(({ request: request }, next)=>{
    if ($b16be82c38219c2b$var$GithubToken) request.headers = Object.assign(Object.assign({}, request.headers), {
        Authorization: `Bearer ${$b16be82c38219c2b$var$GithubToken}`
    });
    return next();
});
const $b16be82c38219c2b$export$8701c19c4b8c549b = new (0, $8e2b93540c1d841c$export$e2c4c3b5712a2495)('idea2app');
const $b16be82c38219c2b$export$76ffa78e7c88f946 = new (0, $0d1ba4dd354e88da$export$ef06e7620d37c296)();


const $f4432e23536978e8$export$ea3d6d720b5c931d = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(({ task: task })=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039), {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Body, {
                children: [
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Title, {
                        children: task.name
                    }),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ed158f87a00484bb$export$2e2bcd8739ae039), {
                        striped: task.percent < 100,
                        animated: task.executing,
                        now: task.percent,
                        label: `${task.percent}%`
                    })
                ]
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Footer, {
                className: "d-flex justify-content-between align-items-center",
                children: [
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("small", {
                        children: [
                            task.loadedSize.toShortString(),
                            " /",
                            ' ',
                            task.totalSize.toShortString()
                        ]
                    }),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                        className: "d-flex gap-3",
                        children: [
                            task.percent < 100 && (task.executing ? (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $85e8222bbf1762c5$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "warning",
                                onClick: ()=>task.pause(),
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Icon), {
                                    name: "pause"
                                })
                            }) : (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $85e8222bbf1762c5$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "success",
                                onClick: ()=>task.start(),
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Icon), {
                                    name: "play"
                                })
                            })),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $85e8222bbf1762c5$export$2e2bcd8739ae039), {
                                size: "sm",
                                variant: "danger",
                                disabled: task.executing,
                                onClick: ()=>(0, $b16be82c38219c2b$export$76ffa78e7c88f946).destroyTask(task.name),
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b8df73c80b604f74$exports.Icon), {
                                    name: "trash"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
const $f4432e23536978e8$export$ef06e7620d37c296 = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(()=>(0, $833f543b429117ba$export$34b9dba7ce09269b)("ol", {
        className: "list-unstyled d-flex flex-column gap-3",
        children: (0, $b16be82c38219c2b$export$76ffa78e7c88f946).tasks.map((task)=>(0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($f4432e23536978e8$export$ea3d6d720b5c931d, {
                    task: task
                })
            }, task.id))
    }));




var $ae662bb446b6a56c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const { t: $ae662bb446b6a56c$var$t } = (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168);
const $ae662bb446b6a56c$var$addTask = (event)=>$ae662bb446b6a56c$var$__awaiter(void 0, void 0, void 0, function*() {
        event.preventDefault();
        const form = event.currentTarget;
        const { path: path } = (0, $iob0w.formToJSON)(form);
        yield (0, $b16be82c38219c2b$export$76ffa78e7c88f946).createTask(path).start({
            chunkSize: Math.pow(1024, 2) / 2
        });
        form.reset();
    });
const $ae662bb446b6a56c$export$2ad2ffac2ac2ce65 = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(()=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $5f7777a6b14048f7$export$2e2bcd8739ae039), {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("h1", {
                className: "my-4",
                children: (0, $85ae22ec5ab7b0e8$export$d977f7cd0cb45fe1)($ae662bb446b6a56c$var$t('downloader'), $ae662bb446b6a56c$var$t('examples'))
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $df771a012e6df6b5$export$2e2bcd8739ae039), {
                className: "d-flex align-items-center gap-3 mb-3",
                onSubmit: $ae662bb446b6a56c$var$addTask,
                children: [
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $2c58e9b2b24f0ee8$export$2e2bcd8739ae039), {
                        className: "flex-fill",
                        label: "URL",
                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $df771a012e6df6b5$export$2e2bcd8739ae039).Control, {
                            placeholder: "URL",
                            type: "url",
                            name: "path",
                            required: true
                        })
                    }),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $85e8222bbf1762c5$export$2e2bcd8739ae039), {
                        type: "submit",
                        children: "+"
                    })
                ]
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $f4432e23536978e8$export$ef06e7620d37c296), {})
        ]
    }));




parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");



var $iob0w = parcelRequire("iob0w");

const $4fa7c28f0dfb04f3$var$$ed859e9f463198da$var$HooksWrapper = ({ ClassComponent: ClassComponent, ...props })=>{
    const location = (0, $db188477a5aad910$export$45d76561a5302f2b)(), params = (0, $db188477a5aad910$export$99eaa27ddbbb95ef)();
    const { pathname: pathname = '/', search: search = '', hash: hash = '' } = location;
    const path = pathname + search + hash;
    const match = {
        url: globalThis.location.origin + path,
        path: path,
        params: params
    }, query = (0, $iob0w.parseURLData)(search);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)(ClassComponent, {
        location: location,
        match: match,
        query: query,
        ...props
    });
};
const $4fa7c28f0dfb04f3$export$369b6b2b30582e8e = (Class, context)=>// which is required for Semantic & Performance Optimization of JS runtimes,
    // and React lifecycle methods should be disabled to avoid duplicated calls.
    class ComponentWithRouter extends Class {
        static{
            this.WrappedComponent = Class;
        }
        static{
            this.displayName = `withRouter(${Class.displayName || Class.name})`;
        }
        static getDerivedStateFromProps(nextProps, prevState) {
            return {};
        }
        static getDerivedStateFromError(error) {}
        componentDidMount() {}
        getSnapshotBeforeUpdate(prevProps, prevState) {}
        shouldComponentUpdate(nextProps, nextState, nextContext) {
            return true;
        }
        componentDidUpdate(prevProps, prevState, snapshot) {}
        componentDidCatch(error, errorInfo) {}
        componentWillUnmount() {}
        render() {
            return (0, $833f543b429117ba$export$34b9dba7ce09269b)($4fa7c28f0dfb04f3$var$$ed859e9f463198da$var$HooksWrapper, {
                ClassComponent: Class,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {};
        }
    };



var $cF2Ke = parcelRequire("cF2Ke");

var $2e5e822b2b9d3254$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $2e5e822b2b9d3254$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $2e5e822b2b9d3254$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2e5e822b2b9d3254$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $2e5e822b2b9d3254$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $2e5e822b2b9d3254$export$e94ab112fc249792 = (()=>{
    var _a, _ProjectModel_list_accessor_storage;
    let _list_decorators;
    let _list_initializers = [];
    let _list_extraInitializers = [];
    return _a = class ProjectModel {
        get list() {
            return $2e5e822b2b9d3254$var$__classPrivateFieldGet(this, _ProjectModel_list_accessor_storage, "f");
        }
        set list(value) {
            $2e5e822b2b9d3254$var$__classPrivateFieldSet(this, _ProjectModel_list_accessor_storage, value, "f");
        }
        clearList() {
            this.list = [];
            (0, $b16be82c38219c2b$export$8701c19c4b8c549b).clear();
        }
        getList(...names) {
            return $2e5e822b2b9d3254$var$__awaiter(this, void 0, void 0, function*() {
                for (const name of names){
                    const body = yield (0, $b16be82c38219c2b$export$8701c19c4b8c549b).getOne(name);
                    const logo = yield _a.getLogo(body.owner.login, body.name);
                    this.list.push(Object.assign(Object.assign({}, body), {
                        logo: logo
                    }));
                }
                return this.list;
            });
        }
        static getLogo(owner, repo) {
            return $2e5e822b2b9d3254$var$__awaiter(this, void 0, void 0, function*() {
                repo = repo.toLowerCase();
                try {
                    return yield new Promise((resolve, reject)=>{
                        const image = new Image();
                        image.onload = ()=>resolve(image.src);
                        image.onerror = reject;
                        image.src = `https://raw.githubusercontent.com/github/explore/master/topics/${repo}/${repo}.png`;
                    });
                } catch (_b) {
                    return `https://github.com/${owner}.png`;
                }
            });
        }
        constructor(){
            _ProjectModel_list_accessor_storage.set(this, $2e5e822b2b9d3254$var$__runInitializers(this, _list_initializers, []));
            $2e5e822b2b9d3254$var$__runInitializers(this, _list_extraInitializers);
        }
    }, _ProjectModel_list_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _list_decorators = [
            (0, $cF2Ke.observable)
        ];
        $2e5e822b2b9d3254$var$__esDecorate(_a, null, _list_decorators, {
            kind: "accessor",
            name: "list",
            static: false,
            private: false,
            access: {
                has: (obj)=>"list" in obj,
                get: (obj)=>obj.list,
                set: (obj, value)=>{
                    obj.list = value;
                }
            },
            metadata: _metadata
        }, _list_initializers, _list_extraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();
var $2e5e822b2b9d3254$export$2e2bcd8739ae039 = new $2e5e822b2b9d3254$export$e94ab112fc249792();



var $2296d3e31d6332cb$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $2296d3e31d6332cb$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $2296d3e31d6332cb$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
const { t: $2296d3e31d6332cb$var$t } = (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168);
let $2296d3e31d6332cb$export$36d69433c4f81145 = (()=>{
    let _classDecorators = [
        (0, $4fa7c28f0dfb04f3$export$369b6b2b30582e8e),
        (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $3lE4N.Component);
    var HomePage = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "renderProject", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ({ id: id, name: name, logo: logo, description: description, homepage: homepage, html_url: html_url })=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ca4e55525ae20d35$export$2e2bcd8739ae039), {
                        className: "mb-3",
                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039), {
                            className: "h-100",
                            children: [
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Img, {
                                    variant: "top",
                                    src: logo
                                }),
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Body, {
                                    children: [
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Title, {
                                            children: name
                                        }),
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Text, {
                                            children: description
                                        })
                                    ]
                                }),
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Footer, {
                                    className: "d-flex justify-content-between",
                                    children: [
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $85e8222bbf1762c5$export$2e2bcd8739ae039), {
                                            variant: "primary",
                                            size: "sm",
                                            target: "_blank",
                                            href: homepage,
                                            children: $2296d3e31d6332cb$var$t('home_page')
                                        }),
                                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $85e8222bbf1762c5$export$2e2bcd8739ae039), {
                                            variant: "success",
                                            size: "sm",
                                            target: "_blank",
                                            href: html_url,
                                            children: $2296d3e31d6332cb$var$t('source_code')
                                        })
                                    ]
                                })
                            ]
                        })
                    }, id)
            });
        }
        componentDidMount() {
            (0, $2e5e822b2b9d3254$export$2e2bcd8739ae039).getList('facebook/react', 'microsoft/TypeScript', 'mobxjs/mobx', 'react-bootstrap/react-bootstrap', 'EasyWebApp/KoAJAX', 'idea2app/ECharts-JSX');
        }
        componentWillUnmount() {
            (0, $2e5e822b2b9d3254$export$2e2bcd8739ae039).clearList();
        }
        render() {
            const { guest: guest } = this.props.query, { list: list } = (0, $2e5e822b2b9d3254$export$2e2bcd8739ae039);
            return (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $5f7777a6b14048f7$export$2e2bcd8739ae039), {
                fluid: "md",
                children: [
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("h1", {
                        className: "my-4",
                        children: $2296d3e31d6332cb$var$t('upstream_projects')
                    }),
                    guest && (0, $833f543b429117ba$export$34b9dba7ce09269b)("h2", {
                        children: [
                            $2296d3e31d6332cb$var$t('welcome'),
                            " ",
                            guest,
                            "!"
                        ]
                    }),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3337fdcef7a6ae36$export$2e2bcd8739ae039), {
                        xs: 1,
                        sm: 2,
                        lg: 4,
                        children: list.map(this.renderProject)
                    })
                ]
            });
        }
    };
    $2296d3e31d6332cb$var$__setFunctionName(_classThis, "HomePage");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        $2296d3e31d6332cb$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        HomePage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $2296d3e31d6332cb$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return HomePage = _classThis;
})();



var $3lE4N = parcelRequire("3lE4N");


var $cF2Ke = parcelRequire("cF2Ke");

var $c66bd636670d658a$exports = {};
var $c66bd636670d658a$var$$aac96070b6d8b41d$export$5eeb11949c905cc1;


var $3lE4N = parcelRequire("3lE4N");


var $kzd8a = parcelRequire("kzd8a");


"use client";
const $65e5f65a7790320a$var$ButtonGroup = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, size: size, vertical: vertical = false, className: className, role: role = 'group', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...rest }, ref)=>{
    const prefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'btn-group');
    let baseClass = prefix;
    if (vertical) baseClass = `${prefix}-vertical`;
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ...rest,
        ref: ref,
        role: role,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, baseClass, size && `${prefix}-${size}`)
    });
});
$65e5f65a7790320a$var$ButtonGroup.displayName = 'ButtonGroup';
var $65e5f65a7790320a$export$2e2bcd8739ae039 = $65e5f65a7790320a$var$ButtonGroup;



var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");




var $kzd8a = parcelRequire("kzd8a");



"use client";
const $d777007b9ee170e7$var$InputGroupText = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'input-group-text');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$d777007b9ee170e7$var$InputGroupText.displayName = 'InputGroupText';
var $d777007b9ee170e7$export$2e2bcd8739ae039 = $d777007b9ee170e7$var$InputGroupText;



"use client";
const $cb5fbc58ed936c1f$var$InputGroupCheckbox = (props)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $d777007b9ee170e7$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $f7696fd13630ab5a$export$2e2bcd8739ae039), {
            type: "checkbox",
            ...props
        })
    });
const $cb5fbc58ed936c1f$var$InputGroupRadio = (props)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $d777007b9ee170e7$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $f7696fd13630ab5a$export$2e2bcd8739ae039), {
            type: "radio",
            ...props
        })
    });
const $cb5fbc58ed936c1f$var$InputGroup = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, size: size, hasValidation: hasValidation, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'input-group');
    // Intentionally an empty object. Used in detecting if a dropdown
    // exists under an input group.
    const contextValue = (0, $jmWak.useMemo)(()=>({}), []);
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $85f137ee157233e9$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, hasValidation && 'has-validation')
        })
    });
});
$cb5fbc58ed936c1f$var$InputGroup.displayName = 'InputGroup';
var $cb5fbc58ed936c1f$export$2e2bcd8739ae039 = Object.assign($cb5fbc58ed936c1f$var$InputGroup, {
    Text: (0, $d777007b9ee170e7$export$2e2bcd8739ae039),
    Radio: $cb5fbc58ed936c1f$var$InputGroupRadio,
    Checkbox: $cb5fbc58ed936c1f$var$InputGroupCheckbox
});



var $kzd8a = parcelRequire("kzd8a");






var $kzd8a = parcelRequire("kzd8a");






"use client";
const $1598701092fc472d$var$ListGroupItem = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $d7cb8d1a1d173352$export$d7a68693710982a)({
        key: (0, $bc7b7daa54233ac1$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$1598701092fc472d$var$ListGroupItem.displayName = 'ListGroupItem';
var $1598701092fc472d$export$2e2bcd8739ae039 = $1598701092fc472d$var$ListGroupItem;



"use client";
const $379053fe725fe9c2$var$ListGroup = /*#__PURE__*/ $kzd8a.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $dbe139f5a1e72daf$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $4793a074f4c7972f$export$2e2bcd8739ae039), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$379053fe725fe9c2$var$ListGroup.displayName = 'ListGroup';
var $379053fe725fe9c2$export$2e2bcd8739ae039 = Object.assign($379053fe725fe9c2$var$ListGroup, {
    Item: (0, $1598701092fc472d$export$2e2bcd8739ae039)
});







var $eb61065bad00bf9b$var$size;
function $eb61065bad00bf9b$export$2e2bcd8739ae039(recalc) {
    if (!$eb61065bad00bf9b$var$size && $eb61065bad00bf9b$var$size !== 0 || recalc) {
        if (0, $53e6d5b016eb161e$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $eb61065bad00bf9b$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $eb61065bad00bf9b$var$size;
}


parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");
function $0b9ede244b925cde$export$2e2bcd8739ae039() {
    return (0, $jmWak.useState)(null);
}







var $kzd8a = parcelRequire("kzd8a");
var $jmWak = parcelRequire("jmWak");




var $kzd8a = parcelRequire("kzd8a");



"use client";
const $6459c2ae70caf85f$var$ModalBody = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$6459c2ae70caf85f$var$ModalBody.displayName = 'ModalBody';
var $6459c2ae70caf85f$export$2e2bcd8739ae039 = $6459c2ae70caf85f$var$ModalBody;





var $kzd8a = parcelRequire("kzd8a");


"use client";
const $247c2af5171a61e5$var$ModalDialog = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$247c2af5171a61e5$var$ModalDialog.displayName = 'ModalDialog';
var $247c2af5171a61e5$export$2e2bcd8739ae039 = $247c2af5171a61e5$var$ModalDialog;



var $kzd8a = parcelRequire("kzd8a");



"use client";
const $906c367e6c61d8a9$var$ModalFooter = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$906c367e6c61d8a9$var$ModalFooter.displayName = 'ModalFooter';
var $906c367e6c61d8a9$export$2e2bcd8739ae039 = $906c367e6c61d8a9$var$ModalFooter;




var $kzd8a = parcelRequire("kzd8a");



"use client";
const $a20573fc1f5105ec$var$ModalHeader = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ae30e06286dea93c$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$a20573fc1f5105ec$var$ModalHeader.displayName = 'ModalHeader';
var $a20573fc1f5105ec$export$2e2bcd8739ae039 = $a20573fc1f5105ec$var$ModalHeader;



var $kzd8a = parcelRequire("kzd8a");




"use client";
const $d0436dfb87bf79f7$var$DivStyledAsH4 = (0, $f36469d8e9627b22$export$2e2bcd8739ae039)('h4');
const $d0436dfb87bf79f7$var$ModalTitle = /*#__PURE__*/ $kzd8a.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $d0436dfb87bf79f7$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix),
        ...props
    });
});
$d0436dfb87bf79f7$var$ModalTitle.displayName = 'ModalTitle';
var $d0436dfb87bf79f7$export$2e2bcd8739ae039 = $d0436dfb87bf79f7$var$ModalTitle;




"use client";
function $feb9072b55697850$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $9c83adfb94811f58$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $feb9072b55697850$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $9c83adfb94811f58$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $feb9072b55697850$var$Modal = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $247c2af5171a61e5$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $jmWak.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $jmWak.useState)(false);
    const waitingForMouseUpRef = (0, $jmWak.useRef)(false);
    const ignoreBackdropClickRef = (0, $jmWak.useRef)(false);
    const removeStaticModalAnimationRef = (0, $jmWak.useRef)(null);
    const [modal, setModalRef] = (0, $0b9ede244b925cde$export$2e2bcd8739ae039)();
    const mergedRef = (0, $c526d8453c8f93e6$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $b6315234e77a11f8$export$35e511eefa30ac5a)();
    bsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $jmWak.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $6e5209f3a28bd586$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $53e6d5b016eb161e$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $0ddd9f7131150c10$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $eb61065bad00bf9b$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $eb61065bad00bf9b$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $2f6fbb54e1cff0d3$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $384c5eee45df98a8$export$2e2bcd8739ae039)(()=>{
        (0, $bf50d51abf54f84c$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $8061db448c42d261$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $39288ac6dc5c98da$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $bf50d51abf54f84c$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $jmWak.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95d2c97ad9caa734$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $fe27af560ebec39d$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $feb9072b55697850$var$DialogTransition : undefined,
            backdropTransition: animation ? $feb9072b55697850$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$feb9072b55697850$var$Modal.displayName = 'Modal';
var $feb9072b55697850$export$2e2bcd8739ae039 = Object.assign($feb9072b55697850$var$Modal, {
    Body: (0, $6459c2ae70caf85f$export$2e2bcd8739ae039),
    Header: (0, $a20573fc1f5105ec$export$2e2bcd8739ae039),
    Title: (0, $d0436dfb87bf79f7$export$2e2bcd8739ae039),
    Footer: (0, $906c367e6c61d8a9$export$2e2bcd8739ae039),
    Dialog: (0, $247c2af5171a61e5$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});



var $kzd8a = parcelRequire("kzd8a");



var $kzd8a = parcelRequire("kzd8a");


const $b79e537a05c145d8$var$PageItem = /*#__PURE__*/ $kzd8a.forwardRef(({ active: active = false, disabled: disabled = false, className: className, style: style, activeLabel: activeLabel = '(current)', children: children, linkStyle: linkStyle, linkClassName: linkClassName, as: as = (0, $cc7927a2f489791a$export$2e2bcd8739ae039), ...props }, ref)=>{
    const Component = active || disabled ? 'span' : as;
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
        ref: ref,
        style: style,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, 'page-item', {
            active: active,
            disabled: disabled
        }),
        children: /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)(Component, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))('page-link', linkClassName),
            style: linkStyle,
            ...props,
            children: [
                children,
                active && activeLabel && /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                    className: "visually-hidden",
                    children: activeLabel
                })
            ]
        })
    });
});
$b79e537a05c145d8$var$PageItem.displayName = 'PageItem';
var $b79e537a05c145d8$export$2e2bcd8739ae039 = $b79e537a05c145d8$var$PageItem;
function $b79e537a05c145d8$var$createButton(name, defaultValue, label = name) {
    const Button = /*#__PURE__*/ $kzd8a.forwardRef(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)($b79e537a05c145d8$var$PageItem, {
            ...props,
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                    "aria-hidden": "true",
                    children: children || defaultValue
                }),
                /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                    className: "visually-hidden",
                    children: label
                })
            ]
        }));
    Button.displayName = name;
    return Button;
}
const $b79e537a05c145d8$export$b25abba66f7be210 = $b79e537a05c145d8$var$createButton('First', "\xab");
const $b79e537a05c145d8$export$1b265216817111b9 = $b79e537a05c145d8$var$createButton('Prev', "\u2039", 'Previous');
const $b79e537a05c145d8$export$1297970233533a7d = $b79e537a05c145d8$var$createButton('Ellipsis', "\u2026", 'More');
const $b79e537a05c145d8$export$b820fc49f2736e85 = $b79e537a05c145d8$var$createButton('Next', "\u203A");
const $b79e537a05c145d8$export$bed9238d8933c9a8 = $b79e537a05c145d8$var$createButton('Last', "\xbb");



"use client";
const $19d2a83c4e94cd20$var$Pagination = /*#__PURE__*/ $kzd8a.forwardRef(({ bsPrefix: bsPrefix, className: className, size: size, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $b6315234e77a11f8$export$7f387860ebffb32c)(bsPrefix, 'pagination');
    return /*#__PURE__*/ (0, $833f543b429117ba$export$34b9dba7ce09269b)("ul", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($46a03b660b5bd4f2$exports)))(className, decoratedBsPrefix, size && `${decoratedBsPrefix}-${size}`)
    });
});
$19d2a83c4e94cd20$var$Pagination.displayName = 'Pagination';
var $19d2a83c4e94cd20$export$2e2bcd8739ae039 = Object.assign($19d2a83c4e94cd20$var$Pagination, {
    First: $b79e537a05c145d8$export$b25abba66f7be210,
    Prev: $b79e537a05c145d8$export$1b265216817111b9,
    Ellipsis: $b79e537a05c145d8$export$1297970233533a7d,
    Item: (0, $b79e537a05c145d8$export$2e2bcd8739ae039),
    Next: $b79e537a05c145d8$export$b820fc49f2736e85,
    Last: $b79e537a05c145d8$export$bed9238d8933c9a8
});



var $iob0w = parcelRequire("iob0w");








var $cF2Ke = parcelRequire("cF2Ke");


var $93fe0439337ed3eb$export$71511d61b312f219;
"use strict";




function $93fe0439337ed3eb$var$_to_array(arr) {
    return $a834b608fd8da8fd$export$71511d61b312f219(arr) || $28910912223efd18$export$71511d61b312f219(arr) || $5117bd7d08faa22e$export$71511d61b312f219(arr) || $6b4a699b9e11976a$export$71511d61b312f219();
}
$93fe0439337ed3eb$export$71511d61b312f219 = $93fe0439337ed3eb$var$_to_array;





var $35185879ecdb8b0f$export$71511d61b312f219;
"use strict";
function $35185879ecdb8b0f$var$_object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
$35185879ecdb8b0f$export$71511d61b312f219 = $35185879ecdb8b0f$var$_object_destructuring_empty;


var $1b8a3567f17d3fac$export$71511d61b312f219;
"use strict";
function $1b8a3567f17d3fac$var$_define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
$1b8a3567f17d3fac$export$71511d61b312f219 = $1b8a3567f17d3fac$var$_define_property;


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");


var $gkgmt = parcelRequire("gkgmt");

function $c66bd636670d658a$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $c66bd636670d658a$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
function $c66bd636670d658a$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
var $c66bd636670d658a$var$$f600741b98acd6fe$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$f600741b98acd6fe$exports, "VariantColors", function() {
    return $c66bd636670d658a$var$$f600741b98acd6fe$export$50b010be9260e56b;
}), $c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$f600741b98acd6fe$exports, "text2color", function() {
    return $c66bd636670d658a$var$$f600741b98acd6fe$export$b480d00b75c9ac2d;
}), $c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$f600741b98acd6fe$exports, "BadgeBar", function() {
    return $c66bd636670d658a$var$$f600741b98acd6fe$export$ef1c4106ceccca63;
});
var $c66bd636670d658a$var$$f600741b98acd6fe$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$f600741b98acd6fe$export$50b010be9260e56b = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info"
], $c66bd636670d658a$var$$f600741b98acd6fe$export$b480d00b75c9ac2d = function(e) {
    return $c66bd636670d658a$var$$f600741b98acd6fe$export$50b010be9260e56b[$iob0w.sum.apply(void 0, (0, $ba6b19be90dbdadc$export$71511d61b312f219)(Array.from(e, function(e) {
        return e.charCodeAt(0);
    }))) % $c66bd636670d658a$var$$f600741b98acd6fe$export$50b010be9260e56b.length];
}, $c66bd636670d658a$var$$f600741b98acd6fe$export$ef1c4106ceccca63 = function(e) {
    var t = e.className, r = e.list, a = e.bgResolver, n = void 0 === a ? $c66bd636670d658a$var$$f600741b98acd6fe$export$b480d00b75c9ac2d : a, c = e.onCheck, s = e.onDelete, i = $c66bd636670d658a$var$$f600741b98acd6fe$var$__rest(e, [
        "className",
        "list",
        "bgResolver",
        "onCheck",
        "onDelete"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("ul", Object.assign({
        className: "list-unstyled m-0 d-flex flex-wrap gap-2 ".concat(void 0 === t ? "" : t)
    }, i, {
        children: r.map(function(e, t) {
            var r = e.text, a = e.link;
            return (0, $833f543b429117ba$export$34b9dba7ce09269b)($877fb262e9f1190e$export$2e2bcd8739ae039, {
                bg: n(r),
                text: "white",
                as: "li",
                className: "d-flex align-items-center gap-2",
                children: [
                    a || URL.canParse(r) ? (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                        className: "text-decoration-none text-white",
                        href: a || r,
                        children: r
                    }) : c ? (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                        onClick: function() {
                            return c({
                                text: r,
                                link: a
                            }, t);
                        },
                        children: r
                    }) : r,
                    s && (0, $833f543b429117ba$export$34b9dba7ce09269b)($0406b4accb6865c0$export$2e2bcd8739ae039, {
                        onClick: function() {
                            return s({
                                text: r,
                                link: a
                            }, t);
                        }
                    })
                ]
            }, r);
        })
    }));
};
$c66bd636670d658a$var$$f600741b98acd6fe$export$ef1c4106ceccca63.displayName = "BadgeBar";
var $c66bd636670d658a$var$$faee9857e4bdfa8b$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$faee9857e4bdfa8b$exports, "ImagePreview", function() {
    return $c66bd636670d658a$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2;
});
var $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2 = function() {
    var e, t, r, a, n, c, s, i, o, l, u, p = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], $ = [], f = $97ddcb8d2dacc617$exports.ObservedComponent, d = [], b = [], m = [], v = [], h = [], _ = [], j = [];
    return s = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, ($c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers(e, d), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers(e, b, !1))), a.set(e, ($c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers(e, m), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers(e, v, ""))), n.set(e, ($c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers(e, h), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers(e, _, !1))), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers(e, j), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "downloading",
                get: function() {
                    return $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "loadedPath",
                get: function() {
                    return $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "viewing",
                get: function() {
                    return $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.observedProps.src;
                    this.loadedPath = "", e && this.load(e);
                }
            },
            {
                key: "load",
                value: function(e) {
                    return $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__awaiter(this, void 0, void 0, function() {
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.downloading = !0, [
                                        4,
                                        new Promise(function(t, r) {
                                            var a = new globalThis.Image;
                                            a.onload = t, a.onerror = r, a.src = e;
                                        })
                                    ];
                                case 1:
                                    return t.sent(), this.loadedPath = e, this.downloading = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.downloading, r = this.loadedPath, a = this.viewing, n = this.props, c = n.className, s = n.loading, i = (n.src, n.fluid), o = n.rounded, l = n.roundedCircle, u = n.thumbnail, p = $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__rest(n, [
                        "className",
                        "loading",
                        "src",
                        "fluid",
                        "rounded",
                        "roundedCircle",
                        "thumbnail"
                    ]);
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({
                        className: $c66bd636670d658a$var$$parcel$interopDefault($46a03b660b5bd4f2$exports)("m-0", t && "d-flex justify-content-center align-items-center", c)
                    }, p, {
                        children: [
                            t ? (0, $833f543b429117ba$export$34b9dba7ce09269b)($32f816caebe11677$export$2e2bcd8739ae039, {}) : r && (0, $833f543b429117ba$export$34b9dba7ce09269b)($6061a0f906a555ad$export$2e2bcd8739ae039, {
                                className: "object-fit-contain",
                                loading: s,
                                fluid: i,
                                rounded: o,
                                roundedCircle: l,
                                thumbnail: u,
                                src: r,
                                onClick: function() {
                                    return e.viewing = !0;
                                }
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)($feb9072b55697850$export$2e2bcd8739ae039, {
                                centered: !0,
                                show: a,
                                onHide: function() {
                                    return e.viewing = !1;
                                },
                                children: [
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($feb9072b55697850$export$2e2bcd8739ae039.Body, {
                                        className: "text-center",
                                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($6061a0f906a555ad$export$2e2bcd8739ae039, {
                                            fluid: !0,
                                            src: r
                                        })
                                    }),
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($feb9072b55697850$export$2e2bcd8739ae039.Footer, {
                                        className: "justify-content-center",
                                        as: "a",
                                        href: r,
                                        target: "_blank",
                                        download: r.split("/").pop(),
                                        children: r
                                    })
                                ]
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }(f), r = new WeakMap, a = new WeakMap, n = new WeakMap, $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__setFunctionName(s, "ImagePreview"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, i = [
        $cF2Ke.observable
    ], o = [
        $cF2Ke.observable
    ], l = [
        $cF2Ke.observable
    ], u = [
        (0, $97ddcb8d2dacc617$exports.reaction)(function(e) {
            return e.observedProps.src;
        })
    ], $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, i, {
        kind: "accessor",
        name: "downloading",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "downloading" in e;
            },
            get: function(e) {
                return e.downloading;
            },
            set: function(e, t) {
                e.downloading = t;
            }
        },
        metadata: t
    }, b, m), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, o, {
        kind: "accessor",
        name: "loadedPath",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "loadedPath" in e;
            },
            get: function(e) {
                return e.loadedPath;
            },
            set: function(e, t) {
                e.loadedPath = t;
            }
        },
        metadata: t
    }, v, h), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, l, {
        kind: "accessor",
        name: "viewing",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "viewing" in e;
            },
            get: function(e) {
                return e.viewing;
            },
            set: function(e, t) {
                e.viewing = t;
            }
        },
        metadata: t
    }, _, j), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__esDecorate(s, null, u, {
        kind: "method",
        name: "componentDidMount",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "componentDidMount" in e;
            },
            get: function(e) {
                return e.componentDidMount;
            }
        },
        metadata: t
    }, null, d), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__esDecorate(null, c = {
        value: s
    }, p, {
        kind: "class",
        name: s.name,
        metadata: t
    }, null, $), s = c.value, t && Object.defineProperty(s, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(s, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ImagePreview"
    }), $c66bd636670d658a$var$$faee9857e4bdfa8b$var$__runInitializers(s, $), s;
}(), $c66bd636670d658a$var$$8663609ea235ec39$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$8663609ea235ec39$exports, "FileTypeMap", function() {
    return $c66bd636670d658a$var$$8663609ea235ec39$export$413fb8502ce63cf9;
}), $c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$8663609ea235ec39$exports, "FilePreview", function() {
    return $c66bd636670d658a$var$$8663609ea235ec39$export$a127194569a41afb;
});
var $c66bd636670d658a$var$$8663609ea235ec39$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$8663609ea235ec39$export$413fb8502ce63cf9 = {
    stream: "binary",
    compressed: "zip",
    msword: "doc",
    document: "docx",
    powerpoint: "ppt",
    presentation: "pptx",
    excel: "xls",
    sheet: "xlsx"
}, $c66bd636670d658a$var$$8663609ea235ec39$export$a127194569a41afb = function(e) {
    var t = e.className, r = e.style, a = e.hidden, n = e.type, c = e.path, s = $c66bd636670d658a$var$$8663609ea235ec39$var$__rest(e, [
        "className",
        "style",
        "hidden",
        "type",
        "path"
    ]), i = (0, $93fe0439337ed3eb$export$71511d61b312f219)((null == n ? void 0 : n.split(/\W+/)) || []), o = i[0], l = i.slice(1), u = decodeURI(new URL(c, "http://localhost").pathname.split("/").at(-1)), p = $c66bd636670d658a$var$$8663609ea235ec39$export$413fb8502ce63cf9[l.at(-1)] || ((null == u ? void 0 : u.includes(".")) ? u.split(".").at(-1) : l.at(-1));
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("figure", {
        className: "d-flex flex-column align-items-center justify-content-center m-0 ".concat(void 0 === t ? "" : t),
        style: r,
        hidden: a,
        children: "image" === o ? (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$faee9857e4bdfa8b$export$4a96334d5925dbf2, Object.assign({
            className: "h-100",
            fluid: !0,
            loading: "lazy",
            src: c
        }, s)) : "audio" === o ? (0, $833f543b429117ba$export$34b9dba7ce09269b)("audio", Object.assign({
            controls: !0,
            src: c
        }, s)) : "video" === o ? (0, $833f543b429117ba$export$34b9dba7ce09269b)("video", Object.assign({
            muted: !0,
            src: c,
            onMouseEnter: function(e) {
                return e.currentTarget.play();
            },
            onMouseLeave: function(e) {
                return e.currentTarget.pause();
            }
        }, s)) : (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
            children: [
                (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", Object.assign({
                    className: "d-inline-flex justify-content-center align-items-center",
                    href: c,
                    target: "_blank",
                    download: u
                }, s, {
                    children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("i", {
                        className: "bi bi-filetype-".concat(p || "file-earmark", " fs-1")
                    })
                })),
                (0, $833f543b429117ba$export$34b9dba7ce09269b)("figcaption", {
                    className: "mw-100 text-truncate",
                    children: u
                })
            ]
        })
    });
};
$c66bd636670d658a$var$$8663609ea235ec39$export$a127194569a41afb.displayName = "FilePreview";
var $c66bd636670d658a$var$$f2af1554fbcf9c96$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$f2af1554fbcf9c96$exports, "FilePicker", function() {
    return $c66bd636670d658a$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1;
});
var $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $c66bd636670d658a$var$$f2af1554fbcf9c96$var$blobCache = new WeakMap, $c66bd636670d658a$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1 = function() {
    var e, t, r, a, n, c, s, i, o, l, u = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], p = [], $ = $97ddcb8d2dacc617$exports.FormComponent, f = [], d = [], b = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), a.set(e, ($c66bd636670d658a$var$$f2af1554fbcf9c96$var$__runInitializers(e, f), $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__runInitializers(e, d, void 0))), r.set(e, ($c66bd636670d658a$var$$f2af1554fbcf9c96$var$__runInitializers(e, b), function(t) {
                if (e.file = t, t) e.innerValue = t, $c66bd636670d658a$var$$f2af1554fbcf9c96$var$blobCache.set(t, URL.createObjectURL(t));
                else if (e.value) {
                    var r = e.innerValue;
                    "string" == typeof r && r.startsWith("blob:") ? URL.revokeObjectURL(r) : r instanceof File && $c66bd636670d658a$var$$f2af1554fbcf9c96$var$blobCache.delete(r), e.innerValue = "";
                }
            })), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "file",
                get: function() {
                    return $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "fileType",
                get: function() {
                    var e, t = this.observedProps.accept, r = this.file;
                    return (null == r ? void 0 : r.type) || (null == (e = null == r ? void 0 : r.name.match(/\.\w+$/)) ? void 0 : e[0]) || t;
                }
            },
            {
                key: "filePath",
                get: function() {
                    var e = this.value;
                    return "string" == typeof e ? e : $c66bd636670d658a$var$$f2af1554fbcf9c96$var$blobCache.get(e);
                }
            },
            {
                key: "restoreFile",
                value: function(e) {
                    return $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__awaiter(this, void 0, void 0, function() {
                        var t, r;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(a) {
                            switch(a.label){
                                case 0:
                                    if ("string" != typeof e) return [
                                        3,
                                        4
                                    ];
                                    a.label = 1;
                                case 1:
                                    return a.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]), [
                                        4,
                                        (0, $iob0w.blobOf)(e)
                                    ];
                                case 2:
                                    return r = new File([
                                        t = a.sent()
                                    ], e.split("/").at(-1), {
                                        type: t.type
                                    }), $c66bd636670d658a$var$$f2af1554fbcf9c96$var$blobCache.set(r, e), [
                                        2,
                                        this.file = r
                                    ];
                                case 3:
                                    return a.sent(), [
                                        3,
                                        4
                                    ];
                                case 4:
                                    if (e instanceof File) return $c66bd636670d658a$var$$f2af1554fbcf9c96$var$blobCache.has(e) || $c66bd636670d658a$var$$f2af1554fbcf9c96$var$blobCache.set(e, URL.createObjectURL(e)), [
                                        2,
                                        this.file = e
                                    ];
                                    return [
                                        2,
                                        this.file = void 0
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.restoreFile(this.value);
                }
            },
            {
                key: "renderInput",
                value: function() {
                    var e = this, t = this.props, a = t.id, n = t.name, c = t.value, s = t.required, i = t.disabled, o = t.accept, l = t.multiple, u = this.filePath;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
                                ref: this.ref,
                                className: "position-absolute start-0 top-0 w-100 h-100 opacity-0",
                                type: "file",
                                name: c ? void 0 : n,
                                required: !c && s,
                                id: a,
                                disabled: i,
                                accept: o,
                                multiple: l,
                                onChange: function(t) {
                                    var a = t.currentTarget.files;
                                    return $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(e, r, "f").call(e, null == a ? void 0 : a[0]);
                                }
                            }),
                            u && (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: n,
                                value: u
                            })
                        ]
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.filePath, a = this.fileType, n = this.props, c = n.className, s = n.style;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                        className: "d-inline-block border rounded position-relative ".concat(void 0 === c ? "" : c),
                        style: Object.assign({
                            width: "10rem",
                            height: "10rem"
                        }, s),
                        children: [
                            t ? (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$8663609ea235ec39$export$a127194569a41afb, {
                                className: "w-100 h-100",
                                type: a,
                                path: t
                            }) : (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                className: "w-100 h-100 d-flex justify-content-center align-items-center display-1",
                                children: "+"
                            }),
                            this.renderInput(),
                            t && (0, $833f543b429117ba$export$34b9dba7ce09269b)($0406b4accb6865c0$export$2e2bcd8739ae039, {
                                className: "position-absolute top-0 end-0",
                                style: {
                                    width: "0.5rem",
                                    height: "0.5rem"
                                },
                                onClick: function() {
                                    return $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__classPrivateFieldGet(e, r, "f").call(e);
                                }
                            })
                        ]
                    });
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__setFunctionName(c, "FilePicker"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, s = [
        $cF2Ke.observable
    ], i = [
        $cF2Ke.computed
    ], o = [
        $cF2Ke.computed
    ], l = [
        (0, $97ddcb8d2dacc617$exports.reaction)(function(e) {
            return e.value;
        })
    ], $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, s, {
        kind: "accessor",
        name: "file",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "file" in e;
            },
            get: function(e) {
                return e.file;
            },
            set: function(e, t) {
                e.file = t;
            }
        },
        metadata: t
    }, d, b), $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, i, {
        kind: "getter",
        name: "fileType",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "fileType" in e;
            },
            get: function(e) {
                return e.fileType;
            }
        },
        metadata: t
    }, null, f), $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, o, {
        kind: "getter",
        name: "filePath",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "filePath" in e;
            },
            get: function(e) {
                return e.filePath;
            }
        },
        metadata: t
    }, null, f), $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__esDecorate(c, null, l, {
        kind: "method",
        name: "restoreFile",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "restoreFile" in e;
            },
            get: function(e) {
                return e.restoreFile;
            }
        },
        metadata: t
    }, null, f), $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__esDecorate(null, n = {
        value: c
    }, u, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, p), c = n.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "FilePicker"
    }), $c66bd636670d658a$var$$f2af1554fbcf9c96$var$__runInitializers(c, p), c;
}(), $c66bd636670d658a$var$$a21a50f24f1cbd28$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$a21a50f24f1cbd28$exports, "FileModel", function() {
    return $c66bd636670d658a$var$$a21a50f24f1cbd28$export$424c8de2e117ab22;
}), $c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$a21a50f24f1cbd28$exports, "FileUploader", function() {
    return $c66bd636670d658a$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749;
});
var $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$a21a50f24f1cbd28$export$424c8de2e117ab22 = function() {
    var e, t, r, a, n = $7a67b1f7b9b75c34$export$d12e20a4eec10acf, c = [], s = [];
    return r = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), a.set(e, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__runInitializers(e, c, [])), $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__runInitializers(e, s), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "files",
                get: function() {
                    return $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "clear",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "clear", this).call(this), this.files = [];
                }
            },
            {
                key: "upload",
                value: function(e) {
                    return $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__awaiter(this, void 0, void 0, function() {
                        var t;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(r) {
                            return e instanceof Blob && (e = URL.createObjectURL(e)), (t = this.files).includes(e) || (this.files = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(t).concat([
                                e
                            ])), [
                                2,
                                e
                            ];
                        });
                    });
                }
            },
            {
                key: "delete",
                value: function(e) {
                    return $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__awaiter(this, void 0, void 0, function() {
                        var t, r;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(a) {
                            return r = (t = this.files).indexOf(e), this.files = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(t.slice(0, r)).concat((0, $ba6b19be90dbdadc$export$71511d61b312f219)(t.slice(r + 1))), [
                                2
                            ];
                        });
                    });
                }
            },
            {
                key: "move",
                value: function(e, t) {
                    var r = this.files, a = r[e], n = r[t], c = Math.min(e, t), s = Math.max(e, t), i = r.slice(0, c), o = r.slice(c + 1, s), l = r.slice(s + 1);
                    this.files = e < t ? (0, $ba6b19be90dbdadc$export$71511d61b312f219)(i).concat((0, $ba6b19be90dbdadc$export$71511d61b312f219)(o), [
                        n,
                        a
                    ], (0, $ba6b19be90dbdadc$export$71511d61b312f219)(l)) : (0, $ba6b19be90dbdadc$export$71511d61b312f219)(i).concat([
                        a,
                        n
                    ], (0, $ba6b19be90dbdadc$export$71511d61b312f219)(o), (0, $ba6b19be90dbdadc$export$71511d61b312f219)(l));
                }
            }
        ]), t;
    }(n), a = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = n[Symbol.metadata]) ? e : null) : void 0, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__esDecorate(r, null, [
        $cF2Ke.observable
    ], {
        kind: "accessor",
        name: "files",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "files" in e;
            },
            get: function(e) {
                return e.files;
            },
            set: function(e, t) {
                e.files = t;
            }
        },
        metadata: t
    }, c, s), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $c66bd636670d658a$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749 = function() {
    var e, t, r, a, n, c, s, i = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], o = [], l = $97ddcb8d2dacc617$exports.FormComponent, u = [], p = [], $ = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, ($c66bd636670d658a$var$$a21a50f24f1cbd28$var$__runInitializers(e, u), $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__runInitializers(e, p, void 0))), Object.defineProperty(e, "handleDrop", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($c66bd636670d658a$var$$a21a50f24f1cbd28$var$__runInitializers(e, $), function(t) {
                    return function(r) {
                        r.preventDefault();
                        var a = e.props, n = e.pickIndex;
                        null != n && (a.store.move(n, t), e.innerValue = a.store.files);
                    };
                })
            }), Object.defineProperty(e, "handleChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    return function(r) {
                        return $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__awaiter(e, void 0, void 0, function() {
                            var e;
                            return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(a) {
                                switch(a.label){
                                    case 0:
                                        if (e = this.props.store, !t) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            e.delete(t)
                                        ];
                                    case 1:
                                        a.sent(), a.label = 2;
                                    case 2:
                                        if (!r) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            e.upload(r)
                                        ];
                                    case 3:
                                        a.sent(), a.label = 4;
                                    case 4:
                                        return this.innerValue = e.files, [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "pickIndex",
                get: function() {
                    return $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), this.props.store.files = this.value || [];
                }
            },
            {
                key: "restoreFile",
                value: function(e) {
                    this.props.store.files = e;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.props, r = t.className, a = t.style, n = t.multiple, c = (t.store, t.value, t.defaultValue, t.onChange, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__rest(t, [
                        "className",
                        "style",
                        "multiple",
                        "store",
                        "value",
                        "defaultValue",
                        "onChange"
                    ])), s = this.value;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("ol", {
                        className: "list-inline d-flex ".concat(void 0 === r ? "m-0" : r),
                        style: a,
                        onDragOver: function(e) {
                            return e.preventDefault();
                        },
                        children: [
                            null == s ? void 0 : s.map(function(t, r) {
                                return (0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
                                    className: "list-inline-item",
                                    draggable: !0,
                                    onDragStart: function() {
                                        return e.pickIndex = r;
                                    },
                                    onDrop: e.handleDrop(r),
                                    children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1, Object.assign({}, c, {
                                        value: t,
                                        onChange: e.handleChange(t)
                                    }))
                                }, t);
                            }),
                            (n || !(null == s ? void 0 : s[0])) && (0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
                                className: "list-inline-item",
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$f2af1554fbcf9c96$export$54dc470bcc5c41d1, Object.assign({}, c, {
                                    name: void 0,
                                    value: "",
                                    required: !(null == s ? void 0 : s[0]) && c.required,
                                    onChange: this.handleChange()
                                }))
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(l), r = new WeakMap, $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__setFunctionName(n, "FileUploader"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = l[Symbol.metadata]) ? e : null) : void 0, c = [
        $cF2Ke.observable
    ], s = [
        (0, $97ddcb8d2dacc617$exports.reaction)(function(e) {
            return e.value;
        })
    ], $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__esDecorate(n, null, c, {
        kind: "accessor",
        name: "pickIndex",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "pickIndex" in e;
            },
            get: function(e) {
                return e.pickIndex;
            },
            set: function(e, t) {
                e.pickIndex = t;
            }
        },
        metadata: t
    }, p, $), $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__esDecorate(n, null, s, {
        kind: "method",
        name: "restoreFile",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "restoreFile" in e;
            },
            get: function(e) {
                return e.restoreFile;
            }
        },
        metadata: t
    }, null, u), $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__esDecorate(null, a = {
        value: n
    }, i, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, o), n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "FileUploader"
    }), $c66bd636670d658a$var$$a21a50f24f1cbd28$var$__runInitializers(n, o), n;
}(), $c66bd636670d658a$var$$4e6504f15de995a8$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$4e6504f15de995a8$exports, "FormField", function() {
    return $c66bd636670d658a$var$$4e6504f15de995a8$export$56e87bf42978147a;
});
var $c66bd636670d658a$var$$4e6504f15de995a8$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$4e6504f15de995a8$export$56e87bf42978147a = function(e) {
    var t = e.className, r = e.style, a = e.label, n = e.placeholder, c = e.id, s = e.name, i = e.options, o = e.multiple, l = e.rows, u = e.onBlur, p = $c66bd636670d658a$var$$4e6504f15de995a8$var$__rest(e, [
        "className",
        "style",
        "label",
        "placeholder",
        "id",
        "name",
        "options",
        "multiple",
        "rows",
        "onBlur"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.FloatingLabel, {
        className: t,
        style: r,
        label: a,
        controlId: s || c,
        onBlur: function(e) {
            e.target.checkValidity() ? (e.target.classList.remove("is-invalid"), e.currentTarget.classList.remove("is-invalid")) : (e.target.classList.add("is-invalid"), e.currentTarget.classList.add("is-invalid")), null == u || u(e);
        },
        children: i ? (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Select, Object.assign({
            className: o ? "h-auto" : "",
            name: s,
            multiple: o,
            htmlSize: l
        }, p, {
            children: i.map(function(e) {
                var t = e.value, r = e.text, a = e.label, n = e.disabled;
                return (0, $833f543b429117ba$export$34b9dba7ce09269b)("option", {
                    value: t,
                    label: a,
                    disabled: n,
                    children: r || t
                }, t);
            })
        })) : (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Control, Object.assign({
            className: l > 1 ? "h-auto" : "",
            name: s,
            multiple: o,
            rows: l
        }, p, {
            placeholder: n || ("string" == typeof a ? a : s || c)
        }))
    });
};
$c66bd636670d658a$var$$4e6504f15de995a8$export$56e87bf42978147a.displayName = "FormField";
var $c66bd636670d658a$var$$92bd5b9c2e8cd28e$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$92bd5b9c2e8cd28e$exports, "RangeInput", function() {
    return $c66bd636670d658a$var$$92bd5b9c2e8cd28e$export$f5603a09670563b9;
});
var $c66bd636670d658a$var$$92bd5b9c2e8cd28e$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$92bd5b9c2e8cd28e$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$92bd5b9c2e8cd28e$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$92bd5b9c2e8cd28e$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$92bd5b9c2e8cd28e$export$f5603a09670563b9 = function() {
    var e, t, r, a, n = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], c = [], s = $97ddcb8d2dacc617$exports.FormComponent;
    return $c66bd636670d658a$var$$92bd5b9c2e8cd28e$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments);
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "renderItem",
                value: function(e) {
                    var t = this.value, r = this.observedProps, a = r.icon, n = r.step, c = void 0 === n ? 1 : n, s = Math.max(Math.min((void 0 === t ? 0 : t) - c * e, +c), 0);
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("li", {
                        className: "text-center",
                        children: "function" == typeof a ? a(s) : a
                    }, e);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.observedProps, r = t.className, a = t.icon, n = t.min, c = t.max, s = void 0 === c ? a ? 5 : 100 : c, i = (t.onChange, $c66bd636670d658a$var$$92bd5b9c2e8cd28e$var$__rest(t, [
                        "className",
                        "icon",
                        "min",
                        "max",
                        "onChange"
                    ])), o = this.value, l = void 0 === o ? n || 0 : o;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                        className: void 0 === r ? "d-inline-block position-relative" : r,
                        title: l + "",
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", Object.assign({
                                min: n,
                                max: s,
                                value: l
                            }, i, {
                                className: a ? "opacity-0" : "",
                                style: {
                                    margin: "0 -0.5rem",
                                    cursor: "pointer"
                                },
                                type: "range",
                                onChange: function(t) {
                                    return e.innerValue = t.currentTarget.value;
                                }
                            })),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("ol", {
                                className: "list-unstyled user-select-none position-absolute start-0 top-0 w-100 h-100 pe-none d-flex justify-content-around",
                                children: Array.from({
                                    length: +s
                                }, function(t, r) {
                                    return e.renderItem(r);
                                })
                            })
                        ]
                    });
                }
            }
        ]), t;
    }(s), "RangeInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $c66bd636670d658a$var$$92bd5b9c2e8cd28e$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RangeInput"
    }), $c66bd636670d658a$var$$92bd5b9c2e8cd28e$var$__runInitializers(a, c), a;
}(), $c66bd636670d658a$var$$fa84453248a3f065$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$fa84453248a3f065$exports, "TextInputTypes", function() {
    return $c66bd636670d658a$var$$fa84453248a3f065$export$82cd8db40d0f609c;
}), $c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$fa84453248a3f065$exports, "BadgeInput", function() {
    return $c66bd636670d658a$var$$fa84453248a3f065$export$76834b0602c89bd;
});
var $c66bd636670d658a$var$$fa84453248a3f065$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$fa84453248a3f065$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$fa84453248a3f065$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$fa84453248a3f065$export$82cd8db40d0f609c = [
    "text",
    "number",
    "tel",
    "email",
    "url"
], $c66bd636670d658a$var$$fa84453248a3f065$export$76834b0602c89bd = function() {
    var e, t, r, a, n = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], c = [], s = $97ddcb8d2dacc617$exports.FormComponent;
    return $c66bd636670d658a$var$$fa84453248a3f065$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "handleInput", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.currentTarget, a = r.value, n = e.innerValue || [];
                    switch(t.key){
                        case "Enter":
                            t.preventDefault(), r.value = "", a && (e.innerValue = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(n).concat([
                                a
                            ]));
                            break;
                        case "Backspace":
                            a || (e.innerValue = n.slice(0, -1));
                    }
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "delete",
                value: function(e) {
                    var t = this.innerValue;
                    this.innerValue = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(t.slice(0, e)).concat((0, $ba6b19be90dbdadc$export$71511d61b312f219)(t.slice(e + 1)));
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.value, r = this.props, a = r.className, n = r.style, c = r.type, s = r.name, i = r.required, o = r.placeholder;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                        className: "form-control p-2 d-flex flex-wrap gap-2 ".concat(void 0 === a ? "" : a),
                        style: n,
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                                list: (t || []).map(function(e) {
                                    return {
                                        text: e
                                    };
                                }),
                                onDelete: function(t, r) {
                                    return (0, $35185879ecdb8b0f$export$71511d61b312f219)(t), e.delete(r);
                                }
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
                                className: "border-0 flex-fill",
                                style: {
                                    outline: "none"
                                },
                                type: c,
                                required: (0, $iob0w.isEmpty)(t) ? i : void 0,
                                placeholder: o,
                                onKeyDown: this.handleInput
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
                                type: "hidden",
                                name: s,
                                value: JSON.stringify(t)
                            })
                        ]
                    });
                }
            }
        ], [
            {
                key: "match",
                value: function(e) {
                    return $c66bd636670d658a$var$$fa84453248a3f065$export$82cd8db40d0f609c.includes(e);
                }
            }
        ]), t;
    }(s), "BadgeInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $c66bd636670d658a$var$$fa84453248a3f065$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "BadgeInput"
    }), $c66bd636670d658a$var$$fa84453248a3f065$var$__runInitializers(a, c), a;
}(), $c66bd636670d658a$var$$36ed2012ed0bbec3$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$36ed2012ed0bbec3$exports, "ArrayField", function() {
    return $c66bd636670d658a$var$$36ed2012ed0bbec3$export$42efeba470be9198;
});
var $c66bd636670d658a$var$$36ed2012ed0bbec3$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$36ed2012ed0bbec3$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$36ed2012ed0bbec3$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$36ed2012ed0bbec3$export$42efeba470be9198 = function() {
    var e, t, r, a, n = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], c = [], s = $97ddcb8d2dacc617$exports.FormComponent;
    return $c66bd636670d658a$var$$36ed2012ed0bbec3$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "add", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    return e.innerValue = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(e.innerValue || []).concat([
                        {}
                    ]);
                }
            }), Object.defineProperty(e, "remove", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r;
                    return e.innerValue = null == (r = e.innerValue) ? void 0 : r.filter(function(e, r) {
                        return r !== t;
                    });
                }
            }), Object.defineProperty(e, "handleChange", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return function(r) {
                        var a, n, c = r.currentTarget, s = (0, $iob0w.formToJSON)(c), i = e.innerValue, o = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(i.slice(0, t)).concat([
                            s
                        ], (0, $ba6b19be90dbdadc$export$71511d61b312f219)(i.slice(t + 1))).map(function(e) {
                            return (0, $cF2Ke.toJS)(e);
                        });
                        null == (n = (a = e.props).onChange) || n.call(a, o);
                    };
                }
            }), Object.defineProperty(e, "handleUpdate", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return function(r) {
                        var a = r.currentTarget;
                        return e.innerValue[t] = (0, $iob0w.formToJSON)(a);
                    };
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function() {
                    (0, $863bf07a5aae9b63$export$71511d61b312f219)((0, $3dfa8530dae89ae9$export$71511d61b312f219)(t.prototype), "componentDidMount", this).call(this), (0, $iob0w.isEmpty)(this.value) && this.add();
                }
            },
            {
                key: "render",
                value: function() {
                    var e, t = this, r = this.props, a = r.className, n = void 0 === a ? "" : a, c = r.style, s = r.name, i = r.renderItem;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
                        children: null == (e = this.value) ? void 0 : e.map(function(e, r, a) {
                            var o = a.length;
                            return (0, $833f543b429117ba$export$34b9dba7ce09269b)("fieldset", {
                                className: "d-flex align-items-center my-2 gap-2 ".concat(n),
                                style: c,
                                name: s,
                                onChange: t.handleChange(r),
                                onBlur: t.handleUpdate(r),
                                children: [
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                        className: "flex-fill",
                                        children: i(e, r)
                                    }),
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($65e5f65a7790320a$export$2e2bcd8739ae039, {
                                        children: [
                                            (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                                type: "button",
                                                size: "sm",
                                                variant: "warning",
                                                onClick: t.add,
                                                children: "+"
                                            }),
                                            (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                                type: "button",
                                                size: "sm",
                                                variant: "danger",
                                                disabled: o < 2,
                                                onClick: function() {
                                                    return t.remove(r);
                                                },
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }, JSON.stringify(e));
                        })
                    });
                }
            }
        ]), t;
    }(s), "ArrayField"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $c66bd636670d658a$var$$36ed2012ed0bbec3$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ArrayField"
    }), $c66bd636670d658a$var$$36ed2012ed0bbec3$var$__runInitializers(a, c), a;
}(), $c66bd636670d658a$var$$cd7ba08b282791a9$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$cd7ba08b282791a9$exports, "RestForm", function() {
    return $c66bd636670d658a$var$$cd7ba08b282791a9$export$341e3470805a945e;
});
var $c66bd636670d658a$var$$cd7ba08b282791a9$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$cd7ba08b282791a9$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$cd7ba08b282791a9$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $c66bd636670d658a$var$$cd7ba08b282791a9$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$cd7ba08b282791a9$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $c66bd636670d658a$var$$cd7ba08b282791a9$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$cd7ba08b282791a9$export$341e3470805a945e = function() {
    var e, t, r, a, n, c, s, i, o, l, u = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], p = [], $ = $97ddcb8d2dacc617$exports.ObservedComponent, f = [], d = [], b = [], m = n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, ($c66bd636670d658a$var$$cd7ba08b282791a9$var$__runInitializers(e, f), $c66bd636670d658a$var$$cd7ba08b282791a9$var$__runInitializers(e, d, !1))), Object.defineProperty(e, "handleSubmit", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($c66bd636670d658a$var$$cd7ba08b282791a9$var$__runInitializers(e, b), function(t) {
                    return $c66bd636670d658a$var$$cd7ba08b282791a9$var$__awaiter(e, void 0, void 0, function() {
                        var e, r, a, n, c, s, i;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(o) {
                            switch(o.label){
                                case 0:
                                    if (t.preventDefault(), t.stopPropagation(), r = (e = t.currentTarget).checkValidity(), this.validated = !0, !r) return [
                                        3,
                                        2
                                    ];
                                    return n = (a = this.props).id, c = a.store, s = a.onSubmit, i = (0, $iob0w.formToJSON)(e), [
                                        4,
                                        null == c ? void 0 : c.updateOne(i, n)
                                    ];
                                case 1:
                                    i = o.sent(), null == s || s(i), null == c || c.clearCurrent(), o.label = 2;
                                case 2:
                                    return this.validated = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                })
            }), Object.defineProperty(e, "handleReset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.currentTarget, a = e.props, n = a.onReset, c = a.store;
                    null == n || n((0, $iob0w.formToJSON)(r)), null == c || c.clearCurrent();
                }
            }), Object.defineProperty(e, "renderFile", (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(e) {
                var t = e.key, r = e.type, a = e.required, n = e.multiple, c = e.accept, s = e.uploader, i = $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(e, [
                    "key",
                    "type",
                    "required",
                    "multiple",
                    "accept",
                    "uploader"
                ]);
                return function(e) {
                    var o = e[t], l = (Array.isArray(o) ? o : [
                        o
                    ]).filter(Boolean);
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: t
                    }, i, {
                        children: s ? (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$a21a50f24f1cbd28$export$1a5cb5295a7d2749, {
                            store: s,
                            name: null == t ? void 0 : t.toString(),
                            required: a,
                            multiple: n,
                            accept: c,
                            defaultValue: l
                        }) : l.map(function(e) {
                            return (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$8663609ea235ec39$export$a127194569a41afb, {
                                type: r,
                                path: e
                            });
                        })
                    }));
                };
            })), Object.defineProperty(e, "renderCheckGroup", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.key, a = t.type, n = t.options, c = $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(t, [
                        "key",
                        "type",
                        "options"
                    ]);
                    return function(t) {
                        return (0, $833f543b429117ba$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                            name: r
                        }, c, {
                            children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                children: e.fieldReady && n.map(function(e) {
                                    var n, s = e.value, i = e.label, o = void 0 === i ? s : i;
                                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Check, Object.assign({
                                        id: [
                                            r,
                                            s
                                        ] + "",
                                        label: o,
                                        inline: !0
                                    }, c, {
                                        type: a,
                                        name: r.toString(),
                                        value: s,
                                        defaultChecked: null == (n = t[r]) ? void 0 : n.includes(s)
                                    }), s);
                                })
                            })
                        }));
                    };
                }
            }), Object.defineProperty(e, "renderMultipleInput", (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t) {
                var r = t.key, a = (t.type, $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "type"
                ]));
                return function(t) {
                    var n = t[r];
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: r
                    }, a, {
                        children: e.fieldReady && (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$fa84453248a3f065$export$76834b0602c89bd, Object.assign({}, a, {
                            name: null == r ? void 0 : r.toString(),
                            defaultValue: n
                        }))
                    }));
                };
            })), Object.defineProperty(e, "renderHTMLEditor", (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t) {
                var r = t.key, a = (t.contentEditable, t.tools), n = $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "contentEditable",
                    "tools"
                ]);
                return function(t) {
                    var c = t[r];
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)(m.FieldBox, Object.assign({
                        name: r
                    }, n, {
                        children: e.fieldReady && (0, $833f543b429117ba$export$34b9dba7ce09269b)($75acd277c1ee9d2f$exports.Editor, {
                            tools: a,
                            name: null == r ? void 0 : r.toString(),
                            defaultValue: c
                        })
                    }));
                };
            })), Object.defineProperty(e, "renderField", (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(t, r) {
                var a = t.key, n = t.type, c = t.step, s = t.renderLabel, i = (t.renderInput, t.validMessage), o = t.invalidMessage, l = $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(t, [
                    "key",
                    "type",
                    "step",
                    "renderLabel",
                    "renderInput",
                    "validMessage",
                    "invalidMessage"
                ]);
                void 0 === r && (r = {});
                var u = "function" == typeof s ? null == s ? void 0 : s(a) : s || a;
                return function(t) {
                    var s = t[a];
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($cb5fbc58ed936c1f$export$2e2bcd8739ae039, {
                        hasValidation: e.customValidation,
                        children: [
                            e.fieldReady && (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$4e6504f15de995a8$export$56e87bf42978147a, Object.assign({}, r, l, {
                                type: n,
                                step: c,
                                label: u,
                                size: e.observedProps.size,
                                name: a.toString(),
                                defaultValue: m.dateValueOf({
                                    type: n,
                                    step: c
                                }, s)
                            })),
                            i && (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Control.Feedback, {
                                tooltip: !0,
                                type: "valid",
                                children: i
                            }),
                            o && (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Control.Feedback, {
                                tooltip: !0,
                                type: "invalid",
                                children: o
                            })
                        ]
                    });
                };
            })), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "validated",
                get: function() {
                    return $c66bd636670d658a$var$$cd7ba08b282791a9$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$cd7ba08b282791a9$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.props, t = e.id, r = e.store;
                    t && (null == r || r.getOne(t));
                }
            },
            {
                key: "fields",
                get: function() {
                    var e = this;
                    return this.observedProps.fields.map(function(t) {
                        var r = t.renderInput, a = $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(t, [
                            "renderInput"
                        ]);
                        return Object.assign(Object.assign({}, a), {
                            renderInput: null != r ? r : "file" === a.type ? e.renderFile(a) : ("radio" === a.type || "checkbox" === a.type) && a.options ? e.renderCheckGroup(a) : a.contentEditable ? e.renderHTMLEditor(a) : !a.options && a.multiple ? e.renderMultipleInput(a) : a.key && e.renderField(a, a.rows && !a.options ? {
                                as: "textarea"
                            } : {})
                        });
                    });
                }
            },
            {
                key: "readOnly",
                get: function() {
                    return this.fields.every(function(e) {
                        var t = e.readOnly, r = e.disabled;
                        return t || r;
                    });
                }
            },
            {
                key: "customValidation",
                get: function() {
                    return this.fields.some(function(e) {
                        var t = e.validMessage, r = e.invalidMessage;
                        return t || r;
                    });
                }
            },
            {
                key: "fieldReady",
                get: function() {
                    var e = this.observedProps, t = e.id, r = e.store;
                    return !t || (null == r ? void 0 : r.downloading) < 1;
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.fields, t = this.readOnly, r = this.customValidation, a = this.validated, n = this.props, c = (n.id, n.className), s = n.size, i = n.store, o = n.translator, l = $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(n, [
                        "id",
                        "className",
                        "size",
                        "store",
                        "translator"
                    ]), u = i || {}, p = u.downloading, $ = u.uploading, f = u.currentOne, d = void 0 === f ? {} : f, b = o.t, m = p > 0 || $ > 0;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039, Object.assign({}, l, {
                        className: void 0 === c ? "d-flex flex-column gap-3" : c,
                        validated: a,
                        noValidate: r,
                        onSubmit: this.handleSubmit,
                        onReset: this.handleReset,
                        children: [
                            e.map(function(e) {
                                var t, r = e.renderInput, a = $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(e, [
                                    "renderInput"
                                ]);
                                return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
                                    children: null == r ? void 0 : r(d, a)
                                }, null == (t = a.key) ? void 0 : t.toString());
                            }),
                            !t && (0, $833f543b429117ba$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex gap-3",
                                children: [
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                        className: "flex-fill",
                                        size: s,
                                        type: "submit",
                                        disabled: m,
                                        children: b("submit")
                                    }),
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                        className: "flex-fill",
                                        size: s,
                                        type: "reset",
                                        variant: "danger",
                                        disabled: m,
                                        children: b("cancel")
                                    })
                                ]
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($);
    return r = new WeakMap, $c66bd636670d658a$var$$cd7ba08b282791a9$var$__setFunctionName(n, "RestForm"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, c = [
        $cF2Ke.observable
    ], s = [
        $cF2Ke.computed
    ], i = [
        $cF2Ke.computed
    ], o = [
        $cF2Ke.computed
    ], l = [
        $cF2Ke.computed
    ], $c66bd636670d658a$var$$cd7ba08b282791a9$var$__esDecorate(n, null, c, {
        kind: "accessor",
        name: "validated",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "validated" in e;
            },
            get: function(e) {
                return e.validated;
            },
            set: function(e, t) {
                e.validated = t;
            }
        },
        metadata: t
    }, d, b), $c66bd636670d658a$var$$cd7ba08b282791a9$var$__esDecorate(n, null, s, {
        kind: "getter",
        name: "fields",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "fields" in e;
            },
            get: function(e) {
                return e.fields;
            }
        },
        metadata: t
    }, null, f), $c66bd636670d658a$var$$cd7ba08b282791a9$var$__esDecorate(n, null, i, {
        kind: "getter",
        name: "readOnly",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "readOnly" in e;
            },
            get: function(e) {
                return e.readOnly;
            }
        },
        metadata: t
    }, null, f), $c66bd636670d658a$var$$cd7ba08b282791a9$var$__esDecorate(n, null, o, {
        kind: "getter",
        name: "customValidation",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "customValidation" in e;
            },
            get: function(e) {
                return e.customValidation;
            }
        },
        metadata: t
    }, null, f), $c66bd636670d658a$var$$cd7ba08b282791a9$var$__esDecorate(n, null, l, {
        kind: "getter",
        name: "fieldReady",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "fieldReady" in e;
            },
            get: function(e) {
                return e.fieldReady;
            }
        },
        metadata: t
    }, null, f), $c66bd636670d658a$var$$cd7ba08b282791a9$var$__esDecorate(null, a = {
        value: n
    }, u, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, p), m = n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RestForm"
    }), Object.defineProperty(n, "dateValueOf", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(e, t) {
            var r = e.type, a = e.step;
            return (0, $iob0w.isEmpty)(t) ? t : "month" === r ? (0, $iob0w.formatDate)(t, "YYYY-MM") : "date" === r ? (0, $iob0w.formatDate)(t, "YYYY-MM-DD") : "datetime-local" === r ? (0, $iob0w.formatDate)(t, "YYYY-MM-DDTHH:mm".concat(60 > +(void 0 === a ? "60" : a) ? ":ss" : "")) : t;
        }
    }), Object.defineProperty(n, "FieldBox", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: function(e) {
            var t = e.name, r = e.renderLabel, a = e.validMessage, n = e.invalidMessage, c = e.children, s = $c66bd636670d658a$var$$cd7ba08b282791a9$var$__rest(e, [
                "name",
                "renderLabel",
                "validMessage",
                "invalidMessage",
                "children"
            ]);
            return (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Group, Object.assign({}, s, {
                children: [
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Label, {
                        children: "function" == typeof r ? r(t) : r || t
                    }),
                    c,
                    a && (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Control.Feedback, {
                        tooltip: !0,
                        type: "valid",
                        children: a
                    }),
                    n && (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Control.Feedback, {
                        tooltip: !0,
                        type: "invalid",
                        children: n
                    })
                ]
            }));
        }
    }), $c66bd636670d658a$var$$cd7ba08b282791a9$var$__runInitializers(n, p), m = n;
}(), $c66bd636670d658a$var$$bcc38e2aa906301f$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$bcc38e2aa906301f$exports, "Pager", function() {
    return $c66bd636670d658a$var$$bcc38e2aa906301f$export$57625d62e5386b09;
});
var $c66bd636670d658a$var$$bcc38e2aa906301f$export$57625d62e5386b09 = function(e) {
    var t = e.pageSize, r = e.pageIndex, a = e.pageCount, n = e.onChange;
    function c() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1, r = {
            pageSize: t,
            pageIndex: e
        };
        return {
            href: "?".concat((0, $iob0w.buildURLData)(Object.assign(Object.assign({}, (0, $iob0w.parseURLData)()), r))),
            onClick: n && function(e) {
                e.preventDefault(), n(r);
            }
        };
    }
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("form", {
        className: "m-0 d-flex align-items-center gap-2",
        onSubmit: n && function(e) {
            return e.preventDefault(), e.stopPropagation();
        },
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Control, {
                type: "number",
                name: "pageSize",
                defaultValue: t,
                min: 1,
                required: !0,
                onChange: function(e) {
                    var t = e.currentTarget;
                    return t.reportValidity() && (null == n ? void 0 : n({
                        pageSize: +t.value,
                        pageIndex: r
                    }));
                }
            }),
            "x",
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Control, {
                type: "number",
                name: "pageIndex",
                defaultValue: r || 1,
                min: 1,
                max: a,
                required: !0,
                onChange: function(e) {
                    var r = e.currentTarget;
                    return r.reportValidity() && (null == n ? void 0 : n({
                        pageSize: t,
                        pageIndex: +r.value
                    }));
                }
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($19d2a83c4e94cd20$export$2e2bcd8739ae039, {
                className: "m-0",
                children: [
                    r > 1 && (0, $833f543b429117ba$export$34b9dba7ce09269b)($19d2a83c4e94cd20$export$2e2bcd8739ae039.Item, Object.assign({}, c(1), {
                        children: "1"
                    })),
                    r > 3 && (0, $833f543b429117ba$export$34b9dba7ce09269b)($19d2a83c4e94cd20$export$2e2bcd8739ae039.Ellipsis, {}),
                    r > 2 && (0, $833f543b429117ba$export$34b9dba7ce09269b)($19d2a83c4e94cd20$export$2e2bcd8739ae039.Item, Object.assign({}, c(r - 1), {
                        children: r - 1
                    })),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($19d2a83c4e94cd20$export$2e2bcd8739ae039.Item, {
                        active: !0,
                        children: r
                    }),
                    a - r > 1 && (0, $833f543b429117ba$export$34b9dba7ce09269b)($19d2a83c4e94cd20$export$2e2bcd8739ae039.Item, Object.assign({}, c(r + 1), {
                        children: r + 1
                    })),
                    a - r > 2 && (0, $833f543b429117ba$export$34b9dba7ce09269b)($19d2a83c4e94cd20$export$2e2bcd8739ae039.Ellipsis, {}),
                    r < a && (0, $833f543b429117ba$export$34b9dba7ce09269b)($19d2a83c4e94cd20$export$2e2bcd8739ae039.Item, Object.assign({}, c(a), {
                        children: a
                    }))
                ]
            })
        ]
    });
};
$c66bd636670d658a$var$$bcc38e2aa906301f$export$57625d62e5386b09.displayName = "Pager";
var $c66bd636670d658a$var$$3800431d840f9bec$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$3800431d840f9bec$exports, "RestTable", function() {
    return $c66bd636670d658a$var$$3800431d840f9bec$export$fd90441354a7d816;
});
var $c66bd636670d658a$var$$bfbc9f72f179e373$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$bfbc9f72f179e373$export$28baae8ef86bbf36 = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(function(e) {
    var t = e.fields, r = e.store, a = e.translator, n = $c66bd636670d658a$var$$bfbc9f72f179e373$var$__rest(e, [
        "fields",
        "store",
        "translator"
    ]), c = r.indexKey, s = r.currentOne, i = !(0, $iob0w.isEmpty)(s), o = s[c];
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($feb9072b55697850$export$2e2bcd8739ae039, {
        show: i,
        onHide: function() {
            return r.clearCurrent();
        },
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($feb9072b55697850$export$2e2bcd8739ae039.Header, {
                closeButton: !0,
                children: o
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)($feb9072b55697850$export$2e2bcd8739ae039.Body, {
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$cd7ba08b282791a9$export$341e3470805a945e, Object.assign({
                    id: o,
                    fields: t,
                    store: r,
                    translator: a
                }, n))
            })
        ]
    });
});
$c66bd636670d658a$var$$aac96070b6d8b41d$export$5eeb11949c905cc1 = "SrGRNq_filterBar";
var $c66bd636670d658a$var$$3800431d840f9bec$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$3800431d840f9bec$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $c66bd636670d658a$var$$3800431d840f9bec$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$3800431d840f9bec$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $c66bd636670d658a$var$$3800431d840f9bec$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $c66bd636670d658a$var$$3800431d840f9bec$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$3800431d840f9bec$export$fd90441354a7d816 = function() {
    var e, t, r, a, n, c, s, i, o, l, u, p, $, f = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], d = [], b = $97ddcb8d2dacc617$exports.ObservedComponent, m = [], v = [], h = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, ($c66bd636670d658a$var$$3800431d840f9bec$var$__runInitializers(e, m), $c66bd636670d658a$var$$3800431d840f9bec$var$__runInitializers(e, v, []))), Object.defineProperty(e, "toggleCheckAll", (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", ($c66bd636670d658a$var$$3800431d840f9bec$var$__runInitializers(e, h), function() {
                var t = e.props, r = t.store, a = t.onCheck, n = r.indexKey, c = r.currentPage;
                e.checkedKeys = e.checkedKeys.length ? [] : c.map(function(e) {
                    return e[n];
                }), null == a || a(e.checkedKeys);
            }))), Object.defineProperty(e, "renderCustomBody", (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                enumerable: !0,
                configurable: !0,
                writable: !0
            }, "value", function(e) {
                var t = e.key, r = e.type, a = e.multiple, n = e.options, c = e.accept, s = e.rows;
                return "url" === r ? function(e) {
                    var r = e[t];
                    return r && (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                        target: "_blank",
                        href: r,
                        children: r
                    });
                } : "email" === r ? function(e) {
                    var r = e[t];
                    return r && (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                        href: "mailto:".concat(r),
                        children: r
                    });
                } : "tel" === r ? function(e) {
                    var r = e[t];
                    return r && (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                        href: "tel:".concat(r),
                        children: r
                    });
                } : "file" === r ? function(e) {
                    var r = e[t];
                    return (Array.isArray(r) ? r : [
                        r
                    ]).map(function(e) {
                        return e && (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$8663609ea235ec39$export$a127194569a41afb, {
                            type: c,
                            path: e
                        }, e);
                    });
                } : n || a ? function(e) {
                    var r = e[t];
                    return r && (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                        list: r.map(function(e) {
                            return {
                                text: e
                            };
                        })
                    });
                } : !n && s ? function(e) {
                    var r = e[t];
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("p", {
                        className: "m-0 text-truncate",
                        style: {
                            maxWidth: "20rem"
                        },
                        title: r,
                        children: r
                    });
                } : void 0;
            })), Object.defineProperty(e, "getList", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $gkgmt.debounce)(function(t) {
                    var r = t.pageIndex, a = t.pageSize, n = e.props, c = n.store, s = n.filter;
                    c.downloading < 1 && c.getList(s, r, a);
                })
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.props, t = e.store, r = e.filter;
                    t.clear(), t.getList(r);
                }
            },
            {
                key: "fieldSize",
                get: function() {
                    var e = this.observedProps.size;
                    return e ? "sm" === e ? "sm" : "lg" : void 0;
                }
            },
            {
                key: "checkedKeys",
                get: function() {
                    return $c66bd636670d658a$var$$3800431d840f9bec$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$3800431d840f9bec$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "toggleCheck",
                value: function(e) {
                    var t, r, a = this.checkedKeys, n = a.indexOf(e);
                    this.checkedKeys = n < 0 ? (0, $ba6b19be90dbdadc$export$71511d61b312f219)(a).concat([
                        e
                    ]) : (0, $ba6b19be90dbdadc$export$71511d61b312f219)(a.slice(0, n)).concat((0, $ba6b19be90dbdadc$export$71511d61b312f219)(a.slice(n + 1))), null == (r = (t = this.props).onCheck) || r.call(t, this.checkedKeys);
                }
            },
            (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                key: "checkColumn"
            }, "get", function() {
                var e, t = this, r = this.checkedKeys, a = this.toggleCheckAll, n = this.observedProps.store, c = n.indexKey, s = n.currentPage;
                return e = {}, (0, $1b8a3567f17d3fac$export$71511d61b312f219)(e, "renderHead", function() {
                    var e;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Check, (e = {
                        type: "checkbox",
                        name: "all-".concat(c.toString()),
                        value: r + ""
                    }, (0, $1b8a3567f17d3fac$export$71511d61b312f219)(e, "checked", !!s[0] && s.every(function(e) {
                        var t = e[c];
                        return r.includes(t);
                    })), (0, $1b8a3567f17d3fac$export$71511d61b312f219)(e, "ref", function(e) {
                        e && (e.indeterminate = !!r.length && r.length < s.length);
                    }), (0, $1b8a3567f17d3fac$export$71511d61b312f219)(e, "onClick", a), (0, $1b8a3567f17d3fac$export$71511d61b312f219)(e, "onKeyUp", function(e) {
                        return " " === e.key && a();
                    }), e));
                }), (0, $1b8a3567f17d3fac$export$71511d61b312f219)(e, "renderBody", function(e) {
                    var a = e[c];
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Check, {
                        type: "checkbox",
                        name: c.toString(),
                        value: a,
                        checked: r.includes(a),
                        onClick: function() {
                            return t.toggleCheck(a);
                        },
                        onKeyUp: function(e) {
                            return " " === e.key && t.toggleCheck(a);
                        }
                    });
                }), e;
            }),
            {
                key: "operateColumn",
                get: function() {
                    var e = this, t = this.observedProps, r = t.editable, a = t.deletable, n = t.columns, c = t.store, s = t.translator, i = this.fieldSize, o = s.t, l = n.every(function(e) {
                        return e.readOnly;
                    }), u = n.every(function(e) {
                        return e.disabled;
                    });
                    return {
                        renderHead: function() {
                            return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {});
                        },
                        renderBody: function(t) {
                            return (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {
                                children: [
                                    u ? (0, $833f543b429117ba$export$34b9dba7ce09269b)($3lE4N.Fragment, {}) : r && (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                        className: "text-nowrap m-1",
                                        variant: l ? "primary" : "warning",
                                        size: i,
                                        onClick: function() {
                                            return c.currentOne = t;
                                        },
                                        children: l ? o("view") : o("edit")
                                    }),
                                    a && (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                        className: "text-nowrap m-1",
                                        variant: "danger",
                                        size: i,
                                        onClick: function() {
                                            return e.deleteList([
                                                t.id
                                            ]);
                                        },
                                        children: o("delete")
                                    })
                                ]
                            });
                        }
                    };
                }
            },
            {
                key: "columns",
                get: function() {
                    var e = this, t = this.observedProps, r = t.editable, a = t.deletable, n = t.columns;
                    return [
                        t.onCheck && this.checkColumn
                    ].concat((0, $ba6b19be90dbdadc$export$71511d61b312f219)(n.map(function(t) {
                        var r = t.renderBody, a = $c66bd636670d658a$var$$3800431d840f9bec$var$__rest(t, [
                            "renderBody"
                        ]);
                        return Object.assign(Object.assign({}, a), {
                            renderBody: null != r ? r : e.renderCustomBody(a)
                        });
                    })), [
                        (r || a) && this.operateColumn
                    ]).filter(Boolean);
                }
            },
            {
                key: "hasHeader",
                get: function() {
                    return this.columns.some(function(e) {
                        return e.renderHead;
                    });
                }
            },
            {
                key: "hasFooter",
                get: function() {
                    return this.columns.some(function(e) {
                        return e.renderFoot;
                    });
                }
            },
            {
                key: "editing",
                get: function() {
                    return !(0, $iob0w.isEmpty)(this.observedProps.store.currentOne);
                }
            },
            {
                key: "renderTable",
                value: function() {
                    var e = this.props, t = (e.className, e.columns, e.store), r = (e.translator, e.editable, e.deletable, e.onCheck, e.onSubmit, e.onReset, e.responsive), a = $c66bd636670d658a$var$$3800431d840f9bec$var$__rest(e, [
                        "className",
                        "columns",
                        "store",
                        "translator",
                        "editable",
                        "deletable",
                        "onCheck",
                        "onSubmit",
                        "onReset",
                        "responsive"
                    ]), n = this.hasHeader, c = this.hasFooter, s = this.columns, i = this.editing, o = t.indexKey, l = t.downloading, u = t.currentPage;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($71c6da7a2e5aef0a$export$2e2bcd8739ae039, Object.assign({}, a, {
                        responsive: void 0 === r || r,
                        children: [
                            n && (0, $833f543b429117ba$export$34b9dba7ce09269b)("thead", {
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", {
                                    className: "align-middle text-nowrap",
                                    children: s.map(function(e, t) {
                                        var r = e.key, a = e.renderHead;
                                        return (r || a) && (0, $833f543b429117ba$export$34b9dba7ce09269b)("th", {
                                            children: "function" == typeof a ? a(r) : a || r
                                        }, (null == r ? void 0 : r.toString()) || t);
                                    })
                                })
                            }),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("tbody", {
                                children: !i && l > 0 ? (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", {
                                    children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                                        className: "text-center p-3",
                                        colSpan: s.length,
                                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($32f816caebe11677$export$2e2bcd8739ae039, {})
                                    })
                                }) : u.map(function(e) {
                                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", {
                                        className: "align-middle",
                                        children: s.map(function(t, r) {
                                            var a = t.key, n = t.renderBody;
                                            return (a || n) && (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                                                children: (null == n ? void 0 : n(e)) || a && e[a]
                                            }, (null == a ? void 0 : a.toString()) || r);
                                        })
                                    }, e[o]);
                                })
                            }),
                            c && (0, $833f543b429117ba$export$34b9dba7ce09269b)("tfoot", {
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("tr", {
                                    className: "align-middle",
                                    children: s.map(function(e, t) {
                                        var r = e.key, a = e.renderFoot;
                                        return (r || a) && (0, $833f543b429117ba$export$34b9dba7ce09269b)("td", {
                                            children: "function" == typeof a ? a(r) : a || r
                                        }, (null == r ? void 0 : r.toString()) || t);
                                    })
                                })
                            })
                        ]
                    }));
                }
            },
            {
                key: "deleteList",
                value: function(e) {
                    return $c66bd636670d658a$var$$3800431d840f9bec$var$__awaiter(this, void 0, void 0, function() {
                        var t, r, a, n, c, s, i, o, l, u;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(p) {
                            switch(p.label){
                                case 0:
                                    if (r = (t = this.props).translator, a = t.store, n = !0, c = !1, s = void 0, !confirm(r.t("sure_to_delete_x", {
                                        keys: e
                                    }))) return [
                                        3,
                                        8
                                    ];
                                    p.label = 1;
                                case 1:
                                    p.trys.push([
                                        1,
                                        6,
                                        7,
                                        8
                                    ]), i = e[Symbol.iterator](), p.label = 2;
                                case 2:
                                    if (n = (o = i.next()).done) return [
                                        3,
                                        5
                                    ];
                                    return l = o.value, [
                                        4,
                                        a.deleteOne(l)
                                    ];
                                case 3:
                                    p.sent(), p.label = 4;
                                case 4:
                                    return n = !0, [
                                        3,
                                        2
                                    ];
                                case 5:
                                    return [
                                        3,
                                        8
                                    ];
                                case 6:
                                    return u = p.sent(), c = !0, s = u, [
                                        3,
                                        8
                                    ];
                                case 7:
                                    try {
                                        n || null == i.return || i.return();
                                    } finally{
                                        if (c) throw s;
                                    }
                                    return [
                                        7
                                    ];
                                case 8:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.props, r = t.className, a = t.editable, n = t.deletable, c = t.filterFields, s = t.store, i = t.translator, o = t.onSubmit, l = (t.onReset, $c66bd636670d658a$var$$3800431d840f9bec$var$__rest(t, [
                        "className",
                        "editable",
                        "deletable",
                        "filterFields",
                        "store",
                        "translator",
                        "onSubmit",
                        "onReset"
                    ])), u = this.fieldSize, p = i.t, $ = s.indexKey, f = s.pageSize, d = s.pageIndex, b = s.pageCount, m = s.totalCount;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({
                        className: void 0 === r ? "overflow-auto d-flex flex-column gap-3" : r
                    }, l, {
                        children: [
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("header", {
                                className: "sticky-top bg-white py-3 d-flex flex-column gap-3",
                                children: [
                                    c && (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$cd7ba08b282791a9$export$341e3470805a945e, {
                                        className: "d-flex flex-wrap align-items-center gap-3 pb-3 border-bottom ".concat($c66bd636670d658a$var$$aac96070b6d8b41d$export$5eeb11949c905cc1),
                                        size: u,
                                        translator: i,
                                        fields: c,
                                        onSubmit: function(e) {
                                            return s.getList(e, 1);
                                        },
                                        onReset: function() {
                                            return s.getList({}, 1);
                                        }
                                    }),
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                                        className: "d-flex justify-content-between align-items-center",
                                        children: [
                                            n && (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                                className: "mx-2",
                                                variant: "danger",
                                                size: u,
                                                onClick: function() {
                                                    return e.deleteList(e.checkedKeys);
                                                },
                                                children: p("delete")
                                            }),
                                            a && (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                                                size: u,
                                                onClick: function() {
                                                    return s.currentOne[$] = "";
                                                },
                                                children: p("create")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            this.renderTable(),
                            (0, $833f543b429117ba$export$34b9dba7ce09269b)("footer", {
                                className: "d-flex justify-content-between align-items-center",
                                children: [
                                    !!m && (0, $833f543b429117ba$export$34b9dba7ce09269b)("span", {
                                        className: "mx-3 fs14",
                                        children: p("total_x_rows", {
                                            totalCount: m
                                        })
                                    }),
                                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$bcc38e2aa906301f$export$57625d62e5386b09, {
                                        pageSize: f,
                                        pageIndex: d,
                                        pageCount: b,
                                        onChange: this.getList
                                    })
                                ]
                            }),
                            a && (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$bfbc9f72f179e373$export$28baae8ef86bbf36, {
                                size: u,
                                fields: this.columns.map(function(e) {
                                    var t = e.renderHead;
                                    return Object.assign(Object.assign({}, $c66bd636670d658a$var$$3800431d840f9bec$var$__rest(e, [
                                        "renderHead"
                                    ])), {
                                        renderLabel: t
                                    });
                                }),
                                store: s,
                                translator: i,
                                onSubmit: o
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }(b), r = new WeakMap, $c66bd636670d658a$var$$3800431d840f9bec$var$__setFunctionName(n, "RestTable"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = b[Symbol.metadata]) ? e : null) : void 0, c = [
        $cF2Ke.computed
    ], s = [
        $cF2Ke.observable
    ], i = [
        $cF2Ke.computed
    ], o = [
        $cF2Ke.computed
    ], l = [
        $cF2Ke.computed
    ], u = [
        $cF2Ke.computed
    ], p = [
        $cF2Ke.computed
    ], $ = [
        $cF2Ke.computed
    ], $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(n, null, c, {
        kind: "getter",
        name: "fieldSize",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "fieldSize" in e;
            },
            get: function(e) {
                return e.fieldSize;
            }
        },
        metadata: t
    }, null, m), $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(n, null, s, {
        kind: "accessor",
        name: "checkedKeys",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "checkedKeys" in e;
            },
            get: function(e) {
                return e.checkedKeys;
            },
            set: function(e, t) {
                e.checkedKeys = t;
            }
        },
        metadata: t
    }, v, h), $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(n, null, i, {
        kind: "getter",
        name: "checkColumn",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "checkColumn" in e;
            },
            get: function(e) {
                return e.checkColumn;
            }
        },
        metadata: t
    }, null, m), $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(n, null, o, {
        kind: "getter",
        name: "operateColumn",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "operateColumn" in e;
            },
            get: function(e) {
                return e.operateColumn;
            }
        },
        metadata: t
    }, null, m), $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(n, null, l, {
        kind: "getter",
        name: "columns",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "columns" in e;
            },
            get: function(e) {
                return e.columns;
            }
        },
        metadata: t
    }, null, m), $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(n, null, u, {
        kind: "getter",
        name: "hasHeader",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "hasHeader" in e;
            },
            get: function(e) {
                return e.hasHeader;
            }
        },
        metadata: t
    }, null, m), $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(n, null, p, {
        kind: "getter",
        name: "hasFooter",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "hasFooter" in e;
            },
            get: function(e) {
                return e.hasFooter;
            }
        },
        metadata: t
    }, null, m), $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(n, null, $, {
        kind: "getter",
        name: "editing",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "editing" in e;
            },
            get: function(e) {
                return e.editing;
            }
        },
        metadata: t
    }, null, m), $c66bd636670d658a$var$$3800431d840f9bec$var$__esDecorate(null, a = {
        value: n
    }, f, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, d), n = a.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "RestTable"
    }), $c66bd636670d658a$var$$3800431d840f9bec$var$__runInitializers(n, d), n;
}(), $c66bd636670d658a$var$$3330ccfab53de794$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$3330ccfab53de794$exports, "ScrollBoundary", function() {
    return $c66bd636670d658a$var$$3330ccfab53de794$export$d086fcc3bc3f366f;
});
var $c66bd636670d658a$var$$3330ccfab53de794$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$3330ccfab53de794$var$EdgeOrder = [
    "top",
    "right",
    "bottom",
    "left"
], $c66bd636670d658a$var$$3330ccfab53de794$var$touch = function(e, t) {
    return function(r) {
        if (r) {
            var a, n = null == (a = r.parentElement) ? void 0 : a.parentElement, c = n ? getComputedStyle(n) : {}, s = c.overflowX, i = c.overflowY, o = "".concat(s).concat(i).match(/auto|scroll/) ? n : null, l = [
                ,
                ,
                ,
                , 
            ].fill("0px");
            l[$c66bd636670d658a$var$$3330ccfab53de794$var$EdgeOrder.indexOf(e)] = "200px", new IntersectionObserver(function(r) {
                return (0, $a8a036b4881ec134$export$71511d61b312f219)(r, 1)[0].isIntersecting && t(e);
            }, {
                root: o,
                rootMargin: l.join(" ")
            }).observe(r);
        }
    };
}, $c66bd636670d658a$var$$3330ccfab53de794$export$d086fcc3bc3f366f = function(e) {
    var t = e.className, r = e.onTouch, a = e.top, n = e.left, c = e.right, s = e.bottom, i = e.children, o = $c66bd636670d658a$var$$3330ccfab53de794$var$__rest(e, [
        "className",
        "onTouch",
        "top",
        "left",
        "right",
        "bottom",
        "children"
    ]);
    return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", Object.assign({
        className: $c66bd636670d658a$var$$parcel$interopDefault($46a03b660b5bd4f2$exports)("position-relative", t)
    }, o, {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 left-0 w-100",
                ref: $c66bd636670d658a$var$$3330ccfab53de794$var$touch("top", r),
                children: a
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 left-0 h-100",
                ref: $c66bd636670d658a$var$$3330ccfab53de794$var$touch("left", r),
                children: n
            }),
            i,
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-0 right-0 h-100",
                ref: $c66bd636670d658a$var$$3330ccfab53de794$var$touch("right", r),
                children: c
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                className: "position-absolute top-100 left-0 w-100",
                ref: $c66bd636670d658a$var$$3330ccfab53de794$var$touch("bottom", r),
                children: s
            })
        ]
    }));
};
$c66bd636670d658a$var$$3330ccfab53de794$export$d086fcc3bc3f366f.displayName = "ScrollBoundary";
var $c66bd636670d658a$var$$6c88af5e81334c9f$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$6c88af5e81334c9f$exports, "ScrollList", function() {
    return $c66bd636670d658a$var$$6c88af5e81334c9f$export$797e591eba0ca37c;
});
var $c66bd636670d658a$var$$6c88af5e81334c9f$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$6c88af5e81334c9f$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$6c88af5e81334c9f$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $c66bd636670d658a$var$$6c88af5e81334c9f$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$6c88af5e81334c9f$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)0 > t.indexOf(a[n]) && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
    return r;
}, $c66bd636670d658a$var$$6c88af5e81334c9f$export$797e591eba0ca37c = function() {
    var e, t, r, a, n = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], c = [], s = $3lE4N.Component;
    return $c66bd636670d658a$var$$6c88af5e81334c9f$var$__setFunctionName(a = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "loadMore", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $gkgmt.debounce)(function(t) {
                    var r = e.props.store;
                    "bottom" === t && r.downloading < 1 && !r.noMore && r.getList();
                })
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "componentDidMount",
                value: function() {
                    return $c66bd636670d658a$var$$6c88af5e81334c9f$var$__awaiter(this, void 0, void 0, function() {
                        var e, t, r, a;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    return $7a67b1f7b9b75c34$export$6a4eb2e7fc9e8903, t = (e = this.props).filter, r = e.defaultData, a = this.props.store, [
                                        4,
                                        (0, $cF2Ke.when)(function() {
                                            return a.downloading < 1;
                                        })
                                    ];
                                case 1:
                                    if (n.sent(), a.clearList(), !r) return [
                                        3,
                                        3
                                    ];
                                    return [
                                        4,
                                        a.restoreList({
                                            allItems: r,
                                            filter: t
                                        })
                                    ];
                                case 2:
                                    n.sent(), n.label = 3;
                                case 3:
                                    return [
                                        4,
                                        a.getList(t, a.pageList.length + 1)
                                    ];
                                case 4:
                                    return n.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.props.store.clearList();
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.translator, r = e.store, a = e.renderList, n = $c66bd636670d658a$var$$6c88af5e81334c9f$var$__rest(e, [
                        "translator",
                        "store",
                        "renderList"
                    ]), c = t.t, s = r.noMore, i = r.allItems;
                    return (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$3330ccfab53de794$export$d086fcc3bc3f366f, Object.assign({}, n, {
                        onTouch: this.loadMore,
                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                            children: [
                                a(i),
                                (0, $833f543b429117ba$export$34b9dba7ce09269b)("footer", {
                                    className: "mt-2 text-center text-muted small",
                                    children: c(s || !i.length ? "no_more" : "load_more")
                                })
                            ]
                        })
                    }));
                }
            }
        ]), t;
    }(s), "ScrollList"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = s[Symbol.metadata]) ? e : null) : void 0, $c66bd636670d658a$var$$6c88af5e81334c9f$var$__esDecorate(null, r = {
        value: a
    }, n, {
        kind: "class",
        name: a.name,
        metadata: t
    }, null, c), a = r.value, t && Object.defineProperty(a, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(a, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ScrollList"
    }), $c66bd636670d658a$var$$6c88af5e81334c9f$var$__runInitializers(a, c), a;
}(), $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$exports = {};
$c66bd636670d658a$var$$parcel$export($c66bd636670d658a$var$$5dc3ca4c9dfca0f7$exports, "SearchableInput", function() {
    return $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$export$2724f2f2a56ff7fc;
});
var $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__esDecorate = function(e, t, r, a, n, c) {
    function s(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", u = !t && e ? a.static ? e : e.prototype : null, p = t || (u ? Object.getOwnPropertyDescriptor(u, a.name) : {}), $ = !1, f = r.length - 1; f >= 0; f--){
        var d = {};
        for(var b in a)d[b] = "access" === b ? {} : a[b];
        for(var b in a.access)d.access[b] = a.access[b];
        d.addInitializer = function(e) {
            if ($) throw TypeError("Cannot add initializers after decoration has completed");
            c.push(s(e || null));
        };
        var m = (0, r[f])("accessor" === o ? {
            get: p.get,
            set: p.set
        } : p[l], d);
        if ("accessor" === o) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = s(m.get)) && (p.get = i), (i = s(m.set)) && (p.set = i), (i = s(m.init)) && n.unshift(i);
        } else (i = s(m)) && ("field" === o ? n.unshift(i) : p[l] = i);
    }
    u && Object.defineProperty(u, a.name, p), $ = !0;
}, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, n = 0; n < t.length; n++)r = a ? t[n].call(e, r) : t[n].call(e);
    return a ? r : void 0;
}, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(n, c) {
        function s(e) {
            try {
                o(a.next(e));
            } catch (e) {
                c(e);
            }
        }
        function i(e) {
            try {
                o(a.throw(e));
            } catch (e) {
                c(e);
            }
        }
        function o(e) {
            var t;
            e.done ? n(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(s, i);
        }
        o((a = a.apply(e, t || [])).next());
    });
}, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $52f9d16dafc91847$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet = function(e, t, r, a, n) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !n) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !n : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? n.call(e, r) : n ? n.value = r : t.set(e, r), r;
}, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$export$2724f2f2a56ff7fc = function() {
    var e, t, r, a, n, c, s, i, o = [
        $5e1e6516101ba9db$export$b6ae1bc530f4c149
    ], l = [], u = $97ddcb8d2dacc617$exports.FormComponent, p = [], $ = [], f = [], d = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $d0a0f288ab521cc7$export$71511d61b312f219)(this, t), e = (0, $0d80fffe6b458f9f$export$71511d61b312f219)(this, t, arguments), r.set(e, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__runInitializers(e, p, e.props.filter)), a.set(e, ($c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__runInitializers(e, $), $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__runInitializers(e, f, !1))), Object.defineProperty(e, "search", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__runInitializers(e, d), (0, $gkgmt.debounce)(function(t) {
                    return $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__awaiter(e, void 0, void 0, function() {
                        var e, r, a;
                        return (0, $e8e7dbc748a933f9$export$71511d61b312f219)(this, function(n) {
                            switch(n.label){
                                case 0:
                                    if (r = (e = this.props).store, a = e.labelKey, t = t.trim(), this.filter = Object.assign(Object.assign({}, this.filter), (0, $1b8a3567f17d3fac$export$71511d61b312f219)({}, a, t || void 0)), !(r.downloading < 1)) return [
                                        3,
                                        5
                                    ];
                                    if (!t) return [
                                        3,
                                        4
                                    ];
                                    if (this.listShown) return [
                                        3,
                                        1
                                    ];
                                    return this.listShown = !0, [
                                        3,
                                        3
                                    ];
                                case 1:
                                    return [
                                        4,
                                        r.getList(this.filter, 1)
                                    ];
                                case 2:
                                    n.sent(), n.label = 3;
                                case 3:
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    this.listShown = !1, r.clearList(), n.label = 5;
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                }, $iob0w.Second))
            }), Object.defineProperty(e, "add", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t, r) {
                    var a = e.value || [];
                    !a.find(function(e) {
                        return e.value === r;
                    }) && (e.innerValue = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(a).concat([
                        {
                            label: t,
                            value: r
                        }
                    ]), e.props.multiple || (e.listShown = !1));
                }
            }), Object.defineProperty(e, "delete", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return e.innerValue = (0, $ba6b19be90dbdadc$export$71511d61b312f219)(e.value.slice(0, t)).concat((0, $ba6b19be90dbdadc$export$71511d61b312f219)(e.value.slice(t + 1)));
                }
            }), Object.defineProperty(e, "handleBlur", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.target, a = t.relatedTarget;
                    r.parentElement !== (null == a ? void 0 : a.parentElement) && (e.listShown = !1);
                }
            }), Object.defineProperty(e, "renderList", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return t[0] ? (0, $833f543b429117ba$export$34b9dba7ce09269b)($379053fe725fe9c2$export$2e2bcd8739ae039, {
                        children: t.map(function(t) {
                            var r = e.observedProps, a = r.labelKey, n = r.valueKey, c = t[a], s = t[n];
                            return (0, $833f543b429117ba$export$34b9dba7ce09269b)($379053fe725fe9c2$export$2e2bcd8739ae039.Item, {
                                as: "button",
                                type: "button",
                                action: !0,
                                onClick: function() {
                                    return e.add(c, s);
                                },
                                children: c
                            }, s);
                        })
                    }) : e.observedProps.store.downloading > 0 && (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                        className: "text-center my-3",
                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($32f816caebe11677$export$2e2bcd8739ae039, {})
                    });
                }
            }), e;
        }
        return (0, $679f156d83dccf68$export$71511d61b312f219)(t, e), (0, $30088f375ab7517b$export$71511d61b312f219)(t, [
            {
                key: "filter",
                get: function() {
                    return $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "listShown",
                get: function() {
                    return $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                key: "renderOverlay"
            }, "value", function() {
                var e = this.filter, t = this.props, r = t.translator, a = t.fields, n = t.store, c = t.labelKey, s = t.renderList, i = void 0 === s ? this.renderList : s, o = e[c], l = !n.allItems.some(function(e) {
                    return e[c] === o;
                });
                return (0, $833f543b429117ba$export$34b9dba7ce09269b)("div", {
                    className: "position-absolute start-0 z-3 overflow-auto py-1 bg-white shadow-sm",
                    style: {
                        top: "100%",
                        maxHeight: "30vh"
                    },
                    onBlurCapture: this.handleBlur,
                    children: [
                        l && (null == a ? void 0 : a[0]) && (0, $833f543b429117ba$export$34b9dba7ce09269b)($85e8222bbf1762c5$export$2e2bcd8739ae039, {
                            className: "w-100 sticky-top",
                            variant: "warning",
                            size: "sm",
                            type: "button",
                            onClick: function() {
                                return n.currentOne = (0, $1b8a3567f17d3fac$export$71511d61b312f219)({}, c, o);
                            },
                            children: [
                                "+ ",
                                o
                            ]
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$6c88af5e81334c9f$export$797e591eba0ca37c, {
                            translator: r,
                            store: n,
                            filter: e,
                            renderList: i
                        })
                    ]
                });
            }),
            (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                key: "render"
            }, "value", function() {
                var e = this, t = this.value, r = this.listShown, a = this.props, n = a.translator, c = a.fields, s = a.store, i = a.labelKey, o = a.valueKey, l = a.type, u = a.name, p = a.required, $ = a.readOnly, f = a.disabled, d = a.placeholder;
                return (0, $833f543b429117ba$export$34b9dba7ce09269b)($cb5fbc58ed936c1f$export$2e2bcd8739ae039, (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                    className: "position-relative"
                }, "children", [
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($cb5fbc58ed936c1f$export$2e2bcd8739ae039.Text, {
                        className: "d-flex flex-wrap align-items-center gap-2",
                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$f600741b98acd6fe$export$ef1c4106ceccca63, {
                            list: (t || []).map(function(e) {
                                return {
                                    text: e.label
                                };
                            }),
                            onDelete: function(t, r) {
                                return (0, $35185879ecdb8b0f$export$71511d61b312f219)(t), e.delete(r);
                            }
                        })
                    }),
                    r && this.renderOverlay(),
                    (null == c ? void 0 : c[0]) && (0, $833f543b429117ba$export$34b9dba7ce09269b)($c66bd636670d658a$var$$bfbc9f72f179e373$export$28baae8ef86bbf36, (0, $1b8a3567f17d3fac$export$71511d61b312f219)({
                        translator: n,
                        fields: c,
                        store: s
                    }, "onSubmit", function(t) {
                        var r = t[i], a = t[o];
                        e.add(r, a), e.listShown = !1;
                    })),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("input", {
                        type: "hidden",
                        name: u,
                        value: JSON.stringify(null == t ? void 0 : t.map(function(e) {
                            return e.value;
                        }))
                    }),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)($df771a012e6df6b5$export$2e2bcd8739ae039.Control, {
                        type: void 0 === l ? "search" : l,
                        placeholder: d,
                        required: p,
                        readOnly: $,
                        disabled: f,
                        onChange: function(t) {
                            var r = t.currentTarget.value;
                            return e.search(r);
                        }
                    })
                ]));
            })
        ]), t;
    }(u), r = new WeakMap, a = new WeakMap, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__setFunctionName(c, "SearchableInput"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = u[Symbol.metadata]) ? e : null) : void 0, s = [
        $cF2Ke.observable
    ], i = [
        $cF2Ke.observable
    ], $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__esDecorate(c, null, s, {
        kind: "accessor",
        name: "filter",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "filter" in e;
            },
            get: function(e) {
                return e.filter;
            },
            set: function(e, t) {
                e.filter = t;
            }
        },
        metadata: t
    }, p, $), $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__esDecorate(c, null, i, {
        kind: "accessor",
        name: "listShown",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "listShown" in e;
            },
            get: function(e) {
                return e.listShown;
            },
            set: function(e, t) {
                e.listShown = t;
            }
        },
        metadata: t
    }, f, d), $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__esDecorate(null, n = {
        value: c
    }, o, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = n.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "SearchableInput"
    }), $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$var$__runInitializers(c, l), c;
}();
$c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$f600741b98acd6fe$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$faee9857e4bdfa8b$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$8663609ea235ec39$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$f2af1554fbcf9c96$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$a21a50f24f1cbd28$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$4e6504f15de995a8$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$92bd5b9c2e8cd28e$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$fa84453248a3f065$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$36ed2012ed0bbec3$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$cd7ba08b282791a9$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$bcc38e2aa906301f$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$3800431d840f9bec$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$3330ccfab53de794$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$6c88af5e81334c9f$exports), $c66bd636670d658a$var$$parcel$exportWildcard($c66bd636670d658a$exports, $c66bd636670d658a$var$$5dc3ca4c9dfca0f7$exports); //# sourceMappingURL=index.js.map


parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");



var $36979414d408a5c8$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $36979414d408a5c8$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $36979414d408a5c8$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
let $36979414d408a5c8$export$fb01502f5340e3de = (()=>{
    let _classDecorators = [
        (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $3lE4N.Component);
    let _instanceExtraInitializers = [];
    let _get_columns_decorators;
    var PaginationPage = _classThis = class extends _classSuper {
        get columns() {
            const { t: t } = (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168);
            return [
                {
                    key: 'full_name',
                    renderHead: t('repository_name'),
                    renderBody: ({ html_url: html_url, full_name: full_name })=>(0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                            target: "_blank",
                            href: html_url,
                            rel: "noreferrer",
                            children: full_name
                        })
                },
                {
                    key: 'homepage',
                    type: 'url',
                    renderHead: t('home_page')
                },
                {
                    key: 'language',
                    renderHead: t('programming_language')
                },
                {
                    key: 'topics',
                    renderHead: t('topic'),
                    renderBody: ({ topics: topics })=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
                            children: topics === null || topics === void 0 ? void 0 : topics.map((topic)=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $877fb262e9f1190e$export$2e2bcd8739ae039), {
                                    as: "a",
                                    className: "me-2 text-decoration-none",
                                    bg: (0, $b8df73c80b604f74$exports.text2color)(topic, [
                                        'light'
                                    ]),
                                    target: "_blank",
                                    href: `https://github.com/topics/${topic}`,
                                    children: topic
                                }, topic))
                        })
                },
                {
                    key: 'stargazers_count',
                    type: 'number',
                    renderHead: t('star_count')
                }
            ];
        }
        render() {
            return (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $5f7777a6b14048f7$export$2e2bcd8739ae039), {
                style: {
                    height: '91vh'
                },
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $c66bd636670d658a$exports.RestTable), {
                    className: "h-100 text-center",
                    columns: this.columns,
                    store: (0, $b16be82c38219c2b$export$8701c19c4b8c549b),
                    translator: (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168),
                    striped: true,
                    hover: true,
                    editable: true,
                    deletable: true,
                    onCheck: console.log
                })
            });
        }
        constructor(){
            super(...arguments);
            $36979414d408a5c8$var$__runInitializers(this, _instanceExtraInitializers);
        }
    };
    $36979414d408a5c8$var$__setFunctionName(_classThis, "PaginationPage");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_columns_decorators = [
            (0, $cF2Ke.computed)
        ];
        $36979414d408a5c8$var$__esDecorate(_classThis, null, _get_columns_decorators, {
            kind: "getter",
            name: "columns",
            static: false,
            private: false,
            access: {
                has: (obj)=>"columns" in obj,
                get: (obj)=>obj.columns
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $36979414d408a5c8$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        PaginationPage = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $36979414d408a5c8$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return PaginationPage = _classThis;
})();













var $cF2Ke = parcelRequire("cF2Ke");

parcelRequire("kzd8a");
var $3lE4N = parcelRequire("3lE4N");

var $cdd358f827e37bf2$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $cdd358f827e37bf2$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $cdd358f827e37bf2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $cdd358f827e37bf2$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $cdd358f827e37bf2$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $cdd358f827e37bf2$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $cdd358f827e37bf2$export$82ac5bfd81727a32 = (()=>{
    var _GitLogo_path_accessor_storage;
    let _classDecorators = [
        (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $3lE4N.Component);
    let _path_decorators;
    let _path_initializers = [];
    let _path_extraInitializers = [];
    var GitLogo = _classThis = class extends _classSuper {
        get path() {
            return $cdd358f827e37bf2$var$__classPrivateFieldGet(this, _GitLogo_path_accessor_storage, "f");
        }
        set path(value) {
            $cdd358f827e37bf2$var$__classPrivateFieldSet(this, _GitLogo_path_accessor_storage, value, "f");
        }
        componentDidMount() {
            return $cdd358f827e37bf2$var$__awaiter(this, void 0, void 0, function*() {
                const { name: name } = this.props;
                const topic = name.toLowerCase();
                try {
                    const { src: src } = yield this.loadImage(`https://raw.githubusercontent.com/github/explore/master/topics/${topic}/${topic}.png`);
                    this.path = src;
                } catch (_a) {
                    const { src: src } = yield this.loadImage(`https://github.com/${name}.png`);
                    this.path = src;
                }
            });
        }
        loadImage(path) {
            return new Promise((resolve, reject)=>{
                const image = new globalThis.Image();
                image.onload = ()=>resolve(image);
                image.onerror = reject;
                image.src = path;
            });
        }
        render() {
            const { path: path } = this;
            const { name: name } = this.props;
            return path && (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $6061a0f906a555ad$export$2e2bcd8739ae039), {
                src: path,
                alt: name,
                fluid: true
            });
        }
        constructor(){
            super(...arguments);
            _GitLogo_path_accessor_storage.set(this, $cdd358f827e37bf2$var$__runInitializers(this, _path_initializers, ''));
            $cdd358f827e37bf2$var$__runInitializers(this, _path_extraInitializers);
        }
    };
    _GitLogo_path_accessor_storage = new WeakMap();
    $cdd358f827e37bf2$var$__setFunctionName(_classThis, "GitLogo");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _path_decorators = [
            (0, $cF2Ke.observable)
        ];
        $cdd358f827e37bf2$var$__esDecorate(_classThis, null, _path_decorators, {
            kind: "accessor",
            name: "path",
            static: false,
            private: false,
            access: {
                has: (obj)=>"path" in obj,
                get: (obj)=>obj.path,
                set: (obj, value)=>{
                    obj.path = value;
                }
            },
            metadata: _metadata
        }, _path_initializers, _path_extraInitializers);
        $cdd358f827e37bf2$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        GitLogo = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $cdd358f827e37bf2$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return GitLogo = _classThis;
})();


const $28f1c0998209c2bd$export$3663268b2052b3d = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(({ className: className = 'shadow-sm', full_name: full_name, html_url: html_url, languages: languages = [], topics: topics = [], description: description, homepage: homepage })=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039), {
        className: className,
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Body, {
                className: "d-flex flex-column gap-3",
                children: [
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Title, {
                        as: "h3",
                        className: "h5",
                        children: (0, $833f543b429117ba$export$34b9dba7ce09269b)("a", {
                            target: "_blank",
                            href: html_url,
                            rel: "noreferrer",
                            children: full_name
                        })
                    }),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)("nav", {
                        className: "flex-fill",
                        children: topics.map((topic)=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $877fb262e9f1190e$export$2e2bcd8739ae039), {
                                className: "text-decoration-none me-1",
                                bg: (0, $b8df73c80b604f74$exports.text2color)(topic, [
                                    'light'
                                ]),
                                as: "a",
                                target: "_blank",
                                href: `https://github.com/topics/${topic}`,
                                children: topic
                            }, topic))
                    }),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3337fdcef7a6ae36$export$2e2bcd8739ae039), {
                        as: "ul",
                        className: "list-unstyled g-4",
                        xs: 4,
                        children: languages.map((language)=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ca4e55525ae20d35$export$2e2bcd8739ae039), {
                                as: "li",
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $cdd358f827e37bf2$export$82ac5bfd81727a32), {
                                    name: language
                                })
                            }, language))
                    }),
                    (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Text, {
                        children: description
                    })
                ]
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $95b0e632403c19f5$export$2e2bcd8739ae039).Footer, {
                className: "d-flex justify-content-between align-items-center",
                children: homepage && (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $85e8222bbf1762c5$export$2e2bcd8739ae039), {
                    variant: "success",
                    target: "_blank",
                    href: homepage,
                    children: (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168).t('home_page')
                })
            })
        ]
    }));




const $25193605e5bd48f1$export$5636eeba3ebdcdc3 = (0, $5e1e6516101ba9db$export$b6ae1bc530f4c149)(()=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $5f7777a6b14048f7$export$2e2bcd8739ae039), {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)("h1", {
                className: "my-4",
                children: (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168).t('scroll_list')
            }),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $c66bd636670d658a$exports.ScrollList), {
                translator: (0, $cdcfc036668a4ffd$export$a7357cdd1f0b0168),
                store: (0, $b16be82c38219c2b$export$8701c19c4b8c549b),
                renderList: (allItems)=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3337fdcef7a6ae36$export$2e2bcd8739ae039), {
                        as: "ul",
                        className: "list-unstyled g-4",
                        xs: 1,
                        sm: 2,
                        children: allItems.map((item)=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ca4e55525ae20d35$export$2e2bcd8739ae039), {
                                as: "li",
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $28f1c0998209c2bd$export$3663268b2052b3d), Object.assign({
                                    className: "h-100 shadow-sm"
                                }, item))
                            }, item.id))
                    })
            })
        ]
    }));


const $325af5f10b3faac7$export$953c2efc134d7f79 = ()=>(0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $3lE4N.Fragment), {
        children: [
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $5c7d45190b2b9254$export$8b543871300e74c2), {}),
            (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $db188477a5aad910$export$7221d69dcfc8e36b), {
                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $db188477a5aad910$export$3565eb3d00ca5a74), {
                    children: [
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $db188477a5aad910$export$e7b0ac011bb776c6), {
                            path: "/",
                            element: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $2296d3e31d6332cb$export$36d69433c4f81145), {})
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $db188477a5aad910$export$e7b0ac011bb776c6), {
                            path: "/component",
                            element: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ef8e9e3f68d8643f$export$46af595855840602), {})
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $db188477a5aad910$export$e7b0ac011bb776c6), {
                            path: "/pagination",
                            element: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $36979414d408a5c8$export$fb01502f5340e3de), {})
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $db188477a5aad910$export$e7b0ac011bb776c6), {
                            path: "/scroll-list",
                            element: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $25193605e5bd48f1$export$5636eeba3ebdcdc3), {})
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $db188477a5aad910$export$e7b0ac011bb776c6), {
                            path: "/chart",
                            element: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $5f7777a6b14048f7$export$2e2bcd8739ae039), {
                                children: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $b799a869ecb05549$export$2e2bcd8739ae039), {})
                            })
                        }),
                        (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $db188477a5aad910$export$e7b0ac011bb776c6), {
                            path: "/downloader",
                            element: (0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $ae662bb446b6a56c$export$2ad2ffac2ac2ce65), {})
                        })
                    ]
                })
            })
        ]
    });


(0, $de9addb89ca41b61$export$dfb5619354ba860)();
(0, $cF2Ke.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', ({ reason: reason })=>{
    const { message: message } = reason;
    if (message) self.alert(message);
});
const { serviceWorker: $b1b793d8911e6aa6$var$serviceWorker } = window.navigator, $b1b793d8911e6aa6$var$NODE_ENV = "production";
if ($b1b793d8911e6aa6$var$NODE_ENV !== 'development') $b1b793d8911e6aa6$var$serviceWorker === null || $b1b793d8911e6aa6$var$serviceWorker === void 0 || $b1b793d8911e6aa6$var$serviceWorker.register('sw.js').then((0, $iob0w.serviceWorkerUpdate)).then((worker)=>{
    if (window.confirm('New version of this Web App detected, update now?')) worker.postMessage({
        type: 'SKIP_WAITING'
    });
});
$b1b793d8911e6aa6$var$serviceWorker === null || $b1b793d8911e6aa6$var$serviceWorker === void 0 || $b1b793d8911e6aa6$var$serviceWorker.addEventListener('controllerchange', ()=>window.location.reload());
(0, $8c69a4426694c4f3$export$882461b6382ed46c)(document.querySelector('#app')).render((0, $833f543b429117ba$export$34b9dba7ce09269b)((0, $325af5f10b3faac7$export$953c2efc134d7f79), {}));


//# sourceMappingURL=React-MobX-Bootstrap-ts.49acd20a.js.map
